const cncRouterDataObj = `# File units = meters
mtllib Assembly 1.mtl
g leadScrew
v 0.0461219 0.139101 -0.107614 
v 0.045066 0.139101 -0.107381 
v 0.0440847 0.139101 -0.106927 
v 0.043224 0.139101 -0.106273 
v 0.0425241 0.139101 -0.105449 
v 0.0420176 0.139101 -0.104494 
v 0.0417284 0.139101 -0.103452 
v 0.0416698 0.139101 -0.102372 
v 0.0418448 0.139101 -0.101305 
v 0.0422449 0.139101 -0.100301 
v 0.0428517 0.139101 -0.099406 
v 0.0436366 0.139101 -0.0986625 
v 0.0445631 0.139101 -0.0981051 
v 0.0455877 0.139101 -0.0977598 
v 0.0466625 0.139101 -0.0976429 
v 0.0477374 0.139101 -0.0977598 
v 0.048762 0.139101 -0.0981051 
v 0.0496884 0.139101 -0.0986625 
v 0.0504733 0.139101 -0.099406 
v 0.0510801 0.139101 -0.100301 
v 0.0514803 0.139101 -0.101305 
v 0.0516552 0.139101 -0.102372 
v 0.0515966 0.139101 -0.103452 
v 0.0513074 0.139101 -0.104494 
v 0.050801 0.139101 -0.105449 
v 0.050101 0.139101 -0.106273 
v 0.0492403 0.139101 -0.106927 
v 0.048259 0.139101 -0.107381 
v 0.0472031 0.139101 -0.107614 
v 0.0466625 0.139101 -0.107643 
v 0.0466625 0.139101 -0.102643 
v 0.0466625 -0.160899 -0.0976429 
v 0.0455877 -0.160899 -0.0977598 
v 0.0445631 -0.160899 -0.0981051 
v 0.0436366 -0.160899 -0.0986625 
v 0.0428517 -0.160899 -0.099406 
v 0.0422449 -0.160899 -0.100301 
v 0.0418448 -0.160899 -0.101305 
v 0.0416698 -0.160899 -0.102372 
v 0.0417284 -0.160899 -0.103452 
v 0.0420176 -0.160899 -0.104494 
v 0.0425241 -0.160899 -0.105449 
v 0.043224 -0.160899 -0.106273 
v 0.0440847 -0.160899 -0.106927 
v 0.045066 -0.160899 -0.107381 
v 0.0472031 -0.160899 -0.107614 
v 0.0466625 -0.160899 -0.107643 
v 0.0461219 -0.160899 -0.107614 
v 0.048259 -0.160899 -0.107381 
v 0.0492403 -0.160899 -0.106927 
v 0.050101 -0.160899 -0.106273 
v 0.050801 -0.160899 -0.105449 
v 0.0513074 -0.160899 -0.104494 
v 0.0515966 -0.160899 -0.103452 
v 0.0516552 -0.160899 -0.102372 
v 0.0514803 -0.160899 -0.101305 
v 0.0510801 -0.160899 -0.100301 
v 0.0504733 -0.160899 -0.099406 
v 0.0496884 -0.160899 -0.0986625 
v 0.048762 -0.160899 -0.0981051 
v 0.0477374 -0.160899 -0.0977598 
v 0.0466625 -0.160899 -0.102643 
vn 0.0803341 0.989393 -0.121027 
vn 0.0745246 -0.175997 0.981566 
vn -0.163025 -0.178634 0.970316 
vn -0.393884 -0.180168 0.90133 
vn -0.602251 -0.180435 0.777649 
vn -0.773867 -0.179407 0.607407 
vn -0.897967 -0.177195 0.402812 
vn -0.968459 -0.174023 0.178335 
vn -0.984077 -0.170181 -0.0513022 
vn -0.947658 -0.165971 -0.272761 
vn -0.864979 -0.161671 -0.475051 
vn -0.743562 -0.15751 -0.64985 
vn -0.591706 -0.153663 -0.791374 
vn -0.417821 -0.150253 -0.896019 
vn -0.230045 -0.147366 -0.961958 
vn -0.0360498 -0.145053 -0.988767 
vn 0.157024 -0.143347 -0.977136 
vn 0.0610274 -0.144123 -0.987676 
vn -0.0360498 -0.145053 -0.988767 
vn 0.157024 -0.143347 -0.977136 
vn 0.342564 -0.142265 -0.928661 
vn 0.514461 -0.141816 -0.845705 
vn 0.667074 -0.142004 -0.731332 
vn 0.795209 -0.142828 -0.589274 
vn 0.89412 -0.14428 -0.423949 
vn 0.95955 -0.146347 -0.240511 
vn 0.987816 -0.149005 -0.0449186 
vn 0.975962 -0.152209 0.15598 
vn 0.922016 -0.15589 0.354378 
vn 0.825347 -0.15994 0.541499 
vn 0.687153 -0.164208 0.707712 
vn 0.511032 -0.168485 0.842887 
vn 0.303539 -0.172514 0.937071 
vn 0.0583605 -0.994416 -0.0879231 
usemtl 0.231373_0.380392_0.705882_0.000000_0.000000
o mesh0
f 31//1 1//1 2//1 
f 2//1 3//1 31//1 
f 3//1 4//1 31//1 
f 4//1 5//1 31//1 
f 5//1 6//1 31//1 
f 6//1 7//1 31//1 
f 7//1 8//1 31//1 
f 8//1 9//1 31//1 
f 9//1 10//1 31//1 
f 10//1 11//1 31//1 
f 11//1 12//1 31//1 
f 12//1 13//1 31//1 
f 13//1 14//1 31//1 
f 14//1 15//1 31//1 
f 15//1 16//1 31//1 
f 16//1 17//1 31//1 
f 17//1 18//1 31//1 
f 18//1 19//1 31//1 
f 19//1 20//1 31//1 
f 20//1 21//1 31//1 
f 21//1 22//1 31//1 
f 22//1 23//1 31//1 
f 23//1 24//1 31//1 
f 24//1 25//1 31//1 
f 25//1 26//1 31//1 
f 26//1 27//1 31//1 
f 27//1 28//1 31//1 
f 28//1 29//1 31//1 
f 29//1 30//1 31//1 
f 30//1 1//1 31//1 
o mesh1
f 32//2 15//2 14//3 
f 33//3 14//3 13//4 
f 34//4 13//4 12//5 
f 35//5 12//5 11//6 
f 36//6 11//6 10//7 
f 37//7 10//7 9//8 
f 38//8 9//8 8//9 
f 39//9 8//9 7//10 
f 40//10 7//10 6//11 
f 41//11 6//11 5//12 
f 42//12 5//12 4//13 
f 43//13 4//13 3//14 
f 44//14 3//14 2//15 
f 45//15 2//15 1//16 
f 46//17 47//18 30//18 
f 1//16 30//18 47//18 
f 47//18 48//19 1//16 
f 46//17 29//20 28//21 
f 49//21 28//21 27//22 
f 50//22 27//22 26//23 
f 51//23 26//23 25//24 
f 52//24 25//24 24//25 
f 53//25 24//25 23//26 
f 54//26 23//26 22//27 
f 55//27 22//27 21//28 
f 56//28 21//28 20//29 
f 57//29 20//29 19//30 
f 58//30 19//30 18//31 
f 59//31 18//31 17//32 
f 60//32 17//32 16//33 
f 61//33 16//33 15//2 
f 15//2 32//2 61//33 
f 16//33 61//33 60//32 
f 17//32 60//32 59//31 
f 18//31 59//31 58//30 
f 19//30 58//30 57//29 
f 20//29 57//29 56//28 
f 21//28 56//28 55//27 
f 22//27 55//27 54//26 
f 23//26 54//26 53//25 
f 24//25 53//25 52//24 
f 25//24 52//24 51//23 
f 26//23 51//23 50//22 
f 27//22 50//22 49//21 
f 28//21 49//21 46//17 
f 30//18 29//20 46//17 
f 1//16 48//19 45//15 
f 2//15 45//15 44//14 
f 3//14 44//14 43//13 
f 4//13 43//13 42//12 
f 5//12 42//12 41//11 
f 6//11 41//11 40//10 
f 7//10 40//10 39//9 
f 8//9 39//9 38//8 
f 9//8 38//8 37//7 
f 10//7 37//7 36//6 
f 11//6 36//6 35//5 
f 12//5 35//5 34//4 
f 13//4 34//4 33//3 
f 14//3 33//3 32//2 
o mesh2
f 62//34 46//34 49//34 
f 49//34 50//34 62//34 
f 50//34 51//34 62//34 
f 51//34 52//34 62//34 
f 52//34 53//34 62//34 
f 53//34 54//34 62//34 
f 54//34 55//34 62//34 
f 55//34 56//34 62//34 
f 56//34 57//34 62//34 
f 57//34 58//34 62//34 
f 58//34 59//34 62//34 
f 59//34 60//34 62//34 
f 60//34 61//34 62//34 
f 61//34 32//34 62//34 
f 32//34 33//34 62//34 
f 33//34 34//34 62//34 
f 34//34 35//34 62//34 
f 35//34 36//34 62//34 
f 36//34 37//34 62//34 
f 37//34 38//34 62//34 
f 38//34 39//34 62//34 
f 39//34 40//34 62//34 
f 40//34 41//34 62//34 
f 41//34 42//34 62//34 
f 42//34 43//34 62//34 
f 43//34 44//34 62//34 
f 44//34 45//34 62//34 
f 45//34 48//34 62//34 
f 48//34 47//34 62//34 
f 47//34 46//34 62//34 
g bearing
v 0.0846739 -0.0163599 -0.0108893 
v 0.0846155 -0.0163599 -0.0114267 
v 0.0846155 -0.00615989 -0.0114267 
v 0.0848465 -0.0163599 -0.010377 
v 0.0846739 -0.00615989 -0.0108893 
v 0.0851252 -0.0163599 -0.00991377 
v 0.0848465 -0.00615989 -0.010377 
v 0.085497 -0.0163599 -0.0095213 
v 0.0851252 -0.00615989 -0.00991377 
v 0.0859445 -0.0163599 -0.00921792 
v 0.085497 -0.00615989 -0.0095213 
v 0.0864467 -0.0163599 -0.00901783 
v 0.0859445 -0.00615989 -0.00921792 
v 0.0869801 -0.0163599 -0.00893037 
v 0.0864467 -0.00615989 -0.00901783 
v 0.0875199 -0.0163599 -0.00895964 
v 0.0869801 -0.00615989 -0.00893037 
v 0.0880408 -0.0163599 -0.00910426 
v 0.0875199 -0.00615989 -0.00895964 
v 0.0885184 -0.0163599 -0.00935748 
v 0.0880408 -0.00615989 -0.00910426 
v 0.0889305 -0.0163599 -0.00970745 
v 0.0885184 -0.00615989 -0.00935748 
v 0.0892576 -0.0163599 -0.0101378 
v 0.0889305 -0.00615989 -0.00970745 
v 0.0894846 -0.0163599 -0.0106284 
v 0.0892576 -0.00615989 -0.0101378 
v 0.0896008 -0.0163599 -0.0111564 
v 0.0894846 -0.00615989 -0.0106284 
v 0.0896008 -0.0163599 -0.011697 
v 0.0896008 -0.00615989 -0.0111564 
v 0.0894846 -0.0163599 -0.012225 
v 0.0896008 -0.00615989 -0.011697 
v 0.0892576 -0.0163599 -0.0127156 
v 0.0894846 -0.00615989 -0.012225 
v 0.0889305 -0.0163599 -0.013146 
v 0.0892576 -0.00615989 -0.0127156 
v 0.0885184 -0.0163599 -0.0134959 
v 0.0889305 -0.00615989 -0.013146 
v 0.0880408 -0.0163599 -0.0137491 
v 0.0885184 -0.00615989 -0.0134959 
v 0.0875199 -0.0163599 -0.0138938 
v 0.0880408 -0.00615989 -0.0137491 
v 0.0869801 -0.0163599 -0.013923 
v 0.0875199 -0.00615989 -0.0138938 
v 0.0864467 -0.0163599 -0.0138356 
v 0.0869801 -0.00615989 -0.013923 
v 0.0859445 -0.0163599 -0.0136355 
v 0.0864467 -0.00615989 -0.0138356 
v 0.085497 -0.0163599 -0.0133321 
v 0.0859445 -0.00615989 -0.0136355 
v 0.0851252 -0.0163599 -0.0129396 
v 0.085497 -0.00615989 -0.0133321 
v 0.0848465 -0.0163599 -0.0124764 
v 0.0851252 -0.00615989 -0.0129396 
v 0.0846739 -0.0163599 -0.0119641 
v 0.0848465 -0.00615989 -0.0124764 
v 0.0846739 -0.00615989 -0.0119641 
v 0.0939398 -0.00615989 -0.0178911 
v 0.0923906 -0.00615989 -0.019207 
v 0.0951699 -0.00615989 -0.0162729 
v 0.0866066 -0.00615989 -0.0208129 
v 0.0846007 -0.00615989 -0.0204841 
v 0.0905948 -0.00615989 -0.0201591 
v 0.0886362 -0.00615989 -0.0207029 
v 0.08103 -0.00615989 -0.018591 
v 0.0796322 -0.00615989 -0.0171153 
v 0.0779352 -0.00615989 -0.0134474 
v 0.0777155 -0.00615989 -0.0114267 
v 0.0827124 -0.00615989 -0.0197317 
v 0.0779352 -0.00615989 -0.00940598 
v 0.0785843 -0.00615989 -0.0153737 
v 0.0939398 -0.00615989 -0.00496233 
v 0.0951699 -0.00615989 -0.0065805 
v 0.0923906 -0.00615989 -0.00364643 
v 0.0960234 -0.00615989 -0.0144281 
v 0.0785843 -0.00615989 -0.00747975 
v 0.0796322 -0.00615989 -0.00573807 
v 0.08103 -0.00615989 -0.00426238 
v 0.0827124 -0.00615989 -0.00312169 
v 0.0846007 -0.00615989 -0.00236933 
v 0.0866066 -0.00615989 -0.00204049 
v 0.0960234 -0.00615989 -0.00842527 
v 0.0964604 -0.00615989 -0.0104104 
v 0.0964604 -0.00615989 -0.012443 
v 0.0886362 -0.00615989 -0.00215053 
v 0.0905948 -0.00615989 -0.00269432 
v 0.0751155 -0.00875989 -0.0114267 
v 0.075396 -0.00875989 -0.0140063 
v 0.0762246 -0.00875989 -0.0164654 
v 0.0775624 -0.00875989 -0.0186888 
v 0.0793468 -0.00875989 -0.0205726 
v 0.0814946 -0.00875989 -0.0220288 
v 0.0839051 -0.00875989 -0.0229893 
v 0.0864658 -0.00875989 -0.0234091 
v 0.0890569 -0.00875989 -0.0232686 
v 0.0915571 -0.00875989 -0.0225744 
v 0.0938497 -0.00875989 -0.021359 
v 0.0958274 -0.00875989 -0.0196791 
v 0.0973978 -0.00875989 -0.0176133 
v 0.0984873 -0.00875989 -0.0152583 
v 0.0990451 -0.00875989 -0.0127241 
v 0.0990451 -0.00875989 -0.0101293 
v 0.0984873 -0.00875989 -0.00759508 
v 0.0973978 -0.00875989 -0.00524006 
v 0.0958274 -0.00875989 -0.00317431 
v 0.0938497 -0.00875989 -0.00149443 
v 0.0915571 -0.00875989 -0.000278982 
v 0.0890569 -0.00875989 0.000415215 
v 0.0864658 -0.00875989 0.000555698 
v 0.0839051 -0.00875989 0.000135897 
v 0.0814946 -0.00875989 -0.000824558 
v 0.0793468 -0.00875989 -0.00228076 
v 0.0775624 -0.00875989 -0.00416461 
v 0.0762246 -0.00875989 -0.00638803 
v 0.075396 -0.00875989 -0.00884706 
v 0.0754647 -0.0137599 -0.0139912 
v 0.0751858 -0.0137599 -0.0127241 
v 0.0762884 -0.0137599 -0.0164358 
v 0.0757436 -0.0137599 -0.0152583 
v 0.0776184 -0.0137599 -0.0186462 
v 0.0768332 -0.0137599 -0.0176133 
v 0.0793924 -0.0137599 -0.020519 
v 0.0784035 -0.0137599 -0.0196791 
v 0.0815275 -0.0137599 -0.0219667 
v 0.0803812 -0.0137599 -0.021359 
v 0.083924 -0.0137599 -0.0229215 
v 0.0826738 -0.0137599 -0.0225744 
v 0.0864696 -0.0137599 -0.0233389 
v 0.0851741 -0.0137599 -0.0232686 
v 0.0890455 -0.0137599 -0.0231992 
v 0.0877651 -0.0137599 -0.0234091 
v 0.0915311 -0.0137599 -0.0225091 
v 0.0903258 -0.0137599 -0.0229893 
v 0.0938102 -0.0137599 -0.0213007 
v 0.0927364 -0.0137599 -0.0220288 
v 0.0948841 -0.0137599 -0.0205726 
v 0.0957764 -0.0137599 -0.0196307 
v 0.0966686 -0.0137599 -0.0186888 
v 0.0973375 -0.0137599 -0.0175771 
v 0.0980064 -0.0137599 -0.0164654 
v 0.0984207 -0.0137599 -0.0152359 
v 0.0989752 -0.0137599 -0.0127165 
v 0.0988349 -0.0137599 -0.0140063 
v 0.0989752 -0.0137599 -0.0101369 
v 0.0991155 -0.0137599 -0.0114267 
v 0.0984207 -0.0137599 -0.00761755 
v 0.0988349 -0.0137599 -0.00884706 
v 0.0973375 -0.0137599 -0.00527632 
v 0.0980064 -0.0137599 -0.00638803 
v 0.0957764 -0.0137599 -0.00322269 
v 0.0966686 -0.0137599 -0.00416461 
v 0.0938102 -0.0137599 -0.00155266 
v 0.0948841 -0.0137599 -0.00228076 
v 0.0915311 -0.0137599 -0.000344331 
v 0.0927364 -0.0137599 -0.000824558 
v 0.0890455 -0.0137599 0.000345798 
v 0.0903258 -0.0137599 0.000135897 
v 0.0864696 -0.0137599 0.000485457 
v 0.0877651 -0.0137599 0.000555698 
v 0.083924 -0.0137599 6.81166e-05 
v 0.0851741 -0.0137599 0.000415215 
v 0.0815275 -0.0137599 -0.000886709 
v 0.0826738 -0.0137599 -0.000278982 
v 0.0793924 -0.0137599 -0.00233437 
v 0.0803812 -0.0137599 -0.00149443 
v 0.0776184 -0.0137599 -0.00420718 
v 0.0784035 -0.0137599 -0.00317431 
v 0.0762884 -0.0137599 -0.00641757 
v 0.0768332 -0.0137599 -0.00524006 
v 0.0754647 -0.0137599 -0.00886218 
v 0.0757436 -0.0137599 -0.00759508 
v 0.0751155 -0.0137599 -0.0114267 
v 0.0751858 -0.0137599 -0.0101293 
v 0.0962957 -0.0163599 -0.0134474 
v 0.0965155 -0.0163599 -0.0114267 
v 0.0956467 -0.0163599 -0.0153737 
v 0.0945987 -0.0163599 -0.0171153 
v 0.0932009 -0.0163599 -0.018591 
v 0.0915185 -0.0163599 -0.0197317 
v 0.0896302 -0.0163599 -0.0204841 
v 0.0876244 -0.0163599 -0.0208129 
v 0.0855947 -0.0163599 -0.0207029 
v 0.0836362 -0.0163599 -0.0201591 
v 0.0818403 -0.0163599 -0.019207 
v 0.0802911 -0.0163599 -0.0178911 
v 0.079061 -0.0163599 -0.0162729 
v 0.0782075 -0.0163599 -0.0144281 
v 0.0777706 -0.0163599 -0.012443 
v 0.0777155 -0.0163599 -0.0114267 
v 0.0777706 -0.0163599 -0.0104104 
v 0.0782075 -0.0163599 -0.00842527 
v 0.079061 -0.0163599 -0.0065805 
v 0.0802911 -0.0163599 -0.00496233 
v 0.0818403 -0.0163599 -0.00364643 
v 0.0836362 -0.0163599 -0.00269432 
v 0.0855947 -0.0163599 -0.00215053 
v 0.0876244 -0.0163599 -0.00204049 
v 0.0896302 -0.0163599 -0.00236933 
v 0.0915185 -0.0163599 -0.00312169 
v 0.0932009 -0.0163599 -0.00426238 
v 0.0945987 -0.0163599 -0.00573807 
v 0.0956467 -0.0163599 -0.00747975 
v 0.0962957 -0.0163599 -0.00940598 
vn 0.977982 -0.015041 -0.208146 
vn 0.999832 -0.0150464 -0.0105093 
vn 0.917356 -0.0150879 -0.397782 
vn 0.977982 -0.015041 -0.208146 
vn 0.819854 -0.0151864 -0.572371 
vn 0.917356 -0.0150879 -0.397782 
vn 0.688468 -0.0153346 -0.725105 
vn 0.819854 -0.0151864 -0.572371 
vn 0.52733 -0.0155296 -0.849519 
vn 0.688468 -0.0153346 -0.725105 
vn 0.341792 -0.015767 -0.939644 
vn 0.52733 -0.0155296 -0.849519 
vn 0.138495 -0.0160403 -0.990233 
vn 0.341792 -0.015767 -0.939644 
vn -0.0745789 -0.0163407 -0.997081 
vn 0.138495 -0.0160403 -0.990233 
vn -0.28815 -0.0166563 -0.95744 
vn -0.0745789 -0.0163407 -0.997081 
vn -0.49182 -0.0169724 -0.870531 
vn -0.28815 -0.0166563 -0.95744 
vn -0.674484 -0.0172716 -0.738087 
vn -0.49182 -0.0169724 -0.870531 
vn -0.825023 -0.0175348 -0.564827 
vn -0.674484 -0.0172716 -0.738087 
vn -0.933289 -0.017743 -0.358688 
vn -0.825023 -0.0175348 -0.564827 
vn -0.991267 -0.0178794 -0.130649 
vn -0.933289 -0.017743 -0.358688 
vn -0.994206 -0.0179324 0.105986 
vn -0.991267 -0.0178794 -0.130649 
vn -0.941404 -0.0178973 0.336806 
vn -0.994206 -0.0179324 0.105986 
vn -0.836422 -0.0177771 0.547798 
vn -0.941404 -0.0178973 0.336806 
vn -0.686618 -0.0175823 0.726805 
vn -0.836422 -0.0177771 0.547798 
vn -0.50215 -0.0173288 0.864607 
vn -0.686618 -0.0175823 0.726805 
vn -0.294709 -0.0170354 0.955435 
vn -0.50215 -0.0173288 0.864607 
vn -0.0763157 -0.0167212 0.996943 
vn -0.294709 -0.0170354 0.955435 
vn 0.141637 -0.0164042 0.989783 
vn -0.0763157 -0.0167212 0.996943 
vn 0.349004 -0.0160997 0.936983 
vn 0.141637 -0.0164042 0.989783 
vn 0.537194 -0.0158201 0.84331 
vn 0.349004 -0.0160997 0.936983 
vn 0.699252 -0.0155747 0.714706 
vn 0.537194 -0.0158201 0.84331 
vn 0.829803 -0.0153706 0.557845 
vn 0.699252 -0.0155747 0.714706 
vn 0.924936 -0.0152126 0.379818 
vn 0.829803 -0.0153706 0.557845 
vn 0.982069 -0.0151039 0.187917 
vn 0.924936 -0.0152126 0.379818 
vn 0.0882132 0.996034 -0.0115707 
vn -0.667913 0.744138 -0.0123099 
vn -0.64772 0.741409 -0.175421 
vn -0.591305 0.736413 -0.328717 
vn -0.502509 0.72951 -0.464005 
vn -0.386981 0.721169 -0.574596 
vn -0.251579 0.711913 -0.655658 
vn -0.103758 0.702266 -0.704313 
vn 0.0489728 0.692718 -0.719544 
vn 0.199456 0.683697 -0.70198 
vn 0.341173 0.675561 -0.65362 
vn 0.468415 0.668594 -0.577555 
vn 0.576363 0.663014 -0.477721 
vn 0.661131 0.658977 -0.358686 
vn 0.71976 0.656586 -0.225476 
vn 0.75022 0.655901 -0.0834452 
vn 0.751405 0.656937 0.0618422 
vn 0.723139 0.659669 0.204709 
vn 0.666202 0.664031 0.339467 
vn 0.582357 0.669908 0.460525 
vn 0.474397 0.677133 0.562528 
vn 0.34618 0.685475 0.640533 
vn 0.202647 0.694635 0.690229 
vn 0.0497875 0.704241 0.708213 
vn -0.105469 0.713849 0.692312 
vn -0.255484 0.722962 0.641914 
vn -0.392283 0.731051 0.558282 
vn -0.508081 0.7376 0.444747 
vn -0.595918 0.742159 0.306728 
vn -0.650327 0.744394 0.151499 
vn -0.968949 -0.017821 -0.246617 
vn -0.991267 -0.0178794 -0.130649 
vn -0.999761 -0.0179168 -0.0125141 
vn -0.885005 -0.0176469 -0.465247 
vn -0.933289 -0.017743 -0.358688 
vn -0.754439 -0.0174089 -0.656139 
vn -0.825023 -0.0175348 -0.564827 
vn -0.586483 -0.0171253 -0.809781 
vn -0.674484 -0.0172716 -0.738087 
vn -0.391907 -0.0168153 -0.919851 
vn -0.49182 -0.0169724 -0.870531 
vn -0.18193 -0.0164974 -0.983173 
vn -0.28815 -0.0166563 -0.95744 
vn 0.0326297 -0.0161878 -0.999336 
vn -0.0745789 -0.0163407 -0.997081 
vn 0.241896 -0.0158997 -0.970172 
vn 0.138495 -0.0160403 -0.990233 
vn 0.437227 -0.0156434 -0.899215 
vn 0.341792 -0.015767 -0.939644 
vn 0.611313 -0.0154265 -0.791239 
vn 0.52733 -0.0155296 -0.849519 
vn 0.758166 -0.0152544 -0.651883 
vn 0.688468 -0.0153346 -0.725105 
vn 0.873054 -0.0151308 -0.487389 
vn 0.819854 -0.0151864 -0.572371 
vn 0.952422 -0.015058 -0.304409 
vn 0.917356 -0.0150879 -0.397782 
vn 0.993831 -0.0150372 -0.10988 
vn 0.977982 -0.015041 -0.208146 
vn 0.995912 -0.0150686 0.0890606 
vn 0.999832 -0.0150464 -0.0105093 
vn 0.958365 -0.0151519 0.285143 
vn 0.982069 -0.0151039 0.187917 
vn 0.881988 -0.0152856 0.471024 
vn 0.924936 -0.0152126 0.379818 
vn 0.768743 -0.0154672 0.639371 
vn 0.829803 -0.0153706 0.557845 
vn 0.621861 -0.0156926 0.78297 
vn 0.699252 -0.0155747 0.714706 
vn 0.445969 -0.0159562 0.894906 
vn 0.537194 -0.0158201 0.84331 
vn 0.247219 -0.0162496 0.968823 
vn 0.349004 -0.0160997 0.936983 
vn 0.0333841 -0.0165621 0.999305 
vn 0.141637 -0.0164042 0.989783 
vn -0.186146 -0.0168797 0.982377 
vn -0.0763157 -0.0167212 0.996943 
vn -0.400544 -0.0171859 0.916116 
vn -0.294709 -0.0170354 0.955435 
vn -0.598007 -0.0174618 0.8013 
vn -0.50215 -0.0173288 0.864607 
vn -0.766539 -0.0176881 0.641954 
vn -0.686618 -0.0175823 0.726805 
vn -0.895055 -0.0178473 0.445599 
vn -0.836422 -0.0177771 0.547798 
vn -0.974648 -0.0179258 0.223027 
vn -0.941404 -0.0178973 0.336806 
vn -0.999761 -0.0179168 -0.0125141 
vn -0.994206 -0.0179324 0.105986 
vn 0.723655 -0.673198 -0.152078 
vn 0.735043 -0.673073 -0.0817571 
vn 0.739228 -0.673372 -0.0106355 
vn 0.679755 -0.674718 -0.287557 
vn 0.70517 -0.673748 -0.220905 
vn 0.609089 -0.677891 -0.411672 
vn 0.647634 -0.676102 -0.351363 
vn 0.514136 -0.682638 -0.519297 
vn 0.564457 -0.680075 -0.467853 
vn 0.3983 -0.688826 -0.605703 
vn 0.45858 -0.685562 -0.565429 
vn 0.265899 -0.696268 -0.666715 
vn 0.333865 -0.692404 -0.639618 
vn 0.122147 -0.704714 -0.698898 
vn 0.195083 -0.700383 -0.68659 
vn -0.0269188 -0.713845 -0.699786 
vn 0.0478716 -0.709216 -0.703364 
vn -0.174565 -0.723273 -0.668134 
vn -0.101362 -0.718549 -0.68805 
vn -0.313591 -0.732548 -0.604181 
vn -0.245615 -0.72796 -0.640115 
vn -0.436672 -0.741172 -0.509884 
vn -0.377576 -0.736973 -0.560631 
vn -0.536822 -0.748636 -0.389058 
vn -0.490022 -0.74508 -0.452475 
vn -0.607949 -0.754458 -0.247368 
vn -0.576343 -0.75178 -0.3204 
vn -0.645443 -0.758235 -0.0921017 
vn -0.631116 -0.756623 -0.170924 
vn -0.646685 -0.759695 0.0682812 
vn -0.65067 -0.759266 -0.0119921 
vn -0.61139 -0.758727 0.224801 
vn -0.633527 -0.759514 0.147585 
vn -0.541676 -0.755405 0.368714 
vn -0.580613 -0.757349 0.29885 
vn -0.441856 -0.749971 0.492246 
vn -0.495185 -0.752931 0.433459 
vn -0.317982 -0.742805 0.589176 
vn -0.382496 -0.746576 0.544353 
vn -0.177245 -0.734376 0.655192 
vn -0.249245 -0.738717 0.626239 
vn -0.0273468 -0.725193 0.688003 
vn -0.102956 -0.729847 0.675814 
vn 0.124061 -0.715757 0.687241 
vn 0.0486317 -0.720477 0.691772 
vn 0.269819 -0.706532 0.654225 
vn 0.198066 -0.711092 0.674625 
vn 0.403557 -0.697918 0.591652 
vn 0.338553 -0.702126 0.626419 
vn 0.519868 -0.690249 0.503283 
vn 0.464189 -0.693947 0.550424 
vn 0.614387 -0.683788 0.393653 
vn 0.570083 -0.686853 0.450819 
vn 0.683803 -0.678735 0.267829 
vn 0.652399 -0.681075 0.332434 
vn 0.725841 -0.675233 0.131208 
vn 0.708347 -0.676783 0.200522 
vn 0.736158 -0.674093 0.0605873 
vn 0.739228 -0.673372 -0.0106355 
vn 0.0853947 -0.996284 -0.011201 
usemtl 0.400000_0.400000_0.400000_0.000000_0.000000
o mesh3
f 63//35 64//36 65//36 
f 66//37 63//35 67//38 
f 68//39 66//37 69//40 
f 70//41 68//39 71//42 
f 72//43 70//41 73//44 
f 74//45 72//43 75//46 
f 76//47 74//45 77//48 
f 78//49 76//47 79//50 
f 80//51 78//49 81//52 
f 82//53 80//51 83//54 
f 84//55 82//53 85//56 
f 86//57 84//55 87//58 
f 88//59 86//57 89//60 
f 90//61 88//59 91//62 
f 92//63 90//61 93//64 
f 94//65 92//63 95//66 
f 96//67 94//65 97//68 
f 98//69 96//67 99//70 
f 100//71 98//69 101//72 
f 102//73 100//71 103//74 
f 104//75 102//73 105//76 
f 106//77 104//75 107//78 
f 108//79 106//77 109//80 
f 110//81 108//79 111//82 
f 112//83 110//81 113//84 
f 114//85 112//83 115//86 
f 116//87 114//85 117//88 
f 118//89 116//87 119//90 
f 64//36 118//89 120//89 
f 120//89 65//36 64//36 
f 119//90 120//89 118//89 
f 117//88 119//90 116//87 
f 115//86 117//88 114//85 
f 113//84 115//86 112//83 
f 111//82 113//84 110//81 
f 109//80 111//82 108//79 
f 107//78 109//80 106//77 
f 105//76 107//78 104//75 
f 103//74 105//76 102//73 
f 101//72 103//74 100//71 
f 99//70 101//72 98//69 
f 97//68 99//70 96//67 
f 95//66 97//68 94//65 
f 93//64 95//66 92//63 
f 91//62 93//64 90//61 
f 89//60 91//62 88//59 
f 87//58 89//60 86//57 
f 85//56 87//58 84//55 
f 83//54 85//56 82//53 
f 81//52 83//54 80//51 
f 79//50 81//52 78//49 
f 77//48 79//50 76//47 
f 75//46 77//48 74//45 
f 73//44 75//46 72//43 
f 71//42 73//44 70//41 
f 69//40 71//42 68//39 
f 67//38 69//40 66//37 
f 65//36 67//38 63//35 
o mesh4
f 121//91 101//91 99//91 
f 121//91 122//91 103//91 
f 123//91 99//91 97//91 
f 103//91 101//91 121//91 
f 124//91 109//91 107//91 
f 124//91 125//91 111//91 
f 99//91 123//91 121//91 
f 122//91 126//91 105//91 
f 127//91 107//91 105//91 
f 111//91 109//91 124//91 
f 128//91 115//91 113//91 
f 128//91 129//91 117//91 
f 130//91 120//91 119//91 
f 131//91 65//91 120//91 
f 105//91 103//91 122//91 
f 107//91 127//91 124//91 
f 132//91 113//91 111//91 
f 117//91 115//91 128//91 
f 120//91 130//91 131//91 
f 133//91 67//91 65//91 
f 105//91 126//91 127//91 
f 113//91 132//91 128//91 
f 134//91 119//91 117//91 
f 65//91 131//91 133//91 
f 135//91 87//91 85//91 
f 136//91 89//91 87//91 
f 111//91 125//91 132//91 
f 119//91 134//91 130//91 
f 137//91 85//91 83//91 
f 87//91 135//91 136//91 
f 138//91 97//91 95//91 
f 117//91 129//91 134//91 
f 139//91 69//91 67//91 
f 140//91 71//91 69//91 
f 141//91 73//91 71//91 
f 142//91 75//91 73//91 
f 143//91 77//91 75//91 
f 143//91 144//91 79//91 
f 85//91 137//91 135//91 
f 145//91 91//91 89//91 
f 146//91 93//91 91//91 
f 147//91 95//91 93//91 
f 97//91 138//91 123//91 
f 69//91 139//91 140//91 
f 73//91 141//91 142//91 
f 79//91 77//91 143//91 
f 148//91 81//91 79//91 
f 149//91 83//91 81//91 
f 89//91 136//91 145//91 
f 93//91 146//91 147//91 
f 67//91 133//91 139//91 
f 75//91 142//91 143//91 
f 81//91 148//91 149//91 
f 91//91 145//91 146//91 
f 71//91 140//91 141//91 
f 83//91 149//91 137//91 
f 79//91 144//91 148//91 
f 95//91 147//91 138//91 
o mesh5
f 150//92 131//92 130//93 
f 151//93 130//93 134//94 
f 152//94 134//94 129//95 
f 153//95 129//95 128//96 
f 154//96 128//96 132//97 
f 155//97 132//97 125//98 
f 156//98 125//98 124//99 
f 157//99 124//99 127//100 
f 158//100 127//100 126//101 
f 159//101 126//101 122//102 
f 160//102 122//102 121//103 
f 161//103 121//103 123//104 
f 162//104 123//104 138//105 
f 163//105 138//105 147//106 
f 164//106 147//106 146//107 
f 165//107 146//107 145//108 
f 166//108 145//108 136//109 
f 167//109 136//109 135//110 
f 168//110 135//110 137//111 
f 169//111 137//111 149//112 
f 170//112 149//112 148//113 
f 171//113 148//113 144//114 
f 172//114 144//114 143//115 
f 173//115 143//115 142//116 
f 174//116 142//116 141//117 
f 175//117 141//117 140//118 
f 176//118 140//118 139//119 
f 177//119 139//119 133//120 
f 178//120 133//120 131//92 
f 131//92 150//92 178//120 
f 133//120 178//120 177//119 
f 139//119 177//119 176//118 
f 140//118 176//118 175//117 
f 141//117 175//117 174//116 
f 142//116 174//116 173//115 
f 143//115 173//115 172//114 
f 144//114 172//114 171//113 
f 148//113 171//113 170//112 
f 149//112 170//112 169//111 
f 137//111 169//111 168//110 
f 135//110 168//110 167//109 
f 136//109 167//109 166//108 
f 145//108 166//108 165//107 
f 146//107 165//107 164//106 
f 147//106 164//106 163//105 
f 138//105 163//105 162//104 
f 123//104 162//104 161//103 
f 121//103 161//103 160//102 
f 122//102 160//102 159//101 
f 126//101 159//101 158//100 
f 127//100 158//100 157//99 
f 124//99 157//99 156//98 
f 125//98 156//98 155//97 
f 132//97 155//97 154//96 
f 128//96 154//96 153//95 
f 129//95 153//95 152//94 
f 134//94 152//94 151//93 
f 130//93 151//93 150//92 
o mesh6
f 151//121 179//121 180//122 
f 180//122 150//123 151//121 
f 152//124 181//124 182//125 
f 182//125 151//121 152//124 
f 153//126 183//126 184//127 
f 184//127 152//124 153//126 
f 154//128 185//128 186//129 
f 186//129 153//126 154//128 
f 155//130 187//130 188//131 
f 188//131 154//128 155//130 
f 156//132 189//132 190//133 
f 190//133 155//130 156//132 
f 157//134 191//134 192//135 
f 192//135 156//132 157//134 
f 158//136 193//136 194//137 
f 194//137 157//134 158//136 
f 159//138 195//138 196//139 
f 196//139 158//136 159//138 
f 160//140 197//140 198//141 
f 198//141 159//138 160//140 
f 160//140 161//142 199//143 
f 161//142 200//142 199//143 
f 161//142 162//144 201//145 
f 162//144 202//144 201//145 
f 162//144 163//146 203//147 
f 163//146 204//146 203//147 
f 164//148 205//148 206//149 
f 206//149 163//146 164//148 
f 165//150 207//150 208//151 
f 208//151 164//148 165//150 
f 166//152 209//152 210//153 
f 210//153 165//150 166//152 
f 167//154 211//154 212//155 
f 212//155 166//152 167//154 
f 168//156 213//156 214//157 
f 214//157 167//154 168//156 
f 169//158 215//158 216//159 
f 216//159 168//156 169//158 
f 170//160 217//160 218//161 
f 218//161 169//158 170//160 
f 171//162 219//162 220//163 
f 220//163 170//160 171//162 
f 172//164 221//164 222//165 
f 222//165 171//162 172//164 
f 173//166 223//166 224//167 
f 224//167 172//164 173//166 
f 174//168 225//168 226//169 
f 226//169 173//166 174//168 
f 175//170 227//170 228//171 
f 228//171 174//168 175//170 
f 176//172 229//172 230//173 
f 230//173 175//170 176//172 
f 177//174 231//174 232//175 
f 232//175 176//172 177//174 
f 178//176 233//176 234//177 
f 234//177 177//174 178//176 
f 150//123 235//178 236//179 
f 236//179 178//176 150//123 
f 236//179 233//176 178//176 
f 234//177 231//174 177//174 
f 232//175 229//172 176//172 
f 230//173 227//170 175//170 
f 228//171 225//168 174//168 
f 226//169 223//166 173//166 
f 224//167 221//164 172//164 
f 222//165 219//162 171//162 
f 220//163 217//160 170//160 
f 218//161 215//158 169//158 
f 216//159 213//156 168//156 
f 214//157 211//154 167//154 
f 212//155 209//152 166//152 
f 210//153 207//150 165//150 
f 208//151 205//148 164//148 
f 206//149 204//146 163//146 
f 203//147 202//144 162//144 
f 201//145 200//142 161//142 
f 199//143 197//140 160//140 
f 198//141 195//138 159//138 
f 196//139 193//136 158//136 
f 194//137 191//134 157//134 
f 192//135 189//132 156//132 
f 190//133 187//130 155//130 
f 188//131 185//128 154//128 
f 186//129 183//126 153//126 
f 184//127 181//124 152//124 
f 182//125 179//121 151//121 
f 180//122 235//178 150//123 
o mesh7
f 237//180 206//180 205//181 
f 205//181 238//182 237//180 
f 239//183 203//183 204//184 
f 204//184 237//180 239//183 
f 240//185 201//185 202//186 
f 202//186 239//183 240//185 
f 241//187 199//187 200//188 
f 200//188 240//185 241//187 
f 242//189 198//189 197//190 
f 197//190 241//187 242//189 
f 243//191 196//191 195//192 
f 195//192 242//189 243//191 
f 244//193 194//193 193//194 
f 193//194 243//191 244//193 
f 245//195 192//195 191//196 
f 191//196 244//193 245//195 
f 246//197 190//197 189//198 
f 189//198 245//195 246//197 
f 247//199 188//199 187//200 
f 187//200 246//197 247//199 
f 248//201 186//201 185//202 
f 185//202 247//199 248//201 
f 249//203 184//203 183//204 
f 183//204 248//201 249//203 
f 250//205 182//205 181//206 
f 181//206 249//203 250//205 
f 251//207 180//207 179//208 
f 179//208 250//205 251//207 
f 236//209 235//210 252//210 
f 180//207 251//207 252//210 
f 252//210 235//210 180//207 
f 253//209 254//211 233//212 
f 254//211 234//211 233//212 
f 254//211 255//213 231//214 
f 255//213 232//213 231//214 
f 255//213 256//215 229//216 
f 256//215 230//215 229//216 
f 257//217 228//217 227//218 
f 227//218 256//215 257//217 
f 258//219 226//219 225//220 
f 225//220 257//217 258//219 
f 259//221 224//221 223//222 
f 223//222 258//219 259//221 
f 260//223 222//223 221//224 
f 221//224 259//221 260//223 
f 261//225 220//225 219//226 
f 219//226 260//223 261//225 
f 262//227 218//227 217//228 
f 217//228 261//225 262//227 
f 263//229 216//229 215//230 
f 215//230 262//227 263//229 
f 263//229 264//231 213//232 
f 264//231 214//231 213//232 
f 265//233 212//233 211//234 
f 211//234 264//231 265//233 
f 266//235 210//235 209//236 
f 209//236 265//233 266//235 
f 266//235 238//182 207//237 
f 238//182 208//238 207//237 
f 207//237 210//235 266//235 
f 209//236 212//233 265//233 
f 211//234 214//231 264//231 
f 213//232 216//229 263//229 
f 215//230 218//227 262//227 
f 217//228 220//225 261//225 
f 219//226 222//223 260//223 
f 221//224 224//221 259//221 
f 223//222 226//219 258//219 
f 225//220 228//217 257//217 
f 227//218 230//215 256//215 
f 229//216 232//213 255//213 
f 231//214 234//211 254//211 
f 233//212 236//209 253//209 
f 252//210 253//209 236//209 
f 179//208 182//205 250//205 
f 181//206 184//203 249//203 
f 183//204 186//201 248//201 
f 185//202 188//199 247//199 
f 187//200 190//197 246//197 
f 189//198 192//195 245//195 
f 191//196 194//193 244//193 
f 193//194 196//191 243//191 
f 195//192 198//189 242//189 
f 197//190 199//187 241//187 
f 200//188 201//185 240//185 
f 202//186 203//183 239//183 
f 204//184 206//180 237//180 
f 205//181 208//238 238//182 
o mesh8
f 251//239 250//239 118//239 
f 64//239 252//239 251//239 
f 250//239 249//239 116//239 
f 248//239 247//239 112//239 
f 247//239 246//239 110//239 
f 116//239 118//239 250//239 
f 249//239 248//239 114//239 
f 110//239 112//239 247//239 
f 246//239 245//239 108//239 
f 245//239 244//239 106//239 
f 244//239 243//239 104//239 
f 241//239 240//239 98//239 
f 240//239 239//239 96//239 
f 264//239 263//239 84//239 
f 263//239 262//239 82//239 
f 114//239 116//239 249//239 
f 108//239 110//239 246//239 
f 104//239 106//239 244//239 
f 243//239 242//239 102//239 
f 242//239 241//239 100//239 
f 96//239 98//239 240//239 
f 237//239 238//239 92//239 
f 238//239 266//239 90//239 
f 82//239 84//239 263//239 
f 262//239 261//239 80//239 
f 112//239 114//239 248//239 
f 102//239 104//239 243//239 
f 98//239 100//239 241//239 
f 239//239 237//239 94//239 
f 90//239 92//239 238//239 
f 266//239 265//239 88//239 
f 265//239 264//239 86//239 
f 80//239 82//239 262//239 
f 259//239 258//239 74//239 
f 258//239 257//239 72//239 
f 257//239 256//239 70//239 
f 256//239 255//239 68//239 
f 106//239 108//239 245//239 
f 94//239 96//239 239//239 
f 88//239 90//239 266//239 
f 84//239 86//239 264//239 
f 72//239 74//239 258//239 
f 68//239 70//239 256//239 
f 255//239 254//239 66//239 
f 254//239 253//239 63//239 
f 100//239 102//239 242//239 
f 86//239 88//239 265//239 
f 261//239 260//239 78//239 
f 260//239 259//239 76//239 
f 70//239 72//239 257//239 
f 63//239 66//239 254//239 
f 92//239 94//239 237//239 
f 76//239 78//239 260//239 
f 66//239 68//239 255//239 
f 253//239 252//239 64//239 
f 78//239 80//239 261//239 
f 64//239 63//239 253//239 
f 74//239 76//239 259//239 
f 118//239 64//239 251//239 
g bearing
v 0.0946739 0.0160401 0.0585359 
v 0.0946155 0.0160401 0.0590733 
v 0.0946155 0.00584011 0.0590733 
v 0.0948465 0.0160401 0.0580236 
v 0.0946739 0.00584011 0.0585359 
v 0.0951252 0.0160401 0.0575604 
v 0.0948465 0.00584011 0.0580236 
v 0.095497 0.0160401 0.0571679 
v 0.0951252 0.00584011 0.0575604 
v 0.0959445 0.0160401 0.0568645 
v 0.095497 0.00584011 0.0571679 
v 0.0964467 0.0160401 0.0566644 
v 0.0959445 0.00584011 0.0568645 
v 0.0969801 0.0160401 0.056577 
v 0.0964467 0.00584011 0.0566644 
v 0.0975199 0.0160401 0.0566062 
v 0.0969801 0.00584011 0.056577 
v 0.0980408 0.0160401 0.0567509 
v 0.0975199 0.00584011 0.0566062 
v 0.0985184 0.0160401 0.0570041 
v 0.0980408 0.00584011 0.0567509 
v 0.0989305 0.0160401 0.057354 
v 0.0985184 0.00584011 0.0570041 
v 0.0992576 0.0160401 0.0577844 
v 0.0989305 0.00584011 0.057354 
v 0.0994846 0.0160401 0.058275 
v 0.0992576 0.00584011 0.0577844 
v 0.0996008 0.0160401 0.058803 
v 0.0994846 0.00584011 0.058275 
v 0.0996008 0.0160401 0.0593436 
v 0.0996008 0.00584011 0.058803 
v 0.0994846 0.0160401 0.0598716 
v 0.0996008 0.00584011 0.0593436 
v 0.0992576 0.0160401 0.0603622 
v 0.0994846 0.00584011 0.0598716 
v 0.0989305 0.0160401 0.0607925 
v 0.0992576 0.00584011 0.0603622 
v 0.0985184 0.0160401 0.0611425 
v 0.0989305 0.00584011 0.0607925 
v 0.0980408 0.0160401 0.0613957 
v 0.0985184 0.00584011 0.0611425 
v 0.0975199 0.0160401 0.0615404 
v 0.0980408 0.00584011 0.0613957 
v 0.0969801 0.0160401 0.0615696 
v 0.0975199 0.00584011 0.0615404 
v 0.0964467 0.0160401 0.0614822 
v 0.0969801 0.00584011 0.0615696 
v 0.0959445 0.0160401 0.0612821 
v 0.0964467 0.00584011 0.0614822 
v 0.095497 0.0160401 0.0609787 
v 0.0959445 0.00584011 0.0612821 
v 0.0951252 0.0160401 0.0605862 
v 0.095497 0.00584011 0.0609787 
v 0.0948465 0.0160401 0.060123 
v 0.0951252 0.00584011 0.0605862 
v 0.0946739 0.0160401 0.0596107 
v 0.0948465 0.00584011 0.060123 
v 0.0946739 0.00584011 0.0596107 
v 0.10394 0.00584011 0.0655377 
v 0.102391 0.00584011 0.0668536 
v 0.10517 0.00584011 0.0639195 
v 0.0966066 0.00584011 0.0684595 
v 0.0946007 0.00584011 0.0681307 
v 0.100595 0.00584011 0.0678057 
v 0.0986362 0.00584011 0.0683495 
v 0.09103 0.00584011 0.0662376 
v 0.0896322 0.00584011 0.0647619 
v 0.0879352 0.00584011 0.061094 
v 0.0877155 0.00584011 0.0590733 
v 0.0927124 0.00584011 0.0673783 
v 0.0879352 0.00584011 0.0570526 
v 0.0885843 0.00584011 0.0630203 
v 0.10394 0.00584011 0.0526089 
v 0.10517 0.00584011 0.0542271 
v 0.102391 0.00584011 0.051293 
v 0.106023 0.00584011 0.0620747 
v 0.0885843 0.00584011 0.0551263 
v 0.0896322 0.00584011 0.0533847 
v 0.09103 0.00584011 0.051909 
v 0.0927124 0.00584011 0.0507683 
v 0.0946007 0.00584011 0.0500159 
v 0.0966066 0.00584011 0.0496871 
v 0.106023 0.00584011 0.0560719 
v 0.10646 0.00584011 0.058057 
v 0.10646 0.00584011 0.0600896 
v 0.0986362 0.00584011 0.0497971 
v 0.100595 0.00584011 0.0503409 
v 0.0851155 0.00844011 0.0590733 
v 0.085396 0.00844011 0.0616529 
v 0.0862246 0.00844011 0.064112 
v 0.0875624 0.00844011 0.0663354 
v 0.0893468 0.00844011 0.0682192 
v 0.0914946 0.00844011 0.0696754 
v 0.0939051 0.00844011 0.0706359 
v 0.0964658 0.00844011 0.0710557 
v 0.0990569 0.00844011 0.0709152 
v 0.101557 0.00844011 0.070221 
v 0.10385 0.00844011 0.0690056 
v 0.105827 0.00844011 0.0673257 
v 0.107398 0.00844011 0.0652599 
v 0.108487 0.00844011 0.0629049 
v 0.109045 0.00844011 0.0603707 
v 0.109045 0.00844011 0.0577759 
v 0.108487 0.00844011 0.0552417 
v 0.107398 0.00844011 0.0528867 
v 0.105827 0.00844011 0.0508209 
v 0.10385 0.00844011 0.049141 
v 0.101557 0.00844011 0.0479256 
v 0.0990569 0.00844011 0.0472314 
v 0.0964658 0.00844011 0.0470909 
v 0.0939051 0.00844011 0.0475107 
v 0.0914946 0.00844011 0.0484712 
v 0.0893468 0.00844011 0.0499274 
v 0.0875624 0.00844011 0.0518112 
v 0.0862246 0.00844011 0.0540346 
v 0.085396 0.00844011 0.0564937 
v 0.0854647 0.0134401 0.0616378 
v 0.0851858 0.0134401 0.0603707 
v 0.0862884 0.0134401 0.0640824 
v 0.0857436 0.0134401 0.0629049 
v 0.0876184 0.0134401 0.0662928 
v 0.0868332 0.0134401 0.0652599 
v 0.0893924 0.0134401 0.0681656 
v 0.0884035 0.0134401 0.0673257 
v 0.0915275 0.0134401 0.0696133 
v 0.0903812 0.0134401 0.0690056 
v 0.093924 0.0134401 0.0705681 
v 0.0926738 0.0134401 0.070221 
v 0.0964696 0.0134401 0.0709855 
v 0.0951741 0.0134401 0.0709152 
v 0.0990455 0.0134401 0.0708458 
v 0.0977651 0.0134401 0.0710557 
v 0.101531 0.0134401 0.0701557 
v 0.100326 0.0134401 0.0706359 
v 0.10381 0.0134401 0.0689473 
v 0.102736 0.0134401 0.0696754 
v 0.104884 0.0134401 0.0682192 
v 0.105776 0.0134401 0.0672773 
v 0.106669 0.0134401 0.0663354 
v 0.107337 0.0134401 0.0652237 
v 0.108006 0.0134401 0.064112 
v 0.108421 0.0134401 0.0628825 
v 0.108975 0.0134401 0.0603631 
v 0.108835 0.0134401 0.0616529 
v 0.108975 0.0134401 0.0577835 
v 0.109115 0.0134401 0.0590733 
v 0.108421 0.0134401 0.0552641 
v 0.108835 0.0134401 0.0564937 
v 0.107337 0.0134401 0.0529229 
v 0.108006 0.0134401 0.0540346 
v 0.105776 0.0134401 0.0508693 
v 0.106669 0.0134401 0.0518112 
v 0.10381 0.0134401 0.0491993 
v 0.104884 0.0134401 0.0499274 
v 0.101531 0.0134401 0.0479909 
v 0.102736 0.0134401 0.0484712 
v 0.0990455 0.0134401 0.0473008 
v 0.100326 0.0134401 0.0475107 
v 0.0964696 0.0134401 0.0471611 
v 0.0977651 0.0134401 0.0470909 
v 0.093924 0.0134401 0.0475785 
v 0.0951741 0.0134401 0.0472314 
v 0.0915275 0.0134401 0.0485333 
v 0.0926738 0.0134401 0.0479256 
v 0.0893924 0.0134401 0.049981 
v 0.0903812 0.0134401 0.049141 
v 0.0876184 0.0134401 0.0518538 
v 0.0884035 0.0134401 0.0508209 
v 0.0862884 0.0134401 0.0540642 
v 0.0868332 0.0134401 0.0528867 
v 0.0854647 0.0134401 0.0565088 
v 0.0857436 0.0134401 0.0552417 
v 0.0851155 0.0134401 0.0590733 
v 0.0851858 0.0134401 0.0577759 
v 0.106296 0.0160401 0.061094 
v 0.106515 0.0160401 0.0590733 
v 0.105647 0.0160401 0.0630203 
v 0.104599 0.0160401 0.0647619 
v 0.103201 0.0160401 0.0662376 
v 0.101519 0.0160401 0.0673783 
v 0.0996302 0.0160401 0.0681307 
v 0.0976244 0.0160401 0.0684595 
v 0.0955947 0.0160401 0.0683495 
v 0.0936362 0.0160401 0.0678057 
v 0.0918403 0.0160401 0.0668536 
v 0.0902911 0.0160401 0.0655377 
v 0.089061 0.0160401 0.0639195 
v 0.0882075 0.0160401 0.0620747 
v 0.0877706 0.0160401 0.0600896 
v 0.0877155 0.0160401 0.0590733 
v 0.0877706 0.0160401 0.058057 
v 0.0882075 0.0160401 0.0560719 
v 0.089061 0.0160401 0.0542271 
v 0.0902911 0.0160401 0.0526089 
v 0.0918403 0.0160401 0.051293 
v 0.0936362 0.0160401 0.0503409 
v 0.0955947 0.0160401 0.0497971 
v 0.0976244 0.0160401 0.0496871 
v 0.0996302 0.0160401 0.0500159 
v 0.101519 0.0160401 0.0507683 
v 0.103201 0.0160401 0.051909 
v 0.104599 0.0160401 0.0533847 
v 0.105647 0.0160401 0.0551263 
v 0.106296 0.0160401 0.0570526 
vn 0.968838 0.0144731 0.247271 
vn 0.998447 0.0145976 0.0537606 
vn 0.902579 0.0144099 0.430283 
vn 0.968838 0.0144731 0.247271 
vn 0.80235 0.0144085 0.596679 
vn 0.902579 0.0144099 0.430283 
vn 0.671577 0.014469 0.740794 
vn 0.80235 0.0144085 0.596679 
vn 0.514423 0.0145907 0.857413 
vn 0.671577 0.014469 0.740794 
vn 0.335827 0.0147725 0.941808 
vn 0.514423 0.0145907 0.857413 
vn 0.141559 0.015012 0.989816 
vn 0.335827 0.0147725 0.941808 
vn -0.0617035 0.0153052 0.997977 
vn 0.141559 0.015012 0.989816 
vn -0.266311 0.0156458 0.96376 
vn -0.0617035 0.0153052 0.997977 
vn -0.463616 0.0160244 0.885891 
vn -0.266311 0.0156458 0.96376 
vn -0.64406 0.0164273 0.764799 
vn -0.463616 0.0160244 0.885891 
vn -0.797451 0.0168363 0.603149 
vn -0.64406 0.0164273 0.764799 
vn -0.913533 0.0172281 0.406399 
vn -0.797451 0.0168363 0.603149 
vn -0.982918 0.0175761 0.183202 
vn -0.913533 0.0172281 0.406399 
vn -0.998349 0.017852 -0.0545859 
vn -0.982918 0.0175761 0.183202 
vn -0.956089 0.0180307 -0.292522 
vn -0.998349 0.017852 -0.0545859 
vn -0.857036 0.0180942 -0.514939 
vn -0.956089 0.0180307 -0.292522 
vn -0.707134 0.0180361 -0.706849 
vn -0.857036 0.0180942 -0.514939 
vn -0.516788 0.0178622 -0.855927 
vn -0.707134 0.0180361 -0.706849 
vn -0.299405 0.0175901 -0.953964 
vn -0.516788 0.0178622 -0.855927 
vn -0.0695232 0.0172448 -0.997431 
vn -0.299405 0.0175901 -0.953964 
vn 0.158932 0.0168543 -0.987146 
vn -0.0695232 0.0172448 -0.997431 
vn 0.373861 0.0164455 -0.927339 
vn 0.158932 0.0168543 -0.987146 
vn 0.565588 0.0160419 -0.824532 
vn 0.373861 0.0164455 -0.927339 
vn 0.726949 0.0156619 -0.686513 
vn 0.565588 0.0160419 -0.824532 
vn 0.853075 0.0153194 -0.521564 
vn 0.726949 0.0156619 -0.686513 
vn 0.941042 0.0150239 -0.337957 
vn 0.853075 0.0153194 -0.521564 
vn 0.989515 0.014782 -0.143669 
vn 0.941042 0.0150239 -0.337957 
vn 0.0980465 -0.993393 0.0596396 
vn -0.660405 -0.748181 0.0639555 
vn -0.634681 -0.739068 0.225742 
vn -0.573803 -0.728074 0.375043 
vn -0.482575 -0.715943 0.504526 
vn -0.36709 -0.703395 0.608671 
vn -0.234103 -0.691076 0.68382 
vn -0.0905186 -0.679528 0.728044 
vn 0.0569703 -0.669181 0.740912 
vn 0.202115 -0.660362 0.723237 
vn 0.339235 -0.653306 0.676839 
vn 0.46328 -0.648178 0.604349 
vn 0.569849 -0.645081 0.509061 
vn 0.6552 -0.644074 0.394818 
vn 0.716259 -0.645175 0.265937 
vn 0.750638 -0.648364 0.12715 
vn 0.756678 -0.653581 -0.0164357 
vn 0.733516 -0.660719 -0.159386 
vn 0.68118 -0.669612 -0.295995 
vn 0.600714 -0.68002 -0.420375 
vn 0.494325 -0.691613 -0.526607 
vn 0.365535 -0.703954 -0.608961 
vn 0.219296 -0.716498 -0.662223 
vn 0.0620284 -0.728594 -0.682131 
vn -0.0985099 -0.739519 -0.665888 
vn -0.253566 -0.748532 -0.612702 
vn -0.393999 -0.754956 -0.52422 
vn -0.511105 -0.75827 -0.404719 
vn -0.597541 -0.758194 -0.260935 
vn -0.648133 -0.754733 -0.101496 
vn -0.954583 0.0174093 0.297437 
vn -0.982918 0.0175761 0.183202 
vn -0.99771 0.0177247 0.0652775 
vn -0.860776 0.0170359 0.508698 
vn -0.913533 0.0172281 0.406399 
vn -0.724786 0.0166324 0.688773 
vn -0.797451 0.0168363 0.603149 
vn -0.556573 0.0162238 0.83064 
vn -0.64406 0.0164273 0.764799 
vn -0.366454 0.0158311 0.930301 
vn -0.463616 0.0160244 0.885891 
vn -0.164356 0.01547 0.98628 
vn -0.266311 0.0156458 0.96376 
vn 0.0405975 0.0151522 0.999061 
vn -0.0617035 0.0153052 0.997977 
vn 0.240257 0.0148852 0.970595 
vn 0.141559 0.015012 0.989816 
vn 0.427465 0.0146742 0.903913 
vn 0.335827 0.0147725 0.941808 
vn 0.596007 0.0145222 0.802848 
vn 0.514423 0.0145907 0.857413 
vn 0.740539 0.014431 0.671859 
vn 0.671577 0.014469 0.740794 
vn 0.856514 0.0144014 0.515923 
vn 0.80235 0.0144085 0.596679 
vn 0.94014 0.0144338 0.340482 
vn 0.902579 0.0144099 0.430283 
vn 0.988362 0.0145277 0.151428 
vn 0.968838 0.0144731 0.247271 
vn 0.998884 0.0146824 -0.0448942 
vn 0.998447 0.0145976 0.0537606 
vn 0.970245 0.014896 -0.241666 
vn 0.989515 0.014782 -0.143669 
vn 0.901945 0.0151653 -0.431585 
vn 0.941042 0.0150239 -0.337957 
vn 0.794641 0.0154853 -0.606883 
vn 0.853075 0.0153194 -0.521564 
vn 0.650419 0.015848 -0.759411 
vn 0.726949 0.0156619 -0.686513 
vn 0.47313 0.0162418 -0.880843 
vn 0.565588 0.0160419 -0.824532 
vn 0.268752 0.0166506 -0.963066 
vn 0.373861 0.0164455 -0.927339 
vn 0.0456916 0.0170534 -0.99881 
vn 0.158932 0.0168543 -0.987146 
vn -0.185125 0.0174249 -0.982561 
vn -0.0695232 0.0172448 -0.997431 
vn -0.410572 0.017737 -0.911656 
vn -0.299405 0.0175901 -0.953964 
vn -0.616228 0.0179627 -0.787363 
vn -0.516788 0.0178622 -0.855927 
vn -0.787882 0.0180803 -0.615561 
vn -0.707134 0.0180361 -0.706849 
vn -0.913406 0.0180776 -0.406647 
vn -0.857036 0.0180942 -0.514939 
vn -0.984492 0.0179548 -0.174507 
vn -0.956089 0.0180307 -0.292522 
vn -0.99771 0.0177247 0.0652775 
vn -0.998349 0.017852 -0.0545859 
vn 0.722697 0.663479 0.193664 
vn 0.736084 0.665307 0.124685 
vn 0.742488 0.667636 0.0545386 
vn 0.675734 0.661356 0.325562 
vn 0.702504 0.66216 0.26083 
vn 0.603598 0.66131 0.445353 
vn 0.64266 0.661073 0.387261 
vn 0.508996 0.66334 0.548546 
vn 0.558909 0.662067 0.499288 
vn 0.395315 0.667408 0.631104 
vn 0.454303 0.665124 0.592638 
vn 0.266604 0.67343 0.689503 
vn 0.33256 0.670182 0.663521 
vn 0.127557 0.68127 0.720834 
vn 0.198054 0.677134 0.708706 
vn -0.0165068 0.690724 0.72293 
vn 0.0557959 0.68581 0.725638 
vn -0.159687 0.701511 0.694538 
vn -0.0885963 0.695972 0.712582 
vn -0.295603 0.713253 0.635522 
vn -0.228966 0.70729 0.668816 
vn -0.417578 0.72547 0.547102 
vn -0.358755 0.719337 0.594852 
vn -0.518927 0.737578 0.432079 
vn -0.471238 0.731578 0.492674 
vn -0.593389 0.748909 0.295001 
vn -0.55988 0.743385 0.365942 
vn -0.635673 0.758749 0.142197 
vn -0.618828 0.75406 0.220103 
vn -0.64209 0.766408 -0.018418 
vn -0.643516 0.762891 0.06232 
vn -0.61113 0.7713 -0.177808 
vn -0.631278 0.76923 -0.0988561 
vn -0.543868 0.773028 -0.32655 
vn -0.581864 0.772575 -0.254089 
vn -0.444042 0.771447 -0.455737 
vn -0.497694 0.772649 -0.394099 
vn -0.317749 0.766689 -0.557874 
vn -0.383747 0.769446 -0.510579 
vn -0.172805 0.759142 -0.627569 
vn -0.247076 0.763231 -0.597019 
vn -0.0179087 0.749385 -0.661893 
vn -0.0960466 0.754498 -0.649237 
vn 0.138198 0.738105 -0.66038 
vn 0.0605211 0.74389 -0.665556 
vn 0.287423 0.726017 -0.624729 
vn 0.214137 0.732119 -0.646643 
vn 0.422789 0.713792 -0.558346 
vn 0.357223 0.719883 -0.595114 
vn 0.538673 0.702017 -0.465836 
vn 0.483463 0.707815 -0.515035 
vn 0.63086 0.691179 -0.352544 
vn 0.587939 0.696455 -0.411435 
vn 0.696478 0.681658 -0.224188 
vn 0.66712 0.686234 -0.289885 
vn 0.733876 0.673742 -0.0865846 
vn 0.718764 0.677485 -0.156181 
vn 0.741777 0.670453 -0.0161121 
vn 0.742488 0.667636 0.0545386 
vn 0.0949897 0.9938 0.0577802 
o mesh3
f 267//240 268//241 269//241 
f 270//242 267//240 271//243 
f 272//244 270//242 273//245 
f 274//246 272//244 275//247 
f 276//248 274//246 277//249 
f 278//250 276//248 279//251 
f 280//252 278//250 281//253 
f 282//254 280//252 283//255 
f 284//256 282//254 285//257 
f 286//258 284//256 287//259 
f 288//260 286//258 289//261 
f 290//262 288//260 291//263 
f 292//264 290//262 293//265 
f 294//266 292//264 295//267 
f 296//268 294//266 297//269 
f 298//270 296//268 299//271 
f 300//272 298//270 301//273 
f 302//274 300//272 303//275 
f 304//276 302//274 305//277 
f 306//278 304//276 307//279 
f 308//280 306//278 309//281 
f 310//282 308//280 311//283 
f 312//284 310//282 313//285 
f 314//286 312//284 315//287 
f 316//288 314//286 317//289 
f 318//290 316//288 319//291 
f 320//292 318//290 321//293 
f 322//294 320//292 323//295 
f 268//241 322//294 324//294 
f 324//294 269//241 268//241 
f 323//295 324//294 322//294 
f 321//293 323//295 320//292 
f 319//291 321//293 318//290 
f 317//289 319//291 316//288 
f 315//287 317//289 314//286 
f 313//285 315//287 312//284 
f 311//283 313//285 310//282 
f 309//281 311//283 308//280 
f 307//279 309//281 306//278 
f 305//277 307//279 304//276 
f 303//275 305//277 302//274 
f 301//273 303//275 300//272 
f 299//271 301//273 298//270 
f 297//269 299//271 296//268 
f 295//267 297//269 294//266 
f 293//265 295//267 292//264 
f 291//263 293//265 290//262 
f 289//261 291//263 288//260 
f 287//259 289//261 286//258 
f 285//257 287//259 284//256 
f 283//255 285//257 282//254 
f 281//253 283//255 280//252 
f 279//251 281//253 278//250 
f 277//249 279//251 276//248 
f 275//247 277//249 274//246 
f 273//245 275//247 272//244 
f 271//243 273//245 270//242 
f 269//241 271//243 267//240 
o mesh4
f 325//296 305//296 303//296 
f 325//296 326//296 307//296 
f 327//296 303//296 301//296 
f 307//296 305//296 325//296 
f 328//296 313//296 311//296 
f 328//296 329//296 315//296 
f 303//296 327//296 325//296 
f 326//296 330//296 309//296 
f 331//296 311//296 309//296 
f 315//296 313//296 328//296 
f 332//296 319//296 317//296 
f 332//296 333//296 321//296 
f 334//296 324//296 323//296 
f 335//296 269//296 324//296 
f 309//296 307//296 326//296 
f 311//296 331//296 328//296 
f 336//296 317//296 315//296 
f 321//296 319//296 332//296 
f 324//296 334//296 335//296 
f 337//296 271//296 269//296 
f 309//296 330//296 331//296 
f 317//296 336//296 332//296 
f 338//296 323//296 321//296 
f 269//296 335//296 337//296 
f 339//296 291//296 289//296 
f 340//296 293//296 291//296 
f 315//296 329//296 336//296 
f 323//296 338//296 334//296 
f 341//296 289//296 287//296 
f 291//296 339//296 340//296 
f 342//296 301//296 299//296 
f 321//296 333//296 338//296 
f 343//296 273//296 271//296 
f 344//296 275//296 273//296 
f 345//296 277//296 275//296 
f 346//296 279//296 277//296 
f 347//296 281//296 279//296 
f 347//296 348//296 283//296 
f 289//296 341//296 339//296 
f 349//296 295//296 293//296 
f 350//296 297//296 295//296 
f 351//296 299//296 297//296 
f 301//296 342//296 327//296 
f 273//296 343//296 344//296 
f 277//296 345//296 346//296 
f 283//296 281//296 347//296 
f 352//296 285//296 283//296 
f 353//296 287//296 285//296 
f 293//296 340//296 349//296 
f 297//296 350//296 351//296 
f 271//296 337//296 343//296 
f 279//296 346//296 347//296 
f 285//296 352//296 353//296 
f 295//296 349//296 350//296 
f 275//296 344//296 345//296 
f 287//296 353//296 341//296 
f 283//296 348//296 352//296 
f 299//296 351//296 342//296 
o mesh5
f 354//297 335//297 334//298 
f 355//298 334//298 338//299 
f 356//299 338//299 333//300 
f 357//300 333//300 332//301 
f 358//301 332//301 336//302 
f 359//302 336//302 329//303 
f 360//303 329//303 328//304 
f 361//304 328//304 331//305 
f 362//305 331//305 330//306 
f 363//306 330//306 326//307 
f 364//307 326//307 325//308 
f 365//308 325//308 327//309 
f 366//309 327//309 342//310 
f 367//310 342//310 351//311 
f 368//311 351//311 350//312 
f 369//312 350//312 349//313 
f 370//313 349//313 340//314 
f 371//314 340//314 339//315 
f 372//315 339//315 341//316 
f 373//316 341//316 353//317 
f 374//317 353//317 352//318 
f 375//318 352//318 348//319 
f 376//319 348//319 347//320 
f 377//320 347//320 346//321 
f 378//321 346//321 345//322 
f 379//322 345//322 344//323 
f 380//323 344//323 343//324 
f 381//324 343//324 337//325 
f 382//325 337//325 335//297 
f 335//297 354//297 382//325 
f 337//325 382//325 381//324 
f 343//324 381//324 380//323 
f 344//323 380//323 379//322 
f 345//322 379//322 378//321 
f 346//321 378//321 377//320 
f 347//320 377//320 376//319 
f 348//319 376//319 375//318 
f 352//318 375//318 374//317 
f 353//317 374//317 373//316 
f 341//316 373//316 372//315 
f 339//315 372//315 371//314 
f 340//314 371//314 370//313 
f 349//313 370//313 369//312 
f 350//312 369//312 368//311 
f 351//311 368//311 367//310 
f 342//310 367//310 366//309 
f 327//309 366//309 365//308 
f 325//308 365//308 364//307 
f 326//307 364//307 363//306 
f 330//306 363//306 362//305 
f 331//305 362//305 361//304 
f 328//304 361//304 360//303 
f 329//303 360//303 359//302 
f 336//302 359//302 358//301 
f 332//301 358//301 357//300 
f 333//300 357//300 356//299 
f 338//299 356//299 355//298 
f 334//298 355//298 354//297 
o mesh6
f 355//326 383//326 384//327 
f 384//327 354//328 355//326 
f 356//329 385//329 386//330 
f 386//330 355//326 356//329 
f 357//331 387//331 388//332 
f 388//332 356//329 357//331 
f 358//333 389//333 390//334 
f 390//334 357//331 358//333 
f 359//335 391//335 392//336 
f 392//336 358//333 359//335 
f 360//337 393//337 394//338 
f 394//338 359//335 360//337 
f 361//339 395//339 396//340 
f 396//340 360//337 361//339 
f 362//341 397//341 398//342 
f 398//342 361//339 362//341 
f 363//343 399//343 400//344 
f 400//344 362//341 363//343 
f 364//345 401//345 402//346 
f 402//346 363//343 364//345 
f 364//345 365//347 403//348 
f 365//347 404//347 403//348 
f 365//347 366//349 405//350 
f 366//349 406//349 405//350 
f 366//349 367//351 407//352 
f 367//351 408//351 407//352 
f 368//353 409//353 410//354 
f 410//354 367//351 368//353 
f 369//355 411//355 412//356 
f 412//356 368//353 369//355 
f 370//357 413//357 414//358 
f 414//358 369//355 370//357 
f 371//359 415//359 416//360 
f 416//360 370//357 371//359 
f 372//361 417//361 418//362 
f 418//362 371//359 372//361 
f 373//363 419//363 420//364 
f 420//364 372//361 373//363 
f 374//365 421//365 422//366 
f 422//366 373//363 374//365 
f 375//367 423//367 424//368 
f 424//368 374//365 375//367 
f 376//369 425//369 426//370 
f 426//370 375//367 376//369 
f 377//371 427//371 428//372 
f 428//372 376//369 377//371 
f 378//373 429//373 430//374 
f 430//374 377//371 378//373 
f 379//375 431//375 432//376 
f 432//376 378//373 379//375 
f 380//377 433//377 434//378 
f 434//378 379//375 380//377 
f 381//379 435//379 436//380 
f 436//380 380//377 381//379 
f 382//381 437//381 438//382 
f 438//382 381//379 382//381 
f 354//328 439//383 440//384 
f 440//384 382//381 354//328 
f 440//384 437//381 382//381 
f 438//382 435//379 381//379 
f 436//380 433//377 380//377 
f 434//378 431//375 379//375 
f 432//376 429//373 378//373 
f 430//374 427//371 377//371 
f 428//372 425//369 376//369 
f 426//370 423//367 375//367 
f 424//368 421//365 374//365 
f 422//366 419//363 373//363 
f 420//364 417//361 372//361 
f 418//362 415//359 371//359 
f 416//360 413//357 370//357 
f 414//358 411//355 369//355 
f 412//356 409//353 368//353 
f 410//354 408//351 367//351 
f 407//352 406//349 366//349 
f 405//350 404//347 365//347 
f 403//348 401//345 364//345 
f 402//346 399//343 363//343 
f 400//344 397//341 362//341 
f 398//342 395//339 361//339 
f 396//340 393//337 360//337 
f 394//338 391//335 359//335 
f 392//336 389//333 358//333 
f 390//334 387//331 357//331 
f 388//332 385//329 356//329 
f 386//330 383//326 355//326 
f 384//327 439//383 354//328 
o mesh7
f 441//385 410//385 409//386 
f 409//386 442//387 441//385 
f 443//388 407//388 408//389 
f 408//389 441//385 443//388 
f 444//390 405//390 406//391 
f 406//391 443//388 444//390 
f 445//392 403//392 404//393 
f 404//393 444//390 445//392 
f 446//394 402//394 401//395 
f 401//395 445//392 446//394 
f 447//396 400//396 399//397 
f 399//397 446//394 447//396 
f 448//398 398//398 397//399 
f 397//399 447//396 448//398 
f 449//400 396//400 395//401 
f 395//401 448//398 449//400 
f 450//402 394//402 393//403 
f 393//403 449//400 450//402 
f 451//404 392//404 391//405 
f 391//405 450//402 451//404 
f 452//406 390//406 389//407 
f 389//407 451//404 452//406 
f 453//408 388//408 387//409 
f 387//409 452//406 453//408 
f 454//410 386//410 385//411 
f 385//411 453//408 454//410 
f 455//412 384//412 383//413 
f 383//413 454//410 455//412 
f 440//414 439//415 456//415 
f 384//412 455//412 456//415 
f 456//415 439//415 384//412 
f 457//414 458//416 437//417 
f 458//416 438//416 437//417 
f 458//416 459//418 435//419 
f 459//418 436//418 435//419 
f 459//418 460//420 433//421 
f 460//420 434//420 433//421 
f 461//422 432//422 431//423 
f 431//423 460//420 461//422 
f 462//424 430//424 429//425 
f 429//425 461//422 462//424 
f 463//426 428//426 427//427 
f 427//427 462//424 463//426 
f 464//428 426//428 425//429 
f 425//429 463//426 464//428 
f 465//430 424//430 423//431 
f 423//431 464//428 465//430 
f 466//432 422//432 421//433 
f 421//433 465//430 466//432 
f 467//434 420//434 419//435 
f 419//435 466//432 467//434 
f 467//434 468//436 417//437 
f 468//436 418//436 417//437 
f 469//438 416//438 415//439 
f 415//439 468//436 469//438 
f 470//440 414//440 413//441 
f 413//441 469//438 470//440 
f 470//440 442//387 411//442 
f 442//387 412//443 411//442 
f 411//442 414//440 470//440 
f 413//441 416//438 469//438 
f 415//439 418//436 468//436 
f 417//437 420//434 467//434 
f 419//435 422//432 466//432 
f 421//433 424//430 465//430 
f 423//431 426//428 464//428 
f 425//429 428//426 463//426 
f 427//427 430//424 462//424 
f 429//425 432//422 461//422 
f 431//423 434//420 460//420 
f 433//421 436//418 459//418 
f 435//419 438//416 458//416 
f 437//417 440//414 457//414 
f 456//415 457//414 440//414 
f 383//413 386//410 454//410 
f 385//411 388//408 453//408 
f 387//409 390//406 452//406 
f 389//407 392//404 451//404 
f 391//405 394//402 450//402 
f 393//403 396//400 449//400 
f 395//401 398//398 448//398 
f 397//399 400//396 447//396 
f 399//397 402//394 446//394 
f 401//395 403//392 445//392 
f 404//393 405//390 444//390 
f 406//391 407//388 443//388 
f 408//389 410//385 441//385 
f 409//386 412//443 442//387 
o mesh8
f 455//444 454//444 322//444 
f 268//444 456//444 455//444 
f 454//444 453//444 320//444 
f 452//444 451//444 316//444 
f 451//444 450//444 314//444 
f 320//444 322//444 454//444 
f 453//444 452//444 318//444 
f 314//444 316//444 451//444 
f 450//444 449//444 312//444 
f 449//444 448//444 310//444 
f 448//444 447//444 308//444 
f 445//444 444//444 302//444 
f 444//444 443//444 300//444 
f 468//444 467//444 288//444 
f 467//444 466//444 286//444 
f 318//444 320//444 453//444 
f 312//444 314//444 450//444 
f 308//444 310//444 448//444 
f 447//444 446//444 306//444 
f 446//444 445//444 304//444 
f 300//444 302//444 444//444 
f 441//444 442//444 296//444 
f 442//444 470//444 294//444 
f 286//444 288//444 467//444 
f 466//444 465//444 284//444 
f 316//444 318//444 452//444 
f 306//444 308//444 447//444 
f 302//444 304//444 445//444 
f 443//444 441//444 298//444 
f 294//444 296//444 442//444 
f 470//444 469//444 292//444 
f 469//444 468//444 290//444 
f 284//444 286//444 466//444 
f 463//444 462//444 278//444 
f 462//444 461//444 276//444 
f 461//444 460//444 274//444 
f 460//444 459//444 272//444 
f 310//444 312//444 449//444 
f 298//444 300//444 443//444 
f 292//444 294//444 470//444 
f 288//444 290//444 468//444 
f 276//444 278//444 462//444 
f 272//444 274//444 460//444 
f 459//444 458//444 270//444 
f 458//444 457//444 267//444 
f 304//444 306//444 446//444 
f 290//444 292//444 469//444 
f 465//444 464//444 282//444 
f 464//444 463//444 280//444 
f 274//444 276//444 461//444 
f 267//444 270//444 458//444 
f 296//444 298//444 441//444 
f 280//444 282//444 464//444 
f 270//444 272//444 459//444 
f 457//444 456//444 268//444 
f 282//444 284//444 465//444 
f 268//444 267//444 457//444 
f 278//444 280//444 463//444 
f 322//444 268//444 455//444 
g flatBase
v -0.0686042 -0.00989681 -0.0906911 
v -0.0686627 -0.00935938 -0.0906911 
v -0.0686627 -0.00935938 -0.0806911 
v -0.0684316 -0.0104091 -0.0906911 
v -0.0686042 -0.00989681 -0.0806911 
v -0.0681529 -0.0108723 -0.0906911 
v -0.0684316 -0.0104091 -0.0806911 
v -0.0677811 -0.0112648 -0.0906911 
v -0.0681529 -0.0108723 -0.0806911 
v -0.0673337 -0.0115682 -0.0906911 
v -0.0677811 -0.0112648 -0.0806911 
v -0.0668315 -0.0117683 -0.0906911 
v -0.0673337 -0.0115682 -0.0806911 
v -0.066298 -0.0118557 -0.0906911 
v -0.0668315 -0.0117683 -0.0806911 
v -0.0657582 -0.0118264 -0.0906911 
v -0.066298 -0.0118557 -0.0806911 
v -0.0652373 -0.0116818 -0.0906911 
v -0.0657582 -0.0118264 -0.0806911 
v -0.0647597 -0.0114286 -0.0906911 
v -0.0652373 -0.0116818 -0.0806911 
v -0.0643477 -0.0110786 -0.0906911 
v -0.0647597 -0.0114286 -0.0806911 
v -0.0640205 -0.0106483 -0.0906911 
v -0.0643477 -0.0110786 -0.0806911 
v -0.0637935 -0.0101576 -0.0906911 
v -0.0640205 -0.0106483 -0.0806911 
v -0.0636773 -0.00962968 -0.0906911 
v -0.0637935 -0.0101576 -0.0806911 
v -0.0636773 -0.00908908 -0.0806911 
v -0.0636773 -0.00908908 -0.0906911 
v -0.0636627 -0.00935938 -0.0906911 
v -0.0636773 -0.00962968 -0.0806911 
v -0.0636627 -0.00935938 -0.0806911 
v -0.0637935 -0.00856113 -0.0906911 
v -0.0640205 -0.0080705 -0.0906911 
v -0.0637935 -0.00856113 -0.0806911 
v -0.0643477 -0.00764013 -0.0906911 
v -0.0640205 -0.0080705 -0.0806911 
v -0.0647597 -0.00729016 -0.0906911 
v -0.0643477 -0.00764013 -0.0806911 
v -0.0652373 -0.00703694 -0.0906911 
v -0.0647597 -0.00729016 -0.0806911 
v -0.0657582 -0.00689231 -0.0906911 
v -0.0652373 -0.00703694 -0.0806911 
v -0.066298 -0.00686305 -0.0906911 
v -0.0657582 -0.00689231 -0.0806911 
v -0.0668315 -0.00695051 -0.0906911 
v -0.066298 -0.00686305 -0.0806911 
v -0.0673337 -0.0071506 -0.0906911 
v -0.0668315 -0.00695051 -0.0806911 
v -0.0677811 -0.00745398 -0.0906911 
v -0.0673337 -0.0071506 -0.0806911 
v -0.0681529 -0.00784645 -0.0906911 
v -0.0677811 -0.00745398 -0.0806911 
v -0.0684316 -0.00830966 -0.0906911 
v -0.0681529 -0.00784645 -0.0806911 
v -0.0686042 -0.00882196 -0.0906911 
v -0.0684316 -0.00830966 -0.0806911 
v -0.0686042 -0.00882196 -0.0806911 
v -0.0761627 0.000640619 -0.0806911 
v 0.161568 -0.00830966 -0.0806911 
v -0.0761627 -0.149359 -0.0806911 
v -0.0686627 -0.139359 -0.0806911 
v -0.0686042 -0.139897 -0.0806911 
v -0.0681529 -0.140872 -0.0806911 
v -0.0684316 -0.140409 -0.0806911 
v 0.173837 0.000640619 -0.0806911 
v 0.16524 -0.00729016 -0.0806911 
v 0.165652 -0.00764013 -0.0806911 
v -0.0677811 -0.141265 -0.0806911 
v -0.0668315 -0.136951 -0.0806911 
v 0.161847 -0.137846 -0.0806911 
v 0.166206 -0.0101576 -0.0806911 
v 0.165979 -0.0106483 -0.0806911 
v 0.164763 -0.00703694 -0.0806911 
v 0.161396 -0.00882196 -0.0806911 
v -0.0673337 -0.141568 -0.0806911 
v -0.066298 -0.136863 -0.0806911 
v -0.0673337 -0.137151 -0.0806911 
v -0.0686042 -0.138822 -0.0806911 
v -0.0684316 -0.13831 -0.0806911 
v 0.162666 -0.137151 -0.0806911 
v 0.163169 -0.136951 -0.0806911 
v 0.161568 -0.13831 -0.0806911 
v 0.165652 -0.0110786 -0.0806911 
v 0.16524 -0.0114286 -0.0806911 
v 0.166323 -0.00962968 -0.0806911 
v 0.161396 -0.138822 -0.0806911 
v -0.0637935 -0.138561 -0.0806911 
v -0.0636773 -0.139089 -0.0806911 
v 0.161847 -0.0108723 -0.0806911 
v -0.0657582 -0.136892 -0.0806911 
v -0.0652373 -0.137037 -0.0806911 
v -0.0647597 -0.13729 -0.0806911 
v 0.163702 -0.0118557 -0.0806911 
v 0.163169 -0.0117683 -0.0806911 
v 0.164763 -0.0116818 -0.0806911 
v 0.164242 -0.00689231 -0.0806911 
v 0.162219 -0.00745398 -0.0806911 
v 0.162666 -0.0071506 -0.0806911 
v 0.161337 -0.00935938 -0.0806911 
v -0.066298 -0.141856 -0.0806911 
v -0.0668315 -0.141768 -0.0806911 
v -0.0681529 -0.137846 -0.0806911 
v -0.0677811 -0.137454 -0.0806911 
v 0.163702 -0.136863 -0.0806911 
v 0.164242 -0.136892 -0.0806911 
v 0.162219 -0.137454 -0.0806911 
v 0.166337 -0.00935938 -0.0806911 
v 0.161337 -0.139359 -0.0806911 
v -0.0636627 -0.139359 -0.0806911 
v -0.0643477 -0.13764 -0.0806911 
v -0.0640205 -0.13807 -0.0806911 
v 0.162219 -0.0112648 -0.0806911 
v 0.162666 -0.0115682 -0.0806911 
v 0.164242 -0.0118264 -0.0806911 
v 0.163702 -0.00686305 -0.0806911 
v 0.163169 -0.00695051 -0.0806911 
v 0.161847 -0.00784645 -0.0806911 
v -0.0657582 -0.141826 -0.0806911 
v 0.161568 -0.0104091 -0.0806911 
v 0.161396 -0.00989681 -0.0806911 
v 0.166206 -0.00856113 -0.0806911 
v 0.166323 -0.00908908 -0.0806911 
v -0.0636773 -0.13963 -0.0806911 
v 0.161568 -0.140409 -0.0806911 
v 0.161396 -0.139897 -0.0806911 
v 0.165979 -0.0080705 -0.0806911 
v -0.0637935 -0.140158 -0.0806911 
v -0.0640205 -0.140648 -0.0806911 
v 0.173837 -0.149359 -0.0806911 
v 0.163169 -0.141768 -0.0806911 
v 0.164242 -0.141826 -0.0806911 
v 0.163702 -0.141856 -0.0806911 
v 0.166206 -0.138561 -0.0806911 
v 0.166323 -0.139089 -0.0806911 
v 0.165979 -0.13807 -0.0806911 
v -0.0647597 -0.141429 -0.0806911 
v -0.0652373 -0.141682 -0.0806911 
v -0.0643477 -0.141079 -0.0806911 
v 0.166337 -0.139359 -0.0806911 
v 0.16524 -0.13729 -0.0806911 
v 0.165652 -0.13764 -0.0806911 
v 0.162219 -0.141265 -0.0806911 
v 0.161847 -0.140872 -0.0806911 
v 0.162666 -0.141568 -0.0806911 
v 0.166323 -0.13963 -0.0806911 
v 0.164763 -0.137037 -0.0806911 
v 0.16524 -0.141429 -0.0806911 
v 0.164763 -0.141682 -0.0806911 
v 0.165979 -0.140648 -0.0806911 
v 0.165652 -0.141079 -0.0806911 
v 0.166206 -0.140158 -0.0806911 
v 0.161568 -0.00830966 -0.0906911 
v 0.173837 0.000640619 -0.0906911 
v 0.166323 -0.00962968 -0.0906911 
v 0.166337 -0.00935938 -0.0906911 
v -0.0761627 0.000640619 -0.0906911 
v 0.165979 -0.0080705 -0.0906911 
v 0.165652 -0.00764013 -0.0906911 
v 0.166323 -0.00908908 -0.0906911 
v 0.164242 -0.136892 -0.0906911 
v 0.166206 -0.0101576 -0.0906911 
v 0.164763 -0.0116818 -0.0906911 
v 0.16524 -0.0114286 -0.0906911 
v 0.163702 -0.0118557 -0.0906911 
v 0.164242 -0.0118264 -0.0906911 
v 0.163169 -0.00695051 -0.0906911 
v 0.16524 -0.00729016 -0.0906911 
v 0.165652 -0.0110786 -0.0906911 
v 0.165979 -0.0106483 -0.0906911 
v 0.163702 -0.00686305 -0.0906911 
v 0.164763 -0.00703694 -0.0906911 
v 0.166206 -0.00856113 -0.0906911 
v 0.162219 -0.0112648 -0.0906911 
v 0.162666 -0.0115682 -0.0906911 
v 0.161396 -0.00882196 -0.0906911 
v 0.162666 -0.0071506 -0.0906911 
v 0.164242 -0.00689231 -0.0906911 
v 0.163169 -0.0117683 -0.0906911 
v -0.066298 -0.136863 -0.0906911 
v -0.0673337 -0.137151 -0.0906911 
v 0.161337 -0.00935938 -0.0906911 
v -0.0637935 -0.138561 -0.0906911 
v -0.0640205 -0.13807 -0.0906911 
v -0.0636773 -0.13963 -0.0906911 
v -0.0636627 -0.139359 -0.0906911 
v -0.0643477 -0.141079 -0.0906911 
v -0.0640205 -0.140648 -0.0906911 
v 0.162219 -0.00745398 -0.0906911 
v 0.161847 -0.00784645 -0.0906911 
v 0.161568 -0.0104091 -0.0906911 
v 0.161847 -0.0108723 -0.0906911 
v 0.163702 -0.136863 -0.0906911 
v -0.0652373 -0.141682 -0.0906911 
v -0.0647597 -0.141429 -0.0906911 
v -0.0681529 -0.137846 -0.0906911 
v -0.0684316 -0.13831 -0.0906911 
v -0.0668315 -0.136951 -0.0906911 
v -0.0657582 -0.136892 -0.0906911 
v -0.0636773 -0.139089 -0.0906911 
v -0.0643477 -0.13764 -0.0906911 
v -0.0637935 -0.140158 -0.0906911 
v 0.161396 -0.00989681 -0.0906911 
v -0.0657582 -0.141826 -0.0906911 
v -0.0761627 -0.149359 -0.0906911 
v -0.0686042 -0.138822 -0.0906911 
v -0.0677811 -0.137454 -0.0906911 
v -0.0647597 -0.13729 -0.0906911 
v 0.173837 -0.149359 -0.0906911 
v 0.166323 -0.139089 -0.0906911 
v 0.166206 -0.138561 -0.0906911 
v 0.166323 -0.13963 -0.0906911 
v 0.166337 -0.139359 -0.0906911 
v -0.0652373 -0.137037 -0.0906911 
v 0.162666 -0.137151 -0.0906911 
v 0.162219 -0.137454 -0.0906911 
v 0.163169 -0.136951 -0.0906911 
v 0.161396 -0.138822 -0.0906911 
v -0.066298 -0.141856 -0.0906911 
v 0.161847 -0.137846 -0.0906911 
v 0.166206 -0.140158 -0.0906911 
v 0.161568 -0.13831 -0.0906911 
v 0.161337 -0.139359 -0.0906911 
v 0.165979 -0.13807 -0.0906911 
v 0.165652 -0.13764 -0.0906911 
v 0.165979 -0.140648 -0.0906911 
v 0.16524 -0.13729 -0.0906911 
v 0.164763 -0.137037 -0.0906911 
v 0.16524 -0.141429 -0.0906911 
v 0.165652 -0.141079 -0.0906911 
v 0.161396 -0.139897 -0.0906911 
v 0.163169 -0.141768 -0.0906911 
v 0.163702 -0.141856 -0.0906911 
v 0.162219 -0.141265 -0.0906911 
v 0.162666 -0.141568 -0.0906911 
v 0.161847 -0.140872 -0.0906911 
v -0.0668315 -0.141768 -0.0906911 
v -0.0681529 -0.140872 -0.0906911 
v -0.0677811 -0.141265 -0.0906911 
v -0.0686042 -0.139897 -0.0906911 
v -0.0684316 -0.140409 -0.0906911 
v 0.164242 -0.141826 -0.0906911 
v 0.164763 -0.141682 -0.0906911 
v 0.161568 -0.140409 -0.0906911 
v -0.0673337 -0.141568 -0.0906911 
v -0.0686627 -0.139359 -0.0906911 
vn 0.967878 0.231754 -0.0974814 
vn 0.995216 0.000690115 -0.0976982 
vn 0.888149 0.449227 -0.09688 
vn 0.967878 0.231754 -0.0974814 
vn 0.761613 0.64089 -0.095942 
vn 0.888149 0.449227 -0.09688 
vn 0.596714 0.796842 -0.0947381 
vn 0.761613 0.64089 -0.095942 
vn 0.403754 0.910092 -0.0933519 
vn 0.596714 0.796842 -0.0947381 
vn 0.193852 0.97672 -0.0918696 
vn 0.403754 0.910092 -0.0933519 
vn -0.0219464 0.995666 -0.0903727 
vn 0.193852 0.97672 -0.0918696 
vn -0.233331 0.968322 -0.0889328 
vn -0.0219464 0.995666 -0.0903727 
vn -0.431134 0.898025 -0.087609 
vn -0.233331 0.968322 -0.0889328 
vn -0.607532 0.789577 -0.0864482 
vn -0.431134 0.898025 -0.087609 
vn -0.756116 0.648831 -0.0854856 
vn -0.607532 0.789577 -0.0864482 
vn -0.871864 0.48236 -0.0847467 
vn -0.756116 0.648831 -0.0854856 
vn -0.951087 0.297214 -0.0842487 
vn -0.871864 0.48236 -0.0847467 
vn -0.99136 0.100738 -0.0840022 
vn -0.951087 0.297214 -0.0842487 
vn -0.991478 -0.0995631 -0.0840122 
vn -0.996468 0.000593178 -0.083975 
vn -0.99136 0.100738 -0.0840022 
vn -0.951423 -0.296129 -0.0842784 
vn -0.872367 -0.48144 -0.0847956 
vn -0.756708 -0.648131 -0.0855526 
vn -0.608118 -0.789116 -0.0865316 
vn -0.431613 -0.897785 -0.0877065 
vn -0.233616 -0.968243 -0.0890411 
vn -0.0219744 -0.995655 -0.0904878 
vn 0.194098 -0.97666 -0.0919862 
vn 0.404239 -0.909866 -0.093464 
vn 0.597351 -0.796353 -0.0948392 
vn 0.762275 -0.640091 -0.0960253 
vn 0.888695 -0.448134 -0.0969395 
vn 0.968186 -0.230451 -0.0975125 
vn -0.0834666 0.000702053 0.99651 
vn -0.0696601 0.000585924 -0.997571 
vn -0.0755863 0.993069 -0.0900049 
vn -0.996468 0.000593178 -0.083975 
vn -0.0756819 -0.993051 -0.0901187 
vn 0.995216 0.000690115 -0.0976982 
vn 0.967878 0.231754 -0.0974814 
vn 0.888149 0.449227 -0.09688 
vn 0.761613 0.64089 -0.095942 
vn 0.596714 0.796842 -0.0947381 
vn 0.403754 0.910092 -0.0933519 
vn 0.193852 0.97672 -0.0918696 
vn -0.0219464 0.995666 -0.0903727 
vn -0.233331 0.968322 -0.0889328 
vn -0.431134 0.898025 -0.087609 
vn -0.607532 0.789577 -0.0864482 
vn -0.756116 0.648831 -0.0854856 
vn -0.871864 0.48236 -0.0847467 
vn -0.951087 0.297214 -0.0842487 
vn -0.99136 0.100738 -0.0840022 
vn -0.991478 -0.0995631 -0.0840122 
vn -0.996468 0.000593178 -0.083975 
vn -0.99136 0.100738 -0.0840022 
vn -0.951423 -0.296129 -0.0842784 
vn -0.872367 -0.48144 -0.0847956 
vn -0.756708 -0.648131 -0.0855526 
vn -0.608118 -0.789116 -0.0865316 
vn -0.431613 -0.897785 -0.0877065 
vn -0.233616 -0.968243 -0.0890411 
vn -0.0219744 -0.995655 -0.0904878 
vn 0.194098 -0.97666 -0.0919862 
vn 0.404239 -0.909866 -0.093464 
vn 0.597351 -0.796353 -0.0948392 
vn 0.762275 -0.640091 -0.0960253 
vn 0.888695 -0.448134 -0.0969395 
vn 0.968186 -0.230451 -0.0975125 
vn 0.967878 0.231754 -0.0974814 
vn 0.995216 0.000690115 -0.0976982 
vn 0.888149 0.449227 -0.09688 
vn 0.967878 0.231754 -0.0974814 
vn 0.761613 0.64089 -0.095942 
vn 0.888149 0.449227 -0.09688 
vn 0.596714 0.796842 -0.0947381 
vn 0.761613 0.64089 -0.095942 
vn 0.403754 0.910092 -0.0933519 
vn 0.596714 0.796842 -0.0947381 
vn 0.193852 0.97672 -0.0918696 
vn 0.403754 0.910092 -0.0933519 
vn -0.0219464 0.995666 -0.0903727 
vn 0.193852 0.97672 -0.0918696 
vn -0.233331 0.968322 -0.0889328 
vn -0.0219464 0.995666 -0.0903727 
vn -0.431134 0.898025 -0.087609 
vn -0.233331 0.968322 -0.0889328 
vn -0.607532 0.789577 -0.0864482 
vn -0.431134 0.898025 -0.087609 
vn -0.756116 0.648831 -0.0854856 
vn -0.607532 0.789577 -0.0864482 
vn -0.871864 0.48236 -0.0847467 
vn -0.756116 0.648831 -0.0854856 
vn -0.951087 0.297214 -0.0842487 
vn -0.871864 0.48236 -0.0847467 
vn -0.99136 0.100738 -0.0840022 
vn -0.951087 0.297214 -0.0842487 
vn -0.991478 -0.0995631 -0.0840122 
vn -0.996468 0.000593178 -0.083975 
vn -0.99136 0.100738 -0.0840022 
vn -0.951423 -0.296129 -0.0842784 
vn -0.991478 -0.0995631 -0.0840122 
vn -0.872367 -0.48144 -0.0847956 
vn -0.951423 -0.296129 -0.0842784 
vn -0.756708 -0.648131 -0.0855526 
vn -0.872367 -0.48144 -0.0847956 
vn -0.608118 -0.789116 -0.0865316 
vn -0.756708 -0.648131 -0.0855526 
vn -0.431613 -0.897785 -0.0877065 
vn -0.608118 -0.789116 -0.0865316 
vn -0.233616 -0.968243 -0.0890411 
vn -0.431613 -0.897785 -0.0877065 
vn -0.0219744 -0.995655 -0.0904878 
vn -0.233616 -0.968243 -0.0890411 
vn 0.194098 -0.97666 -0.0919862 
vn -0.0219744 -0.995655 -0.0904878 
vn 0.404239 -0.909866 -0.093464 
vn 0.194098 -0.97666 -0.0919862 
vn 0.597351 -0.796353 -0.0948392 
vn 0.404239 -0.909866 -0.093464 
vn 0.762275 -0.640091 -0.0960253 
vn 0.597351 -0.796353 -0.0948392 
vn 0.888695 -0.448134 -0.0969395 
vn 0.762275 -0.640091 -0.0960253 
vn 0.968186 -0.230451 -0.0975125 
vn 0.888695 -0.448134 -0.0969395 
vn 0.967878 0.231754 -0.0974814 
vn 0.995216 0.000690115 -0.0976982 
vn 0.888149 0.449227 -0.09688 
vn 0.967878 0.231754 -0.0974814 
vn 0.761613 0.64089 -0.095942 
vn 0.888149 0.449227 -0.09688 
vn 0.596714 0.796842 -0.0947381 
vn 0.761613 0.64089 -0.095942 
vn 0.403754 0.910092 -0.0933519 
vn 0.596714 0.796842 -0.0947381 
vn 0.193852 0.97672 -0.0918696 
vn 0.403754 0.910092 -0.0933519 
vn -0.0219464 0.995666 -0.0903727 
vn 0.193852 0.97672 -0.0918696 
vn -0.233331 0.968322 -0.0889328 
vn -0.0219464 0.995666 -0.0903727 
vn -0.431134 0.898025 -0.087609 
vn -0.233331 0.968322 -0.0889328 
vn -0.607532 0.789577 -0.0864482 
vn -0.431134 0.898025 -0.087609 
vn -0.756116 0.648831 -0.0854856 
vn -0.607532 0.789577 -0.0864482 
vn -0.871864 0.48236 -0.0847467 
vn -0.756116 0.648831 -0.0854856 
vn -0.951087 0.297214 -0.0842487 
vn -0.871864 0.48236 -0.0847467 
vn -0.99136 0.100738 -0.0840022 
vn -0.951087 0.297214 -0.0842487 
vn -0.991478 -0.0995631 -0.0840122 
vn -0.996468 0.000593178 -0.083975 
vn -0.99136 0.100738 -0.0840022 
vn -0.951423 -0.296129 -0.0842784 
vn -0.991478 -0.0995631 -0.0840122 
vn -0.872367 -0.48144 -0.0847956 
vn -0.951423 -0.296129 -0.0842784 
vn -0.756708 -0.648131 -0.0855526 
vn -0.872367 -0.48144 -0.0847956 
vn -0.608118 -0.789116 -0.0865316 
vn -0.756708 -0.648131 -0.0855526 
vn -0.431613 -0.897785 -0.0877065 
vn -0.608118 -0.789116 -0.0865316 
vn -0.233616 -0.968243 -0.0890411 
vn -0.431613 -0.897785 -0.0877065 
vn -0.0219744 -0.995655 -0.0904878 
vn -0.233616 -0.968243 -0.0890411 
vn 0.194098 -0.97666 -0.0919862 
vn -0.0219744 -0.995655 -0.0904878 
vn 0.404239 -0.909866 -0.093464 
vn 0.194098 -0.97666 -0.0919862 
vn 0.597351 -0.796353 -0.0948392 
vn 0.404239 -0.909866 -0.093464 
vn 0.762275 -0.640091 -0.0960253 
vn 0.597351 -0.796353 -0.0948392 
vn 0.888695 -0.448134 -0.0969395 
vn 0.762275 -0.640091 -0.0960253 
vn 0.968186 -0.230451 -0.0975125 
vn 0.888695 -0.448134 -0.0969395 
usemtl 0.921569_0.800000_0.654902_0.000000_0.000000
o mesh9
f 471//445 472//446 473//446 
f 474//447 471//445 475//448 
f 476//449 474//447 477//450 
f 478//451 476//449 479//452 
f 480//453 478//451 481//454 
f 482//455 480//453 483//456 
f 484//457 482//455 485//458 
f 486//459 484//457 487//460 
f 488//461 486//459 489//462 
f 490//463 488//461 491//464 
f 492//465 490//463 493//466 
f 494//467 492//465 495//468 
f 496//469 494//467 497//470 
f 498//471 496//469 499//472 
f 500//473 501//473 502//474 
f 498//471 503//475 504//474 
f 504//474 502//474 498//471 
f 505//476 501//473 500//473 
f 506//477 505//476 507//476 
f 508//478 506//477 509//477 
f 510//479 508//478 511//478 
f 512//480 510//479 513//479 
f 514//481 512//480 515//480 
f 516//482 514//481 517//481 
f 518//483 516//482 519//482 
f 520//484 518//483 521//483 
f 522//485 520//484 523//484 
f 524//486 522//485 525//485 
f 526//487 524//486 527//486 
f 528//488 526//487 529//487 
f 472//446 528//488 530//488 
f 530//488 473//446 472//446 
f 529//487 530//488 528//488 
f 527//486 529//487 526//487 
f 525//485 527//486 524//486 
f 523//484 525//485 522//485 
f 521//483 523//484 520//484 
f 519//482 521//483 518//483 
f 517//481 519//482 516//482 
f 515//480 517//481 514//481 
f 513//479 515//480 512//480 
f 511//478 513//479 510//479 
f 509//477 511//478 508//478 
f 507//476 509//477 506//477 
f 500//473 507//476 505//476 
f 502//474 504//474 500//473 
f 499//472 503//475 498//471 
f 497//470 499//472 496//469 
f 495//468 497//470 494//467 
f 493//466 495//468 492//465 
f 491//464 493//466 490//463 
f 489//462 491//464 488//461 
f 487//460 489//462 486//459 
f 485//458 487//460 484//457 
f 483//456 485//458 482//455 
f 481//454 483//456 480//453 
f 479//452 481//454 478//451 
f 477//450 479//452 476//449 
f 475//448 477//450 474//447 
f 473//446 475//448 471//445 
o mesh10
f 531//489 517//489 515//489 
f 531//489 523//489 521//489 
f 531//489 530//489 529//489 
f 515//489 532//489 531//489 
f 531//489 525//489 523//489 
f 529//489 527//489 531//489 
f 487//489 533//489 534//489 
f 531//489 519//489 517//489 
f 527//489 525//489 531//489 
f 533//489 487//489 485//489 
f 533//489 535//489 534//489 
f 534//489 493//489 491//489 
f 533//489 536//489 537//489 
f 538//489 539//489 540//489 
f 521//489 519//489 531//489 
f 531//489 475//489 473//489 
f 531//489 479//489 477//489 
f 533//489 481//489 479//489 
f 485//489 483//489 533//489 
f 483//489 481//489 533//489 
f 491//489 489//489 534//489 
f 533//489 541//489 536//489 
f 542//489 504//489 503//489 
f 543//489 544//489 545//489 
f 538//489 546//489 539//489 
f 547//489 513//489 511//489 
f 473//489 530//489 531//489 
f 479//489 531//489 533//489 
f 477//489 475//489 531//489 
f 534//489 489//489 487//489 
f 533//489 548//489 541//489 
f 504//489 542//489 549//489 
f 503//489 550//489 542//489 
f 503//489 499//489 550//489 
f 493//489 551//489 552//489 
f 538//489 553//489 554//489 
f 555//489 556//489 557//489 
f 545//489 555//489 543//489 
f 545//489 556//489 555//489 
f 538//489 558//489 544//489 
f 559//489 560//489 561//489 
f 562//489 563//489 564//489 
f 565//489 566//489 567//489 
f 565//489 557//489 568//489 
f 538//489 569//489 546//489 
f 538//489 570//489 571//489 
f 572//489 507//489 500//489 
f 511//489 572//489 547//489 
f 537//489 535//489 533//489 
f 533//489 573//489 574//489 
f 549//489 563//489 504//489 
f 552//489 575//489 493//489 
f 575//489 576//489 493//489 
f 554//489 577//489 538//489 
f 577//489 578//489 538//489 
f 538//489 543//489 579//489 
f 557//489 565//489 555//489 
f 538//489 580//489 558//489 
f 561//489 581//489 559//489 
f 561//489 582//489 581//489 
f 555//489 583//489 584//489 
f 564//489 585//489 562//489 
f 564//489 565//489 585//489 
f 567//489 586//489 565//489 
f 586//489 585//489 565//489 
f 568//489 587//489 565//489 
f 587//489 566//489 565//489 
f 538//489 588//489 569//489 
f 571//489 589//489 538//489 
f 589//489 588//489 538//489 
f 531//489 590//489 570//489 
f 572//489 509//489 507//489 
f 500//489 504//489 572//489 
f 547//489 532//489 513//489 
f 511//489 509//489 572//489 
f 533//489 591//489 573//489 
f 550//489 497//489 495//489 
f 499//489 497//489 550//489 
f 493//489 534//489 551//489 
f 579//489 553//489 538//489 
f 544//489 543//489 538//489 
f 555//489 565//489 583//489 
f 584//489 560//489 555//489 
f 563//489 592//489 593//489 
f 562//489 592//489 563//489 
f 538//489 594//489 595//489 
f 531//489 532//489 590//489 
f 570//489 538//489 531//489 
f 574//489 548//489 533//489 
f 495//489 493//489 550//489 
f 576//489 550//489 493//489 
f 596//489 597//489 598//489 
f 593//489 504//489 563//489 
f 538//489 599//489 594//489 
f 540//489 599//489 538//489 
f 515//489 513//489 532//489 
f 597//489 600//489 601//489 
f 598//489 582//489 596//489 
f 533//489 602//489 603//489 
f 602//489 604//489 605//489 
f 602//489 606//489 607//489 
f 538//489 608//489 606//489 
f 559//489 555//489 560//489 
f 597//489 609//489 610//489 
f 601//489 611//489 597//489 
f 611//489 609//489 597//489 
f 596//489 600//489 597//489 
f 598//489 581//489 582//489 
f 605//489 603//489 602//489 
f 606//489 602//489 538//489 
f 607//489 612//489 602//489 
f 538//489 613//489 614//489 
f 593//489 572//489 504//489 
f 610//489 533//489 597//489 
f 610//489 591//489 533//489 
f 533//489 615//489 616//489 
f 603//489 617//489 533//489 
f 602//489 612//489 618//489 
f 614//489 608//489 538//489 
f 538//489 578//489 619//489 
f 595//489 580//489 538//489 
f 617//489 615//489 533//489 
f 602//489 620//489 621//489 
f 602//489 622//489 623//489 
f 618//489 624//489 602//489 
f 619//489 613//489 538//489 
f 621//489 604//489 602//489 
f 624//489 622//489 602//489 
f 623//489 620//489 602//489 
f 616//489 597//489 533//489 
o mesh11
f 625//490 498//490 502//490 
f 626//490 627//490 628//490 
f 629//490 524//490 526//490 
f 629//490 516//490 518//490 
f 502//490 501//490 625//490 
f 501//490 505//490 625//490 
f 626//490 630//490 631//490 
f 628//490 632//490 626//490 
f 626//490 633//490 634//490 
f 633//490 635//490 636//490 
f 633//490 637//490 638//490 
f 629//490 522//490 524//490 
f 518//490 520//490 629//490 
f 625//490 510//490 512//490 
f 625//490 496//490 498//490 
f 629//490 626//490 639//490 
f 631//490 640//490 626//490 
f 634//490 627//490 626//490 
f 633//490 641//490 642//490 
f 638//490 635//490 633//490 
f 636//490 641//490 633//490 
f 520//490 522//490 629//490 
f 512//490 629//490 625//490 
f 512//490 514//490 629//490 
f 625//490 506//490 508//490 
f 625//490 490//490 492//490 
f 626//490 643//490 639//490 
f 640//490 644//490 626//490 
f 632//490 645//490 626//490 
f 633//490 646//490 647//490 
f 526//490 528//490 629//490 
f 505//490 506//490 625//490 
f 492//490 494//490 625//490 
f 494//490 496//490 625//490 
f 648//490 484//490 486//490 
f 639//490 649//490 629//490 
f 644//490 650//490 626//490 
f 642//490 634//490 633//490 
f 647//490 651//490 633//490 
f 651//490 637//490 633//490 
f 652//490 482//490 484//490 
f 653//490 629//490 471//490 
f 654//490 655//490 656//490 
f 654//490 657//490 658//490 
f 654//490 659//490 660//490 
f 514//490 516//490 629//490 
f 508//490 510//490 625//490 
f 625//490 486//490 488//490 
f 486//490 625//490 648//490 
f 648//490 654//490 484//490 
f 629//490 661//490 662//490 
f 650//490 643//490 626//490 
f 633//490 663//490 664//490 
f 665//490 666//490 667//490 
f 629//490 668//490 669//490 
f 482//490 652//490 670//490 
f 484//490 671//490 652//490 
f 484//490 654//490 671//490 
f 471//490 474//490 653//490 
f 654//490 672//490 655//490 
f 656//490 673//490 654//490 
f 654//490 674//490 657//490 
f 658//490 672//490 654//490 
f 654//490 667//490 659//490 
f 660//490 674//490 654//490 
f 488//490 490//490 625//490 
f 649//490 661//490 629//490 
f 664//490 646//490 633//490 
f 665//490 654//490 675//490 
f 665//490 676//490 666//490 
f 667//490 654//490 665//490 
f 669//490 677//490 629//490 
f 669//490 678//490 677//490 
f 629//490 653//490 679//490 
f 653//490 478//490 480//490 
f 474//490 476//490 653//490 
f 673//490 680//490 654//490 
f 528//490 472//490 629//490 
f 645//490 630//490 626//490 
f 675//490 633//490 665//490 
f 681//490 682//490 683//490 
f 681//490 684//490 685//490 
f 679//490 668//490 629//490 
f 480//490 482//490 653//490 
f 629//490 472//490 471//490 
f 654//490 680//490 686//490 
f 662//490 625//490 629//490 
f 675//490 663//490 633//490 
f 676//490 687//490 688//490 
f 676//490 665//490 689//490 
f 685//490 682//490 681//490 
f 476//490 478//490 653//490 
f 690//490 691//490 676//490 
f 689//490 687//490 676//490 
f 688//490 692//490 676//490 
f 681//490 693//490 684//490 
f 670//490 653//490 482//490 
f 686//490 671//490 654//490 
f 676//490 694//490 690//490 
f 690//490 695//490 691//490 
f 692//490 694//490 676//490 
f 683//490 626//490 681//490 
f 626//490 696//490 697//490 
f 681//490 698//490 693//490 
f 626//490 699//490 700//490 
f 683//490 696//490 626//490 
f 681//490 701//490 702//490 
f 703//490 677//490 691//490 
f 700//490 633//490 626//490 
f 702//490 698//490 681//490 
f 681//490 704//490 705//490 
f 681//490 706//490 707//490 
f 677//490 708//490 706//490 
f 677//490 709//490 691//490 
f 677//490 710//490 711//490 
f 677//490 712//490 713//490 
f 697//490 699//490 626//490 
f 681//490 714//490 715//490 
f 707//490 704//490 681//490 
f 705//490 714//490 681//490 
f 677//490 716//490 708//490 
f 706//490 681//490 677//490 
f 691//490 695//490 703//490 
f 713//490 710//490 677//490 
f 715//490 701//490 681//490 
f 677//490 717//490 709//490 
f 677//490 718//490 712//490 
f 711//490 717//490 677//490 
f 703//490 716//490 677//490 
f 678//490 718//490 677//490 
o mesh12
f 538//491 626//491 629//491 
f 629//491 531//491 538//491 
o mesh13
f 531//492 629//492 677//492 
f 677//492 533//492 531//492 
o mesh14
f 533//493 677//493 681//493 
f 681//493 602//493 533//493 
o mesh15
f 602//494 681//494 626//494 
f 626//494 538//494 602//494 
o mesh16
f 675//495 654//494 572//494 
f 663//496 675//495 593//495 
f 664//497 663//496 592//496 
f 646//498 664//497 562//497 
f 647//499 646//498 585//498 
f 651//500 647//499 586//499 
f 637//501 651//500 567//500 
f 638//502 637//501 566//501 
f 635//503 638//502 587//502 
f 636//504 635//503 568//503 
f 641//505 636//504 557//504 
f 642//506 641//505 556//505 
f 634//507 642//506 545//506 
f 627//508 634//507 544//507 
f 595//509 632//509 628//510 
f 627//508 558//511 580//510 
f 580//510 628//510 627//508 
f 645//512 632//509 595//509 
f 630//513 645//512 594//512 
f 631//514 630//513 599//513 
f 640//515 631//514 540//514 
f 644//516 640//515 539//515 
f 650//517 644//516 546//516 
f 643//518 650//517 569//517 
f 639//519 643//518 588//518 
f 649//520 639//519 589//519 
f 661//521 649//520 571//520 
f 662//522 661//521 570//521 
f 625//523 662//522 590//522 
f 648//524 625//523 532//523 
f 654//494 648//524 547//524 
f 547//524 572//494 654//494 
f 532//523 547//524 648//524 
f 590//522 532//523 625//523 
f 570//521 590//522 662//522 
f 571//520 570//521 661//521 
f 589//519 571//520 649//520 
f 588//518 589//519 639//519 
f 569//517 588//518 643//518 
f 546//516 569//517 650//517 
f 539//515 546//516 644//516 
f 540//514 539//515 640//515 
f 599//513 540//514 631//514 
f 594//512 599//513 630//513 
f 595//509 594//512 645//512 
f 628//510 580//510 595//509 
f 544//507 558//511 627//508 
f 545//506 544//507 634//507 
f 556//505 545//506 642//506 
f 557//504 556//505 641//505 
f 568//503 557//504 636//504 
f 587//502 568//503 635//503 
f 566//501 587//502 638//502 
f 567//500 566//501 637//501 
f 586//499 567//500 651//500 
f 585//498 586//499 647//499 
f 562//497 585//498 646//498 
f 592//496 562//497 664//497 
f 593//495 592//496 663//496 
f 572//494 593//495 675//495 
o mesh17
f 703//525 695//526 581//526 
f 716//527 703//525 598//528 
f 708//529 716//527 597//530 
f 706//531 708//529 616//532 
f 707//533 706//531 615//534 
f 704//535 707//533 617//536 
f 705//537 704//535 603//538 
f 714//539 705//537 605//540 
f 715//541 714//539 604//542 
f 701//543 715//541 621//544 
f 702//545 701//543 620//546 
f 698//547 702//545 623//548 
f 693//549 698//547 622//550 
f 684//551 693//549 624//552 
f 682//553 685//554 612//554 
f 618//555 612//554 685//554 
f 685//554 684//551 618//555 
f 683//556 682//553 607//557 
f 696//558 683//556 606//559 
f 697//560 696//558 608//561 
f 699//562 697//560 614//563 
f 700//564 699//562 613//565 
f 633//566 700//564 619//567 
f 665//568 633//566 578//569 
f 689//570 665//568 577//571 
f 687//572 689//570 554//573 
f 688//574 687//572 553//575 
f 692//576 688//574 579//577 
f 694//578 692//576 543//579 
f 690//580 694//578 555//581 
f 695//526 690//580 559//580 
f 559//580 581//526 695//526 
f 555//581 559//580 690//580 
f 543//579 555//581 694//578 
f 579//577 543//579 692//576 
f 553//575 579//577 688//574 
f 554//573 553//575 687//572 
f 577//571 554//573 689//570 
f 578//569 577//571 665//568 
f 619//567 578//569 633//566 
f 613//565 619//567 700//564 
f 614//563 613//565 699//562 
f 608//561 614//563 697//560 
f 606//559 608//561 696//558 
f 607//557 606//559 683//556 
f 612//554 607//557 682//553 
f 624//552 618//555 684//551 
f 622//550 624//552 693//549 
f 623//548 622//550 698//547 
f 620//546 623//548 702//545 
f 621//544 620//546 701//543 
f 604//542 621//544 715//541 
f 605//540 604//542 714//539 
f 603//538 605//540 705//537 
f 617//536 603//538 704//535 
f 615//534 617//536 707//533 
f 616//532 615//534 706//531 
f 597//530 616//532 708//529 
f 598//528 597//530 716//527 
f 581//526 598//528 703//525 
o mesh18
f 712//582 718//583 534//583 
f 713//584 712//582 535//585 
f 710//586 713//584 537//587 
f 711//588 710//586 536//589 
f 717//590 711//588 541//591 
f 709//592 717//590 548//593 
f 691//594 709//592 574//595 
f 676//596 691//594 573//597 
f 666//598 676//596 591//599 
f 667//600 666//598 610//601 
f 659//602 667//600 609//603 
f 660//604 659//602 611//605 
f 674//606 660//604 601//607 
f 657//608 674//606 600//609 
f 672//610 658//611 582//611 
f 596//612 582//611 658//611 
f 658//611 657//608 596//612 
f 655//613 672//610 561//614 
f 656//615 655//613 560//616 
f 673//617 656//615 584//618 
f 680//619 673//617 583//620 
f 686//621 680//619 565//622 
f 671//623 686//621 564//624 
f 652//625 671//623 563//626 
f 670//627 652//625 549//628 
f 653//629 670//627 542//630 
f 679//631 653//629 550//632 
f 668//633 679//631 576//634 
f 669//635 668//633 575//636 
f 678//637 669//635 552//638 
f 718//583 678//637 551//637 
f 551//637 534//583 718//583 
f 552//638 551//637 678//637 
f 575//636 552//638 669//635 
f 576//634 575//636 668//633 
f 550//632 576//634 679//631 
f 542//630 550//632 653//629 
f 549//628 542//630 670//627 
f 563//626 549//628 652//625 
f 564//624 563//626 671//623 
f 565//622 564//624 686//621 
f 583//620 565//622 680//619 
f 584//618 583//620 673//617 
f 560//616 584//618 656//615 
f 561//614 560//616 655//613 
f 582//611 561//614 672//610 
f 600//609 596//612 657//608 
f 601//607 600//609 674//606 
f 611//605 601//607 660//604 
f 609//603 611//605 659//602 
f 610//601 609//603 667//600 
f 591//599 610//601 666//598 
f 573//597 591//599 676//596 
f 574//595 573//597 691//594 
f 548//593 574//595 709//592 
f 541//591 548//593 717//590 
f 536//589 541//591 711//588 
f 537//587 536//589 710//586 
f 535//585 537//587 713//584 
f 534//583 535//585 712//582 
g verticalBlock
v 0.0761529 -0.0332183 -0.0448412 
v 0.0756155 -0.0331599 -0.0448412 
v 0.0756155 -0.0331599 -0.0498412 
v 0.0766652 -0.033391 -0.0448412 
v 0.0761529 -0.0332183 -0.0498412 
v 0.0771284 -0.0336697 -0.0448412 
v 0.0766652 -0.033391 -0.0498412 
v 0.0775209 -0.0340414 -0.0448412 
v 0.0771284 -0.0336697 -0.0498412 
v 0.0778243 -0.0344889 -0.0448412 
v 0.0775209 -0.0340414 -0.0498412 
v 0.0780243 -0.0349911 -0.0448412 
v 0.0778243 -0.0344889 -0.0498412 
v 0.0781118 -0.0355245 -0.0448412 
v 0.0780243 -0.0349911 -0.0498412 
v 0.0780825 -0.0360643 -0.0448412 
v 0.0781118 -0.0355245 -0.0498412 
v 0.0779379 -0.0365852 -0.0448412 
v 0.0780825 -0.0360643 -0.0498412 
v 0.0776847 -0.0370629 -0.0448412 
v 0.0779379 -0.0365852 -0.0498412 
v 0.0773347 -0.0374749 -0.0448412 
v 0.0776847 -0.0370629 -0.0498412 
v 0.0769044 -0.037802 -0.0448412 
v 0.0773347 -0.0374749 -0.0498412 
v 0.0764137 -0.038029 -0.0448412 
v 0.0769044 -0.037802 -0.0498412 
v 0.0758858 -0.0381452 -0.0448412 
v 0.0764137 -0.038029 -0.0498412 
v 0.0753452 -0.0381452 -0.0448412 
v 0.0758858 -0.0381452 -0.0498412 
v 0.0748172 -0.038029 -0.0448412 
v 0.0753452 -0.0381452 -0.0498412 
v 0.0743266 -0.037802 -0.0448412 
v 0.0748172 -0.038029 -0.0498412 
v 0.0738962 -0.0374749 -0.0448412 
v 0.0743266 -0.037802 -0.0498412 
v 0.0735463 -0.0370629 -0.0448412 
v 0.0738962 -0.0374749 -0.0498412 
v 0.073293 -0.0365852 -0.0448412 
v 0.0735463 -0.0370629 -0.0498412 
v 0.0731484 -0.0360643 -0.0448412 
v 0.073293 -0.0365852 -0.0498412 
v 0.0731191 -0.0355245 -0.0448412 
v 0.0731484 -0.0360643 -0.0498412 
v 0.0732066 -0.0349911 -0.0448412 
v 0.0731191 -0.0355245 -0.0498412 
v 0.0734067 -0.0344889 -0.0448412 
v 0.0732066 -0.0349911 -0.0498412 
v 0.0737101 -0.0340414 -0.0448412 
v 0.0734067 -0.0344889 -0.0498412 
v 0.0741025 -0.0336697 -0.0448412 
v 0.0737101 -0.0340414 -0.0498412 
v 0.0745658 -0.033391 -0.0448412 
v 0.0741025 -0.0336697 -0.0498412 
v 0.075078 -0.0332183 -0.0448412 
v 0.0745658 -0.033391 -0.0498412 
v 0.075078 -0.0332183 -0.0498412 
v 0.0695035 -0.037035 -0.0448412 
v 0.0690118 -0.0388061 -0.0448412 
v 0.0681508 -0.04043 -0.0448412 
v 0.0669609 -0.0418309 -0.0448412 
v 0.070563 -0.0560803 -0.0448412 
v 0.069603 -0.0351997 -0.0448412 
v 0.0747319 -0.053572 -0.0448412 
v 0.0782641 -0.0502261 -0.0448412 
v 0.0635482 -0.0132918 -0.0448412 
v 0.0662595 -0.0288931 -0.0448412 
v 0.0675939 -0.0301571 -0.0448412 
v 0.0686253 -0.0316784 -0.0448412 
v 0.0483347 -0.0374749 -0.0448412 
v 0.0659523 -0.0576339 -0.0448412 
v 0.05527 -0.0418309 -0.0448412 
v 0.0620345 -0.0441101 -0.0448412 
v 0.0601965 -0.0441101 -0.0448412 
v 0.0638295 -0.0437149 -0.0448412 
v 0.0654977 -0.0429432 -0.0448412 
v 0.0809945 -0.0461991 -0.0448412 
v 0.0827953 -0.0416793 -0.0448412 
v 0.0693056 -0.0333859 -0.0448412 
v 0.0567333 -0.0429432 -0.0448412 
v 0.0490825 -0.0360643 -0.0448412 
v 0.0489379 -0.0365852 -0.0448412 
v 0.0629427 -0.0273586 -0.0448412 
v 0.0646845 -0.0279455 -0.0448412 
v 0.0611155 -0.0131599 -0.0448412 
v 0.0611155 -0.0271599 -0.0448412 
v 0.0486847 -0.0370629 -0.0448412 
v 0.0584014 -0.0437149 -0.0448412 
v 0.0389119 -0.0320198 -0.0448412 
v 0.0386485 -0.036878 -0.0448412 
v 0.0441191 -0.0355245 -0.0448412 
v 0.0532192 -0.0388061 -0.0448412 
v 0.0527274 -0.037035 -0.0448412 
v 0.0455658 -0.033391 -0.0448412 
v 0.0424925 -0.0230332 -0.0448412 
v 0.0402135 -0.0273318 -0.0448412 
v 0.0441484 -0.0360643 -0.0448412 
v 0.0479044 -0.037802 -0.0448412 
v 0.0474137 -0.038029 -0.0448412 
v 0.051668 -0.0560803 -0.0448412 
v 0.0835825 -0.036878 -0.0448412 
v 0.0490243 -0.0349911 -0.0448412 
v 0.0491118 -0.0355245 -0.0448412 
v 0.0471529 -0.0332183 -0.0448412 
v 0.0529253 -0.0333859 -0.0448412 
v 0.0536056 -0.0316784 -0.0448412 
v 0.0447101 -0.0340414 -0.0448412 
v 0.0451025 -0.0336697 -0.0448412 
v 0.0444067 -0.0344889 -0.0448412 
v 0.044293 -0.0365852 -0.0448412 
v 0.0468858 -0.0381452 -0.0448412 
v 0.0463452 -0.0381452 -0.0448412 
v 0.0439668 -0.0502261 -0.0448412 
v 0.0562786 -0.0576339 -0.0448412 
v 0.0611155 -0.0581599 -0.0448412 
v 0.0488243 -0.0344889 -0.0448412 
v 0.0456422 -0.019325 -0.0448412 
v 0.0476652 -0.033391 -0.0448412 
v 0.0442066 -0.0349911 -0.0448412 
v 0.0394356 -0.0416793 -0.0448412 
v 0.0445463 -0.0370629 -0.0448412 
v 0.0474991 -0.053572 -0.0448412 
v 0.0540801 -0.04043 -0.0448412 
v 0.0586828 -0.0132918 -0.0448412 
v 0.0539312 -0.0143377 -0.0448412 
v 0.0592882 -0.0273586 -0.0448412 
v 0.0495155 -0.0163806 -0.0448412 
v 0.0575464 -0.0279455 -0.0448412 
v 0.0526279 -0.0351997 -0.0448412 
v 0.0448962 -0.0374749 -0.0448412 
v 0.0453266 -0.037802 -0.0448412 
v 0.0458172 -0.038029 -0.0448412 
v 0.0412365 -0.0461991 -0.0448412 
v 0.0481284 -0.0336697 -0.0448412 
v 0.0485209 -0.0340414 -0.0448412 
v 0.0559715 -0.0288931 -0.0448412 
v 0.0546371 -0.0301571 -0.0448412 
v 0.0466155 -0.0331599 -0.0448412 
v 0.0833191 -0.0320198 -0.0448412 
v 0.0820175 -0.0273318 -0.0448412 
v 0.0797385 -0.0230332 -0.0448412 
v 0.0727154 -0.0163806 -0.0448412 
v 0.0765887 -0.019325 -0.0448412 
v 0.0682998 -0.0143377 -0.0448412 
v 0.046078 -0.0332183 -0.0448412 
v 0.0611155 -0.0271599 -0.0498412 
v 0.0629427 -0.0273586 -0.0498412 
v 0.0646845 -0.0279455 -0.0498412 
v 0.0662595 -0.0288931 -0.0498412 
v 0.0675939 -0.0301571 -0.0498412 
v 0.0686253 -0.0316784 -0.0498412 
v 0.0693056 -0.0333859 -0.0498412 
v 0.069603 -0.0351997 -0.0498412 
v 0.0695035 -0.037035 -0.0498412 
v 0.0690118 -0.0388061 -0.0498412 
v 0.0681508 -0.04043 -0.0498412 
v 0.0669609 -0.0418309 -0.0498412 
v 0.0654977 -0.0429432 -0.0498412 
v 0.0638295 -0.0437149 -0.0498412 
v 0.0620345 -0.0441101 -0.0498412 
v 0.0601965 -0.0441101 -0.0498412 
v 0.0584014 -0.0437149 -0.0498412 
v 0.0567333 -0.0429432 -0.0498412 
v 0.05527 -0.0418309 -0.0498412 
v 0.0540801 -0.04043 -0.0498412 
v 0.0532192 -0.0388061 -0.0498412 
v 0.0527274 -0.037035 -0.0498412 
v 0.0526279 -0.0351997 -0.0498412 
v 0.0529253 -0.0333859 -0.0498412 
v 0.0536056 -0.0316784 -0.0498412 
v 0.0546371 -0.0301571 -0.0498412 
v 0.0559715 -0.0288931 -0.0498412 
v 0.0575464 -0.0279455 -0.0498412 
v 0.0592882 -0.0273586 -0.0498412 
v 0.0466155 -0.0331599 -0.0498412 
v 0.0471529 -0.0332183 -0.0498412 
v 0.0476652 -0.033391 -0.0498412 
v 0.0481284 -0.0336697 -0.0498412 
v 0.0485209 -0.0340414 -0.0498412 
v 0.0488243 -0.0344889 -0.0498412 
v 0.0490243 -0.0349911 -0.0498412 
v 0.0491118 -0.0355245 -0.0498412 
v 0.0490825 -0.0360643 -0.0498412 
v 0.0489379 -0.0365852 -0.0498412 
v 0.0486847 -0.0370629 -0.0498412 
v 0.0483347 -0.0374749 -0.0498412 
v 0.0479044 -0.037802 -0.0498412 
v 0.0474137 -0.038029 -0.0498412 
v 0.0468858 -0.0381452 -0.0498412 
v 0.0463452 -0.0381452 -0.0498412 
v 0.0458172 -0.038029 -0.0498412 
v 0.0453266 -0.037802 -0.0498412 
v 0.0448962 -0.0374749 -0.0498412 
v 0.0445463 -0.0370629 -0.0498412 
v 0.044293 -0.0365852 -0.0498412 
v 0.0441484 -0.0360643 -0.0498412 
v 0.0441191 -0.0355245 -0.0498412 
v 0.0442066 -0.0349911 -0.0498412 
v 0.0444067 -0.0344889 -0.0498412 
v 0.0447101 -0.0340414 -0.0498412 
v 0.0451025 -0.0336697 -0.0498412 
v 0.0455658 -0.033391 -0.0498412 
v 0.046078 -0.0332183 -0.0498412 
v 0.0830678 -0.0307256 0.0393711 
v 0.0822326 -0.0278935 0.0471467 
v 0.0831891 -0.0315172 0.0371955 
v 0.0832673 -0.0320279 0.0357919 
v 0.0816273 -0.0265283 0.0508958 
v 0.0810501 -0.0252263 0.0544711 
v 0.081989 -0.027344 0.0486556 
v 0.0804228 -0.0242031 0.0572795 
v 0.0789782 -0.0220314 0.0632404 
v 0.0777948 -0.0205586 0.0672841 
v 0.0772744 -0.0200454 0.0686945 
v 0.0797146 -0.0230482 0.0604491 
v 0.0794555 -0.0226256 0.061609 
v 0.0745741 -0.0176289 0.0733668 
v 0.075983 -0.0187718 0.0721943 
v 0.0765667 -0.0193475 0.0706123 
v 0.0754838 -0.0183448 0.0733672 
v 0.0726504 -0.0164906 0.0733668 
v 0.0704433 -0.0151845 0.0733668 
v 0.0682594 -0.0144593 0.0733668 
v 0.065888 -0.0136719 0.0733668 
v 0.0635345 -0.0134194 0.0733668 
v 0.0611155 -0.0131599 0.0733668 
v 0.0586965 -0.0134194 0.0733668 
v 0.056343 -0.0136719 0.0733668 
v 0.0517877 -0.0151845 0.0733668 
v 0.0539716 -0.0144593 0.0733668 
v 0.0476569 -0.0176289 0.0733668 
v 0.0456686 -0.0193531 0.0705965 
v 0.0467471 -0.0183448 0.0733672 
v 0.0495806 -0.0164906 0.0733668 
v 0.0430367 -0.0222656 0.0625974 
v 0.0425229 -0.0230532 0.0604354 
v 0.0432348 -0.0220298 0.0632448 
v 0.0449313 -0.0200423 0.0687025 
v 0.0448094 -0.0201563 0.0683893 
v 0.0402808 -0.0271649 0.0491488 
v 0.0402239 -0.0273354 0.0486803 
v 0.0405906 -0.026528 0.0508972 
v 0.0417744 -0.0242007 0.0572858 
v 0.0415711 -0.0245124 0.0564303 
v 0.0390528 -0.0315169 0.0371941 
v 0.0389552 -0.0320277 0.0357903 
v 0.0393528 -0.0299471 0.0415075 
v 0.0386357 -0.0366071 0.0232246 
v 0.0386645 -0.0368766 0.0225491 
v 0.0387798 -0.0329452 0.0332692 
v 0.0386159 -0.0357947 0.0254531 
v 0.0391803 -0.0404931 0.0134826 
v 0.0394587 -0.0416735 0.0105221 
v 0.0389443 -0.0394923 0.0159925 
v 0.0406983 -0.0451145 0.00189472 
v 0.0412742 -0.0461787 -0.000771005 
v 0.0395686 -0.0421392 0.00935435 
v 0.0405132 -0.0446271 0.00311674 
v 0.0436539 -0.0498494 -0.009972 
v 0.0439847 -0.05021 -0.0108773 
v 0.0420329 -0.0475807 -0.00428258 
v 0.0426369 -0.048426 -0.00640235 
v 0.0473521 -0.0534593 -0.0190253 
v 0.0475047 -0.0535639 -0.0192876 
v 0.0453986 -0.0517514 -0.0147464 
v 0.0454752 -0.051835 -0.0149563 
v 0.0516345 -0.0560648 -0.0255622 
v 0.0516686 -0.0560788 -0.0255972 
v 0.0494787 -0.054917 -0.0226801 
v 0.0507001 -0.0555673 -0.024313 
v 0.0488222 -0.054467 -0.0215519 
v 0.0554812 -0.057443 -0.0290147 
v 0.0562835 -0.0576109 -0.0294357 
v 0.0535676 -0.0568561 -0.0275456 
v 0.0547073 -0.0572057 -0.0284205 
v 0.0526607 -0.0564849 -0.0266152 
v 0.0600316 -0.0581193 -0.0307134 
v 0.0594313 -0.0580968 -0.0306564 
v 0.0578712 -0.0579131 -0.0301937 
v 0.0589545 -0.0580406 -0.0305149 
v 0.0575416 -0.0578742 -0.0300959 
v 0.0568164 -0.0577225 -0.0297154 
v 0.0646939 -0.0578735 -0.030094 
v 0.065419 -0.0577251 -0.0297218 
v 0.0628479 -0.0580931 -0.0306471 
v 0.0632775 -0.058042 -0.0305184 
v 0.0643598 -0.0579133 -0.0301941 
v 0.0611155 -0.0581599 -0.0308162 
v 0.0621989 -0.0581181 -0.0307104 
v 0.0684993 -0.0569138 -0.02769 
v 0.0695717 -0.0564851 -0.0266157 
v 0.0704189 -0.0561464 -0.025767 
v 0.0665533 -0.0574929 -0.0291395 
v 0.0675222 -0.0572046 -0.0284178 
v 0.0659488 -0.0576166 -0.0294499 
v 0.0723659 -0.0551452 -0.023253 
v 0.0734088 -0.0544666 -0.0215508 
v 0.0743742 -0.0538384 -0.0199751 
v 0.0705598 -0.056074 -0.0255851 
v 0.0715407 -0.0555696 -0.0243185 
v 0.0763378 -0.0522289 -0.0159433 
v 0.0768076 -0.0517484 -0.0147378 
v 0.0780205 -0.0505081 -0.011626 
v 0.0747189 -0.0535558 -0.0192673 
v 0.0782484 -0.0502136 -0.010887 
v 0.0796285 -0.0484297 -0.00641042 
v 0.0797335 -0.0482939 -0.00606978 
v 0.0812559 -0.0456905 0.000451607 
v 0.0817063 -0.0446264 0.00311899 
v 0.0823372 -0.0431358 0.0068558 
v 0.0809675 -0.0461837 -0.000783888 
v 0.083143 -0.0402467 0.0140996 
v 0.0835455 -0.0374332 0.021154 
v 0.0827472 -0.0416659 0.0105415 
v 0.0830741 -0.0404935 0.0134808 
v 0.0835959 -0.0366071 0.0232245 
v 0.0835379 -0.0337935 0.0309395 
v 0.0835794 -0.0368778 0.0225459 
v 0.0396819 -0.0258951 0.0555552 
v 0.040262 -0.0249591 0.0579356 
v 0.0389703 -0.0274698 0.0515505 
v 0.0432271 -0.0208948 0.0682716 
v 0.0436615 -0.0204701 0.0693516 
v 0.0418345 -0.0226161 0.063894 
v 0.0413203 -0.0232516 0.0622779 
v 0.0383738 -0.0287898 0.0481935 
v 0.037445 -0.0318792 0.0403368 
v 0.0372874 -0.0328566 0.0378511 
v 0.0455465 -0.0186801 0.0739039 
v 0.0451109 -0.0190529 0.0729558 
v 0.036928 -0.0350857 0.0321822 
v 0.0368428 -0.0383137 0.0239731 
v 0.0844749 -0.0306674 0.0434185 
v 0.0834474 -0.0277683 0.0507914 
v 0.0849467 -0.0328569 0.0378505 
v 0.0832961 -0.0274678 0.0515556 
v 0.0804883 -0.0226763 0.063741 
v 0.0820092 -0.0249558 0.057944 
v 0.0804338 -0.0226121 0.0639042 
v 0.0786874 -0.0205563 0.0691324 
v 0.0785921 -0.0204671 0.0693594 
v 0.082102 -0.0250949 0.0575903 
v 0.0853881 -0.0383137 0.0239731 
v 0.0854054 -0.0369701 0.0273901 
v 0.085143 -0.0337678 0.0355339 
v 0.0766845 -0.0186801 0.0739039 
v 0.0711862 -0.0135538 0.0751588 
v 0.075646 -0.0161929 0.0751588 
v 0.0662681 -0.0119207 0.0751588 
v 0.0611155 -0.0113679 0.0751588 
v 0.0559629 -0.0119207 0.0751588 
v 0.0510448 -0.0135538 0.0751588 
v 0.046585 -0.0161929 0.0751588 
v 0.0442399 -0.0181867 0.0751588 
v 0.0779911 -0.0181867 0.0751588 
v 0.0780768 -0.0546771 -0.014035 
v 0.0797346 -0.0529077 -0.0099258 
v 0.0810734 -0.0510859 -0.00569475 
v 0.0815553 -0.0504301 -0.00417171 
v 0.0830763 -0.0476862 0.00220064 
v 0.0833528 -0.046986 0.00382687 
v 0.0842518 -0.0447092 0.00911438 
v 0.0847933 -0.0425228 0.0141921 
v 0.0850304 -0.0415653 0.0164159 
v 0.0853848 -0.0383397 0.023907 
v 0.0369591 -0.0398607 0.0203745 
v 0.0368462 -0.0383397 0.023907 
v 0.0374177 -0.0425239 0.0141895 
v 0.037497 -0.042984 0.013121 
v 0.0384178 -0.0459603 0.00620895 
v 0.0388846 -0.0469851 0.00382883 
v 0.0396806 -0.0487323 -0.000228955 
v 0.0411258 -0.0510897 -0.0057037 
v 0.0412124 -0.051231 -0.0060318 
v 0.0429589 -0.0534439 -0.011171 
v 0.044185 -0.0546721 -0.0140235 
v 0.0449323 -0.0554206 -0.0157618 
v 0.0457989 -0.0559553 -0.0174014 
v 0.0458372 -0.0559759 -0.0174647 
v 0.0479607 -0.0571161 -0.020974 
v 0.0480725 -0.0571762 -0.0211588 
v 0.0500426 -0.0580274 -0.0237904 
v 0.050382 -0.058174 -0.0242439 
v 0.0516673 -0.0586114 -0.0255982 
v 0.0521768 -0.0587848 -0.0261351 
v 0.052533 -0.058906 -0.0265103 
v 0.0543612 -0.0593809 -0.0279813 
v 0.0546226 -0.0594488 -0.0281916 
v 0.0565834 -0.0598129 -0.0293216 
v 0.0566623 -0.0598275 -0.0293671 
v 0.0577246 -0.0599516 -0.0297536 
v 0.057917 -0.0599741 -0.0298236 
v 0.058612 -0.0600553 -0.0300764 
v 0.0599822 -0.0601293 -0.0303082 
v 0.0588437 -0.0600678 -0.0301156 
v 0.0603821 -0.0601509 -0.0303758 
v 0.0622536 -0.0601345 -0.0303244 
v 0.0623737 -0.0601335 -0.0303211 
v 0.0633813 -0.0600614 -0.0300957 
v 0.0641403 -0.060007 -0.0299258 
v 0.0643149 -0.0599831 -0.0298515 
v 0.0656337 -0.0598027 -0.0292901 
v 0.0645103 -0.0599564 -0.0297683 
v 0.0662201 -0.0597224 -0.0290404 
v 0.0678586 -0.0593747 -0.0279622 
v 0.0684573 -0.0592476 -0.0275682 
v 0.070053 -0.0587834 -0.0261308 
v 0.070523 -0.0586467 -0.0257074 
v 0.0721973 -0.058029 -0.0237949 
v 0.0705697 -0.0586295 -0.0256541 
v 0.0724633 -0.0579309 -0.023491 
v 0.0742417 -0.0571095 -0.0209546 
v 0.0749012 -0.0568048 -0.0200138 
v 0.0763795 -0.0559513 -0.0173921 
v 0.0779022 -0.0548635 -0.014468 
v 0.0772987 -0.0554206 -0.0157618 
v 0.061114 -0.0601445 -0.0303557 
v 0.0874135 -0.0445964 0.00937646 
v 0.0888035 -0.0417087 0.0160827 
v 0.0857235 -0.0473193 0.00305279 
v 0.0899788 -0.0383397 0.0239069 
v 0.0794841 -0.053879 -0.0121814 
v 0.0837527 -0.0498463 -0.00281612 
v 0.0815235 -0.0521488 -0.00816329 
v 0.0334275 -0.0417087 0.0160827 
v 0.0348174 -0.0445964 0.00937646 
v 0.0365074 -0.0473193 0.00305279 
v 0.0322522 -0.0383397 0.0239069 
v 0.0384783 -0.0498463 -0.00281612 
v 0.0407074 -0.0521488 -0.00816329 
v 0.0427469 -0.053879 -0.0121814 
v 0.031311 -0.033579 0.036014 
v 0.0316078 -0.0355725 0.0309442 
v 0.0381856 -0.0181867 0.0751588 
v 0.0906232 -0.0355725 0.0309442 
v 0.09092 -0.033579 0.036014 
v 0.0840453 -0.0181867 0.0751588 
v 0.0910173 -0.027735 -0.0480493 
v 0.0910173 -0.027735 0.0441206 
v 0.0910998 -0.02919 0.0418362 
v 0.0910384 -0.0323087 -0.0480493 
v 0.0910903 -0.0313878 0.0387197 
v 0.0904542 -0.035542 -0.0480493 
v 0.091024 -0.0291903 -0.0480493 
v 0.0898982 -0.038619 -0.0480493 
v 0.0886448 -0.041643 -0.0480493 
v 0.0874429 -0.0445428 -0.0480493 
v 0.0855824 -0.0472213 -0.0480493 
v 0.0837847 -0.0498095 -0.0480493 
v 0.0814065 -0.052023 -0.0480493 
v 0.0790908 -0.0541784 -0.0480493 
v 0.076307 -0.0558297 -0.0480493 
v 0.0735757 -0.0574499 -0.0480493 
v 0.0705161 -0.058468 -0.0480493 
v 0.0674912 -0.0594746 -0.0480493 
v 0.0642973 -0.0598179 -0.0480493 
v 0.0579337 -0.0598179 -0.0480493 
v 0.0611155 -0.0601599 -0.0480493 
v 0.0517149 -0.058468 -0.0480493 
v 0.0547397 -0.0594746 -0.0480493 
v 0.045924 -0.0558297 -0.0480493 
v 0.0486553 -0.0574499 -0.0480493 
v 0.0408245 -0.052023 -0.0480493 
v 0.0431401 -0.0541784 -0.0480493 
v 0.0384462 -0.0498095 -0.0480493 
v 0.0366485 -0.0472213 -0.0480493 
v 0.0347881 -0.0445428 -0.0480493 
v 0.0335861 -0.041643 -0.0480493 
v 0.0323328 -0.038619 -0.0480493 
v 0.0317768 -0.035542 -0.0480493 
v 0.0311925 -0.0323087 -0.0480493 
v 0.0311406 -0.0313878 0.0387197 
v 0.0312069 -0.0291903 -0.0480493 
v 0.0312136 -0.027735 -0.0480493 
v 0.0311845 -0.0291912 0.0419676 
v 0.0312136 -0.027735 0.0441206 
v 0.0329799 -0.0321803 -0.0498412 
v 0.034052 -0.0381137 -0.0498412 
v 0.0363607 -0.0436837 -0.0498412 
v 0.0398003 -0.0486357 -0.0498412 
v 0.0442138 -0.0527437 -0.0498412 
v 0.0493996 -0.0558198 -0.0498412 
v 0.0551206 -0.0577235 -0.0498412 
v 0.0611155 -0.0583679 -0.0498412 
v 0.0671104 -0.0577235 -0.0498412 
v 0.0728314 -0.0558198 -0.0498412 
v 0.0780171 -0.0527437 -0.0498412 
v 0.0824306 -0.0486357 -0.0498412 
v 0.0858703 -0.0436837 -0.0498412 
v 0.0881789 -0.0381137 -0.0498412 
v 0.0892511 -0.0321803 -0.0498412 
v 0.0877809 -0.0209596 -0.0498412 
v 0.0879453 -0.0208568 -0.0496523 
v 0.0890984 -0.0234385 -0.0492705 
v 0.0890377 -0.0261547 -0.0498412 
v 0.0902348 -0.025983 -0.0486319 
v 0.0331932 -0.0261547 -0.0498412 
v 0.03445 -0.0209596 -0.0498412 
v 0.0331351 -0.0234329 -0.0492716 
v 0.0319847 -0.0260085 -0.0485398 
v 0.0342857 -0.0208568 -0.0496523 
v 0.0361155 -0.0167599 0.0720319 
v 0.0361155 -0.0167599 -0.0480493 
v 0.0378351 -0.0175745 0.0751588 
v 0.0364557 -0.0164197 0.0733668 
v 0.0861155 -0.0167599 0.0720319 
v 0.0861155 -0.0167599 -0.0480493 
v 0.0857753 -0.0164197 0.0733668 
v 0.0843958 -0.0175745 0.0751588 
v 0.0401155 -0.0127599 -0.0480493 
v 0.0401155 -0.0127599 0.0733668 
v 0.0821155 -0.0127599 -0.0480493 
v 0.0821155 -0.0127599 0.0733668 
v 0.0419074 -0.0135022 -0.0498412 
v 0.0803235 -0.0135022 -0.0498412 
v 0.0401155 -0.00975989 -0.0480493 
v 0.0419074 -0.00901763 -0.0498412 
v 0.0803235 -0.00901763 -0.0498412 
v 0.0821155 -0.00975989 -0.0480493 
v 0.0403417 -0.00745186 -0.0498412 
v 0.0818893 -0.00745186 -0.0498412 
v 0.0803235 -0.0135022 0.0751588 
v 0.0821155 -0.00975989 0.0733668 
v 0.0861155 -0.00570131 -0.0480907 
v 0.0861155 -0.00575989 -0.0480493 
v 0.0861155 -0.00575989 0.0733668 
v 0.0803235 -0.00901763 0.0751588 
v 0.0818893 -0.00745186 0.0751588 
v 0.0861155 -0.00570131 0.0734082 
v 0.0861155 -0.00565989 0.0456588 
v 0.0861155 -0.00565989 0.0516588 
v 0.0861155 -0.00565989 0.0576588 
v 0.0861155 -0.00565989 0.0396588 
v 0.0861155 -0.00565989 0.0336588 
v 0.0861155 -0.00565989 0.0276588 
v 0.0861155 -0.00565989 0.0216588 
v 0.0861155 -0.00565989 0.00965878 
v 0.0861155 -0.00565989 0.00365878 
v 0.0861155 -0.00565989 -0.00234122 
v 0.0861155 -0.00565989 -0.00834122 
v 0.0861155 -0.00565989 0.0636588 
v 0.0861155 -0.00565989 -0.0143412 
v 0.0861155 -0.00565989 0.0733668 
v 0.0861155 -0.00565989 -0.0203412 
v 0.0861155 -0.00565989 -0.0369571 
v 0.0861155 -0.00565989 -0.0480493 
v 0.0361155 -0.00565989 -0.0480493 
v 0.0811155 -0.00565989 -0.0480493 
v 0.0361155 -0.00570131 -0.0480907 
v 0.0361155 -0.00565989 0.0733668 
v 0.0361155 -0.00570131 0.0734082 
v 0.0403417 -0.00745186 0.0751588 
v 0.0811155 -0.00565989 0.0733668 
v 0.0419074 -0.00901763 0.0751588 
v 0.0419074 -0.0135022 0.0751588 
v 0.0401155 -0.00975989 0.0733668 
v 0.0361155 -0.00575989 -0.0480493 
v 0.0361155 -0.00565989 -0.0143412 
v 0.0361155 -0.00565989 -0.0203412 
v 0.0361155 -0.00565989 -0.0369571 
v 0.0361155 -0.00565989 -0.00834122 
v 0.0361155 -0.00565989 -0.00234122 
v 0.0361155 -0.00565989 0.00365878 
v 0.0361155 -0.00565989 0.00965878 
v 0.0361155 -0.00575989 0.0733668 
v 0.0361155 -0.00565989 0.0216588 
v 0.0361155 -0.00565989 0.0276588 
v 0.0361155 -0.00565989 0.0336588 
v 0.0361155 -0.00565989 0.0396588 
v 0.0361155 -0.00565989 0.0456588 
v 0.0361155 -0.00565989 0.0516588 
v 0.0361155 -0.00565989 0.0636588 
v 0.0361155 -0.00565989 0.0576588 
v 0.0561143 -0.00565989 -0.0246666 
v 0.0761155 -0.00565989 -0.021865 
v 0.0661166 -0.00565989 -0.0220159 
v 0.0461155 -0.00565989 -0.0248174 
v 0.0560795 -0.00565989 -0.0216654 
v 0.0661515 -0.00565989 -0.0250171 
v 0.0461155 -0.00565989 -0.0208174 
v 0.0761155 -0.00565989 -0.025865 
v 0.0461155 -0.00565989 -0.0188174 
v 0.0561143 -0.00565989 -0.0186666 
v 0.0761155 -0.00565989 -0.015865 
v 0.0661166 -0.00565989 -0.0160159 
v 0.0661515 -0.00565989 -0.0190171 
v 0.0560795 -0.00565989 -0.0156654 
v 0.0761155 -0.00565989 -0.019865 
v 0.0461155 -0.00565989 -0.0148174 
v 0.0461155 -0.00565989 -0.0128174 
v 0.0561143 -0.00565989 -0.0126666 
v 0.0761155 -0.00565989 -0.00986503 
v 0.0661166 -0.00565989 -0.0100159 
v 0.0661515 -0.00565989 -0.0130171 
v 0.0560795 -0.00565989 -0.00966536 
v 0.0761155 -0.00565989 -0.013865 
v 0.0461155 -0.00565989 -0.00881741 
v 0.0461155 -0.00565989 -0.00681741 
v 0.0561143 -0.00565989 -0.00666658 
v 0.0761155 -0.00565989 -0.00386503 
v 0.0661166 -0.00565989 -0.00401587 
v 0.0661515 -0.00565989 -0.00701708 
v 0.0560795 -0.00565989 -0.00366536 
v 0.0761155 -0.00565989 -0.00786503 
v 0.0461155 -0.00565989 -0.00281741 
v 0.0461155 -0.00565989 -0.000817411 
v 0.0561143 -0.00565989 -0.000666579 
v 0.0761155 -0.00565989 0.00213497 
v 0.0661166 -0.00565989 0.00198413 
v 0.0661515 -0.00565989 -0.00101708 
v 0.0560795 -0.00565989 0.00233464 
v 0.0761155 -0.00565989 -0.00186503 
v 0.0461155 -0.00565989 0.00318259 
v 0.0561143 -0.00565989 0.00533342 
v 0.0661515 -0.00565989 0.00498292 
v 0.0761155 -0.00565989 0.00813497 
v 0.0661166 -0.00565989 0.00798413 
v 0.0461155 -0.00565989 0.00518259 
v 0.0560795 -0.00565989 0.00833464 
v 0.0761155 -0.00565989 0.00413497 
v 0.0461155 -0.00565989 0.00918259 
v 0.0661166 -0.00565989 0.0139841 
v 0.0661515 -0.00565989 0.0169829 
v 0.0761155 -0.00565989 0.016135 
v 0.0560795 -0.00565989 0.0143346 
v 0.0561143 -0.00565989 0.0173334 
v 0.0561143 -0.00565989 0.0113334 
v 0.0661515 -0.00565989 0.0109829 
v 0.0461155 -0.00565989 0.0151826 
v 0.0461155 -0.00565989 0.0111826 
v 0.0461155 -0.00565989 0.0171826 
v 0.0461155 -0.00565989 0.0211826 
v 0.0761155 -0.00565989 0.020135 
v 0.0661166 -0.00565989 0.0199841 
v 0.0761155 -0.00565989 0.010135 
v 0.0761155 -0.00565989 0.014135 
v 0.0560795 -0.00565989 0.0203346 
v 0.0561143 -0.00565989 0.0233334 
v 0.0661515 -0.00565989 0.0229829 
v 0.0761155 -0.00565989 0.026135 
v 0.0661166 -0.00565989 0.0259841 
v 0.0461155 -0.00565989 0.0231826 
v 0.0560795 -0.00565989 0.0263346 
v 0.0761155 -0.00565989 0.022135 
v 0.0461155 -0.00565989 0.0271826 
v 0.0561143 -0.00565989 0.0293334 
v 0.0661515 -0.00565989 0.0289829 
v 0.0761155 -0.00565989 0.032135 
v 0.0661166 -0.00565989 0.0319841 
v 0.0461155 -0.00565989 0.0291826 
v 0.0560795 -0.00565989 0.0323346 
v 0.0761155 -0.00565989 0.028135 
v 0.0461155 -0.00565989 0.0331826 
v 0.0561143 -0.00565989 0.0353334 
v 0.0661515 -0.00565989 0.0349829 
v 0.0761155 -0.00565989 0.038135 
v 0.0661166 -0.00565989 0.0379841 
v 0.0461155 -0.00565989 0.0351826 
v 0.0560795 -0.00565989 0.0383346 
v 0.0761155 -0.00565989 0.034135 
v 0.0461155 -0.00565989 0.0391826 
v 0.0561143 -0.00565989 0.0413334 
v 0.0661515 -0.00565989 0.0409829 
v 0.0761155 -0.00565989 0.044135 
v 0.0661166 -0.00565989 0.0439841 
v 0.0461155 -0.00565989 0.0411826 
v 0.0560795 -0.00565989 0.0443346 
v 0.0761155 -0.00565989 0.040135 
v 0.0461155 -0.00565989 0.0451826 
v 0.0561143 -0.00565989 0.0473334 
v 0.0661515 -0.00565989 0.0469829 
v 0.0761155 -0.00565989 0.050135 
v 0.0661166 -0.00565989 0.0499841 
v 0.0461155 -0.00565989 0.0471826 
v 0.0560795 -0.00565989 0.0503346 
v 0.0761155 -0.00565989 0.046135 
v 0.0461155 -0.00565989 0.0511826 
v 0.0561143 -0.00565989 0.0533334 
v 0.0661515 -0.00565989 0.0529829 
v 0.0761155 -0.00565989 0.056135 
v 0.0661166 -0.00565989 0.0559841 
v 0.0461155 -0.00565989 0.0531826 
v 0.0560795 -0.00565989 0.0563346 
v 0.0761155 -0.00565989 0.052135 
v 0.0461155 -0.00565989 0.0571826 
v 0.0561143 -0.00565989 0.0593334 
v 0.0661515 -0.00565989 0.0589829 
v 0.0761155 -0.00565989 0.062135 
v 0.0661166 -0.00565989 0.0619841 
v 0.0461155 -0.00565989 0.0591826 
v 0.0560795 -0.00565989 0.0623346 
v 0.0761155 -0.00565989 0.058135 
v 0.0461155 -0.00565989 0.0631826 
v 0.0561143 -0.00565989 0.0653334 
v 0.0661515 -0.00565989 0.0649829 
v 0.0461155 -0.00565989 0.0651826 
v 0.0560795 -0.00565989 0.0683346 
v 0.0761155 -0.00565989 0.068135 
v 0.0661166 -0.00565989 0.0679841 
v 0.0761155 -0.00565989 0.064135 
v 0.0461155 -0.00565989 0.0691826 
v 0.0811155 -0.00565989 -0.0369571 
v 0.0811155 -0.00565989 -0.0203412 
v 0.0811155 -0.00565989 -0.0143412 
v 0.0811155 -0.00565989 -0.00834122 
v 0.0811155 -0.00565989 -0.00234122 
v 0.0811155 -0.00565989 0.00365878 
v 0.0811155 -0.00565989 0.00965878 
v 0.0811155 -0.00565989 0.0216588 
v 0.0811155 -0.00565989 0.0276588 
v 0.0811155 -0.00565989 0.0336588 
v 0.0811155 -0.00565989 0.0396588 
v 0.0811155 -0.00565989 0.0456588 
v 0.0811155 -0.00565989 0.0516588 
v 0.0811155 -0.00565989 0.0576588 
v 0.0811155 -0.00565989 0.0636588 
v 0.0661515 -0.0106599 0.0649829 
v 0.0561143 -0.0106599 0.0653334 
v 0.0661166 -0.0106599 0.0679841 
v 0.0461155 -0.0106599 0.0651826 
v 0.0461155 -0.0106599 0.0691826 
v 0.0560795 -0.0106599 0.0683346 
v 0.0761155 -0.0106599 0.068135 
v 0.0761155 -0.0106599 0.064135 
v 0.0661515 -0.0106599 0.0589829 
v 0.0561143 -0.0106599 0.0593334 
v 0.0661166 -0.0106599 0.0619841 
v 0.0461155 -0.0106599 0.0591826 
v 0.0461155 -0.0106599 0.0631826 
v 0.0560795 -0.0106599 0.0623346 
v 0.0761155 -0.0106599 0.062135 
v 0.0761155 -0.0106599 0.058135 
v 0.0661515 -0.0106599 0.0529829 
v 0.0561143 -0.0106599 0.0533334 
v 0.0661166 -0.0106599 0.0559841 
v 0.0461155 -0.0106599 0.0531826 
v 0.0461155 -0.0106599 0.0571826 
v 0.0560795 -0.0106599 0.0563346 
v 0.0761155 -0.0106599 0.056135 
v 0.0761155 -0.0106599 0.052135 
v 0.0661515 -0.0106599 0.0469829 
v 0.0561143 -0.0106599 0.0473334 
v 0.0661166 -0.0106599 0.0499841 
v 0.0461155 -0.0106599 0.0471826 
v 0.0461155 -0.0106599 0.0511826 
v 0.0560795 -0.0106599 0.0503346 
v 0.0761155 -0.0106599 0.050135 
v 0.0761155 -0.0106599 0.046135 
v 0.0661515 -0.0106599 0.0409829 
v 0.0561143 -0.0106599 0.0413334 
v 0.0661166 -0.0106599 0.0439841 
v 0.0461155 -0.0106599 0.0411826 
v 0.0461155 -0.0106599 0.0451826 
v 0.0560795 -0.0106599 0.0443346 
v 0.0761155 -0.0106599 0.044135 
v 0.0761155 -0.0106599 0.040135 
v 0.0661515 -0.0106599 0.0349829 
v 0.0561143 -0.0106599 0.0353334 
v 0.0661166 -0.0106599 0.0379841 
v 0.0461155 -0.0106599 0.0351826 
v 0.0461155 -0.0106599 0.0391826 
v 0.0560795 -0.0106599 0.0383346 
v 0.0761155 -0.0106599 0.038135 
v 0.0761155 -0.0106599 0.034135 
v 0.0661515 -0.0106599 0.0289829 
v 0.0561143 -0.0106599 0.0293334 
v 0.0661166 -0.0106599 0.0319841 
v 0.0461155 -0.0106599 0.0291826 
v 0.0461155 -0.0106599 0.0331826 
v 0.0560795 -0.0106599 0.0323346 
v 0.0761155 -0.0106599 0.032135 
v 0.0761155 -0.0106599 0.028135 
v 0.0661515 -0.0106599 0.0229829 
v 0.0561143 -0.0106599 0.0233334 
v 0.0661166 -0.0106599 0.0259841 
v 0.0461155 -0.0106599 0.0231826 
v 0.0461155 -0.0106599 0.0271826 
v 0.0560795 -0.0106599 0.0263346 
v 0.0761155 -0.0106599 0.026135 
v 0.0761155 -0.0106599 0.022135 
v 0.0661515 -0.0106599 0.0169829 
v 0.0561143 -0.0106599 0.0173334 
v 0.0661166 -0.0106599 0.0199841 
v 0.0461155 -0.0106599 0.0171826 
v 0.0461155 -0.0106599 0.0211826 
v 0.0560795 -0.0106599 0.0203346 
v 0.0761155 -0.0106599 0.020135 
v 0.0761155 -0.0106599 0.016135 
v 0.0661515 -0.0106599 0.0109829 
v 0.0561143 -0.0106599 0.0113334 
v 0.0661166 -0.0106599 0.0139841 
v 0.0461155 -0.0106599 0.0111826 
v 0.0461155 -0.0106599 0.0151826 
v 0.0560795 -0.0106599 0.0143346 
v 0.0761155 -0.0106599 0.014135 
v 0.0761155 -0.0106599 0.010135 
v 0.0661515 -0.0106599 0.00498292 
v 0.0561143 -0.0106599 0.00533342 
v 0.0661166 -0.0106599 0.00798413 
v 0.0461155 -0.0106599 0.00518259 
v 0.0461155 -0.0106599 0.00918259 
v 0.0560795 -0.0106599 0.00833464 
v 0.0761155 -0.0106599 0.00813497 
v 0.0761155 -0.0106599 0.00413497 
v 0.0661515 -0.0106599 -0.00101708 
v 0.0561143 -0.0106599 -0.000666579 
v 0.0461155 -0.0106599 -0.000817411 
v 0.0461155 -0.0106599 0.00318259 
v 0.0560795 -0.0106599 0.00233464 
v 0.0661166 -0.0106599 0.00198413 
v 0.0761155 -0.0106599 0.00213497 
v 0.0761155 -0.0106599 -0.00186503 
v 0.0661515 -0.0106599 -0.00701708 
v 0.0561143 -0.0106599 -0.00666658 
v 0.0461155 -0.0106599 -0.00681741 
v 0.0461155 -0.0106599 -0.00281741 
v 0.0560795 -0.0106599 -0.00366536 
v 0.0661166 -0.0106599 -0.00401587 
v 0.0761155 -0.0106599 -0.00386503 
v 0.0761155 -0.0106599 -0.00786503 
v 0.0661515 -0.0106599 -0.0130171 
v 0.0561143 -0.0106599 -0.0126666 
v 0.0461155 -0.0106599 -0.0128174 
v 0.0461155 -0.0106599 -0.00881741 
v 0.0560795 -0.0106599 -0.00966536 
v 0.0661166 -0.0106599 -0.0100159 
v 0.0761155 -0.0106599 -0.00986503 
v 0.0761155 -0.0106599 -0.013865 
v 0.0661515 -0.0106599 -0.0190171 
v 0.0561143 -0.0106599 -0.0186666 
v 0.0461155 -0.0106599 -0.0188174 
v 0.0461155 -0.0106599 -0.0148174 
v 0.0560795 -0.0106599 -0.0156654 
v 0.0661166 -0.0106599 -0.0160159 
v 0.0761155 -0.0106599 -0.015865 
v 0.0761155 -0.0106599 -0.019865 
v 0.0661515 -0.0106599 -0.0250171 
v 0.0561143 -0.0106599 -0.0246666 
v 0.0461155 -0.0106599 -0.0248174 
v 0.0461155 -0.0106599 -0.0208174 
v 0.0560795 -0.0106599 -0.0216654 
v 0.0661166 -0.0106599 -0.0220159 
v 0.0761155 -0.0106599 -0.021865 
v 0.0761155 -0.0106599 -0.025865 
vn -0.143214 -0.988811 -0.0417399 
vn 0.0561567 -0.997571 -0.0412029 
vn -0.339427 -0.939675 -0.0424232 
vn -0.143214 -0.988811 -0.0417399 
vn -0.524615 -0.850241 -0.0432387 
vn -0.339427 -0.939675 -0.0424232 
vn -0.690482 -0.722 -0.0441655 
vn -0.524615 -0.850241 -0.0432387 
vn -0.828492 -0.558175 -0.0451736 
vn -0.690482 -0.722 -0.0441655 
vn -0.930226 -0.364065 -0.0462222 
vn -0.828492 -0.558175 -0.0451736 
vn -0.987957 -0.147336 -0.0472587 
vn -0.930226 -0.364065 -0.0462222 
vn -0.995477 0.081859 -0.0482207 
vn -0.987957 -0.147336 -0.0472587 
vn -0.949108 0.31111 -0.0490391 
vn -0.995477 0.081859 -0.0482207 
vn -0.84873 0.526491 -0.049647 
vn -0.949108 0.31111 -0.0490391 
vn -0.698516 0.713846 -0.049989 
vn -0.84873 0.526491 -0.049647 
vn -0.507042 0.860468 -0.0500319 
vn -0.698516 0.713846 -0.049989 
vn -0.286572 0.956765 -0.0497713 
vn -0.507042 0.860468 -0.0500319 
vn -0.051607 0.997453 -0.0492329 
vn -0.286572 0.956765 -0.0497713 
vn 0.182918 0.981933 -0.0484668 
vn -0.051607 0.997453 -0.0492329 
vn 0.403296 0.913834 -0.047538 
vn 0.182918 0.981933 -0.0484668 
vn 0.598202 0.799994 -0.0465156 
vn 0.403296 0.913834 -0.047538 
vn 0.759225 0.649238 -0.0454646 
vn 0.598202 0.799994 -0.0465156 
vn 0.880864 0.471279 -0.0444406 
vn 0.759225 0.649238 -0.0454646 
vn 0.960205 0.275891 -0.0434876 
vn 0.880864 0.471279 -0.0444406 
vn 0.996465 0.0723828 -0.0426385 
vn 0.960205 0.275891 -0.0434876 
vn 0.990538 -0.130681 -0.0419167 
vn 0.996465 0.0723828 -0.0426385 
vn 0.944606 -0.325593 -0.0413377 
vn 0.990538 -0.130681 -0.0419167 
vn 0.861848 -0.505514 -0.0409117 
vn 0.944606 -0.325593 -0.0413377 
vn 0.746232 -0.664444 -0.0406448 
vn 0.861848 -0.505514 -0.0409117 
vn 0.602381 -0.797178 -0.0405402 
vn 0.746232 -0.664444 -0.0406448 
vn 0.4355 -0.899273 -0.0405991 
vn 0.602381 -0.797178 -0.0405402 
vn 0.251333 -0.96704 -0.0408209 
vn 0.4355 -0.899273 -0.0405991 
vn 0.0635998 -0.089142 0.993986 
vn -0.143214 -0.988811 -0.0417399 
vn 0.0561567 -0.997571 -0.0412029 
vn -0.339427 -0.939675 -0.0424232 
vn -0.143214 -0.988811 -0.0417399 
vn -0.524615 -0.850241 -0.0432387 
vn -0.339427 -0.939675 -0.0424232 
vn -0.690482 -0.722 -0.0441655 
vn -0.524615 -0.850241 -0.0432387 
vn -0.828492 -0.558175 -0.0451736 
vn -0.690482 -0.722 -0.0441655 
vn -0.930226 -0.364065 -0.0462222 
vn -0.828492 -0.558175 -0.0451736 
vn -0.987957 -0.147336 -0.0472587 
vn -0.930226 -0.364065 -0.0462222 
vn -0.995477 0.081859 -0.0482207 
vn -0.987957 -0.147336 -0.0472587 
vn -0.949108 0.31111 -0.0490391 
vn -0.995477 0.081859 -0.0482207 
vn -0.84873 0.526491 -0.049647 
vn -0.949108 0.31111 -0.0490391 
vn -0.698516 0.713846 -0.049989 
vn -0.84873 0.526491 -0.049647 
vn -0.507042 0.860468 -0.0500319 
vn -0.698516 0.713846 -0.049989 
vn -0.286572 0.956765 -0.0497713 
vn -0.507042 0.860468 -0.0500319 
vn -0.051607 0.997453 -0.0492329 
vn -0.286572 0.956765 -0.0497713 
vn 0.182918 0.981933 -0.0484668 
vn -0.051607 0.997453 -0.0492329 
vn 0.403296 0.913834 -0.047538 
vn 0.182918 0.981933 -0.0484668 
vn 0.598202 0.799994 -0.0465156 
vn 0.403296 0.913834 -0.047538 
vn 0.759225 0.649238 -0.0454646 
vn 0.598202 0.799994 -0.0465156 
vn 0.880864 0.471279 -0.0444406 
vn 0.759225 0.649238 -0.0454646 
vn 0.960205 0.275891 -0.0434876 
vn 0.880864 0.471279 -0.0444406 
vn 0.996465 0.0723828 -0.0426385 
vn 0.960205 0.275891 -0.0434876 
vn 0.990538 -0.130681 -0.0419167 
vn 0.996465 0.0723828 -0.0426385 
vn 0.944606 -0.325593 -0.0413377 
vn 0.990538 -0.130681 -0.0419167 
vn 0.861848 -0.505514 -0.0409117 
vn 0.944606 -0.325593 -0.0413377 
vn 0.746232 -0.664444 -0.0406448 
vn 0.861848 -0.505514 -0.0409117 
vn 0.602381 -0.797178 -0.0405402 
vn 0.746232 -0.664444 -0.0406448 
vn 0.4355 -0.899273 -0.0405991 
vn 0.602381 -0.797178 -0.0405402 
vn 0.251333 -0.96704 -0.0408209 
vn 0.4355 -0.899273 -0.0405991 
vn -0.143214 -0.988811 -0.0417399 
vn 0.0561567 -0.997571 -0.0412029 
vn -0.339427 -0.939675 -0.0424232 
vn -0.143214 -0.988811 -0.0417399 
vn -0.524615 -0.850241 -0.0432387 
vn -0.339427 -0.939675 -0.0424232 
vn -0.690482 -0.722 -0.0441655 
vn -0.524615 -0.850241 -0.0432387 
vn -0.828492 -0.558175 -0.0451736 
vn -0.690482 -0.722 -0.0441655 
vn -0.930226 -0.364065 -0.0462222 
vn -0.828492 -0.558175 -0.0451736 
vn -0.987957 -0.147336 -0.0472587 
vn -0.930226 -0.364065 -0.0462222 
vn -0.995477 0.081859 -0.0482207 
vn -0.987957 -0.147336 -0.0472587 
vn -0.949108 0.31111 -0.0490391 
vn -0.995477 0.081859 -0.0482207 
vn -0.84873 0.526491 -0.049647 
vn -0.949108 0.31111 -0.0490391 
vn -0.698516 0.713846 -0.049989 
vn -0.84873 0.526491 -0.049647 
vn -0.507042 0.860468 -0.0500319 
vn -0.698516 0.713846 -0.049989 
vn -0.286572 0.956765 -0.0497713 
vn -0.507042 0.860468 -0.0500319 
vn -0.051607 0.997453 -0.0492329 
vn -0.286572 0.956765 -0.0497713 
vn 0.182918 0.981933 -0.0484668 
vn -0.051607 0.997453 -0.0492329 
vn 0.403296 0.913834 -0.047538 
vn 0.182918 0.981933 -0.0484668 
vn 0.598202 0.799994 -0.0465156 
vn 0.403296 0.913834 -0.047538 
vn 0.759225 0.649238 -0.0454646 
vn 0.598202 0.799994 -0.0465156 
vn 0.880864 0.471279 -0.0444406 
vn 0.759225 0.649238 -0.0454646 
vn 0.960205 0.275891 -0.0434876 
vn 0.880864 0.471279 -0.0444406 
vn 0.996465 0.0723828 -0.0426385 
vn 0.960205 0.275891 -0.0434876 
vn 0.990538 -0.130681 -0.0419167 
vn 0.996465 0.0723828 -0.0426385 
vn 0.944606 -0.325593 -0.0413377 
vn 0.990538 -0.130681 -0.0419167 
vn 0.861848 -0.505514 -0.0409117 
vn 0.944606 -0.325593 -0.0413377 
vn 0.746232 -0.664444 -0.0406448 
vn 0.861848 -0.505514 -0.0409117 
vn 0.602381 -0.797178 -0.0405402 
vn 0.746232 -0.664444 -0.0406448 
vn 0.4355 -0.899273 -0.0405991 
vn 0.602381 -0.797178 -0.0405402 
vn 0.251333 -0.96704 -0.0408209 
vn 0.4355 -0.899273 -0.0405991 
vn -0.884401 -0.464485 -0.0456958 
vn -0.947623 -0.315993 -0.0464633 
vn -0.896685 -0.44029 -0.0458256 
vn -0.958597 -0.280921 -0.046635 
vn -0.965027 -0.257951 -0.0467457 
vn -0.965022 -0.257968 -0.0467456 
vn -0.763504 -0.644257 -0.0446617 
vn -0.865038 -0.499639 -0.0455037 
vn -0.831451 -0.553757 -0.045199 
vn -0.884419 -0.464451 -0.045696 
vn -0.800721 -0.597349 -0.0449449 
vn -0.610495 -0.790814 -0.0436898 
vn -0.726745 -0.685471 -0.0444033 
vn -0.667798 -0.74304 -0.0440243 
vn -0.643915 -0.763838 -0.0438812 
vn -0.763478 -0.644288 -0.0446615 
vn -0.749257 -0.660779 -0.0445592 
vn -0.517429 -0.854635 -0.0432033 
vn -0.433909 -0.899939 -0.0428155 
vn -0.582196 -0.811882 -0.0435351 
vn -0.610479 -0.790827 -0.0436897 
vn -0.559082 -0.827975 -0.0434132 
vn -0.433945 -0.899921 -0.0428157 
vn -0.334234 -0.941536 -0.0424029 
vn -0.242195 -0.969315 -0.042064 
vn -0.242218 -0.96931 -0.0420641 
vn -0.140525 -0.989197 -0.0417317 
vn -0.0434514 -0.998195 -0.0414525 
vn 0.0561567 -0.997571 -0.0412029 
vn -0.0434591 -0.998195 -0.0414525 
vn 0.154715 -0.987108 -0.0409921 
vn 0.154708 -0.98711 -0.0409921 
vn 0.345198 -0.937648 -0.0406898 
vn 0.248755 -0.967706 -0.040825 
vn 0.521473 -0.852304 -0.0405492 
vn 0.430725 -0.90157 -0.040603 
vn 0.345219 -0.93764 -0.0406897 
vn 0.596029 -0.801939 -0.0405394 
vn 0.677529 -0.734376 -0.0405721 
vn 0.632709 -0.773327 -0.0405479 
vn 0.521505 -0.852284 -0.0405492 
vn 0.677524 -0.734381 -0.0405721 
vn 0.784952 -0.618218 -0.0407096 
vn 0.807861 -0.587962 -0.0407581 
vn 0.777216 -0.627916 -0.040695 
vn 0.706817 -0.70623 -0.0405973 
vn 0.711541 -0.70147 -0.0406021 
vn 0.807872 -0.587947 -0.0407581 
vn 0.904514 -0.42446 -0.0410895 
vn 0.907591 -0.417838 -0.0411051 
vn 0.891918 -0.450331 -0.0410301 
vn 0.839218 -0.542259 -0.0408396 
vn 0.847286 -0.529563 -0.0408639 
vn 0.907599 -0.417821 -0.0411051 
vn 0.967258 -0.250371 -0.0415476 
vn 0.972402 -0.229571 -0.0416087 
vn 0.948759 -0.313282 -0.0413708 
vn 0.972394 -0.229603 -0.0416086 
vn 0.998266 -0.0410168 -0.0422206 
vn 0.998664 -0.0297316 -0.0422605 
vn 0.980515 -0.191963 -0.0417224 
vn 0.996309 -0.0748053 -0.0421033 
vn 0.998665 -0.0297069 -0.0422606 
vn 0.991389 0.12374 -0.0428405 
vn 0.983693 0.174625 -0.0430485 
vn 0.995835 0.0805698 -0.0426702 
vn 0.983698 0.174597 -0.0430484 
vn 0.9443 0.326169 -0.0437187 
vn 0.925919 0.375156 -0.0439529 
vn 0.979934 0.194599 -0.0431325 
vn 0.951388 0.304891 -0.0436198 
vn 0.925915 0.375166 -0.0439529 
vn 0.837229 0.545011 -0.0448434 
vn 0.825222 0.563017 -0.0449461 
vn 0.897642 0.438496 -0.0442698 
vn 0.876762 0.478864 -0.0444808 
vn 0.825205 0.563042 -0.0449462 
vn 0.689458 0.722867 -0.0459499 
vn 0.683371 0.728621 -0.0459899 
vn 0.76916 0.637442 -0.0453908 
vn 0.765915 0.641336 -0.0454151 
vn 0.683359 0.728633 -0.04599 
vn 0.506006 0.861247 -0.0470265 
vn 0.504531 0.862111 -0.0470342 
vn 0.599778 0.798813 -0.0465064 
vn 0.547639 0.835405 -0.0468024 
vn 0.628513 0.776418 -0.0463351 
vn 0.504529 0.862113 -0.0470343 
vn 0.332499 0.941889 -0.04786 
vn 0.295658 0.954086 -0.0480184 
vn 0.419736 0.906405 -0.0474598 
vn 0.368269 0.928495 -0.0477002 
vn 0.460855 0.886216 -0.0472582 
vn 0.0666126 0.996581 -0.0488745 
vn 0.295648 0.954089 -0.0480184 
vn 0.118724 0.991732 -0.0486986 
vn 0.147355 0.987889 -0.0485973 
vn 0.221314 0.974005 -0.0483201 
vn 0.170104 0.984231 -0.0485145 
vn 0.236722 0.970378 -0.0482595 
vn 0.270839 0.961421 -0.0481218 
vn -0.169957 0.984206 -0.0495342 
vn -0.107846 0.99294 -0.0493834 
vn -0.143773 0.988373 -0.0494726 
vn -0.0174013 0.998641 -0.049135 
vn -0.0384372 0.998049 -0.0491958 
vn -0.0914947 0.994582 -0.049341 
vn 0.0666126 0.996581 -0.0488745 
vn 0.0141392 0.998697 -0.0490406 
vn -0.399557 0.915347 -0.0499386 
vn -0.296521 0.953728 -0.0497886 
vn -0.350473 0.935244 -0.049874 
vn -0.392359 0.918456 -0.0499299 
vn -0.199732 0.978594 -0.0496005 
vn -0.248182 0.967438 -0.0497001 
vn -0.169969 0.984204 -0.0495342 
vn -0.607242 0.792939 -0.0500488 
vn -0.489608 0.870507 -0.0500216 
vn -0.542448 0.838597 -0.0500464 
vn -0.589529 0.806195 -0.0500515 
vn -0.399546 0.915352 -0.0499385 
vn -0.449011 0.892127 -0.0499901 
vn -0.779415 0.624521 -0.0498539 
vn -0.686261 0.725634 -0.050002 
vn -0.710063 0.702362 -0.0499751 
vn -0.767771 0.63878 -0.0498794 
vn -0.60722 0.792956 -0.0500488 
vn -0.905515 0.421432 -0.0493733 
vn -0.779395 0.624547 -0.049854 
vn -0.844024 0.534001 -0.0496647 
vn -0.848501 0.52686 -0.0496479 
vn -0.97913 0.197325 -0.0486522 
vn -0.916946 0.395955 -0.0493 
vn -0.937804 0.34367 -0.0491422 
vn -0.961918 0.268927 -0.0489004 
vn -0.905534 0.421391 -0.0493731 
vn -0.998295 -0.033568 -0.0477533 
vn -0.990648 0.12757 -0.0483959 
vn -0.998827 -0.00730728 -0.0478627 
vn -0.979131 0.197323 -0.0486522 
vn -0.989008 0.139701 -0.0484415 
vn -0.997786 -0.0463405 -0.0476994 
vn -0.983047 -0.177194 -0.0471234 
vn -0.998295 -0.0335688 -0.0477533 
vn 0.556013 -0.817956 0.147638 
vn 0.516756 -0.844247 0.142161 
vn 0.530966 -0.832912 0.155987 
vn 0.513546 -0.844216 0.153523 
vn 0.558718 -0.813688 0.160458 
vn 0.463108 -0.875724 0.136526 
vn 0.417336 -0.898972 0.132963 
vn 0.428776 -0.8918 0.144376 
vn 0.418611 -0.896755 0.143508 
vn 0.466837 -0.871872 0.147995 
vn 0.468548 -0.872748 0.137017 
vn 0.480123 -0.86438 0.149427 
vn 0.510344 -0.848269 0.141385 
vn 0.485919 -0.862967 0.138455 
vn 0.580898 -0.797203 0.164394 
vn 0.567834 -0.809454 0.149494 
vn 0.629091 -0.757553 0.174233 
vn 0.616265 -0.771516 0.158052 
vn 0.570919 -0.8072 0.149931 
vn 0.641704 -0.749343 0.163407 
vn 0.643422 -0.744616 0.177636 
vn 0.366432 -0.921337 0.129864 
vn 0.372599 -0.917385 0.139906 
vn 0.382773 -0.91307 0.14067 
vn 0.414316 -0.900399 0.132758 
vn 0.395398 -0.909092 0.131196 
vn 0.674759 -0.714177 0.186151 
vn 0.663883 -0.728547 0.168754 
vn 0.649711 -0.742048 0.16505 
vn 0.717066 -0.667413 0.200939 
vn 0.705538 -0.685123 0.181168 
vn 0.716865 -0.672151 0.185251 
vn -0.533151 -0.826239 0.181878 
vn -0.480277 -0.860215 0.17136 
vn -0.499584 -0.851096 0.161404 
vn -0.55403 -0.814527 0.172037 
vn -0.570395 -0.79895 0.190598 
vn -0.471545 -0.867819 0.156638 
vn -0.488398 -0.857962 0.159276 
vn -0.474504 -0.863622 0.170305 
vn -0.374191 -0.914227 0.155468 
vn -0.383532 -0.912114 0.144743 
vn -0.393644 -0.907648 0.145669 
vn -0.424173 -0.890968 0.162025 
vn -0.368676 -0.918463 0.14319 
vn -0.372695 -0.914867 0.155293 
vn -0.322485 -0.934625 0.149933 
vn -0.330024 -0.933592 0.13961 
vn -0.315544 -0.938762 0.138414 
vn -0.320134 -0.93547 0.149703 
vn -0.427096 -0.889493 0.162456 
vn -0.443671 -0.883153 0.152306 
vn -0.420694 -0.894858 0.14915 
vn -0.65528 -0.728234 0.200708 
vn -0.655439 -0.723183 0.21773 
vn -0.635434 -0.743018 0.210115 
vn -0.585341 -0.787107 0.194521 
vn -0.577651 -0.796821 0.177185 
vn -0.608616 -0.771466 0.185543 
vn -0.568502 -0.803793 0.17528 
vn -0.270531 -0.951708 0.14514 
vn -0.277644 -0.95107 0.13557 
vn -0.295003 -0.945691 0.136535 
vn -0.263982 -0.955087 0.134621 
vn -0.229285 -0.720517 0.654434 
vn -0.302119 -0.688476 0.659337 
vn -0.362747 -0.653939 0.663911 
vn -0.0867395 -0.75806 0.646391 
vn -0.161727 -0.742189 0.650385 
vn 0.0590602 -0.766107 0.639994 
vn -0.0148963 -0.765704 0.643021 
vn 0.202534 -0.745158 0.63539 
vn 0.132414 -0.759046 0.637429 
vn 0.33843 -0.696557 0.632672 
vn 0.274552 -0.723188 0.633735 
vn 0.461877 -0.622401 0.631892 
vn 0.406246 -0.659943 0.632012 
vn -0.392858 -0.633723 0.666377 
vn -0.420878 -0.612833 0.668803 
vn -0.362747 -0.653939 0.663911 
vn 0.527393 -0.567439 0.632352 
vn 0.514527 -0.579295 0.632202 
vn 0.489233 -0.601027 0.631996 
vn -0.435197 -0.60131 0.670097 
vn -0.820641 -0.34704 0.453996 
vn -0.817499 -0.406739 0.407748 
vn -0.827265 -0.403708 0.390707 
vn -0.812511 -0.469164 0.345994 
vn -0.825764 -0.413662 0.383404 
vn -0.80686 -0.459483 0.371285 
vn -0.801761 -0.477032 0.360027 
vn -0.775952 -0.542947 0.321102 
vn -0.78964 -0.529434 0.310111 
vn -0.811278 -0.47311 0.343505 
vn -0.783931 -0.541593 0.303527 
vn -0.771141 -0.566666 0.290226 
vn -0.768481 -0.55824 0.312738 
vn -0.742193 -0.604927 0.288467 
vn -0.751977 -0.599736 0.27358 
vn -0.714735 -0.645567 0.269066 
vn -0.715341 -0.652913 0.248981 
vn -0.732019 -0.63016 0.258932 
vn -0.702076 -0.662326 0.261562 
vn -0.657082 -0.714716 0.239634 
vn -0.669229 -0.70767 0.226573 
vn -0.711753 -0.657584 0.246964 
vn -0.656165 -0.721435 0.221312 
vn -0.660475 -0.716971 0.222992 
vn -0.656675 -0.715141 0.239483 
vn 0.755662 -0.61645 0.22128 
vn 0.721377 -0.661319 0.205604 
vn 0.737097 -0.635615 0.229526 
vn 0.718559 -0.65939 0.221084 
vn 0.767678 -0.591514 0.246537 
vn 0.768116 -0.598285 0.228149 
vn 0.717701 -0.665732 0.204221 
vn 0.718209 -0.659814 0.220955 
vn 0.772702 -0.583537 0.249833 
vn 0.787697 -0.567034 0.240844 
vn 0.78228 -0.576099 0.236955 
vn 0.803254 -0.528559 0.274604 
vn 0.815051 -0.515687 0.264117 
vn 0.812915 -0.508084 0.28464 
vn 0.828001 -0.471239 0.303887 
vn 0.830456 -0.480767 0.281436 
vn 0.820021 -0.50502 0.269295 
vn 0.844945 -0.416012 0.336158 
vn 0.842835 -0.446704 0.300141 
vn 0.849512 -0.424596 0.313126 
vn 0.845788 -0.412484 0.338379 
vn 0.855444 -0.352016 0.379868 
vn 0.858676 -0.384646 0.338708 
vn 0.864969 -0.323024 0.384035 
vn 0.860534 -0.373692 0.346174 
vn 0.856638 -0.313319 0.409882 
vn 0.865023 -0.320094 0.38636 
vn 0.855191 -0.287933 0.430979 
vn 0.852364 -0.262982 0.452013 
vn 0.860108 -0.256663 0.440839 
vn 0.85221 -0.261962 0.452895 
vn 0.8359 -0.200327 0.511019 
vn 0.847795 -0.209252 0.487296 
vn 0.859265 -0.25202 0.445141 
vn 0.834531 -0.196796 0.514616 
vn 0.803766 -0.138739 0.578543 
vn 0.817463 -0.146859 0.556944 
vn 0.838562 -0.186 0.512072 
vn 0.796056 -0.127797 0.591577 
vn 0.763441 -0.0896604 0.639624 
vn 0.793417 -0.113923 0.597922 
vn 0.762085 -0.0805507 0.642447 
vn 0.792534 -0.11286 0.599293 
vn 0.746629 -0.0735257 0.661165 
vn 0.733447 -0.0619853 0.676915 
vn 0.654095 -0.0072099 0.756378 
vn 0.670542 -0.0126544 0.741763 
vn 0.724959 -0.0490497 0.687043 
vn 0.639489 0.000894684 0.768799 
vn 0.513096 0.0549516 0.85657 
vn 0.569672 0.0362818 0.821071 
vn 0.622842 0.0128486 0.782242 
vn 0.52833 0.0516317 0.847468 
vn 0.506827 0.0570467 0.860158 
vn 0.420832 0.081578 0.903463 
vn 0.463848 0.0715925 0.883017 
vn 0.434037 0.079412 0.897388 
vn 0.40351 0.0856761 0.910955 
vn 0.33652 0.0992008 0.936437 
vn 0.323735 0.101908 0.940644 
vn 0.193862 0.117408 0.973978 
vn 0.19925 0.117088 0.972928 
vn 0.269153 0.109778 0.956821 
vn 0.313842 0.10301 0.943871 
vn 0.0647583 0.123169 0.990271 
vn 0.148699 0.120515 0.981512 
vn -0.0666497 0.119412 0.990605 
vn -0.0722302 0.119171 0.990243 
vn -0.0802986 0.118465 0.989706 
vn -0.19301 0.106452 0.975405 
vn -0.151284 0.11213 0.98211 
vn -0.203625 0.105452 0.973353 
vn -0.271316 0.0933972 0.957948 
vn -0.323904 0.0833959 0.942407 
vn -0.289388 0.0897841 0.952992 
vn -0.412405 0.0583281 0.909132 
vn -0.429696 0.0549115 0.901303 
vn -0.357516 0.0753683 0.930861 
vn -0.309329 0.0855173 0.947102 
vn -0.47644 0.0389875 0.878342 
vn -0.459126 0.0427427 0.887343 
vn -0.523627 0.0203418 0.851705 
vn -0.575177 -0.00779086 0.817992 
vn -0.594566 -0.013715 0.80393 
vn -0.608435 -0.0263808 0.793165 
vn -0.685484 -0.0804706 0.723627 
vn -0.704132 -0.0883376 0.704553 
vn -0.650654 -0.0475567 0.757884 
vn -0.702928 -0.0956991 0.704794 
vn -0.736067 -0.118763 0.666409 
vn -0.755 -0.152922 0.637644 
vn -0.771744 -0.162145 0.614914 
vn -0.741385 -0.124449 0.659439 
vn -0.704763 -0.0973879 0.702727 
vn -0.761125 -0.161407 0.628202 
vn -0.794564 -0.22157 0.565309 
vn -0.809252 -0.231796 0.539797 
vn -0.790224 -0.191498 0.58213 
vn -0.802423 -0.241924 0.545518 
vn -0.830842 -0.339079 0.441279 
vn -0.823663 -0.279735 0.493282 
vn -0.815171 -0.291168 0.500716 
vn -0.820328 -0.265907 0.506316 
vn -0.820387 -0.340263 0.45955 
vn -0.830952 -0.358118 0.425758 
vn -0.818734 -0.318964 0.477427 
vn 0.0647583 0.123169 0.990271 
vn 0.0573666 -0.942539 0.329135 
vn 0.0572474 -0.951975 0.300777 
vn 0.999092 -0.00456315 -0.0423508 
vn 0.997849 -0.0501738 -0.0421885 
vn 0.988273 -0.146845 -0.0418643 
vn 0.981695 -0.18583 -0.0417413 
vn 0.968225 -0.246602 -0.0415585 
vn 0.992074 -0.118446 -0.0419567 
vn 0.968222 -0.246615 -0.0415585 
vn 0.997852 -0.050108 -0.0421887 
vn 0.940015 -0.338623 -0.0413031 
vn 0.942997 -0.330225 -0.0413253 
vn 0.901377 -0.431083 -0.041074 
vn 0.901372 -0.431094 -0.041074 
vn 0.856021 -0.51532 -0.0408919 
vn 0.855063 -0.516909 -0.0408887 
vn 0.800816 -0.597523 -0.0407422 
vn 0.80081 -0.597531 -0.0407422 
vn 0.740168 -0.671193 -0.0406364 
vn 0.739176 -0.672286 -0.040635 
vn 0.670722 -0.740599 -0.0405673 
vn 0.670716 -0.740604 -0.0405673 
vn 0.596951 -0.801253 -0.0405395 
vn 0.542989 -0.838761 -0.040543 
vn 0.515856 -0.855715 -0.0405513 
vn 0.608829 -0.792265 -0.0405413 
vn 0.515845 -0.855722 -0.0405513 
vn 0.431417 -0.901239 -0.0406024 
vn 0.390269 -0.919804 -0.0406399 
vn 0.341477 -0.939009 -0.0406943 
vn 0.398135 -0.916427 -0.0406322 
vn 0.341475 -0.939009 -0.0406943 
vn 0.471094 -0.881149 -0.0405739 
vn 0.451658 -0.891267 -0.0405869 
vn 0.249128 -0.96761 -0.0408244 
vn 0.159319 -0.986376 -0.0409831 
vn 0.15339 -0.987315 -0.0409947 
vn 0.193275 -0.980291 -0.0409195 
vn 0.153394 -0.987314 -0.0409947 
vn 0.210883 -0.976656 -0.0408882 
vn 0.278143 -0.959674 -0.0407798 
vn 0.260281 -0.96467 -0.0408069 
vn 0.340063 -0.939522 -0.040696 
vn 0.326107 -0.944456 -0.0407135 
vn -0.0421092 -0.998253 -0.0414489 
vn 0.0337391 -0.998579 -0.0412559 
vn 0.0214794 -0.998916 -0.0412856 
vn -0.013493 -0.999053 -0.0413735 
vn -0.0206159 -0.99893 -0.041392 
vn 0.0561567 -0.997571 -0.0412029 
vn 0.090846 -0.995015 -0.0411246 
vn 0.0944968 -0.994676 -0.0411166 
vn 0.0561117 -0.997574 -0.041203 
vn 0.14809 -0.988123 -0.0410051 
vn 0.125124 -0.991291 -0.0410516 
vn -0.238231 -0.970298 -0.0420502 
vn -0.210492 -0.976695 -0.0419558 
vn -0.221913 -0.974162 -0.0419943 
vn -0.144588 -0.988611 -0.0417441 
vn -0.15285 -0.987366 -0.0417697 
vn -0.0809269 -0.995853 -0.041556 
vn -0.0833886 -0.99565 -0.041563 
vn -0.140914 -0.989142 -0.0417329 
vn -0.0421062 -0.998253 -0.0414489 
vn -0.0480602 -0.997983 -0.0414649 
vn -0.427665 -0.902924 -0.0427881 
vn -0.353981 -0.934287 -0.0424807 
vn -0.35771 -0.932865 -0.0424956 
vn -0.279163 -0.959316 -0.0421956 
vn -0.290243 -0.95602 -0.0422362 
vn -0.334986 -0.941268 -0.0424058 
vn -0.23823 -0.970298 -0.0420502 
vn -0.602647 -0.796813 -0.0436463 
vn -0.428913 -0.902331 -0.0427936 
vn -0.457857 -0.887989 -0.0429225 
vn -0.518471 -0.854003 -0.0432084 
vn -0.427671 -0.902921 -0.0427882 
vn -0.53192 -0.845688 -0.043275 
vn -0.683365 -0.728743 -0.0441206 
vn -0.602654 -0.796808 -0.0436463 
vn -0.682201 -0.729832 -0.0441133 
vn -0.755075 -0.65412 -0.0446007 
vn -0.821428 -0.568525 -0.0451138 
vn -0.755082 -0.654112 -0.0446007 
vn -0.820268 -0.570199 -0.0451041 
vn -0.876745 -0.478787 -0.0456182 
vn -0.92451 -0.378353 -0.0461492 
vn -0.876751 -0.478776 -0.0456182 
vn -0.928222 -0.369148 -0.0461963 
vn -0.959778 -0.276857 -0.0466547 
vn -0.985084 -0.165479 -0.0471768 
vn -0.959782 -0.276842 -0.0466548 
vn -0.976758 -0.209135 -0.0469761 
vn -0.989907 -0.133588 -0.0473203 
vn -0.997259 -0.0566015 -0.0476558 
vn -0.99884 -0.00515799 -0.0478715 
vn -0.997256 -0.0566577 -0.0476556 
vn -0.644508 -0.136378 -0.752337 
vn -0.608913 -0.28117 -0.741733 
vn -0.630194 -0.211838 -0.74698 
vn -0.54369 -0.412722 -0.730795 
vn -0.579071 -0.35036 -0.736155 
vn -0.453136 -0.525531 -0.720059 
vn -0.500494 -0.472733 -0.725279 
vn -0.342335 -0.615408 -0.709986 
vn -0.399185 -0.574148 -0.714847 
vn -0.216801 -0.679458 -0.700952 
vn -0.280455 -0.6511 -0.705275 
vn -0.0822025 -0.715992 -0.693252 
vn -0.149894 -0.701331 -0.696898 
vn 0.0558455 -0.724406 -0.687107 
vn -0.0131326 -0.72372 -0.689968 
vn 0.191919 -0.705068 -0.682675 
vn 0.124327 -0.718167 -0.684674 
vn 0.320885 -0.659206 -0.680059 
vn 0.257227 -0.685477 -0.681143 
vn 0.437971 -0.588823 -0.679315 
vn 0.380634 -0.627263 -0.679455 
vn 0.538826 -0.496629 -0.68046 
vn 0.490005 -0.545874 -0.679644 
vn 0.61958 -0.385994 -0.683469 
vn 0.581241 -0.444334 -0.681708 
vn 0.676909 -0.260906 -0.688275 
vn 0.650751 -0.326301 -0.685603 
vn 0.708124 -0.125942 -0.694765 
vn 0.69553 -0.19603 -0.691238 
vn 0.689767 0.137063 -0.71094 
vn 0.689499 0.138047 -0.711009 
vn 0.703587 0.074701 -0.706671 
vn 0.711284 0.013777 -0.70277 
vn 0.713252 -0.0582868 -0.69848 
vn 0.713329 -0.0265487 -0.700327 
vn -0.647383 0.0149385 -0.762019 
vn -0.650125 -0.0631865 -0.757195 
vn -0.650027 -0.0287868 -0.759366 
vn -0.644508 -0.136378 -0.752337 
vn -0.621375 0.148323 -0.769346 
vn -0.637942 0.0810985 -0.765802 
vn -0.647443 0.0142883 -0.76198 
vn -0.621055 0.149384 -0.769399 
vn -0.934233 0.353257 -0.0491719 
vn -0.772623 -0.565309 0.288928 
vn 0.94853 0.313662 -0.0436604 
vn 0.816281 -0.514367 0.262891 
vn -0.719765 0.692418 -0.0499622 
vn 0.776667 0.628278 -0.0453341 
vn -0.45517 0.429715 -0.77985 
vn 0.547084 0.403979 -0.733144 
vn -0.649223 -0.0860885 -0.75571 
vn 0.712378 -0.079433 -0.697286 
vn 0.0581982 -0.081571 -0.994967 
vn 0.583381 0.430781 0.688545 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.50733 -0.529522 -0.67987 
vn 0.695329 -0.717545 -0.0405864 
vn 0.754721 -0.0841544 0.650626 
vn 0.53587 -0.55931 0.632469 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0625271 0.635801 -0.769316 
vn 0.0671426 0.682733 0.727577 
vn 0.0635998 -0.089142 0.993986 
vn -0.489803 0.462411 0.7391 
vn -0.695283 -0.092196 0.712799 
vn -0.994739 -0.0907558 -0.0475089 
vn -0.418262 -0.55814 -0.716615 
vn -0.444655 -0.59336 0.670973 
vn -0.994739 -0.0907558 -0.0475089 
vn -0.631086 -0.774475 -0.0438066 
vn 0.0666126 0.996581 -0.0488745 
vn 0.0996851 -0.0889342 0.991037 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.995874 -0.0803932 -0.0420842 
vn 0.0250136 -0.0817313 -0.99634 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.0725012 -0.0815033 -0.994033 
vn 0.150971 -0.0886306 0.984557 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0479511 -0.0892306 0.994856 
vn 0.0996851 -0.0889342 0.991037 
vn 0.0666126 0.996581 -0.0488745 
vn 0.0479511 -0.0892306 0.994856 
vn 0.995874 -0.0803932 -0.0420842 
vn -0.0226593 -0.0819692 -0.996377 
vn 0.0250136 -0.0817313 -0.99634 
vn 0.0725012 -0.0815033 -0.994033 
vn -0.994739 -0.0907558 -0.0475089 
vn 0.150971 -0.0886306 0.984557 
usemtl 0.647059_0.647059_0.647059_0.000000_0.000000
o mesh19
f 719//639 720//640 721//640 
f 722//641 719//639 723//642 
f 724//643 722//641 725//644 
f 726//645 724//643 727//646 
f 728//647 726//645 729//648 
f 730//649 728//647 731//650 
f 732//651 730//649 733//652 
f 734//653 732//651 735//654 
f 736//655 734//653 737//656 
f 738//657 736//655 739//658 
f 740//659 738//657 741//660 
f 742//661 740//659 743//662 
f 744//663 742//661 745//664 
f 746//665 744//663 747//666 
f 748//667 746//665 749//668 
f 750//669 748//667 751//670 
f 752//671 750//669 753//672 
f 754//673 752//671 755//674 
f 756//675 754//673 757//676 
f 758//677 756//675 759//678 
f 760//679 758//677 761//680 
f 762//681 760//679 763//682 
f 764//683 762//681 765//684 
f 766//685 764//683 767//686 
f 768//687 766//685 769//688 
f 770//689 768//687 771//690 
f 772//691 770//689 773//692 
f 774//693 772//691 775//694 
f 720//640 774//693 776//693 
f 776//693 721//640 720//640 
f 775//694 776//693 774//693 
f 773//692 775//694 772//691 
f 771//690 773//692 770//689 
f 769//688 771//690 768//687 
f 767//686 769//688 766//685 
f 765//684 767//686 764//683 
f 763//682 765//684 762//681 
f 761//680 763//682 760//679 
f 759//678 761//680 758//677 
f 757//676 759//678 756//675 
f 755//674 757//676 754//673 
f 753//672 755//674 752//671 
f 751//670 753//672 750//669 
f 749//668 751//670 748//667 
f 747//666 749//668 746//665 
f 745//664 747//666 744//663 
f 743//662 745//664 742//661 
f 741//660 743//662 740//659 
f 739//658 741//660 738//657 
f 737//656 739//658 736//655 
f 735//654 737//656 734//653 
f 733//652 735//654 732//651 
f 731//650 733//652 730//649 
f 729//648 731//650 728//647 
f 727//646 729//648 726//645 
f 725//644 727//646 724//643 
f 723//642 725//644 722//641 
f 721//640 723//642 719//639 
o mesh20
f 758//695 760//695 777//695 
f 778//695 756//695 758//695 
f 777//695 778//695 758//695 
f 778//695 779//695 756//695 
f 780//695 781//695 752//695 
f 782//695 777//695 760//695 
f 780//695 754//695 756//695 
f 781//695 750//695 752//695 
f 750//695 781//695 783//695 
f 748//695 783//695 784//695 
f 770//695 785//695 786//695 
f 768//695 787//695 788//695 
f 760//695 762//695 782//695 
f 789//695 790//695 791//695 
f 790//695 792//695 793//695 
f 790//695 781//695 794//695 
f 781//695 780//695 795//695 
f 752//695 754//695 780//695 
f 784//695 746//695 748//695 
f 744//695 784//695 796//695 
f 742//695 796//695 797//695 
f 786//695 768//695 770//695 
f 768//695 786//695 787//695 
f 766//695 788//695 798//695 
f 764//695 798//695 782//695 
f 790//695 799//695 791//695 
f 791//695 800//695 801//695 
f 794//695 792//695 790//695 
f 779//695 780//695 756//695 
f 784//695 744//695 746//695 
f 797//695 740//695 742//695 
f 788//695 766//695 768//695 
f 762//695 764//695 782//695 
f 785//695 802//695 803//695 
f 785//695 804//695 805//695 
f 801//695 806//695 791//695 
f 793//695 807//695 790//695 
f 783//695 748//695 750//695 
f 797//695 738//695 740//695 
f 808//695 809//695 810//695 
f 798//695 764//695 766//695 
f 805//695 802//695 785//695 
f 807//695 799//695 790//695 
f 796//695 742//695 744//695 
f 800//695 811//695 812//695 
f 813//695 814//695 815//695 
f 809//695 816//695 810//695 
f 817//695 818//695 819//695 
f 803//695 786//695 785//695 
f 795//695 794//695 781//695 
f 797//695 820//695 736//695 
f 812//695 821//695 822//695 
f 823//695 824//695 825//695 
f 815//695 826//695 827//695 
f 808//695 828//695 826//695 
f 809//695 829//695 816//695 
f 830//695 831//695 832//695 
f 819//695 833//695 817//695 
f 789//695 817//695 834//695 
f 791//695 806//695 789//695 
f 820//695 734//695 736//695 
f 812//695 835//695 821//695 
f 825//695 836//695 823//695 
f 824//695 823//695 837//695 
f 826//695 815//695 808//695 
f 810//695 838//695 808//695 
f 839//695 840//695 829//695 
f 832//695 841//695 830//695 
f 818//695 830//695 841//695 
f 834//695 790//695 789//695 
f 736//695 738//695 797//695 
f 800//695 842//695 811//695 
f 843//695 844//695 845//695 
f 844//695 846//695 847//695 
f 837//695 848//695 824//695 
f 838//695 828//695 808//695 
f 839//695 849//695 840//695 
f 850//695 849//695 839//695 
f 851//695 850//695 852//695 
f 841//695 819//695 818//695 
f 770//695 772//695 785//695 
f 800//695 791//695 842//695 
f 812//695 853//695 854//695 
f 805//695 804//695 843//695 
f 846//695 855//695 847//695 
f 836//695 856//695 855//695 
f 836//695 857//695 823//695 
f 858//695 730//695 732//695 
f 858//695 859//695 726//695 
f 829//695 809//695 839//695 
f 852//695 832//695 851//695 
f 833//695 834//695 817//695 
f 854//695 835//695 812//695 
f 847//695 845//695 844//695 
f 825//695 856//695 836//695 
f 732//695 820//695 858//695 
f 726//695 728//695 858//695 
f 722//695 724//695 859//695 
f 839//695 852//695 850//695 
f 812//695 822//695 800//695 
f 855//695 846//695 836//695 
f 848//695 837//695 853//695 
f 728//695 730//695 858//695 
f 860//695 719//695 722//695 
f 720//695 719//695 860//695 
f 772//695 774//695 861//695 
f 831//695 851//695 832//695 
f 853//695 812//695 848//695 
f 859//695 724//695 726//695 
f 860//695 862//695 720//695 
f 774//695 720//695 862//695 
f 861//695 863//695 772//695 
f 845//695 805//695 843//695 
f 859//695 860//695 722//695 
f 857//695 836//695 814//695 
f 863//695 785//695 772//695 
f 732//695 734//695 820//695 
f 814//695 813//695 864//695 
f 815//695 827//695 813//695 
f 862//695 861//695 774//695 
f 814//695 864//695 857//695 
o mesh21
f 802//696 805//697 865//697 
f 803//698 802//696 866//699 
f 786//700 803//698 867//701 
f 787//702 786//700 868//703 
f 788//704 787//702 869//705 
f 798//706 788//704 870//707 
f 782//708 798//706 871//709 
f 777//710 782//708 872//711 
f 778//712 777//710 873//713 
f 779//714 778//712 874//715 
f 780//716 779//714 875//717 
f 795//718 780//716 876//719 
f 794//720 795//718 877//721 
f 792//722 794//720 878//723 
f 793//724 792//722 879//725 
f 807//726 793//724 880//727 
f 799//728 807//726 881//729 
f 791//730 799//728 882//731 
f 842//732 791//730 883//733 
f 811//734 842//732 884//735 
f 812//736 811//734 885//737 
f 848//738 812//736 886//739 
f 824//740 848//738 887//741 
f 825//742 824//740 888//743 
f 856//744 825//742 889//745 
f 855//746 856//744 890//747 
f 847//748 855//746 891//749 
f 845//750 847//748 892//751 
f 805//697 845//750 893//750 
f 893//750 865//697 805//697 
f 892//751 893//750 845//750 
f 891//749 892//751 847//748 
f 890//747 891//749 855//746 
f 889//745 890//747 856//744 
f 888//743 889//745 825//742 
f 887//741 888//743 824//740 
f 886//739 887//741 848//738 
f 885//737 886//739 812//736 
f 884//735 885//737 811//734 
f 883//733 884//735 842//732 
f 882//731 883//733 791//730 
f 881//729 882//731 799//728 
f 880//727 881//729 807//726 
f 879//725 880//727 793//724 
f 878//723 879//725 792//722 
f 877//721 878//723 794//720 
f 876//719 877//721 795//718 
f 875//717 876//719 780//716 
f 874//715 875//717 779//714 
f 873//713 874//715 778//712 
f 872//711 873//713 777//710 
f 871//709 872//711 782//708 
f 870//707 871//709 798//706 
f 869//705 870//707 788//704 
f 868//703 869//705 787//702 
f 867//701 868//703 786//700 
f 866//699 867//701 803//698 
f 865//697 866//699 802//696 
o mesh22
f 823//752 857//753 894//753 
f 837//754 823//752 895//755 
f 853//756 837//754 896//757 
f 854//758 853//756 897//759 
f 835//760 854//758 898//761 
f 821//762 835//760 899//763 
f 822//764 821//762 900//765 
f 800//766 822//764 901//767 
f 801//768 800//766 902//769 
f 806//770 801//768 903//771 
f 789//772 806//770 904//773 
f 817//774 789//772 905//775 
f 818//776 817//774 906//777 
f 830//778 818//776 907//779 
f 831//780 830//778 908//781 
f 851//782 831//780 909//783 
f 850//784 851//782 910//785 
f 849//786 850//784 911//787 
f 840//788 849//786 912//789 
f 829//790 840//788 913//791 
f 816//792 829//790 914//793 
f 810//794 816//792 915//795 
f 838//796 810//794 916//797 
f 828//798 838//796 917//799 
f 826//800 828//798 918//801 
f 827//802 826//800 919//803 
f 813//804 827//802 920//805 
f 864//806 813//804 921//807 
f 857//753 864//806 922//806 
f 922//806 894//753 857//753 
f 921//807 922//806 864//806 
f 920//805 921//807 813//804 
f 919//803 920//805 827//802 
f 918//801 919//803 826//800 
f 917//799 918//801 828//798 
f 916//797 917//799 838//796 
f 915//795 916//797 810//794 
f 914//793 915//795 816//792 
f 913//791 914//793 829//790 
f 912//789 913//791 840//788 
f 911//787 912//789 849//786 
f 910//785 911//787 850//784 
f 909//783 910//785 851//782 
f 908//781 909//783 831//780 
f 907//779 908//781 830//778 
f 906//777 907//779 818//776 
f 905//775 906//777 817//774 
f 904//773 905//775 789//772 
f 903//771 904//773 806//770 
f 902//769 903//771 801//768 
f 901//767 902//769 800//766 
f 900//765 901//767 822//764 
f 899//763 900//765 821//762 
f 898//761 899//763 835//760 
f 897//759 898//761 854//758 
f 896//757 897//759 853//756 
f 895//755 896//757 837//754 
f 894//753 895//755 823//752 
o mesh23
f 859//808 923//809 924//810 
f 859//808 925//811 923//809 
f 859//808 858//812 926//813 
f 926//813 925//811 859//808 
f 860//814 927//815 928//816 
f 860//814 859//808 929//817 
f 929//817 927//815 860//814 
f 928//816 930//818 860//814 
f 862//819 931//820 932//821 
f 932//821 933//822 862//819 
f 862//819 860//814 934//823 
f 934//823 935//824 862//819 
f 935//824 931//820 862//819 
f 936//825 861//826 937//827 
f 861//826 862//819 938//828 
f 938//828 937//827 861//826 
f 937//827 939//829 936//825 
f 861//826 940//830 941//831 
f 941//831 863//832 861//826 
f 863//832 942//833 943//834 
f 943//834 785//835 863//832 
f 804//836 785//835 944//837 
f 804//836 945//836 946//838 
f 946//838 843//839 804//836 
f 844//840 843//839 947//841 
f 843//839 946//838 947//841 
f 846//842 844//840 948//843 
f 844//840 949//844 948//843 
f 846//842 950//845 951//846 
f 950//845 952//847 951//846 
f 846//842 953//848 950//845 
f 836//849 954//850 955//851 
f 836//849 956//852 954//850 
f 836//849 957//853 958//854 
f 836//849 951//846 957//853 
f 958//854 956//852 836//849 
f 814//855 959//856 960//857 
f 814//855 961//858 959//856 
f 814//855 962//859 963//860 
f 963//860 961//858 814//855 
f 814//855 955//851 962//859 
f 815//861 964//862 965//863 
f 815//861 960//857 966//864 
f 966//864 964//862 815//861 
f 808//865 967//866 968//867 
f 808//865 965//863 969//868 
f 969//868 970//869 808//865 
f 970//869 967//866 808//865 
f 809//870 971//871 972//872 
f 809//870 973//873 971//871 
f 809//870 968//867 973//873 
f 839//874 974//875 975//876 
f 839//874 976//877 977//878 
f 839//874 972//872 976//877 
f 977//878 974//875 839//874 
f 852//879 978//880 979//881 
f 852//879 980//882 981//883 
f 852//879 975//876 980//882 
f 981//883 978//880 852//879 
f 832//884 982//885 983//886 
f 832//884 979//881 984//887 
f 984//887 985//888 832//884 
f 985//888 982//885 832//884 
f 841//889 986//890 987//891 
f 841//889 988//892 989//893 
f 841//889 983//886 990//894 
f 990//894 988//892 841//889 
f 989//893 986//890 841//889 
f 819//895 991//896 992//897 
f 819//895 993//898 994//899 
f 819//895 987//891 995//900 
f 995//900 993//898 819//895 
f 994//899 991//896 819//895 
f 834//901 833//902 996//903 
f 833//902 997//904 996//903 
f 833//902 998//905 999//906 
f 833//902 1000//907 998//905 
f 833//902 992//897 1001//908 
f 1001//908 1000//907 833//902 
f 999//906 997//904 833//902 
f 790//909 1002//910 1003//911 
f 790//909 1004//912 1005//913 
f 1005//913 1006//914 790//909 
f 1006//914 1002//910 790//909 
f 834//901 1007//915 1008//916 
f 1008//916 790//909 834//901 
f 1008//916 1004//912 790//909 
f 781//917 1009//918 1010//919 
f 1010//919 1011//920 781//917 
f 781//917 1012//921 1013//922 
f 1013//922 1009//918 781//917 
f 781//917 790//909 1014//923 
f 1014//923 1012//921 781//917 
f 783//924 1015//925 1016//926 
f 1016//926 1017//927 783//924 
f 783//924 781//917 1018//928 
f 1018//928 1019//929 783//924 
f 1019//929 1015//925 783//924 
f 784//930 1020//931 1021//932 
f 1021//932 1022//933 784//930 
f 784//930 783//924 1023//934 
f 1023//934 1020//931 784//930 
f 796//935 784//930 1024//936 
f 1024//936 1025//937 796//935 
f 1025//937 1026//938 796//935 
f 797//939 1027//940 1028//941 
f 1028//941 1029//942 797//939 
f 797//939 796//935 1030//943 
f 1030//943 1027//940 797//939 
f 820//944 1031//945 1032//946 
f 820//944 797//939 1033//947 
f 1033//947 1034//948 820//944 
f 1034//948 1031//945 820//944 
f 858//812 1035//949 1036//950 
f 858//812 820//944 1037//951 
f 1037//951 1035//949 858//812 
f 1036//950 926//813 858//812 
f 1032//946 1037//951 820//944 
f 1029//942 1033//947 797//939 
f 1026//938 1030//943 796//935 
f 1022//933 1024//936 784//930 
f 1017//927 1023//934 783//924 
f 1011//920 1018//928 781//917 
f 1003//911 1014//923 790//909 
f 996//903 1007//915 834//901 
f 992//897 833//902 819//895 
f 987//891 819//895 841//889 
f 983//886 841//889 832//884 
f 979//881 832//884 852//879 
f 975//876 852//879 839//874 
f 972//872 839//874 809//870 
f 968//867 809//870 808//865 
f 965//863 808//865 815//861 
f 960//857 815//861 814//855 
f 955//851 814//855 836//849 
f 951//846 836//849 846//842 
f 948//843 953//848 846//842 
f 947//841 949//844 844//840 
f 944//837 945//836 804//836 
f 943//834 944//837 785//835 
f 941//831 942//833 863//832 
f 936//825 940//830 861//826 
f 933//822 938//828 862//819 
f 930//818 934//823 860//814 
f 924//810 929//817 859//808 
o mesh24
f 961//952 963//953 1038//954 
f 963//953 1039//955 1038//954 
f 1038//954 1040//956 961//952 
f 956//957 958//958 1041//959 
f 958//958 1042//960 1041//959 
f 1041//959 1043//961 956//957 
f 954//962 1043//961 1044//963 
f 1039//955 962//964 955//965 
f 955//965 1044//963 1039//955 
f 1044//963 955//965 954//962 
f 1040//956 1045//966 959//967 
f 1045//966 1046//968 966//969 
f 966//969 960//970 1045//966 
f 964//971 966//969 1046//968 
f 1046//968 1047//972 964//971 
f 960//970 959//967 1045//966 
f 952//973 1048//974 1049//975 
f 1042//960 957//976 951//977 
f 951//977 1049//975 1042//960 
f 1047//972 1050//978 969//979 
f 969//979 965//980 1047//972 
f 1050//978 1051//981 970//982 
f 1051//981 967//983 970//982 
f 970//982 969//979 1050//978 
f 965//980 964//971 1047//972 
f 1049//975 951//977 952//973 
f 959//967 961//952 1040//956 
f 954//962 956//957 1043//961 
f 958//958 957//976 1042//960 
f 963//953 962//964 1039//955 
o mesh25
f 1052//984 1053//985 924//986 
f 923//987 1054//988 1052//984 
f 924//986 923//987 1052//984 
f 927//989 929//990 1053//985 
f 1053//985 1055//991 927//989 
f 929//990 924//986 1053//985 
f 1056//992 935//993 934//994 
f 934//994 1057//995 1056//992 
f 931//996 935//993 1056//992 
f 1056//992 1058//997 931//996 
f 1058//997 1059//998 932//999 
f 933//1000 932//999 1059//998 
f 1059//998 1060//1001 933//1000 
f 1055//991 1061//1002 928//1003 
f 930//1004 928//1003 1061//1002 
f 1061//1002 1057//995 930//1004 
f 1035//1005 1062//1006 1063//1007 
f 1064//1008 926//1009 1036//1010 
f 1054//988 925//1011 926//1009 
f 926//1009 1064//1008 1054//988 
f 1036//1010 1063//1007 1064//1008 
f 1065//1012 937//1013 938//1014 
f 938//1014 1060//1001 1065//1012 
f 1065//1012 939//1015 937//1013 
f 938//1014 933//1000 1060//1001 
f 1063//1007 1036//1010 1035//1005 
f 928//1003 927//989 1055//991 
f 932//999 931//996 1058//997 
f 934//994 930//1004 1057//995 
f 923//987 925//1011 1054//988 
o mesh26
f 1066//1016 941//1016 940//1017 
f 940//1017 1067//1018 1066//1016 
f 1068//1019 943//1019 942//1020 
f 942//1020 1066//1016 1068//1019 
f 1069//1021 945//1021 944//1022 
f 944//1022 1068//1019 1069//1021 
f 1069//1021 1070//1023 946//1024 
f 1070//1023 947//1023 946//1024 
f 1070//1023 1071//1025 949//1026 
f 1071//1025 948//1025 949//1026 
f 1071//1025 1072//1027 953//1028 
f 1072//1027 950//1027 953//1028 
f 1067//1018 939//1029 1065//1030 
f 1067//1018 936//1031 939//1029 
f 1072//1027 1073//1032 1048//1033 
f 1048//1033 952//1034 1072//1027 
f 952//1034 950//1027 1072//1027 
f 1065//1030 1074//1035 1067//1018 
f 953//1028 948//1025 1071//1025 
f 949//1026 947//1023 1070//1023 
f 946//1024 945//1021 1069//1021 
f 944//1022 943//1019 1068//1019 
f 942//1020 941//1016 1066//1016 
f 940//1017 936//1031 1067//1018 
o mesh27
f 1075//1036 1076//1037 1022//1038 
f 1025//1039 1024//1040 1076//1037 
f 1076//1037 1077//1041 1025//1039 
f 1024//1040 1022//1038 1076//1037 
f 1078//1042 1079//1043 1030//1044 
f 1026//1045 1077//1041 1078//1042 
f 1079//1043 1027//1046 1030//1044 
f 1028//1047 1027//1046 1079//1043 
f 1079//1043 1080//1048 1028//1047 
f 1030//1044 1026//1045 1078//1042 
f 1080//1048 1081//1049 1029//1050 
f 1082//1051 1034//1052 1033//1053 
f 1033//1053 1081//1049 1082//1051 
f 1033//1053 1029//1050 1081//1049 
f 1083//1054 1084//1055 1032//1056 
f 1031//1057 1082//1051 1083//1054 
f 1084//1055 1035//1058 1037//1059 
f 1037//1059 1032//1056 1084//1055 
f 1032//1056 1031//1057 1083//1054 
f 1084//1055 1062//1060 1035//1058 
f 973//1061 968//1062 1085//1063 
f 968//1062 1086//1064 1085//1063 
f 1085//1063 1087//1065 973//1061 
f 1087//1065 971//1066 973//1061 
f 967//1067 1051//1068 1086//1064 
f 971//1066 1087//1065 1088//1069 
f 1088//1069 976//1070 972//1071 
f 1089//1072 977//1073 976//1070 
f 976//1070 1088//1069 1089//1072 
f 1089//1072 1090//1074 977//1073 
f 1091//1075 975//1076 974//1077 
f 1091//1075 1092//1078 980//1079 
f 980//1079 975//1076 1091//1075 
f 974//1077 1090//1074 1091//1075 
f 1092//1078 981//1080 980//1079 
f 1093//1081 1094//1082 978//1083 
f 981//1080 1092//1078 1093//1081 
f 984//1084 979//1085 1094//1082 
f 1094//1082 1095//1086 984//1084 
f 979//1085 978//1083 1094//1082 
f 985//1087 1096//1088 1097//1089 
f 985//1087 1095//1086 1096//1088 
f 1097//1089 982//1090 985//1087 
f 1097//1089 1098//1091 982//1090 
f 1099//1092 990//1093 983//1094 
f 983//1094 1098//1091 1099//1092 
f 983//1094 982//1090 1098//1091 
f 990//1093 1099//1092 1100//1095 
f 1101//1096 989//1097 988//1098 
f 988//1098 1100//1095 1101//1096 
f 1102//1099 1103//1100 986//1101 
f 989//1097 1101//1096 1102//1099 
f 995//1102 987//1103 1103//1100 
f 1103//1100 1104//1104 995//1102 
f 987//1103 986//1101 1103//1100 
f 995//1102 1104//1104 1105//1105 
f 1106//1106 994//1107 993//1108 
f 993//1108 1105//1105 1106//1106 
f 994//1107 1106//1106 1107//1109 
f 1108//1110 992//1111 991//1112 
f 1108//1110 1001//1113 992//1111 
f 991//1112 1107//1109 1108//1110 
f 1109//1114 1110//1115 1000//1116 
f 1001//1113 1108//1110 1109//1114 
f 1110//1115 998//1117 1000//1116 
f 998//1117 1111//1118 1112//1119 
f 1112//1119 999//1120 998//1117 
f 998//1117 1110//1115 1111//1118 
f 1113//1121 996//1122 997//1123 
f 997//1123 1114//1124 1113//1121 
f 1007//1125 996//1122 1115//1126 
f 996//1122 1113//1121 1115//1126 
f 1116//1127 1008//1128 1007//1125 
f 1117//1129 1118//1130 1004//1131 
f 1008//1128 1116//1127 1117//1129 
f 1118//1130 1005//1132 1004//1131 
f 1005//1132 1118//1130 1119//1133 
f 1119//1133 1006//1134 1005//1132 
f 1119//1133 1120//1135 1006//1134 
f 1121//1136 1003//1137 1002//1138 
f 1002//1138 1122//1139 1121//1136 
f 1014//1140 1003//1137 1121//1136 
f 1123//1141 1012//1142 1014//1140 
f 1124//1143 1013//1144 1012//1142 
f 1012//1142 1123//1141 1124//1143 
f 1013//1144 1124//1143 1125//1145 
f 1126//1146 1010//1147 1009//1148 
f 1009//1148 1125//1145 1126//1146 
f 1010//1147 1126//1146 1127//1149 
f 1127//1149 1011//1150 1010//1147 
f 1128//1151 1019//1152 1018//1153 
f 1018//1153 1129//1154 1128//1151 
f 1018//1153 1011//1150 1129//1154 
f 1019//1152 1128//1151 1130//1155 
f 1131//1156 1016//1157 1015//1158 
f 1015//1158 1130//1155 1131//1156 
f 1016//1157 1131//1156 1132//1159 
f 1020//1160 1023//1161 1133//1162 
f 1132//1159 1133//1162 1023//1161 
f 1023//1161 1017//1163 1132//1159 
f 1134//1164 1021//1165 1020//1160 
f 1020//1160 1135//1166 1134//1164 
f 1134//1164 1075//1036 1021//1165 
f 1133//1162 1135//1166 1020//1160 
f 1132//1159 1017//1163 1016//1157 
f 1130//1155 1015//1158 1019//1152 
f 1127//1149 1129//1154 1011//1150 
f 1125//1145 1009//1148 1013//1144 
f 1121//1136 1123//1141 1014//1140 
f 1002//1138 1006//1134 1122//1139 
f 1120//1135 1122//1139 1006//1134 
f 1004//1131 1008//1128 1117//1129 
f 1007//1125 1136//1167 1116//1127 
f 1115//1126 1136//1167 1007//1125 
f 997//1123 999//1120 1114//1124 
f 1112//1119 1114//1124 999//1120 
f 1000//1116 1001//1113 1109//1114 
f 1107//1109 991//1112 994//1107 
f 1105//1105 993//1108 995//1102 
f 986//1101 989//1097 1102//1099 
f 1100//1095 988//1098 990//1093 
f 985//1087 984//1084 1095//1086 
f 978//1083 981//1080 1093//1081 
f 974//1077 977//1073 1090//1074 
f 1088//1069 972//1071 971//1066 
f 968//1062 967//1067 1086//1064 
f 1031//1057 1034//1052 1082//1051 
f 1029//1050 1028//1047 1080//1048 
f 1026//1045 1025//1039 1077//1041 
f 1022//1038 1021//1165 1075//1036 
o mesh28
f 1137//1168 1138//1168 1082//1168 
f 1139//1168 1137//1168 1081//1168 
f 1138//1168 1083//1168 1082//1168 
f 1140//1168 1084//1168 1083//1168 
f 1081//1168 1080//1168 1139//1168 
f 1083//1168 1138//1168 1140//1168 
f 1076//1168 1075//1168 1141//1168 
f 1142//1168 1078//1168 1077//1168 
f 1079//1168 1078//1168 1142//1168 
f 1082//1168 1081//1168 1137//1168 
f 1141//1168 1143//1168 1076//1168 
f 1077//1168 1143//1168 1142//1168 
f 1080//1168 1079//1168 1139//1168 
f 1075//1168 1134//1168 1141//1168 
f 1142//1168 1139//1168 1079//1168 
f 1077//1168 1076//1168 1143//1168 
f 1134//1168 1135//1168 1141//1168 
o mesh29
f 1144//1168 1087//1168 1085//1168 
f 1144//1168 1088//1168 1087//1168 
f 1145//1168 1146//1168 1089//1168 
f 1085//1168 1147//1168 1144//1168 
f 1088//1168 1144//1168 1145//1168 
f 1146//1168 1148//1168 1091//1168 
f 1089//1168 1088//1168 1145//1168 
f 1091//1168 1090//1168 1146//1168 
f 1148//1168 1149//1168 1093//1168 
f 1090//1168 1089//1168 1146//1168 
f 1093//1168 1092//1168 1148//1168 
f 1092//1168 1091//1168 1148//1168 
f 1149//1168 1150//1168 1094//1168 
f 1094//1168 1093//1168 1149//1168 
f 1150//1168 1096//1168 1095//1168 
f 1095//1168 1094//1168 1150//1168 
f 1085//1168 1086//1168 1147//1168 
o mesh30
f 1151//1169 1152//1169 1050//1169 
f 1050//1169 1047//1169 1151//1169 
f 1051//1169 1050//1169 1152//1169 
f 1151//1169 1040//1169 1038//1169 
f 1152//1169 1147//1169 1051//1169 
f 1151//1169 1045//1169 1040//1169 
f 1047//1169 1046//1169 1151//1169 
f 1046//1169 1045//1169 1151//1169 
f 1153//1169 1038//1169 1039//1169 
f 1147//1169 1086//1169 1051//1169 
f 1049//1169 1048//1169 1073//1169 
f 1153//1169 1041//1169 1042//1169 
f 1153//1169 1044//1169 1043//1169 
f 1038//1169 1153//1169 1151//1169 
f 1042//1169 1049//1169 1153//1169 
f 1039//1169 1044//1169 1153//1169 
f 1043//1169 1041//1169 1153//1169 
f 1073//1169 1153//1169 1049//1169 
o mesh31
f 1140//1169 1154//1169 1063//1169 
f 1064//1169 1063//1169 1154//1169 
f 1154//1169 1155//1169 1064//1169 
f 1063//1169 1062//1169 1140//1169 
f 1155//1169 1052//1169 1054//1169 
f 1054//1169 1064//1169 1155//1169 
f 1156//1169 1061//1169 1055//1169 
f 1155//1169 1053//1169 1052//1169 
f 1055//1169 1155//1169 1156//1169 
f 1055//1169 1053//1169 1155//1169 
f 1156//1169 1056//1169 1057//1169 
f 1057//1169 1061//1169 1156//1169 
f 1156//1169 1059//1169 1058//1169 
f 1060//1169 1156//1169 1074//1169 
f 1058//1169 1056//1169 1156//1169 
f 1074//1169 1065//1169 1060//1169 
f 1060//1169 1059//1169 1156//1169 
f 1062//1169 1084//1169 1140//1169 
o mesh32
f 1157//1170 1158//1170 1159//1171 
f 1160//1172 1155//1173 1154//1174 
f 1160//1172 1161//1175 1155//1173 
f 1154//1174 1162//1176 1160//1172 
f 1163//1177 1159//1171 1161//1175 
f 1164//1178 1140//1179 1138//1180 
f 1138//1180 1165//1181 1164//1178 
f 1162//1176 1154//1174 1140//1179 
f 1166//1182 1137//1183 1139//1184 
f 1139//1184 1167//1185 1166//1182 
f 1165//1181 1138//1180 1137//1183 
f 1168//1186 1142//1187 1143//1188 
f 1143//1188 1169//1189 1168//1186 
f 1167//1185 1139//1184 1142//1187 
f 1170//1190 1135//1191 1133//1192 
f 1170//1190 1141//1193 1135//1191 
f 1133//1192 1171//1194 1170//1190 
f 1169//1189 1143//1188 1141//1193 
f 1172//1195 1128//1196 1129//1197 
f 1172//1195 1130//1198 1128//1196 
f 1129//1197 1173//1199 1172//1195 
f 1171//1194 1132//1200 1131//1201 
f 1171//1194 1133//1192 1132//1200 
f 1131//1201 1130//1198 1171//1194 
f 1174//1202 1122//1203 1120//1204 
f 1174//1202 1121//1205 1122//1203 
f 1120//1204 1175//1206 1174//1202 
f 1173//1199 1123//1207 1121//1205 
f 1173//1199 1125//1208 1124//1209 
f 1173//1199 1129//1197 1127//1210 
f 1127//1210 1126//1211 1173//1199 
f 1126//1211 1125//1208 1173//1199 
f 1124//1209 1123//1207 1173//1199 
f 1176//1212 1115//1213 1113//1214 
f 1113//1214 1114//1215 1176//1212 
f 1114//1215 1112//1216 1176//1212 
f 1177//1217 1175//1206 1116//1218 
f 1175//1206 1117//1219 1116//1218 
f 1177//1217 1136//1220 1115//1213 
f 1115//1213 1176//1212 1177//1217 
f 1175//1206 1119//1221 1118//1222 
f 1175//1206 1120//1204 1119//1221 
f 1118//1222 1117//1219 1175//1206 
f 1116//1218 1136//1220 1177//1217 
f 1178//1223 1105//1224 1104//1225 
f 1178//1223 1107//1226 1106//1227 
f 1106//1227 1105//1224 1178//1223 
f 1178//1223 1109//1228 1108//1229 
f 1108//1229 1107//1226 1178//1223 
f 1179//1230 1176//1212 1111//1231 
f 1110//1232 1178//1223 1179//1230 
f 1111//1231 1110//1232 1179//1230 
f 1110//1232 1109//1228 1178//1223 
f 1180//1233 1100//1234 1099//1235 
f 1180//1233 1102//1236 1101//1237 
f 1101//1237 1100//1234 1180//1233 
f 1181//1238 1178//1223 1103//1239 
f 1102//1236 1180//1233 1181//1238 
f 1103//1239 1102//1236 1181//1238 
f 1182//1240 1097//1241 1096//1242 
f 1183//1243 1180//1233 1098//1244 
f 1097//1241 1182//1240 1183//1243 
f 1098//1244 1097//1241 1183//1243 
f 1096//1242 1150//1245 1182//1240 
f 1184//1246 1182//1240 1149//1247 
f 1148//1248 1185//1249 1184//1246 
f 1149//1247 1148//1248 1184//1246 
f 1186//1250 1185//1249 1146//1251 
f 1145//1252 1187//1253 1186//1250 
f 1146//1251 1145//1252 1186//1250 
f 1188//1254 1187//1253 1144//1255 
f 1147//1256 1189//1257 1188//1254 
f 1144//1255 1147//1256 1188//1254 
f 1190//1258 1189//1257 1152//1259 
f 1152//1259 1151//1260 1190//1258 
f 1191//1261 1192//1262 1190//1258 
f 1151//1260 1191//1261 1190//1258 
f 1193//1263 1192//1262 1194//1264 
f 1194//1264 1195//1263 1193//1263 
f 1191//1261 1194//1264 1192//1262 
f 1147//1256 1152//1259 1189//1257 
f 1145//1252 1144//1255 1187//1253 
f 1148//1248 1146//1251 1185//1249 
f 1150//1245 1149//1247 1182//1240 
f 1099//1235 1098//1244 1180//1233 
f 1104//1225 1103//1239 1178//1223 
f 1112//1216 1111//1231 1176//1212 
f 1174//1202 1173//1199 1121//1205 
f 1172//1195 1171//1194 1130//1198 
f 1170//1190 1169//1189 1141//1193 
f 1168//1186 1167//1185 1142//1187 
f 1166//1182 1165//1181 1137//1183 
f 1164//1178 1162//1176 1140//1179 
f 1160//1172 1163//1177 1161//1175 
f 1159//1171 1163//1177 1157//1170 
o mesh33
f 1196//1265 1197//1266 1189//1267 
f 1197//1266 1188//1266 1189//1267 
f 1197//1266 1198//1268 1187//1269 
f 1198//1268 1186//1268 1187//1269 
f 1198//1268 1199//1270 1185//1271 
f 1199//1270 1184//1270 1185//1271 
f 1199//1270 1200//1272 1182//1273 
f 1200//1272 1183//1272 1182//1273 
f 1200//1272 1201//1274 1180//1275 
f 1201//1274 1181//1274 1180//1275 
f 1201//1274 1202//1276 1178//1277 
f 1202//1276 1179//1276 1178//1277 
f 1202//1276 1203//1278 1176//1279 
f 1203//1278 1177//1278 1176//1279 
f 1204//1280 1174//1280 1175//1281 
f 1175//1281 1203//1278 1204//1280 
f 1205//1282 1172//1282 1173//1283 
f 1173//1283 1204//1280 1205//1282 
f 1206//1284 1170//1284 1171//1285 
f 1171//1285 1205//1282 1206//1284 
f 1207//1286 1168//1286 1169//1287 
f 1169//1287 1206//1284 1207//1286 
f 1208//1288 1166//1288 1167//1289 
f 1167//1289 1207//1286 1208//1288 
f 1209//1290 1164//1290 1165//1291 
f 1165//1291 1208//1288 1209//1290 
f 1210//1292 1160//1292 1162//1293 
f 1162//1293 1209//1290 1210//1292 
f 1211//1294 1212//1295 1213//1296 
f 1213//1296 1214//1297 1211//1294 
f 1210//1292 1214//1297 1163//1298 
f 1214//1297 1215//1297 1157//1299 
f 1157//1299 1163//1298 1214//1297 
f 1216//1300 1192//1301 1193//1302 
f 1196//1265 1190//1303 1192//1301 
f 1192//1301 1216//1300 1196//1265 
f 1217//1304 1216//1300 1218//1305 
f 1216//1300 1219//1306 1218//1305 
f 1218//1305 1220//1307 1217//1304 
f 1193//1302 1219//1306 1216//1300 
f 1163//1298 1160//1292 1210//1292 
f 1213//1296 1215//1297 1214//1297 
f 1162//1293 1164//1290 1209//1290 
f 1165//1291 1166//1288 1208//1288 
f 1167//1289 1168//1286 1207//1286 
f 1169//1287 1170//1284 1206//1284 
f 1171//1285 1172//1282 1205//1282 
f 1173//1283 1174//1280 1204//1280 
f 1175//1281 1177//1278 1203//1278 
f 1176//1279 1179//1276 1202//1276 
f 1178//1277 1181//1274 1201//1274 
f 1180//1275 1183//1272 1200//1272 
f 1182//1273 1184//1270 1199//1270 
f 1185//1271 1186//1268 1198//1268 
f 1187//1269 1188//1266 1197//1266 
f 1189//1267 1190//1303 1196//1265 
o mesh34
f 1221//1308 1222//1308 1220//1308 
f 1219//1308 1193//1308 1195//1308 
f 1220//1308 1218//1308 1221//1308 
f 1218//1308 1219//1308 1221//1308 
f 1195//1308 1221//1308 1219//1308 
o mesh35
f 1153//1309 1221//1309 1195//1309 
f 1153//1309 1223//1309 1224//1309 
f 1153//1309 1194//1309 1191//1309 
f 1224//1309 1221//1309 1153//1309 
f 1195//1309 1194//1309 1153//1309 
f 1191//1309 1151//1309 1153//1309 
o mesh36
f 1225//1310 1213//1310 1212//1310 
f 1225//1310 1215//1310 1213//1310 
f 1215//1310 1225//1310 1158//1310 
f 1158//1310 1157//1310 1215//1310 
f 1212//1310 1226//1310 1225//1310 
o mesh37
f 1156//1311 1225//1311 1227//1311 
f 1156//1311 1159//1311 1158//1311 
f 1158//1311 1225//1311 1156//1311 
f 1156//1311 1155//1311 1161//1311 
f 1161//1311 1159//1311 1156//1311 
f 1227//1311 1228//1311 1156//1311 
o mesh38
f 1229//1312 1222//1312 1221//1312 
f 1221//1312 1230//1312 1229//1312 
f 1221//1312 1224//1312 1230//1312 
o mesh39
f 1231//1313 1232//1313 1225//1313 
f 1232//1313 1227//1313 1225//1313 
f 1225//1313 1226//1313 1231//1313 
o mesh40
f 1217//1314 1220//1314 1222//1314 
f 1222//1314 1233//1314 1217//1314 
f 1222//1314 1229//1314 1233//1314 
o mesh41
f 1211//1315 1234//1315 1226//1315 
f 1234//1315 1231//1315 1226//1315 
f 1226//1315 1212//1315 1211//1315 
o mesh42
f 1233//1316 1229//1316 1235//1316 
f 1235//1316 1236//1316 1233//1316 
o mesh43
f 1234//1317 1237//1317 1238//1317 
f 1238//1317 1231//1317 1234//1317 
o mesh44
f 761//1318 874//1318 873//1318 
f 1234//1318 892//1318 891//1318 
f 903//1318 902//1318 886//1318 
f 873//1318 763//1318 761//1318 
f 891//1318 897//1318 1234//1318 
f 1234//1318 776//1318 775//1318 
f 888//1318 887//1318 900//1318 
f 885//1318 904//1318 903//1318 
f 759//1318 875//1318 874//1318 
f 1234//1318 893//1318 892//1318 
f 775//1318 867//1318 1234//1318 
f 899//1318 889//1318 888//1318 
f 905//1318 884//1318 883//1318 
f 886//1318 885//1318 903//1318 
f 1197//1318 1196//1318 916//1318 
f 755//1318 1204//1318 876//1318 
f 761//1318 759//1318 874//1318 
f 872//1318 765//1318 763//1318 
f 891//1318 899//1318 898//1318 
f 1234//1318 721//1318 776//1318 
f 887//1318 886//1318 902//1318 
f 899//1318 890//1318 889//1318 
f 883//1318 1203//1318 905//1318 
f 884//1318 905//1318 904//1318 
f 1196//1318 917//1318 916//1318 
f 876//1318 757//1318 755//1318 
f 757//1318 876//1318 875//1318 
f 872//1318 767//1318 765//1318 
f 771//1318 769//1318 870//1318 
f 1234//1318 865//1318 893//1318 
f 867//1318 866//1318 1234//1318 
f 902//1318 901//1318 887//1318 
f 899//1318 891//1318 890//1318 
f 1203//1318 882//1318 881//1318 
f 885//1318 884//1318 904//1318 
f 906//1318 1203//1318 1202//1318 
f 916//1318 915//1318 1197//1318 
f 1196//1318 921//1318 920//1318 
f 759//1318 757//1318 875//1318 
f 1204//1318 878//1318 877//1318 
f 763//1318 873//1318 872//1318 
f 769//1318 767//1318 871//1318 
f 870//1318 869//1318 771//1318 
f 868//1318 775//1318 773//1318 
f 866//1318 865//1318 1234//1318 
f 900//1318 899//1318 888//1318 
f 883//1318 882//1318 1203//1318 
f 1202//1318 907//1318 906//1318 
f 1199//1318 1198//1318 912//1318 
f 1198//1318 1197//1318 914//1318 
f 1196//1318 918//1318 917//1318 
f 920//1318 919//1318 1196//1318 
f 753//1318 751//1318 1205//1318 
f 877//1318 876//1318 1204//1318 
f 1204//1318 1203//1318 879//1318 
f 871//1318 870//1318 769//1318 
f 773//1318 771//1318 868//1318 
f 901//1318 900//1318 887//1318 
f 906//1318 905//1318 1203//1318 
f 907//1318 1202//1318 1201//1318 
f 908//1318 1201//1318 1200//1318 
f 1210//1318 733//1318 731//1318 
f 1207//1318 745//1318 743//1318 
f 1200//1318 1199//1318 910//1318 
f 912//1318 911//1318 1199//1318 
f 914//1318 913//1318 1198//1318 
f 919//1318 918//1318 1196//1318 
f 755//1318 753//1318 1204//1318 
f 1203//1318 880//1318 879//1318 
f 869//1318 868//1318 771//1318 
f 1234//1318 897//1318 896//1318 
f 881//1318 880//1318 1203//1318 
f 1200//1318 909//1318 908//1318 
f 1211//1318 727//1318 725//1318 
f 727//1318 1211//1318 1214//1318 
f 731//1318 1214//1318 1210//1318 
f 1209//1318 737//1318 735//1318 
f 1207//1318 747//1318 745//1318 
f 1206//1318 749//1318 747//1318 
f 751//1318 749//1318 1206//1318 
f 911//1318 910//1318 1199//1318 
f 915//1318 914//1318 1197//1318 
f 1196//1318 1234//1318 922//1318 
f 879//1318 878//1318 1204//1318 
f 872//1318 871//1318 767//1318 
f 896//1318 895//1318 1234//1318 
f 1201//1318 908//1318 907//1318 
f 725//1318 1234//1318 1211//1318 
f 731//1318 729//1318 1214//1318 
f 735//1318 1210//1318 1209//1318 
f 1208//1318 741//1318 739//1318 
f 743//1318 1208//1318 1207//1318 
f 1206//1318 1205//1318 751//1318 
f 913//1318 912//1318 1198//1318 
f 1234//1318 894//1318 922//1318 
f 868//1318 867//1318 775//1318 
f 891//1318 898//1318 897//1318 
f 725//1318 723//1318 1234//1318 
f 735//1318 733//1318 1210//1318 
f 739//1318 1209//1318 1208//1318 
f 747//1318 1207//1318 1206//1318 
f 1234//1318 1216//1318 1217//1318 
f 922//1318 921//1318 1196//1318 
f 895//1318 894//1318 1234//1318 
f 1214//1318 729//1318 727//1318 
f 743//1318 741//1318 1208//1318 
f 1237//1318 1234//1318 1233//1318 
f 1234//1318 1196//1318 1216//1318 
f 1205//1318 1204//1318 753//1318 
f 739//1318 737//1318 1209//1318 
f 1217//1318 1233//1318 1234//1318 
f 723//1318 721//1318 1234//1318 
f 1233//1318 1236//1318 1237//1318 
f 1236//1318 1239//1318 1237//1318 
f 1239//1318 1240//1318 1237//1318 
f 910//1318 909//1318 1200//1318 
o mesh45
f 1228//1319 1227//1319 1232//1319 
f 1232//1319 1241//1319 1228//1319 
o mesh46
f 1242//1320 1232//1320 1231//1320 
f 1231//1320 1238//1320 1242//1320 
o mesh47
f 1240//1321 1243//1321 1244//1321 
f 1238//1321 1237//1321 1240//1321 
f 1244//1321 1238//1321 1240//1321 
o mesh48
f 1245//1322 1242//1322 1238//1322 
f 1238//1322 1244//1322 1245//1322 
o mesh49
f 1241//1323 1232//1323 1242//1323 
f 1242//1323 1246//1323 1241//1323 
o mesh50
f 1247//1324 1242//1324 1245//1324 
f 1245//1324 1248//1324 1247//1324 
f 1247//1324 1246//1324 1242//1324 
o mesh51
f 1245//1325 1249//1325 1250//1325 
f 1250//1325 1251//1325 1245//1325 
f 1245//1325 1252//1325 1249//1325 
f 1245//1325 1253//1325 1252//1325 
f 1245//1325 1254//1325 1253//1325 
f 1245//1325 1255//1325 1254//1325 
f 1245//1325 1244//1325 1256//1325 
f 1256//1325 1255//1325 1245//1325 
f 1244//1325 1257//1325 1256//1325 
f 1244//1325 1258//1325 1257//1325 
f 1244//1325 1259//1325 1258//1325 
f 1245//1325 1251//1325 1260//1325 
f 1244//1325 1261//1325 1259//1325 
f 1260//1325 1262//1325 1245//1325 
f 1262//1325 1248//1325 1245//1325 
f 1244//1325 1263//1325 1261//1325 
f 1244//1325 1264//1325 1263//1325 
f 1244//1325 1243//1325 1265//1325 
f 1265//1325 1264//1325 1244//1325 
o mesh52
f 1266//1326 1267//1326 1239//1326 
f 1267//1326 1265//1326 1243//1326 
f 1267//1326 1240//1326 1239//1326 
f 1239//1326 1268//1326 1266//1326 
f 1243//1326 1240//1326 1267//1326 
o mesh53
f 1269//1327 1270//1327 1271//1327 
f 1271//1327 1272//1327 1269//1327 
f 1272//1327 1247//1327 1248//1327 
f 1248//1327 1262//1327 1272//1327 
f 1271//1327 1247//1327 1272//1327 
o mesh54
f 1066//1328 1067//1328 1241//1328 
f 1246//1328 1273//1328 1069//1328 
f 1246//1328 1068//1328 1066//1328 
f 1273//1328 1070//1328 1069//1328 
f 1071//1328 1273//1328 1274//1328 
f 1069//1328 1068//1328 1246//1328 
f 1274//1328 1072//1328 1071//1328 
f 1071//1328 1070//1328 1273//1328 
f 1241//1328 1074//1328 1156//1328 
f 1274//1328 1223//1328 1153//1328 
f 1246//1328 1271//1328 1273//1328 
f 1241//1328 1067//1328 1074//1328 
f 1153//1328 1073//1328 1274//1328 
f 1156//1328 1228//1328 1241//1328 
f 1241//1328 1246//1328 1066//1328 
f 1073//1328 1072//1328 1274//1328 
f 1246//1328 1247//1328 1271//1328 
o mesh55
f 1223//1329 1274//1329 1230//1329 
f 1230//1329 1224//1329 1223//1329 
o mesh56
f 1274//1330 1273//1330 1275//1330 
f 1275//1330 1230//1330 1274//1330 
o mesh57
f 1276//1331 1277//1331 1278//1331 
f 1278//1331 1279//1331 1276//1331 
f 1276//1331 1280//1331 1277//1331 
f 1276//1331 1281//1331 1280//1331 
f 1276//1331 1282//1331 1281//1331 
f 1276//1331 1283//1331 1282//1331 
f 1284//1331 1285//1331 1283//1331 
f 1283//1331 1276//1331 1284//1331 
f 1284//1331 1286//1331 1285//1331 
f 1284//1331 1287//1331 1286//1331 
f 1284//1331 1288//1331 1287//1331 
f 1284//1331 1289//1331 1288//1331 
f 1276//1331 1279//1331 1266//1331 
f 1284//1331 1290//1331 1289//1331 
f 1266//1331 1268//1331 1276//1331 
f 1284//1331 1291//1331 1292//1331 
f 1292//1331 1290//1331 1284//1331 
f 1284//1331 1270//1331 1269//1331 
f 1269//1331 1291//1331 1284//1331 
o mesh58
f 1239//1332 1235//1332 1276//1332 
f 1276//1332 1268//1332 1239//1332 
f 1239//1332 1236//1332 1235//1332 
o mesh59
f 1271//1333 1270//1333 1284//1333 
f 1275//1333 1273//1333 1271//1333 
f 1284//1333 1275//1333 1271//1333 
o mesh60
f 1230//1334 1275//1334 1235//1334 
f 1235//1334 1229//1334 1230//1334 
o mesh61
f 1275//1335 1284//1335 1276//1335 
f 1276//1335 1235//1335 1275//1335 
o mesh62
f 1266//1336 1279//1336 1421//1336 
f 1421//1336 1279//1336 1293//1336 
f 1422//1336 1294//1336 1295//1336 
f 1279//1336 1296//1336 1293//1336 
f 1295//1336 1297//1336 1422//1336 
f 1293//1336 1298//1336 1421//1336 
f 1278//1336 1299//1336 1296//1336 
f 1297//1336 1299//1336 1422//1336 
f 1422//1336 1421//1336 1300//1336 
f 1296//1336 1279//1336 1278//1336 
f 1300//1336 1294//1336 1422//1336 
f 1299//1336 1278//1336 1422//1336 
f 1278//1336 1301//1336 1302//1336 
f 1423//1336 1303//1336 1304//1336 
f 1302//1336 1305//1336 1278//1336 
f 1304//1336 1306//1336 1423//1336 
f 1305//1336 1307//1336 1278//1336 
f 1277//1336 1308//1336 1301//1336 
f 1306//1336 1308//1336 1423//1336 
f 1422//1336 1307//1336 1303//1336 
f 1301//1336 1278//1336 1277//1336 
f 1303//1336 1423//1336 1422//1336 
f 1308//1336 1277//1336 1423//1336 
f 1277//1336 1309//1336 1310//1336 
f 1424//1336 1311//1336 1312//1336 
f 1310//1336 1313//1336 1277//1336 
f 1312//1336 1314//1336 1424//1336 
f 1313//1336 1315//1336 1277//1336 
f 1280//1336 1316//1336 1309//1336 
f 1314//1336 1316//1336 1424//1336 
f 1423//1336 1315//1336 1311//1336 
f 1309//1336 1277//1336 1280//1336 
f 1311//1336 1424//1336 1423//1336 
f 1316//1336 1280//1336 1424//1336 
f 1280//1336 1317//1336 1318//1336 
f 1425//1336 1319//1336 1320//1336 
f 1318//1336 1321//1336 1280//1336 
f 1320//1336 1322//1336 1425//1336 
f 1321//1336 1323//1336 1280//1336 
f 1281//1336 1324//1336 1317//1336 
f 1322//1336 1324//1336 1425//1336 
f 1424//1336 1323//1336 1319//1336 
f 1317//1336 1280//1336 1281//1336 
f 1319//1336 1425//1336 1424//1336 
f 1324//1336 1281//1336 1425//1336 
f 1281//1336 1325//1336 1326//1336 
f 1426//1336 1327//1336 1328//1336 
f 1326//1336 1329//1336 1281//1336 
f 1328//1336 1330//1336 1426//1336 
f 1329//1336 1331//1336 1281//1336 
f 1282//1336 1332//1336 1325//1336 
f 1330//1336 1332//1336 1426//1336 
f 1425//1336 1331//1336 1327//1336 
f 1325//1336 1281//1336 1282//1336 
f 1327//1336 1426//1336 1425//1336 
f 1332//1336 1282//1336 1426//1336 
f 1282//1336 1333//1336 1334//1336 
f 1427//1336 1335//1336 1336//1336 
f 1282//1336 1337//1336 1333//1336 
f 1336//1336 1338//1336 1427//1336 
f 1334//1336 1339//1336 1282//1336 
f 1283//1336 1340//1336 1337//1336 
f 1338//1336 1340//1336 1427//1336 
f 1426//1336 1339//1336 1335//1336 
f 1337//1336 1282//1336 1283//1336 
f 1335//1336 1427//1336 1426//1336 
f 1340//1336 1283//1336 1427//1336 
f 1341//1336 1342//1336 1343//1336 
f 1344//1336 1345//1336 1342//1336 
f 1283//1336 1346//1336 1347//1336 
f 1342//1336 1341//1336 1344//1336 
f 1345//1336 1344//1336 1348//1336 
f 1283//1336 1349//1336 1346//1336 
f 1348//1336 1350//1336 1345//1336 
f 1285//1336 1351//1336 1350//1336 
f 1428//1336 1352//1336 1353//1336 
f 1347//1336 1354//1336 1283//1336 
f 1283//1336 1285//1336 1348//1336 
f 1350//1336 1348//1336 1285//1336 
f 1427//1336 1354//1336 1355//1336 
f 1353//1336 1356//1336 1428//1336 
f 1348//1336 1349//1336 1283//1336 
f 1355//1336 1343//1336 1427//1336 
f 1356//1336 1351//1336 1428//1336 
f 1428//1336 1427//1336 1343//1336 
f 1343//1336 1355//1336 1341//1336 
f 1343//1336 1352//1336 1428//1336 
f 1351//1336 1285//1336 1428//1336 
f 1285//1336 1357//1336 1358//1336 
f 1429//1336 1359//1336 1360//1336 
f 1285//1336 1361//1336 1357//1336 
f 1360//1336 1362//1336 1429//1336 
f 1358//1336 1363//1336 1285//1336 
f 1286//1336 1364//1336 1361//1336 
f 1362//1336 1364//1336 1429//1336 
f 1428//1336 1363//1336 1359//1336 
f 1361//1336 1285//1336 1286//1336 
f 1359//1336 1429//1336 1428//1336 
f 1364//1336 1286//1336 1429//1336 
f 1286//1336 1365//1336 1366//1336 
f 1430//1336 1367//1336 1368//1336 
f 1286//1336 1369//1336 1365//1336 
f 1368//1336 1370//1336 1430//1336 
f 1366//1336 1371//1336 1286//1336 
f 1287//1336 1372//1336 1369//1336 
f 1370//1336 1372//1336 1430//1336 
f 1429//1336 1371//1336 1367//1336 
f 1369//1336 1286//1336 1287//1336 
f 1367//1336 1430//1336 1429//1336 
f 1372//1336 1287//1336 1430//1336 
f 1287//1336 1373//1336 1374//1336 
f 1431//1336 1375//1336 1376//1336 
f 1287//1336 1377//1336 1373//1336 
f 1376//1336 1378//1336 1431//1336 
f 1374//1336 1379//1336 1287//1336 
f 1288//1336 1380//1336 1377//1336 
f 1378//1336 1380//1336 1431//1336 
f 1430//1336 1379//1336 1375//1336 
f 1377//1336 1287//1336 1288//1336 
f 1375//1336 1431//1336 1430//1336 
f 1380//1336 1288//1336 1431//1336 
f 1288//1336 1381//1336 1382//1336 
f 1432//1336 1383//1336 1384//1336 
f 1288//1336 1385//1336 1381//1336 
f 1384//1336 1386//1336 1432//1336 
f 1382//1336 1387//1336 1288//1336 
f 1289//1336 1388//1336 1385//1336 
f 1386//1336 1388//1336 1432//1336 
f 1431//1336 1387//1336 1383//1336 
f 1385//1336 1288//1336 1289//1336 
f 1383//1336 1432//1336 1431//1336 
f 1388//1336 1289//1336 1432//1336 
f 1289//1336 1389//1336 1390//1336 
f 1433//1336 1391//1336 1392//1336 
f 1289//1336 1393//1336 1389//1336 
f 1392//1336 1394//1336 1433//1336 
f 1390//1336 1395//1336 1289//1336 
f 1290//1336 1396//1336 1393//1336 
f 1394//1336 1396//1336 1433//1336 
f 1432//1336 1395//1336 1391//1336 
f 1393//1336 1289//1336 1290//1336 
f 1391//1336 1433//1336 1432//1336 
f 1396//1336 1290//1336 1433//1336 
f 1290//1336 1397//1336 1398//1336 
f 1434//1336 1399//1336 1400//1336 
f 1290//1336 1401//1336 1397//1336 
f 1400//1336 1402//1336 1434//1336 
f 1398//1336 1403//1336 1290//1336 
f 1292//1336 1404//1336 1401//1336 
f 1402//1336 1404//1336 1434//1336 
f 1433//1336 1403//1336 1399//1336 
f 1401//1336 1290//1336 1292//1336 
f 1399//1336 1434//1336 1433//1336 
f 1404//1336 1292//1336 1434//1336 
f 1292//1336 1405//1336 1406//1336 
f 1435//1336 1407//1336 1408//1336 
f 1292//1336 1409//1336 1405//1336 
f 1408//1336 1410//1336 1435//1336 
f 1406//1336 1411//1336 1292//1336 
f 1291//1336 1412//1336 1409//1336 
f 1410//1336 1412//1336 1435//1336 
f 1434//1336 1411//1336 1407//1336 
f 1409//1336 1292//1336 1291//1336 
f 1407//1336 1435//1336 1434//1336 
f 1412//1336 1291//1336 1435//1336 
f 1291//1336 1413//1336 1414//1336 
f 1291//1336 1415//1336 1413//1336 
f 1269//1336 1272//1336 1416//1336 
f 1272//1336 1417//1336 1418//1336 
f 1414//1336 1419//1336 1291//1336 
f 1291//1336 1269//1336 1420//1336 
f 1418//1336 1416//1336 1272//1336 
f 1435//1336 1419//1336 1417//1336 
f 1420//1336 1415//1336 1291//1336 
f 1417//1336 1272//1336 1435//1336 
f 1416//1336 1420//1336 1269//1336 
f 1267//1336 1421//1336 1264//1336 
f 1421//1336 1422//1336 1263//1336 
f 1422//1336 1423//1336 1261//1336 
f 1423//1336 1424//1336 1259//1336 
f 1424//1336 1425//1336 1258//1336 
f 1425//1336 1426//1336 1257//1336 
f 1426//1336 1427//1336 1256//1336 
f 1427//1336 1428//1336 1255//1336 
f 1428//1336 1429//1336 1254//1336 
f 1429//1336 1430//1336 1253//1336 
f 1430//1336 1431//1336 1252//1336 
f 1431//1336 1432//1336 1249//1336 
f 1432//1336 1433//1336 1250//1336 
f 1433//1336 1434//1336 1251//1336 
f 1434//1336 1435//1336 1260//1336 
f 1435//1336 1272//1336 1262//1336 
f 1262//1336 1260//1336 1435//1336 
f 1260//1336 1251//1336 1434//1336 
f 1251//1336 1250//1336 1433//1336 
f 1250//1336 1249//1336 1432//1336 
f 1249//1336 1252//1336 1431//1336 
f 1252//1336 1253//1336 1430//1336 
f 1253//1336 1254//1336 1429//1336 
f 1254//1336 1255//1336 1428//1336 
f 1255//1336 1256//1336 1427//1336 
f 1256//1336 1257//1336 1426//1336 
f 1257//1336 1258//1336 1425//1336 
f 1258//1336 1259//1336 1424//1336 
f 1259//1336 1261//1336 1423//1336 
f 1261//1336 1263//1336 1422//1336 
f 1263//1336 1264//1336 1421//1336 
f 1264//1336 1265//1336 1267//1336 
f 1419//1336 1435//1336 1291//1336 
f 1411//1336 1434//1336 1292//1336 
f 1403//1336 1433//1336 1290//1336 
f 1395//1336 1432//1336 1289//1336 
f 1387//1336 1431//1336 1288//1336 
f 1379//1336 1430//1336 1287//1336 
f 1371//1336 1429//1336 1286//1336 
f 1363//1336 1428//1336 1285//1336 
f 1354//1336 1427//1336 1283//1336 
f 1339//1336 1426//1336 1282//1336 
f 1331//1336 1425//1336 1281//1336 
f 1323//1336 1424//1336 1280//1336 
f 1315//1336 1423//1336 1277//1336 
f 1307//1336 1422//1336 1278//1336 
f 1298//1336 1300//1336 1421//1336 
f 1421//1336 1267//1336 1266//1336 
o mesh63
f 1436//1337 1414//1337 1413//1337 
f 1413//1337 1437//1337 1436//1337 
o mesh64
f 1438//1336 1436//1336 1437//1336 
f 1439//1336 1440//1336 1441//1336 
f 1441//1336 1437//1336 1439//1336 
f 1442//1336 1443//1336 1436//1336 
f 1436//1336 1438//1336 1442//1336 
f 1437//1336 1441//1336 1438//1336 
o mesh65
f 1439//1338 1415//1338 1420//1338 
f 1420//1338 1440//1338 1439//1338 
o mesh66
f 1441//1339 1416//1339 1418//1339 
f 1418//1339 1438//1339 1441//1339 
o mesh67
f 1442//1340 1417//1340 1419//1340 
f 1419//1340 1443//1340 1442//1340 
o mesh68
f 1438//1341 1418//1341 1417//1341 
f 1417//1341 1442//1341 1438//1341 
o mesh69
f 1443//1342 1419//1342 1414//1342 
f 1414//1342 1436//1342 1443//1342 
o mesh70
f 1440//1343 1420//1343 1416//1343 
f 1416//1343 1441//1343 1440//1343 
o mesh71
f 1437//1344 1413//1344 1415//1344 
f 1415//1344 1439//1344 1437//1344 
o mesh72
f 1444//1345 1406//1345 1405//1345 
f 1405//1345 1445//1345 1444//1345 
o mesh73
f 1446//1346 1444//1346 1445//1346 
f 1447//1346 1448//1346 1449//1346 
f 1449//1346 1445//1346 1447//1346 
f 1450//1346 1451//1346 1444//1346 
f 1444//1346 1446//1346 1450//1346 
f 1445//1346 1449//1346 1446//1346 
o mesh74
f 1447//1347 1409//1347 1412//1347 
f 1412//1347 1448//1347 1447//1347 
o mesh75
f 1449//1348 1410//1348 1408//1348 
f 1408//1348 1446//1348 1449//1348 
o mesh76
f 1450//1349 1407//1349 1411//1349 
f 1411//1349 1451//1349 1450//1349 
o mesh77
f 1446//1350 1408//1350 1407//1350 
f 1407//1350 1450//1350 1446//1350 
o mesh78
f 1451//1351 1411//1351 1406//1351 
f 1406//1351 1444//1351 1451//1351 
o mesh79
f 1448//1352 1412//1352 1410//1352 
f 1410//1352 1449//1352 1448//1352 
o mesh80
f 1445//1353 1405//1353 1409//1353 
f 1409//1353 1447//1353 1445//1353 
o mesh81
f 1452//1354 1398//1354 1397//1354 
f 1397//1354 1453//1354 1452//1354 
o mesh82
f 1454//1355 1452//1355 1453//1355 
f 1455//1355 1456//1355 1457//1355 
f 1458//1355 1459//1355 1452//1355 
f 1457//1355 1453//1355 1455//1355 
f 1453//1355 1457//1355 1454//1355 
f 1452//1355 1454//1355 1458//1355 
o mesh83
f 1455//1356 1401//1356 1404//1356 
f 1404//1356 1456//1356 1455//1356 
o mesh84
f 1457//1357 1402//1357 1400//1357 
f 1400//1357 1454//1357 1457//1357 
o mesh85
f 1458//1358 1399//1358 1403//1358 
f 1403//1358 1459//1358 1458//1358 
o mesh86
f 1454//1359 1400//1359 1399//1359 
f 1399//1359 1458//1359 1454//1359 
o mesh87
f 1459//1360 1403//1360 1398//1360 
f 1398//1360 1452//1360 1459//1360 
o mesh88
f 1456//1361 1404//1361 1402//1361 
f 1402//1361 1457//1361 1456//1361 
o mesh89
f 1453//1362 1397//1362 1401//1362 
f 1401//1362 1455//1362 1453//1362 
o mesh90
f 1460//1363 1390//1363 1389//1363 
f 1389//1363 1461//1363 1460//1363 
o mesh91
f 1462//1364 1460//1364 1461//1364 
f 1463//1364 1464//1364 1465//1364 
f 1465//1364 1461//1364 1463//1364 
f 1466//1364 1467//1364 1460//1364 
f 1460//1364 1462//1364 1466//1364 
f 1461//1364 1465//1364 1462//1364 
o mesh92
f 1463//1365 1393//1365 1396//1365 
f 1396//1365 1464//1365 1463//1365 
o mesh93
f 1465//1366 1394//1366 1392//1366 
f 1392//1366 1462//1366 1465//1366 
o mesh94
f 1466//1367 1391//1367 1395//1367 
f 1395//1367 1467//1367 1466//1367 
o mesh95
f 1462//1368 1392//1368 1391//1368 
f 1391//1368 1466//1368 1462//1368 
o mesh96
f 1467//1369 1395//1369 1390//1369 
f 1390//1369 1460//1369 1467//1369 
o mesh97
f 1464//1370 1396//1370 1394//1370 
f 1394//1370 1465//1370 1464//1370 
o mesh98
f 1461//1371 1389//1371 1393//1371 
f 1393//1371 1463//1371 1461//1371 
o mesh99
f 1468//1372 1382//1372 1381//1372 
f 1381//1372 1469//1372 1468//1372 
o mesh100
f 1470//1373 1468//1373 1469//1373 
f 1471//1373 1472//1373 1473//1373 
f 1474//1373 1475//1373 1468//1373 
f 1473//1373 1469//1373 1471//1373 
f 1469//1373 1473//1373 1470//1373 
f 1468//1373 1470//1373 1474//1373 
o mesh101
f 1471//1374 1385//1374 1388//1374 
f 1388//1374 1472//1374 1471//1374 
o mesh102
f 1473//1375 1386//1375 1384//1375 
f 1384//1375 1470//1375 1473//1375 
o mesh103
f 1474//1376 1383//1376 1387//1376 
f 1387//1376 1475//1376 1474//1376 
o mesh104
f 1470//1377 1384//1377 1383//1377 
f 1383//1377 1474//1377 1470//1377 
o mesh105
f 1475//1378 1387//1378 1382//1378 
f 1382//1378 1468//1378 1475//1378 
o mesh106
f 1472//1379 1388//1379 1386//1379 
f 1386//1379 1473//1379 1472//1379 
o mesh107
f 1469//1380 1381//1380 1385//1380 
f 1385//1380 1471//1380 1469//1380 
o mesh108
f 1476//1381 1374//1381 1373//1381 
f 1373//1381 1477//1381 1476//1381 
o mesh109
f 1478//1382 1476//1382 1477//1382 
f 1479//1382 1480//1382 1481//1382 
f 1482//1382 1483//1382 1476//1382 
f 1481//1382 1477//1382 1479//1382 
f 1477//1382 1481//1382 1478//1382 
f 1476//1382 1478//1382 1482//1382 
o mesh110
f 1479//1383 1377//1383 1380//1383 
f 1380//1383 1480//1383 1479//1383 
o mesh111
f 1481//1384 1378//1384 1376//1384 
f 1376//1384 1478//1384 1481//1384 
o mesh112
f 1482//1385 1375//1385 1379//1385 
f 1379//1385 1483//1385 1482//1385 
o mesh113
f 1478//1386 1376//1386 1375//1386 
f 1375//1386 1482//1386 1478//1386 
o mesh114
f 1483//1387 1379//1387 1374//1387 
f 1374//1387 1476//1387 1483//1387 
o mesh115
f 1480//1388 1380//1388 1378//1388 
f 1378//1388 1481//1388 1480//1388 
o mesh116
f 1477//1389 1373//1389 1377//1389 
f 1377//1389 1479//1389 1477//1389 
o mesh117
f 1484//1390 1366//1390 1365//1390 
f 1365//1390 1485//1390 1484//1390 
o mesh118
f 1486//1391 1484//1391 1485//1391 
f 1487//1391 1488//1391 1489//1391 
f 1490//1391 1491//1391 1484//1391 
f 1489//1391 1485//1391 1487//1391 
f 1485//1391 1489//1391 1486//1391 
f 1484//1391 1486//1391 1490//1391 
o mesh119
f 1487//1392 1369//1392 1372//1392 
f 1372//1392 1488//1392 1487//1392 
o mesh120
f 1489//1393 1370//1393 1368//1393 
f 1368//1393 1486//1393 1489//1393 
o mesh121
f 1490//1394 1367//1394 1371//1394 
f 1371//1394 1491//1394 1490//1394 
o mesh122
f 1486//1395 1368//1395 1367//1395 
f 1367//1395 1490//1395 1486//1395 
o mesh123
f 1491//1396 1371//1396 1366//1396 
f 1366//1396 1484//1396 1491//1396 
o mesh124
f 1488//1397 1372//1397 1370//1397 
f 1370//1397 1489//1397 1488//1397 
o mesh125
f 1485//1398 1365//1398 1369//1398 
f 1369//1398 1487//1398 1485//1398 
o mesh126
f 1492//1399 1358//1399 1357//1399 
f 1357//1399 1493//1399 1492//1399 
o mesh127
f 1494//1400 1492//1400 1493//1400 
f 1495//1400 1496//1400 1497//1400 
f 1498//1400 1499//1400 1492//1400 
f 1497//1400 1493//1400 1495//1400 
f 1493//1400 1497//1400 1494//1400 
f 1492//1400 1494//1400 1498//1400 
o mesh128
f 1495//1401 1361//1401 1364//1401 
f 1364//1401 1496//1401 1495//1401 
o mesh129
f 1497//1402 1362//1402 1360//1402 
f 1360//1402 1494//1402 1497//1402 
o mesh130
f 1498//1403 1359//1403 1363//1403 
f 1363//1403 1499//1403 1498//1403 
o mesh131
f 1494//1404 1360//1404 1359//1404 
f 1359//1404 1498//1404 1494//1404 
o mesh132
f 1499//1405 1363//1405 1358//1405 
f 1358//1405 1492//1405 1499//1405 
o mesh133
f 1496//1406 1364//1406 1362//1406 
f 1362//1406 1497//1406 1496//1406 
o mesh134
f 1493//1407 1357//1407 1361//1407 
f 1361//1407 1495//1407 1493//1407 
o mesh135
f 1500//1408 1342//1408 1345//1408 
f 1345//1408 1501//1408 1500//1408 
o mesh136
f 1502//1409 1500//1409 1501//1409 
f 1503//1409 1504//1409 1505//1409 
f 1506//1409 1507//1409 1500//1409 
f 1505//1409 1501//1409 1503//1409 
f 1501//1409 1505//1409 1502//1409 
f 1500//1409 1502//1409 1506//1409 
o mesh137
f 1503//1410 1350//1410 1351//1410 
f 1351//1410 1504//1410 1503//1410 
o mesh138
f 1505//1411 1356//1411 1353//1411 
f 1353//1411 1502//1411 1505//1411 
o mesh139
f 1506//1412 1352//1412 1343//1412 
f 1343//1412 1507//1412 1506//1412 
o mesh140
f 1502//1413 1353//1413 1352//1413 
f 1352//1413 1506//1413 1502//1413 
o mesh141
f 1507//1414 1343//1414 1342//1414 
f 1342//1414 1500//1414 1507//1414 
o mesh142
f 1504//1415 1351//1415 1356//1415 
f 1356//1415 1505//1415 1504//1415 
o mesh143
f 1501//1416 1345//1416 1350//1416 
f 1350//1416 1503//1416 1501//1416 
o mesh144
f 1508//1417 1347//1417 1346//1417 
f 1346//1417 1509//1417 1508//1417 
o mesh145
f 1510//1418 1508//1418 1509//1418 
f 1511//1418 1512//1418 1513//1418 
f 1514//1418 1515//1418 1508//1418 
f 1513//1418 1509//1418 1511//1418 
f 1509//1418 1513//1418 1510//1418 
f 1508//1418 1510//1418 1514//1418 
o mesh146
f 1511//1419 1349//1419 1348//1419 
f 1348//1419 1512//1419 1511//1419 
o mesh147
f 1513//1420 1344//1420 1341//1420 
f 1341//1420 1510//1420 1513//1420 
o mesh148
f 1514//1421 1355//1421 1354//1421 
f 1354//1421 1515//1421 1514//1421 
o mesh149
f 1510//1422 1341//1422 1355//1422 
f 1355//1422 1514//1422 1510//1422 
o mesh150
f 1515//1423 1354//1423 1347//1423 
f 1347//1423 1508//1423 1515//1423 
o mesh151
f 1512//1424 1348//1424 1344//1424 
f 1344//1424 1513//1424 1512//1424 
o mesh152
f 1509//1425 1346//1425 1349//1425 
f 1349//1425 1511//1425 1509//1425 
o mesh153
f 1516//1426 1334//1426 1333//1426 
f 1333//1426 1517//1426 1516//1426 
o mesh154
f 1518//1427 1516//1427 1517//1427 
f 1519//1427 1520//1427 1521//1427 
f 1522//1427 1523//1427 1516//1427 
f 1521//1427 1517//1427 1519//1427 
f 1517//1427 1521//1427 1518//1427 
f 1516//1427 1518//1427 1522//1427 
o mesh155
f 1519//1428 1337//1428 1340//1428 
f 1340//1428 1520//1428 1519//1428 
o mesh156
f 1521//1429 1338//1429 1336//1429 
f 1336//1429 1518//1429 1521//1429 
o mesh157
f 1522//1430 1335//1430 1339//1430 
f 1339//1430 1523//1430 1522//1430 
o mesh158
f 1518//1431 1336//1431 1335//1431 
f 1335//1431 1522//1431 1518//1431 
o mesh159
f 1523//1432 1339//1432 1334//1432 
f 1334//1432 1516//1432 1523//1432 
o mesh160
f 1520//1433 1340//1433 1338//1433 
f 1338//1433 1521//1433 1520//1433 
o mesh161
f 1517//1434 1333//1434 1337//1434 
f 1337//1434 1519//1434 1517//1434 
o mesh162
f 1524//1435 1329//1435 1326//1435 
f 1326//1435 1525//1435 1524//1435 
o mesh163
f 1526//1436 1527//1436 1528//1436 
f 1529//1436 1524//1436 1525//1436 
f 1530//1436 1531//1436 1524//1436 
f 1525//1436 1528//1436 1529//1436 
f 1528//1436 1525//1436 1526//1436 
f 1524//1436 1529//1436 1530//1436 
o mesh164
f 1526//1437 1325//1437 1332//1437 
f 1332//1437 1527//1437 1526//1437 
o mesh165
f 1528//1438 1330//1438 1328//1438 
f 1328//1438 1529//1438 1528//1438 
o mesh166
f 1327//1439 1331//1439 1531//1439 
f 1531//1439 1530//1439 1327//1439 
o mesh167
f 1529//1440 1328//1440 1327//1440 
f 1327//1440 1530//1440 1529//1440 
o mesh168
f 1329//1441 1524//1441 1531//1441 
f 1531//1441 1331//1441 1329//1441 
o mesh169
f 1527//1442 1332//1442 1330//1442 
f 1330//1442 1528//1442 1527//1442 
o mesh170
f 1525//1443 1326//1443 1325//1443 
f 1325//1443 1526//1443 1525//1443 
o mesh171
f 1532//1444 1321//1444 1318//1444 
f 1318//1444 1533//1444 1532//1444 
o mesh172
f 1534//1445 1535//1445 1536//1445 
f 1537//1445 1532//1445 1533//1445 
f 1538//1445 1539//1445 1532//1445 
f 1533//1445 1536//1445 1537//1445 
f 1536//1445 1533//1445 1534//1445 
f 1532//1445 1537//1445 1538//1445 
o mesh173
f 1534//1446 1317//1446 1324//1446 
f 1324//1446 1535//1446 1534//1446 
o mesh174
f 1536//1447 1322//1447 1320//1447 
f 1320//1447 1537//1447 1536//1447 
o mesh175
f 1538//1448 1319//1448 1323//1448 
f 1323//1448 1539//1448 1538//1448 
o mesh176
f 1537//1449 1320//1449 1319//1449 
f 1319//1449 1538//1449 1537//1449 
o mesh177
f 1539//1450 1323//1450 1321//1450 
f 1321//1450 1532//1450 1539//1450 
o mesh178
f 1535//1451 1324//1451 1322//1451 
f 1322//1451 1536//1451 1535//1451 
o mesh179
f 1533//1452 1318//1452 1317//1452 
f 1317//1452 1534//1452 1533//1452 
o mesh180
f 1540//1453 1313//1453 1310//1453 
f 1310//1453 1541//1453 1540//1453 
o mesh181
f 1542//1454 1543//1454 1544//1454 
f 1545//1454 1540//1454 1541//1454 
f 1546//1454 1547//1454 1540//1454 
f 1541//1454 1544//1454 1545//1454 
f 1544//1454 1541//1454 1542//1454 
f 1540//1454 1545//1454 1546//1454 
o mesh182
f 1542//1455 1309//1455 1316//1455 
f 1316//1455 1543//1455 1542//1455 
o mesh183
f 1544//1456 1314//1456 1312//1456 
f 1312//1456 1545//1456 1544//1456 
o mesh184
f 1546//1457 1311//1457 1315//1457 
f 1315//1457 1547//1457 1546//1457 
o mesh185
f 1545//1458 1312//1458 1311//1458 
f 1311//1458 1546//1458 1545//1458 
o mesh186
f 1547//1459 1315//1459 1313//1459 
f 1313//1459 1540//1459 1547//1459 
o mesh187
f 1543//1460 1316//1460 1314//1460 
f 1314//1460 1544//1460 1543//1460 
o mesh188
f 1541//1461 1310//1461 1309//1461 
f 1309//1461 1542//1461 1541//1461 
o mesh189
f 1548//1462 1305//1462 1302//1462 
f 1302//1462 1549//1462 1548//1462 
o mesh190
f 1550//1463 1551//1463 1552//1463 
f 1553//1463 1548//1463 1549//1463 
f 1554//1463 1555//1463 1548//1463 
f 1549//1463 1552//1463 1553//1463 
f 1552//1463 1549//1463 1550//1463 
f 1548//1463 1553//1463 1554//1463 
o mesh191
f 1550//1464 1301//1464 1308//1464 
f 1308//1464 1551//1464 1550//1464 
o mesh192
f 1552//1465 1306//1465 1304//1465 
f 1304//1465 1553//1465 1552//1465 
o mesh193
f 1554//1466 1303//1466 1307//1466 
f 1307//1466 1555//1466 1554//1466 
o mesh194
f 1553//1467 1304//1467 1303//1467 
f 1303//1467 1554//1467 1553//1467 
o mesh195
f 1555//1468 1307//1468 1305//1468 
f 1305//1468 1548//1468 1555//1468 
o mesh196
f 1551//1469 1308//1469 1306//1469 
f 1306//1469 1552//1469 1551//1469 
o mesh197
f 1549//1470 1302//1470 1301//1470 
f 1301//1470 1550//1470 1549//1470 
o mesh198
f 1556//1471 1298//1471 1293//1471 
f 1293//1471 1557//1471 1556//1471 
o mesh199
f 1558//1472 1559//1472 1560//1472 
f 1561//1472 1556//1472 1557//1472 
f 1562//1472 1563//1472 1556//1472 
f 1557//1472 1560//1472 1561//1472 
f 1560//1472 1557//1472 1558//1472 
f 1556//1472 1561//1472 1562//1472 
o mesh200
f 1557//1473 1293//1473 1296//1473 
f 1296//1473 1558//1473 1557//1473 
o mesh201
f 1558//1474 1296//1474 1299//1474 
f 1299//1474 1559//1474 1558//1474 
o mesh202
f 1559//1475 1299//1475 1297//1475 
f 1297//1475 1560//1475 1559//1475 
o mesh203
f 1560//1476 1297//1476 1295//1476 
f 1295//1476 1561//1476 1560//1476 
o mesh204
f 1561//1477 1295//1477 1294//1477 
f 1294//1477 1562//1477 1561//1477 
o mesh205
f 1294//1478 1300//1478 1563//1478 
f 1563//1478 1562//1478 1294//1478 
o mesh206
f 1298//1479 1556//1479 1563//1479 
f 1563//1479 1300//1479 1298//1479 
g nema17
v 0.0463922 0.128101 -0.100158 
v 0.0458643 0.128101 -0.100274 
v 0.0453736 0.128101 -0.100501 
v 0.0449433 0.128101 -0.100828 
v 0.0445933 0.128101 -0.10124 
v 0.0443401 0.128101 -0.101718 
v 0.0441954 0.128101 -0.102238 
v 0.0441662 0.128101 -0.102778 
v 0.0442536 0.128101 -0.103312 
v 0.0444537 0.128101 -0.103814 
v 0.0447571 0.128101 -0.104261 
v 0.0451496 0.128101 -0.104633 
v 0.0456128 0.128101 -0.104912 
v 0.0461251 0.128101 -0.105084 
v 0.0466625 0.128101 -0.105143 
v 0.0471999 0.128101 -0.105084 
v 0.0477122 0.128101 -0.104912 
v 0.0481754 0.128101 -0.104633 
v 0.0485679 0.128101 -0.104261 
v 0.0488713 0.128101 -0.103814 
v 0.0490714 0.128101 -0.103312 
v 0.0491588 0.128101 -0.102778 
v 0.0491296 0.128101 -0.102238 
v 0.048985 0.128101 -0.101718 
v 0.0487317 0.128101 -0.10124 
v 0.0483818 0.128101 -0.100828 
v 0.0479514 0.128101 -0.100501 
v 0.0474608 0.128101 -0.100274 
v 0.0469328 0.128101 -0.100158 
v 0.0466625 0.128101 -0.100143 
v 0.0466625 0.128101 -0.102643 
v 0.0466625 0.150101 -0.105143 
v 0.0461251 0.150101 -0.105084 
v 0.0456128 0.150101 -0.104912 
v 0.0451496 0.150101 -0.104633 
v 0.0447571 0.150101 -0.104261 
v 0.0444537 0.150101 -0.103814 
v 0.0442536 0.150101 -0.103312 
v 0.0441662 0.150101 -0.102778 
v 0.0441954 0.150101 -0.102238 
v 0.0443401 0.150101 -0.101718 
v 0.0445933 0.150101 -0.10124 
v 0.0449433 0.150101 -0.100828 
v 0.0453736 0.150101 -0.100501 
v 0.0458643 0.150101 -0.100274 
v 0.0469328 0.150101 -0.100158 
v 0.0466625 0.150101 -0.100143 
v 0.0463922 0.150101 -0.100158 
v 0.0474608 0.150101 -0.100274 
v 0.0479514 0.150101 -0.100501 
v 0.0483818 0.150101 -0.100828 
v 0.0487317 0.150101 -0.10124 
v 0.048985 0.150101 -0.101718 
v 0.0491296 0.150101 -0.102238 
v 0.0491588 0.150101 -0.102778 
v 0.0490714 0.150101 -0.103312 
v 0.0488713 0.150101 -0.103814 
v 0.0485679 0.150101 -0.104261 
v 0.0481754 0.150101 -0.104633 
v 0.0477122 0.150101 -0.104912 
v 0.0471999 0.150101 -0.105084 
v 0.0466625 0.150101 -0.0916429 
v 0.0454732 0.150101 -0.0917074 
v 0.0431502 0.150101 -0.0922188 
v 0.0420437 0.150101 -0.112626 
v 0.0442978 0.150101 -0.113386 
v 0.0466625 0.150101 -0.113643 
v 0.0490272 0.150101 -0.113386 
v 0.0409914 0.150101 -0.0932175 
v 0.0390978 0.150101 -0.094657 
v 0.0375579 0.150101 -0.0964699 
v 0.0360635 0.150101 -0.105586 
v 0.0369439 0.150101 -0.107795 
v 0.0382787 0.150101 -0.109764 
v 0.0400056 0.150101 -0.1114 
v 0.0563811 0.150101 -0.107795 
v 0.0572616 0.150101 -0.105586 
v 0.0358074 0.150101 -0.100863 
v 0.0356786 0.150101 -0.103238 
v 0.0512813 0.150101 -0.112626 
v 0.0533194 0.150101 -0.1114 
v 0.0550463 0.150101 -0.109764 
v 0.0576464 0.150101 -0.103238 
v 0.0575176 0.150101 -0.100863 
v 0.0568813 0.150101 -0.0985714 
v 0.0364438 0.150101 -0.0985714 
v 0.0557671 0.150101 -0.0964699 
v 0.0542272 0.150101 -0.094657 
v 0.0523336 0.150101 -0.0932175 
v 0.0501748 0.150101 -0.0922188 
v 0.0478518 0.150101 -0.0917074 
v 0.0466625 0.152101 -0.113643 
v 0.0442978 0.152101 -0.113386 
v 0.0420437 0.152101 -0.112626 
v 0.0400056 0.152101 -0.1114 
v 0.0382787 0.152101 -0.109764 
v 0.0369439 0.152101 -0.107795 
v 0.0360635 0.152101 -0.105586 
v 0.0356786 0.152101 -0.103238 
v 0.0358074 0.152101 -0.100863 
v 0.0364438 0.152101 -0.0985714 
v 0.0375579 0.152101 -0.0964699 
v 0.0390978 0.152101 -0.094657 
v 0.0409914 0.152101 -0.0932175 
v 0.0431502 0.152101 -0.0922188 
v 0.0478518 0.152101 -0.0917074 
v 0.0466625 0.152101 -0.0916429 
v 0.0454732 0.152101 -0.0917074 
v 0.0501748 0.152101 -0.0922188 
v 0.0523336 0.152101 -0.0932175 
v 0.0542272 0.152101 -0.094657 
v 0.0557671 0.152101 -0.0964699 
v 0.0568813 0.152101 -0.0985714 
v 0.0575176 0.152101 -0.100863 
v 0.0576464 0.152101 -0.103238 
v 0.0572616 0.152101 -0.105586 
v 0.0563811 0.152101 -0.107795 
v 0.0550463 0.152101 -0.109764 
v 0.0533194 0.152101 -0.1114 
v 0.0512813 0.152101 -0.112626 
v 0.0490272 0.152101 -0.113386 
v 0.0311625 0.152101 -0.123793 
v 0.0313787 0.152101 -0.120131 
v 0.0309463 0.152101 -0.120131 
v 0.0255125 0.152101 -0.114893 
v 0.0293955 0.152101 -0.117206 
v 0.0296382 0.152101 -0.116848 
v 0.0305239 0.152101 -0.120038 
v 0.0301314 0.152101 -0.119857 
v 0.0318011 0.152101 -0.120038 
v 0.0589125 0.152101 -0.123793 
v 0.0325379 0.152101 -0.119595 
v 0.0321936 0.152101 -0.119857 
v 0.0299522 0.152101 -0.116551 
v 0.0255125 0.152101 -0.118143 
v 0.0295071 0.152101 -0.119265 
v 0.0293046 0.152101 -0.118883 
v 0.0297871 0.152101 -0.119595 
v 0.0303227 0.152101 -0.116328 
v 0.0307326 0.152101 -0.11619 
v 0.0292354 0.152101 -0.117608 
v 0.0291654 0.152101 -0.118035 
v 0.0331362 0.152101 -0.118467 
v 0.0330205 0.152101 -0.118883 
v 0.0291889 0.152101 -0.118467 
v 0.0328179 0.152101 -0.119265 
v 0.0311625 0.152101 -0.116143 
v 0.0331596 0.152101 -0.118035 
v 0.0323729 0.152101 -0.116551 
v 0.0326868 0.152101 -0.116848 
v 0.0315924 0.152101 -0.11619 
v 0.0330896 0.152101 -0.117608 
v 0.0329295 0.152101 -0.117206 
v 0.0320023 0.152101 -0.116328 
v 0.0678125 0.152101 -0.118042 
v 0.0678125 0.152101 -0.114893 
v 0.0640896 0.152101 -0.117608 
v 0.0641596 0.152101 -0.118035 
v 0.0607871 0.152101 -0.119595 
v 0.0605071 0.152101 -0.119265 
v 0.0621625 0.152101 -0.123793 
v 0.0619463 0.152101 -0.120131 
v 0.0615239 0.152101 -0.120038 
v 0.0638179 0.152101 -0.119265 
v 0.0635379 0.152101 -0.119595 
v 0.0641362 0.152101 -0.118467 
v 0.0601654 0.152101 -0.118035 
v 0.0602354 0.152101 -0.117608 
v 0.0601889 0.152101 -0.118467 
v 0.0603046 0.152101 -0.118883 
v 0.0623787 0.152101 -0.120131 
v 0.0640205 0.152101 -0.118883 
v 0.0621625 0.152101 -0.116143 
v 0.0606382 0.152101 -0.116848 
v 0.0609522 0.152101 -0.116551 
v 0.0611314 0.152101 -0.119857 
v 0.0628011 0.152101 -0.120038 
v 0.0631936 0.152101 -0.119857 
v 0.0639295 0.152101 -0.117206 
v 0.0625924 0.152101 -0.11619 
v 0.0603955 0.152101 -0.117206 
v 0.0633729 0.152101 -0.116551 
v 0.0636868 0.152101 -0.116848 
v 0.0630023 0.152101 -0.116328 
v 0.0613227 0.152101 -0.116328 
v 0.0617326 0.152101 -0.11619 
v 0.0589125 0.152101 -0.0814929 
v 0.0606382 0.152101 -0.0858482 
v 0.0609522 0.152101 -0.0855508 
v 0.0603955 0.152101 -0.0862061 
v 0.0602354 0.152101 -0.0866079 
v 0.0601654 0.152101 -0.0870347 
v 0.0601889 0.152101 -0.0874665 
v 0.0621625 0.152101 -0.0814929 
v 0.0633729 0.152101 -0.0855508 
v 0.0636868 0.152101 -0.0858482 
v 0.0605071 0.152101 -0.0882653 
v 0.0603046 0.152101 -0.0878832 
v 0.0611314 0.152101 -0.0888567 
v 0.0607871 0.152101 -0.0885949 
v 0.0623787 0.152101 -0.0891312 
v 0.0678125 0.152101 -0.0871429 
v 0.0640205 0.152101 -0.0878832 
v 0.0638179 0.152101 -0.0882653 
v 0.0615239 0.152101 -0.0890383 
v 0.0619463 0.152101 -0.0891312 
v 0.0641362 0.152101 -0.0874665 
v 0.0640896 0.152101 -0.0866079 
v 0.0641596 0.152101 -0.0870347 
v 0.0630023 0.152101 -0.0853278 
v 0.0613227 0.152101 -0.0853278 
v 0.0617326 0.152101 -0.0851897 
v 0.0628011 0.152101 -0.0890383 
v 0.0635379 0.152101 -0.0885949 
v 0.0639295 0.152101 -0.0862061 
v 0.0631936 0.152101 -0.0888567 
v 0.0621625 0.152101 -0.0851429 
v 0.0625924 0.152101 -0.0851897 
v 0.0309463 0.152101 -0.0891312 
v 0.0313787 0.152101 -0.0891312 
v 0.0323729 0.152101 -0.0855508 
v 0.0321936 0.152101 -0.0888567 
v 0.0329295 0.152101 -0.0862061 
v 0.0330896 0.152101 -0.0866079 
v 0.0326868 0.152101 -0.0858482 
v 0.0255125 0.152101 -0.0871429 
v 0.0295071 0.152101 -0.0882653 
v 0.0301314 0.152101 -0.0888567 
v 0.0297871 0.152101 -0.0885949 
v 0.0318011 0.152101 -0.0890383 
v 0.0328179 0.152101 -0.0882653 
v 0.0325379 0.152101 -0.0885949 
v 0.0331362 0.152101 -0.0874665 
v 0.0330205 0.152101 -0.0878832 
v 0.0310985 0.152101 -0.0814929 
v 0.0296382 0.152101 -0.0858482 
v 0.0293046 0.152101 -0.0878832 
v 0.0305239 0.152101 -0.0890383 
v 0.0331596 0.152101 -0.0870347 
v 0.0303227 0.152101 -0.0853278 
v 0.0307326 0.152101 -0.0851897 
v 0.0293955 0.152101 -0.0862061 
v 0.0291889 0.152101 -0.0874665 
v 0.0291654 0.152101 -0.0870347 
v 0.0299522 0.152101 -0.0855508 
v 0.0292354 0.152101 -0.0866079 
v 0.0320023 0.152101 -0.0853278 
v 0.0311625 0.152101 -0.0851429 
v 0.0315924 0.152101 -0.0851897 
v 0.0589125 0.152101 -0.114893 
v 0.0255125 0.199101 -0.0871429 
v 0.0255125 0.199101 -0.114893 
v 0.0255125 0.199101 -0.118143 
v 0.0311625 0.199101 -0.123793 
v 0.0589125 0.199101 -0.123793 
v 0.0621625 0.199101 -0.123793 
v 0.0678125 0.199101 -0.118042 
v 0.0678125 0.199101 -0.114893 
v 0.0678125 0.199101 -0.0871429 
v 0.0621625 0.199101 -0.0814929 
v 0.0589125 0.199101 -0.0814929 
v 0.0310985 0.199101 -0.0814929 
v 0.0311625 0.199101 -0.116143 
v 0.0315924 0.199101 -0.11619 
v 0.0320023 0.199101 -0.116328 
v 0.0323729 0.199101 -0.116551 
v 0.0326868 0.199101 -0.116848 
v 0.0329295 0.199101 -0.117206 
v 0.0330896 0.199101 -0.117608 
v 0.0331596 0.199101 -0.118035 
v 0.0331362 0.199101 -0.118467 
v 0.0330205 0.199101 -0.118883 
v 0.0328179 0.199101 -0.119265 
v 0.0325379 0.199101 -0.119595 
v 0.0321936 0.199101 -0.119857 
v 0.0318011 0.199101 -0.120038 
v 0.0313787 0.199101 -0.120131 
v 0.0309463 0.199101 -0.120131 
v 0.0305239 0.199101 -0.120038 
v 0.0301314 0.199101 -0.119857 
v 0.0297871 0.199101 -0.119595 
v 0.0295071 0.199101 -0.119265 
v 0.0293046 0.199101 -0.118883 
v 0.0291889 0.199101 -0.118467 
v 0.0291654 0.199101 -0.118035 
v 0.0292354 0.199101 -0.117608 
v 0.0293955 0.199101 -0.117206 
v 0.0296382 0.199101 -0.116848 
v 0.0299522 0.199101 -0.116551 
v 0.0303227 0.199101 -0.116328 
v 0.0307326 0.199101 -0.11619 
v 0.0621625 0.199101 -0.116143 
v 0.0625924 0.199101 -0.11619 
v 0.0630023 0.199101 -0.116328 
v 0.0633729 0.199101 -0.116551 
v 0.0636868 0.199101 -0.116848 
v 0.0639295 0.199101 -0.117206 
v 0.0640896 0.199101 -0.117608 
v 0.0641596 0.199101 -0.118035 
v 0.0641362 0.199101 -0.118467 
v 0.0640205 0.199101 -0.118883 
v 0.0638179 0.199101 -0.119265 
v 0.0635379 0.199101 -0.119595 
v 0.0631936 0.199101 -0.119857 
v 0.0628011 0.199101 -0.120038 
v 0.0623787 0.199101 -0.120131 
v 0.0619463 0.199101 -0.120131 
v 0.0615239 0.199101 -0.120038 
v 0.0611314 0.199101 -0.119857 
v 0.0607871 0.199101 -0.119595 
v 0.0605071 0.199101 -0.119265 
v 0.0603046 0.199101 -0.118883 
v 0.0601889 0.199101 -0.118467 
v 0.0601654 0.199101 -0.118035 
v 0.0602354 0.199101 -0.117608 
v 0.0603955 0.199101 -0.117206 
v 0.0606382 0.199101 -0.116848 
v 0.0609522 0.199101 -0.116551 
v 0.0613227 0.199101 -0.116328 
v 0.0617326 0.199101 -0.11619 
v 0.0621625 0.199101 -0.0851429 
v 0.0625924 0.199101 -0.0851897 
v 0.0630023 0.199101 -0.0853278 
v 0.0633729 0.199101 -0.0855508 
v 0.0636868 0.199101 -0.0858482 
v 0.0639295 0.199101 -0.0862061 
v 0.0640896 0.199101 -0.0866079 
v 0.0641596 0.199101 -0.0870347 
v 0.0641362 0.199101 -0.0874665 
v 0.0640205 0.199101 -0.0878832 
v 0.0638179 0.199101 -0.0882653 
v 0.0635379 0.199101 -0.0885949 
v 0.0631936 0.199101 -0.0888567 
v 0.0628011 0.199101 -0.0890383 
v 0.0623787 0.199101 -0.0891312 
v 0.0619463 0.199101 -0.0891312 
v 0.0615239 0.199101 -0.0890383 
v 0.0611314 0.199101 -0.0888567 
v 0.0607871 0.199101 -0.0885949 
v 0.0605071 0.199101 -0.0882653 
v 0.0603046 0.199101 -0.0878832 
v 0.0601889 0.199101 -0.0874665 
v 0.0601654 0.199101 -0.0870347 
v 0.0602354 0.199101 -0.0866079 
v 0.0603955 0.199101 -0.0862061 
v 0.0606382 0.199101 -0.0858482 
v 0.0609522 0.199101 -0.0855508 
v 0.0613227 0.199101 -0.0853278 
v 0.0617326 0.199101 -0.0851897 
v 0.0311625 0.199101 -0.0851429 
v 0.0315924 0.199101 -0.0851897 
v 0.0320023 0.199101 -0.0853278 
v 0.0323729 0.199101 -0.0855508 
v 0.0326868 0.199101 -0.0858482 
v 0.0329295 0.199101 -0.0862061 
v 0.0330896 0.199101 -0.0866079 
v 0.0331596 0.199101 -0.0870347 
v 0.0331362 0.199101 -0.0874665 
v 0.0330205 0.199101 -0.0878832 
v 0.0328179 0.199101 -0.0882653 
v 0.0325379 0.199101 -0.0885949 
v 0.0321936 0.199101 -0.0888567 
v 0.0318011 0.199101 -0.0890383 
v 0.0313787 0.199101 -0.0891312 
v 0.0309463 0.199101 -0.0891312 
v 0.0305239 0.199101 -0.0890383 
v 0.0301314 0.199101 -0.0888567 
v 0.0297871 0.199101 -0.0885949 
v 0.0295071 0.199101 -0.0882653 
v 0.0293046 0.199101 -0.0878832 
v 0.0291889 0.199101 -0.0874665 
v 0.0291654 0.199101 -0.0870347 
v 0.0292354 0.199101 -0.0866079 
v 0.0293955 0.199101 -0.0862061 
v 0.0296382 0.199101 -0.0858482 
v 0.0299522 0.199101 -0.0855508 
v 0.0303227 0.199101 -0.0853278 
v 0.0307326 0.199101 -0.0851897 
v 0.0576464 0.199101 -0.102047 
v 0.0572616 0.199101 -0.0997001 
v 0.0575176 0.199101 -0.104423 
v 0.0420437 0.199101 -0.0926596 
v 0.0400056 0.199101 -0.0938859 
v 0.0369439 0.199101 -0.0974905 
v 0.0364438 0.199101 -0.106714 
v 0.0490272 0.199101 -0.0919001 
v 0.0563811 0.199101 -0.0974905 
v 0.0550463 0.199101 -0.0955217 
v 0.0568813 0.199101 -0.106714 
v 0.0542272 0.199101 -0.110629 
v 0.0557671 0.199101 -0.108816 
v 0.0501748 0.199101 -0.113067 
v 0.0523336 0.199101 -0.112068 
v 0.0382787 0.199101 -0.0955217 
v 0.0360635 0.199101 -0.0997001 
v 0.0390978 0.199101 -0.110629 
v 0.0409914 0.199101 -0.112068 
v 0.0512813 0.199101 -0.0926596 
v 0.0454732 0.199101 -0.113578 
v 0.0442978 0.199101 -0.0919001 
v 0.0466625 0.199101 -0.0916429 
v 0.0356786 0.199101 -0.102047 
v 0.0358074 0.199101 -0.104423 
v 0.0431502 0.199101 -0.113067 
v 0.0375579 0.199101 -0.108816 
v 0.0478518 0.199101 -0.113578 
v 0.0533194 0.199101 -0.0938859 
v 0.0589125 0.199101 -0.114893 
v 0.0490272 0.197101 -0.0919001 
v 0.0466625 0.197101 -0.0916429 
v 0.0512813 0.197101 -0.0926596 
v 0.0533194 0.197101 -0.0938859 
v 0.0550463 0.197101 -0.0955217 
v 0.0563811 0.197101 -0.0974905 
v 0.0572616 0.197101 -0.0997001 
v 0.0576464 0.197101 -0.102047 
v 0.0575176 0.197101 -0.104423 
v 0.0568813 0.197101 -0.106714 
v 0.0557671 0.197101 -0.108816 
v 0.0542272 0.197101 -0.110629 
v 0.0523336 0.197101 -0.112068 
v 0.0501748 0.197101 -0.113067 
v 0.0478518 0.197101 -0.113578 
v 0.0454732 0.197101 -0.113578 
v 0.0431502 0.197101 -0.113067 
v 0.0409914 0.197101 -0.112068 
v 0.0390978 0.197101 -0.110629 
v 0.0375579 0.197101 -0.108816 
v 0.0364438 0.197101 -0.106714 
v 0.0358074 0.197101 -0.104423 
v 0.0356786 0.197101 -0.102047 
v 0.0360635 0.197101 -0.0997001 
v 0.0369439 0.197101 -0.0974905 
v 0.0382787 0.197101 -0.0955217 
v 0.0400056 0.197101 -0.0938859 
v 0.0420437 0.197101 -0.0926596 
v 0.0442978 0.197101 -0.0919001 
v 0.0456128 0.197101 -0.100374 
v 0.0451496 0.197101 -0.100653 
v 0.0461251 0.197101 -0.100201 
v 0.0466625 0.197101 -0.100143 
v 0.0471999 0.197101 -0.100201 
v 0.0458643 0.197101 -0.105012 
v 0.0463922 0.197101 -0.105128 
v 0.0453736 0.197101 -0.104785 
v 0.0449433 0.197101 -0.104458 
v 0.0445933 0.197101 -0.104046 
v 0.0442536 0.197101 -0.101974 
v 0.0441662 0.197101 -0.102508 
v 0.0444537 0.197101 -0.101472 
v 0.0447571 0.197101 -0.101024 
v 0.0488713 0.197101 -0.101472 
v 0.0485679 0.197101 -0.101024 
v 0.0490714 0.197101 -0.101974 
v 0.0441954 0.197101 -0.103047 
v 0.0443401 0.197101 -0.103568 
v 0.0477122 0.197101 -0.100374 
v 0.0481754 0.197101 -0.100653 
v 0.0491588 0.197101 -0.102508 
v 0.0491296 0.197101 -0.103047 
v 0.048985 0.197101 -0.103568 
v 0.0487317 0.197101 -0.104046 
v 0.0483818 0.197101 -0.104458 
v 0.0479514 0.197101 -0.104785 
v 0.0474608 0.197101 -0.105012 
v 0.0469328 0.197101 -0.105128 
v 0.0471999 0.152101 -0.100201 
v 0.0466625 0.152101 -0.100143 
v 0.0477122 0.152101 -0.100374 
v 0.0481754 0.152101 -0.100653 
v 0.0485679 0.152101 -0.101024 
v 0.0488713 0.152101 -0.101472 
v 0.0490714 0.152101 -0.101974 
v 0.0491588 0.152101 -0.102508 
v 0.0491296 0.152101 -0.103047 
v 0.048985 0.152101 -0.103568 
v 0.0487317 0.152101 -0.104046 
v 0.0483818 0.152101 -0.104458 
v 0.0479514 0.152101 -0.104785 
v 0.0474608 0.152101 -0.105012 
v 0.0469328 0.152101 -0.105128 
v 0.0463922 0.152101 -0.105128 
v 0.0458643 0.152101 -0.105012 
v 0.0453736 0.152101 -0.104785 
v 0.0449433 0.152101 -0.104458 
v 0.0445933 0.152101 -0.104046 
v 0.0443401 0.152101 -0.103568 
v 0.0441954 0.152101 -0.103047 
v 0.0441662 0.152101 -0.102508 
v 0.0442536 0.152101 -0.101974 
v 0.0444537 0.152101 -0.101472 
v 0.0447571 0.152101 -0.101024 
v 0.0451496 0.152101 -0.100653 
v 0.0456128 0.152101 -0.100374 
v 0.0461251 0.152101 -0.100201 
v 0.0466625 0.152101 -0.102643 
vn 0.0788915 -0.986425 -0.144018 
vn 0.0596907 0.133884 -0.989198 
vn -0.131323 0.135734 -0.982003 
vn -0.319962 0.138228 -0.937293 
vn -0.499341 0.141339 -0.854799 
vn -0.662044 0.145025 -0.735299 
vn -0.800166 0.149205 -0.580924 
vn -0.905473 0.153754 -0.395574 
vn -0.969798 0.158487 -0.185402 
vn -0.98576 0.163148 0.0407481 
vn -0.947867 0.167415 0.271147 
vn -0.853923 0.170926 0.491528 
vn -0.706407 0.173331 0.686255 
vn -0.51326 0.174359 0.840335 
vn -0.28751 0.173887 0.941861 
vn -0.0455722 0.171972 0.984047 
vn 0.195288 0.168836 0.966104 
vn 0.0760322 0.170538 0.982413 
vn -0.0455722 0.171972 0.984047 
vn 0.195288 0.168836 0.966104 
vn 0.419456 0.164809 0.89269 
vn 0.614637 0.160255 0.77236 
vn 0.772468 0.155515 0.615718 
vn 0.88826 0.150871 0.433857 
vn 0.960313 0.146535 0.237331 
vn 0.989131 0.142654 0.0356294 
vn 0.976743 0.139321 -0.162981 
vn 0.9262 0.136592 -0.35142 
vn 0.841236 0.1345 -0.523671 
vn 0.726064 0.133059 -0.67463 
vn 0.585264 0.132275 -0.799981 
vn 0.423735 0.132152 -0.896094 
vn 0.246691 0.132689 -0.959967 
vn 0.0788915 -0.986425 -0.144018 
vn 0.0596907 0.133884 -0.989198 
vn -0.131323 0.135734 -0.982003 
vn -0.319962 0.138228 -0.937293 
vn -0.499341 0.141339 -0.854799 
vn -0.662044 0.145025 -0.735299 
vn -0.800166 0.149205 -0.580924 
vn -0.905473 0.153754 -0.395574 
vn -0.969798 0.158487 -0.185402 
vn -0.98576 0.163148 0.0407481 
vn -0.947867 0.167415 0.271147 
vn -0.853923 0.170926 0.491528 
vn -0.706407 0.173331 0.686255 
vn -0.51326 0.174359 0.840335 
vn -0.28751 0.173887 0.941861 
vn -0.0455722 0.171972 0.984047 
vn 0.195288 0.168836 0.966104 
vn 0.0760322 0.170538 0.982413 
vn -0.0455722 0.171972 0.984047 
vn 0.419456 0.164809 0.89269 
vn 0.614637 0.160255 0.77236 
vn 0.772468 0.155515 0.615718 
vn 0.88826 0.150871 0.433857 
vn 0.960313 0.146535 0.237331 
vn 0.989131 0.142654 0.0356294 
vn 0.976743 0.139321 -0.162981 
vn 0.9262 0.136592 -0.35142 
vn 0.841236 0.1345 -0.523671 
vn 0.726064 0.133059 -0.67463 
vn 0.585264 0.132275 -0.799981 
vn 0.423735 0.132152 -0.896094 
vn 0.246691 0.132689 -0.959967 
vn 0.0788915 -0.986425 -0.144018 
vn -0.978579 0.159671 -0.129954 
vn -0.603477 0.14358 -0.784347 
vn 0.0596907 0.133884 -0.989198 
vn 0.681622 0.132724 -0.719566 
vn 0.98355 0.140099 -0.114024 
vn 0.789301 0.154924 0.59414 
vn 0.0760322 0.170538 0.982413 
vn -0.731914 0.17305 0.659057 
vn -0.131323 0.135734 -0.982003 
vn 0.0596907 0.133884 -0.989198 
vn -0.319962 0.138228 -0.937293 
vn -0.131323 0.135734 -0.982003 
vn -0.499341 0.141339 -0.854799 
vn -0.319962 0.138228 -0.937293 
vn -0.662044 0.145025 -0.735299 
vn -0.499341 0.141339 -0.854799 
vn -0.800166 0.149205 -0.580924 
vn -0.662044 0.145025 -0.735299 
vn -0.905473 0.153754 -0.395574 
vn -0.800166 0.149205 -0.580924 
vn -0.969798 0.158487 -0.185402 
vn -0.905473 0.153754 -0.395574 
vn -0.98576 0.163148 0.0407481 
vn -0.969798 0.158487 -0.185402 
vn -0.947867 0.167415 0.271147 
vn -0.98576 0.163148 0.0407481 
vn -0.853923 0.170926 0.491528 
vn -0.947867 0.167415 0.271147 
vn -0.706407 0.173331 0.686255 
vn -0.853923 0.170926 0.491528 
vn -0.51326 0.174359 0.840335 
vn -0.706407 0.173331 0.686255 
vn -0.28751 0.173887 0.941861 
vn -0.51326 0.174359 0.840335 
vn -0.0455722 0.171972 0.984047 
vn -0.28751 0.173887 0.941861 
vn 0.195288 0.168836 0.966104 
vn -0.0455722 0.171972 0.984047 
vn 0.419456 0.164809 0.89269 
vn 0.195288 0.168836 0.966104 
vn 0.614637 0.160255 0.77236 
vn 0.419456 0.164809 0.89269 
vn 0.772468 0.155515 0.615718 
vn 0.614637 0.160255 0.77236 
vn 0.88826 0.150871 0.433857 
vn 0.772468 0.155515 0.615718 
vn 0.960313 0.146535 0.237331 
vn 0.88826 0.150871 0.433857 
vn 0.989131 0.142654 0.0356294 
vn 0.960313 0.146535 0.237331 
vn 0.976743 0.139321 -0.162981 
vn 0.989131 0.142654 0.0356294 
vn 0.9262 0.136592 -0.35142 
vn 0.976743 0.139321 -0.162981 
vn 0.841236 0.1345 -0.523671 
vn 0.9262 0.136592 -0.35142 
vn 0.726064 0.133059 -0.67463 
vn 0.841236 0.1345 -0.523671 
vn 0.585264 0.132275 -0.799981 
vn 0.726064 0.133059 -0.67463 
vn 0.423735 0.132152 -0.896094 
vn 0.585264 0.132275 -0.799981 
vn 0.246691 0.132689 -0.959967 
vn 0.423735 0.132152 -0.896094 
vn -0.131323 0.135734 -0.982003 
vn 0.0596907 0.133884 -0.989198 
vn -0.319962 0.138228 -0.937293 
vn -0.131323 0.135734 -0.982003 
vn -0.499341 0.141339 -0.854799 
vn -0.319962 0.138228 -0.937293 
vn -0.662044 0.145025 -0.735299 
vn -0.499341 0.141339 -0.854799 
vn -0.800166 0.149205 -0.580924 
vn -0.662044 0.145025 -0.735299 
vn -0.905473 0.153754 -0.395574 
vn -0.800166 0.149205 -0.580924 
vn -0.969798 0.158487 -0.185402 
vn -0.905473 0.153754 -0.395574 
vn -0.98576 0.163148 0.0407481 
vn -0.969798 0.158487 -0.185402 
vn -0.947867 0.167415 0.271147 
vn -0.98576 0.163148 0.0407481 
vn -0.853923 0.170926 0.491528 
vn -0.947867 0.167415 0.271147 
vn -0.706407 0.173331 0.686255 
vn -0.853923 0.170926 0.491528 
vn -0.51326 0.174359 0.840335 
vn -0.706407 0.173331 0.686255 
vn -0.28751 0.173887 0.941861 
vn -0.51326 0.174359 0.840335 
vn -0.0455722 0.171972 0.984047 
vn -0.28751 0.173887 0.941861 
vn 0.195288 0.168836 0.966104 
vn -0.0455722 0.171972 0.984047 
vn 0.419456 0.164809 0.89269 
vn 0.195288 0.168836 0.966104 
vn 0.614637 0.160255 0.77236 
vn 0.419456 0.164809 0.89269 
vn 0.772468 0.155515 0.615718 
vn 0.614637 0.160255 0.77236 
vn 0.88826 0.150871 0.433857 
vn 0.772468 0.155515 0.615718 
vn 0.960313 0.146535 0.237331 
vn 0.88826 0.150871 0.433857 
vn 0.989131 0.142654 0.0356294 
vn 0.960313 0.146535 0.237331 
vn 0.976743 0.139321 -0.162981 
vn 0.989131 0.142654 0.0356294 
vn 0.9262 0.136592 -0.35142 
vn 0.976743 0.139321 -0.162981 
vn 0.841236 0.1345 -0.523671 
vn 0.9262 0.136592 -0.35142 
vn 0.726064 0.133059 -0.67463 
vn 0.841236 0.1345 -0.523671 
vn 0.585264 0.132275 -0.799981 
vn 0.726064 0.133059 -0.67463 
vn 0.423735 0.132152 -0.896094 
vn 0.585264 0.132275 -0.799981 
vn 0.246691 0.132689 -0.959967 
vn 0.423735 0.132152 -0.896094 
vn -0.131323 0.135734 -0.982003 
vn 0.0596907 0.133884 -0.989198 
vn -0.319962 0.138228 -0.937293 
vn -0.131323 0.135734 -0.982003 
vn -0.499341 0.141339 -0.854799 
vn -0.319962 0.138228 -0.937293 
vn -0.662044 0.145025 -0.735299 
vn -0.499341 0.141339 -0.854799 
vn -0.800166 0.149205 -0.580924 
vn -0.662044 0.145025 -0.735299 
vn -0.905473 0.153754 -0.395574 
vn -0.800166 0.149205 -0.580924 
vn -0.969798 0.158487 -0.185402 
vn -0.905473 0.153754 -0.395574 
vn -0.98576 0.163148 0.0407481 
vn -0.969798 0.158487 -0.185402 
vn -0.947867 0.167415 0.271147 
vn -0.98576 0.163148 0.0407481 
vn -0.853923 0.170926 0.491528 
vn -0.947867 0.167415 0.271147 
vn -0.706407 0.173331 0.686255 
vn -0.853923 0.170926 0.491528 
vn -0.51326 0.174359 0.840335 
vn -0.706407 0.173331 0.686255 
vn -0.28751 0.173887 0.941861 
vn -0.51326 0.174359 0.840335 
vn -0.0455722 0.171972 0.984047 
vn -0.28751 0.173887 0.941861 
vn 0.195288 0.168836 0.966104 
vn -0.0455722 0.171972 0.984047 
vn 0.419456 0.164809 0.89269 
vn 0.195288 0.168836 0.966104 
vn 0.614637 0.160255 0.77236 
vn 0.419456 0.164809 0.89269 
vn 0.772468 0.155515 0.615718 
vn 0.614637 0.160255 0.77236 
vn 0.88826 0.150871 0.433857 
vn 0.772468 0.155515 0.615718 
vn 0.960313 0.146535 0.237331 
vn 0.88826 0.150871 0.433857 
vn 0.989131 0.142654 0.0356294 
vn 0.960313 0.146535 0.237331 
vn 0.976743 0.139321 -0.162981 
vn 0.989131 0.142654 0.0356294 
vn 0.9262 0.136592 -0.35142 
vn 0.976743 0.139321 -0.162981 
vn 0.841236 0.1345 -0.523671 
vn 0.9262 0.136592 -0.35142 
vn 0.726064 0.133059 -0.67463 
vn 0.841236 0.1345 -0.523671 
vn 0.585264 0.132275 -0.799981 
vn 0.726064 0.133059 -0.67463 
vn 0.423735 0.132152 -0.896094 
vn 0.585264 0.132275 -0.799981 
vn 0.246691 0.132689 -0.959967 
vn 0.423735 0.132152 -0.896094 
vn -0.131323 0.135734 -0.982003 
vn 0.0596907 0.133884 -0.989198 
vn -0.319962 0.138228 -0.937293 
vn -0.131323 0.135734 -0.982003 
vn -0.499341 0.141339 -0.854799 
vn -0.319962 0.138228 -0.937293 
vn -0.662044 0.145025 -0.735299 
vn -0.499341 0.141339 -0.854799 
vn -0.800166 0.149205 -0.580924 
vn -0.662044 0.145025 -0.735299 
vn -0.905473 0.153754 -0.395574 
vn -0.800166 0.149205 -0.580924 
vn -0.969798 0.158487 -0.185402 
vn -0.905473 0.153754 -0.395574 
vn -0.98576 0.163148 0.0407481 
vn -0.969798 0.158487 -0.185402 
vn -0.947867 0.167415 0.271147 
vn -0.98576 0.163148 0.0407481 
vn -0.853923 0.170926 0.491528 
vn -0.947867 0.167415 0.271147 
vn -0.706407 0.173331 0.686255 
vn -0.853923 0.170926 0.491528 
vn -0.51326 0.174359 0.840335 
vn -0.706407 0.173331 0.686255 
vn -0.28751 0.173887 0.941861 
vn -0.51326 0.174359 0.840335 
vn -0.0455722 0.171972 0.984047 
vn -0.28751 0.173887 0.941861 
vn 0.195288 0.168836 0.966104 
vn -0.0455722 0.171972 0.984047 
vn 0.419456 0.164809 0.89269 
vn 0.195288 0.168836 0.966104 
vn 0.614637 0.160255 0.77236 
vn 0.419456 0.164809 0.89269 
vn 0.772468 0.155515 0.615718 
vn 0.614637 0.160255 0.77236 
vn 0.88826 0.150871 0.433857 
vn 0.772468 0.155515 0.615718 
vn 0.960313 0.146535 0.237331 
vn 0.88826 0.150871 0.433857 
vn 0.989131 0.142654 0.0356294 
vn 0.960313 0.146535 0.237331 
vn 0.976743 0.139321 -0.162981 
vn 0.989131 0.142654 0.0356294 
vn 0.9262 0.136592 -0.35142 
vn 0.976743 0.139321 -0.162981 
vn 0.841236 0.1345 -0.523671 
vn 0.9262 0.136592 -0.35142 
vn 0.726064 0.133059 -0.67463 
vn 0.841236 0.1345 -0.523671 
vn 0.585264 0.132275 -0.799981 
vn 0.726064 0.133059 -0.67463 
vn 0.423735 0.132152 -0.896094 
vn 0.585264 0.132275 -0.799981 
vn 0.246691 0.132689 -0.959967 
vn 0.423735 0.132152 -0.896094 
vn 0.058423 0.992578 -0.106652 
vn -0.131323 0.135734 -0.982003 
vn 0.0596907 0.133884 -0.989198 
vn -0.319962 0.138228 -0.937293 
vn -0.131323 0.135734 -0.982003 
vn -0.499341 0.141339 -0.854799 
vn -0.319962 0.138228 -0.937293 
vn -0.662044 0.145025 -0.735299 
vn -0.499341 0.141339 -0.854799 
vn -0.800166 0.149205 -0.580924 
vn -0.662044 0.145025 -0.735299 
vn -0.905473 0.153754 -0.395574 
vn -0.800166 0.149205 -0.580924 
vn -0.969798 0.158487 -0.185402 
vn -0.905473 0.153754 -0.395574 
vn -0.98576 0.163148 0.0407481 
vn -0.969798 0.158487 -0.185402 
vn -0.947867 0.167415 0.271147 
vn -0.98576 0.163148 0.0407481 
vn -0.853923 0.170926 0.491528 
vn -0.947867 0.167415 0.271147 
vn -0.706407 0.173331 0.686255 
vn -0.853923 0.170926 0.491528 
vn -0.51326 0.174359 0.840335 
vn -0.706407 0.173331 0.686255 
vn -0.28751 0.173887 0.941861 
vn -0.51326 0.174359 0.840335 
vn -0.0455722 0.171972 0.984047 
vn -0.28751 0.173887 0.941861 
vn 0.195288 0.168836 0.966104 
vn -0.0455722 0.171972 0.984047 
vn 0.419456 0.164809 0.89269 
vn 0.195288 0.168836 0.966104 
vn 0.614637 0.160255 0.77236 
vn 0.419456 0.164809 0.89269 
vn 0.772468 0.155515 0.615718 
vn 0.614637 0.160255 0.77236 
vn 0.88826 0.150871 0.433857 
vn 0.772468 0.155515 0.615718 
vn 0.960313 0.146535 0.237331 
vn 0.88826 0.150871 0.433857 
vn 0.989131 0.142654 0.0356294 
vn 0.960313 0.146535 0.237331 
vn 0.976743 0.139321 -0.162981 
vn 0.989131 0.142654 0.0356294 
vn 0.9262 0.136592 -0.35142 
vn 0.976743 0.139321 -0.162981 
vn 0.841236 0.1345 -0.523671 
vn 0.9262 0.136592 -0.35142 
vn 0.726064 0.133059 -0.67463 
vn 0.841236 0.1345 -0.523671 
vn 0.585264 0.132275 -0.799981 
vn 0.726064 0.133059 -0.67463 
vn 0.423735 0.132152 -0.896094 
vn 0.585264 0.132275 -0.799981 
vn 0.246691 0.132689 -0.959967 
vn 0.423735 0.132152 -0.896094 
vn 0.058423 0.992578 -0.106652 
vn -0.131323 0.135734 -0.982003 
vn 0.0596907 0.133884 -0.989198 
vn -0.319962 0.138228 -0.937293 
vn -0.131323 0.135734 -0.982003 
vn -0.499341 0.141339 -0.854799 
vn -0.319962 0.138228 -0.937293 
vn -0.662044 0.145025 -0.735299 
vn -0.499341 0.141339 -0.854799 
vn -0.800166 0.149205 -0.580924 
vn -0.662044 0.145025 -0.735299 
vn -0.905473 0.153754 -0.395574 
vn -0.800166 0.149205 -0.580924 
vn -0.969798 0.158487 -0.185402 
vn -0.905473 0.153754 -0.395574 
vn -0.98576 0.163148 0.0407481 
vn -0.969798 0.158487 -0.185402 
vn -0.947867 0.167415 0.271147 
vn -0.98576 0.163148 0.0407481 
vn -0.853923 0.170926 0.491528 
vn -0.947867 0.167415 0.271147 
vn -0.706407 0.173331 0.686255 
vn -0.853923 0.170926 0.491528 
vn -0.51326 0.174359 0.840335 
vn -0.706407 0.173331 0.686255 
vn -0.28751 0.173887 0.941861 
vn -0.51326 0.174359 0.840335 
vn -0.0455722 0.171972 0.984047 
vn -0.28751 0.173887 0.941861 
vn 0.195288 0.168836 0.966104 
vn -0.0455722 0.171972 0.984047 
vn 0.419456 0.164809 0.89269 
vn 0.195288 0.168836 0.966104 
vn 0.614637 0.160255 0.77236 
vn 0.419456 0.164809 0.89269 
vn 0.772468 0.155515 0.615718 
vn 0.614637 0.160255 0.77236 
vn 0.88826 0.150871 0.433857 
vn 0.772468 0.155515 0.615718 
vn 0.960313 0.146535 0.237331 
vn 0.88826 0.150871 0.433857 
vn 0.989131 0.142654 0.0356294 
vn 0.960313 0.146535 0.237331 
vn 0.976743 0.139321 -0.162981 
vn 0.989131 0.142654 0.0356294 
vn 0.9262 0.136592 -0.35142 
vn 0.976743 0.139321 -0.162981 
vn 0.841236 0.1345 -0.523671 
vn 0.9262 0.136592 -0.35142 
vn 0.726064 0.133059 -0.67463 
vn 0.841236 0.1345 -0.523671 
vn 0.585264 0.132275 -0.799981 
vn 0.726064 0.133059 -0.67463 
vn 0.423735 0.132152 -0.896094 
vn 0.585264 0.132275 -0.799981 
vn 0.246691 0.132689 -0.959967 
vn 0.423735 0.132152 -0.896094 
vn 0.058423 0.992578 -0.106652 
usemtl 0.349020_0.376471_0.400000_0.000000_0.000000
o mesh207
f 1594//1480 1564//1480 1565//1480 
f 1565//1480 1566//1480 1594//1480 
f 1566//1480 1567//1480 1594//1480 
f 1567//1480 1568//1480 1594//1480 
f 1568//1480 1569//1480 1594//1480 
f 1569//1480 1570//1480 1594//1480 
f 1570//1480 1571//1480 1594//1480 
f 1571//1480 1572//1480 1594//1480 
f 1572//1480 1573//1480 1594//1480 
f 1573//1480 1574//1480 1594//1480 
f 1574//1480 1575//1480 1594//1480 
f 1575//1480 1576//1480 1594//1480 
f 1576//1480 1577//1480 1594//1480 
f 1577//1480 1578//1480 1594//1480 
f 1578//1480 1579//1480 1594//1480 
f 1579//1480 1580//1480 1594//1480 
f 1580//1480 1581//1480 1594//1480 
f 1581//1480 1582//1480 1594//1480 
f 1582//1480 1583//1480 1594//1480 
f 1583//1480 1584//1480 1594//1480 
f 1584//1480 1585//1480 1594//1480 
f 1585//1480 1586//1480 1594//1480 
f 1586//1480 1587//1480 1594//1480 
f 1587//1480 1588//1480 1594//1480 
f 1588//1480 1589//1480 1594//1480 
f 1589//1480 1590//1480 1594//1480 
f 1590//1480 1591//1480 1594//1480 
f 1591//1480 1592//1480 1594//1480 
f 1592//1480 1593//1480 1594//1480 
f 1593//1480 1564//1480 1594//1480 
o mesh208
f 1595//1481 1578//1481 1577//1482 
f 1596//1482 1577//1482 1576//1483 
f 1597//1483 1576//1483 1575//1484 
f 1598//1484 1575//1484 1574//1485 
f 1599//1485 1574//1485 1573//1486 
f 1600//1486 1573//1486 1572//1487 
f 1601//1487 1572//1487 1571//1488 
f 1602//1488 1571//1488 1570//1489 
f 1603//1489 1570//1489 1569//1490 
f 1604//1490 1569//1490 1568//1491 
f 1605//1491 1568//1491 1567//1492 
f 1606//1492 1567//1492 1566//1493 
f 1607//1493 1566//1493 1565//1494 
f 1608//1494 1565//1494 1564//1495 
f 1609//1496 1610//1497 1593//1497 
f 1564//1495 1593//1497 1610//1497 
f 1610//1497 1611//1498 1564//1495 
f 1609//1496 1592//1499 1591//1500 
f 1612//1500 1591//1500 1590//1501 
f 1613//1501 1590//1501 1589//1502 
f 1614//1502 1589//1502 1588//1503 
f 1615//1503 1588//1503 1587//1504 
f 1616//1504 1587//1504 1586//1505 
f 1617//1505 1586//1505 1585//1506 
f 1618//1506 1585//1506 1584//1507 
f 1619//1507 1584//1507 1583//1508 
f 1620//1508 1583//1508 1582//1509 
f 1621//1509 1582//1509 1581//1510 
f 1622//1510 1581//1510 1580//1511 
f 1623//1511 1580//1511 1579//1512 
f 1624//1512 1579//1512 1578//1481 
f 1578//1481 1595//1481 1624//1512 
f 1579//1512 1624//1512 1623//1511 
f 1580//1511 1623//1511 1622//1510 
f 1581//1510 1622//1510 1621//1509 
f 1582//1509 1621//1509 1620//1508 
f 1583//1508 1620//1508 1619//1507 
f 1584//1507 1619//1507 1618//1506 
f 1585//1506 1618//1506 1617//1505 
f 1586//1505 1617//1505 1616//1504 
f 1587//1504 1616//1504 1615//1503 
f 1588//1503 1615//1503 1614//1502 
f 1589//1502 1614//1502 1613//1501 
f 1590//1501 1613//1501 1612//1500 
f 1591//1500 1612//1500 1609//1496 
f 1593//1497 1592//1499 1609//1496 
f 1564//1495 1611//1498 1608//1494 
f 1565//1494 1608//1494 1607//1493 
f 1566//1493 1607//1493 1606//1492 
f 1567//1492 1606//1492 1605//1491 
f 1568//1491 1605//1491 1604//1490 
f 1569//1490 1604//1490 1603//1489 
f 1570//1489 1603//1489 1602//1488 
f 1571//1488 1602//1488 1601//1487 
f 1572//1487 1601//1487 1600//1486 
f 1573//1486 1600//1486 1599//1485 
f 1574//1485 1599//1485 1598//1484 
f 1575//1484 1598//1484 1597//1483 
f 1576//1483 1597//1483 1596//1482 
f 1577//1482 1596//1482 1595//1481 
o mesh209
f 1625//1513 1626//1513 1611//1513 
f 1627//1513 1608//1513 1611//1513 
f 1628//1513 1597//1513 1598//1513 
f 1629//1513 1596//1513 1597//1513 
f 1630//1513 1595//1513 1596//1513 
f 1630//1513 1631//1513 1624//1513 
f 1611//1513 1626//1513 1627//1513 
f 1632//1513 1607//1513 1608//1513 
f 1633//1513 1606//1513 1607//1513 
f 1633//1513 1634//1513 1605//1513 
f 1635//1513 1601//1513 1602//1513 
f 1635//1513 1636//1513 1600//1513 
f 1637//1513 1599//1513 1600//1513 
f 1637//1513 1638//1513 1598//1513 
f 1597//1513 1628//1513 1629//1513 
f 1624//1513 1595//1513 1630//1513 
f 1639//1513 1620//1513 1621//1513 
f 1640//1513 1619//1513 1620//1513 
f 1608//1513 1627//1513 1632//1513 
f 1605//1513 1606//1513 1633//1513 
f 1641//1513 1603//1513 1604//1513 
f 1641//1513 1642//1513 1602//1513 
f 1600//1513 1601//1513 1635//1513 
f 1598//1513 1599//1513 1637//1513 
f 1596//1513 1629//1513 1630//1513 
f 1631//1513 1643//1513 1623//1513 
f 1644//1513 1622//1513 1623//1513 
f 1644//1513 1645//1513 1621//1513 
f 1620//1513 1639//1513 1640//1513 
f 1646//1513 1618//1513 1619//1513 
f 1647//1513 1617//1513 1618//1513 
f 1647//1513 1648//1513 1616//1513 
f 1607//1513 1632//1513 1633//1513 
f 1634//1513 1649//1513 1604//1513 
f 1602//1513 1603//1513 1641//1513 
f 1600//1513 1636//1513 1637//1513 
f 1623//1513 1624//1513 1631//1513 
f 1621//1513 1622//1513 1644//1513 
f 1619//1513 1640//1513 1646//1513 
f 1616//1513 1617//1513 1647//1513 
f 1650//1513 1615//1513 1616//1513 
f 1650//1513 1651//1513 1614//1513 
f 1652//1513 1613//1513 1614//1513 
f 1652//1513 1653//1513 1612//1513 
f 1604//1513 1605//1513 1634//1513 
f 1602//1513 1642//1513 1635//1513 
f 1623//1513 1643//1513 1644//1513 
f 1618//1513 1646//1513 1647//1513 
f 1614//1513 1615//1513 1650//1513 
f 1612//1513 1613//1513 1652//1513 
f 1654//1513 1609//1513 1612//1513 
f 1654//1513 1625//1513 1610//1513 
f 1604//1513 1649//1513 1641//1513 
f 1621//1513 1645//1513 1639//1513 
f 1614//1513 1651//1513 1652//1513 
f 1610//1513 1609//1513 1654//1513 
f 1598//1513 1638//1513 1628//1513 
f 1612//1513 1653//1513 1654//1513 
f 1616//1513 1648//1513 1650//1513 
f 1611//1513 1610//1513 1625//1513 
o mesh210
f 1655//1514 1630//1514 1629//1515 
f 1656//1515 1629//1515 1628//1516 
f 1657//1516 1628//1516 1638//1517 
f 1658//1517 1638//1517 1637//1518 
f 1659//1518 1637//1518 1636//1519 
f 1660//1519 1636//1519 1635//1520 
f 1661//1520 1635//1520 1642//1521 
f 1662//1521 1642//1521 1641//1522 
f 1663//1522 1641//1522 1649//1523 
f 1664//1523 1649//1523 1634//1524 
f 1665//1524 1634//1524 1633//1525 
f 1666//1525 1633//1525 1632//1526 
f 1667//1526 1632//1526 1627//1527 
f 1668//1527 1627//1527 1626//1528 
f 1654//1529 1669//1529 1670//1530 
f 1671//1531 1626//1528 1625//1530 
f 1625//1530 1670//1530 1671//1531 
f 1669//1529 1654//1529 1653//1532 
f 1672//1532 1653//1532 1652//1533 
f 1673//1533 1652//1533 1651//1534 
f 1674//1534 1651//1534 1650//1535 
f 1675//1535 1650//1535 1648//1536 
f 1676//1536 1648//1536 1647//1537 
f 1677//1537 1647//1537 1646//1538 
f 1678//1538 1646//1538 1640//1539 
f 1679//1539 1640//1539 1639//1540 
f 1680//1540 1639//1540 1645//1541 
f 1681//1541 1645//1541 1644//1542 
f 1682//1542 1644//1542 1643//1543 
f 1683//1543 1643//1543 1631//1544 
f 1684//1544 1631//1544 1630//1514 
f 1630//1514 1655//1514 1684//1544 
f 1631//1544 1684//1544 1683//1543 
f 1643//1543 1683//1543 1682//1542 
f 1644//1542 1682//1542 1681//1541 
f 1645//1541 1681//1541 1680//1540 
f 1639//1540 1680//1540 1679//1539 
f 1640//1539 1679//1539 1678//1538 
f 1646//1538 1678//1538 1677//1537 
f 1647//1537 1677//1537 1676//1536 
f 1648//1536 1676//1536 1675//1535 
f 1650//1535 1675//1535 1674//1534 
f 1651//1534 1674//1534 1673//1533 
f 1652//1533 1673//1533 1672//1532 
f 1653//1532 1672//1532 1669//1529 
f 1670//1530 1625//1530 1654//1529 
f 1626//1528 1671//1531 1668//1527 
f 1627//1527 1668//1527 1667//1526 
f 1632//1526 1667//1526 1666//1525 
f 1633//1525 1666//1525 1665//1524 
f 1634//1524 1665//1524 1664//1523 
f 1649//1523 1664//1523 1663//1522 
f 1641//1522 1663//1522 1662//1521 
f 1642//1521 1662//1521 1661//1520 
f 1635//1520 1661//1520 1660//1519 
f 1636//1519 1660//1519 1659//1518 
f 1637//1518 1659//1518 1658//1517 
f 1638//1517 1658//1517 1657//1516 
f 1628//1516 1657//1516 1656//1515 
f 1629//1515 1656//1515 1655//1514 
o mesh211
f 1685//1545 1686//1545 1687//1545 
f 1688//1545 1689//1545 1690//1545 
f 1685//1545 1691//1545 1692//1545 
f 1685//1545 1693//1545 1686//1545 
f 1694//1545 1695//1545 1696//1545 
f 1690//1545 1697//1545 1688//1545 
f 1698//1545 1699//1545 1700//1545 
f 1698//1545 1685//1545 1701//1545 
f 1687//1545 1691//1545 1685//1545 
f 1696//1545 1685//1545 1694//1545 
f 1688//1545 1702//1545 1703//1545 
f 1688//1545 1704//1545 1689//1545 
f 1698//1545 1705//1545 1704//1545 
f 1701//1545 1699//1545 1698//1545 
f 1696//1545 1693//1545 1685//1545 
f 1694//1545 1706//1545 1707//1545 
f 1697//1545 1702//1545 1688//1545 
f 1698//1545 1708//1545 1705//1545 
f 1692//1545 1701//1545 1685//1545 
f 1707//1545 1709//1545 1694//1545 
f 1813//1545 1688//1545 1710//1545 
f 1704//1545 1688//1545 1698//1545 
f 1709//1545 1695//1545 1694//1545 
f 1694//1545 1813//1545 1711//1545 
f 1813//1545 1712//1545 1713//1545 
f 1710//1545 1714//1545 1813//1545 
f 1700//1545 1708//1545 1698//1545 
f 1813//1545 1715//1545 1711//1545 
f 1713//1545 1716//1545 1813//1545 
f 1714//1545 1717//1545 1813//1545 
f 1711//1545 1706//1545 1694//1545 
f 1717//1545 1712//1545 1813//1545 
f 1716//1545 1715//1545 1813//1545 
f 1718//1545 1719//1545 1720//1545 
f 1720//1545 1721//1545 1718//1545 
f 1694//1545 1722//1545 1723//1545 
f 1724//1545 1725//1545 1726//1545 
f 1718//1545 1727//1545 1728//1545 
f 1721//1545 1729//1545 1718//1545 
f 1813//1545 1730//1545 1731//1545 
f 1813//1545 1694//1545 1732//1545 
f 1723//1545 1733//1545 1694//1545 
f 1724//1545 1734//1545 1725//1545 
f 1728//1545 1724//1545 1718//1545 
f 1729//1545 1735//1545 1718//1545 
f 1719//1545 1813//1545 1736//1545 
f 1813//1545 1737//1545 1738//1545 
f 1732//1545 1730//1545 1813//1545 
f 1694//1545 1739//1545 1722//1545 
f 1724//1545 1740//1545 1734//1545 
f 1728//1545 1741//1545 1724//1545 
f 1719//1545 1742//1545 1720//1545 
f 1736//1545 1743//1545 1719//1545 
f 1813//1545 1744//1545 1737//1545 
f 1733//1545 1732//1545 1694//1545 
f 1726//1545 1694//1545 1724//1545 
f 1735//1545 1727//1545 1718//1545 
f 1719//1545 1745//1545 1746//1545 
f 1743//1545 1747//1545 1719//1545 
f 1813//1545 1748//1545 1749//1545 
f 1731//1545 1744//1545 1813//1545 
f 1741//1545 1740//1545 1724//1545 
f 1747//1545 1745//1545 1719//1545 
f 1738//1545 1748//1545 1813//1545 
f 1746//1545 1742//1545 1719//1545 
f 1726//1545 1739//1545 1694//1545 
f 1750//1545 1751//1545 1752//1545 
f 1750//1545 1753//1545 1751//1545 
f 1750//1545 1754//1545 1753//1545 
f 1750//1545 1755//1545 1754//1545 
f 1750//1545 1813//1545 1756//1545 
f 1757//1545 1758//1545 1759//1545 
f 1756//1545 1755//1545 1750//1545 
f 1813//1545 1760//1545 1761//1545 
f 1813//1545 1762//1545 1763//1545 
f 1813//1545 1719//1545 1764//1545 
f 1765//1545 1766//1545 1767//1545 
f 1759//1545 1765//1545 1757//1545 
f 1761//1545 1756//1545 1813//1545 
f 1813//1545 1768//1545 1762//1545 
f 1764//1545 1769//1545 1813//1545 
f 1765//1545 1770//1545 1766//1545 
f 1765//1545 1771//1545 1772//1545 
f 1757//1545 1773//1545 1758//1545 
f 1750//1545 1774//1545 1775//1545 
f 1763//1545 1760//1545 1813//1545 
f 1719//1545 1776//1545 1764//1545 
f 1719//1545 1767//1545 1777//1545 
f 1772//1545 1770//1545 1765//1545 
f 1759//1545 1778//1545 1765//1545 
f 1775//1545 1757//1545 1750//1545 
f 1769//1545 1768//1545 1813//1545 
f 1777//1545 1779//1545 1719//1545 
f 1778//1545 1771//1545 1765//1545 
f 1752//1545 1774//1545 1750//1545 
f 1767//1545 1719//1545 1765//1545 
f 1779//1545 1776//1545 1719//1545 
f 1757//1545 1780//1545 1781//1545 
f 1781//1545 1773//1545 1757//1545 
f 1688//1545 1658//1545 1659//1545 
f 1688//1545 1813//1545 1655//1545 
f 1813//1545 1680//1545 1681//1545 
f 1813//1545 1678//1545 1679//1545 
f 1782//1545 1688//1545 1661//1545 
f 1688//1545 1657//1545 1658//1545 
f 1655//1545 1656//1545 1688//1545 
f 1813//1545 1682//1545 1683//1545 
f 1679//1545 1680//1545 1813//1545 
f 1750//1545 1677//1545 1678//1545 
f 1688//1545 1660//1545 1661//1545 
f 1656//1545 1657//1545 1688//1545 
f 1683//1545 1684//1545 1813//1545 
f 1678//1545 1813//1545 1750//1545 
f 1661//1545 1783//1545 1782//1545 
f 1684//1545 1655//1545 1813//1545 
f 1750//1545 1676//1545 1677//1545 
f 1750//1545 1674//1545 1675//1545 
f 1750//1545 1670//1545 1669//1545 
f 1659//1545 1660//1545 1688//1545 
f 1675//1545 1676//1545 1750//1545 
f 1669//1545 1672//1545 1750//1545 
f 1750//1545 1784//1545 1671//1545 
f 1681//1545 1682//1545 1813//1545 
f 1672//1545 1673//1545 1750//1545 
f 1785//1545 1661//1545 1662//1545 
f 1784//1545 1668//1545 1671//1545 
f 1667//1545 1786//1545 1787//1545 
f 1667//1545 1784//1545 1788//1545 
f 1789//1545 1688//1545 1790//1545 
f 1688//1545 1791//1545 1792//1545 
f 1673//1545 1674//1545 1750//1545 
f 1661//1545 1785//1545 1793//1545 
f 1662//1545 1794//1545 1795//1545 
f 1662//1545 1796//1545 1797//1545 
f 1784//1545 1667//1545 1668//1545 
f 1788//1545 1786//1545 1667//1545 
f 1798//1545 1789//1545 1799//1545 
f 1790//1545 1800//1545 1789//1545 
f 1688//1545 1801//1545 1791//1545 
f 1793//1545 1783//1545 1661//1545 
f 1797//1545 1794//1545 1662//1545 
f 1663//1545 1787//1545 1802//1545 
f 1787//1545 1666//1545 1667//1545 
f 1787//1545 1664//1545 1665//1545 
f 1798//1545 1803//1545 1804//1545 
f 1789//1545 1805//1545 1799//1545 
f 1789//1545 1806//1545 1807//1545 
f 1792//1545 1790//1545 1688//1545 
f 1662//1545 1795//1545 1785//1545 
f 1802//1545 1662//1545 1663//1545 
f 1802//1545 1796//1545 1662//1545 
f 1665//1545 1666//1545 1787//1545 
f 1798//1545 1808//1545 1803//1545 
f 1789//1545 1809//1545 1805//1545 
f 1800//1545 1806//1545 1789//1545 
f 1787//1545 1663//1545 1664//1545 
f 1798//1545 1810//1545 1784//1545 
f 1799//1545 1808//1545 1798//1545 
f 1782//1545 1801//1545 1688//1545 
f 1784//1545 1750//1545 1798//1545 
f 1798//1545 1811//1545 1812//1545 
f 1807//1545 1809//1545 1789//1545 
f 1812//1545 1810//1545 1798//1545 
f 1671//1545 1670//1545 1750//1545 
f 1804//1545 1811//1545 1798//1545 
f 1775//1545 1780//1545 1757//1545 
f 1749//1545 1736//1545 1813//1545 
f 1703//1545 1710//1545 1688//1545 
o mesh212
f 1814//1546 1815//1546 1688//1546 
f 1698//1546 1688//1546 1815//1546 
f 1815//1546 1816//1546 1698//1546 
f 1688//1546 1789//1546 1814//1546 
o mesh213
f 1817//1547 1685//1547 1698//1547 
f 1698//1547 1816//1547 1817//1547 
o mesh214
f 1817//1548 1818//1548 1694//1548 
f 1724//1548 1694//1548 1818//1548 
f 1818//1548 1819//1548 1724//1548 
f 1694//1548 1685//1548 1817//1548 
o mesh215
f 1820//1549 1718//1549 1724//1549 
f 1724//1549 1819//1549 1820//1549 
o mesh216
f 1820//1550 1821//1550 1719//1550 
f 1765//1550 1719//1550 1821//1550 
f 1821//1550 1822//1550 1765//1550 
f 1719//1550 1718//1550 1820//1550 
o mesh217
f 1823//1551 1757//1551 1765//1551 
f 1765//1551 1822//1551 1823//1551 
o mesh218
f 1823//1552 1824//1552 1750//1552 
f 1798//1552 1750//1552 1824//1552 
f 1824//1552 1825//1552 1798//1552 
f 1750//1552 1757//1552 1823//1552 
o mesh219
f 1814//1553 1789//1553 1798//1553 
f 1798//1553 1825//1553 1814//1553 
o mesh220
f 1714//1554 1710//1555 1826//1555 
f 1717//1556 1714//1554 1827//1557 
f 1712//1558 1717//1556 1828//1559 
f 1713//1560 1712//1558 1829//1561 
f 1716//1562 1713//1560 1830//1563 
f 1715//1564 1716//1562 1831//1565 
f 1711//1566 1715//1564 1832//1567 
f 1706//1568 1711//1566 1833//1569 
f 1707//1570 1706//1568 1834//1571 
f 1709//1572 1707//1570 1835//1573 
f 1695//1574 1709//1572 1836//1575 
f 1696//1576 1695//1574 1837//1577 
f 1693//1578 1696//1576 1838//1579 
f 1686//1580 1693//1578 1839//1581 
f 1687//1582 1686//1580 1840//1583 
f 1691//1584 1687//1582 1841//1585 
f 1692//1586 1691//1584 1842//1587 
f 1701//1588 1692//1586 1843//1589 
f 1699//1590 1701//1588 1844//1591 
f 1700//1592 1699//1590 1845//1593 
f 1708//1594 1700//1592 1846//1595 
f 1705//1596 1708//1594 1847//1597 
f 1704//1598 1705//1596 1848//1599 
f 1689//1600 1704//1598 1849//1601 
f 1690//1602 1689//1600 1850//1603 
f 1697//1604 1690//1602 1851//1605 
f 1702//1606 1697//1604 1852//1607 
f 1703//1608 1702//1606 1853//1609 
f 1710//1555 1703//1608 1854//1608 
f 1854//1608 1826//1555 1710//1555 
f 1853//1609 1854//1608 1703//1608 
f 1852//1607 1853//1609 1702//1606 
f 1851//1605 1852//1607 1697//1604 
f 1850//1603 1851//1605 1690//1602 
f 1849//1601 1850//1603 1689//1600 
f 1848//1599 1849//1601 1704//1598 
f 1847//1597 1848//1599 1705//1596 
f 1846//1595 1847//1597 1708//1594 
f 1845//1593 1846//1595 1700//1592 
f 1844//1591 1845//1593 1699//1590 
f 1843//1589 1844//1591 1701//1588 
f 1842//1587 1843//1589 1692//1586 
f 1841//1585 1842//1587 1691//1584 
f 1840//1583 1841//1585 1687//1582 
f 1839//1581 1840//1583 1686//1580 
f 1838//1579 1839//1581 1693//1578 
f 1837//1577 1838//1579 1696//1576 
f 1836//1575 1837//1577 1695//1574 
f 1835//1573 1836//1575 1709//1572 
f 1834//1571 1835//1573 1707//1570 
f 1833//1569 1834//1571 1706//1568 
f 1832//1567 1833//1569 1711//1566 
f 1831//1565 1832//1567 1715//1564 
f 1830//1563 1831//1565 1716//1562 
f 1829//1561 1830//1563 1713//1560 
f 1828//1559 1829//1561 1712//1558 
f 1827//1557 1828//1559 1717//1556 
f 1826//1555 1827//1557 1714//1554 
o mesh221
f 1743//1610 1736//1611 1855//1611 
f 1747//1612 1743//1610 1856//1613 
f 1745//1614 1747//1612 1857//1615 
f 1746//1616 1745//1614 1858//1617 
f 1742//1618 1746//1616 1859//1619 
f 1720//1620 1742//1618 1860//1621 
f 1721//1622 1720//1620 1861//1623 
f 1729//1624 1721//1622 1862//1625 
f 1735//1626 1729//1624 1863//1627 
f 1727//1628 1735//1626 1864//1629 
f 1728//1630 1727//1628 1865//1631 
f 1741//1632 1728//1630 1866//1633 
f 1740//1634 1741//1632 1867//1635 
f 1734//1636 1740//1634 1868//1637 
f 1725//1638 1734//1636 1869//1639 
f 1726//1640 1725//1638 1870//1641 
f 1739//1642 1726//1640 1871//1643 
f 1722//1644 1739//1642 1872//1645 
f 1723//1646 1722//1644 1873//1647 
f 1733//1648 1723//1646 1874//1649 
f 1732//1650 1733//1648 1875//1651 
f 1730//1652 1732//1650 1876//1653 
f 1731//1654 1730//1652 1877//1655 
f 1744//1656 1731//1654 1878//1657 
f 1737//1658 1744//1656 1879//1659 
f 1738//1660 1737//1658 1880//1661 
f 1748//1662 1738//1660 1881//1663 
f 1749//1664 1748//1662 1882//1665 
f 1736//1611 1749//1664 1883//1664 
f 1883//1664 1855//1611 1736//1611 
f 1882//1665 1883//1664 1749//1664 
f 1881//1663 1882//1665 1748//1662 
f 1880//1661 1881//1663 1738//1660 
f 1879//1659 1880//1661 1737//1658 
f 1878//1657 1879//1659 1744//1656 
f 1877//1655 1878//1657 1731//1654 
f 1876//1653 1877//1655 1730//1652 
f 1875//1651 1876//1653 1732//1650 
f 1874//1649 1875//1651 1733//1648 
f 1873//1647 1874//1649 1723//1646 
f 1872//1645 1873//1647 1722//1644 
f 1871//1643 1872//1645 1739//1642 
f 1870//1641 1871//1643 1726//1640 
f 1869//1639 1870//1641 1725//1638 
f 1868//1637 1869//1639 1734//1636 
f 1867//1635 1868//1637 1740//1634 
f 1866//1633 1867//1635 1741//1632 
f 1865//1631 1866//1633 1728//1630 
f 1864//1629 1865//1631 1727//1628 
f 1863//1627 1864//1629 1735//1626 
f 1862//1625 1863//1627 1729//1624 
f 1861//1623 1862//1625 1721//1622 
f 1860//1621 1861//1623 1720//1620 
f 1859//1619 1860//1621 1742//1618 
f 1858//1617 1859//1619 1746//1616 
f 1857//1615 1858//1617 1745//1614 
f 1856//1613 1857//1615 1747//1612 
f 1855//1611 1856//1613 1743//1610 
o mesh222
f 1781//1666 1780//1667 1884//1667 
f 1773//1668 1781//1666 1885//1669 
f 1758//1670 1773//1668 1886//1671 
f 1759//1672 1758//1670 1887//1673 
f 1778//1674 1759//1672 1888//1675 
f 1771//1676 1778//1674 1889//1677 
f 1772//1678 1771//1676 1890//1679 
f 1770//1680 1772//1678 1891//1681 
f 1766//1682 1770//1680 1892//1683 
f 1767//1684 1766//1682 1893//1685 
f 1777//1686 1767//1684 1894//1687 
f 1779//1688 1777//1686 1895//1689 
f 1776//1690 1779//1688 1896//1691 
f 1764//1692 1776//1690 1897//1693 
f 1769//1694 1764//1692 1898//1695 
f 1768//1696 1769//1694 1899//1697 
f 1762//1698 1768//1696 1900//1699 
f 1763//1700 1762//1698 1901//1701 
f 1760//1702 1763//1700 1902//1703 
f 1761//1704 1760//1702 1903//1705 
f 1756//1706 1761//1704 1904//1707 
f 1755//1708 1756//1706 1905//1709 
f 1754//1710 1755//1708 1906//1711 
f 1753//1712 1754//1710 1907//1713 
f 1751//1714 1753//1712 1908//1715 
f 1752//1716 1751//1714 1909//1717 
f 1774//1718 1752//1716 1910//1719 
f 1775//1720 1774//1718 1911//1721 
f 1780//1667 1775//1720 1912//1720 
f 1912//1720 1884//1667 1780//1667 
f 1911//1721 1912//1720 1775//1720 
f 1910//1719 1911//1721 1774//1718 
f 1909//1717 1910//1719 1752//1716 
f 1908//1715 1909//1717 1751//1714 
f 1907//1713 1908//1715 1753//1712 
f 1906//1711 1907//1713 1754//1710 
f 1905//1709 1906//1711 1755//1708 
f 1904//1707 1905//1709 1756//1706 
f 1903//1705 1904//1707 1761//1704 
f 1902//1703 1903//1705 1760//1702 
f 1901//1701 1902//1703 1763//1700 
f 1900//1699 1901//1701 1762//1698 
f 1899//1697 1900//1699 1768//1696 
f 1898//1695 1899//1697 1769//1694 
f 1897//1693 1898//1695 1764//1692 
f 1896//1691 1897//1693 1776//1690 
f 1895//1689 1896//1691 1779//1688 
f 1894//1687 1895//1689 1777//1686 
f 1893//1685 1894//1687 1767//1684 
f 1892//1683 1893//1685 1766//1682 
f 1891//1681 1892//1683 1770//1680 
f 1890//1679 1891//1681 1772//1678 
f 1889//1677 1890//1679 1771//1676 
f 1888//1675 1889//1677 1778//1674 
f 1887//1673 1888//1675 1759//1672 
f 1886//1671 1887//1673 1758//1670 
f 1885//1669 1886//1671 1773//1668 
f 1884//1667 1885//1669 1781//1666 
o mesh223
f 1812//1722 1811//1723 1913//1723 
f 1810//1724 1812//1722 1914//1725 
f 1784//1726 1810//1724 1915//1727 
f 1788//1728 1784//1726 1916//1729 
f 1786//1730 1788//1728 1917//1731 
f 1787//1732 1786//1730 1918//1733 
f 1802//1734 1787//1732 1919//1735 
f 1796//1736 1802//1734 1920//1737 
f 1797//1738 1796//1736 1921//1739 
f 1794//1740 1797//1738 1922//1741 
f 1795//1742 1794//1740 1923//1743 
f 1785//1744 1795//1742 1924//1745 
f 1793//1746 1785//1744 1925//1747 
f 1783//1748 1793//1746 1926//1749 
f 1782//1750 1783//1748 1927//1751 
f 1801//1752 1782//1750 1928//1753 
f 1791//1754 1801//1752 1929//1755 
f 1792//1756 1791//1754 1930//1757 
f 1790//1758 1792//1756 1931//1759 
f 1800//1760 1790//1758 1932//1761 
f 1806//1762 1800//1760 1933//1763 
f 1807//1764 1806//1762 1934//1765 
f 1809//1766 1807//1764 1935//1767 
f 1805//1768 1809//1766 1936//1769 
f 1799//1770 1805//1768 1937//1771 
f 1808//1772 1799//1770 1938//1773 
f 1803//1774 1808//1772 1939//1775 
f 1804//1776 1803//1774 1940//1777 
f 1811//1723 1804//1776 1941//1776 
f 1941//1776 1913//1723 1811//1723 
f 1940//1777 1941//1776 1804//1776 
f 1939//1775 1940//1777 1803//1774 
f 1938//1773 1939//1775 1808//1772 
f 1937//1771 1938//1773 1799//1770 
f 1936//1769 1937//1771 1805//1768 
f 1935//1767 1936//1769 1809//1766 
f 1934//1765 1935//1767 1807//1764 
f 1933//1763 1934//1765 1806//1762 
f 1932//1761 1933//1763 1800//1760 
f 1931//1759 1932//1761 1790//1758 
f 1930//1757 1931//1759 1792//1756 
f 1929//1755 1930//1757 1791//1754 
f 1928//1753 1929//1755 1801//1752 
f 1927//1751 1928//1753 1782//1750 
f 1926//1749 1927//1751 1783//1748 
f 1925//1747 1926//1749 1793//1746 
f 1924//1745 1925//1747 1785//1744 
f 1923//1743 1924//1745 1795//1742 
f 1922//1741 1923//1743 1794//1740 
f 1921//1739 1922//1741 1797//1738 
f 1920//1737 1921//1739 1796//1736 
f 1919//1735 1920//1737 1802//1734 
f 1918//1733 1919//1735 1787//1732 
f 1917//1731 1918//1733 1786//1730 
f 1916//1729 1917//1731 1788//1728 
f 1915//1727 1916//1729 1784//1726 
f 1914//1725 1915//1727 1810//1724 
f 1913//1723 1914//1725 1812//1722 
o mesh224
f 1824//1778 1942//1778 1943//1778 
f 1971//1778 1944//1778 1942//1778 
f 1942//1778 1824//1778 1971//1778 
f 1922//1778 1945//1778 1946//1778 
f 1926//1778 1925//1778 1947//1778 
f 1928//1778 1927//1778 1948//1778 
f 1825//1778 1939//1778 1938//1778 
f 1920//1778 1824//1778 1949//1778 
f 1824//1778 1950//1778 1951//1778 
f 1971//1778 1952//1778 1944//1778 
f 1971//1778 1953//1778 1954//1778 
f 1971//1778 1955//1778 1956//1778 
f 1946//1778 1923//1778 1922//1778 
f 1946//1778 1957//1778 1924//1778 
f 1958//1778 1927//1778 1926//1778 
f 1815//1778 1959//1778 1960//1778 
f 1948//1778 1815//1778 1928//1778 
f 1938//1778 1814//1778 1825//1778 
f 1825//1778 1913//1778 1941//1778 
f 1824//1778 1961//1778 1949//1778 
f 1943//1778 1950//1778 1824//1778 
f 1956//1778 1953//1778 1971//1778 
f 1971//1778 1815//1778 1962//1778 
f 1921//1778 1963//1778 1945//1778 
f 1921//1778 1949//1778 1964//1778 
f 1957//1778 1925//1778 1924//1778 
f 1927//1778 1965//1778 1966//1778 
f 1947//1778 1958//1778 1926//1778 
f 1960//1778 1967//1778 1815//1778 
f 1948//1778 1968//1778 1815//1778 
f 1815//1778 1932//1778 1931//1778 
f 1814//1778 1933//1778 1932//1778 
f 1938//1778 1937//1778 1814//1778 
f 1941//1778 1940//1778 1825//1778 
f 1824//1778 1918//1778 1917//1778 
f 1949//1778 1921//1778 1920//1778 
f 1954//1778 1952//1778 1971//1778 
f 1962//1778 1969//1778 1971//1778 
f 1964//1778 1963//1778 1921//1778 
f 1924//1778 1923//1778 1946//1778 
f 1958//1778 1965//1778 1927//1778 
f 1968//1778 1959//1778 1815//1778 
f 1931//1778 1930//1778 1815//1778 
f 1814//1778 1934//1778 1933//1778 
f 1940//1778 1939//1778 1825//1778 
f 1825//1778 1915//1778 1914//1778 
f 1825//1778 1824//1778 1916//1778 
f 1824//1778 1919//1778 1918//1778 
f 1824//1778 1970//1778 1961//1778 
f 1969//1778 1955//1778 1971//1778 
f 1957//1778 1947//1778 1925//1778 
f 1967//1778 1962//1778 1815//1778 
f 1932//1778 1815//1778 1814//1778 
f 1814//1778 1936//1778 1935//1778 
f 1914//1778 1913//1778 1825//1778 
f 1917//1778 1916//1778 1824//1778 
f 1951//1778 1970//1778 1824//1778 
f 1966//1778 1948//1778 1927//1778 
f 1935//1778 1934//1778 1814//1778 
f 1916//1778 1915//1778 1825//1778 
f 1922//1778 1921//1778 1945//1778 
f 1930//1778 1929//1778 1815//1778 
f 1920//1778 1919//1778 1824//1778 
f 1937//1778 1936//1778 1814//1778 
f 1824//1778 1911//1778 1910//1778 
f 1823//1778 1822//1778 1888//1778 
f 1971//1778 1903//1778 1902//1778 
f 1824//1778 1908//1778 1907//1778 
f 1910//1778 1909//1778 1824//1778 
f 1822//1778 1889//1778 1888//1778 
f 1822//1778 1821//1778 1894//1778 
f 1902//1778 1901//1778 1971//1778 
f 1971//1778 1905//1778 1904//1778 
f 1824//1778 1906//1778 1905//1778 
f 1909//1778 1908//1778 1824//1778 
f 1888//1778 1887//1778 1823//1778 
f 1822//1778 1892//1778 1891//1778 
f 1894//1778 1893//1778 1822//1778 
f 1904//1778 1903//1778 1971//1778 
f 1907//1778 1906//1778 1824//1778 
f 1824//1778 1823//1778 1912//1778 
f 1822//1778 1890//1778 1889//1778 
f 1893//1778 1892//1778 1822//1778 
f 1821//1778 1896//1778 1895//1778 
f 1905//1778 1971//1778 1824//1778 
f 1823//1778 1884//1778 1912//1778 
f 1823//1778 1886//1778 1885//1778 
f 1891//1778 1890//1778 1822//1778 
f 1821//1778 1897//1778 1896//1778 
f 1971//1778 1899//1778 1898//1778 
f 1901//1778 1900//1778 1971//1778 
f 1885//1778 1884//1778 1823//1778 
f 1895//1778 1894//1778 1821//1778 
f 1898//1778 1821//1778 1971//1778 
f 1912//1778 1911//1778 1824//1778 
f 1898//1778 1897//1778 1821//1778 
f 1887//1778 1886//1778 1823//1778 
f 1818//1778 1875//1778 1874//1778 
f 1820//1778 1862//1778 1861//1778 
f 1818//1778 1876//1778 1875//1778 
f 1971//1778 1877//1778 1876//1778 
f 1971//1778 1879//1778 1878//1778 
f 1821//1778 1856//1778 1855//1778 
f 1820//1778 1863//1778 1862//1778 
f 1874//1778 1873//1778 1818//1778 
f 1878//1778 1877//1778 1971//1778 
f 1971//1778 1882//1778 1881//1778 
f 1971//1778 1855//1778 1883//1778 
f 1821//1778 1857//1778 1856//1778 
f 1820//1778 1864//1778 1863//1778 
f 1820//1778 1819//1778 1866//1778 
f 1876//1778 1818//1778 1971//1778 
f 1881//1778 1880//1778 1971//1778 
f 1855//1778 1971//1778 1821//1778 
f 1820//1778 1865//1778 1864//1778 
f 1819//1778 1867//1778 1866//1778 
f 1880//1778 1879//1778 1971//1778 
f 1821//1778 1858//1778 1857//1778 
f 1861//1778 1821//1778 1820//1778 
f 1819//1778 1868//1778 1867//1778 
f 1883//1778 1882//1778 1971//1778 
f 1821//1778 1860//1778 1859//1778 
f 1866//1778 1865//1778 1820//1778 
f 1819//1778 1870//1778 1869//1778 
f 1819//1778 1818//1778 1871//1778 
f 1859//1778 1858//1778 1821//1778 
f 1869//1778 1868//1778 1819//1778 
f 1818//1778 1872//1778 1871//1778 
f 1861//1778 1860//1778 1821//1778 
f 1873//1778 1872//1778 1818//1778 
f 1815//1778 1852//1778 1851//1778 
f 1971//1778 1827//1778 1826//1778 
f 1815//1778 1853//1778 1852//1778 
f 1971//1778 1828//1778 1827//1778 
f 1971//1778 1831//1778 1830//1778 
f 1851//1778 1850//1778 1815//1778 
f 1815//1778 1826//1778 1854//1778 
f 1971//1778 1829//1778 1828//1778 
f 1971//1778 1832//1778 1831//1778 
f 1818//1778 1817//1778 1838//1778 
f 1817//1778 1844//1778 1843//1778 
f 1816//1778 1845//1778 1844//1778 
f 1816//1778 1847//1778 1846//1778 
f 1816//1778 1815//1778 1849//1778 
f 1854//1778 1853//1778 1815//1778 
f 1830//1778 1829//1778 1971//1778 
f 1818//1778 1836//1778 1835//1778 
f 1817//1778 1839//1778 1838//1778 
f 1817//1778 1841//1778 1840//1778 
f 1843//1778 1842//1778 1817//1778 
f 1846//1778 1845//1778 1816//1778 
f 1849//1778 1848//1778 1816//1778 
f 1826//1778 1815//1778 1971//1778 
f 1818//1778 1834//1778 1833//1778 
f 1818//1778 1837//1778 1836//1778 
f 1840//1778 1839//1778 1817//1778 
f 1844//1778 1817//1778 1816//1778 
f 1850//1778 1849//1778 1815//1778 
f 1833//1778 1971//1778 1818//1778 
f 1838//1778 1837//1778 1818//1778 
f 1848//1778 1847//1778 1816//1778 
f 1835//1778 1834//1778 1818//1778 
f 1833//1778 1832//1778 1971//1778 
f 1842//1778 1841//1778 1817//1778 
f 1871//1778 1870//1778 1819//1778 
f 1900//1778 1899//1778 1971//1778 
f 1929//1778 1928//1778 1815//1778 
o mesh225
f 1972//1779 1973//1780 1964//1780 
f 1974//1781 1972//1779 1949//1782 
f 1975//1783 1974//1781 1961//1784 
f 1976//1785 1975//1783 1970//1786 
f 1977//1787 1976//1785 1951//1788 
f 1978//1789 1977//1787 1950//1790 
f 1979//1791 1978//1789 1943//1792 
f 1980//1793 1979//1791 1942//1794 
f 1981//1795 1980//1793 1944//1796 
f 1982//1797 1981//1795 1952//1798 
f 1983//1799 1982//1797 1954//1800 
f 1984//1801 1983//1799 1953//1802 
f 1985//1803 1984//1801 1956//1804 
f 1986//1805 1985//1803 1955//1806 
f 1987//1807 1986//1805 1969//1808 
f 1988//1809 1987//1807 1962//1810 
f 1989//1811 1988//1809 1967//1812 
f 1990//1813 1989//1811 1960//1814 
f 1991//1815 1990//1813 1959//1816 
f 1992//1817 1991//1815 1968//1818 
f 1993//1819 1992//1817 1948//1820 
f 1994//1821 1993//1819 1966//1822 
f 1995//1823 1994//1821 1965//1824 
f 1996//1825 1995//1823 1958//1826 
f 1997//1827 1996//1825 1947//1828 
f 1998//1829 1997//1827 1957//1830 
f 1999//1831 1998//1829 1946//1832 
f 2000//1833 1999//1831 1945//1834 
f 1973//1780 2000//1833 1963//1833 
f 1963//1833 1964//1780 1973//1780 
f 1945//1834 1963//1833 2000//1833 
f 1946//1832 1945//1834 1999//1831 
f 1957//1830 1946//1832 1998//1829 
f 1947//1828 1957//1830 1997//1827 
f 1958//1826 1947//1828 1996//1825 
f 1965//1824 1958//1826 1995//1823 
f 1966//1822 1965//1824 1994//1821 
f 1948//1820 1966//1822 1993//1819 
f 1968//1818 1948//1820 1992//1817 
f 1959//1816 1968//1818 1991//1815 
f 1960//1814 1959//1816 1990//1813 
f 1967//1812 1960//1814 1989//1811 
f 1962//1810 1967//1812 1988//1809 
f 1969//1808 1962//1810 1987//1807 
f 1955//1806 1969//1808 1986//1805 
f 1956//1804 1955//1806 1985//1803 
f 1953//1802 1956//1804 1984//1801 
f 1954//1800 1953//1802 1983//1799 
f 1952//1798 1954//1800 1982//1797 
f 1944//1796 1952//1798 1981//1795 
f 1942//1794 1944//1796 1980//1793 
f 1943//1792 1942//1794 1979//1791 
f 1950//1790 1943//1792 1978//1789 
f 1951//1788 1950//1790 1977//1787 
f 1970//1786 1951//1788 1976//1785 
f 1961//1784 1970//1786 1975//1783 
f 1949//1782 1961//1784 1974//1781 
f 1964//1780 1949//1782 1972//1779 
o mesh226
f 1999//1835 2001//1835 2002//1835 
f 2000//1835 2003//1835 2001//1835 
f 1973//1835 2004//1835 2003//1835 
f 1973//1835 1972//1835 2005//1835 
f 1988//1835 2006//1835 2007//1835 
f 1989//1835 2008//1835 2006//1835 
f 1990//1835 2009//1835 2008//1835 
f 1990//1835 1991//1835 2010//1835 
f 1995//1835 2011//1835 2012//1835 
f 1995//1835 1996//1835 2013//1835 
f 1997//1835 2014//1835 2013//1835 
f 1997//1835 1998//1835 2002//1835 
f 2001//1835 1999//1835 2000//1835 
f 2005//1835 2004//1835 1973//1835 
f 1977//1835 2015//1835 2016//1835 
f 1978//1835 2017//1835 2015//1835 
f 2006//1835 1988//1835 1989//1835 
f 2010//1835 2009//1835 1990//1835 
f 1993//1835 2018//1835 2019//1835 
f 1993//1835 1994//1835 2012//1835 
f 2013//1835 2011//1835 1995//1835 
f 2002//1835 2014//1835 1997//1835 
f 2003//1835 2000//1835 1973//1835 
f 1972//1835 1974//1835 2020//1835 
f 1975//1835 2021//1835 2020//1835 
f 1975//1835 1976//1835 2016//1835 
f 2015//1835 1977//1835 1978//1835 
f 1979//1835 2022//1835 2017//1835 
f 1980//1835 2023//1835 2022//1835 
f 1980//1835 1981//1835 2024//1835 
f 2008//1835 1989//1835 1990//1835 
f 1991//1835 1992//1835 2019//1835 
f 2012//1835 2018//1835 1993//1835 
f 2013//1835 1996//1835 1997//1835 
f 2020//1835 2005//1835 1972//1835 
f 2016//1835 2021//1835 1975//1835 
f 2017//1835 1978//1835 1979//1835 
f 2024//1835 2023//1835 1980//1835 
f 1982//1835 2025//1835 2024//1835 
f 1982//1835 1983//1835 2026//1835 
f 1984//1835 2027//1835 2026//1835 
f 1984//1835 1985//1835 2028//1835 
f 2019//1835 2010//1835 1991//1835 
f 2012//1835 1994//1835 1995//1835 
f 2020//1835 1974//1835 1975//1835 
f 2022//1835 1979//1835 1980//1835 
f 2026//1835 2025//1835 1982//1835 
f 2028//1835 2027//1835 1984//1835 
f 1986//1835 2029//1835 2028//1835 
f 1986//1835 1987//1835 2007//1835 
f 2019//1835 1992//1835 1993//1835 
f 2016//1835 1976//1835 1977//1835 
f 2026//1835 1983//1835 1984//1835 
f 2007//1835 2029//1835 1986//1835 
f 2002//1835 1998//1835 1999//1835 
f 2028//1835 1985//1835 1986//1835 
f 2024//1835 1981//1835 1982//1835 
f 2007//1835 1987//1835 1988//1835 
o mesh227
f 2030//1836 2031//1837 2004//1837 
f 2032//1838 2030//1836 2005//1839 
f 2033//1840 2032//1838 2020//1841 
f 2034//1842 2033//1840 2021//1843 
f 2035//1844 2034//1842 2016//1845 
f 2036//1846 2035//1844 2015//1847 
f 2037//1848 2036//1846 2017//1849 
f 2038//1850 2037//1848 2022//1851 
f 2039//1852 2038//1850 2023//1853 
f 2040//1854 2039//1852 2024//1855 
f 2041//1856 2040//1854 2025//1857 
f 2042//1858 2041//1856 2026//1859 
f 2043//1860 2042//1858 2027//1861 
f 2044//1862 2043//1860 2028//1863 
f 2045//1864 2044//1862 2029//1865 
f 2046//1866 2045//1864 2007//1867 
f 2047//1868 2046//1866 2006//1869 
f 2048//1870 2047//1868 2008//1871 
f 2049//1872 2048//1870 2009//1873 
f 2050//1874 2049//1872 2010//1875 
f 2051//1876 2050//1874 2019//1877 
f 2052//1878 2051//1876 2018//1879 
f 2053//1880 2052//1878 2012//1881 
f 2054//1882 2053//1880 2011//1883 
f 2055//1884 2054//1882 2013//1885 
f 2056//1886 2055//1884 2014//1887 
f 2057//1888 2056//1886 2002//1889 
f 2058//1890 2057//1888 2001//1891 
f 2031//1837 2058//1890 2003//1890 
f 2003//1890 2004//1837 2031//1837 
f 2001//1891 2003//1890 2058//1890 
f 2002//1889 2001//1891 2057//1888 
f 2014//1887 2002//1889 2056//1886 
f 2013//1885 2014//1887 2055//1884 
f 2011//1883 2013//1885 2054//1882 
f 2012//1881 2011//1883 2053//1880 
f 2018//1879 2012//1881 2052//1878 
f 2019//1877 2018//1879 2051//1876 
f 2010//1875 2019//1877 2050//1874 
f 2009//1873 2010//1875 2049//1872 
f 2008//1871 2009//1873 2048//1870 
f 2006//1869 2008//1871 2047//1868 
f 2007//1867 2006//1869 2046//1866 
f 2029//1865 2007//1867 2045//1864 
f 2028//1863 2029//1865 2044//1862 
f 2027//1861 2028//1863 2043//1860 
f 2026//1859 2027//1861 2042//1858 
f 2025//1857 2026//1859 2041//1856 
f 2024//1855 2025//1857 2040//1854 
f 2023//1853 2024//1855 2039//1852 
f 2022//1851 2023//1853 2038//1850 
f 2017//1849 2022//1851 2037//1848 
f 2015//1847 2017//1849 2036//1846 
f 2016//1845 2015//1847 2035//1844 
f 2021//1843 2016//1845 2034//1842 
f 2020//1841 2021//1843 2033//1840 
f 2005//1839 2020//1841 2032//1838 
f 2004//1837 2005//1839 2030//1836 
o mesh228
f 2059//1892 2030//1892 2032//1892 
f 2032//1892 2033//1892 2059//1892 
f 2033//1892 2034//1892 2059//1892 
f 2034//1892 2035//1892 2059//1892 
f 2035//1892 2036//1892 2059//1892 
f 2036//1892 2037//1892 2059//1892 
f 2037//1892 2038//1892 2059//1892 
f 2038//1892 2039//1892 2059//1892 
f 2039//1892 2040//1892 2059//1892 
f 2040//1892 2041//1892 2059//1892 
f 2041//1892 2042//1892 2059//1892 
f 2042//1892 2043//1892 2059//1892 
f 2043//1892 2044//1892 2059//1892 
f 2044//1892 2045//1892 2059//1892 
f 2045//1892 2046//1892 2059//1892 
f 2046//1892 2047//1892 2059//1892 
f 2047//1892 2048//1892 2059//1892 
f 2048//1892 2049//1892 2059//1892 
f 2049//1892 2050//1892 2059//1892 
f 2050//1892 2051//1892 2059//1892 
f 2051//1892 2052//1892 2059//1892 
f 2052//1892 2053//1892 2059//1892 
f 2053//1892 2054//1892 2059//1892 
f 2054//1892 2055//1892 2059//1892 
f 2055//1892 2056//1892 2059//1892 
f 2056//1892 2057//1892 2059//1892 
f 2057//1892 2058//1892 2059//1892 
f 2058//1892 2031//1892 2059//1892 
f 2031//1892 2030//1892 2059//1892 
g 35cm_T2020
v 0.142494 -0.198246 -0.0949734 
v 0.142494 0.151754 -0.0949734 
v 0.138959 0.151754 -0.0914378 
v 0.138959 -0.198246 -0.0914378 
v 0.134994 0.151754 -0.0914378 
v 0.134994 -0.198246 -0.0914378 
v 0.134994 0.151754 -0.0954023 
v 0.134994 -0.198246 -0.0954023 
v 0.13853 0.151754 -0.0989378 
v 0.13853 -0.198246 -0.0989378 
v 0.13853 0.151754 -0.103938 
v 0.13853 -0.198246 -0.103938 
v 0.134994 0.151754 -0.107473 
v 0.134994 -0.198246 -0.107473 
v 0.134994 0.151754 -0.111438 
v 0.134994 -0.198246 -0.111438 
v 0.138959 0.151754 -0.111438 
v 0.138959 -0.198246 -0.111438 
v 0.142494 0.151754 -0.107902 
v 0.142494 -0.198246 -0.107902 
v 0.147494 0.151754 -0.107902 
v 0.147494 -0.198246 -0.107902 
v 0.15103 0.151754 -0.111438 
v 0.15103 -0.198246 -0.111438 
v 0.154994 0.151754 -0.111438 
v 0.154994 -0.198246 -0.111438 
v 0.154994 0.151754 -0.107473 
v 0.154994 -0.198246 -0.107473 
v 0.151459 0.151754 -0.103938 
v 0.151459 -0.198246 -0.103938 
v 0.151459 0.151754 -0.0989378 
v 0.151459 -0.198246 -0.0989378 
v 0.154994 0.151754 -0.0954023 
v 0.154994 -0.198246 -0.0954023 
v 0.154994 0.151754 -0.0914378 
v 0.154994 -0.198246 -0.0914378 
v 0.15103 -0.198246 -0.0914378 
v 0.147494 -0.198246 -0.0949734 
v 0.15103 0.151754 -0.0914378 
v 0.147494 0.151754 -0.0949734 
vn 0.808807 0.147506 0.569274 
vn 0.138838 0.168561 0.975864 
vn -0.976207 0.169305 -0.135483 
vn -0.568525 0.148212 -0.809205 
vn -0.693339 0.18075 0.697575 
vn -0.976207 0.169305 -0.135483 
vn 0.109785 0.133288 -0.984978 
vn 0.702775 0.128168 -0.699771 
vn -0.568525 0.148212 -0.809205 
vn 0.109785 0.133288 -0.984978 
vn 0.985402 0.132924 -0.106369 
vn 0.808807 0.147506 0.569274 
vn 0.702775 0.128168 -0.699771 
vn 0.985402 0.132924 -0.106369 
vn 0.144342 -0.979541 -0.140234 
vn 0.107304 0.988746 -0.104251 
vn 0.138838 0.168561 0.975864 
vn -0.693339 0.18075 0.697575 
usemtl 0.301961_0.301961_0.301961_0.000000_0.000000
o mesh229
f 2060//1893 2061//1893 2062//1893 
f 2062//1893 2063//1893 2060//1893 
o mesh230
f 2063//1894 2062//1894 2064//1894 
f 2064//1894 2065//1894 2063//1894 
o mesh231
f 2065//1895 2064//1895 2066//1895 
f 2066//1895 2067//1895 2065//1895 
o mesh232
f 2067//1896 2066//1896 2068//1896 
f 2068//1896 2069//1896 2067//1896 
o mesh233
f 2069//1895 2068//1895 2070//1895 
f 2070//1895 2071//1895 2069//1895 
o mesh234
f 2071//1897 2070//1897 2072//1897 
f 2072//1897 2073//1897 2071//1897 
o mesh235
f 2073//1898 2072//1898 2074//1898 
f 2074//1898 2075//1898 2073//1898 
o mesh236
f 2075//1899 2074//1899 2076//1899 
f 2076//1899 2077//1899 2075//1899 
o mesh237
f 2077//1900 2076//1900 2078//1900 
f 2078//1900 2079//1900 2077//1900 
o mesh238
f 2079//1899 2078//1899 2080//1899 
f 2080//1899 2081//1899 2079//1899 
o mesh239
f 2081//1901 2080//1901 2082//1901 
f 2082//1901 2083//1901 2081//1901 
o mesh240
f 2083//1902 2082//1902 2084//1902 
f 2084//1902 2085//1902 2083//1902 
o mesh241
f 2085//1903 2084//1903 2086//1903 
f 2086//1903 2087//1903 2085//1903 
o mesh242
f 2087//1904 2086//1904 2088//1904 
f 2088//1904 2089//1904 2087//1904 
o mesh243
f 2089//1903 2088//1903 2090//1903 
f 2090//1903 2091//1903 2089//1903 
o mesh244
f 2091//1905 2090//1905 2092//1905 
f 2092//1905 2093//1905 2091//1905 
o mesh245
f 2093//1906 2092//1906 2094//1906 
f 2094//1906 2095//1906 2093//1906 
o mesh246
f 2096//1907 2091//1907 2093//1907 
f 2073//1907 2075//1907 2077//1907 
f 2071//1907 2079//1907 2089//1907 
f 2093//1907 2095//1907 2096//1907 
f 2079//1907 2071//1907 2073//1907 
f 2091//1907 2069//1907 2071//1907 
f 2083//1907 2085//1907 2087//1907 
f 2096//1907 2097//1907 2091//1907 
f 2089//1907 2091//1907 2071//1907 
f 2089//1907 2081//1907 2083//1907 
f 2063//1907 2065//1907 2067//1907 
f 2077//1907 2079//1907 2073//1907 
f 2089//1907 2079//1907 2081//1907 
f 2069//1907 2060//1907 2063//1907 
f 2087//1907 2089//1907 2083//1907 
f 2069//1907 2097//1907 2060//1907 
f 2067//1907 2069//1907 2063//1907 
f 2097//1907 2069//1907 2091//1907 
o mesh247
f 2070//1908 2090//1908 2088//1908 
f 2072//1908 2078//1908 2076//1908 
f 2098//1908 2094//1908 2092//1908 
f 2082//1908 2088//1908 2086//1908 
f 2088//1908 2078//1908 2070//1908 
f 2076//1908 2074//1908 2072//1908 
f 2090//1908 2099//1908 2098//1908 
f 2062//1908 2068//1908 2066//1908 
f 2086//1908 2084//1908 2082//1908 
f 2072//1908 2070//1908 2078//1908 
f 2090//1908 2068//1908 2099//1908 
f 2066//1908 2064//1908 2062//1908 
f 2082//1908 2080//1908 2088//1908 
f 2092//1908 2090//1908 2098//1908 
f 2062//1908 2061//1908 2068//1908 
f 2070//1908 2068//1908 2090//1908 
f 2080//1908 2078//1908 2088//1908 
f 2061//1908 2099//1908 2068//1908 
o mesh248
f 2095//1909 2094//1909 2098//1909 
f 2098//1909 2096//1909 2095//1909 
o mesh249
f 2096//1910 2098//1910 2099//1910 
f 2099//1910 2097//1910 2096//1910 
o mesh250
f 2097//1909 2099//1909 2061//1909 
f 2061//1909 2060//1909 2097//1909 
g bearing
v 0.0266739 0.0160401 -0.0294641 
v 0.0266155 0.0160401 -0.0289267 
v 0.0266155 0.00584011 -0.0289267 
v 0.0268465 0.0160401 -0.0299764 
v 0.0266739 0.00584011 -0.0294641 
v 0.0271252 0.0160401 -0.0304396 
v 0.0268465 0.00584011 -0.0299764 
v 0.027497 0.0160401 -0.0308321 
v 0.0271252 0.00584011 -0.0304396 
v 0.0279445 0.0160401 -0.0311355 
v 0.027497 0.00584011 -0.0308321 
v 0.0284467 0.0160401 -0.0313356 
v 0.0279445 0.00584011 -0.0311355 
v 0.0289801 0.0160401 -0.031423 
v 0.0284467 0.00584011 -0.0313356 
v 0.0295199 0.0160401 -0.0313938 
v 0.0289801 0.00584011 -0.031423 
v 0.0300408 0.0160401 -0.0312491 
v 0.0295199 0.00584011 -0.0313938 
v 0.0305184 0.0160401 -0.0309959 
v 0.0300408 0.00584011 -0.0312491 
v 0.0309305 0.0160401 -0.030646 
v 0.0305184 0.00584011 -0.0309959 
v 0.0312576 0.0160401 -0.0302156 
v 0.0309305 0.00584011 -0.030646 
v 0.0314846 0.0160401 -0.029725 
v 0.0312576 0.00584011 -0.0302156 
v 0.0316008 0.0160401 -0.029197 
v 0.0314846 0.00584011 -0.029725 
v 0.0316008 0.0160401 -0.0286564 
v 0.0316008 0.00584011 -0.029197 
v 0.0314846 0.0160401 -0.0281284 
v 0.0316008 0.00584011 -0.0286564 
v 0.0312576 0.0160401 -0.0276378 
v 0.0314846 0.00584011 -0.0281284 
v 0.0309305 0.0160401 -0.0272075 
v 0.0312576 0.00584011 -0.0276378 
v 0.0305184 0.0160401 -0.0268575 
v 0.0309305 0.00584011 -0.0272075 
v 0.0300408 0.0160401 -0.0266043 
v 0.0305184 0.00584011 -0.0268575 
v 0.0295199 0.0160401 -0.0264596 
v 0.0300408 0.00584011 -0.0266043 
v 0.0289801 0.0160401 -0.0264304 
v 0.0295199 0.00584011 -0.0264596 
v 0.0284467 0.0160401 -0.0265178 
v 0.0289801 0.00584011 -0.0264304 
v 0.0279445 0.0160401 -0.0267179 
v 0.0284467 0.00584011 -0.0265178 
v 0.027497 0.0160401 -0.0270213 
v 0.0279445 0.00584011 -0.0267179 
v 0.0271252 0.0160401 -0.0274138 
v 0.027497 0.00584011 -0.0270213 
v 0.0268465 0.0160401 -0.027877 
v 0.0271252 0.00584011 -0.0274138 
v 0.0266739 0.0160401 -0.0283893 
v 0.0268465 0.00584011 -0.027877 
v 0.0266739 0.00584011 -0.0283893 
v 0.0359398 0.00584011 -0.0224623 
v 0.0343906 0.00584011 -0.0211464 
v 0.0371699 0.00584011 -0.0240805 
v 0.0286066 0.00584011 -0.0195405 
v 0.0266007 0.00584011 -0.0198693 
v 0.0325948 0.00584011 -0.0201943 
v 0.0306362 0.00584011 -0.0196505 
v 0.02303 0.00584011 -0.0217624 
v 0.0216322 0.00584011 -0.0232381 
v 0.0199352 0.00584011 -0.026906 
v 0.0197155 0.00584011 -0.0289267 
v 0.0247124 0.00584011 -0.0206217 
v 0.0199352 0.00584011 -0.0309474 
v 0.0205843 0.00584011 -0.0249797 
v 0.0359398 0.00584011 -0.0353911 
v 0.0371699 0.00584011 -0.0337729 
v 0.0343906 0.00584011 -0.036707 
v 0.0380234 0.00584011 -0.0259253 
v 0.0205843 0.00584011 -0.0328737 
v 0.0216322 0.00584011 -0.0346153 
v 0.02303 0.00584011 -0.036091 
v 0.0247124 0.00584011 -0.0372317 
v 0.0266007 0.00584011 -0.0379841 
v 0.0286066 0.00584011 -0.0383129 
v 0.0380234 0.00584011 -0.0319281 
v 0.0384604 0.00584011 -0.029943 
v 0.0384604 0.00584011 -0.0279104 
v 0.0306362 0.00584011 -0.0382029 
v 0.0325948 0.00584011 -0.0376591 
v 0.0171155 0.00844011 -0.0289267 
v 0.017396 0.00844011 -0.0263471 
v 0.0182246 0.00844011 -0.023888 
v 0.0195624 0.00844011 -0.0216646 
v 0.0213468 0.00844011 -0.0197808 
v 0.0234946 0.00844011 -0.0183246 
v 0.0259051 0.00844011 -0.0173641 
v 0.0284658 0.00844011 -0.0169443 
v 0.0310569 0.00844011 -0.0170848 
v 0.0335571 0.00844011 -0.017779 
v 0.0358497 0.00844011 -0.0189944 
v 0.0378274 0.00844011 -0.0206743 
v 0.0393978 0.00844011 -0.0227401 
v 0.0404873 0.00844011 -0.0250951 
v 0.0410451 0.00844011 -0.0276293 
v 0.0410451 0.00844011 -0.0302241 
v 0.0404873 0.00844011 -0.0327583 
v 0.0393978 0.00844011 -0.0351133 
v 0.0378274 0.00844011 -0.0371791 
v 0.0358497 0.00844011 -0.038859 
v 0.0335571 0.00844011 -0.0400744 
v 0.0310569 0.00844011 -0.0407686 
v 0.0284658 0.00844011 -0.0409091 
v 0.0259051 0.00844011 -0.0404893 
v 0.0234946 0.00844011 -0.0395288 
v 0.0213468 0.00844011 -0.0380726 
v 0.0195624 0.00844011 -0.0361888 
v 0.0182246 0.00844011 -0.0339654 
v 0.017396 0.00844011 -0.0315063 
v 0.0174647 0.0134401 -0.0263622 
v 0.0171858 0.0134401 -0.0276293 
v 0.0182884 0.0134401 -0.0239176 
v 0.0177436 0.0134401 -0.0250951 
v 0.0196184 0.0134401 -0.0217072 
v 0.0188332 0.0134401 -0.0227401 
v 0.0213924 0.0134401 -0.0198344 
v 0.0204035 0.0134401 -0.0206743 
v 0.0235275 0.0134401 -0.0183867 
v 0.0223812 0.0134401 -0.0189944 
v 0.025924 0.0134401 -0.0174319 
v 0.0246738 0.0134401 -0.017779 
v 0.0284696 0.0134401 -0.0170145 
v 0.0271741 0.0134401 -0.0170848 
v 0.0310455 0.0134401 -0.0171542 
v 0.0297651 0.0134401 -0.0169443 
v 0.0335311 0.0134401 -0.0178443 
v 0.0323258 0.0134401 -0.0173641 
v 0.0358102 0.0134401 -0.0190527 
v 0.0347364 0.0134401 -0.0183246 
v 0.0368841 0.0134401 -0.0197808 
v 0.0377764 0.0134401 -0.0207227 
v 0.0386686 0.0134401 -0.0216646 
v 0.0393375 0.0134401 -0.0227763 
v 0.0400064 0.0134401 -0.023888 
v 0.0404207 0.0134401 -0.0251175 
v 0.0409752 0.0134401 -0.0276369 
v 0.0408349 0.0134401 -0.0263471 
v 0.0409752 0.0134401 -0.0302165 
v 0.0411155 0.0134401 -0.0289267 
v 0.0404207 0.0134401 -0.0327359 
v 0.0408349 0.0134401 -0.0315063 
v 0.0393375 0.0134401 -0.0350771 
v 0.0400064 0.0134401 -0.0339654 
v 0.0377764 0.0134401 -0.0371307 
v 0.0386686 0.0134401 -0.0361888 
v 0.0358102 0.0134401 -0.0388007 
v 0.0368841 0.0134401 -0.0380726 
v 0.0335311 0.0134401 -0.0400091 
v 0.0347364 0.0134401 -0.0395288 
v 0.0310455 0.0134401 -0.0406992 
v 0.0323258 0.0134401 -0.0404893 
v 0.0284696 0.0134401 -0.0408389 
v 0.0297651 0.0134401 -0.0409091 
v 0.025924 0.0134401 -0.0404215 
v 0.0271741 0.0134401 -0.0407686 
v 0.0235275 0.0134401 -0.0394667 
v 0.0246738 0.0134401 -0.0400744 
v 0.0213924 0.0134401 -0.038019 
v 0.0223812 0.0134401 -0.038859 
v 0.0196184 0.0134401 -0.0361462 
v 0.0204035 0.0134401 -0.0371791 
v 0.0182884 0.0134401 -0.0339358 
v 0.0188332 0.0134401 -0.0351133 
v 0.0174647 0.0134401 -0.0314912 
v 0.0177436 0.0134401 -0.0327583 
v 0.0171155 0.0134401 -0.0289267 
v 0.0171858 0.0134401 -0.0302241 
v 0.0382957 0.0160401 -0.026906 
v 0.0385155 0.0160401 -0.0289267 
v 0.0376467 0.0160401 -0.0249797 
v 0.0365987 0.0160401 -0.0232381 
v 0.0352009 0.0160401 -0.0217624 
v 0.0335185 0.0160401 -0.0206217 
v 0.0316302 0.0160401 -0.0198693 
v 0.0296244 0.0160401 -0.0195405 
v 0.0275947 0.0160401 -0.0196505 
v 0.0256362 0.0160401 -0.0201943 
v 0.0238403 0.0160401 -0.0211464 
v 0.0222911 0.0160401 -0.0224623 
v 0.021061 0.0160401 -0.0240805 
v 0.0202075 0.0160401 -0.0259253 
v 0.0197706 0.0160401 -0.0279104 
v 0.0197155 0.0160401 -0.0289267 
v 0.0197706 0.0160401 -0.029943 
v 0.0202075 0.0160401 -0.0319281 
v 0.021061 0.0160401 -0.0337729 
v 0.0222911 0.0160401 -0.0353911 
v 0.0238403 0.0160401 -0.036707 
v 0.0256362 0.0160401 -0.0376591 
v 0.0275947 0.0160401 -0.0382029 
v 0.0296244 0.0160401 -0.0383129 
v 0.0316302 0.0160401 -0.0379841 
v 0.0335185 0.0160401 -0.0372317 
v 0.0352009 0.0160401 -0.036091 
v 0.0365987 0.0160401 -0.0346153 
v 0.0376467 0.0160401 -0.0328737 
v 0.0382957 0.0160401 -0.0309474 
vn 0.983197 0.0156806 0.181874 
vn 0.999484 0.0155783 -0.0280938 
vn 0.922726 0.015801 0.385133 
vn 0.983197 0.0156806 0.181874 
vn 0.81978 0.0159346 0.572457 
vn 0.922726 0.015801 0.385133 
vn 0.678013 0.0160759 0.734874 
vn 0.81978 0.0159346 0.572457 
vn 0.503062 0.0162187 0.864098 
vn 0.678013 0.0160759 0.734874 
vn 0.302481 0.0163557 0.953015 
vn 0.503062 0.0162187 0.864098 
vn 0.0855377 0.01648 0.996199 
vn 0.302481 0.0163557 0.953015 
vn -0.137169 0.0165845 0.990409 
vn 0.0855377 0.01648 0.996199 
vn -0.354264 0.0166629 0.934997 
vn -0.137169 0.0165845 0.990409 
vn -0.554308 0.0167105 0.832144 
vn -0.354264 0.0166629 0.934997 
vn -0.726595 0.0167241 0.686863 
vn -0.554308 0.0167105 0.832144 
vn -0.861941 0.0167028 0.506733 
vn -0.726595 0.0167241 0.686863 
vn -0.953358 0.0166482 0.301382 
vn -0.861941 0.0167028 0.506733 
vn -0.996513 0.0165635 0.0817765 
vn -0.953358 0.0166482 0.301382 
vn -0.989932 0.0164541 -0.140583 
vn -0.996513 0.0165635 0.0817765 
vn -0.934935 0.0163264 -0.354444 
vn -0.989932 0.0164541 -0.140583 
vn -0.835348 0.0161875 -0.549484 
vn -0.934935 0.0163264 -0.354444 
vn -0.697071 0.0160445 -0.716823 
vn -0.835348 0.0161875 -0.549484 
vn -0.527567 0.0159043 -0.849364 
vn -0.697071 0.0160445 -0.716823 
vn -0.335348 0.0157732 -0.941962 
vn -0.527567 0.0159043 -0.849364 
vn -0.129493 0.0156564 -0.991457 
vn -0.335348 0.0157732 -0.941962 
vn 0.0807548 0.0155585 -0.996613 
vn -0.129493 0.0156564 -0.991457 
vn 0.28634 0.015483 -0.958003 
vn 0.0807548 0.0155585 -0.996613 
vn 0.478669 0.0154322 -0.87786 
vn 0.28634 0.015483 -0.958003 
vn 0.649842 0.015408 -0.759913 
vn 0.478669 0.0154322 -0.87786 
vn 0.792843 0.015411 -0.609231 
vn 0.649842 0.015408 -0.759913 
vn 0.901714 0.0154412 -0.432057 
vn 0.792843 0.015411 -0.609231 
vn 0.971715 0.0154975 -0.235647 
vn 0.901714 0.0154412 -0.432057 
vn 0.0295644 -0.999131 -0.0293727 
vn -0.700009 -0.713509 -0.0298661 
vn -0.685809 -0.716506 0.127611 
vn -0.63709 -0.718649 0.278676 
vn -0.556013 -0.719814 0.415594 
vn -0.446559 -0.719931 0.531305 
vn -0.314307 -0.718993 0.619887 
vn -0.166075 -0.717056 0.676941 
vn -0.00947381 -0.714234 0.699843 
vn 0.147587 -0.710686 0.687854 
vn 0.297383 -0.706608 0.642081 
vn 0.432805 -0.702213 0.565311 
vn 0.547695 -0.69772 0.461754 
vn 0.637095 -0.693342 0.33673 
vn 0.697391 -0.689272 0.196342 
vn 0.726373 -0.685682 0.0471547 
vn 0.72323 -0.682715 -0.104105 
vn 0.688502 -0.680486 -0.250807 
vn 0.623986 -0.679075 -0.38665 
vn 0.532633 -0.678533 -0.50586 
vn 0.418424 -0.67888 -0.60336 
vn 0.286228 -0.680103 -0.674932 
vn 0.141663 -0.682158 -0.71735 
vn -0.00908566 -0.684971 -0.728513 
vn -0.159446 -0.688435 -0.707555 
vn -0.302688 -0.692413 -0.654938 
vn -0.432175 -0.69674 -0.572519 
vn -0.541655 -0.701226 -0.463565 
vn -0.625575 -0.705661 -0.332714 
vn -0.679416 -0.709827 -0.185846 
vn -0.981128 0.0166093 0.192646 
vn -0.996513 0.0165635 0.0817765 
vn -0.99942 0.0165115 -0.0297769 
vn -0.913478 0.0166795 0.406547 
vn -0.953358 0.0166482 0.301382 
vn -0.79938 0.0167178 0.600593 
vn -0.861941 0.0167028 0.506733 
vn -0.644539 0.0167216 0.764388 
vn -0.726595 0.0167241 0.686863 
vn -0.457113 0.0166908 0.889252 
vn -0.554308 0.0167105 0.832144 
vn -0.24714 0.0166273 0.968837 
vn -0.354264 0.0166629 0.934997 
vn -0.0257957 0.0165351 0.99953 
vn -0.137169 0.0165845 0.990409 
vn 0.195418 0.0164199 0.980583 
vn 0.0855377 0.01648 0.996199 
vn 0.405433 0.0162884 0.91398 
vn 0.302481 0.0163557 0.953015 
vn 0.594257 0.0161476 0.804113 
vn 0.503062 0.0162187 0.864098 
vn 0.753443 0.0160047 0.657318 
vn 0.678013 0.0160759 0.734874 
vn 0.87638 0.0158664 0.481358 
vn 0.81978 0.0159346 0.572457 
vn 0.958422 0.0157388 0.284921 
vn 0.922726 0.015801 0.385133 
vn 0.996897 0.015627 0.0771525 
vn 0.983197 0.0156806 0.181874 
vn 0.99103 0.015535 -0.13273 
vn 0.999484 0.0155783 -0.0280938 
vn 0.941818 0.0154662 -0.335768 
vn 0.971715 0.0154975 -0.235647 
vn 0.851872 0.0154227 -0.523524 
vn 0.901714 0.0154412 -0.432057 
vn 0.725263 0.0154061 -0.688299 
vn 0.792843 0.015411 -0.609231 
vn 0.567361 0.0154167 -0.823325 
vn 0.649842 0.015408 -0.759913 
vn 0.384674 0.0154544 -0.922923 
vn 0.478669 0.0154322 -0.87786 
vn 0.184681 0.0155178 -0.982676 
vn 0.28634 0.015483 -0.958003 
vn -0.0243445 0.0156049 -0.999582 
vn 0.0807548 0.0155585 -0.996613 
vn -0.233546 0.0157127 -0.972219 
vn -0.129493 0.0156564 -0.991457 
vn -0.433738 0.0158373 -0.9009 
vn -0.335348 0.0157732 -0.941962 
vn -0.615709 0.0159737 -0.787811 
vn -0.527567 0.0159043 -0.849364 
vn -0.77061 0.0161161 -0.637104 
vn -0.697071 0.0160445 -0.716823 
vn -0.890389 0.0162579 -0.45491 
vn -0.835348 0.0161875 -0.549484 
vn -0.9683 0.0163921 -0.24925 
vn -0.934935 0.0163264 -0.354444 
vn -0.99942 0.0165115 -0.0297769 
vn -0.989932 0.0164541 -0.140583 
vn 0.700333 0.703697 0.11977 
vn 0.710675 0.702006 0.0461356 
vn 0.713133 0.700468 -0.0280195 
vn 0.656322 0.707467 0.262169 
vn 0.682167 0.705523 0.192056 
vn 0.582604 0.711623 0.392638 
vn 0.623028 0.709508 0.329295 
vn 0.482065 0.715986 0.504953 
vn 0.535453 0.713791 0.451433 
vn 0.358939 0.720354 0.593509 
vn 0.42301 0.718182 0.552518 
vn 0.2187 0.724516 0.653641 
vn 0.290572 0.722474 0.627375 
vn 0.067874 0.72826 0.681931 
vn 0.144169 0.726453 0.671923 
vn -0.0862534 0.731387 0.676486 
vn -0.00925227 0.729912 0.683478 
vn -0.236013 0.733722 0.637142 
vn -0.162162 0.732663 0.660991 
vn -0.373798 0.735132 0.565558 
vn -0.306863 0.734549 0.605205 
vn -0.492536 0.735535 0.465185 
vn -0.435956 0.735462 0.518689 
vn -0.586153 0.734906 0.341083 
vn -0.542814 0.735348 0.405728 
vn -0.649961 0.733284 0.199613 
vn -0.622014 0.734215 0.272081 
vn -0.680942 0.730761 0.0480254 
vn -0.669674 0.732127 0.124609 
vn -0.677887 0.727483 -0.10601 
vn -0.683672 0.729206 -0.0291691 
vn -0.641404 0.723629 -0.254877 
vn -0.663718 0.725616 -0.181551 
vn -0.573788 0.719403 -0.391441 
vn -0.611284 0.721549 -0.325113 
vn -0.478798 0.715018 -0.509413 
vn -0.52943 0.717217 -0.453104 
vn -0.361367 0.710685 -0.603607 
vn -0.422542 0.712833 -0.559757 
vn -0.227289 0.706598 -0.670118 
vn -0.296022 0.708599 -0.640514 
vn -0.0828981 0.702935 -0.706407 
vn -0.155974 0.704704 -0.692145 
vn 0.0652256 0.699844 -0.711312 
vn -0.00888971 0.70131 -0.712801 
vn 0.210529 0.697446 -0.685016 
vn 0.138632 0.698552 -0.702002 
vn 0.346719 0.69583 -0.628972 
vn 0.28014 0.696536 -0.660575 
vn 0.467974 0.695057 -0.545799 
vn 0.409554 0.695336 -0.59057 
vn 0.56912 0.695153 -0.439164 
vn 0.521354 0.694996 -0.495147 
vn 0.645791 0.696115 -0.313653 
vn 0.610752 0.695527 -0.37845 
vn 0.694573 0.697909 -0.174619 
vn 0.67384 0.696911 -0.245466 
vn 0.707731 0.699098 -0.101874 
vn 0.713133 0.700468 -0.0280195 
vn 0.0286325 0.999185 -0.0284468 
usemtl 0.400000_0.400000_0.400000_0.000000_0.000000
o mesh3
f 2100//1911 2101//1912 2102//1912 
f 2103//1913 2100//1911 2104//1914 
f 2105//1915 2103//1913 2106//1916 
f 2107//1917 2105//1915 2108//1918 
f 2109//1919 2107//1917 2110//1920 
f 2111//1921 2109//1919 2112//1922 
f 2113//1923 2111//1921 2114//1924 
f 2115//1925 2113//1923 2116//1926 
f 2117//1927 2115//1925 2118//1928 
f 2119//1929 2117//1927 2120//1930 
f 2121//1931 2119//1929 2122//1932 
f 2123//1933 2121//1931 2124//1934 
f 2125//1935 2123//1933 2126//1936 
f 2127//1937 2125//1935 2128//1938 
f 2129//1939 2127//1937 2130//1940 
f 2131//1941 2129//1939 2132//1942 
f 2133//1943 2131//1941 2134//1944 
f 2135//1945 2133//1943 2136//1946 
f 2137//1947 2135//1945 2138//1948 
f 2139//1949 2137//1947 2140//1950 
f 2141//1951 2139//1949 2142//1952 
f 2143//1953 2141//1951 2144//1954 
f 2145//1955 2143//1953 2146//1956 
f 2147//1957 2145//1955 2148//1958 
f 2149//1959 2147//1957 2150//1960 
f 2151//1961 2149//1959 2152//1962 
f 2153//1963 2151//1961 2154//1964 
f 2155//1965 2153//1963 2156//1966 
f 2101//1912 2155//1965 2157//1965 
f 2157//1965 2102//1912 2101//1912 
f 2156//1966 2157//1965 2155//1965 
f 2154//1964 2156//1966 2153//1963 
f 2152//1962 2154//1964 2151//1961 
f 2150//1960 2152//1962 2149//1959 
f 2148//1958 2150//1960 2147//1957 
f 2146//1956 2148//1958 2145//1955 
f 2144//1954 2146//1956 2143//1953 
f 2142//1952 2144//1954 2141//1951 
f 2140//1950 2142//1952 2139//1949 
f 2138//1948 2140//1950 2137//1947 
f 2136//1946 2138//1948 2135//1945 
f 2134//1944 2136//1946 2133//1943 
f 2132//1942 2134//1944 2131//1941 
f 2130//1940 2132//1942 2129//1939 
f 2128//1938 2130//1940 2127//1937 
f 2126//1936 2128//1938 2125//1935 
f 2124//1934 2126//1936 2123//1933 
f 2122//1932 2124//1934 2121//1931 
f 2120//1930 2122//1932 2119//1929 
f 2118//1928 2120//1930 2117//1927 
f 2116//1926 2118//1928 2115//1925 
f 2114//1924 2116//1926 2113//1923 
f 2112//1922 2114//1924 2111//1921 
f 2110//1920 2112//1922 2109//1919 
f 2108//1918 2110//1920 2107//1917 
f 2106//1916 2108//1918 2105//1915 
f 2104//1914 2106//1916 2103//1913 
f 2102//1912 2104//1914 2100//1911 
o mesh4
f 2158//1967 2138//1967 2136//1967 
f 2158//1967 2159//1967 2140//1967 
f 2160//1967 2136//1967 2134//1967 
f 2140//1967 2138//1967 2158//1967 
f 2161//1967 2146//1967 2144//1967 
f 2161//1967 2162//1967 2148//1967 
f 2136//1967 2160//1967 2158//1967 
f 2159//1967 2163//1967 2142//1967 
f 2164//1967 2144//1967 2142//1967 
f 2148//1967 2146//1967 2161//1967 
f 2165//1967 2152//1967 2150//1967 
f 2165//1967 2166//1967 2154//1967 
f 2167//1967 2157//1967 2156//1967 
f 2168//1967 2102//1967 2157//1967 
f 2142//1967 2140//1967 2159//1967 
f 2144//1967 2164//1967 2161//1967 
f 2169//1967 2150//1967 2148//1967 
f 2154//1967 2152//1967 2165//1967 
f 2157//1967 2167//1967 2168//1967 
f 2170//1967 2104//1967 2102//1967 
f 2142//1967 2163//1967 2164//1967 
f 2150//1967 2169//1967 2165//1967 
f 2171//1967 2156//1967 2154//1967 
f 2102//1967 2168//1967 2170//1967 
f 2172//1967 2124//1967 2122//1967 
f 2173//1967 2126//1967 2124//1967 
f 2148//1967 2162//1967 2169//1967 
f 2156//1967 2171//1967 2167//1967 
f 2174//1967 2122//1967 2120//1967 
f 2124//1967 2172//1967 2173//1967 
f 2175//1967 2134//1967 2132//1967 
f 2154//1967 2166//1967 2171//1967 
f 2176//1967 2106//1967 2104//1967 
f 2177//1967 2108//1967 2106//1967 
f 2178//1967 2110//1967 2108//1967 
f 2179//1967 2112//1967 2110//1967 
f 2180//1967 2114//1967 2112//1967 
f 2180//1967 2181//1967 2116//1967 
f 2122//1967 2174//1967 2172//1967 
f 2182//1967 2128//1967 2126//1967 
f 2183//1967 2130//1967 2128//1967 
f 2184//1967 2132//1967 2130//1967 
f 2134//1967 2175//1967 2160//1967 
f 2106//1967 2176//1967 2177//1967 
f 2110//1967 2178//1967 2179//1967 
f 2116//1967 2114//1967 2180//1967 
f 2185//1967 2118//1967 2116//1967 
f 2186//1967 2120//1967 2118//1967 
f 2126//1967 2173//1967 2182//1967 
f 2130//1967 2183//1967 2184//1967 
f 2104//1967 2170//1967 2176//1967 
f 2112//1967 2179//1967 2180//1967 
f 2118//1967 2185//1967 2186//1967 
f 2128//1967 2182//1967 2183//1967 
f 2108//1967 2177//1967 2178//1967 
f 2120//1967 2186//1967 2174//1967 
f 2116//1967 2181//1967 2185//1967 
f 2132//1967 2184//1967 2175//1967 
o mesh5
f 2187//1968 2168//1968 2167//1969 
f 2188//1969 2167//1969 2171//1970 
f 2189//1970 2171//1970 2166//1971 
f 2190//1971 2166//1971 2165//1972 
f 2191//1972 2165//1972 2169//1973 
f 2192//1973 2169//1973 2162//1974 
f 2193//1974 2162//1974 2161//1975 
f 2194//1975 2161//1975 2164//1976 
f 2195//1976 2164//1976 2163//1977 
f 2196//1977 2163//1977 2159//1978 
f 2197//1978 2159//1978 2158//1979 
f 2198//1979 2158//1979 2160//1980 
f 2199//1980 2160//1980 2175//1981 
f 2200//1981 2175//1981 2184//1982 
f 2201//1982 2184//1982 2183//1983 
f 2202//1983 2183//1983 2182//1984 
f 2203//1984 2182//1984 2173//1985 
f 2204//1985 2173//1985 2172//1986 
f 2205//1986 2172//1986 2174//1987 
f 2206//1987 2174//1987 2186//1988 
f 2207//1988 2186//1988 2185//1989 
f 2208//1989 2185//1989 2181//1990 
f 2209//1990 2181//1990 2180//1991 
f 2210//1991 2180//1991 2179//1992 
f 2211//1992 2179//1992 2178//1993 
f 2212//1993 2178//1993 2177//1994 
f 2213//1994 2177//1994 2176//1995 
f 2214//1995 2176//1995 2170//1996 
f 2215//1996 2170//1996 2168//1968 
f 2168//1968 2187//1968 2215//1996 
f 2170//1996 2215//1996 2214//1995 
f 2176//1995 2214//1995 2213//1994 
f 2177//1994 2213//1994 2212//1993 
f 2178//1993 2212//1993 2211//1992 
f 2179//1992 2211//1992 2210//1991 
f 2180//1991 2210//1991 2209//1990 
f 2181//1990 2209//1990 2208//1989 
f 2185//1989 2208//1989 2207//1988 
f 2186//1988 2207//1988 2206//1987 
f 2174//1987 2206//1987 2205//1986 
f 2172//1986 2205//1986 2204//1985 
f 2173//1985 2204//1985 2203//1984 
f 2182//1984 2203//1984 2202//1983 
f 2183//1983 2202//1983 2201//1982 
f 2184//1982 2201//1982 2200//1981 
f 2175//1981 2200//1981 2199//1980 
f 2160//1980 2199//1980 2198//1979 
f 2158//1979 2198//1979 2197//1978 
f 2159//1978 2197//1978 2196//1977 
f 2163//1977 2196//1977 2195//1976 
f 2164//1976 2195//1976 2194//1975 
f 2161//1975 2194//1975 2193//1974 
f 2162//1974 2193//1974 2192//1973 
f 2169//1973 2192//1973 2191//1972 
f 2165//1972 2191//1972 2190//1971 
f 2166//1971 2190//1971 2189//1970 
f 2171//1970 2189//1970 2188//1969 
f 2167//1969 2188//1969 2187//1968 
o mesh6
f 2188//1997 2216//1997 2217//1998 
f 2217//1998 2187//1999 2188//1997 
f 2189//2000 2218//2000 2219//2001 
f 2219//2001 2188//1997 2189//2000 
f 2190//2002 2220//2002 2221//2003 
f 2221//2003 2189//2000 2190//2002 
f 2191//2004 2222//2004 2223//2005 
f 2223//2005 2190//2002 2191//2004 
f 2192//2006 2224//2006 2225//2007 
f 2225//2007 2191//2004 2192//2006 
f 2193//2008 2226//2008 2227//2009 
f 2227//2009 2192//2006 2193//2008 
f 2194//2010 2228//2010 2229//2011 
f 2229//2011 2193//2008 2194//2010 
f 2195//2012 2230//2012 2231//2013 
f 2231//2013 2194//2010 2195//2012 
f 2196//2014 2232//2014 2233//2015 
f 2233//2015 2195//2012 2196//2014 
f 2197//2016 2234//2016 2235//2017 
f 2235//2017 2196//2014 2197//2016 
f 2197//2016 2198//2018 2236//2019 
f 2198//2018 2237//2018 2236//2019 
f 2198//2018 2199//2020 2238//2021 
f 2199//2020 2239//2020 2238//2021 
f 2199//2020 2200//2022 2240//2023 
f 2200//2022 2241//2022 2240//2023 
f 2201//2024 2242//2024 2243//2025 
f 2243//2025 2200//2022 2201//2024 
f 2202//2026 2244//2026 2245//2027 
f 2245//2027 2201//2024 2202//2026 
f 2203//2028 2246//2028 2247//2029 
f 2247//2029 2202//2026 2203//2028 
f 2204//2030 2248//2030 2249//2031 
f 2249//2031 2203//2028 2204//2030 
f 2205//2032 2250//2032 2251//2033 
f 2251//2033 2204//2030 2205//2032 
f 2206//2034 2252//2034 2253//2035 
f 2253//2035 2205//2032 2206//2034 
f 2207//2036 2254//2036 2255//2037 
f 2255//2037 2206//2034 2207//2036 
f 2208//2038 2256//2038 2257//2039 
f 2257//2039 2207//2036 2208//2038 
f 2209//2040 2258//2040 2259//2041 
f 2259//2041 2208//2038 2209//2040 
f 2210//2042 2260//2042 2261//2043 
f 2261//2043 2209//2040 2210//2042 
f 2211//2044 2262//2044 2263//2045 
f 2263//2045 2210//2042 2211//2044 
f 2212//2046 2264//2046 2265//2047 
f 2265//2047 2211//2044 2212//2046 
f 2213//2048 2266//2048 2267//2049 
f 2267//2049 2212//2046 2213//2048 
f 2214//2050 2268//2050 2269//2051 
f 2269//2051 2213//2048 2214//2050 
f 2215//2052 2270//2052 2271//2053 
f 2271//2053 2214//2050 2215//2052 
f 2187//1999 2272//2054 2273//2055 
f 2273//2055 2215//2052 2187//1999 
f 2273//2055 2270//2052 2215//2052 
f 2271//2053 2268//2050 2214//2050 
f 2269//2051 2266//2048 2213//2048 
f 2267//2049 2264//2046 2212//2046 
f 2265//2047 2262//2044 2211//2044 
f 2263//2045 2260//2042 2210//2042 
f 2261//2043 2258//2040 2209//2040 
f 2259//2041 2256//2038 2208//2038 
f 2257//2039 2254//2036 2207//2036 
f 2255//2037 2252//2034 2206//2034 
f 2253//2035 2250//2032 2205//2032 
f 2251//2033 2248//2030 2204//2030 
f 2249//2031 2246//2028 2203//2028 
f 2247//2029 2244//2026 2202//2026 
f 2245//2027 2242//2024 2201//2024 
f 2243//2025 2241//2022 2200//2022 
f 2240//2023 2239//2020 2199//2020 
f 2238//2021 2237//2018 2198//2018 
f 2236//2019 2234//2016 2197//2016 
f 2235//2017 2232//2014 2196//2014 
f 2233//2015 2230//2012 2195//2012 
f 2231//2013 2228//2010 2194//2010 
f 2229//2011 2226//2008 2193//2008 
f 2227//2009 2224//2006 2192//2006 
f 2225//2007 2222//2004 2191//2004 
f 2223//2005 2220//2002 2190//2002 
f 2221//2003 2218//2000 2189//2000 
f 2219//2001 2216//1997 2188//1997 
f 2217//1998 2272//2054 2187//1999 
o mesh7
f 2274//2056 2243//2056 2242//2057 
f 2242//2057 2275//2058 2274//2056 
f 2276//2059 2240//2059 2241//2060 
f 2241//2060 2274//2056 2276//2059 
f 2277//2061 2238//2061 2239//2062 
f 2239//2062 2276//2059 2277//2061 
f 2278//2063 2236//2063 2237//2064 
f 2237//2064 2277//2061 2278//2063 
f 2279//2065 2235//2065 2234//2066 
f 2234//2066 2278//2063 2279//2065 
f 2280//2067 2233//2067 2232//2068 
f 2232//2068 2279//2065 2280//2067 
f 2281//2069 2231//2069 2230//2070 
f 2230//2070 2280//2067 2281//2069 
f 2282//2071 2229//2071 2228//2072 
f 2228//2072 2281//2069 2282//2071 
f 2283//2073 2227//2073 2226//2074 
f 2226//2074 2282//2071 2283//2073 
f 2284//2075 2225//2075 2224//2076 
f 2224//2076 2283//2073 2284//2075 
f 2285//2077 2223//2077 2222//2078 
f 2222//2078 2284//2075 2285//2077 
f 2286//2079 2221//2079 2220//2080 
f 2220//2080 2285//2077 2286//2079 
f 2287//2081 2219//2081 2218//2082 
f 2218//2082 2286//2079 2287//2081 
f 2288//2083 2217//2083 2216//2084 
f 2216//2084 2287//2081 2288//2083 
f 2273//2085 2272//2086 2289//2086 
f 2217//2083 2288//2083 2289//2086 
f 2289//2086 2272//2086 2217//2083 
f 2290//2085 2291//2087 2270//2088 
f 2291//2087 2271//2087 2270//2088 
f 2291//2087 2292//2089 2268//2090 
f 2292//2089 2269//2089 2268//2090 
f 2292//2089 2293//2091 2266//2092 
f 2293//2091 2267//2091 2266//2092 
f 2294//2093 2265//2093 2264//2094 
f 2264//2094 2293//2091 2294//2093 
f 2295//2095 2263//2095 2262//2096 
f 2262//2096 2294//2093 2295//2095 
f 2296//2097 2261//2097 2260//2098 
f 2260//2098 2295//2095 2296//2097 
f 2297//2099 2259//2099 2258//2100 
f 2258//2100 2296//2097 2297//2099 
f 2298//2101 2257//2101 2256//2102 
f 2256//2102 2297//2099 2298//2101 
f 2299//2103 2255//2103 2254//2104 
f 2254//2104 2298//2101 2299//2103 
f 2300//2105 2253//2105 2252//2106 
f 2252//2106 2299//2103 2300//2105 
f 2300//2105 2301//2107 2250//2108 
f 2301//2107 2251//2107 2250//2108 
f 2302//2109 2249//2109 2248//2110 
f 2248//2110 2301//2107 2302//2109 
f 2303//2111 2247//2111 2246//2112 
f 2246//2112 2302//2109 2303//2111 
f 2303//2111 2275//2058 2244//2113 
f 2275//2058 2245//2114 2244//2113 
f 2244//2113 2247//2111 2303//2111 
f 2246//2112 2249//2109 2302//2109 
f 2248//2110 2251//2107 2301//2107 
f 2250//2108 2253//2105 2300//2105 
f 2252//2106 2255//2103 2299//2103 
f 2254//2104 2257//2101 2298//2101 
f 2256//2102 2259//2099 2297//2099 
f 2258//2100 2261//2097 2296//2097 
f 2260//2098 2263//2095 2295//2095 
f 2262//2096 2265//2093 2294//2093 
f 2264//2094 2267//2091 2293//2091 
f 2266//2092 2269//2089 2292//2089 
f 2268//2090 2271//2087 2291//2087 
f 2270//2088 2273//2085 2290//2085 
f 2289//2086 2290//2085 2273//2085 
f 2216//2084 2219//2081 2287//2081 
f 2218//2082 2221//2079 2286//2079 
f 2220//2080 2223//2077 2285//2077 
f 2222//2078 2225//2075 2284//2075 
f 2224//2076 2227//2073 2283//2073 
f 2226//2074 2229//2071 2282//2071 
f 2228//2072 2231//2069 2281//2069 
f 2230//2070 2233//2067 2280//2067 
f 2232//2068 2235//2065 2279//2065 
f 2234//2066 2236//2063 2278//2063 
f 2237//2064 2238//2061 2277//2061 
f 2239//2062 2240//2059 2276//2059 
f 2241//2060 2243//2056 2274//2056 
f 2242//2057 2245//2114 2275//2058 
o mesh8
f 2288//2115 2287//2115 2155//2115 
f 2101//2115 2289//2115 2288//2115 
f 2287//2115 2286//2115 2153//2115 
f 2285//2115 2284//2115 2149//2115 
f 2284//2115 2283//2115 2147//2115 
f 2153//2115 2155//2115 2287//2115 
f 2286//2115 2285//2115 2151//2115 
f 2147//2115 2149//2115 2284//2115 
f 2283//2115 2282//2115 2145//2115 
f 2282//2115 2281//2115 2143//2115 
f 2281//2115 2280//2115 2141//2115 
f 2278//2115 2277//2115 2135//2115 
f 2277//2115 2276//2115 2133//2115 
f 2301//2115 2300//2115 2121//2115 
f 2300//2115 2299//2115 2119//2115 
f 2151//2115 2153//2115 2286//2115 
f 2145//2115 2147//2115 2283//2115 
f 2141//2115 2143//2115 2281//2115 
f 2280//2115 2279//2115 2139//2115 
f 2279//2115 2278//2115 2137//2115 
f 2133//2115 2135//2115 2277//2115 
f 2274//2115 2275//2115 2129//2115 
f 2275//2115 2303//2115 2127//2115 
f 2119//2115 2121//2115 2300//2115 
f 2299//2115 2298//2115 2117//2115 
f 2149//2115 2151//2115 2285//2115 
f 2139//2115 2141//2115 2280//2115 
f 2135//2115 2137//2115 2278//2115 
f 2276//2115 2274//2115 2131//2115 
f 2127//2115 2129//2115 2275//2115 
f 2303//2115 2302//2115 2125//2115 
f 2302//2115 2301//2115 2123//2115 
f 2117//2115 2119//2115 2299//2115 
f 2296//2115 2295//2115 2111//2115 
f 2295//2115 2294//2115 2109//2115 
f 2294//2115 2293//2115 2107//2115 
f 2293//2115 2292//2115 2105//2115 
f 2143//2115 2145//2115 2282//2115 
f 2131//2115 2133//2115 2276//2115 
f 2125//2115 2127//2115 2303//2115 
f 2121//2115 2123//2115 2301//2115 
f 2109//2115 2111//2115 2295//2115 
f 2105//2115 2107//2115 2293//2115 
f 2292//2115 2291//2115 2103//2115 
f 2291//2115 2290//2115 2100//2115 
f 2137//2115 2139//2115 2279//2115 
f 2123//2115 2125//2115 2302//2115 
f 2298//2115 2297//2115 2115//2115 
f 2297//2115 2296//2115 2113//2115 
f 2107//2115 2109//2115 2294//2115 
f 2100//2115 2103//2115 2291//2115 
f 2129//2115 2131//2115 2274//2115 
f 2113//2115 2115//2115 2297//2115 
f 2103//2115 2105//2115 2292//2115 
f 2290//2115 2289//2115 2101//2115 
f 2115//2115 2117//2115 2298//2115 
f 2101//2115 2100//2115 2290//2115 
f 2111//2115 2113//2115 2296//2115 
f 2155//2115 2101//2115 2288//2115 
g 775DCMotor
v 0.0586301 -0.0353896 -0.0643412 
v 0.0587463 -0.0348616 -0.0643412 
v 0.0589733 -0.034371 -0.0643412 
v 0.0593005 -0.0339406 -0.0643412 
v 0.0597125 -0.0335907 -0.0643412 
v 0.0601901 -0.0333375 -0.0643412 
v 0.060711 -0.0331928 -0.0643412 
v 0.0612508 -0.0331636 -0.0643412 
v 0.0617843 -0.033251 -0.0643412 
v 0.0622865 -0.0334511 -0.0643412 
v 0.0627339 -0.0337545 -0.0643412 
v 0.0631057 -0.034147 -0.0643412 
v 0.0633844 -0.0346102 -0.0643412 
v 0.063557 -0.0351225 -0.0643412 
v 0.0636155 -0.0356599 -0.0643412 
v 0.063557 -0.0361973 -0.0643412 
v 0.0633844 -0.0367096 -0.0643412 
v 0.0631057 -0.0371728 -0.0643412 
v 0.0627339 -0.0375653 -0.0643412 
v 0.0622865 -0.0378687 -0.0643412 
v 0.0617843 -0.0380688 -0.0643412 
v 0.0612508 -0.0381562 -0.0643412 
v 0.060711 -0.038127 -0.0643412 
v 0.0601901 -0.0379823 -0.0643412 
v 0.0597125 -0.0377291 -0.0643412 
v 0.0593005 -0.0373791 -0.0643412 
v 0.0589733 -0.0369488 -0.0643412 
v 0.0587463 -0.0364581 -0.0643412 
v 0.0586301 -0.0359302 -0.0643412 
v 0.0586155 -0.0356599 -0.0643412 
v 0.0611155 -0.0356599 -0.0643412 
v 0.0636155 -0.0356599 -0.0493412 
v 0.063557 -0.0351225 -0.0493412 
v 0.0633844 -0.0346102 -0.0493412 
v 0.0631057 -0.034147 -0.0493412 
v 0.0627339 -0.0337545 -0.0493412 
v 0.0622865 -0.0334511 -0.0493412 
v 0.0617843 -0.033251 -0.0493412 
v 0.0612508 -0.0331636 -0.0493412 
v 0.060711 -0.0331928 -0.0493412 
v 0.0601901 -0.0333375 -0.0493412 
v 0.0597125 -0.0335907 -0.0493412 
v 0.0593005 -0.0339406 -0.0493412 
v 0.0589733 -0.034371 -0.0493412 
v 0.0587463 -0.0348616 -0.0493412 
v 0.0586301 -0.0359302 -0.0493412 
v 0.0586155 -0.0356599 -0.0493412 
v 0.0586301 -0.0353896 -0.0493412 
v 0.0587463 -0.0364581 -0.0493412 
v 0.0589733 -0.0369488 -0.0493412 
v 0.0593005 -0.0373791 -0.0493412 
v 0.0597125 -0.0377291 -0.0493412 
v 0.0601901 -0.0379823 -0.0493412 
v 0.060711 -0.038127 -0.0493412 
v 0.0612508 -0.0381562 -0.0493412 
v 0.0617843 -0.0380688 -0.0493412 
v 0.0622865 -0.0378687 -0.0493412 
v 0.0627339 -0.0375653 -0.0493412 
v 0.0631057 -0.0371728 -0.0493412 
v 0.0633844 -0.0367096 -0.0493412 
v 0.063557 -0.0361973 -0.0493412 
v 0.0531624 -0.0347949 -0.0493412 
v 0.0535342 -0.0331055 -0.0493412 
v 0.0542606 -0.0315355 -0.0493412 
v 0.0553075 -0.0301583 -0.0493412 
v 0.056626 -0.0290384 -0.0493412 
v 0.0581544 -0.0282281 -0.0493412 
v 0.0615486 -0.0276716 -0.0493412 
v 0.0632557 -0.0279515 -0.0493412 
v 0.0598212 -0.0277653 -0.0493412 
v 0.0648627 -0.0285918 -0.0493412 
v 0.0662946 -0.0295626 -0.0493412 
v 0.0683761 -0.0323008 -0.0493412 
v 0.0689284 -0.0339401 -0.0493412 
v 0.0674842 -0.0308185 -0.0493412 
v 0.0691155 -0.0356599 -0.0493412 
v 0.0689284 -0.0373797 -0.0493412 
v 0.0683761 -0.039019 -0.0493412 
v 0.0674842 -0.0405013 -0.0493412 
v 0.0662946 -0.0417572 -0.0493412 
v 0.0648627 -0.042728 -0.0493412 
v 0.0632557 -0.0433683 -0.0493412 
v 0.0615486 -0.0436482 -0.0493412 
v 0.0598212 -0.0435545 -0.0493412 
v 0.0581544 -0.0430917 -0.0493412 
v 0.056626 -0.0422814 -0.0493412 
v 0.0553075 -0.0411615 -0.0493412 
v 0.0542606 -0.0397843 -0.0493412 
v 0.0535342 -0.0382143 -0.0493412 
v 0.0531624 -0.0365248 -0.0493412 
v 0.0531155 -0.0356599 -0.0493412 
v 0.0691155 -0.0356599 -0.0448412 
v 0.0689284 -0.0339401 -0.0448412 
v 0.0683761 -0.0323008 -0.0448412 
v 0.0674842 -0.0308185 -0.0448412 
v 0.0662946 -0.0295626 -0.0448412 
v 0.0648627 -0.0285918 -0.0448412 
v 0.0632557 -0.0279515 -0.0448412 
v 0.0615486 -0.0276716 -0.0448412 
v 0.0598212 -0.0277653 -0.0448412 
v 0.0581544 -0.0282281 -0.0448412 
v 0.056626 -0.0290384 -0.0448412 
v 0.0553075 -0.0301583 -0.0448412 
v 0.0542606 -0.0315355 -0.0448412 
v 0.0535342 -0.0331055 -0.0448412 
v 0.0531624 -0.0365248 -0.0448412 
v 0.0531155 -0.0356599 -0.0448412 
v 0.0531624 -0.0347949 -0.0448412 
v 0.0535342 -0.0382143 -0.0448412 
v 0.0542606 -0.0397843 -0.0448412 
v 0.0553075 -0.0411615 -0.0448412 
v 0.056626 -0.0422814 -0.0448412 
v 0.0581544 -0.0430917 -0.0448412 
v 0.0598212 -0.0435545 -0.0448412 
v 0.0615486 -0.0436482 -0.0448412 
v 0.0632557 -0.0433683 -0.0448412 
v 0.0648627 -0.042728 -0.0448412 
v 0.0662946 -0.0417572 -0.0448412 
v 0.0674842 -0.0405013 -0.0448412 
v 0.0683761 -0.039019 -0.0448412 
v 0.0689284 -0.0373797 -0.0448412 
v 0.0458752 -0.0338019 -0.0448412 
v 0.0454931 -0.0340045 -0.0448412 
v 0.0412148 -0.0289546 -0.0448412 
v 0.0462919 -0.0336862 -0.0448412 
v 0.0431215 -0.0248333 -0.0448412 
v 0.0467238 -0.0336628 -0.0448412 
v 0.0458696 -0.0212182 -0.0448412 
v 0.0471505 -0.0337328 -0.0448412 
v 0.0493305 -0.0182784 -0.0448412 
v 0.0479102 -0.0341356 -0.0448412 
v 0.0577181 -0.0149365 -0.0448412 
v 0.0533426 -0.0161514 -0.0448412 
v 0.0475523 -0.0338929 -0.0448412 
v 0.0482077 -0.0344495 -0.0448412 
v 0.0484306 -0.0348201 -0.0448412 
v 0.0451635 -0.0342845 -0.0448412 
v 0.0449018 -0.0346288 -0.0448412 
v 0.0622524 -0.0146907 -0.0448412 
v 0.0667336 -0.0154253 -0.0448412 
v 0.0485687 -0.03523 -0.0448412 
v 0.0486155 -0.0356599 -0.0448412 
v 0.0402386 -0.0333894 -0.0448412 
v 0.0482077 -0.0368702 -0.0448412 
v 0.0484306 -0.0364997 -0.0448412 
v 0.0739018 -0.0346288 -0.0448412 
v 0.0737202 -0.0350213 -0.0448412 
v 0.0485687 -0.0360898 -0.0448412 
v 0.0741635 -0.0342845 -0.0448412 
v 0.0744931 -0.0340045 -0.0448412 
v 0.0479102 -0.0371842 -0.0448412 
v 0.0471505 -0.037587 -0.0448412 
v 0.0475523 -0.0374269 -0.0448412 
v 0.0752919 -0.0336862 -0.0448412 
v 0.0709521 -0.0171061 -0.0448412 
v 0.0747106 -0.0196545 -0.0448412 
v 0.0757238 -0.0336628 -0.0448412 
v 0.0778334 -0.0229512 -0.0448412 
v 0.0748752 -0.0338019 -0.0448412 
v 0.0761505 -0.0337328 -0.0448412 
v 0.0816245 -0.0311455 -0.0448412 
v 0.0772077 -0.0344495 -0.0448412 
v 0.0769102 -0.0341356 -0.0448412 
v 0.0801746 -0.0268422 -0.0448412 
v 0.0458696 -0.0501016 -0.0448412 
v 0.0765523 -0.0338929 -0.0448412 
v 0.0821155 -0.0356599 -0.0448412 
v 0.0775687 -0.03523 -0.0448412 
v 0.0757238 -0.037657 -0.0448412 
v 0.0761505 -0.037587 -0.0448412 
v 0.0778334 -0.0483686 -0.0448412 
v 0.0752919 -0.0376335 -0.0448412 
v 0.0747106 -0.0516653 -0.0448412 
v 0.0744931 -0.0373153 -0.0448412 
v 0.0748752 -0.0375178 -0.0448412 
v 0.0667336 -0.0558944 -0.0448412 
v 0.0741635 -0.0370353 -0.0448412 
v 0.0622524 -0.0566291 -0.0448412 
v 0.0533426 -0.0551684 -0.0448412 
v 0.0493305 -0.0530414 -0.0448412 
v 0.0462919 -0.0376335 -0.0448412 
v 0.0736272 -0.0354437 -0.0448412 
v 0.0774306 -0.0348201 -0.0448412 
v 0.0816245 -0.0401743 -0.0448412 
v 0.0801746 -0.0444776 -0.0448412 
v 0.0769102 -0.0371842 -0.0448412 
v 0.0765523 -0.0374269 -0.0448412 
v 0.0709521 -0.0542136 -0.0448412 
v 0.0577181 -0.0563832 -0.0448412 
v 0.0467238 -0.037657 -0.0448412 
v 0.0775687 -0.0360898 -0.0448412 
v 0.0776155 -0.0356599 -0.0448412 
v 0.0772077 -0.0368702 -0.0448412 
v 0.0431215 -0.0464865 -0.0448412 
v 0.0458752 -0.0375178 -0.0448412 
v 0.0412148 -0.0423652 -0.0448412 
v 0.0402386 -0.0379304 -0.0448412 
v 0.0449018 -0.036691 -0.0448412 
v 0.0736155 -0.0356599 -0.0448412 
v 0.0447202 -0.0350213 -0.0448412 
v 0.0446272 -0.0354437 -0.0448412 
v 0.0774306 -0.0364997 -0.0448412 
v 0.0737202 -0.0362985 -0.0448412 
v 0.0739018 -0.036691 -0.0448412 
v 0.0454931 -0.0373153 -0.0448412 
v 0.0451635 -0.0370353 -0.0448412 
v 0.0401155 -0.0356599 -0.0448412 
v 0.0447202 -0.0362985 -0.0448412 
v 0.0446155 -0.0356599 -0.0448412 
v 0.0736272 -0.0358761 -0.0448412 
v 0.0446272 -0.0358761 -0.0448412 
v 0.0821155 -0.0356599 0.0216588 
v 0.0816245 -0.0311455 0.0216588 
v 0.0801746 -0.0268422 0.0216588 
v 0.0778334 -0.0229512 0.0216588 
v 0.0747106 -0.0196545 0.0216588 
v 0.0709521 -0.0171061 0.0216588 
v 0.0667336 -0.0154253 0.0216588 
v 0.0622524 -0.0146907 0.0216588 
v 0.0577181 -0.0149365 0.0216588 
v 0.0533426 -0.0161514 0.0216588 
v 0.0493305 -0.0182784 0.0216588 
v 0.0458696 -0.0212182 0.0216588 
v 0.0431215 -0.0248333 0.0216588 
v 0.0412148 -0.0289546 0.0216588 
v 0.0402386 -0.0379304 0.0216588 
v 0.0401155 -0.0356599 0.0216588 
v 0.0402386 -0.0333894 0.0216588 
v 0.0412148 -0.0423652 0.0216588 
v 0.0431215 -0.0464865 0.0216588 
v 0.0458696 -0.0501016 0.0216588 
v 0.0493305 -0.0530414 0.0216588 
v 0.0533426 -0.0551684 0.0216588 
v 0.0577181 -0.0563832 0.0216588 
v 0.0622524 -0.0566291 0.0216588 
v 0.0667336 -0.0558944 0.0216588 
v 0.0709521 -0.0542136 0.0216588 
v 0.0747106 -0.0516653 0.0216588 
v 0.0778334 -0.0483686 0.0216588 
v 0.0801746 -0.0444776 0.0216588 
v 0.0816245 -0.0401743 0.0216588 
v 0.0485687 -0.0360898 0.0216588 
v 0.0486155 -0.0356599 0.0216588 
v 0.0484306 -0.0364997 0.0216588 
v 0.0482077 -0.0368702 0.0216588 
v 0.0479102 -0.0371842 0.0216588 
v 0.0475523 -0.0374269 0.0216588 
v 0.0471505 -0.037587 0.0216588 
v 0.0467238 -0.037657 0.0216588 
v 0.0462919 -0.0376335 0.0216588 
v 0.0458752 -0.0375178 0.0216588 
v 0.0454931 -0.0373153 0.0216588 
v 0.0451635 -0.0370353 0.0216588 
v 0.0449018 -0.036691 0.0216588 
v 0.0447202 -0.0362985 0.0216588 
v 0.0446272 -0.0358761 0.0216588 
v 0.0446272 -0.0354437 0.0216588 
v 0.0446155 -0.0356599 0.0216588 
v 0.0447202 -0.0350213 0.0216588 
v 0.0449018 -0.0346288 0.0216588 
v 0.0451635 -0.0342845 0.0216588 
v 0.0454931 -0.0340045 0.0216588 
v 0.0458752 -0.0338019 0.0216588 
v 0.0462919 -0.0336862 0.0216588 
v 0.0467238 -0.0336628 0.0216588 
v 0.0471505 -0.0337328 0.0216588 
v 0.0475523 -0.0338929 0.0216588 
v 0.0479102 -0.0341356 0.0216588 
v 0.0482077 -0.0344495 0.0216588 
v 0.0484306 -0.0348201 0.0216588 
v 0.0485687 -0.03523 0.0216588 
v 0.0775687 -0.0360898 0.0216588 
v 0.0776155 -0.0356599 0.0216588 
v 0.0774306 -0.0364997 0.0216588 
v 0.0772077 -0.0368702 0.0216588 
v 0.0769102 -0.0371842 0.0216588 
v 0.0765523 -0.0374269 0.0216588 
v 0.0761505 -0.037587 0.0216588 
v 0.0757238 -0.037657 0.0216588 
v 0.0752919 -0.0376335 0.0216588 
v 0.0748752 -0.0375178 0.0216588 
v 0.0744931 -0.0373153 0.0216588 
v 0.0741635 -0.0370353 0.0216588 
v 0.0739018 -0.036691 0.0216588 
v 0.0737202 -0.0362985 0.0216588 
v 0.0736272 -0.0358761 0.0216588 
v 0.0736272 -0.0354437 0.0216588 
v 0.0736155 -0.0356599 0.0216588 
v 0.0737202 -0.0350213 0.0216588 
v 0.0739018 -0.0346288 0.0216588 
v 0.0741635 -0.0342845 0.0216588 
v 0.0744931 -0.0340045 0.0216588 
v 0.0748752 -0.0338019 0.0216588 
v 0.0752919 -0.0336862 0.0216588 
v 0.0757238 -0.0336628 0.0216588 
v 0.0761505 -0.0337328 0.0216588 
v 0.0765523 -0.0338929 0.0216588 
v 0.0769102 -0.0341356 0.0216588 
v 0.0772077 -0.0344495 0.0216588 
v 0.0774306 -0.0348201 0.0216588 
v 0.0775687 -0.03523 0.0216588 
v 0.0686967 -0.0331055 0.0216588 
v 0.0690686 -0.0347949 0.0216588 
v 0.0679703 -0.0315355 0.0216588 
v 0.065605 -0.0290384 0.0216588 
v 0.0669234 -0.0301583 0.0216588 
v 0.0533025 -0.0373797 0.0216588 
v 0.0640766 -0.0282281 0.0216588 
v 0.0559364 -0.0295626 0.0216588 
v 0.0547467 -0.0405013 0.0216588 
v 0.0624097 -0.0277653 0.0216588 
v 0.0547467 -0.0308185 0.0216588 
v 0.0559364 -0.0417572 0.0216588 
v 0.0573682 -0.042728 0.0216588 
v 0.0589752 -0.0279515 0.0216588 
v 0.0606824 -0.0276716 0.0216588 
v 0.0573682 -0.0285918 0.0216588 
v 0.0533025 -0.0339401 0.0216588 
v 0.0538549 -0.0323008 0.0216588 
v 0.0531155 -0.0356599 0.0216588 
v 0.0538549 -0.039019 0.0216588 
v 0.0589752 -0.0433683 0.0216588 
v 0.0624097 -0.0435545 0.0216588 
v 0.0606824 -0.0436482 0.0216588 
v 0.0669234 -0.0411615 0.0216588 
v 0.065605 -0.0422814 0.0216588 
v 0.0686967 -0.0382143 0.0216588 
v 0.0679703 -0.0397843 0.0216588 
v 0.0690686 -0.0365248 0.0216588 
v 0.0640766 -0.0430917 0.0216588 
v 0.0531155 -0.0356599 0.0276588 
v 0.0533025 -0.0339401 0.0276588 
v 0.0538549 -0.0323008 0.0276588 
v 0.0547467 -0.0308185 0.0276588 
v 0.0559364 -0.0295626 0.0276588 
v 0.0573682 -0.0285918 0.0276588 
v 0.0589752 -0.0279515 0.0276588 
v 0.0606824 -0.0276716 0.0276588 
v 0.0624097 -0.0277653 0.0276588 
v 0.0640766 -0.0282281 0.0276588 
v 0.065605 -0.0290384 0.0276588 
v 0.0669234 -0.0301583 0.0276588 
v 0.0679703 -0.0315355 0.0276588 
v 0.0686967 -0.0331055 0.0276588 
v 0.0690686 -0.0347949 0.0276588 
v 0.0690686 -0.0365248 0.0276588 
v 0.0686967 -0.0382143 0.0276588 
v 0.0679703 -0.0397843 0.0276588 
v 0.0669234 -0.0411615 0.0276588 
v 0.065605 -0.0422814 0.0276588 
v 0.0640766 -0.0430917 0.0276588 
v 0.0624097 -0.0435545 0.0276588 
v 0.0606824 -0.0436482 0.0276588 
v 0.0589752 -0.0433683 0.0276588 
v 0.0573682 -0.042728 0.0276588 
v 0.0559364 -0.0417572 0.0276588 
v 0.0547467 -0.0405013 0.0276588 
v 0.0538549 -0.039019 0.0276588 
v 0.0533025 -0.0373797 0.0276588 
v 0.0634846 -0.0348616 0.0276588 
v 0.0632576 -0.034371 0.0276588 
v 0.0629305 -0.0339406 0.0276588 
v 0.0625184 -0.0335907 0.0276588 
v 0.0620408 -0.0333375 0.0276588 
v 0.0609801 -0.0331636 0.0276588 
v 0.0615199 -0.0331928 0.0276588 
v 0.0604467 -0.033251 0.0276588 
v 0.0599445 -0.0334511 0.0276588 
v 0.059497 -0.0337545 0.0276588 
v 0.0591252 -0.034147 0.0276588 
v 0.0588465 -0.0346102 0.0276588 
v 0.0586739 -0.0351225 0.0276588 
v 0.0586155 -0.0356599 0.0276588 
v 0.0586739 -0.0361973 0.0276588 
v 0.0588465 -0.0367096 0.0276588 
v 0.0591252 -0.0371728 0.0276588 
v 0.059497 -0.0375653 0.0276588 
v 0.0599445 -0.0378687 0.0276588 
v 0.0604467 -0.0380688 0.0276588 
v 0.0609801 -0.0381562 0.0276588 
v 0.0615199 -0.038127 0.0276588 
v 0.0620408 -0.0379823 0.0276588 
v 0.0625184 -0.0377291 0.0276588 
v 0.0629305 -0.0373791 0.0276588 
v 0.0632576 -0.0369488 0.0276588 
v 0.0634846 -0.0364581 0.0276588 
v 0.0636008 -0.0359302 0.0276588 
v 0.0636008 -0.0353896 0.0276588 
v 0.0586739 -0.0361973 0.0216588 
v 0.0586155 -0.0356599 0.0216588 
v 0.0588465 -0.0367096 0.0216588 
v 0.0591252 -0.0371728 0.0216588 
v 0.059497 -0.0375653 0.0216588 
v 0.0599445 -0.0378687 0.0216588 
v 0.0604467 -0.0380688 0.0216588 
v 0.0609801 -0.0381562 0.0216588 
v 0.0615199 -0.038127 0.0216588 
v 0.0620408 -0.0379823 0.0216588 
v 0.0625184 -0.0377291 0.0216588 
v 0.0629305 -0.0373791 0.0216588 
v 0.0632576 -0.0369488 0.0216588 
v 0.0634846 -0.0364581 0.0216588 
v 0.0636008 -0.0359302 0.0216588 
v 0.0636008 -0.0353896 0.0216588 
v 0.0634846 -0.0348616 0.0216588 
v 0.0632576 -0.034371 0.0216588 
v 0.0629305 -0.0339406 0.0216588 
v 0.0625184 -0.0335907 0.0216588 
v 0.0620408 -0.0333375 0.0216588 
v 0.0615199 -0.0331928 0.0216588 
v 0.0609801 -0.0331636 0.0216588 
v 0.0604467 -0.033251 0.0216588 
v 0.0599445 -0.0334511 0.0216588 
v 0.059497 -0.0337545 0.0216588 
v 0.0591252 -0.034147 0.0216588 
v 0.0588465 -0.0346102 0.0216588 
v 0.0586739 -0.0351225 0.0216588 
v 0.0611155 -0.0356599 0.0216588 
vn 0.0623057 -0.0363544 -0.997395 
vn 0.999228 -0.0335801 0.0203956 
vn 0.98519 0.170231 0.0205621 
vn 0.929347 0.368623 0.0207791 
vn 0.832743 0.55326 0.0210406 
vn 0.698023 0.715757 0.0213384 
vn 0.529599 0.847972 0.0216618 
vn 0.333781 0.942394 0.0219973 
vn 0.11882 0.992665 0.0223289 
vn -0.10522 0.994191 0.0226385 
vn -0.326834 0.944804 0.0229071 
vn -0.53373 0.845339 0.0231166 
vn -0.713774 0.69999 0.0232515 
vn -0.856096 0.516292 0.0233015 
vn -0.952182 0.304644 0.0232625 
vn -0.996731 0.0774068 0.0231377 
vn -0.988074 -0.152262 0.0229367 
vn -0.999014 -0.0379437 0.0230459 
vn -0.996731 0.0774068 0.0231377 
vn -0.988074 -0.152262 0.0229367 
vn -0.928113 -0.371608 0.0226745 
vn -0.821834 -0.569288 0.022369 
vn -0.676556 -0.736062 0.0220391 
vn -0.501097 -0.865119 0.0217032 
vn -0.30501 -0.952109 0.0213775 
vn -0.0979572 -0.994967 0.0210759 
vn 0.110734 -0.993632 0.0208093 
vn 0.312372 -0.949737 0.0205864 
vn 0.499075 -0.866318 0.0204134 
vn 0.663875 -0.747569 0.0202945 
vn 0.800764 -0.598638 0.0202326 
vn 0.904743 -0.425476 0.020229 
vn 0.971852 -0.234718 0.0202837 
vn 0.0623057 -0.0363544 -0.997395 
vn 0.999228 -0.0335801 0.0203956 
vn 0.98519 0.170231 0.0205621 
vn 0.929347 0.368623 0.0207791 
vn 0.832743 0.55326 0.0210406 
vn 0.698023 0.715757 0.0213384 
vn 0.529599 0.847972 0.0216618 
vn 0.333781 0.942394 0.0219973 
vn 0.11882 0.992665 0.0223289 
vn -0.10522 0.994191 0.0226385 
vn -0.326834 0.944804 0.0229071 
vn -0.53373 0.845339 0.0231166 
vn -0.713774 0.69999 0.0232515 
vn -0.856096 0.516292 0.0233015 
vn -0.952182 0.304644 0.0232625 
vn -0.996731 0.0774068 0.0231377 
vn -0.988074 -0.152262 0.0229367 
vn -0.999014 -0.0379437 0.0230459 
vn -0.996731 0.0774068 0.0231377 
vn -0.928113 -0.371608 0.0226745 
vn -0.821834 -0.569288 0.022369 
vn -0.676556 -0.736062 0.0220391 
vn -0.501097 -0.865119 0.0217032 
vn -0.30501 -0.952109 0.0213775 
vn -0.0979572 -0.994967 0.0210759 
vn 0.110734 -0.993632 0.0208093 
vn 0.312372 -0.949737 0.0205864 
vn 0.499075 -0.866318 0.0204134 
vn 0.663875 -0.747569 0.0202945 
vn 0.800764 -0.598638 0.0202326 
vn 0.904743 -0.425476 0.020229 
vn 0.971852 -0.234718 0.0202837 
vn 0.0623057 -0.0363544 -0.997395 
vn 0.999228 -0.0335801 0.0203956 
vn 0.98519 0.170231 0.0205621 
vn 0.929347 0.368623 0.0207791 
vn 0.832743 0.55326 0.0210406 
vn 0.698023 0.715757 0.0213384 
vn 0.529599 0.847972 0.0216618 
vn 0.333781 0.942394 0.0219973 
vn 0.11882 0.992665 0.0223289 
vn -0.10522 0.994191 0.0226385 
vn -0.326834 0.944804 0.0229071 
vn -0.53373 0.845339 0.0231166 
vn -0.713774 0.69999 0.0232515 
vn -0.856096 0.516292 0.0233015 
vn -0.952182 0.304644 0.0232625 
vn -0.996731 0.0774068 0.0231377 
vn -0.988074 -0.152262 0.0229367 
vn -0.999014 -0.0379437 0.0230459 
vn -0.996731 0.0774068 0.0231377 
vn -0.928113 -0.371608 0.0226745 
vn -0.821834 -0.569288 0.022369 
vn -0.676556 -0.736062 0.0220391 
vn -0.501097 -0.865119 0.0217032 
vn -0.30501 -0.952109 0.0213775 
vn -0.0979572 -0.994967 0.0210759 
vn 0.110734 -0.993632 0.0208093 
vn 0.312372 -0.949737 0.0205864 
vn 0.499075 -0.866318 0.0204134 
vn 0.663875 -0.747569 0.0202945 
vn 0.800764 -0.598638 0.0202326 
vn 0.904743 -0.425476 0.020229 
vn 0.971852 -0.234718 0.0202837 
vn -0.98109 0.192156 0.0232104 
vn -0.999014 -0.0379437 0.0230459 
vn -0.910332 0.413222 0.0232931 
vn -0.98109 0.192156 0.0232104 
vn -0.790249 0.612343 0.0232876 
vn -0.910332 0.413222 0.0232931 
vn -0.627831 0.778004 0.0231942 
vn -0.790249 0.612343 0.0232876 
vn -0.432896 0.90115 0.0230203 
vn -0.627831 0.778004 0.0231942 
vn -0.21709 0.975886 0.0227791 
vn -0.432896 0.90115 0.0230203 
vn 0.00724355 0.999721 0.0224876 
vn -0.21709 0.975886 0.0227791 
vn 0.228104 0.973384 0.0221647 
vn 0.00724355 0.999721 0.0224876 
vn 0.434643 0.900338 0.021829 
vn 0.228104 0.973384 0.0221647 
vn 0.617675 0.78614 0.0214977 
vn 0.434643 0.900338 0.021829 
vn 0.769915 0.637795 0.0211856 
vn 0.617675 0.78614 0.0214977 
vn 0.886014 0.463187 0.0209047 
vn 0.769915 0.637795 0.0211856 
vn 0.962464 0.270622 0.0206646 
vn 0.886014 0.463187 0.0209047 
vn 0.997442 0.0684895 0.0204722 
vn 0.962464 0.270622 0.0206646 
vn 0.99064 -0.134975 0.0203326 
vn 0.999228 -0.0335801 0.0203956 
vn 0.997442 0.0684895 0.0204722 
vn 0.943112 -0.331858 0.0202491 
vn 0.99064 -0.134975 0.0203326 
vn 0.85714 -0.514686 0.0202235 
vn 0.943112 -0.331858 0.0202491 
vn 0.736145 -0.676521 0.0202563 
vn 0.85714 -0.514686 0.0202235 
vn 0.584611 -0.811058 0.020347 
vn 0.736145 -0.676521 0.0202563 
vn 0.408048 -0.91273 0.0204933 
vn 0.584611 -0.811058 0.020347 
vn 0.212948 -0.976844 0.020692 
vn 0.408048 -0.91273 0.0204933 
vn 0.00674427 -0.999758 0.0209376 
vn 0.212948 -0.976844 0.020692 
vn -0.202259 -0.979102 0.0212229 
vn 0.00674427 -0.999758 0.0209376 
vn -0.405024 -0.914052 0.0215381 
vn -0.202259 -0.979102 0.0212229 
vn -0.592011 -0.805633 0.0218708 
vn -0.405024 -0.914052 0.0215381 
vn -0.753544 -0.657022 0.0222059 
vn -0.592011 -0.805633 0.0218708 
vn -0.880351 -0.473788 0.022526 
vn -0.753544 -0.657022 0.0222059 
vn -0.964259 -0.263977 0.0228122 
vn -0.880351 -0.473788 0.022526 
vn -0.98109 0.192156 0.0232104 
vn -0.999014 -0.0379437 0.0230459 
vn -0.910332 0.413222 0.0232931 
vn -0.98109 0.192156 0.0232104 
vn -0.790249 0.612343 0.0232876 
vn -0.910332 0.413222 0.0232931 
vn -0.627831 0.778004 0.0231942 
vn -0.790249 0.612343 0.0232876 
vn -0.432896 0.90115 0.0230203 
vn -0.627831 0.778004 0.0231942 
vn -0.21709 0.975886 0.0227791 
vn -0.432896 0.90115 0.0230203 
vn 0.00724355 0.999721 0.0224876 
vn -0.21709 0.975886 0.0227791 
vn 0.228104 0.973384 0.0221647 
vn 0.00724355 0.999721 0.0224876 
vn 0.434643 0.900338 0.021829 
vn 0.228104 0.973384 0.0221647 
vn 0.617675 0.78614 0.0214977 
vn 0.434643 0.900338 0.021829 
vn 0.769915 0.637795 0.0211856 
vn 0.617675 0.78614 0.0214977 
vn 0.886014 0.463187 0.0209047 
vn 0.769915 0.637795 0.0211856 
vn 0.962464 0.270622 0.0206646 
vn 0.886014 0.463187 0.0209047 
vn 0.997442 0.0684895 0.0204722 
vn 0.962464 0.270622 0.0206646 
vn 0.99064 -0.134975 0.0203326 
vn 0.999228 -0.0335801 0.0203956 
vn 0.997442 0.0684895 0.0204722 
vn 0.943112 -0.331858 0.0202491 
vn 0.99064 -0.134975 0.0203326 
vn 0.85714 -0.514686 0.0202235 
vn 0.943112 -0.331858 0.0202491 
vn 0.736145 -0.676521 0.0202563 
vn 0.85714 -0.514686 0.0202235 
vn 0.584611 -0.811058 0.020347 
vn 0.736145 -0.676521 0.0202563 
vn 0.408048 -0.91273 0.0204933 
vn 0.584611 -0.811058 0.020347 
vn 0.212948 -0.976844 0.020692 
vn 0.408048 -0.91273 0.0204933 
vn 0.00674427 -0.999758 0.0209376 
vn 0.212948 -0.976844 0.020692 
vn -0.202259 -0.979102 0.0212229 
vn 0.00674427 -0.999758 0.0209376 
vn -0.405024 -0.914052 0.0215381 
vn -0.202259 -0.979102 0.0212229 
vn -0.592011 -0.805633 0.0218708 
vn -0.405024 -0.914052 0.0215381 
vn -0.753544 -0.657022 0.0222059 
vn -0.592011 -0.805633 0.0218708 
vn -0.880351 -0.473788 0.022526 
vn -0.753544 -0.657022 0.0222059 
vn -0.964259 -0.263977 0.0228122 
vn -0.880351 -0.473788 0.022526 
vn 0.0596769 -0.0348205 0.99761 
vn -0.999014 -0.0379437 0.0230459 
vn -0.98109 0.192156 0.0232104 
vn -0.910332 0.413222 0.0232931 
vn -0.790249 0.612343 0.0232876 
vn -0.627831 0.778004 0.0231942 
vn -0.432896 0.90115 0.0230203 
vn -0.21709 0.975886 0.0227791 
vn 0.00724355 0.999721 0.0224876 
vn 0.228104 0.973384 0.0221647 
vn 0.434643 0.900338 0.021829 
vn 0.617675 0.78614 0.0214977 
vn 0.769915 0.637795 0.0211856 
vn 0.886014 0.463187 0.0209047 
vn 0.962464 0.270622 0.0206646 
vn 0.997442 0.0684895 0.0204722 
vn 0.99064 -0.134975 0.0203326 
vn 0.943112 -0.331858 0.0202491 
vn 0.85714 -0.514686 0.0202235 
vn 0.736145 -0.676521 0.0202563 
vn 0.584611 -0.811058 0.020347 
vn 0.408048 -0.91273 0.0204933 
vn 0.212948 -0.976844 0.020692 
vn 0.00674427 -0.999758 0.0209376 
vn -0.202259 -0.979102 0.0212229 
vn -0.405024 -0.914052 0.0215381 
vn -0.592011 -0.805633 0.0218708 
vn -0.753544 -0.657022 0.0222059 
vn -0.880351 -0.473788 0.022526 
vn -0.964259 -0.263977 0.0228122 
vn 0.0596769 -0.0348205 0.99761 
vn 0.98519 0.170231 0.0205621 
vn 0.999228 -0.0335801 0.0203956 
vn 0.929347 0.368623 0.0207791 
vn 0.98519 0.170231 0.0205621 
vn 0.832743 0.55326 0.0210406 
vn 0.929347 0.368623 0.0207791 
vn 0.698023 0.715757 0.0213384 
vn 0.832743 0.55326 0.0210406 
vn 0.529599 0.847972 0.0216618 
vn 0.698023 0.715757 0.0213384 
vn 0.333781 0.942394 0.0219973 
vn 0.529599 0.847972 0.0216618 
vn 0.11882 0.992665 0.0223289 
vn 0.333781 0.942394 0.0219973 
vn -0.10522 0.994191 0.0226385 
vn 0.11882 0.992665 0.0223289 
vn -0.326834 0.944804 0.0229071 
vn -0.10522 0.994191 0.0226385 
vn -0.53373 0.845339 0.0231166 
vn -0.326834 0.944804 0.0229071 
vn -0.713774 0.69999 0.0232515 
vn -0.53373 0.845339 0.0231166 
vn -0.856096 0.516292 0.0233015 
vn -0.713774 0.69999 0.0232515 
vn -0.952182 0.304644 0.0232625 
vn -0.856096 0.516292 0.0233015 
vn -0.996731 0.0774068 0.0231377 
vn -0.952182 0.304644 0.0232625 
vn -0.988074 -0.152262 0.0229367 
vn -0.996731 0.0774068 0.0231377 
vn -0.928113 -0.371608 0.0226745 
vn -0.988074 -0.152262 0.0229367 
vn -0.821834 -0.569288 0.022369 
vn -0.928113 -0.371608 0.0226745 
vn -0.676556 -0.736062 0.0220391 
vn -0.821834 -0.569288 0.022369 
vn -0.501097 -0.865119 0.0217032 
vn -0.676556 -0.736062 0.0220391 
vn -0.30501 -0.952109 0.0213775 
vn -0.501097 -0.865119 0.0217032 
vn -0.0979572 -0.994967 0.0210759 
vn -0.30501 -0.952109 0.0213775 
vn 0.110734 -0.993632 0.0208093 
vn -0.0979572 -0.994967 0.0210759 
vn 0.312372 -0.949737 0.0205864 
vn 0.110734 -0.993632 0.0208093 
vn 0.499075 -0.866318 0.0204134 
vn 0.312372 -0.949737 0.0205864 
vn 0.663875 -0.747569 0.0202945 
vn 0.499075 -0.866318 0.0204134 
vn 0.800764 -0.598638 0.0202326 
vn 0.663875 -0.747569 0.0202945 
vn 0.904743 -0.425476 0.020229 
vn 0.800764 -0.598638 0.0202326 
vn 0.971852 -0.234718 0.0202837 
vn 0.904743 -0.425476 0.020229 
vn 0.0596769 -0.0348205 0.99761 
usemtl 0.800000_0.800000_0.800000_0.000000_0.000000
o mesh251
f 2334//2116 2304//2116 2305//2116 
f 2305//2116 2306//2116 2334//2116 
f 2306//2116 2307//2116 2334//2116 
f 2307//2116 2308//2116 2334//2116 
f 2308//2116 2309//2116 2334//2116 
f 2309//2116 2310//2116 2334//2116 
f 2310//2116 2311//2116 2334//2116 
f 2311//2116 2312//2116 2334//2116 
f 2312//2116 2313//2116 2334//2116 
f 2313//2116 2314//2116 2334//2116 
f 2314//2116 2315//2116 2334//2116 
f 2315//2116 2316//2116 2334//2116 
f 2316//2116 2317//2116 2334//2116 
f 2317//2116 2318//2116 2334//2116 
f 2318//2116 2319//2116 2334//2116 
f 2319//2116 2320//2116 2334//2116 
f 2320//2116 2321//2116 2334//2116 
f 2321//2116 2322//2116 2334//2116 
f 2322//2116 2323//2116 2334//2116 
f 2323//2116 2324//2116 2334//2116 
f 2324//2116 2325//2116 2334//2116 
f 2325//2116 2326//2116 2334//2116 
f 2326//2116 2327//2116 2334//2116 
f 2327//2116 2328//2116 2334//2116 
f 2328//2116 2329//2116 2334//2116 
f 2329//2116 2330//2116 2334//2116 
f 2330//2116 2331//2116 2334//2116 
f 2331//2116 2332//2116 2334//2116 
f 2332//2116 2333//2116 2334//2116 
f 2333//2116 2304//2116 2334//2116 
o mesh252
f 2335//2117 2318//2117 2317//2118 
f 2336//2118 2317//2118 2316//2119 
f 2337//2119 2316//2119 2315//2120 
f 2338//2120 2315//2120 2314//2121 
f 2339//2121 2314//2121 2313//2122 
f 2340//2122 2313//2122 2312//2123 
f 2341//2123 2312//2123 2311//2124 
f 2342//2124 2311//2124 2310//2125 
f 2343//2125 2310//2125 2309//2126 
f 2344//2126 2309//2126 2308//2127 
f 2345//2127 2308//2127 2307//2128 
f 2346//2128 2307//2128 2306//2129 
f 2347//2129 2306//2129 2305//2130 
f 2348//2130 2305//2130 2304//2131 
f 2349//2132 2350//2133 2333//2133 
f 2304//2131 2333//2133 2350//2133 
f 2350//2133 2351//2134 2304//2131 
f 2349//2132 2332//2135 2331//2136 
f 2352//2136 2331//2136 2330//2137 
f 2353//2137 2330//2137 2329//2138 
f 2354//2138 2329//2138 2328//2139 
f 2355//2139 2328//2139 2327//2140 
f 2356//2140 2327//2140 2326//2141 
f 2357//2141 2326//2141 2325//2142 
f 2358//2142 2325//2142 2324//2143 
f 2359//2143 2324//2143 2323//2144 
f 2360//2144 2323//2144 2322//2145 
f 2361//2145 2322//2145 2321//2146 
f 2362//2146 2321//2146 2320//2147 
f 2363//2147 2320//2147 2319//2148 
f 2364//2148 2319//2148 2318//2117 
f 2318//2117 2335//2117 2364//2148 
f 2319//2148 2364//2148 2363//2147 
f 2320//2147 2363//2147 2362//2146 
f 2321//2146 2362//2146 2361//2145 
f 2322//2145 2361//2145 2360//2144 
f 2323//2144 2360//2144 2359//2143 
f 2324//2143 2359//2143 2358//2142 
f 2325//2142 2358//2142 2357//2141 
f 2326//2141 2357//2141 2356//2140 
f 2327//2140 2356//2140 2355//2139 
f 2328//2139 2355//2139 2354//2138 
f 2329//2138 2354//2138 2353//2137 
f 2330//2137 2353//2137 2352//2136 
f 2331//2136 2352//2136 2349//2132 
f 2333//2133 2332//2135 2349//2132 
f 2304//2131 2351//2134 2348//2130 
f 2305//2130 2348//2130 2347//2129 
f 2306//2129 2347//2129 2346//2128 
f 2307//2128 2346//2128 2345//2127 
f 2308//2127 2345//2127 2344//2126 
f 2309//2126 2344//2126 2343//2125 
f 2310//2125 2343//2125 2342//2124 
f 2311//2124 2342//2124 2341//2123 
f 2312//2123 2341//2123 2340//2122 
f 2313//2122 2340//2122 2339//2121 
f 2314//2121 2339//2121 2338//2120 
f 2315//2120 2338//2120 2337//2119 
f 2316//2119 2337//2119 2336//2118 
f 2317//2118 2336//2118 2335//2117 
o mesh253
f 2365//2149 2351//2149 2350//2149 
f 2365//2149 2366//2149 2348//2149 
f 2348//2149 2351//2149 2365//2149 
f 2366//2149 2367//2149 2347//2149 
f 2347//2149 2348//2149 2366//2149 
f 2367//2149 2368//2149 2346//2149 
f 2368//2149 2369//2149 2345//2149 
f 2369//2149 2370//2149 2344//2149 
f 2371//2149 2342//2149 2343//2149 
f 2371//2149 2372//2149 2341//2149 
f 2346//2149 2347//2149 2367//2149 
f 2344//2149 2345//2149 2369//2149 
f 2373//2149 2343//2149 2344//2149 
f 2341//2149 2342//2149 2371//2149 
f 2374//2149 2340//2149 2341//2149 
f 2374//2149 2375//2149 2339//2149 
f 2376//2149 2337//2149 2338//2149 
f 2376//2149 2377//2149 2336//2149 
f 2345//2149 2346//2149 2368//2149 
f 2343//2149 2373//2149 2371//2149 
f 2339//2149 2340//2149 2374//2149 
f 2375//2149 2378//2149 2338//2149 
f 2336//2149 2337//2149 2376//2149 
f 2379//2149 2335//2149 2336//2149 
f 2344//2149 2370//2149 2373//2149 
f 2338//2149 2339//2149 2375//2149 
f 2336//2149 2377//2149 2379//2149 
f 2379//2149 2380//2149 2364//2149 
f 2381//2149 2363//2149 2364//2149 
f 2381//2149 2382//2149 2362//2149 
f 2382//2149 2383//2149 2361//2149 
f 2383//2149 2384//2149 2360//2149 
f 2385//2149 2359//2149 2360//2149 
f 2385//2149 2386//2149 2358//2149 
f 2386//2149 2387//2149 2357//2149 
f 2387//2149 2388//2149 2356//2149 
f 2389//2149 2355//2149 2356//2149 
f 2390//2149 2354//2149 2355//2149 
f 2391//2149 2353//2149 2354//2149 
f 2391//2149 2392//2149 2352//2149 
f 2341//2149 2372//2149 2374//2149 
f 2364//2149 2335//2149 2379//2149 
f 2362//2149 2363//2149 2381//2149 
f 2360//2149 2361//2149 2383//2149 
f 2358//2149 2359//2149 2385//2149 
f 2356//2149 2357//2149 2387//2149 
f 2355//2149 2389//2149 2390//2149 
f 2352//2149 2353//2149 2391//2149 
f 2338//2149 2378//2149 2376//2149 
f 2361//2149 2362//2149 2382//2149 
f 2357//2149 2358//2149 2386//2149 
f 2354//2149 2390//2149 2391//2149 
f 2364//2149 2380//2149 2381//2149 
f 2356//2149 2388//2149 2389//2149 
f 2393//2149 2349//2149 2352//2149 
f 2393//2149 2394//2149 2350//2149 
f 2360//2149 2384//2149 2385//2149 
f 2350//2149 2349//2149 2393//2149 
f 2352//2149 2392//2149 2393//2149 
f 2350//2149 2394//2149 2365//2149 
o mesh254
f 2395//2150 2379//2150 2377//2151 
f 2396//2151 2377//2151 2376//2152 
f 2397//2152 2376//2152 2378//2153 
f 2398//2153 2378//2153 2375//2154 
f 2399//2154 2375//2154 2374//2155 
f 2400//2155 2374//2155 2372//2156 
f 2401//2156 2372//2156 2371//2157 
f 2402//2157 2371//2157 2373//2158 
f 2403//2158 2373//2158 2370//2159 
f 2404//2159 2370//2159 2369//2160 
f 2405//2160 2369//2160 2368//2161 
f 2406//2161 2368//2161 2367//2162 
f 2407//2162 2367//2162 2366//2163 
f 2408//2163 2366//2163 2365//2164 
f 2393//2165 2409//2165 2410//2166 
f 2411//2167 2365//2164 2394//2166 
f 2394//2166 2410//2166 2411//2167 
f 2409//2165 2393//2165 2392//2168 
f 2412//2168 2392//2168 2391//2169 
f 2413//2169 2391//2169 2390//2170 
f 2414//2170 2390//2170 2389//2171 
f 2415//2171 2389//2171 2388//2172 
f 2416//2172 2388//2172 2387//2173 
f 2417//2173 2387//2173 2386//2174 
f 2418//2174 2386//2174 2385//2175 
f 2419//2175 2385//2175 2384//2176 
f 2420//2176 2384//2176 2383//2177 
f 2421//2177 2383//2177 2382//2178 
f 2422//2178 2382//2178 2381//2179 
f 2423//2179 2381//2179 2380//2180 
f 2424//2180 2380//2180 2379//2150 
f 2379//2150 2395//2150 2424//2180 
f 2380//2180 2424//2180 2423//2179 
f 2381//2179 2423//2179 2422//2178 
f 2382//2178 2422//2178 2421//2177 
f 2383//2177 2421//2177 2420//2176 
f 2384//2176 2420//2176 2419//2175 
f 2385//2175 2419//2175 2418//2174 
f 2386//2174 2418//2174 2417//2173 
f 2387//2173 2417//2173 2416//2172 
f 2388//2172 2416//2172 2415//2171 
f 2389//2171 2415//2171 2414//2170 
f 2390//2170 2414//2170 2413//2169 
f 2391//2169 2413//2169 2412//2168 
f 2392//2168 2412//2168 2409//2165 
f 2410//2166 2394//2166 2393//2165 
f 2365//2164 2411//2167 2408//2163 
f 2366//2163 2408//2163 2407//2162 
f 2367//2162 2407//2162 2406//2161 
f 2368//2161 2406//2161 2405//2160 
f 2369//2160 2405//2160 2404//2159 
f 2370//2159 2404//2159 2403//2158 
f 2373//2158 2403//2158 2402//2157 
f 2371//2157 2402//2157 2401//2156 
f 2372//2156 2401//2156 2400//2155 
f 2374//2155 2400//2155 2399//2154 
f 2375//2154 2399//2154 2398//2153 
f 2378//2153 2398//2153 2397//2152 
f 2376//2152 2397//2152 2396//2151 
f 2377//2151 2396//2151 2395//2150 
o mesh255
f 2425//2181 2426//2181 2427//2181 
f 2428//2181 2425//2181 2429//2181 
f 2430//2181 2428//2181 2431//2181 
f 2432//2181 2430//2181 2433//2181 
f 2434//2181 2435//2181 2405//2181 
f 2429//2181 2431//2181 2428//2181 
f 2433//2181 2436//2181 2432//2181 
f 2435//2181 2404//2181 2405//2181 
f 2431//2181 2433//2181 2430//2181 
f 2437//2181 2432//2181 2436//2181 
f 2405//2181 2438//2181 2434//2181 
f 2439//2181 2408//2181 2411//2181 
f 2427//2181 2440//2181 2441//2181 
f 2436//2181 2435//2181 2437//2181 
f 2435//2181 2403//2181 2404//2181 
f 2442//2181 2402//2181 2403//2181 
f 2442//2181 2443//2181 2401//2181 
f 2411//2181 2444//2181 2439//2181 
f 2427//2181 2426//2181 2440//2181 
f 2434//2181 2437//2181 2435//2181 
f 2401//2181 2402//2181 2442//2181 
f 2438//2181 2407//2181 2408//2181 
f 2411//2181 2410//2181 2445//2181 
f 2441//2181 2446//2181 2427//2181 
f 2403//2181 2435//2181 2442//2181 
f 2445//2181 2444//2181 2411//2181 
f 2438//2181 2405//2181 2406//2181 
f 2410//2181 2447//2181 2448//2181 
f 2449//2181 2450//2181 2397//2181 
f 2427//2181 2429//2181 2425//2181 
f 2406//2181 2407//2181 2438//2181 
f 2448//2181 2451//2181 2410//2181 
f 2443//2181 2398//2181 2399//2181 
f 2398//2181 2452//2181 2449//2181 
f 2453//2181 2452//2181 2398//2181 
f 2439//2181 2438//2181 2408//2181 
f 2410//2181 2454//2181 2447//2181 
f 2399//2181 2400//2181 2443//2181 
f 2398//2181 2443//2181 2453//2181 
f 2451//2181 2445//2181 2410//2181 
f 2410//2181 2455//2181 2456//2181 
f 2397//2181 2398//2181 2449//2181 
f 2457//2181 2458//2181 2459//2181 
f 2460//2181 2459//2181 2461//2181 
f 2456//2181 2454//2181 2410//2181 
f 2443//2181 2462//2181 2453//2181 
f 2462//2181 2443//2181 2458//2181 
f 2461//2181 2463//2181 2460//2181 
f 2464//2181 2465//2181 2466//2181 
f 2400//2181 2401//2181 2443//2181 
f 2459//2181 2460//2181 2457//2181 
f 2463//2181 2461//2181 2467//2181 
f 2466//2181 2467//2181 2464//2181 
f 2468//2181 2414//2181 2415//2181 
f 2458//2181 2457//2181 2462//2181 
f 2466//2181 2469//2181 2467//2181 
f 2464//2181 2470//2181 2471//2181 
f 2472//2181 2473//2181 2474//2181 
f 2475//2181 2472//2181 2476//2181 
f 2477//2181 2478//2181 2479//2181 
f 2480//2181 2477//2181 2481//2181 
f 2482//2181 2416//2181 2417//2181 
f 2482//2181 2483//2181 2415//2181 
f 2468//2181 2413//2181 2414//2181 
f 2468//2181 2484//2181 2412//2181 
f 2395//2181 2396//2181 2485//2181 
f 2467//2181 2469//2181 2463//2181 
f 2471//2181 2486//2181 2464//2181 
f 2487//2181 2488//2181 2489//2181 
f 2473//2181 2490//2181 2488//2181 
f 2476//2181 2491//2181 2475//2181 
f 2478//2181 2475//2181 2491//2181 
f 2481//2181 2492//2181 2480//2181 
f 2480//2181 2492//2181 2421//2181 
f 2415//2181 2416//2181 2482//2181 
f 2412//2181 2413//2181 2468//2181 
f 2455//2181 2410//2181 2409//2181 
f 2412//2181 2484//2181 2493//2181 
f 2396//2181 2450//2181 2485//2181 
f 2486//2181 2465//2181 2464//2181 
f 2470//2181 2494//2181 2495//2181 
f 2489//2181 2496//2181 2487//2181 
f 2474//2181 2476//2181 2472//2181 
f 2479//2181 2481//2181 2477//2181 
f 2492//2181 2420//2181 2421//2181 
f 2492//2181 2417//2181 2418//2181 
f 2415//2181 2483//2181 2468//2181 
f 2493//2181 2455//2181 2412//2181 
f 2409//2181 2412//2181 2455//2181 
f 2484//2181 2468//2181 2497//2181 
f 2498//2181 2497//2181 2499//2181 
f 2499//2181 2500//2181 2501//2181 
f 2502//2181 2424//2181 2395//2181 
f 2502//2181 2421//2181 2422//2181 
f 2446//2181 2503//2181 2504//2181 
f 2495//2181 2471//2181 2470//2181 
f 2487//2181 2505//2181 2494//2181 
f 2488//2181 2490//2181 2489//2181 
f 2491//2181 2479//2181 2478//2181 
f 2421//2181 2506//2181 2507//2181 
f 2418//2181 2419//2181 2492//2181 
f 2499//2181 2508//2181 2498//2181 
f 2501//2181 2509//2181 2499//2181 
f 2485//2181 2502//2181 2395//2181 
f 2422//2181 2423//2181 2502//2181 
f 2504//2181 2510//2181 2446//2181 
f 2494//2181 2470//2181 2487//2181 
f 2488//2181 2474//2181 2473//2181 
f 2419//2181 2420//2181 2492//2181 
f 2497//2181 2498//2181 2484//2181 
f 2500//2181 2511//2181 2501//2181 
f 2423//2181 2424//2181 2502//2181 
f 2441//2181 2503//2181 2446//2181 
f 2421//2181 2507//2181 2480//2181 
f 2509//2181 2508//2181 2499//2181 
f 2504//2181 2512//2181 2510//2181 
f 2417//2181 2492//2181 2482//2181 
f 2496//2181 2505//2181 2487//2181 
f 2421//2181 2502//2181 2513//2181 
f 2500//2181 2510//2181 2514//2181 
f 2513//2181 2506//2181 2421//2181 
f 2510//2181 2512//2181 2514//2181 
f 2514//2181 2511//2181 2500//2181 
f 2396//2181 2397//2181 2450//2181 
o mesh256
f 2515//2182 2470//2182 2464//2183 
f 2516//2183 2464//2183 2467//2184 
f 2517//2184 2467//2184 2461//2185 
f 2518//2185 2461//2185 2459//2186 
f 2519//2186 2459//2186 2458//2187 
f 2520//2187 2458//2187 2443//2188 
f 2521//2188 2443//2188 2442//2189 
f 2522//2189 2442//2189 2435//2190 
f 2523//2190 2435//2190 2436//2191 
f 2524//2191 2436//2191 2433//2192 
f 2525//2192 2433//2192 2431//2193 
f 2526//2193 2431//2193 2429//2194 
f 2527//2194 2429//2194 2427//2195 
f 2528//2195 2427//2195 2446//2196 
f 2500//2197 2529//2197 2530//2198 
f 2531//2199 2446//2196 2510//2198 
f 2510//2198 2530//2198 2531//2199 
f 2529//2197 2500//2197 2499//2200 
f 2532//2200 2499//2200 2497//2201 
f 2533//2201 2497//2201 2468//2202 
f 2534//2202 2468//2202 2483//2203 
f 2535//2203 2483//2203 2482//2204 
f 2536//2204 2482//2204 2492//2205 
f 2537//2205 2492//2205 2481//2206 
f 2538//2206 2481//2206 2479//2207 
f 2539//2207 2479//2207 2491//2208 
f 2540//2208 2491//2208 2476//2209 
f 2541//2209 2476//2209 2474//2210 
f 2542//2210 2474//2210 2488//2211 
f 2543//2211 2488//2211 2487//2212 
f 2544//2212 2487//2212 2470//2182 
f 2470//2182 2515//2182 2544//2212 
f 2487//2212 2544//2212 2543//2211 
f 2488//2211 2543//2211 2542//2210 
f 2474//2210 2542//2210 2541//2209 
f 2476//2209 2541//2209 2540//2208 
f 2491//2208 2540//2208 2539//2207 
f 2479//2207 2539//2207 2538//2206 
f 2481//2206 2538//2206 2537//2205 
f 2492//2205 2537//2205 2536//2204 
f 2482//2204 2536//2204 2535//2203 
f 2483//2203 2535//2203 2534//2202 
f 2468//2202 2534//2202 2533//2201 
f 2497//2201 2533//2201 2532//2200 
f 2499//2200 2532//2200 2529//2197 
f 2530//2198 2510//2198 2500//2197 
f 2446//2196 2531//2199 2528//2195 
f 2427//2195 2528//2195 2527//2194 
f 2429//2194 2527//2194 2526//2193 
f 2431//2193 2526//2193 2525//2192 
f 2433//2192 2525//2192 2524//2191 
f 2436//2191 2524//2191 2523//2190 
f 2435//2190 2523//2190 2522//2189 
f 2442//2189 2522//2189 2521//2188 
f 2443//2188 2521//2188 2520//2187 
f 2458//2187 2520//2187 2519//2186 
f 2459//2186 2519//2186 2518//2185 
f 2461//2185 2518//2185 2517//2184 
f 2467//2184 2517//2184 2516//2183 
f 2464//2183 2516//2183 2515//2182 
o mesh257
f 2545//2213 2546//2214 2445//2214 
f 2547//2215 2545//2213 2451//2216 
f 2548//2217 2547//2215 2448//2218 
f 2549//2219 2548//2217 2447//2220 
f 2550//2221 2549//2219 2454//2222 
f 2551//2223 2550//2221 2456//2224 
f 2552//2225 2551//2223 2455//2226 
f 2553//2227 2552//2225 2493//2228 
f 2554//2229 2553//2227 2484//2230 
f 2555//2231 2554//2229 2498//2232 
f 2556//2233 2555//2231 2508//2234 
f 2557//2235 2556//2233 2509//2236 
f 2558//2237 2557//2235 2501//2238 
f 2559//2239 2558//2237 2511//2240 
f 2560//2241 2561//2242 2512//2242 
f 2514//2243 2512//2242 2561//2242 
f 2561//2242 2559//2239 2514//2243 
f 2562//2244 2560//2241 2504//2245 
f 2563//2246 2562//2244 2503//2247 
f 2564//2248 2563//2246 2441//2249 
f 2565//2250 2564//2248 2440//2251 
f 2566//2252 2565//2250 2426//2253 
f 2567//2254 2566//2252 2425//2255 
f 2568//2256 2567//2254 2428//2257 
f 2569//2258 2568//2256 2430//2259 
f 2570//2260 2569//2258 2432//2261 
f 2571//2262 2570//2260 2437//2263 
f 2572//2264 2571//2262 2434//2265 
f 2573//2266 2572//2264 2438//2267 
f 2574//2268 2573//2266 2439//2269 
f 2546//2214 2574//2268 2444//2268 
f 2444//2268 2445//2214 2546//2214 
f 2439//2269 2444//2268 2574//2268 
f 2438//2267 2439//2269 2573//2266 
f 2434//2265 2438//2267 2572//2264 
f 2437//2263 2434//2265 2571//2262 
f 2432//2261 2437//2263 2570//2260 
f 2430//2259 2432//2261 2569//2258 
f 2428//2257 2430//2259 2568//2256 
f 2425//2255 2428//2257 2567//2254 
f 2426//2253 2425//2255 2566//2252 
f 2440//2251 2426//2253 2565//2250 
f 2441//2249 2440//2251 2564//2248 
f 2503//2247 2441//2249 2563//2246 
f 2504//2245 2503//2247 2562//2244 
f 2512//2242 2504//2245 2560//2241 
f 2511//2240 2514//2243 2559//2239 
f 2501//2238 2511//2240 2558//2237 
f 2509//2236 2501//2238 2557//2235 
f 2508//2234 2509//2236 2556//2233 
f 2498//2232 2508//2234 2555//2231 
f 2484//2230 2498//2232 2554//2229 
f 2493//2228 2484//2230 2553//2227 
f 2455//2226 2493//2228 2552//2225 
f 2456//2224 2455//2226 2551//2223 
f 2454//2222 2456//2224 2550//2221 
f 2447//2220 2454//2222 2549//2219 
f 2448//2218 2447//2220 2548//2217 
f 2451//2216 2448//2218 2547//2215 
f 2445//2214 2451//2216 2545//2213 
o mesh258
f 2575//2270 2576//2271 2495//2271 
f 2577//2272 2575//2270 2494//2273 
f 2578//2274 2577//2272 2505//2275 
f 2579//2276 2578//2274 2496//2277 
f 2580//2278 2579//2276 2489//2279 
f 2581//2280 2580//2278 2490//2281 
f 2582//2282 2581//2280 2473//2283 
f 2583//2284 2582//2282 2472//2285 
f 2584//2286 2583//2284 2475//2287 
f 2585//2288 2584//2286 2478//2289 
f 2586//2290 2585//2288 2477//2291 
f 2587//2292 2586//2290 2480//2293 
f 2588//2294 2587//2292 2507//2295 
f 2589//2296 2588//2294 2506//2297 
f 2590//2298 2591//2299 2502//2299 
f 2513//2300 2502//2299 2591//2299 
f 2591//2299 2589//2296 2513//2300 
f 2592//2301 2590//2298 2485//2302 
f 2593//2303 2592//2301 2450//2304 
f 2594//2305 2593//2303 2449//2306 
f 2595//2307 2594//2305 2452//2308 
f 2596//2309 2595//2307 2453//2310 
f 2597//2311 2596//2309 2462//2312 
f 2598//2313 2597//2311 2457//2314 
f 2599//2315 2598//2313 2460//2316 
f 2600//2317 2599//2315 2463//2318 
f 2601//2319 2600//2317 2469//2320 
f 2602//2321 2601//2319 2466//2322 
f 2603//2323 2602//2321 2465//2324 
f 2604//2325 2603//2323 2486//2326 
f 2576//2271 2604//2325 2471//2325 
f 2471//2325 2495//2271 2576//2271 
f 2486//2326 2471//2325 2604//2325 
f 2465//2324 2486//2326 2603//2323 
f 2466//2322 2465//2324 2602//2321 
f 2469//2320 2466//2322 2601//2319 
f 2463//2318 2469//2320 2600//2317 
f 2460//2316 2463//2318 2599//2315 
f 2457//2314 2460//2316 2598//2313 
f 2462//2312 2457//2314 2597//2311 
f 2453//2310 2462//2312 2596//2309 
f 2452//2308 2453//2310 2595//2307 
f 2449//2306 2452//2308 2594//2305 
f 2450//2304 2449//2306 2593//2303 
f 2485//2302 2450//2304 2592//2301 
f 2502//2299 2485//2302 2590//2298 
f 2506//2297 2513//2300 2589//2296 
f 2507//2295 2506//2297 2588//2294 
f 2480//2293 2507//2295 2587//2292 
f 2477//2291 2480//2293 2586//2290 
f 2478//2289 2477//2291 2585//2288 
f 2475//2287 2478//2289 2584//2286 
f 2472//2285 2475//2287 2583//2284 
f 2473//2283 2472//2285 2582//2282 
f 2490//2281 2473//2283 2581//2280 
f 2489//2279 2490//2281 2580//2278 
f 2496//2277 2489//2279 2579//2276 
f 2505//2275 2496//2277 2578//2274 
f 2494//2273 2505//2275 2577//2272 
f 2495//2271 2494//2273 2575//2270 
o mesh259
f 2605//2327 2606//2327 2594//2327 
f 2595//2327 2520//2327 2607//2327 
f 2520//2327 2608//2327 2609//2327 
f 2572//2327 2521//2327 2522//2327 
f 2610//2327 2550//2327 2551//2327 
f 2516//2327 2517//2327 2601//2327 
f 2598//2327 2599//2327 2518//2327 
f 2597//2327 2598//2327 2519//2327 
f 2607//2327 2605//2327 2595//2327 
f 2520//2327 2611//2327 2608//2327 
f 2520//2327 2572//2327 2612//2327 
f 2572//2327 2520//2327 2521//2327 
f 2571//2327 2522//2327 2523//2327 
f 2532//2327 2556//2327 2557//2327 
f 2532//2327 2551//2327 2552//2327 
f 2610//2327 2549//2327 2550//2327 
f 2533//2327 2534//2327 2613//2327 
f 2517//2327 2600//2327 2601//2327 
f 2599//2327 2600//2327 2517//2327 
f 2519//2327 2520//2327 2597//2327 
f 2594//2327 2595//2327 2605//2327 
f 2520//2327 2614//2327 2611//2327 
f 2572//2327 2615//2327 2612//2327 
f 2523//2327 2570//2327 2571//2327 
f 2570//2327 2523//2327 2524//2327 
f 2569//2327 2524//2327 2525//2327 
f 2568//2327 2525//2327 2526//2327 
f 2532//2327 2555//2327 2556//2327 
f 2532//2327 2553//2327 2554//2327 
f 2551//2327 2532//2327 2610//2327 
f 2610//2327 2545//2327 2547//2327 
f 2534//2327 2616//2327 2613//2327 
f 2535//2327 2617//2327 2616//2327 
f 2517//2327 2518//2327 2599//2327 
f 2520//2327 2596//2327 2597//2327 
f 2609//2327 2607//2327 2520//2327 
f 2520//2327 2618//2327 2619//2327 
f 2612//2327 2620//2327 2520//2327 
f 2572//2327 2621//2327 2622//2327 
f 2623//2327 2621//2327 2574//2327 
f 2621//2327 2572//2327 2573//2327 
f 2524//2327 2569//2327 2570//2327 
f 2526//2327 2567//2327 2568//2327 
f 2557//2327 2529//2327 2532//2327 
f 2552//2327 2553//2327 2532//2327 
f 2547//2327 2548//2327 2610//2327 
f 2623//2327 2546//2327 2545//2327 
f 2532//2327 2533//2327 2624//2327 
f 2616//2327 2534//2327 2535//2327 
f 2536//2327 2625//2327 2617//2327 
f 2536//2327 2626//2327 2627//2327 
f 2586//2327 2628//2327 2629//2327 
f 2587//2327 2588//2327 2630//2327 
f 2586//2327 2537//2327 2538//2327 
f 2518//2327 2519//2327 2598//2327 
f 2619//2327 2614//2327 2520//2327 
f 2622//2327 2615//2327 2572//2327 
f 2573//2327 2574//2327 2621//2327 
f 2525//2327 2568//2327 2569//2327 
f 2567//2327 2526//2327 2527//2327 
f 2554//2327 2555//2327 2532//2327 
f 2545//2327 2610//2327 2623//2327 
f 2613//2327 2624//2327 2533//2327 
f 2627//2327 2625//2327 2536//2327 
f 2586//2327 2631//2327 2628//2327 
f 2631//2327 2586//2327 2587//2327 
f 2586//2327 2536//2327 2537//2327 
f 2585//2327 2538//2327 2539//2327 
f 2583//2327 2540//2327 2541//2327 
f 2582//2327 2541//2327 2542//2327 
f 2595//2327 2596//2327 2520//2327 
f 2574//2327 2546//2327 2623//2327 
f 2527//2327 2566//2327 2567//2327 
f 2566//2327 2527//2327 2528//2327 
f 2528//2327 2531//2327 2563//2327 
f 2606//2327 2632//2327 2591//2327 
f 2548//2327 2549//2327 2610//2327 
f 2617//2327 2535//2327 2536//2327 
f 2536//2327 2629//2327 2633//2327 
f 2630//2327 2631//2327 2587//2327 
f 2539//2327 2584//2327 2585//2327 
f 2584//2327 2539//2327 2540//2327 
f 2542//2327 2581//2327 2582//2327 
f 2581//2327 2542//2327 2543//2327 
f 2620//2327 2618//2327 2520//2327 
f 2528//2327 2565//2327 2566//2327 
f 2563//2327 2564//2327 2528//2327 
f 2632//2327 2589//2327 2591//2327 
f 2624//2327 2610//2327 2532//2327 
f 2629//2327 2536//2327 2586//2327 
f 2540//2327 2583//2327 2584//2327 
f 2543//2327 2580//2327 2581//2327 
f 2544//2327 2578//2327 2579//2327 
f 2516//2327 2603//2327 2604//2327 
f 2522//2327 2571//2327 2572//2327 
f 2531//2327 2562//2327 2563//2327 
f 2591//2327 2590//2327 2606//2327 
f 2633//2327 2626//2327 2536//2327 
f 2541//2327 2582//2327 2583//2327 
f 2544//2327 2577//2327 2578//2327 
f 2516//2327 2602//2327 2603//2327 
f 2564//2327 2565//2327 2528//2327 
f 2530//2327 2559//2327 2561//2327 
f 2529//2327 2558//2327 2559//2327 
f 2632//2327 2588//2327 2589//2327 
f 2538//2327 2585//2327 2586//2327 
f 2579//2327 2543//2327 2544//2327 
f 2544//2327 2515//2327 2575//2327 
f 2601//2327 2602//2327 2516//2327 
f 2531//2327 2530//2327 2560//2327 
f 2559//2327 2530//2327 2529//2327 
f 2606//2327 2592//2327 2593//2327 
f 2590//2327 2592//2327 2606//2327 
f 2579//2327 2580//2327 2543//2327 
f 2515//2327 2576//2327 2575//2327 
f 2604//2327 2515//2327 2516//2327 
f 2561//2327 2560//2327 2530//2327 
f 2632//2327 2630//2327 2588//2327 
f 2575//2327 2577//2327 2544//2327 
f 2560//2327 2562//2327 2531//2327 
f 2557//2327 2558//2327 2529//2327 
f 2593//2327 2594//2327 2606//2327 
f 2604//2327 2576//2327 2515//2327 
o mesh260
f 2623//2328 2634//2328 2635//2329 
f 2621//2329 2635//2329 2636//2330 
f 2622//2330 2636//2330 2637//2331 
f 2615//2331 2637//2331 2638//2332 
f 2612//2332 2638//2332 2639//2333 
f 2620//2333 2639//2333 2640//2334 
f 2618//2334 2640//2334 2641//2335 
f 2619//2335 2641//2335 2642//2336 
f 2614//2336 2642//2336 2643//2337 
f 2611//2337 2643//2337 2644//2338 
f 2608//2338 2644//2338 2645//2339 
f 2609//2339 2645//2339 2646//2340 
f 2607//2340 2646//2340 2647//2341 
f 2605//2341 2647//2341 2648//2342 
f 2606//2342 2648//2342 2649//2343 
f 2632//2343 2649//2343 2650//2344 
f 2630//2344 2650//2344 2651//2345 
f 2631//2345 2651//2345 2652//2346 
f 2628//2346 2652//2346 2653//2347 
f 2629//2347 2653//2347 2654//2348 
f 2633//2348 2654//2348 2655//2349 
f 2626//2349 2655//2349 2656//2350 
f 2627//2350 2656//2350 2657//2351 
f 2625//2351 2657//2351 2658//2352 
f 2617//2352 2658//2352 2659//2353 
f 2616//2353 2659//2353 2660//2354 
f 2613//2354 2660//2354 2661//2355 
f 2624//2355 2661//2355 2662//2356 
f 2610//2356 2662//2356 2634//2328 
f 2634//2328 2623//2328 2610//2356 
f 2662//2356 2610//2356 2624//2355 
f 2661//2355 2624//2355 2613//2354 
f 2660//2354 2613//2354 2616//2353 
f 2659//2353 2616//2353 2617//2352 
f 2658//2352 2617//2352 2625//2351 
f 2657//2351 2625//2351 2627//2350 
f 2656//2350 2627//2350 2626//2349 
f 2655//2349 2626//2349 2633//2348 
f 2654//2348 2633//2348 2629//2347 
f 2653//2347 2629//2347 2628//2346 
f 2652//2346 2628//2346 2631//2345 
f 2651//2345 2631//2345 2630//2344 
f 2650//2344 2630//2344 2632//2343 
f 2649//2343 2632//2343 2606//2342 
f 2648//2342 2606//2342 2605//2341 
f 2647//2341 2605//2341 2607//2340 
f 2646//2340 2607//2340 2609//2339 
f 2645//2339 2609//2339 2608//2338 
f 2644//2338 2608//2338 2611//2337 
f 2643//2337 2611//2337 2614//2336 
f 2642//2336 2614//2336 2619//2335 
f 2641//2335 2619//2335 2618//2334 
f 2640//2334 2618//2334 2620//2333 
f 2639//2333 2620//2333 2612//2332 
f 2638//2332 2612//2332 2615//2331 
f 2637//2331 2615//2331 2622//2330 
f 2636//2330 2622//2330 2621//2329 
f 2635//2329 2621//2329 2623//2328 
o mesh261
f 2648//2357 2647//2357 2663//2357 
f 2647//2357 2646//2357 2664//2357 
f 2664//2357 2663//2357 2647//2357 
f 2646//2357 2645//2357 2665//2357 
f 2645//2357 2644//2357 2666//2357 
f 2644//2357 2643//2357 2667//2357 
f 2641//2357 2668//2357 2669//2357 
f 2641//2357 2640//2357 2670//2357 
f 2665//2357 2664//2357 2646//2357 
f 2667//2357 2666//2357 2644//2357 
f 2642//2357 2669//2357 2667//2357 
f 2670//2357 2668//2357 2641//2357 
f 2639//2357 2671//2357 2670//2357 
f 2639//2357 2638//2357 2672//2357 
f 2666//2357 2665//2357 2645//2357 
f 2669//2357 2642//2357 2641//2357 
f 2672//2357 2671//2357 2639//2357 
f 2638//2357 2637//2357 2673//2357 
f 2636//2357 2674//2357 2673//2357 
f 2636//2357 2635//2357 2675//2357 
f 2634//2357 2676//2357 2675//2357 
f 2634//2357 2662//2357 2677//2357 
f 2667//2357 2643//2357 2642//2357 
f 2673//2357 2672//2357 2638//2357 
f 2675//2357 2674//2357 2636//2357 
f 2677//2357 2676//2357 2634//2357 
f 2661//2357 2678//2357 2677//2357 
f 2661//2357 2660//2357 2679//2357 
f 2660//2357 2659//2357 2680//2357 
f 2659//2357 2658//2357 2681//2357 
f 2657//2357 2682//2357 2681//2357 
f 2657//2357 2656//2357 2683//2357 
f 2656//2357 2655//2357 2684//2357 
f 2655//2357 2654//2357 2685//2357 
f 2653//2357 2686//2357 2685//2357 
f 2652//2357 2687//2357 2686//2357 
f 2651//2357 2688//2357 2687//2357 
f 2651//2357 2650//2357 2689//2357 
f 2670//2357 2640//2357 2639//2357 
f 2675//2357 2635//2357 2634//2357 
f 2679//2357 2678//2357 2661//2357 
f 2681//2357 2680//2357 2659//2357 
f 2683//2357 2682//2357 2657//2357 
f 2685//2357 2684//2357 2655//2357 
f 2686//2357 2653//2357 2652//2357 
f 2689//2357 2688//2357 2651//2357 
f 2673//2357 2637//2357 2636//2357 
f 2680//2357 2679//2357 2660//2357 
f 2684//2357 2683//2357 2656//2357 
f 2687//2357 2652//2357 2651//2357 
f 2677//2357 2662//2357 2661//2357 
f 2685//2357 2654//2357 2653//2357 
f 2649//2357 2690//2357 2689//2357 
f 2649//2357 2648//2357 2691//2357 
f 2681//2357 2658//2357 2657//2357 
f 2691//2357 2690//2357 2649//2357 
f 2689//2357 2650//2357 2649//2357 
f 2663//2357 2691//2357 2648//2357 
o mesh262
f 2692//2358 2693//2359 2676//2359 
f 2694//2360 2692//2358 2677//2361 
f 2695//2362 2694//2360 2678//2363 
f 2696//2364 2695//2362 2679//2365 
f 2697//2366 2696//2364 2680//2367 
f 2698//2368 2697//2366 2681//2369 
f 2699//2370 2698//2368 2682//2371 
f 2700//2372 2699//2370 2683//2373 
f 2701//2374 2700//2372 2684//2375 
f 2702//2376 2701//2374 2685//2377 
f 2703//2378 2702//2376 2686//2379 
f 2704//2380 2703//2378 2687//2381 
f 2705//2382 2704//2380 2688//2383 
f 2706//2384 2705//2382 2689//2385 
f 2707//2386 2706//2384 2690//2387 
f 2708//2388 2707//2386 2691//2389 
f 2709//2390 2708//2388 2663//2391 
f 2710//2392 2709//2390 2664//2393 
f 2711//2394 2710//2392 2665//2395 
f 2712//2396 2711//2394 2666//2397 
f 2713//2398 2712//2396 2667//2399 
f 2714//2400 2713//2398 2669//2401 
f 2715//2402 2714//2400 2668//2403 
f 2716//2404 2715//2402 2670//2405 
f 2717//2406 2716//2404 2671//2407 
f 2718//2408 2717//2406 2672//2409 
f 2719//2410 2718//2408 2673//2411 
f 2720//2412 2719//2410 2674//2413 
f 2693//2359 2720//2412 2675//2412 
f 2675//2412 2676//2359 2693//2359 
f 2674//2413 2675//2412 2720//2412 
f 2673//2411 2674//2413 2719//2410 
f 2672//2409 2673//2411 2718//2408 
f 2671//2407 2672//2409 2717//2406 
f 2670//2405 2671//2407 2716//2404 
f 2668//2403 2670//2405 2715//2402 
f 2669//2401 2668//2403 2714//2400 
f 2667//2399 2669//2401 2713//2398 
f 2666//2397 2667//2399 2712//2396 
f 2665//2395 2666//2397 2711//2394 
f 2664//2393 2665//2395 2710//2392 
f 2663//2391 2664//2393 2709//2390 
f 2691//2389 2663//2391 2708//2388 
f 2690//2387 2691//2389 2707//2386 
f 2689//2385 2690//2387 2706//2384 
f 2688//2383 2689//2385 2705//2382 
f 2687//2381 2688//2383 2704//2380 
f 2686//2379 2687//2381 2703//2378 
f 2685//2377 2686//2379 2702//2376 
f 2684//2375 2685//2377 2701//2374 
f 2683//2373 2684//2375 2700//2372 
f 2682//2371 2683//2373 2699//2370 
f 2681//2369 2682//2371 2698//2368 
f 2680//2367 2681//2369 2697//2366 
f 2679//2365 2680//2367 2696//2364 
f 2678//2363 2679//2365 2695//2362 
f 2677//2361 2678//2363 2694//2360 
f 2676//2359 2677//2361 2692//2358 
o mesh263
f 2721//2414 2692//2414 2694//2414 
f 2694//2414 2695//2414 2721//2414 
f 2695//2414 2696//2414 2721//2414 
f 2696//2414 2697//2414 2721//2414 
f 2697//2414 2698//2414 2721//2414 
f 2698//2414 2699//2414 2721//2414 
f 2699//2414 2700//2414 2721//2414 
f 2700//2414 2701//2414 2721//2414 
f 2701//2414 2702//2414 2721//2414 
f 2702//2414 2703//2414 2721//2414 
f 2703//2414 2704//2414 2721//2414 
f 2704//2414 2705//2414 2721//2414 
f 2705//2414 2706//2414 2721//2414 
f 2706//2414 2707//2414 2721//2414 
f 2707//2414 2708//2414 2721//2414 
f 2708//2414 2709//2414 2721//2414 
f 2709//2414 2710//2414 2721//2414 
f 2710//2414 2711//2414 2721//2414 
f 2711//2414 2712//2414 2721//2414 
f 2712//2414 2713//2414 2721//2414 
f 2713//2414 2714//2414 2721//2414 
f 2714//2414 2715//2414 2721//2414 
f 2715//2414 2716//2414 2721//2414 
f 2716//2414 2717//2414 2721//2414 
f 2717//2414 2718//2414 2721//2414 
f 2718//2414 2719//2414 2721//2414 
f 2719//2414 2720//2414 2721//2414 
f 2720//2414 2693//2414 2721//2414 
f 2693//2414 2692//2414 2721//2414 
g 1mmSpacer
v 0.0964706 0.00584011 0.0620032 
v 0.0971155 0.00584011 0.0620733 
v 0.0971155 0.00484011 0.0620733 
v 0.0958558 0.00584011 0.061796 
v 0.0964706 0.00484011 0.0620032 
v 0.0953 0.00584011 0.0614616 
v 0.0958558 0.00484011 0.061796 
v 0.094829 0.00584011 0.0610155 
v 0.0953 0.00484011 0.0614616 
v 0.0944649 0.00584011 0.0604785 
v 0.094829 0.00484011 0.0610155 
v 0.0942248 0.00584011 0.0598759 
v 0.0944649 0.00484011 0.0604785 
v 0.0941199 0.00584011 0.0592357 
v 0.0942248 0.00484011 0.0598759 
v 0.094155 0.00584011 0.058588 
v 0.0941199 0.00484011 0.0592357 
v 0.0943285 0.00584011 0.0579629 
v 0.094155 0.00484011 0.058588 
v 0.0946324 0.00584011 0.0573897 
v 0.0943285 0.00484011 0.0579629 
v 0.0950524 0.00584011 0.0568953 
v 0.0946324 0.00484011 0.0573897 
v 0.0955688 0.00584011 0.0565027 
v 0.0950524 0.00484011 0.0568953 
v 0.0961576 0.00584011 0.0562303 
v 0.0955688 0.00484011 0.0565027 
v 0.0967911 0.00584011 0.0560909 
v 0.0961576 0.00484011 0.0562303 
v 0.0974398 0.00584011 0.0560909 
v 0.0971155 0.00584011 0.0560733 
v 0.0971155 0.00484011 0.0560733 
v 0.0967911 0.00484011 0.0560909 
v 0.0980734 0.00584011 0.0562303 
v 0.0974398 0.00484011 0.0560909 
v 0.0986621 0.00584011 0.0565027 
v 0.0980734 0.00484011 0.0562303 
v 0.0991786 0.00584011 0.0568953 
v 0.0986621 0.00484011 0.0565027 
v 0.0995985 0.00584011 0.0573897 
v 0.0991786 0.00484011 0.0568953 
v 0.0999024 0.00584011 0.0579629 
v 0.0995985 0.00484011 0.0573897 
v 0.100076 0.00584011 0.058588 
v 0.0999024 0.00484011 0.0579629 
v 0.100111 0.00584011 0.0592357 
v 0.100076 0.00484011 0.058588 
v 0.100006 0.00584011 0.0598759 
v 0.100111 0.00484011 0.0592357 
v 0.099766 0.00584011 0.0604785 
v 0.100006 0.00484011 0.0598759 
v 0.099402 0.00584011 0.0610155 
v 0.099766 0.00484011 0.0604785 
v 0.098931 0.00584011 0.0614616 
v 0.099402 0.00484011 0.0610155 
v 0.0983751 0.00584011 0.061796 
v 0.098931 0.00484011 0.0614616 
v 0.0977604 0.00584011 0.0620032 
v 0.0983751 0.00484011 0.061796 
v 0.0977604 0.00484011 0.0620032 
v 0.100164 0.00484011 0.0616628 
v 0.0995362 0.00484011 0.0622577 
v 0.098795 0.00484011 0.0627036 
v 0.0979754 0.00484011 0.0629798 
v 0.0971155 0.00484011 0.0630733 
v 0.097548 0.00484011 0.0550967 
v 0.0983927 0.00484011 0.0552827 
v 0.10065 0.00484011 0.0609469 
v 0.0940668 0.00484011 0.0616628 
v 0.0935814 0.00484011 0.0609469 
v 0.0950533 0.00484011 0.0556459 
v 0.0958383 0.00484011 0.0552827 
v 0.096683 0.00484011 0.0550967 
v 0.0971155 0.00484011 0.0550733 
v 0.0991777 0.00484011 0.0556459 
v 0.0998663 0.00484011 0.0561693 
v 0.100426 0.00484011 0.0568285 
v 0.100831 0.00484011 0.0575927 
v 0.101063 0.00484011 0.0584262 
v 0.10097 0.00484011 0.0601434 
v 0.0962556 0.00484011 0.0629798 
v 0.0946948 0.00484011 0.0622577 
v 0.0938047 0.00484011 0.0568285 
v 0.0943647 0.00484011 0.0561693 
v 0.10111 0.00484011 0.0592899 
v 0.0954359 0.00484011 0.0627036 
v 0.0931213 0.00484011 0.0592899 
v 0.0931682 0.00484011 0.0584262 
v 0.0932613 0.00484011 0.0601434 
v 0.0933996 0.00484011 0.0575927 
v 0.0971155 0.00584011 0.0630733 
v 0.0979754 0.00584011 0.0629798 
v 0.098795 0.00584011 0.0627036 
v 0.0995362 0.00584011 0.0622577 
v 0.100164 0.00584011 0.0616628 
v 0.10065 0.00584011 0.0609469 
v 0.10097 0.00584011 0.0601434 
v 0.10111 0.00584011 0.0592899 
v 0.101063 0.00584011 0.0584262 
v 0.100831 0.00584011 0.0575927 
v 0.100426 0.00584011 0.0568285 
v 0.0998663 0.00584011 0.0561693 
v 0.0991777 0.00584011 0.0556459 
v 0.0983927 0.00584011 0.0552827 
v 0.096683 0.00584011 0.0550967 
v 0.0971155 0.00584011 0.0550733 
v 0.097548 0.00584011 0.0550967 
v 0.0958383 0.00584011 0.0552827 
v 0.0950533 0.00584011 0.0556459 
v 0.0943647 0.00584011 0.0561693 
v 0.0938047 0.00584011 0.0568285 
v 0.0933996 0.00584011 0.0575927 
v 0.0931682 0.00584011 0.0584262 
v 0.0931213 0.00584011 0.0592899 
v 0.0932613 0.00584011 0.0601434 
v 0.0935814 0.00584011 0.0609469 
v 0.0940668 0.00584011 0.0616628 
v 0.0946948 0.00584011 0.0622577 
v 0.0954359 0.00584011 0.0627036 
v 0.0962556 0.00584011 0.0629798 
vn 0.349331 0.0059638 -0.93698 
vn 0.133877 0.00615077 -0.990979 
vn 0.541827 0.00578483 -0.84047 
vn 0.349331 0.0059638 -0.93698 
vn 0.704816 0.005621 -0.709368 
vn 0.541827 0.00578483 -0.84047 
vn 0.833997 0.00547707 -0.551742 
vn 0.704816 0.005621 -0.709368 
vn 0.926847 0.00535596 -0.375401 
vn 0.833997 0.00547707 -0.551742 
vn 0.982207 0.00525935 -0.187726 
vn 0.926847 0.00535596 -0.375401 
vn 0.999977 0.00518809 0.00438349 
vn 0.982207 0.00525935 -0.187726 
vn 0.980894 0.00514257 0.194477 
vn 0.999977 0.00518809 0.00438349 
vn 0.926401 0.00512293 0.376503 
vn 0.980894 0.00514257 0.194477 
vn 0.838578 0.0051292 0.544757 
vn 0.926401 0.00512293 0.376503 
vn 0.72012 0.00516139 0.693831 
vn 0.838578 0.0051292 0.544757 
vn 0.574365 0.0052194 0.818583 
vn 0.72012 0.00516139 0.693831 
vn 0.405361 0.00530301 0.914141 
vn 0.574365 0.0052194 0.818583 
vn 0.217976 0.00541163 0.975939 
vn 0.405361 0.00530301 0.914141 
vn 0.0180335 0.00554406 0.999822 
vn 0.119168 0.00547498 0.992859 
vn 0.217976 0.00541163 0.975939 
vn -0.187513 0.00569809 0.982246 
vn 0.0180335 0.00554406 0.999822 
vn -0.390425 0.00586998 0.920616 
vn -0.187513 0.00569809 0.982246 
vn -0.581104 0.00605389 0.813807 
vn -0.390425 0.00586998 0.920616 
vn -0.748705 0.00624134 0.662874 
vn -0.581104 0.00605389 0.813807 
vn -0.881625 0.00642104 0.471907 
vn -0.748705 0.00624134 0.662874 
vn -0.96853 0.00657932 0.24881 
vn -0.881625 0.00642104 0.471907 
vn -0.999962 0.00670159 0.00566226 
vn -0.96853 0.00657932 0.24881 
vn -0.970298 0.00677476 -0.241816 
vn -0.999962 0.00670159 0.00566226 
vn -0.879456 0.00679025 -0.475931 
vn -0.970298 0.00677476 -0.241816 
vn -0.733567 0.00674614 -0.679583 
vn -0.879456 0.00679025 -0.475931 
vn -0.544173 0.00664777 -0.838947 
vn -0.733567 0.00674614 -0.679583 
vn -0.32617 0.00650627 -0.945289 
vn -0.544173 0.00664777 -0.838947 
vn -0.095312 0.00633581 -0.995427 
vn -0.32617 0.00650627 -0.945289 
vn 0.12661 -0.990206 0.0588384 
vn 0.119168 0.00547498 0.992859 
vn 0.313627 0.00535425 0.949531 
vn 0.492486 0.00525803 0.870305 
vn 0.650419 0.00518718 0.759558 
vn 0.782985 0.00514206 0.622019 
vn 0.886502 0.00512282 0.462696 
vn 0.957958 0.00512951 0.286862 
vn 0.994967 0.0051621 0.100069 
vn 0.995763 0.00522052 -0.0918122 
vn 0.959241 0.00530453 -0.282538 
vn 0.885064 0.00541353 -0.465438 
vn 0.773826 0.00554633 -0.633373 
vn 0.627325 0.00570067 -0.778736 
vn 0.448916 0.0058728 -0.893555 
vn 0.243964 0.00605684 -0.969765 
vn 0.0203111 0.00624426 -0.999774 
vn 0.133877 0.00615077 -0.990979 
vn 0.243964 0.00605684 -0.969765 
vn 0.0203111 0.00624426 -0.999774 
vn -0.211392 0.00642374 -0.97738 
vn -0.437754 0.00658157 -0.89907 
vn -0.643426 0.00670315 -0.765479 
vn -0.812779 0.00677547 -0.582533 
vn -0.932285 0.00679001 -0.36166 
vn -0.992917 0.00674499 -0.118623 
vn -0.991644 0.00664584 0.128832 
vn -0.931487 0.00650378 0.363717 
vn -0.820231 0.00633297 0.571997 
vn -0.668506 0.00614781 0.743681 
vn -0.487946 0.0059609 0.872853 
vn -0.289866 0.00578211 0.95705 
vn -0.0845223 0.00561857 0.996406 
vn 0.125168 0.990429 0.0581682 
usemtl 0.647059_0.647059_0.647059_0.000000_0.000000
o mesh264
f 2722//2415 2723//2416 2724//2416 
f 2725//2417 2722//2415 2726//2418 
f 2727//2419 2725//2417 2728//2420 
f 2729//2421 2727//2419 2730//2422 
f 2731//2423 2729//2421 2732//2424 
f 2733//2425 2731//2423 2734//2426 
f 2735//2427 2733//2425 2736//2428 
f 2737//2429 2735//2427 2738//2430 
f 2739//2431 2737//2429 2740//2432 
f 2741//2433 2739//2431 2742//2434 
f 2743//2435 2741//2433 2744//2436 
f 2745//2437 2743//2435 2746//2438 
f 2747//2439 2745//2437 2748//2440 
f 2749//2441 2747//2439 2750//2442 
f 2751//2443 2752//2444 2753//2444 
f 2754//2445 2753//2444 2752//2444 
f 2752//2444 2749//2441 2754//2445 
f 2755//2446 2751//2443 2756//2447 
f 2757//2448 2755//2446 2758//2449 
f 2759//2450 2757//2448 2760//2451 
f 2761//2452 2759//2450 2762//2453 
f 2763//2454 2761//2452 2764//2455 
f 2765//2456 2763//2454 2766//2457 
f 2767//2458 2765//2456 2768//2459 
f 2769//2460 2767//2458 2770//2461 
f 2771//2462 2769//2460 2772//2463 
f 2773//2464 2771//2462 2774//2465 
f 2775//2466 2773//2464 2776//2467 
f 2777//2468 2775//2466 2778//2469 
f 2779//2470 2777//2468 2780//2471 
f 2723//2416 2779//2470 2781//2470 
f 2781//2470 2724//2416 2723//2416 
f 2780//2471 2781//2470 2779//2470 
f 2778//2469 2780//2471 2777//2468 
f 2776//2467 2778//2469 2775//2466 
f 2774//2465 2776//2467 2773//2464 
f 2772//2463 2774//2465 2771//2462 
f 2770//2461 2772//2463 2769//2460 
f 2768//2459 2770//2461 2767//2458 
f 2766//2457 2768//2459 2765//2456 
f 2764//2455 2766//2457 2763//2454 
f 2762//2453 2764//2455 2761//2452 
f 2760//2451 2762//2453 2759//2450 
f 2758//2449 2760//2451 2757//2448 
f 2756//2447 2758//2449 2755//2446 
f 2753//2444 2756//2447 2751//2443 
f 2750//2442 2754//2445 2749//2441 
f 2748//2440 2750//2442 2747//2439 
f 2746//2438 2748//2440 2745//2437 
f 2744//2436 2746//2438 2743//2435 
f 2742//2434 2744//2436 2741//2433 
f 2740//2432 2742//2434 2739//2431 
f 2738//2430 2740//2432 2737//2429 
f 2736//2428 2738//2430 2735//2427 
f 2734//2426 2736//2428 2733//2425 
f 2732//2424 2734//2426 2731//2423 
f 2730//2422 2732//2424 2729//2421 
f 2728//2420 2730//2422 2727//2419 
f 2726//2418 2728//2420 2725//2417 
f 2724//2416 2726//2418 2722//2415 
o mesh265
f 2782//2472 2783//2472 2778//2472 
f 2783//2472 2784//2472 2780//2472 
f 2784//2472 2785//2472 2781//2472 
f 2785//2472 2786//2472 2724//2472 
f 2787//2472 2756//2472 2753//2472 
f 2788//2472 2758//2472 2756//2472 
f 2789//2472 2774//2472 2772//2472 
f 2789//2472 2782//2472 2776//2472 
f 2780//2472 2778//2472 2783//2472 
f 2724//2472 2781//2472 2785//2472 
f 2790//2472 2732//2472 2730//2472 
f 2790//2472 2791//2472 2734//2472 
f 2792//2472 2748//2472 2746//2472 
f 2793//2472 2750//2472 2748//2472 
f 2793//2472 2794//2472 2754//2472 
f 2795//2472 2753//2472 2754//2472 
f 2756//2472 2787//2472 2788//2472 
f 2796//2472 2760//2472 2758//2472 
f 2796//2472 2797//2472 2762//2472 
f 2797//2472 2798//2472 2764//2472 
f 2799//2472 2766//2472 2764//2472 
f 2799//2472 2800//2472 2768//2472 
f 2801//2472 2772//2472 2770//2472 
f 2776//2472 2774//2472 2789//2472 
f 2781//2472 2780//2472 2784//2472 
f 2786//2472 2802//2472 2726//2472 
f 2803//2472 2730//2472 2728//2472 
f 2734//2472 2732//2472 2790//2472 
f 2804//2472 2744//2472 2742//2472 
f 2804//2472 2805//2472 2746//2472 
f 2748//2472 2792//2472 2793//2472 
f 2754//2472 2794//2472 2795//2472 
f 2758//2472 2788//2472 2796//2472 
f 2764//2472 2762//2472 2797//2472 
f 2768//2472 2766//2472 2799//2472 
f 2800//2472 2806//2472 2770//2472 
f 2772//2472 2801//2472 2789//2472 
f 2726//2472 2724//2472 2786//2472 
f 2807//2472 2728//2472 2726//2472 
f 2730//2472 2803//2472 2790//2472 
f 2808//2472 2738//2472 2736//2472 
f 2808//2472 2809//2472 2740//2472 
f 2746//2472 2744//2472 2804//2472 
f 2754//2472 2750//2472 2793//2472 
f 2762//2472 2760//2472 2796//2472 
f 2770//2472 2768//2472 2800//2472 
f 2778//2472 2776//2472 2782//2472 
f 2728//2472 2807//2472 2803//2472 
f 2810//2472 2736//2472 2734//2472 
f 2740//2472 2738//2472 2808//2472 
f 2811//2472 2742//2472 2740//2472 
f 2746//2472 2805//2472 2792//2472 
f 2764//2472 2798//2472 2799//2472 
f 2726//2472 2802//2472 2807//2472 
f 2736//2472 2810//2472 2808//2472 
f 2742//2472 2811//2472 2804//2472 
f 2770//2472 2806//2472 2801//2472 
f 2740//2472 2809//2472 2811//2472 
f 2734//2472 2791//2472 2810//2472 
f 2753//2472 2795//2472 2787//2472 
o mesh266
f 2812//2473 2786//2473 2785//2474 
f 2813//2474 2785//2474 2784//2475 
f 2814//2475 2784//2475 2783//2476 
f 2815//2476 2783//2476 2782//2477 
f 2816//2477 2782//2477 2789//2478 
f 2817//2478 2789//2478 2801//2479 
f 2818//2479 2801//2479 2806//2480 
f 2819//2480 2806//2480 2800//2481 
f 2820//2481 2800//2481 2799//2482 
f 2821//2482 2799//2482 2798//2483 
f 2822//2483 2798//2483 2797//2484 
f 2823//2484 2797//2484 2796//2485 
f 2824//2485 2796//2485 2788//2486 
f 2825//2486 2788//2486 2787//2487 
f 2826//2488 2827//2489 2795//2489 
f 2787//2487 2795//2489 2827//2489 
f 2827//2489 2828//2490 2787//2487 
f 2826//2488 2794//2491 2793//2492 
f 2829//2492 2793//2492 2792//2493 
f 2830//2493 2792//2493 2805//2494 
f 2831//2494 2805//2494 2804//2495 
f 2832//2495 2804//2495 2811//2496 
f 2833//2496 2811//2496 2809//2497 
f 2834//2497 2809//2497 2808//2498 
f 2835//2498 2808//2498 2810//2499 
f 2836//2499 2810//2499 2791//2500 
f 2837//2500 2791//2500 2790//2501 
f 2838//2501 2790//2501 2803//2502 
f 2839//2502 2803//2502 2807//2503 
f 2840//2503 2807//2503 2802//2504 
f 2841//2504 2802//2504 2786//2473 
f 2786//2473 2812//2473 2841//2504 
f 2802//2504 2841//2504 2840//2503 
f 2807//2503 2840//2503 2839//2502 
f 2803//2502 2839//2502 2838//2501 
f 2790//2501 2838//2501 2837//2500 
f 2791//2500 2837//2500 2836//2499 
f 2810//2499 2836//2499 2835//2498 
f 2808//2498 2835//2498 2834//2497 
f 2809//2497 2834//2497 2833//2496 
f 2811//2496 2833//2496 2832//2495 
f 2804//2495 2832//2495 2831//2494 
f 2805//2494 2831//2494 2830//2493 
f 2792//2493 2830//2493 2829//2492 
f 2793//2492 2829//2492 2826//2488 
f 2795//2489 2794//2491 2826//2488 
f 2787//2487 2828//2490 2825//2486 
f 2788//2486 2825//2486 2824//2485 
f 2796//2485 2824//2485 2823//2484 
f 2797//2484 2823//2484 2822//2483 
f 2798//2483 2822//2483 2821//2482 
f 2799//2482 2821//2482 2820//2481 
f 2800//2481 2820//2481 2819//2480 
f 2806//2480 2819//2480 2818//2479 
f 2801//2479 2818//2479 2817//2478 
f 2789//2478 2817//2478 2816//2477 
f 2782//2477 2816//2477 2815//2476 
f 2783//2476 2815//2476 2814//2475 
f 2784//2475 2814//2475 2813//2474 
f 2785//2474 2813//2474 2812//2473 
o mesh267
f 2828//2505 2827//2505 2752//2505 
f 2827//2505 2826//2505 2749//2505 
f 2825//2505 2828//2505 2751//2505 
f 2749//2505 2752//2505 2827//2505 
f 2813//2505 2779//2505 2723//2505 
f 2814//2505 2777//2505 2779//2505 
f 2752//2505 2751//2505 2828//2505 
f 2829//2505 2747//2505 2749//2505 
f 2779//2505 2813//2505 2814//2505 
f 2815//2505 2775//2505 2777//2505 
f 2817//2505 2771//2505 2773//2505 
f 2817//2505 2818//2505 2769//2505 
f 2824//2505 2825//2505 2755//2505 
f 2749//2505 2826//2505 2829//2505 
f 2829//2505 2830//2505 2745//2505 
f 2830//2505 2831//2505 2743//2505 
f 2777//2505 2814//2505 2815//2505 
f 2816//2505 2773//2505 2775//2505 
f 2769//2505 2771//2505 2817//2505 
f 2818//2505 2819//2505 2767//2505 
f 2821//2505 2763//2505 2765//2505 
f 2821//2505 2822//2505 2761//2505 
f 2823//2505 2759//2505 2761//2505 
f 2823//2505 2824//2505 2757//2505 
f 2751//2505 2755//2505 2825//2505 
f 2743//2505 2745//2505 2830//2505 
f 2775//2505 2815//2505 2816//2505 
f 2767//2505 2769//2505 2818//2505 
f 2820//2505 2765//2505 2767//2505 
f 2761//2505 2763//2505 2821//2505 
f 2757//2505 2759//2505 2823//2505 
f 2745//2505 2747//2505 2829//2505 
f 2832//2505 2741//2505 2743//2505 
f 2832//2505 2833//2505 2739//2505 
f 2773//2505 2816//2505 2817//2505 
f 2765//2505 2820//2505 2821//2505 
f 2755//2505 2757//2505 2824//2505 
f 2739//2505 2741//2505 2832//2505 
f 2838//2505 2729//2505 2731//2505 
f 2838//2505 2839//2505 2727//2505 
f 2767//2505 2819//2505 2820//2505 
f 2743//2505 2831//2505 2832//2505 
f 2835//2505 2735//2505 2737//2505 
f 2835//2505 2836//2505 2733//2505 
f 2727//2505 2729//2505 2838//2505 
f 2839//2505 2840//2505 2725//2505 
f 2761//2505 2822//2505 2823//2505 
f 2833//2505 2834//2505 2737//2505 
f 2733//2505 2735//2505 2835//2505 
f 2836//2505 2837//2505 2731//2505 
f 2725//2505 2727//2505 2839//2505 
f 2840//2505 2841//2505 2722//2505 
f 2737//2505 2739//2505 2833//2505 
f 2731//2505 2733//2505 2836//2505 
f 2722//2505 2725//2505 2840//2505 
f 2812//2505 2723//2505 2722//2505 
f 2737//2505 2834//2505 2835//2505 
f 2722//2505 2841//2505 2812//2505 
f 2731//2505 2837//2505 2838//2505 
f 2723//2505 2812//2505 2813//2505 
g bearing
v 0.0946739 0.0160401 -0.0294641 
v 0.0946155 0.0160401 -0.0289267 
v 0.0946155 0.00584011 -0.0289267 
v 0.0948465 0.0160401 -0.0299764 
v 0.0946739 0.00584011 -0.0294641 
v 0.0951252 0.0160401 -0.0304396 
v 0.0948465 0.00584011 -0.0299764 
v 0.095497 0.0160401 -0.0308321 
v 0.0951252 0.00584011 -0.0304396 
v 0.0959445 0.0160401 -0.0311355 
v 0.095497 0.00584011 -0.0308321 
v 0.0964467 0.0160401 -0.0313356 
v 0.0959445 0.00584011 -0.0311355 
v 0.0969801 0.0160401 -0.031423 
v 0.0964467 0.00584011 -0.0313356 
v 0.0975199 0.0160401 -0.0313938 
v 0.0969801 0.00584011 -0.031423 
v 0.0980408 0.0160401 -0.0312491 
v 0.0975199 0.00584011 -0.0313938 
v 0.0985184 0.0160401 -0.0309959 
v 0.0980408 0.00584011 -0.0312491 
v 0.0989305 0.0160401 -0.030646 
v 0.0985184 0.00584011 -0.0309959 
v 0.0992576 0.0160401 -0.0302156 
v 0.0989305 0.00584011 -0.030646 
v 0.0994846 0.0160401 -0.029725 
v 0.0992576 0.00584011 -0.0302156 
v 0.0996008 0.0160401 -0.029197 
v 0.0994846 0.00584011 -0.029725 
v 0.0996008 0.0160401 -0.0286564 
v 0.0996008 0.00584011 -0.029197 
v 0.0994846 0.0160401 -0.0281284 
v 0.0996008 0.00584011 -0.0286564 
v 0.0992576 0.0160401 -0.0276378 
v 0.0994846 0.00584011 -0.0281284 
v 0.0989305 0.0160401 -0.0272075 
v 0.0992576 0.00584011 -0.0276378 
v 0.0985184 0.0160401 -0.0268575 
v 0.0989305 0.00584011 -0.0272075 
v 0.0980408 0.0160401 -0.0266043 
v 0.0985184 0.00584011 -0.0268575 
v 0.0975199 0.0160401 -0.0264596 
v 0.0980408 0.00584011 -0.0266043 
v 0.0969801 0.0160401 -0.0264304 
v 0.0975199 0.00584011 -0.0264596 
v 0.0964467 0.0160401 -0.0265178 
v 0.0969801 0.00584011 -0.0264304 
v 0.0959445 0.0160401 -0.0267179 
v 0.0964467 0.00584011 -0.0265178 
v 0.095497 0.0160401 -0.0270213 
v 0.0959445 0.00584011 -0.0267179 
v 0.0951252 0.0160401 -0.0274138 
v 0.095497 0.00584011 -0.0270213 
v 0.0948465 0.0160401 -0.027877 
v 0.0951252 0.00584011 -0.0274138 
v 0.0946739 0.0160401 -0.0283893 
v 0.0948465 0.00584011 -0.027877 
v 0.0946739 0.00584011 -0.0283893 
v 0.10394 0.00584011 -0.0224623 
v 0.102391 0.00584011 -0.0211464 
v 0.10517 0.00584011 -0.0240805 
v 0.0966066 0.00584011 -0.0195405 
v 0.0946007 0.00584011 -0.0198693 
v 0.100595 0.00584011 -0.0201943 
v 0.0986362 0.00584011 -0.0196505 
v 0.09103 0.00584011 -0.0217624 
v 0.0896322 0.00584011 -0.0232381 
v 0.0879352 0.00584011 -0.026906 
v 0.0877155 0.00584011 -0.0289267 
v 0.0927124 0.00584011 -0.0206217 
v 0.0879352 0.00584011 -0.0309474 
v 0.0885843 0.00584011 -0.0249797 
v 0.10394 0.00584011 -0.0353911 
v 0.10517 0.00584011 -0.0337729 
v 0.102391 0.00584011 -0.036707 
v 0.106023 0.00584011 -0.0259253 
v 0.0885843 0.00584011 -0.0328737 
v 0.0896322 0.00584011 -0.0346153 
v 0.09103 0.00584011 -0.036091 
v 0.0927124 0.00584011 -0.0372317 
v 0.0946007 0.00584011 -0.0379841 
v 0.0966066 0.00584011 -0.0383129 
v 0.106023 0.00584011 -0.0319281 
v 0.10646 0.00584011 -0.029943 
v 0.10646 0.00584011 -0.0279104 
v 0.0986362 0.00584011 -0.0382029 
v 0.100595 0.00584011 -0.0376591 
v 0.0851155 0.00844011 -0.0289267 
v 0.085396 0.00844011 -0.0263471 
v 0.0862246 0.00844011 -0.023888 
v 0.0875624 0.00844011 -0.0216646 
v 0.0893468 0.00844011 -0.0197808 
v 0.0914946 0.00844011 -0.0183246 
v 0.0939051 0.00844011 -0.0173641 
v 0.0964658 0.00844011 -0.0169443 
v 0.0990569 0.00844011 -0.0170848 
v 0.101557 0.00844011 -0.017779 
v 0.10385 0.00844011 -0.0189944 
v 0.105827 0.00844011 -0.0206743 
v 0.107398 0.00844011 -0.0227401 
v 0.108487 0.00844011 -0.0250951 
v 0.109045 0.00844011 -0.0276293 
v 0.109045 0.00844011 -0.0302241 
v 0.108487 0.00844011 -0.0327583 
v 0.107398 0.00844011 -0.0351133 
v 0.105827 0.00844011 -0.0371791 
v 0.10385 0.00844011 -0.038859 
v 0.101557 0.00844011 -0.0400744 
v 0.0990569 0.00844011 -0.0407686 
v 0.0964658 0.00844011 -0.0409091 
v 0.0939051 0.00844011 -0.0404893 
v 0.0914946 0.00844011 -0.0395288 
v 0.0893468 0.00844011 -0.0380726 
v 0.0875624 0.00844011 -0.0361888 
v 0.0862246 0.00844011 -0.0339654 
v 0.085396 0.00844011 -0.0315063 
v 0.0854647 0.0134401 -0.0263622 
v 0.0851858 0.0134401 -0.0276293 
v 0.0862884 0.0134401 -0.0239176 
v 0.0857436 0.0134401 -0.0250951 
v 0.0876184 0.0134401 -0.0217072 
v 0.0868332 0.0134401 -0.0227401 
v 0.0893924 0.0134401 -0.0198344 
v 0.0884035 0.0134401 -0.0206743 
v 0.0915275 0.0134401 -0.0183867 
v 0.0903812 0.0134401 -0.0189944 
v 0.093924 0.0134401 -0.0174319 
v 0.0926738 0.0134401 -0.017779 
v 0.0964696 0.0134401 -0.0170145 
v 0.0951741 0.0134401 -0.0170848 
v 0.0990455 0.0134401 -0.0171542 
v 0.0977651 0.0134401 -0.0169443 
v 0.101531 0.0134401 -0.0178443 
v 0.100326 0.0134401 -0.0173641 
v 0.10381 0.0134401 -0.0190527 
v 0.102736 0.0134401 -0.0183246 
v 0.104884 0.0134401 -0.0197808 
v 0.105776 0.0134401 -0.0207227 
v 0.106669 0.0134401 -0.0216646 
v 0.107337 0.0134401 -0.0227763 
v 0.108006 0.0134401 -0.023888 
v 0.108421 0.0134401 -0.0251175 
v 0.108975 0.0134401 -0.0276369 
v 0.108835 0.0134401 -0.0263471 
v 0.108975 0.0134401 -0.0302165 
v 0.109115 0.0134401 -0.0289267 
v 0.108421 0.0134401 -0.0327359 
v 0.108835 0.0134401 -0.0315063 
v 0.107337 0.0134401 -0.0350771 
v 0.108006 0.0134401 -0.0339654 
v 0.105776 0.0134401 -0.0371307 
v 0.106669 0.0134401 -0.0361888 
v 0.10381 0.0134401 -0.0388007 
v 0.104884 0.0134401 -0.0380726 
v 0.101531 0.0134401 -0.0400091 
v 0.102736 0.0134401 -0.0395288 
v 0.0990455 0.0134401 -0.0406992 
v 0.100326 0.0134401 -0.0404893 
v 0.0964696 0.0134401 -0.0408389 
v 0.0977651 0.0134401 -0.0409091 
v 0.093924 0.0134401 -0.0404215 
v 0.0951741 0.0134401 -0.0407686 
v 0.0915275 0.0134401 -0.0394667 
v 0.0926738 0.0134401 -0.0400744 
v 0.0893924 0.0134401 -0.038019 
v 0.0903812 0.0134401 -0.038859 
v 0.0876184 0.0134401 -0.0361462 
v 0.0884035 0.0134401 -0.0371791 
v 0.0862884 0.0134401 -0.0339358 
v 0.0868332 0.0134401 -0.0351133 
v 0.0854647 0.0134401 -0.0314912 
v 0.0857436 0.0134401 -0.0327583 
v 0.0851155 0.0134401 -0.0289267 
v 0.0851858 0.0134401 -0.0302241 
v 0.106296 0.0160401 -0.026906 
v 0.106515 0.0160401 -0.0289267 
v 0.105647 0.0160401 -0.0249797 
v 0.104599 0.0160401 -0.0232381 
v 0.103201 0.0160401 -0.0217624 
v 0.101519 0.0160401 -0.0206217 
v 0.0996302 0.0160401 -0.0198693 
v 0.0976244 0.0160401 -0.0195405 
v 0.0955947 0.0160401 -0.0196505 
v 0.0936362 0.0160401 -0.0201943 
v 0.0918403 0.0160401 -0.0211464 
v 0.0902911 0.0160401 -0.0224623 
v 0.089061 0.0160401 -0.0240805 
v 0.0882075 0.0160401 -0.0259253 
v 0.0877706 0.0160401 -0.0279104 
v 0.0877155 0.0160401 -0.0289267 
v 0.0877706 0.0160401 -0.029943 
v 0.0882075 0.0160401 -0.0319281 
v 0.089061 0.0160401 -0.0337729 
v 0.0902911 0.0160401 -0.0353911 
v 0.0918403 0.0160401 -0.036707 
v 0.0936362 0.0160401 -0.0376591 
v 0.0955947 0.0160401 -0.0382029 
v 0.0976244 0.0160401 -0.0383129 
v 0.0996302 0.0160401 -0.0379841 
v 0.101519 0.0160401 -0.0372317 
v 0.103201 0.0160401 -0.036091 
v 0.104599 0.0160401 -0.0346153 
v 0.105647 0.0160401 -0.0328737 
v 0.106296 0.0160401 -0.0309474 
vn 0.985212 0.0147177 0.170705 
vn 0.999546 0.0146136 -0.0263542 
vn 0.931823 0.0148768 0.362607 
vn 0.985212 0.0147177 0.170705 
vn 0.840208 0.0150883 0.542054 
vn 0.931823 0.0148768 0.362607 
vn 0.712393 0.0153483 0.701613 
vn 0.840208 0.0150883 0.542054 
vn 0.551792 0.0156506 0.833835 
vn 0.712393 0.0153483 0.701613 
vn 0.363421 0.0159863 0.931488 
vn 0.551792 0.0156506 0.833835 
vn 0.154111 0.016343 0.987918 
vn 0.363421 0.0159863 0.931488 
vn -0.0673459 0.0167047 0.99759 
vn 0.154111 0.016343 0.987918 
vn -0.290238 0.0170515 0.956803 
vn -0.0673459 0.0167047 0.99759 
vn -0.502282 0.0173608 0.86453 
vn -0.290238 0.0170515 0.956803 
vn -0.690398 0.0176092 0.723215 
vn -0.502282 0.0173608 0.86453 
vn -0.841941 0.0177755 0.539277 
vn -0.690398 0.0176092 0.723215 
vn -0.946217 0.0178445 0.32304 
vn -0.841941 0.0177755 0.539277 
vn -0.995968 0.0178094 0.0879275 
vn -0.946217 0.0178445 0.32304 
vn -0.988375 0.0176736 -0.151002 
vn -0.995968 0.0178094 0.0879275 
vn -0.925299 0.01745 -0.378837 
vn -0.988375 0.0176736 -0.151002 
vn -0.812698 0.0171582 -0.582432 
vn -0.925299 0.01745 -0.378837 
vn -0.659499 0.0168211 -0.751517 
vn -0.812698 0.0171582 -0.582432 
vn -0.476275 0.0164619 -0.879142 
vn -0.659499 0.0168211 -0.751517 
vn -0.274069 0.0161016 -0.961575 
vn -0.476275 0.0164619 -0.879142 
vn -0.0635271 0.0157575 -0.997856 
vn -0.274069 0.0161016 -0.961575 
vn 0.145625 0.0154431 -0.989219 
vn -0.0635271 0.0157575 -0.997856 
vn 0.344828 0.0151685 -0.938543 
vn 0.145625 0.0154431 -0.989219 
vn 0.526754 0.0149405 -0.849886 
vn 0.344828 0.0151685 -0.938543 
vn 0.685264 0.0147639 -0.728145 
vn 0.526754 0.0149405 -0.849886 
vn 0.815329 0.0146416 -0.578813 
vn 0.685264 0.0147639 -0.728145 
vn 0.912942 0.0145753 -0.40783 
vn 0.815329 0.0146416 -0.578813 
vn 0.975056 0.014566 -0.221482 
vn 0.912942 0.0145753 -0.40783 
vn 0.0981794 -0.994739 -0.0292436 
vn -0.661434 -0.749347 -0.0313662 
vn -0.645631 -0.751819 0.1339 
vn -0.592131 -0.75133 0.291348 
vn -0.504129 -0.74792 0.431821 
vn -0.387165 -0.741862 0.54749 
vn -0.248513 -0.733616 0.632495 
vn -0.0964115 -0.723767 0.683277 
vn 0.0606964 -0.712949 0.698584 
vn 0.214793 -0.701784 0.679238 
vn 0.358722 -0.690834 0.627748 
vn 0.486439 -0.680579 0.547895 
vn 0.593105 -0.671408 0.44434 
vn 0.675083 -0.663619 0.322294 
vn 0.729869 -0.657434 0.187273 
vn 0.756017 -0.65301 0.0449078 
vn 0.753049 -0.650446 -0.0991843 
vn 0.721391 -0.649797 -0.239496 
vn 0.662324 -0.651077 -0.370709 
vn 0.577956 -0.654259 -0.487762 
vn 0.471211 -0.659273 -0.585935 
vn 0.345828 -0.666004 -0.66094 
vn 0.206373 -0.674274 -0.709059 
vn 0.058218 -0.683838 -0.727308 
vn -0.0924953 -0.694367 -0.713652 
vn -0.23897 -0.705445 -0.667264 
vn -0.373961 -0.716562 -0.588806 
vn -0.490117 -0.727132 -0.480692 
vn -0.580463 -0.736525 -0.347266 
vn -0.639014 -0.744114 -0.194822 
vn -0.978195 0.01784 0.20692 
vn -0.995968 0.0178094 0.0879275 
vn -0.99933 0.0177535 -0.0320166 
vn -0.900537 0.0178228 0.434415 
vn -0.946217 0.0178445 0.32304 
vn -0.771474 0.0177037 0.636015 
vn -0.841941 0.0177755 0.539277 
vn -0.600148 0.017494 0.799697 
vn -0.690398 0.0176092 0.723215 
vn -0.398427 0.0172123 0.917038 
vn -0.502282 0.0173608 0.86453 
vn -0.17935 0.0168813 0.98364 
vn -0.290238 0.0170515 0.956803 
vn 0.0442742 0.0165244 0.998883 
vn -0.0673459 0.0167047 0.99759 
vn 0.26088 0.0161629 0.965236 
vn 0.154111 0.016343 0.987918 
vn 0.460695 0.015815 0.887417 
vn 0.363421 0.0159863 0.931488 
vn 0.635918 0.0154947 0.771601 
vn 0.551792 0.0156506 0.833835 
vn 0.780647 0.0152126 0.624787 
vn 0.712393 0.0153483 0.701613 
vn 0.890697 0.0149762 0.45435 
vn 0.840208 0.0150883 0.542054 
vn 0.963374 0.0147905 0.267753 
vn 0.931823 0.0148768 0.362607 
vn 0.99727 0.0146587 0.0723719 
vn 0.985212 0.0147177 0.170705 
vn 0.992101 0.0145827 -0.124594 
vn 0.999546 0.0146136 -0.0263542 
vn 0.94859 0.0145635 -0.316171 
vn 0.975056 0.014566 -0.221482 
vn 0.868404 0.0146014 -0.495642 
vn 0.912942 0.0145753 -0.40783 
vn 0.754126 0.0146958 -0.656566 
vn 0.815329 0.0146416 -0.578813 
vn 0.609276 0.0148455 -0.79282 
vn 0.685264 0.0147639 -0.728145 
vn 0.438362 0.0150483 -0.898673 
vn 0.526754 0.0149405 -0.849886 
vn 0.246957 0.0153003 -0.968906 
vn 0.344828 0.0151685 -0.938543 
vn 0.0417863 0.0155959 -0.999005 
vn 0.145625 0.0154431 -0.989219 
vn -0.169207 0.0159266 -0.985452 
vn -0.0635271 0.0157575 -0.997856 
vn -0.376863 0.0162807 -0.926126 
vn -0.274069 0.0161016 -0.961575 
vn -0.570949 0.0166429 -0.820817 
vn -0.476275 0.0164619 -0.879142 
vn -0.740536 0.0169938 -0.671802 
vn -0.659499 0.0168211 -0.751517 
vn -0.874685 0.0173112 -0.484382 
vn -0.812698 0.0171582 -0.582432 
vn -0.963485 0.0175717 -0.267186 
vn -0.925299 0.01745 -0.378837 
vn -0.99933 0.0177535 -0.0320166 
vn -0.988375 0.0176736 -0.151002 
vn 0.731811 0.671846 0.114349 
vn 0.741154 0.66989 0.0440249 
vn 0.743329 0.668392 -0.0267364 
vn 0.691807 0.677087 0.250911 
vn 0.715331 0.67425 0.183543 
vn 0.624294 0.683985 0.377388 
vn 0.66139 0.680339 0.315757 
vn 0.531255 0.692349 0.488283 
vn 0.5808 0.687998 0.435121 
vn 0.415757 0.701919 0.578321 
vn 0.476078 0.697003 0.536225 
vn 0.282013 0.712353 0.642668 
vn 0.350856 0.707053 0.613984 
vn 0.135411 0.72322 0.677212 
vn 0.209938 0.717763 0.663885 
vn -0.0175413 0.73401 0.678912 
vn 0.059282 0.72866 0.682305 
vn -0.169391 0.744141 0.64619 
vn -0.0940986 0.739196 0.666885 
vn -0.312077 0.753002 0.579306 
vn -0.242394 0.748768 0.616921 
vn -0.437454 0.760001 0.480658 
vn -0.377424 0.756769 0.533715 
vn -0.53796 0.764631 0.354878 
vn -0.491245 0.762638 0.420786 
vn -0.607356 0.766536 0.208665 
vn -0.576866 0.765939 0.283837 
vn -0.641386 0.765567 0.0503128 
vn -0.628965 0.766412 0.130444 
vn -0.63823 0.7618 -0.111011 
vn -0.644469 0.76402 -0.0305617 
vn -0.598633 0.755528 -0.266112 
vn -0.622843 0.758952 -0.189892 
vn -0.525707 0.747215 -0.406574 
vn -0.566061 0.751592 -0.33865 
vn -0.424463 0.737432 -0.525381 
vn -0.478253 0.742469 -0.469056 
vn -0.301214 0.726792 -0.617287 
vn -0.365161 0.732181 -0.574951 
vn -0.16296 0.71589 -0.67893 
vn -0.233514 0.721338 -0.652029 
vn -0.0168543 0.705263 -0.708746 
vn -0.0904471 0.710511 -0.697849 
vn 0.130196 0.695368 -0.706762 
vn 0.0569665 0.700198 -0.711672 
vn 0.271808 0.686576 -0.67434 
vn 0.202056 0.690814 -0.694226 
vn 0.402284 0.679173 -0.613915 
vn 0.338765 0.682686 -0.64744 
vn 0.516693 0.673372 -0.528771 
vn 0.461774 0.676062 -0.5742 
vn 0.61091 0.669321 -0.422845 
vn 0.566552 0.671121 -0.478138 
vn 0.681619 0.667116 -0.300587 
vn 0.649378 0.667984 -0.363463 
vn 0.726318 0.666804 -0.166836 
vn 0.707344 0.666722 -0.234833 
vn 0.738357 0.667361 -0.0972492 
vn 0.743329 0.668392 -0.0267364 
vn 0.0951105 0.995064 -0.0283295 
usemtl 0.400000_0.400000_0.400000_0.000000_0.000000
o mesh3
f 2842//2506 2843//2507 2844//2507 
f 2845//2508 2842//2506 2846//2509 
f 2847//2510 2845//2508 2848//2511 
f 2849//2512 2847//2510 2850//2513 
f 2851//2514 2849//2512 2852//2515 
f 2853//2516 2851//2514 2854//2517 
f 2855//2518 2853//2516 2856//2519 
f 2857//2520 2855//2518 2858//2521 
f 2859//2522 2857//2520 2860//2523 
f 2861//2524 2859//2522 2862//2525 
f 2863//2526 2861//2524 2864//2527 
f 2865//2528 2863//2526 2866//2529 
f 2867//2530 2865//2528 2868//2531 
f 2869//2532 2867//2530 2870//2533 
f 2871//2534 2869//2532 2872//2535 
f 2873//2536 2871//2534 2874//2537 
f 2875//2538 2873//2536 2876//2539 
f 2877//2540 2875//2538 2878//2541 
f 2879//2542 2877//2540 2880//2543 
f 2881//2544 2879//2542 2882//2545 
f 2883//2546 2881//2544 2884//2547 
f 2885//2548 2883//2546 2886//2549 
f 2887//2550 2885//2548 2888//2551 
f 2889//2552 2887//2550 2890//2553 
f 2891//2554 2889//2552 2892//2555 
f 2893//2556 2891//2554 2894//2557 
f 2895//2558 2893//2556 2896//2559 
f 2897//2560 2895//2558 2898//2561 
f 2843//2507 2897//2560 2899//2560 
f 2899//2560 2844//2507 2843//2507 
f 2898//2561 2899//2560 2897//2560 
f 2896//2559 2898//2561 2895//2558 
f 2894//2557 2896//2559 2893//2556 
f 2892//2555 2894//2557 2891//2554 
f 2890//2553 2892//2555 2889//2552 
f 2888//2551 2890//2553 2887//2550 
f 2886//2549 2888//2551 2885//2548 
f 2884//2547 2886//2549 2883//2546 
f 2882//2545 2884//2547 2881//2544 
f 2880//2543 2882//2545 2879//2542 
f 2878//2541 2880//2543 2877//2540 
f 2876//2539 2878//2541 2875//2538 
f 2874//2537 2876//2539 2873//2536 
f 2872//2535 2874//2537 2871//2534 
f 2870//2533 2872//2535 2869//2532 
f 2868//2531 2870//2533 2867//2530 
f 2866//2529 2868//2531 2865//2528 
f 2864//2527 2866//2529 2863//2526 
f 2862//2525 2864//2527 2861//2524 
f 2860//2523 2862//2525 2859//2522 
f 2858//2521 2860//2523 2857//2520 
f 2856//2519 2858//2521 2855//2518 
f 2854//2517 2856//2519 2853//2516 
f 2852//2515 2854//2517 2851//2514 
f 2850//2513 2852//2515 2849//2512 
f 2848//2511 2850//2513 2847//2510 
f 2846//2509 2848//2511 2845//2508 
f 2844//2507 2846//2509 2842//2506 
o mesh4
f 2900//2562 2880//2562 2878//2562 
f 2900//2562 2901//2562 2882//2562 
f 2902//2562 2878//2562 2876//2562 
f 2882//2562 2880//2562 2900//2562 
f 2903//2562 2888//2562 2886//2562 
f 2903//2562 2904//2562 2890//2562 
f 2878//2562 2902//2562 2900//2562 
f 2901//2562 2905//2562 2884//2562 
f 2906//2562 2886//2562 2884//2562 
f 2890//2562 2888//2562 2903//2562 
f 2907//2562 2894//2562 2892//2562 
f 2907//2562 2908//2562 2896//2562 
f 2909//2562 2899//2562 2898//2562 
f 2910//2562 2844//2562 2899//2562 
f 2884//2562 2882//2562 2901//2562 
f 2886//2562 2906//2562 2903//2562 
f 2911//2562 2892//2562 2890//2562 
f 2896//2562 2894//2562 2907//2562 
f 2899//2562 2909//2562 2910//2562 
f 2912//2562 2846//2562 2844//2562 
f 2884//2562 2905//2562 2906//2562 
f 2892//2562 2911//2562 2907//2562 
f 2913//2562 2898//2562 2896//2562 
f 2844//2562 2910//2562 2912//2562 
f 2914//2562 2866//2562 2864//2562 
f 2915//2562 2868//2562 2866//2562 
f 2890//2562 2904//2562 2911//2562 
f 2898//2562 2913//2562 2909//2562 
f 2916//2562 2864//2562 2862//2562 
f 2866//2562 2914//2562 2915//2562 
f 2917//2562 2876//2562 2874//2562 
f 2896//2562 2908//2562 2913//2562 
f 2918//2562 2848//2562 2846//2562 
f 2919//2562 2850//2562 2848//2562 
f 2920//2562 2852//2562 2850//2562 
f 2921//2562 2854//2562 2852//2562 
f 2922//2562 2856//2562 2854//2562 
f 2922//2562 2923//2562 2858//2562 
f 2864//2562 2916//2562 2914//2562 
f 2924//2562 2870//2562 2868//2562 
f 2925//2562 2872//2562 2870//2562 
f 2926//2562 2874//2562 2872//2562 
f 2876//2562 2917//2562 2902//2562 
f 2848//2562 2918//2562 2919//2562 
f 2852//2562 2920//2562 2921//2562 
f 2858//2562 2856//2562 2922//2562 
f 2927//2562 2860//2562 2858//2562 
f 2928//2562 2862//2562 2860//2562 
f 2868//2562 2915//2562 2924//2562 
f 2872//2562 2925//2562 2926//2562 
f 2846//2562 2912//2562 2918//2562 
f 2854//2562 2921//2562 2922//2562 
f 2860//2562 2927//2562 2928//2562 
f 2870//2562 2924//2562 2925//2562 
f 2850//2562 2919//2562 2920//2562 
f 2862//2562 2928//2562 2916//2562 
f 2858//2562 2923//2562 2927//2562 
f 2874//2562 2926//2562 2917//2562 
o mesh5
f 2929//2563 2910//2563 2909//2564 
f 2930//2564 2909//2564 2913//2565 
f 2931//2565 2913//2565 2908//2566 
f 2932//2566 2908//2566 2907//2567 
f 2933//2567 2907//2567 2911//2568 
f 2934//2568 2911//2568 2904//2569 
f 2935//2569 2904//2569 2903//2570 
f 2936//2570 2903//2570 2906//2571 
f 2937//2571 2906//2571 2905//2572 
f 2938//2572 2905//2572 2901//2573 
f 2939//2573 2901//2573 2900//2574 
f 2940//2574 2900//2574 2902//2575 
f 2941//2575 2902//2575 2917//2576 
f 2942//2576 2917//2576 2926//2577 
f 2943//2577 2926//2577 2925//2578 
f 2944//2578 2925//2578 2924//2579 
f 2945//2579 2924//2579 2915//2580 
f 2946//2580 2915//2580 2914//2581 
f 2947//2581 2914//2581 2916//2582 
f 2948//2582 2916//2582 2928//2583 
f 2949//2583 2928//2583 2927//2584 
f 2950//2584 2927//2584 2923//2585 
f 2951//2585 2923//2585 2922//2586 
f 2952//2586 2922//2586 2921//2587 
f 2953//2587 2921//2587 2920//2588 
f 2954//2588 2920//2588 2919//2589 
f 2955//2589 2919//2589 2918//2590 
f 2956//2590 2918//2590 2912//2591 
f 2957//2591 2912//2591 2910//2563 
f 2910//2563 2929//2563 2957//2591 
f 2912//2591 2957//2591 2956//2590 
f 2918//2590 2956//2590 2955//2589 
f 2919//2589 2955//2589 2954//2588 
f 2920//2588 2954//2588 2953//2587 
f 2921//2587 2953//2587 2952//2586 
f 2922//2586 2952//2586 2951//2585 
f 2923//2585 2951//2585 2950//2584 
f 2927//2584 2950//2584 2949//2583 
f 2928//2583 2949//2583 2948//2582 
f 2916//2582 2948//2582 2947//2581 
f 2914//2581 2947//2581 2946//2580 
f 2915//2580 2946//2580 2945//2579 
f 2924//2579 2945//2579 2944//2578 
f 2925//2578 2944//2578 2943//2577 
f 2926//2577 2943//2577 2942//2576 
f 2917//2576 2942//2576 2941//2575 
f 2902//2575 2941//2575 2940//2574 
f 2900//2574 2940//2574 2939//2573 
f 2901//2573 2939//2573 2938//2572 
f 2905//2572 2938//2572 2937//2571 
f 2906//2571 2937//2571 2936//2570 
f 2903//2570 2936//2570 2935//2569 
f 2904//2569 2935//2569 2934//2568 
f 2911//2568 2934//2568 2933//2567 
f 2907//2567 2933//2567 2932//2566 
f 2908//2566 2932//2566 2931//2565 
f 2913//2565 2931//2565 2930//2564 
f 2909//2564 2930//2564 2929//2563 
o mesh6
f 2930//2592 2958//2592 2959//2593 
f 2959//2593 2929//2594 2930//2592 
f 2931//2595 2960//2595 2961//2596 
f 2961//2596 2930//2592 2931//2595 
f 2932//2597 2962//2597 2963//2598 
f 2963//2598 2931//2595 2932//2597 
f 2933//2599 2964//2599 2965//2600 
f 2965//2600 2932//2597 2933//2599 
f 2934//2601 2966//2601 2967//2602 
f 2967//2602 2933//2599 2934//2601 
f 2935//2603 2968//2603 2969//2604 
f 2969//2604 2934//2601 2935//2603 
f 2936//2605 2970//2605 2971//2606 
f 2971//2606 2935//2603 2936//2605 
f 2937//2607 2972//2607 2973//2608 
f 2973//2608 2936//2605 2937//2607 
f 2938//2609 2974//2609 2975//2610 
f 2975//2610 2937//2607 2938//2609 
f 2939//2611 2976//2611 2977//2612 
f 2977//2612 2938//2609 2939//2611 
f 2939//2611 2940//2613 2978//2614 
f 2940//2613 2979//2613 2978//2614 
f 2940//2613 2941//2615 2980//2616 
f 2941//2615 2981//2615 2980//2616 
f 2941//2615 2942//2617 2982//2618 
f 2942//2617 2983//2617 2982//2618 
f 2943//2619 2984//2619 2985//2620 
f 2985//2620 2942//2617 2943//2619 
f 2944//2621 2986//2621 2987//2622 
f 2987//2622 2943//2619 2944//2621 
f 2945//2623 2988//2623 2989//2624 
f 2989//2624 2944//2621 2945//2623 
f 2946//2625 2990//2625 2991//2626 
f 2991//2626 2945//2623 2946//2625 
f 2947//2627 2992//2627 2993//2628 
f 2993//2628 2946//2625 2947//2627 
f 2948//2629 2994//2629 2995//2630 
f 2995//2630 2947//2627 2948//2629 
f 2949//2631 2996//2631 2997//2632 
f 2997//2632 2948//2629 2949//2631 
f 2950//2633 2998//2633 2999//2634 
f 2999//2634 2949//2631 2950//2633 
f 2951//2635 3000//2635 3001//2636 
f 3001//2636 2950//2633 2951//2635 
f 2952//2637 3002//2637 3003//2638 
f 3003//2638 2951//2635 2952//2637 
f 2953//2639 3004//2639 3005//2640 
f 3005//2640 2952//2637 2953//2639 
f 2954//2641 3006//2641 3007//2642 
f 3007//2642 2953//2639 2954//2641 
f 2955//2643 3008//2643 3009//2644 
f 3009//2644 2954//2641 2955//2643 
f 2956//2645 3010//2645 3011//2646 
f 3011//2646 2955//2643 2956//2645 
f 2957//2647 3012//2647 3013//2648 
f 3013//2648 2956//2645 2957//2647 
f 2929//2594 3014//2649 3015//2650 
f 3015//2650 2957//2647 2929//2594 
f 3015//2650 3012//2647 2957//2647 
f 3013//2648 3010//2645 2956//2645 
f 3011//2646 3008//2643 2955//2643 
f 3009//2644 3006//2641 2954//2641 
f 3007//2642 3004//2639 2953//2639 
f 3005//2640 3002//2637 2952//2637 
f 3003//2638 3000//2635 2951//2635 
f 3001//2636 2998//2633 2950//2633 
f 2999//2634 2996//2631 2949//2631 
f 2997//2632 2994//2629 2948//2629 
f 2995//2630 2992//2627 2947//2627 
f 2993//2628 2990//2625 2946//2625 
f 2991//2626 2988//2623 2945//2623 
f 2989//2624 2986//2621 2944//2621 
f 2987//2622 2984//2619 2943//2619 
f 2985//2620 2983//2617 2942//2617 
f 2982//2618 2981//2615 2941//2615 
f 2980//2616 2979//2613 2940//2613 
f 2978//2614 2976//2611 2939//2611 
f 2977//2612 2974//2609 2938//2609 
f 2975//2610 2972//2607 2937//2607 
f 2973//2608 2970//2605 2936//2605 
f 2971//2606 2968//2603 2935//2603 
f 2969//2604 2966//2601 2934//2601 
f 2967//2602 2964//2599 2933//2599 
f 2965//2600 2962//2597 2932//2597 
f 2963//2598 2960//2595 2931//2595 
f 2961//2596 2958//2592 2930//2592 
f 2959//2593 3014//2649 2929//2594 
o mesh7
f 3016//2651 2985//2651 2984//2652 
f 2984//2652 3017//2653 3016//2651 
f 3018//2654 2982//2654 2983//2655 
f 2983//2655 3016//2651 3018//2654 
f 3019//2656 2980//2656 2981//2657 
f 2981//2657 3018//2654 3019//2656 
f 3020//2658 2978//2658 2979//2659 
f 2979//2659 3019//2656 3020//2658 
f 3021//2660 2977//2660 2976//2661 
f 2976//2661 3020//2658 3021//2660 
f 3022//2662 2975//2662 2974//2663 
f 2974//2663 3021//2660 3022//2662 
f 3023//2664 2973//2664 2972//2665 
f 2972//2665 3022//2662 3023//2664 
f 3024//2666 2971//2666 2970//2667 
f 2970//2667 3023//2664 3024//2666 
f 3025//2668 2969//2668 2968//2669 
f 2968//2669 3024//2666 3025//2668 
f 3026//2670 2967//2670 2966//2671 
f 2966//2671 3025//2668 3026//2670 
f 3027//2672 2965//2672 2964//2673 
f 2964//2673 3026//2670 3027//2672 
f 3028//2674 2963//2674 2962//2675 
f 2962//2675 3027//2672 3028//2674 
f 3029//2676 2961//2676 2960//2677 
f 2960//2677 3028//2674 3029//2676 
f 3030//2678 2959//2678 2958//2679 
f 2958//2679 3029//2676 3030//2678 
f 3015//2680 3014//2681 3031//2681 
f 2959//2678 3030//2678 3031//2681 
f 3031//2681 3014//2681 2959//2678 
f 3032//2680 3033//2682 3012//2683 
f 3033//2682 3013//2682 3012//2683 
f 3033//2682 3034//2684 3010//2685 
f 3034//2684 3011//2684 3010//2685 
f 3034//2684 3035//2686 3008//2687 
f 3035//2686 3009//2686 3008//2687 
f 3036//2688 3007//2688 3006//2689 
f 3006//2689 3035//2686 3036//2688 
f 3037//2690 3005//2690 3004//2691 
f 3004//2691 3036//2688 3037//2690 
f 3038//2692 3003//2692 3002//2693 
f 3002//2693 3037//2690 3038//2692 
f 3039//2694 3001//2694 3000//2695 
f 3000//2695 3038//2692 3039//2694 
f 3040//2696 2999//2696 2998//2697 
f 2998//2697 3039//2694 3040//2696 
f 3041//2698 2997//2698 2996//2699 
f 2996//2699 3040//2696 3041//2698 
f 3042//2700 2995//2700 2994//2701 
f 2994//2701 3041//2698 3042//2700 
f 3042//2700 3043//2702 2992//2703 
f 3043//2702 2993//2702 2992//2703 
f 3044//2704 2991//2704 2990//2705 
f 2990//2705 3043//2702 3044//2704 
f 3045//2706 2989//2706 2988//2707 
f 2988//2707 3044//2704 3045//2706 
f 3045//2706 3017//2653 2986//2708 
f 3017//2653 2987//2709 2986//2708 
f 2986//2708 2989//2706 3045//2706 
f 2988//2707 2991//2704 3044//2704 
f 2990//2705 2993//2702 3043//2702 
f 2992//2703 2995//2700 3042//2700 
f 2994//2701 2997//2698 3041//2698 
f 2996//2699 2999//2696 3040//2696 
f 2998//2697 3001//2694 3039//2694 
f 3000//2695 3003//2692 3038//2692 
f 3002//2693 3005//2690 3037//2690 
f 3004//2691 3007//2688 3036//2688 
f 3006//2689 3009//2686 3035//2686 
f 3008//2687 3011//2684 3034//2684 
f 3010//2685 3013//2682 3033//2682 
f 3012//2683 3015//2680 3032//2680 
f 3031//2681 3032//2680 3015//2680 
f 2958//2679 2961//2676 3029//2676 
f 2960//2677 2963//2674 3028//2674 
f 2962//2675 2965//2672 3027//2672 
f 2964//2673 2967//2670 3026//2670 
f 2966//2671 2969//2668 3025//2668 
f 2968//2669 2971//2666 3024//2666 
f 2970//2667 2973//2664 3023//2664 
f 2972//2665 2975//2662 3022//2662 
f 2974//2663 2977//2660 3021//2660 
f 2976//2661 2978//2658 3020//2658 
f 2979//2659 2980//2656 3019//2656 
f 2981//2657 2982//2654 3018//2654 
f 2983//2655 2985//2651 3016//2651 
f 2984//2652 2987//2709 3017//2653 
o mesh8
f 3030//2710 3029//2710 2897//2710 
f 2843//2710 3031//2710 3030//2710 
f 3029//2710 3028//2710 2895//2710 
f 3027//2710 3026//2710 2891//2710 
f 3026//2710 3025//2710 2889//2710 
f 2895//2710 2897//2710 3029//2710 
f 3028//2710 3027//2710 2893//2710 
f 2889//2710 2891//2710 3026//2710 
f 3025//2710 3024//2710 2887//2710 
f 3024//2710 3023//2710 2885//2710 
f 3023//2710 3022//2710 2883//2710 
f 3020//2710 3019//2710 2877//2710 
f 3019//2710 3018//2710 2875//2710 
f 3043//2710 3042//2710 2863//2710 
f 3042//2710 3041//2710 2861//2710 
f 2893//2710 2895//2710 3028//2710 
f 2887//2710 2889//2710 3025//2710 
f 2883//2710 2885//2710 3023//2710 
f 3022//2710 3021//2710 2881//2710 
f 3021//2710 3020//2710 2879//2710 
f 2875//2710 2877//2710 3019//2710 
f 3016//2710 3017//2710 2871//2710 
f 3017//2710 3045//2710 2869//2710 
f 2861//2710 2863//2710 3042//2710 
f 3041//2710 3040//2710 2859//2710 
f 2891//2710 2893//2710 3027//2710 
f 2881//2710 2883//2710 3022//2710 
f 2877//2710 2879//2710 3020//2710 
f 3018//2710 3016//2710 2873//2710 
f 2869//2710 2871//2710 3017//2710 
f 3045//2710 3044//2710 2867//2710 
f 3044//2710 3043//2710 2865//2710 
f 2859//2710 2861//2710 3041//2710 
f 3038//2710 3037//2710 2853//2710 
f 3037//2710 3036//2710 2851//2710 
f 3036//2710 3035//2710 2849//2710 
f 3035//2710 3034//2710 2847//2710 
f 2885//2710 2887//2710 3024//2710 
f 2873//2710 2875//2710 3018//2710 
f 2867//2710 2869//2710 3045//2710 
f 2863//2710 2865//2710 3043//2710 
f 2851//2710 2853//2710 3037//2710 
f 2847//2710 2849//2710 3035//2710 
f 3034//2710 3033//2710 2845//2710 
f 3033//2710 3032//2710 2842//2710 
f 2879//2710 2881//2710 3021//2710 
f 2865//2710 2867//2710 3044//2710 
f 3040//2710 3039//2710 2857//2710 
f 3039//2710 3038//2710 2855//2710 
f 2849//2710 2851//2710 3036//2710 
f 2842//2710 2845//2710 3033//2710 
f 2871//2710 2873//2710 3016//2710 
f 2855//2710 2857//2710 3039//2710 
f 2845//2710 2847//2710 3034//2710 
f 3032//2710 3031//2710 2843//2710 
f 2857//2710 2859//2710 3040//2710 
f 2843//2710 2842//2710 3032//2710 
f 2853//2710 2855//2710 3038//2710 
f 2897//2710 2843//2710 3030//2710 
g 35cm_T2020
v -0.0490819 -0.198355 -0.095158 
v -0.0490819 0.151645 -0.095158 
v -0.0526175 0.151645 -0.0916224 
v -0.0526175 -0.198355 -0.0916224 
v -0.0565819 0.151645 -0.0916224 
v -0.0565819 -0.198355 -0.0916224 
v -0.0565819 0.151645 -0.0955869 
v -0.0565819 -0.198355 -0.0955869 
v -0.0530464 0.151645 -0.0991224 
v -0.0530464 -0.198355 -0.0991224 
v -0.0530464 0.151645 -0.104122 
v -0.0530464 -0.198355 -0.104122 
v -0.0565819 0.151645 -0.107658 
v -0.0565819 -0.198355 -0.107658 
v -0.0565819 0.151645 -0.111622 
v -0.0565819 -0.198355 -0.111622 
v -0.0526175 0.151645 -0.111622 
v -0.0526175 -0.198355 -0.111622 
v -0.0490819 0.151645 -0.108087 
v -0.0490819 -0.198355 -0.108087 
v -0.0440819 0.151645 -0.108087 
v -0.0440819 -0.198355 -0.108087 
v -0.0405464 0.151645 -0.111622 
v -0.0405464 -0.198355 -0.111622 
v -0.0365819 0.151645 -0.111622 
v -0.0365819 -0.198355 -0.111622 
v -0.0365819 0.151645 -0.107658 
v -0.0365819 -0.198355 -0.107658 
v -0.0401175 0.151645 -0.104122 
v -0.0401175 -0.198355 -0.104122 
v -0.0401175 0.151645 -0.0991224 
v -0.0401175 -0.198355 -0.0991224 
v -0.0365819 0.151645 -0.0955869 
v -0.0365819 -0.198355 -0.0955869 
v -0.0365819 0.151645 -0.0916224 
v -0.0365819 -0.198355 -0.0916224 
v -0.0405464 -0.198355 -0.0916224 
v -0.0440819 -0.198355 -0.095158 
v -0.0405464 0.151645 -0.0916224 
v -0.0440819 0.151645 -0.095158 
vn 0.72709 0.17214 0.664611 
vn -0.0744885 0.169653 0.982685 
vn -0.983794 0.139874 -0.112182 
vn -0.676393 0.132575 -0.724511 
vn -0.787847 0.15442 0.596198 
vn -0.983794 0.139874 -0.112182 
vn -0.0587254 0.133751 -0.989273 
vn 0.605223 0.143287 -0.783054 
vn -0.676393 0.132575 -0.724511 
vn -0.0587254 0.133751 -0.989273 
vn 0.978995 0.15905 -0.127561 
vn 0.72709 0.17214 0.664611 
vn 0.605223 0.143287 -0.783054 
vn 0.978995 0.15905 -0.127561 
vn -0.0774559 -0.986905 -0.141485 
vn -0.0574001 0.99283 -0.10485 
vn -0.0744885 0.169653 0.982685 
vn -0.787847 0.15442 0.596198 
usemtl 0.301961_0.301961_0.301961_0.000000_0.000000
o mesh229
f 3046//2711 3047//2711 3048//2711 
f 3048//2711 3049//2711 3046//2711 
o mesh230
f 3049//2712 3048//2712 3050//2712 
f 3050//2712 3051//2712 3049//2712 
o mesh231
f 3051//2713 3050//2713 3052//2713 
f 3052//2713 3053//2713 3051//2713 
o mesh232
f 3053//2714 3052//2714 3054//2714 
f 3054//2714 3055//2714 3053//2714 
o mesh233
f 3055//2713 3054//2713 3056//2713 
f 3056//2713 3057//2713 3055//2713 
o mesh234
f 3057//2715 3056//2715 3058//2715 
f 3058//2715 3059//2715 3057//2715 
o mesh235
f 3059//2716 3058//2716 3060//2716 
f 3060//2716 3061//2716 3059//2716 
o mesh236
f 3061//2717 3060//2717 3062//2717 
f 3062//2717 3063//2717 3061//2717 
o mesh237
f 3063//2718 3062//2718 3064//2718 
f 3064//2718 3065//2718 3063//2718 
o mesh238
f 3065//2717 3064//2717 3066//2717 
f 3066//2717 3067//2717 3065//2717 
o mesh239
f 3067//2719 3066//2719 3068//2719 
f 3068//2719 3069//2719 3067//2719 
o mesh240
f 3069//2720 3068//2720 3070//2720 
f 3070//2720 3071//2720 3069//2720 
o mesh241
f 3071//2721 3070//2721 3072//2721 
f 3072//2721 3073//2721 3071//2721 
o mesh242
f 3073//2722 3072//2722 3074//2722 
f 3074//2722 3075//2722 3073//2722 
o mesh243
f 3075//2721 3074//2721 3076//2721 
f 3076//2721 3077//2721 3075//2721 
o mesh244
f 3077//2723 3076//2723 3078//2723 
f 3078//2723 3079//2723 3077//2723 
o mesh245
f 3079//2724 3078//2724 3080//2724 
f 3080//2724 3081//2724 3079//2724 
o mesh246
f 3082//2725 3077//2725 3079//2725 
f 3059//2725 3061//2725 3063//2725 
f 3057//2725 3065//2725 3075//2725 
f 3079//2725 3081//2725 3082//2725 
f 3065//2725 3057//2725 3059//2725 
f 3077//2725 3055//2725 3057//2725 
f 3069//2725 3071//2725 3073//2725 
f 3082//2725 3083//2725 3077//2725 
f 3075//2725 3077//2725 3057//2725 
f 3075//2725 3067//2725 3069//2725 
f 3049//2725 3051//2725 3053//2725 
f 3063//2725 3065//2725 3059//2725 
f 3075//2725 3065//2725 3067//2725 
f 3055//2725 3046//2725 3049//2725 
f 3073//2725 3075//2725 3069//2725 
f 3055//2725 3083//2725 3046//2725 
f 3053//2725 3055//2725 3049//2725 
f 3083//2725 3055//2725 3077//2725 
o mesh247
f 3056//2726 3076//2726 3074//2726 
f 3058//2726 3064//2726 3062//2726 
f 3084//2726 3080//2726 3078//2726 
f 3068//2726 3074//2726 3072//2726 
f 3074//2726 3064//2726 3056//2726 
f 3062//2726 3060//2726 3058//2726 
f 3076//2726 3085//2726 3084//2726 
f 3048//2726 3054//2726 3052//2726 
f 3072//2726 3070//2726 3068//2726 
f 3058//2726 3056//2726 3064//2726 
f 3076//2726 3054//2726 3085//2726 
f 3052//2726 3050//2726 3048//2726 
f 3068//2726 3066//2726 3074//2726 
f 3078//2726 3076//2726 3084//2726 
f 3048//2726 3047//2726 3054//2726 
f 3056//2726 3054//2726 3076//2726 
f 3066//2726 3064//2726 3074//2726 
f 3047//2726 3085//2726 3054//2726 
o mesh248
f 3081//2727 3080//2727 3084//2727 
f 3084//2727 3082//2727 3081//2727 
o mesh249
f 3082//2728 3084//2728 3085//2728 
f 3085//2728 3083//2728 3082//2728 
o mesh250
f 3083//2727 3085//2727 3047//2727 
f 3047//2727 3046//2727 3083//2727 
g 6mmSpacer
v 0.161396 -0.138822 -0.0906911 
v 0.161337 -0.139359 -0.0906911 
v 0.161337 -0.139359 -0.0966911 
v 0.161568 -0.13831 -0.0906911 
v 0.161396 -0.138822 -0.0966911 
v 0.161847 -0.137846 -0.0906911 
v 0.161568 -0.13831 -0.0966911 
v 0.162219 -0.137454 -0.0906911 
v 0.161847 -0.137846 -0.0966911 
v 0.162666 -0.137151 -0.0906911 
v 0.162219 -0.137454 -0.0966911 
v 0.163169 -0.136951 -0.0906911 
v 0.162666 -0.137151 -0.0966911 
v 0.163702 -0.136863 -0.0906911 
v 0.163169 -0.136951 -0.0966911 
v 0.164242 -0.136892 -0.0906911 
v 0.163702 -0.136863 -0.0966911 
v 0.164763 -0.137037 -0.0906911 
v 0.164242 -0.136892 -0.0966911 
v 0.16524 -0.13729 -0.0906911 
v 0.164763 -0.137037 -0.0966911 
v 0.165652 -0.13764 -0.0906911 
v 0.16524 -0.13729 -0.0966911 
v 0.165979 -0.13807 -0.0906911 
v 0.165652 -0.13764 -0.0966911 
v 0.166206 -0.138561 -0.0906911 
v 0.165979 -0.13807 -0.0966911 
v 0.166323 -0.139089 -0.0906911 
v 0.166206 -0.138561 -0.0966911 
v 0.166323 -0.13963 -0.0966911 
v 0.166323 -0.13963 -0.0906911 
v 0.166337 -0.139359 -0.0906911 
v 0.166323 -0.139089 -0.0966911 
v 0.166337 -0.139359 -0.0966911 
v 0.166206 -0.140158 -0.0906911 
v 0.165979 -0.140648 -0.0906911 
v 0.166206 -0.140158 -0.0966911 
v 0.165652 -0.141079 -0.0906911 
v 0.165979 -0.140648 -0.0966911 
v 0.16524 -0.141429 -0.0906911 
v 0.165652 -0.141079 -0.0966911 
v 0.164763 -0.141682 -0.0906911 
v 0.16524 -0.141429 -0.0966911 
v 0.164242 -0.141826 -0.0906911 
v 0.164763 -0.141682 -0.0966911 
v 0.163702 -0.141856 -0.0906911 
v 0.164242 -0.141826 -0.0966911 
v 0.163169 -0.141768 -0.0906911 
v 0.163702 -0.141856 -0.0966911 
v 0.162666 -0.141568 -0.0906911 
v 0.163169 -0.141768 -0.0966911 
v 0.162219 -0.141265 -0.0906911 
v 0.162666 -0.141568 -0.0966911 
v 0.161847 -0.140872 -0.0906911 
v 0.162219 -0.141265 -0.0966911 
v 0.161568 -0.140409 -0.0906911 
v 0.161847 -0.140872 -0.0966911 
v 0.161396 -0.139897 -0.0906911 
v 0.161568 -0.140409 -0.0966911 
v 0.161396 -0.139897 -0.0966911 
v 0.166082 -0.14267 -0.0966911 
v 0.165318 -0.143075 -0.0966911 
v 0.164484 -0.143307 -0.0966911 
v 0.163621 -0.143354 -0.0966911 
v 0.165318 -0.135643 -0.0966911 
v 0.166082 -0.136049 -0.0966911 
v 0.166741 -0.136609 -0.0966911 
v 0.162767 -0.143214 -0.0966911 
v 0.161964 -0.142893 -0.0966911 
v 0.161248 -0.142408 -0.0966911 
v 0.160653 -0.136939 -0.0966911 
v 0.161248 -0.136311 -0.0966911 
v 0.161964 -0.135825 -0.0966911 
v 0.162767 -0.135505 -0.0966911 
v 0.163621 -0.135365 -0.0966911 
v 0.160207 -0.141039 -0.0966911 
v 0.159931 -0.140219 -0.0966911 
v 0.164484 -0.135412 -0.0966911 
v 0.167265 -0.137297 -0.0966911 
v 0.167628 -0.138082 -0.0966911 
v 0.167814 -0.138927 -0.0966911 
v 0.167837 -0.139359 -0.0966911 
v 0.167814 -0.139792 -0.0966911 
v 0.167628 -0.140637 -0.0966911 
v 0.167265 -0.141422 -0.0966911 
v 0.166741 -0.14211 -0.0966911 
v 0.160653 -0.14178 -0.0966911 
v 0.159837 -0.139359 -0.0966911 
v 0.160207 -0.13768 -0.0966911 
v 0.159931 -0.138499 -0.0966911 
v 0.159837 -0.139359 -0.0906911 
v 0.159931 -0.140219 -0.0906911 
v 0.160207 -0.141039 -0.0906911 
v 0.160653 -0.14178 -0.0906911 
v 0.161248 -0.142408 -0.0906911 
v 0.161964 -0.142893 -0.0906911 
v 0.162767 -0.143214 -0.0906911 
v 0.163621 -0.143354 -0.0906911 
v 0.164484 -0.143307 -0.0906911 
v 0.165318 -0.143075 -0.0906911 
v 0.166082 -0.14267 -0.0906911 
v 0.166741 -0.14211 -0.0906911 
v 0.167265 -0.141422 -0.0906911 
v 0.167628 -0.140637 -0.0906911 
v 0.167814 -0.138927 -0.0906911 
v 0.167837 -0.139359 -0.0906911 
v 0.167814 -0.139792 -0.0906911 
v 0.167628 -0.138082 -0.0906911 
v 0.167265 -0.137297 -0.0906911 
v 0.166741 -0.136609 -0.0906911 
v 0.166082 -0.136049 -0.0906911 
v 0.165318 -0.135643 -0.0906911 
v 0.164484 -0.135412 -0.0906911 
v 0.163621 -0.135365 -0.0906911 
v 0.162767 -0.135505 -0.0906911 
v 0.161964 -0.135825 -0.0906911 
v 0.161248 -0.136311 -0.0906911 
v 0.160653 -0.136939 -0.0906911 
v 0.160207 -0.13768 -0.0906911 
v 0.159931 -0.138499 -0.0906911 
vn 0.954947 -0.287509 -0.0735882 
vn 0.990541 -0.115008 -0.0748442 
vn 0.89033 -0.449445 -0.0728847 
vn 0.954947 -0.287509 -0.0735882 
vn 0.798935 -0.597005 -0.0727208 
vn 0.89033 -0.449445 -0.0728847 
vn 0.683175 -0.726588 -0.0730932 
vn 0.798935 -0.597005 -0.0727208 
vn 0.545679 -0.83472 -0.074009 
vn 0.683175 -0.726588 -0.0730932 
vn 0.389363 -0.917986 -0.0754851 
vn 0.545679 -0.83472 -0.074009 
vn 0.217535 -0.972967 -0.0775464 
vn 0.389363 -0.917986 -0.0754851 
vn 0.0340453 -0.996195 -0.0802231 
vn 0.217535 -0.972967 -0.0775464 
vn -0.156481 -0.984141 -0.0835438 
vn 0.0340453 -0.996195 -0.0802231 
vn -0.348315 -0.933282 -0.0875245 
vn -0.156481 -0.984141 -0.0835438 
vn -0.534169 -0.840341 -0.0921476 
vn -0.348315 -0.933282 -0.0875245 
vn -0.704647 -0.702851 -0.0973294 
vn -0.534169 -0.840341 -0.0921476 
vn -0.847781 -0.520274 -0.102874 
vn -0.704647 -0.702851 -0.0973294 
vn -0.949059 -0.295857 -0.10842 
vn -0.847781 -0.520274 -0.102874 
vn -0.992779 -0.0390679 -0.113415 
vn -0.979063 -0.17061 -0.111028 
vn -0.949059 -0.295857 -0.10842 
vn -0.965523 0.232462 -0.117161 
vn -0.861507 0.493604 -0.118996 
vn -0.687185 0.716745 -0.118544 
vn -0.461245 0.879671 -0.115901 
vn -0.209002 0.971528 -0.111584 
vn 0.0451113 0.99331 -0.106298 
vn 0.28248 0.953973 -0.100698 
vn 0.491372 0.865724 -0.0952614 
vn 0.66565 0.740783 -0.0902804 
vn 0.802887 0.589909 -0.0859013 
vn 0.902824 0.422084 -0.082177 
vn 0.966365 0.244704 -0.0791092 
vn 0.995005 0.0639255 -0.076675 
vn 0.179189 -0.12469 -0.975881 
vn -0.979063 -0.17061 -0.111028 
vn -0.904634 -0.412879 -0.105677 
vn -0.780487 -0.617111 -0.100074 
vn -0.622014 -0.777261 -0.0946776 
vn -0.442521 -0.892255 -0.0897589 
vn -0.252648 -0.963778 -0.0854517 
vn -0.0606657 -0.994801 -0.0818014 
vn 0.12698 -0.98877 -0.0788059 
vn 0.305162 -0.949227 -0.0764408 
vn 0.469677 -0.879674 -0.0746756 
vn 0.616969 -0.783549 -0.0734823 
vn 0.743942 -0.664263 -0.0728397 
vn 0.847833 -0.525251 -0.0727358 
vn 0.926129 -0.370042 -0.0731684 
vn 0.976507 -0.20233 -0.0741459 
vn 0.996791 -0.0260716 -0.0756861 
vn 0.990541 -0.115008 -0.0748442 
vn 0.976507 -0.20233 -0.0741459 
vn 0.98494 0.154394 -0.0778148 
vn 0.93906 0.334179 -0.0805622 
vn 0.857481 0.50762 -0.0839564 
vn 0.738952 0.667986 -0.0880107 
vn 0.583056 0.807126 -0.0927021 
vn 0.390978 0.915175 -0.0979368 
vn 0.166774 0.980548 -0.103503 
vn -0.0808504 0.990746 -0.109018 
vn -0.336786 0.934666 -0.113909 
vn -0.579148 0.806714 -0.117472 
vn -0.78221 0.611532 -0.119061 
vn -0.923024 0.366087 -0.118351 
vn -0.988631 0.0962857 -0.115489 
vn 0.21272 -0.148023 0.965836 
usemtl 0.647059_0.647059_0.647059_0.000000_0.000000
o mesh268
f 3086//2729 3087//2730 3088//2730 
f 3089//2731 3086//2729 3090//2732 
f 3091//2733 3089//2731 3092//2734 
f 3093//2735 3091//2733 3094//2736 
f 3095//2737 3093//2735 3096//2738 
f 3097//2739 3095//2737 3098//2740 
f 3099//2741 3097//2739 3100//2742 
f 3101//2743 3099//2741 3102//2744 
f 3103//2745 3101//2743 3104//2746 
f 3105//2747 3103//2745 3106//2748 
f 3107//2749 3105//2747 3108//2750 
f 3109//2751 3107//2749 3110//2752 
f 3111//2753 3109//2751 3112//2754 
f 3113//2755 3111//2753 3114//2756 
f 3115//2757 3116//2757 3117//2758 
f 3113//2755 3118//2759 3119//2758 
f 3119//2758 3117//2758 3113//2755 
f 3120//2760 3116//2757 3115//2757 
f 3121//2761 3120//2760 3122//2760 
f 3123//2762 3121//2761 3124//2761 
f 3125//2763 3123//2762 3126//2762 
f 3127//2764 3125//2763 3128//2763 
f 3129//2765 3127//2764 3130//2764 
f 3131//2766 3129//2765 3132//2765 
f 3133//2767 3131//2766 3134//2766 
f 3135//2768 3133//2767 3136//2767 
f 3137//2769 3135//2768 3138//2768 
f 3139//2770 3137//2769 3140//2769 
f 3141//2771 3139//2770 3142//2770 
f 3143//2772 3141//2771 3144//2771 
f 3087//2730 3143//2772 3145//2772 
f 3145//2772 3088//2730 3087//2730 
f 3144//2771 3145//2772 3143//2772 
f 3142//2770 3144//2771 3141//2771 
f 3140//2769 3142//2770 3139//2770 
f 3138//2768 3140//2769 3137//2769 
f 3136//2767 3138//2768 3135//2768 
f 3134//2766 3136//2767 3133//2767 
f 3132//2765 3134//2766 3131//2766 
f 3130//2764 3132//2765 3129//2765 
f 3128//2763 3130//2764 3127//2764 
f 3126//2762 3128//2763 3125//2763 
f 3124//2761 3126//2762 3123//2762 
f 3122//2760 3124//2761 3121//2761 
f 3115//2757 3122//2760 3120//2760 
f 3117//2758 3119//2758 3115//2757 
f 3114//2756 3118//2759 3113//2755 
f 3112//2754 3114//2756 3111//2753 
f 3110//2752 3112//2754 3109//2751 
f 3108//2750 3110//2752 3107//2749 
f 3106//2748 3108//2750 3105//2747 
f 3104//2746 3106//2748 3103//2745 
f 3102//2744 3104//2746 3101//2743 
f 3100//2742 3102//2744 3099//2741 
f 3098//2740 3100//2742 3097//2739 
f 3096//2738 3098//2740 3095//2737 
f 3094//2736 3096//2738 3093//2735 
f 3092//2734 3094//2736 3091//2733 
f 3090//2732 3092//2734 3089//2731 
f 3088//2730 3090//2732 3086//2729 
o mesh269
f 3146//2773 3128//2773 3126//2773 
f 3146//2773 3147//2773 3130//2773 
f 3148//2773 3132//2773 3130//2773 
f 3148//2773 3149//2773 3134//2773 
f 3130//2773 3128//2773 3146//2773 
f 3134//2773 3132//2773 3148//2773 
f 3150//2773 3151//2773 3108//2773 
f 3151//2773 3152//2773 3110//2773 
f 3130//2773 3147//2773 3148//2773 
f 3153//2773 3136//2773 3134//2773 
f 3154//2773 3138//2773 3136//2773 
f 3155//2773 3140//2773 3138//2773 
f 3156//2773 3157//2773 3096//2773 
f 3157//2773 3158//2773 3098//2773 
f 3158//2773 3159//2773 3100//2773 
f 3159//2773 3160//2773 3102//2773 
f 3150//2773 3106//2773 3104//2773 
f 3110//2773 3108//2773 3151//2773 
f 3134//2773 3149//2773 3153//2773 
f 3138//2773 3154//2773 3155//2773 
f 3161//2773 3144//2773 3142//2773 
f 3161//2773 3162//2773 3145//2773 
f 3098//2773 3096//2773 3157//2773 
f 3102//2773 3100//2773 3159//2773 
f 3163//2773 3104//2773 3102//2773 
f 3108//2773 3106//2773 3150//2773 
f 3164//2773 3112//2773 3110//2773 
f 3164//2773 3165//2773 3114//2773 
f 3166//2773 3118//2773 3114//2773 
f 3166//2773 3167//2773 3119//2773 
f 3168//2773 3115//2773 3119//2773 
f 3168//2773 3169//2773 3122//2773 
f 3170//2773 3124//2773 3122//2773 
f 3170//2773 3171//2773 3126//2773 
f 3136//2773 3153//2773 3154//2773 
f 3172//2773 3142//2773 3140//2773 
f 3145//2773 3144//2773 3161//2773 
f 3162//2773 3173//2773 3088//2773 
f 3174//2773 3092//2773 3090//2773 
f 3174//2773 3156//2773 3094//2773 
f 3100//2773 3098//2773 3158//2773 
f 3104//2773 3163//2773 3150//2773 
f 3114//2773 3112//2773 3164//2773 
f 3119//2773 3118//2773 3166//2773 
f 3122//2773 3115//2773 3168//2773 
f 3126//2773 3124//2773 3170//2773 
f 3140//2773 3155//2773 3172//2773 
f 3088//2773 3145//2773 3162//2773 
f 3175//2773 3090//2773 3088//2773 
f 3094//2773 3092//2773 3174//2773 
f 3102//2773 3160//2773 3163//2773 
f 3114//2773 3165//2773 3166//2773 
f 3122//2773 3169//2773 3170//2773 
f 3142//2773 3172//2773 3161//2773 
f 3090//2773 3175//2773 3174//2773 
f 3110//2773 3152//2773 3164//2773 
f 3126//2773 3171//2773 3146//2773 
f 3096//2773 3094//2773 3156//2773 
f 3088//2773 3173//2773 3175//2773 
f 3119//2773 3167//2773 3168//2773 
o mesh270
f 3176//2774 3173//2774 3162//2775 
f 3177//2775 3162//2775 3161//2776 
f 3178//2776 3161//2776 3172//2777 
f 3179//2777 3172//2777 3155//2778 
f 3180//2778 3155//2778 3154//2779 
f 3181//2779 3154//2779 3153//2780 
f 3182//2780 3153//2780 3149//2781 
f 3183//2781 3149//2781 3148//2782 
f 3184//2782 3148//2782 3147//2783 
f 3185//2783 3147//2783 3146//2784 
f 3186//2784 3146//2784 3171//2785 
f 3187//2785 3171//2785 3170//2786 
f 3188//2786 3170//2786 3169//2787 
f 3189//2787 3169//2787 3168//2788 
f 3166//2789 3190//2789 3191//2790 
f 3192//2791 3168//2788 3167//2790 
f 3167//2790 3191//2790 3192//2791 
f 3190//2789 3166//2789 3165//2792 
f 3193//2792 3165//2792 3164//2793 
f 3194//2793 3164//2793 3152//2794 
f 3195//2794 3152//2794 3151//2795 
f 3196//2795 3151//2795 3150//2796 
f 3197//2796 3150//2796 3163//2797 
f 3198//2797 3163//2797 3160//2798 
f 3199//2798 3160//2798 3159//2799 
f 3200//2799 3159//2799 3158//2800 
f 3201//2800 3158//2800 3157//2801 
f 3202//2801 3157//2801 3156//2802 
f 3203//2802 3156//2802 3174//2803 
f 3204//2803 3174//2803 3175//2804 
f 3205//2804 3175//2804 3173//2774 
f 3173//2774 3176//2774 3205//2804 
f 3175//2804 3205//2804 3204//2803 
f 3174//2803 3204//2803 3203//2802 
f 3156//2802 3203//2802 3202//2801 
f 3157//2801 3202//2801 3201//2800 
f 3158//2800 3201//2800 3200//2799 
f 3159//2799 3200//2799 3199//2798 
f 3160//2798 3199//2798 3198//2797 
f 3163//2797 3198//2797 3197//2796 
f 3150//2796 3197//2796 3196//2795 
f 3151//2795 3196//2795 3195//2794 
f 3152//2794 3195//2794 3194//2793 
f 3164//2793 3194//2793 3193//2792 
f 3165//2792 3193//2792 3190//2789 
f 3191//2790 3167//2790 3166//2789 
f 3168//2788 3192//2791 3189//2787 
f 3169//2787 3189//2787 3188//2786 
f 3170//2786 3188//2786 3187//2785 
f 3171//2785 3187//2785 3186//2784 
f 3146//2784 3186//2784 3185//2783 
f 3147//2783 3185//2783 3184//2782 
f 3148//2782 3184//2782 3183//2781 
f 3149//2781 3183//2781 3182//2780 
f 3153//2780 3182//2780 3181//2779 
f 3154//2779 3181//2779 3180//2778 
f 3155//2778 3180//2778 3179//2777 
f 3172//2777 3179//2777 3178//2776 
f 3161//2776 3178//2776 3177//2775 
f 3162//2775 3177//2775 3176//2774 
o mesh271
f 3180//2805 3181//2805 3135//2805 
f 3181//2805 3182//2805 3133//2805 
f 3192//2805 3191//2805 3117//2805 
f 3190//2805 3113//2805 3117//2805 
f 3179//2805 3180//2805 3137//2805 
f 3133//2805 3135//2805 3181//2805 
f 3192//2805 3116//2805 3120//2805 
f 3117//2805 3191//2805 3190//2805 
f 3196//2805 3105//2805 3107//2805 
f 3197//2805 3103//2805 3105//2805 
f 3135//2805 3137//2805 3180//2805 
f 3182//2805 3183//2805 3131//2805 
f 3184//2805 3129//2805 3131//2805 
f 3184//2805 3185//2805 3127//2805 
f 3188//2805 3121//2805 3123//2805 
f 3188//2805 3189//2805 3120//2805 
f 3117//2805 3116//2805 3192//2805 
f 3190//2805 3193//2805 3111//2805 
f 3105//2805 3196//2805 3197//2805 
f 3197//2805 3198//2805 3101//2805 
f 3200//2805 3097//2805 3099//2805 
f 3201//2805 3095//2805 3097//2805 
f 3202//2805 3093//2805 3095//2805 
f 3203//2805 3091//2805 3093//2805 
f 3178//2805 3141//2805 3143//2805 
f 3178//2805 3179//2805 3139//2805 
f 3131//2805 3133//2805 3182//2805 
f 3127//2805 3129//2805 3184//2805 
f 3186//2805 3125//2805 3127//2805 
f 3186//2805 3187//2805 3123//2805 
f 3120//2805 3121//2805 3188//2805 
f 3111//2805 3113//2805 3190//2805 
f 3194//2805 3109//2805 3111//2805 
f 3194//2805 3195//2805 3107//2805 
f 3101//2805 3103//2805 3197//2805 
f 3198//2805 3199//2805 3099//2805 
f 3097//2805 3200//2805 3201//2805 
f 3093//2805 3202//2805 3203//2805 
f 3177//2805 3143//2805 3087//2805 
f 3139//2805 3141//2805 3178//2805 
f 3131//2805 3183//2805 3184//2805 
f 3123//2805 3125//2805 3186//2805 
f 3120//2805 3189//2805 3192//2805 
f 3107//2805 3109//2805 3194//2805 
f 3099//2805 3101//2805 3198//2805 
f 3095//2805 3201//2805 3202//2805 
f 3143//2805 3177//2805 3178//2805 
f 3127//2805 3185//2805 3186//2805 
f 3111//2805 3193//2805 3194//2805 
f 3099//2805 3199//2805 3200//2805 
f 3204//2805 3089//2805 3091//2805 
f 3204//2805 3205//2805 3086//2805 
f 3137//2805 3139//2805 3179//2805 
f 3107//2805 3195//2805 3196//2805 
f 3086//2805 3089//2805 3204//2805 
f 3205//2805 3176//2805 3087//2805 
f 3123//2805 3187//2805 3188//2805 
f 3087//2805 3086//2805 3205//2805 
f 3091//2805 3203//2805 3204//2805 
f 3087//2805 3176//2805 3177//2805 
g nema17
v 0.0656008 0.0262604 0.0325733 
v 0.0654846 0.0267884 0.0325733 
v 0.0652576 0.027279 0.0325733 
v 0.0649305 0.0277094 0.0325733 
v 0.0645184 0.0280593 0.0325733 
v 0.0640408 0.0283125 0.0325733 
v 0.0635199 0.0284572 0.0325733 
v 0.0629801 0.0284864 0.0325733 
v 0.0624467 0.028399 0.0325733 
v 0.0619445 0.0281989 0.0325733 
v 0.061497 0.0278955 0.0325733 
v 0.0611252 0.027503 0.0325733 
v 0.0608465 0.0270398 0.0325733 
v 0.0606739 0.0265275 0.0325733 
v 0.0606155 0.0259901 0.0325733 
v 0.0606739 0.0254527 0.0325733 
v 0.0608465 0.0249404 0.0325733 
v 0.0611252 0.0244772 0.0325733 
v 0.061497 0.0240847 0.0325733 
v 0.0619445 0.0237813 0.0325733 
v 0.0624467 0.0235812 0.0325733 
v 0.0629801 0.0234938 0.0325733 
v 0.0635199 0.023523 0.0325733 
v 0.0640408 0.0236677 0.0325733 
v 0.0645184 0.0239209 0.0325733 
v 0.0649305 0.0242709 0.0325733 
v 0.0652576 0.0247012 0.0325733 
v 0.0654846 0.0251919 0.0325733 
v 0.0656008 0.0257198 0.0325733 
v 0.0656155 0.0259901 0.0325733 
v 0.0631155 0.0259901 0.0325733 
v 0.0606155 0.0259901 0.0105733 
v 0.0606739 0.0265275 0.0105733 
v 0.0608465 0.0270398 0.0105733 
v 0.0611252 0.027503 0.0105733 
v 0.061497 0.0278955 0.0105733 
v 0.0619445 0.0281989 0.0105733 
v 0.0624467 0.028399 0.0105733 
v 0.0629801 0.0284864 0.0105733 
v 0.0635199 0.0284572 0.0105733 
v 0.0640408 0.0283125 0.0105733 
v 0.0645184 0.0280593 0.0105733 
v 0.0649305 0.0277094 0.0105733 
v 0.0652576 0.027279 0.0105733 
v 0.0654846 0.0267884 0.0105733 
v 0.0656008 0.0257198 0.0105733 
v 0.0656155 0.0259901 0.0105733 
v 0.0656008 0.0262604 0.0105733 
v 0.0654846 0.0251919 0.0105733 
v 0.0652576 0.0247012 0.0105733 
v 0.0649305 0.0242709 0.0105733 
v 0.0645184 0.0239209 0.0105733 
v 0.0640408 0.0236677 0.0105733 
v 0.0635199 0.023523 0.0105733 
v 0.0629801 0.0234938 0.0105733 
v 0.0624467 0.0235812 0.0105733 
v 0.0619445 0.0237813 0.0105733 
v 0.061497 0.0240847 0.0105733 
v 0.0611252 0.0244772 0.0105733 
v 0.0608465 0.0249404 0.0105733 
v 0.0606739 0.0254527 0.0105733 
v 0.0741155 0.0259901 0.0105733 
v 0.074051 0.0271794 0.0105733 
v 0.0735397 0.0295024 0.0105733 
v 0.0531321 0.0306089 0.0105733 
v 0.0523726 0.0283548 0.0105733 
v 0.0521155 0.0259901 0.0105733 
v 0.0523726 0.0236254 0.0105733 
v 0.0725409 0.0316612 0.0105733 
v 0.0711014 0.0335548 0.0105733 
v 0.0692885 0.0350947 0.0105733 
v 0.0601727 0.0365892 0.0105733 
v 0.057963 0.0357087 0.0105733 
v 0.0559942 0.0343739 0.0105733 
v 0.0543585 0.032647 0.0105733 
v 0.057963 0.0162715 0.0105733 
v 0.0601727 0.0153911 0.0105733 
v 0.0648951 0.0368452 0.0105733 
v 0.0625199 0.036974 0.0105733 
v 0.0531321 0.0213713 0.0105733 
v 0.0543585 0.0193332 0.0105733 
v 0.0559942 0.0176063 0.0105733 
v 0.0625199 0.0150062 0.0105733 
v 0.0648951 0.015135 0.0105733 
v 0.067187 0.0157714 0.0105733 
v 0.067187 0.0362089 0.0105733 
v 0.0692885 0.0168855 0.0105733 
v 0.0711014 0.0184254 0.0105733 
v 0.0725409 0.020319 0.0105733 
v 0.0735397 0.0224778 0.0105733 
v 0.074051 0.0248008 0.0105733 
v 0.0521155 0.0259901 0.0085733 
v 0.0523726 0.0283548 0.0085733 
v 0.0531321 0.0306089 0.0085733 
v 0.0543585 0.032647 0.0085733 
v 0.0559942 0.0343739 0.0085733 
v 0.057963 0.0357087 0.0085733 
v 0.0601727 0.0365892 0.0085733 
v 0.0625199 0.036974 0.0085733 
v 0.0648951 0.0368452 0.0085733 
v 0.067187 0.0362089 0.0085733 
v 0.0692885 0.0350947 0.0085733 
v 0.0711014 0.0335548 0.0085733 
v 0.0725409 0.0316612 0.0085733 
v 0.0735397 0.0295024 0.0085733 
v 0.074051 0.0248008 0.0085733 
v 0.0741155 0.0259901 0.0085733 
v 0.074051 0.0271794 0.0085733 
v 0.0735397 0.0224778 0.0085733 
v 0.0725409 0.020319 0.0085733 
v 0.0711014 0.0184254 0.0085733 
v 0.0692885 0.0168855 0.0085733 
v 0.067187 0.0157714 0.0085733 
v 0.0648951 0.015135 0.0085733 
v 0.0625199 0.0150062 0.0085733 
v 0.0601727 0.0153911 0.0085733 
v 0.057963 0.0162715 0.0085733 
v 0.0559942 0.0176063 0.0085733 
v 0.0543585 0.0193332 0.0085733 
v 0.0531321 0.0213713 0.0085733 
v 0.0523726 0.0236254 0.0085733 
v 0.0419655 0.0414901 0.0085733 
v 0.0456272 0.0412739 0.0085733 
v 0.0456272 0.0417063 0.0085733 
v 0.0508655 0.0471401 0.0085733 
v 0.0485523 0.0432571 0.0085733 
v 0.0489102 0.0430144 0.0085733 
v 0.0457202 0.0421287 0.0085733 
v 0.0459018 0.0425212 0.0085733 
v 0.0457202 0.0408515 0.0085733 
v 0.0419655 0.0137401 0.0085733 
v 0.0461635 0.0401147 0.0085733 
v 0.0459018 0.040459 0.0085733 
v 0.0492077 0.0427005 0.0085733 
v 0.0476155 0.0471401 0.0085733 
v 0.0464931 0.0431455 0.0085733 
v 0.0468752 0.0433481 0.0085733 
v 0.0461635 0.0428655 0.0085733 
v 0.0494306 0.0423299 0.0085733 
v 0.0495687 0.04192 0.0085733 
v 0.0481505 0.0434172 0.0085733 
v 0.0477238 0.0434872 0.0085733 
v 0.0472919 0.0395165 0.0085733 
v 0.0468752 0.0396322 0.0085733 
v 0.0472919 0.0434638 0.0085733 
v 0.0464931 0.0398347 0.0085733 
v 0.0496155 0.0414901 0.0085733 
v 0.0477238 0.039493 0.0085733 
v 0.0492077 0.0402798 0.0085733 
v 0.0489102 0.0399658 0.0085733 
v 0.0495687 0.0410602 0.0085733 
v 0.0481505 0.039563 0.0085733 
v 0.0485523 0.0397231 0.0085733 
v 0.0494306 0.0406503 0.0085733 
v 0.0477162 0.00484011 0.0085733 
v 0.0508655 0.00484011 0.0085733 
v 0.0481505 0.00856301 0.0085733 
v 0.0477238 0.00849304 0.0085733 
v 0.0461635 0.0118655 0.0085733 
v 0.0464931 0.0121455 0.0085733 
v 0.0419655 0.0104901 0.0085733 
v 0.0456272 0.0107063 0.0085733 
v 0.0457202 0.0111287 0.0085733 
v 0.0464931 0.00883473 0.0085733 
v 0.0461635 0.00911471 0.0085733 
v 0.0472919 0.00851645 0.0085733 
v 0.0477238 0.0124872 0.0085733 
v 0.0481505 0.0124172 0.0085733 
v 0.0472919 0.0124638 0.0085733 
v 0.0468752 0.0123481 0.0085733 
v 0.0456272 0.0102739 0.0085733 
v 0.0468752 0.00863215 0.0085733 
v 0.0496155 0.0104901 0.0085733 
v 0.0489102 0.0120144 0.0085733 
v 0.0492077 0.0117005 0.0085733 
v 0.0459018 0.0115212 0.0085733 
v 0.0457202 0.0098515 0.0085733 
v 0.0459018 0.009459 0.0085733 
v 0.0485523 0.00872308 0.0085733 
v 0.0495687 0.0100602 0.0085733 
v 0.0485523 0.0122571 0.0085733 
v 0.0492077 0.00927976 0.0085733 
v 0.0489102 0.00896578 0.0085733 
v 0.0494306 0.00965033 0.0085733 
v 0.0494306 0.0113299 0.0085733 
v 0.0495687 0.01092 0.0085733 
v 0.0842655 0.0137401 0.0085733 
v 0.0799102 0.0120144 0.0085733 
v 0.0802077 0.0117005 0.0085733 
v 0.0795523 0.0122571 0.0085733 
v 0.0791505 0.0124172 0.0085733 
v 0.0787238 0.0124872 0.0085733 
v 0.0782919 0.0124638 0.0085733 
v 0.0842655 0.0104901 0.0085733 
v 0.0802077 0.00927976 0.0085733 
v 0.0799102 0.00896578 0.0085733 
v 0.0774931 0.0121455 0.0085733 
v 0.0778752 0.0123481 0.0085733 
v 0.0769018 0.0115212 0.0085733 
v 0.0771635 0.0118655 0.0085733 
v 0.0766272 0.0102739 0.0085733 
v 0.0786155 0.00484011 0.0085733 
v 0.0778752 0.00863215 0.0085733 
v 0.0774931 0.00883473 0.0085733 
v 0.0767202 0.0111287 0.0085733 
v 0.0766272 0.0107063 0.0085733 
v 0.0782919 0.00851645 0.0085733 
v 0.0791505 0.00856301 0.0085733 
v 0.0787238 0.00849304 0.0085733 
v 0.0804306 0.00965033 0.0085733 
v 0.0804306 0.0113299 0.0085733 
v 0.0805687 0.01092 0.0085733 
v 0.0767202 0.0098515 0.0085733 
v 0.0771635 0.00911471 0.0085733 
v 0.0795523 0.00872308 0.0085733 
v 0.0769018 0.009459 0.0085733 
v 0.0806155 0.0104901 0.0085733 
v 0.0805687 0.0100602 0.0085733 
v 0.0766272 0.0417063 0.0085733 
v 0.0766272 0.0412739 0.0085733 
v 0.0802077 0.0402798 0.0085733 
v 0.0769018 0.040459 0.0085733 
v 0.0795523 0.0397231 0.0085733 
v 0.0791505 0.039563 0.0085733 
v 0.0799102 0.0399658 0.0085733 
v 0.0786155 0.0471401 0.0085733 
v 0.0774931 0.0431455 0.0085733 
v 0.0769018 0.0425212 0.0085733 
v 0.0771635 0.0428655 0.0085733 
v 0.0767202 0.0408515 0.0085733 
v 0.0774931 0.0398347 0.0085733 
v 0.0771635 0.0401147 0.0085733 
v 0.0782919 0.0395165 0.0085733 
v 0.0778752 0.0396322 0.0085733 
v 0.0842655 0.0415541 0.0085733 
v 0.0799102 0.0430144 0.0085733 
v 0.0778752 0.0433481 0.0085733 
v 0.0767202 0.0421287 0.0085733 
v 0.0787238 0.039493 0.0085733 
v 0.0804306 0.0423299 0.0085733 
v 0.0805687 0.04192 0.0085733 
v 0.0795523 0.0432571 0.0085733 
v 0.0782919 0.0434638 0.0085733 
v 0.0787238 0.0434872 0.0085733 
v 0.0802077 0.0427005 0.0085733 
v 0.0791505 0.0434172 0.0085733 
v 0.0804306 0.0406503 0.0085733 
v 0.0806155 0.0414901 0.0085733 
v 0.0805687 0.0410602 0.0085733 
v 0.0508655 0.0137401 0.0085733 
v 0.0786155 0.0471401 -0.0384267 
v 0.0508655 0.0471401 -0.0384267 
v 0.0476155 0.0471401 -0.0384267 
v 0.0419655 0.0414901 -0.0384267 
v 0.0419655 0.0137401 -0.0384267 
v 0.0419655 0.0104901 -0.0384267 
v 0.0477162 0.00484011 -0.0384267 
v 0.0508655 0.00484011 -0.0384267 
v 0.0786155 0.00484011 -0.0384267 
v 0.0842655 0.0104901 -0.0384267 
v 0.0842655 0.0137401 -0.0384267 
v 0.0842655 0.0415541 -0.0384267 
v 0.0496155 0.0414901 -0.0384267 
v 0.0495687 0.0410602 -0.0384267 
v 0.0494306 0.0406503 -0.0384267 
v 0.0492077 0.0402798 -0.0384267 
v 0.0489102 0.0399658 -0.0384267 
v 0.0485523 0.0397231 -0.0384267 
v 0.0481505 0.039563 -0.0384267 
v 0.0477238 0.039493 -0.0384267 
v 0.0472919 0.0395165 -0.0384267 
v 0.0468752 0.0396322 -0.0384267 
v 0.0464931 0.0398347 -0.0384267 
v 0.0461635 0.0401147 -0.0384267 
v 0.0459018 0.040459 -0.0384267 
v 0.0457202 0.0408515 -0.0384267 
v 0.0456272 0.0412739 -0.0384267 
v 0.0456272 0.0417063 -0.0384267 
v 0.0457202 0.0421287 -0.0384267 
v 0.0459018 0.0425212 -0.0384267 
v 0.0461635 0.0428655 -0.0384267 
v 0.0464931 0.0431455 -0.0384267 
v 0.0468752 0.0433481 -0.0384267 
v 0.0472919 0.0434638 -0.0384267 
v 0.0477238 0.0434872 -0.0384267 
v 0.0481505 0.0434172 -0.0384267 
v 0.0485523 0.0432571 -0.0384267 
v 0.0489102 0.0430144 -0.0384267 
v 0.0492077 0.0427005 -0.0384267 
v 0.0494306 0.0423299 -0.0384267 
v 0.0495687 0.04192 -0.0384267 
v 0.0496155 0.0104901 -0.0384267 
v 0.0495687 0.0100602 -0.0384267 
v 0.0494306 0.00965033 -0.0384267 
v 0.0492077 0.00927976 -0.0384267 
v 0.0489102 0.00896578 -0.0384267 
v 0.0485523 0.00872308 -0.0384267 
v 0.0481505 0.00856301 -0.0384267 
v 0.0477238 0.00849304 -0.0384267 
v 0.0472919 0.00851645 -0.0384267 
v 0.0468752 0.00863215 -0.0384267 
v 0.0464931 0.00883473 -0.0384267 
v 0.0461635 0.00911471 -0.0384267 
v 0.0459018 0.009459 -0.0384267 
v 0.0457202 0.0098515 -0.0384267 
v 0.0456272 0.0102739 -0.0384267 
v 0.0456272 0.0107063 -0.0384267 
v 0.0457202 0.0111287 -0.0384267 
v 0.0459018 0.0115212 -0.0384267 
v 0.0461635 0.0118655 -0.0384267 
v 0.0464931 0.0121455 -0.0384267 
v 0.0468752 0.0123481 -0.0384267 
v 0.0472919 0.0124638 -0.0384267 
v 0.0477238 0.0124872 -0.0384267 
v 0.0481505 0.0124172 -0.0384267 
v 0.0485523 0.0122571 -0.0384267 
v 0.0489102 0.0120144 -0.0384267 
v 0.0492077 0.0117005 -0.0384267 
v 0.0494306 0.0113299 -0.0384267 
v 0.0495687 0.01092 -0.0384267 
v 0.0806155 0.0104901 -0.0384267 
v 0.0805687 0.0100602 -0.0384267 
v 0.0804306 0.00965033 -0.0384267 
v 0.0802077 0.00927976 -0.0384267 
v 0.0799102 0.00896578 -0.0384267 
v 0.0795523 0.00872308 -0.0384267 
v 0.0791505 0.00856301 -0.0384267 
v 0.0787238 0.00849304 -0.0384267 
v 0.0782919 0.00851645 -0.0384267 
v 0.0778752 0.00863215 -0.0384267 
v 0.0774931 0.00883473 -0.0384267 
v 0.0771635 0.00911471 -0.0384267 
v 0.0769018 0.009459 -0.0384267 
v 0.0767202 0.0098515 -0.0384267 
v 0.0766272 0.0102739 -0.0384267 
v 0.0766272 0.0107063 -0.0384267 
v 0.0767202 0.0111287 -0.0384267 
v 0.0769018 0.0115212 -0.0384267 
v 0.0771635 0.0118655 -0.0384267 
v 0.0774931 0.0121455 -0.0384267 
v 0.0778752 0.0123481 -0.0384267 
v 0.0782919 0.0124638 -0.0384267 
v 0.0787238 0.0124872 -0.0384267 
v 0.0791505 0.0124172 -0.0384267 
v 0.0795523 0.0122571 -0.0384267 
v 0.0799102 0.0120144 -0.0384267 
v 0.0802077 0.0117005 -0.0384267 
v 0.0804306 0.0113299 -0.0384267 
v 0.0805687 0.01092 -0.0384267 
v 0.0806155 0.0414901 -0.0384267 
v 0.0805687 0.0410602 -0.0384267 
v 0.0804306 0.0406503 -0.0384267 
v 0.0802077 0.0402798 -0.0384267 
v 0.0799102 0.0399658 -0.0384267 
v 0.0795523 0.0397231 -0.0384267 
v 0.0791505 0.039563 -0.0384267 
v 0.0787238 0.039493 -0.0384267 
v 0.0782919 0.0395165 -0.0384267 
v 0.0778752 0.0396322 -0.0384267 
v 0.0774931 0.0398347 -0.0384267 
v 0.0771635 0.0401147 -0.0384267 
v 0.0769018 0.040459 -0.0384267 
v 0.0767202 0.0408515 -0.0384267 
v 0.0766272 0.0412739 -0.0384267 
v 0.0766272 0.0417063 -0.0384267 
v 0.0767202 0.0421287 -0.0384267 
v 0.0769018 0.0425212 -0.0384267 
v 0.0771635 0.0428655 -0.0384267 
v 0.0774931 0.0431455 -0.0384267 
v 0.0778752 0.0433481 -0.0384267 
v 0.0782919 0.0434638 -0.0384267 
v 0.0787238 0.0434872 -0.0384267 
v 0.0791505 0.0434172 -0.0384267 
v 0.0795523 0.0432571 -0.0384267 
v 0.0799102 0.0430144 -0.0384267 
v 0.0802077 0.0427005 -0.0384267 
v 0.0804306 0.0423299 -0.0384267 
v 0.0805687 0.04192 -0.0384267 
v 0.063711 0.0150062 -0.0384267 
v 0.0660583 0.0153911 -0.0384267 
v 0.0613359 0.015135 -0.0384267 
v 0.0730988 0.0306089 -0.0384267 
v 0.0718725 0.032647 -0.0384267 
v 0.068268 0.0357087 -0.0384267 
v 0.059044 0.0362089 -0.0384267 
v 0.0738583 0.0236254 -0.0384267 
v 0.068268 0.0162715 -0.0384267 
v 0.0702367 0.0176063 -0.0384267 
v 0.059044 0.0157714 -0.0384267 
v 0.0551295 0.0184254 -0.0384267 
v 0.0569424 0.0168855 -0.0384267 
v 0.0526913 0.0224778 -0.0384267 
v 0.05369 0.020319 -0.0384267 
v 0.0702367 0.0343739 -0.0384267 
v 0.0660583 0.0365892 -0.0384267 
v 0.0551295 0.0335548 -0.0384267 
v 0.05369 0.0316612 -0.0384267 
v 0.0730988 0.0213713 -0.0384267 
v 0.05218 0.0271794 -0.0384267 
v 0.0738583 0.0283548 -0.0384267 
v 0.0741155 0.0259901 -0.0384267 
v 0.063711 0.036974 -0.0384267 
v 0.0613359 0.0368452 -0.0384267 
v 0.0526913 0.0295024 -0.0384267 
v 0.0569424 0.0350947 -0.0384267 
v 0.05218 0.0248008 -0.0384267 
v 0.0718725 0.0193332 -0.0384267 
v 0.0508655 0.0137401 -0.0384267 
v 0.0738583 0.0236254 -0.0364267 
v 0.0741155 0.0259901 -0.0364267 
v 0.0730988 0.0213713 -0.0364267 
v 0.0718725 0.0193332 -0.0364267 
v 0.0702367 0.0176063 -0.0364267 
v 0.068268 0.0162715 -0.0364267 
v 0.0660583 0.0153911 -0.0364267 
v 0.063711 0.0150062 -0.0364267 
v 0.0613359 0.015135 -0.0364267 
v 0.059044 0.0157714 -0.0364267 
v 0.0569424 0.0168855 -0.0364267 
v 0.0551295 0.0184254 -0.0364267 
v 0.05369 0.020319 -0.0364267 
v 0.0526913 0.0224778 -0.0364267 
v 0.05218 0.0248008 -0.0364267 
v 0.05218 0.0271794 -0.0364267 
v 0.0526913 0.0295024 -0.0364267 
v 0.05369 0.0316612 -0.0364267 
v 0.0551295 0.0335548 -0.0364267 
v 0.0569424 0.0350947 -0.0364267 
v 0.059044 0.0362089 -0.0364267 
v 0.0613359 0.0368452 -0.0364267 
v 0.063711 0.036974 -0.0364267 
v 0.0660583 0.0365892 -0.0364267 
v 0.068268 0.0357087 -0.0364267 
v 0.0702367 0.0343739 -0.0364267 
v 0.0718725 0.032647 -0.0364267 
v 0.0730988 0.0306089 -0.0364267 
v 0.0738583 0.0283548 -0.0364267 
v 0.0653844 0.0270398 -0.0364267 
v 0.0651057 0.027503 -0.0364267 
v 0.065557 0.0265275 -0.0364267 
v 0.0656155 0.0259901 -0.0364267 
v 0.065557 0.0254527 -0.0364267 
v 0.0607463 0.0267884 -0.0364267 
v 0.0606301 0.0262604 -0.0364267 
v 0.0609733 0.027279 -0.0364267 
v 0.0613005 0.0277094 -0.0364267 
v 0.0617125 0.0280593 -0.0364267 
v 0.0637843 0.028399 -0.0364267 
v 0.0632508 0.0284864 -0.0364267 
v 0.0642865 0.0281989 -0.0364267 
v 0.0647339 0.0278955 -0.0364267 
v 0.0642865 0.0237813 -0.0364267 
v 0.0647339 0.0240847 -0.0364267 
v 0.0637843 0.0235812 -0.0364267 
v 0.062711 0.0284572 -0.0364267 
v 0.0621901 0.0283125 -0.0364267 
v 0.0653844 0.0249404 -0.0364267 
v 0.0651057 0.0244772 -0.0364267 
v 0.0632508 0.0234938 -0.0364267 
v 0.062711 0.023523 -0.0364267 
v 0.0621901 0.0236677 -0.0364267 
v 0.0617125 0.0239209 -0.0364267 
v 0.0613005 0.0242709 -0.0364267 
v 0.0609733 0.0247012 -0.0364267 
v 0.0607463 0.0251919 -0.0364267 
v 0.0606301 0.0257198 -0.0364267 
v 0.065557 0.0254527 0.0085733 
v 0.0656155 0.0259901 0.0085733 
v 0.0653844 0.0249404 0.0085733 
v 0.0651057 0.0244772 0.0085733 
v 0.0647339 0.0240847 0.0085733 
v 0.0642865 0.0237813 0.0085733 
v 0.0637843 0.0235812 0.0085733 
v 0.0632508 0.0234938 0.0085733 
v 0.062711 0.023523 0.0085733 
v 0.0621901 0.0236677 0.0085733 
v 0.0617125 0.0239209 0.0085733 
v 0.0613005 0.0242709 0.0085733 
v 0.0609733 0.0247012 0.0085733 
v 0.0607463 0.0251919 0.0085733 
v 0.0606301 0.0257198 0.0085733 
v 0.0606301 0.0262604 0.0085733 
v 0.0607463 0.0267884 0.0085733 
v 0.0609733 0.027279 0.0085733 
v 0.0613005 0.0277094 0.0085733 
v 0.0617125 0.0280593 0.0085733 
v 0.0621901 0.0283125 0.0085733 
v 0.062711 0.0284572 0.0085733 
v 0.0632508 0.0284864 0.0085733 
v 0.0637843 0.028399 0.0085733 
v 0.0642865 0.0281989 0.0085733 
v 0.0647339 0.0278955 0.0085733 
v 0.0651057 0.027503 0.0085733 
v 0.0653844 0.0270398 0.0085733 
v 0.065557 0.0265275 0.0085733 
v 0.0631155 0.0259901 0.0085733 
vn 0.0415723 0.00479476 0.999124 
vn -0.999947 0.00505185 0.00894837 
vn -0.973404 0.228923 0.00892872 
vn -0.897717 0.440483 0.00889129 
vn -0.777451 0.628881 0.00883845 
vn -0.619553 0.784906 0.00877342 
vn -0.432743 0.901476 0.00869995 
vn -0.226845 0.973893 0.00862201 
vn -0.0121312 0.99989 0.00854353 
vn 0.201248 0.979504 0.00846814 
vn 0.403729 0.91484 0.00839907 
vn 0.586672 0.809781 0.00833904 
vn 0.742607 0.669676 0.00829026 
vn 0.865387 0.501036 0.00825438 
vn 0.950289 0.31126 0.00823258 
vn 0.994076 0.108377 0.00822554 
vn 0.995035 -0.0991852 0.00823347 
vn 0.999955 0.00464496 0.00822764 
vn 0.994076 0.108377 0.00822554 
vn 0.995035 -0.0991852 0.00823347 
vn 0.953009 -0.302828 0.00825614 
vn 0.869419 -0.494006 0.00829283 
vn 0.747273 -0.664464 0.00834235 
vn 0.591171 -0.806503 0.00840299 
vn 0.407259 -0.913273 0.00847252 
vn 0.203151 -0.97911 0.00854819 
vn -0.0122493 -0.999888 0.00862674 
vn -0.229015 -0.973384 0.00870452 
vn -0.436605 -0.89961 0.0087776 
vn -0.624396 -0.781058 0.008842 
vn -0.782338 -0.622791 0.008894 
vn -0.901667 -0.432338 0.00893042 
vn -0.975608 -0.219337 0.00894895 
vn 0.0415723 0.00479476 0.999124 
vn -0.999947 0.00505185 0.00894837 
vn -0.973404 0.228923 0.00892872 
vn -0.897717 0.440483 0.00889129 
vn -0.777451 0.628881 0.00883845 
vn -0.619553 0.784906 0.00877342 
vn -0.432743 0.901476 0.00869995 
vn -0.226845 0.973893 0.00862201 
vn -0.0121312 0.99989 0.00854353 
vn 0.201248 0.979504 0.00846814 
vn 0.403729 0.91484 0.00839907 
vn 0.586672 0.809781 0.00833904 
vn 0.742607 0.669676 0.00829026 
vn 0.865387 0.501036 0.00825438 
vn 0.950289 0.31126 0.00823258 
vn 0.994076 0.108377 0.00822554 
vn 0.995035 -0.0991852 0.00823347 
vn 0.999955 0.00464496 0.00822764 
vn 0.994076 0.108377 0.00822554 
vn 0.953009 -0.302828 0.00825614 
vn 0.869419 -0.494006 0.00829283 
vn 0.747273 -0.664464 0.00834235 
vn 0.591171 -0.806503 0.00840299 
vn 0.407259 -0.913273 0.00847252 
vn 0.203151 -0.97911 0.00854819 
vn -0.0122493 -0.999888 0.00862674 
vn -0.229015 -0.973384 0.00870452 
vn -0.436605 -0.89961 0.0087776 
vn -0.624396 -0.781058 0.008842 
vn -0.782338 -0.622791 0.008894 
vn -0.901667 -0.432338 0.00893042 
vn -0.975608 -0.219337 0.00894895 
vn 0.0415723 0.00479476 0.999124 
vn 0.0417254 0.999093 0.00852426 
vn -0.682652 0.73069 0.00879901 
vn -0.999947 0.00505185 0.00894837 
vn -0.680971 -0.732257 0.00886093 
vn 0.0421306 -0.999075 0.00860703 
vn 0.729506 -0.683923 0.00834936 
vn 0.999955 0.00464496 0.00822764 
vn 0.721008 0.692877 0.00829684 
vn -0.973404 0.228923 0.00892872 
vn -0.999947 0.00505185 0.00894837 
vn -0.897717 0.440483 0.00889129 
vn -0.973404 0.228923 0.00892872 
vn -0.777451 0.628881 0.00883845 
vn -0.897717 0.440483 0.00889129 
vn -0.619553 0.784906 0.00877342 
vn -0.777451 0.628881 0.00883845 
vn -0.432743 0.901476 0.00869995 
vn -0.619553 0.784906 0.00877342 
vn -0.226845 0.973893 0.00862201 
vn -0.432743 0.901476 0.00869995 
vn -0.0121312 0.99989 0.00854353 
vn -0.226845 0.973893 0.00862201 
vn 0.201248 0.979504 0.00846814 
vn -0.0121312 0.99989 0.00854353 
vn 0.403729 0.91484 0.00839907 
vn 0.201248 0.979504 0.00846814 
vn 0.586672 0.809781 0.00833904 
vn 0.403729 0.91484 0.00839907 
vn 0.742607 0.669676 0.00829026 
vn 0.586672 0.809781 0.00833904 
vn 0.865387 0.501036 0.00825438 
vn 0.742607 0.669676 0.00829026 
vn 0.950289 0.31126 0.00823258 
vn 0.865387 0.501036 0.00825438 
vn 0.994076 0.108377 0.00822554 
vn 0.950289 0.31126 0.00823258 
vn 0.995035 -0.0991852 0.00823347 
vn 0.994076 0.108377 0.00822554 
vn 0.953009 -0.302828 0.00825614 
vn 0.995035 -0.0991852 0.00823347 
vn 0.869419 -0.494006 0.00829283 
vn 0.953009 -0.302828 0.00825614 
vn 0.747273 -0.664464 0.00834235 
vn 0.869419 -0.494006 0.00829283 
vn 0.591171 -0.806503 0.00840299 
vn 0.747273 -0.664464 0.00834235 
vn 0.407259 -0.913273 0.00847252 
vn 0.591171 -0.806503 0.00840299 
vn 0.203151 -0.97911 0.00854819 
vn 0.407259 -0.913273 0.00847252 
vn -0.0122493 -0.999888 0.00862674 
vn 0.203151 -0.97911 0.00854819 
vn -0.229015 -0.973384 0.00870452 
vn -0.0122493 -0.999888 0.00862674 
vn -0.436605 -0.89961 0.0087776 
vn -0.229015 -0.973384 0.00870452 
vn -0.624396 -0.781058 0.008842 
vn -0.436605 -0.89961 0.0087776 
vn -0.782338 -0.622791 0.008894 
vn -0.624396 -0.781058 0.008842 
vn -0.901667 -0.432338 0.00893042 
vn -0.782338 -0.622791 0.008894 
vn -0.975608 -0.219337 0.00894895 
vn -0.901667 -0.432338 0.00893042 
vn -0.973404 0.228923 0.00892872 
vn -0.999947 0.00505185 0.00894837 
vn -0.897717 0.440483 0.00889129 
vn -0.973404 0.228923 0.00892872 
vn -0.777451 0.628881 0.00883845 
vn -0.897717 0.440483 0.00889129 
vn -0.619553 0.784906 0.00877342 
vn -0.777451 0.628881 0.00883845 
vn -0.432743 0.901476 0.00869995 
vn -0.619553 0.784906 0.00877342 
vn -0.226845 0.973893 0.00862201 
vn -0.432743 0.901476 0.00869995 
vn -0.0121312 0.99989 0.00854353 
vn -0.226845 0.973893 0.00862201 
vn 0.201248 0.979504 0.00846814 
vn -0.0121312 0.99989 0.00854353 
vn 0.403729 0.91484 0.00839907 
vn 0.201248 0.979504 0.00846814 
vn 0.586672 0.809781 0.00833904 
vn 0.403729 0.91484 0.00839907 
vn 0.742607 0.669676 0.00829026 
vn 0.586672 0.809781 0.00833904 
vn 0.865387 0.501036 0.00825438 
vn 0.742607 0.669676 0.00829026 
vn 0.950289 0.31126 0.00823258 
vn 0.865387 0.501036 0.00825438 
vn 0.994076 0.108377 0.00822554 
vn 0.950289 0.31126 0.00823258 
vn 0.995035 -0.0991852 0.00823347 
vn 0.994076 0.108377 0.00822554 
vn 0.953009 -0.302828 0.00825614 
vn 0.995035 -0.0991852 0.00823347 
vn 0.869419 -0.494006 0.00829283 
vn 0.953009 -0.302828 0.00825614 
vn 0.747273 -0.664464 0.00834235 
vn 0.869419 -0.494006 0.00829283 
vn 0.591171 -0.806503 0.00840299 
vn 0.747273 -0.664464 0.00834235 
vn 0.407259 -0.913273 0.00847252 
vn 0.591171 -0.806503 0.00840299 
vn 0.203151 -0.97911 0.00854819 
vn 0.407259 -0.913273 0.00847252 
vn -0.0122493 -0.999888 0.00862674 
vn 0.203151 -0.97911 0.00854819 
vn -0.229015 -0.973384 0.00870452 
vn -0.0122493 -0.999888 0.00862674 
vn -0.436605 -0.89961 0.0087776 
vn -0.229015 -0.973384 0.00870452 
vn -0.624396 -0.781058 0.008842 
vn -0.436605 -0.89961 0.0087776 
vn -0.782338 -0.622791 0.008894 
vn -0.624396 -0.781058 0.008842 
vn -0.901667 -0.432338 0.00893042 
vn -0.782338 -0.622791 0.008894 
vn -0.975608 -0.219337 0.00894895 
vn -0.901667 -0.432338 0.00893042 
vn -0.973404 0.228923 0.00892872 
vn -0.999947 0.00505185 0.00894837 
vn -0.897717 0.440483 0.00889129 
vn -0.973404 0.228923 0.00892872 
vn -0.777451 0.628881 0.00883845 
vn -0.897717 0.440483 0.00889129 
vn -0.619553 0.784906 0.00877342 
vn -0.777451 0.628881 0.00883845 
vn -0.432743 0.901476 0.00869995 
vn -0.619553 0.784906 0.00877342 
vn -0.226845 0.973893 0.00862201 
vn -0.432743 0.901476 0.00869995 
vn -0.0121312 0.99989 0.00854353 
vn -0.226845 0.973893 0.00862201 
vn 0.201248 0.979504 0.00846814 
vn -0.0121312 0.99989 0.00854353 
vn 0.403729 0.91484 0.00839907 
vn 0.201248 0.979504 0.00846814 
vn 0.586672 0.809781 0.00833904 
vn 0.403729 0.91484 0.00839907 
vn 0.742607 0.669676 0.00829026 
vn 0.586672 0.809781 0.00833904 
vn 0.865387 0.501036 0.00825438 
vn 0.742607 0.669676 0.00829026 
vn 0.950289 0.31126 0.00823258 
vn 0.865387 0.501036 0.00825438 
vn 0.994076 0.108377 0.00822554 
vn 0.950289 0.31126 0.00823258 
vn 0.995035 -0.0991852 0.00823347 
vn 0.994076 0.108377 0.00822554 
vn 0.953009 -0.302828 0.00825614 
vn 0.995035 -0.0991852 0.00823347 
vn 0.869419 -0.494006 0.00829283 
vn 0.953009 -0.302828 0.00825614 
vn 0.747273 -0.664464 0.00834235 
vn 0.869419 -0.494006 0.00829283 
vn 0.591171 -0.806503 0.00840299 
vn 0.747273 -0.664464 0.00834235 
vn 0.407259 -0.913273 0.00847252 
vn 0.591171 -0.806503 0.00840299 
vn 0.203151 -0.97911 0.00854819 
vn 0.407259 -0.913273 0.00847252 
vn -0.0122493 -0.999888 0.00862674 
vn 0.203151 -0.97911 0.00854819 
vn -0.229015 -0.973384 0.00870452 
vn -0.0122493 -0.999888 0.00862674 
vn -0.436605 -0.89961 0.0087776 
vn -0.229015 -0.973384 0.00870452 
vn -0.624396 -0.781058 0.008842 
vn -0.436605 -0.89961 0.0087776 
vn -0.782338 -0.622791 0.008894 
vn -0.624396 -0.781058 0.008842 
vn -0.901667 -0.432338 0.00893042 
vn -0.782338 -0.622791 0.008894 
vn -0.975608 -0.219337 0.00894895 
vn -0.901667 -0.432338 0.00893042 
vn -0.973404 0.228923 0.00892872 
vn -0.999947 0.00505185 0.00894837 
vn -0.897717 0.440483 0.00889129 
vn -0.973404 0.228923 0.00892872 
vn -0.777451 0.628881 0.00883845 
vn -0.897717 0.440483 0.00889129 
vn -0.619553 0.784906 0.00877342 
vn -0.777451 0.628881 0.00883845 
vn -0.432743 0.901476 0.00869995 
vn -0.619553 0.784906 0.00877342 
vn -0.226845 0.973893 0.00862201 
vn -0.432743 0.901476 0.00869995 
vn -0.0121312 0.99989 0.00854353 
vn -0.226845 0.973893 0.00862201 
vn 0.201248 0.979504 0.00846814 
vn -0.0121312 0.99989 0.00854353 
vn 0.403729 0.91484 0.00839907 
vn 0.201248 0.979504 0.00846814 
vn 0.586672 0.809781 0.00833904 
vn 0.403729 0.91484 0.00839907 
vn 0.742607 0.669676 0.00829026 
vn 0.586672 0.809781 0.00833904 
vn 0.865387 0.501036 0.00825438 
vn 0.742607 0.669676 0.00829026 
vn 0.950289 0.31126 0.00823258 
vn 0.865387 0.501036 0.00825438 
vn 0.994076 0.108377 0.00822554 
vn 0.950289 0.31126 0.00823258 
vn 0.995035 -0.0991852 0.00823347 
vn 0.994076 0.108377 0.00822554 
vn 0.953009 -0.302828 0.00825614 
vn 0.995035 -0.0991852 0.00823347 
vn 0.869419 -0.494006 0.00829283 
vn 0.953009 -0.302828 0.00825614 
vn 0.747273 -0.664464 0.00834235 
vn 0.869419 -0.494006 0.00829283 
vn 0.591171 -0.806503 0.00840299 
vn 0.747273 -0.664464 0.00834235 
vn 0.407259 -0.913273 0.00847252 
vn 0.591171 -0.806503 0.00840299 
vn 0.203151 -0.97911 0.00854819 
vn 0.407259 -0.913273 0.00847252 
vn -0.0122493 -0.999888 0.00862674 
vn 0.203151 -0.97911 0.00854819 
vn -0.229015 -0.973384 0.00870452 
vn -0.0122493 -0.999888 0.00862674 
vn -0.436605 -0.89961 0.0087776 
vn -0.229015 -0.973384 0.00870452 
vn -0.624396 -0.781058 0.008842 
vn -0.436605 -0.89961 0.0087776 
vn -0.782338 -0.622791 0.008894 
vn -0.624396 -0.781058 0.008842 
vn -0.901667 -0.432338 0.00893042 
vn -0.782338 -0.622791 0.008894 
vn -0.975608 -0.219337 0.00894895 
vn -0.901667 -0.432338 0.00893042 
vn 0.04229 0.00487754 -0.999093 
vn -0.973404 0.228923 0.00892872 
vn -0.999947 0.00505185 0.00894837 
vn -0.897717 0.440483 0.00889129 
vn -0.973404 0.228923 0.00892872 
vn -0.777451 0.628881 0.00883845 
vn -0.897717 0.440483 0.00889129 
vn -0.619553 0.784906 0.00877342 
vn -0.777451 0.628881 0.00883845 
vn -0.432743 0.901476 0.00869995 
vn -0.619553 0.784906 0.00877342 
vn -0.226845 0.973893 0.00862201 
vn -0.432743 0.901476 0.00869995 
vn -0.0121312 0.99989 0.00854353 
vn -0.226845 0.973893 0.00862201 
vn 0.201248 0.979504 0.00846814 
vn -0.0121312 0.99989 0.00854353 
vn 0.403729 0.91484 0.00839907 
vn 0.201248 0.979504 0.00846814 
vn 0.586672 0.809781 0.00833904 
vn 0.403729 0.91484 0.00839907 
vn 0.742607 0.669676 0.00829026 
vn 0.586672 0.809781 0.00833904 
vn 0.865387 0.501036 0.00825438 
vn 0.742607 0.669676 0.00829026 
vn 0.950289 0.31126 0.00823258 
vn 0.865387 0.501036 0.00825438 
vn 0.994076 0.108377 0.00822554 
vn 0.950289 0.31126 0.00823258 
vn 0.995035 -0.0991852 0.00823347 
vn 0.994076 0.108377 0.00822554 
vn 0.953009 -0.302828 0.00825614 
vn 0.995035 -0.0991852 0.00823347 
vn 0.869419 -0.494006 0.00829283 
vn 0.953009 -0.302828 0.00825614 
vn 0.747273 -0.664464 0.00834235 
vn 0.869419 -0.494006 0.00829283 
vn 0.591171 -0.806503 0.00840299 
vn 0.747273 -0.664464 0.00834235 
vn 0.407259 -0.913273 0.00847252 
vn 0.591171 -0.806503 0.00840299 
vn 0.203151 -0.97911 0.00854819 
vn 0.407259 -0.913273 0.00847252 
vn -0.0122493 -0.999888 0.00862674 
vn 0.203151 -0.97911 0.00854819 
vn -0.229015 -0.973384 0.00870452 
vn -0.0122493 -0.999888 0.00862674 
vn -0.436605 -0.89961 0.0087776 
vn -0.229015 -0.973384 0.00870452 
vn -0.624396 -0.781058 0.008842 
vn -0.436605 -0.89961 0.0087776 
vn -0.782338 -0.622791 0.008894 
vn -0.624396 -0.781058 0.008842 
vn -0.901667 -0.432338 0.00893042 
vn -0.782338 -0.622791 0.008894 
vn -0.975608 -0.219337 0.00894895 
vn -0.901667 -0.432338 0.00893042 
vn 0.04229 0.00487754 -0.999093 
vn -0.973404 0.228923 0.00892872 
vn -0.999947 0.00505185 0.00894837 
vn -0.897717 0.440483 0.00889129 
vn -0.973404 0.228923 0.00892872 
vn -0.777451 0.628881 0.00883845 
vn -0.897717 0.440483 0.00889129 
vn -0.619553 0.784906 0.00877342 
vn -0.777451 0.628881 0.00883845 
vn -0.432743 0.901476 0.00869995 
vn -0.619553 0.784906 0.00877342 
vn -0.226845 0.973893 0.00862201 
vn -0.432743 0.901476 0.00869995 
vn -0.0121312 0.99989 0.00854353 
vn -0.226845 0.973893 0.00862201 
vn 0.201248 0.979504 0.00846814 
vn -0.0121312 0.99989 0.00854353 
vn 0.403729 0.91484 0.00839907 
vn 0.201248 0.979504 0.00846814 
vn 0.586672 0.809781 0.00833904 
vn 0.403729 0.91484 0.00839907 
vn 0.742607 0.669676 0.00829026 
vn 0.586672 0.809781 0.00833904 
vn 0.865387 0.501036 0.00825438 
vn 0.742607 0.669676 0.00829026 
vn 0.950289 0.31126 0.00823258 
vn 0.865387 0.501036 0.00825438 
vn 0.994076 0.108377 0.00822554 
vn 0.950289 0.31126 0.00823258 
vn 0.995035 -0.0991852 0.00823347 
vn 0.994076 0.108377 0.00822554 
vn 0.953009 -0.302828 0.00825614 
vn 0.995035 -0.0991852 0.00823347 
vn 0.869419 -0.494006 0.00829283 
vn 0.953009 -0.302828 0.00825614 
vn 0.747273 -0.664464 0.00834235 
vn 0.869419 -0.494006 0.00829283 
vn 0.591171 -0.806503 0.00840299 
vn 0.747273 -0.664464 0.00834235 
vn 0.407259 -0.913273 0.00847252 
vn 0.591171 -0.806503 0.00840299 
vn 0.203151 -0.97911 0.00854819 
vn 0.407259 -0.913273 0.00847252 
vn -0.0122493 -0.999888 0.00862674 
vn 0.203151 -0.97911 0.00854819 
vn -0.229015 -0.973384 0.00870452 
vn -0.0122493 -0.999888 0.00862674 
vn -0.436605 -0.89961 0.0087776 
vn -0.229015 -0.973384 0.00870452 
vn -0.624396 -0.781058 0.008842 
vn -0.436605 -0.89961 0.0087776 
vn -0.782338 -0.622791 0.008894 
vn -0.624396 -0.781058 0.008842 
vn -0.901667 -0.432338 0.00893042 
vn -0.782338 -0.622791 0.008894 
vn -0.975608 -0.219337 0.00894895 
vn -0.901667 -0.432338 0.00893042 
vn 0.04229 0.00487754 -0.999093 
usemtl 0.349020_0.376471_0.400000_0.000000_0.000000
o mesh207
f 3236//2806 3206//2806 3207//2806 
f 3207//2806 3208//2806 3236//2806 
f 3208//2806 3209//2806 3236//2806 
f 3209//2806 3210//2806 3236//2806 
f 3210//2806 3211//2806 3236//2806 
f 3211//2806 3212//2806 3236//2806 
f 3212//2806 3213//2806 3236//2806 
f 3213//2806 3214//2806 3236//2806 
f 3214//2806 3215//2806 3236//2806 
f 3215//2806 3216//2806 3236//2806 
f 3216//2806 3217//2806 3236//2806 
f 3217//2806 3218//2806 3236//2806 
f 3218//2806 3219//2806 3236//2806 
f 3219//2806 3220//2806 3236//2806 
f 3220//2806 3221//2806 3236//2806 
f 3221//2806 3222//2806 3236//2806 
f 3222//2806 3223//2806 3236//2806 
f 3223//2806 3224//2806 3236//2806 
f 3224//2806 3225//2806 3236//2806 
f 3225//2806 3226//2806 3236//2806 
f 3226//2806 3227//2806 3236//2806 
f 3227//2806 3228//2806 3236//2806 
f 3228//2806 3229//2806 3236//2806 
f 3229//2806 3230//2806 3236//2806 
f 3230//2806 3231//2806 3236//2806 
f 3231//2806 3232//2806 3236//2806 
f 3232//2806 3233//2806 3236//2806 
f 3233//2806 3234//2806 3236//2806 
f 3234//2806 3235//2806 3236//2806 
f 3235//2806 3206//2806 3236//2806 
o mesh208
f 3237//2807 3220//2807 3219//2808 
f 3238//2808 3219//2808 3218//2809 
f 3239//2809 3218//2809 3217//2810 
f 3240//2810 3217//2810 3216//2811 
f 3241//2811 3216//2811 3215//2812 
f 3242//2812 3215//2812 3214//2813 
f 3243//2813 3214//2813 3213//2814 
f 3244//2814 3213//2814 3212//2815 
f 3245//2815 3212//2815 3211//2816 
f 3246//2816 3211//2816 3210//2817 
f 3247//2817 3210//2817 3209//2818 
f 3248//2818 3209//2818 3208//2819 
f 3249//2819 3208//2819 3207//2820 
f 3250//2820 3207//2820 3206//2821 
f 3251//2822 3252//2823 3235//2823 
f 3206//2821 3235//2823 3252//2823 
f 3252//2823 3253//2824 3206//2821 
f 3251//2822 3234//2825 3233//2826 
f 3254//2826 3233//2826 3232//2827 
f 3255//2827 3232//2827 3231//2828 
f 3256//2828 3231//2828 3230//2829 
f 3257//2829 3230//2829 3229//2830 
f 3258//2830 3229//2830 3228//2831 
f 3259//2831 3228//2831 3227//2832 
f 3260//2832 3227//2832 3226//2833 
f 3261//2833 3226//2833 3225//2834 
f 3262//2834 3225//2834 3224//2835 
f 3263//2835 3224//2835 3223//2836 
f 3264//2836 3223//2836 3222//2837 
f 3265//2837 3222//2837 3221//2838 
f 3266//2838 3221//2838 3220//2807 
f 3220//2807 3237//2807 3266//2838 
f 3221//2838 3266//2838 3265//2837 
f 3222//2837 3265//2837 3264//2836 
f 3223//2836 3264//2836 3263//2835 
f 3224//2835 3263//2835 3262//2834 
f 3225//2834 3262//2834 3261//2833 
f 3226//2833 3261//2833 3260//2832 
f 3227//2832 3260//2832 3259//2831 
f 3228//2831 3259//2831 3258//2830 
f 3229//2830 3258//2830 3257//2829 
f 3230//2829 3257//2829 3256//2828 
f 3231//2828 3256//2828 3255//2827 
f 3232//2827 3255//2827 3254//2826 
f 3233//2826 3254//2826 3251//2822 
f 3235//2823 3234//2825 3251//2822 
f 3206//2821 3253//2824 3250//2820 
f 3207//2820 3250//2820 3249//2819 
f 3208//2819 3249//2819 3248//2818 
f 3209//2818 3248//2818 3247//2817 
f 3210//2817 3247//2817 3246//2816 
f 3211//2816 3246//2816 3245//2815 
f 3212//2815 3245//2815 3244//2814 
f 3213//2814 3244//2814 3243//2813 
f 3214//2813 3243//2813 3242//2812 
f 3215//2812 3242//2812 3241//2811 
f 3216//2811 3241//2811 3240//2810 
f 3217//2810 3240//2810 3239//2809 
f 3218//2809 3239//2809 3238//2808 
f 3219//2808 3238//2808 3237//2807 
o mesh209
f 3267//2839 3268//2839 3253//2839 
f 3269//2839 3250//2839 3253//2839 
f 3270//2839 3239//2839 3240//2839 
f 3271//2839 3238//2839 3239//2839 
f 3272//2839 3237//2839 3238//2839 
f 3272//2839 3273//2839 3266//2839 
f 3253//2839 3268//2839 3269//2839 
f 3274//2839 3249//2839 3250//2839 
f 3275//2839 3248//2839 3249//2839 
f 3275//2839 3276//2839 3247//2839 
f 3277//2839 3243//2839 3244//2839 
f 3277//2839 3278//2839 3242//2839 
f 3279//2839 3241//2839 3242//2839 
f 3279//2839 3280//2839 3240//2839 
f 3239//2839 3270//2839 3271//2839 
f 3266//2839 3237//2839 3272//2839 
f 3281//2839 3262//2839 3263//2839 
f 3282//2839 3261//2839 3262//2839 
f 3250//2839 3269//2839 3274//2839 
f 3247//2839 3248//2839 3275//2839 
f 3283//2839 3245//2839 3246//2839 
f 3283//2839 3284//2839 3244//2839 
f 3242//2839 3243//2839 3277//2839 
f 3240//2839 3241//2839 3279//2839 
f 3238//2839 3271//2839 3272//2839 
f 3273//2839 3285//2839 3265//2839 
f 3286//2839 3264//2839 3265//2839 
f 3286//2839 3287//2839 3263//2839 
f 3262//2839 3281//2839 3282//2839 
f 3288//2839 3260//2839 3261//2839 
f 3289//2839 3259//2839 3260//2839 
f 3289//2839 3290//2839 3258//2839 
f 3249//2839 3274//2839 3275//2839 
f 3276//2839 3291//2839 3246//2839 
f 3244//2839 3245//2839 3283//2839 
f 3242//2839 3278//2839 3279//2839 
f 3265//2839 3266//2839 3273//2839 
f 3263//2839 3264//2839 3286//2839 
f 3261//2839 3282//2839 3288//2839 
f 3258//2839 3259//2839 3289//2839 
f 3292//2839 3257//2839 3258//2839 
f 3292//2839 3293//2839 3256//2839 
f 3294//2839 3255//2839 3256//2839 
f 3294//2839 3295//2839 3254//2839 
f 3246//2839 3247//2839 3276//2839 
f 3244//2839 3284//2839 3277//2839 
f 3265//2839 3285//2839 3286//2839 
f 3260//2839 3288//2839 3289//2839 
f 3256//2839 3257//2839 3292//2839 
f 3254//2839 3255//2839 3294//2839 
f 3296//2839 3251//2839 3254//2839 
f 3296//2839 3267//2839 3252//2839 
f 3246//2839 3291//2839 3283//2839 
f 3263//2839 3287//2839 3281//2839 
f 3256//2839 3293//2839 3294//2839 
f 3252//2839 3251//2839 3296//2839 
f 3240//2839 3280//2839 3270//2839 
f 3254//2839 3295//2839 3296//2839 
f 3258//2839 3290//2839 3292//2839 
f 3253//2839 3252//2839 3267//2839 
o mesh210
f 3297//2840 3272//2840 3271//2841 
f 3298//2841 3271//2841 3270//2842 
f 3299//2842 3270//2842 3280//2843 
f 3300//2843 3280//2843 3279//2844 
f 3301//2844 3279//2844 3278//2845 
f 3302//2845 3278//2845 3277//2846 
f 3303//2846 3277//2846 3284//2847 
f 3304//2847 3284//2847 3283//2848 
f 3305//2848 3283//2848 3291//2849 
f 3306//2849 3291//2849 3276//2850 
f 3307//2850 3276//2850 3275//2851 
f 3308//2851 3275//2851 3274//2852 
f 3309//2852 3274//2852 3269//2853 
f 3310//2853 3269//2853 3268//2854 
f 3296//2855 3311//2855 3312//2856 
f 3313//2857 3268//2854 3267//2856 
f 3267//2856 3312//2856 3313//2857 
f 3311//2855 3296//2855 3295//2858 
f 3314//2858 3295//2858 3294//2859 
f 3315//2859 3294//2859 3293//2860 
f 3316//2860 3293//2860 3292//2861 
f 3317//2861 3292//2861 3290//2862 
f 3318//2862 3290//2862 3289//2863 
f 3319//2863 3289//2863 3288//2864 
f 3320//2864 3288//2864 3282//2865 
f 3321//2865 3282//2865 3281//2866 
f 3322//2866 3281//2866 3287//2867 
f 3323//2867 3287//2867 3286//2868 
f 3324//2868 3286//2868 3285//2869 
f 3325//2869 3285//2869 3273//2870 
f 3326//2870 3273//2870 3272//2840 
f 3272//2840 3297//2840 3326//2870 
f 3273//2870 3326//2870 3325//2869 
f 3285//2869 3325//2869 3324//2868 
f 3286//2868 3324//2868 3323//2867 
f 3287//2867 3323//2867 3322//2866 
f 3281//2866 3322//2866 3321//2865 
f 3282//2865 3321//2865 3320//2864 
f 3288//2864 3320//2864 3319//2863 
f 3289//2863 3319//2863 3318//2862 
f 3290//2862 3318//2862 3317//2861 
f 3292//2861 3317//2861 3316//2860 
f 3293//2860 3316//2860 3315//2859 
f 3294//2859 3315//2859 3314//2858 
f 3295//2858 3314//2858 3311//2855 
f 3312//2856 3267//2856 3296//2855 
f 3268//2854 3313//2857 3310//2853 
f 3269//2853 3310//2853 3309//2852 
f 3274//2852 3309//2852 3308//2851 
f 3275//2851 3308//2851 3307//2850 
f 3276//2850 3307//2850 3306//2849 
f 3291//2849 3306//2849 3305//2848 
f 3283//2848 3305//2848 3304//2847 
f 3284//2847 3304//2847 3303//2846 
f 3277//2846 3303//2846 3302//2845 
f 3278//2845 3302//2845 3301//2844 
f 3279//2844 3301//2844 3300//2843 
f 3280//2843 3300//2843 3299//2842 
f 3270//2842 3299//2842 3298//2841 
f 3271//2841 3298//2841 3297//2840 
o mesh211
f 3327//2871 3328//2871 3329//2871 
f 3330//2871 3331//2871 3332//2871 
f 3327//2871 3333//2871 3334//2871 
f 3327//2871 3335//2871 3328//2871 
f 3336//2871 3337//2871 3338//2871 
f 3332//2871 3339//2871 3330//2871 
f 3340//2871 3341//2871 3342//2871 
f 3340//2871 3327//2871 3343//2871 
f 3329//2871 3333//2871 3327//2871 
f 3338//2871 3327//2871 3336//2871 
f 3330//2871 3344//2871 3345//2871 
f 3330//2871 3346//2871 3331//2871 
f 3340//2871 3347//2871 3346//2871 
f 3343//2871 3341//2871 3340//2871 
f 3338//2871 3335//2871 3327//2871 
f 3336//2871 3348//2871 3349//2871 
f 3339//2871 3344//2871 3330//2871 
f 3340//2871 3350//2871 3347//2871 
f 3334//2871 3343//2871 3327//2871 
f 3349//2871 3351//2871 3336//2871 
f 3455//2871 3330//2871 3352//2871 
f 3346//2871 3330//2871 3340//2871 
f 3351//2871 3337//2871 3336//2871 
f 3336//2871 3455//2871 3353//2871 
f 3455//2871 3354//2871 3355//2871 
f 3352//2871 3356//2871 3455//2871 
f 3342//2871 3350//2871 3340//2871 
f 3455//2871 3357//2871 3353//2871 
f 3355//2871 3358//2871 3455//2871 
f 3356//2871 3359//2871 3455//2871 
f 3353//2871 3348//2871 3336//2871 
f 3359//2871 3354//2871 3455//2871 
f 3358//2871 3357//2871 3455//2871 
f 3360//2871 3361//2871 3362//2871 
f 3362//2871 3363//2871 3360//2871 
f 3336//2871 3364//2871 3365//2871 
f 3366//2871 3367//2871 3368//2871 
f 3360//2871 3369//2871 3370//2871 
f 3363//2871 3371//2871 3360//2871 
f 3455//2871 3372//2871 3373//2871 
f 3455//2871 3336//2871 3374//2871 
f 3365//2871 3375//2871 3336//2871 
f 3366//2871 3376//2871 3367//2871 
f 3370//2871 3366//2871 3360//2871 
f 3371//2871 3377//2871 3360//2871 
f 3361//2871 3455//2871 3378//2871 
f 3455//2871 3379//2871 3380//2871 
f 3374//2871 3372//2871 3455//2871 
f 3336//2871 3381//2871 3364//2871 
f 3366//2871 3382//2871 3376//2871 
f 3370//2871 3383//2871 3366//2871 
f 3361//2871 3384//2871 3362//2871 
f 3378//2871 3385//2871 3361//2871 
f 3455//2871 3386//2871 3379//2871 
f 3375//2871 3374//2871 3336//2871 
f 3368//2871 3336//2871 3366//2871 
f 3377//2871 3369//2871 3360//2871 
f 3361//2871 3387//2871 3388//2871 
f 3385//2871 3389//2871 3361//2871 
f 3455//2871 3390//2871 3391//2871 
f 3373//2871 3386//2871 3455//2871 
f 3383//2871 3382//2871 3366//2871 
f 3389//2871 3387//2871 3361//2871 
f 3380//2871 3390//2871 3455//2871 
f 3388//2871 3384//2871 3361//2871 
f 3368//2871 3381//2871 3336//2871 
f 3392//2871 3393//2871 3394//2871 
f 3392//2871 3395//2871 3393//2871 
f 3392//2871 3396//2871 3395//2871 
f 3392//2871 3397//2871 3396//2871 
f 3392//2871 3455//2871 3398//2871 
f 3399//2871 3400//2871 3401//2871 
f 3398//2871 3397//2871 3392//2871 
f 3455//2871 3402//2871 3403//2871 
f 3455//2871 3404//2871 3405//2871 
f 3455//2871 3361//2871 3406//2871 
f 3407//2871 3408//2871 3409//2871 
f 3401//2871 3407//2871 3399//2871 
f 3403//2871 3398//2871 3455//2871 
f 3455//2871 3410//2871 3404//2871 
f 3406//2871 3411//2871 3455//2871 
f 3407//2871 3412//2871 3408//2871 
f 3407//2871 3413//2871 3414//2871 
f 3399//2871 3415//2871 3400//2871 
f 3392//2871 3416//2871 3417//2871 
f 3405//2871 3402//2871 3455//2871 
f 3361//2871 3418//2871 3406//2871 
f 3361//2871 3409//2871 3419//2871 
f 3414//2871 3412//2871 3407//2871 
f 3401//2871 3420//2871 3407//2871 
f 3417//2871 3399//2871 3392//2871 
f 3411//2871 3410//2871 3455//2871 
f 3419//2871 3421//2871 3361//2871 
f 3420//2871 3413//2871 3407//2871 
f 3394//2871 3416//2871 3392//2871 
f 3409//2871 3361//2871 3407//2871 
f 3421//2871 3418//2871 3361//2871 
f 3399//2871 3422//2871 3423//2871 
f 3423//2871 3415//2871 3399//2871 
f 3330//2871 3300//2871 3301//2871 
f 3330//2871 3455//2871 3297//2871 
f 3455//2871 3322//2871 3323//2871 
f 3455//2871 3320//2871 3321//2871 
f 3424//2871 3330//2871 3303//2871 
f 3330//2871 3299//2871 3300//2871 
f 3297//2871 3298//2871 3330//2871 
f 3455//2871 3324//2871 3325//2871 
f 3321//2871 3322//2871 3455//2871 
f 3392//2871 3319//2871 3320//2871 
f 3330//2871 3302//2871 3303//2871 
f 3298//2871 3299//2871 3330//2871 
f 3325//2871 3326//2871 3455//2871 
f 3320//2871 3455//2871 3392//2871 
f 3303//2871 3425//2871 3424//2871 
f 3326//2871 3297//2871 3455//2871 
f 3392//2871 3318//2871 3319//2871 
f 3392//2871 3316//2871 3317//2871 
f 3392//2871 3312//2871 3311//2871 
f 3301//2871 3302//2871 3330//2871 
f 3317//2871 3318//2871 3392//2871 
f 3311//2871 3314//2871 3392//2871 
f 3392//2871 3426//2871 3313//2871 
f 3323//2871 3324//2871 3455//2871 
f 3314//2871 3315//2871 3392//2871 
f 3427//2871 3303//2871 3304//2871 
f 3426//2871 3310//2871 3313//2871 
f 3309//2871 3428//2871 3429//2871 
f 3309//2871 3426//2871 3430//2871 
f 3431//2871 3330//2871 3432//2871 
f 3330//2871 3433//2871 3434//2871 
f 3315//2871 3316//2871 3392//2871 
f 3303//2871 3427//2871 3435//2871 
f 3304//2871 3436//2871 3437//2871 
f 3304//2871 3438//2871 3439//2871 
f 3426//2871 3309//2871 3310//2871 
f 3430//2871 3428//2871 3309//2871 
f 3440//2871 3431//2871 3441//2871 
f 3432//2871 3442//2871 3431//2871 
f 3330//2871 3443//2871 3433//2871 
f 3435//2871 3425//2871 3303//2871 
f 3439//2871 3436//2871 3304//2871 
f 3305//2871 3429//2871 3444//2871 
f 3429//2871 3308//2871 3309//2871 
f 3429//2871 3306//2871 3307//2871 
f 3440//2871 3445//2871 3446//2871 
f 3431//2871 3447//2871 3441//2871 
f 3431//2871 3448//2871 3449//2871 
f 3434//2871 3432//2871 3330//2871 
f 3304//2871 3437//2871 3427//2871 
f 3444//2871 3304//2871 3305//2871 
f 3444//2871 3438//2871 3304//2871 
f 3307//2871 3308//2871 3429//2871 
f 3440//2871 3450//2871 3445//2871 
f 3431//2871 3451//2871 3447//2871 
f 3442//2871 3448//2871 3431//2871 
f 3429//2871 3305//2871 3306//2871 
f 3440//2871 3452//2871 3426//2871 
f 3441//2871 3450//2871 3440//2871 
f 3424//2871 3443//2871 3330//2871 
f 3426//2871 3392//2871 3440//2871 
f 3440//2871 3453//2871 3454//2871 
f 3449//2871 3451//2871 3431//2871 
f 3454//2871 3452//2871 3440//2871 
f 3313//2871 3312//2871 3392//2871 
f 3446//2871 3453//2871 3440//2871 
f 3417//2871 3422//2871 3399//2871 
f 3391//2871 3378//2871 3455//2871 
f 3345//2871 3352//2871 3330//2871 
o mesh212
f 3456//2872 3457//2872 3330//2872 
f 3340//2872 3330//2872 3457//2872 
f 3457//2872 3458//2872 3340//2872 
f 3330//2872 3431//2872 3456//2872 
o mesh213
f 3459//2873 3327//2873 3340//2873 
f 3340//2873 3458//2873 3459//2873 
o mesh214
f 3459//2874 3460//2874 3336//2874 
f 3366//2874 3336//2874 3460//2874 
f 3460//2874 3461//2874 3366//2874 
f 3336//2874 3327//2874 3459//2874 
o mesh215
f 3462//2875 3360//2875 3366//2875 
f 3366//2875 3461//2875 3462//2875 
o mesh216
f 3462//2876 3463//2876 3361//2876 
f 3407//2876 3361//2876 3463//2876 
f 3463//2876 3464//2876 3407//2876 
f 3361//2876 3360//2876 3462//2876 
o mesh217
f 3465//2877 3399//2877 3407//2877 
f 3407//2877 3464//2877 3465//2877 
o mesh218
f 3465//2878 3466//2878 3392//2878 
f 3440//2878 3392//2878 3466//2878 
f 3466//2878 3467//2878 3440//2878 
f 3392//2878 3399//2878 3465//2878 
o mesh219
f 3456//2879 3431//2879 3440//2879 
f 3440//2879 3467//2879 3456//2879 
o mesh220
f 3356//2880 3352//2881 3468//2881 
f 3359//2882 3356//2880 3469//2883 
f 3354//2884 3359//2882 3470//2885 
f 3355//2886 3354//2884 3471//2887 
f 3358//2888 3355//2886 3472//2889 
f 3357//2890 3358//2888 3473//2891 
f 3353//2892 3357//2890 3474//2893 
f 3348//2894 3353//2892 3475//2895 
f 3349//2896 3348//2894 3476//2897 
f 3351//2898 3349//2896 3477//2899 
f 3337//2900 3351//2898 3478//2901 
f 3338//2902 3337//2900 3479//2903 
f 3335//2904 3338//2902 3480//2905 
f 3328//2906 3335//2904 3481//2907 
f 3329//2908 3328//2906 3482//2909 
f 3333//2910 3329//2908 3483//2911 
f 3334//2912 3333//2910 3484//2913 
f 3343//2914 3334//2912 3485//2915 
f 3341//2916 3343//2914 3486//2917 
f 3342//2918 3341//2916 3487//2919 
f 3350//2920 3342//2918 3488//2921 
f 3347//2922 3350//2920 3489//2923 
f 3346//2924 3347//2922 3490//2925 
f 3331//2926 3346//2924 3491//2927 
f 3332//2928 3331//2926 3492//2929 
f 3339//2930 3332//2928 3493//2931 
f 3344//2932 3339//2930 3494//2933 
f 3345//2934 3344//2932 3495//2935 
f 3352//2881 3345//2934 3496//2934 
f 3496//2934 3468//2881 3352//2881 
f 3495//2935 3496//2934 3345//2934 
f 3494//2933 3495//2935 3344//2932 
f 3493//2931 3494//2933 3339//2930 
f 3492//2929 3493//2931 3332//2928 
f 3491//2927 3492//2929 3331//2926 
f 3490//2925 3491//2927 3346//2924 
f 3489//2923 3490//2925 3347//2922 
f 3488//2921 3489//2923 3350//2920 
f 3487//2919 3488//2921 3342//2918 
f 3486//2917 3487//2919 3341//2916 
f 3485//2915 3486//2917 3343//2914 
f 3484//2913 3485//2915 3334//2912 
f 3483//2911 3484//2913 3333//2910 
f 3482//2909 3483//2911 3329//2908 
f 3481//2907 3482//2909 3328//2906 
f 3480//2905 3481//2907 3335//2904 
f 3479//2903 3480//2905 3338//2902 
f 3478//2901 3479//2903 3337//2900 
f 3477//2899 3478//2901 3351//2898 
f 3476//2897 3477//2899 3349//2896 
f 3475//2895 3476//2897 3348//2894 
f 3474//2893 3475//2895 3353//2892 
f 3473//2891 3474//2893 3357//2890 
f 3472//2889 3473//2891 3358//2888 
f 3471//2887 3472//2889 3355//2886 
f 3470//2885 3471//2887 3354//2884 
f 3469//2883 3470//2885 3359//2882 
f 3468//2881 3469//2883 3356//2880 
o mesh221
f 3385//2936 3378//2937 3497//2937 
f 3389//2938 3385//2936 3498//2939 
f 3387//2940 3389//2938 3499//2941 
f 3388//2942 3387//2940 3500//2943 
f 3384//2944 3388//2942 3501//2945 
f 3362//2946 3384//2944 3502//2947 
f 3363//2948 3362//2946 3503//2949 
f 3371//2950 3363//2948 3504//2951 
f 3377//2952 3371//2950 3505//2953 
f 3369//2954 3377//2952 3506//2955 
f 3370//2956 3369//2954 3507//2957 
f 3383//2958 3370//2956 3508//2959 
f 3382//2960 3383//2958 3509//2961 
f 3376//2962 3382//2960 3510//2963 
f 3367//2964 3376//2962 3511//2965 
f 3368//2966 3367//2964 3512//2967 
f 3381//2968 3368//2966 3513//2969 
f 3364//2970 3381//2968 3514//2971 
f 3365//2972 3364//2970 3515//2973 
f 3375//2974 3365//2972 3516//2975 
f 3374//2976 3375//2974 3517//2977 
f 3372//2978 3374//2976 3518//2979 
f 3373//2980 3372//2978 3519//2981 
f 3386//2982 3373//2980 3520//2983 
f 3379//2984 3386//2982 3521//2985 
f 3380//2986 3379//2984 3522//2987 
f 3390//2988 3380//2986 3523//2989 
f 3391//2990 3390//2988 3524//2991 
f 3378//2937 3391//2990 3525//2990 
f 3525//2990 3497//2937 3378//2937 
f 3524//2991 3525//2990 3391//2990 
f 3523//2989 3524//2991 3390//2988 
f 3522//2987 3523//2989 3380//2986 
f 3521//2985 3522//2987 3379//2984 
f 3520//2983 3521//2985 3386//2982 
f 3519//2981 3520//2983 3373//2980 
f 3518//2979 3519//2981 3372//2978 
f 3517//2977 3518//2979 3374//2976 
f 3516//2975 3517//2977 3375//2974 
f 3515//2973 3516//2975 3365//2972 
f 3514//2971 3515//2973 3364//2970 
f 3513//2969 3514//2971 3381//2968 
f 3512//2967 3513//2969 3368//2966 
f 3511//2965 3512//2967 3367//2964 
f 3510//2963 3511//2965 3376//2962 
f 3509//2961 3510//2963 3382//2960 
f 3508//2959 3509//2961 3383//2958 
f 3507//2957 3508//2959 3370//2956 
f 3506//2955 3507//2957 3369//2954 
f 3505//2953 3506//2955 3377//2952 
f 3504//2951 3505//2953 3371//2950 
f 3503//2949 3504//2951 3363//2948 
f 3502//2947 3503//2949 3362//2946 
f 3501//2945 3502//2947 3384//2944 
f 3500//2943 3501//2945 3388//2942 
f 3499//2941 3500//2943 3387//2940 
f 3498//2939 3499//2941 3389//2938 
f 3497//2937 3498//2939 3385//2936 
o mesh222
f 3423//2992 3422//2993 3526//2993 
f 3415//2994 3423//2992 3527//2995 
f 3400//2996 3415//2994 3528//2997 
f 3401//2998 3400//2996 3529//2999 
f 3420//3000 3401//2998 3530//3001 
f 3413//3002 3420//3000 3531//3003 
f 3414//3004 3413//3002 3532//3005 
f 3412//3006 3414//3004 3533//3007 
f 3408//3008 3412//3006 3534//3009 
f 3409//3010 3408//3008 3535//3011 
f 3419//3012 3409//3010 3536//3013 
f 3421//3014 3419//3012 3537//3015 
f 3418//3016 3421//3014 3538//3017 
f 3406//3018 3418//3016 3539//3019 
f 3411//3020 3406//3018 3540//3021 
f 3410//3022 3411//3020 3541//3023 
f 3404//3024 3410//3022 3542//3025 
f 3405//3026 3404//3024 3543//3027 
f 3402//3028 3405//3026 3544//3029 
f 3403//3030 3402//3028 3545//3031 
f 3398//3032 3403//3030 3546//3033 
f 3397//3034 3398//3032 3547//3035 
f 3396//3036 3397//3034 3548//3037 
f 3395//3038 3396//3036 3549//3039 
f 3393//3040 3395//3038 3550//3041 
f 3394//3042 3393//3040 3551//3043 
f 3416//3044 3394//3042 3552//3045 
f 3417//3046 3416//3044 3553//3047 
f 3422//2993 3417//3046 3554//3046 
f 3554//3046 3526//2993 3422//2993 
f 3553//3047 3554//3046 3417//3046 
f 3552//3045 3553//3047 3416//3044 
f 3551//3043 3552//3045 3394//3042 
f 3550//3041 3551//3043 3393//3040 
f 3549//3039 3550//3041 3395//3038 
f 3548//3037 3549//3039 3396//3036 
f 3547//3035 3548//3037 3397//3034 
f 3546//3033 3547//3035 3398//3032 
f 3545//3031 3546//3033 3403//3030 
f 3544//3029 3545//3031 3402//3028 
f 3543//3027 3544//3029 3405//3026 
f 3542//3025 3543//3027 3404//3024 
f 3541//3023 3542//3025 3410//3022 
f 3540//3021 3541//3023 3411//3020 
f 3539//3019 3540//3021 3406//3018 
f 3538//3017 3539//3019 3418//3016 
f 3537//3015 3538//3017 3421//3014 
f 3536//3013 3537//3015 3419//3012 
f 3535//3011 3536//3013 3409//3010 
f 3534//3009 3535//3011 3408//3008 
f 3533//3007 3534//3009 3412//3006 
f 3532//3005 3533//3007 3414//3004 
f 3531//3003 3532//3005 3413//3002 
f 3530//3001 3531//3003 3420//3000 
f 3529//2999 3530//3001 3401//2998 
f 3528//2997 3529//2999 3400//2996 
f 3527//2995 3528//2997 3415//2994 
f 3526//2993 3527//2995 3423//2992 
o mesh223
f 3454//3048 3453//3049 3555//3049 
f 3452//3050 3454//3048 3556//3051 
f 3426//3052 3452//3050 3557//3053 
f 3430//3054 3426//3052 3558//3055 
f 3428//3056 3430//3054 3559//3057 
f 3429//3058 3428//3056 3560//3059 
f 3444//3060 3429//3058 3561//3061 
f 3438//3062 3444//3060 3562//3063 
f 3439//3064 3438//3062 3563//3065 
f 3436//3066 3439//3064 3564//3067 
f 3437//3068 3436//3066 3565//3069 
f 3427//3070 3437//3068 3566//3071 
f 3435//3072 3427//3070 3567//3073 
f 3425//3074 3435//3072 3568//3075 
f 3424//3076 3425//3074 3569//3077 
f 3443//3078 3424//3076 3570//3079 
f 3433//3080 3443//3078 3571//3081 
f 3434//3082 3433//3080 3572//3083 
f 3432//3084 3434//3082 3573//3085 
f 3442//3086 3432//3084 3574//3087 
f 3448//3088 3442//3086 3575//3089 
f 3449//3090 3448//3088 3576//3091 
f 3451//3092 3449//3090 3577//3093 
f 3447//3094 3451//3092 3578//3095 
f 3441//3096 3447//3094 3579//3097 
f 3450//3098 3441//3096 3580//3099 
f 3445//3100 3450//3098 3581//3101 
f 3446//3102 3445//3100 3582//3103 
f 3453//3049 3446//3102 3583//3102 
f 3583//3102 3555//3049 3453//3049 
f 3582//3103 3583//3102 3446//3102 
f 3581//3101 3582//3103 3445//3100 
f 3580//3099 3581//3101 3450//3098 
f 3579//3097 3580//3099 3441//3096 
f 3578//3095 3579//3097 3447//3094 
f 3577//3093 3578//3095 3451//3092 
f 3576//3091 3577//3093 3449//3090 
f 3575//3089 3576//3091 3448//3088 
f 3574//3087 3575//3089 3442//3086 
f 3573//3085 3574//3087 3432//3084 
f 3572//3083 3573//3085 3434//3082 
f 3571//3081 3572//3083 3433//3080 
f 3570//3079 3571//3081 3443//3078 
f 3569//3077 3570//3079 3424//3076 
f 3568//3075 3569//3077 3425//3074 
f 3567//3073 3568//3075 3435//3072 
f 3566//3071 3567//3073 3427//3070 
f 3565//3069 3566//3071 3437//3068 
f 3564//3067 3565//3069 3436//3066 
f 3563//3065 3564//3067 3439//3064 
f 3562//3063 3563//3065 3438//3062 
f 3561//3061 3562//3063 3444//3060 
f 3560//3059 3561//3061 3429//3058 
f 3559//3057 3560//3059 3428//3056 
f 3558//3055 3559//3057 3430//3054 
f 3557//3053 3558//3055 3426//3052 
f 3556//3051 3557//3053 3452//3050 
f 3555//3049 3556//3051 3454//3048 
o mesh224
f 3466//3104 3584//3104 3585//3104 
f 3613//3104 3586//3104 3584//3104 
f 3584//3104 3466//3104 3613//3104 
f 3564//3104 3587//3104 3588//3104 
f 3568//3104 3567//3104 3589//3104 
f 3570//3104 3569//3104 3590//3104 
f 3467//3104 3581//3104 3580//3104 
f 3562//3104 3466//3104 3591//3104 
f 3466//3104 3592//3104 3593//3104 
f 3613//3104 3594//3104 3586//3104 
f 3613//3104 3595//3104 3596//3104 
f 3613//3104 3597//3104 3598//3104 
f 3588//3104 3565//3104 3564//3104 
f 3588//3104 3599//3104 3566//3104 
f 3600//3104 3569//3104 3568//3104 
f 3457//3104 3601//3104 3602//3104 
f 3590//3104 3457//3104 3570//3104 
f 3580//3104 3456//3104 3467//3104 
f 3467//3104 3555//3104 3583//3104 
f 3466//3104 3603//3104 3591//3104 
f 3585//3104 3592//3104 3466//3104 
f 3598//3104 3595//3104 3613//3104 
f 3613//3104 3457//3104 3604//3104 
f 3563//3104 3605//3104 3587//3104 
f 3563//3104 3591//3104 3606//3104 
f 3599//3104 3567//3104 3566//3104 
f 3569//3104 3607//3104 3608//3104 
f 3589//3104 3600//3104 3568//3104 
f 3602//3104 3609//3104 3457//3104 
f 3590//3104 3610//3104 3457//3104 
f 3457//3104 3574//3104 3573//3104 
f 3456//3104 3575//3104 3574//3104 
f 3580//3104 3579//3104 3456//3104 
f 3583//3104 3582//3104 3467//3104 
f 3466//3104 3560//3104 3559//3104 
f 3591//3104 3563//3104 3562//3104 
f 3596//3104 3594//3104 3613//3104 
f 3604//3104 3611//3104 3613//3104 
f 3606//3104 3605//3104 3563//3104 
f 3566//3104 3565//3104 3588//3104 
f 3600//3104 3607//3104 3569//3104 
f 3610//3104 3601//3104 3457//3104 
f 3573//3104 3572//3104 3457//3104 
f 3456//3104 3576//3104 3575//3104 
f 3582//3104 3581//3104 3467//3104 
f 3467//3104 3557//3104 3556//3104 
f 3467//3104 3466//3104 3558//3104 
f 3466//3104 3561//3104 3560//3104 
f 3466//3104 3612//3104 3603//3104 
f 3611//3104 3597//3104 3613//3104 
f 3599//3104 3589//3104 3567//3104 
f 3609//3104 3604//3104 3457//3104 
f 3574//3104 3457//3104 3456//3104 
f 3456//3104 3578//3104 3577//3104 
f 3556//3104 3555//3104 3467//3104 
f 3559//3104 3558//3104 3466//3104 
f 3593//3104 3612//3104 3466//3104 
f 3608//3104 3590//3104 3569//3104 
f 3577//3104 3576//3104 3456//3104 
f 3558//3104 3557//3104 3467//3104 
f 3564//3104 3563//3104 3587//3104 
f 3572//3104 3571//3104 3457//3104 
f 3562//3104 3561//3104 3466//3104 
f 3579//3104 3578//3104 3456//3104 
f 3466//3104 3553//3104 3552//3104 
f 3465//3104 3464//3104 3530//3104 
f 3613//3104 3545//3104 3544//3104 
f 3466//3104 3550//3104 3549//3104 
f 3552//3104 3551//3104 3466//3104 
f 3464//3104 3531//3104 3530//3104 
f 3464//3104 3463//3104 3536//3104 
f 3544//3104 3543//3104 3613//3104 
f 3613//3104 3547//3104 3546//3104 
f 3466//3104 3548//3104 3547//3104 
f 3551//3104 3550//3104 3466//3104 
f 3530//3104 3529//3104 3465//3104 
f 3464//3104 3534//3104 3533//3104 
f 3536//3104 3535//3104 3464//3104 
f 3546//3104 3545//3104 3613//3104 
f 3549//3104 3548//3104 3466//3104 
f 3466//3104 3465//3104 3554//3104 
f 3464//3104 3532//3104 3531//3104 
f 3535//3104 3534//3104 3464//3104 
f 3463//3104 3538//3104 3537//3104 
f 3547//3104 3613//3104 3466//3104 
f 3465//3104 3526//3104 3554//3104 
f 3465//3104 3528//3104 3527//3104 
f 3533//3104 3532//3104 3464//3104 
f 3463//3104 3539//3104 3538//3104 
f 3613//3104 3541//3104 3540//3104 
f 3543//3104 3542//3104 3613//3104 
f 3527//3104 3526//3104 3465//3104 
f 3537//3104 3536//3104 3463//3104 
f 3540//3104 3463//3104 3613//3104 
f 3554//3104 3553//3104 3466//3104 
f 3540//3104 3539//3104 3463//3104 
f 3529//3104 3528//3104 3465//3104 
f 3460//3104 3517//3104 3516//3104 
f 3462//3104 3504//3104 3503//3104 
f 3460//3104 3518//3104 3517//3104 
f 3613//3104 3519//3104 3518//3104 
f 3613//3104 3521//3104 3520//3104 
f 3463//3104 3498//3104 3497//3104 
f 3462//3104 3505//3104 3504//3104 
f 3516//3104 3515//3104 3460//3104 
f 3520//3104 3519//3104 3613//3104 
f 3613//3104 3524//3104 3523//3104 
f 3613//3104 3497//3104 3525//3104 
f 3463//3104 3499//3104 3498//3104 
f 3462//3104 3506//3104 3505//3104 
f 3462//3104 3461//3104 3508//3104 
f 3518//3104 3460//3104 3613//3104 
f 3523//3104 3522//3104 3613//3104 
f 3497//3104 3613//3104 3463//3104 
f 3462//3104 3507//3104 3506//3104 
f 3461//3104 3509//3104 3508//3104 
f 3522//3104 3521//3104 3613//3104 
f 3463//3104 3500//3104 3499//3104 
f 3503//3104 3463//3104 3462//3104 
f 3461//3104 3510//3104 3509//3104 
f 3525//3104 3524//3104 3613//3104 
f 3463//3104 3502//3104 3501//3104 
f 3508//3104 3507//3104 3462//3104 
f 3461//3104 3512//3104 3511//3104 
f 3461//3104 3460//3104 3513//3104 
f 3501//3104 3500//3104 3463//3104 
f 3511//3104 3510//3104 3461//3104 
f 3460//3104 3514//3104 3513//3104 
f 3503//3104 3502//3104 3463//3104 
f 3515//3104 3514//3104 3460//3104 
f 3457//3104 3494//3104 3493//3104 
f 3613//3104 3469//3104 3468//3104 
f 3457//3104 3495//3104 3494//3104 
f 3613//3104 3470//3104 3469//3104 
f 3613//3104 3473//3104 3472//3104 
f 3493//3104 3492//3104 3457//3104 
f 3457//3104 3468//3104 3496//3104 
f 3613//3104 3471//3104 3470//3104 
f 3613//3104 3474//3104 3473//3104 
f 3460//3104 3459//3104 3480//3104 
f 3459//3104 3486//3104 3485//3104 
f 3458//3104 3487//3104 3486//3104 
f 3458//3104 3489//3104 3488//3104 
f 3458//3104 3457//3104 3491//3104 
f 3496//3104 3495//3104 3457//3104 
f 3472//3104 3471//3104 3613//3104 
f 3460//3104 3478//3104 3477//3104 
f 3459//3104 3481//3104 3480//3104 
f 3459//3104 3483//3104 3482//3104 
f 3485//3104 3484//3104 3459//3104 
f 3488//3104 3487//3104 3458//3104 
f 3491//3104 3490//3104 3458//3104 
f 3468//3104 3457//3104 3613//3104 
f 3460//3104 3476//3104 3475//3104 
f 3460//3104 3479//3104 3478//3104 
f 3482//3104 3481//3104 3459//3104 
f 3486//3104 3459//3104 3458//3104 
f 3492//3104 3491//3104 3457//3104 
f 3475//3104 3613//3104 3460//3104 
f 3480//3104 3479//3104 3460//3104 
f 3490//3104 3489//3104 3458//3104 
f 3477//3104 3476//3104 3460//3104 
f 3475//3104 3474//3104 3613//3104 
f 3484//3104 3483//3104 3459//3104 
f 3513//3104 3512//3104 3461//3104 
f 3542//3104 3541//3104 3613//3104 
f 3571//3104 3570//3104 3457//3104 
o mesh225
f 3614//3105 3615//3106 3606//3106 
f 3616//3107 3614//3105 3591//3108 
f 3617//3109 3616//3107 3603//3110 
f 3618//3111 3617//3109 3612//3112 
f 3619//3113 3618//3111 3593//3114 
f 3620//3115 3619//3113 3592//3116 
f 3621//3117 3620//3115 3585//3118 
f 3622//3119 3621//3117 3584//3120 
f 3623//3121 3622//3119 3586//3122 
f 3624//3123 3623//3121 3594//3124 
f 3625//3125 3624//3123 3596//3126 
f 3626//3127 3625//3125 3595//3128 
f 3627//3129 3626//3127 3598//3130 
f 3628//3131 3627//3129 3597//3132 
f 3629//3133 3628//3131 3611//3134 
f 3630//3135 3629//3133 3604//3136 
f 3631//3137 3630//3135 3609//3138 
f 3632//3139 3631//3137 3602//3140 
f 3633//3141 3632//3139 3601//3142 
f 3634//3143 3633//3141 3610//3144 
f 3635//3145 3634//3143 3590//3146 
f 3636//3147 3635//3145 3608//3148 
f 3637//3149 3636//3147 3607//3150 
f 3638//3151 3637//3149 3600//3152 
f 3639//3153 3638//3151 3589//3154 
f 3640//3155 3639//3153 3599//3156 
f 3641//3157 3640//3155 3588//3158 
f 3642//3159 3641//3157 3587//3160 
f 3615//3106 3642//3159 3605//3159 
f 3605//3159 3606//3106 3615//3106 
f 3587//3160 3605//3159 3642//3159 
f 3588//3158 3587//3160 3641//3157 
f 3599//3156 3588//3158 3640//3155 
f 3589//3154 3599//3156 3639//3153 
f 3600//3152 3589//3154 3638//3151 
f 3607//3150 3600//3152 3637//3149 
f 3608//3148 3607//3150 3636//3147 
f 3590//3146 3608//3148 3635//3145 
f 3610//3144 3590//3146 3634//3143 
f 3601//3142 3610//3144 3633//3141 
f 3602//3140 3601//3142 3632//3139 
f 3609//3138 3602//3140 3631//3137 
f 3604//3136 3609//3138 3630//3135 
f 3611//3134 3604//3136 3629//3133 
f 3597//3132 3611//3134 3628//3131 
f 3598//3130 3597//3132 3627//3129 
f 3595//3128 3598//3130 3626//3127 
f 3596//3126 3595//3128 3625//3125 
f 3594//3124 3596//3126 3624//3123 
f 3586//3122 3594//3124 3623//3121 
f 3584//3120 3586//3122 3622//3119 
f 3585//3118 3584//3120 3621//3117 
f 3592//3116 3585//3118 3620//3115 
f 3593//3114 3592//3116 3619//3113 
f 3612//3112 3593//3114 3618//3111 
f 3603//3110 3612//3112 3617//3109 
f 3591//3108 3603//3110 3616//3107 
f 3606//3106 3591//3108 3614//3105 
o mesh226
f 3641//3161 3643//3161 3644//3161 
f 3642//3161 3645//3161 3643//3161 
f 3615//3161 3646//3161 3645//3161 
f 3615//3161 3614//3161 3647//3161 
f 3630//3161 3648//3161 3649//3161 
f 3631//3161 3650//3161 3648//3161 
f 3632//3161 3651//3161 3650//3161 
f 3632//3161 3633//3161 3652//3161 
f 3637//3161 3653//3161 3654//3161 
f 3637//3161 3638//3161 3655//3161 
f 3639//3161 3656//3161 3655//3161 
f 3639//3161 3640//3161 3644//3161 
f 3643//3161 3641//3161 3642//3161 
f 3647//3161 3646//3161 3615//3161 
f 3619//3161 3657//3161 3658//3161 
f 3620//3161 3659//3161 3657//3161 
f 3648//3161 3630//3161 3631//3161 
f 3652//3161 3651//3161 3632//3161 
f 3635//3161 3660//3161 3661//3161 
f 3635//3161 3636//3161 3654//3161 
f 3655//3161 3653//3161 3637//3161 
f 3644//3161 3656//3161 3639//3161 
f 3645//3161 3642//3161 3615//3161 
f 3614//3161 3616//3161 3662//3161 
f 3617//3161 3663//3161 3662//3161 
f 3617//3161 3618//3161 3658//3161 
f 3657//3161 3619//3161 3620//3161 
f 3621//3161 3664//3161 3659//3161 
f 3622//3161 3665//3161 3664//3161 
f 3622//3161 3623//3161 3666//3161 
f 3650//3161 3631//3161 3632//3161 
f 3633//3161 3634//3161 3661//3161 
f 3654//3161 3660//3161 3635//3161 
f 3655//3161 3638//3161 3639//3161 
f 3662//3161 3647//3161 3614//3161 
f 3658//3161 3663//3161 3617//3161 
f 3659//3161 3620//3161 3621//3161 
f 3666//3161 3665//3161 3622//3161 
f 3624//3161 3667//3161 3666//3161 
f 3624//3161 3625//3161 3668//3161 
f 3626//3161 3669//3161 3668//3161 
f 3626//3161 3627//3161 3670//3161 
f 3661//3161 3652//3161 3633//3161 
f 3654//3161 3636//3161 3637//3161 
f 3662//3161 3616//3161 3617//3161 
f 3664//3161 3621//3161 3622//3161 
f 3668//3161 3667//3161 3624//3161 
f 3670//3161 3669//3161 3626//3161 
f 3628//3161 3671//3161 3670//3161 
f 3628//3161 3629//3161 3649//3161 
f 3661//3161 3634//3161 3635//3161 
f 3658//3161 3618//3161 3619//3161 
f 3668//3161 3625//3161 3626//3161 
f 3649//3161 3671//3161 3628//3161 
f 3644//3161 3640//3161 3641//3161 
f 3670//3161 3627//3161 3628//3161 
f 3666//3161 3623//3161 3624//3161 
f 3649//3161 3629//3161 3630//3161 
o mesh227
f 3672//3162 3673//3163 3646//3163 
f 3674//3164 3672//3162 3647//3165 
f 3675//3166 3674//3164 3662//3167 
f 3676//3168 3675//3166 3663//3169 
f 3677//3170 3676//3168 3658//3171 
f 3678//3172 3677//3170 3657//3173 
f 3679//3174 3678//3172 3659//3175 
f 3680//3176 3679//3174 3664//3177 
f 3681//3178 3680//3176 3665//3179 
f 3682//3180 3681//3178 3666//3181 
f 3683//3182 3682//3180 3667//3183 
f 3684//3184 3683//3182 3668//3185 
f 3685//3186 3684//3184 3669//3187 
f 3686//3188 3685//3186 3670//3189 
f 3687//3190 3686//3188 3671//3191 
f 3688//3192 3687//3190 3649//3193 
f 3689//3194 3688//3192 3648//3195 
f 3690//3196 3689//3194 3650//3197 
f 3691//3198 3690//3196 3651//3199 
f 3692//3200 3691//3198 3652//3201 
f 3693//3202 3692//3200 3661//3203 
f 3694//3204 3693//3202 3660//3205 
f 3695//3206 3694//3204 3654//3207 
f 3696//3208 3695//3206 3653//3209 
f 3697//3210 3696//3208 3655//3211 
f 3698//3212 3697//3210 3656//3213 
f 3699//3214 3698//3212 3644//3215 
f 3700//3216 3699//3214 3643//3217 
f 3673//3163 3700//3216 3645//3216 
f 3645//3216 3646//3163 3673//3163 
f 3643//3217 3645//3216 3700//3216 
f 3644//3215 3643//3217 3699//3214 
f 3656//3213 3644//3215 3698//3212 
f 3655//3211 3656//3213 3697//3210 
f 3653//3209 3655//3211 3696//3208 
f 3654//3207 3653//3209 3695//3206 
f 3660//3205 3654//3207 3694//3204 
f 3661//3203 3660//3205 3693//3202 
f 3652//3201 3661//3203 3692//3200 
f 3651//3199 3652//3201 3691//3198 
f 3650//3197 3651//3199 3690//3196 
f 3648//3195 3650//3197 3689//3194 
f 3649//3193 3648//3195 3688//3192 
f 3671//3191 3649//3193 3687//3190 
f 3670//3189 3671//3191 3686//3188 
f 3669//3187 3670//3189 3685//3186 
f 3668//3185 3669//3187 3684//3184 
f 3667//3183 3668//3185 3683//3182 
f 3666//3181 3667//3183 3682//3180 
f 3665//3179 3666//3181 3681//3178 
f 3664//3177 3665//3179 3680//3176 
f 3659//3175 3664//3177 3679//3174 
f 3657//3173 3659//3175 3678//3172 
f 3658//3171 3657//3173 3677//3170 
f 3663//3169 3658//3171 3676//3168 
f 3662//3167 3663//3169 3675//3166 
f 3647//3165 3662//3167 3674//3164 
f 3646//3163 3647//3165 3672//3162 
o mesh228
f 3701//3218 3672//3218 3674//3218 
f 3674//3218 3675//3218 3701//3218 
f 3675//3218 3676//3218 3701//3218 
f 3676//3218 3677//3218 3701//3218 
f 3677//3218 3678//3218 3701//3218 
f 3678//3218 3679//3218 3701//3218 
f 3679//3218 3680//3218 3701//3218 
f 3680//3218 3681//3218 3701//3218 
f 3681//3218 3682//3218 3701//3218 
f 3682//3218 3683//3218 3701//3218 
f 3683//3218 3684//3218 3701//3218 
f 3684//3218 3685//3218 3701//3218 
f 3685//3218 3686//3218 3701//3218 
f 3686//3218 3687//3218 3701//3218 
f 3687//3218 3688//3218 3701//3218 
f 3688//3218 3689//3218 3701//3218 
f 3689//3218 3690//3218 3701//3218 
f 3690//3218 3691//3218 3701//3218 
f 3691//3218 3692//3218 3701//3218 
f 3692//3218 3693//3218 3701//3218 
f 3693//3218 3694//3218 3701//3218 
f 3694//3218 3695//3218 3701//3218 
f 3695//3218 3696//3218 3701//3218 
f 3696//3218 3697//3218 3701//3218 
f 3697//3218 3698//3218 3701//3218 
f 3698//3218 3699//3218 3701//3218 
f 3699//3218 3700//3218 3701//3218 
f 3700//3218 3673//3218 3701//3218 
f 3673//3218 3672//3218 3701//3218 
g 1mmSpacer
v 0.0964706 -0.00515989 0.0445032 
v 0.0971155 -0.00515989 0.0445733 
v 0.0971155 -0.00615989 0.0445733 
v 0.0958558 -0.00515989 0.044296 
v 0.0964706 -0.00615989 0.0445032 
v 0.0953 -0.00515989 0.0439616 
v 0.0958558 -0.00615989 0.044296 
v 0.094829 -0.00515989 0.0435155 
v 0.0953 -0.00615989 0.0439616 
v 0.0944649 -0.00515989 0.0429785 
v 0.094829 -0.00615989 0.0435155 
v 0.0942248 -0.00515989 0.0423759 
v 0.0944649 -0.00615989 0.0429785 
v 0.0941199 -0.00515989 0.0417357 
v 0.0942248 -0.00615989 0.0423759 
v 0.094155 -0.00515989 0.041088 
v 0.0941199 -0.00615989 0.0417357 
v 0.0943285 -0.00515989 0.0404629 
v 0.094155 -0.00615989 0.041088 
v 0.0946324 -0.00515989 0.0398897 
v 0.0943285 -0.00615989 0.0404629 
v 0.0950524 -0.00515989 0.0393953 
v 0.0946324 -0.00615989 0.0398897 
v 0.0955688 -0.00515989 0.0390027 
v 0.0950524 -0.00615989 0.0393953 
v 0.0961576 -0.00515989 0.0387303 
v 0.0955688 -0.00615989 0.0390027 
v 0.0967911 -0.00515989 0.0385909 
v 0.0961576 -0.00615989 0.0387303 
v 0.0974398 -0.00515989 0.0385909 
v 0.0971155 -0.00515989 0.0385733 
v 0.0971155 -0.00615989 0.0385733 
v 0.0967911 -0.00615989 0.0385909 
v 0.0980734 -0.00515989 0.0387303 
v 0.0974398 -0.00615989 0.0385909 
v 0.0986621 -0.00515989 0.0390027 
v 0.0980734 -0.00615989 0.0387303 
v 0.0991786 -0.00515989 0.0393953 
v 0.0986621 -0.00615989 0.0390027 
v 0.0995985 -0.00515989 0.0398897 
v 0.0991786 -0.00615989 0.0393953 
v 0.0999024 -0.00515989 0.0404629 
v 0.0995985 -0.00615989 0.0398897 
v 0.100076 -0.00515989 0.041088 
v 0.0999024 -0.00615989 0.0404629 
v 0.100111 -0.00515989 0.0417357 
v 0.100076 -0.00615989 0.041088 
v 0.100006 -0.00515989 0.0423759 
v 0.100111 -0.00615989 0.0417357 
v 0.099766 -0.00515989 0.0429785 
v 0.100006 -0.00615989 0.0423759 
v 0.099402 -0.00515989 0.0435155 
v 0.099766 -0.00615989 0.0429785 
v 0.098931 -0.00515989 0.0439616 
v 0.099402 -0.00615989 0.0435155 
v 0.0983751 -0.00515989 0.044296 
v 0.098931 -0.00615989 0.0439616 
v 0.0977604 -0.00515989 0.0445032 
v 0.0983751 -0.00615989 0.044296 
v 0.0977604 -0.00615989 0.0445032 
v 0.100164 -0.00615989 0.0441628 
v 0.0995362 -0.00615989 0.0447577 
v 0.098795 -0.00615989 0.0452036 
v 0.0979754 -0.00615989 0.0454798 
v 0.0971155 -0.00615989 0.0455733 
v 0.097548 -0.00615989 0.0375967 
v 0.0983927 -0.00615989 0.0377827 
v 0.10065 -0.00615989 0.0434469 
v 0.0940668 -0.00615989 0.0441628 
v 0.0935814 -0.00615989 0.0434469 
v 0.0950533 -0.00615989 0.0381459 
v 0.0958383 -0.00615989 0.0377827 
v 0.096683 -0.00615989 0.0375967 
v 0.0971155 -0.00615989 0.0375733 
v 0.0991777 -0.00615989 0.0381459 
v 0.0998663 -0.00615989 0.0386693 
v 0.100426 -0.00615989 0.0393285 
v 0.100831 -0.00615989 0.0400927 
v 0.101063 -0.00615989 0.0409262 
v 0.10097 -0.00615989 0.0426434 
v 0.0962556 -0.00615989 0.0454798 
v 0.0946948 -0.00615989 0.0447577 
v 0.0938047 -0.00615989 0.0393285 
v 0.0943647 -0.00615989 0.0386693 
v 0.10111 -0.00615989 0.0417899 
v 0.0954359 -0.00615989 0.0452036 
v 0.0931213 -0.00615989 0.0417899 
v 0.0931682 -0.00615989 0.0409262 
v 0.0932613 -0.00615989 0.0426434 
v 0.0933996 -0.00615989 0.0400927 
v 0.0971155 -0.00515989 0.0455733 
v 0.0979754 -0.00515989 0.0454798 
v 0.098795 -0.00515989 0.0452036 
v 0.0995362 -0.00515989 0.0447577 
v 0.100164 -0.00515989 0.0441628 
v 0.10065 -0.00515989 0.0434469 
v 0.10097 -0.00515989 0.0426434 
v 0.10111 -0.00515989 0.0417899 
v 0.101063 -0.00515989 0.0409262 
v 0.100831 -0.00515989 0.0400927 
v 0.100426 -0.00515989 0.0393285 
v 0.0998663 -0.00515989 0.0386693 
v 0.0991777 -0.00515989 0.0381459 
v 0.0983927 -0.00515989 0.0377827 
v 0.096683 -0.00515989 0.0375967 
v 0.0971155 -0.00515989 0.0375733 
v 0.097548 -0.00515989 0.0375967 
v 0.0958383 -0.00515989 0.0377827 
v 0.0950533 -0.00515989 0.0381459 
v 0.0943647 -0.00515989 0.0386693 
v 0.0938047 -0.00515989 0.0393285 
v 0.0933996 -0.00515989 0.0400927 
v 0.0931682 -0.00515989 0.0409262 
v 0.0931213 -0.00515989 0.0417899 
v 0.0932613 -0.00515989 0.0426434 
v 0.0935814 -0.00515989 0.0434469 
v 0.0940668 -0.00515989 0.0441628 
v 0.0946948 -0.00515989 0.0447577 
v 0.0954359 -0.00515989 0.0452036 
v 0.0962556 -0.00515989 0.0454798 
vn 0.343573 -0.00518232 -0.939112 
vn 0.131476 -0.0053369 -0.991305 
vn 0.534025 -0.00503746 -0.845454 
vn 0.343573 -0.00518232 -0.939112 
vn 0.696448 -0.00490735 -0.71759 
vn 0.534025 -0.00503746 -0.845454 
vn 0.82644 -0.00479529 -0.563005 
vn 0.696448 -0.00490735 -0.71759 
vn 0.921198 -0.0047033 -0.389065 
vn 0.82644 -0.00479529 -0.563005 
vn 0.979196 -0.00463254 -0.202862 
vn 0.921198 -0.0047033 -0.389065 
vn 0.999927 -0.00458359 -0.0111622 
vn 0.979196 -0.00463254 -0.202862 
vn 0.983732 -0.00455675 0.179585 
vn 0.999927 -0.00458359 -0.0111622 
vn 0.931694 -0.0045521 0.363216 
vn 0.983732 -0.00455675 0.179585 
vn 0.84559 -0.00456968 0.533814 
vn 0.931694 -0.0045521 0.363216 
vn 0.727887 -0.00460941 0.685681 
vn 0.84559 -0.00456968 0.533814 
vn 0.581791 -0.00467111 0.813325 
vn 0.727887 -0.00460941 0.685681 
vn 0.411329 -0.00475433 0.911474 
vn 0.581791 -0.00467111 0.813325 
vn 0.22148 -0.00485819 0.975153 
vn 0.411329 -0.00475433 0.911474 
vn 0.0183381 -0.00498108 0.999819 
vn 0.121142 -0.0049174 0.992623 
vn 0.22148 -0.00485819 0.975153 
vn -0.190711 -0.00512028 0.981633 
vn 0.0183381 -0.00498108 0.999819 
vn -0.396844 -0.00527155 0.917871 
vn -0.190711 -0.00512028 0.981633 
vn -0.58978 -0.00542863 0.807545 
vn -0.396844 -0.00527155 0.917871 
vn -0.75803 -0.00558308 0.652195 
vn -0.58978 -0.00542863 0.807545 
vn -0.889577 -0.00572434 0.456749 
vn -0.75803 -0.00558308 0.652195 
vn -0.97313 -0.00584062 0.230183 
vn -0.889577 -0.00572434 0.456749 
vn -0.999879 -0.00592054 -0.014418 
vn -0.97313 -0.00584062 0.230183 
vn -0.965378 -0.00595533 -0.260788 
vn -0.999879 -0.00592054 -0.014418 
vn -0.870889 -0.00594092 -0.491443 
vn -0.965378 -0.00595533 -0.260788 
vn -0.723552 -0.00587902 -0.690244 
vn -0.870889 -0.00594092 -0.491443 
vn -0.5352 -0.00577664 -0.844706 
vn -0.723552 -0.00587902 -0.690244 
vn -0.320262 -0.00564436 -0.947312 
vn -0.5352 -0.00577664 -0.844706 
vn -0.0935444 -0.00549404 -0.9956 
vn -0.320262 -0.00564436 -0.947312 
vn 0.125358 -0.991264 0.0409986 
vn 0.121142 -0.0049174 0.992623 
vn 0.318475 -0.00480376 0.947919 
vn 0.499319 -0.00471007 0.866406 
vn 0.658157 -0.00463754 0.752866 
vn 0.790506 -0.00458679 0.612437 
vn 0.892762 -0.00455812 0.450505 
vn 0.962098 -0.00455165 0.272665 
vn 0.996394 -0.0045674 0.0847219 
vn 0.994217 -0.00460532 -0.107289 
vn 0.954846 -0.00466522 -0.297066 
vn 0.878345 -0.0047467 -0.478004 
vn 0.765706 -0.00484891 -0.643172 
vn 0.619057 -0.00497032 -0.78533 
vn 0.441955 -0.00510832 -0.897023 
vn 0.239743 -0.00525879 -0.970822 
vn 0.0199382 -0.00541569 -0.999787 
vn 0.131476 -0.0053369 -0.991305 
vn 0.239743 -0.00525879 -0.970822 
vn 0.0199382 -0.00541569 -0.999787 
vn -0.207488 -0.00557072 -0.978222 
vn -0.430114 -0.0057135 -0.902756 
vn -0.633635 -0.00583229 -0.77361 
vn -0.803175 -0.00591558 -0.595713 
vn -0.925316 -0.00595431 -0.379151 
vn -0.990348 -0.00594396 -0.138475 
vn -0.994005 -0.00588576 0.109177 
vn -0.937984 -0.00578635 0.346629 
vn -0.829133 -0.00565608 0.559023 
vn -0.677742 -0.0055068 0.735279 
vn -0.495657 -0.00534984 0.868502 
vn -0.294751 -0.00519475 0.95556 
vn -0.0859646 -0.00504887 0.996285 
vn 0.126636 0.991084 0.0414163 
usemtl 0.647059_0.647059_0.647059_0.000000_0.000000
o mesh264
f 3702//3219 3703//3220 3704//3220 
f 3705//3221 3702//3219 3706//3222 
f 3707//3223 3705//3221 3708//3224 
f 3709//3225 3707//3223 3710//3226 
f 3711//3227 3709//3225 3712//3228 
f 3713//3229 3711//3227 3714//3230 
f 3715//3231 3713//3229 3716//3232 
f 3717//3233 3715//3231 3718//3234 
f 3719//3235 3717//3233 3720//3236 
f 3721//3237 3719//3235 3722//3238 
f 3723//3239 3721//3237 3724//3240 
f 3725//3241 3723//3239 3726//3242 
f 3727//3243 3725//3241 3728//3244 
f 3729//3245 3727//3243 3730//3246 
f 3731//3247 3732//3248 3733//3248 
f 3734//3249 3733//3248 3732//3248 
f 3732//3248 3729//3245 3734//3249 
f 3735//3250 3731//3247 3736//3251 
f 3737//3252 3735//3250 3738//3253 
f 3739//3254 3737//3252 3740//3255 
f 3741//3256 3739//3254 3742//3257 
f 3743//3258 3741//3256 3744//3259 
f 3745//3260 3743//3258 3746//3261 
f 3747//3262 3745//3260 3748//3263 
f 3749//3264 3747//3262 3750//3265 
f 3751//3266 3749//3264 3752//3267 
f 3753//3268 3751//3266 3754//3269 
f 3755//3270 3753//3268 3756//3271 
f 3757//3272 3755//3270 3758//3273 
f 3759//3274 3757//3272 3760//3275 
f 3703//3220 3759//3274 3761//3274 
f 3761//3274 3704//3220 3703//3220 
f 3760//3275 3761//3274 3759//3274 
f 3758//3273 3760//3275 3757//3272 
f 3756//3271 3758//3273 3755//3270 
f 3754//3269 3756//3271 3753//3268 
f 3752//3267 3754//3269 3751//3266 
f 3750//3265 3752//3267 3749//3264 
f 3748//3263 3750//3265 3747//3262 
f 3746//3261 3748//3263 3745//3260 
f 3744//3259 3746//3261 3743//3258 
f 3742//3257 3744//3259 3741//3256 
f 3740//3255 3742//3257 3739//3254 
f 3738//3253 3740//3255 3737//3252 
f 3736//3251 3738//3253 3735//3250 
f 3733//3248 3736//3251 3731//3247 
f 3730//3246 3734//3249 3729//3245 
f 3728//3244 3730//3246 3727//3243 
f 3726//3242 3728//3244 3725//3241 
f 3724//3240 3726//3242 3723//3239 
f 3722//3238 3724//3240 3721//3237 
f 3720//3236 3722//3238 3719//3235 
f 3718//3234 3720//3236 3717//3233 
f 3716//3232 3718//3234 3715//3231 
f 3714//3230 3716//3232 3713//3229 
f 3712//3228 3714//3230 3711//3227 
f 3710//3226 3712//3228 3709//3225 
f 3708//3224 3710//3226 3707//3223 
f 3706//3222 3708//3224 3705//3221 
f 3704//3220 3706//3222 3702//3219 
o mesh265
f 3762//3276 3763//3276 3758//3276 
f 3763//3276 3764//3276 3760//3276 
f 3764//3276 3765//3276 3761//3276 
f 3765//3276 3766//3276 3704//3276 
f 3767//3276 3736//3276 3733//3276 
f 3768//3276 3738//3276 3736//3276 
f 3769//3276 3754//3276 3752//3276 
f 3769//3276 3762//3276 3756//3276 
f 3760//3276 3758//3276 3763//3276 
f 3704//3276 3761//3276 3765//3276 
f 3770//3276 3712//3276 3710//3276 
f 3770//3276 3771//3276 3714//3276 
f 3772//3276 3728//3276 3726//3276 
f 3773//3276 3730//3276 3728//3276 
f 3773//3276 3774//3276 3734//3276 
f 3775//3276 3733//3276 3734//3276 
f 3736//3276 3767//3276 3768//3276 
f 3776//3276 3740//3276 3738//3276 
f 3776//3276 3777//3276 3742//3276 
f 3777//3276 3778//3276 3744//3276 
f 3779//3276 3746//3276 3744//3276 
f 3779//3276 3780//3276 3748//3276 
f 3781//3276 3752//3276 3750//3276 
f 3756//3276 3754//3276 3769//3276 
f 3761//3276 3760//3276 3764//3276 
f 3766//3276 3782//3276 3706//3276 
f 3783//3276 3710//3276 3708//3276 
f 3714//3276 3712//3276 3770//3276 
f 3784//3276 3724//3276 3722//3276 
f 3784//3276 3785//3276 3726//3276 
f 3728//3276 3772//3276 3773//3276 
f 3734//3276 3774//3276 3775//3276 
f 3738//3276 3768//3276 3776//3276 
f 3744//3276 3742//3276 3777//3276 
f 3748//3276 3746//3276 3779//3276 
f 3780//3276 3786//3276 3750//3276 
f 3752//3276 3781//3276 3769//3276 
f 3706//3276 3704//3276 3766//3276 
f 3787//3276 3708//3276 3706//3276 
f 3710//3276 3783//3276 3770//3276 
f 3788//3276 3718//3276 3716//3276 
f 3788//3276 3789//3276 3720//3276 
f 3726//3276 3724//3276 3784//3276 
f 3734//3276 3730//3276 3773//3276 
f 3742//3276 3740//3276 3776//3276 
f 3750//3276 3748//3276 3780//3276 
f 3758//3276 3756//3276 3762//3276 
f 3708//3276 3787//3276 3783//3276 
f 3790//3276 3716//3276 3714//3276 
f 3720//3276 3718//3276 3788//3276 
f 3791//3276 3722//3276 3720//3276 
f 3726//3276 3785//3276 3772//3276 
f 3744//3276 3778//3276 3779//3276 
f 3706//3276 3782//3276 3787//3276 
f 3716//3276 3790//3276 3788//3276 
f 3722//3276 3791//3276 3784//3276 
f 3750//3276 3786//3276 3781//3276 
f 3720//3276 3789//3276 3791//3276 
f 3714//3276 3771//3276 3790//3276 
f 3733//3276 3775//3276 3767//3276 
o mesh266
f 3792//3277 3766//3277 3765//3278 
f 3793//3278 3765//3278 3764//3279 
f 3794//3279 3764//3279 3763//3280 
f 3795//3280 3763//3280 3762//3281 
f 3796//3281 3762//3281 3769//3282 
f 3797//3282 3769//3282 3781//3283 
f 3798//3283 3781//3283 3786//3284 
f 3799//3284 3786//3284 3780//3285 
f 3800//3285 3780//3285 3779//3286 
f 3801//3286 3779//3286 3778//3287 
f 3802//3287 3778//3287 3777//3288 
f 3803//3288 3777//3288 3776//3289 
f 3804//3289 3776//3289 3768//3290 
f 3805//3290 3768//3290 3767//3291 
f 3806//3292 3807//3293 3775//3293 
f 3767//3291 3775//3293 3807//3293 
f 3807//3293 3808//3294 3767//3291 
f 3806//3292 3774//3295 3773//3296 
f 3809//3296 3773//3296 3772//3297 
f 3810//3297 3772//3297 3785//3298 
f 3811//3298 3785//3298 3784//3299 
f 3812//3299 3784//3299 3791//3300 
f 3813//3300 3791//3300 3789//3301 
f 3814//3301 3789//3301 3788//3302 
f 3815//3302 3788//3302 3790//3303 
f 3816//3303 3790//3303 3771//3304 
f 3817//3304 3771//3304 3770//3305 
f 3818//3305 3770//3305 3783//3306 
f 3819//3306 3783//3306 3787//3307 
f 3820//3307 3787//3307 3782//3308 
f 3821//3308 3782//3308 3766//3277 
f 3766//3277 3792//3277 3821//3308 
f 3782//3308 3821//3308 3820//3307 
f 3787//3307 3820//3307 3819//3306 
f 3783//3306 3819//3306 3818//3305 
f 3770//3305 3818//3305 3817//3304 
f 3771//3304 3817//3304 3816//3303 
f 3790//3303 3816//3303 3815//3302 
f 3788//3302 3815//3302 3814//3301 
f 3789//3301 3814//3301 3813//3300 
f 3791//3300 3813//3300 3812//3299 
f 3784//3299 3812//3299 3811//3298 
f 3785//3298 3811//3298 3810//3297 
f 3772//3297 3810//3297 3809//3296 
f 3773//3296 3809//3296 3806//3292 
f 3775//3293 3774//3295 3806//3292 
f 3767//3291 3808//3294 3805//3290 
f 3768//3290 3805//3290 3804//3289 
f 3776//3289 3804//3289 3803//3288 
f 3777//3288 3803//3288 3802//3287 
f 3778//3287 3802//3287 3801//3286 
f 3779//3286 3801//3286 3800//3285 
f 3780//3285 3800//3285 3799//3284 
f 3786//3284 3799//3284 3798//3283 
f 3781//3283 3798//3283 3797//3282 
f 3769//3282 3797//3282 3796//3281 
f 3762//3281 3796//3281 3795//3280 
f 3763//3280 3795//3280 3794//3279 
f 3764//3279 3794//3279 3793//3278 
f 3765//3278 3793//3278 3792//3277 
o mesh267
f 3808//3309 3807//3309 3732//3309 
f 3807//3309 3806//3309 3729//3309 
f 3805//3309 3808//3309 3731//3309 
f 3729//3309 3732//3309 3807//3309 
f 3793//3309 3759//3309 3703//3309 
f 3794//3309 3757//3309 3759//3309 
f 3732//3309 3731//3309 3808//3309 
f 3809//3309 3727//3309 3729//3309 
f 3759//3309 3793//3309 3794//3309 
f 3795//3309 3755//3309 3757//3309 
f 3797//3309 3751//3309 3753//3309 
f 3797//3309 3798//3309 3749//3309 
f 3804//3309 3805//3309 3735//3309 
f 3729//3309 3806//3309 3809//3309 
f 3809//3309 3810//3309 3725//3309 
f 3810//3309 3811//3309 3723//3309 
f 3757//3309 3794//3309 3795//3309 
f 3796//3309 3753//3309 3755//3309 
f 3749//3309 3751//3309 3797//3309 
f 3798//3309 3799//3309 3747//3309 
f 3801//3309 3743//3309 3745//3309 
f 3801//3309 3802//3309 3741//3309 
f 3803//3309 3739//3309 3741//3309 
f 3803//3309 3804//3309 3737//3309 
f 3731//3309 3735//3309 3805//3309 
f 3723//3309 3725//3309 3810//3309 
f 3755//3309 3795//3309 3796//3309 
f 3747//3309 3749//3309 3798//3309 
f 3800//3309 3745//3309 3747//3309 
f 3741//3309 3743//3309 3801//3309 
f 3737//3309 3739//3309 3803//3309 
f 3725//3309 3727//3309 3809//3309 
f 3812//3309 3721//3309 3723//3309 
f 3812//3309 3813//3309 3719//3309 
f 3753//3309 3796//3309 3797//3309 
f 3745//3309 3800//3309 3801//3309 
f 3735//3309 3737//3309 3804//3309 
f 3719//3309 3721//3309 3812//3309 
f 3818//3309 3709//3309 3711//3309 
f 3818//3309 3819//3309 3707//3309 
f 3747//3309 3799//3309 3800//3309 
f 3723//3309 3811//3309 3812//3309 
f 3815//3309 3715//3309 3717//3309 
f 3815//3309 3816//3309 3713//3309 
f 3707//3309 3709//3309 3818//3309 
f 3819//3309 3820//3309 3705//3309 
f 3741//3309 3802//3309 3803//3309 
f 3813//3309 3814//3309 3717//3309 
f 3713//3309 3715//3309 3815//3309 
f 3816//3309 3817//3309 3711//3309 
f 3705//3309 3707//3309 3819//3309 
f 3820//3309 3821//3309 3702//3309 
f 3717//3309 3719//3309 3813//3309 
f 3711//3309 3713//3309 3816//3309 
f 3702//3309 3705//3309 3820//3309 
f 3792//3309 3703//3309 3702//3309 
f 3717//3309 3814//3309 3815//3309 
f 3702//3309 3821//3309 3792//3309 
f 3711//3309 3817//3309 3818//3309 
f 3703//3309 3792//3309 3793//3309 
g 35cm_T2020
v 0.217735 0.139343 -0.115242 
v -0.132265 0.139343 -0.115242 
v -0.132265 0.135807 -0.111706 
v 0.217735 0.135807 -0.111706 
v -0.132265 0.131843 -0.111706 
v 0.217735 0.131843 -0.111706 
v -0.132265 0.131843 -0.115671 
v 0.217735 0.131843 -0.115671 
v -0.132265 0.135378 -0.119206 
v 0.217735 0.135378 -0.119206 
v -0.132265 0.135378 -0.124206 
v 0.217735 0.135378 -0.124206 
v -0.132265 0.131843 -0.127742 
v 0.217735 0.131843 -0.127742 
v -0.132265 0.131843 -0.131706 
v 0.217735 0.131843 -0.131706 
v -0.132265 0.135807 -0.131706 
v 0.217735 0.135807 -0.131706 
v -0.132265 0.139343 -0.128171 
v 0.217735 0.139343 -0.128171 
v -0.132265 0.144343 -0.128171 
v 0.217735 0.144343 -0.128171 
v -0.132265 0.147878 -0.131706 
v 0.217735 0.147878 -0.131706 
v -0.132265 0.151843 -0.131706 
v 0.217735 0.151843 -0.131706 
v -0.132265 0.151843 -0.127742 
v 0.217735 0.151843 -0.127742 
v -0.132265 0.148307 -0.124206 
v 0.217735 0.148307 -0.124206 
v -0.132265 0.148307 -0.119206 
v 0.217735 0.148307 -0.119206 
v -0.132265 0.151843 -0.115671 
v 0.217735 0.151843 -0.115671 
v -0.132265 0.151843 -0.111706 
v 0.217735 0.151843 -0.111706 
v 0.217735 0.147878 -0.111706 
v 0.217735 0.144343 -0.115242 
v -0.132265 0.147878 -0.111706 
v -0.132265 0.144343 -0.115242 
vn -0.130685 0.819046 0.558646 
vn -0.150827 0.138942 0.978747 
vn -0.147076 -0.976493 -0.157574 
vn -0.127242 -0.563037 -0.816577 
vn -0.16043 -0.70989 0.685797 
vn -0.147076 -0.976493 -0.157574 
vn -0.114438 0.10542 -0.987821 
vn -0.110794 0.694385 -0.711024 
vn -0.127242 -0.563037 -0.816577 
vn -0.114438 0.10542 -0.987821 
vn -0.116178 0.985398 -0.124471 
vn -0.130685 0.819046 0.558646 
vn -0.110794 0.694385 -0.711024 
vn -0.116178 0.985398 -0.124471 
vn 0.977584 0.137267 -0.159645 
vn -0.986651 0.106173 -0.123482 
vn -0.150827 0.138942 0.978747 
vn -0.16043 -0.70989 0.685797 
usemtl 0.301961_0.301961_0.301961_0.000000_0.000000
o mesh229
f 3822//3310 3823//3310 3824//3310 
f 3824//3310 3825//3310 3822//3310 
o mesh230
f 3825//3311 3824//3311 3826//3311 
f 3826//3311 3827//3311 3825//3311 
o mesh231
f 3827//3312 3826//3312 3828//3312 
f 3828//3312 3829//3312 3827//3312 
o mesh232
f 3829//3313 3828//3313 3830//3313 
f 3830//3313 3831//3313 3829//3313 
o mesh233
f 3831//3312 3830//3312 3832//3312 
f 3832//3312 3833//3312 3831//3312 
o mesh234
f 3833//3314 3832//3314 3834//3314 
f 3834//3314 3835//3314 3833//3314 
o mesh235
f 3835//3315 3834//3315 3836//3315 
f 3836//3315 3837//3315 3835//3315 
o mesh236
f 3837//3316 3836//3316 3838//3316 
f 3838//3316 3839//3316 3837//3316 
o mesh237
f 3839//3317 3838//3317 3840//3317 
f 3840//3317 3841//3317 3839//3317 
o mesh238
f 3841//3316 3840//3316 3842//3316 
f 3842//3316 3843//3316 3841//3316 
o mesh239
f 3843//3318 3842//3318 3844//3318 
f 3844//3318 3845//3318 3843//3318 
o mesh240
f 3845//3319 3844//3319 3846//3319 
f 3846//3319 3847//3319 3845//3319 
o mesh241
f 3847//3320 3846//3320 3848//3320 
f 3848//3320 3849//3320 3847//3320 
o mesh242
f 3849//3321 3848//3321 3850//3321 
f 3850//3321 3851//3321 3849//3321 
o mesh243
f 3851//3320 3850//3320 3852//3320 
f 3852//3320 3853//3320 3851//3320 
o mesh244
f 3853//3322 3852//3322 3854//3322 
f 3854//3322 3855//3322 3853//3322 
o mesh245
f 3855//3323 3854//3323 3856//3323 
f 3856//3323 3857//3323 3855//3323 
o mesh246
f 3858//3324 3853//3324 3855//3324 
f 3835//3324 3837//3324 3839//3324 
f 3833//3324 3841//3324 3851//3324 
f 3855//3324 3857//3324 3858//3324 
f 3841//3324 3833//3324 3835//3324 
f 3853//3324 3831//3324 3833//3324 
f 3845//3324 3847//3324 3849//3324 
f 3858//3324 3859//3324 3853//3324 
f 3851//3324 3853//3324 3833//3324 
f 3851//3324 3843//3324 3845//3324 
f 3825//3324 3827//3324 3829//3324 
f 3839//3324 3841//3324 3835//3324 
f 3851//3324 3841//3324 3843//3324 
f 3831//3324 3822//3324 3825//3324 
f 3849//3324 3851//3324 3845//3324 
f 3831//3324 3859//3324 3822//3324 
f 3829//3324 3831//3324 3825//3324 
f 3859//3324 3831//3324 3853//3324 
o mesh247
f 3832//3325 3852//3325 3850//3325 
f 3834//3325 3840//3325 3838//3325 
f 3860//3325 3856//3325 3854//3325 
f 3844//3325 3850//3325 3848//3325 
f 3850//3325 3840//3325 3832//3325 
f 3838//3325 3836//3325 3834//3325 
f 3852//3325 3861//3325 3860//3325 
f 3824//3325 3830//3325 3828//3325 
f 3848//3325 3846//3325 3844//3325 
f 3834//3325 3832//3325 3840//3325 
f 3852//3325 3830//3325 3861//3325 
f 3828//3325 3826//3325 3824//3325 
f 3844//3325 3842//3325 3850//3325 
f 3854//3325 3852//3325 3860//3325 
f 3824//3325 3823//3325 3830//3325 
f 3832//3325 3830//3325 3852//3325 
f 3842//3325 3840//3325 3850//3325 
f 3823//3325 3861//3325 3830//3325 
o mesh248
f 3857//3326 3856//3326 3860//3326 
f 3860//3326 3858//3326 3857//3326 
o mesh249
f 3858//3327 3860//3327 3861//3327 
f 3861//3327 3859//3327 3858//3327 
o mesh250
f 3859//3326 3861//3326 3823//3326 
f 3823//3326 3822//3326 3859//3326 
g 35cm_T2020
v -0.144306 -0.198478 -0.115378 
v -0.144306 0.151522 -0.115378 
v -0.147841 0.151522 -0.111843 
v -0.147841 -0.198478 -0.111843 
v -0.151806 0.151522 -0.111843 
v -0.151806 -0.198478 -0.111843 
v -0.151806 0.151522 -0.115807 
v -0.151806 -0.198478 -0.115807 
v -0.14827 0.151522 -0.119343 
v -0.14827 -0.198478 -0.119343 
v -0.14827 0.151522 -0.124343 
v -0.14827 -0.198478 -0.124343 
v -0.151806 0.151522 -0.127878 
v -0.151806 -0.198478 -0.127878 
v -0.151806 0.151522 -0.131843 
v -0.151806 -0.198478 -0.131843 
v -0.147841 0.151522 -0.131843 
v -0.147841 -0.198478 -0.131843 
v -0.144306 0.151522 -0.128307 
v -0.144306 -0.198478 -0.128307 
v -0.139306 0.151522 -0.128307 
v -0.139306 -0.198478 -0.128307 
v -0.13577 0.151522 -0.131843 
v -0.13577 -0.198478 -0.131843 
v -0.131806 0.151522 -0.131843 
v -0.131806 -0.198478 -0.131843 
v -0.131806 0.151522 -0.127878 
v -0.131806 -0.198478 -0.127878 
v -0.135341 0.151522 -0.124343 
v -0.135341 -0.198478 -0.124343 
v -0.135341 0.151522 -0.119343 
v -0.135341 -0.198478 -0.119343 
v -0.131806 0.151522 -0.115807 
v -0.131806 -0.198478 -0.115807 
v -0.131806 0.151522 -0.111843 
v -0.131806 -0.198478 -0.111843 
v -0.13577 -0.198478 -0.111843 
v -0.139306 -0.198478 -0.115378 
v -0.13577 0.151522 -0.111843 
v -0.139306 0.151522 -0.115378 
vn 0.681714 0.189427 0.706671 
vn -0.182558 0.170955 0.968218 
vn -0.984415 0.128387 -0.120185 
vn -0.709776 0.123772 -0.693469 
vn -0.829422 0.144636 0.539574 
vn -0.984415 0.128387 -0.120185 
vn -0.139108 0.130267 -0.981672 
vn 0.534448 0.148506 -0.832052 
vn -0.709776 0.123772 -0.693469 
vn -0.139108 0.130267 -0.981672 
vn 0.970684 0.175472 -0.164263 
vn 0.681714 0.189427 0.706671 
vn 0.534448 0.148506 -0.832052 
vn 0.970684 0.175472 -0.164263 
vn -0.184849 -0.969316 -0.162043 
vn -0.138124 0.982986 -0.121083 
vn -0.182558 0.170955 0.968218 
vn -0.829422 0.144636 0.539574 
o mesh229
f 3862//3328 3863//3328 3864//3328 
f 3864//3328 3865//3328 3862//3328 
o mesh230
f 3865//3329 3864//3329 3866//3329 
f 3866//3329 3867//3329 3865//3329 
o mesh231
f 3867//3330 3866//3330 3868//3330 
f 3868//3330 3869//3330 3867//3330 
o mesh232
f 3869//3331 3868//3331 3870//3331 
f 3870//3331 3871//3331 3869//3331 
o mesh233
f 3871//3330 3870//3330 3872//3330 
f 3872//3330 3873//3330 3871//3330 
o mesh234
f 3873//3332 3872//3332 3874//3332 
f 3874//3332 3875//3332 3873//3332 
o mesh235
f 3875//3333 3874//3333 3876//3333 
f 3876//3333 3877//3333 3875//3333 
o mesh236
f 3877//3334 3876//3334 3878//3334 
f 3878//3334 3879//3334 3877//3334 
o mesh237
f 3879//3335 3878//3335 3880//3335 
f 3880//3335 3881//3335 3879//3335 
o mesh238
f 3881//3334 3880//3334 3882//3334 
f 3882//3334 3883//3334 3881//3334 
o mesh239
f 3883//3336 3882//3336 3884//3336 
f 3884//3336 3885//3336 3883//3336 
o mesh240
f 3885//3337 3884//3337 3886//3337 
f 3886//3337 3887//3337 3885//3337 
o mesh241
f 3887//3338 3886//3338 3888//3338 
f 3888//3338 3889//3338 3887//3338 
o mesh242
f 3889//3339 3888//3339 3890//3339 
f 3890//3339 3891//3339 3889//3339 
o mesh243
f 3891//3338 3890//3338 3892//3338 
f 3892//3338 3893//3338 3891//3338 
o mesh244
f 3893//3340 3892//3340 3894//3340 
f 3894//3340 3895//3340 3893//3340 
o mesh245
f 3895//3341 3894//3341 3896//3341 
f 3896//3341 3897//3341 3895//3341 
o mesh246
f 3898//3342 3893//3342 3895//3342 
f 3875//3342 3877//3342 3879//3342 
f 3873//3342 3881//3342 3891//3342 
f 3895//3342 3897//3342 3898//3342 
f 3881//3342 3873//3342 3875//3342 
f 3893//3342 3871//3342 3873//3342 
f 3885//3342 3887//3342 3889//3342 
f 3898//3342 3899//3342 3893//3342 
f 3891//3342 3893//3342 3873//3342 
f 3891//3342 3883//3342 3885//3342 
f 3865//3342 3867//3342 3869//3342 
f 3879//3342 3881//3342 3875//3342 
f 3891//3342 3881//3342 3883//3342 
f 3871//3342 3862//3342 3865//3342 
f 3889//3342 3891//3342 3885//3342 
f 3871//3342 3899//3342 3862//3342 
f 3869//3342 3871//3342 3865//3342 
f 3899//3342 3871//3342 3893//3342 
o mesh247
f 3872//3343 3892//3343 3890//3343 
f 3874//3343 3880//3343 3878//3343 
f 3900//3343 3896//3343 3894//3343 
f 3884//3343 3890//3343 3888//3343 
f 3890//3343 3880//3343 3872//3343 
f 3878//3343 3876//3343 3874//3343 
f 3892//3343 3901//3343 3900//3343 
f 3864//3343 3870//3343 3868//3343 
f 3888//3343 3886//3343 3884//3343 
f 3874//3343 3872//3343 3880//3343 
f 3892//3343 3870//3343 3901//3343 
f 3868//3343 3866//3343 3864//3343 
f 3884//3343 3882//3343 3890//3343 
f 3894//3343 3892//3343 3900//3343 
f 3864//3343 3863//3343 3870//3343 
f 3872//3343 3870//3343 3892//3343 
f 3882//3343 3880//3343 3890//3343 
f 3863//3343 3901//3343 3870//3343 
o mesh248
f 3897//3344 3896//3344 3900//3344 
f 3900//3344 3898//3344 3897//3344 
o mesh249
f 3898//3345 3900//3345 3901//3345 
f 3901//3345 3899//3345 3898//3345 
o mesh250
f 3899//3344 3901//3344 3863//3344 
f 3863//3344 3862//3344 3899//3344 
g bearing
v 0.0266739 -0.0163599 -0.0283893 
v 0.0266155 -0.0163599 -0.0289267 
v 0.0266155 -0.00615989 -0.0289267 
v 0.0268465 -0.0163599 -0.027877 
v 0.0266739 -0.00615989 -0.0283893 
v 0.0271252 -0.0163599 -0.0274138 
v 0.0268465 -0.00615989 -0.027877 
v 0.027497 -0.0163599 -0.0270213 
v 0.0271252 -0.00615989 -0.0274138 
v 0.0279445 -0.0163599 -0.0267179 
v 0.027497 -0.00615989 -0.0270213 
v 0.0284467 -0.0163599 -0.0265178 
v 0.0279445 -0.00615989 -0.0267179 
v 0.0289801 -0.0163599 -0.0264304 
v 0.0284467 -0.00615989 -0.0265178 
v 0.0295199 -0.0163599 -0.0264596 
v 0.0289801 -0.00615989 -0.0264304 
v 0.0300408 -0.0163599 -0.0266043 
v 0.0295199 -0.00615989 -0.0264596 
v 0.0305184 -0.0163599 -0.0268575 
v 0.0300408 -0.00615989 -0.0266043 
v 0.0309305 -0.0163599 -0.0272075 
v 0.0305184 -0.00615989 -0.0268575 
v 0.0312576 -0.0163599 -0.0276378 
v 0.0309305 -0.00615989 -0.0272075 
v 0.0314846 -0.0163599 -0.0281284 
v 0.0312576 -0.00615989 -0.0276378 
v 0.0316008 -0.0163599 -0.0286564 
v 0.0314846 -0.00615989 -0.0281284 
v 0.0316008 -0.0163599 -0.029197 
v 0.0316008 -0.00615989 -0.0286564 
v 0.0314846 -0.0163599 -0.029725 
v 0.0316008 -0.00615989 -0.029197 
v 0.0312576 -0.0163599 -0.0302156 
v 0.0314846 -0.00615989 -0.029725 
v 0.0309305 -0.0163599 -0.030646 
v 0.0312576 -0.00615989 -0.0302156 
v 0.0305184 -0.0163599 -0.0309959 
v 0.0309305 -0.00615989 -0.030646 
v 0.0300408 -0.0163599 -0.0312491 
v 0.0305184 -0.00615989 -0.0309959 
v 0.0295199 -0.0163599 -0.0313938 
v 0.0300408 -0.00615989 -0.0312491 
v 0.0289801 -0.0163599 -0.031423 
v 0.0295199 -0.00615989 -0.0313938 
v 0.0284467 -0.0163599 -0.0313356 
v 0.0289801 -0.00615989 -0.031423 
v 0.0279445 -0.0163599 -0.0311355 
v 0.0284467 -0.00615989 -0.0313356 
v 0.027497 -0.0163599 -0.0308321 
v 0.0279445 -0.00615989 -0.0311355 
v 0.0271252 -0.0163599 -0.0304396 
v 0.027497 -0.00615989 -0.0308321 
v 0.0268465 -0.0163599 -0.0299764 
v 0.0271252 -0.00615989 -0.0304396 
v 0.0266739 -0.0163599 -0.0294641 
v 0.0268465 -0.00615989 -0.0299764 
v 0.0266739 -0.00615989 -0.0294641 
v 0.0359398 -0.00615989 -0.0353911 
v 0.0343906 -0.00615989 -0.036707 
v 0.0371699 -0.00615989 -0.0337729 
v 0.0286066 -0.00615989 -0.0383129 
v 0.0266007 -0.00615989 -0.0379841 
v 0.0325948 -0.00615989 -0.0376591 
v 0.0306362 -0.00615989 -0.0382029 
v 0.02303 -0.00615989 -0.036091 
v 0.0216322 -0.00615989 -0.0346153 
v 0.0199352 -0.00615989 -0.0309474 
v 0.0197155 -0.00615989 -0.0289267 
v 0.0247124 -0.00615989 -0.0372317 
v 0.0199352 -0.00615989 -0.026906 
v 0.0205843 -0.00615989 -0.0328737 
v 0.0359398 -0.00615989 -0.0224623 
v 0.0371699 -0.00615989 -0.0240805 
v 0.0343906 -0.00615989 -0.0211464 
v 0.0380234 -0.00615989 -0.0319281 
v 0.0205843 -0.00615989 -0.0249797 
v 0.0216322 -0.00615989 -0.0232381 
v 0.02303 -0.00615989 -0.0217624 
v 0.0247124 -0.00615989 -0.0206217 
v 0.0266007 -0.00615989 -0.0198693 
v 0.0286066 -0.00615989 -0.0195405 
v 0.0380234 -0.00615989 -0.0259253 
v 0.0384604 -0.00615989 -0.0279104 
v 0.0384604 -0.00615989 -0.029943 
v 0.0306362 -0.00615989 -0.0196505 
v 0.0325948 -0.00615989 -0.0201943 
v 0.0171155 -0.00875989 -0.0289267 
v 0.017396 -0.00875989 -0.0315063 
v 0.0182246 -0.00875989 -0.0339654 
v 0.0195624 -0.00875989 -0.0361888 
v 0.0213468 -0.00875989 -0.0380726 
v 0.0234946 -0.00875989 -0.0395288 
v 0.0259051 -0.00875989 -0.0404893 
v 0.0284658 -0.00875989 -0.0409091 
v 0.0310569 -0.00875989 -0.0407686 
v 0.0335571 -0.00875989 -0.0400744 
v 0.0358497 -0.00875989 -0.038859 
v 0.0378274 -0.00875989 -0.0371791 
v 0.0393978 -0.00875989 -0.0351133 
v 0.0404873 -0.00875989 -0.0327583 
v 0.0410451 -0.00875989 -0.0302241 
v 0.0410451 -0.00875989 -0.0276293 
v 0.0404873 -0.00875989 -0.0250951 
v 0.0393978 -0.00875989 -0.0227401 
v 0.0378274 -0.00875989 -0.0206743 
v 0.0358497 -0.00875989 -0.0189944 
v 0.0335571 -0.00875989 -0.017779 
v 0.0310569 -0.00875989 -0.0170848 
v 0.0284658 -0.00875989 -0.0169443 
v 0.0259051 -0.00875989 -0.0173641 
v 0.0234946 -0.00875989 -0.0183246 
v 0.0213468 -0.00875989 -0.0197808 
v 0.0195624 -0.00875989 -0.0216646 
v 0.0182246 -0.00875989 -0.023888 
v 0.017396 -0.00875989 -0.0263471 
v 0.0174647 -0.0137599 -0.0314912 
v 0.0171858 -0.0137599 -0.0302241 
v 0.0182884 -0.0137599 -0.0339358 
v 0.0177436 -0.0137599 -0.0327583 
v 0.0196184 -0.0137599 -0.0361462 
v 0.0188332 -0.0137599 -0.0351133 
v 0.0213924 -0.0137599 -0.038019 
v 0.0204035 -0.0137599 -0.0371791 
v 0.0235275 -0.0137599 -0.0394667 
v 0.0223812 -0.0137599 -0.038859 
v 0.025924 -0.0137599 -0.0404215 
v 0.0246738 -0.0137599 -0.0400744 
v 0.0284696 -0.0137599 -0.0408389 
v 0.0271741 -0.0137599 -0.0407686 
v 0.0310455 -0.0137599 -0.0406992 
v 0.0297651 -0.0137599 -0.0409091 
v 0.0335311 -0.0137599 -0.0400091 
v 0.0323258 -0.0137599 -0.0404893 
v 0.0358102 -0.0137599 -0.0388007 
v 0.0347364 -0.0137599 -0.0395288 
v 0.0368841 -0.0137599 -0.0380726 
v 0.0377764 -0.0137599 -0.0371307 
v 0.0386686 -0.0137599 -0.0361888 
v 0.0393375 -0.0137599 -0.0350771 
v 0.0400064 -0.0137599 -0.0339654 
v 0.0404207 -0.0137599 -0.0327359 
v 0.0409752 -0.0137599 -0.0302165 
v 0.0408349 -0.0137599 -0.0315063 
v 0.0409752 -0.0137599 -0.0276369 
v 0.0411155 -0.0137599 -0.0289267 
v 0.0404207 -0.0137599 -0.0251175 
v 0.0408349 -0.0137599 -0.0263471 
v 0.0393375 -0.0137599 -0.0227763 
v 0.0400064 -0.0137599 -0.023888 
v 0.0377764 -0.0137599 -0.0207227 
v 0.0386686 -0.0137599 -0.0216646 
v 0.0358102 -0.0137599 -0.0190527 
v 0.0368841 -0.0137599 -0.0197808 
v 0.0335311 -0.0137599 -0.0178443 
v 0.0347364 -0.0137599 -0.0183246 
v 0.0310455 -0.0137599 -0.0171542 
v 0.0323258 -0.0137599 -0.0173641 
v 0.0284696 -0.0137599 -0.0170145 
v 0.0297651 -0.0137599 -0.0169443 
v 0.025924 -0.0137599 -0.0174319 
v 0.0271741 -0.0137599 -0.0170848 
v 0.0235275 -0.0137599 -0.0183867 
v 0.0246738 -0.0137599 -0.017779 
v 0.0213924 -0.0137599 -0.0198344 
v 0.0223812 -0.0137599 -0.0189944 
v 0.0196184 -0.0137599 -0.0217072 
v 0.0204035 -0.0137599 -0.0206743 
v 0.0182884 -0.0137599 -0.0239176 
v 0.0188332 -0.0137599 -0.0227401 
v 0.0174647 -0.0137599 -0.0263622 
v 0.0177436 -0.0137599 -0.0250951 
v 0.0171155 -0.0137599 -0.0289267 
v 0.0171858 -0.0137599 -0.0276293 
v 0.0382957 -0.0163599 -0.0309474 
v 0.0385155 -0.0163599 -0.0289267 
v 0.0376467 -0.0163599 -0.0328737 
v 0.0365987 -0.0163599 -0.0346153 
v 0.0352009 -0.0163599 -0.036091 
v 0.0335185 -0.0163599 -0.0372317 
v 0.0316302 -0.0163599 -0.0379841 
v 0.0296244 -0.0163599 -0.0383129 
v 0.0275947 -0.0163599 -0.0382029 
v 0.0256362 -0.0163599 -0.0376591 
v 0.0238403 -0.0163599 -0.036707 
v 0.0222911 -0.0163599 -0.0353911 
v 0.021061 -0.0163599 -0.0337729 
v 0.0202075 -0.0163599 -0.0319281 
v 0.0197706 -0.0163599 -0.029943 
v 0.0197155 -0.0163599 -0.0289267 
v 0.0197706 -0.0163599 -0.0279104 
v 0.0202075 -0.0163599 -0.0259253 
v 0.021061 -0.0163599 -0.0240805 
v 0.0222911 -0.0163599 -0.0224623 
v 0.0238403 -0.0163599 -0.0211464 
v 0.0256362 -0.0163599 -0.0201943 
v 0.0275947 -0.0163599 -0.0196505 
v 0.0296244 -0.0163599 -0.0195405 
v 0.0316302 -0.0163599 -0.0198693 
v 0.0335185 -0.0163599 -0.0206217 
v 0.0352009 -0.0163599 -0.0217624 
v 0.0365987 -0.0163599 -0.0232381 
v 0.0376467 -0.0163599 -0.0249797 
v 0.0382957 -0.0163599 -0.026906 
vn 0.97171 -0.0158064 -0.235646 
vn 0.999479 -0.0158888 -0.0280937 
vn 0.90171 -0.0157489 -0.432055 
vn 0.97171 -0.0158064 -0.235646 
vn 0.792839 -0.0157182 -0.609228 
vn 0.90171 -0.0157489 -0.432055 
vn 0.649839 -0.0157151 -0.75991 
vn 0.792839 -0.0157182 -0.609228 
vn 0.478667 -0.0157398 -0.877856 
vn 0.649839 -0.0157151 -0.75991 
vn 0.286339 -0.0157916 -0.957998 
vn 0.478667 -0.0157398 -0.877856 
vn 0.0807544 -0.0158686 -0.996608 
vn 0.286339 -0.0157916 -0.957998 
vn -0.129493 -0.0159685 -0.991452 
vn 0.0807544 -0.0158686 -0.996608 
vn -0.335346 -0.0160876 -0.941958 
vn -0.129493 -0.0159685 -0.991452 
vn -0.527565 -0.0162213 -0.84936 
vn -0.335346 -0.0160876 -0.941958 
vn -0.697067 -0.0163643 -0.716819 
vn -0.527565 -0.0162213 -0.84936 
vn -0.835343 -0.0165101 -0.549481 
vn -0.697067 -0.0163643 -0.716819 
vn -0.93493 -0.0166518 -0.354443 
vn -0.835343 -0.0165101 -0.549481 
vn -0.989927 -0.0167821 -0.140582 
vn -0.93493 -0.0166518 -0.354443 
vn -0.996508 -0.0168937 0.0817761 
vn -0.989927 -0.0167821 -0.140582 
vn -0.953353 -0.01698 0.301381 
vn -0.996508 -0.0168937 0.0817761 
vn -0.861936 -0.0170357 0.50673 
vn -0.953353 -0.01698 0.301381 
vn -0.726591 -0.0170574 0.686859 
vn -0.861936 -0.0170357 0.50673 
vn -0.554305 -0.0170435 0.832139 
vn -0.726591 -0.0170574 0.686859 
vn -0.354262 -0.016995 0.934992 
vn -0.554305 -0.0170435 0.832139 
vn -0.137168 -0.016915 0.990403 
vn -0.354262 -0.016995 0.934992 
vn 0.0855372 -0.0168085 0.996193 
vn -0.137168 -0.016915 0.990403 
vn 0.30248 -0.0166817 0.95301 
vn 0.0855372 -0.0168085 0.996193 
vn 0.503059 -0.0165419 0.864094 
vn 0.30248 -0.0166817 0.95301 
vn 0.67801 -0.0163964 0.73487 
vn 0.503059 -0.0165419 0.864094 
vn 0.819776 -0.0162522 0.572454 
vn 0.67801 -0.0163964 0.73487 
vn 0.922721 -0.0161159 0.385132 
vn 0.819776 -0.0162522 0.572454 
vn 0.983192 -0.0159932 0.181873 
vn 0.922721 -0.0161159 0.385132 
vn 0.029574 0.999131 -0.0293822 
vn -0.700174 0.713347 -0.0298731 
vn -0.679575 0.709664 -0.185889 
vn -0.625719 0.705497 -0.332791 
vn -0.541778 0.701061 -0.463671 
vn -0.432272 0.696574 -0.572647 
vn -0.302755 0.692247 -0.655083 
vn -0.159481 0.688268 -0.70771 
vn -0.00908764 0.684803 -0.728672 
vn 0.141693 0.681989 -0.717505 
vn 0.28629 0.679934 -0.675077 
vn 0.418513 0.678711 -0.603489 
vn 0.532747 0.678364 -0.505968 
vn 0.624119 0.678906 -0.386733 
vn 0.688649 0.680317 -0.250861 
vn 0.723386 0.682547 -0.104127 
vn 0.726531 0.685513 0.0471649 
vn 0.697545 0.689104 0.196385 
vn 0.637237 0.693175 0.336805 
vn 0.547818 0.697555 0.461858 
vn 0.432903 0.702048 0.56544 
vn 0.297452 0.706444 0.64223 
vn 0.147621 0.710523 0.688015 
vn -0.00947605 0.714072 0.700008 
vn -0.166114 0.716895 0.677103 
vn -0.314382 0.718832 0.620036 
vn -0.446667 0.71977 0.531432 
vn -0.556146 0.719653 0.415693 
vn -0.637242 0.718488 0.278742 
vn -0.685972 0.716345 0.127642 
vn -0.968295 -0.0167189 -0.249249 
vn -0.989927 -0.0167821 -0.140582 
vn -0.999415 -0.0168406 -0.0297767 
vn -0.890384 -0.016582 -0.454908 
vn -0.93493 -0.0166518 -0.354443 
vn -0.770606 -0.0164373 -0.6371 
vn -0.835343 -0.0165101 -0.549481 
vn -0.615706 -0.016292 -0.787807 
vn -0.697067 -0.0163643 -0.716819 
vn -0.433735 -0.0161529 -0.900895 
vn -0.527565 -0.0162213 -0.84936 
vn -0.233545 -0.0160259 -0.972214 
vn -0.335346 -0.0160876 -0.941958 
vn -0.0243443 -0.0159159 -0.999577 
vn -0.129493 -0.0159685 -0.991452 
vn 0.18468 -0.0158271 -0.982671 
vn 0.0807544 -0.0158686 -0.996608 
vn 0.384672 -0.0157624 -0.922919 
vn 0.286339 -0.0157916 -0.957998 
vn 0.567359 -0.015724 -0.823321 
vn 0.478667 -0.0157398 -0.877856 
vn 0.72526 -0.0157131 -0.688296 
vn 0.649839 -0.0157151 -0.75991 
vn 0.851868 -0.0157301 -0.523521 
vn 0.792839 -0.0157182 -0.609228 
vn 0.941813 -0.0157744 -0.335766 
vn 0.90171 -0.0157489 -0.432055 
vn 0.991026 -0.0158446 -0.132729 
vn 0.97171 -0.0158064 -0.235646 
vn 0.996892 -0.0159384 0.0771521 
vn 0.999479 -0.0158888 -0.0280937 
vn 0.958417 -0.0160525 0.284919 
vn 0.983192 -0.0159932 0.181873 
vn 0.876376 -0.0161827 0.481356 
vn 0.922721 -0.0161159 0.385132 
vn 0.75344 -0.0163237 0.657315 
vn 0.819776 -0.0162522 0.572454 
vn 0.594254 -0.0164694 0.804109 
vn 0.67801 -0.0163964 0.73487 
vn 0.405431 -0.016613 0.913975 
vn 0.503059 -0.0165419 0.864094 
vn 0.195417 -0.0167472 0.980577 
vn 0.30248 -0.0166817 0.95301 
vn -0.0257956 -0.0168647 0.999525 
vn 0.0855372 -0.0168085 0.996193 
vn -0.247139 -0.0169587 0.968832 
vn -0.137168 -0.016915 0.990403 
vn -0.457111 -0.0170234 0.889247 
vn -0.354262 -0.016995 0.934992 
vn -0.644536 -0.0170549 0.764384 
vn -0.554305 -0.0170435 0.832139 
vn -0.799376 -0.017051 0.600589 
vn -0.726591 -0.0170574 0.686859 
vn -0.913472 -0.0170119 0.406545 
vn -0.861936 -0.0170357 0.50673 
vn -0.981122 -0.0169403 0.192645 
vn -0.953353 -0.01698 0.301381 
vn -0.999415 -0.0168406 -0.0297767 
vn -0.996508 -0.0168937 0.0817761 
vn 0.694423 -0.698067 -0.174581 
vn 0.707578 -0.699256 -0.101852 
vn 0.712979 -0.700626 -0.0280134 
vn 0.645652 -0.696274 -0.313586 
vn 0.673696 -0.69707 -0.245414 
vn 0.568998 -0.695312 -0.43907 
vn 0.610621 -0.695686 -0.378369 
vn 0.467874 -0.695216 -0.545682 
vn 0.521243 -0.695155 -0.495042 
vn 0.346645 -0.695989 -0.628838 
vn 0.409466 -0.695495 -0.590444 
vn 0.210483 -0.697604 -0.684869 
vn 0.28008 -0.696694 -0.660433 
vn 0.0652115 -0.700002 -0.711158 
vn 0.138602 -0.69871 -0.70185 
vn -0.0828799 -0.703092 -0.706252 
vn -0.00888778 -0.701467 -0.712646 
vn -0.227238 -0.706755 -0.66997 
vn -0.155939 -0.704861 -0.691993 
vn -0.361286 -0.71084 -0.603472 
vn -0.295956 -0.708755 -0.640372 
vn -0.47869 -0.715173 -0.509297 
vn -0.422447 -0.712988 -0.559631 
vn -0.573657 -0.719557 -0.391352 
vn -0.52931 -0.717371 -0.453 
vn -0.641255 -0.723781 -0.254818 
vn -0.611143 -0.721702 -0.325038 
vn -0.677728 -0.727634 -0.105985 
vn -0.663563 -0.725767 -0.181509 
vn -0.680781 -0.730912 0.0480141 
vn -0.683511 -0.729357 -0.0291622 
vn -0.649807 -0.733433 0.199566 
vn -0.669515 -0.732277 0.124579 
vn -0.586013 -0.735056 0.341001 
vn -0.621865 -0.734364 0.272016 
vn -0.492418 -0.735684 0.465074 
vn -0.542684 -0.735498 0.405631 
vn -0.373709 -0.735281 0.565423 
vn -0.435852 -0.735611 0.518565 
vn -0.235957 -0.733872 0.63699 
vn -0.306789 -0.734699 0.605061 
vn -0.086233 -0.731537 0.676326 
vn -0.162123 -0.732813 0.660834 
vn 0.0678581 -0.728411 0.681771 
vn -0.00925009 -0.730063 0.683317 
vn 0.218649 -0.724668 0.65349 
vn 0.144135 -0.726605 0.671766 
vn 0.358856 -0.720507 0.593373 
vn 0.290505 -0.722627 0.62723 
vn 0.481956 -0.71614 0.504838 
vn 0.422914 -0.718336 0.552392 
vn 0.582474 -0.711779 0.39255 
vn 0.535333 -0.713946 0.451331 
vn 0.656176 -0.707623 0.262111 
vn 0.622889 -0.709663 0.329221 
vn 0.70018 -0.703854 0.119744 
vn 0.682017 -0.70568 0.192014 
vn 0.71052 -0.702163 0.0461256 
vn 0.712979 -0.700626 -0.0280134 
vn 0.0286235 -0.999186 -0.0284379 
usemtl 0.400000_0.400000_0.400000_0.000000_0.000000
o mesh3
f 3902//3346 3903//3347 3904//3347 
f 3905//3348 3902//3346 3906//3349 
f 3907//3350 3905//3348 3908//3351 
f 3909//3352 3907//3350 3910//3353 
f 3911//3354 3909//3352 3912//3355 
f 3913//3356 3911//3354 3914//3357 
f 3915//3358 3913//3356 3916//3359 
f 3917//3360 3915//3358 3918//3361 
f 3919//3362 3917//3360 3920//3363 
f 3921//3364 3919//3362 3922//3365 
f 3923//3366 3921//3364 3924//3367 
f 3925//3368 3923//3366 3926//3369 
f 3927//3370 3925//3368 3928//3371 
f 3929//3372 3927//3370 3930//3373 
f 3931//3374 3929//3372 3932//3375 
f 3933//3376 3931//3374 3934//3377 
f 3935//3378 3933//3376 3936//3379 
f 3937//3380 3935//3378 3938//3381 
f 3939//3382 3937//3380 3940//3383 
f 3941//3384 3939//3382 3942//3385 
f 3943//3386 3941//3384 3944//3387 
f 3945//3388 3943//3386 3946//3389 
f 3947//3390 3945//3388 3948//3391 
f 3949//3392 3947//3390 3950//3393 
f 3951//3394 3949//3392 3952//3395 
f 3953//3396 3951//3394 3954//3397 
f 3955//3398 3953//3396 3956//3399 
f 3957//3400 3955//3398 3958//3401 
f 3903//3347 3957//3400 3959//3400 
f 3959//3400 3904//3347 3903//3347 
f 3958//3401 3959//3400 3957//3400 
f 3956//3399 3958//3401 3955//3398 
f 3954//3397 3956//3399 3953//3396 
f 3952//3395 3954//3397 3951//3394 
f 3950//3393 3952//3395 3949//3392 
f 3948//3391 3950//3393 3947//3390 
f 3946//3389 3948//3391 3945//3388 
f 3944//3387 3946//3389 3943//3386 
f 3942//3385 3944//3387 3941//3384 
f 3940//3383 3942//3385 3939//3382 
f 3938//3381 3940//3383 3937//3380 
f 3936//3379 3938//3381 3935//3378 
f 3934//3377 3936//3379 3933//3376 
f 3932//3375 3934//3377 3931//3374 
f 3930//3373 3932//3375 3929//3372 
f 3928//3371 3930//3373 3927//3370 
f 3926//3369 3928//3371 3925//3368 
f 3924//3367 3926//3369 3923//3366 
f 3922//3365 3924//3367 3921//3364 
f 3920//3363 3922//3365 3919//3362 
f 3918//3361 3920//3363 3917//3360 
f 3916//3359 3918//3361 3915//3358 
f 3914//3357 3916//3359 3913//3356 
f 3912//3355 3914//3357 3911//3354 
f 3910//3353 3912//3355 3909//3352 
f 3908//3351 3910//3353 3907//3350 
f 3906//3349 3908//3351 3905//3348 
f 3904//3347 3906//3349 3902//3346 
o mesh4
f 3960//3402 3940//3402 3938//3402 
f 3960//3402 3961//3402 3942//3402 
f 3962//3402 3938//3402 3936//3402 
f 3942//3402 3940//3402 3960//3402 
f 3963//3402 3948//3402 3946//3402 
f 3963//3402 3964//3402 3950//3402 
f 3938//3402 3962//3402 3960//3402 
f 3961//3402 3965//3402 3944//3402 
f 3966//3402 3946//3402 3944//3402 
f 3950//3402 3948//3402 3963//3402 
f 3967//3402 3954//3402 3952//3402 
f 3967//3402 3968//3402 3956//3402 
f 3969//3402 3959//3402 3958//3402 
f 3970//3402 3904//3402 3959//3402 
f 3944//3402 3942//3402 3961//3402 
f 3946//3402 3966//3402 3963//3402 
f 3971//3402 3952//3402 3950//3402 
f 3956//3402 3954//3402 3967//3402 
f 3959//3402 3969//3402 3970//3402 
f 3972//3402 3906//3402 3904//3402 
f 3944//3402 3965//3402 3966//3402 
f 3952//3402 3971//3402 3967//3402 
f 3973//3402 3958//3402 3956//3402 
f 3904//3402 3970//3402 3972//3402 
f 3974//3402 3926//3402 3924//3402 
f 3975//3402 3928//3402 3926//3402 
f 3950//3402 3964//3402 3971//3402 
f 3958//3402 3973//3402 3969//3402 
f 3976//3402 3924//3402 3922//3402 
f 3926//3402 3974//3402 3975//3402 
f 3977//3402 3936//3402 3934//3402 
f 3956//3402 3968//3402 3973//3402 
f 3978//3402 3908//3402 3906//3402 
f 3979//3402 3910//3402 3908//3402 
f 3980//3402 3912//3402 3910//3402 
f 3981//3402 3914//3402 3912//3402 
f 3982//3402 3916//3402 3914//3402 
f 3982//3402 3983//3402 3918//3402 
f 3924//3402 3976//3402 3974//3402 
f 3984//3402 3930//3402 3928//3402 
f 3985//3402 3932//3402 3930//3402 
f 3986//3402 3934//3402 3932//3402 
f 3936//3402 3977//3402 3962//3402 
f 3908//3402 3978//3402 3979//3402 
f 3912//3402 3980//3402 3981//3402 
f 3918//3402 3916//3402 3982//3402 
f 3987//3402 3920//3402 3918//3402 
f 3988//3402 3922//3402 3920//3402 
f 3928//3402 3975//3402 3984//3402 
f 3932//3402 3985//3402 3986//3402 
f 3906//3402 3972//3402 3978//3402 
f 3914//3402 3981//3402 3982//3402 
f 3920//3402 3987//3402 3988//3402 
f 3930//3402 3984//3402 3985//3402 
f 3910//3402 3979//3402 3980//3402 
f 3922//3402 3988//3402 3976//3402 
f 3918//3402 3983//3402 3987//3402 
f 3934//3402 3986//3402 3977//3402 
o mesh5
f 3989//3403 3970//3403 3969//3404 
f 3990//3404 3969//3404 3973//3405 
f 3991//3405 3973//3405 3968//3406 
f 3992//3406 3968//3406 3967//3407 
f 3993//3407 3967//3407 3971//3408 
f 3994//3408 3971//3408 3964//3409 
f 3995//3409 3964//3409 3963//3410 
f 3996//3410 3963//3410 3966//3411 
f 3997//3411 3966//3411 3965//3412 
f 3998//3412 3965//3412 3961//3413 
f 3999//3413 3961//3413 3960//3414 
f 4000//3414 3960//3414 3962//3415 
f 4001//3415 3962//3415 3977//3416 
f 4002//3416 3977//3416 3986//3417 
f 4003//3417 3986//3417 3985//3418 
f 4004//3418 3985//3418 3984//3419 
f 4005//3419 3984//3419 3975//3420 
f 4006//3420 3975//3420 3974//3421 
f 4007//3421 3974//3421 3976//3422 
f 4008//3422 3976//3422 3988//3423 
f 4009//3423 3988//3423 3987//3424 
f 4010//3424 3987//3424 3983//3425 
f 4011//3425 3983//3425 3982//3426 
f 4012//3426 3982//3426 3981//3427 
f 4013//3427 3981//3427 3980//3428 
f 4014//3428 3980//3428 3979//3429 
f 4015//3429 3979//3429 3978//3430 
f 4016//3430 3978//3430 3972//3431 
f 4017//3431 3972//3431 3970//3403 
f 3970//3403 3989//3403 4017//3431 
f 3972//3431 4017//3431 4016//3430 
f 3978//3430 4016//3430 4015//3429 
f 3979//3429 4015//3429 4014//3428 
f 3980//3428 4014//3428 4013//3427 
f 3981//3427 4013//3427 4012//3426 
f 3982//3426 4012//3426 4011//3425 
f 3983//3425 4011//3425 4010//3424 
f 3987//3424 4010//3424 4009//3423 
f 3988//3423 4009//3423 4008//3422 
f 3976//3422 4008//3422 4007//3421 
f 3974//3421 4007//3421 4006//3420 
f 3975//3420 4006//3420 4005//3419 
f 3984//3419 4005//3419 4004//3418 
f 3985//3418 4004//3418 4003//3417 
f 3986//3417 4003//3417 4002//3416 
f 3977//3416 4002//3416 4001//3415 
f 3962//3415 4001//3415 4000//3414 
f 3960//3414 4000//3414 3999//3413 
f 3961//3413 3999//3413 3998//3412 
f 3965//3412 3998//3412 3997//3411 
f 3966//3411 3997//3411 3996//3410 
f 3963//3410 3996//3410 3995//3409 
f 3964//3409 3995//3409 3994//3408 
f 3971//3408 3994//3408 3993//3407 
f 3967//3407 3993//3407 3992//3406 
f 3968//3406 3992//3406 3991//3405 
f 3973//3405 3991//3405 3990//3404 
f 3969//3404 3990//3404 3989//3403 
o mesh6
f 3990//3432 4018//3432 4019//3433 
f 4019//3433 3989//3434 3990//3432 
f 3991//3435 4020//3435 4021//3436 
f 4021//3436 3990//3432 3991//3435 
f 3992//3437 4022//3437 4023//3438 
f 4023//3438 3991//3435 3992//3437 
f 3993//3439 4024//3439 4025//3440 
f 4025//3440 3992//3437 3993//3439 
f 3994//3441 4026//3441 4027//3442 
f 4027//3442 3993//3439 3994//3441 
f 3995//3443 4028//3443 4029//3444 
f 4029//3444 3994//3441 3995//3443 
f 3996//3445 4030//3445 4031//3446 
f 4031//3446 3995//3443 3996//3445 
f 3997//3447 4032//3447 4033//3448 
f 4033//3448 3996//3445 3997//3447 
f 3998//3449 4034//3449 4035//3450 
f 4035//3450 3997//3447 3998//3449 
f 3999//3451 4036//3451 4037//3452 
f 4037//3452 3998//3449 3999//3451 
f 3999//3451 4000//3453 4038//3454 
f 4000//3453 4039//3453 4038//3454 
f 4000//3453 4001//3455 4040//3456 
f 4001//3455 4041//3455 4040//3456 
f 4001//3455 4002//3457 4042//3458 
f 4002//3457 4043//3457 4042//3458 
f 4003//3459 4044//3459 4045//3460 
f 4045//3460 4002//3457 4003//3459 
f 4004//3461 4046//3461 4047//3462 
f 4047//3462 4003//3459 4004//3461 
f 4005//3463 4048//3463 4049//3464 
f 4049//3464 4004//3461 4005//3463 
f 4006//3465 4050//3465 4051//3466 
f 4051//3466 4005//3463 4006//3465 
f 4007//3467 4052//3467 4053//3468 
f 4053//3468 4006//3465 4007//3467 
f 4008//3469 4054//3469 4055//3470 
f 4055//3470 4007//3467 4008//3469 
f 4009//3471 4056//3471 4057//3472 
f 4057//3472 4008//3469 4009//3471 
f 4010//3473 4058//3473 4059//3474 
f 4059//3474 4009//3471 4010//3473 
f 4011//3475 4060//3475 4061//3476 
f 4061//3476 4010//3473 4011//3475 
f 4012//3477 4062//3477 4063//3478 
f 4063//3478 4011//3475 4012//3477 
f 4013//3479 4064//3479 4065//3480 
f 4065//3480 4012//3477 4013//3479 
f 4014//3481 4066//3481 4067//3482 
f 4067//3482 4013//3479 4014//3481 
f 4015//3483 4068//3483 4069//3484 
f 4069//3484 4014//3481 4015//3483 
f 4016//3485 4070//3485 4071//3486 
f 4071//3486 4015//3483 4016//3485 
f 4017//3487 4072//3487 4073//3488 
f 4073//3488 4016//3485 4017//3487 
f 3989//3434 4074//3489 4075//3490 
f 4075//3490 4017//3487 3989//3434 
f 4075//3490 4072//3487 4017//3487 
f 4073//3488 4070//3485 4016//3485 
f 4071//3486 4068//3483 4015//3483 
f 4069//3484 4066//3481 4014//3481 
f 4067//3482 4064//3479 4013//3479 
f 4065//3480 4062//3477 4012//3477 
f 4063//3478 4060//3475 4011//3475 
f 4061//3476 4058//3473 4010//3473 
f 4059//3474 4056//3471 4009//3471 
f 4057//3472 4054//3469 4008//3469 
f 4055//3470 4052//3467 4007//3467 
f 4053//3468 4050//3465 4006//3465 
f 4051//3466 4048//3463 4005//3463 
f 4049//3464 4046//3461 4004//3461 
f 4047//3462 4044//3459 4003//3459 
f 4045//3460 4043//3457 4002//3457 
f 4042//3458 4041//3455 4001//3455 
f 4040//3456 4039//3453 4000//3453 
f 4038//3454 4036//3451 3999//3451 
f 4037//3452 4034//3449 3998//3449 
f 4035//3450 4032//3447 3997//3447 
f 4033//3448 4030//3445 3996//3445 
f 4031//3446 4028//3443 3995//3443 
f 4029//3444 4026//3441 3994//3441 
f 4027//3442 4024//3439 3993//3439 
f 4025//3440 4022//3437 3992//3437 
f 4023//3438 4020//3435 3991//3435 
f 4021//3436 4018//3432 3990//3432 
f 4019//3433 4074//3489 3989//3434 
o mesh7
f 4076//3491 4045//3491 4044//3492 
f 4044//3492 4077//3493 4076//3491 
f 4078//3494 4042//3494 4043//3495 
f 4043//3495 4076//3491 4078//3494 
f 4079//3496 4040//3496 4041//3497 
f 4041//3497 4078//3494 4079//3496 
f 4080//3498 4038//3498 4039//3499 
f 4039//3499 4079//3496 4080//3498 
f 4081//3500 4037//3500 4036//3501 
f 4036//3501 4080//3498 4081//3500 
f 4082//3502 4035//3502 4034//3503 
f 4034//3503 4081//3500 4082//3502 
f 4083//3504 4033//3504 4032//3505 
f 4032//3505 4082//3502 4083//3504 
f 4084//3506 4031//3506 4030//3507 
f 4030//3507 4083//3504 4084//3506 
f 4085//3508 4029//3508 4028//3509 
f 4028//3509 4084//3506 4085//3508 
f 4086//3510 4027//3510 4026//3511 
f 4026//3511 4085//3508 4086//3510 
f 4087//3512 4025//3512 4024//3513 
f 4024//3513 4086//3510 4087//3512 
f 4088//3514 4023//3514 4022//3515 
f 4022//3515 4087//3512 4088//3514 
f 4089//3516 4021//3516 4020//3517 
f 4020//3517 4088//3514 4089//3516 
f 4090//3518 4019//3518 4018//3519 
f 4018//3519 4089//3516 4090//3518 
f 4075//3520 4074//3521 4091//3521 
f 4019//3518 4090//3518 4091//3521 
f 4091//3521 4074//3521 4019//3518 
f 4092//3520 4093//3522 4072//3523 
f 4093//3522 4073//3522 4072//3523 
f 4093//3522 4094//3524 4070//3525 
f 4094//3524 4071//3524 4070//3525 
f 4094//3524 4095//3526 4068//3527 
f 4095//3526 4069//3526 4068//3527 
f 4096//3528 4067//3528 4066//3529 
f 4066//3529 4095//3526 4096//3528 
f 4097//3530 4065//3530 4064//3531 
f 4064//3531 4096//3528 4097//3530 
f 4098//3532 4063//3532 4062//3533 
f 4062//3533 4097//3530 4098//3532 
f 4099//3534 4061//3534 4060//3535 
f 4060//3535 4098//3532 4099//3534 
f 4100//3536 4059//3536 4058//3537 
f 4058//3537 4099//3534 4100//3536 
f 4101//3538 4057//3538 4056//3539 
f 4056//3539 4100//3536 4101//3538 
f 4102//3540 4055//3540 4054//3541 
f 4054//3541 4101//3538 4102//3540 
f 4102//3540 4103//3542 4052//3543 
f 4103//3542 4053//3542 4052//3543 
f 4104//3544 4051//3544 4050//3545 
f 4050//3545 4103//3542 4104//3544 
f 4105//3546 4049//3546 4048//3547 
f 4048//3547 4104//3544 4105//3546 
f 4105//3546 4077//3493 4046//3548 
f 4077//3493 4047//3549 4046//3548 
f 4046//3548 4049//3546 4105//3546 
f 4048//3547 4051//3544 4104//3544 
f 4050//3545 4053//3542 4103//3542 
f 4052//3543 4055//3540 4102//3540 
f 4054//3541 4057//3538 4101//3538 
f 4056//3539 4059//3536 4100//3536 
f 4058//3537 4061//3534 4099//3534 
f 4060//3535 4063//3532 4098//3532 
f 4062//3533 4065//3530 4097//3530 
f 4064//3531 4067//3528 4096//3528 
f 4066//3529 4069//3526 4095//3526 
f 4068//3527 4071//3524 4094//3524 
f 4070//3525 4073//3522 4093//3522 
f 4072//3523 4075//3520 4092//3520 
f 4091//3521 4092//3520 4075//3520 
f 4018//3519 4021//3516 4089//3516 
f 4020//3517 4023//3514 4088//3514 
f 4022//3515 4025//3512 4087//3512 
f 4024//3513 4027//3510 4086//3510 
f 4026//3511 4029//3508 4085//3508 
f 4028//3509 4031//3506 4084//3506 
f 4030//3507 4033//3504 4083//3504 
f 4032//3505 4035//3502 4082//3502 
f 4034//3503 4037//3500 4081//3500 
f 4036//3501 4038//3498 4080//3498 
f 4039//3499 4040//3496 4079//3496 
f 4041//3497 4042//3494 4078//3494 
f 4043//3495 4045//3491 4076//3491 
f 4044//3492 4047//3549 4077//3493 
o mesh8
f 4090//3550 4089//3550 3957//3550 
f 3903//3550 4091//3550 4090//3550 
f 4089//3550 4088//3550 3955//3550 
f 4087//3550 4086//3550 3951//3550 
f 4086//3550 4085//3550 3949//3550 
f 3955//3550 3957//3550 4089//3550 
f 4088//3550 4087//3550 3953//3550 
f 3949//3550 3951//3550 4086//3550 
f 4085//3550 4084//3550 3947//3550 
f 4084//3550 4083//3550 3945//3550 
f 4083//3550 4082//3550 3943//3550 
f 4080//3550 4079//3550 3937//3550 
f 4079//3550 4078//3550 3935//3550 
f 4103//3550 4102//3550 3923//3550 
f 4102//3550 4101//3550 3921//3550 
f 3953//3550 3955//3550 4088//3550 
f 3947//3550 3949//3550 4085//3550 
f 3943//3550 3945//3550 4083//3550 
f 4082//3550 4081//3550 3941//3550 
f 4081//3550 4080//3550 3939//3550 
f 3935//3550 3937//3550 4079//3550 
f 4076//3550 4077//3550 3931//3550 
f 4077//3550 4105//3550 3929//3550 
f 3921//3550 3923//3550 4102//3550 
f 4101//3550 4100//3550 3919//3550 
f 3951//3550 3953//3550 4087//3550 
f 3941//3550 3943//3550 4082//3550 
f 3937//3550 3939//3550 4080//3550 
f 4078//3550 4076//3550 3933//3550 
f 3929//3550 3931//3550 4077//3550 
f 4105//3550 4104//3550 3927//3550 
f 4104//3550 4103//3550 3925//3550 
f 3919//3550 3921//3550 4101//3550 
f 4098//3550 4097//3550 3913//3550 
f 4097//3550 4096//3550 3911//3550 
f 4096//3550 4095//3550 3909//3550 
f 4095//3550 4094//3550 3907//3550 
f 3945//3550 3947//3550 4084//3550 
f 3933//3550 3935//3550 4078//3550 
f 3927//3550 3929//3550 4105//3550 
f 3923//3550 3925//3550 4103//3550 
f 3911//3550 3913//3550 4097//3550 
f 3907//3550 3909//3550 4095//3550 
f 4094//3550 4093//3550 3905//3550 
f 4093//3550 4092//3550 3902//3550 
f 3939//3550 3941//3550 4081//3550 
f 3925//3550 3927//3550 4104//3550 
f 4100//3550 4099//3550 3917//3550 
f 4099//3550 4098//3550 3915//3550 
f 3909//3550 3911//3550 4096//3550 
f 3902//3550 3905//3550 4093//3550 
f 3931//3550 3933//3550 4076//3550 
f 3915//3550 3917//3550 4099//3550 
f 3905//3550 3907//3550 4094//3550 
f 4092//3550 4091//3550 3903//3550 
f 3917//3550 3919//3550 4100//3550 
f 3903//3550 3902//3550 4092//3550 
f 3913//3550 3915//3550 4098//3550 
f 3957//3550 3903//3550 4090//3550 
g bearing
v 0.166279 -0.00989681 -0.0966911 
v 0.166337 -0.00935938 -0.0966911 
v 0.166337 -0.00935938 -0.106891 
v 0.166106 -0.0104091 -0.0966911 
v 0.166279 -0.00989681 -0.106891 
v 0.165828 -0.0108723 -0.0966911 
v 0.166106 -0.0104091 -0.106891 
v 0.165456 -0.0112648 -0.0966911 
v 0.165828 -0.0108723 -0.106891 
v 0.165008 -0.0115682 -0.0966911 
v 0.165456 -0.0112648 -0.106891 
v 0.164506 -0.0117683 -0.0966911 
v 0.165008 -0.0115682 -0.106891 
v 0.163973 -0.0118557 -0.0966911 
v 0.164506 -0.0117683 -0.106891 
v 0.163433 -0.0118264 -0.0966911 
v 0.163973 -0.0118557 -0.106891 
v 0.162912 -0.0116818 -0.0966911 
v 0.163433 -0.0118264 -0.106891 
v 0.162434 -0.0114286 -0.0966911 
v 0.162912 -0.0116818 -0.106891 
v 0.162022 -0.0110786 -0.0966911 
v 0.162434 -0.0114286 -0.106891 
v 0.161695 -0.0106483 -0.0966911 
v 0.162022 -0.0110786 -0.106891 
v 0.161468 -0.0101576 -0.0966911 
v 0.161695 -0.0106483 -0.106891 
v 0.161352 -0.00962968 -0.0966911 
v 0.161468 -0.0101576 -0.106891 
v 0.161352 -0.00908908 -0.0966911 
v 0.161352 -0.00962968 -0.106891 
v 0.161468 -0.00856113 -0.0966911 
v 0.161352 -0.00908908 -0.106891 
v 0.161695 -0.0080705 -0.0966911 
v 0.161468 -0.00856113 -0.106891 
v 0.162022 -0.00764013 -0.0966911 
v 0.161695 -0.0080705 -0.106891 
v 0.162434 -0.00729016 -0.0966911 
v 0.162022 -0.00764013 -0.106891 
v 0.162912 -0.00703694 -0.0966911 
v 0.162434 -0.00729016 -0.106891 
v 0.163433 -0.00689231 -0.0966911 
v 0.162912 -0.00703694 -0.106891 
v 0.163973 -0.00686305 -0.0966911 
v 0.163433 -0.00689231 -0.106891 
v 0.164506 -0.00695051 -0.0966911 
v 0.163973 -0.00686305 -0.106891 
v 0.165008 -0.0071506 -0.0966911 
v 0.164506 -0.00695051 -0.106891 
v 0.165456 -0.00745398 -0.0966911 
v 0.165008 -0.0071506 -0.106891 
v 0.165828 -0.00784645 -0.0966911 
v 0.165456 -0.00745398 -0.106891 
v 0.166106 -0.00830966 -0.0966911 
v 0.165828 -0.00784645 -0.106891 
v 0.166279 -0.00882196 -0.0966911 
v 0.166106 -0.00830966 -0.106891 
v 0.166279 -0.00882196 -0.106891 
v 0.157013 -0.00289501 -0.106891 
v 0.158562 -0.0015791 -0.106891 
v 0.155783 -0.00451317 -0.106891 
v 0.164346 2.68329e-05 -0.106891 
v 0.166352 -0.000302011 -0.106891 
v 0.160358 -0.000627 -0.106891 
v 0.162317 -8.32119e-05 -0.106891 
v 0.169923 -0.00219506 -0.106891 
v 0.171321 -0.00367074 -0.106891 
v 0.173018 -0.00733866 -0.106891 
v 0.173237 -0.00935938 -0.106891 
v 0.16824 -0.00105437 -0.106891 
v 0.173018 -0.0113801 -0.106891 
v 0.172369 -0.00541242 -0.106891 
v 0.157013 -0.0158238 -0.106891 
v 0.155783 -0.0142056 -0.106891 
v 0.158562 -0.0171397 -0.106891 
v 0.154929 -0.00635795 -0.106891 
v 0.172369 -0.0133063 -0.106891 
v 0.171321 -0.015048 -0.106891 
v 0.169923 -0.0165237 -0.106891 
v 0.16824 -0.0176644 -0.106891 
v 0.166352 -0.0184168 -0.106891 
v 0.164346 -0.0187456 -0.106891 
v 0.154929 -0.0123608 -0.106891 
v 0.154492 -0.0103757 -0.106891 
v 0.154492 -0.00834306 -0.106891 
v 0.162317 -0.0186356 -0.106891 
v 0.160358 -0.0180918 -0.106891 
v 0.175837 -0.00935938 -0.104291 
v 0.175557 -0.00677974 -0.104291 
v 0.174728 -0.00432071 -0.104291 
v 0.17339 -0.00209729 -0.104291 
v 0.171606 -0.000213437 -0.104291 
v 0.169458 0.00124276 -0.104291 
v 0.167048 0.00220322 -0.104291 
v 0.164487 0.00262302 -0.104291 
v 0.161896 0.00248254 -0.104291 
v 0.159396 0.00178834 -0.104291 
v 0.157103 0.000572887 -0.104291 
v 0.155125 -0.00110699 -0.104291 
v 0.153555 -0.00317273 -0.104291 
v 0.152466 -0.00552776 -0.104291 
v 0.151908 -0.00806195 -0.104291 
v 0.151908 -0.0106568 -0.104291 
v 0.152466 -0.013191 -0.104291 
v 0.153555 -0.015546 -0.104291 
v 0.155125 -0.0176118 -0.104291 
v 0.157103 -0.0192916 -0.104291 
v 0.159396 -0.0205071 -0.104291 
v 0.161896 -0.0212013 -0.104291 
v 0.164487 -0.0213418 -0.104291 
v 0.167048 -0.020922 -0.104291 
v 0.169458 -0.0199615 -0.104291 
v 0.171606 -0.0185053 -0.104291 
v 0.17339 -0.0166215 -0.104291 
v 0.174728 -0.0143981 -0.104291 
v 0.175557 -0.011939 -0.104291 
v 0.175488 -0.00679486 -0.0992911 
v 0.175767 -0.00806195 -0.0992911 
v 0.174664 -0.00435025 -0.0992911 
v 0.175209 -0.00552776 -0.0992911 
v 0.173334 -0.00213986 -0.0992911 
v 0.17412 -0.00317273 -0.0992911 
v 0.17156 -0.00026705 -0.0992911 
v 0.172549 -0.00110699 -0.0992911 
v 0.169425 0.00118061 -0.0992911 
v 0.170572 0.000572887 -0.0992911 
v 0.167029 0.00213544 -0.0992911 
v 0.168279 0.00178834 -0.0992911 
v 0.164483 0.00255278 -0.0992911 
v 0.165779 0.00248254 -0.0992911 
v 0.161907 0.00241312 -0.0992911 
v 0.163188 0.00262302 -0.0992911 
v 0.159422 0.00172299 -0.0992911 
v 0.160627 0.00220322 -0.0992911 
v 0.157143 0.000514663 -0.0992911 
v 0.158216 0.00124276 -0.0992911 
v 0.156069 -0.000213437 -0.0992911 
v 0.155176 -0.00115536 -0.0992911 
v 0.154284 -0.00209729 -0.0992911 
v 0.153615 -0.003209 -0.0992911 
v 0.152946 -0.00432071 -0.0992911 
v 0.152532 -0.00555022 -0.0992911 
v 0.151978 -0.00806956 -0.0992911 
v 0.152118 -0.00677974 -0.0992911 
v 0.151978 -0.0106492 -0.0992911 
v 0.151837 -0.00935938 -0.0992911 
v 0.152532 -0.0131685 -0.0992911 
v 0.152118 -0.011939 -0.0992911 
v 0.153615 -0.0155098 -0.0992911 
v 0.152946 -0.0143981 -0.0992911 
v 0.155176 -0.0175634 -0.0992911 
v 0.154284 -0.0166215 -0.0992911 
v 0.157143 -0.0192334 -0.0992911 
v 0.156069 -0.0185053 -0.0992911 
v 0.159422 -0.0204418 -0.0992911 
v 0.158216 -0.0199615 -0.0992911 
v 0.161907 -0.0211319 -0.0992911 
v 0.160627 -0.020922 -0.0992911 
v 0.164483 -0.0212715 -0.0992911 
v 0.163188 -0.0213418 -0.0992911 
v 0.167029 -0.0208542 -0.0992911 
v 0.165779 -0.0212013 -0.0992911 
v 0.169425 -0.0198994 -0.0992911 
v 0.168279 -0.0205071 -0.0992911 
v 0.17156 -0.0184517 -0.0992911 
v 0.170572 -0.0192916 -0.0992911 
v 0.173334 -0.0165789 -0.0992911 
v 0.172549 -0.0176118 -0.0992911 
v 0.174664 -0.0143685 -0.0992911 
v 0.17412 -0.015546 -0.0992911 
v 0.175488 -0.0119239 -0.0992911 
v 0.175209 -0.013191 -0.0992911 
v 0.175837 -0.00935938 -0.0992911 
v 0.175767 -0.0106568 -0.0992911 
v 0.154657 -0.00733866 -0.0966911 
v 0.154437 -0.00935938 -0.0966911 
v 0.155306 -0.00541242 -0.0966911 
v 0.156354 -0.00367074 -0.0966911 
v 0.157752 -0.00219506 -0.0966911 
v 0.159434 -0.00105437 -0.0966911 
v 0.161323 -0.000302011 -0.0966911 
v 0.163328 2.68329e-05 -0.0966911 
v 0.165358 -8.32119e-05 -0.0966911 
v 0.167317 -0.000627 -0.0966911 
v 0.169112 -0.0015791 -0.0966911 
v 0.170662 -0.00289501 -0.0966911 
v 0.171892 -0.00451317 -0.0966911 
v 0.172745 -0.00635795 -0.0966911 
v 0.173182 -0.00834306 -0.0966911 
v 0.173237 -0.00935938 -0.0966911 
v 0.173182 -0.0103757 -0.0966911 
v 0.172745 -0.0123608 -0.0966911 
v 0.171892 -0.0142056 -0.0966911 
v 0.170662 -0.0158238 -0.0966911 
v 0.169112 -0.0171397 -0.0966911 
v 0.167317 -0.0180918 -0.0966911 
v 0.165358 -0.0186356 -0.0966911 
v 0.163328 -0.0187456 -0.0966911 
v 0.161323 -0.0184168 -0.0966911 
v 0.159434 -0.0176644 -0.0966911 
v 0.157752 -0.0165237 -0.0966911 
v 0.156354 -0.015048 -0.0966911 
v 0.155306 -0.0133063 -0.0966911 
v 0.154657 -0.0113801 -0.0966911 
vn -0.963077 0.243631 -0.114571 
vn -0.993319 -0.0111185 -0.114864 
vn -0.869866 0.48015 -0.113089 
vn -0.963077 0.243631 -0.114571 
vn -0.723303 0.681614 -0.110615 
vn -0.869866 0.48015 -0.113089 
vn -0.537316 0.836509 -0.107442 
vn -0.723303 0.681614 -0.110615 
vn -0.327239 0.939213 -0.103888 
vn -0.537316 0.836509 -0.107442 
vn -0.107489 0.989141 -0.100233 
vn -0.327239 0.939213 -0.103888 
vn 0.109707 0.989249 -0.0966985 
vn -0.107489 0.989141 -0.100233 
vn 0.314668 0.944592 -0.0934391 
vn 0.109707 0.989249 -0.0966985 
vn 0.500075 0.861234 -0.0905526 
vn 0.314668 0.944592 -0.0934391 
vn 0.660569 0.745579 -0.0880952 
vn 0.500075 0.861234 -0.0905526 
vn 0.792318 0.604003 -0.086095 
vn 0.660569 0.745579 -0.0880952 
vn 0.892671 0.442704 -0.0845634 
vn 0.792318 0.604003 -0.086095 
vn 0.959886 0.267667 -0.0835027 
vn 0.892671 0.442704 -0.0845634 
vn 0.992952 0.0846854 -0.0829117 
vn 0.959886 0.267667 -0.0835027 
vn 0.991478 -0.100587 -0.0827886 
vn 0.992952 0.0846854 -0.0829117 
vn 0.955636 -0.282576 -0.083133 
vn 0.991478 -0.100587 -0.0827886 
vn 0.886154 -0.455723 -0.083946 
vn 0.955636 -0.282576 -0.083133 
vn 0.784354 -0.614431 -0.0852295 
vn 0.886154 -0.455723 -0.083946 
vn 0.652234 -0.753011 -0.0869836 
vn 0.784354 -0.614431 -0.0852295 
vn 0.492619 -0.865661 -0.0892023 
vn 0.652234 -0.753011 -0.0869836 
vn 0.309376 -0.946492 -0.0918678 
vn 0.492619 -0.865661 -0.0892023 
vn 0.107712 -0.989639 -0.0949399 
vn 0.309376 -0.946492 -0.0918678 
vn -0.105464 -0.989548 -0.0983447 
vn 0.107712 -0.989639 -0.0949399 
vn -0.321165 -0.941519 -0.101959 
vn -0.105464 -0.989548 -0.0983447 
vn -0.528094 -0.842595 -0.105598 
vn -0.321165 -0.941519 -0.101959 
vn -0.712812 -0.692832 -0.109011 
vn -0.528094 -0.842595 -0.105598 
vn -0.860662 -0.496731 -0.111892 
vn -0.712812 -0.692832 -0.109011 
vn -0.957682 -0.264322 -0.113929 
vn -0.860662 -0.496731 -0.111892 
vn 0.147747 -0.00844023 -0.988989 
vn 0.734844 -0.00789681 -0.67819 
vn 0.723025 0.120712 -0.680194 
vn 0.686324 0.244976 -0.684797 
vn 0.625619 0.360313 -0.691936 
vn 0.542495 0.462171 -0.701497 
vn 0.439312 0.54609 -0.713295 
vn 0.319304 0.607815 -0.727053 
vn 0.186672 0.643463 -0.742367 
vn 0.0466651 0.64979 -0.75868 
vn -0.0944149 0.62454 -0.775265 
vn -0.229337 0.566896 -0.791223 
vn -0.350272 0.477945 -0.80553 
vn -0.449378 0.361078 -0.817118 
vn -0.519619 0.222134 -0.825017 
vn -0.555696 0.0691546 -0.828505 
vn -0.554853 -0.0883145 -0.827248 
vn -0.517321 -0.240279 -0.821368 
vn -0.446242 -0.377455 -0.811416 
vn -0.347113 -0.492225 -0.798265 
vn -0.226941 -0.579205 -0.782955 
vn -0.0933532 -0.635368 -0.766546 
vn 0.0461313 -0.659824 -0.750003 
vn 0.184603 -0.653426 -0.734136 
vn 0.316023 -0.618328 -0.719583 
vn 0.435322 -0.55759 -0.706816 
vn 0.538374 -0.474872 -0.696168 
vn 0.621938 -0.374212 -0.687865 
vn 0.683572 -0.259877 -0.682051 
vn 0.721556 -0.136275 -0.678812 
vn 0.980726 0.176813 -0.0831486 
vn 0.992952 0.0846854 -0.0829117 
vn 0.996535 -0.00801396 -0.0827917 
vn 0.9305 0.356537 -0.0839742 
vn 0.959886 0.267667 -0.0835027 
vn 0.846547 0.52544 -0.0852704 
vn 0.892671 0.442704 -0.0845634 
vn 0.730226 0.677639 -0.0870369 
vn 0.792318 0.604003 -0.086095 
vn 0.583707 0.807042 -0.089268 
vn 0.660569 0.745579 -0.0880952 
vn 0.410191 0.907353 -0.0919449 
vn 0.500075 0.861234 -0.0905526 
vn 0.214225 0.972151 -0.0950271 
vn 0.314668 0.944592 -0.0934391 
vn 0.00209251 0.995141 -0.0984394 
vn 0.109707 0.989249 -0.0966985 
vn -0.21775 0.970654 -0.102057 
vn -0.107489 0.989141 -0.100233 
vn -0.434346 0.894523 -0.105694 
vn -0.327239 0.939213 -0.103888 
vn -0.63428 0.765367 -0.109096 
vn -0.537316 0.836509 -0.107442 
vn -0.802449 0.586124 -0.111959 
vn -0.723303 0.681614 -0.110615 
vn -0.923877 0.365326 -0.113969 
vn -0.869866 0.48015 -0.113089 
vn -0.986427 0.11733 -0.114873 
vn -0.963077 0.243631 -0.114571 
vn -0.983621 -0.139172 -0.114546 
vn -0.993319 -0.0111185 -0.114864 
vn -0.916299 -0.384212 -0.113034 
vn -0.957682 -0.264322 -0.113929 
vn -0.792264 -0.600083 -0.110538 
vn -0.860662 -0.496731 -0.111892 
vn -0.624134 -0.773907 -0.107351 
vn -0.712812 -0.692832 -0.109011 
vn -0.426522 -0.898502 -0.10379 
vn -0.528094 -0.842595 -0.105598 
vn -0.21365 -0.971765 -0.100136 
vn -0.321165 -0.941519 -0.101959 
vn 0.00205356 -0.99532 -0.0966071 
vn -0.105464 -0.989548 -0.0983447 
vn 0.210459 -0.973135 -0.0933567 
vn 0.107712 -0.989639 -0.0949399 
vn 0.403661 -0.910424 -0.0904811 
vn 0.309376 -0.946492 -0.0918678 
vn 0.575649 -0.812944 -0.0880356 
vn 0.492619 -0.865661 -0.0892023 
vn 0.721929 -0.686597 -0.0860479 
vn 0.652234 -0.753011 -0.0869836 
vn 0.839186 -0.537235 -0.0845289 
vn 0.784354 -0.614431 -0.0852295 
vn 0.925032 -0.370603 -0.0834808 
vn 0.886154 -0.455723 -0.083946 
vn 0.977821 -0.192339 -0.0829023 
vn 0.955636 -0.282576 -0.083133 
vn 0.996535 -0.00801396 -0.0827917 
vn 0.991478 -0.100587 -0.0827886 
vn -0.643317 0.174219 0.745514 
vn -0.659747 0.0821034 0.746989 
vn -0.664783 -0.0114528 0.746948 
vn -0.57799 0.347759 0.738235 
vn -0.615856 0.263275 0.742568 
vn -0.474607 0.497771 0.725929 
vn -0.530564 0.426312 0.732639 
vn -0.341818 0.615842 0.709858 
vn -0.411278 0.561188 0.718275 
vn -0.189601 0.697086 0.691464 
vn -0.267503 0.661238 0.700862 
vn -0.027895 0.739909 0.672128 
vn -0.109343 0.723288 0.681835 
vn 0.134318 0.745336 0.653018 
vn 0.0536573 0.747153 0.662482 
vn 0.289457 0.7162 0.635037 
vn 0.213187 0.734861 0.643841 
vn 0.431428 0.656448 0.618826 
vn 0.362414 0.689877 0.626679 
vn 0.555511 0.57062 0.604814 
vn 0.495952 0.616497 0.611525 
vn 0.658168 0.463519 0.593266 
vn 0.609699 0.519424 0.59872 
vn 0.736843 0.340018 0.584338 
vn 0.700629 0.403514 0.588468 
vn 0.789795 0.204967 0.578111 
vn 0.766615 0.273635 0.580883 
vn 0.815976 0.0631585 0.574625 
vn 0.806273 0.134611 0.576024 
vn 0.814943 -0.0806775 0.573898 
vn 0.818867 -0.00879974 0.573916 
vn 0.786818 -0.221856 0.575931 
vn 0.804238 -0.15189 0.57457 
vn 0.732278 -0.355719 0.580718 
vn 0.762785 -0.289993 0.577982 
vn 0.652581 -0.477622 0.58823 
vn 0.695471 -0.418456 0.584136 
vn 0.549631 -0.582931 0.598412 
vn 0.603866 -0.53264 0.592993 
vn 0.426077 -0.667048 0.611151 
vn 0.490232 -0.627922 0.604472 
vn 0.28545 -0.72549 0.626245 
vn 0.357638 -0.69975 0.618421 
vn 0.132332 -0.75404 0.643359 
vn 0.21012 -0.743748 0.634578 
vn -0.0274734 -0.749027 0.66197 
vn 0.0528503 -0.755927 0.652519 
vn -0.186819 -0.707748 0.681316 
vn -0.107703 -0.733036 0.671609 
vn -0.337248 -0.629086 0.700367 
vn -0.263721 -0.673078 0.690954 
vn -0.46932 -0.514239 0.717842 
vn -0.406191 -0.576 0.70939 
vn -0.573348 -0.367423 0.732307 
vn -0.525424 -0.444431 0.725541 
vn -0.640603 -0.196249 0.74237 
vn -0.61204 -0.284274 0.737967 
vn -0.658338 -0.104786 0.745393 
vn -0.664783 -0.0114528 0.746948 
vn 0.178454 -0.0101944 0.983895 
o mesh3
f 4106//3551 4107//3552 4108//3552 
f 4109//3553 4106//3551 4110//3554 
f 4111//3555 4109//3553 4112//3556 
f 4113//3557 4111//3555 4114//3558 
f 4115//3559 4113//3557 4116//3560 
f 4117//3561 4115//3559 4118//3562 
f 4119//3563 4117//3561 4120//3564 
f 4121//3565 4119//3563 4122//3566 
f 4123//3567 4121//3565 4124//3568 
f 4125//3569 4123//3567 4126//3570 
f 4127//3571 4125//3569 4128//3572 
f 4129//3573 4127//3571 4130//3574 
f 4131//3575 4129//3573 4132//3576 
f 4133//3577 4131//3575 4134//3578 
f 4135//3579 4133//3577 4136//3580 
f 4137//3581 4135//3579 4138//3582 
f 4139//3583 4137//3581 4140//3584 
f 4141//3585 4139//3583 4142//3586 
f 4143//3587 4141//3585 4144//3588 
f 4145//3589 4143//3587 4146//3590 
f 4147//3591 4145//3589 4148//3592 
f 4149//3593 4147//3591 4150//3594 
f 4151//3595 4149//3593 4152//3596 
f 4153//3597 4151//3595 4154//3598 
f 4155//3599 4153//3597 4156//3600 
f 4157//3601 4155//3599 4158//3602 
f 4159//3603 4157//3601 4160//3604 
f 4161//3605 4159//3603 4162//3606 
f 4107//3552 4161//3605 4163//3605 
f 4163//3605 4108//3552 4107//3552 
f 4162//3606 4163//3605 4161//3605 
f 4160//3604 4162//3606 4159//3603 
f 4158//3602 4160//3604 4157//3601 
f 4156//3600 4158//3602 4155//3599 
f 4154//3598 4156//3600 4153//3597 
f 4152//3596 4154//3598 4151//3595 
f 4150//3594 4152//3596 4149//3593 
f 4148//3592 4150//3594 4147//3591 
f 4146//3590 4148//3592 4145//3589 
f 4144//3588 4146//3590 4143//3587 
f 4142//3586 4144//3588 4141//3585 
f 4140//3584 4142//3586 4139//3583 
f 4138//3582 4140//3584 4137//3581 
f 4136//3580 4138//3582 4135//3579 
f 4134//3578 4136//3580 4133//3577 
f 4132//3576 4134//3578 4131//3575 
f 4130//3574 4132//3576 4129//3573 
f 4128//3572 4130//3574 4127//3571 
f 4126//3570 4128//3572 4125//3569 
f 4124//3568 4126//3570 4123//3567 
f 4122//3566 4124//3568 4121//3565 
f 4120//3564 4122//3566 4119//3563 
f 4118//3562 4120//3564 4117//3561 
f 4116//3560 4118//3562 4115//3559 
f 4114//3558 4116//3560 4113//3557 
f 4112//3556 4114//3558 4111//3555 
f 4110//3554 4112//3556 4109//3553 
f 4108//3552 4110//3554 4106//3551 
o mesh4
f 4164//3607 4144//3607 4142//3607 
f 4164//3607 4165//3607 4146//3607 
f 4166//3607 4142//3607 4140//3607 
f 4146//3607 4144//3607 4164//3607 
f 4167//3607 4152//3607 4150//3607 
f 4167//3607 4168//3607 4154//3607 
f 4142//3607 4166//3607 4164//3607 
f 4165//3607 4169//3607 4148//3607 
f 4170//3607 4150//3607 4148//3607 
f 4154//3607 4152//3607 4167//3607 
f 4171//3607 4158//3607 4156//3607 
f 4171//3607 4172//3607 4160//3607 
f 4173//3607 4163//3607 4162//3607 
f 4174//3607 4108//3607 4163//3607 
f 4148//3607 4146//3607 4165//3607 
f 4150//3607 4170//3607 4167//3607 
f 4175//3607 4156//3607 4154//3607 
f 4160//3607 4158//3607 4171//3607 
f 4163//3607 4173//3607 4174//3607 
f 4176//3607 4110//3607 4108//3607 
f 4148//3607 4169//3607 4170//3607 
f 4156//3607 4175//3607 4171//3607 
f 4177//3607 4162//3607 4160//3607 
f 4108//3607 4174//3607 4176//3607 
f 4178//3607 4130//3607 4128//3607 
f 4179//3607 4132//3607 4130//3607 
f 4154//3607 4168//3607 4175//3607 
f 4162//3607 4177//3607 4173//3607 
f 4180//3607 4128//3607 4126//3607 
f 4130//3607 4178//3607 4179//3607 
f 4181//3607 4140//3607 4138//3607 
f 4160//3607 4172//3607 4177//3607 
f 4182//3607 4112//3607 4110//3607 
f 4183//3607 4114//3607 4112//3607 
f 4184//3607 4116//3607 4114//3607 
f 4185//3607 4118//3607 4116//3607 
f 4186//3607 4120//3607 4118//3607 
f 4186//3607 4187//3607 4122//3607 
f 4128//3607 4180//3607 4178//3607 
f 4188//3607 4134//3607 4132//3607 
f 4189//3607 4136//3607 4134//3607 
f 4190//3607 4138//3607 4136//3607 
f 4140//3607 4181//3607 4166//3607 
f 4112//3607 4182//3607 4183//3607 
f 4116//3607 4184//3607 4185//3607 
f 4122//3607 4120//3607 4186//3607 
f 4191//3607 4124//3607 4122//3607 
f 4192//3607 4126//3607 4124//3607 
f 4132//3607 4179//3607 4188//3607 
f 4136//3607 4189//3607 4190//3607 
f 4110//3607 4176//3607 4182//3607 
f 4118//3607 4185//3607 4186//3607 
f 4124//3607 4191//3607 4192//3607 
f 4134//3607 4188//3607 4189//3607 
f 4114//3607 4183//3607 4184//3607 
f 4126//3607 4192//3607 4180//3607 
f 4122//3607 4187//3607 4191//3607 
f 4138//3607 4190//3607 4181//3607 
o mesh5
f 4193//3608 4174//3608 4173//3609 
f 4194//3609 4173//3609 4177//3610 
f 4195//3610 4177//3610 4172//3611 
f 4196//3611 4172//3611 4171//3612 
f 4197//3612 4171//3612 4175//3613 
f 4198//3613 4175//3613 4168//3614 
f 4199//3614 4168//3614 4167//3615 
f 4200//3615 4167//3615 4170//3616 
f 4201//3616 4170//3616 4169//3617 
f 4202//3617 4169//3617 4165//3618 
f 4203//3618 4165//3618 4164//3619 
f 4204//3619 4164//3619 4166//3620 
f 4205//3620 4166//3620 4181//3621 
f 4206//3621 4181//3621 4190//3622 
f 4207//3622 4190//3622 4189//3623 
f 4208//3623 4189//3623 4188//3624 
f 4209//3624 4188//3624 4179//3625 
f 4210//3625 4179//3625 4178//3626 
f 4211//3626 4178//3626 4180//3627 
f 4212//3627 4180//3627 4192//3628 
f 4213//3628 4192//3628 4191//3629 
f 4214//3629 4191//3629 4187//3630 
f 4215//3630 4187//3630 4186//3631 
f 4216//3631 4186//3631 4185//3632 
f 4217//3632 4185//3632 4184//3633 
f 4218//3633 4184//3633 4183//3634 
f 4219//3634 4183//3634 4182//3635 
f 4220//3635 4182//3635 4176//3636 
f 4221//3636 4176//3636 4174//3608 
f 4174//3608 4193//3608 4221//3636 
f 4176//3636 4221//3636 4220//3635 
f 4182//3635 4220//3635 4219//3634 
f 4183//3634 4219//3634 4218//3633 
f 4184//3633 4218//3633 4217//3632 
f 4185//3632 4217//3632 4216//3631 
f 4186//3631 4216//3631 4215//3630 
f 4187//3630 4215//3630 4214//3629 
f 4191//3629 4214//3629 4213//3628 
f 4192//3628 4213//3628 4212//3627 
f 4180//3627 4212//3627 4211//3626 
f 4178//3626 4211//3626 4210//3625 
f 4179//3625 4210//3625 4209//3624 
f 4188//3624 4209//3624 4208//3623 
f 4189//3623 4208//3623 4207//3622 
f 4190//3622 4207//3622 4206//3621 
f 4181//3621 4206//3621 4205//3620 
f 4166//3620 4205//3620 4204//3619 
f 4164//3619 4204//3619 4203//3618 
f 4165//3618 4203//3618 4202//3617 
f 4169//3617 4202//3617 4201//3616 
f 4170//3616 4201//3616 4200//3615 
f 4167//3615 4200//3615 4199//3614 
f 4168//3614 4199//3614 4198//3613 
f 4175//3613 4198//3613 4197//3612 
f 4171//3612 4197//3612 4196//3611 
f 4172//3611 4196//3611 4195//3610 
f 4177//3610 4195//3610 4194//3609 
f 4173//3609 4194//3609 4193//3608 
o mesh6
f 4194//3637 4222//3637 4223//3638 
f 4223//3638 4193//3639 4194//3637 
f 4195//3640 4224//3640 4225//3641 
f 4225//3641 4194//3637 4195//3640 
f 4196//3642 4226//3642 4227//3643 
f 4227//3643 4195//3640 4196//3642 
f 4197//3644 4228//3644 4229//3645 
f 4229//3645 4196//3642 4197//3644 
f 4198//3646 4230//3646 4231//3647 
f 4231//3647 4197//3644 4198//3646 
f 4199//3648 4232//3648 4233//3649 
f 4233//3649 4198//3646 4199//3648 
f 4200//3650 4234//3650 4235//3651 
f 4235//3651 4199//3648 4200//3650 
f 4201//3652 4236//3652 4237//3653 
f 4237//3653 4200//3650 4201//3652 
f 4202//3654 4238//3654 4239//3655 
f 4239//3655 4201//3652 4202//3654 
f 4203//3656 4240//3656 4241//3657 
f 4241//3657 4202//3654 4203//3656 
f 4203//3656 4204//3658 4242//3659 
f 4204//3658 4243//3658 4242//3659 
f 4204//3658 4205//3660 4244//3661 
f 4205//3660 4245//3660 4244//3661 
f 4205//3660 4206//3662 4246//3663 
f 4206//3662 4247//3662 4246//3663 
f 4207//3664 4248//3664 4249//3665 
f 4249//3665 4206//3662 4207//3664 
f 4208//3666 4250//3666 4251//3667 
f 4251//3667 4207//3664 4208//3666 
f 4209//3668 4252//3668 4253//3669 
f 4253//3669 4208//3666 4209//3668 
f 4210//3670 4254//3670 4255//3671 
f 4255//3671 4209//3668 4210//3670 
f 4211//3672 4256//3672 4257//3673 
f 4257//3673 4210//3670 4211//3672 
f 4212//3674 4258//3674 4259//3675 
f 4259//3675 4211//3672 4212//3674 
f 4213//3676 4260//3676 4261//3677 
f 4261//3677 4212//3674 4213//3676 
f 4214//3678 4262//3678 4263//3679 
f 4263//3679 4213//3676 4214//3678 
f 4215//3680 4264//3680 4265//3681 
f 4265//3681 4214//3678 4215//3680 
f 4216//3682 4266//3682 4267//3683 
f 4267//3683 4215//3680 4216//3682 
f 4217//3684 4268//3684 4269//3685 
f 4269//3685 4216//3682 4217//3684 
f 4218//3686 4270//3686 4271//3687 
f 4271//3687 4217//3684 4218//3686 
f 4219//3688 4272//3688 4273//3689 
f 4273//3689 4218//3686 4219//3688 
f 4220//3690 4274//3690 4275//3691 
f 4275//3691 4219//3688 4220//3690 
f 4221//3692 4276//3692 4277//3693 
f 4277//3693 4220//3690 4221//3692 
f 4193//3639 4278//3694 4279//3695 
f 4279//3695 4221//3692 4193//3639 
f 4279//3695 4276//3692 4221//3692 
f 4277//3693 4274//3690 4220//3690 
f 4275//3691 4272//3688 4219//3688 
f 4273//3689 4270//3686 4218//3686 
f 4271//3687 4268//3684 4217//3684 
f 4269//3685 4266//3682 4216//3682 
f 4267//3683 4264//3680 4215//3680 
f 4265//3681 4262//3678 4214//3678 
f 4263//3679 4260//3676 4213//3676 
f 4261//3677 4258//3674 4212//3674 
f 4259//3675 4256//3672 4211//3672 
f 4257//3673 4254//3670 4210//3670 
f 4255//3671 4252//3668 4209//3668 
f 4253//3669 4250//3666 4208//3666 
f 4251//3667 4248//3664 4207//3664 
f 4249//3665 4247//3662 4206//3662 
f 4246//3663 4245//3660 4205//3660 
f 4244//3661 4243//3658 4204//3658 
f 4242//3659 4240//3656 4203//3656 
f 4241//3657 4238//3654 4202//3654 
f 4239//3655 4236//3652 4201//3652 
f 4237//3653 4234//3650 4200//3650 
f 4235//3651 4232//3648 4199//3648 
f 4233//3649 4230//3646 4198//3646 
f 4231//3647 4228//3644 4197//3644 
f 4229//3645 4226//3642 4196//3642 
f 4227//3643 4224//3640 4195//3640 
f 4225//3641 4222//3637 4194//3637 
f 4223//3638 4278//3694 4193//3639 
o mesh7
f 4280//3696 4249//3696 4248//3697 
f 4248//3697 4281//3698 4280//3696 
f 4282//3699 4246//3699 4247//3700 
f 4247//3700 4280//3696 4282//3699 
f 4283//3701 4244//3701 4245//3702 
f 4245//3702 4282//3699 4283//3701 
f 4284//3703 4242//3703 4243//3704 
f 4243//3704 4283//3701 4284//3703 
f 4285//3705 4241//3705 4240//3706 
f 4240//3706 4284//3703 4285//3705 
f 4286//3707 4239//3707 4238//3708 
f 4238//3708 4285//3705 4286//3707 
f 4287//3709 4237//3709 4236//3710 
f 4236//3710 4286//3707 4287//3709 
f 4288//3711 4235//3711 4234//3712 
f 4234//3712 4287//3709 4288//3711 
f 4289//3713 4233//3713 4232//3714 
f 4232//3714 4288//3711 4289//3713 
f 4290//3715 4231//3715 4230//3716 
f 4230//3716 4289//3713 4290//3715 
f 4291//3717 4229//3717 4228//3718 
f 4228//3718 4290//3715 4291//3717 
f 4292//3719 4227//3719 4226//3720 
f 4226//3720 4291//3717 4292//3719 
f 4293//3721 4225//3721 4224//3722 
f 4224//3722 4292//3719 4293//3721 
f 4294//3723 4223//3723 4222//3724 
f 4222//3724 4293//3721 4294//3723 
f 4279//3725 4278//3726 4295//3726 
f 4223//3723 4294//3723 4295//3726 
f 4295//3726 4278//3726 4223//3723 
f 4296//3725 4297//3727 4276//3728 
f 4297//3727 4277//3727 4276//3728 
f 4297//3727 4298//3729 4274//3730 
f 4298//3729 4275//3729 4274//3730 
f 4298//3729 4299//3731 4272//3732 
f 4299//3731 4273//3731 4272//3732 
f 4300//3733 4271//3733 4270//3734 
f 4270//3734 4299//3731 4300//3733 
f 4301//3735 4269//3735 4268//3736 
f 4268//3736 4300//3733 4301//3735 
f 4302//3737 4267//3737 4266//3738 
f 4266//3738 4301//3735 4302//3737 
f 4303//3739 4265//3739 4264//3740 
f 4264//3740 4302//3737 4303//3739 
f 4304//3741 4263//3741 4262//3742 
f 4262//3742 4303//3739 4304//3741 
f 4305//3743 4261//3743 4260//3744 
f 4260//3744 4304//3741 4305//3743 
f 4306//3745 4259//3745 4258//3746 
f 4258//3746 4305//3743 4306//3745 
f 4306//3745 4307//3747 4256//3748 
f 4307//3747 4257//3747 4256//3748 
f 4308//3749 4255//3749 4254//3750 
f 4254//3750 4307//3747 4308//3749 
f 4309//3751 4253//3751 4252//3752 
f 4252//3752 4308//3749 4309//3751 
f 4309//3751 4281//3698 4250//3753 
f 4281//3698 4251//3754 4250//3753 
f 4250//3753 4253//3751 4309//3751 
f 4252//3752 4255//3749 4308//3749 
f 4254//3750 4257//3747 4307//3747 
f 4256//3748 4259//3745 4306//3745 
f 4258//3746 4261//3743 4305//3743 
f 4260//3744 4263//3741 4304//3741 
f 4262//3742 4265//3739 4303//3739 
f 4264//3740 4267//3737 4302//3737 
f 4266//3738 4269//3735 4301//3735 
f 4268//3736 4271//3733 4300//3733 
f 4270//3734 4273//3731 4299//3731 
f 4272//3732 4275//3729 4298//3729 
f 4274//3730 4277//3727 4297//3727 
f 4276//3728 4279//3725 4296//3725 
f 4295//3726 4296//3725 4279//3725 
f 4222//3724 4225//3721 4293//3721 
f 4224//3722 4227//3719 4292//3719 
f 4226//3720 4229//3717 4291//3717 
f 4228//3718 4231//3715 4290//3715 
f 4230//3716 4233//3713 4289//3713 
f 4232//3714 4235//3711 4288//3711 
f 4234//3712 4237//3709 4287//3709 
f 4236//3710 4239//3707 4286//3707 
f 4238//3708 4241//3705 4285//3705 
f 4240//3706 4242//3703 4284//3703 
f 4243//3704 4244//3701 4283//3701 
f 4245//3702 4246//3699 4282//3699 
f 4247//3700 4249//3696 4280//3696 
f 4248//3697 4251//3754 4281//3698 
o mesh8
f 4294//3755 4293//3755 4161//3755 
f 4107//3755 4295//3755 4294//3755 
f 4293//3755 4292//3755 4159//3755 
f 4291//3755 4290//3755 4155//3755 
f 4290//3755 4289//3755 4153//3755 
f 4159//3755 4161//3755 4293//3755 
f 4292//3755 4291//3755 4157//3755 
f 4153//3755 4155//3755 4290//3755 
f 4289//3755 4288//3755 4151//3755 
f 4288//3755 4287//3755 4149//3755 
f 4287//3755 4286//3755 4147//3755 
f 4284//3755 4283//3755 4141//3755 
f 4283//3755 4282//3755 4139//3755 
f 4307//3755 4306//3755 4127//3755 
f 4306//3755 4305//3755 4125//3755 
f 4157//3755 4159//3755 4292//3755 
f 4151//3755 4153//3755 4289//3755 
f 4147//3755 4149//3755 4287//3755 
f 4286//3755 4285//3755 4145//3755 
f 4285//3755 4284//3755 4143//3755 
f 4139//3755 4141//3755 4283//3755 
f 4280//3755 4281//3755 4135//3755 
f 4281//3755 4309//3755 4133//3755 
f 4125//3755 4127//3755 4306//3755 
f 4305//3755 4304//3755 4123//3755 
f 4155//3755 4157//3755 4291//3755 
f 4145//3755 4147//3755 4286//3755 
f 4141//3755 4143//3755 4284//3755 
f 4282//3755 4280//3755 4137//3755 
f 4133//3755 4135//3755 4281//3755 
f 4309//3755 4308//3755 4131//3755 
f 4308//3755 4307//3755 4129//3755 
f 4123//3755 4125//3755 4305//3755 
f 4302//3755 4301//3755 4117//3755 
f 4301//3755 4300//3755 4115//3755 
f 4300//3755 4299//3755 4113//3755 
f 4299//3755 4298//3755 4111//3755 
f 4149//3755 4151//3755 4288//3755 
f 4137//3755 4139//3755 4282//3755 
f 4131//3755 4133//3755 4309//3755 
f 4127//3755 4129//3755 4307//3755 
f 4115//3755 4117//3755 4301//3755 
f 4111//3755 4113//3755 4299//3755 
f 4298//3755 4297//3755 4109//3755 
f 4297//3755 4296//3755 4106//3755 
f 4143//3755 4145//3755 4285//3755 
f 4129//3755 4131//3755 4308//3755 
f 4304//3755 4303//3755 4121//3755 
f 4303//3755 4302//3755 4119//3755 
f 4113//3755 4115//3755 4300//3755 
f 4106//3755 4109//3755 4297//3755 
f 4135//3755 4137//3755 4280//3755 
f 4119//3755 4121//3755 4303//3755 
f 4109//3755 4111//3755 4298//3755 
f 4296//3755 4295//3755 4107//3755 
f 4121//3755 4123//3755 4304//3755 
f 4107//3755 4106//3755 4296//3755 
f 4117//3755 4119//3755 4302//3755 
f 4161//3755 4107//3755 4294//3755 
g 35cm_T2020
v 0.218651 0.00884011 -0.0425171 
v -0.131349 0.00884011 -0.0425171 
v -0.131349 0.00530457 -0.0389816 
v 0.218651 0.00530457 -0.0389816 
v -0.131349 0.00134011 -0.0389816 
v 0.218651 0.00134011 -0.0389816 
v -0.131349 0.00134011 -0.0429461 
v 0.218651 0.00134011 -0.0429461 
v -0.131349 0.00487564 -0.0464816 
v 0.218651 0.00487564 -0.0464816 
v -0.131349 0.00487564 -0.0514816 
v 0.218651 0.00487564 -0.0514816 
v -0.131349 0.00134011 -0.0550171 
v 0.218651 0.00134011 -0.0550171 
v -0.131349 0.00134011 -0.0589816 
v 0.218651 0.00134011 -0.0589816 
v -0.131349 0.00530457 -0.0589816 
v 0.218651 0.00530457 -0.0589816 
v -0.131349 0.00884011 -0.0554461 
v 0.218651 0.00884011 -0.0554461 
v -0.131349 0.0138401 -0.0554461 
v 0.218651 0.0138401 -0.0554461 
v -0.131349 0.0173756 -0.0589816 
v 0.218651 0.0173756 -0.0589816 
v -0.131349 0.0213401 -0.0589816 
v 0.218651 0.0213401 -0.0589816 
v -0.131349 0.0213401 -0.0550171 
v 0.218651 0.0213401 -0.0550171 
v -0.131349 0.0178046 -0.0514816 
v 0.218651 0.0178046 -0.0514816 
v -0.131349 0.0178046 -0.0464816 
v 0.218651 0.0178046 -0.0464816 
v -0.131349 0.0213401 -0.0429461 
v 0.218651 0.0213401 -0.0429461 
v -0.131349 0.0213401 -0.0389816 
v 0.218651 0.0213401 -0.0389816 
v 0.218651 0.0173756 -0.0389816 
v 0.218651 0.0138401 -0.0425171 
v -0.131349 0.0173756 -0.0389816 
v -0.131349 0.0138401 -0.0425171 
vn -0.137519 0.731254 0.668099 
vn -0.139692 -0.00920993 0.990152 
vn -0.128835 -0.989355 -0.0676614 
vn -0.12346 -0.672775 -0.729473 
vn -0.135709 -0.739525 0.659307 
vn -0.128835 -0.989355 -0.0676614 
vn -0.121952 -0.00804034 -0.992503 
vn -0.124818 0.663716 -0.737497 
vn -0.12346 -0.672775 -0.729473 
vn -0.121952 -0.00804034 -0.992503 
vn -0.131037 0.988986 -0.0688178 
vn -0.137519 0.731254 0.668099 
vn -0.124818 0.663716 -0.737497 
vn -0.131037 0.988986 -0.0688178 
vn 0.996812 -0.00993758 -0.0791592 
vn -0.998117 -0.00764007 -0.0608581 
vn -0.139692 -0.00920993 0.990152 
vn -0.135709 -0.739525 0.659307 
usemtl 0.301961_0.301961_0.301961_0.000000_0.000000
o mesh229
f 4310//3756 4311//3756 4312//3756 
f 4312//3756 4313//3756 4310//3756 
o mesh230
f 4313//3757 4312//3757 4314//3757 
f 4314//3757 4315//3757 4313//3757 
o mesh231
f 4315//3758 4314//3758 4316//3758 
f 4316//3758 4317//3758 4315//3758 
o mesh232
f 4317//3759 4316//3759 4318//3759 
f 4318//3759 4319//3759 4317//3759 
o mesh233
f 4319//3758 4318//3758 4320//3758 
f 4320//3758 4321//3758 4319//3758 
o mesh234
f 4321//3760 4320//3760 4322//3760 
f 4322//3760 4323//3760 4321//3760 
o mesh235
f 4323//3761 4322//3761 4324//3761 
f 4324//3761 4325//3761 4323//3761 
o mesh236
f 4325//3762 4324//3762 4326//3762 
f 4326//3762 4327//3762 4325//3762 
o mesh237
f 4327//3763 4326//3763 4328//3763 
f 4328//3763 4329//3763 4327//3763 
o mesh238
f 4329//3762 4328//3762 4330//3762 
f 4330//3762 4331//3762 4329//3762 
o mesh239
f 4331//3764 4330//3764 4332//3764 
f 4332//3764 4333//3764 4331//3764 
o mesh240
f 4333//3765 4332//3765 4334//3765 
f 4334//3765 4335//3765 4333//3765 
o mesh241
f 4335//3766 4334//3766 4336//3766 
f 4336//3766 4337//3766 4335//3766 
o mesh242
f 4337//3767 4336//3767 4338//3767 
f 4338//3767 4339//3767 4337//3767 
o mesh243
f 4339//3766 4338//3766 4340//3766 
f 4340//3766 4341//3766 4339//3766 
o mesh244
f 4341//3768 4340//3768 4342//3768 
f 4342//3768 4343//3768 4341//3768 
o mesh245
f 4343//3769 4342//3769 4344//3769 
f 4344//3769 4345//3769 4343//3769 
o mesh246
f 4346//3770 4341//3770 4343//3770 
f 4323//3770 4325//3770 4327//3770 
f 4321//3770 4329//3770 4339//3770 
f 4343//3770 4345//3770 4346//3770 
f 4329//3770 4321//3770 4323//3770 
f 4341//3770 4319//3770 4321//3770 
f 4333//3770 4335//3770 4337//3770 
f 4346//3770 4347//3770 4341//3770 
f 4339//3770 4341//3770 4321//3770 
f 4339//3770 4331//3770 4333//3770 
f 4313//3770 4315//3770 4317//3770 
f 4327//3770 4329//3770 4323//3770 
f 4339//3770 4329//3770 4331//3770 
f 4319//3770 4310//3770 4313//3770 
f 4337//3770 4339//3770 4333//3770 
f 4319//3770 4347//3770 4310//3770 
f 4317//3770 4319//3770 4313//3770 
f 4347//3770 4319//3770 4341//3770 
o mesh247
f 4320//3771 4340//3771 4338//3771 
f 4322//3771 4328//3771 4326//3771 
f 4348//3771 4344//3771 4342//3771 
f 4332//3771 4338//3771 4336//3771 
f 4338//3771 4328//3771 4320//3771 
f 4326//3771 4324//3771 4322//3771 
f 4340//3771 4349//3771 4348//3771 
f 4312//3771 4318//3771 4316//3771 
f 4336//3771 4334//3771 4332//3771 
f 4322//3771 4320//3771 4328//3771 
f 4340//3771 4318//3771 4349//3771 
f 4316//3771 4314//3771 4312//3771 
f 4332//3771 4330//3771 4338//3771 
f 4342//3771 4340//3771 4348//3771 
f 4312//3771 4311//3771 4318//3771 
f 4320//3771 4318//3771 4340//3771 
f 4330//3771 4328//3771 4338//3771 
f 4311//3771 4349//3771 4318//3771 
o mesh248
f 4345//3772 4344//3772 4348//3772 
f 4348//3772 4346//3772 4345//3772 
o mesh249
f 4346//3773 4348//3773 4349//3773 
f 4349//3773 4347//3773 4346//3773 
o mesh250
f 4347//3772 4349//3772 4311//3772 
f 4311//3772 4310//3772 4347//3772 
g screwGear
v 0.0676477 0.0509901 0.0224614 
v 0.058797 0.0509901 0.0228699 
v 0.0583546 0.0509901 0.0218775 
v 0.0602631 0.0509901 0.0244563 
v 0.0594434 0.0509901 0.0237432 
v 0.0644194 0.0509901 0.0251767 
v 0.063346 0.0509901 0.0253444 
v 0.0622616 0.0509901 0.0252763 
v 0.0612175 0.0509901 0.0249755 
v 0.0654314 0.0509901 0.0247811 
v 0.0670845 0.0509901 0.0233906 
v 0.0663339 0.0509901 0.0241762 
v 0.058137 0.0509901 0.020813 
v 0.0679968 0.0509901 0.0214326 
v 0.0681105 0.0509901 0.0205733 
v 0.0581205 0.0509901 0.0205733 
v 0.0583546 0.0339901 0.0218775 
v 0.058137 0.0339901 0.020813 
v 0.058797 0.0339901 0.0228699 
v 0.0594434 0.0339901 0.0237432 
v 0.0602631 0.0339901 0.0244563 
v 0.0612175 0.0339901 0.0249755 
v 0.0622616 0.0339901 0.0252763 
v 0.063346 0.0339901 0.0253444 
v 0.0644194 0.0339901 0.0251767 
v 0.0654314 0.0339901 0.0247811 
v 0.0663339 0.0339901 0.0241762 
v 0.0670845 0.0339901 0.0233906 
v 0.0676477 0.0339901 0.0224614 
v 0.0679968 0.0339901 0.0214326 
v 0.0581205 0.0346532 0.0205733 
v 0.0581545 0.0339901 0.0197266 
v 0.0581545 0.0346727 0.0197266 
v 0.0681155 0.0339901 0.0203525 
v 0.0681105 0.0346532 0.0205733 
v 0.0681155 0.0346504 0.0203525 
v 0.0681182 0.0346488 0.0155733 
v 0.0681182 0.0339901 0.0155733 
v 0.0581545 0.0346727 0.0155733 
v 0.0581545 0.0339901 0.0155733 
v 0.0648825 0.0339901 0.0194129 
v 0.0650426 0.0339901 0.0198147 
v 0.0646398 0.0339901 0.019055 
v 0.0637541 0.0339901 0.022245 
v 0.0633317 0.0339901 0.022338 
v 0.0644909 0.0339901 0.0218017 
v 0.0641466 0.0339901 0.0220635 
v 0.0647709 0.0339901 0.0214721 
v 0.0649734 0.0339901 0.02109 
v 0.0650891 0.0339901 0.0206733 
v 0.0643258 0.0339901 0.0187575 
v 0.0635454 0.0339901 0.0183965 
v 0.0639553 0.0339901 0.0185346 
v 0.0631155 0.0339901 0.0183497 
v 0.0626855 0.0339901 0.0183965 
v 0.0613485 0.0339901 0.0194129 
v 0.0615912 0.0339901 0.019055 
v 0.0611884 0.0339901 0.0198147 
v 0.0611418 0.0339901 0.0206733 
v 0.0611184 0.0339901 0.0202415 
v 0.0628992 0.0339901 0.022338 
v 0.0624769 0.0339901 0.022245 
v 0.0631155 0.0339901 0.0223497 
v 0.0651125 0.0339901 0.0202415 
v 0.0619051 0.0339901 0.0187575 
v 0.0622757 0.0339901 0.0185346 
v 0.0612575 0.0339901 0.02109 
v 0.0614601 0.0339901 0.0214721 
v 0.0620844 0.0339901 0.0220635 
v 0.0617401 0.0339901 0.0218017 
v 0.0631155 0.0284901 0.0183497 
v 0.06332 0.0284817 0.0183602 
v 0.0635199 0.0284572 0.0183911 
v 0.063545 0.0284518 0.0183979 
v 0.0637552 0.0284069 0.0184548 
v 0.0639553 0.0283448 0.0185346 
v 0.0640408 0.0283125 0.0185767 
v 0.0643258 0.0281776 0.0187575 
v 0.0645147 0.0280537 0.0189365 
v 0.0646398 0.0279716 0.019055 
v 0.0648825 0.0277586 0.0194129 
v 0.0649305 0.0277094 0.0195096 
v 0.0650426 0.0275827 0.0198147 
v 0.0650888 0.0275251 0.020024 
v 0.0651125 0.0274941 0.0204594 
v 0.0650891 0.0275246 0.0206733 
v 0.0651125 0.027494 0.0202415 
v 0.0650415 0.027584 0.0208887 
v 0.0649734 0.0276628 0.02109 
v 0.0649285 0.0277074 0.0211748 
v 0.0647709 0.0278635 0.0214721 
v 0.0645172 0.0280576 0.0217708 
v 0.0644909 0.0280778 0.0218017 
v 0.0641466 0.0282676 0.0220635 
v 0.0640408 0.0283125 0.0221228 
v 0.0637541 0.0284072 0.022245 
v 0.0635199 0.0284572 0.0223084 
v 0.0633317 0.0284807 0.022338 
v 0.0631556 0.0284898 0.0223493 
v 0.0629801 0.0284864 0.0223452 
v 0.0628999 0.0284773 0.0223336 
v 0.0626833 0.0284525 0.0223025 
v 0.0624769 0.0284072 0.022245 
v 0.062447 0.0283978 0.022233 
v 0.0622596 0.028339 0.0221573 
v 0.0620844 0.0282676 0.0220635 
v 0.061948 0.0281924 0.0219598 
v 0.0617401 0.0280778 0.0218017 
v 0.0614988 0.0278932 0.0215177 
v 0.0614601 0.0278635 0.0214721 
v 0.0612575 0.0276628 0.02109 
v 0.0611892 0.0275837 0.0208878 
v 0.0611252 0.027503 0.0205472 
v 0.061116 0.0274908 0.0203948 
v 0.0611418 0.0275246 0.0206733 
v 0.0611499 0.0275349 0.0199802 
v 0.0611884 0.0275827 0.0198147 
v 0.0611253 0.027503 0.0201842 
v 0.0611184 0.027494 0.0202415 
v 0.0612589 0.0276644 0.0196059 
v 0.0613485 0.0277586 0.0194129 
v 0.0615002 0.0278918 0.0191891 
v 0.0615912 0.0279716 0.019055 
v 0.0619051 0.0281776 0.0187575 
v 0.0619445 0.0281989 0.0187284 
v 0.0622757 0.0283448 0.0185346 
v 0.0624467 0.028399 0.0184649 
v 0.0626855 0.0284529 0.0183965 
v 0.0629801 0.0284864 0.0183543 
v 0.0564509 0.0334456 0.0205733 
v 0.0564509 0.0334456 0.0155733 
v 0.0550412 0.0318898 0.0155733 
v 0.0550412 0.0318898 0.0205733 
v 0.0539873 0.0300739 0.0155733 
v 0.0539873 0.0300739 0.0205733 
v 0.0533359 0.028078 0.0155733 
v 0.0533359 0.028078 0.0205733 
v 0.0531155 0.0259901 0.0155733 
v 0.0531155 0.0259901 0.0205733 
v 0.0533359 0.0239022 0.0155733 
v 0.0533359 0.0239022 0.0205733 
v 0.0539873 0.0219063 0.0155733 
v 0.0539873 0.0219063 0.0205733 
v 0.0550412 0.0200905 0.0155733 
v 0.0550412 0.0200905 0.0205733 
v 0.0564509 0.0185346 0.0155733 
v 0.0581545 0.0173075 0.0155733 
v 0.0581545 0.0173075 0.0197266 
v 0.0564509 0.0185346 0.0205733 
v 0.0581205 0.017327 0.0205733 
v 0.0697282 0.0184887 0.0205733 
v 0.0697282 0.0184887 0.0155733 
v 0.071159 0.0200486 0.0155733 
v 0.071159 0.0200486 0.0205733 
v 0.0722294 0.0218747 0.0155733 
v 0.0722294 0.0218747 0.0205733 
v 0.0728914 0.0238853 0.0155733 
v 0.0728914 0.0238853 0.0205733 
v 0.0731155 0.0259901 0.0155733 
v 0.0731155 0.0259901 0.0205733 
v 0.0728914 0.0280949 0.0155733 
v 0.0728914 0.0280949 0.0205733 
v 0.0722294 0.0301055 0.0155733 
v 0.0722294 0.0301055 0.0205733 
v 0.071159 0.0319316 0.0155733 
v 0.071159 0.0319316 0.0205733 
v 0.0697282 0.0334915 0.0155733 
v 0.0681155 0.0173299 0.0203525 
v 0.0681105 0.017327 0.0205733 
v 0.0697282 0.0334915 0.0205733 
v 0.0681182 0.0173314 0.0155733 
v 0.0656008 0.0257198 0.0155733 
v 0.0654846 0.0251919 0.0155733 
v 0.0652576 0.0247012 0.0155733 
v 0.0681182 0.0179901 0.0155733 
v 0.0649305 0.0242709 0.0155733 
v 0.0581545 0.0179901 0.0155733 
v 0.0629801 0.0234938 0.0155733 
v 0.0640408 0.0236677 0.0155733 
v 0.0645184 0.0239209 0.0155733 
v 0.0624467 0.0235812 0.0155733 
v 0.0606739 0.0254527 0.0155733 
v 0.0635199 0.023523 0.0155733 
v 0.061497 0.0240847 0.0155733 
v 0.0619445 0.0237813 0.0155733 
v 0.0611252 0.0244772 0.0155733 
v 0.0608465 0.0249404 0.0155733 
v 0.0606155 0.0259901 0.0155733 
v 0.0606739 0.0265275 0.0155733 
v 0.0608465 0.0270398 0.0155733 
v 0.061497 0.0278955 0.0155733 
v 0.0611252 0.027503 0.0155733 
v 0.0635199 0.0284572 0.0155733 
v 0.0629801 0.0284864 0.0155733 
v 0.0652576 0.027279 0.0155733 
v 0.0649305 0.0277094 0.0155733 
v 0.0619445 0.0281989 0.0155733 
v 0.0624467 0.028399 0.0155733 
v 0.0640408 0.0283125 0.0155733 
v 0.0645184 0.0280593 0.0155733 
v 0.0654846 0.0267884 0.0155733 
v 0.0656008 0.0262604 0.0155733 
v 0.0656155 0.0259901 0.0155733 
v 0.0681155 0.0179901 0.0203525 
v 0.0581545 0.0179901 0.0197266 
v 0.0676477 0.0179901 0.0224614 
v 0.0679968 0.0179901 0.0214326 
v 0.0679968 0.000990107 0.0214326 
v 0.0670845 0.0179901 0.0233906 
v 0.0676477 0.000990107 0.0224614 
v 0.0663339 0.0179901 0.0241762 
v 0.0670845 0.000990107 0.0233906 
v 0.0654314 0.0179901 0.0247811 
v 0.0663339 0.000990107 0.0241762 
v 0.0644194 0.0179901 0.0251767 
v 0.0654314 0.000990107 0.0247811 
v 0.063346 0.0179901 0.0253444 
v 0.0644194 0.000990107 0.0251767 
v 0.0622616 0.0179901 0.0252763 
v 0.063346 0.000990107 0.0253444 
v 0.0612175 0.0179901 0.0249755 
v 0.0622616 0.000990107 0.0252763 
v 0.0602631 0.0179901 0.0244563 
v 0.0612175 0.000990107 0.0249755 
v 0.0594434 0.0179901 0.0237432 
v 0.0602631 0.000990107 0.0244563 
v 0.058797 0.0179901 0.0228699 
v 0.0594434 0.000990107 0.0237432 
v 0.0583546 0.0179901 0.0218775 
v 0.058797 0.000990107 0.0228699 
v 0.058137 0.0179901 0.020813 
v 0.0583546 0.000990107 0.0218775 
v 0.058137 0.000990107 0.020813 
v 0.0581205 0.000990107 0.0205733 
v 0.0681105 0.000990107 0.0205733 
v 0.0628992 0.0179901 0.022338 
v 0.0633317 0.0179901 0.022338 
v 0.0631155 0.0179901 0.0223497 
v 0.0624769 0.0179901 0.022245 
v 0.0637541 0.0179901 0.022245 
v 0.0650426 0.0179901 0.0198147 
v 0.0620844 0.0179901 0.0220635 
v 0.0612575 0.0179901 0.02109 
v 0.0611418 0.0179901 0.0206733 
v 0.0648825 0.0179901 0.0194129 
v 0.0649734 0.0179901 0.02109 
v 0.0647709 0.0179901 0.0214721 
v 0.0644909 0.0179901 0.0218017 
v 0.0641466 0.0179901 0.0220635 
v 0.0617401 0.0179901 0.0218017 
v 0.0614601 0.0179901 0.0214721 
v 0.0611184 0.0179901 0.0202415 
v 0.0613485 0.0179901 0.0194129 
v 0.0619051 0.0179901 0.0187575 
v 0.0615912 0.0179901 0.019055 
v 0.0643258 0.0179901 0.0187575 
v 0.0639553 0.0179901 0.0185346 
v 0.0646398 0.0179901 0.019055 
v 0.0611884 0.0179901 0.0198147 
v 0.0626855 0.0179901 0.0183965 
v 0.0622757 0.0179901 0.0185346 
v 0.0635454 0.0179901 0.0183965 
v 0.0631155 0.0179901 0.0183497 
v 0.0650891 0.0179901 0.0206733 
v 0.0651125 0.0179901 0.0202415 
v 0.0631155 0.0234901 0.0183497 
v 0.0629801 0.0234938 0.0183543 
v 0.0626855 0.0235274 0.0183965 
v 0.0624467 0.0235812 0.0184649 
v 0.0622757 0.0236354 0.0185346 
v 0.0619445 0.0237813 0.0187284 
v 0.0619051 0.0238026 0.0187575 
v 0.0615912 0.0240086 0.019055 
v 0.0615002 0.0240884 0.0191891 
v 0.0613485 0.0242216 0.0194129 
v 0.0612583 0.0243165 0.0196076 
v 0.0611499 0.0244453 0.0199802 
v 0.0611252 0.0244772 0.0201523 
v 0.0611884 0.0243975 0.0198147 
v 0.0611252 0.0244772 0.0205472 
v 0.0611418 0.0244556 0.0206733 
v 0.0611218 0.0244817 0.0202416 
v 0.061116 0.0244894 0.0203942 
v 0.0611894 0.0243962 0.0208887 
v 0.0612575 0.0243174 0.02109 
v 0.0614601 0.0241167 0.0214721 
v 0.0614988 0.024087 0.0215177 
v 0.0617401 0.0239025 0.0218017 
v 0.0619445 0.0237813 0.0219711 
v 0.0620886 0.0237172 0.0220563 
v 0.0624467 0.0235812 0.0222346 
v 0.0624773 0.0235743 0.0222434 
v 0.062259 0.0236414 0.0221571 
v 0.0626836 0.0235277 0.0223025 
v 0.0628992 0.0234995 0.022338 
v 0.0631563 0.0234904 0.0223493 
v 0.0629802 0.0234966 0.0223416 
v 0.0633317 0.0234995 0.022338 
v 0.0635199 0.023523 0.0223084 
v 0.0637541 0.023573 0.022245 
v 0.0640408 0.0236677 0.0221228 
v 0.0641466 0.0237126 0.0220635 
v 0.0644909 0.0239025 0.0218017 
v 0.0645172 0.0239226 0.0217708 
v 0.0647709 0.0241167 0.0214721 
v 0.0649305 0.0242709 0.0211899 
v 0.064968 0.0243132 0.021088 
v 0.0650417 0.0243965 0.0208878 
v 0.0650891 0.0244556 0.0206733 
v 0.0651125 0.0244862 0.0204584 
v 0.0650886 0.0244549 0.020023 
v 0.0650426 0.0243975 0.0198147 
v 0.0651125 0.0244862 0.0202415 
v 0.0649305 0.0242709 0.0195096 
v 0.0648825 0.0242216 0.0194129 
v 0.0646398 0.0240086 0.019055 
v 0.0645147 0.0239265 0.0189365 
v 0.0643258 0.0238026 0.0187575 
v 0.0640408 0.0236677 0.0185767 
v 0.0639532 0.0236387 0.0185393 
v 0.0637565 0.0235737 0.0184552 
v 0.0635454 0.0235274 0.0183965 
v 0.0633201 0.0234985 0.0183602 
v 0.0635198 0.0235241 0.0183924 
v 0.0606739 0.0265275 0.0355733 
v 0.0606155 0.0259901 0.0355733 
v 0.0608465 0.0270398 0.0355733 
v 0.0654846 0.0267884 0.0355733 
v 0.0652576 0.027279 0.0355733 
v 0.0656008 0.0262604 0.0355733 
v 0.0656008 0.0257198 0.0355733 
v 0.0656155 0.0259901 0.0355733 
v 0.0654846 0.0251919 0.0355733 
v 0.0652576 0.0247012 0.0355733 
v 0.0606739 0.0254527 0.0355733 
v 0.0608465 0.0249404 0.0355733 
v 0.0649305 0.0242709 0.0355733 
v 0.0640408 0.0236677 0.0355733 
v 0.0645184 0.0239209 0.0355733 
v 0.0629801 0.0234938 0.0355733 
v 0.0635199 0.023523 0.0355733 
v 0.0624467 0.0235812 0.0355733 
v 0.0619445 0.0237813 0.0355733 
v 0.061497 0.0240847 0.0355733 
v 0.0611252 0.0244772 0.0355733 
v 0.0611252 0.027503 0.0355733 
v 0.061497 0.0278955 0.0355733 
v 0.0619445 0.0281989 0.0355733 
v 0.0624467 0.028399 0.0355733 
v 0.0629801 0.0284864 0.0355733 
v 0.0635199 0.0284572 0.0355733 
v 0.0640408 0.0283125 0.0355733 
v 0.0645184 0.0280593 0.0355733 
v 0.0649305 0.0277094 0.0355733 
v 0.0407577 0.0458657 0.0205733 
v 0.0429421 0.0477854 0.0205733 
v 0.0659361 -0.00805021 0.0205733 
v 0.0602948 -0.00805021 0.0205733 
v 0.0326946 0.0163086 0.0205733 
v 0.0320223 0.0197829 0.0205733 
v 0.0393492 0.044311 0.0205733 
v 0.0514954 0.0531287 0.0205733 
v 0.0545824 0.0544814 0.0205733 
v 0.0484613 0.0513718 0.0205733 
v 0.0514457 0.0531069 0.0205733 
v 0.0469184 0.0505108 0.0205733 
v 0.0433303 0.0481265 0.0205733 
v 0.0460592 0.0500314 0.0205733 
v 0.0952285 0.0147801 0.0205733 
v 0.0715005 -0.00712168 0.0205733 
v 0.0423883 0.000189138 0.0205733 
v 0.0411094 0.00147668 0.0205733 
v 0.034851 0.0104242 0.0205733 
v 0.0337528 0.0129025 0.0205733 
v 0.0371361 0.00627368 0.0205733 
v 0.0353395 0.0093218 0.0205733 
v 0.0329455 0.0155011 0.0205733 
v 0.0333687 0.0141387 0.0205733 
v 0.0317283 0.0235572 0.0205733 
v 0.0318049 0.0257619 0.0205733 
v 0.0364071 0.0404676 0.0205733 
v 0.0384402 0.0433077 0.0205733 
v 0.0806929 0.0520783 0.0205733 
v 0.0746249 0.0548588 0.0205733 
v 0.0964665 0.0219428 0.0205733 
v 0.0960421 0.0183547 0.0205733 
v 0.0931556 0.00973318 0.0205733 
v 0.0900701 0.00501045 0.0205733 
v 0.0817976 -0.00260497 0.0205733 
v 0.0768362 -0.00528995 0.0205733 
v 0.0451425 -0.00203462 0.0205733 
v 0.031952 0.0206852 0.0205733 
v 0.0318486 0.027018 0.0205733 
v 0.0323494 0.0304074 0.0205733 
v 0.036275 0.0402299 0.0205733 
v 0.0761715 0.0542527 0.0205733 
v 0.07772 0.0536457 0.0205733 
v 0.0713159 0.0557464 0.0205733 
v 0.0882703 0.0458362 0.0205733 
v 0.0886469 0.0454472 0.0205733 
v 0.0849115 0.0490624 0.0205733 
v 0.0861666 0.0480093 0.0205733 
v 0.096507 0.0253198 0.0205733 
v 0.0950857 0.0143384 0.0205733 
v 0.0944786 0.0124603 0.0205733 
v 0.0862494 0.000859999 0.0205733 
v 0.0481523 -0.00396474 0.0205733 
v 0.049771 -0.0047817 0.0205733 
v 0.048677 -0.0042574 0.0205733 
v 0.0398941 0.00270025 0.0205733 
v 0.039274 0.00341794 0.0205733 
v 0.0324366 0.0307354 0.0205733 
v 0.0332302 0.0337199 0.0205733 
v 0.0339746 0.0356182 0.0205733 
v 0.0347445 0.037474 0.0205733 
v 0.0334215 0.034285 0.0205733 
v 0.0611557 0.0561197 0.0205733 
v 0.0808502 0.0519954 0.0205733 
v 0.0908138 0.0426502 0.0205733 
v 0.0942419 0.0362495 0.0205733 
v 0.0962224 0.0198789 0.0205733 
v 0.0589874 -0.00790661 0.0205733 
v 0.0554092 -0.00705431 0.0205733 
v 0.0591511 -0.00793603 0.0205733 
v 0.0375878 0.00567035 0.0205733 
v 0.0609985 0.0560896 0.0205733 
v 0.0560619 0.0549412 0.0205733 
v 0.0577658 0.0554707 0.0205733 
v 0.0837806 0.0500114 0.0205733 
v 0.0887516 0.045312 0.0205733 
v 0.0927409 0.0394855 0.0205733 
v 0.0958542 0.0306312 0.0205733 
v 0.0961618 0.0291949 0.0205733 
v 0.0965103 0.0255918 0.0205733 
v 0.0519697 -0.00583539 0.0205733 
v 0.0645703 0.0563778 0.0205733 
v 0.0919175 0.0408376 0.0205733 
v 0.0943611 0.0358948 0.0205733 
v 0.0953696 0.0328947 0.0205733 
v 0.0549158 -0.00687946 0.0205733 
v 0.0661486 0.0563206 0.0205733 
v 0.0679013 0.056257 0.0205733 
v 0.0399748 0.00805243 0.0222086 
v 0.0401842 0.00773818 0.0222214 
v 0.043294 0.00443802 0.022372 
v 0.043535 0.00418226 0.0223837 
v 0.0470674 0.00149506 0.0225233 
v 0.0473235 0.00130022 0.0225334 
v 0.0511822 -0.000753694 0.0226661 
v 0.0514536 -0.000898112 0.0226754 
v 0.0557387 -0.00235097 0.0228216 
v 0.0560196 -0.00244623 0.0228312 
v 0.0605992 -0.00318763 0.0229874 
v 0.0608769 -0.00323257 0.0229969 
v 0.0655673 -0.00319444 0.023157 
v 0.0658289 -0.00319232 0.0231659 
v 0.0704313 -0.00237077 0.0233229 
v 0.0706662 -0.00232884 0.0233309 
v 0.0749942 -0.000784725 0.0234786 
v 0.0751951 -0.000713049 0.0234855 
v 0.0791172 0.00145322 0.023621 
v 0.0792858 0.00154638 0.0236269 
v 0.0828989 0.00438537 0.0237724 
v 0.0830403 0.00449643 0.0237781 
v 0.0862293 0.00799136 0.0239358 
v 0.0863395 0.00811221 0.0239412 
v 0.0889384 0.0121533 0.024105 
v 0.0890167 0.0122751 0.0241099 
v 0.0909019 0.0167006 0.0242728 
v 0.0909505 0.0168146 0.024277 
v 0.0920826 0.021531 0.0244357 
v 0.0924228 0.0262241 0.0245802 
v 0.0920049 0.0309276 0.0247263 
v 0.0907911 0.0356355 0.0248862 
v 0.0887785 0.0401458 0.0250538 
v 0.0860321 0.0442604 0.0252222 
v 0.0826788 0.0478134 0.0253844 
v 0.0788886 0.050692 0.0255341 
v 0.0747566 0.0528873 0.0256761 
v 0.0701887 0.0544321 0.025832 
v 0.0653305 0.0552146 0.0259977 
v 0.0603786 0.0551703 0.0261667 
v 0.0555423 0.0543031 0.0263317 
v 0.0510152 0.0526839 0.0264862 
v 0.0554229 0.0542604 0.0263358 
v 0.0469264 0.0504215 0.0266276 
v 0.0508911 0.0526153 0.0264905 
v 0.0431737 0.047468 0.0267789 
v 0.0468012 0.0503229 0.0266326 
v 0.039877 0.0438493 0.026942 
v 0.0430501 0.0473324 0.026785 
v 0.0372032 0.0396842 0.0271107 
v 0.0397656 0.0436757 0.0269491 
v 0.0352732 0.0351434 0.0272778 
v 0.0371145 0.0394756 0.0271184 
v 0.0341449 0.0304266 0.0274364 
v 0.0352165 0.0349065 0.0272858 
v 0.0338083 0.025734 0.0275809 
v 0.0341265 0.0301706 0.0274443 
v 0.0342299 0.02103 0.0277271 
v 0.0338322 0.0254678 0.0275892 
v 0.0354475 0.0163225 0.0278869 
v 0.034304 0.0207436 0.0277368 
v 0.0374638 0.0118137 0.0280546 
v 0.0355789 0.0160287 0.0278979 
v 0.0402135 0.0077014 0.028223 
v 0.0376551 0.0115277 0.0280663 
v 0.0435694 0.00415147 0.0283851 
v 0.0404619 0.00743869 0.028235 
v 0.0473611 0.00127619 0.0285348 
v 0.0438669 0.00392584 0.0283969 
v 0.0514952 -0.000916129 0.0286768 
v 0.0476965 0.00109834 0.0285463 
v 0.0560649 -0.00245748 0.0288327 
v 0.0518796 -0.0010458 0.0286899 
v 0.060924 -0.00323614 0.0289985 
v 0.0564952 -0.00252645 0.0288474 
v 0.0658759 -0.00318791 0.0291675 
v 0.061385 -0.00323165 0.0290143 
v 0.0707111 -0.00231683 0.0293325 
v 0.0663482 -0.00310283 0.0291836 
v 0.0752363 -0.000694389 0.0294869 
v 0.071174 -0.00215088 0.0293483 
v 0.0793232 0.00157114 0.0296282 
v 0.0756703 -0.000453806 0.0295019 
v 0.0830742 0.00452791 0.0297796 
v 0.0797259 0.00188857 0.0296445 
v 0.0863682 0.00814956 0.0299428 
v 0.0834428 0.0049332 0.0297979 
v 0.0890388 0.0123169 0.0301115 
v 0.0866795 0.00863526 0.0299625 
v 0.0909651 0.016859 0.0302786 
v 0.0892724 0.0128676 0.0301318 
v 0.0920895 0.0215762 0.0304372 
v 0.0911067 0.0174534 0.0302986 
v 0.0924225 0.0262683 0.0305815 
v 0.092133 0.0221895 0.030456 
v 0.0919971 0.0309728 0.0307278 
v 0.0923669 0.0268824 0.0306006 
v 0.0907757 0.0356798 0.0308877 
v 0.091832 0.0316091 0.0307494 
v 0.0887557 0.0401872 0.0310554 
v 0.090493 0.0363105 0.0309112 
v 0.0860027 0.0442972 0.0312238 
v 0.0883572 0.0407821 0.0310798 
v 0.0826444 0.0478441 0.0313859 
v 0.0855003 0.0448278 0.031248 
v 0.078851 0.050716 0.0315355 
v 0.0820584 0.0482877 0.031409 
v 0.0747149 0.0529053 0.0316775 
v 0.0782068 0.051057 0.0315576 
v 0.0701435 0.0544433 0.0318335 
v 0.0739908 0.053149 0.0317022 
v 0.0652834 0.0552181 0.0319993 
v 0.0693501 0.0545698 0.0318606 
v 0.0603316 0.0551659 0.0321683 
v 0.0644507 0.0552093 0.0320277 
v 0.0554974 0.054291 0.0323332 
v 0.0594945 0.0550144 0.0321968 
v 0.0509741 0.0526653 0.0324876 
v 0.0546917 0.0540014 0.0323607 
v 0.0468891 0.0503967 0.0326289 
v 0.0502312 0.0522527 0.0325133 
v 0.0431398 0.0474365 0.0327804 
v 0.0462082 0.0498591 0.0326564 
v 0.0398484 0.043812 0.0329436 
v 0.0425259 0.0467605 0.0328108 
v 0.0371811 0.0396424 0.0331123 
v 0.0393375 0.0430134 0.0329759 
v 0.0352586 0.0350989 0.0332794 
v 0.0368031 0.0387491 0.0331452 
v 0.034138 0.0303814 0.0334379 
v 0.0350326 0.0341474 0.0333114 
v 0.0338087 0.0256898 0.0335822 
v 0.0340699 0.0294116 0.0334677 
v 0.0342377 0.0209848 0.0337285 
v 0.0338966 0.0247264 0.0336122 
v 0.035463 0.0162783 0.0338885 
v 0.0344947 0.0199977 0.0337621 
v 0.0374868 0.0117723 0.0340562 
v 0.0358978 0.0153103 0.0339245 
v 0.0402429 0.00766467 0.0342246 
v 0.0380931 0.0108687 0.0340932 
v 0.0436038 0.00412073 0.0343866 
v 0.0409997 0.00686659 0.0342611 
v 0.0473988 0.00125223 0.0345361 
v 0.044478 0.00345994 0.0344211 
v 0.0515369 -0.000934087 0.0346782 
v 0.0483512 0.000749039 0.0345688 
v 0.0561101 -0.00246866 0.0348343 
v 0.0526021 -0.00129153 0.0347146 
v 0.0609711 -0.00323964 0.0350001 
v 0.0572674 -0.00265221 0.0348738 
v 0.0659229 -0.00318342 0.0351691 
v 0.062176 -0.00322596 0.0350412 
v 0.070756 -0.00230474 0.035334 
v 0.0671245 -0.00296497 0.0352101 
v 0.0752774 -0.000675673 0.0354883 
v 0.0719039 -0.00189114 0.0353732 
v 0.0469638 0.0504462 0.0206262 
v 0.0474275 0.0507328 0.0206098 
v 0.0436345 0.0478344 0.0207602 
v 0.0432076 0.0474995 0.0207773 
v 0.0402657 0.0442804 0.0209227 
v 0.0399058 0.0438867 0.0209404 
v 0.037505 0.0401602 0.0210915 
v 0.0372253 0.039726 0.0211091 
v 0.0354811 0.0356405 0.0212596 
v 0.0352878 0.0351879 0.0212763 
v 0.03426 0.0309209 0.0214199 
v 0.0341519 0.0304718 0.021435 
v 0.0338392 0.0262048 0.0215664 
v 0.0338079 0.0257782 0.0215796 
v 0.034185 0.0214977 0.0217125 
v 0.0342222 0.0210752 0.0217256 
v 0.0353289 0.0167685 0.0218717 
v 0.0354321 0.0163668 0.0218854 
v 0.0372787 0.0122197 0.0220394 
v 0.037441 0.0118551 0.022053 
v 0.0596371 -0.00799258 0.0205859 
v 0.0602948 -0.00805065 0.020603 
v 0.0610377 -0.00811624 0.0206224 
v 0.0646735 -0.00816789 0.020717 
v 0.0605064 -0.00806934 0.0206085 
v 0.0659358 -0.00805094 0.0207498 
v 0.068297 -0.00783218 0.0208113 
v 0.0662777 -0.00801926 0.0207587 
v 0.0715165 -0.0071812 0.0208953 
v 0.0725172 -0.0069375 0.0209214 
v 0.0759664 -0.00577361 0.0210114 
v 0.0718973 -0.0071042 0.0209052 
v 0.0768657 -0.00535893 0.0210349 
v 0.0792708 -0.0042499 0.0210977 
v 0.0772221 -0.00519458 0.0210442 
v 0.0818615 -0.00270071 0.0211675 
v 0.0829208 -0.00202318 0.0211969 
v 0.0857982 0.000224857 0.0212861 
v 0.0820299 -0.00259997 0.021172 
v 0.0824198 -0.00236683 0.0211825 
v 0.0863452 0.000754741 0.0213054 
v 0.0884194 0.00276417 0.0213786 
v 0.0864308 0.000837754 0.0213084 
v 0.0902046 0.0049073 0.0214511 
v 0.0911381 0.00608814 0.0214904 
v 0.0931079 0.00916224 0.0215867 
v 0.0903219 0.00504808 0.0214558 
v 0.090774 0.00559079 0.0214742 
v 0.0933423 0.00963127 0.0216006 
v 0.0947395 0.0124264 0.0216831 
v 0.0934816 0.00990995 0.0216088 
v 0.0956345 0.0148275 0.02175 
v 0.096217 0.0165105 0.0217963 
v 0.0970518 0.0200647 0.021889 
v 0.095782 0.0152231 0.021761 
v 0.0960245 0.0158736 0.0217791 
v 0.0970839 0.0203212 0.0218953 
v 0.0971378 0.020752 0.0219059 
v 0.0975047 0.0236861 0.0219783 
v 0.0975456 0.0259909 0.0220323 
v 0.0975413 0.0280013 0.0220797 
v 0.0971499 0.0316404 0.0221692 
v 0.0975504 0.0262661 0.0220388 
v 0.0975699 0.0273652 0.0220646 
v 0.0971438 0.0316684 0.0221699 
v 0.0971152 0.0318007 0.0221734 
v 0.0963758 0.0352158 0.0222625 
v 0.0957239 0.0371852 0.0223169 
v 0.0949785 0.0393095 0.0223763 
v 0.0956733 0.0373378 0.0223211 
v 0.0952169 0.0387167 0.0223593 
v 0.0934918 0.0424295 0.0224688 
v 0.0934042 0.0426132 0.0224742 
v 0.0914899 0.0457304 0.0225726 
v 0.0903595 0.0471953 0.022622 
v 0.0887879 0.0491614 0.022689 
v 0.0901129 0.0475148 0.0226327 
v 0.0892371 0.0486498 0.022671 
v 0.0865309 0.0514274 0.0227724 
v 0.0862053 0.0517542 0.0227844 
v 0.0833637 0.0540583 0.0228767 
v 0.0820216 0.0549278 0.0229153 
v 0.0796943 0.0563862 0.0229812 
v 0.0802683 0.0560636 0.0229656 
v 0.0817184 0.0551242 0.022924 
v 0.0770144 0.0576791 0.0230541 
v 0.076392 0.0579794 0.023071 
v 0.0729414 0.0592141 0.0231651 
v 0.0768613 0.0577529 0.0230583 
v 0.0716109 0.059536 0.0232014 
v 0.0687008 0.0601974 0.0232808 
v 0.071467 0.0595708 0.0232053 
v 0.0693507 0.0600828 0.023263 
v 0.0659743 0.060504 0.0233553 
v 0.0650578 0.0606071 0.0233804 
v 0.0613933 0.0606296 0.0234807 
v 0.0657324 0.0605313 0.0233619 
v 0.0602554 0.0605153 0.023512 
v 0.0570412 0.0601487 0.0236002 
v 0.0598811 0.0604777 0.0235222 
v 0.0577177 0.0602603 0.0235816 
v 0.0546063 0.0595882 0.0236671 
v 0.0534686 0.0593263 0.0236984 
v 0.0500042 0.0581315 0.0237938 
v 0.0541553 0.0594844 0.0236795 
v 0.0491862 0.057748 0.0238164 
v 0.046659 0.0565632 0.0238861 
v 0.0460668 0.0562386 0.0239025 
v 0.048802 0.0575679 0.023827 
v 0.0441462 0.0550235 0.0239583 
v 0.0429662 0.0542769 0.0239926 
v 0.0400904 0.0519996 0.0240873 
v 0.0439558 0.054903 0.0239638 
v 0.0396086 0.0515268 0.0241054 
v 0.0395029 0.051423 0.0241093 
v 0.0374509 0.0494095 0.0241864 
v 0.0370006 0.0489083 0.0242047 
v 0.0357312 0.0473036 0.0242612 
v 0.0328906 0.043129 0.0244018 
v 0.032764 0.0429286 0.0244084 
v 0.0325649 0.0425242 0.024421 
v 0.0347236 0.04603 0.024306 
v 0.0355989 0.0471364 0.0242671 
v 0.0324135 0.0422165 0.0244306 
v 0.0311309 0.0396104 0.0245117 
v 0.0308681 0.0389786 0.0245307 
v 0.0302777 0.0372633 0.0245807 
v 0.0296737 0.0355083 0.0246318 
v 0.0288527 0.0319326 0.0247305 
v 0.0301299 0.0368336 0.0245932 
v 0.0288262 0.0317125 0.0247362 
v 0.0287707 0.0312505 0.0247483 
v 0.0284115 0.0282604 0.0248264 
v 0.0283731 0.0275813 0.0248435 
v 0.028383 0.0259904 0.0248831 
v 0.0288053 0.0202647 0.0250301 
v 0.0288055 0.020263 0.0250301 
v 0.0283958 0.0239102 0.0249348 
v 0.0283849 0.0256865 0.0248906 
v 0.0288405 0.020105 0.0250345 
v 0.0296055 0.0166505 0.0251304 
v 0.0297939 0.0159979 0.0251491 
v 0.0302548 0.0147096 0.0251875 
v 0.0310308 0.0125408 0.0252521 
v 0.0303188 0.0145309 0.0251928 
v 0.0325279 0.00943633 0.0253502 
v 0.032625 0.00923483 0.0253566 
v 0.0345761 0.00609114 0.0254624 
v 0.0349686 0.00553947 0.0254818 
v 0.0356922 0.00464672 0.0255143 
v 0.0372804 0.00268695 0.0255859 
v 0.0359655 0.00430948 0.0255267 
v 0.0395662 0.000407509 0.0256756 
v 0.0398793 9.52027e-05 0.0256879 
v 0.0427613 -0.0022254 0.0257875 
v 0.0433113 -0.00261392 0.0258052 
v 0.0441062 -0.00310393 0.025829 
v 0.0464373 -0.0045409 0.025899 
v 0.0444379 -0.00330835 0.025839 
v 0.0491536 -0.00584203 0.0259778 
v 0.0497474 -0.00612643 0.025995 
v 0.0532344 -0.00736219 0.0260964 
v 0.0493318 -0.00592739 0.025983 
v 0.0538843 -0.00754737 0.0261153 
v 0.054583 -0.00769991 0.0261357 
v 0.0574706 -0.00833038 0.02622 
v 0.0547552 -0.00773751 0.0261407 
v 0.0602473 -0.00863487 0.0263012 
v 0.061118 -0.00873036 0.0263267 
v 0.0648169 -0.00874173 0.0264352 
v 0.0605178 -0.00866454 0.0263091 
v 0.0654794 -0.00870208 0.0264546 
v 0.0659841 -0.0086401 0.0264695 
v 0.0691228 -0.0082546 0.0265619 
v 0.066386 -0.00859073 0.0264813 
v 0.0716403 -0.00767056 0.0266363 
v 0.0726971 -0.00742541 0.0266675 
v 0.0761915 -0.0062125 0.026771 
v 0.0721189 -0.00755955 0.0266504 
v 0.0767962 -0.00595912 0.0267889 
v 0.0770697 -0.00582394 0.0267971 
v 0.0774743 -0.00562393 0.0268091 
v 0.0800873 -0.00433219 0.0268868 
v 0.0820953 -0.0030596 0.0269495 
v 0.0831852 -0.00236886 0.0269835 
v 0.0823082 -0.00292468 0.0269561 
v 0.0860798 -7.02544e-05 0.0270861 
v 0.0865718 0.000373627 0.0271049 
v 0.0866362 0.000439438 0.0271076 
v 0.0867588 0.00056482 0.0271127 
v 0.0891358 0.00299532 0.0272113 
v 0.0904772 0.00469402 0.0272757 
v 0.093636 0.00947321 0.027448 
v 0.0936853 0.00956349 0.0274511 
v 0.0914074 0.00587195 0.0273203 
v 0.0906266 0.00488315 0.0272828 
v 0.0933769 0.00899826 0.0274316 
v 0.0937985 0.00980568 0.0274591 
v 0.0952382 0.0128853 0.0275617 
v 0.0958774 0.014743 0.0276202 
v 0.0973103 0.020284 0.0277882 
v 0.0973572 0.0205693 0.0277965 
v 0.0964309 0.0163511 0.027671 
v 0.0960339 0.0151978 0.0276346 
v 0.0972559 0.0199528 0.0277786 
v 0.0973775 0.0207701 0.0278021 
v 0.0977265 0.0242181 0.0278989 
v 0.0977178 0.0259899 0.0279466 
v 0.0977084 0.0278814 0.0279976 
v 0.0977161 0.0263188 0.0279555 
v 0.0972981 0.031549 0.0281015 
v 0.0972732 0.03169 0.0281056 
v 0.0971874 0.0321781 0.02812 
v 0.0963301 0.0357365 0.0282282 
v 0.0972403 0.0318774 0.0281111 
v 0.0958229 0.0371592 0.0282742 
v 0.0958042 0.0372116 0.0282759 
v 0.0935281 0.0424488 0.028452 
v 0.0935011 0.0425048 0.0284539 
v 0.0951016 0.0391824 0.0283396 
v 0.0957315 0.0374156 0.0282825 
v 0.093199 0.0430432 0.0284731 
v 0.0912139 0.0461179 0.0285873 
v 0.0933684 0.0427413 0.0284623 
v 0.0903505 0.0471869 0.0286298 
v 0.0864923 0.0513849 0.0288047 
v 0.0863067 0.0515703 0.0288127 
v 0.0889154 0.0489638 0.0287006 
v 0.0900622 0.0475439 0.028644 
v 0.085873 0.0519531 0.02883 
v 0.0829852 0.0542024 0.0289374 
v 0.0861208 0.0517344 0.0288201 
v 0.0819633 0.054837 0.0289711 
v 0.0798779 0.056132 0.0290399 
v 0.0816127 0.0550547 0.0289827 
v 0.0769541 0.0575408 0.0291327 
v 0.0760023 0.0579577 0.0291629 
v 0.072543 0.0591218 0.0292732 
v 0.0767537 0.0576373 0.029139 
v 0.0765607 0.0577303 0.0291452 
v 0.0715618 0.0593394 0.0293046 
v 0.0689817 0.0599117 0.0293872 
v 0.0713647 0.0593831 0.0293109 
v 0.0659536 0.0602507 0.0294845 
v 0.0647446 0.0603496 0.0295235 
v 0.0610955 0.0603047 0.0296415 
v 0.0656585 0.0602837 0.029494 
v 0.0653274 0.0603208 0.0295047 
v 0.0602814 0.0602076 0.0296679 
v 0.0574737 0.0598727 0.0297591 
v 0.0598564 0.0601569 0.0296817 
v 0.0546958 0.0592356 0.0298498 
v 0.0533945 0.0589048 0.0298924 
v 0.0499624 0.0576624 0.0300051 
v 0.0541966 0.0591211 0.0298662 
v 0.05389 0.0590508 0.0298762 
v 0.0493541 0.0573658 0.0300252 
v 0.0466834 0.0560636 0.0301133 
v 0.0489299 0.057159 0.0300392 
v 0.0444022 0.0546317 0.0301919 
v 0.0431242 0.0537889 0.030237 
v 0.0403065 0.0514913 0.0303495 
v 0.0441696 0.0544857 0.0301999 
v 0.043574 0.0541118 0.0302204 
v 0.0399621 0.051143 0.0303652 
v 0.0377515 0.0489081 0.0304663 
v 0.0398215 0.0510009 0.0303716 
v 0.0361892 0.0469471 0.0305492 
v 0.0351585 0.0455998 0.0306055 
v 0.03326 0.0425002 0.0307277 
v 0.0360243 0.0467402 0.0305579 
v 0.0354695 0.0460438 0.0305874 
v 0.0331271 0.0422199 0.0307382 
v 0.0317037 0.0392178 0.0308503 
v 0.0329594 0.0418662 0.0307514 
v 0.0309424 0.0370349 0.0309276 
v 0.0303791 0.0353399 0.0309872 
v 0.0296018 0.0317884 0.0311059 
v 0.0307779 0.0365633 0.0309443 
v 0.0304978 0.0357602 0.0309727 
v 0.0295798 0.0315868 0.0311123 
v 0.0295247 0.0310818 0.0311283 
v 0.0292077 0.0281768 0.0312205 
v 0.0292044 0.02599 0.0312868 
v 0.0292314 0.0240312 0.0313465 
v 0.029667 0.0204407 0.0314614 
v 0.0292038 0.0256421 0.0312974 
v 0.0292021 0.024519 0.0313315 
v 0.0296742 0.0204098 0.0314625 
v 0.0297222 0.0202029 0.0314695 
v 0.0304842 0.0169204 0.0315815 
v 0.0311489 0.0150162 0.0316507 
v 0.0334109 0.00991446 0.0318457 
v 0.0334749 0.00978461 0.0318508 
v 0.0318753 0.013027 0.0317237 
v 0.0312276 0.0147907 0.0316589 
v 0.0316848 0.0134812 0.0317066 
v 0.0365468 0.00531164 0.0320431 
v 0.0365852 0.00526356 0.0320452 
v 0.0335863 0.00960922 0.0318581 
v 0.0354115 0.0067345 0.0319788 
v 0.0403336 0.00124172 0.0322375 
v 0.0404781 0.00109748 0.0322446 
v 0.0376831 0.00388767 0.0321074 
v 0.0368429 0.00494052 0.0320598 
v 0.0407279 0.000898682 0.0322554 
v 0.0433053 -0.00115251 0.0323665 
v 0.0447739 -0.00208242 0.0324227 
v 0.0467364 -0.00329622 0.032497 
v 0.0463821 -0.00310068 0.0324842 
v 0.0451349 -0.00231099 0.0324365 
v 0.0496597 -0.00468732 0.0326031 
v 0.0499803 -0.00483989 0.0326148 
v 0.0533685 -0.00602343 0.0327386 
v 0.0549167 -0.00638195 0.0327956 
v 0.0572967 -0.00690756 0.0328833 
v 0.0551337 -0.0064322 0.0328036 
v 0.0568925 -0.00683945 0.0328683 
v 0.0603629 -0.00723574 0.0329972 
v 0.0608668 -0.00728968 0.0330159 
v 0.0644542 -0.00728419 0.0331503 
v 0.0606758 -0.00726923 0.0330088 
v 0.0658585 -0.00712898 0.0332034 
v 0.0680484 -0.00688692 0.0332861 
v 0.0662972 -0.00708049 0.0332199 
v 0.0712581 -0.00616168 0.0334085 
v 0.0717792 -0.00604394 0.0334284 
v 0.0751686 -0.00486819 0.0335588 
v 0.0763949 -0.00428725 0.0336064 
v 0.078436 -0.00332033 0.0336856 
v 0.0768299 -0.0040812 0.0336232 
v 0.0811612 -0.00162951 0.0337953 
v 0.0817125 -0.00128745 0.0338175 
v 0.0845039 0.000918551 0.0339459 
v 0.0814075 -0.00147669 0.0338052 
v 0.0853895 0.00179177 0.0339929 
v 0.0870567 0.00343545 0.0340813 
v 0.0855451 0.00194515 0.0340011 
v 0.0889985 0.0058453 0.0342024 
v 0.0894789 0.00644139 0.0342323 
v 0.0913802 0.00944431 0.0343744 
v 0.0891745 0.00606371 0.0342133 
v 0.0918628 0.0104309 0.0344187 
v 0.0929543 0.0126625 0.0345189 
v 0.0920395 0.0107922 0.0344349 
v 0.0939367 0.0154096 0.0346363 
v 0.0941917 0.0161225 0.0346668 
v 0.0950105 0.0195808 0.0348076 
v 0.0941065 0.0158842 0.0346566 
v 0.0951419 0.0206441 0.0348488 
v 0.0954498 0.0231353 0.0349455 
v 0.0952046 0.0211515 0.0348685 
v 0.0954833 0.0259905 0.0350512 
v 0.0954928 0.0268026 0.0350812 
v 0.0951402 0.0303063 0.0352155 
v 0.0954874 0.0263468 0.0350644 
v 0.0949278 0.0312968 0.0352563 
v 0.0939423 0.0352862 0.0354239 
v 0.0935005 0.0364194 0.0354756 
v 0.09488 0.0315196 0.0352655 
v 0.094397 0.033772 0.0353582 
v 0.0934086 0.036655 0.0354864 
v 0.0926672 0.0385565 0.0355733 
v 0.092874 0.0378485 0.0355733 
v 0.0936652 0.035139 0.0355733 
v 0.0942784 0.0316553 0.0355733 
v 0.0932387 0.0365996 0.0355733 
v 0.0942946 0.0314206 0.0355733 
v 0.0945027 0.028423 0.0355733 
v 0.0943824 0.0249622 0.0355733 
v 0.0944301 0.0263368 0.0355733 
v 0.0938815 0.0215728 0.0355733 
v 0.0938255 0.021362 0.0355733 
v 0.0930007 0.0182604 0.0355733 
v 0.0928095 0.0176953 0.0355733 
v 0.0914864 0.0145063 0.0355733 
v 0.0923034 0.0164756 0.0355733 
v 0.0898239 0.0115126 0.0355733 
v 0.0877907 0.00867248 0.0355733 
v 0.0900155 0.0118577 0.0355733 
v 0.086963 0.00775886 0.0355733 
v 0.0854732 0.00611455 0.0355733 
v 0.0829007 0.0038537 0.0355733 
v 0.0801717 0.00194882 0.0355733 
v 0.0833771 0.00427237 0.0355733 
v 0.0777696 0.000608376 0.0355733 
v 0.0763477 -0.000124207 0.0355248 
v 0.0794109 0.00152429 0.0355733 
v 0.0350245 0.0105248 0.0206967 
v 0.0380259 0.00602032 0.0208652 
v 0.0416921 0.00212971 0.0210274 
v 0.0458372 -0.00102359 0.0211772 
v 0.050356 -0.00342882 0.0213191 
v 0.0553518 -0.00512265 0.0214749 
v 0.0606662 -0.005983 0.0216407 
v 0.0660843 -0.00593896 0.0218096 
v 0.0713769 -0.00499421 0.0219747 
v 0.0763321 -0.00322634 0.0221292 
v 0.0808078 -0.00075426 0.0222706 
v 0.0849156 0.00247346 0.0224218 
v 0.0885254 0.00642955 0.022585 
v 0.0914545 0.0109842 0.0227537 
v 0.0935703 0.015951 0.0229208 
v 0.094809 0.0211114 0.0230795 
v 0.0951812 0.0262461 0.023224 
v 0.0947239 0.0313923 0.0233701 
v 0.093396 0.0365434 0.0235299 
v 0.0911939 0.0414781 0.0236975 
v 0.088189 0.04598 0.0238659 
v 0.08452 0.0498674 0.0240281 
v 0.0803732 0.053017 0.0241779 
v 0.0758522 0.0554189 0.0243198 
v 0.0708544 0.057109 0.0244757 
v 0.065539 0.0579652 0.0246415 
v 0.060121 0.0579168 0.0248104 
v 0.0548295 0.0569679 0.0249754 
v 0.0498764 0.0551964 0.0251299 
v 0.0454027 0.0527209 0.0252713 
v 0.0412968 0.0494895 0.0254226 
v 0.0376899 0.0455302 0.0255858 
v 0.0347643 0.0409731 0.0257545 
v 0.0326527 0.0360049 0.0259216 
v 0.0314182 0.0308442 0.0260802 
v 0.0310499 0.0257099 0.0262246 
v 0.0315112 0.0205632 0.0263708 
v 0.0328434 0.0154126 0.0265307 
v 0.0350495 0.0104794 0.0266983 
v 0.038058 0.00598007 0.0268667 
v 0.0417297 0.00209602 0.0270289 
v 0.0458784 -0.00104987 0.0271785 
v 0.0504015 -0.00344854 0.0273206 
v 0.0554013 -0.00513496 0.0274765 
v 0.0607177 -0.00598691 0.0276423 
v 0.0661357 -0.00593414 0.0278112 
v 0.071426 -0.00498107 0.0279762 
v 0.0763771 -0.00320593 0.0281306 
v 0.0808487 -0.000727169 0.028272 
v 0.0849527 0.00250789 0.0284234 
v 0.0885568 0.00647041 0.0285866 
v 0.0914787 0.01103 0.0287553 
v 0.0935863 0.0159996 0.0289223 
v 0.0948165 0.0211608 0.0290809 
v 0.0951808 0.0262945 0.0292253 
v 0.0947154 0.0314418 0.0293716 
v 0.093379 0.0365918 0.0295315 
v 0.0911689 0.0415234 0.0296991 
v 0.0881569 0.0460202 0.0298675 
v 0.0844824 0.049901 0.0300296 
v 0.080332 0.0530432 0.0301792 
v 0.0758067 0.0554386 0.0303213 
v 0.0708049 0.0571213 0.0304772 
v 0.0654875 0.057969 0.0306431 
v 0.0600696 0.0579119 0.030812 
v 0.0547804 0.0569547 0.030977 
v 0.0498314 0.0551759 0.0311313 
v 0.0453619 0.0526938 0.0312727 
v 0.0412597 0.0494551 0.0314241 
v 0.0376585 0.0454893 0.0315874 
v 0.0347402 0.0409274 0.0317561 
v 0.0326367 0.0359563 0.0319231 
v 0.0314107 0.0307947 0.0320816 
v 0.0310504 0.0256615 0.0322259 
v 0.0315198 0.0205137 0.0323723 
v 0.0328604 0.0153642 0.0325323 
v 0.0350746 0.0104342 0.0326999 
v 0.0380901 0.00593988 0.0328683 
v 0.0417673 0.00206239 0.0330304 
v 0.0459195 -0.00107609 0.0331799 
v 0.0504471 -0.00346819 0.033322 
v 0.0554508 -0.00514719 0.033478 
v 0.0607693 -0.00599073 0.0336439 
v 0.0661871 -0.00592923 0.0338128 
v 0.0714751 -0.00496784 0.0339777 
v 0.0764221 -0.00318545 0.034132 
v 0.0808895 -0.000700006 0.0342734 
v 0.0849897 0.0025424 0.0344249 
v 0.0885881 0.00651133 0.0345882 
v 0.0915028 0.0110758 0.0347569 
v 0.0936022 0.0160483 0.0349239 
v 0.094824 0.0212102 0.0350824 
v 0.0951803 0.0263429 0.0352266 
v 0.0947069 0.0314912 0.035373 
v 0.093362 0.0366402 0.035533 
v 0.0763822 -0.000198253 0.0355733 
v 0.0747853 -0.00112666 0.0355733 
v 0.0720425 -0.00232857 0.0355733 
v 0.0716485 -0.00250123 0.0355733 
v 0.0684652 -0.00349053 0.0355733 
v 0.0672309 -0.0037268 0.0355733 
v 0.0650753 -0.00413945 0.0355733 
v 0.0621405 -0.00436132 0.0355733 
v 0.0616607 -0.0043976 0.0355733 
v 0.0583297 -0.00427676 0.0355733 
v 0.056978 -0.00407467 0.0355733 
v 0.0549151 -0.00376623 0.0355733 
v 0.0519559 -0.00297247 0.0355733 
v 0.051606 -0.00287863 0.0355733 
v 0.0485109 -0.00166552 0.0355733 
v 0.0473103 -0.00103249 0.0355733 
v 0.0453808 -1.51811e-05 0.0355733 
v 0.0429598 0.00162391 0.0355733 
v 0.0424503 0.00196882 0.0355733 
v 0.0400644 0.00397094 0.0355733 
v 0.0389688 0.00510953 0.0355733 
v 0.0379689 0.00614865 0.0355733 
v 0.0368263 0.00752297 0.0355479 
v 0.0356332 0.00937921 0.0354944 
v 0.0374568 0.00668077 0.0355733 
v 0.0348244 0.0106793 0.0354572 
v 0.0333349 0.013679 0.0353761 
v 0.0349155 0.0104958 0.0354622 
v 0.0326666 0.0155379 0.0353289 
v 0.0320224 0.0173295 0.0352835 
v 0.0331393 0.014223 0.0353623 
v 0.0312406 0.0206715 0.0352038 
v 0.0312185 0.0207659 0.0352016 
v 0.0307944 0.0242987 0.0351222 
v 0.0315434 0.0193772 0.0352347 
v 0.0307704 0.0259897 0.0350858 
v 0.0307988 0.0285016 0.0350317 
v 0.0307789 0.0245882 0.035116 
v 0.0307587 0.0249622 0.0351079 
v 0.0312237 0.03202 0.0349517 
v 0.03114 0.0313273 0.0349675 
v 0.0309526 0.0297754 0.0350028 
v 0.0323828 0.03654 0.0348415 
v 0.0334694 0.0394387 0.0347666 
v 0.0319308 0.0350459 0.0348788 
v 0.0320377 0.0355033 0.0348678 
v 0.0322218 0.0361107 0.0348526 
v 0.0344996 0.0414777 0.0347107 
v 0.0350715 0.0426095 0.0346797 
v 0.0338436 0.0401794 0.0347463 
v 0.0373555 0.0460395 0.0345789 
v 0.0395592 0.0486576 0.0344964 
v 0.0366067 0.0449656 0.0346109 
v 0.0370275 0.0456115 0.034592 
v 0.0372696 0.0459374 0.0345821 
v 0.0409916 0.0500243 0.0344498 
v 0.0421295 0.05111 0.0344129 
v 0.0401143 0.0491873 0.0344783 
v 0.0451967 0.0534157 0.0343263 
v 0.0483733 0.0553059 0.0342461 
v 0.0441996 0.0526914 0.034354 
v 0.0449759 0.0532843 0.0343319 
v 0.0499467 0.0560131 0.0342071 
v 0.0516244 0.0567672 0.0341656 
v 0.0486649 0.0554369 0.0342389 
v 0.0550446 0.057877 0.0340808 
v 0.0550409 0.0578758 0.0340809 
v 0.0589041 0.0586568 0.0339853 
v 0.0536589 0.0574273 0.0341152 
v 0.0603982 0.0587845 0.0339483 
v 0.0624649 0.0589613 0.0338971 
v 0.0590348 0.0586679 0.033982 
v 0.0665171 0.0588376 0.0337968 
v 0.0658416 0.0588815 0.0338135 
v 0.0660664 0.0588761 0.0338079 
v 0.0646171 0.0589104 0.0338438 
v 0.0712241 0.0580114 0.0336803 
v 0.0735138 0.0574148 0.0336236 
v 0.0700553 0.058316 0.0337092 
v 0.077302 0.0559415 0.0335298 
v 0.076416 0.0563094 0.0335517 
v 0.0768811 0.0561323 0.0335402 
v 0.0754074 0.0566936 0.0335767 
v 0.0812445 0.0537398 0.03343 
v 0.0834305 0.0522612 0.0333706 
v 0.0802161 0.0543989 0.0334574 
v 0.0804642 0.0542676 0.0334512 
v 0.0864933 0.0496335 0.0332753 
v 0.0856056 0.0504189 0.0333035 
v 0.0861877 0.0499259 0.0332855 
v 0.0845933 0.0512764 0.0333347 
v 0.0893636 0.0464208 0.0331698 
v 0.0910799 0.0441113 0.0330983 
v 0.0885581 0.047404 0.0332012 
v 0.0889367 0.0469952 0.0331876 
v 0.0931367 0.0405462 0.0329952 
v 0.0924113 0.0418427 0.0330324 
v 0.0929131 0.0409875 0.0330076 
v 0.0918352 0.0428243 0.0330609 
v 0.0946895 0.0368302 0.0328952 
v 0.0956214 0.0338117 0.0328181 
v 0.0943381 0.0377624 0.0329199 
v 0.0945614 0.037245 0.0329058 
v 0.0963763 0.0297396 0.0327203 
v 0.0960709 0.0314882 0.0327621 
v 0.0963094 0.0302551 0.0327324 
v 0.0958931 0.0324072 0.0327843 
v 0.0966107 0.0259904 0.0326359 
v 0.0964718 0.0225576 0.0325589 
v 0.0965595 0.027012 0.0326589 
v 0.0966173 0.0261518 0.0326395 
v 0.0961613 0.0204749 0.0325093 
v 0.0959367 0.0189678 0.0324735 
v 0.0958373 0.0184994 0.0324619 
v 0.0963354 0.0216427 0.0325371 
v 0.0948738 0.0150173 0.0323734 
v 0.0935434 0.0116611 0.032283 
v 0.0948915 0.0150812 0.032375 
v 0.0952028 0.0162062 0.0324036 
v 0.0926661 0.00999751 0.0322354 
v 0.0918458 0.00844198 0.0321909 
v 0.0915683 0.00798675 0.0321774 
v 0.0931548 0.0109243 0.0322619 
v 0.0884206 0.00378246 0.0320452 
v 0.0871306 0.00230125 0.0319964 
v 0.0895017 0.00502381 0.0320862 
v 0.0896952 0.0053012 0.0320947 
v 0.0902092 0.00603821 0.0321174 
v 0.085938 0.00119811 0.031957 
v 0.0844586 -0.000170224 0.0319082 
v 0.084018 -0.000529289 0.0318947 
v 0.0865274 0.00174334 0.0319765 
v 0.0810811 -0.00263322 0.0318113 
v 0.0779363 -0.0044104 0.0317302 
v 0.0815808 -0.00227529 0.0318255 
v 0.0822617 -0.00178749 0.0318448 
v 0.0766871 -0.0049493 0.0316982 
v 0.07459 -0.00585394 0.0316445 
v 0.0740929 -0.006033 0.0316317 
v 0.0776176 -0.00454789 0.031722 
v 0.0706109 -0.00705089 0.0315425 
v 0.0670423 -0.00769061 0.031451 
v 0.0714213 -0.00681398 0.0315633 
v 0.0724276 -0.0065198 0.0315891 
v 0.0659134 -0.00776972 0.0314221 
v 0.0633967 -0.00794609 0.0313575 
v 0.0628293 -0.00795044 0.031343 
v 0.0668626 -0.00770321 0.0314464 
v 0.0592073 -0.00775384 0.03125 
v 0.0556289 -0.0071718 0.0311581 
v 0.0603132 -0.00781387 0.0312784 
v 0.0611136 -0.00785732 0.0312989 
v 0.0547778 -0.00693749 0.0311362 
v 0.0521051 -0.00620163 0.0310675 
v 0.0515296 -0.00600352 0.0310527 
v 0.0554325 -0.00711775 0.0311531 
v 0.0481801 -0.0046108 0.0309666 
v 0.0494585 -0.00514237 0.0309995 
v 0.0500735 -0.00539808 0.0310153 
v 0.0444923 -0.00251623 0.0308696 
v 0.0419969 -0.000780115 0.0307982 
v 0.0415489 -0.000425375 0.0307844 
v 0.0451797 -0.00296777 0.0308888 
v 0.0449995 -0.00286909 0.0308841 
v 0.0388396 0.00200644 0.0306946 
v 0.0400423 0.0009269 0.0307345 
v 0.0407221 0.000316739 0.030757 
v 0.0361797 0.00502434 0.0305921 
v 0.034258 0.00768426 0.0305072 
v 0.0339391 0.0081894 0.0304917 
v 0.0367145 0.00436826 0.0306138 
v 0.036406 0.00471122 0.0306021 
v 0.0321904 0.0113821 0.030397 
v 0.0330893 0.00974101 0.0304457 
v 0.0334278 0.009123 0.030464 
v 0.0307514 0.0148792 0.0302993 
v 0.0297524 0.0182586 0.03021 
v 0.0296099 0.0188832 0.030194 
v 0.0309533 0.014354 0.0303138 
v 0.0307922 0.0147411 0.030303 
v 0.0290242 0.0224761 0.0301051 
v 0.0293694 0.0203587 0.0301575 
v 0.0294512 0.0198572 0.0301699 
v 0.0288243 0.0261094 0.0300203 
v 0.029014 0.0297743 0.0299343 
v 0.0288308 0.0259904 0.0300231 
v 0.0290831 0.030378 0.0299196 
v 0.0288645 0.0253786 0.0300374 
v 0.029306 0.0316314 0.0298881 
v 0.0297224 0.0339729 0.0298292 
v 0.0291728 0.0308825 0.0299069 
v 0.030739 0.0374779 0.0297358 
v 0.0306409 0.0371395 0.0297448 
v 0.0321343 0.0408819 0.0296396 
v 0.0324063 0.0414424 0.0296232 
v 0.0304361 0.0364336 0.0297636 
v 0.0329104 0.0423355 0.029596 
v 0.0342011 0.0446218 0.0295267 
v 0.0326126 0.0418079 0.0296121 
v 0.0363221 0.0475914 0.0294306 
v 0.0387671 0.0503403 0.0293351 
v 0.0359797 0.0471121 0.0294461 
v 0.0392392 0.0508079 0.0293181 
v 0.0357158 0.0467425 0.029458 
v 0.0398095 0.0513059 0.0292991 
v 0.0419894 0.0532092 0.0292265 
v 0.039536 0.0510671 0.0293082 
v 0.0449778 0.0553043 0.0291386 
v 0.0442831 0.0548173 0.029159 
v 0.0481986 0.0570844 0.0290521 
v 0.043946 0.054581 0.0291689 
v 0.0492691 0.0575547 0.0290235 
v 0.052173 0.0587148 0.0289458 
v 0.0487742 0.057357 0.0290367 
v 0.0556947 0.0597047 0.0288515 
v 0.054653 0.0594119 0.0288794 
v 0.0593307 0.0603196 0.0287539 
v 0.0540656 0.0592467 0.0288951 
v 0.0602637 0.0603994 0.0287289 
v 0.0636278 0.0605421 0.0286385 
v 0.0597617 0.060365 0.0287424 
v 0.0599715 0.060387 0.0287367 
v 0.0672784 0.0603093 0.0285403 
v 0.065967 0.0603929 0.0285755 
v 0.0709128 0.0596849 0.0284423 
v 0.0656188 0.0604151 0.0285849 
v 0.0716058 0.059518 0.0284236 
v 0.0750746 0.0584589 0.02833 
v 0.0713827 0.0595731 0.0284297 
v 0.0715745 0.0595276 0.0284245 
v 0.0784407 0.0570262 0.028239 
v 0.0771386 0.0575804 0.0282742 
v 0.0769989 0.0576399 0.028278 
v 0.0767895 0.057729 0.0282836 
v 0.0822157 0.0548732 0.028135 
v 0.0851695 0.052701 0.0280437 
v 0.0820538 0.0549773 0.0281397 
v 0.0816619 0.0552295 0.028151 
v 0.087876 0.0502301 0.0279484 
v 0.0865471 0.0514433 0.0279952 
v 0.086199 0.0517611 0.0280074 
v 0.0907306 0.0469426 0.0278317 
v 0.0927982 0.0439153 0.0277317 
v 0.0904682 0.0472796 0.0278433 
v 0.0902176 0.0475848 0.0278539 
v 0.0903246 0.0474639 0.0278496 
v 0.0945335 0.0406877 0.0276314 
v 0.0935735 0.0424733 0.0276869 
v 0.0934571 0.0426898 0.0276936 
v 0.0961465 0.0366151 0.0275124 
v 0.0970921 0.0330732 0.027415 
v 0.0959315 0.0372559 0.0275306 
v 0.0959278 0.0372668 0.0275309 
v 0.0972981 0.0317552 0.0273807 
v 0.097658 0.0294524 0.0273207 
v 0.0973073 0.0316962 0.0273791 
v 0.0978285 0.0250897 0.0272137 
v 0.0975468 0.0214299 0.0271219 
v 0.0978381 0.0257621 0.02723 
v 0.097827 0.0259896 0.0272356 
v 0.0978181 0.0261707 0.02724 
v 0.0968808 0.0178219 0.0270259 
v 0.0973347 0.0202807 0.0270913 
v 0.0973921 0.0205919 0.0270996 
v 0.0955956 0.0136438 0.0269072 
v 0.0941182 0.0102842 0.0268055 
v 0.0959578 0.0147144 0.0269381 
v 0.0958278 0.0142765 0.0269258 
v 0.0960372 0.0149816 0.0269457 
v 0.0922952 0.00710061 0.0267029 
v 0.09365 0.00946663 0.0267791 
v 0.093721 0.00959048 0.0267831 
v 0.0905258 0.0046545 0.0266188 
v 0.0896919 0.00357553 0.0265809 
v 0.0871845 0.000895536 0.0264805 
v 0.0905204 0.00464702 0.0266185 
v 0.0901276 0.0041041 0.0265998 
v 0.0866463 0.000430207 0.0264615 
v 0.0844092 -0.00150399 0.0263829 
v 0.086576 0.000369382 0.0264591 
v 0.0821167 -0.00309524 0.0263117 
v 0.0807898 -0.00396415 0.0262717 
v 0.0775347 -0.00566322 0.0261795 
v 0.0813707 -0.003613 0.0262885 
v 0.0820919 -0.00311243 0.0263109 
v 0.0770795 -0.00584261 0.0261666 
v 0.0741198 -0.007009 0.0260826 
v 0.0772138 -0.00578969 0.0261704 
v 0.0698879 -0.00813259 0.0259623 
v 0.066254 -0.00865806 0.0258587 
v 0.0716441 -0.0076923 0.0260123 
v 0.070553 -0.00799343 0.0259812 
v 0.071791 -0.00765175 0.0260164 
v 0.0659879 -0.00866815 0.0258511 
v 0.0625864 -0.00879712 0.0257539 
v 0.0660256 -0.00866672 0.0258522 
v 0.0602455 -0.00863717 0.0256868 
v 0.0582248 -0.00845643 0.0256289 
v 0.0546219 -0.00774922 0.0255253 
v 0.0601272 -0.00862909 0.0256834 
v 0.0588951 -0.0085449 0.0256481 
v 0.0545753 -0.00773484 0.025524 
v 0.0543537 -0.00766642 0.0255176 
v 0.0511149 -0.00666621 0.0254243 
v 0.0491591 -0.00582631 0.0253678 
v 0.0471136 -0.00490173 0.0253087 
v 0.0489551 -0.00573872 0.0253619 
v 0.047715 -0.00520614 0.0253261 
v 0.044092 -0.00312673 0.0252194 
v 0.0439476 -0.0030419 0.0252151 
v 0.0409971 -0.000859509 0.0251174 
v 0.044052 -0.00310323 0.0252182 
v 0.0395891 0.000433768 0.0250644 
v 0.0382727 0.00164304 0.0250147 
v 0.0378046 0.00213083 0.0249956 
v 0.0356825 0.0046391 0.0249012 
v 0.0395994 0.000424317 0.0250647 
v 0.0356365 0.00469351 0.0248991 
v 0.0354337 0.0049332 0.0248901 
v 0.0333726 0.00796889 0.0247829 
v 0.0325755 0.00946236 0.0247333 
v 0.0313569 0.0118334 0.024655 
v 0.0324701 0.00965977 0.0247267 
v 0.0316309 0.011232 0.0246744 
v 0.0302571 0.0147108 0.0245654 
v 0.0288786 0.0202764 0.0244024 
v 0.0288749 0.0203005 0.0244018 
v 0.0300463 0.0152622 0.0245482 
v 0.0291053 0.0188087 0.0244435 
v 0.0301289 0.015046 0.0245549 
v 0.0284813 0.0231193 0.0243235 
v 0.0288183 0.0206668 0.0243915 
v 0.0285407 0.0224644 0.0243412 
v 0.0284004 0.025991 0.0242481 
v 0.0283779 0.0267882 0.0242272 
v 0.0286624 0.0304441 0.0241286 
v 0.0283931 0.026248 0.0242413 
v 0.0288959 0.0316995 0.0240927 
v 0.0295001 0.0347204 0.0240055 
v 0.0289211 0.0318353 0.0240888 
v 0.0293382 0.0340776 0.0240246 
v 0.0303095 0.0372533 0.0239276 
v 0.0306163 0.0382133 0.023898 
v 0.0320947 0.0415674 0.0237884 
v 0.0303663 0.0374308 0.0239221 
v 0.0326246 0.0424898 0.0237563 
v 0.0342874 0.0453043 0.0236576 
v 0.0327873 0.0427731 0.0237465 
v 0.0339351 0.0447713 0.0236769 
v 0.0357721 0.0472731 0.0235834 
v 0.0364953 0.048232 0.0235473 
v 0.038999 0.050909 0.0234387 
v 0.0360586 0.047653 0.0235691 
v 0.0396538 0.0514747 0.0234138 
v 0.042294 0.0537041 0.0233145 
v 0.0400702 0.0518344 0.0233979 
v 0.041795 0.0533246 0.0233322 
v 0.0441854 0.0549656 0.023252 
v 0.0453451 0.0557391 0.0232137 
v 0.0485893 0.0574375 0.0231142 
v 0.0445786 0.0552279 0.0232391 
v 0.0492123 0.0576834 0.0230951 
v 0.0520215 0.0587918 0.0230087 
v 0.049496 0.0577953 0.0230863 
v 0.0526294 0.0589886 0.02299 
v 0.0546295 0.059501 0.0229282 
v 0.056175 0.059897 0.0228805 
v 0.0597951 0.0604248 0.0227683 
v 0.0549293 0.0595778 0.0229189 
v 0.0602597 0.0604426 0.0227538 
v 0.0634801 0.060566 0.0226536 
v 0.0606888 0.060459 0.0227405 
v 0.06409 0.0605514 0.0226346 
v 0.0659658 0.0603899 0.0225759 
v 0.0677364 0.0602375 0.0225205 
v 0.0713274 0.0595397 0.0224078 
v 0.0665479 0.0603398 0.0225577 
v 0.0715902 0.0594588 0.0223995 
v 0.0748521 0.0584556 0.0222966 
v 0.072249 0.0592562 0.0223787 
v 0.0753971 0.0582503 0.0222794 
v 0.0769584 0.0575498 0.0222299 
v 0.078737 0.0567519 0.0221736 
v 0.0818946 0.0549112 0.0220716 
v 0.0775661 0.0572772 0.0222107 
v 0.0819727 0.0548537 0.0220688 
v 0.0823654 0.0545647 0.0220546 
v 0.0848589 0.0527291 0.0219645 
v 0.0853215 0.0523419 0.0219465 
v 0.0864168 0.0513031 0.0219003 
v 0.0879696 0.0498303 0.0218348 
v 0.0867374 0.050999 0.0218868 
v 0.0902722 0.0471268 0.0217228 
v 0.0905811 0.0466923 0.0217058 
v 0.0903349 0.0470533 0.0217198 
v 0.0924072 0.0440158 0.0216017 
v 0.0927005 0.0435229 0.0215832 
v 0.0933127 0.0423331 0.0215399 
v 0.0936265 0.0417231 0.0215177 
v 0.0943702 0.0402778 0.0214651 
v 0.0955844 0.0371362 0.0213568 
v 0.0958235 0.0363599 0.0213309 
v 0.0956851 0.0368756 0.0213478 
v 0.0966377 0.0333244 0.0212316 
v 0.0967414 0.032815 0.0212155 
v 0.0969085 0.0316303 0.021179 
v 0.0970254 0.030801 0.0211534 
v 0.0972512 0.0292007 0.0211041 
v 0.0973597 0.0259894 0.0210103 
v 0.0973743 0.0255559 0.0209977 
v 0.0973558 0.0253035 0.0209902 
v 0.0971056 0.0218966 0.0208888 
v 0.0968504 0.0203607 0.0208406 
v 0.0967545 0.0197836 0.0208225 
v 0.0966877 0.0193813 0.0208098 
v 0.0957705 0.0158688 0.0206935 
v 0.0951781 0.0143059 0.0206384 
v 0.0954057 0.0149062 0.0206595 
v 0.0417745 0.0499242 0.0221159 
v 0.0459444 0.0530721 0.0219659 
v 0.0380829 0.0460313 0.0222786 
v 0.0350585 0.0415171 0.0224477 
v 0.0328425 0.0365649 0.022616 
v 0.0315073 0.0313938 0.0227765 
v 0.0310496 0.0262275 0.0229231 
v 0.0314281 0.0210719 0.0230683 
v 0.0326802 0.015892 0.0232277 
v 0.034816 0.0109098 0.0233956 
v 0.0377699 0.00634624 0.0235649 
v 0.0414067 0.0023891 0.0237284 
v 0.0455408 -0.000831672 0.0238799 
v 0.0500473 -0.003293 0.024022 
v 0.0550363 -0.00504222 0.0241776 
v 0.0603585 -0.00595793 0.0243436 
v 0.0657982 -0.00596425 0.0245132 
v 0.0711235 -0.00506064 0.0246793 
v 0.0761184 -0.00332204 0.024835 
v 0.0806311 -0.000870317 0.0249772 
v 0.0847705 0.00233979 0.0251285 
v 0.0884154 0.00628757 0.0252919 
v 0.0913798 0.010844 0.0254612 
v 0.0935274 0.0158219 0.0256291 
v 0.0947917 0.0210006 0.0257887 
v 0.0951818 0.0261577 0.0259341 
v 0.0947358 0.0313225 0.0260805 
v 0.0934127 0.036495 0.0262408 
v 0.0912085 0.0414517 0.0264091 
v 0.0881944 0.0459733 0.0265782 
v 0.0845108 0.0498757 0.026741 
v 0.0803459 0.0530343 0.0268913 
v 0.0758032 0.0554401 0.0270339 
v 0.0707806 0.0571273 0.0271905 
v 0.0654408 0.0579725 0.027357 
v 0.0600017 0.0579053 0.0275266 
v 0.0546952 0.0569316 0.0276921 
v 0.0497347 0.0551317 0.0278468 
v 0.0452572 0.0526239 0.0279887 
v 0.0411496 0.049352 0.0281411 
v 0.0375525 0.0453502 0.0283053 
v 0.0346489 0.0407527 0.0284747 
v 0.0325702 0.0357505 0.0286422 
v 0.0313768 0.0305656 0.0288009 
v 0.0310538 0.0254166 0.0289451 
v 0.0315678 0.0202434 0.0290928 
v 0.0329618 0.0150798 0.029254 
v 0.0352342 0.01015 0.0294226 
v 0.0383075 0.00567162 0.0295915 
v 0.0420367 0.00182475 0.0297535 
v 0.046231 -0.00127144 0.0299025 
v 0.0508114 -0.00362219 0.0300458 
v 0.0558664 -0.00524654 0.0302035 
v 0.0612225 -0.00602074 0.0303705 
v 0.0666595 -0.00588022 0.0305401 
v 0.0719458 -0.00483688 0.0307049 
v 0.0768707 -0.00297661 0.0308585 
v 0.0813146 -0.000411974 0.0310003 
v 0.085389 0.00292135 0.0311538 
v 0.0889371 0.00697636 0.0313187 
v 0.0917789 0.0116136 0.0314882 
v 0.0937884 0.0166386 0.0316553 
v 0.094911 0.0218284 0.0318129 
v 0.0951672 0.0269707 0.0319563 
v 0.0945848 0.032151 0.0321052 
v 0.0931199 0.0373043 0.0322673 
v 0.09078 0.0422059 0.0324361 
v 0.0876484 0.0466399 0.0326047 
v 0.0838747 0.0504305 0.0327659 
v 0.0796524 0.0534639 0.0329137 
v 0.0750328 0.0557601 0.0330579 
v 0.0699466 0.0573208 0.0332165 
v 0.0645756 0.0580236 0.033384 
v 0.0591422 0.0578098 0.0335535 
v 0.0538774 0.0566974 0.0337176 
v 0.0489891 0.0547776 0.0338701 
v 0.0445776 0.0521554 0.034012 
v 0.0405377 0.0487611 0.0341666 
v 0.0370398 0.0446538 0.0343321 
v 0.0342604 0.039978 0.0345017 
v 0.0323205 0.0349316 0.0346682 
v 0.0312685 0.0297384 0.0348249 
v 0.0310788 0.0246012 0.0349675 
v 0.03173 0.0194152 0.0351177 
v 0.0332658 0.0142736 0.0352805 
v 0.0356728 0.00940167 0.0354496 
v 0.0851346 0.0493019 0.0207158 
v 0.0810326 0.0525844 0.0208684 
v 0.0765609 0.0551019 0.0210103 
v 0.0716065 0.0569123 0.0211648 
v 0.0663034 0.057898 0.0213301 
v 0.0608645 0.0579778 0.0214997 
v 0.0555218 0.0571448 0.0216664 
v 0.0504936 0.0554683 0.0218232 
v 0.0913576 0.041274 0.0355733 
v 0.0884568 0.0457141 0.0355733 
v 0.0848647 0.0496161 0.0355733 
v 0.0806794 0.0528737 0.0355733 
v 0.0760149 0.0553979 0.0355733 
v 0.0709986 0.05712 0.0355733 
v 0.0657673 0.057993 0.0355733 
v 0.0604636 0.057993 0.0355733 
v 0.0552323 0.05712 0.0355733 
v 0.050216 0.0553979 0.0355733 
v 0.0455516 0.0528737 0.0355733 
v 0.0413662 0.0496161 0.0355733 
v 0.0377741 0.0457141 0.0355733 
v 0.0348733 0.041274 0.0355733 
v 0.0327428 0.036417 0.0355733 
v 0.0314409 0.0312757 0.0355733 
v 0.0310029 0.0259901 0.0355733 
v 0.0314409 0.0207046 0.0355733 
v 0.0327428 0.0155632 0.0355733 
v 0.0348733 0.0107062 0.0355733 
v 0.0815564 -0.00223577 0.0320452 
v 0.0859507 0.00118447 0.0320452 
v 0.076659 -0.00488607 0.0320452 
v 0.0713923 -0.00669416 0.0320452 
v 0.0658997 -0.0076107 0.0320452 
v 0.0603312 -0.0076107 0.0320452 
v 0.0548387 -0.00669416 0.0320452 
v 0.0495719 -0.00488607 0.0320452 
v 0.0446746 -0.00223577 0.0320452 
v 0.040314 0.00122045 0.0320385 
v 0.0865554 0.0514527 0.0282742 
v 0.0820293 0.0549396 0.0282726 
v 0.0904267 0.0472473 0.0282742 
v 0.0935203 0.0424445 0.0282727 
v 0.0958049 0.0372188 0.0282477 
v 0.0288318 0.031711 0.0244018 
v 0.0284144 0.0259909 0.0244058 
v 0.0303043 0.0372544 0.0244003 
v 0.0325693 0.0425218 0.0243942 
vn 0.0646211 -0.997245 0.0364219 
vn 0.96612 0.0247314 -0.256904 
vn 0.99825 0.0245035 -0.0538156 
vn 0.892195 0.0250195 -0.450956 
vn 0.96612 0.0247314 -0.256904 
vn 0.778189 0.0253596 -0.627518 
vn 0.892195 0.0250195 -0.450956 
vn 0.6275 0.0257403 -0.778191 
vn 0.778189 0.0253596 -0.627518 
vn 0.44538 0.0261472 -0.89496 
vn 0.6275 0.0257403 -0.778191 
vn 0.239043 0.0265623 -0.970646 
vn 0.44538 0.0261472 -0.89496 
vn 0.0176576 0.0269645 -0.99948 
vn 0.239043 0.0265623 -0.970646 
vn -0.207873 0.0273305 -0.977774 
vn 0.0176576 0.0269645 -0.99948 
vn -0.425403 0.0276365 -0.904582 
vn -0.207873 0.0273305 -0.977774 
vn -0.622359 0.0278607 -0.782236 
vn -0.425403 0.0276365 -0.904582 
vn -0.786801 0.027986 -0.616572 
vn -0.622359 0.0278607 -0.782236 
vn -0.908609 0.0280022 -0.416709 
vn -0.786801 0.027986 -0.616572 
vn -0.980536 0.027908 -0.194347 
vn -0.908609 0.0280022 -0.416709 
vn 0.999664 0.0244619 -0.00860157 
vn 0.988381 0.0243416 0.150032 
vn -0.998919 0.027711 0.0373292 
vn -0.999567 0.0277586 -0.0097608 
vn -0.980536 0.027908 -0.194347 
vn -0.998919 0.027711 0.0373292 
vn 0.999664 0.0244619 -0.00860157 
vn 0.999142 0.0244262 0.0334327 
vn 0.0613638 0.997516 0.034586 
vn -0.148317 0.0253846 0.988614 
vn 0.0608154 0.025043 0.997835 
vn -0.0379727 0.0251989 0.998961 
vn -0.135755 0.0253629 0.990418 
vn -0.353694 0.0257657 0.935006 
vn -0.148285 0.0253846 0.988619 
vn -0.252639 0.0255722 0.967223 
vn -0.545846 0.0261717 0.837477 
vn -0.353694 0.0257657 0.935006 
vn -0.397457 0.0258535 0.917256 
vn -0.715036 0.0265846 0.698581 
vn -0.545846 0.0261717 0.837477 
vn -0.651071 0.0264207 0.758557 
vn -0.851755 0.0269835 0.523245 
vn -0.715036 0.0265846 0.698581 
vn -0.947391 0.0273455 0.318908 
vn -0.851755 0.0269835 0.523245 
vn -0.879725 0.0270781 0.474711 
vn -0.995052 0.027647 0.0954315 
vn -0.947391 0.0273455 0.318908 
vn -0.977309 0.0275036 0.210024 
vn -0.999403 0.027769 -0.0205578 
vn -0.99041 0.0278668 -0.135322 
vn -0.995052 0.027647 0.0954315 
vn -0.967468 0.0279416 -0.251447 
vn -0.932423 0.027988 -0.360284 
vn -0.912585 0.0280004 -0.407927 
vn -0.823734 0.0280012 -0.566284 
vn -0.686552 0.0279185 -0.726544 
vn -0.670603 0.027905 -0.741292 
vn -0.482333 0.0277074 -0.87555 
vn -0.424857 0.0276358 -0.904838 
vn -0.270315 0.0274235 -0.962381 
vn -0.145771 0.0272343 -0.988943 
vn -0.04688 0.0270738 -0.998534 
vn 0.17579 0.0266815 -0.984066 
vn 0.0652802 0.0268815 -0.997505 
vn 0.0445989 0.0269178 -0.998642 
vn 0.134649 0.0267572 -0.990532 
vn -0.04688 0.0270738 -0.998534 
vn 0.386535 0.02627 -0.921901 
vn 0.175713 0.0266817 -0.98408 
vn 0.284391 0.0264746 -0.958343 
vn 0.575786 0.0258606 -0.817191 
vn 0.386535 0.02627 -0.921901 
vn 0.401426 0.0262392 -0.915515 
vn 0.492148 0.0260469 -0.870122 
vn 0.735852 0.0254722 -0.676663 
vn 0.575786 0.0258606 -0.817191 
vn 0.642966 0.0257035 -0.765463 
vn 0.860981 0.02512 -0.508017 
vn 0.735852 0.0254722 -0.676663 
vn 0.84599 0.0251658 -0.532604 
vn 0.947277 0.0248161 -0.319452 
vn 0.860981 0.02512 -0.508017 
vn 0.992553 0.0245695 -0.11931 
vn 0.947277 0.0248161 -0.319452 
vn 0.974787 0.024687 -0.221769 
vn 0.996152 0.0243867 0.0841776 
vn 0.997925 0.024509 -0.0595378 
vn 0.999626 0.0244438 0.012267 
vn 0.992553 0.0245695 -0.11931 
vn 0.978235 0.0243087 0.206071 
vn 0.958794 0.0242719 0.283064 
vn 0.993513 0.0243674 0.111079 
vn 0.996152 0.0243867 0.0841776 
vn 0.958794 0.0242719 0.283064 
vn 0.924646 0.0242405 0.380055 
vn 0.882437 0.0242277 0.469807 
vn 0.816146 0.0242364 0.577337 
vn 0.770181 0.024255 0.637364 
vn 0.626198 0.0243531 0.779284 
vn 0.608158 0.0243686 0.793442 
vn 0.455685 0.0245201 0.889803 
vn 0.376436 0.0246113 0.926116 
vn 0.264838 0.024752 0.963975 
vn 0.125536 0.0249461 0.991775 
vn -0.615603 0.78722 0.0362964 
vn -0.769887 0.637119 0.0367956 
vn -0.889783 0.454861 0.0372515 
vn -0.967925 0.248403 0.0376373 
vn -0.998896 0.0277104 0.0379279 
vn -0.979903 -0.195801 0.0381031 
vn -0.911248 -0.410088 0.0381502 
vn -0.796462 -0.603489 0.0380657 
vn -0.642052 -0.765726 0.0378559 
vn -0.435513 0.899471 0.0357808 
vn -0.439048 0.89775 0.0357904 
vn -0.456873 -0.888739 0.0375358 
vn -0.642052 -0.765726 0.0378559 
vn -0.460542 -0.886843 0.0375426 
vn -0.435513 0.899471 0.0357808 
vn 0.706797 -0.706565 0.0347093 
vn 0.83605 -0.547581 0.0342848 
vn 0.929336 -0.367674 0.0339243 
vn 0.98409 -0.174456 0.0336378 
vn 0.999142 0.0244262 0.0334327 
vn 0.974602 0.221452 0.0333135 
vn 0.911767 0.409357 0.033283 
vn 0.813051 0.581237 0.0333417 
vn 0.681935 0.730645 0.0334884 
vn 0.556471 -0.830123 0.0351535 
vn 0.555998 -0.83044 0.0351549 
vn 0.53376 0.844964 0.0337028 
vn 0.533512 0.845121 0.0337032 
vn 0.681935 0.730645 0.0334884 
vn 0.533049 0.845413 0.0337039 
vn 0.556725 -0.829953 0.0351528 
vn 0.0652802 0.0268815 -0.997505 
vn -0.998919 0.027711 0.0373292 
vn 0.999142 0.0244262 0.0334327 
vn -0.908609 0.0280022 -0.416709 
vn -0.980536 0.027908 -0.194347 
vn -0.786801 0.027986 -0.616572 
vn -0.908609 0.0280022 -0.416709 
vn -0.622359 0.0278607 -0.782236 
vn -0.786801 0.027986 -0.616572 
vn -0.425403 0.0276365 -0.904582 
vn -0.622359 0.0278607 -0.782236 
vn -0.207873 0.0273305 -0.977774 
vn -0.425403 0.0276365 -0.904582 
vn 0.0176576 0.0269645 -0.99948 
vn -0.207873 0.0273305 -0.977774 
vn 0.239043 0.0265623 -0.970646 
vn 0.0176576 0.0269645 -0.99948 
vn 0.44538 0.0261472 -0.89496 
vn 0.239043 0.0265623 -0.970646 
vn 0.6275 0.0257403 -0.778191 
vn 0.44538 0.0261472 -0.89496 
vn 0.778189 0.0253596 -0.627518 
vn 0.6275 0.0257403 -0.778191 
vn 0.892195 0.0250195 -0.450956 
vn 0.778189 0.0253596 -0.627518 
vn 0.96612 0.0247314 -0.256904 
vn 0.892195 0.0250195 -0.450956 
vn 0.99825 0.0245035 -0.0538156 
vn 0.96612 0.0247314 -0.256904 
vn 0.988381 0.0243416 0.150032 
vn 0.999664 0.0244619 -0.00860157 
vn 0.99825 0.0245035 -0.0538156 
vn -0.999567 0.0277586 -0.0097608 
vn -0.998919 0.027711 0.0373292 
vn 0.988381 0.0243416 0.150032 
vn 0.0613638 0.997516 0.034586 
vn 0.0646211 -0.997245 0.0364219 
vn 0.264838 0.024752 0.963975 
vn 0.0608154 0.025043 0.997835 
vn 0.125536 0.0249461 0.991775 
vn 0.455685 0.0245201 0.889803 
vn 0.264838 0.024752 0.963975 
vn 0.376436 0.0246113 0.926116 
vn 0.626198 0.0243531 0.779284 
vn 0.455685 0.0245201 0.889803 
vn 0.608158 0.0243686 0.793442 
vn 0.770181 0.024255 0.637364 
vn 0.626198 0.0243531 0.779284 
vn 0.882437 0.0242277 0.469807 
vn 0.770181 0.024255 0.637364 
vn 0.816146 0.0242364 0.577337 
vn 0.958794 0.0242719 0.283064 
vn 0.882437 0.0242277 0.469807 
vn 0.924964 0.0242407 0.379282 
vn 0.996152 0.0243867 0.0841776 
vn 0.978231 0.0243086 0.206088 
vn 0.991751 0.0243573 0.125846 
vn 0.958794 0.0242719 0.283064 
vn 0.997925 0.024509 -0.0595378 
vn 0.992553 0.0245695 -0.11931 
vn 0.99615 0.0243867 0.0842029 
vn 0.999623 0.0244436 0.0125415 
vn 0.992553 0.0245695 -0.11931 
vn 0.974697 0.0246875 -0.222162 
vn 0.947277 0.0248161 -0.319452 
vn 0.860981 0.02512 -0.508017 
vn 0.84599 0.0251658 -0.532604 
vn 0.735852 0.0254722 -0.676663 
vn 0.641557 0.0257069 -0.766644 
vn 0.575811 0.0258605 -0.817174 
vn 0.575786 0.0258606 -0.817191 
vn 0.401339 0.0262394 -0.915554 
vn 0.386571 0.0262699 -0.921886 
vn 0.492428 0.0260463 -0.869963 
vn 0.386535 0.02627 -0.921901 
vn 0.284266 0.0264749 -0.95838 
vn 0.17579 0.0266815 -0.984066 
vn -0.04688 0.0270738 -0.998534 
vn 0.0652802 0.0268815 -0.997505 
vn 0.04425 0.0269184 -0.998658 
vn 0.17579 0.0266815 -0.984066 
vn 0.134722 0.0267571 -0.990522 
vn -0.270315 0.0274235 -0.962381 
vn -0.04688 0.0270738 -0.998534 
vn -0.145771 0.0272343 -0.988943 
vn -0.482333 0.0277074 -0.87555 
vn -0.270315 0.0274235 -0.962381 
vn -0.424857 0.0276358 -0.904838 
vn -0.670603 0.027905 -0.741292 
vn -0.482333 0.0277074 -0.87555 
vn -0.823734 0.0280012 -0.566284 
vn -0.670603 0.027905 -0.741292 
vn -0.686552 0.0279185 -0.726544 
vn -0.932423 0.027988 -0.360284 
vn -0.823734 0.0280012 -0.566284 
vn -0.909732 0.0280017 -0.41425 
vn -0.99041 0.0278668 -0.135322 
vn -0.932394 0.0279881 -0.360357 
vn -0.967583 0.0279414 -0.251004 
vn -0.995052 0.027647 0.0954315 
vn -0.99041 0.0278668 -0.135322 
vn -0.999413 0.0277685 -0.0200665 
vn -0.977201 0.0275029 0.210527 
vn -0.947391 0.0273455 0.318908 
vn -0.995052 0.027647 0.0954315 
vn -0.879725 0.0270781 0.474711 
vn -0.851755 0.0269835 0.523245 
vn -0.715036 0.0265846 0.698581 
vn -0.651071 0.0264207 0.758557 
vn -0.545846 0.0261717 0.837477 
vn -0.397457 0.0258535 0.917256 
vn -0.353762 0.0257659 0.934981 
vn -0.353694 0.0257657 0.935006 
vn -0.253263 0.0255733 0.967059 
vn -0.148317 0.0253846 0.988614 
vn -0.0379995 0.0251989 0.99896 
vn -0.13582 0.025363 0.990409 
vn 0.983323 -0.178727 0.0336432 
vn 0.999142 0.0244262 0.0334327 
vn 0.926081 -0.375796 0.0339384 
vn 0.983323 -0.178727 0.0336432 
vn -0.948485 -0.314516 0.0381451 
vn -0.850509 -0.524577 0.0381175 
vn -0.995411 -0.0878089 0.0380335 
vn -0.948485 -0.314516 0.0381451 
vn -0.989077 0.142472 0.0377915 
vn -0.998896 0.0277104 0.0379279 
vn -0.995411 -0.0878089 0.0380335 
vn -0.930887 0.363385 0.0374373 
vn -0.989077 0.142472 0.0377915 
vn -0.825489 0.563204 0.0369961 
vn -0.930887 0.363385 0.0374373 
vn 0.97364 0.225643 0.0333119 
vn 0.908214 0.417181 0.0332837 
vn -0.305879 0.95141 0.0354408 
vn -0.191029 0.980955 0.0351574 
vn -0.270816 0.961982 0.0353526 
vn -0.0968998 0.994681 0.0349363 
vn -0.0969139 0.994679 0.0349363 
vn -0.106983 0.993646 0.0349595 
vn -0.503614 0.863179 0.0359692 
vn -0.305879 0.95141 0.0354408 
vn -0.423082 0.905386 0.0357472 
vn -0.68009 0.732219 0.0364969 
vn -0.554957 0.831094 0.0361163 
vn -0.659212 0.751074 0.0364309 
vn -0.503646 0.863161 0.0359693 
vn -0.696903 0.716233 0.0365509 
vn -0.68009 0.732219 0.0364969 
vn -0.728916 0.683621 0.036656 
vn -0.760292 0.64854 0.0367623 
vn -0.749897 0.660535 0.0367267 
vn -0.825489 0.563204 0.0369961 
vn -0.760303 0.648528 0.0367624 
vn -0.72929 0.683222 0.0366573 
vn -0.749664 0.660799 0.0367259 
vn -0.68009 0.732219 0.0364969 
vn -0.610977 0.790816 0.0362824 
vn -0.503579 0.8632 0.0359691 
vn -0.305879 0.95141 0.0354408 
vn -0.492018 0.869843 0.0359366 
vn -0.349116 0.936405 0.0355517 
vn -0.503614 0.863179 0.0359692 
vn -0.305879 0.95141 0.0354408 
vn -0.190065 0.981142 0.0351551 
vn -0.0968998 0.994681 0.0349363 
vn 0.113638 0.992924 0.0344761 
vn 0.0455479 0.998362 0.0346199 
vn -0.0228512 0.999134 0.0347691 
vn 0.316731 0.947903 0.0340765 
vn 0.227081 0.973274 0.0342474 
vn 0.305292 0.951648 0.0340978 
vn 0.144727 0.988873 0.0344121 
vn 0.113659 0.992921 0.0344761 
vn 0.504278 0.862881 0.0337498 
vn 0.387186 0.921376 0.0339486 
vn 0.451659 0.891549 0.0338369 
vn 0.316731 0.947903 0.0340765 
vn 0.669195 0.742331 0.0335052 
vn 0.504278 0.862881 0.0337498 
vn 0.579807 0.81406 0.033632 
vn 0.805474 0.591692 0.0333486 
vn 0.781933 0.622469 0.0333714 
vn 0.799394 0.599881 0.0333543 
vn 0.756989 0.652574 0.0333979 
vn 0.682739 0.729895 0.0334874 
vn 0.669231 0.742299 0.0335051 
vn 0.806733 0.589975 0.0333474 
vn 0.805474 0.591692 0.0333486 
vn 0.808876 0.587033 0.0333454 
vn 0.723671 0.689335 0.0334362 
vn 0.669177 0.742347 0.0335052 
vn 0.782327 0.621973 0.033371 
vn 0.756713 0.652893 0.0333982 
vn 0.796427 0.603813 0.0333571 
vn 0.669195 0.742331 0.0335052 
vn 0.518843 0.854204 0.0337264 
vn 0.504278 0.862881 0.0337498 
vn 0.634621 0.772095 0.0335524 
vn 0.380927 0.923981 0.0339597 
vn 0.316731 0.947903 0.0340765 
vn 0.226339 0.973446 0.0342488 
vn 0.113638 0.992924 0.0344761 
vn 0.0613638 0.997516 0.034586 
vn -0.0183023 0.999228 0.0347591 
vn 0.332375 -0.942469 0.0357596 
vn 0.119619 -0.992156 0.0362907 
vn 0.237913 -0.970619 0.0360001 
vn 0.526512 -0.849437 0.0352379 
vn 0.332375 -0.942469 0.0357596 
vn 0.399153 -0.916194 0.0355846 
vn 0.694031 -0.719106 0.0347486 
vn 0.526512 -0.849437 0.0352379 
vn 0.54145 -0.839996 0.035196 
vn 0.659243 -0.751122 0.0348542 
vn 0.82871 -0.558625 0.0343106 
vn 0.748391 -0.662355 0.0345784 
vn 0.780808 -0.623819 0.034473 
vn 0.806172 -0.590682 0.0343881 
vn 0.694013 -0.719124 0.0347487 
vn 0.819924 -0.571442 0.0343411 
vn 0.832003 -0.55371 0.0342991 
vn 0.82871 -0.558625 0.0343106 
vn 0.926081 -0.375796 0.0339384 
vn 0.831141 -0.555003 0.0343021 
vn 0.82871 -0.558625 0.0343106 
vn 0.82871 -0.558625 0.0343106 
vn 0.7076 -0.70576 0.0347068 
vn 0.694067 -0.719071 0.0347485 
vn 0.822806 -0.567285 0.0343311 
vn 0.805868 -0.591095 0.0343892 
vn 0.78132 -0.623178 0.0344713 
vn 0.694031 -0.719106 0.0347486 
vn 0.603702 -0.79644 0.035018 
vn 0.526476 -0.84946 0.035238 
vn 0.526512 -0.849437 0.0352379 
vn 0.405422 -0.913437 0.0355679 
vn 0.33236 -0.942474 0.0357596 
vn 0.47305 -0.880325 0.0353856 
vn 0.332375 -0.942469 0.0357596 
vn 0.152163 -0.987692 0.0362119 
vn 0.119619 -0.992156 0.0362907 
vn 0.238789 -0.970404 0.0359979 
vn 0.320499 -0.946572 0.0357902 
vn 0.119619 -0.992156 0.0362907 
vn 0.0482466 -0.99817 0.0364605 
vn -0.102082 -0.994095 0.0368046 
vn -0.0240732 -0.999039 0.0366284 
vn -0.321686 -0.946113 0.0372723 
vn -0.102082 -0.994095 0.0368046 
vn -0.200141 -0.979067 0.0370189 
vn -0.527344 -0.848816 0.037664 
vn -0.321686 -0.946113 0.0372723 
vn -0.366899 -0.92951 0.0373627 
vn -0.515377 -0.856136 0.0376427 
vn -0.707222 -0.705973 0.0379529 
vn -0.527307 -0.848839 0.037664 
vn -0.637348 -0.769646 0.0378485 
vn -0.75637 -0.653038 0.0380184 
vn -0.707222 -0.705973 0.0379529 
vn -0.78704 -0.615727 0.0380552 
vn -0.776618 -0.628822 0.0380431 
vn -0.787008 -0.615768 0.0380551 
vn -0.726054 -0.686588 0.0379789 
vn -0.755898 -0.653584 0.0380178 
vn -0.707243 -0.705951 0.0379529 
vn -0.776778 -0.628624 0.0380433 
vn -0.707222 -0.705973 0.0379529 
vn -0.580141 -0.81364 0.0377552 
vn -0.527377 -0.848796 0.0376641 
vn -0.686207 -0.726417 0.0379227 
vn -0.527344 -0.848816 0.037664 
vn -0.443964 -0.895259 0.0375115 
vn -0.321686 -0.946113 0.0372723 
vn -0.112626 -0.992955 0.0368281 
vn -0.102082 -0.994095 0.0368046 
vn -0.200631 -0.978967 0.0370199 
vn -0.285254 -0.95773 0.0371978 
vn -0.102082 -0.994095 0.0368046 
vn -0.019258 -0.999144 0.0366173 
vn 0.0646211 -0.997245 0.0364219 
vn 0.0652802 0.0268815 -0.997505 
vn -0.335151 -0.161456 0.928227 
vn -0.297588 -0.225809 0.927605 
vn -0.302442 -0.219051 0.927656 
vn -0.299189 -0.223774 0.927583 
vn -0.249611 -0.282473 0.926231 
vn -0.255236 -0.276975 0.926358 
vn -0.251457 -0.280812 0.926237 
vn -0.193693 -0.329175 0.92419 
vn -0.199684 -0.325046 0.924376 
vn -0.195646 -0.327935 0.924219 
vn -0.134327 -0.364087 0.921627 
vn -0.140507 -0.361165 0.921855 
vn -0.136519 -0.363153 0.921674 
vn -0.0689427 -0.389377 0.918494 
vn -0.0755267 -0.387522 0.918761 
vn -0.0713839 -0.388792 0.918556 
vn 0.00158556 -0.403795 0.914848 
vn -0.00508183 -0.403102 0.915141 
vn -0.000977466 -0.403628 0.914923 
vn 0.0744324 -0.406027 0.910825 
vn 0.0680229 -0.406473 0.911127 
vn 0.0718941 -0.406298 0.910908 
vn 0.146422 -0.395775 0.9066 
vn 0.140578 -0.397216 0.906894 
vn 0.14405 -0.396447 0.906686 
vn 0.214479 -0.373826 0.90236 
vn 0.20943 -0.376023 0.902633 
vn 0.212387 -0.374815 0.902444 
vn 0.275071 -0.342585 0.898316 
vn 0.270892 -0.345272 0.898557 
vn 0.273205 -0.343865 0.898396 
vn 0.329281 -0.302695 0.894399 
vn 0.325605 -0.306007 0.894618 
vn 0.327542 -0.304358 0.894473 
vn 0.377862 -0.253079 0.890602 
vn 0.374866 -0.256853 0.890787 
vn 0.376372 -0.25507 0.890665 
vn 0.418339 -0.195094 0.887091 
vn 0.416134 -0.199106 0.887237 
vn 0.417194 -0.197314 0.887139 
vn 0.448747 -0.130903 0.88402 
vn 0.447357 -0.134905 0.884122 
vn 0.448001 -0.133226 0.884051 
vn 0.467926 -0.0632171 0.881504 
vn 0.467584 -0.0655088 0.881518 
vn 0.475672 0.00487801 0.879609 
vn 0.475691 0.00271906 0.879608 
vn 0.473005 0.0700922 0.878267 
vn 0.473386 0.0677995 0.878242 
vn 0.459748 0.136606 0.87748 
vn 0.460524 0.134302 0.877428 
vn 0.435381 0.201806 0.877335 
vn 0.436542 0.199621 0.877258 
vn 0.400262 0.262908 0.877878 
vn 0.401748 0.260964 0.877779 
vn 0.355655 0.317331 0.879096 
vn 0.357369 0.315717 0.878983 
vn 0.303584 0.363052 0.880926 
vn 0.305406 0.361815 0.880805 
vn 0.24796 0.398241 0.883131 
vn 0.250022 0.397268 0.882988 
vn 0.186078 0.425012 0.885855 
vn 0.188401 0.424345 0.885684 
vn 0.118469 0.442048 0.889133 
vn 0.120943 0.441764 0.888942 
vn 0.0475431 0.447781 0.892878 
vn 0.0500349 0.447914 0.892675 
vn -0.0237991 0.441486 0.896952 
vn -0.0214266 0.442019 0.89675 
vn -0.0925459 0.423442 0.901184 
vn -0.0904121 0.424309 0.900993 
vn -0.0232492 0.441708 0.896858 
vn -0.154958 0.395535 0.905284 
vn -0.153015 0.396718 0.905098 
vn -0.0923949 0.423612 0.901119 
vn -0.211948 0.358195 0.909272 
vn -0.210099 0.359786 0.909072 
vn -0.15498 0.395654 0.905229 
vn -0.264094 0.310161 0.913266 
vn -0.262474 0.312121 0.913065 
vn -0.212167 0.358189 0.909223 
vn -0.308539 0.252505 0.917085 
vn -0.307261 0.254741 0.916895 
vn -0.264499 0.309928 0.913228 
vn -0.342822 0.18729 0.920541 
vn -0.34196 0.189673 0.920374 
vn -0.309069 0.251941 0.917062 
vn -0.365288 0.117353 0.923468 
vn -0.364861 0.119738 0.92333 
vn -0.343375 0.186317 0.920532 
vn -0.375345 0.0461378 0.925736 
vn -0.375318 0.0484083 0.925631 
vn -0.365733 0.115941 0.92347 
vn -0.373837 -0.022656 0.927217 
vn -0.37421 -0.0202318 0.927123 
vn -0.375548 0.0445812 0.92573 
vn -0.360551 -0.0930921 0.928082 
vn -0.361366 -0.0906524 0.928007 
vn -0.373775 -0.0245053 0.927196 
vn -0.334848 -0.162097 0.928225 
vn -0.336092 -0.159793 0.928175 
vn -0.360106 -0.0952135 0.92804 
vn -0.297177 -0.22639 0.927596 
vn -0.29878 -0.224359 0.927574 
vn -0.3339 -0.16442 0.928158 
vn -0.249111 -0.282969 0.926214 
vn -0.250958 -0.281311 0.92622 
vn -0.295631 -0.228792 0.9275 
vn -0.193131 -0.329568 0.924167 
vn -0.195085 -0.328332 0.924197 
vn -0.246922 -0.285294 0.926087 
vn -0.133735 -0.364373 0.9216 
vn -0.13593 -0.363442 0.921647 
vn -0.190315 -0.331647 0.924008 
vn -0.0682905 -0.389569 0.918462 
vn -0.0707335 -0.388987 0.918524 
vn -0.13068 -0.365973 0.921405 
vn 0.00227414 -0.403875 0.914811 
vn -0.00028936 -0.403712 0.914886 
vn -0.0646803 -0.390752 0.918221 
vn 0.075128 -0.405988 0.910785 
vn 0.0725906 -0.406263 0.910868 
vn 0.0063839 -0.404473 0.914528 
vn 0.147094 -0.395619 0.906559 
vn 0.144724 -0.396295 0.906645 
vn 0.0796185 -0.405845 0.910467 
vn 0.2151 -0.373565 0.90232 
vn 0.213011 -0.374557 0.902404 
vn 0.151791 -0.394626 0.906217 
vn 0.275606 -0.342253 0.898279 
vn 0.273741 -0.343537 0.898359 
vn 0.219798 -0.371676 0.901968 
vn 0.329775 -0.302267 0.894362 
vn 0.328038 -0.303933 0.894436 
vn 0.279798 -0.339748 0.897933 
vn 0.37829 -0.252563 0.890566 
vn 0.376803 -0.254556 0.890629 
vn 0.333823 -0.298875 0.894 
vn 0.418679 -0.194508 0.887059 
vn 0.417538 -0.196729 0.887108 
vn 0.381979 -0.248256 0.890203 
vn 0.448984 -0.13027 0.883993 
vn 0.448242 -0.132593 0.884024 
vn 0.421779 -0.18933 0.886711 
vn 0.468053 -0.0625642 0.881483 
vn 0.467715 -0.064855 0.881497 
vn 0.451277 -0.124345 0.883678 
vn 0.475694 0.0054865 0.879594 
vn 0.475716 0.00332577 0.879593 
vn 0.469372 -0.0560873 0.881217 
vn 0.47293 0.0707241 0.878257 
vn 0.473315 0.0684307 0.878231 
vn 0.475967 0.011739 0.879385 
vn 0.459568 0.137238 0.877475 
vn 0.460348 0.134935 0.877423 
vn 0.472198 0.077418 0.878086 
vn 0.435096 0.202412 0.877337 
vn 0.43626 0.200229 0.87726 
vn 0.457662 0.144176 0.877359 
vn 0.399879 0.263462 0.877886 
vn 0.401368 0.261521 0.877787 
vn 0.431904 0.209328 0.877291 
vn 0.35519 0.317811 0.879111 
vn 0.356905 0.3162 0.878997 
vn 0.395379 0.270051 0.877923 
vn 0.30306 0.363441 0.880946 
vn 0.304882 0.362208 0.880825 
vn 0.34946 0.323764 0.879235 
vn 0.247403 0.398535 0.883154 
vn 0.249468 0.397565 0.883011 
vn 0.296278 0.368486 0.881157 
vn 0.185457 0.425224 0.885884 
vn 0.187782 0.42456 0.885713 
vn 0.240116 0.402428 0.8834 
vn 0.117804 0.442158 0.889167 
vn 0.120279 0.441878 0.888975 
vn 0.177118 0.428097 0.886207 
vn 0.0468599 0.447778 0.892916 
vn 0.0493513 0.447915 0.892713 
vn 0.108601 0.443706 0.889568 
vn -0.0244715 0.441369 0.896992 
vn -0.0221008 0.441905 0.89679 
vn 0.0370906 0.447751 0.893389 
vn -0.0931798 0.423216 0.901224 
vn -0.0910487 0.424086 0.901033 
vn -0.0344279 0.43962 0.897524 
vn -0.155515 0.395231 0.905322 
vn -0.153573 0.396417 0.905135 
vn -0.102908 0.419732 0.901795 
vn -0.212473 0.357786 0.90931 
vn -0.210626 0.359381 0.909111 
vn -0.164228 0.390463 0.905852 
vn -0.264559 0.309655 0.913303 
vn -0.262941 0.311617 0.913103 
vn -0.220841 0.351264 0.909858 
vn -0.308918 0.251915 0.91712 
vn -0.307643 0.254153 0.916931 
vn -0.272134 0.301367 0.91385 
vn -0.343094 0.18664 0.920572 
vn -0.342236 0.189024 0.920404 
vn -0.315234 0.242006 0.917639 
vn -0.365443 0.116674 0.923493 
vn -0.36502 0.119058 0.923356 
vn -0.347738 0.175419 0.921036 
vn -0.375382 0.0454979 0.925753 
vn -0.375358 0.0477705 0.925648 
vn -0.368123 0.104579 0.923877 
vn -0.373768 -0.0233244 0.927229 
vn -0.374145 -0.0208993 0.927135 
vn -0.376008 0.0338648 0.925997 
vn -0.360365 -0.093762 0.928087 
vn -0.361184 -0.0913229 0.928012 
vn -0.372434 -0.0356627 0.927373 
vn -0.334544 -0.162737 0.928222 
vn -0.335791 -0.160435 0.928173 
vn -0.356797 -0.106352 0.928108 
vn -0.296764 -0.22697 0.927586 
vn -0.29837 -0.224942 0.927565 
vn -0.32862 -0.175015 0.928105 
vn -0.24861 -0.283463 0.926198 
vn -0.250459 -0.281809 0.926204 
vn -0.28856 -0.238334 0.927324 
vn -0.192569 -0.329959 0.924145 
vn -0.194523 -0.328727 0.924175 
vn -0.238407 -0.29336 0.925798 
vn -0.133142 -0.364659 0.921573 
vn -0.135341 -0.363731 0.92162 
vn -0.180818 -0.337965 0.923626 
vn -0.0676378 -0.38976 0.918429 
vn -0.0700825 -0.389181 0.918491 
vn -0.120662 -0.37056 0.920938 
vn 0.00296292 -0.403954 0.914774 
vn 0.00039897 -0.403796 0.914849 
vn -0.053694 -0.393709 0.917666 
vn 0.0758235 -0.405947 0.910746 
vn 0.0732871 -0.406226 0.910829 
vn 0.0179219 -0.405535 0.913904 
vn 0.147765 -0.395462 0.906518 
vn 0.145398 -0.396141 0.906605 
vn 0.0912095 -0.4049 0.909801 
vn 0.21572 -0.373304 0.90228 
vn 0.213635 -0.374298 0.902364 
vn 0.162924 -0.391736 0.905538 
vn -0.152541 0.396967 0.905068 
vn -0.152458 0.397017 0.90506 
vn -0.145637 0.400597 0.904606 
vn -0.164669 0.390195 0.905887 
vn -0.203336 0.364873 0.908583 
vn -0.209573 0.360189 0.909034 
vn -0.204015 0.364345 0.908642 
vn -0.209874 0.359931 0.909067 
vn -0.241384 0.333225 0.911425 
vn -0.256639 0.318278 0.912598 
vn -0.262475 0.312058 0.913086 
vn -0.262006 0.312623 0.913028 
vn -0.302627 0.261716 0.916472 
vn -0.275298 0.297601 0.914136 
vn -0.306878 0.255329 0.91686 
vn -0.305274 0.25766 0.916744 
vn -0.307413 0.254398 0.91694 
vn -0.329974 0.215219 0.919129 
vn -0.3387 0.197125 0.920013 
vn -0.342151 0.189034 0.920434 
vn -0.341683 0.190321 0.920343 
vn -0.363023 0.127288 0.923045 
vn -0.352682 0.161624 0.921679 
vn -0.349799 0.169714 0.921324 
vn -0.364985 0.118853 0.923396 
vn -0.364702 0.120417 0.923305 
vn -0.366064 0.114073 0.923572 
vn -0.373865 0.0652326 0.925186 
vn -0.374819 0.0554389 0.925439 
vn -0.3753 0.0473237 0.925695 
vn -0.375276 0.0490457 0.925615 
vn -0.376088 0.0174151 0.92642 
vn -0.37482 -0.0133718 0.927001 
vn -0.373957 -0.0216515 0.927193 
vn -0.374274 -0.0195644 0.927112 
vn -0.363104 -0.0840245 0.927952 
vn -0.372547 -0.0338857 0.927394 
vn -0.360761 -0.0923496 0.928075 
vn -0.361546 -0.0899818 0.928002 
vn -0.36367 -0.0812018 0.927982 
vn -0.338881 -0.153695 0.92819 
vn -0.355178 -0.110957 0.92819 
vn -0.336391 -0.15915 0.928177 
vn -0.349382 -0.127617 0.928249 
vn -0.327737 -0.176366 0.928161 
vn -0.335049 -0.161646 0.928231 
vn -0.303116 -0.217759 0.92774 
vn -0.297279 -0.226201 0.927609 
vn -0.273773 -0.256383 0.926993 
vn -0.265263 -0.266056 0.926741 
vn -0.23106 -0.299757 0.925612 
vn -0.249062 -0.282966 0.926228 
vn -0.153742 -0.353991 0.922526 
vn -0.147027 -0.357605 0.922226 
vn -0.193376 -0.329348 0.924195 
vn -0.133273 -0.364535 0.921603 
vn -0.104958 -0.376919 0.92028 
vn -0.015803 -0.401306 0.915808 
vn -0.0137324 -0.40163 0.915699 
vn -0.0611662 -0.391512 0.918138 
vn -0.0675391 -0.389713 0.918456 
vn -0.00764074 -0.402525 0.915377 
vn 0.000596831 -0.403593 0.914939 
vn 0.00993935 -0.404605 0.914437 
vn 0.0557633 -0.406566 0.911918 
vn 0.00325874 -0.403902 0.914796 
vn 0.071744 -0.406084 0.911015 
vn 0.101677 -0.403545 0.909293 
vn 0.0761171 -0.405845 0.910767 
vn 0.142705 -0.396537 0.906859 
vn 0.15543 -0.393505 0.906088 
vn 0.199559 -0.379666 0.903344 
vn 0.147518 -0.395439 0.906569 
vn 0.211264 -0.375081 0.902597 
vn 0.241976 -0.361066 0.900599 
vn 0.215908 -0.373148 0.902299 
vn 0.27435 -0.342948 0.898398 
vn 0.287099 -0.334758 0.897503 
vn 0.322391 -0.308433 0.894949 
vn 0.276361 -0.341698 0.898258 
vn 0.280982 -0.338767 0.897934 
vn 0.329387 -0.302497 0.894427 
vn 0.354839 -0.278509 0.892481 
vn 0.330499 -0.301529 0.894344 
vn 0.377493 -0.25339 0.89067 
vn 0.388904 -0.239053 0.889723 
vn 0.413962 -0.202292 0.887532 
vn 0.378919 -0.251665 0.890553 
vn 0.384311 -0.244977 0.890108 
vn 0.417235 -0.196813 0.887231 
vn 0.435099 -0.162982 0.885509 
vn 0.419161 -0.193497 0.887053 
vn 0.447451 -0.134084 0.8842 
vn 0.454789 -0.113412 0.883348 
vn 0.466477 -0.0699295 0.881765 
vn 0.449288 -0.129212 0.883994 
vn 0.452175 -0.121171 0.88366 
vn 0.467128 -0.0668133 0.881662 
vn 0.468177 -0.0615305 0.88149 
vn 0.473531 -0.0253026 0.880414 
vn 0.475543 0.00323844 0.879687 
vn 0.475815 0.0268663 0.879135 
vn 0.472949 0.0698851 0.878314 
vn 0.475657 0.00648178 0.879607 
vn 0.47587 0.0193876 0.879302 
vn 0.472909 0.0702197 0.878309 
vn 0.472718 0.0718107 0.878283 
vn 0.46572 0.112589 0.87774 
vn 0.459693 0.136482 0.877528 
vn 0.451552 0.162117 0.877393 
vn 0.459158 0.13835 0.877515 
vn 0.454025 0.154898 0.877421 
vn 0.435912 0.200457 0.877381 
vn 0.434872 0.202675 0.877388 
vn 0.414002 0.241515 0.877652 
vn 0.401911 0.260347 0.877888 
vn 0.383791 0.285049 0.878323 
vn 0.399116 0.264406 0.87795 
vn 0.388864 0.278498 0.878193 
vn 0.358209 0.31455 0.879059 
vn 0.354283 0.318625 0.879182 
vn 0.32123 0.3491 0.880307 
vn 0.305766 0.361329 0.880879 
vn 0.278276 0.380438 0.881946 
vn 0.284727 0.376221 0.881696 
vn 0.302158 0.364018 0.881017 
vn 0.248112 0.398068 0.883166 
vn 0.24087 0.401823 0.883471 
vn 0.201225 0.419423 0.885208 
vn 0.246335 0.399005 0.883241 
vn 0.185944 0.424963 0.885907 
vn 0.151688 0.435057 0.887534 
vn 0.184236 0.42554 0.885987 
vn 0.15934 0.433071 0.887164 
vn 0.119406 0.441794 0.889135 
vn 0.108382 0.443501 0.889697 
vn 0.064096 0.447416 0.892026 
vn 0.116495 0.442273 0.889283 
vn 0.050178 0.447685 0.892782 
vn 0.0105136 0.445939 0.895002 
vn 0.0455427 0.447672 0.893037 
vn 0.0189153 0.44662 0.894524 
vn -0.0200481 0.44203 0.896776 
vn -0.0343019 0.439425 0.897624 
vn -0.0785086 0.428055 0.900336 
vn -0.0257137 0.441054 0.897112 
vn -0.089224 0.424517 0.901013 
vn -0.121923 0.41169 0.903131 
vn -0.129685 0.408174 0.903646 
vn -0.0942758 0.422737 0.901335 
vn -0.154153 0.395878 0.905272 
vn -0.168734 0.387578 0.906263 
vn -0.205523 0.36297 0.908853 
vn -0.156539 0.394571 0.905433 
vn -0.212016 0.35802 0.909324 
vn -0.213458 0.356892 0.90943 
vn -0.240101 0.33414 0.911428 
vn -0.246091 0.328472 0.911891 
vn -0.263631 0.310513 0.91328 
vn -0.302523 0.261426 0.916589 
vn -0.304176 0.25897 0.916739 
vn -0.307261 0.25429 0.917021 
vn -0.276869 0.295426 0.914367 
vn -0.265422 0.308553 0.913426 
vn -0.30959 0.250663 0.917236 
vn -0.327781 0.219108 0.918995 
vn -0.331683 0.211425 0.919394 
vn -0.341284 0.190654 0.920422 
vn -0.349991 0.16874 0.92143 
vn -0.363628 0.12396 0.92326 
vn -0.343532 0.185321 0.920675 
vn -0.364293 0.12121 0.923363 
vn -0.36564 0.115379 0.923577 
vn -0.37237 0.0772139 0.924867 
vn -0.373411 0.0684917 0.925134 
vn -0.375147 0.0480001 0.925722 
vn -0.373739 -0.0226538 0.927257 
vn -0.373736 -0.0226759 0.927258 
vn -0.375988 0.0224862 0.926352 
vn -0.375366 0.0442552 0.92582 
vn -0.373526 -0.0246687 0.927292 
vn -0.366584 -0.0680205 0.927895 
vn -0.364737 -0.0762786 0.927981 
vn -0.360524 -0.0927956 0.928123 
vn -0.351887 -0.120364 0.928272 
vn -0.359872 -0.0951196 0.92814 
vn -0.335477 -0.160507 0.928274 
vn -0.334266 -0.163064 0.928265 
vn -0.311802 -0.204167 0.927952 
vn -0.307197 -0.211431 0.927862 
vn -0.299058 -0.223533 0.927684 
vn -0.279644 -0.249236 0.92719 
vn -0.295841 -0.228079 0.927609 
vn -0.252007 -0.27994 0.926351 
vn -0.247978 -0.283947 0.926218 
vn -0.212238 -0.315329 0.924945 
vn -0.205356 -0.320611 0.924682 
vn -0.195654 -0.327693 0.924304 
vn -0.166476 -0.346654 0.923102 
vn -0.191505 -0.330594 0.924139 
vn -0.134097 -0.364095 0.921658 
vn -0.1268 -0.367542 0.921322 
vn -0.0846567 -0.384308 0.919315 
vn -0.13191 -0.365146 0.921558 
vn -0.0767636 -0.386884 0.918928 
vn -0.0683783 -0.389437 0.918511 
vn -0.033007 -0.398175 0.916715 
vn -0.0662625 -0.39005 0.918406 
vn 0.00103885 -0.403624 0.914924 
vn 0.0118356 -0.404763 0.914345 
vn 0.0576421 -0.40652 0.911822 
vn 0.00439778 -0.404008 0.914745 
vn 0.0658804 -0.40631 0.911357 
vn 0.0721696 -0.406042 0.911 
vn 0.111359 -0.402245 0.908734 
vn 0.0772245 -0.405758 0.910712 
vn 0.143049 -0.396443 0.906846 
vn 0.156251 -0.393278 0.906045 
vn 0.200381 -0.379341 0.903298 
vn 0.149046 -0.395061 0.906484 
vn 0.20804 -0.376368 0.90281 
vn 0.211572 -0.374939 0.902584 
vn 0.216814 -0.372749 0.902247 
vn 0.249834 -0.356977 0.900083 
vn 0.274574 -0.342795 0.898388 
vn 0.28749 -0.334481 0.897481 
vn 0.277131 -0.3412 0.89821 
vn 0.322747 -0.308121 0.894928 
vn 0.328779 -0.303006 0.894478 
vn 0.329606 -0.30229 0.894416 
vn 0.33119 -0.300907 0.894298 
vn 0.360442 -0.272644 0.892046 
vn 0.377634 -0.253202 0.890663 
vn 0.417351 -0.196594 0.887225 
vn 0.417979 -0.195519 0.887167 
vn 0.388895 -0.239046 0.889729 
vn 0.379495 -0.250945 0.890511 
vn 0.413998 -0.202213 0.887533 
vn 0.419599 -0.192714 0.887017 
vn 0.438319 -0.155972 0.885183 
vn 0.447503 -0.133925 0.884198 
vn 0.467154 -0.0666564 0.88166 
vn 0.467851 -0.0631755 0.881546 
vn 0.454477 -0.114341 0.883389 
vn 0.449577 -0.128405 0.883964 
vn 0.466308 -0.0706873 0.881794 
vn 0.468322 -0.060738 0.881468 
vn 0.474182 -0.0184833 0.880233 
vn 0.475542 0.00333143 0.879687 
vn 0.475831 0.0254537 0.879168 
vn 0.475674 0.00719783 0.879592 
vn 0.47309 0.0686344 0.878337 
vn 0.472895 0.0703062 0.878309 
vn 0.472169 0.0760915 0.878218 
vn 0.464342 0.118585 0.877681 
vn 0.472626 0.0725279 0.878274 
vn 0.459857 0.135889 0.877534 
vn 0.459678 0.136525 0.877529 
vn 0.435901 0.200479 0.877382 
vn 0.435584 0.201157 0.877384 
vn 0.452184 0.160306 0.877401 
vn 0.458957 0.139035 0.877512 
vn 0.432386 0.207841 0.877408 
vn 0.410989 0.246414 0.877706 
vn 0.434194 0.204099 0.877393 
vn 0.401923 0.26033 0.877888 
vn 0.358241 0.31452 0.879057 
vn 0.356011 0.316847 0.879127 
vn 0.385554 0.282804 0.878277 
vn 0.398739 0.264947 0.877958 
vn 0.351039 0.321915 0.879285 
vn 0.317539 0.352128 0.88044 
vn 0.353891 0.31903 0.879194 
vn 0.30583 0.361284 0.880875 
vn 0.28114 0.37859 0.881833 
vn 0.301694 0.364364 0.881033 
vn 0.248204 0.398024 0.88316 
vn 0.237244 0.403643 0.883622 
vn 0.197378 0.420886 0.885379 
vn 0.245871 0.399254 0.883258 
vn 0.243618 0.400423 0.883352 
vn 0.186086 0.424921 0.885897 
vn 0.155628 0.434061 0.887339 
vn 0.183754 0.425708 0.886006 
vn 0.119589 0.441772 0.889121 
vn 0.104977 0.443978 0.889867 
vn 0.0604631 0.44754 0.892217 
vn 0.116017 0.442359 0.889302 
vn 0.112009 0.442981 0.889506 
vn 0.0504048 0.447695 0.892764 
vn 0.0154283 0.446369 0.894716 
vn 0.0450887 0.447679 0.893057 
vn -0.0197975 0.442083 0.896755 
vn -0.0363604 0.439019 0.897742 
vn -0.080851 0.427321 0.900478 
vn -0.0261296 0.440992 0.897131 
vn -0.0300082 0.440275 0.897362 
vn -0.0889626 0.42462 0.90099 
vn -0.124179 0.410701 0.903274 
vn -0.094646 0.422616 0.901353 
vn -0.153892 0.396035 0.905248 
vn -0.170078 0.386791 0.906348 
vn -0.206966 0.361908 0.908949 
vn -0.156831 0.394426 0.905446 
vn -0.164274 0.390214 0.905951 
vn -0.211737 0.358258 0.909295 
vn -0.241346 0.333007 0.911514 
vn -0.213701 0.356724 0.909439 
vn -0.26336 0.310838 0.913248 
vn -0.277414 0.294807 0.914402 
vn -0.304865 0.257978 0.91679 
vn -0.265612 0.308375 0.91343 
vn -0.273012 0.300004 0.914036 
vn -0.307022 0.2547 0.916987 
vn -0.32838 0.218006 0.919043 
vn -0.309728 0.250489 0.917237 
vn -0.341104 0.191134 0.920389 
vn -0.349694 0.169621 0.921381 
vn -0.363567 0.124307 0.923237 
vn -0.343626 0.185158 0.920672 
vn -0.347703 0.174921 0.921143 
vn -0.364192 0.121737 0.923333 
vn -0.365698 0.115229 0.923573 
vn -0.372377 0.0773383 0.924854 
vn -0.375137 0.0485322 0.925698 
vn -0.376007 0.0239433 0.926308 
vn -0.373871 -0.0216385 0.927228 
vn -0.375395 0.0441547 0.925813 
vn -0.375922 0.0300782 0.926163 
vn -0.373831 -0.0220361 0.927235 
vn -0.37355 -0.0247201 0.927281 
vn -0.366819 -0.0670688 0.927871 
vn -0.360743 -0.0921301 0.928104 
vn -0.335835 -0.159831 0.928261 
vn -0.335033 -0.161537 0.928256 
vn -0.352675 -0.118204 0.92825 
vn -0.359907 -0.0951223 0.928126 
vn -0.354699 -0.112188 0.928225 
vn -0.299555 -0.222888 0.927679 
vn -0.299093 -0.223552 0.927668 
vn -0.333871 -0.163977 0.928247 
vn -0.312597 -0.202953 0.927951 
vn -0.252616 -0.279379 0.926355 
vn -0.250702 -0.281303 0.926292 
vn -0.285302 -0.242215 0.927327 
vn -0.295931 -0.22802 0.927595 
vn -0.247688 -0.284285 0.926192 
vn -0.214859 -0.313304 0.925028 
vn -0.196348 -0.327244 0.924315 
vn -0.170812 -0.344078 0.923273 
vn -0.175151 -0.341387 0.923459 
vn -0.191634 -0.330547 0.924129 
vn -0.134907 -0.363747 0.921677 
vn -0.130839 -0.3657 0.92149 
vn -0.0886166 -0.382999 0.919488 
vn -0.0693514 -0.389201 0.918539 
vn -0.0390761 -0.396954 0.917006 
vn -0.0665716 -0.390011 0.918401 
vn -0.044203 -0.395807 0.917269 
vn -2.30105e-05 -0.403549 0.914958 
vn 0.00648191 -0.404286 0.91461 
vn 0.0527615 -0.406623 0.912071 
vn 0.00401775 -0.404019 0.914742 
vn 0.0710265 -0.406154 0.91104 
vn 0.099624 -0.403824 0.909396 
vn 0.0767999 -0.405839 0.910712 
vn 0.141948 -0.396741 0.906889 
vn 0.148779 -0.395179 0.906476 
vn 0.193876 -0.381787 0.903687 
vn 0.210511 -0.375427 0.902629 
vn 0.276141 -0.341919 0.898241 
vn 0.237735 -0.363218 0.900863 
vn 0.216412 -0.372973 0.902251 
vn 0.273627 -0.343439 0.898431 
vn 0.2805 -0.339124 0.89795 
vn 0.316661 -0.313165 0.895351 
vn 0.276712 -0.341524 0.898216 
vn 0.330269 -0.301837 0.894325 
vn 0.328639 -0.303209 0.894461 
vn 0.378717 -0.252046 0.890531 
vn 0.350318 -0.283139 0.89281 
vn 0.330751 -0.301372 0.894303 
vn 0.376796 -0.254312 0.890702 
vn 0.382966 -0.246761 0.890194 
vn 0.409303 -0.209896 0.887927 
vn 0.379083 -0.251553 0.890515 
vn 0.419018 -0.19392 0.887028 
vn 0.416636 -0.197952 0.88726 
vn 0.44922 -0.129636 0.883966 
vn 0.431861 -0.169833 0.885806 
vn 0.41926 -0.193447 0.887017 
vn 0.447026 -0.135358 0.884221 
vn 0.45048 -0.126138 0.883831 
vn 0.463827 -0.081835 0.882138 
vn 0.44935 -0.129224 0.88396 
vn 0.46818 -0.0619113 0.881462 
vn 0.466902 -0.0682087 0.881674 
vn 0.475714 0.0060953 0.879579 
vn 0.472383 -0.0356562 0.880672 
vn 0.468227 -0.0615864 0.881459 
vn 0.475545 0.00187889 0.879689 
vn 0.475856 0.0120077 0.879441 
vn 0.474421 0.0560005 0.878515 
vn 0.475711 0.0063292 0.879579 
vn 0.472854 0.0713562 0.878247 
vn 0.473169 0.0686216 0.878295 
vn 0.464126 0.11985 0.877623 
vn 0.460256 0.134786 0.877495 
vn 0.459387 0.137871 0.877471 
vn 0.472826 0.0715219 0.878248 
vn 0.468347 0.100253 0.877839 
vn 0.459362 0.137943 0.877472 
vn 0.451401 0.162807 0.877343 
vn 0.454477 0.153815 0.877378 
vn 0.464377 0.118852 0.877626 
vn 0.472535 0.0740516 0.878196 
vn 0.459408 0.137809 0.87747 
vn 0.472907 0.0710429 0.878243 
vn 0.475784 0.0324637 0.878963 
vn 0.474726 -0.0130031 0.880038 
vn 0.47572 0.00557954 0.879579 
vn 0.468629 -0.0597383 0.881373 
vn 0.468066 -0.0626936 0.881467 
vn 0.457383 -0.105624 0.882975 
vn 0.454907 -0.113476 0.883279 
vn 0.437604 -0.157934 0.885189 
vn 0.448883 -0.130697 0.883981 
vn 0.415577 -0.199931 0.887312 
vn 0.388362 -0.240053 0.889691 
vn 0.418358 -0.19521 0.887056 
vn 0.377666 -0.253459 0.890577 
vn 0.357067 -0.276474 0.892225 
vn 0.322054 -0.308952 0.894891 
vn 0.284651 -0.336596 0.897595 
vn 0.328821 -0.303231 0.894387 
vn 0.251534 -0.356266 0.899892 
vn 0.230088 -0.367035 0.901302 
vn 0.274362 -0.343148 0.898318 
vn -0.130272 0.408094 0.903597 
vn -0.261081 0.352125 -0.898802 
vn -0.201362 0.399833 -0.894196 
vn -0.210641 0.3936 -0.894824 
vn -0.203424 0.39858 -0.894289 
vn -0.31294 0.293628 -0.903245 
vn -0.269279 0.344338 -0.8994 
vn -0.26305 0.350427 -0.898891 
vn -0.35422 0.226521 -0.907313 
vn -0.319642 0.284611 -0.903784 
vn -0.314669 0.291527 -0.903325 
vn -0.383078 0.153823 -0.910818 
vn -0.359142 0.216732 -0.907769 
vn -0.355584 0.224113 -0.907377 
vn -0.398814 0.078957 -0.913626 
vn -0.386115 0.143792 -0.911175 
vn -0.383995 0.151251 -0.910863 
vn -0.401893 0.00523372 -0.915672 
vn -0.400048 0.0692017 -0.913878 
vn -0.399262 0.0763796 -0.91365 
vn -0.392465 -0.0717768 -0.916962 
vn -0.401561 -0.00405563 -0.915823 
vn -0.40191 0.0028015 -0.915675 
vn -0.369393 -0.147927 -0.917424 
vn -0.390523 -0.0811794 -0.917007 
vn -0.392049 -0.0743553 -0.916934 
vn -0.333142 -0.219383 -0.916999 
vn -0.365895 -0.156771 -0.917357 
vn -0.368499 -0.150521 -0.917361 
vn -0.285415 -0.282855 -0.915714 
vn -0.328308 -0.227247 -0.916827 
vn -0.331785 -0.22183 -0.916902 
vn -0.228898 -0.33588 -0.913669 
vn -0.279601 -0.289424 -0.915455 
vn -0.283674 -0.285006 -0.915588 
vn -0.166792 -0.377119 -0.911022 
vn -0.22253 -0.340992 -0.913348 
vn -0.226897 -0.337629 -0.913523 
vn -0.0983063 -0.407956 -0.907694 
vn -0.160299 -0.38077 -0.910669 
vn -0.164681 -0.378417 -0.910868 
vn -0.0228769 -0.427618 -0.90367 
vn -0.0912228 -0.410535 -0.90727 
vn -0.09597 -0.408907 -0.907516 
vn 0.0552827 -0.434031 -0.8992 
vn -0.01557 -0.428941 -0.903198 
vn -0.0202809 -0.428192 -0.90346 
vn 0.13269 -0.426939 -0.894492 
vn 0.0624484 -0.434083 -0.898706 
vn 0.058001 -0.434154 -0.898969 
vn 0.206038 -0.407269 -0.889764 
vn 0.139369 -0.425836 -0.894002 
vn 0.135374 -0.426597 -0.894253 
vn 0.27264 -0.376911 -0.885215 
vn 0.211955 -0.405232 -0.889304 
vn 0.208538 -0.406504 -0.889532 
vn 0.332226 -0.337241 -0.880849 
vn 0.277625 -0.374228 -0.884804 
vn 0.274839 -0.375816 -0.885 
vn 0.387245 -0.28617 -0.876441 
vn 0.336555 -0.333944 -0.880461 
vn 0.334165 -0.335851 -0.880646 
vn 0.433523 -0.225957 -0.872354 
vn 0.390918 -0.282281 -0.876071 
vn 0.389041 -0.284376 -0.876229 
vn 0.469006 -0.15902 -0.868762 
vn 0.436394 -0.221685 -0.872018 
vn 0.435048 -0.223819 -0.872146 
vn 0.49255 -0.0883085 -0.865792 
vn 0.471008 -0.154615 -0.868473 
vn 0.470161 -0.156644 -0.868569 
vn 0.504041 -0.0168874 -0.863515 
vn 0.493708 -0.0840248 -0.865559 
vn 0.493283 -0.0858311 -0.865624 
vn 0.504289 0.0526197 -0.86193 
vn 0.50446 -0.0129457 -0.863338 
vn 0.493288 0.125087 -0.860825 
vn 0.504126 0.0561586 -0.861802 
vn 0.470261 0.196196 -0.860443 
vn 0.492596 0.128477 -0.860723 
vn 0.469102 0.199278 -0.860367 
vn 0.434184 0.265597 -0.86078 
vn 0.435696 0.262955 -0.860828 
vn 0.389327 0.324777 -0.861942 
vn 0.391035 0.322658 -0.861965 
vn 0.336755 0.374816 -0.863776 
vn 0.338487 0.373244 -0.863779 
vn 0.279092 0.414579 -0.866159 
vn 0.280686 0.41352 -0.86615 
vn 0.214394 0.445811 -0.869073 
vn 0.215909 0.445096 -0.869064 
vn 0.142557 0.467137 -0.872617 
vn 0.144003 0.466702 -0.872612 
vn 0.067187 0.476351 -0.876684 
vn 0.0684584 0.476164 -0.876688 
vn -0.0085985 0.472812 -0.881122 
vn -0.00759188 0.472801 -0.881137 
vn -0.0816483 0.456941 -0.885742 
vn -0.0809657 0.457008 -0.88577 
vn -0.0834906 0.456373 -0.885863 
vn -0.149205 0.430135 -0.890349 
vn -0.148866 0.430165 -0.890391 
vn -0.151126 0.429181 -0.890486 
vn -0.211229 0.393185 -0.894868 
vn -0.211266 0.393019 -0.894932 
vn -0.213324 0.391695 -0.895024 
vn -0.269803 0.343815 -0.899443 
vn -0.26994 0.343491 -0.899526 
vn -0.27188 0.341725 -0.899614 
vn -0.320073 0.283998 -0.903824 
vn -0.320279 0.283452 -0.903923 
vn -0.321957 0.281294 -0.904001 
vn -0.35946 0.216055 -0.907804 
vn -0.359677 0.215237 -0.907913 
vn -0.360974 0.212793 -0.907974 
vn -0.386309 0.143083 -0.911204 
vn -0.386462 0.141962 -0.911314 
vn -0.387304 0.139378 -0.911356 
vn -0.400119 0.0684933 -0.9139 
vn -0.400125 0.0670656 -0.914004 
vn -0.4005 0.0645019 -0.914024 
vn -0.401519 -0.00478714 -0.915838 
vn -0.401286 -0.00677166 -0.915928 
vn -0.401239 -0.00921859 -0.915927 
vn -0.390352 -0.0819132 -0.917014 
vn -0.389709 -0.0840637 -0.917093 
vn -0.389219 -0.0866555 -0.91706 
vn -0.365596 -0.157472 -0.917356 
vn -0.364475 -0.159707 -0.917416 
vn -0.363505 -0.162289 -0.917348 
vn -0.327893 -0.227883 -0.916818 
vn -0.326253 -0.230096 -0.916851 
vn -0.324828 -0.232505 -0.916749 
vn -0.279091 -0.289969 -0.915438 
vn -0.276928 -0.292043 -0.915435 
vn -0.275136 -0.294136 -0.915306 
vn -0.221955 -0.341428 -0.913325 
vn -0.219301 -0.343251 -0.913283 
vn -0.217272 -0.34493 -0.913135 
vn -0.159692 -0.381091 -0.910642 
vn -0.156608 -0.382568 -0.910558 
vn -0.154493 -0.383793 -0.910403 
vn -0.090523 -0.41077 -0.907234 
vn -0.0866189 -0.411927 -0.90709 
vn -0.0842335 -0.412825 -0.906907 
vn -0.0148318 -0.429054 -0.903157 
vn -0.0105297 -0.429547 -0.902983 
vn -0.0079043 -0.430052 -0.902769 
vn 0.0631925 -0.434067 -0.898661 
vn 0.0677447 -0.433796 -0.898461 
vn 0.0704681 -0.433844 -0.898228 
vn 0.140087 -0.425695 -0.893957 
vn 0.144716 -0.424611 -0.893735 
vn 0.14738 -0.424197 -0.893497 
vn 0.212618 -0.404982 -0.88926 
vn 0.217148 -0.403092 -0.889024 
vn 0.219608 -0.402268 -0.888793 
vn 0.278212 -0.37389 -0.884762 
vn 0.282487 -0.371253 -0.884518 
vn 0.28463 -0.370117 -0.884307 
vn 0.337108 -0.3335 -0.880418 
vn 0.341463 -0.329799 -0.880134 
vn 0.343389 -0.328343 -0.879929 
vn 0.391397 -0.281742 -0.87603 
vn 0.395259 -0.277144 -0.875764 
vn 0.397019 -0.275289 -0.875552 
vn 0.436778 -0.221072 -0.871982 
vn 0.439935 -0.21568 -0.871745 
vn 0.441407 -0.213496 -0.871539 
vn 0.471281 -0.153954 -0.868442 
vn 0.473567 -0.147936 -0.868245 
vn 0.474658 -0.145535 -0.868055 
vn 0.493867 -0.0833447 -0.865534 
vn 0.495175 -0.0769105 -0.865382 
vn 0.495839 -0.0744301 -0.865219 
vn 0.504507 -0.0122747 -0.86332 
vn 0.504801 -0.00564445 -0.863217 
vn 0.505046 -0.0032262 -0.863086 
vn 0.504072 0.0568461 -0.861789 
vn 0.503334 0.0641239 -0.861709 
vn 0.503209 0.0664367 -0.861607 
vn 0.492428 0.129164 -0.860716 
vn 0.490427 0.136575 -0.860714 
vn 0.489903 0.139004 -0.860624 
vn 0.468821 0.199936 -0.860368 
vn 0.465505 0.207189 -0.860452 
vn 0.464557 0.209602 -0.86038 
vn 0.4338 0.266199 -0.860788 
vn 0.429213 0.272993 -0.86096 
vn 0.427865 0.275251 -0.860912 
vn 0.388859 0.3253 -0.861957 
vn 0.383133 0.331362 -0.862211 
vn 0.381459 0.333342 -0.86219 
vn 0.336225 0.375245 -0.863796 
vn 0.329568 0.380363 -0.864123 
vn 0.327679 0.381979 -0.864129 
vn 0.278527 0.414907 -0.866184 
vn 0.271181 0.418949 -0.86657 
vn 0.269209 0.42016 -0.866598 
vn 0.213734 0.446067 -0.869104 
vn 0.204824 0.449291 -0.869589 
vn 0.202549 0.450234 -0.869634 
vn 0.14185 0.467284 -0.872654 
vn 0.132144 0.469051 -0.873229 
vn 0.129611 0.469643 -0.873291 
vn 0.0664612 0.476378 -0.876725 
vn 0.0563028 0.476489 -0.877376 
vn 0.0536366 0.476656 -0.877452 
vn -0.00931279 0.472717 -0.881165 
vn -0.0195294 0.471094 -0.881867 
vn -0.0221806 0.470813 -0.881954 
vn -0.0823223 0.456734 -0.885786 
vn -0.0922038 0.453427 -0.886511 
vn -0.094694 0.45273 -0.886605 
vn -0.149816 0.429833 -0.890393 
vn -0.159019 0.425005 -0.891114 
vn -0.161227 0.423975 -0.891207 
vn -0.211818 0.392768 -0.894911 
vn -0.221039 0.385905 -0.895667 
vn -0.223087 0.384509 -0.895759 
vn -0.270326 0.343291 -0.899486 
vn -0.278586 0.334589 -0.900244 
vn -0.280494 0.332756 -0.900331 
vn -0.320504 0.283384 -0.903865 
vn -0.327338 0.273068 -0.90459 
vn -0.328963 0.270856 -0.904666 
vn -0.359777 0.215377 -0.90784 
vn -0.364813 0.203824 -0.908497 
vn -0.36604 0.201347 -0.908556 
vn -0.386502 0.142374 -0.911233 
vn -0.389512 0.13006 -0.911792 
vn -0.390279 0.127469 -0.91183 
vn -0.40019 0.067785 -0.913922 
vn -0.401117 0.0552168 -0.914361 
vn -0.401421 0.0526704 -0.914378 
vn -0.401476 -0.00551883 -0.915853 
vn -0.400348 -0.0190374 -0.916166 
vn -0.400235 -0.0215166 -0.91616 
vn -0.39018 -0.0826468 -0.917022 
vn -0.386604 -0.0963091 -0.917203 
vn -0.386038 -0.0989102 -0.917165 
vn -0.365296 -0.158174 -0.917355 
vn -0.359225 -0.171353 -0.917385 
vn -0.358179 -0.173918 -0.917311 
vn -0.327476 -0.228519 -0.916809 
vn -0.319081 -0.240593 -0.91668 
vn 0.347274 0.365862 -0.86345 
vn 0.392407 0.3211 -0.861923 
vn 0.363736 0.350969 -0.862854 
vn 0.290126 0.407821 -0.865742 
vn 0.331478 0.378889 -0.86404 
vn 0.347097 0.36603 -0.86345 
vn 0.291802 0.406802 -0.865658 
vn 0.289729 0.408093 -0.865746 
vn 0.248383 0.430861 -0.867562 
vn 0.226833 0.440634 -0.868555 
vn 0.155769 0.464043 -0.872009 
vn 0.203452 0.449828 -0.869633 
vn 0.226174 0.440948 -0.868568 
vn 0.155157 0.464242 -0.872012 
vn 0.10502 0.473266 -0.874637 
vn 0.0806011 0.475511 -0.87601 
vn 0.00441425 0.474191 -0.880411 
vn 0.055801 0.476574 -0.877362 
vn 0.0791868 0.475676 -0.876049 
vn 0.00501286 0.474344 -0.880325 
vn 0.00264171 0.474099 -0.880468 
vn -0.0457536 0.466291 -0.883447 
vn -0.0695875 0.460307 -0.885028 
vn -0.13852 0.435097 -0.889664 
vn -0.0937528 0.453024 -0.886555 
vn -0.0716096 0.459855 -0.885102 
vn -0.141371 0.433896 -0.889803 
vn -0.186986 0.409179 -0.893089 
vn -0.140632 0.434242 -0.889751 
vn 0.294114 -0.364269 -0.883632 
vn 0.270383 -0.37829 -0.885319 
vn 0.278797 -0.373552 -0.884721 
vn 0.230493 -0.397772 -0.88806 
vn 0.230109 -0.397912 -0.888097 
vn 0.224153 -0.400405 -0.888499 
vn 0.176833 -0.416807 -0.891629 
vn 0.159266 -0.421484 -0.892741 
vn 0.213279 -0.40473 -0.889216 
vn 0.158512 -0.421622 -0.892809 
vn 0.126034 -0.428179 -0.894862 
vn 0.140803 -0.425553 -0.893912 
vn 0.0828977 -0.433191 -0.897482 
vn 0.0817702 -0.433202 -0.89758 
vn 0.0744768 -0.433607 -0.898019 
vn 0.0238404 -0.433164 -0.901 
vn 0.00452454 -0.431569 -0.902068 
vn 0.0639365 -0.43405 -0.898617 
vn 0.00309786 -0.431336 -0.902186 
vn -0.0283844 -0.426701 -0.903947 
vn -0.0140934 -0.429166 -0.903116 
vn -0.0723609 -0.416431 -0.906283 
vn -0.0739516 -0.41588 -0.906408 
vn -0.0792696 -0.414288 -0.906687 
vn -0.127079 -0.396653 -0.90913 
vn -0.144262 -0.388867 -0.909929 
vn -0.0898227 -0.411004 -0.907198 
vn -0.145865 -0.387993 -0.910047 
vn -0.173668 -0.373276 -0.91132 
vn -0.159084 -0.381412 -0.910614 
vn -0.207523 -0.351927 -0.912733 
vn -0.209289 -0.350543 -0.912862 
vn -0.216522 -0.345332 -0.913162 
vn -0.221381 -0.341863 -0.913302 
vn -0.251518 -0.316809 -0.914533 
vn -0.26639 -0.302989 -0.915005 
vn -0.268175 -0.301017 -0.915134 
vn -0.282669 -0.285884 -0.915625 
vn -0.278581 -0.290512 -0.915421 
vn -0.317591 -0.242961 -0.916573 
vn -0.299688 -0.266175 -0.916154 
vn -0.319126 -0.240522 -0.916683 
vn -0.289828 -0.277867 -0.915854 
vn -0.331572 -0.221874 -0.916969 
vn -0.355598 -0.178908 -0.917356 
vn -0.329965 -0.224395 -0.916935 
vn -0.367578 -0.152366 -0.917426 
vn -0.377548 -0.125958 -0.917383 
vn -0.359282 -0.171213 -0.917389 
vn -0.391348 -0.0769012 -0.917024 
vn -0.391659 -0.075491 -0.917008 
vn -0.399952 -0.0231026 -0.916245 
vn -0.386648 -0.0961065 -0.917206 
vn -0.401748 0.00208654 -0.915748 
vn -0.402008 0.0374544 -0.91487 
vn -0.400359 -0.0187917 -0.916166 
vn -0.400823 -0.013217 -0.91606 
vn -0.397695 0.0872526 -0.913359 
vn -0.398981 0.0774663 -0.913681 
vn -0.40108 0.0555196 -0.914359 
vn -0.383659 0.151801 -0.910913 
vn -0.36918 0.193334 -0.909026 
vn -0.389404 0.130423 -0.911786 
vn -0.387785 0.136884 -0.911529 
vn -0.385448 0.145573 -0.911174 
vn -0.355941 0.222996 -0.907512 
vn -0.347655 0.23908 -0.906629 
vn -0.364613 0.204226 -0.908487 
vn -0.316398 0.288863 -0.903576 
vn -0.28565 0.3269 -0.900855 
vn -0.327038 0.273476 -0.904576 
vn -0.320851 0.282588 -0.90399 
vn -0.317507 0.287322 -0.903679 
vn -0.266042 0.347314 -0.899219 
vn -0.249527 0.362671 -0.89789 
vn -0.278193 0.334967 -0.900226 
vn -0.206209 0.396518 -0.894568 
vn -0.1623 0.423237 -0.891364 
vn -0.220577 0.386219 -0.895646 
vn -0.209223 0.394427 -0.894792 
vn -0.141516 0.433671 -0.889889 
vn -0.11871 0.443631 -0.888313 
vn -0.158482 0.425255 -0.89109 
vn -0.0726897 0.459404 -0.885248 
vn -0.0727405 0.459389 -0.885251 
vn -0.020546 0.470896 -0.88195 
vn -0.0915523 0.453609 -0.886486 
vn -0.000388508 0.473637 -0.88072 
vn 0.0277773 0.475928 -0.879045 
vn -0.0187839 0.471172 -0.881841 
vn 0.0830355 0.475301 -0.875896 
vn 0.0738078 0.475877 -0.876409 
vn 0.076875 0.475706 -0.876238 
vn 0.0571053 0.476438 -0.877351 
vn 0.147716 0.46586 -0.872442 
vn 0.179168 0.457721 -0.870856 
vn 0.131532 0.469123 -0.873283 
vn 0.231632 0.438529 -0.868354 
vn 0.219449 0.443649 -0.868918 
vn 0.225787 0.441037 -0.868623 
vn 0.205593 0.448971 -0.869572 
vn 0.285595 0.410553 -0.865957 
vn 0.314329 0.391662 -0.864753 
vn 0.271879 0.418519 -0.866558 
vn 0.275059 0.416729 -0.866418 
vn 0.355412 0.358615 -0.863178 
vn 0.343717 0.368839 -0.863606 
vn 0.351283 0.362306 -0.863328 
vn 0.330266 0.379765 -0.86412 
vn 0.394931 0.318121 -0.861875 
vn 0.418507 0.288318 -0.861234 
vn 0.383781 0.330595 -0.862217 
vn 0.388726 0.325176 -0.862063 
vn 0.447845 0.242309 -0.860652 
vn 0.437865 0.259366 -0.860815 
vn 0.444607 0.248032 -0.860701 
vn 0.429758 0.272078 -0.860977 
vn 0.471148 0.193923 -0.860473 
vn 0.485413 0.15403 -0.86061 
vn 0.465905 0.206169 -0.860481 
vn 0.468915 0.19926 -0.860473 
vn 0.498447 0.0997676 -0.86116 
vn 0.493661 0.123282 -0.860872 
vn 0.497174 0.106674 -0.861068 
vn 0.490656 0.135509 -0.860752 
vn 0.504474 0.0492159 -0.862023 
vn 0.505218 0.00513589 -0.862977 
vn 0.50339 0.063076 -0.861754 
vn 0.504332 0.051398 -0.861979 
vn 0.503556 -0.0219396 -0.863684 
vn 0.501331 -0.0415557 -0.864257 
vn 0.500457 -0.0476983 -0.864446 
vn 0.504686 -0.00677362 -0.863276 
vn 0.491123 -0.0937605 -0.86603 
vn 0.476972 -0.138893 -0.867875 
vn 0.491338 -0.0929217 -0.865998 
vn 0.494854 -0.0781053 -0.865459 
vn 0.467716 -0.161851 -0.868934 
vn 0.457871 -0.182964 -0.869988 
vn 0.454672 -0.189265 -0.870317 
vn 0.473024 -0.14913 -0.868337 
vn 0.41775 -0.248808 -0.87383 
vn 0.401499 -0.269666 -0.875259 
vn 0.430327 -0.230743 -0.872683 
vn 0.432803 -0.226956 -0.872452 
vn 0.43918 -0.216799 -0.871848 
vn 0.387143 -0.286193 -0.876478 
vn 0.368115 -0.305822 -0.878046 
vn 0.362532 -0.311152 -0.878496 
vn 0.39433 -0.27812 -0.875873 
vn 0.324806 -0.342867 -0.881444 
vn 0.285191 -0.36957 -0.884355 
vn 0.331493 -0.337745 -0.880932 
vn 0.340423 -0.330585 -0.880242 
vn 0.26985 -0.378384 -0.885441 
vn 0.243157 -0.391895 -0.887295 
vn 0.236847 -0.394772 -0.887727 
vn 0.281304 -0.371879 -0.884632 
vn 0.192174 -0.411941 -0.890715 
vn 0.145539 -0.42436 -0.893721 
vn 0.202781 -0.408354 -0.890015 
vn 0.215759 -0.403556 -0.889151 
vn 0.130688 -0.427216 -0.894655 
vn 0.0970123 -0.431804 -0.896735 
vn 0.0893803 -0.432487 -0.897199 
vn 0.143176 -0.424849 -0.89387 
vn 0.0401515 -0.433775 -0.900126 
vn -0.00933653 -0.429636 -0.902954 
vn 0.0552624 -0.433953 -0.899239 
vn 0.066135 -0.433765 -0.898595 
vn -0.0213263 -0.427803 -0.903621 
vn -0.0588901 -0.419886 -0.905664 
vn -0.0670589 -0.417718 -0.906099 
vn -0.0121146 -0.42924 -0.903109 
vn -0.115029 -0.401572 -0.908575 
vn -0.0968676 -0.408391 -0.907653 
vn -0.0880862 -0.411373 -0.907201 
vn -0.167559 -0.376613 -0.911091 
vn -0.2022 -0.355328 -0.91261 
vn -0.208509 -0.350973 -0.912876 
vn -0.15793 -0.3818 -0.910652 
vn -0.16035 -0.380525 -0.910763 
vn -0.247068 -0.320639 -0.914411 
vn -0.230297 -0.334667 -0.913762 
vn -0.220591 -0.342182 -0.913374 
vn -0.285892 -0.282188 -0.91577 
vn -0.314166 -0.247284 -0.916597 
vn -0.318949 -0.24062 -0.916719 
vn -0.278087 -0.290687 -0.915516 
vn -0.282369 -0.286078 -0.915657 
vn -0.345534 -0.198071 -0.917265 
vn -0.332415 -0.220373 -0.917026 
vn -0.327189 -0.228509 -0.916914 
vn -0.368149 -0.150758 -0.917463 
vn -0.384282 -0.104339 -0.917301 
vn -0.386677 -0.0957089 -0.917235 
vn -0.365122 -0.157978 -0.917458 
vn -0.36739 -0.152602 -0.917462 
vn -0.397064 -0.0457534 -0.91665 
vn -0.391607 -0.075397 -0.917038 
vn -0.39004 -0.0823029 -0.917112 
vn -0.401813 0.00512473 -0.915707 
vn -0.40112 0.053956 -0.914435 
vn -0.401748 0.0035414 -0.915743 
vn -0.400498 0.0620359 -0.914195 
vn -0.401317 -0.00508776 -0.915925 
vn -0.398733 0.0789085 -0.913666 
vn -0.393722 0.110356 -0.912581 
vn -0.399861 0.0688515 -0.913986 
vn -0.381764 0.157801 -0.91069 
vn -0.383145 0.153268 -0.910884 
vn -0.36455 0.204181 -0.908523 
vn -0.361134 0.211847 -0.908132 
vn -0.385866 0.143784 -0.911281 
vn -0.355214 0.224303 -0.907475 
vn -0.338262 0.255469 -0.905712 
vn -0.358749 0.216982 -0.907865 
vn -0.310728 0.296422 -0.903096 
vn -0.278548 0.334497 -0.90029 
vn -0.315484 0.290005 -0.90353 
vn -0.272293 0.340988 -0.899769 
vn -0.319062 0.285013 -0.903862 
vn -0.265026 0.348216 -0.89917 
vn -0.235649 0.374382 -0.896832 
vn -0.268518 0.344783 -0.899457 
vn -0.19552 0.403584 -0.893807 
vn -0.205147 0.397182 -0.894517 
vn -0.153868 0.42757 -0.890791 
vn -0.209744 0.393997 -0.89486 
vn -0.140367 0.434146 -0.889839 
vn -0.103139 0.449531 -0.887291 
vn -0.146536 0.43121 -0.890272 
vn -0.0579795 0.463244 -0.884332 
vn -0.0715153 0.459674 -0.885204 
vn -0.0111325 0.472229 -0.881406 
vn -0.0790632 0.457484 -0.885696 
vn 0.000899168 0.473719 -0.880676 
vn 0.0445404 0.476394 -0.878103 
vn -0.00556585 0.472959 -0.881067 
vn -0.00285318 0.473289 -0.880903 
vn 0.0921174 0.474491 -0.875427 
vn 0.0750108 0.475756 -0.876373 
vn 0.139753 0.467487 -0.872883 
vn 0.0704958 0.475979 -0.876627 
vn 0.148873 0.465548 -0.872412 
vn 0.194654 0.452762 -0.870124 
vn 0.145938 0.466194 -0.872563 
vn 0.148457 0.465641 -0.872433 
vn 0.239352 0.43502 -0.868025 
vn 0.222248 0.442462 -0.868811 
vn 0.220396 0.443218 -0.868898 
vn 0.217644 0.444323 -0.869027 
vn 0.288512 0.408723 -0.865856 
vn 0.326273 0.38279 -0.864302 
vn 0.286464 0.409975 -0.865944 
vn 0.281483 0.412959 -0.86616 
vn 0.361367 0.353066 -0.862994 
vn 0.344468 0.368143 -0.863605 
vn 0.339958 0.371917 -0.863774 
vn 0.399094 0.313142 -0.861781 
vn 0.427082 0.275994 -0.861062 
vn 0.395602 0.317265 -0.861883 
vn 0.392329 0.321041 -0.861981 
vn 0.393672 0.319501 -0.86194 
vn 0.451247 0.235984 -0.860632 
vn 0.438351 0.258484 -0.860834 
vn 0.436725 0.26112 -0.860865 
vn 0.474699 0.184894 -0.860508 
vn 0.489445 0.13991 -0.860737 
vn 0.471488 0.192977 -0.860499 
vn 0.471431 0.193115 -0.860499 
vn 0.493656 0.123128 -0.860897 
vn 0.499489 0.0933893 -0.861272 
vn 0.493822 0.122411 -0.860904 
vn 0.505063 0.0372767 -0.862277 
vn 0.50456 -0.00827585 -0.863337 
vn 0.504663 0.0455809 -0.862112 
vn 0.504494 0.0483927 -0.862058 
vn 0.504342 0.0507638 -0.86201 
vn 0.499458 -0.0538366 -0.864663 
vn 0.503441 -0.0227717 -0.863729 
vn 0.503787 -0.0188759 -0.863622 
vn 0.487307 -0.107535 -0.866584 
vn 0.472003 -0.151558 -0.868472 
vn 0.491086 -0.0937454 -0.866052 
vn 0.489611 -0.0993321 -0.866265 
vn 0.491948 -0.0903376 -0.865925 
vn 0.452096 -0.194085 -0.870598 
vn 0.467342 -0.162609 -0.868993 
vn 0.468053 -0.160972 -0.868915 
vn 0.432334 -0.227612 -0.872514 
vn 0.422414 -0.242262 -0.873428 
vn 0.392807 -0.279812 -0.876018 
vn 0.432263 -0.227719 -0.872521 
vn 0.427465 -0.234956 -0.872966 
vn 0.386606 -0.28673 -0.87654 
vn 0.359118 -0.314281 -0.878784 
vn 0.385758 -0.287653 -0.876611 
vn 0.330943 -0.338139 -0.880988 
vn 0.31398 -0.350722 -0.882276 
vn 0.274638 -0.375683 -0.885119 
vn 0.321308 -0.345436 -0.881723 
vn 0.330618 -0.338391 -0.881013 
vn 0.269231 -0.378688 -0.8855 
vn 0.232799 -0.396522 -0.888018 
vn 0.270814 -0.377818 -0.885389 
vn 0.179845 -0.415714 -0.891536 
vn 0.1334 -0.426699 -0.894501 
vn 0.202127 -0.40855 -0.890074 
vn 0.188248 -0.413162 -0.890988 
vn 0.203958 -0.407902 -0.889953 
vn 0.129988 -0.427304 -0.894715 
vn 0.0856136 -0.432744 -0.897443 
vn 0.130456 -0.427222 -0.894686 
vn 0.0546198 -0.433924 -0.899292 
vn 0.0275944 -0.433212 -0.900869 
vn -0.0213081 -0.427776 -0.903633 
vn 0.0530197 -0.433926 -0.899387 
vn 0.0365946 -0.433629 -0.900348 
vn -0.0219526 -0.427669 -0.903669 
vn -0.0250378 -0.427139 -0.903839 
vn -0.0697512 -0.416941 -0.906253 
vn -0.0973666 -0.408191 -0.907689 
vn -0.126031 -0.396979 -0.909134 
vn -0.10025 -0.407162 -0.907838 
vn -0.117504 -0.400549 -0.90871 
vn -0.168016 -0.376333 -0.911122 
vn -0.169927 -0.375265 -0.911209 
vn -0.210557 -0.349496 -0.912972 
vn -0.168547 -0.376038 -0.911146 
vn -0.230676 -0.334334 -0.913789 
vn -0.248827 -0.319054 -0.914489 
vn -0.255485 -0.313028 -0.914735 
vn -0.28622 -0.281785 -0.915792 
vn -0.230559 -0.334425 -0.913785 
vn -0.286858 -0.281069 -0.915813 
vn -0.289641 -0.27791 -0.915901 
vn -0.320033 -0.239033 -0.916756 
vn -0.332641 -0.219969 -0.917041 
vn -0.350635 -0.188497 -0.917346 
vn -0.334262 -0.217357 -0.917074 
vn -0.346408 -0.19643 -0.917288 
vn -0.368293 -0.150355 -0.917471 
vn -0.391669 -0.0750332 -0.917041 
vn -0.391741 -0.0747043 -0.917038 
vn -0.371285 -0.142831 -0.917468 
vn -0.386873 -0.0949048 -0.917236 
vn -0.370128 -0.145785 -0.91747 
vn -0.398424 -0.0358636 -0.9165 
vn -0.392805 -0.0696558 -0.91698 
vn -0.397179 -0.0448827 -0.916643 
vn -0.401748 0.0038477 -0.915742 
vn -0.402069 0.0143189 -0.915497 
vn -0.400444 0.0625007 -0.914187 
vn -0.401877 0.00722754 -0.915665 
vn -0.398681 0.0792106 -0.913662 
vn -0.391844 0.119404 -0.912251 
vn -0.398446 0.0810616 -0.913603 
vn -0.393618 0.110813 -0.912571 
vn -0.383054 0.153526 -0.910879 
vn -0.379014 0.166319 -0.910322 
vn -0.36117 0.211736 -0.908143 
vn -0.38233 0.155913 -0.910777 
vn -0.355091 0.224524 -0.907469 
vn -0.333809 0.262763 -0.905277 
vn -0.353115 0.228466 -0.907256 
vn -0.338256 0.255457 -0.905718 
vn -0.315359 0.29016 -0.903524 
vn -0.305618 0.303049 -0.90264 
vn -0.273133 0.34012 -0.899843 
vn -0.311548 0.295316 -0.903176 
vn -0.264901 0.348327 -0.899164 
vn -0.229795 0.379067 -0.896383 
vn -0.259507 0.353479 -0.898726 
vn -0.236393 0.373765 -0.896893 
vn -0.205051 0.397242 -0.894513 
vn -0.189231 0.407572 -0.893351 
vn -0.147988 0.430497 -0.890377 
vn -0.199724 0.400826 -0.894119 
vn -0.140278 0.434183 -0.889835 
vn -0.104494 0.449034 -0.887384 
vn -0.136699 0.435832 -0.889586 
vn -0.0967636 0.451779 -0.886866 
vn -0.0714596 0.459686 -0.885202 
vn -0.0515188 0.464788 -0.883922 
vn -0.00502371 0.473024 -0.881035 
vn -0.0675878 0.460752 -0.884952 
vn 0.000927214 0.47372 -0.880675 
vn 0.0426358 0.476365 -0.878213 
vn 0.00648568 0.474297 -0.880341 
vn 0.0505563 0.47643 -0.877758 
vn 0.0749954 0.475757 -0.876374 
vn 0.0981205 0.473893 -0.875099 
vn 0.145319 0.466329 -0.872594 
vn 0.0826263 0.475273 -0.87595 
vn 0.148822 0.465561 -0.872413 
vn 0.192011 0.453646 -0.870251 
vn 0.157639 0.463499 -0.871962 
vn 0.199263 0.451185 -0.8699 
vn 0.220323 0.443251 -0.8689 
vn 0.243919 0.432893 -0.867817 
vn 0.285345 0.410657 -0.86599 
vn 0.228465 0.439856 -0.868522 
vn 0.286378 0.410032 -0.865945 
vn 0.291583 0.406822 -0.865722 
vn 0.323598 0.384825 -0.864404 
vn 0.329624 0.380214 -0.864168 
vn 0.344358 0.368244 -0.863605 
vn 0.364488 0.35012 -0.862881 
vn 0.34862 0.364584 -0.863448 
vn 0.39549 0.317409 -0.861881 
vn 0.397249 0.315482 -0.86178 
vn 0.39988 0.312213 -0.861753 
vn 0.398759 0.313691 -0.861736 
vn 0.39629 0.316473 -0.861858 
vn 0.424888 0.279225 -0.861106 
vn 0.426538 0.276954 -0.861024 
vn 0.42901 0.273137 -0.861015 
vn 0.438237 0.258689 -0.86083 
vn 0.442077 0.252441 -0.860721 
vn 0.442795 0.251078 -0.860751 
vn 0.452973 0.232755 -0.860605 
vn 0.452634 0.233541 -0.86057 
vn 0.471399 0.193226 -0.860492 
vn 0.47305 0.189282 -0.860463 
vn 0.475293 0.183381 -0.860504 
vn 0.474915 0.184517 -0.86047 
vn 0.472762 0.189854 -0.860495 
vn 0.488199 0.144457 -0.860694 
vn 0.488518 0.143482 -0.860676 
vn 0.489999 0.137894 -0.860747 
vn 0.493768 0.122699 -0.860894 
vn 0.495974 0.112754 -0.860986 
vn 0.496112 0.111902 -0.861017 
vn 0.499889 0.0909472 -0.861301 
vn 0.499594 0.0930151 -0.861252 
vn 0.504487 0.048696 -0.862045 
vn 0.504779 0.0441779 -0.862118 
vn 0.504802 0.043268 -0.86215 
vn 0.504957 0.0400997 -0.862213 
vn 0.504955 0.040681 -0.862187 
vn 0.504875 -0.00283075 -0.863188 
vn 0.504898 -0.00276649 -0.863175 
vn 0.503488 -0.0224365 -0.863711 
vn 0.502799 -0.0294572 -0.863901 
vn 0.502743 -0.0298235 -0.863921 
vn 0.502153 -0.0349619 -0.864072 
vn 0.490678 -0.0954173 -0.866101 
vn 0.50024 -0.0490831 -0.864494 
vn 0.494294 -0.0805229 -0.865557 
vn 0.489091 -0.101308 -0.866329 
vn 0.489123 -0.101212 -0.866323 
vn 0.49122 -0.0933029 -0.866024 
vn 0.481658 -0.125607 -0.867311 
vn 0.294196 -0.364223 -0.883624 
vn 0.313964 -0.350957 -0.882188 
vn 0.565807 -0.746568 0.349999 
vn 0.559551 -0.705622 0.43474 
vn 0.551991 -0.711537 0.434766 
vn 0.67938 -0.646753 0.346632 
vn 0.629583 -0.64154 0.438236 
vn 0.651968 -0.617251 0.440385 
vn 0.436297 -0.827422 0.353578 
vn 0.475686 -0.766589 0.431352 
vn 0.434351 -0.791148 0.430609 
vn 0.545845 -0.716281 0.434736 
vn 0.293841 -0.88657 0.357284 
vn 0.390475 -0.815052 0.428042 
vn 0.422963 -0.797562 0.430113 
vn 0.300515 -0.854094 0.424516 
vn 0.141978 -0.921688 0.361018 
vn 0.199699 -0.885024 0.420539 
vn 0.151833 -0.894968 0.419499 
vn 0.286665 -0.858883 0.424433 
vn -0.0152506 -0.931012 0.36467 
vn 0.000549797 -0.910908 0.41261 
vn -0.0048521 -0.910916 0.412564 
vn 0.10085 -0.903472 0.416615 
vn 0.139743 -0.897178 0.418979 
vn -0.173378 -0.913468 0.368124 
vn -0.112424 -0.906005 0.408064 
vn -0.163271 -0.898783 0.406856 
vn -0.100846 -0.907156 0.408532 
vn -0.0137102 -0.910878 0.412447 
vn -0.327637 -0.868803 0.371261 
vn -0.214165 -0.889368 0.403928 
vn -0.313309 -0.861371 0.399847 
vn -0.169542 -0.897742 0.406589 
vn -0.473121 -0.797689 0.373965 
vn -0.419927 -0.816906 0.39538 
vn -0.457775 -0.796773 0.394454 
vn -0.409371 -0.822032 0.395827 
vn -0.322908 -0.857866 0.399746 
vn -0.604863 -0.701654 0.376593 
vn -0.512121 -0.764716 0.391078 
vn -0.590296 -0.708395 0.386946 
vn -0.468623 -0.79068 0.393977 
vn -0.597632 -0.702597 0.386255 
vn -0.602205 -0.698743 0.386145 
vn -0.682823 -0.623725 0.38042 
vn -0.709403 -0.594209 0.37903 
vn -0.717372 -0.584957 0.378422 
vn 0.688197 0.707677 0.15993 
vn 0.668769 0.719834 0.185977 
vn 0.675287 0.713853 0.185478 
vn 0.569924 0.805807 0.160817 
vn 0.592961 0.78211 0.191575 
vn 0.680143 0.709328 0.185089 
vn 0.566673 0.800848 0.193711 
vn 0.789411 0.592811 0.159389 
vn 0.748566 0.638322 0.179427 
vn 0.779625 0.600721 0.176971 
vn 0.685229 0.704498 0.184779 
vn 0.871414 0.463975 0.159261 
vn 0.86142 0.479177 0.168358 
vn 0.865947 0.471127 0.167855 
vn 0.808972 0.561553 0.173849 
vn 0.869441 0.464795 0.167445 
vn 0.787155 0.591036 0.176249 
vn 0.870232 0.463337 0.167375 
vn 0.93262 0.324369 0.15813 
vn 0.930515 0.32958 0.159748 
vn 0.932479 0.324134 0.159438 
vn 0.912248 0.376208 0.162084 
vn -0.979045 0.202174 -0.0244388 
vn -0.999312 0.027798 -0.0245438 
vn -0.995263 0.0972016 -0.00188916 
vn -0.997072 0.0764583 -0.00097647 
vn -0.999614 0.0277571 0.00104613 
vn -0.982092 0.188301 -0.00609511 
vn -0.97793 0.208818 -0.00697024 
vn -0.948541 0.316421 -0.0121519 
vn -0.929028 0.369194 -0.0245386 
vn -0.979319 0.202212 -0.00669157 
vn -0.934221 0.356408 -0.0142844 
vn -0.85154 0.523716 -0.0245127 
vn -0.856921 0.51495 -0.0226465 
vn -0.929216 0.369235 -0.0149439 
vn -0.907547 0.41959 -0.0174059 
vn -0.89868 0.43822 -0.0183874 
vn -0.851571 0.52373 -0.0230988 
vn -0.844413 0.53517 -0.023676 
vn -0.840588 0.541141 -0.0240481 
vn 0.805853 -0.554044 -0.208894 
vn 0.83546 -0.524657 -0.163525 
vn 0.826163 -0.538892 -0.164473 
vn 0.883546 -0.420051 -0.207132 
vn 0.885255 -0.437461 -0.157961 
vn 0.891611 -0.424565 -0.157399 
vn 0.815166 -0.554974 -0.165857 
vn 0.707011 -0.675029 -0.210883 
vn 0.765447 -0.620593 -0.170164 
vn 0.812259 -0.559119 -0.166194 
vn 0.714041 -0.677928 -0.174811 
vn 0.588923 -0.779599 -0.213062 
vn 0.62023 -0.763148 -0.181436 
vn 0.606785 -0.773664 -0.182361 
vn 0.696777 -0.695406 -0.175821 
vn 0.711726 -0.680319 -0.174962 
vn 0.596592 -0.781339 -0.183269 
vn 0.454071 -0.86454 -0.215383 
vn 0.521516 -0.832295 -0.187898 
vn 0.592153 -0.784621 -0.183643 
vn 0.465834 -0.863806 -0.191932 
vn 0.305524 -0.926943 -0.21779 
vn 0.334437 -0.921041 -0.199588 
vn 0.316992 -0.926957 -0.200667 
vn 0.430677 -0.881496 -0.193603 
vn 0.455925 -0.868958 -0.192469 
vn 0.146938 -0.964319 -0.220221 
vn 0.21479 -0.954482 -0.206955 
vn 0.156946 -0.964788 -0.211073 
vn 0.306371 -0.930331 -0.201545 
vn -0.0174838 -0.974752 -0.222603 
vn -0.0112807 -0.975263 -0.220761 
vn -0.0175129 -0.975085 -0.22114 
vn 0.147066 -0.966222 -0.211629 
vn 0.110463 -0.970718 -0.213318 
vn 0.00435273 -0.97555 -0.219735 
vn -0.0368894 -0.9743 -0.222214 
vn -0.0512498 -0.973453 -0.223075 
vn 0.925709 -0.346118 -0.15253 
vn 0.916038 -0.343974 -0.206291 
vn 0.934143 -0.293408 -0.203195 
vn 0.895304 -0.41686 -0.157029 
vn 0.948349 -0.27995 -0.149206 
vn 0.939478 -0.276793 -0.20191 
vn 0.973105 -0.127588 -0.191804 
vn 0.981543 -0.12909 -0.141097 
vn 0.980574 -0.136023 -0.141324 
vn 0.968978 -0.154111 -0.193214 
vn 0.970754 -0.143229 -0.192673 
vn 0.961348 -0.233251 -0.146303 
vn 0.947444 -0.250038 -0.199575 
vn 0.956786 -0.250764 -0.147237 
vn 0.951644 -0.268928 -0.148497 
vn 0.978222 -0.0858543 -0.188973 
vn 0.982953 0.00614373 -0.183756 
vn 0.989906 -0.037685 -0.136626 
vn 0.990647 0.0246075 -0.13421 
vn 0.983067 -0.117426 -0.14068 
vn 0.982985 0.0129486 -0.18323 
vn 0.96876 0.176293 -0.174429 
vn 0.975917 0.177424 -0.126914 
vn 0.976051 0.176665 -0.126938 
vn 0.988191 0.0787994 -0.131412 
vn 0.977802 0.110937 -0.177752 
vn 0.972305 0.154046 -0.175762 
vn 0.989306 0.0616652 -0.132179 
vn 0.982844 0.0246216 -0.182788 
vn 0.990485 0.0320402 -0.133838 
vn 0.954287 0.272687 -0.122383 
vn 0.975274 0.181008 -0.126798 
vn 0.959975 0.221532 -0.171381 
vn 0.938249 0.303105 -0.16678 
vn 0.937706 0.325999 -0.120137 
vn 0.962881 0.20788 -0.172178 
vn 0.933918 0.316754 -0.165725 
vn 0.877062 0.466973 -0.112684 
vn 0.916433 0.382718 -0.116948 
vn 0.898757 0.408157 -0.160136 
vn 0.880118 0.44765 -0.158119 
vn 0.922831 0.366766 -0.117751 
vn 0.931531 0.323857 -0.165427 
vn 0.936299 0.330095 -0.119923 
vn 0.823933 0.556335 -0.107819 
vn 0.874511 0.471811 -0.112357 
vn 0.846894 0.509045 -0.153762 
vn 0.799313 0.582103 -0.149179 
vn 0.795151 0.597091 -0.105906 
vn 0.871751 0.464096 -0.157054 
vn 0.854619 0.495701 -0.154618 
vn 0.792439 0.591634 -0.148355 
vn 0.693747 0.713393 -0.0989251 
vn 0.752794 0.650222 -0.102527 
vn 0.730365 0.667883 -0.143175 
vn 0.698831 0.701195 -0.141281 
vn 0.790894 0.593722 -0.148261 
vn 0.764615 0.636148 -0.103339 
vn 0.788602 0.605804 -0.105398 
vn 0.60979 0.786951 -0.094155 
vn 0.684796 0.722081 -0.0982472 
vn 0.648591 0.748627 -0.137432 
vn 0.583173 0.801266 -0.133727 
vn 0.574941 0.812919 -0.0927665 
vn 0.690373 0.709646 -0.14067 
vn 0.660768 0.737753 -0.138224 
vn 0.441204 0.893221 -0.0865746 
vn 0.512437 0.85404 -0.0895781 
vn 0.486531 0.864176 -0.128401 
vn 0.455787 0.880958 -0.127166 
vn 0.570349 0.810601 -0.132772 
vn 0.527711 0.844615 -0.0902585 
vn 0.5669 0.818589 -0.0923882 
vn 0.572484 0.809067 -0.132935 
vn 0.295527 0.951961 -0.0802152 
vn 0.331281 0.940001 -0.0815464 
vn 0.312648 0.942268 -0.119924 
vn 0.424211 0.901503 -0.0856583 
vn 0.382602 0.91567 -0.123143 
vn 0.439572 0.889273 -0.126375 
vn 0.397241 0.909315 -0.123879 
vn 0.437039 0.895288 -0.0863567 
vn 0.140994 0.987288 -0.0733635 
vn 0.215881 0.973421 -0.0764609 
vn 0.189421 0.975307 -0.113561 
vn 0.156866 0.981217 -0.112276 
vn 0.287405 0.950464 -0.118392 
vn 0.233659 0.969246 -0.0772429 
vn 0.291623 0.953178 -0.0800523 
vn 0.294623 0.948194 -0.118849 
vn 0.0134417 0.997623 -0.0675878 
vn 0.115564 0.990683 -0.0720566 
vn 0.0718348 0.99157 -0.10784 
vn -0.0062832 0.994522 -0.104339 
vn -0.0186345 0.997619 -0.0664036 
vn 0.140812 0.983734 -0.111535 
vn 0.0887851 0.990106 -0.108659 
vn 0.134291 0.988247 -0.0730312 
vn -0.179625 0.981941 -0.0593912 
vn -0.109595 0.992027 -0.0622232 
vn -0.134144 0.986103 -0.0980088 
vn -0.170144 0.980671 -0.0966232 
vn -0.0313702 0.994199 -0.102884 
vn -0.0903362 0.993913 -0.0630615 
vn -0.029209 0.997394 -0.0659707 
vn -0.0183302 0.994444 -0.10366 
vn -0.313088 0.948222 -0.0533994 
vn -0.212152 0.975528 -0.0577681 
vn -0.253925 0.9628 -0.0924021 
vn -0.328254 0.940366 -0.0892271 
vn -0.337576 0.939832 -0.0525214 
vn -0.178799 0.979167 -0.0962412 
vn -0.236261 0.967207 -0.0932238 
vn -0.192547 0.979526 -0.0587697 
vn -0.488265 0.871485 -0.0459456 
vn -0.429765 0.901644 -0.0483718 
vn -0.451212 0.888517 -0.083345 
vn -0.474863 0.876191 -0.0824266 
vn -0.354561 0.930906 -0.0877557 
vn -0.412075 0.909824 -0.0491323 
vn -0.349029 0.935664 -0.0520712 
vn -0.336513 0.937484 -0.088785 
vn -0.627042 0.778016 -0.0388437 
vn -0.611496 0.790256 -0.039609 
vn -0.612959 0.786525 -0.0752291 
vn -0.523291 0.85101 -0.0441403 
vn -0.558891 0.825565 -0.0779965 
vn -0.486901 0.86961 -0.0818965 
vn -0.543624 0.835621 -0.0788037 
vn -0.493973 0.868277 -0.0456699 
vn -0.749597 0.661156 -0.0312437 
vn -0.708082 0.705317 -0.0338765 
vn -0.724068 0.686373 -0.0679534 
vn -0.738717 0.67067 -0.0670722 
vn -0.645295 0.76043 -0.0730735 
vn -0.693877 0.719253 -0.0347801 
vn -0.630426 0.775285 -0.0386686 
vn -0.625656 0.77654 -0.0744296 
vn -0.845114 0.531371 -0.0585376 
vn -0.780695 0.624247 -0.0288448 
vn -0.806267 0.588324 -0.0617171 
vn -0.748167 0.660175 -0.0664481 
vn -0.794841 0.603575 -0.0626537 
vn -0.753781 0.656397 -0.0309436 
vn -0.916384 0.397066 -0.0507827 
vn -0.926021 0.374184 -0.0497191 
vn -0.86669 0.495667 -0.0562469 
vn -0.850317 0.523062 -0.0580235 
vn -0.960814 0.273619 -0.0443734 
vn -0.977638 0.206206 -0.0412638 
vn -0.928132 0.368949 -0.0494649 
vn -0.95506 0.292925 -0.0453469 
vn -0.985725 0.16378 -0.0390224 
vn -0.998059 0.0522406 -0.0338971 
vn -0.99881 0.0356951 -0.0332412 
vn -0.999071 0.0278092 -0.0329177 
vn -0.978508 0.202081 -0.0410552 
vn -0.997754 -0.0604696 -0.0288297 
vn -0.996352 -0.0806484 -0.0278915 
vn -0.990337 -0.136343 -0.0253788 
vn -0.988726 -0.147662 -0.0248271 
vn -0.988879 -0.148451 0.0090151 
vn -0.99934 -0.0361177 0.0039015 
vn -0.988616 -0.148406 -0.0247904 
vn -0.999829 0.0184255 0.00144937 
vn -0.947095 -0.32048 0.0174273 
vn -0.952788 -0.303168 -0.0168481 
vn -0.950606 -0.309961 -0.0165181 
vn -0.98084 -0.193515 -0.0224531 
vn -0.96548 -0.260078 0.0144059 
vn -0.959806 -0.28024 0.0154141 
vn -0.988117 -0.153426 0.00924143 
vn -0.98887 -0.148506 0.00901775 
vn -0.875472 -0.482558 0.026182 
vn -0.92187 -0.386933 0.0209387 
vn -0.903927 -0.427568 -0.0100688 
vn -0.879065 -0.476644 -0.00736817 
vn -0.947122 -0.320474 -0.0159971 
vn -0.91245 -0.409038 -0.0111093 
vn -0.945194 -0.326028 0.0177116 
vn -0.776532 -0.629111 0.0348884 
vn -0.784396 -0.620258 0.00151425 
vn -0.778373 -0.627799 0.00196959 
vn -0.810714 -0.584558 0.0321541 
vn -0.872119 -0.488575 0.0265284 
vn -0.84937 -0.527782 -0.00423265 
vn -0.798329 -0.601306 0.033176 
vn -0.875751 -0.482712 -0.00701353 
vn -0.653727 -0.75549 0.0433176 
vn -0.72535 -0.687294 0.0386489 
vn -0.694766 -0.71919 0.00816074 
vn -0.776995 -0.629504 0.00207375 
vn -0.709536 -0.704633 0.00714348 
vn -0.768038 -0.639417 0.035537 
vn -0.511609 -0.857694 0.0511639 
vn -0.516534 -0.856062 0.0187067 
vn -0.513381 -0.857954 0.0188612 
vn -0.552994 -0.831741 0.0490416 
vn -0.643432 -0.764241 0.0439468 
vn -0.60897 -0.793077 0.0135935 
vn -0.535795 -0.84287 0.0499366 
vn -0.653992 -0.756425 0.0107457 
vn -0.654316 -0.756145 0.0107252 
vn -0.51217 -0.858676 0.0189206 
vn -0.41808 -0.908105 0.0235403 
vn -0.438504 -0.897067 0.054635 
vn -0.501392 -0.863676 0.0516705 
vn -0.354995 -0.933033 0.0585525 
vn -0.399474 -0.916419 0.0244326 
vn -0.361782 -0.931893 0.0262389 
vn -0.355525 -0.93429 0.0265386 
vn -0.336405 -0.939845 0.0593643 
vn -0.349425 -0.935118 0.0587981 
vn -0.229985 -0.971069 0.0642832 
vn -0.294914 -0.955071 0.0294309 
vn -0.196466 -0.979917 0.0341154 
vn -0.210286 -0.975464 0.0651928 
vn -0.189386 -0.979668 0.0662146 
vn -0.189679 -0.981242 0.0344352 
vn -0.188252 -0.981514 0.0345024 
vn -0.0800171 -0.996006 0.0396224 
vn -0.102399 -0.992265 0.0701714 
vn -0.184219 -0.980635 0.066463 
vn -0.0600383 -0.997371 0.0405647 
vn -0.0199241 -0.997056 0.0740461 
vn -0.0235546 -0.998827 0.0422997 
vn -0.0200499 -0.998897 0.0424656 
vn 0.00587266 -0.997154 0.0751637 
vn -0.0118994 -0.997158 0.0743987 
vn 0.114113 -0.990229 0.0801521 
vn 0.0490846 -0.997749 0.0456966 
vn 0.148281 -0.987663 0.0503471 
vn 0.147989 -0.985603 0.0817638 
vn 0.133331 -0.987753 0.0810376 
vn 0.149368 -0.987497 0.0503969 
vn 0.155949 -0.986463 0.050698 
vn 0.260252 -0.963941 0.0555564 
vn 0.23807 -0.967445 0.0858633 
vn 0.15964 -0.983736 0.0823299 
vn 0.279168 -0.958582 0.0564351 
vn 0.309775 -0.946611 0.0892612 
vn 0.310371 -0.94885 0.0579131 
vn 0.314546 -0.947462 0.0581089 
vn 0.339243 -0.936333 0.0905238 
vn 0.323174 -0.942065 0.0898456 
vn 0.436591 -0.89463 0.0950066 
vn 0.379672 -0.923102 0.0610906 
vn 0.462089 -0.884455 0.0649111 
vn 0.460966 -0.882192 0.0961653 
vn 0.453275 -0.88621 0.0957746 
vn 0.472284 -0.876123 0.0967286 
vn 0.465726 -0.882533 0.0650734 
vn 0.474377 -0.877885 0.0654567 
vn 0.563214 -0.82338 0.0695347 
vn 0.543229 -0.833618 0.0999134 
vn 0.578915 -0.812354 0.0702711 
vn 0.59802 -0.794876 0.102687 
vn 0.598861 -0.797671 0.0713193 
vn 0.59954 -0.797158 0.0713546 
vn 0.626529 -0.772434 0.103956 
vn 0.603662 -0.790566 0.102949 
vn 0.703063 -0.702841 0.108243 
vn 0.660247 -0.747355 0.0743984 
vn 0.719764 -0.689835 0.07789 
vn 0.717702 -0.687741 0.10916 
vn 0.715939 -0.689597 0.109031 
vn 0.717971 -0.691713 0.0777887 
vn 0.7333 -0.675342 0.0786458 
vn 0.798175 -0.59668 0.0829994 
vn 0.782358 -0.612405 0.113476 
vn 0.72105 -0.684191 0.109404 
vn 0.817534 -0.564003 0.116359 
vn 0.809328 -0.581346 0.0838194 
vn 0.819929 -0.566164 0.0847008 
vn 0.820073 -0.565953 0.0847127 
vn 0.864202 -0.495341 0.0882708 
vn 0.840142 -0.529367 0.118032 
vn 0.821266 -0.558494 0.116646 
vn 0.88925 -0.44066 0.122689 
vn 0.898699 -0.428881 0.0916622 
vn 0.895646 -0.427313 0.123377 
vn 0.900363 -0.42534 0.0918229 
vn 0.896839 -0.424766 0.123504 
vn 0.909418 -0.405424 0.0926905 
vn 0.945164 -0.311835 0.0970723 
vn 0.934491 -0.332122 0.128142 
vn 0.899895 -0.418137 0.1239 
vn 0.950677 -0.281238 0.130836 
vn 0.950678 -0.294336 0.097869 
vn 0.954219 -0.282437 0.0984697 
vn 0.956308 -0.275151 0.0988274 
vn 0.962484 -0.23665 0.132742 
vn 0.954227 -0.268663 0.131416 
vn 0.980804 -0.138469 0.137297 
vn 0.97508 -0.196919 0.102183 
vn 0.985909 -0.130096 0.105159 
vn 0.981971 -0.12949 0.137711 
vn 0.986958 -0.121599 0.105491 
vn 0.982913 -0.121752 0.138055 
vn 0.989418 -0.0987196 0.106335 
vn 0.993896 0.000138404 0.110323 
vn 0.989532 -0.0232555 0.142425 
vn 0.983526 -0.116351 0.138347 
vn 0.98917 0.0243385 0.144745 
vn 0.99365 0.0182353 0.111032 
vn 0.993486 0.0243523 0.111321 
vn 0.993329 0.0292247 0.111547 
vn 0.986416 0.117268 0.115027 
vn 0.986334 0.075012 0.146689 
vn 0.988857 0.0331713 0.145124 
vn 0.973245 0.172957 0.151261 
vn 0.977042 0.177499 0.117824 
vn 0.972539 0.176722 0.151451 
vn 0.976747 0.179074 0.11789 
vn 0.969987 0.189727 0.152084 
vn 0.971579 0.181718 0.151699 
vn 0.969506 0.214099 0.119244 
vn 0.943094 0.308671 0.123675 
vn 0.945745 0.284481 0.156963 
vn 0.932978 0.322734 0.159358 
vn 0.937211 0.325778 0.124512 
vn 0.937108 0.326071 0.124526 
vn 0.899457 0.417475 0.129192 
vn 0.853273 0.503968 0.133941 
vn 0.871791 0.471661 0.132352 
vn 0.798687 0.585527 0.138768 
vn 0.874941 0.465878 0.132043 
vn 0.785347 0.603041 0.139898 
vn 0.723626 0.674887 0.144541 
vn 0.791807 0.594665 0.139341 
vn 0.787998 0.599632 0.139643 
vn 0.652505 0.742915 0.14938 
vn 0.574737 0.803687 0.154158 
vn 0.680345 0.717837 0.147785 
vn 0.68955 0.709126 0.147176 
vn 0.570484 0.806663 0.154413 
vn 0.560125 0.813777 0.155005 
vn 0.474906 0.865412 0.159771 
vn 0.440794 0.88287 0.16199 
vn 0.511152 0.836586 0.197096 
vn 0.557504 0.807099 0.194373 
vn 0.43402 0.877879 0.202371 
vn 0.437088 0.884671 0.162208 
vn 0.43152 0.887342 0.162528 
vn 0.428607 0.880472 0.202644 
vn 0.42338 0.882939 0.202897 
vn 0.316309 0.9251 0.210094 
vn 0.40855 0.889673 0.203886 
vn 0.385307 0.907954 0.164796 
vn 0.292298 0.941082 0.170076 
vn 0.290254 0.933122 0.212217 
vn 0.27361 0.946495 0.171129 
vn 0.175116 0.968549 0.176771 
vn 0.220587 0.951005 0.216635 
vn 0.284983 0.934655 0.212615 
vn 0.286288 0.942867 0.170416 
vn 0.291444 0.941341 0.170113 
vn 0.138578 0.965016 0.222578 
vn 0.139433 0.973891 0.179149 
vn 0.129905 0.975102 0.179725 
vn 0.130519 0.966034 0.22303 
vn 0.121467 0.967103 0.22351 
vn 0.00540953 0.972775 0.231689 
vn 0.105568 0.968711 0.224622 
vn 0.0751774 0.980319 0.182548 
vn -0.0179316 0.981989 0.188084 
vn -0.0171585 0.972176 0.233621 
vn -0.0438909 0.980899 0.189501 
vn -0.145982 0.969773 0.195523 
vn -0.0951136 0.966378 0.238887 
vn -0.0289586 0.97167 0.234559 
vn -0.0318772 0.981497 0.188806 
vn -0.0260324 0.981737 0.188453 
vn -0.173254 0.953944 0.244897 
vn -0.175742 0.964401 0.197599 
vn -0.192499 0.960978 0.198658 
vn -0.187222 0.951086 0.245731 
vn -0.195782 0.949238 0.246204 
vn -0.307622 0.91685 0.254469 
vn -0.209799 0.945971 0.247232 
vn -0.246157 0.948055 0.201491 
vn -0.330073 0.92104 0.206728 
vn -0.325403 0.910235 0.256095 
vn -0.344166 0.915718 0.20739 
vn -0.33776 0.905424 0.257149 
vn -0.360902 0.90902 0.208404 
vn -0.455359 0.86416 0.214187 
vn -0.40234 0.877322 0.261588 
vn -0.469585 0.841463 0.267263 
vn -0.476441 0.852297 0.215857 
vn -0.486594 0.84635 0.216604 
vn -0.476313 0.83753 0.267711 
vn -0.493415 0.827235 0.268747 
vn -0.59055 0.75785 0.277334 
vn -0.506695 0.818802 0.269857 
vn -0.544301 0.809504 0.220089 
vn -0.61066 0.759184 0.225244 
vn -0.601291 0.748873 0.278638 
vn -0.605644 0.745166 0.279147 
vn -0.627388 0.745122 0.226226 
vn -0.64178 0.732411 0.227361 
vn -0.618718 0.752484 0.225734 
vn -0.717003 0.656717 0.233728 
vn -0.716278 0.634223 0.291043 
vn -0.667657 0.687728 0.285068 
vn -0.728231 0.643777 0.235013 
vn -0.736759 0.633656 0.235938 
vn -0.721212 0.628376 0.291543 
vn -0.737515 0.608441 0.293038 
vn -0.783318 0.573374 0.240115 
vn -0.747116 0.596028 0.294227 
vn -0.806228 0.508588 0.302217 
vn -0.825275 0.50877 0.245102 
vn -0.810765 0.500795 0.30309 
vn -0.816408 0.490893 0.304141 
vn -0.8404 0.482668 0.246494 
vn -0.849147 0.466537 0.247575 
vn -0.8343 0.493402 0.245963 
vn -0.894569 0.367818 0.253883 
vn -0.881134 0.352005 0.315746 
vn -0.855468 0.414697 0.310163 
vn -0.898293 0.358083 0.25465 
vn -0.905766 0.337618 0.256129 
vn -0.886182 0.338228 0.316674 
vn -0.894358 0.314619 0.318023 
vn -0.924139 0.198482 0.326454 
vn -0.898241 0.302385 0.318945 
vn -0.928557 0.264971 0.259946 
vn -0.94436 0.195897 0.264214 
vn -0.925191 0.192602 0.326997 
vn -0.92769 0.177826 0.328283 
vn -0.950933 0.158467 0.265734 
vn -0.953494 0.140497 0.266663 
vn -0.948448 0.173557 0.265187 
vn -0.961784 0.0309918 0.272049 
vn -0.940638 0.0273128 0.33831 
vn -0.938217 0.092044 0.333581 
vn -0.961824 0.027426 0.27229 
vn -0.961844 0.00906643 0.27345 
vn -0.940679 0.0169871 0.338872 
vn -0.940167 -0.0163207 0.340323 
vn -0.93948 -0.0308007 0.341217 
vn -0.927401 -0.137503 0.34788 
vn -0.957636 -0.0781102 0.277187 
vn -0.9492 -0.142039 0.280791 
vn -0.927232 -0.138428 0.347964 
vn -0.926078 -0.144625 0.348516 
vn -0.94106 -0.186265 0.282332 
vn -0.93687 -0.205072 0.283232 
vn -0.946639 -0.157118 0.281406 
vn -0.907074 -0.306828 0.288223 
vn -0.884165 -0.298964 0.358989 
vn -0.903149 -0.242112 0.354548 
vn -0.905648 -0.310913 0.28833 
vn -0.881717 -0.305636 0.359391 
vn -0.901247 -0.322721 0.289145 
vn -0.866715 -0.344018 0.361188 
vn -0.862879 -0.411647 0.293236 
vn -0.860894 -0.357439 0.362075 
vn -0.814006 -0.449138 0.368333 
vn -0.836344 -0.461247 0.296277 
vn -0.808686 -0.458119 0.368991 
vn -0.80895 -0.506794 0.297927 
vn -0.799093 -0.521772 0.298671 
vn -0.825689 -0.479565 0.297079 
vn -0.811878 -0.452862 0.368469 
vn -0.752424 -0.541791 0.374594 
vn -0.740072 -0.600481 0.302846 
vn -0.71855 -0.583572 0.378325 
vn -0.723597 -0.61974 0.303856 
vn -0.657586 -0.687961 0.307069 
vn -0.732686 -0.609365 0.303061 
vn -0.560661 -0.767337 0.311212 
vn -0.57437 -0.757347 0.310683 
vn -0.600433 -0.737084 0.310141 
vn -0.62145 -0.719804 0.309325 
vn -0.463868 -0.828152 0.314628 
vn -0.373167 -0.871905 0.317061 
vn -0.484983 -0.816137 0.314184 
vn -0.469191 -0.825261 0.314332 
vn -0.255998 -0.912098 0.320223 
vn -0.273079 -0.90729 0.31977 
vn -0.316916 -0.893108 0.319252 
vn -0.335302 -0.886558 0.318728 
vn -0.152162 -0.934113 0.322922 
vn -0.0481098 -0.944303 0.325541 
vn -0.15797 -0.933151 0.322916 
vn -0.177337 -0.929714 0.322774 
vn 0.0718509 -0.941781 0.328461 
vn 0.0557252 -0.943007 0.328075 
vn 0.00666083 -0.944808 0.327556 
vn -0.0163267 -0.94492 0.326894 
vn 0.174555 -0.927389 0.330877 
vn 0.169551 -0.928313 0.330889 
vn 0.273521 -0.902336 0.333131 
vn 0.143002 -0.93283 0.330725 
vn 0.381996 -0.861111 0.335511 
vn 0.368554 -0.867061 0.335222 
vn 0.323593 -0.884942 0.334912 
vn 0.295967 -0.89486 0.334111 
vn 0.471635 -0.814692 0.337397 
vn 0.554508 -0.75996 0.33909 
vn 0.463317 -0.819426 0.337458 
vn 0.438744 -0.832887 0.337347 
vn 0.641897 -0.686672 0.341247 
vn 0.680258 -0.647703 0.343118 
vn 0.585796 -0.735463 0.340495 
vn 0.630598 -0.697215 0.340935 
vn 0.567854 -0.749722 0.339793 
vn 0.694994 -0.631721 0.343383 
vn 0.709722 -0.615135 0.343371 
vn 0.742705 -0.573714 0.345313 
vn 0.692325 -0.570273 0.442125 
vn 0.655835 -0.612932 0.440675 
vn 0.739484 -0.503849 0.44643 
vn 0.768797 -0.538016 0.345673 
vn 0.773815 -0.530469 0.346141 
vn 0.786863 -0.51023 0.347148 
vn 0.750481 -0.487093 0.446675 
vn 0.743546 -0.497721 0.446557 
vn 0.819263 -0.455636 0.348144 
vn 0.794933 -0.405645 0.451146 
vn 0.846375 -0.400988 0.350511 
vn 0.806485 -0.379533 0.453361 
vn 0.825952 -0.443099 0.34852 
vn 0.857731 -0.37557 0.351063 
vn 0.810581 -0.369917 0.454004 
vn 0.86631 -0.355234 0.351164 
vn 0.830593 -0.319834 0.455874 
vn 0.896995 -0.264884 0.353887 
vn 0.852385 -0.247771 0.460488 
vn 0.897451 -0.263199 0.353989 
vn 0.905072 -0.233406 0.355481 
vn 0.857406 -0.228976 0.460896 
vn 0.855757 -0.235259 0.460796 
vn 0.918211 -0.172242 0.356681 
vn 0.873814 -0.139363 0.465861 
vn 0.925575 -0.120258 0.358956 
vn 0.876509 -0.112128 0.468145 
vn 0.920304 -0.159853 0.357055 
vn 0.928756 -0.0894909 0.359728 
vn 0.877617 -0.0991158 0.469004 
vn 0.880858 -0.048291 0.470912 
vn 0.930695 -0.0653939 0.359904 
vn 0.931579 0.0242536 0.362728 
vn 0.879319 0.0242381 0.475616 
vn 0.931459 0.0284537 0.362732 
vn 0.930015 0.050849 0.363986 
vn 0.878257 0.0447805 0.476087 
vn 0.878887 0.0332586 0.47587 
vn 0.922725 0.12159 0.365779 
vn 0.866289 0.133017 0.481508 
vn 0.92068 0.134937 0.366252 
vn 0.914653 0.166978 0.368141 
vn 0.860692 0.15795 0.484005 
vn 0.84496 0.21976 0.487594 
vn 0.859377 0.163546 0.484484 
vn 0.909607 0.190757 0.369089 
vn 0.901005 0.226843 0.369772 
vn 0.876137 0.304811 0.373463 
vn 0.832525 0.257516 0.490497 
vn 0.821286 0.285914 0.493703 
vn 0.766081 0.406997 0.497468 
vn 0.834808 0.400481 0.37777 
vn 0.828979 0.411867 0.378364 
vn 0.798661 0.338829 0.497328 
vn 0.866872 0.328886 0.374656 
vn 0.816601 0.434295 0.380198 
vn 0.872325 0.315374 0.373615 
vn 0.818881 0.291792 0.494259 
vn 0.694511 0.519037 0.498253 
vn 0.78153 0.492577 0.382857 
vn 0.801807 0.459757 0.381745 
vn 0.606164 0.618748 0.499717 
vn 0.664124 0.63637 0.392394 
vn 0.656328 0.644053 0.392975 
vn 0.717213 0.578382 0.388689 
vn 0.737922 0.552841 0.387089 
vn 0.726534 0.567419 0.387536 
vn 0.502973 0.70369 0.501836 
vn 0.586032 0.705807 0.398 
vn 0.616247 0.680373 0.39665 
vn 0.641895 0.657491 0.394558 
vn 0.387207 0.771669 0.504577 
vn 0.429412 0.805558 0.408267 
vn 0.418613 0.810868 0.40897 
vn 0.504131 0.763468 0.403694 
vn 0.53064 0.74602 0.402337 
vn 0.51034 0.75967 0.403058 
vn 0.381068 0.827536 0.412276 
vn 0.331956 0.847254 0.414688 
vn 0.261462 0.820782 0.507893 
vn 0.406842 0.816248 0.410145 
vn 0.128636 0.849466 0.511723 
vn 0.150103 0.891662 0.427092 
vn 0.138294 0.893176 0.427915 
vn 0.242399 0.874201 0.420731 
vn 0.27292 0.865795 0.419421 
vn 0.100271 0.896556 0.431431 
vn 0.0434614 0.899572 0.434604 
vn -0.00809323 0.856554 0.515993 
vn 0.132417 0.893771 0.428532 
vn -0.145306 0.841338 0.520612 
vn -0.0511751 0.895842 0.441415 
vn -0.154841 0.879994 0.449038 
vn -0.0477002 0.896097 0.441288 
vn -0.0114256 0.898221 0.439395 
vn -0.192608 0.870593 0.452736 
vn -0.247763 0.854785 0.456023 
vn -0.279393 0.803627 0.525474 
vn -0.154942 0.87997 0.449049 
vn -0.406632 0.74382 0.530455 
vn -0.337105 0.819814 0.462887 
vn -0.329173 0.823211 0.462568 
vn -0.294085 0.837546 0.460467 
vn -0.453832 0.755144 0.473069 
vn -0.511857 0.714195 0.477419 
vn -0.523277 0.662954 0.535419 
vn -0.425611 0.773155 0.470199 
vn -0.431654 0.769668 0.470411 
vn -0.625679 0.562752 0.540218 
vn -0.585133 0.65028 0.484516 
vn -0.569643 0.664539 0.483627 
vn -0.544764 0.686583 0.481494 
vn -0.670922 0.552387 0.494704 
vn -0.715365 0.488463 0.499656 
vn -0.710431 0.445637 0.544697 
vn -0.651169 0.57813 0.491674 
vn -0.658197 0.569411 0.492491 
vn -0.648775 0.580925 0.491546 
vn -0.774518 0.314718 0.548702 
vn -0.762772 0.401899 0.506612 
vn -0.752201 0.422441 0.505705 
vn -0.732918 0.458004 0.503055 
vn -0.815488 0.173729 0.552085 
vn -0.809435 0.280655 0.515798 
vn -0.830801 0.196235 0.520828 
vn -0.80021 0.3101 0.513325 
vn -0.805792 0.293256 0.51449 
vn -0.795719 0.322097 0.512918 
vn -0.831605 0.026919 0.554714 
vn -0.844456 0.0976239 0.526654 
vn -0.840254 0.133462 0.525511 
vn -0.833995 0.176937 0.522633 
vn -0.821985 -0.121104 0.556484 
vn -0.845918 -0.0207006 0.532912 
vn -0.834348 -0.120367 0.537937 
vn -0.846318 -0.0125383 0.53253 
vn -0.846764 0.0269546 0.531286 
vn -0.846771 -0.00199553 0.531954 
vn -0.825799 -0.159674 0.540888 
vn -0.811357 -0.217235 0.542686 
vn -0.786682 -0.26557 0.557319 
vn -0.8338 -0.123042 0.538181 
vn -0.726719 -0.401776 0.557185 
vn -0.77326 -0.319766 0.547557 
vn -0.779371 -0.304678 0.547496 
vn -0.793534 -0.267893 0.546385 
vn -0.706813 -0.439861 0.554019 
vn -0.671467 -0.490745 0.555249 
vn -0.653121 -0.513841 0.556237 
vn -0.729965 -0.403549 0.551634 
vn -0.727166 -0.408578 0.551628 
vn 0.0608154 0.025043 0.997835 
usemtl 0.615686_0.811765_0.929412_0.000000_0.000000
o mesh272
f 4350//3774 4351//3774 4352//3774 
f 4350//3774 4353//3774 4354//3774 
f 4350//3774 4355//3774 4356//3774 
f 4354//3774 4351//3774 4350//3774 
f 4350//3774 4357//3774 4358//3774 
f 4350//3774 4359//3774 4355//3774 
f 4350//3774 4360//3774 4361//3774 
f 4358//3774 4353//3774 4350//3774 
f 4361//3774 4359//3774 4350//3774 
f 4356//3774 4357//3774 4350//3774 
f 4362//3774 4363//3774 4350//3774 
f 4362//3774 4364//3774 4363//3774 
f 4352//3774 4362//3774 4350//3774 
f 4362//3774 4365//3774 4364//3774 
o mesh273
f 4366//3775 4367//3776 4362//3776 
f 4368//3777 4366//3775 4352//3778 
f 4369//3779 4368//3777 4351//3780 
f 4370//3781 4369//3779 4354//3782 
f 4371//3783 4370//3781 4353//3784 
f 4372//3785 4371//3783 4358//3786 
f 4373//3787 4372//3785 4357//3788 
f 4374//3789 4373//3787 4356//3790 
f 4375//3791 4374//3789 4355//3792 
f 4376//3793 4375//3791 4359//3794 
f 4377//3795 4376//3793 4361//3796 
f 4378//3797 4377//3795 4360//3798 
f 4379//3799 4378//3797 4350//3800 
f 4362//3776 4367//3776 4380//3801 
f 4381//3802 4382//3802 4380//3801 
f 4380//3801 4367//3776 4381//3802 
f 4383//3803 4379//3799 4384//3804 
f 4363//3805 4364//3804 4384//3804 
f 4384//3804 4379//3799 4363//3805 
f 4384//3804 4385//3806 4383//3803 
f 4380//3801 4365//3807 4362//3776 
f 4350//3800 4363//3805 4379//3799 
f 4360//3798 4350//3800 4378//3797 
f 4361//3796 4360//3798 4377//3795 
f 4359//3794 4361//3796 4376//3793 
f 4355//3792 4359//3794 4375//3791 
f 4356//3790 4355//3792 4374//3789 
f 4357//3788 4356//3790 4373//3787 
f 4358//3786 4357//3788 4372//3785 
f 4353//3784 4358//3786 4371//3783 
f 4354//3782 4353//3784 4370//3781 
f 4351//3780 4354//3782 4369//3779 
f 4352//3778 4351//3780 4368//3777 
f 4362//3776 4352//3778 4366//3775 
o mesh274
f 4383//3806 4385//3806 4386//3806 
f 4386//3806 4387//3806 4383//3806 
o mesh275
f 4388//3808 4382//3808 4381//3808 
f 4381//3808 4389//3808 4388//3808 
o mesh276
f 4387//3809 4390//3809 4391//3809 
f 4387//3809 4392//3809 4390//3809 
f 4374//3809 4393//3809 4394//3809 
f 4376//3809 4395//3809 4396//3809 
f 4377//3809 4397//3809 4395//3809 
f 4378//3809 4398//3809 4397//3809 
f 4379//3809 4399//3809 4398//3809 
f 4387//3809 4400//3809 4392//3809 
f 4387//3809 4401//3809 4402//3809 
f 4387//3809 4389//3809 4403//3809 
f 4394//3809 4373//3809 4374//3809 
f 4375//3809 4396//3809 4393//3809 
f 4395//3809 4376//3809 4377//3809 
f 4398//3809 4378//3809 4379//3809 
f 4402//3809 4400//3809 4387//3809 
f 4389//3809 4404//3809 4403//3809 
f 4389//3809 4405//3809 4406//3809 
f 4381//3809 4407//3809 4405//3809 
f 4367//3809 4408//3809 4409//3809 
f 4372//3809 4410//3809 4411//3809 
f 4373//3809 4412//3809 4410//3809 
f 4393//3809 4374//3809 4375//3809 
f 4397//3809 4377//3809 4378//3809 
f 4383//3809 4413//3809 4399//3809 
f 4403//3809 4401//3809 4387//3809 
f 4389//3809 4414//3809 4415//3809 
f 4405//3809 4389//3809 4381//3809 
f 4409//3809 4381//3809 4367//3809 
f 4366//3809 4416//3809 4408//3809 
f 4368//3809 4417//3809 4416//3809 
f 4371//3809 4411//3809 4418//3809 
f 4410//3809 4372//3809 4373//3809 
f 4396//3809 4375//3809 4376//3809 
f 4383//3809 4391//3809 4413//3809 
f 4415//3809 4404//3809 4389//3809 
f 4409//3809 4407//3809 4381//3809 
f 4416//3809 4366//3809 4368//3809 
f 4369//3809 4419//3809 4417//3809 
f 4370//3809 4418//3809 4419//3809 
f 4411//3809 4371//3809 4372//3809 
f 4399//3809 4379//3809 4383//3809 
f 4406//3809 4414//3809 4389//3809 
f 4417//3809 4368//3809 4369//3809 
f 4418//3809 4370//3809 4371//3809 
f 4391//3809 4383//3809 4387//3809 
f 4419//3809 4369//3809 4370//3809 
f 4408//3809 4367//3809 4366//3809 
f 4394//3809 4412//3809 4373//3809 
o mesh277
f 4401//3810 4403//3811 4420//3811 
f 4420//3811 4421//3812 4401//3810 
f 4421//3812 4422//3813 4401//3810 
f 4402//3814 4401//3810 4423//3815 
f 4423//3815 4424//3816 4402//3814 
f 4400//3817 4402//3814 4425//3818 
f 4425//3818 4426//3819 4400//3817 
f 4392//3820 4400//3817 4427//3821 
f 4427//3821 4428//3822 4392//3820 
f 4390//3823 4392//3820 4429//3824 
f 4391//3825 4390//3823 4430//3826 
f 4430//3826 4431//3827 4391//3825 
f 4413//3828 4391//3825 4432//3829 
f 4432//3829 4433//3830 4413//3828 
f 4413//3828 4434//3831 4435//3832 
f 4413//3828 4436//3833 4434//3831 
f 4399//3832 4437//3834 4438//3835 
f 4399//3832 4435//3832 4437//3834 
f 4398//3835 4439//3836 4440//3837 
f 4398//3835 4438//3835 4439//3836 
f 4397//3837 4441//3838 4442//3839 
f 4397//3837 4440//3837 4441//3838 
f 4395//3839 4442//3839 4443//3840 
f 4396//3840 4444//3841 4445//3842 
f 4396//3840 4443//3840 4444//3841 
f 4393//3842 4446//3843 4447//3844 
f 4393//3842 4445//3842 4446//3843 
f 4410//3845 4412//3846 4448//3847 
f 4448//3847 4449//3848 4410//3845 
f 4394//3849 4447//3844 4448//3847 
f 4412//3846 4394//3849 4448//3847 
f 4411//3850 4410//3845 4450//3851 
f 4450//3851 4451//3852 4411//3850 
f 4418//3853 4411//3850 4452//3854 
f 4452//3854 4453//3855 4418//3853 
f 4453//3855 4454//3856 4418//3853 
f 4419//3857 4418//3853 4455//3858 
f 4455//3858 4456//3859 4419//3857 
f 4417//3860 4419//3857 4457//3861 
f 4457//3861 4458//3862 4417//3860 
f 4416//3863 4417//3860 4459//3864 
f 4408//3865 4416//3863 4460//3866 
f 4460//3866 4461//3867 4408//3865 
f 4409//3868 4462//3869 4463//3870 
f 4409//3868 4408//3865 4464//3871 
f 4464//3871 4462//3869 4409//3868 
f 4409//3868 4465//3872 4466//3873 
f 4409//3868 4467//3874 4465//3872 
f 4409//3868 4468//3875 4467//3874 
f 4407//3876 4469//3877 4470//3878 
f 4407//3876 4466//3873 4469//3877 
f 4405//3878 4471//3879 4472//3880 
f 4405//3878 4470//3878 4471//3879 
f 4406//3880 4472//3880 4473//3881 
f 4414//3881 4474//3882 4475//3883 
f 4414//3881 4473//3881 4474//3882 
f 4415//3883 4476//3884 4477//3885 
f 4415//3883 4475//3883 4476//3884 
f 4404//3885 4478//3886 4420//3811 
f 4404//3885 4477//3885 4478//3886 
f 4420//3811 4403//3811 4404//3885 
f 4477//3885 4404//3885 4415//3883 
f 4475//3883 4415//3883 4414//3881 
f 4473//3881 4414//3881 4406//3880 
f 4472//3880 4406//3880 4405//3878 
f 4470//3878 4405//3878 4407//3876 
f 4466//3873 4407//3876 4409//3868 
f 4463//3870 4468//3875 4409//3868 
f 4461//3867 4464//3871 4408//3865 
f 4459//3864 4460//3866 4416//3863 
f 4458//3862 4459//3864 4417//3860 
f 4456//3859 4457//3861 4419//3857 
f 4454//3856 4455//3858 4418//3853 
f 4451//3852 4452//3854 4411//3850 
f 4449//3848 4450//3851 4410//3845 
f 4447//3844 4394//3849 4393//3842 
f 4445//3842 4393//3842 4396//3840 
f 4443//3840 4396//3840 4395//3839 
f 4442//3839 4395//3839 4397//3837 
f 4440//3837 4397//3837 4398//3835 
f 4438//3835 4398//3835 4399//3832 
f 4435//3832 4399//3832 4413//3828 
f 4433//3830 4436//3833 4413//3828 
f 4431//3827 4432//3829 4391//3825 
f 4429//3824 4430//3826 4390//3823 
f 4428//3822 4429//3824 4392//3820 
f 4426//3819 4427//3821 4400//3817 
f 4424//3816 4425//3818 4402//3814 
f 4422//3813 4423//3815 4401//3810 
o mesh278
f 4479//3887 4480//3887 4481//3888 
f 4482//3888 4481//3888 4483//3889 
f 4484//3889 4483//3889 4485//3890 
f 4486//3890 4485//3890 4487//3891 
f 4488//3891 4487//3891 4489//3892 
f 4490//3892 4489//3892 4491//3893 
f 4492//3893 4491//3893 4493//3894 
f 4494//3894 4493//3894 4495//3895 
f 4480//3887 4479//3887 4382//3896 
f 4479//3887 4380//3897 4382//3896 
f 4495//3895 4496//3898 4497//3898 
f 4497//3898 4498//3899 4495//3895 
f 4497//3898 4499//3900 4498//3899 
f 4382//3896 4388//3901 4480//3887 
f 4495//3895 4498//3899 4494//3894 
f 4493//3894 4494//3894 4492//3893 
f 4491//3893 4492//3893 4490//3892 
f 4489//3892 4490//3892 4488//3891 
f 4487//3891 4488//3891 4486//3890 
f 4485//3890 4486//3890 4484//3889 
f 4483//3889 4484//3889 4482//3888 
f 4481//3888 4482//3888 4479//3887 
o mesh279
f 4500//3902 4501//3902 4502//3903 
f 4503//3903 4502//3903 4504//3904 
f 4505//3904 4504//3904 4506//3905 
f 4507//3905 4506//3905 4508//3906 
f 4509//3906 4508//3906 4510//3907 
f 4511//3907 4510//3907 4512//3908 
f 4513//3908 4512//3908 4514//3909 
f 4515//3909 4514//3909 4516//3910 
f 4501//3902 4500//3902 4517//3911 
f 4500//3902 4518//3912 4517//3911 
f 4516//3910 4386//3913 4385//3914 
f 4385//3914 4519//3915 4516//3910 
f 4385//3914 4384//3916 4519//3915 
f 4517//3911 4520//3917 4501//3902 
f 4516//3910 4519//3915 4515//3909 
f 4514//3909 4515//3909 4513//3908 
f 4512//3908 4513//3908 4511//3907 
f 4510//3907 4511//3907 4509//3906 
f 4508//3906 4509//3906 4507//3905 
f 4506//3905 4507//3905 4505//3904 
f 4504//3904 4505//3904 4503//3903 
f 4502//3903 4503//3903 4500//3902 
o mesh280
f 4508//3918 4506//3918 4521//3918 
f 4506//3918 4504//3918 4522//3918 
f 4522//3918 4521//3918 4506//3918 
f 4504//3918 4523//3918 4522//3918 
f 4504//3918 4524//3918 4525//3918 
f 4524//3918 4526//3918 4527//3918 
f 4525//3918 4523//3918 4504//3918 
f 4524//3918 4528//3918 4529//3918 
f 4526//3918 4530//3918 4527//3918 
f 4491//3918 4489//3918 4531//3918 
f 4529//3918 4525//3918 4524//3918 
f 4527//3918 4532//3918 4524//3918 
f 4526//3918 4533//3918 4534//3918 
f 4526//3918 4491//3918 4535//3918 
f 4531//3918 4536//3918 4491//3918 
f 4489//3918 4487//3918 4537//3918 
f 4532//3918 4528//3918 4524//3918 
f 4535//3918 4533//3918 4526//3918 
f 4537//3918 4531//3918 4489//3918 
f 4485//3918 4538//3918 4537//3918 
f 4483//3918 4539//3918 4538//3918 
f 4389//3918 4540//3918 4541//3918 
f 4387//3918 4542//3918 4543//3918 
f 4512//3918 4544//3918 4545//3918 
f 4534//3918 4530//3918 4526//3918 
f 4537//3918 4487//3918 4485//3918 
f 4483//3918 4541//3918 4539//3918 
f 4389//3918 4546//3918 4540//3918 
f 4389//3918 4543//3918 4547//3918 
f 4387//3918 4548//3918 4542//3918 
f 4387//3918 4545//3918 4549//3918 
f 4512//3918 4550//3918 4544//3918 
f 4536//3918 4535//3918 4491//3918 
f 4541//3918 4483//3918 4389//3918 
f 4543//3918 4389//3918 4387//3918 
f 4545//3918 4387//3918 4512//3918 
f 4538//3918 4485//3918 4483//3918 
f 4549//3918 4548//3918 4387//3918 
f 4510//3918 4551//3918 4550//3918 
f 4508//3918 4552//3918 4551//3918 
f 4526//3918 4495//3918 4493//3918 
f 4547//3918 4546//3918 4389//3918 
f 4551//3918 4510//3918 4508//3918 
f 4526//3918 4496//3918 4495//3918 
f 4550//3918 4512//3918 4510//3918 
f 4389//3918 4481//3918 4480//3918 
f 4521//3918 4552//3918 4508//3918 
f 4389//3918 4483//3918 4481//3918 
f 4524//3918 4504//3918 4502//3918 
f 4387//3918 4516//3918 4514//3918 
f 4480//3918 4388//3918 4389//3918 
f 4502//3918 4501//3918 4524//3918 
f 4387//3918 4386//3918 4516//3918 
f 4501//3918 4520//3918 4524//3918 
f 4493//3918 4491//3918 4526//3918 
f 4514//3918 4512//3918 4387//3918 
o mesh281
f 4553//3919 4524//3919 4520//3919 
f 4520//3919 4517//3919 4553//3919 
o mesh282
f 4554//3920 4497//3920 4496//3920 
f 4496//3920 4526//3920 4554//3920 
o mesh283
f 4555//3921 4556//3922 4557//3922 
f 4558//3923 4555//3921 4559//3924 
f 4560//3925 4558//3923 4561//3926 
f 4562//3927 4560//3925 4563//3928 
f 4564//3929 4562//3927 4565//3930 
f 4566//3931 4564//3929 4567//3932 
f 4568//3933 4566//3931 4569//3934 
f 4570//3935 4568//3933 4571//3936 
f 4572//3937 4570//3935 4573//3938 
f 4574//3939 4572//3937 4575//3940 
f 4576//3941 4574//3939 4577//3942 
f 4578//3943 4576//3941 4579//3944 
f 4580//3945 4578//3943 4581//3946 
f 4554//3947 4580//3945 4499//3948 
f 4582//3949 4583//3948 4499//3948 
f 4499//3948 4580//3945 4582//3949 
f 4557//3922 4556//3922 4518//3950 
f 4553//3951 4517//3951 4518//3950 
f 4518//3950 4556//3922 4553//3951 
f 4518//3950 4584//3950 4557//3922 
f 4499//3948 4497//3952 4554//3947 
f 4581//3946 4582//3949 4580//3945 
f 4579//3944 4581//3946 4578//3943 
f 4577//3942 4579//3944 4576//3941 
f 4575//3940 4577//3942 4574//3939 
f 4573//3938 4575//3940 4572//3937 
f 4571//3936 4573//3938 4570//3935 
f 4569//3934 4571//3936 4568//3933 
f 4567//3932 4569//3934 4566//3931 
f 4565//3930 4567//3932 4564//3929 
f 4563//3928 4565//3930 4562//3927 
f 4561//3926 4563//3928 4560//3925 
f 4559//3924 4561//3926 4558//3923 
f 4557//3922 4559//3924 4555//3921 
o mesh284
f 4582//3953 4571//3953 4569//3953 
f 4582//3953 4565//3953 4563//3953 
f 4582//3953 4573//3953 4571//3953 
f 4579//3953 4577//3953 4575//3953 
f 4573//3953 4582//3953 4581//3953 
f 4563//3953 4561//3953 4582//3953 
f 4569//3953 4567//3953 4582//3953 
f 4581//3953 4579//3953 4573//3953 
f 4561//3953 4559//3953 4582//3953 
f 4575//3953 4573//3953 4579//3953 
f 4567//3953 4565//3953 4582//3953 
f 4559//3953 4557//3953 4582//3953 
f 4584//3953 4583//3953 4582//3953 
f 4557//3953 4584//3953 4582//3953 
o mesh285
f 4566//3954 4568//3954 4585//3954 
f 4564//3954 4566//3954 4586//3954 
f 4585//3954 4587//3954 4566//3954 
f 4587//3954 4586//3954 4566//3954 
f 4568//3954 4570//3954 4588//3954 
f 4562//3954 4564//3954 4589//3954 
f 4588//3954 4585//3954 4568//3954 
f 4524//3954 4553//3954 4590//3954 
f 4586//3954 4589//3954 4564//3954 
f 4570//3954 4572//3954 4591//3954 
f 4576//3954 4578//3954 4592//3954 
f 4578//3954 4580//3954 4593//3954 
f 4590//3954 4594//3954 4524//3954 
f 4556//3954 4555//3954 4595//3954 
f 4555//3954 4558//3954 4596//3954 
f 4558//3954 4560//3954 4597//3954 
f 4560//3954 4562//3954 4598//3954 
f 4591//3954 4588//3954 4570//3954 
f 4572//3954 4574//3954 4599//3954 
f 4574//3954 4576//3954 4600//3954 
f 4593//3954 4592//3954 4578//3954 
f 4580//3954 4554//3954 4601//3954 
f 4554//3954 4526//3954 4602//3954 
f 4526//3954 4603//3954 4604//3954 
f 4524//3954 4605//3954 4606//3954 
f 4594//3954 4607//3954 4524//3954 
f 4596//3954 4595//3954 4555//3954 
f 4598//3954 4597//3954 4560//3954 
f 4599//3954 4591//3954 4572//3954 
f 4592//3954 4600//3954 4576//3954 
f 4554//3954 4608//3954 4601//3954 
f 4604//3954 4602//3954 4526//3954 
f 4526//3954 4609//3954 4610//3954 
f 4524//3954 4611//3954 4612//3954 
f 4607//3954 4605//3954 4524//3954 
f 4553//3954 4556//3954 4613//3954 
f 4597//3954 4596//3954 4558//3954 
f 4600//3954 4599//3954 4574//3954 
f 4602//3954 4608//3954 4554//3954 
f 4526//3954 4612//3954 4609//3954 
f 4606//3954 4611//3954 4524//3954 
f 4613//3954 4614//3954 4553//3954 
f 4589//3954 4598//3954 4562//3954 
f 4610//3954 4603//3954 4526//3954 
f 4614//3954 4590//3954 4553//3954 
f 4601//3954 4593//3954 4580//3954 
f 4595//3954 4613//3954 4556//3954 
f 4612//3954 4526//3954 4524//3954 
o mesh286
f 4609//3955 4612//3956 4615//3956 
f 4615//3956 4616//3957 4609//3955 
f 4610//3958 4609//3955 4617//3959 
f 4617//3959 4618//3960 4610//3958 
f 4603//3961 4610//3958 4619//3962 
f 4619//3962 4620//3963 4603//3961 
f 4604//3964 4603//3961 4621//3965 
f 4602//3966 4604//3964 4622//3967 
f 4622//3967 4623//3968 4602//3966 
f 4608//3969 4602//3966 4624//3970 
f 4624//3970 4625//3971 4608//3969 
f 4601//3972 4626//3973 4627//3974 
f 4601//3972 4608//3969 4628//3975 
f 4628//3975 4626//3973 4601//3972 
f 4601//3972 4629//3976 4630//3977 
f 4601//3972 4631//3978 4632//3979 
f 4632//3979 4629//3976 4601//3972 
f 4593//3980 4633//3981 4634//3982 
f 4593//3980 4630//3977 4633//3981 
f 4592//3982 4634//3982 4635//3983 
f 4600//3983 4636//3984 4637//3985 
f 4600//3983 4635//3983 4636//3984 
f 4599//3985 4638//3986 4639//3987 
f 4599//3985 4637//3985 4638//3986 
f 4591//3988 4640//3989 4641//3990 
f 4591//3988 4642//3991 4640//3989 
f 4591//3988 4639//3987 4642//3991 
f 4588//3992 4643//3993 4644//3994 
f 4588//3992 4641//3990 4643//3993 
f 4586//3995 4587//3996 4645//3997 
f 4585//3998 4646//3999 4645//3997 
f 4585//3998 4644//3994 4646//3999 
f 4645//3997 4587//3996 4585//3998 
f 4589//4000 4586//3995 4647//4001 
f 4647//4001 4648//4002 4589//4000 
f 4598//4003 4589//4000 4649//4004 
f 4649//4004 4650//4005 4598//4003 
f 4597//4006 4598//4003 4651//4007 
f 4596//4008 4597//4006 4652//4009 
f 4652//4009 4653//4010 4596//4008 
f 4595//4011 4596//4008 4654//4012 
f 4654//4012 4655//4013 4595//4011 
f 4613//4014 4595//4011 4656//4015 
f 4656//4015 4657//4016 4613//4014 
f 4614//4017 4613//4014 4658//4018 
f 4658//4018 4659//4019 4614//4017 
f 4614//4017 4660//4020 4661//4021 
f 4614//4017 4662//4022 4660//4020 
f 4590//4021 4663//4023 4664//4024 
f 4590//4021 4661//4021 4663//4023 
f 4594//4024 4664//4024 4665//4025 
f 4607//4025 4666//4026 4667//4027 
f 4607//4025 4665//4025 4666//4026 
f 4605//4027 4668//4028 4669//4029 
f 4605//4027 4667//4027 4668//4028 
f 4606//4030 4670//4031 4671//4032 
f 4606//4030 4669//4029 4670//4031 
f 4611//4032 4672//4033 4615//3956 
f 4611//4032 4671//4032 4673//4034 
f 4673//4034 4672//4033 4611//4032 
f 4615//3956 4612//3956 4611//4032 
f 4671//4032 4611//4032 4606//4030 
f 4669//4029 4606//4030 4605//4027 
f 4667//4027 4605//4027 4607//4025 
f 4665//4025 4607//4025 4594//4024 
f 4664//4024 4594//4024 4590//4021 
f 4661//4021 4590//4021 4614//4017 
f 4659//4019 4662//4022 4614//4017 
f 4657//4016 4658//4018 4613//4014 
f 4655//4013 4656//4015 4595//4011 
f 4653//4010 4654//4012 4596//4008 
f 4651//4007 4652//4009 4597//4006 
f 4650//4005 4651//4007 4598//4003 
f 4648//4002 4649//4004 4589//4000 
f 4645//3997 4647//4001 4586//3995 
f 4644//3994 4585//3998 4588//3992 
f 4641//3990 4588//3992 4591//3988 
f 4639//3987 4591//3988 4599//3985 
f 4637//3985 4599//3985 4600//3983 
f 4635//3983 4600//3983 4592//3982 
f 4634//3982 4592//3982 4593//3980 
f 4630//3977 4593//3980 4601//3972 
f 4627//3974 4631//3978 4601//3972 
f 4625//3971 4628//3975 4608//3969 
f 4623//3968 4624//3970 4602//3966 
f 4621//3965 4622//3967 4604//3964 
f 4620//3963 4621//3965 4603//3961 
f 4618//3960 4619//3962 4610//3958 
f 4616//3957 4617//3959 4609//3955 
o mesh287
f 4674//4035 4675//4036 4537//4036 
f 4676//4037 4674//4035 4538//4038 
f 4677//4039 4678//4040 4544//4040 
f 4679//4041 4677//4039 4550//4042 
f 4680//4043 4681//4044 4552//4044 
f 4551//4045 4552//4044 4681//4044 
f 4681//4044 4679//4041 4551//4045 
f 4682//4046 4680//4043 4521//4047 
f 4683//4048 4682//4046 4522//4049 
f 4684//4050 4685//4051 4536//4051 
f 4675//4036 4684//4050 4531//4050 
f 4528//4052 4670//4053 4669//4054 
f 4528//4052 4532//4055 4673//4056 
f 4673//4056 4671//4057 4528//4052 
f 4671//4057 4670//4053 4528//4052 
f 4529//4058 4528//4052 4668//4059 
f 4668//4059 4667//4060 4529//4058 
f 4525//4061 4665//4062 4664//4063 
f 4525//4061 4529//4058 4666//4064 
f 4666//4064 4665//4062 4525//4061 
f 4683//4048 4656//4065 4655//4066 
f 4683//4048 4657//4067 4656//4065 
f 4683//4048 4659//4068 4658//4069 
f 4658//4069 4657//4067 4683//4048 
f 4523//4070 4662//4071 4659//4068 
f 4659//4068 4683//4048 4523//4070 
f 4523//4070 4661//4072 4660//4073 
f 4523//4070 4525//4061 4663//4074 
f 4663//4074 4661//4072 4523//4070 
f 4660//4073 4662//4071 4523//4070 
f 4686//4074 4654//4075 4653//4076 
f 4686//4074 4655//4066 4654//4075 
f 4687//4077 4652//4078 4651//4079 
f 4688//4080 4653//4076 4652//4078 
f 4652//4078 4687//4077 4688//4080 
f 4651//4079 4650//4081 4687//4077 
f 4687//4077 4649//4082 4648//4083 
f 4687//4077 4650//4081 4649//4082 
f 4689//4084 4690//4083 4645//4085 
f 4690//4083 4648//4083 4647//4086 
f 4647//4086 4645//4085 4690//4083 
f 4691//4087 4643//4088 4641//4089 
f 4691//4087 4644//4090 4643//4088 
f 4691//4087 4689//4084 4646//4091 
f 4646//4091 4644//4090 4691//4087 
f 4692//4092 4642//4093 4639//4094 
f 4692//4092 4691//4087 4640//4095 
f 4640//4095 4642//4093 4692//4092 
f 4693//4096 4692//4092 4638//4097 
f 4638//4097 4637//4098 4693//4096 
f 4694//4099 4633//4100 4630//4101 
f 4694//4099 4634//4102 4633//4100 
f 4694//4099 4635//4103 4634//4102 
f 4694//4099 4693//4096 4636//4104 
f 4636//4104 4635//4103 4694//4099 
f 4536//4051 4631//4105 4627//4106 
f 4536//4051 4632//4107 4631//4105 
f 4685//4051 4694//4099 4629//4106 
f 4629//4106 4632//4107 4685//4051 
f 4632//4107 4536//4051 4685//4051 
f 4535//4106 4624//4108 4623//4109 
f 4535//4106 4628//4110 4625//4111 
f 4535//4106 4626//4112 4628//4110 
f 4535//4106 4627//4106 4626//4112 
f 4625//4111 4624//4108 4535//4106 
f 4533//4113 4621//4114 4620//4115 
f 4533//4113 4622//4116 4621//4114 
f 4533//4113 4623//4109 4622//4116 
f 4534//4115 4619//4117 4618//4118 
f 4534//4115 4620//4115 4619//4117 
f 4530//4118 4617//4119 4616//4120 
f 4530//4118 4618//4118 4617//4119 
f 4532//4055 4527//4120 4615//4121 
f 4527//4120 4616//4120 4615//4121 
f 4615//4121 4672//4122 4532//4055 
f 4547//4123 4543//4124 4478//4124 
f 4478//4124 4477//4125 4547//4123 
f 4546//4126 4547//4123 4476//4127 
f 4476//4127 4475//4128 4546//4126 
f 4540//4129 4546//4126 4474//4130 
f 4474//4130 4473//4131 4540//4129 
f 4473//4131 4472//4132 4540//4129 
f 4541//4133 4470//4134 4469//4135 
f 4469//4135 4466//4136 4541//4133 
f 4541//4133 4540//4129 4471//4137 
f 4471//4137 4470//4134 4541//4133 
f 4466//4136 4465//4138 4541//4133 
f 4676//4037 4463//4139 4462//4140 
f 4539//4141 4468//4142 4463//4139 
f 4463//4139 4676//4037 4539//4141 
f 4539//4141 4541//4133 4467//4143 
f 4467//4143 4468//4142 4539//4141 
f 4695//4144 4459//4145 4458//4146 
f 4695//4144 4462//4140 4464//4147 
f 4464//4147 4461//4148 4695//4144 
f 4461//4148 4460//4149 4695//4144 
f 4460//4149 4459//4145 4695//4144 
f 4696//4150 4457//4151 4456//4152 
f 4696//4150 4458//4146 4457//4151 
f 4697//4153 4454//4154 4453//4155 
f 4697//4153 4455//4156 4454//4154 
f 4697//4153 4456//4152 4455//4156 
f 4698//4157 4450//4158 4449//4159 
f 4698//4157 4451//4160 4450//4158 
f 4698//4157 4453//4155 4452//4161 
f 4452//4161 4451//4160 4698//4157 
f 4699//4162 4449//4159 4448//4163 
f 4448//4163 4700//4164 4699//4162 
f 4448//4163 4447//4165 4700//4164 
f 4701//4166 4700//4164 4446//4167 
f 4446//4167 4445//4168 4701//4166 
f 4702//4169 4701//4166 4444//4170 
f 4444//4170 4443//4171 4702//4169 
f 4443//4171 4442//4172 4702//4169 
f 4703//4173 4702//4169 4441//4174 
f 4441//4174 4440//4175 4703//4173 
f 4544//4040 4432//4176 4431//4177 
f 4544//4040 4436//4178 4433//4179 
f 4433//4179 4432//4176 4544//4040 
f 4544//4040 4678//4040 4434//4180 
f 4678//4040 4438//4181 4437//4182 
f 4678//4040 4703//4173 4439//4183 
f 4439//4183 4438//4181 4678//4040 
f 4437//4182 4435//4184 4678//4040 
f 4435//4184 4434//4180 4678//4040 
f 4434//4180 4436//4178 4544//4040 
f 4545//4185 4429//4186 4428//4187 
f 4545//4185 4431//4177 4430//4188 
f 4430//4188 4429//4186 4545//4185 
f 4549//4189 4427//4190 4426//4191 
f 4549//4189 4428//4187 4427//4190 
f 4548//4191 4423//4192 4422//4193 
f 4548//4191 4424//4194 4423//4192 
f 4548//4191 4426//4191 4425//4195 
f 4425//4195 4424//4194 4548//4191 
f 4542//4196 4421//4197 4420//4198 
f 4420//4198 4543//4124 4542//4196 
f 4542//4196 4422//4193 4421//4197 
f 4420//4198 4478//4124 4543//4124 
f 4422//4193 4542//4196 4548//4191 
f 4426//4191 4548//4191 4549//4189 
f 4428//4187 4549//4189 4545//4185 
f 4431//4177 4545//4185 4544//4040 
f 4440//4175 4439//4183 4703//4173 
f 4442//4172 4441//4174 4702//4169 
f 4445//4168 4444//4170 4701//4166 
f 4447//4165 4446//4167 4700//4164 
f 4449//4159 4699//4162 4698//4157 
f 4453//4155 4698//4157 4697//4153 
f 4456//4152 4697//4153 4696//4150 
f 4458//4146 4696//4150 4695//4144 
f 4462//4140 4695//4144 4676//4037 
f 4465//4138 4467//4143 4541//4133 
f 4472//4132 4471//4137 4540//4129 
f 4475//4128 4474//4130 4546//4126 
f 4477//4125 4476//4127 4547//4123 
f 4672//4122 4673//4056 4532//4055 
f 4616//4120 4527//4120 4530//4118 
f 4618//4118 4530//4118 4534//4115 
f 4620//4115 4534//4115 4533//4113 
f 4623//4109 4533//4113 4535//4106 
f 4627//4106 4535//4106 4536//4051 
f 4630//4101 4629//4106 4694//4099 
f 4637//4098 4636//4104 4693//4096 
f 4639//4094 4638//4097 4692//4092 
f 4641//4089 4640//4095 4691//4087 
f 4645//4085 4646//4091 4689//4084 
f 4648//4083 4690//4083 4687//4077 
f 4653//4076 4688//4080 4686//4074 
f 4655//4066 4686//4074 4683//4048 
f 4664//4063 4663//4074 4525//4061 
f 4667//4060 4666//4064 4529//4058 
f 4669//4054 4668//4059 4528//4052 
f 4531//4050 4537//4036 4675//4036 
f 4536//4051 4531//4050 4684//4050 
f 4522//4049 4523//4070 4683//4048 
f 4521//4047 4522//4049 4682//4046 
f 4552//4044 4521//4047 4680//4043 
f 4550//4042 4551//4045 4679//4041 
f 4544//4040 4550//4042 4677//4039 
f 4538//4038 4539//4141 4676//4037 
f 4537//4036 4538//4038 4674//4035 
o mesh288
f 4704//4199 4705//4199 4479//4199 
f 4584//4199 4706//4199 4707//4199 
f 4708//4199 4709//4199 4490//4199 
f 4482//4199 4710//4199 4704//4199 
f 4711//4199 4712//4199 4365//4199 
f 4380//4199 4713//4199 4714//4199 
f 4715//4199 4713//4199 4380//4199 
f 4479//4199 4716//4199 4717//4199 
f 4718//4199 4505//4199 4507//4199 
f 4584//4199 4719//4199 4706//4199 
f 4720//4199 4721//4199 4498//4199 
f 4722//4199 4723//4199 4492//4199 
f 4494//4199 4724//4199 4725//4199 
f 4492//4199 4726//4199 4708//4199 
f 4492//4199 4723//4199 4727//4199 
f 4728//4199 4729//4199 4488//4199 
f 4730//4199 4731//4199 4482//4199 
f 4479//4199 4482//4199 4704//4199 
f 4714//4199 4711//4199 4380//4199 
f 4717//4199 4715//4199 4479//4199 
f 4732//4199 4519//4199 4384//4199 
f 4733//4199 4384//4199 4364//4199 
f 4734//4199 4507//4199 4509//4199 
f 4507//4199 4735//4199 4718//4199 
f 4736//4199 4737//4199 4503//4199 
f 4738//4199 4739//4199 4584//4199 
f 4738//4199 4518//4199 4500//4199 
f 4584//4199 4739//4199 4719//4199 
f 4499//4199 4740//4199 4720//4199 
f 4725//4199 4722//4199 4494//4199 
f 4727//4199 4726//4199 4492//4199 
f 4490//4199 4741//4199 4728//4199 
f 4488//4199 4742//4199 4743//4199 
f 4484//4199 4744//4199 4730//4199 
f 4482//4199 4731//4199 4710//4199 
f 4380//4199 4479//4199 4715//4199 
f 4384//4199 4745//4199 4746//4199 
f 4364//4199 4747//4199 4733//4199 
f 4515//4199 4748//4199 4749//4199 
f 4515//4199 4750//4199 4751//4199 
f 4509//4199 4752//4199 4734//4199 
f 4718//4199 4753//4199 4505//4199 
f 4505//4199 4754//4199 4736//4199 
f 4737//4199 4755//4199 4500//4199 
f 4500//4199 4755//4199 4738//4199 
f 4707//4199 4583//4199 4584//4199 
f 4499//4199 4756//4199 4740//4199 
f 4499//4199 4757//4199 4758//4199 
f 4498//4199 4759//4199 4760//4199 
f 4490//4199 4492//4199 4708//4199 
f 4490//4199 4709//4199 4741//4199 
f 4761//4199 4762//4199 4486//4199 
f 4488//4199 4729//4199 4742//4199 
f 4763//4199 4764//4199 4484//4199 
f 4486//4199 4762//4199 4765//4199 
f 4484//4199 4764//4199 4744//4199 
f 4365//4199 4380//4199 4711//4199 
f 4364//4199 4365//4199 4766//4199 
f 4519//4199 4732//4199 4767//4199 
f 4733//4199 4745//4199 4384//4199 
f 4751//4199 4748//4199 4515//4199 
f 4750//4199 4515//4199 4519//4199 
f 4768//4199 4513//4199 4515//4199 
f 4769//4199 4511//4199 4513//4199 
f 4734//4199 4770//4199 4507//4199 
f 4503//4199 4505//4199 4736//4199 
f 4584//4199 4518//4199 4738//4199 
f 4583//4199 4771//4199 4772//4199 
f 4707//4199 4773//4199 4583//4199 
f 4758//4199 4756//4199 4499//4199 
f 4757//4199 4499//4199 4583//4199 
f 4774//4199 4724//4199 4494//4199 
f 4498//4199 4721//4199 4759//4199 
f 4488//4199 4490//4199 4728//4199 
f 4743//4199 4761//4199 4488//4199 
f 4765//4199 4763//4199 4486//4199 
f 4705//4199 4716//4199 4479//4199 
f 4365//4199 4775//4199 4766//4199 
f 4365//4199 4776//4199 4777//4199 
f 4384//4199 4746//4199 4732//4199 
f 4519//4199 4778//4199 4750//4199 
f 4515//4199 4779//4199 4768//4199 
f 4513//4199 4780//4199 4769//4199 
f 4509//4199 4781//4199 4782//4199 
f 4781//4199 4509//4199 4511//4199 
f 4509//4199 4783//4199 4752//4199 
f 4500//4199 4503//4199 4737//4199 
f 4773//4199 4771//4199 4583//4199 
f 4583//4199 4784//4199 4757//4199 
f 4760//4199 4774//4199 4498//4199 
f 4486//4199 4488//4199 4761//4199 
f 4482//4199 4484//4199 4730//4199 
f 4766//4199 4785//4199 4364//4199 
f 4365//4199 4712//4199 4776//4199 
f 4749//4199 4779//4199 4515//4199 
f 4768//4199 4786//4199 4513//4199 
f 4769//4199 4787//4199 4511//4199 
f 4511//4199 4788//4199 4781//4199 
f 4753//4199 4754//4199 4505//4199 
f 4772//4199 4789//4199 4583//4199 
f 4494//4199 4498//4199 4774//4199 
f 4484//4199 4486//4199 4763//4199 
f 4364//4199 4790//4199 4791//4199 
f 4777//4199 4775//4199 4365//4199 
f 4786//4199 4780//4199 4513//4199 
f 4782//4199 4783//4199 4509//4199 
f 4789//4199 4784//4199 4583//4199 
f 4492//4199 4494//4199 4722//4199 
f 4785//4199 4790//4199 4364//4199 
f 4787//4199 4788//4199 4511//4199 
f 4498//4199 4499//4199 4720//4199 
f 4767//4199 4778//4199 4519//4199 
f 4791//4199 4747//4199 4364//4199 
f 4770//4199 4735//4199 4507//4199 
o mesh289
f 5337//4200 5338//4201 4792//4202 
f 5338//4201 4793//4203 4792//4202 
f 5338//4201 5339//4204 4794//4205 
f 5339//4204 4795//4206 4794//4205 
f 5339//4204 5340//4207 4796//4208 
f 5340//4207 4797//4209 4796//4208 
f 5340//4207 5341//4210 4798//4211 
f 5341//4210 4799//4212 4798//4211 
f 5341//4210 5342//4213 4800//4214 
f 5342//4213 4801//4215 4800//4214 
f 5342//4213 5343//4216 4802//4217 
f 5343//4216 4803//4218 4802//4217 
f 5343//4216 5344//4219 4804//4220 
f 5344//4219 4805//4221 4804//4220 
f 5344//4219 5345//4222 4806//4223 
f 5345//4222 4807//4224 4806//4223 
f 5345//4222 5346//4225 4808//4226 
f 5346//4225 4809//4227 4808//4226 
f 5346//4225 5347//4228 4810//4229 
f 5347//4228 4811//4230 4810//4229 
f 5347//4228 5348//4231 4812//4232 
f 5348//4231 4813//4233 4812//4232 
f 5348//4231 5349//4234 4814//4235 
f 5349//4234 4815//4236 4814//4235 
f 5349//4234 5350//4237 4816//4238 
f 5350//4237 4817//4239 4816//4238 
f 5350//4237 5351//4240 4818//4241 
f 5351//4240 4819//4242 4818//4241 
f 5352//4243 4820//4244 4819//4242 
f 5353//4245 4821//4246 4820//4244 
f 5354//4247 4822//4248 4821//4246 
f 5355//4249 4823//4250 4822//4248 
f 5356//4251 4824//4252 4823//4250 
f 5357//4253 4825//4254 4824//4252 
f 5358//4255 4826//4256 4825//4254 
f 5359//4257 4827//4258 4826//4256 
f 5360//4259 4828//4260 4827//4258 
f 5361//4261 4829//4262 4828//4260 
f 5362//4263 4830//4264 4829//4262 
f 5363//4265 4831//4266 4830//4264 
f 5364//4267 4832//4268 4831//4266 
f 5365//4269 4833//4270 4834//4271 
f 4834//4271 5364//4267 5365//4269 
f 5366//4272 4835//4273 4836//4274 
f 4836//4274 5365//4269 5366//4272 
f 5367//4275 4837//4276 4838//4277 
f 4838//4277 5366//4272 5367//4275 
f 5368//4278 4839//4279 4840//4280 
f 4840//4280 5367//4275 5368//4278 
f 5369//4281 4841//4282 4842//4283 
f 4842//4283 5368//4278 5369//4281 
f 5370//4284 4843//4285 4844//4286 
f 4844//4286 5369//4281 5370//4284 
f 5371//4287 4845//4288 4846//4289 
f 4846//4289 5370//4284 5371//4287 
f 5372//4290 4847//4291 4848//4292 
f 4848//4292 5371//4287 5372//4290 
f 5373//4293 4849//4294 4850//4295 
f 4850//4295 5372//4290 5373//4293 
f 5374//4296 4851//4297 4852//4298 
f 4852//4298 5373//4293 5374//4296 
f 5375//4299 4853//4300 4854//4301 
f 4854//4301 5374//4296 5375//4299 
f 5376//4302 4855//4303 4856//4304 
f 4856//4304 5375//4299 5376//4302 
f 5377//4305 4857//4306 4858//4307 
f 4858//4307 5376//4302 5377//4305 
f 5378//4308 4859//4309 4860//4310 
f 4860//4310 5377//4305 5378//4308 
f 5379//4311 4861//4312 4862//4313 
f 4862//4313 5378//4308 5379//4311 
f 5380//4314 4863//4315 4864//4316 
f 4864//4316 5379//4311 5380//4314 
f 5381//4317 4865//4318 4866//4319 
f 4866//4319 5380//4314 5381//4317 
f 5382//4320 4867//4321 4868//4322 
f 4868//4322 5381//4317 5382//4320 
f 5383//4323 4869//4324 4870//4325 
f 4870//4325 5382//4320 5383//4323 
f 5384//4326 4871//4327 4872//4328 
f 4872//4328 5383//4323 5384//4326 
f 5385//4329 4873//4330 4874//4331 
f 4874//4331 5384//4326 5385//4329 
f 5386//4332 4875//4333 4876//4334 
f 4876//4334 5385//4329 5386//4332 
f 5387//4335 4877//4336 4878//4337 
f 4878//4337 5386//4332 5387//4335 
f 5388//4338 4879//4339 4880//4340 
f 4880//4340 5387//4335 5388//4338 
f 5389//4341 4881//4342 4882//4343 
f 4882//4343 5388//4338 5389//4341 
f 5390//4344 4883//4345 4884//4346 
f 4884//4346 5389//4341 5390//4344 
f 5391//4347 4885//4348 4886//4349 
f 4886//4349 5390//4344 5391//4347 
f 5392//4350 4887//4351 4888//4352 
f 4888//4352 5391//4347 5392//4350 
f 5393//4353 4889//4354 4890//4355 
f 4890//4355 5392//4350 5393//4353 
f 5394//4356 4891//4357 4892//4358 
f 4892//4358 5393//4353 5394//4356 
f 5395//4359 4893//4360 4894//4361 
f 4894//4361 5394//4356 5395//4359 
f 5396//4362 4895//4363 4896//4364 
f 4896//4364 5395//4359 5396//4362 
f 5397//4365 4897//4366 4898//4367 
f 4898//4367 5396//4362 5397//4365 
f 5398//4368 4899//4369 4900//4370 
f 4900//4370 5397//4365 5398//4368 
f 5399//4371 4901//4372 4902//4373 
f 4902//4373 5398//4368 5399//4371 
f 5400//4374 4903//4375 4904//4376 
f 4904//4376 5399//4371 5400//4374 
f 5401//4377 4905//4378 4906//4379 
f 4906//4379 5400//4374 5401//4377 
f 5402//4380 4907//4381 4908//4382 
f 4908//4382 5401//4377 5402//4380 
f 5403//4383 4909//4384 4910//4385 
f 4910//4385 5402//4380 5403//4383 
f 5404//4386 4911//4387 4912//4388 
f 4912//4388 5403//4383 5404//4386 
f 5405//4389 4913//4390 4914//4391 
f 4914//4391 5404//4386 5405//4389 
f 5406//4392 4915//4393 4916//4394 
f 4916//4394 5405//4389 5406//4392 
f 5407//4395 4917//4396 4918//4397 
f 4918//4397 5406//4392 5407//4395 
f 5408//4398 4919//4399 4920//4400 
f 4920//4400 5407//4395 5408//4398 
f 5409//4401 4921//4402 4922//4403 
f 4922//4403 5408//4398 5409//4401 
f 5410//4404 4923//4405 4924//4406 
f 4924//4406 5409//4401 5410//4404 
f 5411//4407 4925//4408 4926//4409 
f 4926//4409 5410//4404 5411//4407 
f 5412//4410 4927//4411 4928//4412 
f 4928//4412 5411//4407 5412//4410 
f 5413//4413 4929//4414 4930//4415 
f 4930//4415 5412//4410 5413//4413 
f 5414//4416 4931//4417 4932//4418 
f 4932//4418 5413//4413 5414//4416 
f 5415//4419 4933//4420 4934//4421 
f 4934//4421 5414//4416 5415//4419 
f 5416//4422 4935//4423 4936//4424 
f 4936//4424 5415//4419 5416//4422 
f 5417//4425 4937//4426 4938//4427 
f 4938//4427 5416//4422 5417//4425 
f 5418//4428 4939//4429 4940//4430 
f 4940//4430 5417//4425 5418//4428 
f 5419//4431 4941//4432 4942//4433 
f 4942//4433 5418//4428 5419//4431 
f 5420//4434 4943//4435 4944//4436 
f 4944//4436 5419//4431 5420//4434 
f 5421//4437 4945//4438 4946//4439 
f 4946//4439 5420//4434 5421//4437 
f 5422//4440 4947//4441 4948//4442 
f 4948//4442 5421//4437 5422//4440 
f 4715//4443 4949//4444 4950//4445 
f 4949//4444 4715//4443 4717//4446 
f 4717//4446 4951//4447 4949//4444 
f 4952//4448 4951//4447 4716//4449 
f 4716//4449 4705//4450 4952//4448 
f 4952//4448 4705//4450 4704//4451 
f 4704//4451 4953//4452 4952//4448 
f 4710//4453 4954//4454 4953//4452 
f 4955//4455 4954//4454 4731//4456 
f 4954//4454 4710//4453 4731//4456 
f 4956//4457 4955//4455 4730//4458 
f 4730//4458 4744//4459 4956//4457 
f 4956//4457 4744//4459 4764//4460 
f 4764//4460 4957//4461 4956//4457 
f 4763//4462 4958//4463 4957//4461 
f 4959//4464 4958//4463 4762//4465 
f 4958//4463 4763//4462 4765//4466 
f 4765//4466 4762//4465 4958//4463 
f 4761//4467 4960//4468 4959//4464 
f 4960//4468 4743//4469 4742//4470 
f 4960//4468 4761//4467 4743//4469 
f 4742//4470 4961//4471 4960//4468 
f 4729//4472 4962//4473 4961//4471 
f 4962//4473 4729//4472 4728//4474 
f 4728//4474 4963//4475 4962//4473 
f 4741//4476 4964//4477 4963//4475 
f 4965//4478 4964//4477 4709//4479 
f 4964//4477 4741//4476 4709//4479 
f 4726//4480 4966//4481 4965//4478 
f 4965//4478 4708//4482 4726//4480 
f 4967//4483 4966//4481 4727//4484 
f 4966//4481 4726//4480 4727//4484 
f 5337//4200 4968//4485 4967//4483 
f 5337//4200 4727//4484 4723//4486 
f 5338//4201 5337//4200 4725//4487 
f 5337//4200 4722//4488 4725//4487 
f 4725//4487 4724//4489 5338//4201 
f 5338//4201 4774//4490 4760//4491 
f 4760//4491 5339//4204 5338//4201 
f 4760//4491 4759//4492 5339//4204 
f 5340//4207 5339//4204 4720//4493 
f 5339//4204 4721//4494 4720//4493 
f 5341//4210 4756//4495 4758//4496 
f 5340//4207 4740//4497 4756//4495 
f 4756//4495 5341//4210 5340//4207 
f 5341//4210 4757//4498 4784//4499 
f 4784//4499 5342//4213 5341//4210 
f 5343//4216 4771//4500 4773//4501 
f 5342//4213 4772//4502 4771//4500 
f 5342//4213 4789//4503 4772//4502 
f 4771//4500 5343//4216 5342//4213 
f 4773//4501 4969//4504 5343//4216 
f 4969//4504 4970//4505 5343//4216 
f 5343//4216 4971//4506 4972//4507 
f 4972//4507 5344//4219 5343//4216 
f 5343//4216 4973//4508 4971//4506 
f 4972//4507 4974//4509 5344//4219 
f 5345//4222 5344//4219 4975//4510 
f 5344//4219 4976//4511 4975//4510 
f 4975//4510 4977//4512 5345//4222 
f 5345//4222 4978//4513 4979//4514 
f 4979//4514 5346//4225 5345//4222 
f 5345//4222 4980//4515 4978//4513 
f 4979//4514 4981//4516 5346//4225 
f 5347//4228 5346//4225 4982//4517 
f 5346//4225 4983//4518 4982//4517 
f 4982//4517 4984//4519 5347//4228 
f 5348//4231 5347//4228 4985//4520 
f 4985//4520 4986//4521 5348//4231 
f 5347//4228 4987//4522 4988//4523 
f 4988//4523 4985//4520 5347//4228 
f 4986//4521 4989//4524 5348//4231 
f 5349//4234 5348//4231 4990//4525 
f 5348//4231 4991//4526 4990//4525 
f 4990//4525 4992//4527 5349//4234 
f 5350//4237 5349//4234 4993//4528 
f 4993//4528 4994//4529 5350//4237 
f 5349//4234 4995//4530 4996//4531 
f 4996//4531 4993//4528 5349//4234 
f 4994//4529 4997//4532 5350//4237 
f 5351//4240 5350//4237 4998//4533 
f 5350//4237 4999//4534 4998//4533 
f 4998//4533 5000//4535 5351//4240 
f 5352//4243 5351//4240 5001//4536 
f 5001//4536 5002//4537 5352//4243 
f 5351//4240 5003//4538 5004//4539 
f 5004//4539 5001//4536 5351//4240 
f 5002//4537 5005//4540 5352//4243 
f 5352//4243 5006//4541 5007//4542 
f 5007//4542 5353//4245 5352//4243 
f 5007//4542 5008//4543 5353//4245 
f 5354//4247 5353//4245 5009//4544 
f 5009//4544 5010//4545 5354//4247 
f 5353//4245 5011//4546 5012//4547 
f 5012//4547 5009//4544 5353//4245 
f 5010//4545 5013//4548 5354//4247 
f 5354//4247 5014//4549 5015//4550 
f 5015//4550 5355//4249 5354//4247 
f 5015//4550 5016//4551 5355//4249 
f 5356//4251 5355//4249 5017//4552 
f 5355//4249 5018//4553 5019//4554 
f 5019//4554 5017//4552 5355//4249 
f 5017//4552 5020//4555 5356//4251 
f 5356//4251 5021//4556 5022//4557 
f 5022//4557 5357//4253 5356//4251 
f 5022//4557 5023//4558 5357//4253 
f 5358//4255 5357//4253 5024//4559 
f 5357//4253 5025//4560 5026//4561 
f 5026//4561 5024//4559 5357//4253 
f 5024//4559 5027//4562 5358//4255 
f 5358//4255 5028//4563 5029//4564 
f 5029//4564 5359//4257 5358//4255 
f 5029//4564 5030//4565 5359//4257 
f 5360//4259 5359//4257 5031//4566 
f 5359//4257 5032//4567 5031//4566 
f 5359//4257 5033//4568 5032//4567 
f 5031//4566 5034//4569 5360//4259 
f 5360//4259 5035//4570 5036//4571 
f 5036//4571 5361//4261 5360//4259 
f 5360//4259 5037//4572 5035//4570 
f 5036//4571 5038//4573 5361//4261 
f 5362//4263 5361//4261 5039//4574 
f 5361//4261 5040//4575 5041//4576 
f 5041//4576 5039//4574 5361//4261 
f 5039//4574 5042//4577 5362//4263 
f 5362//4263 5043//4578 5044//4579 
f 5044//4579 5363//4265 5362//4263 
f 5362//4263 5045//4580 5043//4578 
f 5044//4579 5046//4581 5363//4265 
f 5364//4267 5363//4265 5047//4582 
f 5363//4265 5048//4583 5049//4584 
f 5049//4584 5047//4582 5363//4265 
f 5047//4582 5050//4585 5364//4267 
f 5364//4267 5051//4586 5052//4587 
f 5052//4587 5365//4269 5364//4267 
f 5364//4267 5053//4588 5051//4586 
f 5052//4587 5054//4589 5365//4269 
f 5365//4269 5055//4590 5056//4591 
f 5056//4591 5366//4272 5365//4269 
f 5365//4269 5057//4592 5055//4590 
f 5056//4591 5058//4593 5366//4272 
f 5367//4275 5366//4272 5059//4594 
f 5059//4594 5060//4595 5367//4275 
f 5366//4272 5061//4596 5059//4594 
f 5060//4595 5062//4597 5367//4275 
f 5367//4275 5063//4598 5064//4599 
f 5064//4599 5368//4278 5367//4275 
f 5064//4599 5065//4600 5368//4278 
f 5065//4600 5066//4601 5368//4278 
f 5369//4281 5067//4602 5068//4603 
f 5068//4603 5069//4604 5369//4281 
f 5369//4281 5368//4278 5070//4605 
f 5368//4278 5071//4606 5070//4605 
f 5070//4605 5067//4602 5369//4281 
f 5369//4281 5072//4607 5073//4608 
f 5073//4608 5370//4284 5369//4281 
f 5073//4608 5074//4609 5370//4284 
f 5074//4609 5075//4610 5370//4284 
f 5371//4287 5370//4284 5076//4611 
f 5076//4611 5077//4612 5371//4287 
f 5370//4284 5078//4613 5076//4611 
f 5077//4612 5079//4614 5371//4287 
f 5371//4287 5080//4615 5081//4616 
f 5081//4616 5372//4290 5371//4287 
f 5081//4616 5082//4617 5372//4290 
f 5082//4617 5083//4618 5372//4290 
f 5373//4293 5084//4619 5085//4620 
f 5373//4293 5372//4290 5086//4621 
f 5372//4290 5087//4622 5086//4621 
f 5086//4621 5084//4619 5373//4293 
f 5373//4293 5088//4623 5089//4624 
f 5089//4624 5374//4296 5373//4293 
f 5089//4624 5090//4625 5374//4296 
f 5090//4625 5091//4626 5374//4296 
f 5375//4299 5374//4296 5092//4627 
f 5374//4296 5093//4628 5092//4627 
f 5092//4627 5094//4629 5375//4299 
f 5375//4299 5095//4630 5096//4631 
f 5096//4631 5376//4302 5375//4299 
f 5096//4631 5097//4632 5376//4302 
f 5097//4632 5098//4633 5376//4302 
f 5377//4305 5376//4302 5099//4634 
f 5376//4302 5100//4635 5099//4634 
f 5099//4634 5101//4636 5377//4305 
f 5377//4305 5102//4637 5103//4638 
f 5103//4638 5378//4308 5377//4305 
f 5103//4638 5104//4639 5378//4308 
f 5104//4639 5105//4640 5378//4308 
f 5379//4311 5378//4308 5106//4641 
f 5378//4308 5107//4642 5106//4641 
f 5106//4641 5108//4643 5379//4311 
f 5379//4311 5109//4644 5110//4645 
f 5379//4311 5111//4646 5109//4644 
f 5110//4645 5380//4314 5379//4311 
f 5110//4645 5112//4647 5380//4314 
f 5112//4647 5113//4648 5380//4314 
f 5381//4317 5380//4314 5114//4649 
f 5380//4314 5115//4650 5114//4649 
f 5114//4649 5116//4651 5381//4317 
f 5381//4317 5117//4652 5118//4653 
f 5381//4317 5119//4654 5117//4652 
f 5118//4653 5382//4320 5381//4317 
f 5118//4653 5120//4655 5382//4320 
f 5120//4655 5121//4656 5382//4320 
f 5383//4323 5382//4320 5122//4657 
f 5382//4320 5123//4658 5122//4657 
f 5122//4657 5124//4659 5383//4323 
f 5383//4323 5125//4660 5126//4661 
f 5383//4323 5127//4662 5125//4660 
f 5126//4661 5384//4326 5383//4323 
f 5126//4661 5128//4663 5384//4326 
f 5128//4663 5129//4664 5384//4326 
f 5384//4326 5130//4665 5131//4666 
f 5131//4666 5385//4329 5384//4326 
f 5131//4666 5132//4667 5385//4329 
f 5386//4332 5385//4329 5133//4668 
f 5385//4329 5134//4669 5133//4668 
f 5133//4668 5135//4670 5386//4332 
f 5135//4670 5136//4671 5386//4332 
f 5136//4671 5137//4672 5386//4332 
f 5386//4332 5138//4673 5139//4674 
f 5139//4674 5387//4335 5386//4332 
f 5139//4674 5140//4675 5387//4335 
f 5388//4338 5141//4676 5142//4677 
f 5388//4338 5387//4335 5143//4678 
f 5387//4335 5144//4679 5143//4678 
f 5143//4678 5145//4680 5388//4338 
f 5145//4680 5141//4676 5388//4338 
f 5388//4338 5146//4681 5147//4682 
f 5147//4682 5389//4341 5388//4338 
f 5147//4682 5148//4683 5389//4341 
f 5390//4344 5149//4684 5150//4685 
f 5390//4344 5389//4341 5151//4686 
f 5389//4341 5152//4687 5151//4686 
f 5151//4686 5153//4688 5390//4344 
f 5153//4688 5149//4684 5390//4344 
f 5390//4344 5154//4689 5155//4690 
f 5155//4690 5391//4347 5390//4344 
f 5155//4690 5156//4691 5391//4347 
f 5392//4350 5391//4347 5157//4692 
f 5391//4347 5158//4693 5157//4692 
f 5157//4692 5159//4694 5392//4350 
f 5159//4694 5160//4695 5392//4350 
f 5392//4350 5161//4696 5162//4697 
f 5162//4697 5393//4353 5392//4350 
f 5392//4350 5163//4698 5161//4696 
f 5162//4697 5164//4699 5393//4353 
f 5164//4699 5165//4700 5393//4353 
f 5394//4356 5166//4701 5167//4702 
f 5394//4356 5393//4353 5168//4703 
f 5393//4353 5169//4704 5168//4703 
f 5168//4703 5166//4701 5394//4356 
f 5394//4356 5170//4705 5171//4706 
f 5171//4706 5395//4359 5394//4356 
f 5394//4356 5172//4707 5170//4705 
f 5171//4706 5173//4708 5395//4359 
f 5396//4362 5174//4709 5175//4710 
f 5396//4362 5395//4359 5176//4711 
f 5395//4359 5177//4712 5176//4711 
f 5176//4711 5174//4709 5396//4362 
f 5396//4362 5178//4713 5179//4714 
f 5179//4714 5397//4365 5396//4362 
f 5396//4362 5180//4715 5178//4713 
f 5179//4714 5181//4716 5397//4365 
f 5398//4368 5397//4365 5182//4717 
f 5397//4365 5183//4718 5182//4717 
f 5182//4717 5184//4719 5398//4368 
f 5398//4368 5185//4720 5186//4721 
f 5186//4721 5399//4371 5398//4368 
f 5398//4368 5187//4722 5188//4723 
f 5188//4723 5185//4720 5398//4368 
f 5186//4721 5189//4724 5399//4371 
f 5400//4374 5399//4371 5190//4725 
f 5399//4371 5191//4726 5190//4725 
f 5190//4725 5192//4727 5400//4374 
f 5400//4374 5193//4728 5194//4729 
f 5194//4729 5401//4377 5400//4374 
f 5400//4374 5195//4730 5196//4731 
f 5196//4731 5193//4728 5400//4374 
f 5194//4729 5197//4732 5401//4377 
f 5402//4380 5401//4377 5198//4733 
f 5401//4377 5199//4734 5198//4733 
f 5198//4733 5200//4735 5402//4380 
f 5402//4380 5201//4736 5202//4737 
f 5202//4737 5403//4383 5402//4380 
f 5402//4380 5203//4738 5204//4739 
f 5204//4739 5201//4736 5402//4380 
f 5202//4737 5205//4740 5403//4383 
f 5404//4386 5403//4383 5206//4741 
f 5403//4383 5207//4742 5206//4741 
f 5206//4741 5208//4743 5404//4386 
f 5405//4389 5404//4386 5209//4744 
f 5209//4744 5210//4745 5405//4389 
f 5404//4386 5211//4746 5212//4747 
f 5212//4747 5209//4744 5404//4386 
f 5210//4745 5213//4748 5405//4389 
f 5406//4392 5405//4389 5214//4749 
f 5405//4389 5215//4750 5214//4749 
f 5214//4749 5216//4751 5406//4392 
f 5407//4395 5406//4392 5217//4752 
f 5217//4752 5218//4753 5407//4395 
f 5406//4392 5219//4754 5220//4755 
f 5220//4755 5217//4752 5406//4392 
f 5218//4753 5221//4756 5407//4395 
f 5408//4398 5407//4395 5222//4757 
f 5407//4395 5223//4758 5222//4757 
f 5222//4757 5224//4759 5408//4398 
f 5409//4401 5408//4398 5225//4760 
f 5225//4760 5226//4761 5409//4401 
f 5408//4398 5227//4762 5228//4763 
f 5228//4763 5225//4760 5408//4398 
f 5226//4761 5229//4764 5409//4401 
f 5409//4401 5230//4765 5231//4766 
f 5231//4766 5410//4404 5409//4401 
f 5231//4766 5232//4767 5410//4404 
f 5411//4407 5410//4404 5233//4768 
f 5233//4768 5234//4769 5411//4407 
f 5410//4404 5235//4770 5236//4771 
f 5236//4771 5233//4768 5410//4404 
f 5234//4769 5237//4772 5411//4407 
f 5411//4407 5238//4773 5239//4774 
f 5239//4774 5412//4410 5411//4407 
f 5239//4774 5240//4775 5412//4410 
f 5413//4413 5241//4776 5242//4777 
f 5413//4413 5412//4410 5243//4778 
f 5412//4410 5244//4779 5245//4780 
f 5245//4780 5243//4778 5412//4410 
f 5243//4778 5241//4776 5413//4413 
f 5414//4416 5246//4781 5247//4782 
f 5413//4413 5248//4783 5249//4784 
f 5249//4784 5414//4416 5413//4413 
f 5249//4784 5246//4781 5414//4416 
f 5415//4419 5250//4785 5251//4786 
f 5415//4419 5414//4416 5252//4787 
f 5414//4416 5253//4788 5252//4787 
f 5252//4787 5250//4785 5415//4419 
f 5415//4419 5254//4789 5255//4790 
f 5255//4790 5416//4422 5415//4419 
f 5255//4790 5256//4791 5416//4422 
f 5417//4425 5416//4422 5257//4792 
f 5416//4422 5258//4793 5257//4792 
f 5416//4422 5259//4794 5258//4793 
f 5257//4792 5260//4795 5417//4425 
f 5417//4425 5261//4796 5262//4797 
f 5262//4797 5418//4428 5417//4425 
f 5262//4797 5263//4798 5418//4428 
f 5419//4431 5418//4428 5264//4799 
f 5418//4428 5265//4800 5266//4801 
f 5266//4801 5264//4799 5418//4428 
f 5264//4799 5267//4802 5419//4431 
f 5419//4431 5268//4803 5269//4804 
f 5269//4804 5420//4434 5419//4431 
f 5419//4431 5270//4805 5268//4803 
f 5269//4804 5271//4806 5420//4434 
f 5421//4437 5420//4434 5272//4807 
f 5420//4434 5273//4808 5272//4807 
f 5272//4807 5274//4809 5421//4437 
f 5421//4437 5275//4810 5276//4811 
f 5276//4811 5422//4440 5421//4437 
f 5276//4811 5277//4812 5422//4440 
f 5423//4813 5422//4440 5278//4814 
f 5422//4440 5279//4815 5278//4814 
f 5278//4814 5280//4816 5423//4813 
f 5423//4813 5281//4817 5282//4818 
f 5423//4813 5283//4819 5281//4817 
f 5282//4818 5424//4820 5423//4813 
f 5282//4818 5284//4821 5424//4820 
f 5425//4822 5424//4820 5285//4823 
f 5424//4820 5286//4824 5285//4823 
f 5285//4823 5287//4825 5425//4822 
f 5425//4822 5288//4826 5289//4827 
f 5425//4822 5290//4828 5288//4826 
f 5289//4827 5426//4829 5425//4822 
f 5289//4827 5291//4830 5426//4829 
f 5427//4831 5426//4829 5292//4832 
f 5426//4829 5293//4833 5292//4832 
f 5292//4832 5294//4834 5427//4831 
f 5427//4831 5295//4835 5296//4836 
f 5427//4831 5297//4837 5295//4835 
f 5296//4836 5428//4838 5427//4831 
f 5296//4836 5298//4839 5428//4838 
f 5429//4840 5428//4838 5299//4841 
f 5428//4838 5300//4842 5299//4841 
f 5299//4841 5301//4843 5429//4840 
f 5429//4840 5302//4844 5303//4845 
f 5429//4840 5304//4846 5302//4844 
f 5303//4845 5430//4847 5429//4840 
f 5303//4845 5305//4848 5430//4847 
f 5430//4847 5306//4849 5307//4850 
f 5307//4850 5431//4851 5430//4847 
f 5430//4847 5308//4852 5309//4853 
f 5309//4853 5306//4849 5430//4847 
f 5310//4854 5311//4855 5312//4856 
f 5430//4847 5313//4857 5314//4858 
f 5431//4851 5315//4859 5313//4857 
f 5313//4857 5430//4847 5431//4851 
f 5430//4847 5316//4860 5317//4861 
f 5317//4861 5429//4840 5430//4847 
f 5428//4838 5429//4840 5318//4862 
f 5429//4840 5319//4863 5318//4862 
f 5318//4862 5320//4864 5428//4838 
f 5428//4838 5321//4865 5322//4866 
f 5322//4866 5427//4831 5428//4838 
f 5322//4866 5323//4867 5427//4831 
f 5426//4829 5427//4831 5324//4868 
f 5427//4831 5325//4869 5324//4868 
f 5426//4829 5326//4870 5327//4871 
f 5426//4829 5328//4872 5326//4870 
f 5327//4871 5425//4822 5426//4829 
f 5425//4822 5329//4873 5330//4874 
f 5330//4874 5424//4820 5425//4822 
f 5423//4813 5424//4820 5331//4875 
f 5331//4875 5332//4876 5423//4813 
f 5424//4820 5333//4877 5331//4875 
f 5422//4440 5423//4813 5334//4878 
f 5334//4878 5335//4879 5422//4440 
f 5423//4813 5336//4880 5334//4878 
f 5335//4879 4947//4441 5422//4440 
f 5332//4876 5336//4880 5423//4813 
f 5330//4874 5333//4877 5424//4820 
f 5327//4871 5329//4873 5425//4822 
f 5324//4868 5328//4872 5426//4829 
f 5323//4867 5325//4869 5427//4831 
f 5320//4864 5321//4865 5428//4838 
f 5317//4861 5319//4863 5429//4840 
f 5314//4858 5316//4860 5430//4847 
f 5315//4859 5431//4851 5312//4856 
f 5312//4856 5431//4851 5310//4854 
f 5307//4850 5310//4854 5431//4851 
f 5305//4848 5308//4852 5430//4847 
f 5301//4843 5304//4846 5429//4840 
f 5298//4839 5300//4842 5428//4838 
f 5294//4834 5297//4837 5427//4831 
f 5291//4830 5293//4833 5426//4829 
f 5287//4825 5290//4828 5425//4822 
f 5284//4821 5286//4824 5424//4820 
f 5280//4816 5283//4819 5423//4813 
f 5277//4812 5279//4815 5422//4440 
f 5274//4809 5275//4810 5421//4437 
f 5271//4806 5273//4808 5420//4434 
f 5267//4802 5270//4805 5419//4431 
f 5263//4798 5265//4800 5418//4428 
f 5260//4795 5261//4796 5417//4425 
f 5256//4791 5259//4794 5416//4422 
f 5251//4786 5254//4789 5415//4419 
f 5247//4782 5253//4788 5414//4416 
f 5242//4777 5248//4783 5413//4413 
f 5240//4775 5244//4779 5412//4410 
f 5237//4772 5238//4773 5411//4407 
f 5232//4767 5235//4770 5410//4404 
f 5229//4764 5230//4765 5409//4401 
f 5224//4759 5227//4762 5408//4398 
f 5221//4756 5223//4758 5407//4395 
f 5216//4751 5219//4754 5406//4392 
f 5213//4748 5215//4750 5405//4389 
f 5208//4743 5211//4746 5404//4386 
f 5205//4740 5207//4742 5403//4383 
f 5200//4735 5203//4738 5402//4380 
f 5197//4732 5199//4734 5401//4377 
f 5192//4727 5195//4730 5400//4374 
f 5189//4724 5191//4726 5399//4371 
f 5184//4719 5187//4722 5398//4368 
f 5181//4716 5183//4718 5397//4365 
f 5175//4710 5180//4715 5396//4362 
f 5173//4708 5177//4712 5395//4359 
f 5167//4702 5172//4707 5394//4356 
f 5165//4700 5169//4704 5393//4353 
f 5160//4695 5163//4698 5392//4350 
f 5156//4691 5158//4693 5391//4347 
f 5150//4685 5154//4689 5390//4344 
f 5148//4683 5152//4687 5389//4341 
f 5142//4677 5146//4681 5388//4338 
f 5140//4675 5144//4679 5387//4335 
f 5137//4672 5138//4673 5386//4332 
f 5132//4667 5134//4669 5385//4329 
f 5129//4664 5130//4665 5384//4326 
f 5124//4659 5127//4662 5383//4323 
f 5121//4656 5123//4658 5382//4320 
f 5116//4651 5119//4654 5381//4317 
f 5113//4648 5115//4650 5380//4314 
f 5108//4643 5111//4646 5379//4311 
f 5105//4640 5107//4642 5378//4308 
f 5101//4636 5102//4637 5377//4305 
f 5098//4633 5100//4635 5376//4302 
f 5094//4629 5095//4630 5375//4299 
f 5091//4626 5093//4628 5374//4296 
f 5085//4620 5088//4623 5373//4293 
f 5083//4618 5087//4622 5372//4290 
f 5079//4614 5080//4615 5371//4287 
f 5075//4610 5078//4613 5370//4284 
f 5069//4604 5072//4607 5369//4281 
f 5066//4601 5071//4606 5368//4278 
f 5062//4597 5063//4598 5367//4275 
f 5058//4593 5061//4596 5366//4272 
f 5054//4589 5057//4592 5365//4269 
f 5050//4585 5053//4588 5364//4267 
f 5046//4581 5048//4583 5363//4265 
f 5042//4577 5045//4580 5362//4263 
f 5038//4573 5040//4575 5361//4261 
f 5034//4569 5037//4572 5360//4259 
f 5030//4565 5033//4568 5359//4257 
f 5027//4562 5028//4563 5358//4255 
f 5023//4558 5025//4560 5357//4253 
f 5020//4555 5021//4556 5356//4251 
f 5016//4551 5018//4553 5355//4249 
f 5013//4548 5014//4549 5354//4247 
f 5008//4543 5011//4546 5353//4245 
f 5005//4540 5006//4541 5352//4243 
f 5000//4535 5003//4538 5351//4240 
f 4997//4532 4999//4534 5350//4237 
f 4992//4527 4995//4530 5349//4234 
f 4989//4524 4991//4526 5348//4231 
f 4984//4519 4987//4522 5347//4228 
f 4981//4516 4983//4518 5346//4225 
f 4977//4512 4980//4515 5345//4222 
f 4974//4509 4976//4511 5344//4219 
f 4970//4505 4973//4508 5343//4216 
f 4784//4499 4789//4503 5342//4213 
f 4758//4496 4757//4498 5341//4210 
f 4720//4493 4740//4497 5340//4207 
f 4759//4492 4721//4494 5339//4204 
f 4724//4489 4774//4490 5338//4201 
f 4723//4486 4722//4488 5337//4200 
f 4727//4484 5337//4200 4967//4483 
f 4709//4479 4708//4482 4965//4478 
f 4728//4474 4741//4476 4963//4475 
f 4742//4470 4729//4472 4961//4471 
f 4762//4465 4761//4467 4959//4464 
f 4764//4460 4763//4462 4957//4461 
f 4731//4456 4730//4458 4955//4455 
f 4704//4451 4710//4453 4953//4452 
f 4717//4446 4716//4449 4951//4447 
f 4950//4445 4713//4881 4715//4443 
f 4948//4442 4945//4438 5421//4437 
f 4946//4439 4943//4435 5420//4434 
f 4944//4436 4941//4432 5419//4431 
f 4942//4433 4939//4429 5418//4428 
f 4940//4430 4937//4426 5417//4425 
f 4938//4427 4935//4423 5416//4422 
f 4936//4424 4933//4420 5415//4419 
f 4934//4421 4931//4417 5414//4416 
f 4932//4418 4929//4414 5413//4413 
f 4930//4415 4927//4411 5412//4410 
f 4928//4412 4925//4408 5411//4407 
f 4926//4409 4923//4405 5410//4404 
f 4924//4406 4921//4402 5409//4401 
f 4922//4403 4919//4399 5408//4398 
f 4920//4400 4917//4396 5407//4395 
f 4918//4397 4915//4393 5406//4392 
f 4916//4394 4913//4390 5405//4389 
f 4914//4391 4911//4387 5404//4386 
f 4912//4388 4909//4384 5403//4383 
f 4910//4385 4907//4381 5402//4380 
f 4908//4382 4905//4378 5401//4377 
f 4906//4379 4903//4375 5400//4374 
f 4904//4376 4901//4372 5399//4371 
f 4902//4373 4899//4369 5398//4368 
f 4900//4370 4897//4366 5397//4365 
f 4898//4367 4895//4363 5396//4362 
f 4896//4364 4893//4360 5395//4359 
f 4894//4361 4891//4357 5394//4356 
f 4892//4358 4889//4354 5393//4353 
f 4890//4355 4887//4351 5392//4350 
f 4888//4352 4885//4348 5391//4347 
f 4886//4349 4883//4345 5390//4344 
f 4884//4346 4881//4342 5389//4341 
f 4882//4343 4879//4339 5388//4338 
f 4880//4340 4877//4336 5387//4335 
f 4878//4337 4875//4333 5386//4332 
f 4876//4334 4873//4330 5385//4329 
f 4874//4331 4871//4327 5384//4326 
f 4872//4328 4869//4324 5383//4323 
f 4870//4325 4867//4321 5382//4320 
f 4868//4322 4865//4318 5381//4317 
f 4866//4319 4863//4315 5380//4314 
f 4864//4316 4861//4312 5379//4311 
f 4862//4313 4859//4309 5378//4308 
f 4860//4310 4857//4306 5377//4305 
f 4858//4307 4855//4303 5376//4302 
f 4856//4304 4853//4300 5375//4299 
f 4854//4301 4851//4297 5374//4296 
f 4852//4298 4849//4294 5373//4293 
f 4850//4295 4847//4291 5372//4290 
f 4848//4292 4845//4288 5371//4287 
f 4846//4289 4843//4285 5370//4284 
f 4844//4286 4841//4282 5369//4281 
f 4842//4283 4839//4279 5368//4278 
f 4840//4280 4837//4276 5367//4275 
f 4838//4277 4835//4273 5366//4272 
f 4836//4274 4833//4270 5365//4269 
f 4834//4271 4832//4268 5364//4267 
f 4831//4266 5363//4265 5364//4267 
f 4830//4264 5362//4263 5363//4265 
f 4829//4262 5361//4261 5362//4263 
f 4828//4260 5360//4259 5361//4261 
f 4827//4258 5359//4257 5360//4259 
f 4826//4256 5358//4255 5359//4257 
f 4825//4254 5357//4253 5358//4255 
f 4824//4252 5356//4251 5357//4253 
f 4823//4250 5355//4249 5356//4251 
f 4822//4248 5354//4247 5355//4249 
f 4821//4246 5353//4245 5354//4247 
f 4820//4244 5352//4243 5353//4245 
f 4819//4242 5351//4240 5352//4243 
f 4818//4241 4817//4239 5350//4237 
f 4816//4238 4815//4236 5349//4234 
f 4814//4235 4813//4233 5348//4231 
f 4812//4232 4811//4230 5347//4228 
f 4810//4229 4809//4227 5346//4225 
f 4808//4226 4807//4224 5345//4222 
f 4806//4223 4805//4221 5344//4219 
f 4804//4220 4803//4218 5343//4216 
f 4802//4217 4801//4215 5342//4213 
f 4800//4214 4799//4212 5341//4210 
f 4798//4211 4797//4209 5340//4207 
f 4796//4208 4795//4206 5339//4204 
f 4794//4205 4793//4203 5338//4201 
f 4792//4202 4968//4485 5337//4200 
o mesh290
f 5850//4882 5851//4883 4949//4884 
f 5851//4883 4950//4885 4949//4884 
f 5852//4886 5850//4882 4952//4887 
f 5850//4882 4951//4888 4952//4887 
f 5853//4889 5852//4886 4954//4890 
f 5852//4886 4953//4891 4954//4890 
f 5854//4892 5853//4889 4956//4893 
f 5853//4889 4955//4894 4956//4893 
f 5855//4895 5854//4892 4958//4896 
f 5854//4892 4957//4897 4958//4896 
f 5856//4898 5855//4895 4960//4899 
f 5855//4895 4959//4900 4960//4899 
f 5857//4901 5856//4898 4962//4902 
f 5856//4898 4961//4903 4962//4902 
f 5858//4904 5857//4901 4964//4905 
f 5857//4901 4963//4906 4964//4905 
f 5859//4907 5858//4904 4966//4908 
f 5858//4904 4965//4909 4966//4908 
f 5860//4910 5859//4907 4968//4911 
f 5859//4907 4967//4912 4968//4911 
f 5861//4913 5860//4910 4793//4914 
f 5860//4910 4792//4915 4793//4914 
f 5862//4916 5861//4913 4795//4917 
f 5861//4913 4794//4918 4795//4917 
f 5863//4919 5862//4916 4797//4920 
f 5862//4916 4796//4921 4797//4920 
f 5864//4922 5863//4919 4799//4923 
f 5863//4919 4798//4924 4799//4923 
f 5865//4925 5864//4922 4801//4926 
f 5864//4922 4800//4927 4801//4926 
f 5866//4928 5865//4925 4803//4929 
f 5865//4925 4802//4930 4803//4929 
f 5867//4931 5866//4928 4805//4932 
f 5866//4928 4804//4933 4805//4932 
f 5868//4934 5867//4931 4807//4935 
f 5867//4931 4806//4936 4807//4935 
f 5869//4937 5868//4934 4809//4938 
f 5868//4934 4808//4939 4809//4938 
f 5870//4940 5869//4937 4811//4941 
f 5869//4937 4810//4942 4811//4941 
f 5871//4943 5870//4940 4813//4944 
f 5870//4940 4812//4945 4813//4944 
f 5872//4946 5871//4943 4815//4947 
f 5871//4943 4814//4948 4815//4947 
f 5873//4949 5872//4946 4817//4950 
f 5872//4946 4816//4951 4817//4950 
f 5874//4952 5873//4949 4819//4953 
f 5873//4949 4818//4954 4819//4953 
f 5875//4955 5874//4952 4820//4956 
f 5876//4957 5875//4955 4821//4958 
f 5877//4959 5876//4957 4822//4960 
f 5877//4959 4823//4961 4824//4962 
f 5878//4963 4824//4962 4825//4964 
f 5879//4965 4825//4964 4826//4966 
f 5880//4967 4826//4966 4827//4968 
f 5881//4969 4827//4968 4828//4970 
f 5882//4971 4828//4970 4829//4972 
f 5883//4973 4829//4972 4830//4974 
f 5884//4975 4830//4974 4831//4976 
f 5885//4977 4831//4976 4832//4978 
f 4832//4978 5886//4979 5885//4977 
f 5886//4979 4834//4980 4833//4981 
f 4833//4981 5887//4982 5886//4979 
f 5887//4982 4836//4983 4835//4984 
f 4835//4984 5888//4985 5887//4982 
f 5888//4985 4838//4986 4837//4987 
f 4837//4987 5889//4988 5888//4985 
f 5889//4988 4840//4989 4839//4990 
f 4839//4990 5890//4991 5889//4988 
f 5890//4991 4842//4992 4841//4993 
f 4841//4993 5891//4994 5890//4991 
f 5891//4994 4844//4995 4843//4996 
f 4843//4996 5892//4997 5891//4994 
f 5892//4997 4846//4998 4845//4999 
f 4845//4999 5893//5000 5892//4997 
f 5893//5000 4848//5001 4847//5002 
f 4847//5002 5894//5003 5893//5000 
f 5894//5003 4850//5004 4849//5005 
f 4849//5005 5895//5006 5894//5003 
f 5895//5006 4852//5007 4851//5008 
f 4851//5008 5896//5009 5895//5006 
f 5896//5009 4854//5010 4853//5011 
f 4853//5011 5897//5012 5896//5009 
f 5897//5012 4856//5013 4855//5014 
f 4855//5014 5898//5015 5897//5012 
f 5898//5015 4858//5016 4857//5017 
f 4857//5017 5899//5018 5898//5015 
f 5899//5018 4860//5019 4859//5020 
f 4859//5020 5900//5021 5899//5018 
f 5900//5021 4862//5022 4861//5023 
f 4861//5023 5901//5024 5900//5021 
f 5901//5024 4864//5025 4863//5026 
f 4863//5026 5902//5027 5901//5024 
f 5902//5027 4866//5028 4865//5029 
f 4865//5029 5903//5030 5902//5027 
f 5903//5030 4868//5031 4867//5032 
f 4867//5032 5904//5033 5903//5030 
f 5904//5033 4870//5034 4869//5035 
f 4869//5035 5905//5036 5904//5033 
f 5905//5036 4872//5037 4871//5038 
f 4871//5038 5906//5039 5905//5036 
f 5906//5039 4874//5040 4873//5041 
f 4873//5041 5907//5042 5906//5039 
f 5907//5042 4876//5043 4875//5044 
f 4875//5044 5908//5045 5907//5042 
f 5908//5045 4878//5046 4877//5047 
f 4877//5047 5909//5048 5908//5045 
f 5909//5048 4880//5049 4879//5050 
f 4879//5050 5910//5051 5909//5048 
f 5910//5051 4882//5052 4881//5053 
f 4881//5053 5911//5054 5910//5051 
f 5911//5054 4884//5055 4883//5056 
f 4883//5056 5912//5057 5911//5054 
f 5912//5057 4886//5058 4885//5059 
f 4885//5059 5913//5060 5912//5057 
f 5913//5060 4888//5061 4887//5062 
f 4887//5062 5914//5063 5913//5060 
f 5914//5063 4890//5064 4889//5065 
f 4889//5065 5915//5066 5914//5063 
f 5915//5066 4892//5067 4891//5068 
f 4891//5068 5916//5069 5915//5066 
f 5916//5069 4894//5070 4893//5071 
f 4893//5071 5917//5072 5916//5069 
f 5917//5072 4896//5073 4895//5074 
f 4895//5074 5918//5075 5917//5072 
f 5918//5075 4898//5076 4897//5077 
f 4897//5077 5919//5078 5918//5075 
f 5919//5078 4900//5079 4899//5080 
f 4899//5080 5920//5081 5919//5078 
f 5920//5081 4902//5082 4901//5083 
f 4901//5083 5921//5084 5920//5081 
f 5921//5084 4904//5085 4903//5086 
f 4903//5086 5922//5087 5921//5084 
f 5922//5087 4906//5088 4905//5089 
f 4905//5089 5923//5090 5922//5087 
f 5923//5090 4908//5091 4907//5092 
f 4907//5092 5924//5093 5923//5090 
f 5924//5093 4910//5094 4909//5095 
f 4909//5095 5925//5096 5924//5093 
f 5925//5096 4912//5097 4911//5098 
f 4911//5098 5926//5099 5925//5096 
f 5926//5099 4914//5100 4913//5101 
f 4913//5101 5927//5102 5926//5099 
f 5927//5102 4916//5103 4915//5104 
f 4915//5104 5928//5105 5927//5102 
f 5928//5105 4918//5106 4917//5107 
f 4917//5107 5929//5108 5928//5105 
f 5929//5108 4920//5109 4919//5110 
f 4919//5110 5930//5111 5929//5108 
f 5930//5111 4922//5112 4921//5113 
f 4921//5113 5931//5114 5930//5111 
f 5931//5114 4924//5115 4923//5116 
f 4923//5116 5932//5117 5931//5114 
f 5932//5117 4926//5118 4925//5119 
f 4925//5119 5933//5120 5932//5117 
f 5933//5120 4928//5121 4927//5122 
f 4927//5122 5934//5123 5933//5120 
f 5934//5123 4930//5124 4929//5125 
f 4929//5125 5935//5126 5934//5123 
f 5936//5127 4748//5128 4751//5129 
f 5937//5130 5936//5127 4778//5131 
f 5936//5127 4750//5132 4778//5131 
f 4778//5131 4767//5133 5937//5130 
f 5937//5130 4732//5134 4746//5135 
f 4746//5135 5938//5136 5937//5130 
f 5939//5137 5938//5136 4733//5138 
f 5938//5136 4745//5139 4733//5138 
f 5939//5137 4747//5140 4791//5141 
f 4791//5141 5940//5142 5939//5137 
f 5941//5143 5940//5142 4785//5144 
f 5940//5142 4790//5145 4785//5144 
f 4785//5144 4766//5146 5941//5143 
f 5941//5143 4775//5147 4777//5148 
f 4777//5148 5942//5149 5941//5143 
f 5943//5150 5942//5149 4712//5151 
f 5942//5149 4776//5152 4712//5151 
f 5943//5150 4714//5153 4713//5154 
f 4713//5154 5851//4883 5943//5150 
f 5943//5150 4711//5155 4714//5153 
f 5432//5156 5433//5157 4947//5158 
f 4948//5159 4947//5158 5433//5157 
f 5433//5157 5434//5160 4948//5159 
f 4948//5159 5434//5160 5435//5161 
f 5436//5162 4946//5163 4945//5164 
f 4945//5164 5435//5161 5436//5162 
f 5436//5162 5437//5165 4946//5163 
f 5437//5165 5438//5166 4943//5167 
f 4944//5168 4943//5167 5438//5166 
f 5438//5166 5439//5169 4944//5168 
f 4944//5168 5439//5169 5440//5170 
f 5441//5171 4942//5172 4941//5173 
f 4941//5173 5440//5170 5441//5171 
f 5441//5171 5442//5174 4942//5172 
f 5442//5174 5443//5175 4939//5176 
f 4940//5177 4939//5176 5443//5175 
f 5443//5175 5444//5178 4940//5177 
f 4940//5177 5444//5178 5445//5179 
f 5446//5180 4938//5181 4937//5182 
f 4937//5182 5445//5179 5446//5180 
f 5446//5180 5447//5183 4938//5181 
f 5447//5183 5448//5184 4935//5185 
f 4936//5186 4935//5185 5448//5184 
f 5448//5184 5449//5187 4936//5186 
f 4936//5186 5449//5187 5450//5188 
f 4933//5189 5450//5188 5451//5190 
f 5451//5190 4934//5191 4933//5189 
f 5451//5190 5452//5192 4934//5191 
f 5452//5192 5453//5193 4931//5194 
f 5453//5193 5935//5126 4932//5195 
f 4932//5195 4931//5194 5453//5193 
f 5935//5126 5453//5193 5454//5196 
f 5454//5196 5455//5197 5935//5126 
f 5453//5193 5456//5198 5454//5196 
f 5934//5123 5935//5126 5457//5199 
f 5457//5199 5458//5200 5934//5123 
f 5935//5126 5455//5197 5459//5201 
f 5459//5201 5457//5199 5935//5126 
f 5933//5120 5934//5123 5460//5202 
f 5460//5202 5461//5203 5933//5120 
f 5934//5123 5462//5204 5460//5202 
f 5932//5117 5463//5205 5464//5206 
f 5464//5206 5465//5207 5932//5117 
f 5933//5120 5466//5208 5463//5205 
f 5463//5205 5932//5117 5933//5120 
f 5931//5114 5932//5117 5467//5209 
f 5467//5209 5468//5210 5931//5114 
f 5932//5117 5469//5211 5470//5212 
f 5470//5212 5467//5209 5932//5117 
f 5930//5111 5931//5114 5471//5213 
f 5931//5114 5472//5214 5471//5213 
f 5931//5114 5473//5215 5472//5214 
f 5929//5108 5930//5111 5474//5216 
f 5474//5216 5475//5217 5929//5108 
f 5930//5111 5476//5218 5477//5219 
f 5477//5219 5478//5220 5930//5111 
f 5478//5220 5474//5216 5930//5111 
f 5929//5108 5479//5221 5480//5222 
f 5480//5222 5928//5105 5929//5108 
f 5929//5108 5481//5223 5479//5221 
f 5927//5102 5928//5105 5482//5224 
f 5482//5224 5483//5225 5927//5102 
f 5928//5105 5484//5226 5485//5227 
f 5485//5227 5486//5228 5928//5105 
f 5486//5228 5482//5224 5928//5105 
f 5927//5102 5487//5229 5488//5230 
f 5488//5230 5926//5099 5927//5102 
f 5927//5102 5489//5231 5487//5229 
f 5925//5096 5926//5099 5490//5232 
f 5490//5232 5491//5233 5925//5096 
f 5926//5099 5492//5234 5493//5235 
f 5493//5235 5490//5232 5926//5099 
f 5925//5096 5494//5236 5495//5237 
f 5495//5237 5924//5093 5925//5096 
f 5925//5096 5496//5238 5494//5236 
f 5923//5090 5924//5093 5497//5239 
f 5924//5093 5498//5240 5497//5239 
f 5497//5239 5499//5241 5923//5090 
f 5924//5093 5500//5242 5498//5240 
f 5923//5090 5501//5243 5502//5244 
f 5502//5244 5922//5087 5923//5090 
f 5923//5090 5503//5245 5501//5243 
f 5921//5084 5922//5087 5504//5246 
f 5922//5087 5505//5247 5506//5248 
f 5506//5248 5504//5246 5922//5087 
f 5922//5087 5507//5249 5505//5247 
f 5921//5084 5508//5250 5509//5251 
f 5509//5251 5920//5081 5921//5084 
f 5921//5084 5510//5252 5508//5250 
f 5919//5078 5920//5081 5511//5253 
f 5920//5081 5512//5254 5513//5255 
f 5513//5255 5511//5253 5920//5081 
f 5920//5081 5514//5256 5512//5254 
f 5919//5078 5515//5257 5516//5258 
f 5516//5258 5918//5075 5919//5078 
f 5919//5078 5517//5259 5518//5260 
f 5518//5260 5515//5257 5919//5078 
f 5917//5072 5918//5075 5519//5261 
f 5918//5075 5520//5262 5521//5263 
f 5521//5263 5519//5261 5918//5075 
f 5918//5075 5522//5264 5520//5262 
f 5917//5072 5523//5265 5524//5266 
f 5524//5266 5916//5069 5917//5072 
f 5917//5072 5525//5267 5526//5268 
f 5526//5268 5523//5265 5917//5072 
f 5915//5066 5916//5069 5527//5269 
f 5916//5069 5528//5270 5529//5271 
f 5529//5271 5527//5269 5916//5069 
f 5916//5069 5530//5272 5528//5270 
f 5915//5066 5531//5273 5532//5274 
f 5532//5274 5914//5063 5915//5066 
f 5915//5066 5533//5275 5534//5276 
f 5534//5276 5531//5273 5915//5066 
f 5913//5060 5914//5063 5535//5277 
f 5914//5063 5536//5278 5537//5279 
f 5537//5279 5535//5277 5914//5063 
f 5914//5063 5538//5280 5536//5278 
f 5912//5057 5913//5060 5539//5281 
f 5539//5281 5540//5282 5912//5057 
f 5913//5060 5541//5283 5542//5284 
f 5542//5284 5539//5281 5913//5060 
f 5912//5057 5543//5285 5544//5286 
f 5544//5286 5911//5054 5912//5057 
f 5544//5286 5545//5287 5911//5054 
f 5912//5057 5546//5288 5543//5285 
f 5910//5051 5911//5054 5547//5289 
f 5547//5289 5548//5290 5910//5051 
f 5911//5054 5549//5291 5547//5289 
f 5911//5054 5550//5292 5549//5291 
f 5910//5051 5551//5293 5552//5294 
f 5552//5294 5909//5048 5910//5051 
f 5552//5294 5553//5295 5909//5048 
f 5910//5051 5554//5296 5551//5293 
f 5908//5045 5555//5297 5556//5298 
f 5909//5048 5557//5299 5555//5297 
f 5909//5048 5558//5300 5557//5299 
f 5555//5297 5908//5045 5909//5048 
f 5909//5048 5559//5301 5558//5300 
f 5908//5045 5560//5302 5561//5303 
f 5561//5303 5907//5042 5908//5045 
f 5561//5303 5562//5304 5907//5042 
f 5908//5045 5563//5305 5560//5302 
f 5906//5039 5907//5042 5564//5306 
f 5564//5306 5565//5307 5906//5039 
f 5907//5042 5566//5308 5564//5306 
f 5907//5042 5567//5309 5566//5308 
f 5906//5039 5568//5310 5569//5311 
f 5569//5311 5905//5036 5906//5039 
f 5569//5311 5570//5312 5905//5036 
f 5906//5039 5571//5313 5568//5310 
f 5904//5033 5905//5036 5572//5314 
f 5572//5314 5573//5315 5904//5033 
f 5905//5036 5574//5316 5572//5314 
f 5905//5036 5575//5317 5574//5316 
f 5904//5033 5576//5318 5577//5319 
f 5577//5319 5903//5030 5904//5033 
f 5577//5319 5578//5320 5903//5030 
f 5904//5033 5579//5321 5576//5318 
f 5902//5027 5903//5030 5580//5322 
f 5580//5322 5581//5323 5902//5027 
f 5903//5030 5582//5324 5580//5322 
f 5903//5030 5583//5325 5582//5324 
f 5902//5027 5584//5326 5585//5327 
f 5585//5327 5901//5024 5902//5027 
f 5585//5327 5586//5328 5901//5024 
f 5902//5027 5587//5329 5584//5326 
f 5900//5021 5901//5024 5588//5330 
f 5901//5024 5589//5331 5588//5330 
f 5901//5024 5590//5332 5589//5331 
f 5900//5021 5591//5333 5592//5334 
f 5592//5334 5899//5018 5900//5021 
f 5592//5334 5593//5335 5899//5018 
f 5900//5021 5594//5336 5595//5337 
f 5595//5337 5591//5333 5900//5021 
f 5898//5015 5899//5018 5596//5338 
f 5899//5018 5597//5339 5596//5338 
f 5899//5018 5598//5340 5597//5339 
f 5898//5015 5599//5341 5600//5342 
f 5600//5342 5897//5012 5898//5015 
f 5600//5342 5601//5343 5897//5012 
f 5898//5015 5602//5344 5603//5345 
f 5603//5345 5599//5341 5898//5015 
f 5896//5009 5897//5012 5604//5346 
f 5897//5012 5605//5347 5604//5346 
f 5897//5012 5606//5348 5605//5347 
f 5896//5009 5607//5349 5608//5350 
f 5608//5350 5895//5006 5896//5009 
f 5608//5350 5609//5351 5895//5006 
f 5896//5009 5610//5352 5611//5353 
f 5611//5353 5607//5349 5896//5009 
f 5894//5003 5895//5006 5612//5354 
f 5895//5006 5613//5355 5612//5354 
f 5895//5006 5614//5356 5613//5355 
f 5894//5003 5615//5357 5616//5358 
f 5894//5003 5617//5359 5615//5357 
f 5616//5358 5893//5000 5894//5003 
f 5616//5358 5618//5360 5893//5000 
f 5894//5003 5619//5361 5617//5359 
f 5893//5000 5620//5362 5621//5363 
f 5621//5363 5892//4997 5893//5000 
f 5893//5000 5622//5364 5620//5362 
f 5891//4994 5892//4997 5623//5365 
f 5892//4997 5624//5366 5623//5365 
f 5623//5365 5625//5367 5891//4994 
f 5625//5367 5626//5368 5891//4994 
f 5892//4997 5627//5369 5624//5366 
f 5891//4994 5628//5370 5629//5371 
f 5629//5371 5890//4991 5891//4994 
f 5891//4994 5630//5372 5628//5370 
f 5890//4991 5631//5373 5632//5374 
f 5890//4991 5633//5375 5631//5373 
f 5632//5374 5889//4988 5890//4991 
f 5632//5374 5634//5376 5889//4988 
f 5890//4991 5635//5377 5633//5375 
f 5889//4988 5636//5378 5637//5379 
f 5637//5379 5888//4985 5889//4988 
f 5889//4988 5638//5380 5636//5378 
f 5887//4982 5888//4985 5639//5381 
f 5888//4985 5640//5382 5639//5381 
f 5639//5381 5641//5383 5887//4982 
f 5888//4985 5642//5384 5640//5382 
f 5887//4982 5643//5385 5644//5386 
f 5644//5386 5886//4979 5887//4982 
f 5887//4982 5645//5387 5643//5385 
f 5885//4977 5886//4979 5646//5388 
f 5886//4979 5647//5389 5646//5388 
f 5646//5388 5648//5390 5885//4977 
f 5886//4979 5649//5391 5647//5389 
f 5885//4977 5650//5392 5651//5393 
f 5651//5393 5884//4975 5885//4977 
f 5885//4977 5652//5394 5653//5395 
f 5653//5395 5650//5392 5885//4977 
f 5883//4973 5884//4975 5654//5396 
f 5884//4975 5655//5397 5654//5396 
f 5654//5396 5656//5398 5883//4973 
f 5884//4975 5657//5399 5655//5397 
f 5883//4973 5658//5400 5659//5401 
f 5659//5401 5882//4971 5883//4973 
f 5883//4973 5660//5402 5661//5403 
f 5661//5403 5658//5400 5883//4973 
f 5881//4969 5882//4971 5662//5404 
f 5882//4971 5663//5405 5662//5404 
f 5882//4971 5664//5406 5663//5405 
f 5882//4971 5665//5407 5664//5406 
f 5881//4969 5666//5408 5667//5409 
f 5667//5409 5880//4967 5881//4969 
f 5881//4969 5668//5410 5666//5408 
f 5881//4969 5669//5411 5668//5410 
f 5879//4965 5880//4967 5670//5412 
f 5880//4967 5671//5413 5670//5412 
f 5880//4967 5672//5414 5671//5413 
f 5879//4965 5673//5415 5674//5416 
f 5674//5416 5878//4963 5879//4965 
f 5879//4965 5675//5417 5673//5415 
f 5879//4965 5676//5418 5677//5419 
f 5677//5419 5675//5417 5879//4965 
f 5877//4959 5878//4963 5678//5420 
f 5878//4963 5679//5421 5678//5420 
f 5878//4963 5680//5422 5679//5421 
f 5876//4957 5681//5423 5682//5424 
f 5876//4957 5683//5425 5681//5423 
f 5877//4959 5684//5426 5683//5425 
f 5683//5425 5876//4957 5877//4959 
f 5682//5424 5685//5427 5876//4957 
f 5875//4955 5876//4957 5686//5428 
f 5876//4957 5687//5429 5686//5428 
f 5876//4957 5685//5427 5687//5429 
f 5874//4952 5875//4955 5688//5430 
f 5688//5430 5689//5431 5874//4952 
f 5875//4955 5690//5432 5688//5430 
f 5875//4955 5691//5433 5690//5432 
f 5875//4955 5692//5434 5691//5433 
f 5873//4949 5874//4952 5693//5435 
f 5874//4952 5694//5436 5693//5435 
f 5874//4952 5695//5437 5694//5436 
f 5872//4946 5873//4949 5696//5438 
f 5696//5438 5697//5439 5872//4946 
f 5873//4949 5698//5440 5699//5441 
f 5699//5441 5696//5438 5873//4949 
f 5873//4949 5700//5442 5698//5440 
f 5871//4943 5872//4946 5701//5443 
f 5872//4946 5702//5444 5701//5443 
f 5872//4946 5703//5445 5702//5444 
f 5701//5443 5704//5446 5871//4943 
f 5870//4940 5871//4943 5705//5447 
f 5705//5447 5706//5448 5870//4940 
f 5871//4943 5707//5449 5708//5450 
f 5708//5450 5705//5447 5871//4943 
f 5706//5448 5709//5451 5870//4940 
f 5869//4937 5870//4940 5710//5452 
f 5870//4940 5711//5453 5710//5452 
f 5710//5452 5712//5454 5869//4937 
f 5868//4934 5869//4937 5713//5455 
f 5713//5455 5714//5456 5868//4934 
f 5869//4937 5715//5457 5713//5455 
f 5869//4937 5716//5458 5715//5457 
f 5868//4934 5717//5459 5718//5460 
f 5718//5460 5867//4931 5868//4934 
f 5868//4934 5719//5461 5717//5459 
f 5866//4928 5867//4931 5720//5462 
f 5720//5462 5721//5463 5866//4928 
f 5867//4931 5722//5464 5723//5465 
f 5723//5465 5720//5462 5867//4931 
f 5867//4931 5724//5466 5722//5464 
f 5866//4928 5725//5467 5726//5468 
f 5726//5468 5865//4925 5866//4928 
f 5866//4928 5727//5469 5725//5467 
f 5726//5468 5728//5470 5865//4925 
f 5864//4922 5865//4925 5729//5471 
f 5729//5471 5730//5472 5864//4922 
f 5865//4925 5731//5473 5732//5474 
f 5732//5474 5729//5471 5865//4925 
f 5730//5472 5733//5475 5864//4922 
f 5864//4922 5734//5476 5735//5477 
f 5735//5477 5863//4919 5864//4922 
f 5735//5477 5736//5478 5863//4919 
f 5862//4916 5863//4919 5737//5479 
f 5863//4919 5738//5480 5739//5481 
f 5739//5481 5737//5479 5863//4919 
f 5737//5479 5740//5482 5862//4916 
f 5862//4916 5741//5483 5742//5484 
f 5742//5484 5861//4913 5862//4916 
f 5862//4916 5743//5485 5741//5483 
f 5860//4910 5744//5486 5745//5487 
f 5745//5487 5746//5488 5860//4910 
f 5746//5488 5747//5489 5860//4910 
f 5861//4913 5748//5490 5744//5486 
f 5744//5486 5860//4910 5861//4913 
f 5747//5489 5749//5491 5860//4910 
f 5860//4910 5750//5492 5751//5493 
f 5751//5493 5859//4907 5860//4910 
f 5860//4910 5749//5491 5750//5492 
f 5751//5493 5752//5494 5859//4907 
f 5858//4904 5859//4907 5753//5495 
f 5859//4907 5754//5496 5755//5497 
f 5755//5497 5753//5495 5859//4907 
f 5753//5495 5756//5498 5858//4904 
f 5857//4901 5757//5499 5758//5500 
f 5858//4904 5759//5501 5760//5502 
f 5760//5502 5857//4901 5858//4904 
f 5858//4904 5761//5503 5759//5501 
f 5760//5502 5757//5499 5857//4901 
f 5856//4898 5857//4901 5762//5504 
f 5857//4901 5763//5505 5764//5506 
f 5764//5506 5762//5504 5857//4901 
f 5762//5504 5765//5507 5856//4898 
f 5856//4898 5766//5508 5767//5509 
f 5767//5509 5855//4895 5856//4898 
f 5856//4898 5768//5510 5766//5508 
f 5767//5509 5769//5511 5855//4895 
f 5854//4892 5855//4895 5770//5512 
f 5855//4895 5771//5513 5772//5514 
f 5772//5514 5770//5512 5855//4895 
f 5770//5512 5773//5515 5854//4892 
f 5854//4892 5774//5516 5775//5517 
f 5775//5517 5853//4889 5854//4892 
f 5854//4892 5776//5518 5774//5516 
f 5775//5517 5777//5519 5853//4889 
f 5852//4886 5853//4889 5778//5520 
f 5853//4889 5779//5521 5780//5522 
f 5780//5522 5778//5520 5853//4889 
f 5778//5520 5781//5523 5852//4886 
f 5852//4886 5782//5524 5783//5525 
f 5783//5525 5850//4882 5852//4886 
f 5852//4886 5784//5526 5782//5524 
f 5783//5525 5785//5527 5850//4882 
f 5851//4883 5850//4882 5786//5528 
f 5850//4882 5787//5529 5788//5530 
f 5788//5530 5786//5528 5850//4882 
f 5786//5528 5789//5531 5851//4883 
f 5851//4883 5790//5532 5791//5533 
f 5791//5533 5943//5150 5851//4883 
f 5851//4883 5792//5534 5790//5532 
f 5791//5533 5793//5535 5943//5150 
f 5942//5149 5943//5150 5794//5536 
f 5943//5150 5795//5537 5794//5536 
f 5794//5536 5796//5538 5942//5149 
f 5796//5538 5797//5539 5942//5149 
f 5941//5143 5942//5149 5798//5540 
f 5798//5540 5799//5541 5941//5143 
f 5942//5149 5800//5542 5798//5540 
f 5799//5541 5801//5543 5941//5143 
f 5940//5142 5941//5143 5802//5544 
f 5941//5143 5803//5545 5802//5544 
f 5802//5544 5804//5546 5940//5142 
f 5804//5546 5805//5547 5940//5142 
f 5939//5137 5940//5142 5806//5548 
f 5806//5548 5807//5549 5939//5137 
f 5940//5142 5808//5550 5806//5548 
f 5807//5549 5809//5551 5939//5137 
f 5938//5136 5939//5137 5810//5552 
f 5939//5137 5811//5553 5810//5552 
f 5810//5552 5812//5554 5938//5136 
f 5812//5554 5813//5555 5938//5136 
f 5937//5130 5938//5136 5814//5556 
f 5814//5556 5815//5557 5937//5130 
f 5938//5136 5816//5558 5814//5556 
f 5815//5557 5817//5559 5937//5130 
f 5937//5130 5818//5560 5819//5561 
f 5819//5561 5936//5127 5937//5130 
f 5819//5561 5820//5562 5936//5127 
f 5820//5562 5821//5563 5936//5127 
f 4748//5128 5936//5127 5822//5564 
f 5936//5127 5823//5565 5822//5564 
f 5824//5566 4749//5567 4748//5128 
f 5822//5564 5824//5566 4748//5128 
f 5825//5568 4779//5569 4749//5567 
f 4749//5567 5826//5570 5825//5568 
f 4779//5569 5825//5568 5827//5571 
f 4768//5572 5828//5573 5829//5574 
f 4768//5572 5827//5571 5828//5573 
f 5829//5574 4786//5575 4768//5572 
f 5829//5574 5830//5576 4786//5575 
f 5830//5576 5831//5577 4780//5578 
f 4780//5578 5831//5577 5832//5579 
f 5832//5579 4769//5580 4780//5578 
f 5833//5581 4787//5582 4769//5580 
f 4769//5580 5834//5583 5833//5581 
f 5832//5579 5834//5583 4769//5580 
f 4787//5582 5833//5581 5835//5584 
f 4788//5585 5836//5586 5837//5587 
f 4788//5585 5835//5584 5836//5586 
f 5837//5587 4781//5588 4788//5585 
f 5837//5587 5838//5589 4781//5588 
f 5838//5589 5839//5590 4782//5591 
f 4782//5591 5839//5590 5840//5592 
f 5840//5592 4783//5593 4782//5591 
f 4783//5593 5841//5594 5842//5595 
f 5842//5595 4752//5596 4783//5593 
f 5840//5592 5841//5594 4783//5593 
f 5842//5595 5843//5597 4734//5598 
f 4734//5598 5843//5597 5844//5599 
f 5844//5599 4770//5600 4734//5598 
f 5844//5599 5845//5601 4770//5600 
f 4770//5600 5845//5601 5846//5602 
f 4718//5603 4735//5604 5847//5605 
f 4735//5604 5846//5602 5847//5605 
f 5848//5606 4753//5607 4718//5603 
f 4718//5603 5849//5608 5848//5606 
f 5847//5605 5849//5608 4718//5603 
f 4754//5609 4753//5607 5848//5606 
f 5846//5602 4735//5604 4770//5600 
f 4734//5598 4752//5596 5842//5595 
f 4782//5591 4781//5588 5838//5589 
f 5835//5584 4788//5585 4787//5582 
f 4780//5578 4786//5575 5830//5576 
f 5827//5571 4768//5572 4779//5569 
f 5824//5566 5826//5570 4749//5567 
f 5821//5563 5823//5565 5936//5127 
f 5817//5559 5818//5560 5937//5130 
f 5813//5555 5816//5558 5938//5136 
f 5809//5551 5811//5553 5939//5137 
f 5805//5547 5808//5550 5940//5142 
f 5801//5543 5803//5545 5941//5143 
f 5797//5539 5800//5542 5942//5149 
f 5793//5535 5795//5537 5943//5150 
f 5789//5531 5792//5534 5851//4883 
f 5785//5527 5787//5529 5850//4882 
f 5781//5523 5784//5526 5852//4886 
f 5777//5519 5779//5521 5853//4889 
f 5773//5515 5776//5518 5854//4892 
f 5769//5511 5771//5513 5855//4895 
f 5765//5507 5768//5510 5856//4898 
f 5758//5500 5763//5505 5857//4901 
f 5756//5498 5761//5503 5858//4904 
f 5752//5494 5754//5496 5859//4907 
f 5742//5484 5748//5490 5861//4913 
f 5740//5482 5743//5485 5862//4916 
f 5736//5478 5738//5480 5863//4919 
f 5733//5475 5734//5476 5864//4922 
f 5728//5470 5731//5473 5865//4925 
f 5721//5463 5727//5469 5866//4928 
f 5718//5460 5724//5466 5867//4931 
f 5714//5456 5719//5461 5868//4934 
f 5712//5454 5716//5458 5869//4937 
f 5709//5451 5711//5453 5870//4940 
f 5704//5446 5707//5449 5871//4943 
f 5697//5439 5703//5445 5872//4946 
f 5693//5435 5700//5442 5873//4949 
f 5689//5431 5695//5437 5874//4952 
f 5686//5428 5692//5434 5875//4955 
f 5678//5420 5684//5426 5877//4959 
f 5674//5416 5680//5422 5878//4963 
f 5670//5412 5676//5418 5879//4965 
f 5667//5409 5672//5414 5880//4967 
f 5662//5404 5669//5411 5881//4969 
f 5659//5401 5665//5407 5882//4971 
f 5656//5398 5660//5402 5883//4973 
f 5651//5393 5657//5399 5884//4975 
f 5648//5390 5652//5394 5885//4977 
f 5644//5386 5649//5391 5886//4979 
f 5641//5383 5645//5387 5887//4982 
f 5637//5379 5642//5384 5888//4985 
f 5634//5376 5638//5380 5889//4988 
f 5629//5371 5635//5377 5890//4991 
f 5626//5368 5630//5372 5891//4994 
f 5621//5363 5627//5369 5892//4997 
f 5618//5360 5622//5364 5893//5000 
f 5612//5354 5619//5361 5894//5003 
f 5609//5351 5614//5356 5895//5006 
f 5604//5346 5610//5352 5896//5009 
f 5601//5343 5606//5348 5897//5012 
f 5596//5338 5602//5344 5898//5015 
f 5593//5335 5598//5340 5899//5018 
f 5588//5330 5594//5336 5900//5021 
f 5586//5328 5590//5332 5901//5024 
f 5581//5323 5587//5329 5902//5027 
f 5578//5320 5583//5325 5903//5030 
f 5573//5315 5579//5321 5904//5033 
f 5570//5312 5575//5317 5905//5036 
f 5565//5307 5571//5313 5906//5039 
f 5562//5304 5567//5309 5907//5042 
f 5556//5298 5563//5305 5908//5045 
f 5553//5295 5559//5301 5909//5048 
f 5548//5290 5554//5296 5910//5051 
f 5545//5287 5550//5292 5911//5054 
f 5540//5282 5546//5288 5912//5057 
f 5535//5277 5541//5283 5913//5060 
f 5532//5274 5538//5280 5914//5063 
f 5527//5269 5533//5275 5915//5066 
f 5524//5266 5530//5272 5916//5069 
f 5519//5261 5525//5267 5917//5072 
f 5516//5258 5522//5264 5918//5075 
f 5511//5253 5517//5259 5919//5078 
f 5509//5251 5514//5256 5920//5081 
f 5504//5246 5510//5252 5921//5084 
f 5502//5244 5507//5249 5922//5087 
f 5499//5241 5503//5245 5923//5090 
f 5495//5237 5500//5242 5924//5093 
f 5491//5233 5496//5238 5925//5096 
f 5488//5230 5492//5234 5926//5099 
f 5483//5225 5489//5231 5927//5102 
f 5480//5222 5484//5226 5928//5105 
f 5475//5217 5481//5223 5929//5108 
f 5471//5213 5476//5218 5930//5111 
f 5468//5210 5473//5215 5931//5114 
f 5465//5207 5469//5211 5932//5117 
f 5461//5203 5466//5208 5933//5120 
f 5458//5200 5462//5204 5934//5123 
f 4931//5194 4934//5191 5452//5192 
f 5450//5188 4933//5189 4936//5186 
f 4935//5185 4938//5181 5447//5183 
f 5445//5179 4937//5182 4940//5177 
f 4939//5176 4942//5172 5442//5174 
f 5440//5170 4941//5173 4944//5168 
f 4943//5167 4946//5163 5437//5165 
f 5435//5161 4945//5164 4948//5159 
f 4947//5158 5335//5610 5432//5156 
f 5432//5156 5335//5610 5334//5611 
f 4713//5154 4950//4885 5851//4883 
f 4712//5151 4711//5155 5943//5150 
f 4777//5148 4776//5152 5942//5149 
f 4766//5146 4775//5147 5941//5143 
f 4791//5141 4790//5145 5940//5142 
f 4733//5138 4747//5140 5939//5137 
f 4746//5135 4745//5139 5938//5136 
f 4767//5133 4732//5134 5937//5130 
f 4751//5129 4750//5132 5936//5127 
f 4929//5125 4932//5195 5935//5126 
f 4927//5122 4930//5124 5934//5123 
f 4925//5119 4928//5121 5933//5120 
f 4923//5116 4926//5118 5932//5117 
f 4921//5113 4924//5115 5931//5114 
f 4919//5110 4922//5112 5930//5111 
f 4917//5107 4920//5109 5929//5108 
f 4915//5104 4918//5106 5928//5105 
f 4913//5101 4916//5103 5927//5102 
f 4911//5098 4914//5100 5926//5099 
f 4909//5095 4912//5097 5925//5096 
f 4907//5092 4910//5094 5924//5093 
f 4905//5089 4908//5091 5923//5090 
f 4903//5086 4906//5088 5922//5087 
f 4901//5083 4904//5085 5921//5084 
f 4899//5080 4902//5082 5920//5081 
f 4897//5077 4900//5079 5919//5078 
f 4895//5074 4898//5076 5918//5075 
f 4893//5071 4896//5073 5917//5072 
f 4891//5068 4894//5070 5916//5069 
f 4889//5065 4892//5067 5915//5066 
f 4887//5062 4890//5064 5914//5063 
f 4885//5059 4888//5061 5913//5060 
f 4883//5056 4886//5058 5912//5057 
f 4881//5053 4884//5055 5911//5054 
f 4879//5050 4882//5052 5910//5051 
f 4877//5047 4880//5049 5909//5048 
f 4875//5044 4878//5046 5908//5045 
f 4873//5041 4876//5043 5907//5042 
f 4871//5038 4874//5040 5906//5039 
f 4869//5035 4872//5037 5905//5036 
f 4867//5032 4870//5034 5904//5033 
f 4865//5029 4868//5031 5903//5030 
f 4863//5026 4866//5028 5902//5027 
f 4861//5023 4864//5025 5901//5024 
f 4859//5020 4862//5022 5900//5021 
f 4857//5017 4860//5019 5899//5018 
f 4855//5014 4858//5016 5898//5015 
f 4853//5011 4856//5013 5897//5012 
f 4851//5008 4854//5010 5896//5009 
f 4849//5005 4852//5007 5895//5006 
f 4847//5002 4850//5004 5894//5003 
f 4845//4999 4848//5001 5893//5000 
f 4843//4996 4846//4998 5892//4997 
f 4841//4993 4844//4995 5891//4994 
f 4839//4990 4842//4992 5890//4991 
f 4837//4987 4840//4989 5889//4988 
f 4835//4984 4838//4986 5888//4985 
f 4833//4981 4836//4983 5887//4982 
f 4832//4978 4834//4980 5886//4979 
f 4831//4976 5885//4977 5884//4975 
f 4830//4974 5884//4975 5883//4973 
f 4829//4972 5883//4973 5882//4971 
f 4828//4970 5882//4971 5881//4969 
f 4827//4968 5881//4969 5880//4967 
f 4826//4966 5880//4967 5879//4965 
f 4825//4964 5879//4965 5878//4963 
f 4824//4962 5878//4963 5877//4959 
f 4822//4960 4823//4961 5877//4959 
f 4821//4958 4822//4960 5876//4957 
f 4820//4956 4821//4958 5875//4955 
f 4819//4953 4820//4956 5874//4952 
f 4817//4950 4818//4954 5873//4949 
f 4815//4947 4816//4951 5872//4946 
f 4813//4944 4814//4948 5871//4943 
f 4811//4941 4812//4945 5870//4940 
f 4809//4938 4810//4942 5869//4937 
f 4807//4935 4808//4939 5868//4934 
f 4805//4932 4806//4936 5867//4931 
f 4803//4929 4804//4933 5866//4928 
f 4801//4926 4802//4930 5865//4925 
f 4799//4923 4800//4927 5864//4922 
f 4797//4920 4798//4924 5863//4919 
f 4795//4917 4796//4921 5862//4916 
f 4793//4914 4794//4918 5861//4913 
f 4968//4911 4792//4915 5860//4910 
f 4966//4908 4967//4912 5859//4907 
f 4964//4905 4965//4909 5858//4904 
f 4962//4902 4963//4906 5857//4901 
f 4960//4899 4961//4903 5856//4898 
f 4958//4896 4959//4900 5855//4895 
f 4956//4893 4957//4897 5854//4892 
f 4954//4890 4955//4894 5853//4889 
f 4952//4887 4953//4891 5852//4886 
f 4949//4884 4951//4888 5850//4882 
o mesh291
f 5964//5612 5281//5613 5283//5614 
f 5964//5612 5965//5615 5282//5616 
f 5965//5615 5284//5617 5282//5616 
f 5282//5616 5281//5613 5964//5612 
f 5966//5618 5278//5619 5279//5620 
f 5964//5612 5280//5621 5278//5619 
f 5278//5619 5966//5618 5964//5612 
f 5967//5622 5966//5618 5276//5623 
f 5966//5618 5277//5624 5276//5623 
f 5276//5623 5275//5625 5967//5622 
f 5968//5626 5272//5627 5273//5628 
f 5967//5622 5274//5629 5272//5627 
f 5272//5627 5968//5626 5967//5622 
f 5969//5630 5268//5631 5270//5632 
f 5969//5630 5968//5626 5269//5633 
f 5269//5633 5268//5631 5969//5630 
f 5968//5626 5271//5634 5269//5633 
f 5970//5635 5266//5636 5265//5637 
f 5970//5635 5969//5630 5264//5638 
f 5969//5630 5267//5639 5264//5638 
f 5264//5638 5266//5636 5970//5635 
f 5971//5640 5970//5635 5262//5641 
f 5262//5641 5261//5642 5971//5640 
f 5970//5635 5263//5643 5262//5641 
f 5972//5644 5258//5645 5259//5646 
f 5972//5644 5971//5640 5257//5647 
f 5257//5647 5258//5645 5972//5644 
f 5971//5640 5260//5648 5257//5647 
f 5973//5649 5255//5650 5254//5651 
f 5972//5644 5256//5652 5255//5650 
f 5255//5650 5973//5649 5972//5644 
f 5254//5651 5251//5653 5973//5649 
f 5973//5649 5250//5654 5252//5655 
f 5252//5655 5253//5656 5973//5649 
f 5253//5656 5247//5657 5973//5649 
f 5974//5658 5178//5659 5180//5660 
f 5974//5658 5975//5661 5179//5662 
f 5179//5662 5178//5659 5974//5658 
f 5180//5660 5175//5663 5974//5658 
f 5975//5661 5181//5664 5179//5662 
f 5976//5665 5176//5666 5177//5667 
f 5974//5658 5174//5668 5176//5666 
f 5176//5666 5976//5665 5974//5658 
f 5977//5669 5170//5670 5172//5671 
f 5977//5669 5171//5672 5170//5670 
f 5172//5671 5167//5673 5977//5669 
f 5976//5665 5173//5674 5171//5672 
f 5171//5672 5977//5669 5976//5665 
f 5167//5673 5166//5675 5977//5669 
f 5978//5676 5977//5669 5169//5677 
f 5169//5677 5165//5678 5978//5676 
f 5977//5669 5166//5675 5168//5679 
f 5168//5679 5169//5677 5977//5669 
f 5979//5680 5980//5681 5081//5682 
f 5980//5681 5082//5683 5081//5682 
f 5980//5681 5083//5684 5082//5683 
f 5081//5682 5080//5685 5979//5680 
f 5979//5680 5077//5686 5076//5687 
f 5076//5687 5981//5688 5979//5680 
f 5979//5680 5079//5689 5077//5686 
f 5076//5687 5078//5690 5981//5688 
f 5982//5691 5981//5688 5072//5692 
f 5981//5688 5075//5693 5074//5694 
f 5074//5694 5073//5695 5981//5688 
f 5073//5695 5072//5692 5981//5688 
f 5072//5692 5069//5696 5982//5691 
f 5982//5691 5069//5696 5068//5697 
f 5068//5697 5067//5698 5982//5691 
f 4737//5699 4993//5700 4996//5701 
f 4736//5702 4994//5703 4993//5700 
f 4736//5702 4997//5704 4994//5703 
f 4993//5700 4737//5699 4736//5702 
f 4996//5701 4995//5705 4737//5699 
f 4755//5706 4737//5699 4990//5707 
f 4737//5699 4992//5708 4990//5707 
f 4990//5707 4991//5709 4755//5706 
f 4738//5710 4985//5711 4988//5712 
f 4755//5706 4986//5713 4985//5711 
f 4755//5706 4989//5714 4986//5713 
f 4985//5711 4738//5710 4755//5706 
f 4988//5712 4987//5715 4738//5710 
f 4739//5716 4738//5710 4982//5717 
f 4738//5710 4984//5718 4982//5717 
f 4982//5717 4983//5719 4739//5716 
f 4719//5720 4978//5721 4980//5722 
f 4739//5716 4979//5723 4978//5721 
f 4739//5716 4981//5724 4979//5723 
f 4978//5721 4719//5720 4739//5716 
f 4706//5725 4719//5720 4975//5726 
f 4975//5726 4976//5727 4706//5725 
f 4719//5720 4977//5728 4975//5726 
f 4707//5729 4706//5725 4973//5730 
f 4973//5730 4970//5731 4707//5729 
f 4706//5725 4974//5732 4972//5733 
f 4972//5733 4971//5734 4706//5725 
f 4971//5734 4973//5730 4706//5725 
f 4707//5729 4970//5731 4969//5735 
f 4969//5735 4773//5736 4707//5729 
f 4998//5737 4754//5738 5848//5739 
f 4754//5738 4998//5737 4999//5740 
f 4999//5740 4736//5702 4754//5738 
f 5848//5739 5000//5741 4998//5737 
f 5848//5739 5849//5742 5000//5741 
f 5844//5743 5005//5744 5002//5745 
f 5002//5745 5846//5746 5845//5747 
f 5001//5748 5847//5749 5846//5746 
f 5846//5746 5002//5745 5001//5748 
f 5001//5748 5004//5750 5847//5749 
f 5847//5749 5004//5750 5003//5751 
f 5003//5751 5849//5742 5847//5749 
f 5003//5751 5000//5741 5849//5742 
f 5843//5752 5842//5753 5007//5754 
f 5842//5753 5008//5755 5007//5754 
f 5007//5754 5006//5756 5843//5752 
f 5844//5743 5843//5752 5006//5756 
f 5006//5756 5005//5744 5844//5743 
f 5842//5753 5841//5757 5008//5755 
f 5837//5758 5013//5759 5010//5760 
f 5010//5760 5009//5761 5839//5762 
f 5839//5762 5838//5763 5010//5760 
f 5839//5762 5009//5761 5012//5764 
f 5012//5764 5840//5765 5839//5762 
f 5012//5764 5011//5766 5840//5765 
f 5011//5766 5008//5755 5840//5765 
f 5015//5767 5014//5768 5835//5769 
f 5833//5770 5016//5771 5015//5767 
f 5835//5769 5833//5770 5015//5767 
f 5837//5758 5836//5772 5014//5768 
f 5014//5768 5013//5759 5837//5758 
f 5836//5772 5835//5769 5014//5768 
f 5833//5770 5834//5773 5016//5771 
f 5020//5774 5017//5775 5831//5776 
f 5831//5776 5830//5777 5020//5774 
f 5831//5776 5017//5775 5019//5778 
f 5019//5778 5832//5779 5831//5776 
f 5019//5778 5018//5780 5832//5779 
f 5018//5780 5016//5771 5832//5779 
f 5022//5781 5021//5782 5827//5783 
f 5825//5784 5023//5785 5022//5781 
f 5827//5783 5825//5784 5022//5781 
f 5829//5786 5828//5787 5021//5782 
f 5021//5782 5020//5774 5829//5786 
f 5828//5787 5827//5783 5021//5782 
f 5825//5784 5826//5788 5023//5785 
f 5027//5789 5024//5790 5822//5791 
f 5822//5791 5823//5792 5027//5789 
f 5824//5793 5822//5791 5026//5794 
f 5822//5791 5024//5790 5026//5794 
f 5026//5794 5025//5795 5824//5793 
f 5025//5795 5023//5785 5824//5793 
f 5029//5796 5028//5797 5819//5798 
f 5818//5799 5030//5800 5029//5796 
f 5819//5798 5818//5799 5029//5796 
f 5821//5801 5820//5802 5028//5797 
f 5028//5797 5027//5789 5821//5801 
f 5820//5802 5819//5798 5028//5797 
f 5034//5803 5031//5804 5814//5805 
f 5814//5805 5816//5806 5034//5803 
f 5815//5807 5814//5805 5032//5808 
f 5814//5805 5031//5804 5032//5808 
f 5032//5808 5033//5809 5815//5807 
f 5033//5809 5030//5800 5815//5807 
f 5030//5800 5817//5810 5815//5807 
f 5038//5811 5036//5812 5811//5813 
f 5036//5812 5035//5814 5810//5815 
f 5810//5815 5811//5813 5036//5812 
f 5813//5816 5812//5817 5035//5814 
f 5035//5814 5037//5818 5813//5816 
f 5037//5818 5034//5803 5813//5816 
f 5812//5817 5810//5815 5035//5814 
f 5042//5819 5039//5820 5806//5821 
f 5806//5821 5808//5822 5042//5819 
f 5807//5823 5806//5821 5041//5824 
f 5806//5821 5039//5820 5041//5824 
f 5041//5824 5040//5825 5807//5823 
f 5809//5826 5807//5823 5040//5825 
f 5040//5825 5038//5811 5809//5826 
f 5044//5827 5043//5828 5802//5829 
f 5803//5830 5046//5831 5044//5827 
f 5802//5829 5803//5830 5044//5827 
f 5805//5832 5804//5833 5043//5828 
f 5043//5828 5045//5834 5805//5832 
f 5045//5834 5042//5819 5805//5832 
f 5804//5833 5802//5829 5043//5828 
f 5050//5835 5047//5836 5798//5837 
f 5798//5837 5800//5838 5050//5835 
f 5799//5839 5798//5837 5049//5840 
f 5798//5837 5047//5836 5049//5840 
f 5049//5840 5048//5841 5799//5839 
f 5801//5842 5799//5839 5048//5841 
f 5048//5841 5046//5831 5801//5842 
f 5052//5843 5051//5844 5794//5845 
f 5795//5846 5054//5847 5052//5843 
f 5794//5845 5795//5846 5052//5843 
f 5797//5848 5796//5849 5051//5844 
f 5051//5844 5053//5850 5797//5848 
f 5053//5850 5050//5835 5797//5848 
f 5796//5849 5794//5845 5051//5844 
f 5058//5851 5056//5852 5790//5853 
f 5790//5853 5792//5854 5058//5851 
f 5791//5855 5790//5853 5055//5856 
f 5790//5853 5056//5852 5055//5856 
f 5055//5856 5057//5857 5791//5855 
f 5793//5858 5791//5855 5057//5857 
f 5057//5857 5054//5847 5793//5858 
f 5062//5859 5060//5860 5787//5861 
f 5060//5860 5059//5862 5788//5863 
f 5788//5863 5787//5861 5060//5860 
f 5789//5864 5786//5865 5059//5862 
f 5059//5862 5061//5866 5789//5864 
f 5061//5866 5058//5851 5789//5864 
f 5786//5865 5788//5863 5059//5862 
f 5066//5867 5065//5868 5782//5869 
f 5782//5869 5784//5870 5066//5867 
f 5783//5871 5782//5869 5064//5872 
f 5782//5869 5065//5868 5064//5872 
f 5064//5872 5063//5873 5783//5871 
f 5785//5874 5783//5871 5063//5873 
f 5063//5873 5062//5859 5785//5874 
f 5982//5691 5067//5698 5779//5875 
f 5067//5698 5070//5876 5780//5877 
f 5780//5877 5779//5875 5067//5698 
f 5781//5878 5778//5879 5070//5876 
f 5070//5876 5071//5880 5781//5878 
f 5071//5880 5066//5867 5781//5878 
f 5778//5879 5780//5877 5070//5876 
f 5981//5688 5774//5881 5776//5882 
f 5982//5691 5775//5883 5774//5881 
f 5774//5881 5981//5688 5982//5691 
f 5982//5691 5777//5884 5775//5883 
f 5979//5680 5981//5688 5772//5885 
f 5772//5885 5771//5886 5979//5680 
f 5981//5688 5773//5887 5770//5888 
f 5770//5888 5772//5885 5981//5688 
f 5980//5681 5767//5889 5766//5890 
f 5766//5890 5768//5891 5980//5681 
f 5768//5891 5765//5892 5980//5681 
f 5979//5680 5769//5893 5767//5889 
f 5767//5889 5980//5681 5979//5680 
f 5980//5681 5765//5892 5762//5894 
f 5762//5894 5764//5895 5980//5681 
f 5764//5895 5763//5896 5980//5681 
f 5763//5896 5758//5897 5980//5681 
f 5758//5897 5084//5898 5086//5899 
f 5086//5899 5980//5681 5758//5897 
f 5758//5897 5757//5900 5084//5898 
f 5086//5899 5087//5901 5980//5681 
f 5091//5902 5759//5903 5761//5904 
f 5760//5905 5759//5903 5089//5906 
f 5759//5903 5090//5907 5089//5906 
f 5759//5903 5091//5902 5090//5907 
f 5757//5900 5760//5905 5088//5908 
f 5088//5908 5085//5909 5757//5900 
f 5085//5909 5084//5898 5757//5900 
f 5089//5906 5088//5908 5760//5905 
f 5094//5910 5092//5911 5755//5912 
f 5755//5912 5754//5913 5094//5910 
f 5756//5914 5753//5915 5092//5911 
f 5092//5911 5093//5916 5756//5914 
f 5093//5916 5091//5902 5756//5914 
f 5753//5915 5755//5912 5092//5911 
f 5098//5917 5750//5918 5749//5919 
f 5096//5920 5095//5921 5751//5922 
f 5750//5918 5097//5923 5096//5920 
f 5750//5918 5098//5917 5097//5923 
f 5751//5922 5750//5918 5096//5920 
f 5752//5924 5751//5922 5095//5921 
f 5095//5921 5094//5910 5752//5924 
f 5101//5925 5099//5926 5745//5927 
f 5747//5928 5746//5929 5099//5926 
f 5099//5926 5100//5930 5747//5928 
f 5100//5930 5098//5917 5747//5928 
f 5746//5929 5745//5927 5099//5926 
f 5105//5931 5741//5932 5743//5933 
f 5103//5934 5102//5935 5742//5936 
f 5741//5932 5104//5937 5103//5934 
f 5741//5932 5105//5931 5104//5937 
f 5742//5936 5741//5932 5103//5934 
f 5748//5938 5742//5936 5102//5935 
f 5101//5925 5744//5939 5748//5938 
f 5102//5935 5101//5925 5748//5938 
f 5740//5940 5737//5941 5106//5942 
f 5106//5942 5107//5943 5740//5940 
f 5108//5944 5106//5942 5739//5945 
f 5106//5942 5737//5941 5739//5945 
f 5739//5945 5738//5946 5108//5944 
f 5738//5946 5736//5947 5108//5944 
f 5736//5947 5109//5948 5111//5949 
f 5110//5950 5109//5948 5735//5951 
f 5109//5948 5736//5947 5735//5951 
f 5734//5952 5112//5953 5110//5950 
f 5113//5954 5112//5953 5734//5952 
f 5734//5952 5733//5955 5113//5954 
f 5735//5951 5734//5952 5110//5950 
f 5113//5954 5733//5955 5730//5956 
f 5730//5956 5729//5957 5114//5958 
f 5114//5958 5115//5959 5730//5956 
f 5114//5958 5729//5957 5732//5960 
f 5732//5960 5116//5961 5114//5958 
f 5732//5960 5731//5962 5116//5961 
f 5731//5962 5728//5963 5116//5961 
f 5728//5963 5117//5964 5119//5965 
f 5118//5966 5117//5964 5726//5967 
f 5117//5964 5728//5963 5726//5967 
f 5725//5968 5121//5969 5120//5970 
f 5120//5970 5118//5966 5725//5968 
f 5726//5967 5725//5968 5118//5966 
f 5121//5969 5727//5971 5721//5972 
f 5721//5972 5720//5973 5122//5974 
f 5122//5974 5123//5975 5721//5972 
f 5121//5969 5725//5968 5727//5971 
f 5122//5974 5720//5973 5723//5976 
f 5723//5976 5124//5977 5122//5974 
f 5723//5976 5722//5978 5124//5977 
f 5124//5977 5722//5978 5724//5979 
f 5724//5979 5125//5980 5127//5981 
f 5126//5982 5125//5980 5718//5983 
f 5125//5980 5724//5979 5718//5983 
f 5717//5984 5129//5985 5128//5986 
f 5128//5986 5126//5982 5717//5984 
f 5718//5983 5717//5984 5126//5982 
f 5130//5987 5129//5985 5719//5988 
f 5714//5989 5713//5990 5131//5991 
f 5131//5991 5130//5987 5714//5989 
f 5129//5985 5717//5984 5719//5988 
f 5131//5991 5713//5990 5715//5992 
f 5715//5992 5132//5993 5131//5991 
f 5715//5992 5716//5994 5132//5993 
f 5716//5994 5712//5995 5132//5993 
f 5712//5995 5133//5996 5134//5997 
f 5135//5998 5133//5996 5710//5999 
f 5133//5996 5712//5995 5710//5999 
f 5709//6000 5137//6001 5136//6002 
f 5136//6002 5711//6003 5709//6000 
f 5136//6002 5135//5998 5711//6003 
f 5710//5999 5711//6003 5135//5998 
f 5706//6004 5705//6005 5139//6006 
f 5138//6007 5709//6000 5706//6004 
f 5139//6006 5138//6007 5706//6004 
f 5140//6008 5139//6006 5705//6005 
f 5705//6005 5708//6009 5140//6008 
f 5708//6009 5707//6010 5140//6008 
f 5707//6010 5704//6011 5140//6008 
f 5704//6011 5701//6012 5143//6013 
f 5143//6013 5144//6014 5704//6011 
f 5145//6015 5143//6013 5701//6012 
f 5702//6016 5141//6017 5145//6015 
f 5701//6012 5702//6016 5145//6015 
f 5702//6016 5703//6018 5142//6019 
f 5697//6020 5696//6021 5147//6022 
f 5146//6023 5703//6018 5697//6020 
f 5147//6022 5146//6023 5697//6020 
f 5146//6023 5142//6019 5703//6018 
f 5148//6024 5147//6022 5696//6021 
f 5696//6021 5699//6025 5148//6024 
f 5699//6025 5698//6026 5148//6024 
f 5148//6024 5698//6026 5700//6027 
f 5700//6027 5151//6028 5152//6029 
f 5153//6030 5151//6028 5693//6031 
f 5151//6028 5700//6027 5693//6031 
f 5694//6032 5149//6033 5153//6030 
f 5693//6031 5694//6032 5153//6030 
f 5695//6034 5150//6035 5149//6033 
f 5689//6036 5688//6037 5155//6038 
f 5154//6039 5695//6034 5689//6036 
f 5155//6038 5154//6039 5689//6036 
f 5154//6039 5150//6035 5695//6034 
f 5156//6040 5155//6038 5688//6037 
f 5688//6037 5690//6041 5156//6040 
f 5690//6041 5691//6042 5156//6040 
f 5692//6043 5686//6044 5157//6045 
f 5157//6045 5158//6046 5692//6043 
f 5156//6040 5691//6042 5692//6043 
f 5159//6047 5157//6045 5686//6044 
f 5687//6048 5160//6049 5159//6047 
f 5686//6044 5687//6048 5159//6047 
f 5160//6049 5687//6048 5685//6050 
f 5685//6050 5161//6051 5163//6052 
f 5682//6053 5681//6054 5162//6055 
f 5161//6051 5685//6050 5682//6053 
f 5162//6055 5161//6051 5682//6053 
f 5164//6056 5162//6055 5681//6054 
f 5683//6057 5978//5676 5164//6056 
f 5681//6054 5683//6057 5164//6056 
f 5978//5676 5684//6058 5678//6059 
f 5678//6059 5977//5669 5978//5676 
f 5978//5676 5683//6057 5684//6058 
f 5976//5665 5977//5669 5674//6060 
f 5977//5669 5680//6061 5674//6060 
f 5674//6060 5673//6062 5976//5665 
f 5977//5669 5679//6063 5680//6061 
f 5976//5665 5676//6064 5670//6065 
f 5670//6065 5974//5658 5976//5665 
f 5976//5665 5675//6066 5677//6067 
f 5677//6067 5676//6064 5976//5665 
f 5975//5661 5667//6068 5666//6069 
f 5974//5658 5672//6070 5667//6068 
f 5667//6068 5975//5661 5974//5658 
f 5974//5658 5671//6071 5672//6070 
f 5666//6069 5668//6072 5975//5661 
f 5975//5661 5669//6073 5662//6074 
f 5662//6074 5663//6075 5975//5661 
f 5975//5661 5668//6072 5669//6073 
f 5975//5661 5182//6076 5183//6077 
f 5663//6075 5184//6078 5182//6076 
f 5182//6076 5975//5661 5663//6075 
f 5663//6075 5664//6079 5184//6078 
f 5665//6080 5187//6081 5184//6078 
f 5665//6080 5188//6082 5187//6081 
f 5186//6083 5185//6084 5659//6085 
f 5185//6084 5665//6080 5659//6085 
f 5659//6085 5658//6086 5186//6083 
f 5185//6084 5188//6082 5665//6080 
f 5658//6086 5189//6087 5186//6083 
f 5656//6088 5654//6089 5190//6090 
f 5191//6091 5660//6092 5656//6088 
f 5191//6091 5189//6087 5661//6093 
f 5189//6087 5658//6086 5661//6093 
f 5661//6093 5660//6092 5191//6091 
f 5192//6094 5190//6090 5654//6089 
f 5654//6089 5655//6095 5192//6094 
f 5655//6095 5657//6096 5195//6097 
f 5657//6096 5196//6098 5195//6097 
f 5194//6099 5193//6100 5651//6101 
f 5193//6100 5657//6096 5651//6101 
f 5651//6101 5650//6102 5194//6099 
f 5193//6100 5196//6098 5657//6096 
f 5650//6102 5197//6103 5194//6099 
f 5648//6104 5646//6105 5198//6106 
f 5199//6107 5652//6108 5648//6104 
f 5197//6103 5650//6102 5653//6109 
f 5653//6109 5199//6107 5197//6103 
f 5653//6109 5652//6108 5199//6107 
f 5200//6110 5198//6106 5646//6105 
f 5646//6105 5647//6111 5200//6110 
f 5647//6111 5649//6112 5203//6113 
f 5649//6112 5204//6114 5203//6113 
f 5202//6115 5201//6116 5644//6117 
f 5201//6116 5649//6112 5644//6117 
f 5644//6117 5643//6118 5202//6115 
f 5201//6116 5204//6114 5649//6112 
f 5643//6118 5205//6119 5202//6115 
f 5645//6120 5207//6121 5205//6119 
f 5641//6122 5639//6123 5206//6124 
f 5207//6121 5645//6120 5641//6122 
f 5206//6124 5207//6121 5641//6122 
f 5208//6125 5206//6124 5639//6123 
f 5639//6123 5640//6126 5208//6125 
f 5640//6126 5642//6127 5211//6128 
f 5642//6127 5212//6129 5211//6128 
f 5210//6130 5209//6131 5637//6132 
f 5209//6131 5642//6127 5637//6132 
f 5637//6132 5636//6133 5210//6130 
f 5209//6131 5212//6129 5642//6127 
f 5636//6133 5213//6134 5210//6130 
f 5215//6135 5634//6136 5632//6137 
f 5215//6135 5638//6138 5634//6136 
f 5636//6133 5638//6138 5215//6135 
f 5215//6135 5213//6134 5636//6133 
f 5631//6139 5216//6140 5214//6141 
f 5214//6141 5632//6137 5631//6139 
f 5631//6139 5633//6142 5216//6140 
f 5633//6142 5635//6143 5219//6144 
f 5635//6143 5220//6145 5219//6144 
f 5635//6143 5629//6146 5217//6147 
f 5218//6148 5217//6147 5629//6146 
f 5629//6146 5628//6149 5218//6148 
f 5217//6147 5220//6145 5635//6143 
f 5628//6149 5221//6150 5218//6148 
f 5223//6151 5626//6152 5625//6153 
f 5223//6151 5630//6154 5626//6152 
f 5628//6149 5630//6154 5223//6151 
f 5223//6151 5221//6150 5628//6149 
f 5623//6155 5224//6156 5222//6157 
f 5222//6157 5625//6153 5623//6155 
f 5623//6155 5624//6158 5224//6156 
f 5624//6158 5627//6159 5227//6160 
f 5627//6159 5228//6161 5227//6160 
f 5226//6162 5225//6163 5621//6164 
f 5225//6163 5627//6159 5621//6164 
f 5621//6164 5620//6165 5226//6162 
f 5225//6163 5228//6161 5627//6159 
f 5620//6165 5229//6166 5226//6162 
f 5230//6167 5618//6168 5616//6169 
f 5230//6167 5622//6170 5618//6168 
f 5620//6165 5622//6170 5230//6167 
f 5230//6167 5229//6166 5620//6165 
f 5615//6171 5232//6172 5231//6173 
f 5231//6173 5616//6169 5615//6171 
f 5615//6171 5617//6174 5232//6172 
f 5617//6174 5619//6175 5235//6176 
f 5619//6175 5236//6177 5235//6176 
f 5619//6175 5233//6178 5236//6177 
f 5234//6179 5233//6178 5612//6180 
f 5233//6178 5619//6175 5612//6180 
f 5612//6180 5613//6181 5234//6179 
f 5613//6181 5237//6182 5234//6179 
f 5238//6183 5609//6184 5608//6185 
f 5238//6183 5614//6186 5609//6184 
f 5613//6181 5614//6186 5238//6183 
f 5238//6183 5237//6182 5613//6181 
f 5607//6187 5240//6188 5239//6189 
f 5239//6189 5608//6185 5607//6187 
f 5240//6188 5607//6187 5611//6190 
f 5244//6191 5611//6190 5610//6192 
f 5610//6192 5245//6193 5244//6191 
f 5610//6192 5604//6194 5243//6195 
f 5241//6196 5243//6195 5604//6194 
f 5604//6194 5605//6197 5241//6196 
f 5243//6195 5245//6193 5610//6192 
f 5248//6198 5601//6199 5600//6200 
f 5248//6198 5606//6201 5601//6199 
f 5605//6197 5606//6201 5248//6198 
f 5248//6198 5242//6202 5605//6197 
f 5600//6200 5249//6203 5248//6198 
f 5599//6204 5246//6205 5249//6203 
f 5249//6203 5600//6200 5599//6204 
f 5247//5657 5602//6206 5596//6207 
f 5596//6207 5973//5649 5247//5657 
f 5599//6204 5603//6208 5247//5657 
f 5247//5657 5246//6205 5599//6204 
f 5603//6208 5602//6206 5247//5657 
f 5972//5644 5973//5649 5592//6209 
f 5973//5649 5593//6210 5592//6209 
f 5973//5649 5598//6211 5593//6210 
f 5973//5649 5597//6212 5598//6211 
f 5972//5644 5594//6213 5588//6214 
f 5588//6214 5971//5640 5972//5644 
f 5972//5644 5591//6215 5595//6216 
f 5595//6216 5594//6213 5972//5644 
f 5970//5635 5971//5640 5585//6217 
f 5971//5640 5586//6218 5585//6217 
f 5971//5640 5590//6219 5586//6218 
f 5971//5640 5589//6220 5590//6219 
f 5970//5635 5581//6221 5580//6222 
f 5970//5635 5587//6223 5581//6221 
f 5580//6222 5969//5630 5970//5635 
f 5970//5635 5584//6224 5587//6223 
f 5968//5626 5969//5630 5577//6225 
f 5969//5630 5578//6226 5577//6225 
f 5969//5630 5583//6227 5578//6226 
f 5969//5630 5582//6228 5583//6227 
f 5967//5622 5968//5626 5573//6229 
f 5968//5626 5579//6230 5573//6229 
f 5573//6229 5572//6231 5967//5622 
f 5968//5626 5576//6232 5579//6230 
f 5966//5618 5967//5622 5569//6233 
f 5967//5622 5570//6234 5569//6233 
f 5967//5622 5575//6235 5570//6234 
f 5967//5622 5574//6236 5575//6235 
f 5964//5612 5966//5618 5565//6237 
f 5565//6237 5564//6238 5964//5612 
f 5966//5618 5571//6239 5565//6237 
f 5966//5618 5568//6240 5571//6239 
f 5965//5615 5964//5612 5561//6241 
f 5561//6241 5560//6242 5965//5615 
f 5964//5612 5567//6243 5562//6244 
f 5562//6244 5561//6241 5964//5612 
f 5964//5612 5566//6245 5567//6243 
f 5563//6246 5556//6247 5555//6248 
f 5555//6248 5965//5615 5563//6246 
f 5965//5615 5560//6242 5563//6246 
f 5965//5615 5555//6248 5285//6249 
f 5285//6249 5286//6250 5965//5615 
f 5287//6251 5285//6249 5555//6248 
f 5555//6248 5557//6252 5287//6251 
f 5557//6252 5558//6253 5287//6251 
f 5559//6254 5288//6255 5290//6256 
f 5290//6256 5558//6253 5559//6254 
f 5288//6255 5559//6254 5553//6257 
f 5553//6257 5289//6258 5288//6255 
f 5551//6259 5291//6260 5289//6258 
f 5289//6258 5552//6261 5551//6259 
f 5553//6257 5552//6261 5289//6258 
f 5551//6259 5554//6262 5293//6263 
f 5293//6263 5554//6262 5548//6264 
f 5548//6264 5292//6265 5293//6263 
f 5547//6266 5294//6267 5292//6265 
f 5292//6265 5548//6264 5547//6266 
f 5547//6266 5549//6268 5294//6267 
f 5550//6269 5295//6270 5297//6271 
f 5297//6271 5549//6268 5550//6269 
f 5295//6270 5550//6269 5545//6272 
f 5545//6272 5296//6273 5295//6270 
f 5543//6274 5298//6275 5296//6273 
f 5296//6273 5544//6276 5543//6274 
f 5545//6272 5544//6276 5296//6273 
f 5543//6274 5546//6277 5300//6278 
f 5299//6279 5300//6278 5546//6277 
f 5546//6277 5540//6280 5299//6279 
f 5539//6281 5301//6282 5299//6279 
f 5299//6279 5540//6280 5539//6281 
f 5301//6282 5539//6281 5542//6283 
f 5541//6284 5302//6285 5304//6286 
f 5304//6286 5542//6283 5541//6284 
f 5302//6285 5541//6284 5535//6287 
f 5535//6287 5303//6288 5302//6285 
f 5535//6287 5537//6289 5303//6288 
f 5536//6290 5305//6291 5303//6288 
f 5303//6288 5537//6289 5536//6290 
f 5309//6292 5308//6293 5538//6294 
f 5536//6290 5538//6294 5308//6293 
f 5308//6293 5305//6291 5536//6290 
f 5532//6295 5531//6296 5306//6297 
f 5531//6296 5307//6298 5306//6297 
f 5306//6297 5309//6292 5532//6295 
f 5944//6299 5527//6300 5529//6301 
f 5311//6302 5533//6303 5527//6300 
f 5527//6300 5944//6299 5311//6302 
f 5529//6301 5528//6304 5944//6299 
f 5534//6305 5310//6306 5307//6298 
f 5307//6298 5531//6296 5534//6305 
f 5534//6305 5533//6303 5310//6306 
f 5945//6307 5944//6299 5524//6308 
f 5944//6299 5530//6309 5524//6308 
f 5944//6299 5528//6304 5530//6309 
f 5946//6310 5519//6311 5521//6312 
f 5945//6307 5525//6313 5519//6311 
f 5519//6311 5946//6310 5945//6307 
f 5945//6307 5523//6314 5526//6315 
f 5526//6315 5525//6313 5945//6307 
f 5947//6316 5946//6310 5516//6317 
f 5946//6310 5522//6318 5516//6317 
f 5946//6310 5520//6319 5522//6318 
f 5948//6320 5511//6321 5513//6322 
f 5948//6320 5947//6316 5517//6323 
f 5517//6323 5511//6321 5948//6320 
f 5947//6316 5515//6324 5518//6325 
f 5518//6325 5517//6323 5947//6316 
f 5948//6320 5514//6326 5509//6327 
f 5509//6327 5949//6328 5948//6320 
f 5948//6320 5512//6329 5514//6326 
f 5950//6330 5504//6331 5506//6332 
f 5950//6330 5949//6328 5510//6333 
f 5949//6328 5508//6334 5510//6333 
f 5510//6333 5504//6331 5950//6330 
f 5950//6330 5507//6335 5502//6336 
f 5502//6336 5951//6337 5950//6330 
f 5950//6330 5505//6338 5507//6335 
f 5952//6339 5951//6337 5499//6340 
f 5499//6340 5497//6341 5952//6339 
f 5951//6337 5503//6342 5499//6340 
f 5951//6337 5501//6343 5503//6342 
f 5952//6339 5500//6344 5495//6345 
f 5495//6345 5953//6346 5952//6339 
f 5952//6339 5498//6347 5500//6344 
f 5954//6348 5953//6346 5491//6349 
f 5953//6346 5496//6350 5491//6349 
f 5953//6346 5494//6351 5496//6350 
f 5954//6348 5492//6352 5488//6353 
f 5488//6353 5955//6354 5954//6348 
f 5954//6348 5490//6355 5493//6356 
f 5493//6356 5492//6352 5954//6348 
f 5956//6357 5955//6354 5483//6358 
f 5955//6354 5489//6359 5483//6358 
f 5955//6354 5487//6360 5489//6359 
f 5956//6357 5484//6361 5480//6362 
f 5480//6362 5957//6363 5956//6357 
f 5956//6357 5486//6364 5485//6365 
f 5956//6357 5482//6366 5486//6364 
f 5485//6365 5484//6361 5956//6357 
f 5958//6367 5957//6363 5475//6368 
f 5957//6363 5481//6369 5475//6368 
f 5957//6363 5479//6370 5481//6369 
f 5959//6371 5958//6367 5476//6372 
f 5476//6372 5471//6373 5959//6371 
f 5958//6367 5478//6374 5477//6375 
f 5958//6367 5474//6376 5478//6374 
f 5477//6375 5476//6372 5958//6367 
f 5960//6377 5959//6371 5468//6378 
f 5959//6371 5473//6379 5468//6378 
f 5959//6371 5472//6380 5473//6379 
f 5961//6381 5960//6377 5465//6382 
f 5465//6382 5464//6383 5961//6381 
f 5960//6377 5469//6384 5465//6382 
f 5960//6377 5467//6385 5470//6386 
f 5470//6386 5469//6384 5960//6377 
f 5961//6381 5466//6387 5461//6388 
f 5461//6388 5962//6389 5961//6381 
f 5961//6381 5463//6390 5466//6387 
f 5963//6391 5962//6389 5458//6392 
f 5962//6389 5462//6393 5458//6392 
f 5962//6389 5460//6394 5462//6393 
f 5963//6391 5455//6395 5454//6396 
f 5454//6396 5456//6397 5963//6391 
f 5963//6391 5457//6398 5459//6399 
f 5459//6399 5455//6395 5963//6391 
f 5458//6392 5457//6398 5963//6391 
f 5461//6388 5460//6394 5962//6389 
f 5464//6383 5463//6390 5961//6381 
f 5468//6378 5467//6385 5960//6377 
f 5471//6373 5472//6380 5959//6371 
f 5475//6368 5474//6376 5958//6367 
f 5480//6362 5479//6370 5957//6363 
f 5483//6358 5482//6366 5956//6357 
f 5488//6353 5487//6360 5955//6354 
f 5491//6349 5490//6355 5954//6348 
f 5495//6345 5494//6351 5953//6346 
f 5497//6341 5498//6347 5952//6339 
f 5502//6336 5501//6343 5951//6337 
f 5506//6332 5505//6338 5950//6330 
f 5509//6327 5508//6334 5949//6328 
f 5513//6322 5512//6329 5948//6320 
f 5516//6317 5515//6324 5947//6316 
f 5521//6312 5520//6319 5946//6310 
f 5524//6308 5523//6314 5945//6307 
f 5311//6302 5310//6306 5533//6303 
f 5538//6294 5532//6295 5309//6292 
f 5542//6283 5304//6286 5301//6282 
f 5300//6278 5298//6275 5543//6274 
f 5297//6271 5294//6267 5549//6268 
f 5293//6263 5291//6260 5551//6259 
f 5290//6256 5287//6251 5558//6253 
f 5286//6250 5284//5617 5965//5615 
f 5564//6238 5566//6245 5964//5612 
f 5569//6233 5568//6240 5966//5618 
f 5572//6231 5574//6236 5967//5622 
f 5577//6225 5576//6232 5968//5626 
f 5580//6222 5582//6228 5969//5630 
f 5585//6217 5584//6224 5970//5635 
f 5588//6214 5589//6220 5971//5640 
f 5592//6209 5591//6215 5972//5644 
f 5596//6207 5597//6212 5973//5649 
f 5242//6202 5241//6196 5605//6197 
f 5611//6190 5244//6191 5240//6188 
f 5608//6185 5239//6189 5238//6183 
f 5235//6176 5232//6172 5617//6174 
f 5616//6169 5231//6173 5230//6167 
f 5227//6160 5224//6156 5624//6158 
f 5625//6153 5222//6157 5223//6151 
f 5219//6144 5216//6140 5633//6142 
f 5632//6137 5214//6141 5215//6135 
f 5211//6128 5208//6125 5640//6126 
f 5205//6119 5643//6118 5645//6120 
f 5203//6113 5200//6110 5647//6111 
f 5198//6106 5199//6107 5648//6104 
f 5195//6097 5192//6094 5655//6095 
f 5190//6090 5191//6091 5656//6088 
f 5184//6078 5664//6079 5665//6080 
f 5183//6077 5181//5664 5975//5661 
f 5670//6065 5671//6071 5974//5658 
f 5673//6062 5675//6066 5976//5665 
f 5678//6059 5679//6063 5977//5669 
f 5685//6050 5163//6052 5160//6049 
f 5158//6046 5156//6040 5692//6043 
f 5149//6033 5694//6032 5695//6034 
f 5700//6027 5152//6029 5148//6024 
f 5142//6019 5141//6017 5702//6016 
f 5144//6014 5140//6008 5704//6011 
f 5138//6007 5137//6001 5709//6000 
f 5134//5997 5132//5993 5712//5995 
f 5719//5988 5714//5989 5130//5987 
f 5724//5979 5127//5981 5124//5977 
f 5721//5972 5123//5975 5121//5969 
f 5119//5965 5116//5961 5728//5963 
f 5730//5956 5115//5959 5113//5954 
f 5111//5949 5108//5944 5736//5947 
f 5107//5943 5105//5931 5740//5940 
f 5743//5933 5740//5940 5105//5931 
f 5745//5927 5744//5939 5101//5925 
f 5749//5919 5747//5928 5098//5917 
f 5754//5913 5752//5924 5094//5910 
f 5761//5904 5756//5914 5091//5902 
f 5087//5901 5083//5684 5980//5681 
f 5771//5886 5769//5893 5979//5680 
f 5776//5882 5773//5887 5981//5688 
f 5779//5875 5777//5884 5982//5691 
f 5784//5870 5781//5878 5066//5867 
f 5787//5861 5785//5874 5062//5859 
f 5792//5854 5789//5864 5058//5851 
f 5795//5846 5793//5858 5054//5847 
f 5800//5838 5797//5848 5050//5835 
f 5803//5830 5801//5842 5046//5831 
f 5808//5822 5805//5832 5042//5819 
f 5811//5813 5809//5826 5038//5811 
f 5816//5806 5813//5816 5034//5803 
f 5818//5799 5817//5810 5030//5800 
f 5823//5792 5821//5801 5027//5789 
f 5826//5788 5824//5793 5023//5785 
f 5830//5777 5829//5786 5020//5774 
f 5834//5773 5832//5779 5016//5771 
f 5010//5760 5838//5763 5837//5758 
f 5841//5757 5840//5765 5008//5755 
f 5002//5745 5845//5747 5844//5743 
f 4999//5740 4997//5704 4736//5702 
f 4976//5727 4974//5732 4706//5725 
f 4980//5722 4977//5728 4719//5720 
f 4983//5719 4981//5724 4739//5716 
f 4987//5715 4984//5718 4738//5710 
f 4991//5709 4989//5714 4755//5706 
f 4995//5705 4992//5708 4737//5699 
f 5078//5690 5075//5693 5981//5688 
f 5080//5685 5079//5689 5979//5680 
f 5164//6056 5978//5676 5165//5678 
f 5177//5667 5173//5674 5976//5665 
f 5175//5663 5174//5668 5974//5658 
f 5251//5653 5250//5654 5973//5649 
f 5259//5646 5256//5652 5972//5644 
f 5261//5642 5260//5648 5971//5640 
f 5265//5637 5263//5643 5970//5635 
f 5270//5632 5267//5639 5969//5630 
f 5273//5628 5271//5634 5968//5626 
f 5275//5625 5274//5629 5967//5622 
f 5279//5620 5277//5624 5966//5618 
f 5283//5614 5280//5621 5964//5612 
o mesh292
f 4693//6400 5449//6400 5448//6400 
f 5432//6400 5334//6400 4688//6400 
f 4686//6400 5332//6400 5331//6400 
f 5332//6400 4686//6400 4688//6400 
f 5323//6400 4680//6400 4682//6400 
f 4678//6400 5312//6400 5311//6400 
f 5312//6400 4678//6400 4677//6400 
f 5945//6400 4703//6400 4678//6400 
f 5962//6400 4685//6400 4684//6400 
f 5451//6400 5450//6400 4693//6400 
f 5447//6400 5446//6400 4692//6400 
f 4693//6400 5450//6400 5449//6400 
f 5444//6400 5443//6400 4691//6400 
f 4692//6400 5446//6400 5445//6400 
f 5441//6400 5440//6400 4689//6400 
f 4689//6400 5439//6400 5438//6400 
f 4687//6400 5433//6400 5432//6400 
f 4688//6400 5336//6400 5332//6400 
f 4682//6400 5325//6400 5323//6400 
f 5318//6400 4681//6400 4680//6400 
f 4679//6400 4681//6400 5319//6400 
f 4677//6400 5315//6400 5312//6400 
f 4678//6400 5944//6400 5945//6400 
f 5949//6400 4700//6400 4701//6400 
f 5961//6400 4684//6400 4675//6400 
f 4684//6400 5961//6400 5962//6400 
f 4694//6400 5452//6400 5451//6400 
f 4694//6400 5456//6400 5453//6400 
f 5448//6400 5447//6400 4693//6400 
f 5445//6400 5444//6400 4692//6400 
f 4691//6400 5442//6400 5441//6400 
f 5437//6400 5436//6400 4690//6400 
f 4689//6400 5440//6400 5439//6400 
f 4688//6400 4687//6400 5432//6400 
f 5331//6400 5333//6400 4686//6400 
f 4683//6400 5329//6400 5327//6400 
f 5329//6400 4683//6400 4686//6400 
f 5323//6400 5322//6400 4680//6400 
f 4680//6400 5320//6400 5318//6400 
f 5319//6400 5317//6400 4679//6400 
f 5945//6400 5946//6400 4703//6400 
f 5946//6400 5947//6400 4702//6400 
f 4701//6400 5948//6400 5949//6400 
f 5950//6400 5951//6400 4699//6400 
f 5951//6400 5952//6400 4698//6400 
f 5953//6400 4697//6400 4698//6400 
f 5954//6400 5955//6400 4696//6400 
f 5958//6400 5959//6400 4674//6400 
f 5962//6400 5963//6400 4685//6400 
f 5963//6400 5456//6400 4694//6400 
f 5453//6400 5452//6400 4694//6400 
f 4691//6400 4692//6400 5444//6400 
f 4691//6400 5443//6400 5442//6400 
f 5438//6400 5437//6400 4689//6400 
f 5434//6400 5433//6400 4687//6400 
f 4690//6400 5436//6400 5435//6400 
f 5333//6400 5330//6400 4686//6400 
f 4686//6400 5330//6400 5329//6400 
f 4682//6400 5328//6400 5324//6400 
f 5328//6400 4682//6400 4683//6400 
f 5322//6400 5321//6400 4680//6400 
f 5317//6400 5316//6400 4679//6400 
f 4677//6400 5314//6400 5313//6400 
f 4677//6400 4679//6400 5316//6400 
f 4702//6400 4703//6400 5946//6400 
f 5948//6400 4701//6400 4702//6400 
f 4699//6400 4700//6400 5950//6400 
f 4698//6400 5952//6400 5953//6400 
f 4697//6400 5953//6400 5954//6400 
f 5955//6400 5956//6400 4695//6400 
f 5957//6400 4676//6400 4695//6400 
f 4676//6400 5957//6400 5958//6400 
f 4694//6400 4685//6400 5963//6400 
f 4692//6400 4693//6400 5447//6400 
f 4690//6400 4689//6400 5437//6400 
f 5435//6400 5434//6400 4690//6400 
f 5327//6400 5326//6400 4683//6400 
f 4683//6400 5326//6400 5328//6400 
f 5318//6400 5319//6400 4681//6400 
f 5316//6400 5314//6400 4677//6400 
f 4702//6400 5947//6400 5948//6400 
f 4698//6400 4699//6400 5951//6400 
f 4695//6400 4696//6400 5955//6400 
f 4674//6400 4676//6400 5958//6400 
f 4693//6400 4694//6400 5451//6400 
f 4687//6400 4690//6400 5434//6400 
f 5324//6400 5325//6400 4682//6400 
f 5313//6400 5315//6400 4677//6400 
f 5949//6400 5950//6400 4700//6400 
f 4695//6400 5956//6400 5957//6400 
f 4689//6400 4691//6400 5441//6400 
f 5321//6400 5320//6400 4680//6400 
f 4696//6400 4697//6400 5954//6400 
f 5959//6400 5960//6400 4675//6400 
f 5334//6400 5336//6400 4688//6400 
f 4675//6400 4674//6400 5959//6400 
f 5311//6400 5944//6400 4678//6400 
f 4675//6400 5960//6400 5961//6400 
g bearing
v 0.0946739 -0.0163599 0.0421107 
v 0.0946155 -0.0163599 0.0415733 
v 0.0946155 -0.00615989 0.0415733 
v 0.0948465 -0.0163599 0.042623 
v 0.0946739 -0.00615989 0.0421107 
v 0.0951252 -0.0163599 0.0430862 
v 0.0948465 -0.00615989 0.042623 
v 0.095497 -0.0163599 0.0434787 
v 0.0951252 -0.00615989 0.0430862 
v 0.0959445 -0.0163599 0.0437821 
v 0.095497 -0.00615989 0.0434787 
v 0.0964467 -0.0163599 0.0439822 
v 0.0959445 -0.00615989 0.0437821 
v 0.0969801 -0.0163599 0.0440696 
v 0.0964467 -0.00615989 0.0439822 
v 0.0975199 -0.0163599 0.0440404 
v 0.0969801 -0.00615989 0.0440696 
v 0.0980408 -0.0163599 0.0438957 
v 0.0975199 -0.00615989 0.0440404 
v 0.0985184 -0.0163599 0.0436425 
v 0.0980408 -0.00615989 0.0438957 
v 0.0989305 -0.0163599 0.0432925 
v 0.0985184 -0.00615989 0.0436425 
v 0.0992576 -0.0163599 0.0428622 
v 0.0989305 -0.00615989 0.0432925 
v 0.0994846 -0.0163599 0.0423716 
v 0.0992576 -0.00615989 0.0428622 
v 0.0996008 -0.0163599 0.0418436 
v 0.0994846 -0.00615989 0.0423716 
v 0.0996008 -0.0163599 0.041303 
v 0.0996008 -0.00615989 0.0418436 
v 0.0994846 -0.0163599 0.040775 
v 0.0996008 -0.00615989 0.041303 
v 0.0992576 -0.0163599 0.0402844 
v 0.0994846 -0.00615989 0.040775 
v 0.0989305 -0.0163599 0.039854 
v 0.0992576 -0.00615989 0.0402844 
v 0.0985184 -0.0163599 0.0395041 
v 0.0989305 -0.00615989 0.039854 
v 0.0980408 -0.0163599 0.0392509 
v 0.0985184 -0.00615989 0.0395041 
v 0.0975199 -0.0163599 0.0391062 
v 0.0980408 -0.00615989 0.0392509 
v 0.0969801 -0.0163599 0.039077 
v 0.0975199 -0.00615989 0.0391062 
v 0.0964467 -0.0163599 0.0391644 
v 0.0969801 -0.00615989 0.039077 
v 0.0959445 -0.0163599 0.0393645 
v 0.0964467 -0.00615989 0.0391644 
v 0.095497 -0.0163599 0.0396679 
v 0.0959445 -0.00615989 0.0393645 
v 0.0951252 -0.0163599 0.0400604 
v 0.095497 -0.00615989 0.0396679 
v 0.0948465 -0.0163599 0.0405236 
v 0.0951252 -0.00615989 0.0400604 
v 0.0946739 -0.0163599 0.0410359 
v 0.0948465 -0.00615989 0.0405236 
v 0.0946739 -0.00615989 0.0410359 
v 0.10394 -0.00615989 0.0351089 
v 0.102391 -0.00615989 0.033793 
v 0.10517 -0.00615989 0.0367271 
v 0.0966066 -0.00615989 0.0321871 
v 0.0946007 -0.00615989 0.0325159 
v 0.100595 -0.00615989 0.0328409 
v 0.0986362 -0.00615989 0.0322971 
v 0.09103 -0.00615989 0.034409 
v 0.0896322 -0.00615989 0.0358847 
v 0.0879352 -0.00615989 0.0395526 
v 0.0877155 -0.00615989 0.0415733 
v 0.0927124 -0.00615989 0.0332683 
v 0.0879352 -0.00615989 0.043594 
v 0.0885843 -0.00615989 0.0376263 
v 0.10394 -0.00615989 0.0480377 
v 0.10517 -0.00615989 0.0464195 
v 0.102391 -0.00615989 0.0493536 
v 0.106023 -0.00615989 0.0385719 
v 0.0885843 -0.00615989 0.0455203 
v 0.0896322 -0.00615989 0.0472619 
v 0.09103 -0.00615989 0.0487376 
v 0.0927124 -0.00615989 0.0498783 
v 0.0946007 -0.00615989 0.0506307 
v 0.0966066 -0.00615989 0.0509595 
v 0.106023 -0.00615989 0.0445747 
v 0.10646 -0.00615989 0.0425896 
v 0.10646 -0.00615989 0.040557 
v 0.0986362 -0.00615989 0.0508495 
v 0.100595 -0.00615989 0.0503057 
v 0.0851155 -0.00875989 0.0415733 
v 0.085396 -0.00875989 0.0389937 
v 0.0862246 -0.00875989 0.0365346 
v 0.0875624 -0.00875989 0.0343112 
v 0.0893468 -0.00875989 0.0324274 
v 0.0914946 -0.00875989 0.0309712 
v 0.0939051 -0.00875989 0.0300107 
v 0.0964658 -0.00875989 0.0295909 
v 0.0990569 -0.00875989 0.0297314 
v 0.101557 -0.00875989 0.0304256 
v 0.10385 -0.00875989 0.031641 
v 0.105827 -0.00875989 0.0333209 
v 0.107398 -0.00875989 0.0353867 
v 0.108487 -0.00875989 0.0377417 
v 0.109045 -0.00875989 0.0402759 
v 0.109045 -0.00875989 0.0428707 
v 0.108487 -0.00875989 0.0454049 
v 0.107398 -0.00875989 0.0477599 
v 0.105827 -0.00875989 0.0498257 
v 0.10385 -0.00875989 0.0515056 
v 0.101557 -0.00875989 0.052721 
v 0.0990569 -0.00875989 0.0534152 
v 0.0964658 -0.00875989 0.0535557 
v 0.0939051 -0.00875989 0.0531359 
v 0.0914946 -0.00875989 0.0521754 
v 0.0893468 -0.00875989 0.0507192 
v 0.0875624 -0.00875989 0.0488354 
v 0.0862246 -0.00875989 0.046612 
v 0.085396 -0.00875989 0.0441529 
v 0.0854647 -0.0137599 0.0390088 
v 0.0851858 -0.0137599 0.0402759 
v 0.0862884 -0.0137599 0.0365642 
v 0.0857436 -0.0137599 0.0377417 
v 0.0876184 -0.0137599 0.0343538 
v 0.0868332 -0.0137599 0.0353867 
v 0.0893924 -0.0137599 0.032481 
v 0.0884035 -0.0137599 0.0333209 
v 0.0915275 -0.0137599 0.0310333 
v 0.0903812 -0.0137599 0.031641 
v 0.093924 -0.0137599 0.0300785 
v 0.0926738 -0.0137599 0.0304256 
v 0.0964696 -0.0137599 0.0296611 
v 0.0951741 -0.0137599 0.0297314 
v 0.0990455 -0.0137599 0.0298008 
v 0.0977651 -0.0137599 0.0295909 
v 0.101531 -0.0137599 0.0304909 
v 0.100326 -0.0137599 0.0300107 
v 0.10381 -0.0137599 0.0316993 
v 0.102736 -0.0137599 0.0309712 
v 0.104884 -0.0137599 0.0324274 
v 0.105776 -0.0137599 0.0333693 
v 0.106669 -0.0137599 0.0343112 
v 0.107337 -0.0137599 0.0354229 
v 0.108006 -0.0137599 0.0365346 
v 0.108421 -0.0137599 0.0377641 
v 0.108975 -0.0137599 0.0402835 
v 0.108835 -0.0137599 0.0389937 
v 0.108975 -0.0137599 0.0428631 
v 0.109115 -0.0137599 0.0415733 
v 0.108421 -0.0137599 0.0453825 
v 0.108835 -0.0137599 0.0441529 
v 0.107337 -0.0137599 0.0477237 
v 0.108006 -0.0137599 0.046612 
v 0.105776 -0.0137599 0.0497773 
v 0.106669 -0.0137599 0.0488354 
v 0.10381 -0.0137599 0.0514473 
v 0.104884 -0.0137599 0.0507192 
v 0.101531 -0.0137599 0.0526557 
v 0.102736 -0.0137599 0.0521754 
v 0.0990455 -0.0137599 0.0533458 
v 0.100326 -0.0137599 0.0531359 
v 0.0964696 -0.0137599 0.0534855 
v 0.0977651 -0.0137599 0.0535557 
v 0.093924 -0.0137599 0.0530681 
v 0.0951741 -0.0137599 0.0534152 
v 0.0915275 -0.0137599 0.0521133 
v 0.0926738 -0.0137599 0.052721 
v 0.0893924 -0.0137599 0.0506656 
v 0.0903812 -0.0137599 0.0515056 
v 0.0876184 -0.0137599 0.0487928 
v 0.0884035 -0.0137599 0.0498257 
v 0.0862884 -0.0137599 0.0465824 
v 0.0868332 -0.0137599 0.0477599 
v 0.0854647 -0.0137599 0.0441378 
v 0.0857436 -0.0137599 0.0454049 
v 0.0851155 -0.0137599 0.0415733 
v 0.0851858 -0.0137599 0.0428707 
v 0.106296 -0.0163599 0.0395526 
v 0.106515 -0.0163599 0.0415733 
v 0.105647 -0.0163599 0.0376263 
v 0.104599 -0.0163599 0.0358847 
v 0.103201 -0.0163599 0.034409 
v 0.101519 -0.0163599 0.0332683 
v 0.0996302 -0.0163599 0.0325159 
v 0.0976244 -0.0163599 0.0321871 
v 0.0955947 -0.0163599 0.0322971 
v 0.0936362 -0.0163599 0.0328409 
v 0.0918403 -0.0163599 0.033793 
v 0.0902911 -0.0163599 0.0351089 
v 0.089061 -0.0163599 0.0367271 
v 0.0882075 -0.0163599 0.0385719 
v 0.0877706 -0.0163599 0.040557 
v 0.0877155 -0.0163599 0.0415733 
v 0.0877706 -0.0163599 0.0425896 
v 0.0882075 -0.0163599 0.0445747 
v 0.089061 -0.0163599 0.0464195 
v 0.0902911 -0.0163599 0.0480377 
v 0.0918403 -0.0163599 0.0493536 
v 0.0936362 -0.0163599 0.0503057 
v 0.0955947 -0.0163599 0.0508495 
v 0.0976244 -0.0163599 0.0509595 
v 0.0996302 -0.0163599 0.0506307 
v 0.101519 -0.0163599 0.0498783 
v 0.103201 -0.0163599 0.0487376 
v 0.104599 -0.0163599 0.0472619 
v 0.105647 -0.0163599 0.0455203 
v 0.106296 -0.0163599 0.043594 
vn 0.987099 -0.0150398 -0.159406 
vn 0.999172 -0.0148994 0.0378619 
vn 0.935743 -0.0152372 -0.352353 
vn 0.987099 -0.0150398 -0.159406 
vn 0.845614 -0.0154882 -0.53357 
vn 0.935743 -0.0152372 -0.352353 
vn 0.718463 -0.0157877 -0.695386 
vn 0.845614 -0.0154882 -0.53357 
vn 0.557513 -0.0161281 -0.830012 
vn 0.718463 -0.0157877 -0.695386 
vn 0.367732 -0.0164985 -0.929785 
vn 0.557513 -0.0161281 -0.830012 
vn 0.156097 -0.0168837 -0.987597 
vn 0.367732 -0.0164985 -0.929785 
vn -0.0682421 -0.0172645 -0.997519 
vn 0.156097 -0.0168837 -0.987597 
vn -0.294016 -0.0176178 -0.955638 
vn -0.0682421 -0.0172645 -0.997519 
vn -0.508281 -0.0179184 -0.861005 
vn -0.294016 -0.0176178 -0.955638 
vn -0.697364 -0.0181414 -0.716488 
vn -0.508281 -0.0179184 -0.861005 
vn -0.848287 -0.0182666 -0.529221 
vn -0.697364 -0.0181414 -0.716488 
vn -0.950446 -0.0182816 -0.310352 
vn -0.848287 -0.0182666 -0.529221 
vn -0.997095 -0.018185 -0.0739696 
vn -0.950446 -0.0182816 -0.310352 
vn -0.986201 -0.0179863 0.164574 
vn -0.997095 -0.018185 -0.0739696 
vn -0.920422 -0.0177041 0.390526 
vn -0.986201 -0.0179863 0.164574 
vn -0.806292 -0.0173623 0.591263 
vn -0.920422 -0.0177041 0.390526 
vn -0.652963 -0.0169864 0.7572 
vn -0.806292 -0.0173623 0.591263 
vn -0.470891 -0.0166003 0.882035 
vn -0.652963 -0.0169864 0.7572 
vn -0.270761 -0.0162244 0.96251 
vn -0.470891 -0.0166003 0.882035 
vn -0.0627489 -0.0158747 0.997903 
vn -0.270761 -0.0162244 0.96251 
vn 0.143891 -0.0155634 0.989471 
vn -0.0627489 -0.0158747 0.997903 
vn 0.340996 -0.0152989 0.93994 
vn 0.143891 -0.0155634 0.989471 
vn 0.521521 -0.0150869 0.853105 
vn 0.340996 -0.0152989 0.93994 
vn 0.679481 -0.0149311 0.733541 
vn 0.521521 -0.0150869 0.853105 
vn 0.809878 -0.0148336 0.58641 
vn 0.679481 -0.0149311 0.733541 
vn 0.90863 -0.0147957 0.417341 
vn 0.809878 -0.0148336 0.58641 
vn 0.972517 -0.0148177 0.23236 
vn 0.90863 -0.0147957 0.417341 
vn 0.0981662 0.994282 0.0420231 
vn -0.661259 0.748802 0.0450674 
vn -0.646932 0.752985 -0.120384 
vn -0.594618 0.754135 -0.278765 
vn -0.50722 0.752158 -0.420698 
vn -0.390139 0.747215 -0.538015 
vn -0.250691 0.739703 -0.624495 
vn -0.0973114 0.730184 -0.676285 
vn 0.0612667 0.719314 -0.691978 
vn 0.216723 0.707764 -0.672385 
vn 0.361655 0.69616 -0.620135 
vn 0.489861 0.685049 -0.539207 
vn 0.596451 0.674882 -0.43449 
vn 0.677829 0.66601 -0.311412 
vn 0.731613 0.6587 -0.175661 
vn 0.756518 0.65314 -0.0329795 
vn 0.752255 0.64946 0.11097 
vn 0.719434 0.647735 0.250706 
vn 0.6595 0.648001 0.380992 
vn 0.574682 0.650251 0.496904 
vn 0.467974 0.654441 0.593891 
vn 0.34312 0.660482 0.667856 
vn 0.204618 0.66823 0.715263 
vn 0.0577031 0.677475 0.733278 
vn -0.0916806 0.687933 0.719961 
vn -0.236972 0.699223 0.674487 
vn -0.371162 0.710869 0.597414 
vn -0.487087 0.722302 0.490944 
vn -0.577857 0.732878 0.359125 
vn -0.637429 0.741925 0.207923 
vn -0.980951 -0.0182469 -0.193397 
vn -0.997095 -0.018185 -0.0739696 
vn -0.998778 -0.0180974 0.0459887 
vn -0.905988 -0.0182882 -0.422908 
vn -0.950446 -0.0182816 -0.310352 
vn -0.778333 -0.0182172 -0.627587 
vn -0.848287 -0.0182666 -0.529221 
vn -0.606817 -0.018041 -0.794637 
vn -0.697364 -0.0181414 -0.716488 
vn -0.403439 -0.0177763 -0.914834 
vn -0.508281 -0.0179184 -0.861005 
vn -0.181728 -0.0174462 -0.983194 
vn -0.294016 -0.0176178 -0.955638 
vn 0.0448577 -0.017076 -0.998847 
vn -0.0682421 -0.0172645 -0.997519 
vn 0.264126 -0.0166903 -0.964344 
vn 0.156097 -0.0168837 -0.987597 
vn 0.46584 -0.0163104 -0.884719 
vn 0.367732 -0.0164985 -0.929785 
vn 0.641946 -0.0159534 -0.766584 
vn 0.557513 -0.0161281 -0.830012 
vn 0.786502 -0.0156323 -0.617389 
vn 0.718463 -0.0157877 -0.695386 
vn 0.895447 -0.0153562 -0.444902 
vn 0.845614 -0.0154882 -0.53357 
vn 0.966326 -0.0151316 -0.256876 
vn 0.935743 -0.0152372 -0.352353 
vn 0.998034 -0.0149624 -0.0608611 
vn 0.987099 -0.0150398 -0.159406 
vn 0.990613 -0.0148511 0.135887 
vn 0.999172 -0.0148994 0.0378619 
vn 0.945099 -0.0147992 0.326448 
vn 0.972517 -0.0148177 0.23236 
vn 0.863431 -0.0148072 0.50425 
vn 0.90863 -0.0147957 0.417341 
vn 0.748401 -0.014875 0.66308 
vn 0.809878 -0.0148336 0.58641 
vn 0.603656 -0.0150018 0.797104 
vn 0.679481 -0.0149311 0.733541 
vn 0.433729 -0.0151861 0.900915 
vn 0.521521 -0.0150869 0.853105 
vn 0.244102 -0.0154249 0.969627 
vn 0.340996 -0.0152989 0.93994 
vn 0.0412791 -0.0157137 0.999024 
vn 0.143891 -0.0155634 0.989471 
vn -0.167137 -0.0160454 0.985803 
vn -0.0627489 -0.0158747 0.997903 
vn -0.372429 -0.0164099 0.927916 
vn -0.270761 -0.0162244 0.96251 
vn -0.564847 -0.0167932 0.825025 
vn -0.470891 -0.0166003 0.882035 
vn -0.73389 -0.017177 0.679051 
vn -0.652963 -0.0169864 0.7572 
vn -0.868874 -0.017539 0.494722 
vn -0.806292 -0.0173623 0.591263 
vn -0.959841 -0.0178542 0.279977 
vn -0.920422 -0.0177041 0.390526 
vn -0.998778 -0.0180974 0.0459887 
vn -0.986201 -0.0179863 0.164574 
vn 0.732599 -0.672867 -0.10271 
vn 0.741339 -0.670353 -0.0323178 
vn 0.742899 -0.668301 0.0384033 
vn 0.693681 -0.679222 -0.239718 
vn 0.71669 -0.675829 -0.172078 
vn 0.626955 -0.687204 -0.366984 
vn 0.663704 -0.683022 -0.304923 
vn 0.53427 -0.696586 -0.478877 
vn 0.583698 -0.691738 -0.4252 
vn 0.418616 -0.707058 -0.569938 
vn 0.47908 -0.701709 -0.52734 
vn 0.284211 -0.718223 -0.635122 
vn 0.353444 -0.712583 -0.606055 
vn 0.136543 -0.729587 -0.670118 
vn 0.211643 -0.723914 -0.656624 
vn -0.0176904 -0.740577 -0.671738 
vn 0.059785 -0.735168 -0.675244 
vn -0.170776 -0.750559 -0.638355 
vn -0.0948891 -0.745735 -0.659451 
vn -0.314378 -0.758889 -0.570311 
vn -0.244293 -0.754969 -0.608557 
vn -0.440122 -0.764975 -0.470218 
vn -0.379987 -0.762245 -0.524015 
vn -0.540342 -0.768355 -0.343018 
vn -0.493853 -0.767026 -0.409611 
vn -0.608848 -0.768759 -0.195739 
vn -0.578868 -0.768937 -0.271381 
vn -0.641594 -0.766155 -0.0369364 
vn -0.629847 -0.767825 -0.117205 
vn -0.637068 -0.76075 0.124107 
vn -0.643982 -0.763781 0.0438899 
vn -0.596338 -0.752964 0.278254 
vn -0.621067 -0.757122 0.202586 
vn -0.522764 -0.74336 0.417292 
vn -0.56337 -0.748351 0.350122 
vn -0.421482 -0.732576 0.534496 
vn -0.475213 -0.738075 0.478976 
vn -0.298786 -0.721252 0.624919 
vn -0.362388 -0.726942 0.583292 
vn -0.161544 -0.709982 0.685441 
vn -0.231546 -0.715576 0.659043 
vn -0.016704 -0.699283 0.71465 
vn -0.0896464 -0.704533 0.703987 
vn 0.129055 -0.689577 0.712621 
vn 0.0564602 -0.694283 0.717484 
vn 0.26956 -0.681196 0.680668 
vn 0.200326 -0.685204 0.700261 
vn 0.399274 -0.67439 0.621111 
vn 0.336084 -0.677584 0.654162 
vn 0.513369 -0.669335 0.537069 
vn 0.458547 -0.671635 0.581929 
vn 0.607748 -0.666152 0.432301 
vn 0.56325 -0.667504 0.487019 
vn 0.679062 -0.664908 0.311082 
vn 0.646468 -0.665284 0.373464 
vn 0.724718 -0.665629 0.178105 
vn 0.70523 -0.665023 0.245756 
vn 0.737326 -0.666724 0.108768 
vn 0.742899 -0.668301 0.0384033 
vn 0.0950403 -0.994642 0.0406849 
usemtl 0.400000_0.400000_0.400000_0.000000_0.000000
o mesh3
f 5983//6401 5984//6402 5985//6402 
f 5986//6403 5983//6401 5987//6404 
f 5988//6405 5986//6403 5989//6406 
f 5990//6407 5988//6405 5991//6408 
f 5992//6409 5990//6407 5993//6410 
f 5994//6411 5992//6409 5995//6412 
f 5996//6413 5994//6411 5997//6414 
f 5998//6415 5996//6413 5999//6416 
f 6000//6417 5998//6415 6001//6418 
f 6002//6419 6000//6417 6003//6420 
f 6004//6421 6002//6419 6005//6422 
f 6006//6423 6004//6421 6007//6424 
f 6008//6425 6006//6423 6009//6426 
f 6010//6427 6008//6425 6011//6428 
f 6012//6429 6010//6427 6013//6430 
f 6014//6431 6012//6429 6015//6432 
f 6016//6433 6014//6431 6017//6434 
f 6018//6435 6016//6433 6019//6436 
f 6020//6437 6018//6435 6021//6438 
f 6022//6439 6020//6437 6023//6440 
f 6024//6441 6022//6439 6025//6442 
f 6026//6443 6024//6441 6027//6444 
f 6028//6445 6026//6443 6029//6446 
f 6030//6447 6028//6445 6031//6448 
f 6032//6449 6030//6447 6033//6450 
f 6034//6451 6032//6449 6035//6452 
f 6036//6453 6034//6451 6037//6454 
f 6038//6455 6036//6453 6039//6456 
f 5984//6402 6038//6455 6040//6455 
f 6040//6455 5985//6402 5984//6402 
f 6039//6456 6040//6455 6038//6455 
f 6037//6454 6039//6456 6036//6453 
f 6035//6452 6037//6454 6034//6451 
f 6033//6450 6035//6452 6032//6449 
f 6031//6448 6033//6450 6030//6447 
f 6029//6446 6031//6448 6028//6445 
f 6027//6444 6029//6446 6026//6443 
f 6025//6442 6027//6444 6024//6441 
f 6023//6440 6025//6442 6022//6439 
f 6021//6438 6023//6440 6020//6437 
f 6019//6436 6021//6438 6018//6435 
f 6017//6434 6019//6436 6016//6433 
f 6015//6432 6017//6434 6014//6431 
f 6013//6430 6015//6432 6012//6429 
f 6011//6428 6013//6430 6010//6427 
f 6009//6426 6011//6428 6008//6425 
f 6007//6424 6009//6426 6006//6423 
f 6005//6422 6007//6424 6004//6421 
f 6003//6420 6005//6422 6002//6419 
f 6001//6418 6003//6420 6000//6417 
f 5999//6416 6001//6418 5998//6415 
f 5997//6414 5999//6416 5996//6413 
f 5995//6412 5997//6414 5994//6411 
f 5993//6410 5995//6412 5992//6409 
f 5991//6408 5993//6410 5990//6407 
f 5989//6406 5991//6408 5988//6405 
f 5987//6404 5989//6406 5986//6403 
f 5985//6402 5987//6404 5983//6401 
o mesh4
f 6041//6457 6021//6457 6019//6457 
f 6041//6457 6042//6457 6023//6457 
f 6043//6457 6019//6457 6017//6457 
f 6023//6457 6021//6457 6041//6457 
f 6044//6457 6029//6457 6027//6457 
f 6044//6457 6045//6457 6031//6457 
f 6019//6457 6043//6457 6041//6457 
f 6042//6457 6046//6457 6025//6457 
f 6047//6457 6027//6457 6025//6457 
f 6031//6457 6029//6457 6044//6457 
f 6048//6457 6035//6457 6033//6457 
f 6048//6457 6049//6457 6037//6457 
f 6050//6457 6040//6457 6039//6457 
f 6051//6457 5985//6457 6040//6457 
f 6025//6457 6023//6457 6042//6457 
f 6027//6457 6047//6457 6044//6457 
f 6052//6457 6033//6457 6031//6457 
f 6037//6457 6035//6457 6048//6457 
f 6040//6457 6050//6457 6051//6457 
f 6053//6457 5987//6457 5985//6457 
f 6025//6457 6046//6457 6047//6457 
f 6033//6457 6052//6457 6048//6457 
f 6054//6457 6039//6457 6037//6457 
f 5985//6457 6051//6457 6053//6457 
f 6055//6457 6007//6457 6005//6457 
f 6056//6457 6009//6457 6007//6457 
f 6031//6457 6045//6457 6052//6457 
f 6039//6457 6054//6457 6050//6457 
f 6057//6457 6005//6457 6003//6457 
f 6007//6457 6055//6457 6056//6457 
f 6058//6457 6017//6457 6015//6457 
f 6037//6457 6049//6457 6054//6457 
f 6059//6457 5989//6457 5987//6457 
f 6060//6457 5991//6457 5989//6457 
f 6061//6457 5993//6457 5991//6457 
f 6062//6457 5995//6457 5993//6457 
f 6063//6457 5997//6457 5995//6457 
f 6063//6457 6064//6457 5999//6457 
f 6005//6457 6057//6457 6055//6457 
f 6065//6457 6011//6457 6009//6457 
f 6066//6457 6013//6457 6011//6457 
f 6067//6457 6015//6457 6013//6457 
f 6017//6457 6058//6457 6043//6457 
f 5989//6457 6059//6457 6060//6457 
f 5993//6457 6061//6457 6062//6457 
f 5999//6457 5997//6457 6063//6457 
f 6068//6457 6001//6457 5999//6457 
f 6069//6457 6003//6457 6001//6457 
f 6009//6457 6056//6457 6065//6457 
f 6013//6457 6066//6457 6067//6457 
f 5987//6457 6053//6457 6059//6457 
f 5995//6457 6062//6457 6063//6457 
f 6001//6457 6068//6457 6069//6457 
f 6011//6457 6065//6457 6066//6457 
f 5991//6457 6060//6457 6061//6457 
f 6003//6457 6069//6457 6057//6457 
f 5999//6457 6064//6457 6068//6457 
f 6015//6457 6067//6457 6058//6457 
o mesh5
f 6070//6458 6051//6458 6050//6459 
f 6071//6459 6050//6459 6054//6460 
f 6072//6460 6054//6460 6049//6461 
f 6073//6461 6049//6461 6048//6462 
f 6074//6462 6048//6462 6052//6463 
f 6075//6463 6052//6463 6045//6464 
f 6076//6464 6045//6464 6044//6465 
f 6077//6465 6044//6465 6047//6466 
f 6078//6466 6047//6466 6046//6467 
f 6079//6467 6046//6467 6042//6468 
f 6080//6468 6042//6468 6041//6469 
f 6081//6469 6041//6469 6043//6470 
f 6082//6470 6043//6470 6058//6471 
f 6083//6471 6058//6471 6067//6472 
f 6084//6472 6067//6472 6066//6473 
f 6085//6473 6066//6473 6065//6474 
f 6086//6474 6065//6474 6056//6475 
f 6087//6475 6056//6475 6055//6476 
f 6088//6476 6055//6476 6057//6477 
f 6089//6477 6057//6477 6069//6478 
f 6090//6478 6069//6478 6068//6479 
f 6091//6479 6068//6479 6064//6480 
f 6092//6480 6064//6480 6063//6481 
f 6093//6481 6063//6481 6062//6482 
f 6094//6482 6062//6482 6061//6483 
f 6095//6483 6061//6483 6060//6484 
f 6096//6484 6060//6484 6059//6485 
f 6097//6485 6059//6485 6053//6486 
f 6098//6486 6053//6486 6051//6458 
f 6051//6458 6070//6458 6098//6486 
f 6053//6486 6098//6486 6097//6485 
f 6059//6485 6097//6485 6096//6484 
f 6060//6484 6096//6484 6095//6483 
f 6061//6483 6095//6483 6094//6482 
f 6062//6482 6094//6482 6093//6481 
f 6063//6481 6093//6481 6092//6480 
f 6064//6480 6092//6480 6091//6479 
f 6068//6479 6091//6479 6090//6478 
f 6069//6478 6090//6478 6089//6477 
f 6057//6477 6089//6477 6088//6476 
f 6055//6476 6088//6476 6087//6475 
f 6056//6475 6087//6475 6086//6474 
f 6065//6474 6086//6474 6085//6473 
f 6066//6473 6085//6473 6084//6472 
f 6067//6472 6084//6472 6083//6471 
f 6058//6471 6083//6471 6082//6470 
f 6043//6470 6082//6470 6081//6469 
f 6041//6469 6081//6469 6080//6468 
f 6042//6468 6080//6468 6079//6467 
f 6046//6467 6079//6467 6078//6466 
f 6047//6466 6078//6466 6077//6465 
f 6044//6465 6077//6465 6076//6464 
f 6045//6464 6076//6464 6075//6463 
f 6052//6463 6075//6463 6074//6462 
f 6048//6462 6074//6462 6073//6461 
f 6049//6461 6073//6461 6072//6460 
f 6054//6460 6072//6460 6071//6459 
f 6050//6459 6071//6459 6070//6458 
o mesh6
f 6071//6487 6099//6487 6100//6488 
f 6100//6488 6070//6489 6071//6487 
f 6072//6490 6101//6490 6102//6491 
f 6102//6491 6071//6487 6072//6490 
f 6073//6492 6103//6492 6104//6493 
f 6104//6493 6072//6490 6073//6492 
f 6074//6494 6105//6494 6106//6495 
f 6106//6495 6073//6492 6074//6494 
f 6075//6496 6107//6496 6108//6497 
f 6108//6497 6074//6494 6075//6496 
f 6076//6498 6109//6498 6110//6499 
f 6110//6499 6075//6496 6076//6498 
f 6077//6500 6111//6500 6112//6501 
f 6112//6501 6076//6498 6077//6500 
f 6078//6502 6113//6502 6114//6503 
f 6114//6503 6077//6500 6078//6502 
f 6079//6504 6115//6504 6116//6505 
f 6116//6505 6078//6502 6079//6504 
f 6080//6506 6117//6506 6118//6507 
f 6118//6507 6079//6504 6080//6506 
f 6080//6506 6081//6508 6119//6509 
f 6081//6508 6120//6508 6119//6509 
f 6081//6508 6082//6510 6121//6511 
f 6082//6510 6122//6510 6121//6511 
f 6082//6510 6083//6512 6123//6513 
f 6083//6512 6124//6512 6123//6513 
f 6084//6514 6125//6514 6126//6515 
f 6126//6515 6083//6512 6084//6514 
f 6085//6516 6127//6516 6128//6517 
f 6128//6517 6084//6514 6085//6516 
f 6086//6518 6129//6518 6130//6519 
f 6130//6519 6085//6516 6086//6518 
f 6087//6520 6131//6520 6132//6521 
f 6132//6521 6086//6518 6087//6520 
f 6088//6522 6133//6522 6134//6523 
f 6134//6523 6087//6520 6088//6522 
f 6089//6524 6135//6524 6136//6525 
f 6136//6525 6088//6522 6089//6524 
f 6090//6526 6137//6526 6138//6527 
f 6138//6527 6089//6524 6090//6526 
f 6091//6528 6139//6528 6140//6529 
f 6140//6529 6090//6526 6091//6528 
f 6092//6530 6141//6530 6142//6531 
f 6142//6531 6091//6528 6092//6530 
f 6093//6532 6143//6532 6144//6533 
f 6144//6533 6092//6530 6093//6532 
f 6094//6534 6145//6534 6146//6535 
f 6146//6535 6093//6532 6094//6534 
f 6095//6536 6147//6536 6148//6537 
f 6148//6537 6094//6534 6095//6536 
f 6096//6538 6149//6538 6150//6539 
f 6150//6539 6095//6536 6096//6538 
f 6097//6540 6151//6540 6152//6541 
f 6152//6541 6096//6538 6097//6540 
f 6098//6542 6153//6542 6154//6543 
f 6154//6543 6097//6540 6098//6542 
f 6070//6489 6155//6544 6156//6545 
f 6156//6545 6098//6542 6070//6489 
f 6156//6545 6153//6542 6098//6542 
f 6154//6543 6151//6540 6097//6540 
f 6152//6541 6149//6538 6096//6538 
f 6150//6539 6147//6536 6095//6536 
f 6148//6537 6145//6534 6094//6534 
f 6146//6535 6143//6532 6093//6532 
f 6144//6533 6141//6530 6092//6530 
f 6142//6531 6139//6528 6091//6528 
f 6140//6529 6137//6526 6090//6526 
f 6138//6527 6135//6524 6089//6524 
f 6136//6525 6133//6522 6088//6522 
f 6134//6523 6131//6520 6087//6520 
f 6132//6521 6129//6518 6086//6518 
f 6130//6519 6127//6516 6085//6516 
f 6128//6517 6125//6514 6084//6514 
f 6126//6515 6124//6512 6083//6512 
f 6123//6513 6122//6510 6082//6510 
f 6121//6511 6120//6508 6081//6508 
f 6119//6509 6117//6506 6080//6506 
f 6118//6507 6115//6504 6079//6504 
f 6116//6505 6113//6502 6078//6502 
f 6114//6503 6111//6500 6077//6500 
f 6112//6501 6109//6498 6076//6498 
f 6110//6499 6107//6496 6075//6496 
f 6108//6497 6105//6494 6074//6494 
f 6106//6495 6103//6492 6073//6492 
f 6104//6493 6101//6490 6072//6490 
f 6102//6491 6099//6487 6071//6487 
f 6100//6488 6155//6544 6070//6489 
o mesh7
f 6157//6546 6126//6546 6125//6547 
f 6125//6547 6158//6548 6157//6546 
f 6159//6549 6123//6549 6124//6550 
f 6124//6550 6157//6546 6159//6549 
f 6160//6551 6121//6551 6122//6552 
f 6122//6552 6159//6549 6160//6551 
f 6161//6553 6119//6553 6120//6554 
f 6120//6554 6160//6551 6161//6553 
f 6162//6555 6118//6555 6117//6556 
f 6117//6556 6161//6553 6162//6555 
f 6163//6557 6116//6557 6115//6558 
f 6115//6558 6162//6555 6163//6557 
f 6164//6559 6114//6559 6113//6560 
f 6113//6560 6163//6557 6164//6559 
f 6165//6561 6112//6561 6111//6562 
f 6111//6562 6164//6559 6165//6561 
f 6166//6563 6110//6563 6109//6564 
f 6109//6564 6165//6561 6166//6563 
f 6167//6565 6108//6565 6107//6566 
f 6107//6566 6166//6563 6167//6565 
f 6168//6567 6106//6567 6105//6568 
f 6105//6568 6167//6565 6168//6567 
f 6169//6569 6104//6569 6103//6570 
f 6103//6570 6168//6567 6169//6569 
f 6170//6571 6102//6571 6101//6572 
f 6101//6572 6169//6569 6170//6571 
f 6171//6573 6100//6573 6099//6574 
f 6099//6574 6170//6571 6171//6573 
f 6156//6575 6155//6576 6172//6576 
f 6100//6573 6171//6573 6172//6576 
f 6172//6576 6155//6576 6100//6573 
f 6173//6575 6174//6577 6153//6578 
f 6174//6577 6154//6577 6153//6578 
f 6174//6577 6175//6579 6151//6580 
f 6175//6579 6152//6579 6151//6580 
f 6175//6579 6176//6581 6149//6582 
f 6176//6581 6150//6581 6149//6582 
f 6177//6583 6148//6583 6147//6584 
f 6147//6584 6176//6581 6177//6583 
f 6178//6585 6146//6585 6145//6586 
f 6145//6586 6177//6583 6178//6585 
f 6179//6587 6144//6587 6143//6588 
f 6143//6588 6178//6585 6179//6587 
f 6180//6589 6142//6589 6141//6590 
f 6141//6590 6179//6587 6180//6589 
f 6181//6591 6140//6591 6139//6592 
f 6139//6592 6180//6589 6181//6591 
f 6182//6593 6138//6593 6137//6594 
f 6137//6594 6181//6591 6182//6593 
f 6183//6595 6136//6595 6135//6596 
f 6135//6596 6182//6593 6183//6595 
f 6183//6595 6184//6597 6133//6598 
f 6184//6597 6134//6597 6133//6598 
f 6185//6599 6132//6599 6131//6600 
f 6131//6600 6184//6597 6185//6599 
f 6186//6601 6130//6601 6129//6602 
f 6129//6602 6185//6599 6186//6601 
f 6186//6601 6158//6548 6127//6603 
f 6158//6548 6128//6604 6127//6603 
f 6127//6603 6130//6601 6186//6601 
f 6129//6602 6132//6599 6185//6599 
f 6131//6600 6134//6597 6184//6597 
f 6133//6598 6136//6595 6183//6595 
f 6135//6596 6138//6593 6182//6593 
f 6137//6594 6140//6591 6181//6591 
f 6139//6592 6142//6589 6180//6589 
f 6141//6590 6144//6587 6179//6587 
f 6143//6588 6146//6585 6178//6585 
f 6145//6586 6148//6583 6177//6583 
f 6147//6584 6150//6581 6176//6581 
f 6149//6582 6152//6579 6175//6579 
f 6151//6580 6154//6577 6174//6577 
f 6153//6578 6156//6575 6173//6575 
f 6172//6576 6173//6575 6156//6575 
f 6099//6574 6102//6571 6170//6571 
f 6101//6572 6104//6569 6169//6569 
f 6103//6570 6106//6567 6168//6567 
f 6105//6568 6108//6565 6167//6565 
f 6107//6566 6110//6563 6166//6563 
f 6109//6564 6112//6561 6165//6561 
f 6111//6562 6114//6559 6164//6559 
f 6113//6560 6116//6557 6163//6557 
f 6115//6558 6118//6555 6162//6555 
f 6117//6556 6119//6553 6161//6553 
f 6120//6554 6121//6551 6160//6551 
f 6122//6552 6123//6549 6159//6549 
f 6124//6550 6126//6546 6157//6546 
f 6125//6547 6128//6604 6158//6548 
o mesh8
f 6171//6605 6170//6605 6038//6605 
f 5984//6605 6172//6605 6171//6605 
f 6170//6605 6169//6605 6036//6605 
f 6168//6605 6167//6605 6032//6605 
f 6167//6605 6166//6605 6030//6605 
f 6036//6605 6038//6605 6170//6605 
f 6169//6605 6168//6605 6034//6605 
f 6030//6605 6032//6605 6167//6605 
f 6166//6605 6165//6605 6028//6605 
f 6165//6605 6164//6605 6026//6605 
f 6164//6605 6163//6605 6024//6605 
f 6161//6605 6160//6605 6018//6605 
f 6160//6605 6159//6605 6016//6605 
f 6184//6605 6183//6605 6004//6605 
f 6183//6605 6182//6605 6002//6605 
f 6034//6605 6036//6605 6169//6605 
f 6028//6605 6030//6605 6166//6605 
f 6024//6605 6026//6605 6164//6605 
f 6163//6605 6162//6605 6022//6605 
f 6162//6605 6161//6605 6020//6605 
f 6016//6605 6018//6605 6160//6605 
f 6157//6605 6158//6605 6012//6605 
f 6158//6605 6186//6605 6010//6605 
f 6002//6605 6004//6605 6183//6605 
f 6182//6605 6181//6605 6000//6605 
f 6032//6605 6034//6605 6168//6605 
f 6022//6605 6024//6605 6163//6605 
f 6018//6605 6020//6605 6161//6605 
f 6159//6605 6157//6605 6014//6605 
f 6010//6605 6012//6605 6158//6605 
f 6186//6605 6185//6605 6008//6605 
f 6185//6605 6184//6605 6006//6605 
f 6000//6605 6002//6605 6182//6605 
f 6179//6605 6178//6605 5994//6605 
f 6178//6605 6177//6605 5992//6605 
f 6177//6605 6176//6605 5990//6605 
f 6176//6605 6175//6605 5988//6605 
f 6026//6605 6028//6605 6165//6605 
f 6014//6605 6016//6605 6159//6605 
f 6008//6605 6010//6605 6186//6605 
f 6004//6605 6006//6605 6184//6605 
f 5992//6605 5994//6605 6178//6605 
f 5988//6605 5990//6605 6176//6605 
f 6175//6605 6174//6605 5986//6605 
f 6174//6605 6173//6605 5983//6605 
f 6020//6605 6022//6605 6162//6605 
f 6006//6605 6008//6605 6185//6605 
f 6181//6605 6180//6605 5998//6605 
f 6180//6605 6179//6605 5996//6605 
f 5990//6605 5992//6605 6177//6605 
f 5983//6605 5986//6605 6174//6605 
f 6012//6605 6014//6605 6157//6605 
f 5996//6605 5998//6605 6180//6605 
f 5986//6605 5988//6605 6175//6605 
f 6173//6605 6172//6605 5984//6605 
f 5998//6605 6000//6605 6181//6605 
f 5984//6605 5983//6605 6173//6605 
f 5994//6605 5996//6605 6179//6605 
f 6038//6605 5984//6605 6171//6605 
g 1mmSpacer
v 0.0864706 -0.00515989 -0.00849684 
v 0.0871155 -0.00515989 -0.0084267 
v 0.0871155 -0.00615989 -0.0084267 
v 0.0858558 -0.00515989 -0.00870398 
v 0.0864706 -0.00615989 -0.00849684 
v 0.0853 -0.00515989 -0.00903842 
v 0.0858558 -0.00615989 -0.00870398 
v 0.084829 -0.00515989 -0.00948454 
v 0.0853 -0.00615989 -0.00903842 
v 0.0844649 -0.00515989 -0.0100215 
v 0.084829 -0.00615989 -0.00948454 
v 0.0842248 -0.00515989 -0.0106241 
v 0.0844649 -0.00615989 -0.0100215 
v 0.0841199 -0.00515989 -0.0112643 
v 0.0842248 -0.00615989 -0.0106241 
v 0.084155 -0.00515989 -0.011912 
v 0.0841199 -0.00615989 -0.0112643 
v 0.0843285 -0.00515989 -0.0125371 
v 0.084155 -0.00615989 -0.011912 
v 0.0846324 -0.00515989 -0.0131103 
v 0.0843285 -0.00615989 -0.0125371 
v 0.0850524 -0.00515989 -0.0136047 
v 0.0846324 -0.00615989 -0.0131103 
v 0.0855688 -0.00515989 -0.0139973 
v 0.0850524 -0.00615989 -0.0136047 
v 0.0861576 -0.00515989 -0.0142697 
v 0.0855688 -0.00615989 -0.0139973 
v 0.0867911 -0.00515989 -0.0144091 
v 0.0861576 -0.00615989 -0.0142697 
v 0.0874398 -0.00515989 -0.0144091 
v 0.0871155 -0.00515989 -0.0144267 
v 0.0871155 -0.00615989 -0.0144267 
v 0.0867911 -0.00615989 -0.0144091 
v 0.0880734 -0.00515989 -0.0142697 
v 0.0874398 -0.00615989 -0.0144091 
v 0.0886621 -0.00515989 -0.0139973 
v 0.0880734 -0.00615989 -0.0142697 
v 0.0891786 -0.00515989 -0.0136047 
v 0.0886621 -0.00615989 -0.0139973 
v 0.0895985 -0.00515989 -0.0131103 
v 0.0891786 -0.00615989 -0.0136047 
v 0.0899024 -0.00515989 -0.0125371 
v 0.0895985 -0.00615989 -0.0131103 
v 0.090076 -0.00515989 -0.011912 
v 0.0899024 -0.00615989 -0.0125371 
v 0.0901111 -0.00515989 -0.0112643 
v 0.090076 -0.00615989 -0.011912 
v 0.0900061 -0.00515989 -0.0106241 
v 0.0901111 -0.00615989 -0.0112643 
v 0.089766 -0.00515989 -0.0100215 
v 0.0900061 -0.00615989 -0.0106241 
v 0.089402 -0.00515989 -0.00948454 
v 0.089766 -0.00615989 -0.0100215 
v 0.088931 -0.00515989 -0.00903842 
v 0.089402 -0.00615989 -0.00948454 
v 0.0883751 -0.00515989 -0.00870398 
v 0.088931 -0.00615989 -0.00903842 
v 0.0877604 -0.00515989 -0.00849684 
v 0.0883751 -0.00615989 -0.00870398 
v 0.0877604 -0.00615989 -0.00849684 
v 0.0901641 -0.00615989 -0.00883716 
v 0.0895362 -0.00615989 -0.00824233 
v 0.088795 -0.00615989 -0.0077964 
v 0.0879754 -0.00615989 -0.00752022 
v 0.0871155 -0.00615989 -0.0074267 
v 0.087548 -0.00615989 -0.0154033 
v 0.0883927 -0.00615989 -0.0152173 
v 0.0906495 -0.00615989 -0.00955307 
v 0.0840668 -0.00615989 -0.00883716 
v 0.0835814 -0.00615989 -0.00955307 
v 0.0850533 -0.00615989 -0.0148541 
v 0.0858383 -0.00615989 -0.0152173 
v 0.086683 -0.00615989 -0.0154033 
v 0.0871155 -0.00615989 -0.0154267 
v 0.0891777 -0.00615989 -0.0148541 
v 0.0898663 -0.00615989 -0.0143307 
v 0.0904262 -0.00615989 -0.0136715 
v 0.0908314 -0.00615989 -0.0129073 
v 0.0910628 -0.00615989 -0.0120738 
v 0.0909697 -0.00615989 -0.0103566 
v 0.0862556 -0.00615989 -0.00752022 
v 0.0846948 -0.00615989 -0.00824233 
v 0.0838047 -0.00615989 -0.0136715 
v 0.0843647 -0.00615989 -0.0143307 
v 0.0911096 -0.00615989 -0.0112101 
v 0.0854359 -0.00615989 -0.0077964 
v 0.0831213 -0.00615989 -0.0112101 
v 0.0831682 -0.00615989 -0.0120738 
v 0.0832613 -0.00615989 -0.0103566 
v 0.0833996 -0.00615989 -0.0129073 
v 0.0871155 -0.00515989 -0.0074267 
v 0.0879754 -0.00515989 -0.00752022 
v 0.088795 -0.00515989 -0.0077964 
v 0.0895362 -0.00515989 -0.00824233 
v 0.0901641 -0.00515989 -0.00883716 
v 0.0906495 -0.00515989 -0.00955307 
v 0.0909697 -0.00515989 -0.0103566 
v 0.0911096 -0.00515989 -0.0112101 
v 0.0910628 -0.00515989 -0.0120738 
v 0.0908314 -0.00515989 -0.0129073 
v 0.0904262 -0.00515989 -0.0136715 
v 0.0898663 -0.00515989 -0.0143307 
v 0.0891777 -0.00515989 -0.0148541 
v 0.0883927 -0.00515989 -0.0152173 
v 0.086683 -0.00515989 -0.0154033 
v 0.0871155 -0.00515989 -0.0154267 
v 0.087548 -0.00515989 -0.0154033 
v 0.0858383 -0.00515989 -0.0152173 
v 0.0850533 -0.00515989 -0.0148541 
v 0.0843647 -0.00515989 -0.0143307 
v 0.0838047 -0.00515989 -0.0136715 
v 0.0833996 -0.00515989 -0.0129073 
v 0.0831682 -0.00515989 -0.0120738 
v 0.0831213 -0.00515989 -0.0112101 
v 0.0832613 -0.00515989 -0.0103566 
v 0.0835814 -0.00515989 -0.00955307 
v 0.0840668 -0.00515989 -0.00883716 
v 0.0846948 -0.00515989 -0.00824233 
v 0.0854359 -0.00515989 -0.0077964 
v 0.0862556 -0.00515989 -0.00752022 
vn 0.318586 -0.00495013 -0.947881 
vn 0.115022 -0.00506767 -0.99335 
vn 0.50451 -0.00484766 -0.863392 
vn 0.318586 -0.00495013 -0.947881 
vn 0.66667 -0.00476256 -0.745337 
vn 0.50451 -0.00484766 -0.863392 
vn 0.800273 -0.00469627 -0.599618 
vn 0.66667 -0.00476256 -0.745337 
vn 0.901677 -0.00464964 -0.432385 
vn 0.800273 -0.00469627 -0.599618 
vn 0.968251 -0.00462314 -0.249937 
vn 0.901677 -0.00464964 -0.432385 
vn 0.998267 -0.004617 -0.0586672 
vn 0.968251 -0.00462314 -0.249937 
vn 0.990841 -0.00463125 0.134951 
vn 0.998267 -0.004617 -0.0586672 
vn 0.945921 -0.0046658 0.324362 
vn 0.990841 -0.00463125 0.134951 
vn 0.864316 -0.00472032 0.502926 
vn 0.945921 -0.0046658 0.324362 
vn 0.74778 -0.00479423 0.663929 
vn 0.864316 -0.00472032 0.502926 
vn 0.599142 -0.00488645 0.800628 
vn 0.74778 -0.00479423 0.663929 
vn 0.422492 -0.00499525 0.906353 
vn 0.599142 -0.00488645 0.800628 
vn 0.223401 -0.0051179 0.974713 
vn 0.422492 -0.00499525 0.906353 
vn 0.00915422 -0.00525038 0.999944 
vn 0.117645 -0.00518322 0.993042 
vn 0.223401 -0.0051179 0.974713 
vn -0.211089 -0.0053871 0.977452 
vn 0.00915422 -0.00525038 0.999944 
vn -0.426306 -0.00552079 0.904562 
vn -0.211089 -0.0053871 0.977452 
vn -0.623971 -0.00564268 0.781427 
vn -0.426306 -0.00552079 0.904562 
vn -0.790905 -0.00574323 0.611912 
vn -0.623971 -0.00564268 0.781427 
vn -0.914679 -0.00581336 0.40414 
vn -0.790905 -0.00574323 0.611912 
vn -0.985366 -0.00584606 0.17035 
vn -0.914679 -0.00581336 0.40414 
vn -0.997228 -0.00583785 -0.0741803 
vn -0.985366 -0.00584606 0.17035 
vn -0.949736 -0.00578962 -0.312999 
vn -0.997228 -0.00583785 -0.0741803 
vn -0.847568 -0.00570639 -0.530656 
vn -0.949736 -0.00578962 -0.312999 
vn -0.699591 -0.00559621 -0.714522 
vn -0.847568 -0.00570639 -0.530656 
vn -0.517249 -0.0054685 -0.855817 
vn -0.699591 -0.00559621 -0.714522 
vn -0.31291 -0.00533263 -0.949768 
vn -0.517249 -0.0054685 -0.855817 
vn -0.0985552 -0.00519682 -0.995118 
vn -0.31291 -0.00533263 -0.949768 
vn 0.115724 -0.993217 -0.0112909 
vn 0.117645 -0.00518322 0.993042 
vn 0.325339 -0.00505506 0.945584 
vn 0.514008 -0.00493892 0.857771 
vn 0.67725 -0.00483814 0.735737 
vn 0.810265 -0.0047549 0.586044 
vn 0.909618 -0.00469059 0.415418 
vn 0.973039 -0.004646 0.230596 
vn 0.999257 -0.00462158 0.0382562 
vn 0.987903 -0.00461752 -0.155002 
vn 0.939446 -0.00463386 -0.342665 
vn 0.855186 -0.00467046 -0.518299 
vn 0.737294 -0.004727 -0.675555 
vn 0.588889 -0.00480283 -0.808199 
vn 0.414169 -0.00489685 -0.910187 
vn 0.218569 -0.0050072 -0.975809 
vn 0.00894619 -0.00513107 -0.999947 
vn 0.115022 -0.00506767 -0.99335 
vn 0.218569 -0.0050072 -0.975809 
vn 0.00894619 -0.00513107 -0.999947 
vn -0.206276 -0.00526427 -0.97848 
vn -0.417059 -0.00540104 -0.908863 
vn -0.611947 -0.00553394 -0.79088 
vn -0.77863 -0.00565409 -0.627457 
vn -0.905013 -0.00575193 -0.425345 
vn -0.980723 -0.00581851 -0.195317 
vn -0.998811 -0.00584712 0.0484009 
vn -0.957132 -0.00583471 0.289595 
vn -0.858888 -0.0057826 0.512132 
vn -0.712093 -0.00569622 0.702062 
vn -0.528155 -0.0055838 0.84913 
vn -0.320081 -0.00545484 0.947375 
vn -0.100865 -0.00531863 0.994886 
vn 0.116908 0.993077 -0.0114065 
usemtl 0.647059_0.647059_0.647059_0.000000_0.000000
o mesh264
f 6187//6606 6188//6607 6189//6607 
f 6190//6608 6187//6606 6191//6609 
f 6192//6610 6190//6608 6193//6611 
f 6194//6612 6192//6610 6195//6613 
f 6196//6614 6194//6612 6197//6615 
f 6198//6616 6196//6614 6199//6617 
f 6200//6618 6198//6616 6201//6619 
f 6202//6620 6200//6618 6203//6621 
f 6204//6622 6202//6620 6205//6623 
f 6206//6624 6204//6622 6207//6625 
f 6208//6626 6206//6624 6209//6627 
f 6210//6628 6208//6626 6211//6629 
f 6212//6630 6210//6628 6213//6631 
f 6214//6632 6212//6630 6215//6633 
f 6216//6634 6217//6635 6218//6635 
f 6219//6636 6218//6635 6217//6635 
f 6217//6635 6214//6632 6219//6636 
f 6220//6637 6216//6634 6221//6638 
f 6222//6639 6220//6637 6223//6640 
f 6224//6641 6222//6639 6225//6642 
f 6226//6643 6224//6641 6227//6644 
f 6228//6645 6226//6643 6229//6646 
f 6230//6647 6228//6645 6231//6648 
f 6232//6649 6230//6647 6233//6650 
f 6234//6651 6232//6649 6235//6652 
f 6236//6653 6234//6651 6237//6654 
f 6238//6655 6236//6653 6239//6656 
f 6240//6657 6238//6655 6241//6658 
f 6242//6659 6240//6657 6243//6660 
f 6244//6661 6242//6659 6245//6662 
f 6188//6607 6244//6661 6246//6661 
f 6246//6661 6189//6607 6188//6607 
f 6245//6662 6246//6661 6244//6661 
f 6243//6660 6245//6662 6242//6659 
f 6241//6658 6243//6660 6240//6657 
f 6239//6656 6241//6658 6238//6655 
f 6237//6654 6239//6656 6236//6653 
f 6235//6652 6237//6654 6234//6651 
f 6233//6650 6235//6652 6232//6649 
f 6231//6648 6233//6650 6230//6647 
f 6229//6646 6231//6648 6228//6645 
f 6227//6644 6229//6646 6226//6643 
f 6225//6642 6227//6644 6224//6641 
f 6223//6640 6225//6642 6222//6639 
f 6221//6638 6223//6640 6220//6637 
f 6218//6635 6221//6638 6216//6634 
f 6215//6633 6219//6636 6214//6632 
f 6213//6631 6215//6633 6212//6630 
f 6211//6629 6213//6631 6210//6628 
f 6209//6627 6211//6629 6208//6626 
f 6207//6625 6209//6627 6206//6624 
f 6205//6623 6207//6625 6204//6622 
f 6203//6621 6205//6623 6202//6620 
f 6201//6619 6203//6621 6200//6618 
f 6199//6617 6201//6619 6198//6616 
f 6197//6615 6199//6617 6196//6614 
f 6195//6613 6197//6615 6194//6612 
f 6193//6611 6195//6613 6192//6610 
f 6191//6609 6193//6611 6190//6608 
f 6189//6607 6191//6609 6187//6606 
o mesh265
f 6247//6663 6248//6663 6243//6663 
f 6248//6663 6249//6663 6245//6663 
f 6249//6663 6250//6663 6246//6663 
f 6250//6663 6251//6663 6189//6663 
f 6252//6663 6221//6663 6218//6663 
f 6253//6663 6223//6663 6221//6663 
f 6254//6663 6239//6663 6237//6663 
f 6254//6663 6247//6663 6241//6663 
f 6245//6663 6243//6663 6248//6663 
f 6189//6663 6246//6663 6250//6663 
f 6255//6663 6197//6663 6195//6663 
f 6255//6663 6256//6663 6199//6663 
f 6257//6663 6213//6663 6211//6663 
f 6258//6663 6215//6663 6213//6663 
f 6258//6663 6259//6663 6219//6663 
f 6260//6663 6218//6663 6219//6663 
f 6221//6663 6252//6663 6253//6663 
f 6261//6663 6225//6663 6223//6663 
f 6261//6663 6262//6663 6227//6663 
f 6262//6663 6263//6663 6229//6663 
f 6264//6663 6231//6663 6229//6663 
f 6264//6663 6265//6663 6233//6663 
f 6266//6663 6237//6663 6235//6663 
f 6241//6663 6239//6663 6254//6663 
f 6246//6663 6245//6663 6249//6663 
f 6251//6663 6267//6663 6191//6663 
f 6268//6663 6195//6663 6193//6663 
f 6199//6663 6197//6663 6255//6663 
f 6269//6663 6209//6663 6207//6663 
f 6269//6663 6270//6663 6211//6663 
f 6213//6663 6257//6663 6258//6663 
f 6219//6663 6259//6663 6260//6663 
f 6223//6663 6253//6663 6261//6663 
f 6229//6663 6227//6663 6262//6663 
f 6233//6663 6231//6663 6264//6663 
f 6265//6663 6271//6663 6235//6663 
f 6237//6663 6266//6663 6254//6663 
f 6191//6663 6189//6663 6251//6663 
f 6272//6663 6193//6663 6191//6663 
f 6195//6663 6268//6663 6255//6663 
f 6273//6663 6203//6663 6201//6663 
f 6273//6663 6274//6663 6205//6663 
f 6211//6663 6209//6663 6269//6663 
f 6219//6663 6215//6663 6258//6663 
f 6227//6663 6225//6663 6261//6663 
f 6235//6663 6233//6663 6265//6663 
f 6243//6663 6241//6663 6247//6663 
f 6193//6663 6272//6663 6268//6663 
f 6275//6663 6201//6663 6199//6663 
f 6205//6663 6203//6663 6273//6663 
f 6276//6663 6207//6663 6205//6663 
f 6211//6663 6270//6663 6257//6663 
f 6229//6663 6263//6663 6264//6663 
f 6191//6663 6267//6663 6272//6663 
f 6201//6663 6275//6663 6273//6663 
f 6207//6663 6276//6663 6269//6663 
f 6235//6663 6271//6663 6266//6663 
f 6205//6663 6274//6663 6276//6663 
f 6199//6663 6256//6663 6275//6663 
f 6218//6663 6260//6663 6252//6663 
o mesh266
f 6277//6664 6251//6664 6250//6665 
f 6278//6665 6250//6665 6249//6666 
f 6279//6666 6249//6666 6248//6667 
f 6280//6667 6248//6667 6247//6668 
f 6281//6668 6247//6668 6254//6669 
f 6282//6669 6254//6669 6266//6670 
f 6283//6670 6266//6670 6271//6671 
f 6284//6671 6271//6671 6265//6672 
f 6285//6672 6265//6672 6264//6673 
f 6286//6673 6264//6673 6263//6674 
f 6287//6674 6263//6674 6262//6675 
f 6288//6675 6262//6675 6261//6676 
f 6289//6676 6261//6676 6253//6677 
f 6290//6677 6253//6677 6252//6678 
f 6291//6679 6292//6680 6260//6680 
f 6252//6678 6260//6680 6292//6680 
f 6292//6680 6293//6681 6252//6678 
f 6291//6679 6259//6682 6258//6683 
f 6294//6683 6258//6683 6257//6684 
f 6295//6684 6257//6684 6270//6685 
f 6296//6685 6270//6685 6269//6686 
f 6297//6686 6269//6686 6276//6687 
f 6298//6687 6276//6687 6274//6688 
f 6299//6688 6274//6688 6273//6689 
f 6300//6689 6273//6689 6275//6690 
f 6301//6690 6275//6690 6256//6691 
f 6302//6691 6256//6691 6255//6692 
f 6303//6692 6255//6692 6268//6693 
f 6304//6693 6268//6693 6272//6694 
f 6305//6694 6272//6694 6267//6695 
f 6306//6695 6267//6695 6251//6664 
f 6251//6664 6277//6664 6306//6695 
f 6267//6695 6306//6695 6305//6694 
f 6272//6694 6305//6694 6304//6693 
f 6268//6693 6304//6693 6303//6692 
f 6255//6692 6303//6692 6302//6691 
f 6256//6691 6302//6691 6301//6690 
f 6275//6690 6301//6690 6300//6689 
f 6273//6689 6300//6689 6299//6688 
f 6274//6688 6299//6688 6298//6687 
f 6276//6687 6298//6687 6297//6686 
f 6269//6686 6297//6686 6296//6685 
f 6270//6685 6296//6685 6295//6684 
f 6257//6684 6295//6684 6294//6683 
f 6258//6683 6294//6683 6291//6679 
f 6260//6680 6259//6682 6291//6679 
f 6252//6678 6293//6681 6290//6677 
f 6253//6677 6290//6677 6289//6676 
f 6261//6676 6289//6676 6288//6675 
f 6262//6675 6288//6675 6287//6674 
f 6263//6674 6287//6674 6286//6673 
f 6264//6673 6286//6673 6285//6672 
f 6265//6672 6285//6672 6284//6671 
f 6271//6671 6284//6671 6283//6670 
f 6266//6670 6283//6670 6282//6669 
f 6254//6669 6282//6669 6281//6668 
f 6247//6668 6281//6668 6280//6667 
f 6248//6667 6280//6667 6279//6666 
f 6249//6666 6279//6666 6278//6665 
f 6250//6665 6278//6665 6277//6664 
o mesh267
f 6293//6696 6292//6696 6217//6696 
f 6292//6696 6291//6696 6214//6696 
f 6290//6696 6293//6696 6216//6696 
f 6214//6696 6217//6696 6292//6696 
f 6278//6696 6244//6696 6188//6696 
f 6279//6696 6242//6696 6244//6696 
f 6217//6696 6216//6696 6293//6696 
f 6294//6696 6212//6696 6214//6696 
f 6244//6696 6278//6696 6279//6696 
f 6280//6696 6240//6696 6242//6696 
f 6282//6696 6236//6696 6238//6696 
f 6282//6696 6283//6696 6234//6696 
f 6289//6696 6290//6696 6220//6696 
f 6214//6696 6291//6696 6294//6696 
f 6294//6696 6295//6696 6210//6696 
f 6295//6696 6296//6696 6208//6696 
f 6242//6696 6279//6696 6280//6696 
f 6281//6696 6238//6696 6240//6696 
f 6234//6696 6236//6696 6282//6696 
f 6283//6696 6284//6696 6232//6696 
f 6286//6696 6228//6696 6230//6696 
f 6286//6696 6287//6696 6226//6696 
f 6288//6696 6224//6696 6226//6696 
f 6288//6696 6289//6696 6222//6696 
f 6216//6696 6220//6696 6290//6696 
f 6208//6696 6210//6696 6295//6696 
f 6240//6696 6280//6696 6281//6696 
f 6232//6696 6234//6696 6283//6696 
f 6285//6696 6230//6696 6232//6696 
f 6226//6696 6228//6696 6286//6696 
f 6222//6696 6224//6696 6288//6696 
f 6210//6696 6212//6696 6294//6696 
f 6297//6696 6206//6696 6208//6696 
f 6297//6696 6298//6696 6204//6696 
f 6238//6696 6281//6696 6282//6696 
f 6230//6696 6285//6696 6286//6696 
f 6220//6696 6222//6696 6289//6696 
f 6204//6696 6206//6696 6297//6696 
f 6303//6696 6194//6696 6196//6696 
f 6303//6696 6304//6696 6192//6696 
f 6232//6696 6284//6696 6285//6696 
f 6208//6696 6296//6696 6297//6696 
f 6300//6696 6200//6696 6202//6696 
f 6300//6696 6301//6696 6198//6696 
f 6192//6696 6194//6696 6303//6696 
f 6304//6696 6305//6696 6190//6696 
f 6226//6696 6287//6696 6288//6696 
f 6298//6696 6299//6696 6202//6696 
f 6198//6696 6200//6696 6300//6696 
f 6301//6696 6302//6696 6196//6696 
f 6190//6696 6192//6696 6304//6696 
f 6305//6696 6306//6696 6187//6696 
f 6202//6696 6204//6696 6298//6696 
f 6196//6696 6198//6696 6301//6696 
f 6187//6696 6190//6696 6305//6696 
f 6277//6696 6188//6696 6187//6696 
f 6202//6696 6299//6696 6300//6696 
f 6187//6696 6306//6696 6277//6696 
f 6196//6696 6302//6696 6303//6696 
f 6188//6696 6277//6696 6278//6696 
g bearing
v -0.0637211 -0.139897 -0.0966911 
v -0.0636627 -0.139359 -0.0966911 
v -0.0636627 -0.139359 -0.106891 
v -0.0638937 -0.140409 -0.0966911 
v -0.0637211 -0.139897 -0.106891 
v -0.0641724 -0.140872 -0.0966911 
v -0.0638937 -0.140409 -0.106891 
v -0.0645442 -0.141265 -0.0966911 
v -0.0641724 -0.140872 -0.106891 
v -0.0649916 -0.141568 -0.0966911 
v -0.0645442 -0.141265 -0.106891 
v -0.0654938 -0.141768 -0.0966911 
v -0.0649916 -0.141568 -0.106891 
v -0.0660273 -0.141856 -0.0966911 
v -0.0654938 -0.141768 -0.106891 
v -0.0665671 -0.141826 -0.0966911 
v -0.0660273 -0.141856 -0.106891 
v -0.067088 -0.141682 -0.0966911 
v -0.0665671 -0.141826 -0.106891 
v -0.0675656 -0.141429 -0.0966911 
v -0.067088 -0.141682 -0.106891 
v -0.0679776 -0.141079 -0.0966911 
v -0.0675656 -0.141429 -0.106891 
v -0.0683048 -0.140648 -0.0966911 
v -0.0679776 -0.141079 -0.106891 
v -0.0685318 -0.140158 -0.0966911 
v -0.0683048 -0.140648 -0.106891 
v -0.068648 -0.13963 -0.0966911 
v -0.0685318 -0.140158 -0.106891 
v -0.068648 -0.139089 -0.0966911 
v -0.068648 -0.13963 -0.106891 
v -0.0685318 -0.138561 -0.0966911 
v -0.068648 -0.139089 -0.106891 
v -0.0683048 -0.13807 -0.0966911 
v -0.0685318 -0.138561 -0.106891 
v -0.0679776 -0.13764 -0.0966911 
v -0.0683048 -0.13807 -0.106891 
v -0.0675656 -0.13729 -0.0966911 
v -0.0679776 -0.13764 -0.106891 
v -0.067088 -0.137037 -0.0966911 
v -0.0675656 -0.13729 -0.106891 
v -0.0665671 -0.136892 -0.0966911 
v -0.067088 -0.137037 -0.106891 
v -0.0660273 -0.136863 -0.0966911 
v -0.0665671 -0.136892 -0.106891 
v -0.0654938 -0.136951 -0.0966911 
v -0.0660273 -0.136863 -0.106891 
v -0.0649916 -0.137151 -0.0966911 
v -0.0654938 -0.136951 -0.106891 
v -0.0645442 -0.137454 -0.0966911 
v -0.0649916 -0.137151 -0.106891 
v -0.0641724 -0.137846 -0.0966911 
v -0.0645442 -0.137454 -0.106891 
v -0.0638937 -0.13831 -0.0966911 
v -0.0641724 -0.137846 -0.106891 
v -0.0637211 -0.138822 -0.0966911 
v -0.0638937 -0.13831 -0.106891 
v -0.0637211 -0.138822 -0.106891 
v -0.072987 -0.132895 -0.106891 
v -0.0714378 -0.131579 -0.106891 
v -0.0742171 -0.134513 -0.106891 
v -0.0656538 -0.129973 -0.106891 
v -0.0636479 -0.130302 -0.106891 
v -0.069642 -0.130627 -0.106891 
v -0.0676834 -0.130083 -0.106891 
v -0.0600772 -0.132195 -0.106891 
v -0.0586794 -0.133671 -0.106891 
v -0.0569824 -0.137339 -0.106891 
v -0.0567627 -0.139359 -0.106891 
v -0.0617596 -0.131054 -0.106891 
v -0.0569824 -0.14138 -0.106891 
v -0.0576315 -0.135412 -0.106891 
v -0.072987 -0.145824 -0.106891 
v -0.0742171 -0.144206 -0.106891 
v -0.0714378 -0.14714 -0.106891 
v -0.0750706 -0.136358 -0.106891 
v -0.0576315 -0.143306 -0.106891 
v -0.0586794 -0.145048 -0.106891 
v -0.0600772 -0.146524 -0.106891 
v -0.0617596 -0.147664 -0.106891 
v -0.0636479 -0.148417 -0.106891 
v -0.0656538 -0.148746 -0.106891 
v -0.0750706 -0.142361 -0.106891 
v -0.0755076 -0.140376 -0.106891 
v -0.0755076 -0.138343 -0.106891 
v -0.0676834 -0.148636 -0.106891 
v -0.069642 -0.148092 -0.106891 
v -0.0541627 -0.139359 -0.104291 
v -0.0544432 -0.13678 -0.104291 
v -0.0552718 -0.134321 -0.104291 
v -0.0566095 -0.132097 -0.104291 
v -0.058394 -0.130213 -0.104291 
v -0.0605418 -0.128757 -0.104291 
v -0.0629523 -0.127797 -0.104291 
v -0.065513 -0.127377 -0.104291 
v -0.068104 -0.127517 -0.104291 
v -0.0706043 -0.128212 -0.104291 
v -0.0728969 -0.129427 -0.104291 
v -0.0748746 -0.131107 -0.104291 
v -0.0764449 -0.133173 -0.104291 
v -0.0775345 -0.135528 -0.104291 
v -0.0780923 -0.138062 -0.104291 
v -0.0780923 -0.140657 -0.104291 
v -0.0775345 -0.143191 -0.104291 
v -0.0764449 -0.145546 -0.104291 
v -0.0748746 -0.147612 -0.104291 
v -0.0728969 -0.149292 -0.104291 
v -0.0706043 -0.150507 -0.104291 
v -0.068104 -0.151201 -0.104291 
v -0.065513 -0.151342 -0.104291 
v -0.0629523 -0.150922 -0.104291 
v -0.0605418 -0.149962 -0.104291 
v -0.058394 -0.148505 -0.104291 
v -0.0566095 -0.146621 -0.104291 
v -0.0552718 -0.144398 -0.104291 
v -0.0544432 -0.141939 -0.104291 
v -0.0545119 -0.136795 -0.0992911 
v -0.054233 -0.138062 -0.0992911 
v -0.0553356 -0.13435 -0.0992911 
v -0.0547908 -0.135528 -0.0992911 
v -0.0566655 -0.13214 -0.0992911 
v -0.0558804 -0.133173 -0.0992911 
v -0.0584396 -0.130267 -0.0992911 
v -0.0574507 -0.131107 -0.0992911 
v -0.0605747 -0.128819 -0.0992911 
v -0.0594284 -0.129427 -0.0992911 
v -0.0629711 -0.127865 -0.0992911 
v -0.061721 -0.128212 -0.0992911 
v -0.0655168 -0.127447 -0.0992911 
v -0.0642213 -0.127517 -0.0992911 
v -0.0680927 -0.127587 -0.0992911 
v -0.0668123 -0.127377 -0.0992911 
v -0.0705783 -0.128277 -0.0992911 
v -0.069373 -0.127797 -0.0992911 
v -0.0728574 -0.129485 -0.0992911 
v -0.0717836 -0.128757 -0.0992911 
v -0.0739313 -0.130213 -0.0992911 
v -0.0748235 -0.131155 -0.0992911 
v -0.0757158 -0.132097 -0.0992911 
v -0.0763847 -0.133209 -0.0992911 
v -0.0770536 -0.134321 -0.0992911 
v -0.0774678 -0.13555 -0.0992911 
v -0.0780224 -0.13807 -0.0992911 
v -0.0778821 -0.13678 -0.0992911 
v -0.0780224 -0.140649 -0.0992911 
v -0.0781627 -0.139359 -0.0992911 
v -0.0774678 -0.143169 -0.0992911 
v -0.0778821 -0.141939 -0.0992911 
v -0.0763847 -0.14551 -0.0992911 
v -0.0770536 -0.144398 -0.0992911 
v -0.0748235 -0.147563 -0.0992911 
v -0.0757158 -0.146621 -0.0992911 
v -0.0728574 -0.149233 -0.0992911 
v -0.0739313 -0.148505 -0.0992911 
v -0.0705783 -0.150442 -0.0992911 
v -0.0717836 -0.149962 -0.0992911 
v -0.0680927 -0.151132 -0.0992911 
v -0.069373 -0.150922 -0.0992911 
v -0.0655168 -0.151272 -0.0992911 
v -0.0668123 -0.151342 -0.0992911 
v -0.0629711 -0.150854 -0.0992911 
v -0.0642213 -0.151201 -0.0992911 
v -0.0605747 -0.149899 -0.0992911 
v -0.061721 -0.150507 -0.0992911 
v -0.0584396 -0.148452 -0.0992911 
v -0.0594284 -0.149292 -0.0992911 
v -0.0566655 -0.146579 -0.0992911 
v -0.0574507 -0.147612 -0.0992911 
v -0.0553356 -0.144369 -0.0992911 
v -0.0558804 -0.145546 -0.0992911 
v -0.0545119 -0.141924 -0.0992911 
v -0.0547908 -0.143191 -0.0992911 
v -0.0541627 -0.139359 -0.0992911 
v -0.054233 -0.140657 -0.0992911 
v -0.0753429 -0.137339 -0.0966911 
v -0.0755627 -0.139359 -0.0966911 
v -0.0746939 -0.135412 -0.0966911 
v -0.0736459 -0.133671 -0.0966911 
v -0.0722481 -0.132195 -0.0966911 
v -0.0705657 -0.131054 -0.0966911 
v -0.0686774 -0.130302 -0.0966911 
v -0.0666716 -0.129973 -0.0966911 
v -0.0646419 -0.130083 -0.0966911 
v -0.0626834 -0.130627 -0.0966911 
v -0.0608875 -0.131579 -0.0966911 
v -0.0593383 -0.132895 -0.0966911 
v -0.0581082 -0.134513 -0.0966911 
v -0.0572547 -0.136358 -0.0966911 
v -0.0568178 -0.138343 -0.0966911 
v -0.0567627 -0.139359 -0.0966911 
v -0.0568178 -0.140376 -0.0966911 
v -0.0572547 -0.142361 -0.0966911 
v -0.0581082 -0.144206 -0.0966911 
v -0.0593383 -0.145824 -0.0966911 
v -0.0608875 -0.14714 -0.0966911 
v -0.0626834 -0.148092 -0.0966911 
v -0.0646419 -0.148636 -0.0966911 
v -0.0666716 -0.148746 -0.0966911 
v -0.0686774 -0.148417 -0.0966911 
v -0.0705657 -0.147664 -0.0966911 
v -0.0722481 -0.146524 -0.0966911 
v -0.0736459 -0.145048 -0.0966911 
v -0.0746939 -0.143306 -0.0966911 
v -0.0753429 -0.14138 -0.0966911 
vn -0.993144 0.0720117 -0.0920883 
vn -0.98758 -0.129088 -0.0895644 
vn -0.956572 0.275584 -0.0949866 
vn -0.993144 0.0720117 -0.0920883 
vn -0.87557 0.473008 -0.0981842 
vn -0.956572 0.275584 -0.0949866 
vn -0.749493 0.654175 -0.101562 
vn -0.87557 0.473008 -0.0981842 
vn -0.580207 0.80768 -0.104945 
vn -0.749493 0.654175 -0.101562 
vn -0.37308 0.921479 -0.108105 
vn -0.580207 0.80768 -0.104945 
vn -0.137814 0.984245 -0.110767 
vn -0.37308 0.921479 -0.108105 
vn 0.111404 0.987369 -0.112653 
vn -0.137814 0.984245 -0.110767 
vn 0.356941 0.927201 -0.113539 
vn 0.111404 0.987369 -0.112653 
vn 0.580099 0.806626 -0.113308 
vn 0.356941 0.927201 -0.113539 
vn 0.764254 0.635117 -0.111993 
vn 0.580099 0.806626 -0.113308 
vn 0.89755 0.427034 -0.109758 
vn 0.764254 0.635117 -0.111993 
vn 0.974184 0.198864 -0.106859 
vn 0.89755 0.427034 -0.109758 
vn 0.994058 -0.0334651 -0.103577 
vn 0.974184 0.198864 -0.106859 
vn 0.96137 -0.256384 -0.100171 
vn 0.994058 -0.0334651 -0.103577 
vn 0.882929 -0.459409 -0.0968489 
vn 0.96137 -0.256384 -0.100171 
vn 0.766741 -0.635073 -0.0937619 
vn 0.882929 -0.459409 -0.0968489 
vn 0.621061 -0.778461 -0.0910095 
vn 0.766741 -0.635073 -0.0937619 
vn 0.453868 -0.886648 -0.0886522 
vn 0.621061 -0.778461 -0.0910095 
vn 0.272638 -0.9582 -0.0867231 
vn 0.453868 -0.886648 -0.0886522 
vn 0.0842932 -0.992789 -0.085238 
vn 0.272638 -0.9582 -0.0867231 
vn -0.104764 -0.990926 -0.0842028 
vn 0.0842932 -0.992789 -0.085238 
vn -0.288577 -0.953798 -0.0836187 
vn -0.104764 -0.990926 -0.0842028 
vn -0.461561 -0.883171 -0.0834854 
vn -0.288577 -0.953798 -0.0836187 
vn -0.618437 -0.781353 -0.0838027 
vn -0.461561 -0.883171 -0.0834854 
vn -0.754173 -0.651207 -0.084571 
vn -0.618437 -0.781353 -0.0838027 
vn -0.86396 -0.496199 -0.0857902 
vn -0.754173 -0.651207 -0.084571 
vn -0.943205 -0.320494 -0.0874578 
vn -0.86396 -0.496199 -0.0857902 
vn -0.0597412 -0.125834 -0.990251 
vn 0.617802 -0.134328 -0.774775 
vn 0.613426 0.0124251 -0.789655 
vn 0.574953 0.157373 -0.802909 
vn 0.502797 0.29207 -0.813566 
vn 0.39987 0.408 -0.820755 
vn 0.271661 0.497481 -0.82384 
vn 0.125876 0.554608 -0.822536 
vn -0.0283373 0.575993 -0.816964 
vn -0.18142 0.561093 -0.807627 
vn -0.324431 0.512067 -0.795319 
vn -0.449842 0.43325 -0.780985 
vn -0.551977 0.33043 -0.765596 
vn -0.627113 0.210134 -0.750049 
vn -0.673332 0.0790351 -0.735103 
vn -0.690249 -0.0564563 -0.721366 
vn -0.678699 -0.190438 -0.709296 
vn -0.640466 -0.317634 -0.699222 
vn -0.578053 -0.433429 -0.691371 
vn -0.494512 -0.533864 -0.685892 
vn -0.39333 -0.61561 -0.682873 
vn -0.278352 -0.675948 -0.68236 
vn -0.15373 -0.712756 -0.684359 
vn -0.0238933 -0.724518 -0.688841 
vn 0.106472 -0.710361 -0.695738 
vn 0.232449 -0.670109 -0.704927 
vn 0.348938 -0.604382 -0.716215 
vn 0.450731 -0.514719 -0.729319 
vn 0.532652 -0.403721 -0.743836 
vn 0.589784 -0.275208 -0.759221 
vn 0.991034 0.0823027 -0.105248 
vn 0.994058 -0.0334651 -0.103577 
vn 0.983902 -0.146831 -0.101875 
vn 0.943076 0.314425 -0.108374 
vn 0.974184 0.198864 -0.106859 
vn 0.837767 0.534632 -0.110976 
vn 0.89755 0.427034 -0.109758 
vn 0.677928 0.726425 -0.112779 
vn 0.764254 0.635117 -0.111993 
vn 0.472442 0.874015 -0.113565 
vn 0.580099 0.806626 -0.113308 
vn 0.235812 0.965179 -0.113231 
vn 0.356941 0.927201 -0.113539 
vn -0.0139054 0.993631 -0.111823 
vn 0.111404 0.987369 -0.112653 
vn -0.258178 0.95987 -0.109516 
vn -0.137814 0.984245 -0.110767 
vn -0.480875 0.870288 -0.10657 
vn -0.37308 0.921479 -0.108105 
vn -0.670009 0.735135 -0.103266 
vn -0.580207 0.80768 -0.104945 
vn -0.81812 0.566311 -0.09986 
vn -0.749493 0.654175 -0.101562 
vn -0.921713 0.375662 -0.0965543 
vn -0.87557 0.473008 -0.0981842 
vn -0.980299 0.173993 -0.0934945 
vn -0.956572 0.275584 -0.0949866 
vn -0.995439 -0.0293293 -0.0907763 
vn -0.993144 0.0720117 -0.0920883 
vn -0.970009 -0.226404 -0.0884572 
vn -0.98758 -0.129088 -0.0895644 
vn -0.907677 -0.410643 -0.0865683 
vn -0.943205 -0.320494 -0.0874578 
vn -0.812602 -0.576568 -0.0851243 
vn -0.86396 -0.496199 -0.0857902 
vn -0.689253 -0.71962 -0.0841305 
vn -0.754173 -0.651207 -0.084571 
vn -0.542332 -0.835996 -0.0835877 
vn -0.618437 -0.781353 -0.0838027 
vn -0.376759 -0.922541 -0.0834957 
vn -0.461561 -0.883171 -0.0834854 
vn -0.197683 -0.976673 -0.0838544 
vn -0.288577 -0.953798 -0.0836187 
vn -0.0105282 -0.996354 -0.084664 
vn -0.104764 -0.990926 -0.0842028 
vn 0.178944 -0.9801 -0.0859245 
vn 0.0842932 -0.992789 -0.085238 
vn 0.364562 -0.927046 -0.0876329 
vn 0.272638 -0.9582 -0.0867231 
vn 0.539673 -0.837074 -0.0897789 
vn 0.453868 -0.886648 -0.0886522 
vn 0.697078 -0.711024 -0.0923393 
vn 0.621061 -0.778461 -0.0910095 
vn 0.829035 -0.551022 -0.0952687 
vn 0.766741 -0.635073 -0.0937619 
vn 0.927383 -0.360917 -0.0984886 
vn 0.882929 -0.459409 -0.0968489 
vn 0.983902 -0.146831 -0.101875 
vn 0.96137 -0.256384 -0.100171 
vn -0.778275 0.0130076 0.627789 
vn -0.781687 -0.0639352 0.620386 
vn -0.777175 -0.140063 0.613499 
vn -0.746801 0.166201 0.643945 
vn -0.766705 0.0899951 0.635661 
vn -0.681688 0.312692 0.661457 
vn -0.718465 0.240744 0.652572 
vn -0.583313 0.444855 0.679596 
vn -0.636565 0.381067 0.670503 
vn -0.454003 0.554543 0.697398 
vn -0.522289 0.503024 0.688608 
vn -0.298531 0.633665 0.713686 
vn -0.379132 0.598405 0.705811 
vn -0.12442 0.675097 0.727161 
vn -0.213228 0.659469 0.720857 
vn 0.0582034 0.673847 0.736574 
vn -0.0334544 0.680003 0.732446 
vn 0.237386 0.6282 0.740954 
vn 0.149008 0.656528 0.739437 
vn 0.400752 0.540433 0.739818 
vn 0.321789 0.589279 0.741082 
vn 0.537214 0.416752 0.733293 
vn 0.472944 0.48256 0.737197 
vn 0.638462 0.266388 0.722083 
vn 0.592623 0.344249 0.728211 
vn 0.699785 0.100138 0.7073 
vn 0.674263 0.184555 0.715059 
vn 0.720075 -0.0711343 0.690241 
vn 0.715001 0.0144826 0.698974 
vn 0.701222 -0.237644 0.67217 
vn 0.71533 -0.155533 0.681258 
vn 0.647233 -0.391321 0.654184 
vn 0.678312 -0.316517 0.663107 
vn 0.563366 -0.525982 0.637151 
vn 0.608676 -0.461343 0.645504 
vn 0.455465 -0.637208 0.621706 
vn 0.512046 -0.584738 0.629199 
vn 0.329502 -0.722093 0.608284 
vn 0.394371 -0.683074 0.614721 
vn 0.19132 -0.778965 0.597168 
vn 0.261583 -0.754095 0.602425 
vn 0.0465051 -0.807137 0.58853 
vn 0.119405 -0.796648 0.592532 
vn -0.0996626 -0.806721 0.582468 
vn -0.0267277 -0.810468 0.585173 
vn -0.242206 -0.778497 0.579032 
vn -0.171687 -0.796013 0.58042 
vn -0.376435 -0.723828 0.578246 
vn -0.310643 -0.754362 0.578307 
vn -0.497927 -0.64462 0.580116 
vn -0.43904 -0.687152 0.578849 
vn -0.602509 -0.543317 0.584628 
vn -0.552582 -0.596556 0.582043 
vn -0.686269 -0.422926 0.591751 
vn -0.647226 -0.485296 0.587866 
vn -0.74558 -0.28707 0.601416 
vn -0.719194 -0.356679 0.596271 
vn -0.765029 -0.214662 0.607166 
vn -0.777175 -0.140063 0.613499 
vn -0.0721995 -0.152075 0.985728 
usemtl 0.400000_0.400000_0.400000_0.000000_0.000000
o mesh3
f 6307//6697 6308//6698 6309//6698 
f 6310//6699 6307//6697 6311//6700 
f 6312//6701 6310//6699 6313//6702 
f 6314//6703 6312//6701 6315//6704 
f 6316//6705 6314//6703 6317//6706 
f 6318//6707 6316//6705 6319//6708 
f 6320//6709 6318//6707 6321//6710 
f 6322//6711 6320//6709 6323//6712 
f 6324//6713 6322//6711 6325//6714 
f 6326//6715 6324//6713 6327//6716 
f 6328//6717 6326//6715 6329//6718 
f 6330//6719 6328//6717 6331//6720 
f 6332//6721 6330//6719 6333//6722 
f 6334//6723 6332//6721 6335//6724 
f 6336//6725 6334//6723 6337//6726 
f 6338//6727 6336//6725 6339//6728 
f 6340//6729 6338//6727 6341//6730 
f 6342//6731 6340//6729 6343//6732 
f 6344//6733 6342//6731 6345//6734 
f 6346//6735 6344//6733 6347//6736 
f 6348//6737 6346//6735 6349//6738 
f 6350//6739 6348//6737 6351//6740 
f 6352//6741 6350//6739 6353//6742 
f 6354//6743 6352//6741 6355//6744 
f 6356//6745 6354//6743 6357//6746 
f 6358//6747 6356//6745 6359//6748 
f 6360//6749 6358//6747 6361//6750 
f 6362//6751 6360//6749 6363//6752 
f 6308//6698 6362//6751 6364//6751 
f 6364//6751 6309//6698 6308//6698 
f 6363//6752 6364//6751 6362//6751 
f 6361//6750 6363//6752 6360//6749 
f 6359//6748 6361//6750 6358//6747 
f 6357//6746 6359//6748 6356//6745 
f 6355//6744 6357//6746 6354//6743 
f 6353//6742 6355//6744 6352//6741 
f 6351//6740 6353//6742 6350//6739 
f 6349//6738 6351//6740 6348//6737 
f 6347//6736 6349//6738 6346//6735 
f 6345//6734 6347//6736 6344//6733 
f 6343//6732 6345//6734 6342//6731 
f 6341//6730 6343//6732 6340//6729 
f 6339//6728 6341//6730 6338//6727 
f 6337//6726 6339//6728 6336//6725 
f 6335//6724 6337//6726 6334//6723 
f 6333//6722 6335//6724 6332//6721 
f 6331//6720 6333//6722 6330//6719 
f 6329//6718 6331//6720 6328//6717 
f 6327//6716 6329//6718 6326//6715 
f 6325//6714 6327//6716 6324//6713 
f 6323//6712 6325//6714 6322//6711 
f 6321//6710 6323//6712 6320//6709 
f 6319//6708 6321//6710 6318//6707 
f 6317//6706 6319//6708 6316//6705 
f 6315//6704 6317//6706 6314//6703 
f 6313//6702 6315//6704 6312//6701 
f 6311//6700 6313//6702 6310//6699 
f 6309//6698 6311//6700 6307//6697 
o mesh4
f 6365//6753 6345//6753 6343//6753 
f 6365//6753 6366//6753 6347//6753 
f 6367//6753 6343//6753 6341//6753 
f 6347//6753 6345//6753 6365//6753 
f 6368//6753 6353//6753 6351//6753 
f 6368//6753 6369//6753 6355//6753 
f 6343//6753 6367//6753 6365//6753 
f 6366//6753 6370//6753 6349//6753 
f 6371//6753 6351//6753 6349//6753 
f 6355//6753 6353//6753 6368//6753 
f 6372//6753 6359//6753 6357//6753 
f 6372//6753 6373//6753 6361//6753 
f 6374//6753 6364//6753 6363//6753 
f 6375//6753 6309//6753 6364//6753 
f 6349//6753 6347//6753 6366//6753 
f 6351//6753 6371//6753 6368//6753 
f 6376//6753 6357//6753 6355//6753 
f 6361//6753 6359//6753 6372//6753 
f 6364//6753 6374//6753 6375//6753 
f 6377//6753 6311//6753 6309//6753 
f 6349//6753 6370//6753 6371//6753 
f 6357//6753 6376//6753 6372//6753 
f 6378//6753 6363//6753 6361//6753 
f 6309//6753 6375//6753 6377//6753 
f 6379//6753 6331//6753 6329//6753 
f 6380//6753 6333//6753 6331//6753 
f 6355//6753 6369//6753 6376//6753 
f 6363//6753 6378//6753 6374//6753 
f 6381//6753 6329//6753 6327//6753 
f 6331//6753 6379//6753 6380//6753 
f 6382//6753 6341//6753 6339//6753 
f 6361//6753 6373//6753 6378//6753 
f 6383//6753 6313//6753 6311//6753 
f 6384//6753 6315//6753 6313//6753 
f 6385//6753 6317//6753 6315//6753 
f 6386//6753 6319//6753 6317//6753 
f 6387//6753 6321//6753 6319//6753 
f 6387//6753 6388//6753 6323//6753 
f 6329//6753 6381//6753 6379//6753 
f 6389//6753 6335//6753 6333//6753 
f 6390//6753 6337//6753 6335//6753 
f 6391//6753 6339//6753 6337//6753 
f 6341//6753 6382//6753 6367//6753 
f 6313//6753 6383//6753 6384//6753 
f 6317//6753 6385//6753 6386//6753 
f 6323//6753 6321//6753 6387//6753 
f 6392//6753 6325//6753 6323//6753 
f 6393//6753 6327//6753 6325//6753 
f 6333//6753 6380//6753 6389//6753 
f 6337//6753 6390//6753 6391//6753 
f 6311//6753 6377//6753 6383//6753 
f 6319//6753 6386//6753 6387//6753 
f 6325//6753 6392//6753 6393//6753 
f 6335//6753 6389//6753 6390//6753 
f 6315//6753 6384//6753 6385//6753 
f 6327//6753 6393//6753 6381//6753 
f 6323//6753 6388//6753 6392//6753 
f 6339//6753 6391//6753 6382//6753 
o mesh5
f 6394//6754 6375//6754 6374//6755 
f 6395//6755 6374//6755 6378//6756 
f 6396//6756 6378//6756 6373//6757 
f 6397//6757 6373//6757 6372//6758 
f 6398//6758 6372//6758 6376//6759 
f 6399//6759 6376//6759 6369//6760 
f 6400//6760 6369//6760 6368//6761 
f 6401//6761 6368//6761 6371//6762 
f 6402//6762 6371//6762 6370//6763 
f 6403//6763 6370//6763 6366//6764 
f 6404//6764 6366//6764 6365//6765 
f 6405//6765 6365//6765 6367//6766 
f 6406//6766 6367//6766 6382//6767 
f 6407//6767 6382//6767 6391//6768 
f 6408//6768 6391//6768 6390//6769 
f 6409//6769 6390//6769 6389//6770 
f 6410//6770 6389//6770 6380//6771 
f 6411//6771 6380//6771 6379//6772 
f 6412//6772 6379//6772 6381//6773 
f 6413//6773 6381//6773 6393//6774 
f 6414//6774 6393//6774 6392//6775 
f 6415//6775 6392//6775 6388//6776 
f 6416//6776 6388//6776 6387//6777 
f 6417//6777 6387//6777 6386//6778 
f 6418//6778 6386//6778 6385//6779 
f 6419//6779 6385//6779 6384//6780 
f 6420//6780 6384//6780 6383//6781 
f 6421//6781 6383//6781 6377//6782 
f 6422//6782 6377//6782 6375//6754 
f 6375//6754 6394//6754 6422//6782 
f 6377//6782 6422//6782 6421//6781 
f 6383//6781 6421//6781 6420//6780 
f 6384//6780 6420//6780 6419//6779 
f 6385//6779 6419//6779 6418//6778 
f 6386//6778 6418//6778 6417//6777 
f 6387//6777 6417//6777 6416//6776 
f 6388//6776 6416//6776 6415//6775 
f 6392//6775 6415//6775 6414//6774 
f 6393//6774 6414//6774 6413//6773 
f 6381//6773 6413//6773 6412//6772 
f 6379//6772 6412//6772 6411//6771 
f 6380//6771 6411//6771 6410//6770 
f 6389//6770 6410//6770 6409//6769 
f 6390//6769 6409//6769 6408//6768 
f 6391//6768 6408//6768 6407//6767 
f 6382//6767 6407//6767 6406//6766 
f 6367//6766 6406//6766 6405//6765 
f 6365//6765 6405//6765 6404//6764 
f 6366//6764 6404//6764 6403//6763 
f 6370//6763 6403//6763 6402//6762 
f 6371//6762 6402//6762 6401//6761 
f 6368//6761 6401//6761 6400//6760 
f 6369//6760 6400//6760 6399//6759 
f 6376//6759 6399//6759 6398//6758 
f 6372//6758 6398//6758 6397//6757 
f 6373//6757 6397//6757 6396//6756 
f 6378//6756 6396//6756 6395//6755 
f 6374//6755 6395//6755 6394//6754 
o mesh6
f 6395//6783 6423//6783 6424//6784 
f 6424//6784 6394//6785 6395//6783 
f 6396//6786 6425//6786 6426//6787 
f 6426//6787 6395//6783 6396//6786 
f 6397//6788 6427//6788 6428//6789 
f 6428//6789 6396//6786 6397//6788 
f 6398//6790 6429//6790 6430//6791 
f 6430//6791 6397//6788 6398//6790 
f 6399//6792 6431//6792 6432//6793 
f 6432//6793 6398//6790 6399//6792 
f 6400//6794 6433//6794 6434//6795 
f 6434//6795 6399//6792 6400//6794 
f 6401//6796 6435//6796 6436//6797 
f 6436//6797 6400//6794 6401//6796 
f 6402//6798 6437//6798 6438//6799 
f 6438//6799 6401//6796 6402//6798 
f 6403//6800 6439//6800 6440//6801 
f 6440//6801 6402//6798 6403//6800 
f 6404//6802 6441//6802 6442//6803 
f 6442//6803 6403//6800 6404//6802 
f 6404//6802 6405//6804 6443//6805 
f 6405//6804 6444//6804 6443//6805 
f 6405//6804 6406//6806 6445//6807 
f 6406//6806 6446//6806 6445//6807 
f 6406//6806 6407//6808 6447//6809 
f 6407//6808 6448//6808 6447//6809 
f 6408//6810 6449//6810 6450//6811 
f 6450//6811 6407//6808 6408//6810 
f 6409//6812 6451//6812 6452//6813 
f 6452//6813 6408//6810 6409//6812 
f 6410//6814 6453//6814 6454//6815 
f 6454//6815 6409//6812 6410//6814 
f 6411//6816 6455//6816 6456//6817 
f 6456//6817 6410//6814 6411//6816 
f 6412//6818 6457//6818 6458//6819 
f 6458//6819 6411//6816 6412//6818 
f 6413//6820 6459//6820 6460//6821 
f 6460//6821 6412//6818 6413//6820 
f 6414//6822 6461//6822 6462//6823 
f 6462//6823 6413//6820 6414//6822 
f 6415//6824 6463//6824 6464//6825 
f 6464//6825 6414//6822 6415//6824 
f 6416//6826 6465//6826 6466//6827 
f 6466//6827 6415//6824 6416//6826 
f 6417//6828 6467//6828 6468//6829 
f 6468//6829 6416//6826 6417//6828 
f 6418//6830 6469//6830 6470//6831 
f 6470//6831 6417//6828 6418//6830 
f 6419//6832 6471//6832 6472//6833 
f 6472//6833 6418//6830 6419//6832 
f 6420//6834 6473//6834 6474//6835 
f 6474//6835 6419//6832 6420//6834 
f 6421//6836 6475//6836 6476//6837 
f 6476//6837 6420//6834 6421//6836 
f 6422//6838 6477//6838 6478//6839 
f 6478//6839 6421//6836 6422//6838 
f 6394//6785 6479//6840 6480//6841 
f 6480//6841 6422//6838 6394//6785 
f 6480//6841 6477//6838 6422//6838 
f 6478//6839 6475//6836 6421//6836 
f 6476//6837 6473//6834 6420//6834 
f 6474//6835 6471//6832 6419//6832 
f 6472//6833 6469//6830 6418//6830 
f 6470//6831 6467//6828 6417//6828 
f 6468//6829 6465//6826 6416//6826 
f 6466//6827 6463//6824 6415//6824 
f 6464//6825 6461//6822 6414//6822 
f 6462//6823 6459//6820 6413//6820 
f 6460//6821 6457//6818 6412//6818 
f 6458//6819 6455//6816 6411//6816 
f 6456//6817 6453//6814 6410//6814 
f 6454//6815 6451//6812 6409//6812 
f 6452//6813 6449//6810 6408//6810 
f 6450//6811 6448//6808 6407//6808 
f 6447//6809 6446//6806 6406//6806 
f 6445//6807 6444//6804 6405//6804 
f 6443//6805 6441//6802 6404//6802 
f 6442//6803 6439//6800 6403//6800 
f 6440//6801 6437//6798 6402//6798 
f 6438//6799 6435//6796 6401//6796 
f 6436//6797 6433//6794 6400//6794 
f 6434//6795 6431//6792 6399//6792 
f 6432//6793 6429//6790 6398//6790 
f 6430//6791 6427//6788 6397//6788 
f 6428//6789 6425//6786 6396//6786 
f 6426//6787 6423//6783 6395//6783 
f 6424//6784 6479//6840 6394//6785 
o mesh7
f 6481//6842 6450//6842 6449//6843 
f 6449//6843 6482//6844 6481//6842 
f 6483//6845 6447//6845 6448//6846 
f 6448//6846 6481//6842 6483//6845 
f 6484//6847 6445//6847 6446//6848 
f 6446//6848 6483//6845 6484//6847 
f 6485//6849 6443//6849 6444//6850 
f 6444//6850 6484//6847 6485//6849 
f 6486//6851 6442//6851 6441//6852 
f 6441//6852 6485//6849 6486//6851 
f 6487//6853 6440//6853 6439//6854 
f 6439//6854 6486//6851 6487//6853 
f 6488//6855 6438//6855 6437//6856 
f 6437//6856 6487//6853 6488//6855 
f 6489//6857 6436//6857 6435//6858 
f 6435//6858 6488//6855 6489//6857 
f 6490//6859 6434//6859 6433//6860 
f 6433//6860 6489//6857 6490//6859 
f 6491//6861 6432//6861 6431//6862 
f 6431//6862 6490//6859 6491//6861 
f 6492//6863 6430//6863 6429//6864 
f 6429//6864 6491//6861 6492//6863 
f 6493//6865 6428//6865 6427//6866 
f 6427//6866 6492//6863 6493//6865 
f 6494//6867 6426//6867 6425//6868 
f 6425//6868 6493//6865 6494//6867 
f 6495//6869 6424//6869 6423//6870 
f 6423//6870 6494//6867 6495//6869 
f 6480//6871 6479//6872 6496//6872 
f 6424//6869 6495//6869 6496//6872 
f 6496//6872 6479//6872 6424//6869 
f 6497//6871 6498//6873 6477//6874 
f 6498//6873 6478//6873 6477//6874 
f 6498//6873 6499//6875 6475//6876 
f 6499//6875 6476//6875 6475//6876 
f 6499//6875 6500//6877 6473//6878 
f 6500//6877 6474//6877 6473//6878 
f 6501//6879 6472//6879 6471//6880 
f 6471//6880 6500//6877 6501//6879 
f 6502//6881 6470//6881 6469//6882 
f 6469//6882 6501//6879 6502//6881 
f 6503//6883 6468//6883 6467//6884 
f 6467//6884 6502//6881 6503//6883 
f 6504//6885 6466//6885 6465//6886 
f 6465//6886 6503//6883 6504//6885 
f 6505//6887 6464//6887 6463//6888 
f 6463//6888 6504//6885 6505//6887 
f 6506//6889 6462//6889 6461//6890 
f 6461//6890 6505//6887 6506//6889 
f 6507//6891 6460//6891 6459//6892 
f 6459//6892 6506//6889 6507//6891 
f 6507//6891 6508//6893 6457//6894 
f 6508//6893 6458//6893 6457//6894 
f 6509//6895 6456//6895 6455//6896 
f 6455//6896 6508//6893 6509//6895 
f 6510//6897 6454//6897 6453//6898 
f 6453//6898 6509//6895 6510//6897 
f 6510//6897 6482//6844 6451//6899 
f 6482//6844 6452//6900 6451//6899 
f 6451//6899 6454//6897 6510//6897 
f 6453//6898 6456//6895 6509//6895 
f 6455//6896 6458//6893 6508//6893 
f 6457//6894 6460//6891 6507//6891 
f 6459//6892 6462//6889 6506//6889 
f 6461//6890 6464//6887 6505//6887 
f 6463//6888 6466//6885 6504//6885 
f 6465//6886 6468//6883 6503//6883 
f 6467//6884 6470//6881 6502//6881 
f 6469//6882 6472//6879 6501//6879 
f 6471//6880 6474//6877 6500//6877 
f 6473//6878 6476//6875 6499//6875 
f 6475//6876 6478//6873 6498//6873 
f 6477//6874 6480//6871 6497//6871 
f 6496//6872 6497//6871 6480//6871 
f 6423//6870 6426//6867 6494//6867 
f 6425//6868 6428//6865 6493//6865 
f 6427//6866 6430//6863 6492//6863 
f 6429//6864 6432//6861 6491//6861 
f 6431//6862 6434//6859 6490//6859 
f 6433//6860 6436//6857 6489//6857 
f 6435//6858 6438//6855 6488//6855 
f 6437//6856 6440//6853 6487//6853 
f 6439//6854 6442//6851 6486//6851 
f 6441//6852 6443//6849 6485//6849 
f 6444//6850 6445//6847 6484//6847 
f 6446//6848 6447//6845 6483//6845 
f 6448//6846 6450//6842 6481//6842 
f 6449//6843 6452//6900 6482//6844 
o mesh8
f 6495//6901 6494//6901 6362//6901 
f 6308//6901 6496//6901 6495//6901 
f 6494//6901 6493//6901 6360//6901 
f 6492//6901 6491//6901 6356//6901 
f 6491//6901 6490//6901 6354//6901 
f 6360//6901 6362//6901 6494//6901 
f 6493//6901 6492//6901 6358//6901 
f 6354//6901 6356//6901 6491//6901 
f 6490//6901 6489//6901 6352//6901 
f 6489//6901 6488//6901 6350//6901 
f 6488//6901 6487//6901 6348//6901 
f 6485//6901 6484//6901 6342//6901 
f 6484//6901 6483//6901 6340//6901 
f 6508//6901 6507//6901 6328//6901 
f 6507//6901 6506//6901 6326//6901 
f 6358//6901 6360//6901 6493//6901 
f 6352//6901 6354//6901 6490//6901 
f 6348//6901 6350//6901 6488//6901 
f 6487//6901 6486//6901 6346//6901 
f 6486//6901 6485//6901 6344//6901 
f 6340//6901 6342//6901 6484//6901 
f 6481//6901 6482//6901 6336//6901 
f 6482//6901 6510//6901 6334//6901 
f 6326//6901 6328//6901 6507//6901 
f 6506//6901 6505//6901 6324//6901 
f 6356//6901 6358//6901 6492//6901 
f 6346//6901 6348//6901 6487//6901 
f 6342//6901 6344//6901 6485//6901 
f 6483//6901 6481//6901 6338//6901 
f 6334//6901 6336//6901 6482//6901 
f 6510//6901 6509//6901 6332//6901 
f 6509//6901 6508//6901 6330//6901 
f 6324//6901 6326//6901 6506//6901 
f 6503//6901 6502//6901 6318//6901 
f 6502//6901 6501//6901 6316//6901 
f 6501//6901 6500//6901 6314//6901 
f 6500//6901 6499//6901 6312//6901 
f 6350//6901 6352//6901 6489//6901 
f 6338//6901 6340//6901 6483//6901 
f 6332//6901 6334//6901 6510//6901 
f 6328//6901 6330//6901 6508//6901 
f 6316//6901 6318//6901 6502//6901 
f 6312//6901 6314//6901 6500//6901 
f 6499//6901 6498//6901 6310//6901 
f 6498//6901 6497//6901 6307//6901 
f 6344//6901 6346//6901 6486//6901 
f 6330//6901 6332//6901 6509//6901 
f 6505//6901 6504//6901 6322//6901 
f 6504//6901 6503//6901 6320//6901 
f 6314//6901 6316//6901 6501//6901 
f 6307//6901 6310//6901 6498//6901 
f 6336//6901 6338//6901 6481//6901 
f 6320//6901 6322//6901 6504//6901 
f 6310//6901 6312//6901 6499//6901 
f 6497//6901 6496//6901 6308//6901 
f 6322//6901 6324//6901 6505//6901 
f 6308//6901 6307//6901 6497//6901 
f 6318//6901 6320//6901 6503//6901 
f 6362//6901 6308//6901 6495//6901 
g 35cm_T2020
v 0.225424 -0.198008 -0.115166 
v 0.225424 0.151992 -0.115166 
v 0.221888 0.151992 -0.11163 
v 0.221888 -0.198008 -0.11163 
v 0.217924 0.151992 -0.11163 
v 0.217924 -0.198008 -0.11163 
v 0.217924 0.151992 -0.115595 
v 0.217924 -0.198008 -0.115595 
v 0.221459 0.151992 -0.11913 
v 0.221459 -0.198008 -0.11913 
v 0.221459 0.151992 -0.12413 
v 0.221459 -0.198008 -0.12413 
v 0.217924 0.151992 -0.127666 
v 0.217924 -0.198008 -0.127666 
v 0.217924 0.151992 -0.13163 
v 0.217924 -0.198008 -0.13163 
v 0.221888 0.151992 -0.13163 
v 0.221888 -0.198008 -0.13163 
v 0.225424 0.151992 -0.128095 
v 0.225424 -0.198008 -0.128095 
v 0.230424 0.151992 -0.128095 
v 0.230424 -0.198008 -0.128095 
v 0.233959 0.151992 -0.13163 
v 0.233959 -0.198008 -0.13163 
v 0.237924 0.151992 -0.13163 
v 0.237924 -0.198008 -0.13163 
v 0.237924 0.151992 -0.127666 
v 0.237924 -0.198008 -0.127666 
v 0.234388 0.151992 -0.12413 
v 0.234388 -0.198008 -0.12413 
v 0.234388 0.151992 -0.11913 
v 0.234388 -0.198008 -0.11913 
v 0.237924 0.151992 -0.115595 
v 0.237924 -0.198008 -0.115595 
v 0.237924 0.151992 -0.11163 
v 0.237924 -0.198008 -0.11163 
v 0.233959 -0.198008 -0.11163 
v 0.230424 -0.198008 -0.115166 
v 0.233959 0.151992 -0.11163 
v 0.230424 0.151992 -0.115166 
vn 0.842302 0.139911 0.520531 
vn 0.232012 0.1696 0.957813 
vn -0.967282 0.185612 -0.172959 
vn -0.50103 0.152554 -0.851878 
vn -0.648755 0.197534 0.734913 
vn -0.967282 0.185612 -0.172959 
vn 0.177664 0.129872 -0.975484 
vn 0.72779 0.12089 -0.675061 
vn -0.50103 0.152554 -0.851878 
vn 0.177664 0.129872 -0.975484 
vn 0.98553 0.124008 -0.115554 
vn 0.842302 0.139911 0.520531 
vn 0.72779 0.12089 -0.675061 
vn 0.98553 0.124008 -0.115554 
vn 0.235065 -0.958701 -0.160118 
vn 0.176335 0.976974 -0.120113 
vn 0.232012 0.1696 0.957813 
vn -0.648755 0.197534 0.734913 
usemtl 0.301961_0.301961_0.301961_0.000000_0.000000
o mesh229
f 6511//6902 6512//6902 6513//6902 
f 6513//6902 6514//6902 6511//6902 
o mesh230
f 6514//6903 6513//6903 6515//6903 
f 6515//6903 6516//6903 6514//6903 
o mesh231
f 6516//6904 6515//6904 6517//6904 
f 6517//6904 6518//6904 6516//6904 
o mesh232
f 6518//6905 6517//6905 6519//6905 
f 6519//6905 6520//6905 6518//6905 
o mesh233
f 6520//6904 6519//6904 6521//6904 
f 6521//6904 6522//6904 6520//6904 
o mesh234
f 6522//6906 6521//6906 6523//6906 
f 6523//6906 6524//6906 6522//6906 
o mesh235
f 6524//6907 6523//6907 6525//6907 
f 6525//6907 6526//6907 6524//6907 
o mesh236
f 6526//6908 6525//6908 6527//6908 
f 6527//6908 6528//6908 6526//6908 
o mesh237
f 6528//6909 6527//6909 6529//6909 
f 6529//6909 6530//6909 6528//6909 
o mesh238
f 6530//6908 6529//6908 6531//6908 
f 6531//6908 6532//6908 6530//6908 
o mesh239
f 6532//6910 6531//6910 6533//6910 
f 6533//6910 6534//6910 6532//6910 
o mesh240
f 6534//6911 6533//6911 6535//6911 
f 6535//6911 6536//6911 6534//6911 
o mesh241
f 6536//6912 6535//6912 6537//6912 
f 6537//6912 6538//6912 6536//6912 
o mesh242
f 6538//6913 6537//6913 6539//6913 
f 6539//6913 6540//6913 6538//6913 
o mesh243
f 6540//6912 6539//6912 6541//6912 
f 6541//6912 6542//6912 6540//6912 
o mesh244
f 6542//6914 6541//6914 6543//6914 
f 6543//6914 6544//6914 6542//6914 
o mesh245
f 6544//6915 6543//6915 6545//6915 
f 6545//6915 6546//6915 6544//6915 
o mesh246
f 6547//6916 6542//6916 6544//6916 
f 6524//6916 6526//6916 6528//6916 
f 6522//6916 6530//6916 6540//6916 
f 6544//6916 6546//6916 6547//6916 
f 6530//6916 6522//6916 6524//6916 
f 6542//6916 6520//6916 6522//6916 
f 6534//6916 6536//6916 6538//6916 
f 6547//6916 6548//6916 6542//6916 
f 6540//6916 6542//6916 6522//6916 
f 6540//6916 6532//6916 6534//6916 
f 6514//6916 6516//6916 6518//6916 
f 6528//6916 6530//6916 6524//6916 
f 6540//6916 6530//6916 6532//6916 
f 6520//6916 6511//6916 6514//6916 
f 6538//6916 6540//6916 6534//6916 
f 6520//6916 6548//6916 6511//6916 
f 6518//6916 6520//6916 6514//6916 
f 6548//6916 6520//6916 6542//6916 
o mesh247
f 6521//6917 6541//6917 6539//6917 
f 6523//6917 6529//6917 6527//6917 
f 6549//6917 6545//6917 6543//6917 
f 6533//6917 6539//6917 6537//6917 
f 6539//6917 6529//6917 6521//6917 
f 6527//6917 6525//6917 6523//6917 
f 6541//6917 6550//6917 6549//6917 
f 6513//6917 6519//6917 6517//6917 
f 6537//6917 6535//6917 6533//6917 
f 6523//6917 6521//6917 6529//6917 
f 6541//6917 6519//6917 6550//6917 
f 6517//6917 6515//6917 6513//6917 
f 6533//6917 6531//6917 6539//6917 
f 6543//6917 6541//6917 6549//6917 
f 6513//6917 6512//6917 6519//6917 
f 6521//6917 6519//6917 6541//6917 
f 6531//6917 6529//6917 6539//6917 
f 6512//6917 6550//6917 6519//6917 
o mesh248
f 6546//6918 6545//6918 6549//6918 
f 6549//6918 6547//6918 6546//6918 
o mesh249
f 6547//6919 6549//6919 6550//6919 
f 6550//6919 6548//6919 6547//6919 
o mesh250
f 6548//6918 6550//6918 6512//6918 
f 6512//6918 6511//6918 6548//6918 
g horizontalLeadNutHolder
v 0.0976529 0.0285401 -0.0313683 
v 0.0971155 0.0285401 -0.0314267 
v 0.0971155 0.0160401 -0.0314267 
v 0.0981652 0.0285401 -0.0311956 
v 0.0976529 0.0160401 -0.0313683 
v 0.0986284 0.0285401 -0.0309169 
v 0.0981652 0.0160401 -0.0311956 
v 0.0990209 0.0285401 -0.0305452 
v 0.0986284 0.0160401 -0.0309169 
v 0.0993243 0.0285401 -0.0300977 
v 0.0990209 0.0160401 -0.0305452 
v 0.0995243 0.0285401 -0.0295955 
v 0.0993243 0.0160401 -0.0300977 
v 0.0996118 0.0285401 -0.0290621 
v 0.0995243 0.0160401 -0.0295955 
v 0.0995825 0.0285401 -0.0285222 
v 0.0996118 0.0160401 -0.0290621 
v 0.0994379 0.0285401 -0.0280014 
v 0.0995825 0.0160401 -0.0285222 
v 0.0991847 0.0285401 -0.0275237 
v 0.0994379 0.0160401 -0.0280014 
v 0.0988347 0.0285401 -0.0271117 
v 0.0991847 0.0160401 -0.0275237 
v 0.0984044 0.0285401 -0.0267846 
v 0.0988347 0.0160401 -0.0271117 
v 0.0979137 0.0285401 -0.0265576 
v 0.0984044 0.0160401 -0.0267846 
v 0.0973858 0.0285401 -0.0264414 
v 0.0979137 0.0160401 -0.0265576 
v 0.0968452 0.0285401 -0.0264414 
v 0.0973858 0.0160401 -0.0264414 
v 0.0963172 0.0285401 -0.0265576 
v 0.0968452 0.0160401 -0.0264414 
v 0.0958266 0.0285401 -0.0267846 
v 0.0963172 0.0160401 -0.0265576 
v 0.0953962 0.0285401 -0.0271117 
v 0.0958266 0.0160401 -0.0267846 
v 0.0950463 0.0285401 -0.0275237 
v 0.0953962 0.0160401 -0.0271117 
v 0.094793 0.0285401 -0.0280014 
v 0.0950463 0.0160401 -0.0275237 
v 0.0946484 0.0285401 -0.0285222 
v 0.094793 0.0160401 -0.0280014 
v 0.0946191 0.0285401 -0.0290621 
v 0.0946484 0.0160401 -0.0285222 
v 0.0947066 0.0285401 -0.0295955 
v 0.0946191 0.0160401 -0.0290621 
v 0.0949067 0.0285401 -0.0300977 
v 0.0947066 0.0160401 -0.0295955 
v 0.0952101 0.0285401 -0.0305452 
v 0.0949067 0.0160401 -0.0300977 
v 0.0956025 0.0285401 -0.0309169 
v 0.0952101 0.0160401 -0.0305452 
v 0.0960658 0.0285401 -0.0311956 
v 0.0956025 0.0160401 -0.0309169 
v 0.096578 0.0285401 -0.0313683 
v 0.0960658 0.0160401 -0.0311956 
v 0.096578 0.0160401 -0.0313683 
v 0.101307 0.0160401 -0.0324873 
v 0.101975 0.0160401 -0.0315029 
v 0.100444 0.0160401 -0.0333052 
v 0.102415 0.0160401 -0.0303981 
v 0.102607 0.0160401 -0.0292245 
v 0.0959331 0.0160401 -0.0342981 
v 0.0971155 0.0160401 -0.0344267 
v 0.0982978 0.0160401 -0.0342981 
v 0.0994249 0.0160401 -0.0339184 
v 0.102225 0.0160401 -0.0268909 
v 0.101668 0.0160401 -0.0258402 
v 0.0925632 0.0160401 -0.0258402 
v 0.0920061 0.0160401 -0.0268909 
v 0.0916879 0.0160401 -0.0280369 
v 0.0918159 0.0160401 -0.0303981 
v 0.0922562 0.0160401 -0.0315029 
v 0.0929236 0.0160401 -0.0324873 
v 0.093787 0.0160401 -0.0333052 
v 0.0948061 0.0160401 -0.0339184 
v 0.102543 0.0160401 -0.0280369 
v 0.100898 0.0160401 -0.0249337 
v 0.099951 0.0160401 -0.024214 
v 0.0988716 0.0160401 -0.0237146 
v 0.0977101 0.0160401 -0.0234589 
v 0.0933331 0.0160401 -0.0249337 
v 0.0916235 0.0160401 -0.0292245 
v 0.0965208 0.0160401 -0.0234589 
v 0.0953593 0.0160401 -0.0237146 
v 0.0942799 0.0160401 -0.024214 
v 0.0971155 0.0180401 -0.0364267 
v 0.0955032 0.0180401 -0.0362514 
v 0.0939663 0.0180401 -0.0357335 
v 0.0925767 0.0180401 -0.0348974 
v 0.0913993 0.0180401 -0.0337821 
v 0.0904891 0.0180401 -0.0324398 
v 0.0898888 0.0180401 -0.0309332 
v 0.0896265 0.0180401 -0.0293327 
v 0.0897143 0.0180401 -0.0277133 
v 0.0901481 0.0180401 -0.0261507 
v 0.0909078 0.0180401 -0.0247178 
v 0.0919577 0.0180401 -0.0234817 
v 0.0932488 0.0180401 -0.0225003 
v 0.0947207 0.0180401 -0.0218193 
v 0.0963046 0.0180401 -0.0214707 
v 0.0979264 0.0180401 -0.0214707 
v 0.0995102 0.0180401 -0.0218193 
v 0.100982 0.0180401 -0.0225003 
v 0.102273 0.0180401 -0.0234817 
v 0.103323 0.0180401 -0.0247178 
v 0.104083 0.0180401 -0.0261507 
v 0.104517 0.0180401 -0.0277133 
v 0.104604 0.0180401 -0.0293327 
v 0.104342 0.0180401 -0.0309332 
v 0.103742 0.0180401 -0.0324398 
v 0.102832 0.0180401 -0.0337821 
v 0.101654 0.0180401 -0.0348974 
v 0.100265 0.0180401 -0.0357335 
v 0.0987278 0.0180401 -0.0362514 
v 0.0671155 0.0285401 -0.05666 
v 0.0862823 0.0285401 -0.0389043 
v 0.0881008 0.0285401 -0.037412 
v 0.0671155 0.0285401 -0.0409267 
v 0.0796155 0.0285401 -0.0409267 
v 0.0917357 0.0285401 -0.0277832 
v 0.092091 0.0285401 -0.0266897 
v 0.0926659 0.0285401 -0.0256939 
v 0.0943655 0.0285401 -0.0241636 
v 0.0954159 0.0285401 -0.0236959 
v 0.0965406 0.0285401 -0.0234568 
v 0.0842077 0.0285401 -0.0400133 
v 0.0819566 0.0285401 -0.0406961 
v 0.090702 0.0285401 -0.0335189 
v 0.0913849 0.0285401 -0.0312678 
v 0.0895931 0.0285401 -0.0355935 
v 0.0916155 0.0285401 -0.0289267 
v 0.0934353 0.0285401 -0.0248394 
v 0.0976904 0.0285401 -0.0234568 
v 0.0988151 0.0285401 -0.0236959 
v 0.0998655 0.0285401 -0.0241636 
v 0.10214 0.0285401 -0.0266897 
v 0.102495 0.0285401 -0.0277832 
v 0.102615 0.0285401 -0.0329267 
v 0.100796 0.0285401 -0.0248394 
v 0.101565 0.0285401 -0.0256939 
v 0.102615 0.0285401 -0.0289267 
v 0.102429 0.0285401 -0.0346426 
v 0.0983802 0.0285401 -0.0399855 
v 0.101879 0.0285401 -0.0362786 
v 0.100991 0.0285401 -0.0377587 
v 0.0998066 0.0285401 -0.0390138 
v 0.104488 0.0265401 -0.0277163 
v 0.104615 0.0265401 -0.0289267 
v 0.104452 0.0265401 -0.0273674 
v 0.104059 0.0265401 -0.0261585 
v 0.103967 0.0265401 -0.0258762 
v 0.103304 0.0265401 -0.0247286 
v 0.103183 0.0265401 -0.0245183 
v 0.10226 0.0265401 -0.0234934 
v 0.102134 0.0265401 -0.0233531 
v 0.100975 0.0265401 -0.0225107 
v 0.100865 0.0265401 -0.0224315 
v 0.099507 0.0265401 -0.0218267 
v 0.0994331 0.0265401 -0.0217938 
v 0.0979258 0.0265401 -0.0214734 
v 0.0978994 0.0265401 -0.0214678 
v 0.0963052 0.0265401 -0.0214734 
v 0.0947978 0.0265401 -0.0217938 
v 0.094724 0.0265401 -0.0218267 
v 0.0933655 0.0265401 -0.0224315 
v 0.0932564 0.0265401 -0.0225107 
v 0.092097 0.0265401 -0.0233531 
v 0.0919707 0.0265401 -0.0234934 
v 0.0910478 0.0265401 -0.0245183 
v 0.0909265 0.0265401 -0.0247286 
v 0.0902639 0.0265401 -0.0258762 
v 0.0901722 0.0265401 -0.0261585 
v 0.0897794 0.0265401 -0.0273674 
v 0.0897427 0.0265401 -0.0277163 
v 0.0896155 0.0265401 -0.0289267 
v 0.0963315 0.0265401 -0.0214678 
v 0.0671155 0.0265401 -0.0389267 
v 0.0796155 0.0265401 -0.0389267 
v 0.0894233 0.0265401 -0.0308776 
v 0.0888543 0.0265401 -0.0327535 
v 0.0879302 0.0265401 -0.0344824 
v 0.0866865 0.0265401 -0.0359978 
v 0.0851712 0.0265401 -0.0372414 
v 0.0834423 0.0265401 -0.0381655 
v 0.0815664 0.0265401 -0.0387346 
v 0.0894391 0.0255401 -0.0307967 
v 0.0894159 0.0255401 -0.0308754 
v 0.0888811 0.0255401 -0.0326881 
v 0.0888483 0.0255401 -0.0327504 
v 0.0879628 0.0255401 -0.0344333 
v 0.0879258 0.0255401 -0.0344789 
v 0.0867198 0.0255401 -0.0359644 
v 0.0866836 0.0255401 -0.0359943 
v 0.0852005 0.0255401 -0.0372217 
v 0.0851696 0.0255401 -0.0372384 
v 0.0834641 0.0255401 -0.0381565 
v 0.0834416 0.0255401 -0.0381633 
v 0.0815779 0.0255401 -0.0387323 
v 0.0815663 0.0255401 -0.0387334 
v 0.0796155 0.0255401 -0.0389267 
v 0.0896155 0.0255401 -0.0289267 
v 0.104615 0.0265401 -0.0329267 
v 0.0993214 0.0265401 -0.0417502 
v 0.101104 0.0265401 -0.0405355 
v 0.102585 0.0265401 -0.0389666 
v 0.103695 0.0265401 -0.0371166 
v 0.104383 0.0265401 -0.0350716 
v 0.104615 0.0255401 -0.0289267 
v 0.104615 0.0255401 -0.0329267 
v 0.0671155 0.0265401 -0.0589267 
v 0.0993214 0.0255401 -0.0417502 
v 0.101104 0.0255401 -0.0405355 
v 0.102585 0.0255401 -0.0389666 
v 0.103695 0.0255401 -0.0371166 
v 0.104383 0.0255401 -0.0350716 
v 0.104083 0.0250074 -0.0317027 
v 0.103742 0.0246664 -0.0324398 
v 0.104342 0.0252667 -0.0309332 
v 0.104517 0.0254413 -0.0301401 
v 0.104604 0.0255291 -0.0293327 
v 0.10346 0.0243844 -0.0329267 
v 0.0925767 0.0235401 -0.0348974 
v 0.0939663 0.0235401 -0.0357335 
v 0.0955032 0.0235401 -0.0362514 
v 0.0971155 0.0235401 -0.0364267 
v 0.0987278 0.0235401 -0.0362514 
v 0.100265 0.0235401 -0.0357335 
v 0.101654 0.0235401 -0.0348974 
v 0.102526 0.0235401 -0.0341207 
v 0.102806 0.0237937 -0.0337621 
v 0.0898774 0.025092 -0.030881 
v 0.0898888 0.0250726 -0.0309332 
v 0.0896265 0.0255209 -0.0293327 
v 0.0897119 0.0253728 -0.0301253 
v 0.090156 0.0246352 -0.0317223 
v 0.0904891 0.024113 -0.0324398 
v 0.0908726 0.0235401 -0.0330832 
v 0.0913993 0.0235401 -0.0337821 
v 0.102429 0.0235401 -0.0346426 
v 0.101879 0.0235401 -0.0362786 
v 0.100991 0.0235401 -0.0377587 
v 0.0998066 0.0235401 -0.0390138 
v 0.0983802 0.0235401 -0.0399855 
v 0.0671155 0.0255401 -0.0589267 
v 0.0666155 0.0235401 -0.0569267 
v 0.0571155 0.0255401 -0.0589267 
v 0.0576155 0.0235401 -0.0569267 
v 0.0819704 0.0235401 -0.0406934 
v 0.0796155 0.0235401 -0.0409267 
v 0.0842338 0.0235401 -0.0400024 
v 0.0863175 0.0235401 -0.0388807 
v 0.0881406 0.0235401 -0.0373719 
v 0.0896322 0.0235401 -0.0355347 
v 0.0907342 0.0235401 -0.0334404 
v 0.0446155 0.0255401 -0.0389267 
v 0.0446155 0.0235401 -0.0409267 
v 0.0422605 0.0235401 -0.0406934 
v 0.0328317 0.0235401 -0.0337821 
v 0.0345987 0.0235401 -0.0355347 
v 0.0334967 0.0235401 -0.0334404 
v 0.0316543 0.0235401 -0.0348974 
v 0.0379134 0.0235401 -0.0388807 
v 0.0333583 0.0235401 -0.0330832 
v 0.0360903 0.0235401 -0.0373719 
v 0.0399972 0.0235401 -0.0400024 
v 0.0302646 0.0235401 -0.0357335 
v 0.0225767 0.0235401 -0.0348974 
v 0.0217051 0.0235401 -0.0341207 
v 0.0218017 0.0235401 -0.0346426 
v 0.0239663 0.0235401 -0.0357335 
v 0.0223516 0.0235401 -0.0362786 
v 0.0232396 0.0235401 -0.0377587 
v 0.0255032 0.0235401 -0.0362514 
v 0.0258508 0.0235401 -0.0399855 
v 0.0271155 0.0235401 -0.0364267 
v 0.0287278 0.0235401 -0.0362514 
v 0.0244244 0.0235401 -0.0390138 
v 0.0249096 0.0255401 -0.0417502 
v 0.0362682 0.0255401 -0.0344333 
v 0.0353826 0.0255401 -0.0327504 
v 0.0375112 0.0255401 -0.0359644 
v 0.0363052 0.0255401 -0.0344789 
v 0.0390304 0.0255401 -0.0372217 
v 0.0375473 0.0255401 -0.0359943 
v 0.0407669 0.0255401 -0.0381565 
v 0.0390614 0.0255401 -0.0372384 
v 0.042653 0.0255401 -0.0387323 
v 0.0407893 0.0255401 -0.0381633 
v 0.0426647 0.0255401 -0.0387334 
v 0.0347919 0.0255401 -0.0307967 
v 0.0346155 0.0255401 -0.0289267 
v 0.0346045 0.0255209 -0.0293327 
v 0.0345181 0.0253712 -0.0301311 
v 0.0353499 0.0255401 -0.0326881 
v 0.0337418 0.024113 -0.0324398 
v 0.0340731 0.0246321 -0.031727 
v 0.0348151 0.0255401 -0.0308754 
v 0.0343568 0.0250972 -0.0308795 
v 0.0343391 0.0250683 -0.0309322 
v 0.0446155 0.0265401 -0.0389267 
v 0.0407886 0.0265401 -0.0381655 
v 0.0426646 0.0265401 -0.0387346 
v 0.0390598 0.0265401 -0.0372414 
v 0.0375444 0.0265401 -0.0359978 
v 0.0363008 0.0265401 -0.0344824 
v 0.0353767 0.0265401 -0.0327535 
v 0.0348076 0.0265401 -0.0308776 
v 0.0346155 0.0265401 -0.0289267 
v 0.0231266 0.0255401 -0.0405355 
v 0.0216456 0.0255401 -0.0389666 
v 0.0205356 0.0255401 -0.0371166 
v 0.0198482 0.0255401 -0.0350716 
v 0.0214246 0.0237937 -0.0337621 
v 0.0207712 0.0243844 -0.0329267 
v 0.0196155 0.0255401 -0.0329267 
v 0.0249096 0.0265401 -0.0417502 
v 0.0571155 0.0265401 -0.0589267 
v 0.0197143 0.0254413 -0.0301401 
v 0.0196265 0.0255291 -0.0293327 
v 0.0201481 0.0250074 -0.0317027 
v 0.0198888 0.0252667 -0.0309332 
v 0.0205163 0.0246393 -0.0324259 
v 0.0196155 0.0255401 -0.0289267 
v 0.0196155 0.0265401 -0.0329267 
v 0.0198482 0.0265401 -0.0350716 
v 0.0205356 0.0265401 -0.0371166 
v 0.0216456 0.0265401 -0.0389666 
v 0.0231266 0.0265401 -0.0405355 
v 0.0196155 0.0265401 -0.0289267 
v 0.0216155 0.0285401 -0.0329267 
v 0.0218017 0.0285401 -0.0346426 
v 0.0223516 0.0285401 -0.0362786 
v 0.0232396 0.0285401 -0.0377587 
v 0.0244244 0.0285401 -0.0390138 
v 0.0258508 0.0285401 -0.0399855 
v 0.0216155 0.0285401 -0.0289267 
v 0.0344883 0.0265401 -0.0277163 
v 0.0326155 0.0285401 -0.0289267 
v 0.0324953 0.0285401 -0.0277832 
v 0.0344516 0.0265401 -0.0273674 
v 0.0340588 0.0265401 -0.0261585 
v 0.03214 0.0285401 -0.0266897 
v 0.0339671 0.0265401 -0.0258762 
v 0.0333045 0.0265401 -0.0247286 
v 0.0315651 0.0285401 -0.0256939 
v 0.0331831 0.0265401 -0.0245183 
v 0.0322603 0.0265401 -0.0234934 
v 0.0307957 0.0285401 -0.0248394 
v 0.032134 0.0265401 -0.0233531 
v 0.0309745 0.0265401 -0.0225107 
v 0.0298655 0.0285401 -0.0241636 
v 0.0308655 0.0265401 -0.0224315 
v 0.029507 0.0265401 -0.0218267 
v 0.0288151 0.0285401 -0.0236959 
v 0.0294331 0.0265401 -0.0217938 
v 0.0279258 0.0265401 -0.0214734 
v 0.0276904 0.0285401 -0.0234568 
v 0.0278994 0.0265401 -0.0214678 
v 0.0265406 0.0285401 -0.0234568 
v 0.0263052 0.0265401 -0.0214734 
v 0.0254159 0.0285401 -0.0236959 
v 0.0247978 0.0265401 -0.0217938 
v 0.024724 0.0265401 -0.0218267 
v 0.0243655 0.0285401 -0.0241636 
v 0.0233655 0.0265401 -0.0224315 
v 0.0232564 0.0265401 -0.0225107 
v 0.0234353 0.0285401 -0.0248394 
v 0.022097 0.0265401 -0.0233531 
v 0.0219707 0.0265401 -0.0234934 
v 0.0226659 0.0285401 -0.0256939 
v 0.0210478 0.0265401 -0.0245183 
v 0.0209265 0.0265401 -0.0247286 
v 0.022091 0.0285401 -0.0266897 
v 0.0202639 0.0265401 -0.0258762 
v 0.0201722 0.0265401 -0.0261585 
v 0.0217357 0.0285401 -0.0277832 
v 0.0197794 0.0265401 -0.0273674 
v 0.0197427 0.0265401 -0.0277163 
v 0.0263315 0.0265401 -0.0214678 
v 0.0201481 0.0180401 -0.0261507 
v 0.0197143 0.0180401 -0.0277133 
v 0.0209078 0.0180401 -0.0247178 
v 0.0219577 0.0180401 -0.0234817 
v 0.0232488 0.0180401 -0.0225003 
v 0.0247207 0.0180401 -0.0218193 
v 0.0263046 0.0180401 -0.0214707 
v 0.0279264 0.0180401 -0.0214707 
v 0.0295102 0.0180401 -0.0218193 
v 0.0309821 0.0180401 -0.0225003 
v 0.0322732 0.0180401 -0.0234817 
v 0.0333231 0.0180401 -0.0247178 
v 0.0340828 0.0180401 -0.0261507 
v 0.0345167 0.0180401 -0.0277133 
v 0.0196265 0.0180401 -0.0293327 
v 0.0198888 0.0180401 -0.0309332 
v 0.0204891 0.0180401 -0.0324398 
v 0.0225767 0.0180401 -0.0348974 
v 0.0213993 0.0180401 -0.0337821 
v 0.0239663 0.0180401 -0.0357335 
v 0.0255032 0.0180401 -0.0362514 
v 0.0271155 0.0180401 -0.0364267 
v 0.0287278 0.0180401 -0.0362514 
v 0.0302646 0.0180401 -0.0357335 
v 0.0316543 0.0180401 -0.0348974 
v 0.0328317 0.0180401 -0.0337821 
v 0.0337418 0.0180401 -0.0324398 
v 0.0343421 0.0180401 -0.0309332 
v 0.0346045 0.0180401 -0.0293327 
v 0.0446155 0.0285401 -0.0409267 
v 0.0422744 0.0285401 -0.0406961 
v 0.0400233 0.0285401 -0.0400133 
v 0.0379486 0.0285401 -0.0389043 
v 0.0361302 0.0285401 -0.037412 
v 0.0346378 0.0285401 -0.0355935 
v 0.0335289 0.0285401 -0.0335189 
v 0.0328461 0.0285401 -0.0312678 
v 0.0591155 0.0265401 -0.0389267 
v 0.0571155 0.0285401 -0.0409267 
v 0.0671155 0.0431227 -0.0389267 
v 0.0591155 0.0431227 -0.0389267 
v 0.0271155 0.0160401 -0.0344267 
v 0.0259331 0.0160401 -0.0342981 
v 0.0248061 0.0160401 -0.0339184 
v 0.023787 0.0160401 -0.0333052 
v 0.0229236 0.0160401 -0.0324873 
v 0.0222562 0.0160401 -0.0315029 
v 0.0218159 0.0160401 -0.0303981 
v 0.0216235 0.0160401 -0.0292245 
v 0.0216879 0.0160401 -0.0280369 
v 0.0220061 0.0160401 -0.0268909 
v 0.0225632 0.0160401 -0.0258402 
v 0.0233331 0.0160401 -0.0249337 
v 0.0242799 0.0160401 -0.024214 
v 0.0253593 0.0160401 -0.0237146 
v 0.0265208 0.0160401 -0.0234589 
v 0.0277101 0.0160401 -0.0234589 
v 0.0288716 0.0160401 -0.0237146 
v 0.029951 0.0160401 -0.024214 
v 0.0308978 0.0160401 -0.0249337 
v 0.0316678 0.0160401 -0.0258402 
v 0.0322248 0.0160401 -0.0268909 
v 0.032543 0.0160401 -0.0280369 
v 0.0326074 0.0160401 -0.0292245 
v 0.032415 0.0160401 -0.0303981 
v 0.0319748 0.0160401 -0.0315029 
v 0.0313074 0.0160401 -0.0324873 
v 0.0304439 0.0160401 -0.0333052 
v 0.0294249 0.0160401 -0.0339184 
v 0.0282978 0.0160401 -0.0342981 
v 0.0247066 0.0160401 -0.0295955 
v 0.0246191 0.0160401 -0.0290621 
v 0.0249067 0.0160401 -0.0300977 
v 0.0252101 0.0160401 -0.0305452 
v 0.0256025 0.0160401 -0.0309169 
v 0.0253962 0.0160401 -0.0271117 
v 0.0258266 0.0160401 -0.0267846 
v 0.0250463 0.0160401 -0.0275237 
v 0.0271155 0.0160401 -0.0314267 
v 0.026578 0.0160401 -0.0313683 
v 0.0276529 0.0160401 -0.0313683 
v 0.0290209 0.0160401 -0.0305452 
v 0.0286284 0.0160401 -0.0309169 
v 0.0293243 0.0160401 -0.0300977 
v 0.0295243 0.0160401 -0.0295955 
v 0.0296118 0.0160401 -0.0290621 
v 0.0263172 0.0160401 -0.0265576 
v 0.024793 0.0160401 -0.0280014 
v 0.0246484 0.0160401 -0.0285222 
v 0.0260658 0.0160401 -0.0311956 
v 0.0281652 0.0160401 -0.0311956 
v 0.0294379 0.0160401 -0.0280014 
v 0.0295825 0.0160401 -0.0285222 
v 0.0291847 0.0160401 -0.0275237 
v 0.0268452 0.0160401 -0.0264414 
v 0.0288347 0.0160401 -0.0271117 
v 0.0284044 0.0160401 -0.0267846 
v 0.0279137 0.0160401 -0.0265576 
v 0.0273858 0.0160401 -0.0264414 
v 0.0276529 0.0285401 -0.0313683 
v 0.0271155 0.0285401 -0.0314267 
v 0.0281652 0.0285401 -0.0311956 
v 0.0286284 0.0285401 -0.0309169 
v 0.0290209 0.0285401 -0.0305452 
v 0.0293243 0.0285401 -0.0300977 
v 0.0295243 0.0285401 -0.0295955 
v 0.0296118 0.0285401 -0.0290621 
v 0.0295825 0.0285401 -0.0285222 
v 0.0294379 0.0285401 -0.0280014 
v 0.0291847 0.0285401 -0.0275237 
v 0.0288347 0.0285401 -0.0271117 
v 0.0284044 0.0285401 -0.0267846 
v 0.0279137 0.0285401 -0.0265576 
v 0.0273858 0.0285401 -0.0264414 
v 0.0268452 0.0285401 -0.0264414 
v 0.0263172 0.0285401 -0.0265576 
v 0.0258266 0.0285401 -0.0267846 
v 0.0253962 0.0285401 -0.0271117 
v 0.0250463 0.0285401 -0.0275237 
v 0.024793 0.0285401 -0.0280014 
v 0.0246484 0.0285401 -0.0285222 
v 0.0246191 0.0285401 -0.0290621 
v 0.0247066 0.0285401 -0.0295955 
v 0.0249067 0.0285401 -0.0300977 
v 0.0252101 0.0285401 -0.0305452 
v 0.0256025 0.0285401 -0.0309169 
v 0.0260658 0.0285401 -0.0311956 
v 0.026578 0.0285401 -0.0313683 
v 0.0571155 0.0285401 -0.0443441 
v 0.0340231 0.0285401 -0.0443441 
v 0.0571155 0.0309903 -0.0409267 
v 0.0571155 0.0305642 -0.0413514 
v 0.0571155 0.0291534 -0.0431917 
v 0.0581428 0.0448171 -0.0398994 
v 0.0581155 0.0322156 -0.0399267 
v 0.0581155 0.0448647 -0.0399267 
v 0.0581155 0.0463183 -0.0411485 
v 0.0671155 0.0463183 -0.0411485 
v 0.0671155 0.0475717 -0.0426473 
v 0.0581155 0.0475717 -0.0426473 
v 0.0671155 0.0485401 -0.0443441 
v 0.0671155 0.0448195 -0.0398952 
v 0.0581155 0.0485401 -0.0443441 
v 0.0671155 0.0485401 -0.0535093 
v 0.0581155 0.0485401 -0.0535093 
v 0.0671155 0.0475717 -0.0552061 
v 0.0581155 0.0475717 -0.0552061 
v 0.0671155 0.0463183 -0.0567049 
v 0.0581155 0.0463183 -0.0567049 
v 0.0671155 0.0448195 -0.0579582 
v 0.0581155 0.0448195 -0.0579582 
v 0.0671155 0.0431227 -0.0589267 
v 0.0581155 0.0431227 -0.0589267 
v 0.0581155 0.0339575 -0.0589267 
v 0.0571155 0.0339575 -0.0589267 
v 0.0581155 0.0275799 -0.049862 
v 0.0581155 0.0280195 -0.0521388 
v 0.0475318 0.0280195 -0.0521388 
v 0.0581155 0.0276274 -0.0475437 
v 0.0423288 0.0275799 -0.049862 
v 0.0581155 0.0281598 -0.0452868 
v 0.0380828 0.0276274 -0.0475437 
v 0.0363795 0.027834 -0.0464012 
v 0.0581155 0.0291534 -0.0431917 
v 0.0349825 0.0281598 -0.0452868 
v 0.0581155 0.0305642 -0.0413514 
v 0.0571155 0.0319631 -0.0577439 
v 0.0581155 0.0319631 -0.0577439 
v 0.0571155 0.0302609 -0.0561693 
v 0.0581155 0.0302609 -0.0561693 
v 0.0571155 0.0289266 -0.0542728 
v 0.0581155 0.0289266 -0.0542728 
v 0.0571155 0.0285401 -0.0535093 
v 0.0512078 0.0285401 -0.0535093 
v 0.0571155 0.0285401 -0.05666 
v 0.0671155 0.0426992 -0.0431886 
v 0.0671155 0.0385401 -0.0434267 
v 0.0671155 0.0373578 -0.0435553 
v 0.0671155 0.0427167 -0.0435125 
v 0.0671155 0.0427516 -0.0428686 
v 0.0671155 0.0332406 -0.0474553 
v 0.0671155 0.0336808 -0.0463505 
v 0.0671155 0.0362307 -0.043935 
v 0.0671155 0.0343482 -0.0453661 
v 0.0671155 0.0352116 -0.0445482 
v 0.0671155 0.0330482 -0.0486289 
v 0.0671155 0.0347578 -0.0529197 
v 0.0671155 0.0340265 -0.0536125 
v 0.0671155 0.0342085 -0.0538809 
v 0.0671155 0.0331126 -0.0498165 
v 0.0671155 0.033791 -0.0533894 
v 0.0671155 0.0334307 -0.0509625 
v 0.0671155 0.0343811 -0.0545023 
v 0.0671155 0.0367839 -0.0541388 
v 0.0671155 0.0357046 -0.0536394 
v 0.0671155 0.0339878 -0.0520132 
v 0.0671155 0.0342767 -0.0551388 
v 0.0671155 0.0385401 -0.0544267 
v 0.0671155 0.0379455 -0.0543945 
v 0.0671155 0.0343286 -0.0541823 
v 0.0671155 0.0438745 -0.0418049 
v 0.0671155 0.044197 -0.0417698 
v 0.0671155 0.0343635 -0.0548262 
v 0.0671155 0.0314379 -0.0541823 
v 0.0671155 0.0443591 -0.0447611 
v 0.0671155 0.044197 -0.0447698 
v 0.0671155 0.044032 -0.0486289 
v 0.0671155 0.0446759 -0.0446913 
v 0.0671155 0.0439677 -0.0498165 
v 0.0671155 0.0330454 -0.0560748 
v 0.0671155 0.0319755 -0.0533894 
v 0.0671155 0.0322534 -0.0532222 
v 0.0671155 0.031558 -0.0538809 
v 0.0671155 0.0408495 -0.043935 
v 0.0671155 0.0418686 -0.0445482 
v 0.0671155 0.0428035 -0.0438251 
v 0.0671155 0.0433994 -0.0463505 
v 0.0671155 0.043718 -0.0446913 
v 0.0671155 0.0434236 -0.0445551 
v 0.0671155 0.0440348 -0.0447611 
v 0.0671155 0.0436495 -0.0509625 
v 0.0671155 0.0430924 -0.0520132 
v 0.0671155 0.0445194 -0.0418049 
v 0.0671155 0.0333622 -0.056005 
v 0.0671155 0.0341248 -0.0554253 
v 0.0671155 0.0339148 -0.0556726 
v 0.0671155 0.0428717 -0.0425672 
v 0.0671155 0.0332057 -0.0531186 
v 0.0671155 0.0335131 -0.0532222 
v 0.0671155 0.0325608 -0.0531186 
v 0.0671155 0.03174 -0.0536125 
v 0.0671155 0.0429554 -0.0441116 
v 0.0671155 0.0397224 -0.0435553 
v 0.0671155 0.042732 -0.0453661 
v 0.0671155 0.0431654 -0.0443588 
v 0.0671155 0.0423225 -0.0529197 
v 0.0671155 0.0449703 -0.0445551 
v 0.0671155 0.0454385 -0.0441116 
v 0.0671155 0.0453402 -0.0422988 
v 0.0671155 0.0455222 -0.0425672 
v 0.0671155 0.0448268 -0.0419085 
v 0.0671155 0.0435671 -0.0419085 
v 0.0671155 0.0430537 -0.0422988 
v 0.0671155 0.0336566 -0.0558688 
v 0.0671155 0.0328833 -0.0530836 
v 0.0671155 0.0402963 -0.0541388 
v 0.0671155 0.0391348 -0.0543945 
v 0.0671155 0.0413757 -0.0536394 
v 0.0671155 0.0455904 -0.0438251 
v 0.0671155 0.0456948 -0.0431886 
v 0.0671155 0.0451047 -0.0420757 
v 0.0671155 0.0438396 -0.0474553 
v 0.0671155 0.031403 -0.0548262 
v 0.0671155 0.0313855 -0.0545023 
v 0.0671155 0.0456772 -0.0435125 
v 0.0671155 0.0456423 -0.0428686 
v 0.0671155 0.0432892 -0.0420757 
v 0.0671155 0.0314898 -0.0551388 
v 0.0671155 0.0318517 -0.0556726 
v 0.0671155 0.0316417 -0.0554253 
v 0.0671155 0.0328833 -0.0560836 
v 0.0671155 0.0327211 -0.0560748 
v 0.0671155 0.0452285 -0.0443588 
v 0.0671155 0.0324043 -0.056005 
v 0.0671155 0.0321099 -0.0558688 
v 0.0581155 0.0452285 -0.0443588 
v 0.0581155 0.0454385 -0.0441116 
v 0.0581155 0.0443591 -0.0447611 
v 0.0581155 0.044032 -0.0486289 
v 0.0581155 0.0439677 -0.0498165 
v 0.0581155 0.0343811 -0.0545023 
v 0.0581155 0.0367839 -0.0541388 
v 0.0581155 0.0379455 -0.0543945 
v 0.0581155 0.0347578 -0.0529197 
v 0.0581155 0.0357046 -0.0536394 
v 0.0581155 0.0342085 -0.0538809 
v 0.0581155 0.0455904 -0.0438251 
v 0.0581155 0.0446759 -0.0446913 
v 0.0581155 0.0449703 -0.0445551 
v 0.0581155 0.0436495 -0.0509625 
v 0.0581155 0.0413757 -0.0536394 
v 0.0581155 0.0423225 -0.0529197 
v 0.0581155 0.0340265 -0.0536125 
v 0.0581155 0.0343635 -0.0548262 
v 0.0581155 0.0418686 -0.0445482 
v 0.0581155 0.0429554 -0.0441116 
v 0.0581155 0.0431654 -0.0443588 
v 0.0581155 0.0430924 -0.0520132 
v 0.0581155 0.0391348 -0.0543945 
v 0.0581155 0.0343286 -0.0541823 
v 0.0581155 0.0341248 -0.0554253 
v 0.0581155 0.0342767 -0.0551388 
v 0.0581155 0.042732 -0.0453661 
v 0.0581155 0.0402963 -0.0541388 
v 0.0581155 0.0339148 -0.0556726 
v 0.0581155 0.0434236 -0.0445551 
v 0.0581155 0.0433994 -0.0463505 
v 0.0581155 0.0408495 -0.043935 
v 0.0581155 0.0427167 -0.0435125 
v 0.0581155 0.0428035 -0.0438251 
v 0.0581155 0.0339878 -0.0520132 
v 0.0581155 0.033791 -0.0533894 
v 0.0581155 0.0440348 -0.0447611 
v 0.0581155 0.043718 -0.0446913 
v 0.0581155 0.0438396 -0.0474553 
v 0.0581155 0.0335131 -0.0532222 
v 0.0581155 0.0328833 -0.0530836 
v 0.0581155 0.0331126 -0.0498165 
v 0.0581155 0.0334307 -0.0509625 
v 0.0581155 0.0426992 -0.0431886 
v 0.0581155 0.0336566 -0.0558688 
v 0.0581155 0.0330454 -0.0560748 
v 0.0581155 0.0333622 -0.056005 
v 0.0581155 0.03174 -0.0536125 
v 0.0581155 0.031558 -0.0538809 
v 0.0581155 0.0319755 -0.0533894 
v 0.0581155 0.0448268 -0.0419085 
v 0.0581155 0.0445194 -0.0418049 
v 0.0581155 0.0451047 -0.0420757 
v 0.0581155 0.0455222 -0.0425672 
v 0.0581155 0.0456772 -0.0435125 
v 0.0581155 0.0456948 -0.0431886 
v 0.0581155 0.0332057 -0.0531186 
v 0.0581155 0.0330482 -0.0486289 
v 0.0581155 0.0397224 -0.0435553 
v 0.0581155 0.0427516 -0.0428686 
v 0.0581155 0.0327211 -0.0560748 
v 0.0581155 0.031403 -0.0548262 
v 0.0581155 0.0322534 -0.0532222 
v 0.0581155 0.0325608 -0.0531186 
v 0.0581155 0.0352116 -0.0445482 
v 0.0581155 0.0453402 -0.0422988 
v 0.0581155 0.0321099 -0.0558688 
v 0.0581155 0.0324043 -0.056005 
v 0.0581155 0.0314898 -0.0551388 
v 0.0581155 0.0316417 -0.0554253 
v 0.0581155 0.0313855 -0.0545023 
v 0.0581155 0.0314379 -0.0541823 
v 0.0581155 0.0332406 -0.0474553 
v 0.0581155 0.0336808 -0.0463505 
v 0.0581155 0.0343482 -0.0453661 
v 0.0581155 0.0362307 -0.043935 
v 0.0581155 0.0456423 -0.0428686 
v 0.0581155 0.0385401 -0.0434267 
v 0.0581155 0.0428717 -0.0425672 
v 0.0581155 0.0432892 -0.0420757 
v 0.0581155 0.0430537 -0.0422988 
v 0.0581155 0.0435671 -0.0419085 
v 0.0581155 0.0318517 -0.0556726 
v 0.0581155 0.0373578 -0.0435553 
v 0.0581155 0.044197 -0.0417698 
v 0.0581155 0.0438745 -0.0418049 
vn -0.159186 0.0245151 0.986944 
vn 0.0638167 0.0241848 0.997669 
vn -0.377005 0.0248055 0.925879 
vn -0.159186 0.0245151 0.986944 
vn -0.577588 0.0250368 0.815945 
vn -0.377005 0.0248055 0.925879 
vn -0.74919 0.0251926 0.661876 
vn -0.577588 0.0250368 0.815945 
vn -0.881445 0.025261 0.47161 
vn -0.74919 0.0251926 0.661876 
vn -0.966401 0.0252366 0.255798 
vn -0.881445 0.025261 0.47161 
vn -0.999322 0.0251214 0.0269058 
vn -0.966401 0.0252366 0.255798 
vn -0.979084 0.0249243 -0.201922 
vn -0.999322 0.0251214 0.0269058 
vn -0.908091 0.0246597 -0.418045 
vn -0.979084 0.0249243 -0.201922 
vn -0.791783 0.024346 -0.610317 
vn -0.908091 0.0246597 -0.418045 
vn -0.637881 0.0240028 -0.769761 
vn -0.791783 0.024346 -0.610317 
vn -0.455545 0.0236495 -0.889899 
vn -0.637881 0.0240028 -0.769761 
vn -0.254601 0.0233035 -0.966765 
vn -0.455545 0.0236495 -0.889899 
vn -0.0449092 0.0229801 -0.998727 
vn -0.254601 0.0233035 -0.966765 
vn 0.164098 0.0226915 -0.986183 
vn -0.0449092 0.0229801 -0.998727 
vn 0.36371 0.0224473 -0.931242 
vn 0.164098 0.0226915 -0.986183 
vn 0.546122 0.0222545 -0.83741 
vn 0.36371 0.0224473 -0.931242 
vn 0.70453 0.0221184 -0.709329 
vn 0.546122 0.0222545 -0.83741 
vn 0.833181 0.0220421 -0.552561 
vn 0.70453 0.0221184 -0.709329 
vn 0.927401 0.0220273 -0.37342 
vn 0.833181 0.0220421 -0.552561 
vn 0.983631 0.0220744 -0.178835 
vn 0.927401 0.0220273 -0.37342 
vn 0.999472 0.0221823 0.023758 
vn 0.983631 0.0220744 -0.178835 
vn 0.973749 0.0223486 0.226524 
vn 0.999472 0.0221823 0.023758 
vn 0.906617 0.022569 0.421351 
vn 0.973749 0.0223486 0.226524 
vn 0.799674 0.0228375 0.6 
vn 0.906617 0.022569 0.421351 
vn 0.656108 0.0231457 0.754312 
vn 0.799674 0.0228375 0.6 
vn 0.480827 0.0234826 0.876501 
vn 0.656108 0.0231457 0.754312 
vn 0.28055 0.0238344 0.959543 
vn 0.480827 0.0234826 0.876501 
vn 0.0634569 -0.997547 -0.0295514 
vn 0.0617197 -0.679211 -0.731343 
vn -0.0902067 -0.685963 -0.722024 
vn -0.238124 -0.693271 -0.6802 
vn -0.375041 -0.700822 -0.606789 
vn -0.494038 -0.708258 -0.504278 
vn -0.588654 -0.715195 -0.376805 
vn -0.653344 -0.72124 -0.230118 
vn -0.683953 -0.726026 -0.0713833 
vn -0.678152 -0.729243 0.0911816 
vn -0.635759 -0.730675 0.248844 
vn -0.558857 -0.730224 0.393003 
vn -0.451684 -0.72792 0.515862 
vn -0.320291 -0.723922 0.611025 
vn -0.172027 -0.718493 0.673925 
vn -0.014932 -0.711974 0.702047 
vn 0.142861 -0.70475 0.694923 
vn 0.293643 -0.697212 0.653964 
vn 0.430517 -0.689735 0.582169 
vn 0.547662 -0.682656 0.483784 
vn 0.640465 -0.676266 0.363963 
vn 0.705574 -0.670801 0.228453 
vn 0.740879 -0.66645 0.0833302 
vn 0.745464 -0.663348 -0.0652208 
vn 0.719544 -0.661588 -0.211085 
vn 0.664399 -0.661221 -0.348368 
vn 0.582307 -0.662256 -0.471525 
vn 0.476487 -0.664664 -0.575483 
vn 0.351044 -0.668376 -0.655775 
vn 0.2109 -0.673279 -0.708673 
vn 0.0605514 0.997767 -0.0281983 
vn 0.718471 0.690829 0.0809583 
vn 0.724784 0.688437 -0.0272556 
vn 0.713534 0.691645 0.111785 
vn 0.683937 0.69507 0.221602 
vn 0.674478 0.695964 0.2464 
vn 0.62049 0.700388 0.352773 
vn 0.608672 0.701262 0.371148 
vn 0.530249 0.706596 0.46857 
vn 0.518204 0.707362 0.480732 
vn 0.416542 0.713459 0.563444 
vn 0.406225 0.714047 0.570191 
vn 0.283907 0.720694 0.632453 
vn 0.27694 0.721056 0.635124 
vn 0.138033 0.727971 0.671569 
vn 0.135552 0.728089 0.671946 
vn -0.0118647 0.73482 0.678158 
vn -0.0143938 0.734931 0.67799 
vn -0.158589 0.74091 0.652612 
vn -0.16596 0.741198 0.650448 
vn -0.297573 0.746028 0.595728 
vn -0.308869 0.746411 0.589467 
vn -0.421851 0.749881 0.509628 
vn -0.435442 0.750246 0.497516 
vn -0.525013 0.752235 0.398126 
vn -0.538678 0.752454 0.378998 
vn -0.601676 0.752944 0.266574 
vn -0.612816 0.752888 0.240035 
vn -0.647905 0.751963 0.121534 
vn -0.653808 0.751518 0.0880704 
vn -0.661505 0.749354 -0.0296673 
vn -0.0118647 0.73482 0.678158 
vn 0.0621892 0.731514 0.678985 
vn -0.661505 0.749354 -0.0296673 
vn -0.649724 0.751846 0.112186 
vn -0.609182 0.752913 0.249036 
vn -0.541546 0.752496 0.374803 
vn -0.449853 0.750617 0.483949 
vn -0.338307 0.74738 0.571814 
vn -0.211996 0.74296 0.634877 
vn -0.0765542 0.737583 0.670903 
vn 0.0621892 0.731514 0.678985 
vn -0.661505 0.749354 -0.0296673 
vn -0.99921 0.0250793 -0.0308181 
vn -0.98372 0.025207 0.17793 
vn -0.985253 0.025203 0.169235 
vn -0.983734 0.0252069 0.177855 
vn -0.924793 0.0252618 0.37963 
vn -0.927647 0.0252612 0.372602 
vn -0.924818 0.0252618 0.379569 
vn -0.824923 0.0252404 0.564682 
vn -0.828474 0.0252421 0.559459 
vn -0.824954 0.0252404 0.564635 
vn -0.688936 0.0251439 0.724386 
vn -0.692574 0.0251471 0.720909 
vn -0.688969 0.025144 0.724355 
vn -0.523612 0.0249788 0.85159 
vn -0.526801 0.0249823 0.849621 
vn -0.523642 0.0249788 0.851572 
vn -0.337112 0.024755 0.941139 
vn -0.339441 0.0247579 0.940302 
vn -0.337134 0.024755 0.941131 
vn -0.138315 0.0244855 0.990086 
vn -0.139527 0.0244872 0.989915 
vn -0.138327 0.0244855 0.990084 
vn 0.0638167 0.0241848 0.997669 
vn -0.99921 0.0250793 -0.0308181 
vn 0.724784 0.688437 -0.0272556 
vn 0.373791 0.691641 -0.617992 
vn 0.490793 0.68835 -0.534131 
vn 0.587735 0.686346 -0.428366 
vn 0.66083 0.685686 -0.305188 
vn 0.707168 0.68639 -0.169654 
vn 0.724784 0.688437 -0.0272556 
vn 0.999384 0.0221498 -0.0272182 
vn 0.373791 0.691641 -0.617992 
vn 0.50454 0.0222955 -0.863101 
vn 0.668893 0.0221458 -0.743029 
vn 0.804906 0.022055 -0.592992 
vn 0.907676 0.0220252 -0.419094 
vn 0.973393 0.022057 -0.228079 
vn 0.999384 0.0221498 -0.0272182 
vn 0.747204 -0.664 -0.0280987 
vn -0.930214 0.0252605 0.366148 
vn -0.930127 0.0252605 0.366367 
vn -0.981129 0.025213 0.191704 
vn -0.989522 0.02519 0.142167 
vn -0.820801 0.0252383 0.570657 
vn -0.820674 0.0252382 0.57084 
vn -0.91376 0.0252634 0.405468 
vn -0.667704 0.0251251 0.744002 
vn -0.667558 0.0251249 0.744134 
vn -0.800423 0.0252269 0.598905 
vn -0.480204 0.0249297 0.876802 
vn -0.480066 0.0249295 0.876878 
vn -0.647401 0.0251063 0.761736 
vn -0.269492 0.0246665 0.962687 
vn -0.269391 0.0246663 0.962715 
vn -0.463368 0.0249101 0.885816 
vn -0.0475935 0.0243537 0.99857 
vn -0.0475548 0.0243536 0.998572 
vn -0.258562 0.0246519 0.96568 
vn 0.170018 0.0240168 0.985148 
vn -0.0438689 0.0243482 0.998741 
vn 0.173639 0.0240109 0.984517 
vn 0.173602 0.024011 0.984523 
vn 0.383321 0.0236576 0.923312 
vn 0.373263 0.0236752 0.927423 
vn 0.383227 0.0236578 0.923351 
vn 0.572055 0.0233113 0.819884 
vn 0.557326 0.0233395 0.829966 
vn 0.571934 0.0233116 0.819968 
vn 0.732204 0.0229872 0.680697 
vn 0.715197 0.0230235 0.698543 
vn 0.732082 0.0229875 0.680829 
vn 0.857961 0.0226977 0.513213 
vn 0.841468 0.0227385 0.539828 
vn 0.857859 0.0226979 0.513384 
vn 0.945295 0.0224523 0.325444 
vn 0.932289 0.0224937 0.361015 
vn 0.945227 0.0224526 0.325642 
vn 0.991829 0.0222584 0.125622 
vn 0.985274 0.0222958 0.169524 
vn 0.991802 0.0222585 0.125829 
vn -0.54966 0.0238263 -0.835049 
vn -0.718983 0.0241769 -0.694607 
vn -0.356777 0.0234746 -0.933894 
vn -0.150245 0.0231382 -0.988378 
vn 0.0602438 0.0228308 -0.997923 
vn 0.265588 0.0225633 -0.963822 
vn 0.457515 0.0223441 -0.888921 
vn 0.628711 0.0221792 -0.777322 
vn 0.735453 0.0220965 -0.677216 
vn 0.772893 0.0220726 -0.634152 
vn 0.884844 0.022027 -0.465367 
vn 0.772797 0.0220727 -0.634269 
vn 0.849995 0.0220358 -0.52633 
vn 0.960443 0.0220432 -0.277603 
vn 0.884844 0.022027 -0.465367 
vn 0.927401 0.0220273 -0.37342 
vn 0.996703 0.0221209 -0.0780577 
vn 0.960443 0.0220432 -0.277603 
vn 0.983631 0.0220744 -0.178835 
vn 0.999384 0.0221498 -0.0272182 
vn 0.996703 0.0221209 -0.0780577 
vn -0.995777 0.0250323 -0.0883311 
vn -0.99921 0.0250793 -0.0308181 
vn -0.989489 0.0251901 0.142401 
vn -0.951967 0.024808 -0.305194 
vn -0.949655 0.0247993 -0.312313 
vn -0.995777 0.0250323 -0.0883311 
vn -0.979507 0.0249264 -0.19986 
vn -0.949655 0.0247993 -0.312313 
vn -0.906857 0.0246559 -0.420716 
vn -0.855163 0.0245078 -0.51778 
vn -0.797057 0.0243589 -0.603413 
vn -0.718983 0.0241769 -0.694607 
vn 0.999384 0.0221498 -0.0272182 
vn 0.728908 -0.661902 -0.174869 
vn 0.681101 -0.661181 -0.314549 
vn 0.605801 -0.661857 -0.441532 
vn 0.505971 -0.663912 -0.550649 
vn 0.385467 -0.667286 -0.637295 
vn 0.742365 -0.662845 -0.0976242 
vn 0.73773 -0.662402 -0.130299 
vn 0.747204 -0.664 -0.0280987 
vn 0.385467 -0.667286 -0.637295 
vn 0.50454 0.0222955 -0.863101 
vn 0.0617197 -0.679211 -0.731343 
vn -0.0801496 -0.714766 0.694756 
vn -0.0792996 -0.71473 0.69489 
vn 0.0643744 -0.708426 0.702843 
vn -0.221333 -0.720385 0.65731 
vn -0.219709 -0.720324 0.657922 
vn -0.352981 -0.725002 0.59142 
vn -0.350765 -0.72493 0.592824 
vn -0.469089 -0.72837 0.499432 
vn -0.466567 -0.728306 0.501882 
vn -0.564234 -0.730302 0.385095 
vn -0.561768 -0.730267 0.388751 
vn -0.633946 -0.730689 0.253388 
vn -0.631948 -0.730703 0.258293 
vn -0.673924 -0.729588 0.116311 
vn -0.67439 -0.729555 0.113788 
vn -0.675018 -0.729509 0.110305 
vn -0.66367 -0.730112 0.162723 
vn -0.642589 -0.730604 0.230862 
vn -0.65262 -0.730433 0.201383 
vn -0.675029 -0.729508 0.110242 
vn -0.682344 -0.728724 0.0580309 
vn -0.685959 -0.72764 -0.000287747 
vn -0.685962 -0.726987 -0.0307641 
vn 0.0643744 -0.708426 0.702843 
vn 0.0634569 -0.997547 -0.0295514 
vn -0.27526 -0.695235 -0.663988 
vn 0.645058 -0.675919 0.356418 
vn 0.702377 -0.67111 0.237228 
vn 0.704053 -0.670949 0.232671 
vn 0.562899 -0.681669 0.46741 
vn 0.642952 -0.676078 0.359904 
vn 0.460018 -0.688024 0.561255 
vn 0.560695 -0.681813 0.469843 
vn 0.33973 -0.69477 0.633938 
vn 0.458026 -0.68814 0.562739 
vn 0.2062 -0.701663 0.68202 
vn 0.338221 -0.694851 0.634656 
vn 0.0643744 -0.708426 0.702843 
vn 0.205381 -0.701703 0.682225 
vn 0.7383 -0.666901 0.100781 
vn 0.747204 -0.664 -0.0280987 
vn 0.74725 -0.664543 -0.000262795 
vn 0.74429 -0.665719 0.053391 
vn 0.704053 -0.670949 0.232671 
vn 0.719676 -0.669337 0.184538 
vn 0.728822 -0.668253 0.149185 
vn 0.737386 -0.667049 0.106341 
vn 0.7383 -0.666901 0.100781 
vn 0.737787 -0.666985 0.10393 
vn 0.711294 -0.670229 0.211785 
vn 0.260795 0.0238676 0.965099 
vn 0.0638167 0.0241848 0.997669 
vn 0.444946 0.0235479 0.895248 
vn 0.444965 0.0235478 0.895238 
vn 0.261935 0.0238657 0.96479 
vn 0.260784 0.0238676 0.965102 
vn 0.60976 0.0232381 0.792245 
vn 0.609785 0.023238 0.792226 
vn 0.44705 0.0235441 0.894199 
vn 0.749904 0.0229489 0.661148 
vn 0.749932 0.0229489 0.661117 
vn 0.612515 0.0232326 0.790118 
vn 0.861289 0.0226893 0.507609 
vn 0.861314 0.0226892 0.507566 
vn 0.752928 0.0229423 0.657703 
vn 0.941015 0.0224662 0.337619 
vn 0.941035 0.0224662 0.337563 
vn 0.864153 0.0226821 0.502718 
vn 0.987299 0.0222851 0.157305 
vn 0.987309 0.022285 0.157239 
vn 0.943269 0.022459 0.33127 
vn 0.999384 0.0221498 -0.0272182 
vn 0.988496 0.0222784 0.149597 
vn -0.27526 -0.695235 -0.663988 
vn -0.407867 -0.702775 -0.582883 
vn -0.520907 -0.710103 -0.473718 
vn -0.608154 -0.716834 -0.341026 
vn -0.664407 -0.72258 -0.1909 
vn -0.680311 -0.725102 -0.106793 
vn -0.685962 -0.726987 -0.0307641 
vn -0.674838 -0.72409 -0.142433 
vn -0.408916 0.0235656 -0.912268 
vn -0.685962 -0.726987 -0.0307641 
vn -0.99921 0.0250793 -0.0308181 
vn -0.966063 0.0248644 -0.257108 
vn -0.883476 0.0245865 -0.467831 
vn -0.757488 0.0242645 -0.652398 
vn -0.596193 0.0239179 -0.802485 
vn -0.408916 0.0235656 -0.912268 
vn -0.99921 0.0250793 -0.0308181 
vn -0.661505 0.749354 -0.0296673 
vn -0.64099 0.745126 -0.184172 
vn -0.587042 0.739607 -0.329187 
vn -0.503145 0.73313 -0.457565 
vn -0.394231 0.726064 -0.563395 
vn -0.266244 0.718778 -0.64224 
vn -0.661505 0.749354 -0.0296673 
vn 0.718471 0.690829 0.0809583 
vn 0.724784 0.688437 -0.0272556 
vn 0.713534 0.691645 0.111785 
vn 0.683937 0.69507 0.221602 
vn 0.674478 0.695964 0.2464 
vn 0.62049 0.700388 0.352773 
vn 0.608672 0.701262 0.371148 
vn 0.530249 0.706596 0.46857 
vn 0.518204 0.707362 0.480732 
vn 0.416542 0.713459 0.563444 
vn 0.406225 0.714047 0.570191 
vn 0.283907 0.720694 0.632453 
vn 0.27694 0.721056 0.635124 
vn 0.138033 0.727971 0.671569 
vn 0.135552 0.728089 0.671946 
vn -0.0118647 0.73482 0.678158 
vn -0.0143938 0.734931 0.67799 
vn -0.158589 0.74091 0.652612 
vn -0.16596 0.741198 0.650448 
vn -0.297573 0.746028 0.595728 
vn -0.308869 0.746411 0.589467 
vn -0.421851 0.749881 0.509628 
vn -0.435442 0.750246 0.497516 
vn -0.525013 0.752235 0.398126 
vn -0.538678 0.752454 0.378998 
vn -0.601676 0.752944 0.266574 
vn -0.612816 0.752888 0.240035 
vn -0.647905 0.751963 0.121534 
vn -0.653808 0.751518 0.0880704 
vn -0.661505 0.749354 -0.0296673 
vn -0.0118647 0.73482 0.678158 
vn -0.930214 0.0252605 0.366148 
vn -0.930127 0.0252605 0.366367 
vn -0.981129 0.025213 0.191704 
vn -0.989522 0.02519 0.142167 
vn -0.820801 0.0252383 0.570657 
vn -0.820674 0.0252382 0.57084 
vn -0.91376 0.0252634 0.405468 
vn -0.667704 0.0251251 0.744002 
vn -0.667558 0.0251249 0.744134 
vn -0.800423 0.0252269 0.598905 
vn -0.480204 0.0249297 0.876802 
vn -0.480066 0.0249295 0.876878 
vn -0.647401 0.0251063 0.761736 
vn -0.269492 0.0246665 0.962687 
vn -0.269391 0.0246663 0.962715 
vn -0.463368 0.0249101 0.885816 
vn -0.0475935 0.0243537 0.99857 
vn -0.0475548 0.0243536 0.998572 
vn -0.258562 0.0246519 0.96568 
vn 0.170018 0.0240168 0.985148 
vn -0.0438689 0.0243482 0.998741 
vn 0.173639 0.0240109 0.984517 
vn 0.173602 0.024011 0.984523 
vn 0.383321 0.0236576 0.923312 
vn 0.373263 0.0236752 0.927423 
vn 0.383227 0.0236578 0.923351 
vn 0.572055 0.0233113 0.819884 
vn 0.557326 0.0233395 0.829966 
vn 0.571934 0.0233116 0.819968 
vn 0.732204 0.0229872 0.680697 
vn 0.715197 0.0230235 0.698543 
vn 0.732082 0.0229875 0.680829 
vn 0.857961 0.0226977 0.513213 
vn 0.841468 0.0227385 0.539828 
vn 0.857859 0.0226979 0.513384 
vn 0.945295 0.0224523 0.325444 
vn 0.932289 0.0224937 0.361015 
vn 0.945227 0.0224526 0.325642 
vn 0.991829 0.0222584 0.125622 
vn 0.985274 0.0222958 0.169524 
vn 0.991802 0.0222585 0.125829 
vn -0.995777 0.0250323 -0.0883311 
vn -0.99921 0.0250793 -0.0308181 
vn -0.989489 0.0251901 0.142401 
vn -0.979084 0.0249243 -0.201922 
vn -0.949655 0.0247993 -0.312313 
vn -0.995777 0.0250323 -0.0883311 
vn -0.908091 0.0246597 -0.418045 
vn -0.855128 0.0245077 -0.517837 
vn -0.855163 0.0245078 -0.51778 
vn -0.812308 0.0243966 -0.582718 
vn -0.718868 0.0241766 -0.694726 
vn -0.54966 0.0238263 -0.835049 
vn -0.718983 0.0241769 -0.694607 
vn -0.674379 0.0240796 -0.737993 
vn -0.356777 0.0234746 -0.933894 
vn -0.150245 0.0231382 -0.988378 
vn 0.0602438 0.0228308 -0.997923 
vn 0.265588 0.0225633 -0.963822 
vn 0.457515 0.0223441 -0.888921 
vn 0.628711 0.0221792 -0.777322 
vn 0.772893 0.0220726 -0.634152 
vn 0.837508 0.0220404 -0.54598 
vn 0.884844 0.022027 -0.465367 
vn 0.960443 0.0220432 -0.277603 
vn 0.926177 0.0220271 -0.376445 
vn 0.996703 0.0221209 -0.0780577 
vn 0.962349 0.0220448 -0.27092 
vn 0.983834 0.0220749 -0.177717 
vn 0.960448 0.0220432 -0.277585 
vn 0.999384 0.0221498 -0.0272182 
vn 0.996703 0.0221209 -0.0780577 
vn -0.54966 0.0238263 -0.835049 
vn 0.0621892 0.731514 0.678985 
vn 0.198527 0.72503 0.659484 
vn 0.32714 0.718408 0.613896 
vn 0.443296 0.711911 0.544676 
vn 0.542979 0.705773 0.455036 
vn 0.622966 0.700201 0.348757 
vn 0.680854 0.695368 0.230002 
vn 0.715058 0.691411 0.103168 
vn 0.724784 0.688437 -0.0272556 
vn 0.0621892 0.731514 0.678985 
vn 0.0638167 0.0241848 0.997669 
vn 0.0617197 -0.679211 -0.731343 
vn -0.0902067 -0.685963 -0.722024 
vn -0.238124 -0.693271 -0.6802 
vn -0.375041 -0.700822 -0.606789 
vn -0.494038 -0.708258 -0.504278 
vn -0.588654 -0.715195 -0.376805 
vn -0.653344 -0.72124 -0.230118 
vn -0.683953 -0.726026 -0.0713833 
vn -0.678152 -0.729243 0.0911816 
vn -0.635759 -0.730675 0.248844 
vn -0.558857 -0.730224 0.393003 
vn -0.451684 -0.72792 0.515862 
vn -0.320291 -0.723922 0.611025 
vn -0.172027 -0.718493 0.673925 
vn -0.014932 -0.711974 0.702047 
vn 0.142861 -0.70475 0.694923 
vn 0.293643 -0.697212 0.653964 
vn 0.430517 -0.689735 0.582169 
vn 0.547662 -0.682656 0.483784 
vn 0.640465 -0.676266 0.363963 
vn 0.705574 -0.670801 0.228453 
vn 0.740879 -0.66645 0.0833302 
vn 0.745464 -0.663348 -0.0652208 
vn 0.719544 -0.661588 -0.211085 
vn 0.664399 -0.661221 -0.348368 
vn 0.582307 -0.662256 -0.471525 
vn 0.476487 -0.664664 -0.575483 
vn 0.351044 -0.668376 -0.655775 
vn 0.2109 -0.673279 -0.708673 
vn 0.0634569 -0.997547 -0.0295514 
vn -0.159186 0.0245151 0.986944 
vn 0.0638167 0.0241848 0.997669 
vn -0.377005 0.0248055 0.925879 
vn -0.159186 0.0245151 0.986944 
vn -0.577588 0.0250368 0.815945 
vn -0.377005 0.0248055 0.925879 
vn -0.74919 0.0251926 0.661876 
vn -0.577588 0.0250368 0.815945 
vn -0.881445 0.025261 0.47161 
vn -0.74919 0.0251926 0.661876 
vn -0.966401 0.0252366 0.255798 
vn -0.881445 0.025261 0.47161 
vn -0.999322 0.0251214 0.0269058 
vn -0.966401 0.0252366 0.255798 
vn -0.979084 0.0249243 -0.201922 
vn -0.999322 0.0251214 0.0269058 
vn -0.908091 0.0246597 -0.418045 
vn -0.979084 0.0249243 -0.201922 
vn -0.791783 0.024346 -0.610317 
vn -0.908091 0.0246597 -0.418045 
vn -0.637881 0.0240028 -0.769761 
vn -0.791783 0.024346 -0.610317 
vn -0.455545 0.0236495 -0.889899 
vn -0.637881 0.0240028 -0.769761 
vn -0.254601 0.0233035 -0.966765 
vn -0.455545 0.0236495 -0.889899 
vn -0.0449092 0.0229801 -0.998727 
vn -0.254601 0.0233035 -0.966765 
vn 0.164098 0.0226915 -0.986183 
vn -0.0449092 0.0229801 -0.998727 
vn 0.36371 0.0224473 -0.931242 
vn 0.164098 0.0226915 -0.986183 
vn 0.546122 0.0222545 -0.83741 
vn 0.36371 0.0224473 -0.931242 
vn 0.70453 0.0221184 -0.709329 
vn 0.546122 0.0222545 -0.83741 
vn 0.833181 0.0220421 -0.552561 
vn 0.70453 0.0221184 -0.709329 
vn 0.927401 0.0220273 -0.37342 
vn 0.833181 0.0220421 -0.552561 
vn 0.983631 0.0220744 -0.178835 
vn 0.927401 0.0220273 -0.37342 
vn 0.999472 0.0221823 0.023758 
vn 0.983631 0.0220744 -0.178835 
vn 0.973749 0.0223486 0.226524 
vn 0.999472 0.0221823 0.023758 
vn 0.906617 0.022569 0.421351 
vn 0.973749 0.0223486 0.226524 
vn 0.799674 0.0228375 0.6 
vn 0.906617 0.022569 0.421351 
vn 0.656108 0.0231457 0.754312 
vn 0.799674 0.0228375 0.6 
vn 0.480827 0.0234826 0.876501 
vn 0.656108 0.0231457 0.754312 
vn 0.28055 0.0238344 0.959543 
vn 0.480827 0.0234826 0.876501 
vn 0.0605514 0.997767 -0.0281983 
vn -0.99921 0.0250793 -0.0308181 
vn -0.688936 0.0251439 0.724386 
vn 0.0621892 0.731514 0.678985 
vn 0.0617803 0.840033 0.539006 
vn 0.0613848 0.92166 0.383111 
vn 0.0625872 0.603045 0.795248 
vn 0.0625985 0.599049 0.798262 
vn 0.0625986 0.59902 0.798284 
vn 0.0629951 0.446371 0.892628 
vn 0.0613848 0.92166 0.383111 
vn 0.0605514 0.997767 -0.0281983 
vn 0.059989 0.900704 -0.430273 
vn 0.0598558 0.813864 -0.577964 
vn 0.0597859 0.703245 -0.708429 
vn 0.059781 0.572058 -0.818032 
vn 0.0598411 0.424022 -0.903673 
vn 0.0602438 0.0228308 -0.997923 
vn 0.0606983 0.99665 0.0548201 
vn 0.0611039 0.963998 0.258794 
vn 0.0603538 0.986801 -0.150271 
vn 0.0606983 0.99665 0.0548201 
vn 0.0600824 0.935549 -0.34805 
vn 0.0603538 0.986801 -0.150271 
vn 0.0602083 0.966221 -0.250583 
vn 0.0598931 0.845501 -0.530604 
vn 0.059989 0.900704 -0.430273 
vn 0.0600824 0.935549 -0.34805 
vn 0.0598931 0.845501 -0.530604 
vn 0.059792 0.720619 -0.690749 
vn 0.0597807 0.683205 -0.727775 
vn 0.0629951 0.446371 0.892628 
vn 0.0625224 0.625523 0.777697 
vn 0.0620351 0.775192 0.628673 
vn 0.0615555 0.889403 0.452961 
vn 0.0613848 0.92166 0.383111 
vn 0.0629951 0.446371 0.892628 
vn 0.0597802 0.575999 -0.815262 
vn -0.266244 0.718778 -0.64224 
vn -0.99921 0.0250793 -0.0308181 
vn 0.0605514 0.997767 -0.0281983 
vn 0.999384 0.0221498 -0.0272182 
vn -0.99921 0.0250793 -0.0308181 
vn 0.0599969 0.230376 -0.97125 
vn 0.0602438 0.0228308 -0.997923 
vn 0.0598393 0.42718 -0.902184 
vn 0.0599969 0.230376 -0.97125 
vn 0.0597762 0.605037 -0.79395 
vn 0.0598393 0.42718 -0.902184 
vn 0.0598098 0.756538 -0.651209 
vn 0.0597762 0.605037 -0.79395 
vn 0.0599389 0.875269 -0.479908 
vn 0.0598098 0.756538 -0.651209 
vn 0.0601593 0.956004 -0.287119 
vn 0.0599389 0.875269 -0.479908 
vn 0.0604634 0.99489 -0.0808564 
vn 0.0601593 0.956004 -0.287119 
vn 0.0608405 0.989629 0.130128 
vn 0.0604634 0.99489 -0.0808564 
vn 0.0612765 0.939651 0.336603 
vn 0.0608405 0.989629 0.130128 
vn 0.0617537 0.846272 0.529161 
vn 0.0612765 0.939651 0.336603 
vn 0.0622518 0.712801 0.698599 
vn 0.0617537 0.846272 0.529161 
vn 0.0627477 0.544581 0.836358 
vn 0.0622518 0.712801 0.698599 
vn 0.0632169 0.348921 0.935018 
vn 0.0627477 0.544581 0.836358 
vn 0.0636346 0.134879 0.988817 
vn 0.0632169 0.348921 0.935018 
vn 0.0639773 -0.087114 0.994142 
vn 0.0638167 0.0241848 0.997669 
vn 0.0636346 0.134879 0.988817 
vn 0.0642249 -0.305805 0.949925 
vn 0.0639773 -0.087114 0.994142 
vn 0.0643622 -0.50981 0.857876 
vn 0.0642249 -0.305805 0.949925 
vn 0.0643806 -0.688379 0.722488 
vn 0.0643622 -0.50981 0.857876 
vn 0.064279 -0.832159 0.5508 
vn 0.0643806 -0.688379 0.722488 
vn 0.0640638 -0.933837 0.351914 
vn 0.064279 -0.832159 0.5508 
vn 0.0637483 -0.988608 0.136348 
vn 0.0640638 -0.933837 0.351914 
vn 0.0633511 -0.994389 -0.084718 
vn 0.0637483 -0.988608 0.136348 
vn 0.0628951 -0.951808 -0.300176 
vn 0.0633511 -0.994389 -0.084718 
vn 0.0624047 -0.863976 -0.499651 
vn 0.0628951 -0.951808 -0.300176 
vn 0.0619047 -0.736116 -0.674018 
vn 0.0624047 -0.863976 -0.499651 
vn 0.0614188 -0.575111 -0.815767 
vn 0.0619047 -0.736116 -0.674018 
vn 0.0609683 -0.389029 -0.919206 
vn 0.0614188 -0.575111 -0.815767 
vn 0.0605715 -0.186672 -0.980553 
vn 0.0609683 -0.389029 -0.919206 
vn 0.0599969 0.230376 -0.97125 
vn 0.0602438 0.0228308 -0.997923 
vn 0.0598393 0.42718 -0.902184 
vn 0.0599969 0.230376 -0.97125 
vn 0.0597762 0.605037 -0.79395 
vn 0.0598393 0.42718 -0.902184 
vn 0.0598098 0.756538 -0.651209 
vn 0.0597762 0.605037 -0.79395 
vn 0.0599389 0.875269 -0.479908 
vn 0.0598098 0.756538 -0.651209 
vn 0.0601593 0.956004 -0.287119 
vn 0.0599389 0.875269 -0.479908 
vn 0.0604634 0.99489 -0.0808564 
vn 0.0601593 0.956004 -0.287119 
vn 0.0608405 0.989629 0.130128 
vn 0.0604634 0.99489 -0.0808564 
vn 0.0612765 0.939651 0.336603 
vn 0.0608405 0.989629 0.130128 
vn 0.0617537 0.846272 0.529161 
vn 0.0612765 0.939651 0.336603 
vn 0.0622518 0.712801 0.698599 
vn 0.0617537 0.846272 0.529161 
vn 0.0627477 0.544581 0.836358 
vn 0.0622518 0.712801 0.698599 
vn 0.0632169 0.348921 0.935018 
vn 0.0627477 0.544581 0.836358 
vn 0.0636346 0.134879 0.988817 
vn 0.0632169 0.348921 0.935018 
vn 0.0639773 -0.087114 0.994142 
vn 0.0638167 0.0241848 0.997669 
vn 0.0636346 0.134879 0.988817 
vn 0.0642249 -0.305805 0.949925 
vn 0.0639773 -0.087114 0.994142 
vn 0.0643622 -0.50981 0.857876 
vn 0.0642249 -0.305805 0.949925 
vn 0.0643806 -0.688379 0.722488 
vn 0.0643622 -0.50981 0.857876 
vn 0.064279 -0.832159 0.5508 
vn 0.0643806 -0.688379 0.722488 
vn 0.0640638 -0.933837 0.351914 
vn 0.064279 -0.832159 0.5508 
vn 0.0637483 -0.988608 0.136348 
vn 0.0640638 -0.933837 0.351914 
vn 0.0633511 -0.994389 -0.084718 
vn 0.0637483 -0.988608 0.136348 
vn 0.0628951 -0.951808 -0.300176 
vn 0.0633511 -0.994389 -0.084718 
vn 0.0624047 -0.863976 -0.499651 
vn 0.0628951 -0.951808 -0.300176 
vn 0.0619047 -0.736116 -0.674018 
vn 0.0624047 -0.863976 -0.499651 
vn 0.0614188 -0.575111 -0.815767 
vn 0.0619047 -0.736116 -0.674018 
vn 0.0609683 -0.389029 -0.919206 
vn 0.0614188 -0.575111 -0.815767 
vn 0.0605715 -0.186672 -0.980553 
vn 0.0609683 -0.389029 -0.919206 
vn 0.0599969 0.230376 -0.97125 
vn 0.0602438 0.0228308 -0.997923 
vn 0.0598393 0.42718 -0.902184 
vn 0.0599969 0.230376 -0.97125 
vn 0.0597762 0.605037 -0.79395 
vn 0.0598393 0.42718 -0.902184 
vn 0.0598098 0.756538 -0.651209 
vn 0.0597762 0.605037 -0.79395 
vn 0.0599389 0.875269 -0.479908 
vn 0.0598098 0.756538 -0.651209 
vn 0.0601593 0.956004 -0.287119 
vn 0.0599389 0.875269 -0.479908 
vn 0.0604634 0.99489 -0.0808564 
vn 0.0601593 0.956004 -0.287119 
vn 0.0608405 0.989629 0.130128 
vn 0.0604634 0.99489 -0.0808564 
vn 0.0612765 0.939651 0.336603 
vn 0.0608405 0.989629 0.130128 
vn 0.0617537 0.846272 0.529161 
vn 0.0612765 0.939651 0.336603 
vn 0.0622518 0.712801 0.698599 
vn 0.0617537 0.846272 0.529161 
vn 0.0627477 0.544581 0.836358 
vn 0.0622518 0.712801 0.698599 
vn 0.0632169 0.348921 0.935018 
vn 0.0627477 0.544581 0.836358 
vn 0.0636346 0.134879 0.988817 
vn 0.0632169 0.348921 0.935018 
vn 0.0639773 -0.087114 0.994142 
vn 0.0638167 0.0241848 0.997669 
vn 0.0636346 0.134879 0.988817 
vn 0.0642249 -0.305805 0.949925 
vn 0.0639773 -0.087114 0.994142 
vn 0.0643622 -0.50981 0.857876 
vn 0.0642249 -0.305805 0.949925 
vn 0.0643806 -0.688379 0.722488 
vn 0.0643622 -0.50981 0.857876 
vn 0.064279 -0.832159 0.5508 
vn 0.0643806 -0.688379 0.722488 
vn 0.0640638 -0.933837 0.351914 
vn 0.064279 -0.832159 0.5508 
vn 0.0637483 -0.988608 0.136348 
vn 0.0640638 -0.933837 0.351914 
vn 0.0633511 -0.994389 -0.084718 
vn 0.0637483 -0.988608 0.136348 
vn 0.0628951 -0.951808 -0.300176 
vn 0.0633511 -0.994389 -0.084718 
vn 0.0624047 -0.863976 -0.499651 
vn 0.0628951 -0.951808 -0.300176 
vn 0.0619047 -0.736116 -0.674018 
vn 0.0624047 -0.863976 -0.499651 
vn 0.0614188 -0.575111 -0.815767 
vn 0.0619047 -0.736116 -0.674018 
vn 0.0609683 -0.389029 -0.919206 
vn 0.0614188 -0.575111 -0.815767 
vn 0.0605715 -0.186672 -0.980553 
vn 0.0609683 -0.389029 -0.919206 
usemtl 0.615686_0.811765_0.929412_0.000000_0.000000
o mesh293
f 6551//6920 6552//6921 6553//6921 
f 6554//6922 6551//6920 6555//6923 
f 6556//6924 6554//6922 6557//6925 
f 6558//6926 6556//6924 6559//6927 
f 6560//6928 6558//6926 6561//6929 
f 6562//6930 6560//6928 6563//6931 
f 6564//6932 6562//6930 6565//6933 
f 6566//6934 6564//6932 6567//6935 
f 6568//6936 6566//6934 6569//6937 
f 6570//6938 6568//6936 6571//6939 
f 6572//6940 6570//6938 6573//6941 
f 6574//6942 6572//6940 6575//6943 
f 6576//6944 6574//6942 6577//6945 
f 6578//6946 6576//6944 6579//6947 
f 6580//6948 6578//6946 6581//6949 
f 6582//6950 6580//6948 6583//6951 
f 6584//6952 6582//6950 6585//6953 
f 6586//6954 6584//6952 6587//6955 
f 6588//6956 6586//6954 6589//6957 
f 6590//6958 6588//6956 6591//6959 
f 6592//6960 6590//6958 6593//6961 
f 6594//6962 6592//6960 6595//6963 
f 6596//6964 6594//6962 6597//6965 
f 6598//6966 6596//6964 6599//6967 
f 6600//6968 6598//6966 6601//6969 
f 6602//6970 6600//6968 6603//6971 
f 6604//6972 6602//6970 6605//6973 
f 6606//6974 6604//6972 6607//6975 
f 6552//6921 6606//6974 6608//6974 
f 6608//6974 6553//6921 6552//6921 
f 6607//6975 6608//6974 6606//6974 
f 6605//6973 6607//6975 6604//6972 
f 6603//6971 6605//6973 6602//6970 
f 6601//6969 6603//6971 6600//6968 
f 6599//6967 6601//6969 6598//6966 
f 6597//6965 6599//6967 6596//6964 
f 6595//6963 6597//6965 6594//6962 
f 6593//6961 6595//6963 6592//6960 
f 6591//6959 6593//6961 6590//6958 
f 6589//6957 6591//6959 6588//6956 
f 6587//6955 6589//6957 6586//6954 
f 6585//6953 6587//6955 6584//6952 
f 6583//6951 6585//6953 6582//6950 
f 6581//6949 6583//6951 6580//6948 
f 6579//6947 6581//6949 6578//6946 
f 6577//6945 6579//6947 6576//6944 
f 6575//6943 6577//6945 6574//6942 
f 6573//6941 6575//6943 6572//6940 
f 6571//6939 6573//6941 6570//6938 
f 6569//6937 6571//6939 6568//6936 
f 6567//6935 6569//6937 6566//6934 
f 6565//6933 6567//6935 6564//6932 
f 6563//6931 6565//6933 6562//6930 
f 6561//6929 6563//6931 6560//6928 
f 6559//6927 6561//6929 6558//6926 
f 6557//6925 6559//6927 6556//6924 
f 6555//6923 6557//6925 6554//6922 
f 6553//6921 6555//6923 6551//6920 
o mesh294
f 6609//6976 6561//6976 6559//6976 
f 6610//6976 6563//6976 6561//6976 
f 6611//6976 6559//6976 6557//6976 
f 6561//6976 6609//6976 6610//6976 
f 6612//6976 6565//6976 6563//6976 
f 6612//6976 6613//6976 6567//6976 
f 6614//6976 6608//6976 6607//6976 
f 6614//6976 6615//6976 6553//6976 
f 6616//6976 6555//6976 6553//6976 
f 6617//6976 6557//6976 6555//6976 
f 6559//6976 6611//6976 6609//6976 
f 6567//6976 6565//6976 6612//6976 
f 6618//6976 6571//6976 6569//6976 
f 6619//6976 6573//6976 6571//6976 
f 6620//6976 6621//6976 6593//6976 
f 6621//6976 6622//6976 6595//6976 
f 6623//6976 6599//6976 6597//6976 
f 6623//6976 6624//6976 6601//6976 
f 6625//6976 6603//6976 6601//6976 
f 6625//6976 6626//6976 6605//6976 
f 6627//6976 6607//6976 6605//6976 
f 6553//6976 6608//6976 6614//6976 
f 6555//6976 6616//6976 6617//6976 
f 6563//6976 6610//6976 6612//6976 
f 6628//6976 6569//6976 6567//6976 
f 6571//6976 6618//6976 6619//6976 
f 6629//6976 6575//6976 6573//6976 
f 6629//6976 6630//6976 6577//6976 
f 6631//6976 6579//6976 6577//6976 
f 6632//6976 6581//6976 6579//6976 
f 6633//6976 6589//6976 6587//6976 
f 6633//6976 6620//6976 6591//6976 
f 6595//6976 6593//6976 6621//6976 
f 6622//6976 6634//6976 6597//6976 
f 6601//6976 6599//6976 6623//6976 
f 6605//6976 6603//6976 6625//6976 
f 6607//6976 6627//6976 6614//6976 
f 6557//6976 6617//6976 6611//6976 
f 6569//6976 6628//6976 6618//6976 
f 6577//6976 6575//6976 6629//6976 
f 6579//6976 6631//6976 6632//6976 
f 6635//6976 6583//6976 6581//6976 
f 6636//6976 6585//6976 6583//6976 
f 6636//6976 6637//6976 6587//6976 
f 6591//6976 6589//6976 6633//6976 
f 6597//6976 6595//6976 6622//6976 
f 6601//6976 6624//6976 6625//6976 
f 6553//6976 6615//6976 6616//6976 
f 6573//6976 6619//6976 6629//6976 
f 6581//6976 6632//6976 6635//6976 
f 6587//6976 6585//6976 6636//6976 
f 6593//6976 6591//6976 6620//6976 
f 6605//6976 6626//6976 6627//6976 
f 6577//6976 6630//6976 6631//6976 
f 6587//6976 6637//6976 6633//6976 
f 6567//6976 6613//6976 6628//6976 
f 6597//6976 6634//6976 6623//6976 
f 6583//6976 6635//6976 6636//6976 
o mesh295
f 6638//6977 6615//6977 6614//6978 
f 6639//6978 6614//6978 6627//6979 
f 6640//6979 6627//6979 6626//6980 
f 6641//6980 6626//6980 6625//6981 
f 6642//6981 6625//6981 6624//6982 
f 6643//6982 6624//6982 6623//6983 
f 6644//6983 6623//6983 6634//6984 
f 6645//6984 6634//6984 6622//6985 
f 6646//6985 6622//6985 6621//6986 
f 6647//6986 6621//6986 6620//6987 
f 6648//6987 6620//6987 6633//6988 
f 6649//6988 6633//6988 6637//6989 
f 6650//6989 6637//6989 6636//6990 
f 6651//6990 6636//6990 6635//6991 
f 6652//6991 6635//6991 6632//6992 
f 6653//6992 6632//6992 6631//6993 
f 6654//6993 6631//6993 6630//6994 
f 6655//6994 6630//6994 6629//6995 
f 6656//6995 6629//6995 6619//6996 
f 6657//6996 6619//6996 6618//6997 
f 6658//6997 6618//6997 6628//6998 
f 6659//6998 6628//6998 6613//6999 
f 6660//6999 6613//6999 6612//7000 
f 6661//7000 6612//7000 6610//7001 
f 6662//7001 6610//7001 6609//7002 
f 6663//7002 6609//7002 6611//7003 
f 6664//7003 6611//7003 6617//7004 
f 6665//7004 6617//7004 6616//7005 
f 6666//7005 6616//7005 6615//6977 
f 6615//6977 6638//6977 6666//7005 
f 6616//7005 6666//7005 6665//7004 
f 6617//7004 6665//7004 6664//7003 
f 6611//7003 6664//7003 6663//7002 
f 6609//7002 6663//7002 6662//7001 
f 6610//7001 6662//7001 6661//7000 
f 6612//7000 6661//7000 6660//6999 
f 6613//6999 6660//6999 6659//6998 
f 6628//6998 6659//6998 6658//6997 
f 6618//6997 6658//6997 6657//6996 
f 6619//6996 6657//6996 6656//6995 
f 6629//6995 6656//6995 6655//6994 
f 6630//6994 6655//6994 6654//6993 
f 6631//6993 6654//6993 6653//6992 
f 6632//6992 6653//6992 6652//6991 
f 6635//6991 6652//6991 6651//6990 
f 6636//6990 6651//6990 6650//6989 
f 6637//6989 6650//6989 6649//6988 
f 6633//6988 6649//6988 6648//6987 
f 6620//6987 6648//6987 6647//6986 
f 6621//6986 6647//6986 6646//6985 
f 6622//6985 6646//6985 6645//6984 
f 6634//6984 6645//6984 6644//6983 
f 6623//6983 6644//6983 6643//6982 
f 6624//6982 6643//6982 6642//6981 
f 6625//6981 6642//6981 6641//6980 
f 6626//6980 6641//6980 6640//6979 
f 6627//6979 6640//6979 6639//6978 
f 6614//6978 6639//6978 6638//6977 
o mesh296
f 6667//7006 6668//7006 6669//7006 
f 6669//7006 6602//7006 6667//7006 
f 6669//7006 6600//7006 6602//7006 
f 6667//7006 6670//7006 6671//7006 
f 6672//7006 6673//7006 6590//7006 
f 6673//7006 6674//7006 6588//7006 
f 6675//7006 6676//7006 6582//7006 
f 6676//7006 6677//7006 6580//7006 
f 6667//7006 6678//7006 6668//7006 
f 6671//7006 6679//7006 6667//7006 
f 6598//7006 6680//7006 6681//7006 
f 6598//7006 6669//7006 6682//7006 
f 6683//7006 6672//7006 6592//7006 
f 6588//7006 6590//7006 6673//7006 
f 6674//7006 6684//7006 6586//7006 
f 6684//7006 6675//7006 6584//7006 
f 6580//7006 6582//7006 6676//7006 
f 6685//7006 6578//7006 6580//7006 
f 6686//7006 6576//7006 6578//7006 
f 6687//7006 6574//7006 6576//7006 
f 6688//7006 6568//7006 6570//7006 
f 6689//7006 6566//7006 6568//7006 
f 6556//7006 6558//7006 6690//7006 
f 6667//7006 6604//7006 6606//7006 
f 6679//7006 6678//7006 6667//7006 
f 6682//7006 6680//7006 6598//7006 
f 6683//7006 6594//7006 6596//7006 
f 6590//7006 6592//7006 6672//7006 
f 6584//7006 6586//7006 6684//7006 
f 6580//7006 6677//7006 6685//7006 
f 6576//7006 6686//7006 6687//7006 
f 6691//7006 6572//7006 6574//7006 
f 6692//7006 6570//7006 6572//7006 
f 6568//7006 6688//7006 6689//7006 
f 6693//7006 6564//7006 6566//7006 
f 6690//7006 6560//7006 6562//7006 
f 6690//7006 6694//7006 6556//7006 
f 6606//7006 6695//7006 6667//7006 
f 6669//7006 6598//7006 6600//7006 
f 6596//7006 6681//7006 6683//7006 
f 6586//7006 6588//7006 6674//7006 
f 6578//7006 6685//7006 6686//7006 
f 6572//7006 6691//7006 6692//7006 
f 6566//7006 6689//7006 6693//7006 
f 6562//7006 6693//7006 6690//7006 
f 6694//7006 6696//7006 6556//7006 
f 6667//7006 6602//7006 6604//7006 
f 6681//7006 6596//7006 6598//7006 
f 6582//7006 6584//7006 6675//7006 
f 6570//7006 6692//7006 6688//7006 
f 6558//7006 6560//7006 6690//7006 
f 6554//7006 6556//7006 6696//7006 
f 6551//7006 6554//7006 6697//7006 
f 6552//7006 6551//7006 6698//7006 
f 6574//7006 6687//7006 6691//7006 
f 6696//7006 6697//7006 6554//7006 
f 6698//7006 6695//7006 6552//7006 
f 6592//7006 6594//7006 6683//7006 
f 6697//7006 6698//7006 6551//7006 
f 6562//7006 6564//7006 6693//7006 
f 6606//7006 6552//7006 6695//7006 
o mesh297
f 6699//7007 6700//7008 6693//7008 
f 6689//7009 6701//7009 6699//7007 
f 6702//7010 6701//7009 6689//7009 
f 6688//7011 6703//7011 6702//7010 
f 6704//7012 6703//7011 6688//7011 
f 6692//7013 6705//7013 6704//7012 
f 6706//7014 6705//7013 6692//7013 
f 6691//7015 6707//7015 6706//7014 
f 6708//7016 6707//7015 6691//7015 
f 6687//7017 6709//7017 6708//7016 
f 6710//7018 6709//7017 6687//7017 
f 6686//7019 6711//7019 6710//7018 
f 6712//7020 6711//7019 6686//7019 
f 6685//7021 6713//7021 6712//7020 
f 6713//7021 6685//7021 6677//7022 
f 6714//7023 6677//7022 6676//7024 
f 6676//7024 6715//7024 6714//7023 
f 6716//7025 6676//7024 6675//7026 
f 6675//7026 6717//7026 6716//7025 
f 6718//7027 6675//7026 6684//7028 
f 6684//7028 6719//7028 6718//7027 
f 6720//7029 6684//7028 6674//7030 
f 6674//7030 6721//7030 6720//7029 
f 6722//7031 6674//7030 6673//7032 
f 6673//7032 6723//7032 6722//7031 
f 6724//7033 6673//7032 6672//7034 
f 6672//7034 6725//7034 6724//7033 
f 6726//7035 6672//7034 6683//7036 
f 6683//7036 6727//7036 6726//7035 
f 6726//7035 6725//7034 6672//7034 
f 6724//7033 6723//7032 6673//7032 
f 6722//7031 6721//7030 6674//7030 
f 6720//7029 6719//7028 6684//7028 
f 6718//7027 6717//7026 6675//7026 
f 6716//7025 6715//7024 6676//7024 
f 6714//7023 6728//7037 6677//7022 
f 6677//7022 6728//7037 6713//7021 
f 6686//7019 6685//7021 6712//7020 
f 6687//7017 6686//7019 6710//7018 
f 6691//7015 6687//7017 6708//7016 
f 6692//7013 6691//7015 6706//7014 
f 6688//7011 6692//7013 6704//7012 
f 6689//7009 6688//7011 6702//7010 
f 6693//7008 6689//7009 6699//7007 
o mesh298
f 6670//7038 6729//7038 6730//7038 
f 6730//7038 6671//7038 6670//7038 
o mesh299
f 6683//7039 6681//7040 6731//7040 
f 6681//7040 6680//7041 6732//7041 
f 6680//7041 6682//7042 6733//7042 
f 6682//7042 6669//7043 6734//7043 
f 6669//7043 6668//7044 6735//7044 
f 6668//7044 6678//7045 6736//7045 
f 6678//7045 6679//7046 6737//7046 
f 6679//7046 6671//7047 6730//7047 
f 6730//7047 6737//7046 6679//7046 
f 6737//7046 6736//7045 6678//7045 
f 6736//7045 6735//7044 6668//7044 
f 6735//7044 6734//7043 6669//7043 
f 6734//7043 6733//7042 6682//7042 
f 6733//7042 6732//7041 6680//7041 
f 6732//7041 6731//7040 6681//7040 
f 6731//7040 6727//7048 6683//7039 
o mesh300
f 6727//7049 6731//7050 6738//7051 
f 6731//7050 6739//7052 6738//7051 
f 6731//7050 6732//7053 6740//7054 
f 6732//7053 6741//7055 6740//7054 
f 6732//7053 6733//7056 6742//7057 
f 6733//7056 6743//7058 6742//7057 
f 6733//7056 6734//7059 6744//7060 
f 6734//7059 6745//7061 6744//7060 
f 6734//7059 6735//7062 6746//7063 
f 6735//7062 6747//7064 6746//7063 
f 6735//7062 6736//7065 6748//7066 
f 6736//7065 6749//7067 6748//7066 
f 6736//7065 6737//7068 6750//7069 
f 6737//7068 6751//7070 6750//7069 
f 6752//7071 6751//7070 6737//7068 
f 6737//7068 6730//7071 6752//7071 
f 6750//7069 6749//7067 6736//7065 
f 6748//7066 6747//7064 6735//7062 
f 6746//7063 6745//7061 6734//7059 
f 6744//7060 6743//7058 6733//7056 
f 6742//7057 6741//7055 6732//7053 
f 6740//7054 6739//7052 6731//7050 
f 6738//7051 6753//7072 6727//7049 
o mesh301
f 6700//7073 6754//7073 6690//7073 
f 6690//7073 6693//7073 6700//7073 
o mesh302
f 6755//7074 6695//7074 6698//7075 
f 6756//7075 6698//7075 6697//7076 
f 6757//7076 6697//7076 6696//7077 
f 6758//7077 6696//7077 6694//7078 
f 6759//7078 6694//7078 6690//7079 
f 6690//7079 6754//7079 6759//7078 
f 6694//7078 6759//7078 6758//7077 
f 6696//7077 6758//7077 6757//7076 
f 6697//7076 6757//7076 6756//7075 
f 6698//7075 6756//7075 6755//7074 
o mesh303
f 6754//7080 6700//7080 6760//7080 
f 6760//7080 6761//7080 6754//7080 
o mesh304
f 6755//7081 6762//7081 6667//7081 
f 6667//7081 6695//7081 6755//7081 
o mesh305
f 6763//7082 6755//7082 6756//7083 
f 6764//7083 6756//7083 6757//7084 
f 6765//7084 6757//7084 6758//7085 
f 6766//7085 6758//7085 6759//7086 
f 6767//7086 6759//7086 6754//7087 
f 6754//7087 6761//7087 6767//7086 
f 6759//7086 6767//7086 6766//7085 
f 6758//7085 6766//7085 6765//7084 
f 6757//7084 6765//7084 6764//7083 
f 6756//7083 6764//7083 6763//7082 
o mesh306
f 6761//7088 6768//7088 6769//7088 
f 6761//7088 6770//7088 6768//7088 
f 6761//7088 6771//7088 6770//7088 
f 6761//7088 6760//7088 6772//7088 
f 6772//7088 6771//7088 6761//7088 
f 6769//7088 6773//7088 6761//7088 
o mesh307
f 6647//7089 6724//7090 6725//7091 
f 6725//7091 6646//7092 6647//7089 
f 6648//7093 6722//7094 6723//7095 
f 6723//7095 6647//7089 6648//7093 
f 6649//7096 6720//7097 6721//7098 
f 6721//7098 6648//7093 6649//7096 
f 6650//7099 6718//7100 6719//7101 
f 6719//7101 6649//7096 6650//7099 
f 6651//7102 6716//7103 6717//7104 
f 6717//7104 6650//7099 6651//7102 
f 6652//7105 6714//7106 6715//7107 
f 6715//7107 6651//7102 6652//7105 
f 6652//7105 6713//7108 6728//7109 
f 6653//7110 6712//7111 6713//7108 
f 6713//7108 6652//7105 6653//7110 
f 6728//7109 6714//7106 6652//7105 
f 6653//7110 6654//7112 6711//7113 
f 6654//7112 6710//7114 6711//7113 
f 6654//7112 6655//7115 6709//7116 
f 6655//7115 6708//7117 6709//7116 
f 6655//7115 6656//7118 6707//7119 
f 6656//7118 6706//7120 6707//7119 
f 6656//7118 6657//7121 6705//7122 
f 6657//7121 6704//7123 6705//7122 
f 6657//7121 6658//7124 6703//7125 
f 6658//7124 6702//7126 6703//7125 
f 6658//7124 6659//7127 6701//7128 
f 6659//7127 6699//7129 6701//7128 
f 6774//7130 6641//7130 6642//7131 
f 6775//7132 6640//7132 6641//7130 
f 6776//7133 6639//7133 6640//7132 
f 6777//7134 6638//7134 6639//7133 
f 6778//7135 6666//7135 6638//7134 
f 6779//7136 6665//7136 6666//7135 
f 6780//7137 6664//7137 6665//7136 
f 6664//7137 6780//7137 6781//7138 
f 6781//7138 6663//7139 6664//7137 
f 6662//7140 6663//7139 6782//7141 
f 6782//7141 6773//7142 6662//7140 
f 6661//7143 6662//7140 6769//7144 
f 6769//7144 6768//7145 6661//7143 
f 6660//7146 6661//7143 6770//7147 
f 6770//7147 6771//7148 6660//7146 
f 6699//7129 6659//7127 6760//7149 
f 6660//7146 6772//7150 6760//7149 
f 6760//7149 6659//7127 6660//7146 
f 6645//7151 6646//7092 6753//7152 
f 6726//7153 6727//7152 6753//7152 
f 6753//7152 6646//7092 6726//7153 
f 6645//7151 6783//7154 6784//7155 
f 6645//7151 6785//7156 6786//7157 
f 6786//7157 6783//7154 6645//7151 
f 6644//7158 6787//7159 6788//7160 
f 6644//7158 6784//7155 6787//7159 
f 6642//7131 6643//7160 6789//7161 
f 6643//7160 6788//7160 6789//7161 
f 6789//7161 6790//7162 6642//7131 
f 6788//7160 6643//7160 6644//7158 
f 6784//7155 6644//7158 6645//7151 
f 6753//7152 6785//7156 6645//7151 
f 6760//7149 6700//7163 6699//7129 
f 6771//7148 6772//7150 6660//7146 
f 6768//7145 6770//7147 6661//7143 
f 6773//7142 6769//7144 6662//7140 
f 6781//7138 6782//7141 6663//7139 
f 6665//7136 6779//7136 6780//7137 
f 6666//7135 6778//7135 6779//7136 
f 6638//7134 6777//7134 6778//7135 
f 6639//7133 6776//7133 6777//7134 
f 6640//7132 6775//7132 6776//7133 
f 6641//7130 6774//7130 6775//7132 
f 6642//7131 6790//7162 6774//7130 
f 6701//7128 6702//7126 6658//7124 
f 6703//7125 6704//7123 6657//7121 
f 6705//7122 6706//7120 6656//7118 
f 6707//7119 6708//7117 6655//7115 
f 6709//7116 6710//7114 6654//7112 
f 6711//7113 6712//7111 6653//7110 
f 6715//7107 6716//7103 6651//7102 
f 6717//7104 6718//7100 6650//7099 
f 6719//7101 6720//7097 6649//7096 
f 6721//7098 6722//7094 6648//7093 
f 6723//7095 6724//7090 6647//7089 
f 6725//7091 6726//7153 6646//7092 
o mesh308
f 6767//7164 6791//7164 6792//7165 
f 6766//7165 6792//7165 6793//7166 
f 6765//7166 6793//7166 6794//7167 
f 6764//7167 6794//7167 6795//7168 
f 6767//7164 6782//7169 6781//7170 
f 6767//7164 6761//7171 6773//7171 
f 6773//7171 6782//7169 6767//7164 
f 6781//7170 6791//7164 6767//7164 
f 6795//7168 6763//7172 6764//7167 
f 6794//7167 6764//7167 6765//7166 
f 6793//7166 6765//7166 6766//7165 
f 6792//7165 6766//7165 6767//7164 
o mesh309
f 6796//7173 6762//7173 6755//7173 
f 6755//7173 6763//7173 6796//7173 
o mesh310
f 6763//7172 6795//7172 6797//7172 
f 6797//7172 6796//7172 6763//7172 
o mesh311
f 6798//7174 6796//7174 6797//7174 
f 6797//7174 6799//7174 6798//7174 
o mesh312
f 6800//7175 6750//7175 6751//7176 
f 6751//7176 6801//7177 6800//7175 
f 6751//7176 6752//7177 6801//7177 
f 6800//7175 6802//7178 6749//7179 
f 6802//7178 6748//7178 6749//7179 
f 6802//7178 6803//7180 6747//7181 
f 6803//7180 6746//7180 6747//7181 
f 6803//7180 6804//7182 6745//7183 
f 6804//7182 6744//7182 6745//7183 
f 6804//7182 6805//7184 6743//7185 
f 6805//7184 6742//7184 6743//7185 
f 6805//7184 6806//7186 6741//7187 
f 6806//7186 6740//7186 6741//7187 
f 6739//7188 6784//7189 6783//7190 
f 6740//7186 6787//7191 6784//7189 
f 6806//7186 6789//7192 6788//7193 
f 6788//7193 6740//7186 6806//7186 
f 6788//7193 6787//7191 6740//7186 
f 6784//7189 6739//7188 6740//7186 
f 6738//7194 6786//7195 6785//7196 
f 6738//7194 6783//7190 6786//7195 
f 6785//7196 6753//7197 6738//7194 
f 6783//7190 6738//7194 6739//7188 
f 6741//7187 6742//7184 6805//7184 
f 6743//7185 6744//7182 6804//7182 
f 6745//7183 6746//7180 6803//7180 
f 6747//7181 6748//7178 6802//7178 
f 6749//7179 6750//7175 6800//7175 
o mesh313
f 6807//7198 6808//7198 6801//7198 
f 6801//7198 6752//7198 6807//7198 
o mesh314
f 6801//7199 6808//7199 6799//7199 
f 6799//7199 6797//7199 6801//7199 
f 6797//7199 6800//7199 6801//7199 
f 6808//7199 6809//7199 6799//7199 
f 6797//7199 6802//7199 6800//7199 
f 6797//7199 6803//7199 6802//7199 
f 6774//7199 6804//7199 6803//7199 
f 6803//7199 6797//7199 6774//7199 
f 6790//7199 6789//7199 6806//7199 
f 6810//7199 6811//7199 6812//7199 
f 6813//7199 6799//7199 6814//7199 
f 6774//7199 6805//7199 6804//7199 
f 6805//7199 6774//7199 6790//7199 
f 6812//7199 6815//7199 6810//7199 
f 6814//7199 6816//7199 6813//7199 
f 6806//7199 6805//7199 6790//7199 
f 6816//7199 6811//7199 6813//7199 
f 6809//7199 6817//7199 6799//7199 
f 6799//7199 6813//7199 6818//7199 
f 6817//7199 6814//7199 6799//7199 
f 6819//7199 6820//7199 6821//7199 
f 6822//7199 6819//7199 6823//7199 
f 6810//7199 6813//7199 6811//7199 
f 6823//7199 6824//7199 6822//7199 
f 6825//7199 6822//7199 6824//7199 
f 6826//7199 6827//7199 6825//7199 
f 6826//7199 6799//7199 6828//7199 
f 6797//7199 6775//7199 6774//7199 
f 6795//7199 6777//7199 6776//7199 
f 6795//7199 6794//7199 6778//7199 
f 6824//7199 6829//7199 6825//7199 
f 6828//7199 6827//7199 6826//7199 
f 6797//7199 6776//7199 6775//7199 
f 6778//7199 6777//7199 6795//7199 
f 6779//7199 6793//7199 6792//7199 
f 6780//7199 6792//7199 6791//7199 
f 6825//7199 6829//7199 6826//7199 
f 6776//7199 6797//7199 6795//7199 
f 6778//7199 6794//7199 6793//7199 
f 6791//7199 6781//7199 6780//7199 
f 6818//7199 6828//7199 6799//7199 
f 6792//7199 6780//7199 6779//7199 
f 6793//7199 6779//7199 6778//7199 
f 6821//7199 6823//7199 6819//7199 
o mesh315
f 6830//7200 6798//7200 6799//7200 
f 6799//7200 6826//7200 6830//7200 
o mesh316
f 6811//7201 6831//7201 6832//7202 
f 6832//7202 6812//7203 6811//7201 
f 6816//7204 6833//7204 6834//7205 
f 6834//7205 6811//7201 6816//7204 
f 6814//7206 6835//7206 6836//7207 
f 6836//7207 6816//7204 6814//7206 
f 6817//7208 6837//7208 6838//7209 
f 6838//7209 6814//7206 6817//7208 
f 6809//7210 6839//7210 6840//7211 
f 6840//7211 6817//7208 6809//7210 
f 6808//7212 6807//7212 6841//7213 
f 6841//7213 6809//7210 6808//7212 
f 6842//7214 6843//7215 6844//7216 
f 6844//7216 6845//7217 6842//7214 
f 6812//7203 6846//7218 6847//7219 
f 6846//7218 6848//7220 6847//7219 
f 6849//7221 6842//7214 6850//7222 
f 6846//7218 6849//7221 6851//7223 
f 6851//7223 6848//7220 6846//7218 
f 6850//7222 6851//7223 6849//7221 
f 6847//7219 6815//7224 6812//7203 
f 6845//7217 6850//7222 6842//7214 
f 6841//7213 6839//7210 6809//7210 
f 6840//7211 6837//7208 6817//7208 
f 6838//7209 6835//7206 6814//7206 
f 6836//7207 6833//7204 6816//7204 
f 6834//7205 6831//7201 6811//7201 
f 6832//7202 6846//7218 6812//7203 
o mesh317
f 6841//7225 6807//7226 6852//7226 
f 6853//7227 6840//7228 6839//7229 
f 6839//7229 6854//7230 6853//7227 
f 6855//7231 6838//7232 6837//7233 
f 6837//7233 6853//7227 6855//7231 
f 6856//7234 6836//7235 6835//7236 
f 6835//7236 6855//7231 6856//7234 
f 6857//7237 6834//7238 6833//7239 
f 6833//7239 6856//7234 6857//7237 
f 6858//7240 6832//7241 6831//7242 
f 6831//7242 6857//7237 6858//7240 
f 6859//7243 6849//7244 6846//7245 
f 6846//7245 6858//7240 6859//7243 
f 6860//7246 6843//7246 6842//7247 
f 6842//7247 6859//7243 6860//7246 
f 6842//7247 6849//7244 6859//7243 
f 6846//7245 6832//7241 6858//7240 
f 6831//7242 6834//7238 6857//7237 
f 6833//7239 6836//7235 6856//7234 
f 6835//7236 6838//7232 6855//7231 
f 6837//7233 6840//7228 6853//7227 
f 6839//7229 6841//7225 6854//7230 
f 6852//7226 6854//7230 6841//7225 
o mesh318
f 6830//7248 6826//7248 6829//7249 
f 6861//7249 6829//7249 6824//7250 
f 6862//7250 6824//7250 6823//7251 
f 6863//7251 6823//7251 6821//7252 
f 6864//7252 6865//7253 6866//7254 
f 6864//7252 6821//7252 6820//7255 
f 6820//7255 6865//7253 6864//7252 
f 6866//7254 6867//7254 6864//7252 
f 6821//7252 6864//7252 6863//7251 
f 6823//7251 6863//7251 6862//7250 
f 6824//7250 6862//7250 6861//7249 
f 6829//7249 6861//7249 6830//7248 
o mesh319
f 6798//7256 6830//7256 6868//7256 
f 6868//7256 6869//7256 6798//7256 
o mesh320
f 6867//7257 6870//7257 6871//7257 
f 6867//7257 6872//7257 6873//7257 
f 6873//7257 6870//7257 6867//7257 
f 6867//7257 6866//7257 6874//7257 
f 6874//7257 6872//7257 6867//7257 
f 6871//7257 6875//7257 6867//7257 
o mesh321
f 6867//7258 6876//7258 6877//7259 
f 6864//7259 6877//7259 6878//7260 
f 6863//7260 6878//7260 6879//7261 
f 6862//7261 6879//7261 6880//7262 
f 6861//7262 6880//7262 6868//7263 
f 6868//7263 6830//7263 6861//7262 
f 6880//7262 6861//7262 6862//7261 
f 6879//7261 6862//7261 6863//7260 
f 6878//7260 6863//7260 6864//7259 
f 6877//7259 6864//7259 6867//7258 
o mesh322
f 6875//7264 6881//7264 6876//7264 
f 6876//7264 6867//7264 6875//7264 
o mesh323
f 6876//7265 6882//7265 6883//7266 
f 6877//7266 6883//7266 6884//7267 
f 6878//7267 6884//7267 6885//7268 
f 6879//7268 6885//7268 6886//7269 
f 6880//7269 6886//7269 6887//7270 
f 6887//7270 6868//7270 6880//7269 
f 6886//7269 6880//7269 6879//7268 
f 6885//7268 6879//7268 6878//7267 
f 6884//7267 6878//7267 6877//7266 
f 6883//7266 6877//7266 6876//7265 
o mesh324
f 6881//7271 6888//7271 6882//7271 
f 6882//7271 6876//7271 6881//7271 
o mesh325
f 6889//7272 6860//7273 6890//7273 
f 6891//7274 6892//7274 6889//7272 
f 6893//7275 6892//7274 6891//7274 
f 6894//7276 6895//7276 6893//7275 
f 6896//7277 6895//7276 6894//7276 
f 6897//7278 6898//7278 6896//7277 
f 6899//7279 6898//7278 6897//7278 
f 6900//7280 6901//7280 6899//7279 
f 6902//7281 6901//7280 6900//7280 
f 6903//7282 6904//7282 6902//7281 
f 6905//7283 6904//7282 6903//7282 
f 6906//7284 6907//7284 6905//7283 
f 6908//7285 6907//7284 6906//7284 
f 6909//7286 6910//7286 6908//7285 
f 6910//7286 6909//7286 6911//7287 
f 6912//7288 6911//7287 6913//7289 
f 6913//7289 6914//7289 6912//7288 
f 6915//7290 6913//7289 6916//7291 
f 6916//7291 6917//7291 6915//7290 
f 6918//7292 6916//7291 6919//7293 
f 6919//7293 6920//7293 6918//7292 
f 6921//7294 6919//7293 6922//7295 
f 6922//7295 6923//7295 6921//7294 
f 6924//7296 6922//7295 6925//7297 
f 6925//7297 6926//7297 6924//7296 
f 6927//7298 6925//7297 6928//7299 
f 6928//7299 6929//7299 6927//7298 
f 6930//7300 6928//7299 6888//7301 
f 6888//7301 6881//7301 6930//7300 
f 6930//7300 6929//7299 6928//7299 
f 6927//7298 6926//7297 6925//7297 
f 6924//7296 6923//7295 6922//7295 
f 6921//7294 6920//7293 6919//7293 
f 6918//7292 6917//7291 6916//7291 
f 6915//7290 6914//7289 6913//7289 
f 6912//7288 6931//7302 6911//7287 
f 6911//7287 6931//7302 6910//7286 
f 6906//7284 6909//7286 6908//7285 
f 6903//7282 6906//7284 6905//7283 
f 6900//7280 6903//7282 6902//7281 
f 6897//7278 6900//7280 6899//7279 
f 6894//7276 6897//7278 6896//7277 
f 6891//7274 6894//7276 6893//7275 
f 6890//7273 6891//7274 6889//7272 
o mesh326
f 6932//7303 6927//7304 6929//7305 
f 6929//7305 6933//7306 6932//7303 
f 6934//7307 6924//7308 6926//7309 
f 6926//7309 6932//7303 6934//7307 
f 6935//7310 6921//7311 6923//7312 
f 6923//7312 6934//7307 6935//7310 
f 6936//7313 6918//7314 6920//7315 
f 6920//7315 6935//7310 6936//7313 
f 6937//7316 6915//7317 6917//7318 
f 6917//7318 6936//7313 6937//7316 
f 6938//7319 6912//7320 6914//7321 
f 6914//7321 6937//7316 6938//7319 
f 6938//7319 6910//7322 6931//7323 
f 6939//7324 6908//7325 6910//7322 
f 6910//7322 6938//7319 6939//7324 
f 6931//7323 6912//7320 6938//7319 
f 6939//7324 6940//7326 6907//7327 
f 6940//7326 6905//7328 6907//7327 
f 6940//7326 6941//7329 6904//7330 
f 6941//7329 6902//7331 6904//7330 
f 6941//7329 6942//7332 6901//7333 
f 6942//7332 6899//7334 6901//7333 
f 6942//7332 6943//7335 6898//7336 
f 6943//7335 6896//7337 6898//7336 
f 6943//7335 6944//7338 6895//7339 
f 6944//7338 6893//7340 6895//7339 
f 6944//7338 6945//7341 6892//7342 
f 6945//7341 6889//7343 6892//7342 
f 6946//7344 6933//7306 6875//7345 
f 6930//7346 6881//7345 6875//7345 
f 6875//7345 6933//7306 6930//7346 
f 6946//7344 6870//7347 6873//7348 
f 6946//7344 6871//7349 6870//7347 
f 6947//7348 6872//7350 6874//7351 
f 6947//7348 6873//7348 6872//7350 
f 6948//7352 6866//7353 6865//7354 
f 6948//7352 6874//7351 6866//7353 
f 6949//7355 6950//7356 6820//7357 
f 6950//7356 6865//7354 6820//7357 
f 6822//7358 6951//7358 6949//7355 
f 6825//7359 6952//7359 6951//7358 
f 6827//7360 6953//7360 6952//7359 
f 6828//7361 6954//7361 6953//7360 
f 6818//7362 6955//7362 6954//7361 
f 6813//7363 6956//7363 6955//7362 
f 6810//7364 6957//7364 6956//7363 
f 6957//7364 6810//7364 6815//7365 
f 6815//7365 6958//7366 6957//7364 
f 6959//7367 6958//7366 6847//7366 
f 6847//7366 6848//7368 6959//7367 
f 6960//7369 6850//7370 6845//7371 
f 6960//7369 6959//7367 6851//7372 
f 6851//7372 6850//7370 6960//7369 
f 6889//7343 6945//7341 6843//7373 
f 6960//7369 6844//7374 6843//7373 
f 6843//7373 6945//7341 6960//7369 
f 6843//7373 6860//7373 6889//7343 
f 6845//7371 6844//7374 6960//7369 
f 6848//7368 6851//7372 6959//7367 
f 6815//7365 6847//7366 6958//7366 
f 6956//7363 6813//7363 6810//7364 
f 6955//7362 6818//7362 6813//7363 
f 6954//7361 6828//7361 6818//7362 
f 6953//7360 6827//7360 6828//7361 
f 6952//7359 6825//7359 6827//7360 
f 6951//7358 6822//7358 6825//7359 
f 6949//7355 6819//7375 6822//7358 
f 6820//7357 6819//7375 6949//7355 
f 6865//7354 6950//7356 6948//7352 
f 6874//7351 6948//7352 6947//7348 
f 6873//7348 6947//7348 6946//7344 
f 6875//7345 6871//7349 6946//7344 
f 6892//7342 6893//7340 6944//7338 
f 6895//7339 6896//7337 6943//7335 
f 6898//7336 6899//7334 6942//7332 
f 6901//7333 6902//7331 6941//7329 
f 6904//7330 6905//7328 6940//7326 
f 6907//7327 6908//7325 6939//7324 
f 6914//7321 6915//7317 6937//7316 
f 6917//7318 6918//7314 6936//7313 
f 6920//7315 6921//7311 6935//7310 
f 6923//7312 6924//7308 6934//7307 
f 6926//7309 6927//7304 6932//7303 
f 6929//7305 6930//7346 6933//7306 
o mesh327
f 6961//7376 6962//7377 6854//7377 
f 6962//7377 6963//7378 6853//7378 
f 6963//7378 6964//7379 6855//7379 
f 6964//7379 6965//7380 6856//7380 
f 6965//7380 6966//7381 6857//7381 
f 6966//7381 6967//7382 6858//7382 
f 6967//7382 6968//7383 6859//7383 
f 6968//7383 6890//7384 6860//7384 
f 6860//7384 6859//7383 6968//7383 
f 6859//7383 6858//7382 6967//7382 
f 6858//7382 6857//7381 6966//7381 
f 6857//7381 6856//7380 6965//7380 
f 6856//7380 6855//7379 6964//7379 
f 6855//7379 6853//7378 6963//7378 
f 6853//7378 6854//7377 6962//7377 
f 6854//7377 6852//7385 6961//7376 
o mesh328
f 6852//7385 6969//7385 6970//7385 
f 6970//7385 6961//7385 6852//7385 
o mesh329
f 6807//7386 6729//7386 6969//7386 
f 6729//7386 6971//7386 6972//7386 
f 6972//7386 6969//7386 6729//7386 
f 6752//7386 6730//7386 6729//7386 
f 6729//7386 6807//7386 6752//7386 
f 6969//7386 6852//7386 6807//7386 
o mesh330
f 6953//7387 6973//7387 6974//7388 
f 6952//7388 6974//7388 6975//7389 
f 6951//7389 6975//7389 6976//7390 
f 6949//7390 6976//7390 6977//7391 
f 6950//7391 6977//7391 6978//7392 
f 6948//7392 6978//7392 6979//7393 
f 6947//7393 6979//7393 6980//7394 
f 6946//7394 6980//7394 6981//7395 
f 6933//7395 6981//7395 6982//7396 
f 6932//7396 6982//7396 6983//7397 
f 6934//7397 6983//7397 6984//7398 
f 6935//7398 6984//7398 6985//7399 
f 6936//7399 6985//7399 6986//7400 
f 6937//7400 6986//7400 6987//7401 
f 6938//7401 6987//7401 6988//7402 
f 6939//7402 6988//7402 6989//7403 
f 6940//7403 6989//7403 6990//7404 
f 6941//7404 6990//7404 6991//7405 
f 6942//7405 6991//7405 6992//7406 
f 6943//7406 6992//7406 6993//7407 
f 6944//7407 6993//7407 6994//7408 
f 6945//7408 6994//7408 6995//7409 
f 6960//7409 6995//7409 6996//7410 
f 6959//7410 6996//7410 6997//7411 
f 6958//7411 6997//7411 6998//7412 
f 6957//7412 6998//7412 6999//7413 
f 6956//7413 6999//7413 7000//7414 
f 6955//7414 7000//7414 7001//7415 
f 6954//7415 7001//7415 6973//7387 
f 6973//7387 6953//7387 6954//7415 
f 7001//7415 6954//7415 6955//7414 
f 7000//7414 6955//7414 6956//7413 
f 6999//7413 6956//7413 6957//7412 
f 6998//7412 6957//7412 6958//7411 
f 6997//7411 6958//7411 6959//7410 
f 6996//7410 6959//7410 6960//7409 
f 6995//7409 6960//7409 6945//7408 
f 6994//7408 6945//7408 6944//7407 
f 6993//7407 6944//7407 6943//7406 
f 6992//7406 6943//7406 6942//7405 
f 6991//7405 6942//7405 6941//7404 
f 6990//7404 6941//7404 6940//7403 
f 6989//7403 6940//7403 6939//7402 
f 6988//7402 6939//7402 6938//7401 
f 6987//7401 6938//7401 6937//7400 
f 6986//7400 6937//7400 6936//7399 
f 6985//7399 6936//7399 6935//7398 
f 6984//7398 6935//7398 6934//7397 
f 6983//7397 6934//7397 6932//7396 
f 6982//7396 6932//7396 6933//7395 
f 6981//7395 6933//7395 6946//7394 
f 6980//7394 6946//7394 6947//7393 
f 6979//7393 6947//7393 6948//7392 
f 6978//7392 6948//7392 6950//7391 
f 6977//7391 6950//7391 6949//7390 
f 6976//7390 6949//7390 6951//7389 
f 6975//7389 6951//7389 6952//7388 
f 6974//7388 6952//7388 6953//7387 
o mesh331
f 6979//7416 7002//7416 7003//7416 
f 6979//7416 6978//7416 7004//7416 
f 6978//7416 6977//7416 7005//7416 
f 6977//7416 6976//7416 7006//7416 
f 6984//7416 7007//7416 7008//7416 
f 6984//7416 6983//7416 7009//7416 
f 7004//7416 7002//7416 6979//7416 
f 7006//7416 7005//7416 6977//7416 
f 6973//7416 7010//7416 7011//7416 
f 6973//7416 7001//7416 7012//7416 
f 6998//7416 7013//7416 7014//7416 
f 6997//7416 7015//7416 7013//7416 
f 6996//7416 7016//7416 7015//7416 
f 6996//7416 6995//7416 7017//7416 
f 6985//7416 7008//7416 7018//7416 
f 7009//7416 7007//7416 6984//7416 
f 6983//7416 6982//7416 7019//7416 
f 6982//7416 6981//7416 7020//7416 
f 7005//7416 7004//7416 6978//7416 
f 6976//7416 6975//7416 7021//7416 
f 6974//7416 7011//7416 7021//7416 
f 7012//7416 7010//7416 6973//7416 
f 7000//7416 7022//7416 7012//7416 
f 6999//7416 7014//7416 7022//7416 
f 7013//7416 6998//7416 6997//7416 
f 7017//7416 7016//7416 6996//7416 
f 6993//7416 7023//7416 7024//7416 
f 6992//7416 7025//7416 7023//7416 
f 6986//7416 7018//7416 7026//7416 
f 7008//7416 6985//7416 6984//7416 
f 7020//7416 7019//7416 6982//7416 
f 6981//7416 6980//7416 7003//7416 
f 7021//7416 7006//7416 6976//7416 
f 7011//7416 6974//7416 6973//7416 
f 7022//7416 7000//7416 6999//7416 
f 7015//7416 6997//7416 6996//7416 
f 6994//7416 7024//7416 7017//7416 
f 7023//7416 6993//7416 6992//7416 
f 6991//7416 7027//7416 7025//7416 
f 6991//7416 6990//7416 7028//7416 
f 6989//7416 7029//7416 7028//7416 
f 6988//7416 7030//7416 7029//7416 
f 7018//7416 6986//7416 6985//7416 
f 7003//7416 7020//7416 6981//7416 
f 7021//7416 6975//7416 6974//7416 
f 7014//7416 6999//7416 6998//7416 
f 7024//7416 6994//7416 6993//7416 
f 7028//7416 7027//7416 6991//7416 
f 7029//7416 6989//7416 6988//7416 
f 6987//7416 7026//7416 7030//7416 
f 7019//7416 7009//7416 6983//7416 
f 7012//7416 7001//7416 7000//7416 
f 7025//7416 6992//7416 6991//7416 
f 7030//7416 6988//7416 6987//7416 
f 7003//7416 6980//7416 6979//7416 
f 7028//7416 6990//7416 6989//7416 
f 7017//7416 6995//7416 6994//7416 
f 7026//7416 6987//7416 6986//7416 
o mesh332
f 7031//7417 7032//7418 7010//7418 
f 7033//7419 7031//7417 7012//7420 
f 7034//7421 7033//7419 7022//7422 
f 7035//7423 7034//7421 7014//7424 
f 7036//7425 7035//7423 7013//7426 
f 7037//7427 7036//7425 7015//7428 
f 7038//7429 7037//7427 7016//7430 
f 7039//7431 7038//7429 7017//7432 
f 7040//7433 7039//7431 7024//7434 
f 7041//7435 7040//7433 7023//7436 
f 7042//7437 7041//7435 7025//7438 
f 7043//7439 7042//7437 7027//7440 
f 7044//7441 7043//7439 7028//7442 
f 7045//7443 7044//7441 7029//7444 
f 7046//7445 7045//7443 7030//7446 
f 7047//7447 7046//7445 7026//7448 
f 7048//7449 7047//7447 7018//7450 
f 7049//7451 7048//7449 7008//7452 
f 7050//7453 7049//7451 7007//7454 
f 7051//7455 7050//7453 7009//7456 
f 7052//7457 7051//7455 7019//7458 
f 7053//7459 7052//7457 7020//7460 
f 7054//7461 7053//7459 7003//7462 
f 7055//7463 7054//7461 7002//7464 
f 7056//7465 7055//7463 7004//7466 
f 7057//7467 7056//7465 7005//7468 
f 7058//7469 7057//7467 7006//7470 
f 7059//7471 7058//7469 7021//7472 
f 7032//7418 7059//7471 7011//7471 
f 7011//7471 7010//7418 7032//7418 
f 7021//7472 7011//7471 7059//7471 
f 7006//7470 7021//7472 7058//7469 
f 7005//7468 7006//7470 7057//7467 
f 7004//7466 7005//7468 7056//7465 
f 7002//7464 7004//7466 7055//7463 
f 7003//7462 7002//7464 7054//7461 
f 7020//7460 7003//7462 7053//7459 
f 7019//7458 7020//7460 7052//7457 
f 7009//7456 7019//7458 7051//7455 
f 7007//7454 7009//7456 7050//7453 
f 7008//7452 7007//7454 7049//7451 
f 7018//7450 7008//7452 7048//7449 
f 7026//7448 7018//7450 7047//7447 
f 7030//7446 7026//7448 7046//7445 
f 7029//7444 7030//7446 7045//7443 
f 7028//7442 7029//7444 7044//7441 
f 7027//7440 7028//7442 7043//7439 
f 7025//7438 7027//7440 7042//7437 
f 7023//7436 7025//7438 7041//7435 
f 7024//7434 7023//7436 7040//7433 
f 7017//7432 7024//7434 7039//7431 
f 7016//7430 7017//7432 7038//7429 
f 7015//7428 7016//7430 7037//7427 
f 7013//7426 7015//7428 7036//7425 
f 7014//7424 7013//7426 7035//7423 
f 7022//7422 7014//7424 7034//7421 
f 7012//7420 7022//7422 7033//7419 
f 7010//7418 7012//7420 7031//7417 
o mesh333
f 6922//7473 6919//7473 7049//7473 
f 6919//7473 6916//7473 7048//7473 
f 6928//7473 6925//7473 7051//7473 
f 6925//7473 6922//7473 7050//7473 
f 7048//7473 7049//7473 6919//7473 
f 6916//7473 6913//7473 7047//7473 
f 7057//7473 6883//7473 6882//7473 
f 6888//7473 6928//7473 7052//7473 
f 7050//7473 7051//7473 6925//7473 
f 7047//7473 7048//7473 6916//7473 
f 6913//7473 6911//7473 7046//7473 
f 7033//7473 7034//7473 6965//7473 
f 7057//7473 6884//7473 6883//7473 
f 7051//7473 7052//7473 6928//7473 
f 7046//7473 7047//7473 6913//7473 
f 6894//7473 7040//7473 7041//7473 
f 6891//7473 7039//7473 7040//7473 
f 7035//7473 7036//7473 6968//7473 
f 7060//7473 7061//7473 6961//7473 
f 7061//7473 6964//7473 6963//7473 
f 6965//7473 7061//7473 7033//7473 
f 7058//7473 6885//7473 6884//7473 
f 6882//7473 7055//7473 7056//7473 
f 6882//7473 6888//7473 7054//7473 
f 7049//7473 7050//7473 6922//7473 
f 6909//7473 7045//7473 7046//7473 
f 6906//7473 7044//7473 7045//7473 
f 6903//7473 7043//7473 7044//7473 
f 6900//7473 7042//7473 7043//7473 
f 6897//7473 7041//7473 7042//7473 
f 7040//7473 6894//7473 6891//7473 
f 6890//7473 7038//7473 7039//7473 
f 6890//7473 6968//7473 7037//7473 
f 6968//7473 6967//7473 7035//7473 
f 7034//7473 7035//7473 6966//7473 
f 7061//7473 6962//7473 6961//7473 
f 6965//7473 6964//7473 7061//7473 
f 7032//7473 6887//7473 6886//7473 
f 7059//7473 6886//7473 6885//7473 
f 6882//7473 7056//7473 7057//7473 
f 6888//7473 7053//7473 7054//7473 
f 7046//7473 6911//7473 6909//7473 
f 7044//7473 6906//7473 6903//7473 
f 7042//7473 6900//7473 6897//7473 
f 7039//7473 6891//7473 6890//7473 
f 6968//7473 7036//7473 7037//7473 
f 6966//7473 6965//7473 7034//7473 
f 6963//7473 6962//7473 7061//7473 
f 6885//7473 7058//7473 7059//7473 
f 7054//7473 7055//7473 6882//7473 
f 7045//7473 6909//7473 6906//7473 
f 7041//7473 6897//7473 6894//7473 
f 6967//7473 6966//7473 7035//7473 
f 7061//7473 7031//7473 7033//7473 
f 6884//7473 7057//7473 7058//7473 
f 7043//7473 6903//7473 6900//7473 
f 6961//7473 6970//7473 7060//7473 
f 6887//7473 7032//7473 7031//7473 
f 7052//7473 7053//7473 6888//7473 
f 7031//7473 7061//7473 6887//7473 
f 7037//7473 7038//7473 6890//7473 
f 6886//7473 7059//7473 7032//7473 
o mesh334
f 6970//7474 7062//7474 7063//7474 
f 7063//7474 7064//7474 6970//7474 
f 7064//7474 7060//7474 6970//7474 
o mesh335
f 6972//7475 7065//7475 7066//7475 
f 6969//7475 7066//7475 7062//7475 
f 7066//7475 6969//7475 6972//7475 
f 7065//7475 7067//7475 7066//7475 
f 7062//7475 6970//7475 6969//7475 
o mesh336
f 7068//7476 7069//7476 7070//7477 
f 7071//7477 7070//7477 7072//7478 
f 7069//7476 7067//7479 7065//7480 
f 7069//7476 7068//7476 7067//7479 
f 7073//7481 7065//7480 6972//7482 
f 6972//7482 6971//7482 7073//7481 
f 7065//7480 7073//7481 7069//7476 
f 7072//7478 7074//7483 7071//7477 
f 7070//7477 7071//7477 7068//7476 
o mesh337
f 7074//7484 7072//7484 7075//7484 
f 7075//7484 7076//7484 7074//7484 
o mesh338
f 7076//7485 7075//7485 7077//7486 
f 7078//7486 7077//7486 7079//7487 
f 7080//7487 7079//7487 7081//7488 
f 7082//7488 7081//7488 7083//7489 
f 7083//7489 7084//7489 7082//7488 
f 7081//7488 7082//7488 7080//7487 
f 7079//7487 7080//7487 7078//7486 
f 7077//7486 7078//7486 7076//7485 
o mesh339
f 7083//7490 6762//7490 7085//7490 
f 6869//7490 7086//7490 7085//7490 
f 7085//7490 7084//7490 7083//7490 
f 6796//7490 6798//7490 6869//7490 
f 7085//7490 6796//7490 6869//7490 
f 6762//7490 6796//7490 7085//7490 
o mesh340
f 7087//7491 7088//7492 7089//7492 
f 7090//7493 7087//7491 7091//7494 
f 7092//7495 7090//7493 7093//7496 
f 7093//7496 7094//7497 7092//7495 
f 7095//7498 7092//7495 7060//7499 
f 7096//7500 7061//7499 7060//7499 
f 7060//7499 7092//7495 7096//7500 
f 7064//7501 7063//7502 7097//7502 
f 7097//7502 7063//7502 7062//7503 
f 7086//7504 7098//7505 7099//7505 
f 7098//7505 7100//7506 7101//7506 
f 7100//7506 7102//7507 7103//7507 
f 7088//7492 7104//7508 7105//7508 
f 7103//7507 7102//7507 7104//7508 
f 7104//7508 7088//7492 7103//7507 
f 7105//7508 7089//7492 7088//7492 
f 7103//7507 7101//7506 7100//7506 
f 7101//7506 7099//7505 7098//7505 
f 7099//7505 7085//7509 7086//7504 
f 7062//7503 7066//7510 7097//7502 
f 7097//7502 7095//7498 7064//7501 
f 7060//7499 7064//7501 7095//7498 
f 7094//7497 7096//7500 7092//7495 
f 7091//7494 7093//7496 7090//7493 
f 7089//7492 7091//7494 7087//7491 
o mesh341
f 6869//7511 7089//7511 7105//7511 
f 6869//7511 7091//7511 7089//7511 
f 6868//7511 7093//7511 7091//7511 
f 7091//7511 6869//7511 6868//7511 
f 6868//7511 7096//7511 7094//7511 
f 7094//7511 7093//7511 6868//7511 
f 6868//7511 6887//7511 7061//7511 
f 7061//7511 7096//7511 6868//7511 
f 7105//7511 7106//7511 6869//7511 
o mesh342
f 7106//7512 7100//7512 7098//7512 
f 7106//7512 7104//7512 7102//7512 
f 7102//7512 7100//7512 7106//7512 
f 7086//7512 6869//7512 7106//7512 
f 7098//7512 7086//7512 7106//7512 
o mesh343
f 7106//7513 7105//7513 7104//7513 
o mesh344
f 7107//7514 6670//7514 7108//7514 
f 6670//7514 7109//7514 7108//7514 
f 7108//7514 7110//7514 7107//7514 
f 7107//7514 7111//7514 6670//7514 
f 6670//7514 7112//7514 7113//7514 
f 6670//7514 7114//7514 7109//7514 
f 6670//7514 7115//7514 7116//7514 
f 6670//7514 7117//7514 7112//7514 
f 7118//7514 7119//7514 7120//7514 
f 7116//7514 7114//7514 6670//7514 
f 6670//7514 7121//7514 7117//7514 
f 6670//7514 7122//7514 7123//7514 
f 7124//7514 7125//7514 7126//7514 
f 7118//7514 7127//7514 7122//7514 
f 7120//7514 7126//7514 7118//7514 
f 7128//7514 7083//7514 7129//7514 
f 7113//7514 7115//7514 6670//7514 
f 7122//7514 7127//7514 7123//7514 
f 7124//7514 7130//7514 7125//7514 
f 7120//7514 7131//7514 7126//7514 
f 6971//7514 7132//7514 7133//7514 
f 7129//7514 7134//7514 7128//7514 
f 7134//7514 7129//7514 7130//7514 
f 7123//7514 7121//7514 6670//7514 
f 7122//7514 7119//7514 7118//7514 
f 6670//7514 6667//7514 7135//7514 
f 7136//7514 7137//7514 7138//7514 
f 7139//7514 7136//7514 7140//7514 
f 7133//7514 7073//7514 6971//7514 
f 6762//7514 7083//7514 7141//7514 
f 7130//7514 7124//7514 7134//7514 
f 7126//7514 7131//7514 7124//7514 
f 6670//7514 7142//7514 7143//7514 
f 7135//7514 7144//7514 6670//7514 
f 7145//7514 7146//7514 7147//7514 
f 7148//7514 7149//7514 7150//7514 
f 7148//7514 7137//7514 7151//7514 
f 7075//7514 7152//7514 7153//7514 
f 7140//7514 7075//7514 7139//7514 
f 7133//7514 7154//7514 7073//7514 
f 7083//7514 7155//7514 7141//7514 
f 7083//7514 7156//7514 7157//7514 
f 7111//7514 7158//7514 6670//7514 
f 6670//7514 7159//7514 7160//7514 
f 7143//7514 7161//7514 6670//7514 
f 7144//7514 7162//7514 6670//7514 
f 7146//7514 7163//7514 7147//7514 
f 7110//7514 7108//7514 7164//7514 
f 7146//7514 7165//7514 7166//7514 
f 7151//7514 7149//7514 7148//7514 
f 7081//7514 7079//7514 7167//7514 
f 7079//7514 7077//7514 7153//7514 
f 7075//7514 7140//7514 7152//7514 
f 7075//7514 7168//7514 7139//7514 
f 7075//7514 7072//7514 7169//7514 
f 7069//7514 7170//7514 7171//7514 
f 7069//7514 7073//7514 7172//7514 
f 6971//7514 7173//7514 7132//7514 
f 6971//7514 6670//7514 7174//7514 
f 7083//7514 7175//7514 7155//7514 
f 7128//7514 7156//7514 7083//7514 
f 6670//7514 7176//7514 7159//7514 
f 7162//7514 7142//7514 6670//7514 
f 7164//7514 7145//7514 7110//7514 
f 7165//7514 7150//7514 7166//7514 
f 7150//7514 7165//7514 7148//7514 
f 7083//7514 7177//7514 7178//7514 
f 7083//7514 7081//7514 7179//7514 
f 7153//7514 7167//7514 7079//7514 
f 7138//7514 7140//7514 7136//7514 
f 7072//7514 7180//7514 7169//7514 
f 7072//7514 7070//7514 7181//7514 
f 7069//7514 7182//7514 7170//7514 
f 7154//7514 7172//7514 7073//7514 
f 6670//7514 7158//7514 7174//7514 
f 7157//7514 7175//7514 7083//7514 
f 7161//7514 7176//7514 6670//7514 
f 7166//7514 7163//7514 7146//7514 
f 7148//7514 7183//7514 7137//7514 
f 6667//7514 7184//7514 7185//7514 
f 7179//7514 7177//7514 7083//7514 
f 7153//7514 7077//7514 7075//7514 
f 7072//7514 7186//7514 7180//7514 
f 7070//7514 7187//7514 7181//7514 
f 7172//7514 7182//7514 7069//7514 
f 7174//7514 7188//7514 6971//7514 
f 7160//7514 7122//7514 6670//7514 
f 7183//7514 7138//7514 7137//7514 
f 6667//7514 7189//7514 7184//7514 
f 6667//7514 7190//7514 7191//7514 
f 6667//7514 7192//7514 7193//7514 
f 7167//7514 7179//7514 7081//7514 
f 7169//7514 7194//7514 7075//7514 
f 7070//7514 7171//7514 7187//7514 
f 7188//7514 7173//7514 6971//7514 
f 7147//7514 7110//7514 7145//7514 
f 7191//7514 7189//7514 6667//7514 
f 7193//7514 7195//7514 6667//7514 
f 7194//7514 7168//7514 7075//7514 
f 7171//7514 7070//7514 7069//7514 
f 7185//7514 7135//7514 6667//7514 
f 7195//7514 7196//7514 6667//7514 
f 7181//7514 7186//7514 7072//7514 
f 7196//7514 7190//7514 6667//7514 
f 7141//7514 7192//7514 6762//7514 
f 7178//7514 7129//7514 7083//7514 
f 6971//7514 6729//7514 6670//7514 
f 6667//7514 6762//7514 7192//7514 
o mesh345
f 7076//7515 7197//7515 7198//7515 
f 7199//7515 7080//7515 7200//7515 
f 7198//7515 7074//7515 7076//7515 
f 7080//7515 7201//7515 7200//7515 
f 7202//7515 7203//7515 7204//7515 
f 7205//7515 7206//7515 7207//7515 
f 7198//7515 7208//7515 7074//7515 
f 7209//7515 7210//7515 7076//7515 
f 7199//7515 7209//7515 7078//7515 
f 7080//7515 7211//7515 7201//7515 
f 7082//7515 7212//7515 7213//7515 
f 7204//7515 7082//7515 7202//7515 
f 7207//7515 7214//7515 7205//7515 
f 7215//7515 7082//7515 7084//7515 
f 7216//7515 7217//7515 7218//7515 
f 7076//7515 7210//7515 7197//7515 
f 7078//7515 7080//7515 7199//7515 
f 7080//7515 7219//7515 7211//7515 
f 7213//7515 7080//7515 7082//7515 
f 7204//7515 7220//7515 7082//7515 
f 7206//7515 7221//7515 7207//7515 
f 7202//7515 7221//7515 7206//7515 
f 7084//7515 7222//7515 7223//7515 
f 7218//7515 7224//7515 7216//7515 
f 7076//7515 7078//7515 7209//7515 
f 7213//7515 7219//7515 7080//7515 
f 7220//7515 7225//7515 7082//7515 
f 7206//7515 7203//7515 7202//7515 
f 7084//7515 7226//7515 7222//7515 
f 7227//7515 7228//7515 7224//7515 
f 7229//7515 7230//7515 7231//7515 
f 7232//7515 7205//7515 7233//7515 
f 7200//7515 7234//7515 7199//7515 
f 7200//7515 7227//7515 7235//7515 
f 7214//7515 7233//7515 7205//7515 
f 7084//7515 7223//7515 7215//7515 
f 7227//7515 7236//7515 7228//7515 
f 7231//7515 7216//7515 7229//7515 
f 7233//7515 7237//7515 7232//7515 
f 7238//7515 7239//7515 7240//7515 
f 7235//7515 7234//7515 7200//7515 
f 7215//7515 7202//7515 7082//7515 
f 7231//7515 7217//7515 7216//7515 
f 7241//7515 7230//7515 7229//7515 
f 7085//7515 7242//7515 7226//7515 
f 7085//7515 7243//7515 7244//7515 
f 7245//7515 7246//7515 7088//7515 
f 7247//7515 7245//7515 7087//7515 
f 7067//7515 7248//7515 7249//7515 
f 7068//7515 7250//7515 7248//7515 
f 7068//7515 7071//7515 7251//7515 
f 7074//7515 7252//7515 7253//7515 
f 7237//7515 7254//7515 7232//7515 
f 7238//7515 7255//7515 7239//7515 
f 7225//7515 7212//7515 7082//7515 
f 7227//7515 7200//7515 7236//7515 
f 7256//7515 7257//7515 7241//7515 
f 7244//7515 7242//7515 7085//7515 
f 7085//7515 7099//7515 7258//7515 
f 7101//7515 7103//7515 7259//7515 
f 7087//7515 7090//7515 7247//7515 
f 7260//7515 7247//7515 7090//7515 
f 7261//7515 7092//7515 7255//7515 
f 7097//7515 7066//7515 7262//7515 
f 7248//7515 7067//7515 7068//7515 
f 7251//7515 7263//7515 7068//7515 
f 7253//7515 7071//7515 7074//7515 
f 7240//7515 7232//7515 7238//7515 
f 7218//7515 7227//7515 7224//7515 
f 7229//7515 7256//7515 7241//7515 
f 7258//7515 7243//7515 7085//7515 
f 7099//7515 7264//7515 7265//7515 
f 7101//7515 7266//7515 7267//7515 
f 7103//7515 7268//7515 7259//7515 
f 7269//7515 7268//7515 7103//7515 
f 7088//7515 7087//7515 7245//7515 
f 7092//7515 7261//7515 7260//7515 
f 7092//7515 7270//7515 7255//7515 
f 7092//7515 7095//7515 7271//7515 
f 7095//7515 7097//7515 7272//7515 
f 7066//7515 7273//7515 7262//7515 
f 7263//7515 7250//7515 7068//7515 
f 7253//7515 7274//7515 7071//7515 
f 7208//7515 7252//7515 7074//7515 
f 7275//7515 7276//7515 7257//7515 
f 7275//7515 7277//7515 7278//7515 
f 7067//7515 7279//7515 7277//7515 
f 7265//7515 7258//7515 7099//7515 
f 7099//7515 7101//7515 7280//7515 
f 7259//7515 7266//7515 7101//7515 
f 7246//7515 7269//7515 7088//7515 
f 7255//7515 7238//7515 7261//7515 
f 7272//7515 7271//7515 7095//7515 
f 7066//7515 7281//7515 7273//7515 
f 7066//7515 7067//7515 7275//7515 
f 7274//7515 7251//7515 7071//7515 
f 7256//7515 7275//7515 7257//7515 
f 7277//7515 7275//7515 7067//7515 
f 7067//7515 7282//7515 7283//7515 
f 7280//7515 7264//7515 7099//7515 
f 7103//7515 7088//7515 7269//7515 
f 7271//7515 7270//7515 7092//7515 
f 7275//7515 7281//7515 7066//7515 
f 7254//7515 7238//7515 7232//7515 
f 7283//7515 7279//7515 7067//7515 
f 7267//7515 7280//7515 7101//7515 
f 7262//7515 7272//7515 7097//7515 
f 7278//7515 7276//7515 7275//7515 
f 7090//7515 7092//7515 7260//7515 
f 7226//7515 7084//7515 7085//7515 
f 7249//7515 7282//7515 7067//7515 
o mesh346
f 7283//7516 7282//7517 7133//7517 
f 7279//7518 7283//7516 7132//7519 
f 7277//7520 7279//7518 7173//7521 
f 7278//7522 7277//7520 7188//7523 
f 7276//7524 7278//7522 7174//7525 
f 7257//7526 7276//7524 7158//7527 
f 7241//7528 7257//7526 7111//7529 
f 7230//7530 7241//7528 7107//7531 
f 7231//7532 7230//7530 7110//7533 
f 7217//7534 7231//7532 7147//7535 
f 7218//7536 7217//7534 7163//7537 
f 7227//7538 7218//7536 7166//7539 
f 7235//7540 7227//7538 7150//7541 
f 7234//7542 7235//7540 7149//7543 
f 7199//7544 7234//7542 7137//7545 
f 7234//7542 7151//7546 7137//7545 
f 7209//7547 7199//7544 7136//7548 
f 7210//7549 7209//7547 7139//7550 
f 7197//7551 7210//7549 7168//7552 
f 7198//7553 7197//7551 7194//7554 
f 7208//7555 7198//7553 7169//7556 
f 7252//7557 7208//7555 7180//7558 
f 7253//7559 7252//7557 7186//7560 
f 7274//7561 7253//7559 7181//7562 
f 7251//7563 7274//7561 7187//7564 
f 7263//7565 7251//7563 7171//7566 
f 7250//7567 7263//7565 7170//7568 
f 7248//7569 7250//7567 7182//7570 
f 7249//7571 7248//7569 7172//7572 
f 7282//7517 7249//7571 7154//7571 
f 7154//7571 7133//7517 7282//7517 
f 7172//7572 7154//7571 7249//7571 
f 7182//7570 7172//7572 7248//7569 
f 7170//7568 7182//7570 7250//7567 
f 7171//7566 7170//7568 7263//7565 
f 7187//7564 7171//7566 7251//7563 
f 7181//7562 7187//7564 7274//7561 
f 7186//7560 7181//7562 7253//7559 
f 7180//7558 7186//7560 7252//7557 
f 7169//7556 7180//7558 7208//7555 
f 7194//7554 7169//7556 7198//7553 
f 7168//7552 7194//7554 7197//7551 
f 7139//7550 7168//7552 7210//7549 
f 7136//7548 7139//7550 7209//7547 
f 7137//7545 7136//7548 7199//7544 
f 7149//7543 7151//7546 7234//7542 
f 7150//7541 7149//7543 7235//7540 
f 7166//7539 7150//7541 7227//7538 
f 7163//7537 7166//7539 7218//7536 
f 7147//7535 7163//7537 7217//7534 
f 7110//7533 7147//7535 7231//7532 
f 7107//7531 7110//7533 7230//7530 
f 7111//7529 7107//7531 7241//7528 
f 7158//7527 7111//7529 7257//7526 
f 7174//7525 7158//7527 7276//7524 
f 7188//7523 7174//7525 7278//7522 
f 7173//7521 7188//7523 7277//7520 
f 7132//7519 7173//7521 7279//7518 
f 7133//7517 7132//7519 7283//7516 
o mesh347
f 7281//7573 7275//7574 7108//7574 
f 7273//7575 7281//7573 7109//7576 
f 7262//7577 7273//7575 7114//7578 
f 7272//7579 7262//7577 7116//7580 
f 7271//7581 7272//7579 7115//7582 
f 7270//7583 7271//7581 7113//7584 
f 7255//7585 7270//7583 7112//7586 
f 7239//7587 7255//7585 7117//7588 
f 7240//7589 7239//7587 7121//7590 
f 7232//7591 7240//7589 7123//7592 
f 7205//7593 7232//7591 7127//7594 
f 7206//7595 7205//7593 7118//7596 
f 7203//7597 7206//7595 7126//7598 
f 7204//7599 7203//7597 7125//7600 
f 7220//7601 7204//7599 7129//7602 
f 7204//7599 7130//7603 7129//7602 
f 7225//7604 7220//7601 7178//7605 
f 7212//7606 7225//7604 7177//7607 
f 7213//7608 7212//7606 7179//7609 
f 7219//7610 7213//7608 7167//7611 
f 7211//7612 7219//7610 7153//7613 
f 7201//7614 7211//7612 7152//7615 
f 7200//7616 7201//7614 7140//7617 
f 7236//7618 7200//7616 7138//7619 
f 7228//7620 7236//7618 7183//7621 
f 7224//7622 7228//7620 7148//7623 
f 7216//7624 7224//7622 7165//7625 
f 7229//7626 7216//7624 7146//7627 
f 7256//7628 7229//7626 7145//7629 
f 7275//7574 7256//7628 7164//7628 
f 7164//7628 7108//7574 7275//7574 
f 7145//7629 7164//7628 7256//7628 
f 7146//7627 7145//7629 7229//7626 
f 7165//7625 7146//7627 7216//7624 
f 7148//7623 7165//7625 7224//7622 
f 7183//7621 7148//7623 7228//7620 
f 7138//7619 7183//7621 7236//7618 
f 7140//7617 7138//7619 7200//7616 
f 7152//7615 7140//7617 7201//7614 
f 7153//7613 7152//7615 7211//7612 
f 7167//7611 7153//7613 7219//7610 
f 7179//7609 7167//7611 7213//7608 
f 7177//7607 7179//7609 7212//7606 
f 7178//7605 7177//7607 7225//7604 
f 7129//7602 7178//7605 7220//7601 
f 7125//7600 7130//7603 7204//7599 
f 7126//7598 7125//7600 7203//7597 
f 7118//7596 7126//7598 7206//7595 
f 7127//7594 7118//7596 7205//7593 
f 7123//7592 7127//7594 7232//7591 
f 7121//7590 7123//7592 7240//7589 
f 7117//7588 7121//7590 7239//7587 
f 7112//7586 7117//7588 7255//7585 
f 7113//7584 7112//7586 7270//7583 
f 7115//7582 7113//7584 7271//7581 
f 7116//7580 7115//7582 7272//7579 
f 7114//7578 7116//7580 7262//7577 
f 7109//7576 7114//7578 7273//7575 
f 7108//7574 7109//7576 7281//7573 
o mesh348
f 7261//7630 7238//7631 7176//7631 
f 7260//7632 7261//7630 7161//7633 
f 7247//7634 7260//7632 7143//7635 
f 7245//7636 7247//7634 7142//7637 
f 7246//7638 7245//7636 7162//7639 
f 7269//7640 7246//7638 7144//7641 
f 7268//7642 7269//7640 7135//7643 
f 7259//7644 7268//7642 7185//7645 
f 7266//7646 7259//7644 7184//7647 
f 7267//7648 7266//7646 7189//7649 
f 7280//7650 7267//7648 7191//7651 
f 7264//7652 7280//7650 7190//7653 
f 7265//7654 7264//7652 7196//7655 
f 7258//7656 7265//7654 7195//7657 
f 7243//7658 7258//7656 7192//7659 
f 7258//7656 7193//7660 7192//7659 
f 7244//7661 7243//7658 7141//7662 
f 7242//7663 7244//7661 7155//7664 
f 7226//7665 7242//7663 7175//7666 
f 7222//7667 7226//7665 7157//7668 
f 7223//7669 7222//7667 7156//7670 
f 7215//7671 7223//7669 7128//7672 
f 7202//7673 7215//7671 7134//7674 
f 7221//7675 7202//7673 7124//7676 
f 7207//7677 7221//7675 7131//7678 
f 7214//7679 7207//7677 7120//7680 
f 7233//7681 7214//7679 7119//7682 
f 7237//7683 7233//7681 7122//7684 
f 7254//7685 7237//7683 7160//7686 
f 7238//7631 7254//7685 7159//7685 
f 7159//7685 7176//7631 7238//7631 
f 7160//7686 7159//7685 7254//7685 
f 7122//7684 7160//7686 7237//7683 
f 7119//7682 7122//7684 7233//7681 
f 7120//7680 7119//7682 7214//7679 
f 7131//7678 7120//7680 7207//7677 
f 7124//7676 7131//7678 7221//7675 
f 7134//7674 7124//7676 7202//7673 
f 7128//7672 7134//7674 7215//7671 
f 7156//7670 7128//7672 7223//7669 
f 7157//7668 7156//7670 7222//7667 
f 7175//7666 7157//7668 7226//7665 
f 7155//7664 7175//7666 7242//7663 
f 7141//7662 7155//7664 7244//7661 
f 7192//7659 7141//7662 7243//7658 
f 7195//7657 7193//7660 7258//7656 
f 7196//7655 7195//7657 7265//7654 
f 7190//7653 7196//7655 7264//7652 
f 7191//7651 7190//7653 7280//7650 
f 7189//7649 7191//7651 7267//7648 
f 7184//7647 7189//7649 7266//7646 
f 7185//7645 7184//7647 7259//7644 
f 7135//7643 7185//7645 7268//7642 
f 7144//7641 7135//7643 7269//7640 
f 7162//7639 7144//7641 7246//7638 
f 7142//7637 7162//7639 7245//7636 
f 7143//7635 7142//7637 7247//7634 
f 7161//7633 7143//7635 7260//7632 
f 7176//7631 7161//7633 7261//7630 
g 1mmSpacer
v 0.0284706 -0.00515989 0.0620032 
v 0.0291155 -0.00515989 0.0620733 
v 0.0291155 -0.00615989 0.0620733 
v 0.0278558 -0.00515989 0.061796 
v 0.0284706 -0.00615989 0.0620032 
v 0.0273 -0.00515989 0.0614616 
v 0.0278558 -0.00615989 0.061796 
v 0.026829 -0.00515989 0.0610155 
v 0.0273 -0.00615989 0.0614616 
v 0.0264649 -0.00515989 0.0604785 
v 0.026829 -0.00615989 0.0610155 
v 0.0262248 -0.00515989 0.0598759 
v 0.0264649 -0.00615989 0.0604785 
v 0.0261199 -0.00515989 0.0592357 
v 0.0262248 -0.00615989 0.0598759 
v 0.026155 -0.00515989 0.058588 
v 0.0261199 -0.00615989 0.0592357 
v 0.0263285 -0.00515989 0.0579629 
v 0.026155 -0.00615989 0.058588 
v 0.0266324 -0.00515989 0.0573897 
v 0.0263285 -0.00615989 0.0579629 
v 0.0270524 -0.00515989 0.0568953 
v 0.0266324 -0.00615989 0.0573897 
v 0.0275688 -0.00515989 0.0565027 
v 0.0270524 -0.00615989 0.0568953 
v 0.0281576 -0.00515989 0.0562303 
v 0.0275688 -0.00615989 0.0565027 
v 0.0287911 -0.00515989 0.0560909 
v 0.0281576 -0.00615989 0.0562303 
v 0.0294398 -0.00515989 0.0560909 
v 0.0291155 -0.00515989 0.0560733 
v 0.0291155 -0.00615989 0.0560733 
v 0.0287911 -0.00615989 0.0560909 
v 0.0300734 -0.00515989 0.0562303 
v 0.0294398 -0.00615989 0.0560909 
v 0.0306621 -0.00515989 0.0565027 
v 0.0300734 -0.00615989 0.0562303 
v 0.0311786 -0.00515989 0.0568953 
v 0.0306621 -0.00615989 0.0565027 
v 0.0315985 -0.00515989 0.0573897 
v 0.0311786 -0.00615989 0.0568953 
v 0.0319024 -0.00515989 0.0579629 
v 0.0315985 -0.00615989 0.0573897 
v 0.032076 -0.00515989 0.058588 
v 0.0319024 -0.00615989 0.0579629 
v 0.0321111 -0.00515989 0.0592357 
v 0.032076 -0.00615989 0.058588 
v 0.0320061 -0.00515989 0.0598759 
v 0.0321111 -0.00615989 0.0592357 
v 0.031766 -0.00515989 0.0604785 
v 0.0320061 -0.00615989 0.0598759 
v 0.031402 -0.00515989 0.0610155 
v 0.031766 -0.00615989 0.0604785 
v 0.030931 -0.00515989 0.0614616 
v 0.031402 -0.00615989 0.0610155 
v 0.0303751 -0.00515989 0.061796 
v 0.030931 -0.00615989 0.0614616 
v 0.0297604 -0.00515989 0.0620032 
v 0.0303751 -0.00615989 0.061796 
v 0.0297604 -0.00615989 0.0620032 
v 0.0321641 -0.00615989 0.0616628 
v 0.0315362 -0.00615989 0.0622577 
v 0.030795 -0.00615989 0.0627036 
v 0.0299754 -0.00615989 0.0629798 
v 0.0291155 -0.00615989 0.0630733 
v 0.029548 -0.00615989 0.0550967 
v 0.0303927 -0.00615989 0.0552827 
v 0.0326495 -0.00615989 0.0609469 
v 0.0260668 -0.00615989 0.0616628 
v 0.0255814 -0.00615989 0.0609469 
v 0.0270533 -0.00615989 0.0556459 
v 0.0278383 -0.00615989 0.0552827 
v 0.028683 -0.00615989 0.0550967 
v 0.0291155 -0.00615989 0.0550733 
v 0.0311777 -0.00615989 0.0556459 
v 0.0318663 -0.00615989 0.0561693 
v 0.0324262 -0.00615989 0.0568285 
v 0.0328314 -0.00615989 0.0575927 
v 0.0330628 -0.00615989 0.0584262 
v 0.0329697 -0.00615989 0.0601434 
v 0.0282556 -0.00615989 0.0629798 
v 0.0266948 -0.00615989 0.0622577 
v 0.0258047 -0.00615989 0.0568285 
v 0.0263647 -0.00615989 0.0561693 
v 0.0331096 -0.00615989 0.0592899 
v 0.0274359 -0.00615989 0.0627036 
v 0.0251213 -0.00615989 0.0592899 
v 0.0251682 -0.00615989 0.0584262 
v 0.0252613 -0.00615989 0.0601434 
v 0.0253996 -0.00615989 0.0575927 
v 0.0291155 -0.00515989 0.0630733 
v 0.0299754 -0.00515989 0.0629798 
v 0.030795 -0.00515989 0.0627036 
v 0.0315362 -0.00515989 0.0622577 
v 0.0321641 -0.00515989 0.0616628 
v 0.0326495 -0.00515989 0.0609469 
v 0.0329697 -0.00515989 0.0601434 
v 0.0331096 -0.00515989 0.0592899 
v 0.0330628 -0.00515989 0.0584262 
v 0.0328314 -0.00515989 0.0575927 
v 0.0324262 -0.00515989 0.0568285 
v 0.0318663 -0.00515989 0.0561693 
v 0.0311777 -0.00515989 0.0556459 
v 0.0303927 -0.00515989 0.0552827 
v 0.028683 -0.00515989 0.0550967 
v 0.0291155 -0.00515989 0.0550733 
v 0.029548 -0.00515989 0.0550967 
v 0.0278383 -0.00515989 0.0552827 
v 0.0270533 -0.00515989 0.0556459 
v 0.0263647 -0.00515989 0.0561693 
v 0.0258047 -0.00515989 0.0568285 
v 0.0253996 -0.00515989 0.0575927 
v 0.0251682 -0.00515989 0.0584262 
v 0.0251213 -0.00515989 0.0592899 
v 0.0252613 -0.00515989 0.0601434 
v 0.0255814 -0.00515989 0.0609469 
v 0.0260668 -0.00515989 0.0616628 
v 0.0266948 -0.00515989 0.0622577 
v 0.0274359 -0.00515989 0.0627036 
v 0.0282556 -0.00515989 0.0629798 
vn 0.286215 -0.00538823 -0.95815 
vn 0.0627023 -0.00547297 -0.998017 
vn 0.491596 -0.00529553 -0.870807 
vn 0.286215 -0.00538823 -0.95815 
vn 0.669497 -0.00520034 -0.742797 
vn 0.491596 -0.00529553 -0.870807 
vn 0.812933 -0.00510746 -0.582335 
vn 0.669497 -0.00520034 -0.742797 
vn 0.917237 -0.00502091 -0.398309 
vn 0.812933 -0.00510746 -0.582335 
vn 0.979839 -0.00494381 -0.199726 
vn 0.917237 -0.00502091 -0.398309 
vn 0.999977 -0.00487853 0.00466533 
vn 0.979839 -0.00494381 -0.199726 
vn 0.978414 -0.00482676 0.206597 
vn 0.999977 -0.00487853 0.00466533 
vn 0.917193 -0.00478965 0.398414 
vn 0.978414 -0.00482676 0.206597 
vn 0.819441 -0.00476794 0.573144 
vn 0.917193 -0.00478965 0.398414 
vn 0.689226 -0.004762 0.72453 
vn 0.819441 -0.00476794 0.573144 
vn 0.531464 -0.00477195 0.847068 
vn 0.689226 -0.004762 0.72453 
vn 0.351849 -0.00479762 0.936045 
vn 0.531464 -0.00477195 0.847068 
vn 0.156819 -0.00483853 0.987616 
vn 0.351849 -0.00479762 0.936045 
vn -0.0464769 -0.00489385 0.998907 
vn 0.0557307 -0.00486445 0.998434 
vn 0.156819 -0.00483853 0.987616 
vn -0.250223 -0.0049623 0.968176 
vn -0.0464769 -0.00489385 0.998907 
vn -0.446014 -0.00504205 0.895012 
vn -0.250223 -0.0049623 0.968176 
vn -0.625007 -0.00513053 0.780602 
vn -0.446014 -0.00504205 0.895012 
vn -0.778183 -0.00522441 0.628016 
vn -0.625007 -0.00513053 0.780602 
vn -0.896761 -0.00531946 0.442484 
vn -0.778183 -0.00522441 0.628016 
vn -0.972799 -0.00541067 0.231589 
vn -0.896761 -0.00531946 0.442484 
vn -0.999971 -0.00549249 0.00525245 
vn -0.972799 -0.00541067 0.231589 
vn -0.974438 -0.00555927 -0.224589 
vn -0.999971 -0.00549249 0.00525245 
vn -0.895654 -0.00560589 -0.444716 
vn -0.974438 -0.00555927 -0.224589 
vn -0.766898 -0.00562852 -0.641744 
vn -0.895654 -0.00560589 -0.444716 
vn -0.595301 -0.0056252 -0.803483 
vn -0.766898 -0.00562852 -0.641744 
vn -0.391282 -0.00559623 -0.920254 
vn -0.595301 -0.0056252 -0.803483 
vn -0.167459 -0.00554407 -0.985863 
vn -0.391282 -0.00559623 -0.920254 
vn 0.0586098 -0.996561 0.058568 
vn 0.0557307 -0.00486445 0.998434 
vn 0.25583 -0.00481621 0.96671 
vn 0.444002 -0.00478284 0.896013 
vn 0.61345 -0.004765 0.789719 
vn 0.758103 -0.00476298 0.652117 
vn 0.87265 -0.00477684 0.488323 
vn 0.952589 -0.00480632 0.304222 
vn 0.994308 -0.00485088 0.106432 
vn 0.995201 -0.00490958 -0.0977261 
vn 0.953838 -0.00498101 -0.300281 
vn 0.870183 -0.00506318 -0.492703 
vn 0.745867 -0.00515334 -0.666075 
vn 0.584474 -0.00524793 -0.811395 
vn 0.391811 -0.00534252 -0.92003 
vn 0.176052 -0.00543195 -0.984366 
vn -0.052334 -0.00551057 -0.998614 
vn 0.0627023 -0.00547297 -0.998017 
vn 0.176052 -0.00543195 -0.984366 
vn -0.052334 -0.00551057 -0.998614 
vn -0.281008 -0.00557282 -0.959689 
vn -0.496592 -0.00561382 -0.867966 
vn -0.68587 -0.00563014 -0.727702 
vn -0.837163 -0.00562038 -0.546924 
vn -0.94159 -0.00558538 -0.336715 
vn -0.993912 -0.0055281 -0.110038 
vn -0.992802 -0.00545311 0.119646 
vn -0.94054 -0.00536588 0.33964 
vn -0.842321 -0.00527208 0.53895 
vn -0.705383 -0.00517704 0.708807 
vn -0.538174 -0.00508539 0.842818 
vn -0.349657 -0.00500091 0.936864 
vn -0.148806 -0.00492653 0.988854 
vn 0.0592135 0.99649 0.0591713 
usemtl 0.647059_0.647059_0.647059_0.000000_0.000000
o mesh264
f 7284//7687 7285//7688 7286//7688 
f 7287//7689 7284//7687 7288//7690 
f 7289//7691 7287//7689 7290//7692 
f 7291//7693 7289//7691 7292//7694 
f 7293//7695 7291//7693 7294//7696 
f 7295//7697 7293//7695 7296//7698 
f 7297//7699 7295//7697 7298//7700 
f 7299//7701 7297//7699 7300//7702 
f 7301//7703 7299//7701 7302//7704 
f 7303//7705 7301//7703 7304//7706 
f 7305//7707 7303//7705 7306//7708 
f 7307//7709 7305//7707 7308//7710 
f 7309//7711 7307//7709 7310//7712 
f 7311//7713 7309//7711 7312//7714 
f 7313//7715 7314//7716 7315//7716 
f 7316//7717 7315//7716 7314//7716 
f 7314//7716 7311//7713 7316//7717 
f 7317//7718 7313//7715 7318//7719 
f 7319//7720 7317//7718 7320//7721 
f 7321//7722 7319//7720 7322//7723 
f 7323//7724 7321//7722 7324//7725 
f 7325//7726 7323//7724 7326//7727 
f 7327//7728 7325//7726 7328//7729 
f 7329//7730 7327//7728 7330//7731 
f 7331//7732 7329//7730 7332//7733 
f 7333//7734 7331//7732 7334//7735 
f 7335//7736 7333//7734 7336//7737 
f 7337//7738 7335//7736 7338//7739 
f 7339//7740 7337//7738 7340//7741 
f 7341//7742 7339//7740 7342//7743 
f 7285//7688 7341//7742 7343//7742 
f 7343//7742 7286//7688 7285//7688 
f 7342//7743 7343//7742 7341//7742 
f 7340//7741 7342//7743 7339//7740 
f 7338//7739 7340//7741 7337//7738 
f 7336//7737 7338//7739 7335//7736 
f 7334//7735 7336//7737 7333//7734 
f 7332//7733 7334//7735 7331//7732 
f 7330//7731 7332//7733 7329//7730 
f 7328//7729 7330//7731 7327//7728 
f 7326//7727 7328//7729 7325//7726 
f 7324//7725 7326//7727 7323//7724 
f 7322//7723 7324//7725 7321//7722 
f 7320//7721 7322//7723 7319//7720 
f 7318//7719 7320//7721 7317//7718 
f 7315//7716 7318//7719 7313//7715 
f 7312//7714 7316//7717 7311//7713 
f 7310//7712 7312//7714 7309//7711 
f 7308//7710 7310//7712 7307//7709 
f 7306//7708 7308//7710 7305//7707 
f 7304//7706 7306//7708 7303//7705 
f 7302//7704 7304//7706 7301//7703 
f 7300//7702 7302//7704 7299//7701 
f 7298//7700 7300//7702 7297//7699 
f 7296//7698 7298//7700 7295//7697 
f 7294//7696 7296//7698 7293//7695 
f 7292//7694 7294//7696 7291//7693 
f 7290//7692 7292//7694 7289//7691 
f 7288//7690 7290//7692 7287//7689 
f 7286//7688 7288//7690 7284//7687 
o mesh265
f 7344//7744 7345//7744 7340//7744 
f 7345//7744 7346//7744 7342//7744 
f 7346//7744 7347//7744 7343//7744 
f 7347//7744 7348//7744 7286//7744 
f 7349//7744 7318//7744 7315//7744 
f 7350//7744 7320//7744 7318//7744 
f 7351//7744 7336//7744 7334//7744 
f 7351//7744 7344//7744 7338//7744 
f 7342//7744 7340//7744 7345//7744 
f 7286//7744 7343//7744 7347//7744 
f 7352//7744 7294//7744 7292//7744 
f 7352//7744 7353//7744 7296//7744 
f 7354//7744 7310//7744 7308//7744 
f 7355//7744 7312//7744 7310//7744 
f 7355//7744 7356//7744 7316//7744 
f 7357//7744 7315//7744 7316//7744 
f 7318//7744 7349//7744 7350//7744 
f 7358//7744 7322//7744 7320//7744 
f 7358//7744 7359//7744 7324//7744 
f 7359//7744 7360//7744 7326//7744 
f 7361//7744 7328//7744 7326//7744 
f 7361//7744 7362//7744 7330//7744 
f 7363//7744 7334//7744 7332//7744 
f 7338//7744 7336//7744 7351//7744 
f 7343//7744 7342//7744 7346//7744 
f 7348//7744 7364//7744 7288//7744 
f 7365//7744 7292//7744 7290//7744 
f 7296//7744 7294//7744 7352//7744 
f 7366//7744 7306//7744 7304//7744 
f 7366//7744 7367//7744 7308//7744 
f 7310//7744 7354//7744 7355//7744 
f 7316//7744 7356//7744 7357//7744 
f 7320//7744 7350//7744 7358//7744 
f 7326//7744 7324//7744 7359//7744 
f 7330//7744 7328//7744 7361//7744 
f 7362//7744 7368//7744 7332//7744 
f 7334//7744 7363//7744 7351//7744 
f 7288//7744 7286//7744 7348//7744 
f 7369//7744 7290//7744 7288//7744 
f 7292//7744 7365//7744 7352//7744 
f 7370//7744 7300//7744 7298//7744 
f 7370//7744 7371//7744 7302//7744 
f 7308//7744 7306//7744 7366//7744 
f 7316//7744 7312//7744 7355//7744 
f 7324//7744 7322//7744 7358//7744 
f 7332//7744 7330//7744 7362//7744 
f 7340//7744 7338//7744 7344//7744 
f 7290//7744 7369//7744 7365//7744 
f 7372//7744 7298//7744 7296//7744 
f 7302//7744 7300//7744 7370//7744 
f 7373//7744 7304//7744 7302//7744 
f 7308//7744 7367//7744 7354//7744 
f 7326//7744 7360//7744 7361//7744 
f 7288//7744 7364//7744 7369//7744 
f 7298//7744 7372//7744 7370//7744 
f 7304//7744 7373//7744 7366//7744 
f 7332//7744 7368//7744 7363//7744 
f 7302//7744 7371//7744 7373//7744 
f 7296//7744 7353//7744 7372//7744 
f 7315//7744 7357//7744 7349//7744 
o mesh266
f 7374//7745 7348//7745 7347//7746 
f 7375//7746 7347//7746 7346//7747 
f 7376//7747 7346//7747 7345//7748 
f 7377//7748 7345//7748 7344//7749 
f 7378//7749 7344//7749 7351//7750 
f 7379//7750 7351//7750 7363//7751 
f 7380//7751 7363//7751 7368//7752 
f 7381//7752 7368//7752 7362//7753 
f 7382//7753 7362//7753 7361//7754 
f 7383//7754 7361//7754 7360//7755 
f 7384//7755 7360//7755 7359//7756 
f 7385//7756 7359//7756 7358//7757 
f 7386//7757 7358//7757 7350//7758 
f 7387//7758 7350//7758 7349//7759 
f 7388//7760 7389//7761 7357//7761 
f 7349//7759 7357//7761 7389//7761 
f 7389//7761 7390//7762 7349//7759 
f 7388//7760 7356//7763 7355//7764 
f 7391//7764 7355//7764 7354//7765 
f 7392//7765 7354//7765 7367//7766 
f 7393//7766 7367//7766 7366//7767 
f 7394//7767 7366//7767 7373//7768 
f 7395//7768 7373//7768 7371//7769 
f 7396//7769 7371//7769 7370//7770 
f 7397//7770 7370//7770 7372//7771 
f 7398//7771 7372//7771 7353//7772 
f 7399//7772 7353//7772 7352//7773 
f 7400//7773 7352//7773 7365//7774 
f 7401//7774 7365//7774 7369//7775 
f 7402//7775 7369//7775 7364//7776 
f 7403//7776 7364//7776 7348//7745 
f 7348//7745 7374//7745 7403//7776 
f 7364//7776 7403//7776 7402//7775 
f 7369//7775 7402//7775 7401//7774 
f 7365//7774 7401//7774 7400//7773 
f 7352//7773 7400//7773 7399//7772 
f 7353//7772 7399//7772 7398//7771 
f 7372//7771 7398//7771 7397//7770 
f 7370//7770 7397//7770 7396//7769 
f 7371//7769 7396//7769 7395//7768 
f 7373//7768 7395//7768 7394//7767 
f 7366//7767 7394//7767 7393//7766 
f 7367//7766 7393//7766 7392//7765 
f 7354//7765 7392//7765 7391//7764 
f 7355//7764 7391//7764 7388//7760 
f 7357//7761 7356//7763 7388//7760 
f 7349//7759 7390//7762 7387//7758 
f 7350//7758 7387//7758 7386//7757 
f 7358//7757 7386//7757 7385//7756 
f 7359//7756 7385//7756 7384//7755 
f 7360//7755 7384//7755 7383//7754 
f 7361//7754 7383//7754 7382//7753 
f 7362//7753 7382//7753 7381//7752 
f 7368//7752 7381//7752 7380//7751 
f 7363//7751 7380//7751 7379//7750 
f 7351//7750 7379//7750 7378//7749 
f 7344//7749 7378//7749 7377//7748 
f 7345//7748 7377//7748 7376//7747 
f 7346//7747 7376//7747 7375//7746 
f 7347//7746 7375//7746 7374//7745 
o mesh267
f 7390//7777 7389//7777 7314//7777 
f 7389//7777 7388//7777 7311//7777 
f 7387//7777 7390//7777 7313//7777 
f 7311//7777 7314//7777 7389//7777 
f 7375//7777 7341//7777 7285//7777 
f 7376//7777 7339//7777 7341//7777 
f 7314//7777 7313//7777 7390//7777 
f 7391//7777 7309//7777 7311//7777 
f 7341//7777 7375//7777 7376//7777 
f 7377//7777 7337//7777 7339//7777 
f 7379//7777 7333//7777 7335//7777 
f 7379//7777 7380//7777 7331//7777 
f 7386//7777 7387//7777 7317//7777 
f 7311//7777 7388//7777 7391//7777 
f 7391//7777 7392//7777 7307//7777 
f 7392//7777 7393//7777 7305//7777 
f 7339//7777 7376//7777 7377//7777 
f 7378//7777 7335//7777 7337//7777 
f 7331//7777 7333//7777 7379//7777 
f 7380//7777 7381//7777 7329//7777 
f 7383//7777 7325//7777 7327//7777 
f 7383//7777 7384//7777 7323//7777 
f 7385//7777 7321//7777 7323//7777 
f 7385//7777 7386//7777 7319//7777 
f 7313//7777 7317//7777 7387//7777 
f 7305//7777 7307//7777 7392//7777 
f 7337//7777 7377//7777 7378//7777 
f 7329//7777 7331//7777 7380//7777 
f 7382//7777 7327//7777 7329//7777 
f 7323//7777 7325//7777 7383//7777 
f 7319//7777 7321//7777 7385//7777 
f 7307//7777 7309//7777 7391//7777 
f 7394//7777 7303//7777 7305//7777 
f 7394//7777 7395//7777 7301//7777 
f 7335//7777 7378//7777 7379//7777 
f 7327//7777 7382//7777 7383//7777 
f 7317//7777 7319//7777 7386//7777 
f 7301//7777 7303//7777 7394//7777 
f 7400//7777 7291//7777 7293//7777 
f 7400//7777 7401//7777 7289//7777 
f 7329//7777 7381//7777 7382//7777 
f 7305//7777 7393//7777 7394//7777 
f 7397//7777 7297//7777 7299//7777 
f 7397//7777 7398//7777 7295//7777 
f 7289//7777 7291//7777 7400//7777 
f 7401//7777 7402//7777 7287//7777 
f 7323//7777 7384//7777 7385//7777 
f 7395//7777 7396//7777 7299//7777 
f 7295//7777 7297//7777 7397//7777 
f 7398//7777 7399//7777 7293//7777 
f 7287//7777 7289//7777 7401//7777 
f 7402//7777 7403//7777 7284//7777 
f 7299//7777 7301//7777 7395//7777 
f 7293//7777 7295//7777 7398//7777 
f 7284//7777 7287//7777 7402//7777 
f 7374//7777 7285//7777 7284//7777 
f 7299//7777 7396//7777 7397//7777 
f 7284//7777 7403//7777 7374//7777 
f 7293//7777 7399//7777 7400//7777 
f 7285//7777 7374//7777 7375//7777 
g 1mmSpacer
v 0.0284706 -0.00515989 -0.0259968 
v 0.0291155 -0.00515989 -0.0259267 
v 0.0291155 -0.00615989 -0.0259267 
v 0.0278558 -0.00515989 -0.026204 
v 0.0284706 -0.00615989 -0.0259968 
v 0.0273 -0.00515989 -0.0265384 
v 0.0278558 -0.00615989 -0.026204 
v 0.026829 -0.00515989 -0.0269845 
v 0.0273 -0.00615989 -0.0265384 
v 0.0264649 -0.00515989 -0.0275215 
v 0.026829 -0.00615989 -0.0269845 
v 0.0262248 -0.00515989 -0.0281241 
v 0.0264649 -0.00615989 -0.0275215 
v 0.0261199 -0.00515989 -0.0287643 
v 0.0262248 -0.00615989 -0.0281241 
v 0.026155 -0.00515989 -0.029412 
v 0.0261199 -0.00615989 -0.0287643 
v 0.0263285 -0.00515989 -0.0300371 
v 0.026155 -0.00615989 -0.029412 
v 0.0266324 -0.00515989 -0.0306103 
v 0.0263285 -0.00615989 -0.0300371 
v 0.0270524 -0.00515989 -0.0311047 
v 0.0266324 -0.00615989 -0.0306103 
v 0.0275688 -0.00515989 -0.0314973 
v 0.0270524 -0.00615989 -0.0311047 
v 0.0281576 -0.00515989 -0.0317697 
v 0.0275688 -0.00615989 -0.0314973 
v 0.0287911 -0.00515989 -0.0319091 
v 0.0281576 -0.00615989 -0.0317697 
v 0.0294398 -0.00515989 -0.0319091 
v 0.0291155 -0.00515989 -0.0319267 
v 0.0291155 -0.00615989 -0.0319267 
v 0.0287911 -0.00615989 -0.0319091 
v 0.0300734 -0.00515989 -0.0317697 
v 0.0294398 -0.00615989 -0.0319091 
v 0.0306621 -0.00515989 -0.0314973 
v 0.0300734 -0.00615989 -0.0317697 
v 0.0311786 -0.00515989 -0.0311047 
v 0.0306621 -0.00615989 -0.0314973 
v 0.0315985 -0.00515989 -0.0306103 
v 0.0311786 -0.00615989 -0.0311047 
v 0.0319024 -0.00515989 -0.0300371 
v 0.0315985 -0.00615989 -0.0306103 
v 0.032076 -0.00515989 -0.029412 
v 0.0319024 -0.00615989 -0.0300371 
v 0.0321111 -0.00515989 -0.0287643 
v 0.032076 -0.00615989 -0.029412 
v 0.0320061 -0.00515989 -0.0281241 
v 0.0321111 -0.00615989 -0.0287643 
v 0.031766 -0.00515989 -0.0275215 
v 0.0320061 -0.00615989 -0.0281241 
v 0.031402 -0.00515989 -0.0269845 
v 0.031766 -0.00615989 -0.0275215 
v 0.030931 -0.00515989 -0.0265384 
v 0.031402 -0.00615989 -0.0269845 
v 0.0303751 -0.00515989 -0.026204 
v 0.030931 -0.00615989 -0.0265384 
v 0.0297604 -0.00515989 -0.0259968 
v 0.0303751 -0.00615989 -0.026204 
v 0.0297604 -0.00615989 -0.0259968 
v 0.0321641 -0.00615989 -0.0263372 
v 0.0315362 -0.00615989 -0.0257423 
v 0.030795 -0.00615989 -0.0252964 
v 0.0299754 -0.00615989 -0.0250202 
v 0.0291155 -0.00615989 -0.0249267 
v 0.029548 -0.00615989 -0.0329033 
v 0.0303927 -0.00615989 -0.0327173 
v 0.0326495 -0.00615989 -0.0270531 
v 0.0260668 -0.00615989 -0.0263372 
v 0.0255814 -0.00615989 -0.0270531 
v 0.0270533 -0.00615989 -0.0323541 
v 0.0278383 -0.00615989 -0.0327173 
v 0.028683 -0.00615989 -0.0329033 
v 0.0291155 -0.00615989 -0.0329267 
v 0.0311777 -0.00615989 -0.0323541 
v 0.0318663 -0.00615989 -0.0318307 
v 0.0324262 -0.00615989 -0.0311715 
v 0.0328314 -0.00615989 -0.0304073 
v 0.0330628 -0.00615989 -0.0295738 
v 0.0329697 -0.00615989 -0.0278566 
v 0.0282556 -0.00615989 -0.0250202 
v 0.0266948 -0.00615989 -0.0257423 
v 0.0258047 -0.00615989 -0.0311715 
v 0.0263647 -0.00615989 -0.0318307 
v 0.0331096 -0.00615989 -0.0287101 
v 0.0274359 -0.00615989 -0.0252964 
v 0.0251213 -0.00615989 -0.0287101 
v 0.0251682 -0.00615989 -0.0295738 
v 0.0252613 -0.00615989 -0.0278566 
v 0.0253996 -0.00615989 -0.0304073 
v 0.0291155 -0.00515989 -0.0249267 
v 0.0299754 -0.00515989 -0.0250202 
v 0.030795 -0.00515989 -0.0252964 
v 0.0315362 -0.00515989 -0.0257423 
v 0.0321641 -0.00515989 -0.0263372 
v 0.0326495 -0.00515989 -0.0270531 
v 0.0329697 -0.00515989 -0.0278566 
v 0.0331096 -0.00515989 -0.0287101 
v 0.0330628 -0.00515989 -0.0295738 
v 0.0328314 -0.00515989 -0.0304073 
v 0.0324262 -0.00515989 -0.0311715 
v 0.0318663 -0.00515989 -0.0318307 
v 0.0311777 -0.00515989 -0.0323541 
v 0.0303927 -0.00515989 -0.0327173 
v 0.028683 -0.00515989 -0.0329033 
v 0.0291155 -0.00515989 -0.0329267 
v 0.029548 -0.00515989 -0.0329033 
v 0.0278383 -0.00515989 -0.0327173 
v 0.0270533 -0.00515989 -0.0323541 
v 0.0263647 -0.00515989 -0.0318307 
v 0.0258047 -0.00515989 -0.0311715 
v 0.0253996 -0.00515989 -0.0304073 
v 0.0251682 -0.00515989 -0.0295738 
v 0.0251213 -0.00515989 -0.0287101 
v 0.0252613 -0.00515989 -0.0278566 
v 0.0255814 -0.00515989 -0.0270531 
v 0.0260668 -0.00515989 -0.0263372 
v 0.0266948 -0.00515989 -0.0257423 
v 0.0274359 -0.00515989 -0.0252964 
v 0.0282556 -0.00515989 -0.0250202 
vn 0.262976 -0.00495075 -0.96479 
vn 0.0573582 -0.00500651 -0.998341 
vn 0.455368 -0.00490528 -0.89029 
vn 0.262976 -0.00495075 -0.96479 
vn 0.627145 -0.00487137 -0.778887 
vn 0.455368 -0.00490528 -0.89029 
vn 0.771936 -0.00484989 -0.635681 
vn 0.627145 -0.00487137 -0.778887 
vn 0.884437 -0.00484136 -0.466634 
vn 0.771936 -0.00484989 -0.635681 
vn 0.960447 -0.00484597 -0.278419 
vn 0.884437 -0.00484136 -0.466634 
vn 0.996918 -0.00486361 -0.078296 
vn 0.960447 -0.00484597 -0.278419 
vn 0.992017 -0.00489387 0.126006 
vn 0.996918 -0.00486361 -0.078296 
vn 0.945217 -0.004936 0.326406 
vn 0.992017 -0.00489387 0.126006 
vn 0.857406 -0.00498884 0.514616 
vn 0.945217 -0.004936 0.326406 
vn 0.731026 -0.0050508 0.682331 
vn 0.857406 -0.00498884 0.514616 
vn 0.570199 -0.00511976 0.82149 
vn 0.731026 -0.0050508 0.682331 
vn 0.380846 -0.00519301 0.924624 
vn 0.570199 -0.00511976 0.82149 
vn 0.170716 -0.00526732 0.985306 
vn 0.380846 -0.00519301 0.924624 
vn -0.0507037 -0.00533892 0.998699 
vn 0.0607631 -0.0053037 0.998138 
vn 0.170716 -0.00526732 0.985306 
vn -0.272482 -0.00540375 0.962146 
vn -0.0507037 -0.00533892 0.998699 
vn -0.482786 -0.00545774 0.875722 
vn -0.272482 -0.00540375 0.962146 
vn -0.669674 -0.00549719 0.742635 
vn -0.482786 -0.00545774 0.875722 
vn -0.822094 -0.00551921 0.569325 
vn -0.669674 -0.00549719 0.742635 
vn -0.930926 -0.00552212 0.365165 
vn -0.822094 -0.00551921 0.569325 
vn -0.989886 -0.00550571 0.141759 
vn -0.930926 -0.00552212 0.365165 
vn -0.996099 -0.00547122 -0.0880775 
vn -0.989886 -0.00550571 0.141759 
vn -0.950241 -0.00542122 -0.311469 
vn -0.996099 -0.00547122 -0.0880775 
vn -0.856242 -0.00535921 -0.516547 
vn -0.950241 -0.00542122 -0.311469 
vn -0.720666 -0.00528921 -0.693262 
vn -0.856242 -0.00535921 -0.516547 
vn -0.551922 -0.0052153 -0.833879 
vn -0.720666 -0.00528921 -0.693262 
vn -0.359478 -0.00514136 -0.933139 
vn -0.551922 -0.0052153 -0.833879 
vn -0.153164 -0.00507081 -0.988188 
vn -0.359478 -0.00514136 -0.933139 
vn 0.0586863 -0.997863 -0.0287167 
vn 0.0607631 -0.0053037 0.998138 
vn 0.277824 -0.00523026 0.960618 
vn 0.478647 -0.00515604 0.877992 
vn 0.654591 -0.00508456 0.755966 
vn 0.798821 -0.0050188 0.601548 
vn 0.906323 -0.00496117 0.422556 
vn 0.973834 -0.00491351 0.227209 
vn 0.999704 -0.0048772 0.0238309 
vn 0.983769 -0.00485318 -0.179373 
vn 0.927222 -0.00484202 -0.374481 
vn 0.832512 -0.00484399 -0.553986 
vn 0.703271 -0.00485904 -0.710905 
vn 0.544256 -0.00488681 -0.838905 
vn 0.36131 -0.00492664 -0.932433 
vn 0.161321 -0.00497744 -0.986889 
vn -0.0478433 -0.00503773 -0.998842 
vn 0.0573582 -0.00500651 -0.998341 
vn 0.161321 -0.00497744 -0.986889 
vn -0.0478433 -0.00503773 -0.998842 
vn -0.257442 -0.00510547 -0.96628 
vn -0.45805 -0.00517811 -0.888911 
vn -0.639864 -0.00525249 -0.76847 
vn -0.793159 -0.00532495 -0.608991 
vn -0.908902 -0.00539148 -0.416975 
vn -0.979503 -0.00544796 -0.201356 
vn -0.999625 -0.00549059 0.026828 
vn -0.966904 -0.00551629 0.255082 
vn -0.882427 -0.0055231 0.470417 
vn -0.750819 -0.00551051 0.660485 
vn -0.579881 -0.00547949 0.814683 
vn -0.379823 -0.00543235 0.925043 
vn -0.162275 -0.00537244 0.986731 
vn 0.0592925 0.997819 -0.0290133 
o mesh264
f 7404//7778 7405//7779 7406//7779 
f 7407//7780 7404//7778 7408//7781 
f 7409//7782 7407//7780 7410//7783 
f 7411//7784 7409//7782 7412//7785 
f 7413//7786 7411//7784 7414//7787 
f 7415//7788 7413//7786 7416//7789 
f 7417//7790 7415//7788 7418//7791 
f 7419//7792 7417//7790 7420//7793 
f 7421//7794 7419//7792 7422//7795 
f 7423//7796 7421//7794 7424//7797 
f 7425//7798 7423//7796 7426//7799 
f 7427//7800 7425//7798 7428//7801 
f 7429//7802 7427//7800 7430//7803 
f 7431//7804 7429//7802 7432//7805 
f 7433//7806 7434//7807 7435//7807 
f 7436//7808 7435//7807 7434//7807 
f 7434//7807 7431//7804 7436//7808 
f 7437//7809 7433//7806 7438//7810 
f 7439//7811 7437//7809 7440//7812 
f 7441//7813 7439//7811 7442//7814 
f 7443//7815 7441//7813 7444//7816 
f 7445//7817 7443//7815 7446//7818 
f 7447//7819 7445//7817 7448//7820 
f 7449//7821 7447//7819 7450//7822 
f 7451//7823 7449//7821 7452//7824 
f 7453//7825 7451//7823 7454//7826 
f 7455//7827 7453//7825 7456//7828 
f 7457//7829 7455//7827 7458//7830 
f 7459//7831 7457//7829 7460//7832 
f 7461//7833 7459//7831 7462//7834 
f 7405//7779 7461//7833 7463//7833 
f 7463//7833 7406//7779 7405//7779 
f 7462//7834 7463//7833 7461//7833 
f 7460//7832 7462//7834 7459//7831 
f 7458//7830 7460//7832 7457//7829 
f 7456//7828 7458//7830 7455//7827 
f 7454//7826 7456//7828 7453//7825 
f 7452//7824 7454//7826 7451//7823 
f 7450//7822 7452//7824 7449//7821 
f 7448//7820 7450//7822 7447//7819 
f 7446//7818 7448//7820 7445//7817 
f 7444//7816 7446//7818 7443//7815 
f 7442//7814 7444//7816 7441//7813 
f 7440//7812 7442//7814 7439//7811 
f 7438//7810 7440//7812 7437//7809 
f 7435//7807 7438//7810 7433//7806 
f 7432//7805 7436//7808 7431//7804 
f 7430//7803 7432//7805 7429//7802 
f 7428//7801 7430//7803 7427//7800 
f 7426//7799 7428//7801 7425//7798 
f 7424//7797 7426//7799 7423//7796 
f 7422//7795 7424//7797 7421//7794 
f 7420//7793 7422//7795 7419//7792 
f 7418//7791 7420//7793 7417//7790 
f 7416//7789 7418//7791 7415//7788 
f 7414//7787 7416//7789 7413//7786 
f 7412//7785 7414//7787 7411//7784 
f 7410//7783 7412//7785 7409//7782 
f 7408//7781 7410//7783 7407//7780 
f 7406//7779 7408//7781 7404//7778 
o mesh265
f 7464//7835 7465//7835 7460//7835 
f 7465//7835 7466//7835 7462//7835 
f 7466//7835 7467//7835 7463//7835 
f 7467//7835 7468//7835 7406//7835 
f 7469//7835 7438//7835 7435//7835 
f 7470//7835 7440//7835 7438//7835 
f 7471//7835 7456//7835 7454//7835 
f 7471//7835 7464//7835 7458//7835 
f 7462//7835 7460//7835 7465//7835 
f 7406//7835 7463//7835 7467//7835 
f 7472//7835 7414//7835 7412//7835 
f 7472//7835 7473//7835 7416//7835 
f 7474//7835 7430//7835 7428//7835 
f 7475//7835 7432//7835 7430//7835 
f 7475//7835 7476//7835 7436//7835 
f 7477//7835 7435//7835 7436//7835 
f 7438//7835 7469//7835 7470//7835 
f 7478//7835 7442//7835 7440//7835 
f 7478//7835 7479//7835 7444//7835 
f 7479//7835 7480//7835 7446//7835 
f 7481//7835 7448//7835 7446//7835 
f 7481//7835 7482//7835 7450//7835 
f 7483//7835 7454//7835 7452//7835 
f 7458//7835 7456//7835 7471//7835 
f 7463//7835 7462//7835 7466//7835 
f 7468//7835 7484//7835 7408//7835 
f 7485//7835 7412//7835 7410//7835 
f 7416//7835 7414//7835 7472//7835 
f 7486//7835 7426//7835 7424//7835 
f 7486//7835 7487//7835 7428//7835 
f 7430//7835 7474//7835 7475//7835 
f 7436//7835 7476//7835 7477//7835 
f 7440//7835 7470//7835 7478//7835 
f 7446//7835 7444//7835 7479//7835 
f 7450//7835 7448//7835 7481//7835 
f 7482//7835 7488//7835 7452//7835 
f 7454//7835 7483//7835 7471//7835 
f 7408//7835 7406//7835 7468//7835 
f 7489//7835 7410//7835 7408//7835 
f 7412//7835 7485//7835 7472//7835 
f 7490//7835 7420//7835 7418//7835 
f 7490//7835 7491//7835 7422//7835 
f 7428//7835 7426//7835 7486//7835 
f 7436//7835 7432//7835 7475//7835 
f 7444//7835 7442//7835 7478//7835 
f 7452//7835 7450//7835 7482//7835 
f 7460//7835 7458//7835 7464//7835 
f 7410//7835 7489//7835 7485//7835 
f 7492//7835 7418//7835 7416//7835 
f 7422//7835 7420//7835 7490//7835 
f 7493//7835 7424//7835 7422//7835 
f 7428//7835 7487//7835 7474//7835 
f 7446//7835 7480//7835 7481//7835 
f 7408//7835 7484//7835 7489//7835 
f 7418//7835 7492//7835 7490//7835 
f 7424//7835 7493//7835 7486//7835 
f 7452//7835 7488//7835 7483//7835 
f 7422//7835 7491//7835 7493//7835 
f 7416//7835 7473//7835 7492//7835 
f 7435//7835 7477//7835 7469//7835 
o mesh266
f 7494//7836 7468//7836 7467//7837 
f 7495//7837 7467//7837 7466//7838 
f 7496//7838 7466//7838 7465//7839 
f 7497//7839 7465//7839 7464//7840 
f 7498//7840 7464//7840 7471//7841 
f 7499//7841 7471//7841 7483//7842 
f 7500//7842 7483//7842 7488//7843 
f 7501//7843 7488//7843 7482//7844 
f 7502//7844 7482//7844 7481//7845 
f 7503//7845 7481//7845 7480//7846 
f 7504//7846 7480//7846 7479//7847 
f 7505//7847 7479//7847 7478//7848 
f 7506//7848 7478//7848 7470//7849 
f 7507//7849 7470//7849 7469//7850 
f 7508//7851 7509//7852 7477//7852 
f 7469//7850 7477//7852 7509//7852 
f 7509//7852 7510//7853 7469//7850 
f 7508//7851 7476//7854 7475//7855 
f 7511//7855 7475//7855 7474//7856 
f 7512//7856 7474//7856 7487//7857 
f 7513//7857 7487//7857 7486//7858 
f 7514//7858 7486//7858 7493//7859 
f 7515//7859 7493//7859 7491//7860 
f 7516//7860 7491//7860 7490//7861 
f 7517//7861 7490//7861 7492//7862 
f 7518//7862 7492//7862 7473//7863 
f 7519//7863 7473//7863 7472//7864 
f 7520//7864 7472//7864 7485//7865 
f 7521//7865 7485//7865 7489//7866 
f 7522//7866 7489//7866 7484//7867 
f 7523//7867 7484//7867 7468//7836 
f 7468//7836 7494//7836 7523//7867 
f 7484//7867 7523//7867 7522//7866 
f 7489//7866 7522//7866 7521//7865 
f 7485//7865 7521//7865 7520//7864 
f 7472//7864 7520//7864 7519//7863 
f 7473//7863 7519//7863 7518//7862 
f 7492//7862 7518//7862 7517//7861 
f 7490//7861 7517//7861 7516//7860 
f 7491//7860 7516//7860 7515//7859 
f 7493//7859 7515//7859 7514//7858 
f 7486//7858 7514//7858 7513//7857 
f 7487//7857 7513//7857 7512//7856 
f 7474//7856 7512//7856 7511//7855 
f 7475//7855 7511//7855 7508//7851 
f 7477//7852 7476//7854 7508//7851 
f 7469//7850 7510//7853 7507//7849 
f 7470//7849 7507//7849 7506//7848 
f 7478//7848 7506//7848 7505//7847 
f 7479//7847 7505//7847 7504//7846 
f 7480//7846 7504//7846 7503//7845 
f 7481//7845 7503//7845 7502//7844 
f 7482//7844 7502//7844 7501//7843 
f 7488//7843 7501//7843 7500//7842 
f 7483//7842 7500//7842 7499//7841 
f 7471//7841 7499//7841 7498//7840 
f 7464//7840 7498//7840 7497//7839 
f 7465//7839 7497//7839 7496//7838 
f 7466//7838 7496//7838 7495//7837 
f 7467//7837 7495//7837 7494//7836 
o mesh267
f 7510//7868 7509//7868 7434//7868 
f 7509//7868 7508//7868 7431//7868 
f 7507//7868 7510//7868 7433//7868 
f 7431//7868 7434//7868 7509//7868 
f 7495//7868 7461//7868 7405//7868 
f 7496//7868 7459//7868 7461//7868 
f 7434//7868 7433//7868 7510//7868 
f 7511//7868 7429//7868 7431//7868 
f 7461//7868 7495//7868 7496//7868 
f 7497//7868 7457//7868 7459//7868 
f 7499//7868 7453//7868 7455//7868 
f 7499//7868 7500//7868 7451//7868 
f 7506//7868 7507//7868 7437//7868 
f 7431//7868 7508//7868 7511//7868 
f 7511//7868 7512//7868 7427//7868 
f 7512//7868 7513//7868 7425//7868 
f 7459//7868 7496//7868 7497//7868 
f 7498//7868 7455//7868 7457//7868 
f 7451//7868 7453//7868 7499//7868 
f 7500//7868 7501//7868 7449//7868 
f 7503//7868 7445//7868 7447//7868 
f 7503//7868 7504//7868 7443//7868 
f 7505//7868 7441//7868 7443//7868 
f 7505//7868 7506//7868 7439//7868 
f 7433//7868 7437//7868 7507//7868 
f 7425//7868 7427//7868 7512//7868 
f 7457//7868 7497//7868 7498//7868 
f 7449//7868 7451//7868 7500//7868 
f 7502//7868 7447//7868 7449//7868 
f 7443//7868 7445//7868 7503//7868 
f 7439//7868 7441//7868 7505//7868 
f 7427//7868 7429//7868 7511//7868 
f 7514//7868 7423//7868 7425//7868 
f 7514//7868 7515//7868 7421//7868 
f 7455//7868 7498//7868 7499//7868 
f 7447//7868 7502//7868 7503//7868 
f 7437//7868 7439//7868 7506//7868 
f 7421//7868 7423//7868 7514//7868 
f 7520//7868 7411//7868 7413//7868 
f 7520//7868 7521//7868 7409//7868 
f 7449//7868 7501//7868 7502//7868 
f 7425//7868 7513//7868 7514//7868 
f 7517//7868 7417//7868 7419//7868 
f 7517//7868 7518//7868 7415//7868 
f 7409//7868 7411//7868 7520//7868 
f 7521//7868 7522//7868 7407//7868 
f 7443//7868 7504//7868 7505//7868 
f 7515//7868 7516//7868 7419//7868 
f 7415//7868 7417//7868 7517//7868 
f 7518//7868 7519//7868 7413//7868 
f 7407//7868 7409//7868 7521//7868 
f 7522//7868 7523//7868 7404//7868 
f 7419//7868 7421//7868 7515//7868 
f 7413//7868 7415//7868 7518//7868 
f 7404//7868 7407//7868 7522//7868 
f 7494//7868 7405//7868 7404//7868 
f 7419//7868 7516//7868 7517//7868 
f 7404//7868 7523//7868 7494//7868 
f 7413//7868 7519//7868 7520//7868 
f 7405//7868 7494//7868 7495//7868 
g bearing
v 0.166279 -0.139897 -0.0966911 
v 0.166337 -0.139359 -0.0966911 
v 0.166337 -0.139359 -0.106891 
v 0.166106 -0.140409 -0.0966911 
v 0.166279 -0.139897 -0.106891 
v 0.165828 -0.140872 -0.0966911 
v 0.166106 -0.140409 -0.106891 
v 0.165456 -0.141265 -0.0966911 
v 0.165828 -0.140872 -0.106891 
v 0.165008 -0.141568 -0.0966911 
v 0.165456 -0.141265 -0.106891 
v 0.164506 -0.141768 -0.0966911 
v 0.165008 -0.141568 -0.106891 
v 0.163973 -0.141856 -0.0966911 
v 0.164506 -0.141768 -0.106891 
v 0.163433 -0.141826 -0.0966911 
v 0.163973 -0.141856 -0.106891 
v 0.162912 -0.141682 -0.0966911 
v 0.163433 -0.141826 -0.106891 
v 0.162434 -0.141429 -0.0966911 
v 0.162912 -0.141682 -0.106891 
v 0.162022 -0.141079 -0.0966911 
v 0.162434 -0.141429 -0.106891 
v 0.161695 -0.140648 -0.0966911 
v 0.162022 -0.141079 -0.106891 
v 0.161468 -0.140158 -0.0966911 
v 0.161695 -0.140648 -0.106891 
v 0.161352 -0.13963 -0.0966911 
v 0.161468 -0.140158 -0.106891 
v 0.161352 -0.139089 -0.0966911 
v 0.161352 -0.13963 -0.106891 
v 0.161468 -0.138561 -0.0966911 
v 0.161352 -0.139089 -0.106891 
v 0.161695 -0.13807 -0.0966911 
v 0.161468 -0.138561 -0.106891 
v 0.162022 -0.13764 -0.0966911 
v 0.161695 -0.13807 -0.106891 
v 0.162434 -0.13729 -0.0966911 
v 0.162022 -0.13764 -0.106891 
v 0.162912 -0.137037 -0.0966911 
v 0.162434 -0.13729 -0.106891 
v 0.163433 -0.136892 -0.0966911 
v 0.162912 -0.137037 -0.106891 
v 0.163973 -0.136863 -0.0966911 
v 0.163433 -0.136892 -0.106891 
v 0.164506 -0.136951 -0.0966911 
v 0.163973 -0.136863 -0.106891 
v 0.165008 -0.137151 -0.0966911 
v 0.164506 -0.136951 -0.106891 
v 0.165456 -0.137454 -0.0966911 
v 0.165008 -0.137151 -0.106891 
v 0.165828 -0.137846 -0.0966911 
v 0.165456 -0.137454 -0.106891 
v 0.166106 -0.13831 -0.0966911 
v 0.165828 -0.137846 -0.106891 
v 0.166279 -0.138822 -0.0966911 
v 0.166106 -0.13831 -0.106891 
v 0.166279 -0.138822 -0.106891 
v 0.157013 -0.132895 -0.106891 
v 0.158562 -0.131579 -0.106891 
v 0.155783 -0.134513 -0.106891 
v 0.164346 -0.129973 -0.106891 
v 0.166352 -0.130302 -0.106891 
v 0.160358 -0.130627 -0.106891 
v 0.162317 -0.130083 -0.106891 
v 0.169923 -0.132195 -0.106891 
v 0.171321 -0.133671 -0.106891 
v 0.173018 -0.137339 -0.106891 
v 0.173237 -0.139359 -0.106891 
v 0.16824 -0.131054 -0.106891 
v 0.173018 -0.14138 -0.106891 
v 0.172369 -0.135412 -0.106891 
v 0.157013 -0.145824 -0.106891 
v 0.155783 -0.144206 -0.106891 
v 0.158562 -0.14714 -0.106891 
v 0.154929 -0.136358 -0.106891 
v 0.172369 -0.143306 -0.106891 
v 0.171321 -0.145048 -0.106891 
v 0.169923 -0.146524 -0.106891 
v 0.16824 -0.147664 -0.106891 
v 0.166352 -0.148417 -0.106891 
v 0.164346 -0.148746 -0.106891 
v 0.154929 -0.142361 -0.106891 
v 0.154492 -0.140376 -0.106891 
v 0.154492 -0.138343 -0.106891 
v 0.162317 -0.148636 -0.106891 
v 0.160358 -0.148092 -0.106891 
v 0.175837 -0.139359 -0.104291 
v 0.175557 -0.13678 -0.104291 
v 0.174728 -0.134321 -0.104291 
v 0.17339 -0.132097 -0.104291 
v 0.171606 -0.130213 -0.104291 
v 0.169458 -0.128757 -0.104291 
v 0.167048 -0.127797 -0.104291 
v 0.164487 -0.127377 -0.104291 
v 0.161896 -0.127517 -0.104291 
v 0.159396 -0.128212 -0.104291 
v 0.157103 -0.129427 -0.104291 
v 0.155125 -0.131107 -0.104291 
v 0.153555 -0.133173 -0.104291 
v 0.152466 -0.135528 -0.104291 
v 0.151908 -0.138062 -0.104291 
v 0.151908 -0.140657 -0.104291 
v 0.152466 -0.143191 -0.104291 
v 0.153555 -0.145546 -0.104291 
v 0.155125 -0.147612 -0.104291 
v 0.157103 -0.149292 -0.104291 
v 0.159396 -0.150507 -0.104291 
v 0.161896 -0.151201 -0.104291 
v 0.164487 -0.151342 -0.104291 
v 0.167048 -0.150922 -0.104291 
v 0.169458 -0.149962 -0.104291 
v 0.171606 -0.148505 -0.104291 
v 0.17339 -0.146621 -0.104291 
v 0.174728 -0.144398 -0.104291 
v 0.175557 -0.141939 -0.104291 
v 0.175488 -0.136795 -0.0992911 
v 0.175767 -0.138062 -0.0992911 
v 0.174664 -0.13435 -0.0992911 
v 0.175209 -0.135528 -0.0992911 
v 0.173334 -0.13214 -0.0992911 
v 0.17412 -0.133173 -0.0992911 
v 0.17156 -0.130267 -0.0992911 
v 0.172549 -0.131107 -0.0992911 
v 0.169425 -0.128819 -0.0992911 
v 0.170572 -0.129427 -0.0992911 
v 0.167029 -0.127865 -0.0992911 
v 0.168279 -0.128212 -0.0992911 
v 0.164483 -0.127447 -0.0992911 
v 0.165779 -0.127517 -0.0992911 
v 0.161907 -0.127587 -0.0992911 
v 0.163188 -0.127377 -0.0992911 
v 0.159422 -0.128277 -0.0992911 
v 0.160627 -0.127797 -0.0992911 
v 0.157143 -0.129485 -0.0992911 
v 0.158216 -0.128757 -0.0992911 
v 0.156069 -0.130213 -0.0992911 
v 0.155176 -0.131155 -0.0992911 
v 0.154284 -0.132097 -0.0992911 
v 0.153615 -0.133209 -0.0992911 
v 0.152946 -0.134321 -0.0992911 
v 0.152532 -0.13555 -0.0992911 
v 0.151978 -0.13807 -0.0992911 
v 0.152118 -0.13678 -0.0992911 
v 0.151978 -0.140649 -0.0992911 
v 0.151837 -0.139359 -0.0992911 
v 0.152532 -0.143169 -0.0992911 
v 0.152118 -0.141939 -0.0992911 
v 0.153615 -0.14551 -0.0992911 
v 0.152946 -0.144398 -0.0992911 
v 0.155176 -0.147563 -0.0992911 
v 0.154284 -0.146621 -0.0992911 
v 0.157143 -0.149233 -0.0992911 
v 0.156069 -0.148505 -0.0992911 
v 0.159422 -0.150442 -0.0992911 
v 0.158216 -0.149962 -0.0992911 
v 0.161907 -0.151132 -0.0992911 
v 0.160627 -0.150922 -0.0992911 
v 0.164483 -0.151272 -0.0992911 
v 0.163188 -0.151342 -0.0992911 
v 0.167029 -0.150854 -0.0992911 
v 0.165779 -0.151201 -0.0992911 
v 0.169425 -0.149899 -0.0992911 
v 0.168279 -0.150507 -0.0992911 
v 0.17156 -0.148452 -0.0992911 
v 0.170572 -0.149292 -0.0992911 
v 0.173334 -0.146579 -0.0992911 
v 0.172549 -0.147612 -0.0992911 
v 0.174664 -0.144369 -0.0992911 
v 0.17412 -0.145546 -0.0992911 
v 0.175488 -0.141924 -0.0992911 
v 0.175209 -0.143191 -0.0992911 
v 0.175837 -0.139359 -0.0992911 
v 0.175767 -0.140657 -0.0992911 
v 0.154657 -0.137339 -0.0966911 
v 0.154437 -0.139359 -0.0966911 
v 0.155306 -0.135412 -0.0966911 
v 0.156354 -0.133671 -0.0966911 
v 0.157752 -0.132195 -0.0966911 
v 0.159434 -0.131054 -0.0966911 
v 0.161323 -0.130302 -0.0966911 
v 0.163328 -0.129973 -0.0966911 
v 0.165358 -0.130083 -0.0966911 
v 0.167317 -0.130627 -0.0966911 
v 0.169112 -0.131579 -0.0966911 
v 0.170662 -0.132895 -0.0966911 
v 0.171892 -0.134513 -0.0966911 
v 0.172745 -0.136358 -0.0966911 
v 0.173182 -0.138343 -0.0966911 
v 0.173237 -0.139359 -0.0966911 
v 0.173182 -0.140376 -0.0966911 
v 0.172745 -0.142361 -0.0966911 
v 0.171892 -0.144206 -0.0966911 
v 0.170662 -0.145824 -0.0966911 
v 0.169112 -0.14714 -0.0966911 
v 0.167317 -0.148092 -0.0966911 
v 0.165358 -0.148636 -0.0966911 
v 0.163328 -0.148746 -0.0966911 
v 0.161323 -0.148417 -0.0966911 
v 0.159434 -0.147664 -0.0966911 
v 0.157752 -0.146524 -0.0966911 
v 0.156354 -0.145048 -0.0966911 
v 0.155306 -0.143306 -0.0966911 
v 0.154657 -0.14138 -0.0966911 
vn -0.988788 0.0919843 -0.117629 
vn -0.980039 -0.163339 -0.113329 
vn -0.928808 0.350336 -0.120751 
vn -0.988788 0.0919843 -0.117629 
vn -0.799057 0.588706 -0.1222 
vn -0.928808 0.350336 -0.120751 
vn -0.608706 0.784003 -0.121718 
vn -0.799057 0.588706 -0.1222 
vn -0.376078 0.918864 -0.119392 
vn -0.608706 0.784003 -0.121718 
vn -0.123988 0.985525 -0.115618 
vn -0.376078 0.918864 -0.119392 
vn 0.125869 0.985824 -0.110944 
vn -0.123988 0.985525 -0.115618 
vn 0.356646 0.928218 -0.105904 
vn 0.125869 0.985824 -0.110944 
vn 0.557322 0.824141 -0.100919 
vn 0.356646 0.928218 -0.105904 
vn 0.721853 0.685318 -0.0962681 
vn 0.557322 0.824141 -0.100919 
vn 0.847718 0.522388 -0.0921148 
vn 0.721853 0.685318 -0.0962681 
vn 0.934614 0.344468 -0.0885366 
vn 0.847718 0.522388 -0.0921148 
vn 0.983528 0.159226 -0.0855593 
vn 0.934614 0.344468 -0.0885366 
vn 0.996172 -0.0268752 -0.0831805 
vn 0.983528 0.159226 -0.0855593 
vn 0.974672 -0.208304 -0.0813853 
vn 0.996172 -0.0268752 -0.0831805 
vn 0.921414 -0.380225 -0.0801559 
vn 0.974672 -0.208304 -0.0813853 
vn 0.838984 -0.538321 -0.0794775 
vn 0.921414 -0.380225 -0.0801559 
vn 0.730162 -0.678652 -0.0793409 
vn 0.838984 -0.538321 -0.0794775 
vn 0.597951 -0.797556 -0.0797443 
vn 0.730162 -0.678652 -0.0793409 
vn 0.445627 -0.891575 -0.0806931 
vn 0.597951 -0.797556 -0.0797443 
vn 0.276818 -0.9574 -0.0821997 
vn 0.445627 -0.891575 -0.0806931 
vn 0.0956186 -0.991844 -0.0842808 
vn 0.276818 -0.9574 -0.0821997 
vn -0.0932486 -0.991839 -0.0869536 
vn 0.0956186 -0.991844 -0.0842808 
vn -0.284214 -0.954506 -0.0902286 
vn -0.0932486 -0.991839 -0.0869536 
vn -0.470573 -0.877329 -0.0940964 
vn -0.284214 -0.954506 -0.0902286 
vn -0.644145 -0.758534 -0.0985093 
vn -0.470573 -0.877329 -0.0940964 
vn -0.794974 -0.597775 -0.103352 
vn -0.644145 -0.758534 -0.0985093 
vn -0.911277 -0.397268 -0.108408 
vn -0.794974 -0.597775 -0.103352 
vn 0.1466 -0.124697 -0.981305 
vn 0.729839 -0.116781 -0.673571 
vn 0.728309 0.010781 -0.685164 
vn 0.701206 0.137133 -0.699646 
vn 0.648082 0.257324 -0.71678 
vn 0.569315 0.365956 -0.736177 
vn 0.466375 0.457261 -0.757236 
vn 0.342156 0.525312 -0.779087 
vn 0.201305 0.564428 -0.800561 
vn 0.0504496 0.569834 -0.82021 
vn -0.101863 0.538533 -0.836425 
vn -0.245693 0.470234 -0.847653 
vn -0.37078 0.36802 -0.852692 
vn -0.467993 0.238407 -0.850967 
vn -0.530742 0.090601 -0.842677 
vn -0.555856 -0.0648601 -0.828744 
vn -0.543678 -0.217634 -0.810586 
vn -0.49745 -0.358789 -0.789819 
vn -0.422359 -0.481462 -0.767989 
vn -0.324566 -0.58097 -0.746412 
vn -0.210462 -0.654583 -0.726104 
vn -0.0861979 -0.701142 -0.707792 
vn 0.0425615 -0.720677 -0.691964 
vn 0.170719 -0.714086 -0.678923 
vn 0.293741 -0.682905 -0.668847 
vn 0.407618 -0.629145 -0.661834 
vn 0.508804 -0.555199 -0.657931 
vn 0.594174 -0.46379 -0.657157 
vn 0.660987 -0.357957 -0.659517 
vn 0.706873 -0.241054 -0.664999 
vn 0.994258 0.0659182 -0.0842959 
vn 0.996172 -0.0268752 -0.0831805 
vn 0.989546 -0.11849 -0.0822111 
vn 0.963724 0.252333 -0.0869726 
vn 0.983528 0.159226 -0.0855593 
vn 0.895998 0.434791 -0.0902513 
vn 0.934614 0.344468 -0.0885366 
vn 0.789677 0.60626 -0.0941229 
vn 0.847718 0.522388 -0.0921148 
vn 0.644328 0.758374 -0.098539 
vn 0.721853 0.685318 -0.0962681 
vn 0.461224 0.88124 -0.103384 
vn 0.557322 0.824141 -0.100919 
vn 0.244463 0.963576 -0.10844 
vn 0.356646 0.928218 -0.105904 
vn 0.00240964 0.993551 -0.113358 
vn 0.125869 0.985824 -0.110944 
vn -0.251026 0.960804 -0.117653 
vn -0.123988 0.985525 -0.115618 
vn -0.496287 0.859718 -0.120766 
vn -0.376078 0.918864 -0.119392 
vn -0.710485 0.693021 -0.122203 
vn -0.608706 0.784003 -0.121718 
vn -0.872329 0.473529 -0.121709 
vn -0.799057 0.588706 -0.1222 
vn -0.967677 0.222152 -0.119372 
vn -0.928808 0.350336 -0.120751 
vn -0.992595 -0.0373467 -0.115591 
vn -0.988788 0.0919843 -0.117629 
vn -0.952424 -0.283878 -0.110913 
vn -0.980039 -0.163339 -0.113329 
vn -0.85824 -0.502211 -0.105872 
vn -0.911277 -0.397268 -0.108408 
vn -0.723098 -0.683338 -0.100888 
vn -0.794974 -0.597775 -0.103352 
vn -0.559535 -0.8232 -0.09624 
vn -0.644145 -0.758534 -0.0985093 
vn -0.378442 -0.921032 -0.0920902 
vn -0.470573 -0.877329 -0.0940964 
vn -0.188858 -0.978007 -0.0885158 
vn -0.284214 -0.954506 -0.0902286 
vn 0.00181836 -0.996333 -0.0855423 
vn -0.0932486 -0.991839 -0.0869536 
vn 0.187489 -0.97874 -0.0831673 
vn 0.0956186 -0.991844 -0.0842808 
vn 0.363039 -0.928214 -0.0813757 
vn 0.276818 -0.9574 -0.0821997 
vn 0.524086 -0.847886 -0.0801499 
vn 0.445627 -0.891575 -0.0806931 
vn 0.666783 -0.741003 -0.0794749 
vn 0.597951 -0.797556 -0.0797443 
vn 0.78769 -0.610942 -0.0793418 
vn 0.730162 -0.678652 -0.0793409 
vn 0.883676 -0.461255 -0.0797486 
vn 0.838984 -0.538321 -0.0794775 
vn 0.951856 -0.295733 -0.0807009 
vn 0.921414 -0.380225 -0.0801559 
vn 0.989546 -0.11849 -0.0822111 
vn 0.974672 -0.208304 -0.0813853 
vn -0.653227 0.0156849 0.756999 
vn -0.660016 -0.0770139 0.747294 
vn -0.655365 -0.168114 0.736366 
vn -0.604119 0.199151 0.771608 
vn -0.634621 0.108334 0.765193 
vn -0.508835 0.367919 0.778282 
vn -0.561983 0.286288 0.776025 
vn -0.3737 0.508004 0.776067 
vn -0.445646 0.442329 0.778296 
vn -0.209843 0.608525 0.765286 
vn -0.294532 0.563706 0.771678 
vn -0.03102 0.663621 0.747425 
vn -0.121415 0.641901 0.757114 
vn 0.149056 0.672783 0.724669 
vn 0.0596532 0.67379 0.736511 
vn 0.318765 0.63978 0.699336 
vn 0.235818 0.661195 0.712187 
vn 0.469515 0.570974 0.673457 
vn 0.396925 0.609399 0.686356 
vn 0.595711 0.473785 0.648581 
vn 0.535928 0.525455 0.660817 
vn 0.69422 0.35564 0.625763 
vn 0.648544 0.416885 0.636866 
vn 0.763718 0.223434 0.60565 
vn 0.732624 0.290892 0.615341 
vn 0.804121 0.0833318 0.588596 
vn 0.787525 0.154014 0.596727 
vn 0.816173 -0.0592335 0.574764 
vn 0.81362 0.0120438 0.581272 
vn 0.801177 -0.199473 0.564204 
vn 0.811958 -0.129921 0.569074 
vn 0.760835 -0.333135 0.556912 
vn 0.784055 -0.267374 0.560151 
vn 0.69716 -0.456404 0.552868 
vn 0.731777 -0.396293 0.554486 
vn 0.612445 -0.565817 0.552052 
vn 0.657279 -0.513047 0.552057 
vn 0.509262 -0.658199 0.55446 
vn 0.56299 -0.614326 0.552853 
vn 0.390489 -0.730617 0.560104 
vn 0.451631 -0.697078 0.556876 
vn 0.25936 -0.780361 0.569007 
vn 0.326251 -0.758485 0.564147 
vn 0.119543 -0.804944 0.581184 
vn 0.190289 -0.795944 0.574686 
vn -0.0247612 -0.802143 0.596619 
vn 0.047665 -0.807092 0.588498 
vn -0.168693 -0.770101 0.615213 
vn -0.0971066 -0.789874 0.605532 
vn -0.3066 -0.707519 0.63672 
vn -0.238787 -0.74268 0.625626 
vn -0.431934 -0.613974 0.660658 
vn -0.371285 -0.664597 0.648428 
vn -0.537242 -0.490422 0.68619 
vn -0.487587 -0.555818 0.673294 
vn -0.614418 -0.339867 0.712025 
vn -0.579865 -0.418231 0.699171 
vn -0.639896 -0.25615 0.724513 
vn -0.655365 -0.168114 0.736366 
vn 0.176442 -0.150081 0.972802 
usemtl 0.400000_0.400000_0.400000_0.000000_0.000000
o mesh3
f 7524//7869 7525//7870 7526//7870 
f 7527//7871 7524//7869 7528//7872 
f 7529//7873 7527//7871 7530//7874 
f 7531//7875 7529//7873 7532//7876 
f 7533//7877 7531//7875 7534//7878 
f 7535//7879 7533//7877 7536//7880 
f 7537//7881 7535//7879 7538//7882 
f 7539//7883 7537//7881 7540//7884 
f 7541//7885 7539//7883 7542//7886 
f 7543//7887 7541//7885 7544//7888 
f 7545//7889 7543//7887 7546//7890 
f 7547//7891 7545//7889 7548//7892 
f 7549//7893 7547//7891 7550//7894 
f 7551//7895 7549//7893 7552//7896 
f 7553//7897 7551//7895 7554//7898 
f 7555//7899 7553//7897 7556//7900 
f 7557//7901 7555//7899 7558//7902 
f 7559//7903 7557//7901 7560//7904 
f 7561//7905 7559//7903 7562//7906 
f 7563//7907 7561//7905 7564//7908 
f 7565//7909 7563//7907 7566//7910 
f 7567//7911 7565//7909 7568//7912 
f 7569//7913 7567//7911 7570//7914 
f 7571//7915 7569//7913 7572//7916 
f 7573//7917 7571//7915 7574//7918 
f 7575//7919 7573//7917 7576//7920 
f 7577//7921 7575//7919 7578//7922 
f 7579//7923 7577//7921 7580//7924 
f 7525//7870 7579//7923 7581//7923 
f 7581//7923 7526//7870 7525//7870 
f 7580//7924 7581//7923 7579//7923 
f 7578//7922 7580//7924 7577//7921 
f 7576//7920 7578//7922 7575//7919 
f 7574//7918 7576//7920 7573//7917 
f 7572//7916 7574//7918 7571//7915 
f 7570//7914 7572//7916 7569//7913 
f 7568//7912 7570//7914 7567//7911 
f 7566//7910 7568//7912 7565//7909 
f 7564//7908 7566//7910 7563//7907 
f 7562//7906 7564//7908 7561//7905 
f 7560//7904 7562//7906 7559//7903 
f 7558//7902 7560//7904 7557//7901 
f 7556//7900 7558//7902 7555//7899 
f 7554//7898 7556//7900 7553//7897 
f 7552//7896 7554//7898 7551//7895 
f 7550//7894 7552//7896 7549//7893 
f 7548//7892 7550//7894 7547//7891 
f 7546//7890 7548//7892 7545//7889 
f 7544//7888 7546//7890 7543//7887 
f 7542//7886 7544//7888 7541//7885 
f 7540//7884 7542//7886 7539//7883 
f 7538//7882 7540//7884 7537//7881 
f 7536//7880 7538//7882 7535//7879 
f 7534//7878 7536//7880 7533//7877 
f 7532//7876 7534//7878 7531//7875 
f 7530//7874 7532//7876 7529//7873 
f 7528//7872 7530//7874 7527//7871 
f 7526//7870 7528//7872 7524//7869 
o mesh4
f 7582//7925 7562//7925 7560//7925 
f 7582//7925 7583//7925 7564//7925 
f 7584//7925 7560//7925 7558//7925 
f 7564//7925 7562//7925 7582//7925 
f 7585//7925 7570//7925 7568//7925 
f 7585//7925 7586//7925 7572//7925 
f 7560//7925 7584//7925 7582//7925 
f 7583//7925 7587//7925 7566//7925 
f 7588//7925 7568//7925 7566//7925 
f 7572//7925 7570//7925 7585//7925 
f 7589//7925 7576//7925 7574//7925 
f 7589//7925 7590//7925 7578//7925 
f 7591//7925 7581//7925 7580//7925 
f 7592//7925 7526//7925 7581//7925 
f 7566//7925 7564//7925 7583//7925 
f 7568//7925 7588//7925 7585//7925 
f 7593//7925 7574//7925 7572//7925 
f 7578//7925 7576//7925 7589//7925 
f 7581//7925 7591//7925 7592//7925 
f 7594//7925 7528//7925 7526//7925 
f 7566//7925 7587//7925 7588//7925 
f 7574//7925 7593//7925 7589//7925 
f 7595//7925 7580//7925 7578//7925 
f 7526//7925 7592//7925 7594//7925 
f 7596//7925 7548//7925 7546//7925 
f 7597//7925 7550//7925 7548//7925 
f 7572//7925 7586//7925 7593//7925 
f 7580//7925 7595//7925 7591//7925 
f 7598//7925 7546//7925 7544//7925 
f 7548//7925 7596//7925 7597//7925 
f 7599//7925 7558//7925 7556//7925 
f 7578//7925 7590//7925 7595//7925 
f 7600//7925 7530//7925 7528//7925 
f 7601//7925 7532//7925 7530//7925 
f 7602//7925 7534//7925 7532//7925 
f 7603//7925 7536//7925 7534//7925 
f 7604//7925 7538//7925 7536//7925 
f 7604//7925 7605//7925 7540//7925 
f 7546//7925 7598//7925 7596//7925 
f 7606//7925 7552//7925 7550//7925 
f 7607//7925 7554//7925 7552//7925 
f 7608//7925 7556//7925 7554//7925 
f 7558//7925 7599//7925 7584//7925 
f 7530//7925 7600//7925 7601//7925 
f 7534//7925 7602//7925 7603//7925 
f 7540//7925 7538//7925 7604//7925 
f 7609//7925 7542//7925 7540//7925 
f 7610//7925 7544//7925 7542//7925 
f 7550//7925 7597//7925 7606//7925 
f 7554//7925 7607//7925 7608//7925 
f 7528//7925 7594//7925 7600//7925 
f 7536//7925 7603//7925 7604//7925 
f 7542//7925 7609//7925 7610//7925 
f 7552//7925 7606//7925 7607//7925 
f 7532//7925 7601//7925 7602//7925 
f 7544//7925 7610//7925 7598//7925 
f 7540//7925 7605//7925 7609//7925 
f 7556//7925 7608//7925 7599//7925 
o mesh5
f 7611//7926 7592//7926 7591//7927 
f 7612//7927 7591//7927 7595//7928 
f 7613//7928 7595//7928 7590//7929 
f 7614//7929 7590//7929 7589//7930 
f 7615//7930 7589//7930 7593//7931 
f 7616//7931 7593//7931 7586//7932 
f 7617//7932 7586//7932 7585//7933 
f 7618//7933 7585//7933 7588//7934 
f 7619//7934 7588//7934 7587//7935 
f 7620//7935 7587//7935 7583//7936 
f 7621//7936 7583//7936 7582//7937 
f 7622//7937 7582//7937 7584//7938 
f 7623//7938 7584//7938 7599//7939 
f 7624//7939 7599//7939 7608//7940 
f 7625//7940 7608//7940 7607//7941 
f 7626//7941 7607//7941 7606//7942 
f 7627//7942 7606//7942 7597//7943 
f 7628//7943 7597//7943 7596//7944 
f 7629//7944 7596//7944 7598//7945 
f 7630//7945 7598//7945 7610//7946 
f 7631//7946 7610//7946 7609//7947 
f 7632//7947 7609//7947 7605//7948 
f 7633//7948 7605//7948 7604//7949 
f 7634//7949 7604//7949 7603//7950 
f 7635//7950 7603//7950 7602//7951 
f 7636//7951 7602//7951 7601//7952 
f 7637//7952 7601//7952 7600//7953 
f 7638//7953 7600//7953 7594//7954 
f 7639//7954 7594//7954 7592//7926 
f 7592//7926 7611//7926 7639//7954 
f 7594//7954 7639//7954 7638//7953 
f 7600//7953 7638//7953 7637//7952 
f 7601//7952 7637//7952 7636//7951 
f 7602//7951 7636//7951 7635//7950 
f 7603//7950 7635//7950 7634//7949 
f 7604//7949 7634//7949 7633//7948 
f 7605//7948 7633//7948 7632//7947 
f 7609//7947 7632//7947 7631//7946 
f 7610//7946 7631//7946 7630//7945 
f 7598//7945 7630//7945 7629//7944 
f 7596//7944 7629//7944 7628//7943 
f 7597//7943 7628//7943 7627//7942 
f 7606//7942 7627//7942 7626//7941 
f 7607//7941 7626//7941 7625//7940 
f 7608//7940 7625//7940 7624//7939 
f 7599//7939 7624//7939 7623//7938 
f 7584//7938 7623//7938 7622//7937 
f 7582//7937 7622//7937 7621//7936 
f 7583//7936 7621//7936 7620//7935 
f 7587//7935 7620//7935 7619//7934 
f 7588//7934 7619//7934 7618//7933 
f 7585//7933 7618//7933 7617//7932 
f 7586//7932 7617//7932 7616//7931 
f 7593//7931 7616//7931 7615//7930 
f 7589//7930 7615//7930 7614//7929 
f 7590//7929 7614//7929 7613//7928 
f 7595//7928 7613//7928 7612//7927 
f 7591//7927 7612//7927 7611//7926 
o mesh6
f 7612//7955 7640//7955 7641//7956 
f 7641//7956 7611//7957 7612//7955 
f 7613//7958 7642//7958 7643//7959 
f 7643//7959 7612//7955 7613//7958 
f 7614//7960 7644//7960 7645//7961 
f 7645//7961 7613//7958 7614//7960 
f 7615//7962 7646//7962 7647//7963 
f 7647//7963 7614//7960 7615//7962 
f 7616//7964 7648//7964 7649//7965 
f 7649//7965 7615//7962 7616//7964 
f 7617//7966 7650//7966 7651//7967 
f 7651//7967 7616//7964 7617//7966 
f 7618//7968 7652//7968 7653//7969 
f 7653//7969 7617//7966 7618//7968 
f 7619//7970 7654//7970 7655//7971 
f 7655//7971 7618//7968 7619//7970 
f 7620//7972 7656//7972 7657//7973 
f 7657//7973 7619//7970 7620//7972 
f 7621//7974 7658//7974 7659//7975 
f 7659//7975 7620//7972 7621//7974 
f 7621//7974 7622//7976 7660//7977 
f 7622//7976 7661//7976 7660//7977 
f 7622//7976 7623//7978 7662//7979 
f 7623//7978 7663//7978 7662//7979 
f 7623//7978 7624//7980 7664//7981 
f 7624//7980 7665//7980 7664//7981 
f 7625//7982 7666//7982 7667//7983 
f 7667//7983 7624//7980 7625//7982 
f 7626//7984 7668//7984 7669//7985 
f 7669//7985 7625//7982 7626//7984 
f 7627//7986 7670//7986 7671//7987 
f 7671//7987 7626//7984 7627//7986 
f 7628//7988 7672//7988 7673//7989 
f 7673//7989 7627//7986 7628//7988 
f 7629//7990 7674//7990 7675//7991 
f 7675//7991 7628//7988 7629//7990 
f 7630//7992 7676//7992 7677//7993 
f 7677//7993 7629//7990 7630//7992 
f 7631//7994 7678//7994 7679//7995 
f 7679//7995 7630//7992 7631//7994 
f 7632//7996 7680//7996 7681//7997 
f 7681//7997 7631//7994 7632//7996 
f 7633//7998 7682//7998 7683//7999 
f 7683//7999 7632//7996 7633//7998 
f 7634//8000 7684//8000 7685//8001 
f 7685//8001 7633//7998 7634//8000 
f 7635//8002 7686//8002 7687//8003 
f 7687//8003 7634//8000 7635//8002 
f 7636//8004 7688//8004 7689//8005 
f 7689//8005 7635//8002 7636//8004 
f 7637//8006 7690//8006 7691//8007 
f 7691//8007 7636//8004 7637//8006 
f 7638//8008 7692//8008 7693//8009 
f 7693//8009 7637//8006 7638//8008 
f 7639//8010 7694//8010 7695//8011 
f 7695//8011 7638//8008 7639//8010 
f 7611//7957 7696//8012 7697//8013 
f 7697//8013 7639//8010 7611//7957 
f 7697//8013 7694//8010 7639//8010 
f 7695//8011 7692//8008 7638//8008 
f 7693//8009 7690//8006 7637//8006 
f 7691//8007 7688//8004 7636//8004 
f 7689//8005 7686//8002 7635//8002 
f 7687//8003 7684//8000 7634//8000 
f 7685//8001 7682//7998 7633//7998 
f 7683//7999 7680//7996 7632//7996 
f 7681//7997 7678//7994 7631//7994 
f 7679//7995 7676//7992 7630//7992 
f 7677//7993 7674//7990 7629//7990 
f 7675//7991 7672//7988 7628//7988 
f 7673//7989 7670//7986 7627//7986 
f 7671//7987 7668//7984 7626//7984 
f 7669//7985 7666//7982 7625//7982 
f 7667//7983 7665//7980 7624//7980 
f 7664//7981 7663//7978 7623//7978 
f 7662//7979 7661//7976 7622//7976 
f 7660//7977 7658//7974 7621//7974 
f 7659//7975 7656//7972 7620//7972 
f 7657//7973 7654//7970 7619//7970 
f 7655//7971 7652//7968 7618//7968 
f 7653//7969 7650//7966 7617//7966 
f 7651//7967 7648//7964 7616//7964 
f 7649//7965 7646//7962 7615//7962 
f 7647//7963 7644//7960 7614//7960 
f 7645//7961 7642//7958 7613//7958 
f 7643//7959 7640//7955 7612//7955 
f 7641//7956 7696//8012 7611//7957 
o mesh7
f 7698//8014 7667//8014 7666//8015 
f 7666//8015 7699//8016 7698//8014 
f 7700//8017 7664//8017 7665//8018 
f 7665//8018 7698//8014 7700//8017 
f 7701//8019 7662//8019 7663//8020 
f 7663//8020 7700//8017 7701//8019 
f 7702//8021 7660//8021 7661//8022 
f 7661//8022 7701//8019 7702//8021 
f 7703//8023 7659//8023 7658//8024 
f 7658//8024 7702//8021 7703//8023 
f 7704//8025 7657//8025 7656//8026 
f 7656//8026 7703//8023 7704//8025 
f 7705//8027 7655//8027 7654//8028 
f 7654//8028 7704//8025 7705//8027 
f 7706//8029 7653//8029 7652//8030 
f 7652//8030 7705//8027 7706//8029 
f 7707//8031 7651//8031 7650//8032 
f 7650//8032 7706//8029 7707//8031 
f 7708//8033 7649//8033 7648//8034 
f 7648//8034 7707//8031 7708//8033 
f 7709//8035 7647//8035 7646//8036 
f 7646//8036 7708//8033 7709//8035 
f 7710//8037 7645//8037 7644//8038 
f 7644//8038 7709//8035 7710//8037 
f 7711//8039 7643//8039 7642//8040 
f 7642//8040 7710//8037 7711//8039 
f 7712//8041 7641//8041 7640//8042 
f 7640//8042 7711//8039 7712//8041 
f 7697//8043 7696//8044 7713//8044 
f 7641//8041 7712//8041 7713//8044 
f 7713//8044 7696//8044 7641//8041 
f 7714//8043 7715//8045 7694//8046 
f 7715//8045 7695//8045 7694//8046 
f 7715//8045 7716//8047 7692//8048 
f 7716//8047 7693//8047 7692//8048 
f 7716//8047 7717//8049 7690//8050 
f 7717//8049 7691//8049 7690//8050 
f 7718//8051 7689//8051 7688//8052 
f 7688//8052 7717//8049 7718//8051 
f 7719//8053 7687//8053 7686//8054 
f 7686//8054 7718//8051 7719//8053 
f 7720//8055 7685//8055 7684//8056 
f 7684//8056 7719//8053 7720//8055 
f 7721//8057 7683//8057 7682//8058 
f 7682//8058 7720//8055 7721//8057 
f 7722//8059 7681//8059 7680//8060 
f 7680//8060 7721//8057 7722//8059 
f 7723//8061 7679//8061 7678//8062 
f 7678//8062 7722//8059 7723//8061 
f 7724//8063 7677//8063 7676//8064 
f 7676//8064 7723//8061 7724//8063 
f 7724//8063 7725//8065 7674//8066 
f 7725//8065 7675//8065 7674//8066 
f 7726//8067 7673//8067 7672//8068 
f 7672//8068 7725//8065 7726//8067 
f 7727//8069 7671//8069 7670//8070 
f 7670//8070 7726//8067 7727//8069 
f 7727//8069 7699//8016 7668//8071 
f 7699//8016 7669//8072 7668//8071 
f 7668//8071 7671//8069 7727//8069 
f 7670//8070 7673//8067 7726//8067 
f 7672//8068 7675//8065 7725//8065 
f 7674//8066 7677//8063 7724//8063 
f 7676//8064 7679//8061 7723//8061 
f 7678//8062 7681//8059 7722//8059 
f 7680//8060 7683//8057 7721//8057 
f 7682//8058 7685//8055 7720//8055 
f 7684//8056 7687//8053 7719//8053 
f 7686//8054 7689//8051 7718//8051 
f 7688//8052 7691//8049 7717//8049 
f 7690//8050 7693//8047 7716//8047 
f 7692//8048 7695//8045 7715//8045 
f 7694//8046 7697//8043 7714//8043 
f 7713//8044 7714//8043 7697//8043 
f 7640//8042 7643//8039 7711//8039 
f 7642//8040 7645//8037 7710//8037 
f 7644//8038 7647//8035 7709//8035 
f 7646//8036 7649//8033 7708//8033 
f 7648//8034 7651//8031 7707//8031 
f 7650//8032 7653//8029 7706//8029 
f 7652//8030 7655//8027 7705//8027 
f 7654//8028 7657//8025 7704//8025 
f 7656//8026 7659//8023 7703//8023 
f 7658//8024 7660//8021 7702//8021 
f 7661//8022 7662//8019 7701//8019 
f 7663//8020 7664//8017 7700//8017 
f 7665//8018 7667//8014 7698//8014 
f 7666//8015 7669//8072 7699//8016 
o mesh8
f 7712//8073 7711//8073 7579//8073 
f 7525//8073 7713//8073 7712//8073 
f 7711//8073 7710//8073 7577//8073 
f 7709//8073 7708//8073 7573//8073 
f 7708//8073 7707//8073 7571//8073 
f 7577//8073 7579//8073 7711//8073 
f 7710//8073 7709//8073 7575//8073 
f 7571//8073 7573//8073 7708//8073 
f 7707//8073 7706//8073 7569//8073 
f 7706//8073 7705//8073 7567//8073 
f 7705//8073 7704//8073 7565//8073 
f 7702//8073 7701//8073 7559//8073 
f 7701//8073 7700//8073 7557//8073 
f 7725//8073 7724//8073 7545//8073 
f 7724//8073 7723//8073 7543//8073 
f 7575//8073 7577//8073 7710//8073 
f 7569//8073 7571//8073 7707//8073 
f 7565//8073 7567//8073 7705//8073 
f 7704//8073 7703//8073 7563//8073 
f 7703//8073 7702//8073 7561//8073 
f 7557//8073 7559//8073 7701//8073 
f 7698//8073 7699//8073 7553//8073 
f 7699//8073 7727//8073 7551//8073 
f 7543//8073 7545//8073 7724//8073 
f 7723//8073 7722//8073 7541//8073 
f 7573//8073 7575//8073 7709//8073 
f 7563//8073 7565//8073 7704//8073 
f 7559//8073 7561//8073 7702//8073 
f 7700//8073 7698//8073 7555//8073 
f 7551//8073 7553//8073 7699//8073 
f 7727//8073 7726//8073 7549//8073 
f 7726//8073 7725//8073 7547//8073 
f 7541//8073 7543//8073 7723//8073 
f 7720//8073 7719//8073 7535//8073 
f 7719//8073 7718//8073 7533//8073 
f 7718//8073 7717//8073 7531//8073 
f 7717//8073 7716//8073 7529//8073 
f 7567//8073 7569//8073 7706//8073 
f 7555//8073 7557//8073 7700//8073 
f 7549//8073 7551//8073 7727//8073 
f 7545//8073 7547//8073 7725//8073 
f 7533//8073 7535//8073 7719//8073 
f 7529//8073 7531//8073 7717//8073 
f 7716//8073 7715//8073 7527//8073 
f 7715//8073 7714//8073 7524//8073 
f 7561//8073 7563//8073 7703//8073 
f 7547//8073 7549//8073 7726//8073 
f 7722//8073 7721//8073 7539//8073 
f 7721//8073 7720//8073 7537//8073 
f 7531//8073 7533//8073 7718//8073 
f 7524//8073 7527//8073 7715//8073 
f 7553//8073 7555//8073 7698//8073 
f 7537//8073 7539//8073 7721//8073 
f 7527//8073 7529//8073 7716//8073 
f 7714//8073 7713//8073 7525//8073 
f 7539//8073 7541//8073 7722//8073 
f 7525//8073 7524//8073 7714//8073 
f 7535//8073 7537//8073 7720//8073 
f 7579//8073 7525//8073 7712//8073 
g horizontalBlock
v 0.0285243 0.00484011 -0.008741 
v 0.0291155 0.00484011 -0.0086767 
v 0.0291155 -0.00515989 -0.0086767 
v 0.0279608 0.00484011 -0.00893087 
v 0.0285243 -0.00515989 -0.008741 
v 0.0274512 0.00484011 -0.00923745 
v 0.0279608 -0.00515989 -0.00893087 
v 0.0270195 0.00484011 -0.00964639 
v 0.0274512 -0.00515989 -0.00923745 
v 0.0266858 0.00484011 -0.0101386 
v 0.0270195 -0.00515989 -0.00964639 
v 0.0264657 0.00484011 -0.010691 
v 0.0266858 -0.00515989 -0.0101386 
v 0.0263695 0.00484011 -0.0112778 
v 0.0264657 -0.00515989 -0.010691 
v 0.0264017 0.00484011 -0.0118716 
v 0.0263695 -0.00515989 -0.0112778 
v 0.0265608 0.00484011 -0.0124446 
v 0.0264017 -0.00515989 -0.0118716 
v 0.0268393 0.00484011 -0.01297 
v 0.0265608 -0.00515989 -0.0124446 
v 0.0272243 0.00484011 -0.0134232 
v 0.0268393 -0.00515989 -0.01297 
v 0.0276977 0.00484011 -0.0137831 
v 0.0272243 -0.00515989 -0.0134232 
v 0.0282374 0.00484011 -0.0140327 
v 0.0276977 -0.00515989 -0.0137831 
v 0.0288181 0.00484011 -0.0141606 
v 0.0282374 -0.00515989 -0.0140327 
v 0.0294128 -0.00515989 -0.0141606 
v 0.0294128 0.00484011 -0.0141606 
v 0.0291155 0.00484011 -0.0141767 
v 0.0288181 -0.00515989 -0.0141606 
v 0.0291155 -0.00515989 -0.0141767 
v 0.0299936 0.00484011 -0.0140327 
v 0.0305332 0.00484011 -0.0137831 
v 0.0299936 -0.00515989 -0.0140327 
v 0.0310066 0.00484011 -0.0134232 
v 0.0305332 -0.00515989 -0.0137831 
v 0.0313916 0.00484011 -0.01297 
v 0.0313655 0.00484011 -0.0130007 
v 0.0313655 -0.00515989 -0.0130007 
v 0.0310066 -0.00515989 -0.0134232 
v 0.0316702 0.00484011 -0.0124446 
v 0.0313916 -0.00515989 -0.01297 
v 0.0318292 0.00484011 -0.0118716 
v 0.0316702 -0.00515989 -0.0124446 
v 0.0318614 0.00484011 -0.0112778 
v 0.0318292 -0.00515989 -0.0118716 
v 0.0317652 0.00484011 -0.010691 
v 0.0318614 -0.00515989 -0.0112778 
v 0.0315451 0.00484011 -0.0101386 
v 0.0317652 -0.00515989 -0.010691 
v 0.0312114 0.00484011 -0.00964639 
v 0.0313655 0.00484011 -0.0098736 
v 0.0313655 -0.00515989 -0.0098736 
v 0.0315451 -0.00515989 -0.0101386 
v 0.0307797 0.00484011 -0.00923745 
v 0.0312114 -0.00515989 -0.00964639 
v 0.0302702 0.00484011 -0.00893087 
v 0.0307797 -0.00515989 -0.00923745 
v 0.0297066 0.00484011 -0.008741 
v 0.0302702 -0.00515989 -0.00893087 
v 0.0297066 -0.00515989 -0.008741 
v 0.0258655 -0.00515989 -0.0349267 
v 0.0313655 -0.00515989 -0.0349267 
v 0.0406155 -0.00515989 -0.0349267 
v 0.0811155 -0.00515989 -0.0349267 
v 0.0937405 -0.00515989 -0.0349267 
v 0.0999905 -0.00515989 -0.0349267 
v 0.0971155 -0.00515989 -0.0316767 
v 0.0979936 -0.00515989 -0.0315327 
v 0.0974128 -0.00515989 -0.0316606 
v 0.0993916 -0.00515989 -0.03047 
v 0.0990066 -0.00515989 -0.0309232 
v 0.0998614 -0.00515989 -0.0287778 
v 0.0965243 -0.00515989 -0.026241 
v 0.0971155 -0.00515989 -0.0261767 
v 0.0946858 -0.00515989 -0.0276386 
v 0.0950195 -0.00515989 -0.0271464 
v 0.0944017 -0.00515989 -0.0293716 
v 0.0943695 -0.00515989 -0.0287778 
v 0.0956977 -0.00515989 -0.0312831 
v 0.0952243 -0.00515989 -0.0309232 
v 0.0968181 -0.00515989 -0.0316606 
v 0.0985332 -0.00515989 -0.0312831 
v 0.0996702 -0.00515989 -0.0299446 
v 0.0998292 -0.00515989 -0.0293716 
v 0.0995451 -0.00515989 -0.0276386 
v 0.0997652 -0.00515989 -0.028191 
v 0.0959608 -0.00515989 -0.0264309 
v 0.0954512 -0.00515989 -0.0267374 
v 0.0944657 -0.00515989 -0.028191 
v 0.0945608 -0.00515989 -0.0299446 
v 0.0948393 -0.00515989 -0.03047 
v 0.0962374 -0.00515989 -0.0315327 
v 0.0987797 -0.00515989 -0.0267374 
v 0.0992114 -0.00515989 -0.0271464 
v 0.0977066 -0.00515989 -0.026241 
v 0.0982702 -0.00515989 -0.0264309 
v 0.0181155 -0.00515989 -0.0030517 
v 0.0181155 -0.00515989 -0.0143017 
v 0.0181155 -0.00515989 0.0373233 
v 0.0181155 -0.00515989 0.0189483 
v 0.108115 -0.00515989 0.0189483 
v 0.0181155 -0.00515989 0.0386983 
v 0.108115 -0.00515989 0.0373233 
v 0.0406155 -0.00515989 0.0650733 
v 0.0811155 -0.00515989 0.0650733 
v 0.0971155 -0.00515989 0.0563233 
v 0.0979936 -0.00515989 0.0564673 
v 0.0974128 -0.00515989 0.0563394 
v 0.0937405 -0.00515989 0.0650733 
v 0.0965243 -0.00515989 0.061759 
v 0.0971155 -0.00515989 0.0618233 
v 0.0968181 -0.00515989 0.0563394 
v 0.0985332 -0.00515989 0.0567169 
v 0.0999905 -0.00515989 0.0650733 
v 0.0998614 -0.00515989 0.0592222 
v 0.0995451 -0.00515989 0.0603614 
v 0.0997652 -0.00515989 0.059809 
v 0.0943695 -0.00515989 0.0592222 
v 0.0944657 -0.00515989 0.059809 
v 0.0944017 -0.00515989 0.0586284 
v 0.0962374 -0.00515989 0.0564673 
v 0.0990066 -0.00515989 0.0570768 
v 0.0996702 -0.00515989 0.0580554 
v 0.0993916 -0.00515989 0.05753 
v 0.0987797 -0.00515989 0.0612626 
v 0.0992114 -0.00515989 0.0608536 
v 0.0977066 -0.00515989 0.061759 
v 0.0954512 -0.00515989 0.0612626 
v 0.0959608 -0.00515989 0.0615691 
v 0.0952243 -0.00515989 0.0570768 
v 0.0948393 -0.00515989 0.05753 
v 0.0956977 -0.00515989 0.0567169 
v 0.0998292 -0.00515989 0.0586284 
v 0.0982702 -0.00515989 0.0615691 
v 0.0945608 -0.00515989 0.0580554 
v 0.0946858 -0.00515989 0.0603614 
v 0.0950195 -0.00515989 0.0608536 
v 0.0181155 -0.00515989 -0.0149267 
v 0.0204592 -0.00515989 -0.0196142 
v 0.0231155 -0.00515989 -0.0249267 
v 0.0231155 -0.00515989 -0.0254892 
v 0.0231155 -0.00515989 -0.0320618 
v 0.024264 -0.00515989 -0.0333017 
v 0.0257692 -0.00515989 -0.0349267 
v 0.100968 -0.00515989 -0.0349267 
v 0.102814 -0.00515989 -0.0333017 
v 0.103115 -0.00515989 -0.0330365 
v 0.103115 -0.00515989 -0.0249267 
v 0.103115 -0.00515989 -0.0254892 
v 0.105772 -0.00515989 -0.0196142 
v 0.108115 -0.00515989 -0.0149267 
v 0.103115 -0.00515989 0.0550733 
v 0.103115 -0.00515989 0.0624393 
v 0.105428 -0.00515989 0.0504483 
v 0.0258655 -0.00515989 0.0649988 
v 0.0231155 -0.00515989 0.0619488 
v 0.0231155 -0.00515989 0.0550733 
v 0.020803 -0.00515989 0.0504483 
v 0.0181155 -0.00515989 0.0450733 
v 0.0406155 -0.00515989 0.0360733 
v 0.0811155 -0.00515989 0.0360733 
v 0.0931155 -0.00515989 0.0200733 
v 0.0931155 -0.00515989 0.0360733 
v 0.0406155 -0.00515989 0.0200733 
v 0.0331155 -0.00515989 0.0200733 
v 0.0331155 -0.00515989 0.0360733 
v 0.0313916 -0.00515989 0.05753 
v 0.0313655 -0.00515989 0.0574993 
v 0.0316702 -0.00515989 0.0580554 
v 0.0318614 -0.00515989 0.0592222 
v 0.0318292 -0.00515989 0.0586284 
v 0.0317652 -0.00515989 0.059809 
v 0.0313655 -0.00515989 0.0650733 
v 0.0313655 -0.00515989 0.0606264 
v 0.0315451 -0.00515989 0.0603614 
v 0.0291155 -0.00515989 0.0563233 
v 0.0294128 -0.00515989 0.0563394 
v 0.0299936 -0.00515989 0.0564673 
v 0.0288181 -0.00515989 0.0563394 
v 0.0276977 -0.00515989 0.0567169 
v 0.0272243 -0.00515989 0.0570768 
v 0.0305332 -0.00515989 0.0567169 
v 0.0268393 -0.00515989 0.05753 
v 0.0282374 -0.00515989 0.0564673 
v 0.0259327 -0.00515989 0.0650733 
v 0.0285243 -0.00515989 0.061759 
v 0.0291155 -0.00515989 0.0618233 
v 0.0264017 -0.00515989 0.0586284 
v 0.0263695 -0.00515989 0.0592222 
v 0.0310066 -0.00515989 0.0570768 
v 0.0279608 -0.00515989 0.0615691 
v 0.0265608 -0.00515989 0.0580554 
v 0.0297066 -0.00515989 0.061759 
v 0.0302702 -0.00515989 0.0615691 
v 0.0270195 -0.00515989 0.0608536 
v 0.0274512 -0.00515989 0.0612626 
v 0.0264657 -0.00515989 0.059809 
v 0.0307797 -0.00515989 0.0612626 
v 0.0312114 -0.00515989 0.0608536 
v 0.0266858 -0.00515989 0.0603614 
v 0.0318614 -0.00515989 -0.0287778 
v 0.0313916 -0.00515989 -0.03047 
v 0.0313655 -0.00515989 -0.0305007 
v 0.0317652 -0.00515989 -0.028191 
v 0.0316702 -0.00515989 -0.0299446 
v 0.0318292 -0.00515989 -0.0293716 
v 0.0313655 -0.00515989 -0.0273736 
v 0.0315451 -0.00515989 -0.0276386 
v 0.0291155 -0.00515989 -0.0316767 
v 0.0288181 -0.00515989 -0.0316606 
v 0.0294128 -0.00515989 -0.0316606 
v 0.0299936 -0.00515989 -0.0315327 
v 0.0305332 -0.00515989 -0.0312831 
v 0.0285243 -0.00515989 -0.026241 
v 0.0291155 -0.00515989 -0.0261767 
v 0.0272243 -0.00515989 -0.0309232 
v 0.0268393 -0.00515989 -0.03047 
v 0.0282374 -0.00515989 -0.0315327 
v 0.0263695 -0.00515989 -0.0287778 
v 0.0264657 -0.00515989 -0.028191 
v 0.0264017 -0.00515989 -0.0293716 
v 0.0265608 -0.00515989 -0.0299446 
v 0.0276977 -0.00515989 -0.0312831 
v 0.0302702 -0.00515989 -0.0264309 
v 0.0307797 -0.00515989 -0.0267374 
v 0.0279608 -0.00515989 -0.0264309 
v 0.0270195 -0.00515989 -0.0271464 
v 0.0274512 -0.00515989 -0.0267374 
v 0.0312114 -0.00515989 -0.0271464 
v 0.0297066 -0.00515989 -0.026241 
v 0.0266858 -0.00515989 -0.0276386 
v 0.0310066 -0.00515989 -0.0309232 
v 0.0258098 -0.00515989 0.016572 
v 0.0258655 -0.00515989 0.0166405 
v 0.0255443 -0.00515989 0.0160488 
v 0.0181155 -0.00515989 0.0115108 
v 0.0253713 -0.00515989 0.0148949 
v 0.0253959 -0.00515989 0.0154811 
v 0.0253713 -0.00515989 0.0115108 
v 0.0299199 -0.00515989 0.0171485 
v 0.0303191 -0.00515989 0.0167185 
v 0.0294386 -0.00515989 0.0174841 
v 0.0283199 -0.00515989 0.0178157 
v 0.0288971 -0.00515989 0.0177099 
v 0.0277335 -0.00515989 0.0177966 
v 0.0271645 -0.00515989 0.0176536 
v 0.0261802 -0.00515989 0.0170271 
v 0.0266387 -0.00515989 0.0173931 
v 0.0306179 -0.00515989 0.0162135 
v 0.0308655 -0.00515989 0.0150733 
v 0.0308029 -0.00515989 0.0156567 
v 0.0283199 -0.00515989 0.00233091 
v 0.0277335 -0.00515989 0.00234995 
v 0.0266387 -0.00515989 0.00275345 
v 0.0261802 -0.00515989 0.00311954 
v 0.0288971 -0.00515989 0.00243671 
v 0.0299199 -0.00515989 0.0029981 
v 0.0294386 -0.00515989 0.00266253 
v 0.0271645 -0.00515989 0.00249297 
v 0.0308029 -0.00515989 0.0044899 
v 0.0306179 -0.00515989 0.00393307 
v 0.0303191 -0.00515989 0.00342814 
v 0.0308655 -0.00515989 0.0115108 
v 0.0308655 -0.00515989 0.0050733 
v 0.0253959 -0.00515989 0.00466548 
v 0.0253713 -0.00515989 0.00525171 
v 0.0255443 -0.00515989 0.00409782 
v 0.0258098 -0.00515989 0.00357457 
v 0.0258655 -0.00515989 0.00350613 
v 0.100861 -0.00515989 0.0152352 
v 0.100865 -0.00515989 0.0150733 
v 0.108115 -0.00515989 0.0115108 
v 0.100762 -0.00515989 0.0158197 
v 0.100541 -0.00515989 0.0163696 
v 0.100207 -0.00515989 0.0168593 
v 0.0999905 -0.00515989 0.017063 
v 0.108115 -0.00515989 -0.0030517 
v 0.100865 -0.00515989 0.00509115 
v 0.100349 -0.00515989 0.00346847 
v 0.0999905 -0.00515989 0.00306668 
v 0.100865 -0.00515989 0.0115108 
v 0.100634 -0.00515989 0.00396893 
v 0.100809 -0.00515989 0.00451785 
v 0.0978363 -0.00515989 0.0023375 
v 0.0962789 -0.00515989 0.00302647 
v 0.0958928 -0.00515989 0.003454 
v 0.0972725 -0.00515989 0.00245569 
v 0.0999653 -0.00515989 0.00303843 
v 0.0956042 -0.00515989 0.0039526 
v 0.0967456 -0.00515989 0.00268876 
v 0.0989755 -0.00515989 0.00246122 
v 0.0984124 -0.00515989 0.00233937 
v 0.0995008 -0.00515989 0.0026977 
v 0.0953655 -0.00515989 0.0050733 
v 0.0954258 -0.00515989 0.00450038 
v 0.0956902 -0.00515989 0.0163696 
v 0.0960244 -0.00515989 0.0168593 
v 0.0975261 -0.00515989 0.0177594 
v 0.0964557 -0.00515989 0.0172659 
v 0.0969642 -0.00515989 0.0175707 
v 0.0954687 -0.00515989 0.0158198 
v 0.0981155 -0.00515989 0.0178233 
v 0.0987048 -0.00515989 0.0177594 
v 0.0992668 -0.00515989 0.0175707 
v 0.0953655 -0.00515989 0.0150733 
v 0.0953655 -0.00515989 0.0115108 
v 0.0997753 -0.00515989 0.0172659 
v 0.0953702 -0.00515989 0.0152352 
v 0.0491808 -0.00515989 -0.0153537 
v 0.0488887 -0.00515989 -0.0143017 
v 0.0507001 -0.00515989 -0.0182194 
v 0.0518848 -0.00515989 -0.0196142 
v 0.0483131 -0.00515989 -0.0122284 
v 0.0481375 -0.00515989 -0.00898954 
v 0.0486622 -0.00515989 -0.0057887 
v 0.0745479 -0.00515989 -9.08279e-05 
v 0.0763682 -0.00515989 -0.0027755 
v 0.0721931 -0.00515989 0.00213977 
v 0.0694138 -0.00515989 0.00381201 
v 0.0631155 -0.00515989 0.00519838 
v 0.06634 -0.00515989 0.00484769 
v 0.0598909 -0.00515989 0.00484769 
v 0.0540379 -0.00515989 0.00213977 
v 0.0568171 -0.00515989 0.00381201 
v 0.0498628 -0.00515989 -0.0027755 
v 0.051683 -0.00515989 -9.08279e-05 
v 0.0497527 -0.00515989 -0.0030517 
v 0.0780935 -0.00515989 -0.00898954 
v 0.0764782 -0.00515989 -0.0030517 
v 0.0775687 -0.00515989 -0.0057887 
v 0.0779179 -0.00515989 -0.0122284 
v 0.0773422 -0.00515989 -0.0143017 
v 0.0770501 -0.00515989 -0.0153537 
v 0.0755308 -0.00515989 -0.0182194 
v 0.0631155 -0.00515989 -0.0248016 
v 0.0647373 -0.00515989 -0.0247137 
v 0.0614937 -0.00515989 -0.0247137 
v 0.067905 -0.00515989 -0.0240164 
v 0.0743461 -0.00515989 -0.0196142 
v 0.0708488 -0.00515989 -0.0226545 
v 0.073431 -0.00515989 -0.0206916 
v 0.058326 -0.00515989 -0.0240164 
v 0.0553822 -0.00515989 -0.0226545 
v 0.0528 -0.00515989 -0.0206916 
v 0.0313916 -0.00515989 0.04003 
v 0.0313655 -0.00515989 0.0399993 
v 0.0316702 -0.00515989 0.0405554 
v 0.0317652 -0.00515989 0.042309 
v 0.0318292 -0.00515989 0.0411284 
v 0.0318614 -0.00515989 0.0417222 
v 0.0313655 -0.00515989 0.0431264 
v 0.0315451 -0.00515989 0.0428614 
v 0.0291155 -0.00515989 0.0388233 
v 0.0294128 -0.00515989 0.0388394 
v 0.0299936 -0.00515989 0.0389673 
v 0.0288181 -0.00515989 0.0388394 
v 0.0276977 -0.00515989 0.0392169 
v 0.0272243 -0.00515989 0.0395768 
v 0.0305332 -0.00515989 0.0392169 
v 0.0268393 -0.00515989 0.04003 
v 0.0282374 -0.00515989 0.0389673 
v 0.0285243 -0.00515989 0.044259 
v 0.0291155 -0.00515989 0.0443233 
v 0.0264017 -0.00515989 0.0411284 
v 0.0263695 -0.00515989 0.0417222 
v 0.0310066 -0.00515989 0.0395768 
v 0.0265608 -0.00515989 0.0405554 
v 0.0297066 -0.00515989 0.044259 
v 0.0302702 -0.00515989 0.0440691 
v 0.0279608 -0.00515989 0.0440691 
v 0.0270195 -0.00515989 0.0433536 
v 0.0274512 -0.00515989 0.0437626 
v 0.0264657 -0.00515989 0.042309 
v 0.0307797 -0.00515989 0.0437626 
v 0.0312114 -0.00515989 0.0433536 
v 0.0266858 -0.00515989 0.0428614 
v 0.0841319 -0.00515989 -0.0111131 
v 0.0841319 -0.00515989 -0.0117403 
v 0.0871155 -0.00515989 -0.0084267 
v 0.0842623 -0.00515989 -0.0104997 
v 0.0845174 -0.00515989 -0.0099267 
v 0.0842623 -0.00515989 -0.0123538 
v 0.0864917 -0.00515989 -0.00849226 
v 0.0853521 -0.00515989 -0.0138538 
v 0.084886 -0.00515989 -0.0134341 
v 0.0863088 -0.00515989 -0.0143017 
v 0.0858953 -0.00515989 -0.0141673 
v 0.0858953 -0.00515989 -0.00868607 
v 0.084886 -0.00515989 -0.00941931 
v 0.0853521 -0.00515989 -0.00899965 
v 0.0845174 -0.00515989 -0.0129267 
v 0.0937405 -0.00515989 -0.0084267 
v 0.0971155 -0.00515989 -0.0084267 
v 0.0977392 -0.00515989 -0.00849226 
v 0.0983357 -0.00515989 -0.00868607 
v 0.0993449 -0.00515989 -0.00941931 
v 0.0997136 -0.00515989 -0.0099267 
v 0.0988788 -0.00515989 -0.00899965 
v 0.0999686 -0.00515989 -0.0104997 
v 0.108115 -0.00515989 -0.0143017 
v 0.100099 -0.00515989 -0.0117403 
v 0.0999905 -0.00515989 -0.012251 
v 0.0999905 -0.00515989 -0.0106024 
v 0.100099 -0.00515989 -0.0111131 
v 0.0988788 -0.00515989 -0.0138538 
v 0.0983357 -0.00515989 -0.0141673 
v 0.0993449 -0.00515989 -0.0134341 
v 0.0999686 -0.00515989 -0.0123538 
v 0.0997136 -0.00515989 -0.0129267 
v 0.0971155 -0.00515989 -0.0144267 
v 0.0977392 -0.00515989 -0.0143611 
v 0.0979222 -0.00515989 -0.0143017 
v 0.0937405 -0.00515989 -0.0144267 
v 0.0871155 -0.00515989 -0.0144267 
v 0.0864917 -0.00515989 -0.0143611 
v 0.0841319 -0.00515989 0.0418869 
v 0.0842623 -0.00515989 0.0425003 
v 0.0845174 -0.00515989 0.0430733 
v 0.0841319 -0.00515989 0.0412597 
v 0.084886 -0.00515989 0.0435807 
v 0.0842623 -0.00515989 0.0406462 
v 0.0871155 -0.00515989 0.0445733 
v 0.084886 -0.00515989 0.0395659 
v 0.0845174 -0.00515989 0.0400733 
v 0.0864917 -0.00515989 0.0445077 
v 0.0858953 -0.00515989 0.0443139 
v 0.0853521 -0.00515989 0.0440003 
v 0.0858953 -0.00515989 0.0388327 
v 0.0853521 -0.00515989 0.0391462 
v 0.0863088 -0.00515989 0.0386983 
v 0.0937405 -0.00515989 0.0445733 
v 0.0971155 -0.00515989 0.0445733 
v 0.0993449 -0.00515989 0.0435807 
v 0.0997136 -0.00515989 0.0430733 
v 0.0983357 -0.00515989 0.0443139 
v 0.0988788 -0.00515989 0.0440003 
v 0.0977392 -0.00515989 0.0445077 
v 0.0999686 -0.00515989 0.0425003 
v 0.108115 -0.00515989 0.0386983 
v 0.100099 -0.00515989 0.0412597 
v 0.0999905 -0.00515989 0.040749 
v 0.108115 -0.00515989 0.0450733 
v 0.100099 -0.00515989 0.0418869 
v 0.0999905 -0.00515989 0.0423976 
v 0.0993449 -0.00515989 0.0395659 
v 0.0988788 -0.00515989 0.0391462 
v 0.0999686 -0.00515989 0.0406462 
v 0.0997136 -0.00515989 0.0400733 
v 0.0983357 -0.00515989 0.0388327 
v 0.0971155 -0.00515989 0.0385733 
v 0.0977392 -0.00515989 0.0386389 
v 0.0979222 -0.00515989 0.0386983 
v 0.0937405 -0.00515989 0.0385733 
v 0.0871155 -0.00515989 0.0385733 
v 0.0864917 -0.00515989 0.0386389 
v 0.0811155 -0.00515989 0.0200733 
v 0.100501 -0.00515989 0.0650733 
v 0.0258655 -0.00515989 -0.0333017 
v 0.0313655 -0.00515989 -0.0333017 
v 0.0406155 -0.00515989 -0.0333017 
v 0.0811155 -0.00515989 -0.0333017 
v 0.0937405 -0.00515989 -0.0333017 
v 0.0406155 -0.00515989 -0.0254892 
v 0.0811155 -0.00515989 -0.0254892 
v 0.0999905 -0.00515989 -0.0333017 
v 0.0999905 -0.00515989 -0.0254892 
v 0.0937405 -0.00515989 -0.0254892 
v 0.0258655 -0.00515989 -0.0196142 
v 0.0258655 -0.00515989 -0.0254892 
v 0.0313655 -0.00515989 -0.0254892 
v 0.0313655 -0.00515989 -0.0196142 
v 0.0811155 -0.00515989 -0.0196142 
v 0.0937405 -0.00515989 -0.0196142 
v 0.0258655 -0.00515989 -0.0143017 
v 0.0313655 -0.00515989 -0.0143017 
v 0.0406155 -0.00515989 -0.0196142 
v 0.0313655 -0.00515989 0.0115108 
v 0.0313655 -0.00515989 -0.0030517 
v 0.0406155 -0.00515989 -0.0030517 
v 0.0811155 -0.00515989 0.0115108 
v 0.0811155 -0.00515989 -0.0030517 
v 0.0937405 -0.00515989 -0.0030517 
v 0.0313655 -0.00515989 0.0189483 
v 0.0406155 -0.00515989 0.0115108 
v 0.0406155 -0.00515989 0.0189483 
v 0.0811155 -0.00515989 0.0189483 
v 0.0937405 -0.00515989 0.0115108 
v 0.0258655 -0.00515989 0.0189483 
v 0.0258655 -0.00515989 0.0373233 
v 0.0937405 -0.00515989 0.0373233 
v 0.0937405 -0.00515989 0.0189483 
v 0.0999905 -0.00515989 0.0189483 
v 0.0999905 -0.00515989 0.0373233 
v 0.0258655 -0.00515989 0.0386983 
v 0.0313655 -0.00515989 0.0373233 
v 0.0313655 -0.00515989 0.0386983 
v 0.0406155 -0.00515989 0.0373233 
v 0.0406155 -0.00515989 0.0386983 
v 0.0811155 -0.00515989 0.0373233 
v 0.0999905 -0.00515989 0.0386983 
v 0.0406155 -0.00515989 0.0504483 
v 0.0811155 -0.00515989 0.0386983 
v 0.0811155 -0.00515989 0.0504483 
v 0.0937405 -0.00515989 0.0504483 
v 0.0999905 -0.00515989 0.0504483 
v 0.0999905 -0.00515989 -0.0196142 
v 0.0999905 -0.00515989 -0.0143017 
v 0.0258655 -0.00515989 0.0504483 
v 0.0313655 -0.00515989 0.0504483 
v 0.0258655 -0.00515989 -0.0030517 
v 0.0999905 -0.00515989 -0.0030517 
v 0.0406155 -0.00515989 -0.0143017 
v 0.0811155 -0.00515989 -0.0143017 
v 0.0406155 0.00484011 0.0650733 
v 0.0811155 0.00484011 0.0650733 
v 0.0937405 0.00484011 0.0650733 
v 0.0968181 0.00484011 0.0563394 
v 0.0971155 0.00484011 0.0563233 
v 0.0974128 0.00484011 0.0563394 
v 0.0962374 0.00484011 0.0564673 
v 0.0979936 0.00484011 0.0564673 
v 0.0956977 0.00484011 0.0567169 
v 0.0985332 0.00484011 0.0567169 
v 0.0999905 0.00484011 0.0650733 
v 0.0998614 0.00484011 0.0592222 
v 0.0997652 0.00484011 0.059809 
v 0.0998292 0.00484011 0.0586284 
v 0.0990066 0.00484011 0.0570768 
v 0.0993916 0.00484011 0.05753 
v 0.0952243 0.00484011 0.0570768 
v 0.0945608 0.00484011 0.0580554 
v 0.0948393 0.00484011 0.05753 
v 0.0943695 0.00484011 0.0592222 
v 0.0946858 0.00484011 0.0603614 
v 0.0944657 0.00484011 0.059809 
v 0.0995451 0.00484011 0.0603614 
v 0.0992114 0.00484011 0.0608536 
v 0.0996702 0.00484011 0.0580554 
v 0.0982702 0.00484011 0.0615691 
v 0.0977066 0.00484011 0.061759 
v 0.0987797 0.00484011 0.0612626 
v 0.0944017 0.00484011 0.0586284 
v 0.0954512 0.00484011 0.0612626 
v 0.0950195 0.00484011 0.0608536 
v 0.0965243 0.00484011 0.061759 
v 0.0959608 0.00484011 0.0615691 
v 0.0971155 0.00484011 0.0618233 
v 0.0181155 0.00484011 0.0386983 
v 0.108115 0.00484011 0.0386983 
v 0.108115 0.00484011 0.0373233 
v 0.0181155 0.00484011 0.0373233 
v 0.108115 0.00484011 0.0189483 
v 0.0181155 0.00484011 -0.0030517 
v 0.0968181 0.00484011 -0.0316606 
v 0.0971155 0.00484011 -0.0316767 
v 0.0974128 0.00484011 -0.0316606 
v 0.0962374 0.00484011 -0.0315327 
v 0.0985332 0.00484011 -0.0312831 
v 0.0990066 0.00484011 -0.0309232 
v 0.0979936 0.00484011 -0.0315327 
v 0.0998292 0.00484011 -0.0293716 
v 0.0998614 0.00484011 -0.0287778 
v 0.0993916 0.00484011 -0.03047 
v 0.0956977 0.00484011 -0.0312831 
v 0.0948393 0.00484011 -0.03047 
v 0.0952243 0.00484011 -0.0309232 
v 0.0997652 0.00484011 -0.028191 
v 0.0996702 0.00484011 -0.0299446 
v 0.0945608 0.00484011 -0.0299446 
v 0.0943695 0.00484011 -0.0287778 
v 0.0944017 0.00484011 -0.0293716 
v 0.0946858 0.00484011 -0.0276386 
v 0.0944657 0.00484011 -0.028191 
v 0.0987797 0.00484011 -0.0267374 
v 0.0982702 0.00484011 -0.0264309 
v 0.0995451 0.00484011 -0.0276386 
v 0.0992114 0.00484011 -0.0271464 
v 0.0954512 0.00484011 -0.0267374 
v 0.0950195 0.00484011 -0.0271464 
v 0.0971155 0.00484011 -0.0261767 
v 0.0959608 0.00484011 -0.0264309 
v 0.0965243 0.00484011 -0.026241 
v 0.0977066 0.00484011 -0.026241 
v 0.0313655 0.00484011 -0.0349267 
v 0.0406155 0.00484011 -0.0349267 
v 0.0811155 0.00484011 -0.0349267 
v 0.0937405 0.00484011 -0.0349267 
v 0.0999905 0.00484011 -0.0349267 
v 0.0204592 0.00484011 -0.0196142 
v 0.0181155 0.00484011 -0.0149267 
v 0.0181155 0.00484011 0.0450733 
v 0.020803 0.00484011 0.0504483 
v 0.0258655 0.00484011 0.0649988 
v 0.0231155 0.00484011 0.0550733 
v 0.100501 0.00484011 0.0650733 
v 0.103115 0.00484011 0.0624393 
v 0.103115 0.00484011 0.0550733 
v 0.108115 0.00484011 -0.0149267 
v 0.105772 0.00484011 -0.0196142 
v 0.108115 0.00484011 -0.0143017 
v 0.103115 0.00484011 -0.0249267 
v 0.103115 0.00484011 -0.0254892 
v 0.103115 0.00484011 -0.0330365 
v 0.102814 0.00484011 -0.0333017 
v 0.100968 0.00484011 -0.0349267 
v 0.0258655 0.00484011 -0.0349267 
v 0.0257692 0.00484011 -0.0349267 
v 0.0231155 0.00484011 -0.0320618 
v 0.024264 0.00484011 -0.0333017 
v 0.0231155 0.00484011 -0.0249267 
v 0.0231155 0.00484011 -0.0254892 
v 0.0811155 0.00484011 0.0360733 
v 0.0331155 0.00484011 0.0200733 
v 0.0331155 0.00484011 0.0360733 
v 0.0406155 0.00484011 0.0360733 
v 0.0406155 0.00484011 0.0200733 
v 0.0811155 0.00484011 0.0200733 
v 0.0931155 0.00484011 0.0200733 
v 0.0931155 0.00484011 0.0360733 
v 0.0313655 0.00484011 0.0574993 
v 0.0318292 0.00484011 0.0586284 
v 0.0313916 0.00484011 0.05753 
v 0.0315451 0.00484011 0.0603614 
v 0.0313655 0.00484011 0.0606264 
v 0.0318614 0.00484011 0.0592222 
v 0.0316702 0.00484011 0.0580554 
v 0.0317652 0.00484011 0.059809 
v 0.0288181 0.00484011 0.0563394 
v 0.0291155 0.00484011 0.0563233 
v 0.0294128 0.00484011 0.0563394 
v 0.0282374 0.00484011 0.0564673 
v 0.0299936 0.00484011 0.0564673 
v 0.0268393 0.00484011 0.05753 
v 0.0272243 0.00484011 0.0570768 
v 0.0276977 0.00484011 0.0567169 
v 0.0265608 0.00484011 0.0580554 
v 0.0305332 0.00484011 0.0567169 
v 0.0310066 0.00484011 0.0570768 
v 0.0263695 0.00484011 0.0592222 
v 0.0259327 0.00484011 0.0650733 
v 0.0313655 0.00484011 0.0650733 
v 0.0291155 0.00484011 0.0618233 
v 0.0264017 0.00484011 0.0586284 
v 0.0279608 0.00484011 0.0615691 
v 0.0274512 0.00484011 0.0612626 
v 0.0285243 0.00484011 0.061759 
v 0.0266858 0.00484011 0.0603614 
v 0.0264657 0.00484011 0.059809 
v 0.0297066 0.00484011 0.061759 
v 0.0307797 0.00484011 0.0612626 
v 0.0302702 0.00484011 0.0615691 
v 0.0270195 0.00484011 0.0608536 
v 0.0312114 0.00484011 0.0608536 
v 0.0318292 0.00484011 -0.0293716 
v 0.0318614 0.00484011 -0.0287778 
v 0.0313655 0.00484011 -0.0305007 
v 0.0315451 0.00484011 -0.0276386 
v 0.0313655 0.00484011 -0.0273736 
v 0.0316702 0.00484011 -0.0299446 
v 0.0313916 0.00484011 -0.03047 
v 0.0317652 0.00484011 -0.028191 
v 0.0288181 0.00484011 -0.0316606 
v 0.0291155 0.00484011 -0.0316767 
v 0.0294128 0.00484011 -0.0316606 
v 0.0282374 0.00484011 -0.0315327 
v 0.0299936 0.00484011 -0.0315327 
v 0.0276977 0.00484011 -0.0312831 
v 0.0265608 0.00484011 -0.0299446 
v 0.0268393 0.00484011 -0.03047 
v 0.0291155 0.00484011 -0.0261767 
v 0.0272243 0.00484011 -0.0309232 
v 0.0264017 0.00484011 -0.0293716 
v 0.0263695 0.00484011 -0.0287778 
v 0.0266858 0.00484011 -0.0276386 
v 0.0264657 0.00484011 -0.028191 
v 0.0285243 0.00484011 -0.026241 
v 0.0279608 0.00484011 -0.0264309 
v 0.0274512 0.00484011 -0.0267374 
v 0.0297066 0.00484011 -0.026241 
v 0.0312114 0.00484011 -0.0271464 
v 0.0307797 0.00484011 -0.0267374 
v 0.0270195 0.00484011 -0.0271464 
v 0.0302702 0.00484011 -0.0264309 
v 0.0305332 0.00484011 -0.0312831 
v 0.0310066 0.00484011 -0.0309232 
v 0.0181155 0.00484011 0.0115108 
v 0.0253713 0.00484011 0.00525171 
v 0.0253959 0.00484011 0.00466548 
v 0.0253713 0.00484011 0.0115108 
v 0.0258098 0.00484011 0.00357457 
v 0.0258655 0.00484011 0.00350613 
v 0.0255443 0.00484011 0.00409782 
v 0.0277335 0.00484011 0.00234995 
v 0.0283199 0.00484011 0.00233091 
v 0.0271645 0.00484011 0.00249297 
v 0.0288971 0.00484011 0.00243671 
v 0.0294386 0.00484011 0.00266253 
v 0.0261802 0.00484011 0.00311954 
v 0.0303191 0.00484011 0.00342814 
v 0.0306179 0.00484011 0.00393307 
v 0.0266387 0.00484011 0.00275345 
v 0.0308655 0.00484011 0.0050733 
v 0.0299199 0.00484011 0.0029981 
v 0.0308029 0.00484011 0.0044899 
v 0.0306179 0.00484011 0.0162135 
v 0.0303191 0.00484011 0.0167185 
v 0.0283199 0.00484011 0.0178157 
v 0.0294386 0.00484011 0.0174841 
v 0.0288971 0.00484011 0.0177099 
v 0.0299199 0.00484011 0.0171485 
v 0.0271645 0.00484011 0.0176536 
v 0.0266387 0.00484011 0.0173931 
v 0.0277335 0.00484011 0.0177966 
v 0.0308029 0.00484011 0.0156567 
v 0.0308655 0.00484011 0.0115108 
v 0.0308655 0.00484011 0.0150733 
v 0.0261802 0.00484011 0.0170271 
v 0.0181155 0.00484011 0.0189483 
v 0.0258655 0.00484011 0.0166405 
v 0.0253959 0.00484011 0.0154811 
v 0.0253713 0.00484011 0.0148949 
v 0.0258098 0.00484011 0.016572 
v 0.0255443 0.00484011 0.0160488 
v 0.0964557 0.00484011 0.0172659 
v 0.0960244 0.00484011 0.0168593 
v 0.0956902 0.00484011 0.0163696 
v 0.0969642 0.00484011 0.0175707 
v 0.0981155 0.00484011 0.0178233 
v 0.0975261 0.00484011 0.0177594 
v 0.0987048 0.00484011 0.0177594 
v 0.0953702 0.00484011 0.0152352 
v 0.0953655 0.00484011 0.0150733 
v 0.0997753 0.00484011 0.0172659 
v 0.0992668 0.00484011 0.0175707 
v 0.0954687 0.00484011 0.0158198 
v 0.0999905 0.00484011 0.017063 
v 0.0995008 0.00484011 0.0026977 
v 0.0999653 0.00484011 0.00303843 
v 0.0972725 0.00484011 0.00245569 
v 0.0978363 0.00484011 0.0023375 
v 0.0989755 0.00484011 0.00246122 
v 0.0984124 0.00484011 0.00233937 
v 0.0967456 0.00484011 0.00268876 
v 0.0962789 0.00484011 0.00302647 
v 0.0956042 0.00484011 0.0039526 
v 0.0958928 0.00484011 0.003454 
v 0.0954258 0.00484011 0.00450038 
v 0.0953655 0.00484011 0.0115108 
v 0.0953655 0.00484011 0.0050733 
v 0.108115 0.00484011 -0.0030517 
v 0.100809 0.00484011 0.00451785 
v 0.100865 0.00484011 0.00509115 
v 0.108115 0.00484011 0.0115108 
v 0.0999905 0.00484011 0.00306668 
v 0.100634 0.00484011 0.00396893 
v 0.100349 0.00484011 0.00346847 
v 0.100865 0.00484011 0.0150733 
v 0.100865 0.00484011 0.0115108 
v 0.100861 0.00484011 0.0152352 
v 0.100762 0.00484011 0.0158197 
v 0.100207 0.00484011 0.0168593 
v 0.100541 0.00484011 0.0163696 
v 0.0770501 0.00484011 -0.0153537 
v 0.0755308 0.00484011 -0.0182194 
v 0.0743461 0.00484011 -0.0196142 
v 0.0780935 0.00484011 -0.00898954 
v 0.0775687 0.00484011 -0.0057887 
v 0.0779179 0.00484011 -0.0122284 
v 0.0773422 0.00484011 -0.0143017 
v 0.0631155 0.00484011 0.00519838 
v 0.0694138 0.00484011 0.00381201 
v 0.06634 0.00484011 0.00484769 
v 0.0763682 0.00484011 -0.0027755 
v 0.0721931 0.00484011 0.00213977 
v 0.0745479 0.00484011 -9.08279e-05 
v 0.0598909 0.00484011 0.00484769 
v 0.0568171 0.00484011 0.00381201 
v 0.0498628 0.00484011 -0.0027755 
v 0.0540379 0.00484011 0.00213977 
v 0.051683 0.00484011 -9.08279e-05 
v 0.0764782 0.00484011 -0.0030517 
v 0.0481375 0.00484011 -0.00898954 
v 0.0486622 0.00484011 -0.0057887 
v 0.0483131 0.00484011 -0.0122284 
v 0.0497527 0.00484011 -0.0030517 
v 0.0488887 0.00484011 -0.0143017 
v 0.0491808 0.00484011 -0.0153537 
v 0.0507001 0.00484011 -0.0182194 
v 0.0614937 0.00484011 -0.0247137 
v 0.0631155 0.00484011 -0.0248016 
v 0.073431 0.00484011 -0.0206916 
v 0.0708488 0.00484011 -0.0226545 
v 0.0647373 0.00484011 -0.0247137 
v 0.067905 0.00484011 -0.0240164 
v 0.058326 0.00484011 -0.0240164 
v 0.0528 0.00484011 -0.0206916 
v 0.0553822 0.00484011 -0.0226545 
v 0.0518848 0.00484011 -0.0196142 
v 0.0313655 0.00484011 0.0399993 
v 0.0318614 0.00484011 0.0417222 
v 0.0317652 0.00484011 0.042309 
v 0.0313916 0.00484011 0.04003 
v 0.0315451 0.00484011 0.0428614 
v 0.0313655 0.00484011 0.0431264 
v 0.0318292 0.00484011 0.0411284 
v 0.0316702 0.00484011 0.0405554 
v 0.0288181 0.00484011 0.0388394 
v 0.0291155 0.00484011 0.0388233 
v 0.0294128 0.00484011 0.0388394 
v 0.0282374 0.00484011 0.0389673 
v 0.0299936 0.00484011 0.0389673 
v 0.0268393 0.00484011 0.04003 
v 0.0272243 0.00484011 0.0395768 
v 0.0276977 0.00484011 0.0392169 
v 0.0265608 0.00484011 0.0405554 
v 0.0305332 0.00484011 0.0392169 
v 0.0310066 0.00484011 0.0395768 
v 0.0263695 0.00484011 0.0417222 
v 0.0291155 0.00484011 0.0443233 
v 0.0264017 0.00484011 0.0411284 
v 0.0285243 0.00484011 0.044259 
v 0.0266858 0.00484011 0.0428614 
v 0.0264657 0.00484011 0.042309 
v 0.0279608 0.00484011 0.0440691 
v 0.0274512 0.00484011 0.0437626 
v 0.0297066 0.00484011 0.044259 
v 0.0307797 0.00484011 0.0437626 
v 0.0302702 0.00484011 0.0440691 
v 0.0270195 0.00484011 0.0433536 
v 0.0312114 0.00484011 0.0433536 
v 0.0871155 0.00484011 -0.0144267 
v 0.0864917 0.00484011 -0.0143611 
v 0.0863088 0.00484011 -0.0143017 
v 0.0937405 0.00484011 -0.0144267 
v 0.0971155 0.00484011 -0.0144267 
v 0.0977392 0.00484011 -0.0143611 
v 0.0979222 0.00484011 -0.0143017 
v 0.0983357 0.00484011 -0.0141673 
v 0.0993449 0.00484011 -0.0134341 
v 0.0997136 0.00484011 -0.0129267 
v 0.0988788 0.00484011 -0.0138538 
v 0.0999686 0.00484011 -0.0123538 
v 0.0999905 0.00484011 -0.0106024 
v 0.100099 0.00484011 -0.0111131 
v 0.100099 0.00484011 -0.0117403 
v 0.0999905 0.00484011 -0.012251 
v 0.0971155 0.00484011 -0.0084267 
v 0.0977392 0.00484011 -0.00849226 
v 0.0988788 0.00484011 -0.00899965 
v 0.0983357 0.00484011 -0.00868607 
v 0.0993449 0.00484011 -0.00941931 
v 0.0997136 0.00484011 -0.0099267 
v 0.0999686 0.00484011 -0.0104997 
v 0.0937405 0.00484011 -0.0084267 
v 0.0841319 0.00484011 -0.0111131 
v 0.0841319 0.00484011 -0.0117403 
v 0.0842623 0.00484011 -0.0104997 
v 0.0871155 0.00484011 -0.0084267 
v 0.0853521 0.00484011 -0.0138538 
v 0.0858953 0.00484011 -0.0141673 
v 0.0845174 0.00484011 -0.0129267 
v 0.084886 0.00484011 -0.0134341 
v 0.0842623 0.00484011 -0.0123538 
v 0.084886 0.00484011 -0.00941931 
v 0.0845174 0.00484011 -0.0099267 
v 0.0858953 0.00484011 -0.00868607 
v 0.0853521 0.00484011 -0.00899965 
v 0.0864917 0.00484011 -0.00849226 
v 0.0871155 0.00484011 0.0385733 
v 0.0864917 0.00484011 0.0386389 
v 0.0863088 0.00484011 0.0386983 
v 0.0937405 0.00484011 0.0385733 
v 0.0971155 0.00484011 0.0385733 
v 0.0977392 0.00484011 0.0386389 
v 0.0979222 0.00484011 0.0386983 
v 0.0993449 0.00484011 0.0395659 
v 0.0997136 0.00484011 0.0400733 
v 0.0983357 0.00484011 0.0388327 
v 0.0988788 0.00484011 0.0391462 
v 0.0999686 0.00484011 0.0406462 
v 0.0999905 0.00484011 0.0423976 
v 0.105428 0.00484011 0.0504483 
v 0.108115 0.00484011 0.0450733 
v 0.100099 0.00484011 0.0418869 
v 0.100099 0.00484011 0.0412597 
v 0.0999905 0.00484011 0.040749 
v 0.0971155 0.00484011 0.0445733 
v 0.0977392 0.00484011 0.0445077 
v 0.0983357 0.00484011 0.0443139 
v 0.0993449 0.00484011 0.0435807 
v 0.0988788 0.00484011 0.0440003 
v 0.0999686 0.00484011 0.0425003 
v 0.0997136 0.00484011 0.0430733 
v 0.0841319 0.00484011 0.0418869 
v 0.0841319 0.00484011 0.0412597 
v 0.0842623 0.00484011 0.0425003 
v 0.0842623 0.00484011 0.0406462 
v 0.0845174 0.00484011 0.0400733 
v 0.084886 0.00484011 0.0435807 
v 0.0845174 0.00484011 0.0430733 
v 0.0853521 0.00484011 0.0440003 
v 0.0937405 0.00484011 0.0445733 
v 0.0871155 0.00484011 0.0445733 
v 0.0858953 0.00484011 0.0443139 
v 0.0864917 0.00484011 0.0445077 
v 0.084886 0.00484011 0.0395659 
v 0.0853521 0.00484011 0.0391462 
v 0.0858953 0.00484011 0.0388327 
v 0.0231155 0.00484011 0.0619488 
v 0.0181155 0.00484011 -0.0143017 
v 0.0811155 0.00484011 0.0504483 
v 0.0937405 0.00484011 0.0504483 
v 0.0999905 0.00484011 0.0504483 
v 0.0406155 0.00484011 0.0504483 
v 0.0811155 0.00484011 0.0386983 
v 0.0258655 0.00484011 0.0386983 
v 0.0258655 0.00484011 0.0373233 
v 0.0313655 0.00484011 0.0386983 
v 0.0313655 0.00484011 0.0373233 
v 0.0406155 0.00484011 0.0386983 
v 0.0406155 0.00484011 0.0373233 
v 0.0811155 0.00484011 0.0373233 
v 0.0999905 0.00484011 0.0386983 
v 0.0258655 0.00484011 0.0189483 
v 0.0313655 0.00484011 0.0189483 
v 0.0937405 0.00484011 0.0373233 
v 0.0999905 0.00484011 0.0373233 
v 0.0999905 0.00484011 0.0189483 
v 0.0406155 0.00484011 0.0189483 
v 0.0406155 0.00484011 0.0115108 
v 0.0811155 0.00484011 0.0189483 
v 0.0811155 0.00484011 0.0115108 
v 0.0937405 0.00484011 0.0189483 
v 0.0937405 0.00484011 0.0115108 
v 0.0313655 0.00484011 0.0115108 
v 0.0406155 0.00484011 -0.0030517 
v 0.0937405 0.00484011 -0.0030517 
v 0.0258655 0.00484011 -0.0030517 
v 0.0258655 0.00484011 -0.0143017 
v 0.0313655 0.00484011 -0.0143017 
v 0.0313655 0.00484011 -0.0196142 
v 0.0406155 0.00484011 -0.0143017 
v 0.0406155 0.00484011 -0.0196142 
v 0.0258655 0.00484011 -0.0196142 
v 0.0313655 0.00484011 -0.0254892 
v 0.0406155 0.00484011 -0.0254892 
v 0.0811155 0.00484011 -0.0196142 
v 0.0937405 0.00484011 -0.0196142 
v 0.0937405 0.00484011 -0.0254892 
v 0.0999905 0.00484011 -0.0196142 
v 0.0999905 0.00484011 -0.0254892 
v 0.0811155 0.00484011 -0.0254892 
v 0.0811155 0.00484011 -0.0333017 
v 0.0937405 0.00484011 -0.0333017 
v 0.0999905 0.00484011 -0.0333017 
v 0.0258655 0.00484011 -0.0333017 
v 0.0313655 0.00484011 -0.0333017 
v 0.0406155 0.00484011 -0.0333017 
v 0.0258655 0.00484011 0.0504483 
v 0.0999905 0.00484011 -0.0143017 
v 0.0258655 0.00484011 -0.0254892 
v 0.0313655 0.00484011 0.0504483 
v 0.0313655 0.00484011 -0.0030517 
v 0.0999905 0.00484011 -0.0030517 
v 0.0811155 0.00484011 -0.0143017 
v 0.0811155 0.00484011 -0.0030517 
vn 0.229105 0.00465753 -0.973391 
vn 0.0223296 0.00467555 -0.99974 
vn 0.425379 0.00464754 -0.905003 
vn 0.229105 0.00465753 -0.973391 
vn 0.603076 0.00464587 -0.79767 
vn 0.425379 0.00464754 -0.905003 
vn 0.754853 0.00465258 -0.655878 
vn 0.603076 0.00464587 -0.79767 
vn 0.87429 0.00466747 -0.485382 
vn 0.754853 0.00465258 -0.655878 
vn 0.956077 0.00469005 -0.293078 
vn 0.87429 0.00466747 -0.485382 
vn 0.99621 0.00471959 -0.0868479 
vn 0.956077 0.00469005 -0.293078 
vn 0.992192 0.00475504 0.124626 
vn 0.99621 0.00471959 -0.0868479 
vn 0.943235 0.00479508 0.332093 
vn 0.992192 0.00475504 0.124626 
vn 0.850447 0.00483807 0.526039 
vn 0.943235 0.00479508 0.332093 
vn 0.716987 0.00488213 0.697069 
vn 0.850447 0.00483807 0.526039 
vn 0.548136 0.00492517 0.836375 
vn 0.716987 0.00488213 0.697069 
vn 0.351249 0.00496495 0.936269 
vn 0.548136 0.00492517 0.836375 
vn 0.135551 0.00499929 0.990758 
vn 0.351249 0.00496495 0.936269 
vn -0.0882711 0.00502616 0.996084 
vn 0.0239449 0.00501377 0.999701 
vn 0.135551 0.00499929 0.990758 
vn -0.308658 0.00504392 0.95116 
vn -0.513937 0.00505141 0.857813 
vn -0.693151 0.00504816 0.720774 
vn -0.836867 0.00503438 0.547383 
vn -0.828446 0.00503562 0.560047 
vn -0.693151 0.00504816 0.720774 
vn -0.937836 0.00501095 0.347043 
vn -0.836867 0.00503438 0.547383 
vn -0.991435 0.00497935 0.130505 
vn -0.937836 0.00501095 0.347043 
vn -0.995845 0.00494147 -0.0909308 
vn -0.991435 0.00497935 0.130505 
vn -0.951966 0.00489946 -0.306164 
vn -0.995845 0.00494147 -0.0909308 
vn -0.863141 0.00485554 -0.50494 
vn -0.951966 0.00489946 -0.306164 
vn -0.734737 0.00481189 -0.678335 
vn -0.798501 0.00483187 -0.601974 
vn -0.863141 0.00485554 -0.50494 
vn -0.573684 0.00477047 -0.819063 
vn -0.734737 0.00481189 -0.678335 
vn -0.387995 0.00473302 -0.921649 
vn -0.573684 0.00477047 -0.819063 
vn -0.186341 0.004701 -0.982474 
vn -0.387995 0.00473302 -0.921649 
vn 0.0232074 -0.999116 -0.0350655 
vn 0.0229842 0.999132 -0.0347283 
vn 0.222335 0.00465801 -0.974959 
vn 0.0223296 0.00467555 -0.99974 
vn 0.412786 0.00464795 -0.910816 
vn 0.222335 0.00465801 -0.974959 
vn 0.586358 0.00464566 -0.810039 
vn 0.412786 0.00464795 -0.910816 
vn 0.736355 0.00465121 -0.67658 
vn 0.586358 0.00464566 -0.810039 
vn 0.85687 0.00466444 -0.515512 
vn 0.736355 0.00465121 -0.67658 
vn 0.942944 0.00468495 -0.332918 
vn 0.85687 0.00466444 -0.515512 
vn 0.990729 0.00471213 -0.135768 
vn 0.942944 0.00468495 -0.332918 
vn 0.997658 0.00474508 0.0682353 
vn 0.990729 0.00471213 -0.135768 
vn 0.962613 0.00478268 0.270838 
vn 0.997658 0.00474508 0.0682353 
vn 0.886094 0.00482352 0.46348 
vn 0.962613 0.00478268 0.270838 
vn 0.770357 0.00486598 0.637594 
vn 0.886094 0.00482352 0.46348 
vn 0.619497 0.00490822 0.784983 
vn 0.770357 0.00486598 0.637594 
vn 0.439457 0.00494825 0.89825 
vn 0.619497 0.00490822 0.784983 
vn 0.237899 0.00498408 0.971277 
vn 0.301361 0.00497368 0.953497 
vn 0.439457 0.00494825 0.89825 
vn 0.0239449 0.00501377 0.999701 
vn 0.237899 0.00498408 0.971277 
vn 0.0223296 0.00467555 -0.99974 
vn -0.192263 0.00503567 0.981331 
vn 0.0239449 0.00501377 0.999701 
vn -0.400136 0.00504847 0.916442 
vn -0.257269 0.0050406 0.966327 
vn -0.192263 0.00503567 0.981331 
vn -0.589321 0.0050514 0.807883 
vn -0.400136 0.00504847 0.916442 
vn -0.750405 0.0050443 0.660959 
vn -0.589321 0.0050514 0.807883 
vn -0.875558 0.00502758 0.483087 
vn -0.750405 0.0050443 0.660959 
vn -0.959027 0.00500225 0.283272 
vn -0.875558 0.00502758 0.483087 
vn -0.997431 0.00496977 0.0714664 
vn -0.968616 0.00499728 0.248513 
vn -0.959027 0.00500225 0.283272 
vn -0.98984 0.00493195 -0.142101 
vn -0.997431 0.00496977 0.0714664 
vn -0.937651 0.00489076 -0.347543 
vn -0.949328 0.00489777 -0.31425 
vn -0.98984 0.00493195 -0.142101 
vn -0.844318 0.00484819 -0.53582 
vn -0.937651 0.00489076 -0.347543 
vn -0.714984 0.00480619 -0.699124 
vn -0.844318 0.00484819 -0.53582 
vn -0.556084 0.00476652 -0.831112 
vn -0.714984 0.00480619 -0.699124 
vn -0.37495 0.0047307 -0.927033 
vn -0.556084 0.00476652 -0.831112 
vn -0.179448 0.00470004 -0.983756 
vn -0.37495 0.0047307 -0.927033 
vn 0.0223296 0.00467555 -0.99974 
vn -0.179448 0.00470004 -0.983756 
vn 0.222335 0.00465801 -0.974959 
vn 0.0223296 0.00467555 -0.99974 
vn 0.412786 0.00464795 -0.910816 
vn 0.222335 0.00465801 -0.974959 
vn 0.586358 0.00464566 -0.810039 
vn 0.412786 0.00464795 -0.910816 
vn 0.736355 0.00465121 -0.67658 
vn 0.586358 0.00464566 -0.810039 
vn 0.85687 0.00466444 -0.515512 
vn 0.736355 0.00465121 -0.67658 
vn 0.942944 0.00468495 -0.332918 
vn 0.85687 0.00466444 -0.515512 
vn 0.990729 0.00471213 -0.135768 
vn 0.942944 0.00468495 -0.332918 
vn 0.997658 0.00474508 0.0682353 
vn 0.990729 0.00471213 -0.135768 
vn 0.962613 0.00478268 0.270838 
vn 0.997658 0.00474508 0.0682353 
vn 0.886094 0.00482352 0.46348 
vn 0.962613 0.00478268 0.270838 
vn 0.770357 0.00486598 0.637594 
vn 0.886094 0.00482352 0.46348 
vn 0.619497 0.00490822 0.784983 
vn 0.770357 0.00486598 0.637594 
vn 0.439457 0.00494825 0.89825 
vn 0.619497 0.00490822 0.784983 
vn 0.237899 0.00498408 0.971277 
vn 0.301361 0.00497368 0.953497 
vn 0.439457 0.00494825 0.89825 
vn 0.0239449 0.00501377 0.999701 
vn 0.237899 0.00498408 0.971277 
vn 0.0223296 0.00467555 -0.99974 
vn -0.192263 0.00503567 0.981331 
vn 0.0239449 0.00501377 0.999701 
vn -0.400136 0.00504847 0.916442 
vn -0.257269 0.0050406 0.966327 
vn -0.192263 0.00503567 0.981331 
vn -0.589321 0.0050514 0.807883 
vn -0.400136 0.00504847 0.916442 
vn -0.750405 0.0050443 0.660959 
vn -0.589321 0.0050514 0.807883 
vn -0.875558 0.00502758 0.483087 
vn -0.750405 0.0050443 0.660959 
vn -0.959027 0.00500225 0.283272 
vn -0.875558 0.00502758 0.483087 
vn -0.997431 0.00496977 0.0714664 
vn -0.968616 0.00499728 0.248513 
vn -0.959027 0.00500225 0.283272 
vn -0.98984 0.00493195 -0.142101 
vn -0.997431 0.00496977 0.0714664 
vn -0.937651 0.00489076 -0.347543 
vn -0.949328 0.00489777 -0.31425 
vn -0.98984 0.00493195 -0.142101 
vn -0.844318 0.00484819 -0.53582 
vn -0.937651 0.00489076 -0.347543 
vn -0.714984 0.00480619 -0.699124 
vn -0.844318 0.00484819 -0.53582 
vn -0.556084 0.00476652 -0.831112 
vn -0.714984 0.00480619 -0.699124 
vn -0.37495 0.0047307 -0.927033 
vn -0.556084 0.00476652 -0.831112 
vn -0.179448 0.00470004 -0.983756 
vn -0.37495 0.0047307 -0.927033 
vn 0.0223296 0.00467555 -0.99974 
vn -0.179448 0.00470004 -0.983756 
vn -0.950702 0.00489865 -0.310067 
vn -0.995394 0.00494059 -0.0957389 
vn -0.861425 0.00485485 -0.507862 
vn -0.950702 0.00489865 -0.310067 
vn -0.732913 0.00481135 -0.680305 
vn -0.861425 0.00485485 -0.507862 
vn -0.572048 0.0047701 -0.820207 
vn -0.655876 0.00479028 -0.754853 
vn -0.732913 0.00481135 -0.680305 
vn -0.386778 0.0047328 -0.922161 
vn -0.572048 0.0047701 -0.820207 
vn -0.185698 0.00470091 -0.982596 
vn -0.386778 0.0047328 -0.922161 
vn 0.0223268 0.00467555 -0.99974 
vn -0.185698 0.00470091 -0.982596 
vn 0.228469 0.00465758 -0.97354 
vn 0.0223268 0.00467555 -0.99974 
vn 0.4242 0.00464757 -0.905557 
vn 0.228469 0.00465758 -0.97354 
vn 0.601518 0.00464585 -0.798846 
vn 0.4242 0.00464757 -0.905557 
vn 0.753142 0.00465245 -0.657841 
vn 0.601518 0.00464585 -0.798846 
vn 0.8727 0.00466718 -0.488234 
vn 0.753142 0.00465245 -0.657841 
vn 0.954916 0.00468956 -0.296839 
vn 0.8727 0.00466718 -0.488234 
vn 0.995799 0.00471888 -0.0914483 
vn 0.954916 0.00468956 -0.296839 
vn -0.999349 0.00495141 -0.035724 
vn 0.999407 0.00472795 -0.0341173 
vn 0.995799 0.00471888 -0.0914483 
vn -0.999349 0.00495141 -0.035724 
vn 0.985318 0.00476346 0.170662 
vn 0.999407 0.00472795 -0.0341173 
vn 0.929122 0.00480296 0.369741 
vn 0.985318 0.00476346 0.170662 
vn 0.832196 0.00484493 0.55446 
vn 0.929122 0.00480296 0.369741 
vn 0.697738 0.0048876 0.716336 
vn 0.832196 0.00484493 0.55446 
vn 0.530818 0.00492905 0.847471 
vn 0.697738 0.0048876 0.716336 
vn 0.338322 0.00496726 0.941017 
vn 0.530818 0.00492905 0.847471 
vn 0.128753 0.00500023 0.991664 
vn 0.338322 0.00496726 0.941017 
vn -0.0881179 0.00502615 0.996097 
vn 0.128753 0.00500023 0.991664 
vn -0.301774 0.0050435 0.953366 
vn -0.0881179 0.00502615 0.996097 
vn -0.501596 0.00505125 0.865088 
vn -0.301774 0.0050435 0.953366 
vn -0.67757 0.00504893 0.735441 
vn -0.501596 0.00505125 0.865088 
vn -0.820984 0.00503667 0.57093 
vn -0.688013 0.00504843 0.725681 
vn -0.67757 0.00504893 0.735441 
vn -0.925002 0.00501522 0.379929 
vn -0.820984 0.00503667 0.57093 
vn -0.98507 0.00498585 0.172084 
vn -0.925002 0.00501522 0.379929 
vn -0.99909 0.00495023 -0.042362 
vn -0.98507 0.00498585 0.172084 
vn 0.999407 0.00472795 -0.0341173 
vn -0.968058 0.0049108 -0.250678 
vn -0.999349 0.00495141 -0.0357299 
vn -0.891942 0.00486776 -0.452124 
vn -0.968058 0.0049108 -0.250678 
vn -0.775676 0.0048244 -0.631112 
vn -0.891942 0.00486776 -0.452124 
vn -0.62554 0.00478269 -0.780178 
vn -0.775676 0.0048244 -0.631112 
vn -0.448967 0.00474436 -0.893536 
vn -0.62554 0.00478269 -0.780178 
vn -0.254132 0.00471089 -0.967158 
vn -0.448967 0.00474436 -0.893536 
vn -0.0495806 0.00468349 -0.998759 
vn -0.254132 0.00471089 -0.967158 
vn 0.156084 0.00466307 -0.987733 
vn -0.0495806 0.00468349 -0.998759 
vn 0.354466 0.00465028 -0.935057 
vn 0.156084 0.00466307 -0.987733 
vn 0.537599 0.00464552 -0.843188 
vn 0.354466 0.00465028 -0.935057 
vn 0.698144 0.00464892 -0.715942 
vn 0.537599 0.00464552 -0.843188 
vn 0.829567 0.0046604 -0.558388 
vn 0.811975 0.00465818 -0.583674 
vn 0.698144 0.00464892 -0.715942 
vn 0.926314 0.00467959 -0.376723 
vn 0.829567 0.0046604 -0.558388 
vn 0.983993 0.00470589 -0.178142 
vn 0.926314 0.00467959 -0.376723 
vn 0.999559 0.00473842 0.0293205 
vn 0.983993 0.00470589 -0.178142 
vn -0.999349 0.00495141 -0.0357299 
vn 0.0223296 0.00467555 -0.99974 
vn 0.0239449 0.00501377 0.999701 
vn -0.874965 0.0048604 -0.484162 
vn -0.999349 0.00495141 -0.0357299 
vn -0.705135 0.00480343 -0.709057 
vn 0.0223296 0.00467555 -0.99974 
vn 0.656514 0.00464717 -0.754299 
vn 0.999407 0.00472795 -0.0341173 
vn 0.885217 0.00466959 -0.465154 
vn 0.912137 0.00481159 0.409858 
vn 0.999407 0.00472795 -0.0341173 
vn 0.738304 0.00487587 0.674451 
vn 0.0239449 0.00501377 0.999701 
vn -0.749934 0.00504433 0.661493 
vn -0.999349 0.00495141 -0.0357299 
vn -0.903903 0.00502115 0.427708 
vn 0.0239449 0.00501377 0.999701 
vn 0.999407 0.00472795 -0.0341173 
vn 0.993773 0.00475266 0.111322 
vn 0.995245 0.00471798 -0.0972848 
vn 0.948545 0.00479189 0.316607 
vn 0.993773 0.00475266 0.111322 
vn 0.860494 0.00483414 0.509438 
vn 0.948545 0.00479189 0.316607 
vn 0.732486 0.0048776 0.680764 
vn 0.843776 0.00484062 0.536673 
vn 0.860494 0.00483414 0.509438 
vn 0.569396 0.00492028 0.822049 
vn 0.732486 0.0048776 0.680764 
vn 0.378078 0.00496005 0.925761 
vn 0.569396 0.00492028 0.822049 
vn 0.167187 0.00499479 0.985913 
vn 0.378078 0.00496005 0.925761 
vn -0.0531698 0.00502252 0.998573 
vn 0.167187 0.00499479 0.985913 
vn -0.271972 0.0050416 0.962292 
vn -0.0531698 0.00502252 0.998573 
vn -0.477969 0.00505084 0.878362 
vn -0.271972 0.0050416 0.962292 
vn -0.660456 0.00504965 0.750848 
vn -0.477969 0.00505084 0.878362 
vn -0.810037 0.00503811 0.586358 
vn -0.660456 0.00504965 0.750848 
vn -0.919279 0.00501695 0.393576 
vn -0.810037 0.00503811 0.586358 
vn -0.983172 0.00498747 0.182612 
vn -0.919279 0.00501695 0.393576 
vn -0.999349 0.00495141 -0.0357299 
vn -0.983172 0.00498747 0.182612 
vn 0.999407 0.00472795 -0.0341173 
vn -0.999349 0.00495141 -0.0357299 
vn 0.0239449 0.00501377 0.999701 
vn 0.229105 0.00465753 -0.973391 
vn 0.0223296 0.00467555 -0.99974 
vn 0.425379 0.00464754 -0.905003 
vn 0.229105 0.00465753 -0.973391 
vn 0.603076 0.00464587 -0.79767 
vn 0.425379 0.00464754 -0.905003 
vn 0.754853 0.00465258 -0.655878 
vn 0.603076 0.00464587 -0.79767 
vn 0.87429 0.00466747 -0.485382 
vn 0.754853 0.00465258 -0.655878 
vn 0.956077 0.00469005 -0.293078 
vn 0.87429 0.00466747 -0.485382 
vn 0.99621 0.00471959 -0.0868479 
vn 0.956077 0.00469005 -0.293078 
vn 0.992192 0.00475504 0.124626 
vn 0.99621 0.00471959 -0.0868479 
vn 0.943235 0.00479508 0.332093 
vn 0.992192 0.00475504 0.124626 
vn 0.850447 0.00483807 0.526039 
vn 0.943235 0.00479508 0.332093 
vn 0.716987 0.00488213 0.697069 
vn 0.850447 0.00483807 0.526039 
vn 0.548136 0.00492517 0.836375 
vn 0.716987 0.00488213 0.697069 
vn 0.351249 0.00496495 0.936269 
vn 0.548136 0.00492517 0.836375 
vn 0.135551 0.00499929 0.990758 
vn 0.351249 0.00496495 0.936269 
vn -0.0882711 0.00502616 0.996084 
vn 0.0239449 0.00501377 0.999701 
vn 0.135551 0.00499929 0.990758 
vn -0.308658 0.00504392 0.95116 
vn -0.513937 0.00505141 0.857813 
vn -0.693151 0.00504816 0.720774 
vn -0.836867 0.00503438 0.547383 
vn -0.828446 0.00503562 0.560047 
vn -0.693151 0.00504816 0.720774 
vn -0.937836 0.00501095 0.347043 
vn -0.836867 0.00503438 0.547383 
vn -0.991435 0.00497935 0.130505 
vn -0.937836 0.00501095 0.347043 
vn -0.995845 0.00494147 -0.0909308 
vn -0.991435 0.00497935 0.130505 
vn -0.951966 0.00489946 -0.306164 
vn -0.995845 0.00494147 -0.0909308 
vn -0.863141 0.00485554 -0.50494 
vn -0.951966 0.00489946 -0.306164 
vn -0.734737 0.00481189 -0.678335 
vn -0.798501 0.00483187 -0.601974 
vn -0.863141 0.00485554 -0.50494 
vn -0.573684 0.00477047 -0.819063 
vn -0.734737 0.00481189 -0.678335 
vn -0.387995 0.00473302 -0.921649 
vn -0.573684 0.00477047 -0.819063 
vn -0.186341 0.004701 -0.982474 
vn -0.387995 0.00473302 -0.921649 
vn 0.229105 0.00465753 -0.973391 
vn 0.0223296 0.00467555 -0.99974 
vn 0.425379 0.00464754 -0.905003 
vn 0.229105 0.00465753 -0.973391 
vn 0.603076 0.00464587 -0.79767 
vn 0.425379 0.00464754 -0.905003 
vn 0.754853 0.00465258 -0.655878 
vn 0.603076 0.00464587 -0.79767 
vn 0.87429 0.00466747 -0.485382 
vn 0.754853 0.00465258 -0.655878 
vn 0.956077 0.00469005 -0.293078 
vn 0.883373 0.00466922 -0.468648 
vn 0.87429 0.00466747 -0.485382 
vn 0.99621 0.00471959 -0.0868479 
vn 0.956077 0.00469005 -0.293078 
vn 0.992192 0.00475504 0.124626 
vn 0.99621 0.00471959 -0.0868479 
vn 0.943235 0.00479508 0.332093 
vn 0.964671 0.00478121 0.263412 
vn 0.992192 0.00475504 0.124626 
vn 0.850447 0.00483807 0.526039 
vn 0.943235 0.00479508 0.332093 
vn 0.716987 0.00488213 0.697069 
vn 0.779828 0.00486294 0.625975 
vn 0.850447 0.00483807 0.526039 
vn 0.548136 0.00492517 0.836375 
vn 0.716987 0.00488213 0.697069 
vn 0.351249 0.00496495 0.936269 
vn 0.548136 0.00492517 0.836375 
vn 0.135551 0.00499929 0.990758 
vn 0.351249 0.00496495 0.936269 
vn -0.0882711 0.00502616 0.996084 
vn 0.0239449 0.00501377 0.999701 
vn 0.135551 0.00499929 0.990758 
vn -0.308658 0.00504392 0.95116 
vn -0.513937 0.00505141 0.857813 
vn -0.693151 0.00504816 0.720774 
vn -0.836867 0.00503438 0.547383 
vn -0.760596 0.00504341 0.649206 
vn -0.693151 0.00504816 0.720774 
vn -0.937836 0.00501095 0.347043 
vn -0.836867 0.00503438 0.547383 
vn -0.991435 0.00497935 0.130505 
vn -0.961279 0.00500116 0.27553 
vn -0.937836 0.00501095 0.347043 
vn -0.995845 0.00494147 -0.0909308 
vn -0.991435 0.00497935 0.130505 
vn -0.951966 0.00489946 -0.306164 
vn -0.995845 0.00494147 -0.0909308 
vn -0.863141 0.00485554 -0.50494 
vn -0.872968 0.00485957 -0.487753 
vn -0.951966 0.00489946 -0.306164 
vn -0.734737 0.00481189 -0.678335 
vn -0.863141 0.00485554 -0.50494 
vn -0.573684 0.00477047 -0.819063 
vn -0.734737 0.00481189 -0.678335 
vn -0.387995 0.00473302 -0.921649 
vn -0.573684 0.00477047 -0.819063 
vn -0.186341 0.004701 -0.982474 
vn -0.387995 0.00473302 -0.921649 
vn 0.229105 0.00465753 -0.973391 
vn 0.0223296 0.00467555 -0.99974 
vn 0.425379 0.00464754 -0.905003 
vn 0.229105 0.00465753 -0.973391 
vn 0.603076 0.00464587 -0.79767 
vn 0.425379 0.00464754 -0.905003 
vn 0.754853 0.00465258 -0.655878 
vn 0.603076 0.00464587 -0.79767 
vn 0.87429 0.00466747 -0.485382 
vn 0.754853 0.00465258 -0.655878 
vn 0.956077 0.00469005 -0.293078 
vn 0.87429 0.00466747 -0.485382 
vn 0.99621 0.00471959 -0.0868479 
vn 0.956077 0.00469005 -0.293078 
vn 0.992192 0.00475504 0.124626 
vn 0.99621 0.00471959 -0.0868479 
vn 0.943235 0.00479508 0.332093 
vn 0.992192 0.00475504 0.124626 
vn 0.850447 0.00483807 0.526039 
vn 0.943235 0.00479508 0.332093 
vn 0.716987 0.00488213 0.697069 
vn 0.850447 0.00483807 0.526039 
vn 0.548136 0.00492517 0.836375 
vn 0.716987 0.00488213 0.697069 
vn 0.351249 0.00496495 0.936269 
vn 0.548136 0.00492517 0.836375 
vn 0.135551 0.00499929 0.990758 
vn 0.351249 0.00496495 0.936269 
vn -0.0882711 0.00502616 0.996084 
vn 0.0239449 0.00501377 0.999701 
vn 0.135551 0.00499929 0.990758 
vn -0.308658 0.00504392 0.95116 
vn -0.513937 0.00505141 0.857813 
vn -0.693151 0.00504816 0.720774 
vn -0.836867 0.00503438 0.547383 
vn -0.828446 0.00503562 0.560047 
vn -0.693151 0.00504816 0.720774 
vn -0.937836 0.00501095 0.347043 
vn -0.836867 0.00503438 0.547383 
vn -0.991435 0.00497935 0.130505 
vn -0.937836 0.00501095 0.347043 
vn -0.995845 0.00494147 -0.0909308 
vn -0.991435 0.00497935 0.130505 
vn -0.951966 0.00489946 -0.306164 
vn -0.995845 0.00494147 -0.0909308 
vn -0.863141 0.00485554 -0.50494 
vn -0.951966 0.00489946 -0.306164 
vn -0.734737 0.00481189 -0.678335 
vn -0.798501 0.00483187 -0.601974 
vn -0.863141 0.00485554 -0.50494 
vn -0.573684 0.00477047 -0.819063 
vn -0.734737 0.00481189 -0.678335 
vn -0.387995 0.00473302 -0.921649 
vn -0.573684 0.00477047 -0.819063 
vn -0.186341 0.004701 -0.982474 
vn -0.387995 0.00473302 -0.921649 
vn 0.229105 0.00465753 -0.973391 
vn 0.0223296 0.00467555 -0.99974 
vn 0.425379 0.00464754 -0.905003 
vn 0.229105 0.00465753 -0.973391 
vn 0.603076 0.00464587 -0.79767 
vn 0.425379 0.00464754 -0.905003 
vn 0.754853 0.00465258 -0.655878 
vn 0.603076 0.00464587 -0.79767 
vn 0.87429 0.00466747 -0.485382 
vn 0.754853 0.00465258 -0.655878 
vn 0.956077 0.00469005 -0.293078 
vn 0.87429 0.00466747 -0.485382 
vn 0.99621 0.00471959 -0.0868479 
vn 0.956077 0.00469005 -0.293078 
vn 0.992192 0.00475504 0.124626 
vn 0.99621 0.00471959 -0.0868479 
vn 0.943235 0.00479508 0.332093 
vn 0.992192 0.00475504 0.124626 
vn 0.850447 0.00483807 0.526039 
vn 0.943235 0.00479508 0.332093 
vn 0.716987 0.00488213 0.697069 
vn 0.850447 0.00483807 0.526039 
vn 0.548136 0.00492517 0.836375 
vn 0.716987 0.00488213 0.697069 
vn 0.351249 0.00496495 0.936269 
vn 0.548136 0.00492517 0.836375 
vn 0.135551 0.00499929 0.990758 
vn 0.351249 0.00496495 0.936269 
vn -0.0882711 0.00502616 0.996084 
vn 0.0239449 0.00501377 0.999701 
vn 0.135551 0.00499929 0.990758 
vn -0.308658 0.00504392 0.95116 
vn -0.0882711 0.00502616 0.996084 
vn -0.513937 0.00505141 0.857813 
vn -0.308658 0.00504392 0.95116 
vn -0.693151 0.00504816 0.720774 
vn -0.513937 0.00505141 0.857813 
vn -0.836867 0.00503438 0.547383 
vn -0.693151 0.00504816 0.720774 
vn -0.937836 0.00501095 0.347043 
vn -0.836867 0.00503438 0.547383 
vn -0.991435 0.00497935 0.130505 
vn -0.937836 0.00501095 0.347043 
vn -0.995845 0.00494147 -0.0909308 
vn -0.991435 0.00497935 0.130505 
vn -0.951966 0.00489946 -0.306164 
vn -0.995845 0.00494147 -0.0909308 
vn -0.863141 0.00485554 -0.50494 
vn -0.951966 0.00489946 -0.306164 
vn -0.734737 0.00481189 -0.678335 
vn -0.863141 0.00485554 -0.50494 
vn -0.573684 0.00477047 -0.819063 
vn -0.734737 0.00481189 -0.678335 
vn -0.387995 0.00473302 -0.921649 
vn -0.573684 0.00477047 -0.819063 
vn -0.186341 0.004701 -0.982474 
vn -0.387995 0.00473302 -0.921649 
vn 0.229105 0.00465753 -0.973391 
vn 0.0223296 0.00467555 -0.99974 
vn 0.425379 0.00464754 -0.905003 
vn 0.229105 0.00465753 -0.973391 
vn 0.603076 0.00464587 -0.79767 
vn 0.425379 0.00464754 -0.905003 
vn 0.754853 0.00465258 -0.655878 
vn 0.603076 0.00464587 -0.79767 
vn 0.87429 0.00466747 -0.485382 
vn 0.754853 0.00465258 -0.655878 
vn 0.956077 0.00469005 -0.293078 
vn 0.87429 0.00466747 -0.485382 
vn 0.99621 0.00471959 -0.0868479 
vn 0.956077 0.00469005 -0.293078 
vn 0.992192 0.00475504 0.124626 
vn 0.99621 0.00471959 -0.0868479 
vn 0.943235 0.00479508 0.332093 
vn 0.992192 0.00475504 0.124626 
vn 0.850447 0.00483807 0.526039 
vn 0.943235 0.00479508 0.332093 
vn 0.716987 0.00488213 0.697069 
vn 0.850447 0.00483807 0.526039 
vn 0.548136 0.00492517 0.836375 
vn 0.716987 0.00488213 0.697069 
vn 0.351249 0.00496495 0.936269 
vn 0.548136 0.00492517 0.836375 
vn 0.135551 0.00499929 0.990758 
vn 0.351249 0.00496495 0.936269 
vn -0.0882711 0.00502616 0.996084 
vn 0.0239449 0.00501377 0.999701 
vn 0.135551 0.00499929 0.990758 
vn -0.308658 0.00504392 0.95116 
vn -0.0882711 0.00502616 0.996084 
vn -0.513937 0.00505141 0.857813 
vn -0.308658 0.00504392 0.95116 
vn -0.693151 0.00504816 0.720774 
vn -0.513937 0.00505141 0.857813 
vn -0.836867 0.00503438 0.547383 
vn -0.693151 0.00504816 0.720774 
vn -0.937836 0.00501095 0.347043 
vn -0.836867 0.00503438 0.547383 
vn -0.991435 0.00497935 0.130505 
vn -0.937836 0.00501095 0.347043 
vn -0.995845 0.00494147 -0.0909308 
vn -0.991435 0.00497935 0.130505 
vn -0.951966 0.00489946 -0.306164 
vn -0.995845 0.00494147 -0.0909308 
vn -0.863141 0.00485554 -0.50494 
vn -0.951966 0.00489946 -0.306164 
vn -0.734737 0.00481189 -0.678335 
vn -0.863141 0.00485554 -0.50494 
vn -0.573684 0.00477047 -0.819063 
vn -0.734737 0.00481189 -0.678335 
vn -0.387995 0.00473302 -0.921649 
vn -0.573684 0.00477047 -0.819063 
vn -0.186341 0.004701 -0.982474 
vn -0.387995 0.00473302 -0.921649 
vn 0.229105 0.00465753 -0.973391 
vn 0.0223296 0.00467555 -0.99974 
vn 0.425379 0.00464754 -0.905003 
vn 0.229105 0.00465753 -0.973391 
vn 0.603076 0.00464587 -0.79767 
vn 0.425379 0.00464754 -0.905003 
vn 0.754853 0.00465258 -0.655878 
vn 0.603076 0.00464587 -0.79767 
vn 0.87429 0.00466747 -0.485382 
vn 0.754853 0.00465258 -0.655878 
vn 0.956077 0.00469005 -0.293078 
vn 0.87429 0.00466747 -0.485382 
vn 0.99621 0.00471959 -0.0868479 
vn 0.956077 0.00469005 -0.293078 
vn 0.992192 0.00475504 0.124626 
vn 0.99621 0.00471959 -0.0868479 
vn 0.943235 0.00479508 0.332093 
vn 0.992192 0.00475504 0.124626 
vn 0.850447 0.00483807 0.526039 
vn 0.943235 0.00479508 0.332093 
vn 0.716987 0.00488213 0.697069 
vn 0.850447 0.00483807 0.526039 
vn 0.548136 0.00492517 0.836375 
vn 0.716987 0.00488213 0.697069 
vn 0.351249 0.00496495 0.936269 
vn 0.548136 0.00492517 0.836375 
vn 0.135551 0.00499929 0.990758 
vn 0.351249 0.00496495 0.936269 
vn -0.0882711 0.00502616 0.996084 
vn 0.0239449 0.00501377 0.999701 
vn 0.135551 0.00499929 0.990758 
vn -0.308658 0.00504392 0.95116 
vn -0.513937 0.00505141 0.857813 
vn -0.693151 0.00504816 0.720774 
vn -0.836867 0.00503438 0.547383 
vn -0.828446 0.00503562 0.560047 
vn -0.693151 0.00504816 0.720774 
vn -0.937836 0.00501095 0.347043 
vn -0.836867 0.00503438 0.547383 
vn -0.991435 0.00497935 0.130505 
vn -0.937836 0.00501095 0.347043 
vn -0.995845 0.00494147 -0.0909308 
vn -0.991435 0.00497935 0.130505 
vn -0.951966 0.00489946 -0.306164 
vn -0.995845 0.00494147 -0.0909308 
vn -0.863141 0.00485554 -0.50494 
vn -0.951966 0.00489946 -0.306164 
vn -0.734737 0.00481189 -0.678335 
vn -0.798501 0.00483187 -0.601974 
vn -0.863141 0.00485554 -0.50494 
vn -0.573684 0.00477047 -0.819063 
vn -0.734737 0.00481189 -0.678335 
vn -0.387995 0.00473302 -0.921649 
vn -0.573684 0.00477047 -0.819063 
vn -0.186341 0.004701 -0.982474 
vn -0.387995 0.00473302 -0.921649 
usemtl 0.917647_0.917647_0.917647_0.000000_0.000000
o mesh349
f 7728//8074 7729//8075 7730//8075 
f 7731//8076 7728//8074 7732//8077 
f 7733//8078 7731//8076 7734//8079 
f 7735//8080 7733//8078 7736//8081 
f 7737//8082 7735//8080 7738//8083 
f 7739//8084 7737//8082 7740//8085 
f 7741//8086 7739//8084 7742//8087 
f 7743//8088 7741//8086 7744//8089 
f 7745//8090 7743//8088 7746//8091 
f 7747//8092 7745//8090 7748//8093 
f 7749//8094 7747//8092 7750//8095 
f 7751//8096 7749//8094 7752//8097 
f 7753//8098 7751//8096 7754//8099 
f 7755//8100 7753//8098 7756//8101 
f 7757//8102 7758//8102 7759//8103 
f 7755//8100 7760//8104 7761//8103 
f 7761//8103 7759//8103 7755//8100 
f 7762//8105 7758//8102 7757//8102 
f 7763//8106 7762//8105 7764//8105 
f 7765//8107 7763//8106 7766//8106 
f 7767//8108 7768//8109 7769//8109 
f 7770//8110 7769//8109 7768//8109 
f 7768//8109 7765//8107 7770//8110 
f 7771//8111 7767//8108 7772//8112 
f 7773//8113 7771//8111 7774//8114 
f 7775//8115 7773//8113 7776//8116 
f 7777//8117 7775//8115 7778//8118 
f 7779//8119 7777//8117 7780//8120 
f 7781//8121 7782//8122 7783//8122 
f 7784//8123 7783//8122 7782//8122 
f 7782//8122 7779//8119 7784//8123 
f 7785//8124 7781//8121 7786//8125 
f 7787//8126 7785//8124 7788//8127 
f 7789//8128 7787//8126 7790//8129 
f 7729//8075 7789//8128 7791//8128 
f 7791//8128 7730//8075 7729//8075 
f 7790//8129 7791//8128 7789//8128 
f 7788//8127 7790//8129 7787//8126 
f 7786//8125 7788//8127 7785//8124 
f 7783//8122 7786//8125 7781//8121 
f 7780//8120 7784//8123 7779//8119 
f 7778//8118 7780//8120 7777//8117 
f 7776//8116 7778//8118 7775//8115 
f 7774//8114 7776//8116 7773//8113 
f 7772//8112 7774//8114 7771//8111 
f 7769//8109 7772//8112 7767//8108 
f 7766//8106 7770//8110 7765//8107 
f 7764//8105 7766//8106 7763//8106 
f 7757//8102 7764//8105 7762//8105 
f 7759//8103 7761//8103 7757//8102 
f 7756//8101 7760//8104 7755//8100 
f 7754//8099 7756//8101 7753//8098 
f 7752//8097 7754//8099 7751//8096 
f 7750//8095 7752//8097 7749//8094 
f 7748//8093 7750//8095 7747//8092 
f 7746//8091 7748//8093 7745//8090 
f 7744//8089 7746//8091 7743//8088 
f 7742//8087 7744//8089 7741//8086 
f 7740//8085 7742//8087 7739//8084 
f 7738//8083 7740//8085 7737//8082 
f 7736//8081 7738//8083 7735//8080 
f 7734//8079 7736//8081 7733//8078 
f 7732//8077 7734//8079 7731//8076 
f 7730//8075 7732//8077 7728//8074 
o mesh350
f 8189//8130 7792//8130 7793//8130 
f 8190//8130 7793//8130 7794//8130 
f 8191//8130 7794//8130 7795//8130 
f 8192//8130 7795//8130 7796//8130 
f 8193//8130 7796//8130 7797//8130 
f 8194//8130 8191//8130 8192//8130 
f 8195//8130 8192//8130 8193//8130 
f 8193//8130 8196//8130 7798//8130 
f 8196//8130 7799//8130 7800//8130 
f 8196//8130 7801//8130 7802//8130 
f 8196//8130 8197//8130 7803//8130 
f 8198//8130 7804//8130 7805//8130 
f 8198//8130 7806//8130 7807//8130 
f 8193//8130 7808//8130 7809//8130 
f 8193//8130 7810//8130 7811//8130 
f 7798//8130 7812//8130 8193//8130 
f 8196//8130 7813//8130 7799//8130 
f 8196//8130 7814//8130 7801//8130 
f 7803//8130 7815//8130 8196//8130 
f 8197//8130 7816//8130 7817//8130 
f 8198//8130 7818//8130 7804//8130 
f 7807//8130 7819//8130 8198//8130 
f 8198//8130 7809//8130 7820//8130 
f 8193//8130 7821//8130 7808//8130 
f 7811//8130 7822//8130 8193//8130 
f 7812//8130 7823//8130 8193//8130 
f 7802//8130 7813//8130 8196//8130 
f 7817//8130 7803//8130 8197//8130 
f 8197//8130 7824//8130 7825//8130 
f 8197//8130 7826//8130 7827//8130 
f 7819//8130 7818//8130 8198//8130 
f 7809//8130 8198//8130 8193//8130 
f 7823//8130 7810//8130 8193//8130 
f 7815//8130 7814//8130 8196//8130 
f 7827//8130 7824//8130 8197//8130 
f 7805//8130 8197//8130 8198//8130 
f 7822//8130 7821//8130 8193//8130 
f 7825//8130 7816//8130 8197//8130 
f 7820//8130 7806//8130 8198//8130 
f 7805//8130 7826//8130 8197//8130 
f 8199//8130 8200//8130 8201//8130 
f 8202//8130 8201//8130 8194//8130 
f 8203//8130 8195//8130 8198//8130 
f 8204//8130 8198//8130 8197//8130 
f 8205//8130 8199//8130 8202//8130 
f 8206//8130 8202//8130 8207//8130 
f 7828//8130 7829//8130 8205//8130 
f 8208//8130 8209//8130 8210//8130 
f 8211//8130 8212//8130 8213//8130 
f 8214//8130 8208//8130 8215//8130 
f 8216//8130 8215//8130 8211//8130 
f 8217//8130 8211//8130 8218//8130 
f 7830//8130 7831//8130 8219//8130 
f 8220//8130 8219//8130 8214//8130 
f 8221//8130 8222//8130 8223//8130 
f 8224//8130 8223//8130 7832//8130 
f 7833//8130 7830//8130 8220//8130 
f 8225//8130 8220//8130 8226//8130 
f 8227//8130 8226//8130 8228//8130 
f 8229//8130 8228//8130 8230//8130 
f 8231//8130 8224//8130 7834//8130 
f 8232//8130 8229//8130 8233//8130 
f 7835//8130 8232//8130 8234//8130 
f 7836//8130 8234//8130 8235//8130 
f 8235//8130 8236//8130 7837//8130 
f 8236//8130 7838//8130 7839//8130 
f 7840//8130 7841//8130 7842//8130 
f 7837//8130 7843//8130 8235//8130 
f 8236//8130 7844//8130 7838//8130 
f 8236//8130 7845//8130 7846//8130 
f 7845//8130 7847//8130 7848//8130 
f 7842//8130 7845//8130 7840//8130 
f 7840//8130 7849//8130 7850//8130 
f 8235//8130 7851//8130 7849//8130 
f 7843//8130 7852//8130 8235//8130 
f 8236//8130 7853//8130 7844//8130 
f 8236//8130 7854//8130 7855//8130 
f 7848//8130 7846//8130 7845//8130 
f 7845//8130 7856//8130 7857//8130 
f 7842//8130 7858//8130 7845//8130 
f 7840//8130 7859//8130 7860//8130 
f 7849//8130 7840//8130 8235//8130 
f 8235//8130 7861//8130 7862//8130 
f 7852//8130 7863//8130 8235//8130 
f 7855//8130 7853//8130 8236//8130 
f 7846//8130 7864//8130 8236//8130 
f 7845//8130 7865//8130 7856//8130 
f 7860//8130 7841//8130 7840//8130 
f 8235//8130 7866//8130 7851//8130 
f 7863//8130 7861//8130 8235//8130 
f 7864//8130 7854//8130 8236//8130 
f 7858//8130 7865//8130 7845//8130 
f 7840//8130 7867//8130 7868//8130 
f 7862//8130 7866//8130 8235//8130 
f 7857//8130 7847//8130 7845//8130 
f 7850//8130 7867//8130 7840//8130 
f 7868//8130 7859//8130 7840//8130 
f 8205//8130 7869//8130 7870//8130 
f 8205//8130 7829//8130 7869//8130 
f 8199//8130 7870//8130 7871//8130 
f 7871//8130 8200//8130 8199//8130 
f 8200//8130 7872//8130 7873//8130 
f 7873//8130 8189//8130 8200//8130 
f 8189//8130 7874//8130 7875//8130 
f 8196//8130 7797//8130 7876//8130 
f 8197//8130 7877//8130 7878//8130 
f 8197//8130 8196//8130 7877//8130 
f 8237//8130 8197//8130 7879//8130 
f 8197//8130 7880//8130 7879//8130 
f 8238//8130 8237//8130 7881//8130 
f 7881//8130 7882//8130 8238//8130 
f 7845//8130 7883//8130 7884//8130 
f 7845//8130 8236//8130 7883//8130 
f 8236//8130 7885//8130 7883//8130 
f 7886//8130 7887//8130 7888//8130 
f 7888//8130 8239//8130 7886//8130 
f 8225//8130 8239//8130 7889//8130 
f 7889//8130 7890//8130 8225//8130 
f 8228//8130 7891//8130 7892//8130 
f 8217//8130 8222//8130 7893//8130 
f 8222//8130 8221//8130 7894//8130 
f 7894//8130 7893//8130 8222//8130 
f 8230//8130 7892//8130 7894//8130 
f 7894//8130 8221//8130 8230//8130 
f 7895//8130 8216//8130 8217//8130 
f 8214//8130 7896//8130 7897//8130 
f 8216//8130 7895//8130 7896//8130 
f 8228//8130 8226//8130 7897//8130 
f 7896//8130 8214//8130 8216//8130 
f 7897//8130 8226//8130 8214//8130 
f 8232//8130 7898//8130 7899//8130 
f 8232//8130 7900//8130 7898//8130 
f 7835//8130 7901//8130 7902//8130 
f 8232//8130 7902//8130 7900//8130 
f 7835//8130 7903//8130 7901//8130 
f 7835//8130 7904//8130 7905//8130 
f 7902//8130 8232//8130 7835//8130 
f 7905//8130 7906//8130 7835//8130 
f 7906//8130 7903//8130 7835//8130 
f 8239//8130 8240//8130 7907//8130 
f 8240//8130 7908//8130 7907//8130 
f 8240//8130 7909//8130 7908//8130 
f 7907//8130 7910//8130 8239//8130 
f 8239//8130 7911//8130 7912//8130 
f 8240//8130 7913//8130 7909//8130 
f 7912//8130 7914//8130 8239//8130 
f 7910//8130 7915//8130 8239//8130 
f 7916//8130 7917//8130 7918//8130 
f 8239//8130 7919//8130 7920//8130 
f 7915//8130 7911//8130 8239//8130 
f 8240//8130 7899//8130 7921//8130 
f 7918//8130 7904//8130 7916//8130 
f 7922//8130 7916//8130 7886//8130 
f 8239//8130 7923//8130 7919//8130 
f 7921//8130 7913//8130 8240//8130 
f 7904//8130 7924//8130 7925//8130 
f 7916//8130 7922//8130 7917//8130 
f 7886//8130 7926//8130 7927//8130 
f 7886//8130 7920//8130 7928//8130 
f 7914//8130 7923//8130 8239//8130 
f 7904//8130 7929//8130 7930//8130 
f 7918//8130 7924//8130 7904//8130 
f 7886//8130 7931//8130 7926//8130 
f 7920//8130 7886//8130 8239//8130 
f 7925//8130 7929//8130 7904//8130 
f 7928//8130 7931//8130 7886//8130 
f 7886//8130 7927//8130 7922//8130 
f 8191//8130 8194//8130 7932//8130 
f 8191//8130 7933//8130 7934//8130 
f 8194//8130 7935//8130 7932//8130 
f 8191//8130 7936//8130 7933//8130 
f 7932//8130 7937//8130 8191//8130 
f 8194//8130 8201//8130 7938//8130 
f 7937//8130 7936//8130 8191//8130 
f 7938//8130 7939//8130 8194//8130 
f 7939//8130 7935//8130 8194//8130 
f 8190//8130 7940//8130 7941//8130 
f 8190//8130 7942//8130 7940//8130 
f 8190//8130 7943//8130 7942//8130 
f 7941//8130 8189//8130 8190//8130 
f 8190//8130 7944//8130 7943//8130 
f 8200//8130 7945//8130 7946//8130 
f 8189//8130 7947//8130 7948//8130 
f 7941//8130 7949//8130 8189//8130 
f 7946//8130 8201//8130 8200//8130 
f 8200//8130 7950//8130 7951//8130 
f 8189//8130 7952//8130 7950//8130 
f 7948//8130 7953//8130 8189//8130 
f 7949//8130 7954//8130 8189//8130 
f 8201//8130 7955//8130 7956//8130 
f 8200//8130 7957//8130 7945//8130 
f 8200//8130 7958//8130 7959//8130 
f 7950//8130 8200//8130 8189//8130 
f 7954//8130 7947//8130 8189//8130 
f 7956//8130 7960//8130 8201//8130 
f 7946//8130 7961//8130 8201//8130 
f 8200//8130 7962//8130 7958//8130 
f 7953//8130 7952//8130 8189//8130 
f 7961//8130 7955//8130 8201//8130 
f 7951//8130 7962//8130 8200//8130 
f 7959//8130 7957//8130 8200//8130 
f 8190//8130 7934//8130 7963//8130 
f 7963//8130 7944//8130 8190//8130 
f 7831//8130 7964//8130 7965//8130 
f 7831//8130 7966//8130 7964//8130 
f 7831//8130 7967//8130 7968//8130 
f 7831//8130 7969//8130 7966//8130 
f 7967//8130 7970//8130 7968//8130 
f 7968//8130 7969//8130 7831//8130 
f 8214//8130 7971//8130 7972//8130 
f 8214//8130 7973//8130 7971//8130 
f 8214//8130 7974//8130 7975//8130 
f 8219//8130 7976//8130 7974//8130 
f 7975//8130 7973//8130 8214//8130 
f 8219//8130 7977//8130 7976//8130 
f 8219//8130 7978//8130 7979//8130 
f 7972//8130 7980//8130 8214//8130 
f 7979//8130 7977//8130 8219//8130 
f 8208//8130 8214//8130 7981//8130 
f 7974//8130 8214//8130 8219//8130 
f 8214//8130 7982//8130 7981//8130 
f 8219//8130 7965//8130 7978//8130 
f 7980//8130 7982//8130 8214//8130 
f 8241//8130 8209//8130 7983//8130 
f 7983//8130 7984//8130 8241//8130 
f 8241//8130 7985//8130 7986//8130 
f 8209//8130 7987//8130 7983//8130 
f 8209//8130 7988//8130 7989//8130 
f 8241//8130 7990//8130 7985//8130 
f 7989//8130 7987//8130 8209//8130 
f 8209//8130 7991//8130 7992//8130 
f 7984//8130 7990//8130 8241//8130 
f 7992//8130 7993//8130 8209//8130 
f 8208//8130 7994//8130 7995//8130 
f 7993//8130 7988//8130 8209//8130 
f 7995//8130 8209//8130 8208//8130 
f 7995//8130 7991//8130 8209//8130 
f 7967//8130 7828//8130 7996//8130 
f 7996//8130 7997//8130 7967//8130 
f 7828//8130 7998//8130 7996//8130 
f 7828//8130 7999//8130 7998//8130 
f 7828//8130 8241//8130 8000//8130 
f 8000//8130 7999//8130 7828//8130 
f 7832//8130 8001//8130 8002//8130 
f 8002//8130 8003//8130 7832//8130 
f 7832//8130 8004//8130 8001//8130 
f 7832//8130 8005//8130 8004//8130 
f 7832//8130 8006//8130 8005//8130 
f 7832//8130 8223//8130 8007//8130 
f 8007//8130 8006//8130 7832//8130 
f 8008//8130 8003//8130 8009//8130 
f 8008//8130 8010//8130 8011//8130 
f 8003//8130 8012//8130 8009//8130 
f 8008//8130 8013//8130 8010//8130 
f 8009//8130 8014//8130 8008//8130 
f 8014//8130 8013//8130 8008//8130 
f 8213//8130 8242//8130 8015//8130 
f 8213//8130 8016//8130 8017//8130 
f 8015//8130 8018//8130 8213//8130 
f 8242//8130 8011//8130 8019//8130 
f 8017//8130 8020//8130 8213//8130 
f 8018//8130 8021//8130 8213//8130 
f 8242//8130 8022//8130 8023//8130 
f 8019//8130 8024//8130 8242//8130 
f 8218//8130 8213//8130 8025//8130 
f 8021//8130 8016//8130 8213//8130 
f 8024//8130 8022//8130 8242//8130 
f 8213//8130 8026//8130 8025//8130 
f 8023//8130 8015//8130 8242//8130 
f 8020//8130 8026//8130 8213//8130 
f 8222//8130 8027//8130 8028//8130 
f 8223//8130 8222//8130 8029//8130 
f 8222//8130 8030//8130 8031//8130 
f 8222//8130 8032//8130 8027//8130 
f 8029//8130 8033//8130 8223//8130 
f 8028//8130 8030//8130 8222//8130 
f 8223//8130 8034//8130 8035//8130 
f 8031//8130 8029//8130 8222//8130 
f 8222//8130 8218//8130 8036//8130 
f 8033//8130 8034//8130 8223//8130 
f 8218//8130 8037//8130 8036//8130 
f 8035//8130 8038//8130 8223//8130 
f 8036//8130 8039//8130 8222//8130 
f 8039//8130 8032//8130 8222//8130 
f 8207//8130 8040//8130 8041//8130 
f 8207//8130 8042//8130 8040//8130 
f 8207//8130 8043//8130 8042//8130 
f 8243//8130 8044//8130 8045//8130 
f 8045//8130 8210//8130 8243//8130 
f 8243//8130 8041//8130 8044//8130 
f 8045//8130 8046//8130 8210//8130 
f 8211//8130 8047//8130 8048//8130 
f 8211//8130 8049//8130 8047//8130 
f 8211//8130 8050//8130 8049//8130 
f 8211//8130 8051//8130 8052//8130 
f 8052//8130 8050//8130 8211//8130 
f 8215//8130 8053//8130 8051//8130 
f 8051//8130 8211//8130 8215//8130 
f 8215//8130 8054//8130 8055//8130 
f 8055//8130 8053//8130 8215//8130 
f 8215//8130 8056//8130 8057//8130 
f 8210//8130 8058//8130 8056//8130 
f 8048//8130 8212//8130 8211//8130 
f 8056//8130 8215//8130 8210//8130 
f 8057//8130 8054//8130 8215//8130 
f 8244//8130 8212//8130 8059//8130 
f 8212//8130 8060//8130 8061//8130 
f 8061//8130 8059//8130 8212//8130 
f 8059//8130 8062//8130 8244//8130 
f 8244//8130 8063//8130 8064//8130 
f 8064//8130 8203//8130 8244//8130 
f 8064//8130 8065//8130 8203//8130 
f 8194//8130 8195//8130 8066//8130 
f 8195//8130 8067//8130 8066//8130 
f 8066//8130 8068//8130 8194//8130 
f 8195//8130 8069//8130 8067//8130 
f 8195//8130 8203//8130 8070//8130 
f 8195//8130 8071//8130 8069//8130 
f 8070//8130 8072//8130 8195//8130 
f 8194//8130 8073//8130 8074//8130 
f 8072//8130 8071//8130 8195//8130 
f 8194//8130 8075//8130 8043//8130 
f 8068//8130 8073//8130 8194//8130 
f 8074//8130 8075//8130 8194//8130 
f 8229//8130 8076//8130 8077//8130 
f 8229//8130 8078//8130 8076//8130 
f 8229//8130 8232//8130 8079//8130 
f 8229//8130 8080//8130 8078//8130 
f 8079//8130 8081//8130 8229//8130 
f 8232//8130 8240//8130 8082//8130 
f 8081//8130 8080//8130 8229//8130 
f 8082//8130 8083//8130 8232//8130 
f 8083//8130 8079//8130 8232//8130 
f 8225//8130 8227//8130 8084//8130 
f 8227//8130 8085//8130 8084//8130 
f 8227//8130 8086//8130 8085//8130 
f 8084//8130 8087//8130 8225//8130 
f 8225//8130 8088//8130 8089//8130 
f 8227//8130 8090//8130 8086//8130 
f 8089//8130 8091//8130 8225//8130 
f 8087//8130 8092//8130 8225//8130 
f 8239//8130 8093//8130 8094//8130 
f 8225//8130 8095//8130 8096//8130 
f 8092//8130 8088//8130 8225//8130 
f 8227//8130 8077//8130 8097//8130 
f 8094//8130 8240//8130 8239//8130 
f 8225//8130 8098//8130 8095//8130 
f 8097//8130 8090//8130 8227//8130 
f 8240//8130 8099//8130 8100//8130 
f 8239//8130 8101//8130 8093//8130 
f 8239//8130 8102//8130 8103//8130 
f 8239//8130 8096//8130 8104//8130 
f 8091//8130 8098//8130 8225//8130 
f 8240//8130 8105//8130 8106//8130 
f 8094//8130 8099//8130 8240//8130 
f 8239//8130 8107//8130 8102//8130 
f 8096//8130 8239//8130 8225//8130 
f 8100//8130 8105//8130 8240//8130 
f 8104//8130 8107//8130 8239//8130 
f 8103//8130 8101//8130 8239//8130 
f 8243//8130 8210//8130 7780//8130 
f 7780//8130 7778//8130 8243//8130 
f 8210//8130 8209//8130 7783//8130 
f 8243//8130 7772//8130 7769//8130 
f 7778//8130 7776//8130 8243//8130 
f 7783//8130 7784//8130 8210//8130 
f 8243//8130 7774//8130 7772//8130 
f 7784//8130 7780//8130 8210//8130 
f 7776//8130 7774//8130 8243//8130 
f 8205//8130 8206//8130 7761//8130 
f 8206//8130 7757//8130 7761//8130 
f 8206//8130 7764//8130 7757//8130 
f 8241//8130 7732//8130 7730//8130 
f 8205//8130 7754//8130 7752//8130 
f 7761//8130 7760//8130 8205//8130 
f 8209//8130 7788//8130 7786//8130 
f 8209//8130 7791//8130 7790//8130 
f 7730//8130 8209//8130 8241//8130 
f 8205//8130 7750//8130 7748//8130 
f 8205//8130 7756//8130 7754//8130 
f 8206//8130 7766//8130 7764//8130 
f 8206//8130 7769//8130 7770//8130 
f 7790//8130 7788//8130 8209//8130 
f 8241//8130 7734//8130 7732//8130 
f 8241//8130 7740//8130 7738//8130 
f 8241//8130 7744//8130 7742//8130 
f 8205//8130 7746//8130 7744//8130 
f 7752//8130 7750//8130 8205//8130 
f 7770//8130 7766//8130 8206//8130 
f 7730//8130 7791//8130 8209//8130 
f 7738//8130 7736//8130 8241//8130 
f 7744//8130 8241//8130 8205//8130 
f 7760//8130 7756//8130 8205//8130 
f 7736//8130 7734//8130 8241//8130 
f 7748//8130 7746//8130 8205//8130 
f 7742//8130 7740//8130 8241//8130 
f 8212//8130 8244//8130 8108//8130 
f 8244//8130 8109//8130 8108//8130 
f 8213//8130 8212//8130 8110//8130 
f 8212//8130 8111//8130 8112//8130 
f 8244//8130 8113//8130 8109//8130 
f 8212//8130 8114//8130 8110//8130 
f 8108//8130 8111//8130 8212//8130 
f 8244//8130 8115//8130 8116//8130 
f 8244//8130 8117//8130 8118//8130 
f 8212//8130 8119//8130 8114//8130 
f 8212//8130 8120//8130 8121//8130 
f 8244//8130 8122//8130 8113//8130 
f 8118//8130 8115//8130 8244//8130 
f 8121//8130 8119//8130 8212//8130 
f 8116//8130 8122//8130 8244//8130 
f 8112//8130 8120//8130 8212//8130 
f 8213//8130 8123//8130 8124//8130 
f 8242//8130 8125//8130 8126//8130 
f 8124//8130 8242//8130 8213//8130 
f 8124//8130 8125//8130 8242//8130 
f 8242//8130 8127//8130 8128//8130 
f 8126//8130 8129//8130 8242//8130 
f 8129//8130 8127//8130 8242//8130 
f 8128//8130 8130//8130 8242//8130 
f 8131//8130 8132//8130 8133//8130 
f 8008//8130 8242//8130 8134//8130 
f 8131//8130 8135//8130 8132//8130 
f 8134//8130 8131//8130 8008//8130 
f 8134//8130 8135//8130 8131//8130 
f 8238//8130 8136//8130 8137//8130 
f 8238//8130 8138//8130 8136//8130 
f 8238//8130 8139//8130 8140//8130 
f 8140//8130 8138//8130 8238//8130 
f 8238//8130 8133//8130 8139//8130 
f 8204//8130 8237//8130 8141//8130 
f 8237//8130 8142//8130 8141//8130 
f 8237//8130 8238//8130 8143//8130 
f 8143//8130 8142//8130 8237//8130 
f 8204//8130 8144//8130 8145//8130 
f 8203//8130 8146//8130 8117//8130 
f 8145//8130 8203//8130 8204//8130 
f 8145//8130 8146//8130 8203//8130 
f 8234//8130 8233//8130 8147//8130 
f 8234//8130 8148//8130 8149//8130 
f 8233//8130 8150//8130 8147//8130 
f 8149//8130 8151//8130 8234//8130 
f 8233//8130 8152//8130 8150//8130 
f 8235//8130 8234//8130 8153//8130 
f 8147//8130 8148//8130 8234//8130 
f 8233//8130 8154//8130 8155//8130 
f 8234//8130 8156//8130 8153//8130 
f 8155//8130 8152//8130 8233//8130 
f 8234//8130 8157//8130 8156//8130 
f 8151//8130 8158//8130 8234//8130 
f 8158//8130 8157//8130 8234//8130 
f 8233//8130 8159//8130 8160//8130 
f 8160//8130 8154//8130 8233//8130 
f 8233//8130 8161//8130 8159//8130 
f 8235//8130 8162//8130 8163//8130 
f 8163//8130 8236//8130 8235//8130 
f 8236//8130 8164//8130 8165//8130 
f 8236//8130 8166//8130 8167//8130 
f 8163//8130 8168//8130 8236//8130 
f 8165//8130 8169//8130 8236//8130 
f 8168//8130 8166//8130 8236//8130 
f 8167//8130 8164//8130 8236//8130 
f 8170//8130 8171//8130 8172//8130 
f 8170//8130 8173//8130 8174//8130 
f 8175//8130 8173//8130 7885//8130 
f 8174//8130 8171//8130 8170//8130 
f 7885//8130 8236//8130 8175//8130 
f 8175//8130 8174//8130 8173//8130 
f 8231//8130 8176//8130 8177//8130 
f 8231//8130 8178//8130 8179//8130 
f 8177//8130 8180//8130 8231//8130 
f 8231//8130 8172//8130 8178//8130 
f 8179//8130 8176//8130 8231//8130 
f 8221//8130 8224//8130 8181//8130 
f 8224//8130 8182//8130 8181//8130 
f 8224//8130 8231//8130 8183//8130 
f 8183//8130 8182//8130 8224//8130 
f 8221//8130 8184//8130 8185//8130 
f 8230//8130 8186//8130 8161//8130 
f 8185//8130 8230//8130 8221//8130 
f 8185//8130 8186//8130 8230//8130 
f 8161//8130 8233//8130 8230//8130 
f 8181//8130 8184//8130 8221//8130 
f 8180//8130 8183//8130 8231//8130 
f 8172//8130 8231//8130 8170//8130 
f 8169//8130 8175//8130 8236//8130 
f 8153//8130 8162//8130 8235//8130 
f 8117//8130 8244//8130 8203//8130 
f 8141//8130 8144//8130 8204//8130 
f 8137//8130 8143//8130 8238//8130 
f 8133//8130 8238//8130 8131//8130 
f 8130//8130 8134//8130 8242//8130 
f 8110//8130 8123//8130 8213//8130 
f 7786//8130 7783//8130 8209//8130 
f 7769//8130 8206//8130 8243//8130 
f 8106//8130 8082//8130 8240//8130 
f 8077//8130 8227//8130 8229//8130 
f 8043//8130 8207//8130 8194//8130 
f 8065//8130 8070//8130 8203//8130 
f 8062//8130 8063//8130 8244//8130 
f 8048//8130 8060//8130 8212//8130 
f 8046//8130 8058//8130 8210//8130 
f 8041//8130 8243//8130 8207//8130 
f 8038//8130 8007//8130 8223//8130 
f 8025//8130 8037//8130 8218//8130 
f 8011//8130 8242//8130 8008//8130 
f 8002//8130 8012//8130 8003//8130 
f 7997//8130 7970//8130 7967//8130 
f 7986//8130 8000//8130 8241//8130 
f 7981//8130 7994//8130 8208//8130 
f 7965//8130 8219//8130 7831//8130 
f 7960//8130 7938//8130 8201//8130 
f 7934//8130 8190//8130 8191//8130 
f 7930//8130 7905//8130 7904//8130 
f 7899//8130 8240//8130 8232//8130 
f 7897//8130 7891//8130 8228//8130 
f 8217//8130 8187//8130 7895//8130 
f 7893//8130 8187//8130 8217//8130 
f 7892//8130 8230//8130 8228//8130 
f 7890//8130 7833//8130 8225//8130 
f 7888//8130 7889//8130 8239//8130 
f 7884//8130 8188//8130 7845//8130 
f 7882//8130 8131//8130 8238//8130 
f 7879//8130 7881//8130 8237//8130 
f 7878//8130 7880//8130 8197//8130 
f 7876//8130 7877//8130 8196//8130 
f 7875//8130 7792//8130 8189//8130 
f 7873//8130 7874//8130 8189//8130 
f 7871//8130 7872//8130 8200//8130 
f 7870//8130 8199//8130 8205//8130 
f 7839//8130 7837//8130 8236//8130 
f 8235//8130 7840//8130 7836//8130 
f 8234//8130 7836//8130 7835//8130 
f 8233//8130 8234//8130 8232//8130 
f 7834//8130 8170//8130 8231//8130 
f 8230//8130 8233//8130 8229//8130 
f 8228//8130 8229//8130 8227//8130 
f 8226//8130 8227//8130 8225//8130 
f 8220//8130 8225//8130 7833//8130 
f 7832//8130 7834//8130 8224//8130 
f 8223//8130 8224//8130 8221//8130 
f 8214//8130 8226//8130 8220//8130 
f 8219//8130 8220//8130 7830//8130 
f 8218//8130 8222//8130 8217//8130 
f 8211//8130 8217//8130 8216//8130 
f 8215//8130 8216//8130 8214//8130 
f 8213//8130 8218//8130 8211//8130 
f 8210//8130 8215//8130 8208//8130 
f 8205//8130 8241//8130 7828//8130 
f 8207//8130 8243//8130 8206//8130 
f 8202//8130 8206//8130 8205//8130 
f 8197//8130 8237//8130 8204//8130 
f 8198//8130 8204//8130 8203//8130 
f 8194//8130 8207//8130 8202//8130 
f 8201//8130 8202//8130 8199//8130 
f 7800//8130 7798//8130 8196//8130 
f 8193//8130 8198//8130 8195//8130 
f 8192//8130 8195//8130 8194//8130 
f 7797//8130 8196//8130 8193//8130 
f 7796//8130 8193//8130 8192//8130 
f 7795//8130 8192//8130 8191//8130 
f 7794//8130 8191//8130 8190//8130 
f 7793//8130 8190//8130 8189//8130 
o mesh351
f 8245//8131 8246//8131 8642//8131 
f 8246//8131 8247//8131 8643//8131 
f 8643//8131 8248//8131 8249//8131 
f 8249//8131 8644//8131 8643//8131 
f 8249//8131 8250//8131 8644//8131 
f 8643//8131 8251//8131 8248//8131 
f 8250//8131 8252//8131 8644//8131 
f 8643//8131 8253//8131 8251//8131 
f 8252//8131 8254//8131 8644//8131 
f 8255//8131 8256//8131 8257//8131 
f 8644//8131 8258//8131 8256//8131 
f 8644//8131 8259//8131 8260//8131 
f 8643//8131 8261//8131 8253//8131 
f 8256//8131 8255//8131 8644//8131 
f 8254//8131 8259//8131 8644//8131 
f 8643//8131 8262//8131 8263//8131 
f 8643//8131 8247//8131 8264//8131 
f 8247//8131 8265//8131 8266//8131 
f 8255//8131 8267//8131 8268//8131 
f 8644//8131 8269//8131 8258//8131 
f 8263//8131 8261//8131 8643//8131 
f 8266//8131 8264//8131 8247//8131 
f 8255//8131 8270//8131 8271//8131 
f 8268//8131 8272//8131 8255//8131 
f 8260//8131 8269//8131 8644//8131 
f 8264//8131 8273//8131 8643//8131 
f 8272//8131 8270//8131 8255//8131 
f 8273//8131 8262//8131 8643//8131 
f 8257//8131 8267//8131 8255//8131 
f 8247//8131 8274//8131 8275//8131 
f 8247//8131 8276//8131 8277//8131 
f 8247//8131 8255//8131 8278//8131 
f 8275//8131 8265//8131 8247//8131 
f 8278//8131 8276//8131 8247//8131 
f 8277//8131 8274//8131 8247//8131 
f 8645//8131 8642//8131 8646//8131 
f 8279//8131 8647//8131 8648//8131 
f 8647//8131 8649//8131 8650//8131 
f 8649//8131 8651//8131 8652//8131 
f 8651//8131 8646//8131 8653//8131 
f 8654//8131 8280//8131 8281//8131 
f 8282//8131 8648//8131 8655//8131 
f 8648//8131 8650//8131 8656//8131 
f 8657//8131 8658//8131 8659//8131 
f 8658//8131 8281//8131 8283//8131 
f 8656//8131 8660//8131 8661//8131 
f 8660//8131 8662//8131 8663//8131 
f 8662//8131 8664//8131 8665//8131 
f 8666//8131 8661//8131 8667//8131 
f 8663//8131 8665//8131 8668//8131 
f 8284//8131 8669//8131 8670//8131 
f 8670//8131 8671//8131 8672//8131 
f 8671//8131 8673//8131 8674//8131 
f 8675//8131 8672//8131 8676//8131 
f 8672//8131 8674//8131 8677//8131 
f 8678//8131 8679//8131 8680//8131 
f 8679//8131 8681//8131 8682//8131 
f 8677//8131 8683//8131 8684//8131 
f 8683//8131 8680//8131 8685//8131 
f 8685//8131 8285//8131 8286//8131 
f 8286//8131 8686//8131 8685//8131 
f 8286//8131 8287//8131 8686//8131 
f 8685//8131 8288//8131 8285//8131 
f 8686//8131 8289//8131 8290//8131 
f 8287//8131 8291//8131 8686//8131 
f 8686//8131 8292//8131 8293//8131 
f 8290//8131 8294//8131 8686//8131 
f 8685//8131 8295//8131 8288//8131 
f 8685//8131 8296//8131 8297//8131 
f 8682//8131 8293//8131 8298//8131 
f 8686//8131 8299//8131 8292//8131 
f 8291//8131 8289//8131 8686//8131 
f 8685//8131 8300//8131 8296//8131 
f 8685//8131 8680//8131 8301//8131 
f 8293//8131 8682//8131 8686//8131 
f 8297//8131 8295//8131 8685//8131 
f 8301//8131 8302//8131 8685//8131 
f 8680//8131 8303//8131 8304//8131 
f 8682//8131 8305//8131 8306//8131 
f 8682//8131 8307//8131 8308//8131 
f 8294//8131 8299//8131 8686//8131 
f 8304//8131 8301//8131 8680//8131 
f 8680//8131 8309//8131 8310//8131 
f 8680//8131 8682//8131 8311//8131 
f 8308//8131 8305//8131 8682//8131 
f 8302//8131 8300//8131 8685//8131 
f 8680//8131 8312//8131 8309//8131 
f 8311//8131 8313//8131 8680//8131 
f 8298//8131 8307//8131 8682//8131 
f 8313//8131 8312//8131 8680//8131 
f 8310//8131 8303//8131 8680//8131 
f 8306//8131 8314//8131 8682//8131 
f 8687//8131 8688//8131 8315//8131 
f 8688//8131 8689//8131 8316//8131 
f 8689//8131 8684//8131 8317//8131 
f 8684//8131 8685//8131 8318//8131 
f 8685//8131 8686//8131 8319//8131 
f 8670//8131 8675//8131 8320//8131 
f 8320//8131 8321//8131 8670//8131 
f 8647//8131 8322//8131 8323//8131 
f 8647//8131 8279//8131 8322//8131 
f 8324//8131 8690//8131 8325//8131 
f 8690//8131 8323//8131 8325//8131 
f 8255//8131 8326//8131 8327//8131 
f 8327//8131 8328//8131 8255//8131 
f 8328//8131 8644//8131 8255//8131 
f 8691//8131 8329//8131 8330//8131 
f 8691//8131 8331//8131 8329//8131 
f 8681//8131 8330//8131 8332//8131 
f 8332//8131 8682//8131 8681//8131 
f 8682//8131 8333//8131 8334//8131 
f 8334//8131 8335//8131 8682//8131 
f 8686//8131 8335//8131 8336//8131 
f 8687//8131 8337//8131 8338//8131 
f 8692//8131 8687//8131 8339//8131 
f 8687//8131 8340//8131 8339//8131 
f 8675//8131 8692//8131 8341//8131 
f 8692//8131 8342//8131 8341//8131 
f 8652//8131 8653//8131 8343//8131 
f 8660//8131 8656//8131 8344//8131 
f 8656//8131 8650//8131 8345//8131 
f 8345//8131 8344//8131 8656//8131 
f 8652//8131 8346//8131 8345//8131 
f 8345//8131 8650//8131 8652//8131 
f 8347//8131 8348//8131 8662//8131 
f 8664//8131 8349//8131 8350//8131 
f 8662//8131 8348//8131 8349//8131 
f 8653//8131 8657//8131 8350//8131 
f 8349//8131 8664//8131 8662//8131 
f 8350//8131 8657//8131 8664//8131 
f 8645//8131 8693//8131 8351//8131 
f 8245//8131 8645//8131 8352//8131 
f 8351//8131 8353//8131 8645//8131 
f 8245//8131 8354//8131 8355//8131 
f 8352//8131 8356//8131 8245//8131 
f 8353//8131 8357//8131 8645//8131 
f 8245//8131 8358//8131 8354//8131 
f 8357//8131 8352//8131 8645//8131 
f 8356//8131 8358//8131 8245//8131 
f 8690//8131 8359//8131 8360//8131 
f 8360//8131 8693//8131 8690//8131 
f 8360//8131 8361//8131 8693//8131 
f 8690//8131 8362//8131 8359//8131 
f 8361//8131 8363//8131 8693//8131 
f 8690//8131 8364//8131 8365//8131 
f 8690//8131 8366//8131 8362//8131 
f 8690//8131 8367//8131 8364//8131 
f 8693//8131 8368//8131 8369//8131 
f 8365//8131 8366//8131 8690//8131 
f 8690//8131 8324//8131 8370//8131 
f 8371//8131 8372//8131 8373//8131 
f 8363//8131 8368//8131 8693//8131 
f 8370//8131 8374//8131 8690//8131 
f 8375//8131 8376//8131 8324//8131 
f 8373//8131 8377//8131 8371//8131 
f 8374//8131 8367//8131 8690//8131 
f 8324//8131 8378//8131 8379//8131 
f 8324//8131 8371//8131 8375//8131 
f 8372//8131 8380//8131 8373//8131 
f 8372//8131 8381//8131 8382//8131 
f 8379//8131 8370//8131 8324//8131 
f 8376//8131 8383//8131 8324//8131 
f 8382//8131 8380//8131 8372//8131 
f 8372//8131 8355//8131 8384//8131 
f 8383//8131 8378//8131 8324//8131 
f 8384//8131 8381//8131 8372//8131 
f 8377//8131 8375//8131 8371//8131 
f 8689//8131 8385//8131 8386//8131 
f 8386//8131 8677//8131 8689//8131 
f 8689//8131 8688//8131 8387//8131 
f 8677//8131 8388//8131 8389//8131 
f 8689//8131 8390//8131 8385//8131 
f 8387//8131 8391//8131 8689//8131 
f 8677//8131 8392//8131 8388//8131 
f 8391//8131 8390//8131 8689//8131 
f 8386//8131 8392//8131 8677//8131 
f 8688//8131 8687//8131 8393//8131 
f 8393//8131 8394//8131 8688//8131 
f 8394//8131 8395//8131 8688//8131 
f 8687//8131 8396//8131 8393//8131 
f 8395//8131 8397//8131 8688//8131 
f 8687//8131 8398//8131 8396//8131 
f 8687//8131 8399//8131 8400//8131 
f 8692//8131 8676//8131 8401//8131 
f 8687//8131 8402//8131 8398//8131 
f 8687//8131 8403//8131 8399//8131 
f 8687//8131 8692//8131 8404//8131 
f 8692//8131 8405//8131 8406//8131 
f 8401//8131 8407//8131 8692//8131 
f 8400//8131 8402//8131 8687//8131 
f 8406//8131 8404//8131 8692//8131 
f 8692//8131 8408//8131 8409//8131 
f 8676//8131 8410//8131 8401//8131 
f 8676//8131 8411//8131 8412//8131 
f 8404//8131 8403//8131 8687//8131 
f 8409//8131 8413//8131 8692//8131 
f 8676//8131 8414//8131 8410//8131 
f 8676//8131 8389//8131 8411//8131 
f 8413//8131 8405//8131 8692//8131 
f 8412//8131 8414//8131 8676//8131 
f 8688//8131 8415//8131 8416//8131 
f 8407//8131 8408//8131 8692//8131 
f 8397//8131 8415//8131 8688//8131 
f 8417//8131 8418//8131 8419//8131 
f 8417//8131 8420//8131 8418//8131 
f 8419//8131 8284//8131 8417//8131 
f 8284//8131 8421//8131 8422//8131 
f 8419//8131 8423//8131 8284//8131 
f 8423//8131 8421//8131 8284//8131 
f 8669//8131 8424//8131 8425//8131 
f 8669//8131 8426//8131 8424//8131 
f 8694//8131 8427//8131 8428//8131 
f 8425//8131 8694//8131 8669//8131 
f 8669//8131 8422//8131 8429//8131 
f 8694//8131 8430//8131 8431//8131 
f 8425//8131 8427//8131 8694//8131 
f 8429//8131 8432//8131 8669//8131 
f 8666//8131 8694//8131 8433//8131 
f 8694//8131 8434//8131 8430//8131 
f 8432//8131 8426//8131 8669//8131 
f 8694//8131 8435//8131 8433//8131 
f 8428//8131 8434//8131 8694//8131 
f 8431//8131 8435//8131 8694//8131 
f 8656//8131 8436//8131 8437//8131 
f 8655//8131 8656//8131 8438//8131 
f 8656//8131 8439//8131 8440//8131 
f 8437//8131 8441//8131 8656//8131 
f 8655//8131 8442//8131 8443//8131 
f 8438//8131 8444//8131 8655//8131 
f 8441//8131 8439//8131 8656//8131 
f 8444//8131 8442//8131 8655//8131 
f 8656//8131 8445//8131 8436//8131 
f 8440//8131 8438//8131 8656//8131 
f 8666//8131 8446//8131 8447//8131 
f 8443//8131 8448//8131 8655//8131 
f 8447//8131 8656//8131 8666//8131 
f 8447//8131 8445//8131 8656//8131 
f 8449//8131 8655//8131 8450//8131 
f 8449//8131 8451//8131 8452//8131 
f 8450//8131 8453//8131 8449//8131 
f 8452//8131 8417//8131 8449//8131 
f 8453//8131 8454//8131 8449//8131 
f 8454//8131 8451//8131 8449//8131 
f 8664//8131 8455//8131 8456//8131 
f 8456//8131 8457//8131 8664//8131 
f 8664//8131 8458//8131 8455//8131 
f 8659//8131 8459//8131 8460//8131 
f 8664//8131 8460//8131 8458//8131 
f 8659//8131 8461//8131 8459//8131 
f 8664//8131 8462//8131 8463//8131 
f 8460//8131 8664//8131 8659//8131 
f 8659//8131 8464//8131 8465//8131 
f 8463//8131 8665//8131 8664//8131 
f 8465//8131 8461//8131 8659//8131 
f 8664//8131 8466//8131 8462//8131 
f 8659//8131 8467//8131 8464//8131 
f 8457//8131 8466//8131 8664//8131 
f 8695//8131 8468//8131 8469//8131 
f 8668//8131 8470//8131 8471//8131 
f 8695//8131 8472//8131 8468//8131 
f 8695//8131 8471//8131 8473//8131 
f 8668//8131 8474//8131 8470//8131 
f 8473//8131 8472//8131 8695//8131 
f 8668//8131 8475//8131 8474//8131 
f 8668//8131 8476//8131 8477//8131 
f 8471//8131 8695//8131 8668//8131 
f 8668//8131 8478//8131 8476//8131 
f 8665//8131 8479//8131 8480//8131 
f 8477//8131 8475//8131 8668//8131 
f 8480//8131 8668//8131 8665//8131 
f 8480//8131 8478//8131 8668//8131 
f 8481//8131 8482//8131 8483//8131 
f 8483//8131 8484//8131 8481//8131 
f 8481//8131 8695//8131 8485//8131 
f 8481//8131 8486//8131 8482//8131 
f 8485//8131 8487//8131 8481//8131 
f 8487//8131 8486//8131 8481//8131 
f 8283//8131 8484//8131 8488//8131 
f 8484//8131 8489//8131 8488//8131 
f 8488//8131 8490//8131 8283//8131 
f 8490//8131 8491//8131 8283//8131 
f 8283//8131 8492//8131 8467//8131 
f 8491//8131 8493//8131 8283//8131 
f 8493//8131 8492//8131 8283//8131 
f 8696//8131 8678//8131 8494//8131 
f 8678//8131 8495//8131 8494//8131 
f 8678//8131 8496//8131 8495//8131 
f 8697//8131 8497//8131 8498//8131 
f 8696//8131 8499//8131 8497//8131 
f 8497//8131 8697//8131 8696//8131 
f 8696//8131 8500//8131 8499//8131 
f 8661//8131 8663//8131 8501//8131 
f 8663//8131 8502//8131 8503//8131 
f 8503//8131 8501//8131 8663//8131 
f 8663//8131 8697//8131 8504//8131 
f 8663//8131 8505//8131 8502//8131 
f 8504//8131 8506//8131 8663//8131 
f 8661//8131 8507//8131 8508//8131 
f 8506//8131 8505//8131 8663//8131 
f 8667//8131 8661//8131 8509//8131 
f 8661//8131 8510//8131 8511//8131 
f 8501//8131 8507//8131 8661//8131 
f 8511//8131 8509//8131 8661//8131 
f 8697//8131 8512//8131 8504//8131 
f 8508//8131 8510//8131 8661//8131 
f 8673//8131 8667//8131 8513//8131 
f 8667//8131 8514//8131 8513//8131 
f 8513//8131 8515//8131 8673//8131 
f 8667//8131 8516//8131 8514//8131 
f 8674//8131 8673//8131 8517//8131 
f 8517//8131 8518//8131 8674//8131 
f 8518//8131 8519//8131 8674//8131 
f 8677//8131 8520//8131 8521//8131 
f 8683//8131 8522//8131 8496//8131 
f 8521//8131 8683//8131 8677//8131 
f 8683//8131 8523//8131 8522//8131 
f 8521//8131 8524//8131 8683//8131 
f 8683//8131 8525//8131 8523//8131 
f 8677//8131 8526//8131 8520//8131 
f 8524//8131 8525//8131 8683//8131 
f 8677//8131 8527//8131 8528//8131 
f 8528//8131 8526//8131 8677//8131 
f 8677//8131 8674//8131 8529//8131 
f 8529//8131 8527//8131 8677//8131 
f 8651//8131 8649//8131 8530//8131 
f 8651//8131 8531//8131 8532//8131 
f 8530//8131 8533//8131 8651//8131 
f 8645//8131 8534//8131 8535//8131 
f 8651//8131 8536//8131 8531//8131 
f 8533//8131 8537//8131 8651//8131 
f 8645//8131 8532//8131 8534//8131 
f 8537//8131 8536//8131 8651//8131 
f 8532//8131 8645//8131 8651//8131 
f 8647//8131 8538//8131 8539//8131 
f 8539//8131 8649//8131 8647//8131 
f 8539//8131 8540//8131 8649//8131 
f 8647//8131 8541//8131 8538//8131 
f 8540//8131 8542//8131 8649//8131 
f 8647//8131 8543//8131 8544//8131 
f 8647//8131 8545//8131 8541//8131 
f 8647//8131 8546//8131 8543//8131 
f 8649//8131 8547//8131 8548//8131 
f 8544//8131 8545//8131 8647//8131 
f 8647//8131 8690//8131 8549//8131 
f 8690//8131 8693//8131 8550//8131 
f 8542//8131 8547//8131 8649//8131 
f 8549//8131 8551//8131 8647//8131 
f 8550//8131 8552//8131 8690//8131 
f 8551//8131 8546//8131 8647//8131 
f 8690//8131 8553//8131 8554//8131 
f 8690//8131 8555//8131 8556//8131 
f 8693//8131 8557//8131 8550//8131 
f 8693//8131 8558//8131 8559//8131 
f 8554//8131 8549//8131 8690//8131 
f 8556//8131 8560//8131 8690//8131 
f 8559//8131 8557//8131 8693//8131 
f 8693//8131 8535//8131 8561//8131 
f 8560//8131 8553//8131 8690//8131 
f 8561//8131 8558//8131 8693//8131 
f 8552//8131 8555//8131 8690//8131 
f 8673//8131 7775//8131 7777//8131 
f 8667//8131 7779//8131 7782//8131 
f 8673//8131 7773//8131 7775//8131 
f 8667//8131 7777//8131 7779//8131 
f 8673//8131 7771//8131 7773//8131 
f 8673//8131 8671//8131 7768//8131 
f 7777//8131 8667//8131 8673//8131 
f 7768//8131 7767//8131 8673//8131 
f 7767//8131 7771//8131 8673//8131 
f 8670//8131 7755//8131 7759//8131 
f 7759//8131 8671//8131 8670//8131 
f 7759//8131 7758//8131 8671//8131 
f 8670//8131 7753//8131 7755//8131 
f 8670//8131 7747//8131 7749//8131 
f 8669//8131 8694//8131 7729//8131 
f 8671//8131 7763//8131 7765//8131 
f 7758//8131 7762//8131 8671//8131 
f 7749//8131 7751//8131 8670//8131 
f 8670//8131 7743//8131 7745//8131 
f 7729//8131 7728//8131 8669//8131 
f 8694//8131 7785//8131 7787//8131 
f 8694//8131 7782//8131 7781//8131 
f 7762//8131 7763//8131 8671//8131 
f 7745//8131 7747//8131 8670//8131 
f 8670//8131 8669//8131 7741//8131 
f 8669//8131 7737//8131 7739//8131 
f 8669//8131 7733//8131 7735//8131 
f 8694//8131 7789//8131 7729//8131 
f 7781//8131 7785//8131 8694//8131 
f 7751//8131 7753//8131 8670//8131 
f 7739//8131 7741//8131 8669//8131 
f 8669//8131 7731//8131 7733//8131 
f 7787//8131 7789//8131 8694//8131 
f 7741//8131 7743//8131 8670//8131 
f 7728//8131 7731//8131 8669//8131 
f 7735//8131 7737//8131 8669//8131 
f 8679//8131 8678//8131 8562//8131 
f 8678//8131 8563//8131 8562//8131 
f 8678//8131 8696//8131 8564//8131 
f 8564//8131 8563//8131 8678//8131 
f 8679//8131 8565//8131 8566//8131 
f 8681//8131 8567//8131 8568//8131 
f 8566//8131 8681//8131 8679//8131 
f 8566//8131 8567//8131 8681//8131 
f 8691//8131 8568//8131 8569//8131 
f 8691//8131 8570//8131 8571//8131 
f 8569//8131 8572//8131 8691//8131 
f 8572//8131 8570//8131 8691//8131 
f 8571//8131 8573//8131 8691//8131 
f 8481//8131 8331//8131 8574//8131 
f 8331//8131 8575//8131 8574//8131 
f 8331//8131 8576//8131 8575//8131 
f 8331//8131 8691//8131 8577//8131 
f 8577//8131 8576//8131 8331//8131 
f 8668//8131 8695//8131 8578//8131 
f 8695//8131 8579//8131 8578//8131 
f 8695//8131 8580//8131 8581//8131 
f 8581//8131 8579//8131 8695//8131 
f 8695//8131 8582//8131 8580//8131 
f 8695//8131 8583//8131 8582//8131 
f 8695//8131 8574//8131 8584//8131 
f 8584//8131 8583//8131 8695//8131 
f 8578//8131 8585//8131 8668//8131 
f 8696//8131 8586//8131 8587//8131 
f 8697//8131 8588//8131 8586//8131 
f 8586//8131 8696//8131 8697//8131 
f 8668//8131 8585//8131 8589//8131 
f 8696//8131 8590//8131 8591//8131 
f 8696//8131 8592//8131 8593//8131 
f 8587//8131 8594//8131 8696//8131 
f 8697//8131 8595//8131 8596//8131 
f 8589//8131 8697//8131 8668//8131 
f 8593//8131 8590//8131 8696//8131 
f 8596//8131 8588//8131 8697//8131 
f 8697//8131 8597//8131 8598//8131 
f 8589//8131 8599//8131 8697//8131 
f 8594//8131 8592//8131 8696//8131 
f 8599//8131 8597//8131 8697//8131 
f 8598//8131 8595//8131 8697//8131 
f 8657//8131 8653//8131 8600//8131 
f 8653//8131 8601//8131 8600//8131 
f 8653//8131 8646//8131 8602//8131 
f 8602//8131 8601//8131 8653//8131 
f 8657//8131 8603//8131 8604//8131 
f 8658//8131 8605//8131 8606//8131 
f 8604//8131 8658//8131 8657//8131 
f 8604//8131 8605//8131 8658//8131 
f 8654//8131 8607//8131 8608//8131 
f 8654//8131 8609//8131 8610//8131 
f 8608//8131 8611//8131 8654//8131 
f 8654//8131 8606//8131 8609//8131 
f 8610//8131 8607//8131 8654//8131 
f 8612//8131 8644//8131 8613//8131 
f 8614//8131 8615//8131 8612//8131 
f 8280//8131 8616//8131 8615//8131 
f 8615//8131 8614//8131 8280//8131 
f 8280//8131 8654//8131 8617//8131 
f 8617//8131 8616//8131 8280//8131 
f 8643//8131 8644//8131 8618//8131 
f 8644//8131 8619//8131 8618//8131 
f 8644//8131 8620//8131 8619//8131 
f 8644//8131 8621//8131 8622//8131 
f 8644//8131 8612//8131 8623//8131 
f 8622//8131 8620//8131 8644//8131 
f 8623//8131 8624//8131 8644//8131 
f 8624//8131 8621//8131 8644//8131 
f 8646//8131 8625//8131 8626//8131 
f 8642//8131 8627//8131 8625//8131 
f 8646//8131 8628//8131 8629//8131 
f 8625//8131 8646//8131 8642//8131 
f 8642//8131 8630//8131 8631//8131 
f 8626//8131 8628//8131 8646//8131 
f 8642//8131 8632//8131 8630//8131 
f 8643//8131 8633//8131 8634//8131 
f 8631//8131 8627//8131 8642//8131 
f 8634//8131 8642//8131 8643//8131 
f 8642//8131 8635//8131 8632//8131 
f 8634//8131 8636//8131 8642//8131 
f 8646//8131 8637//8131 8638//8131 
f 8636//8131 8635//8131 8642//8131 
f 8629//8131 8637//8131 8646//8131 
f 8638//8131 8639//8131 8646//8131 
f 8639//8131 8602//8131 8646//8131 
f 8618//8131 8633//8131 8643//8131 
f 8613//8131 8614//8131 8612//8131 
f 8611//8131 8617//8131 8654//8131 
f 8606//8131 8654//8131 8658//8131 
f 8600//8131 8603//8131 8657//8131 
f 8591//8131 8564//8131 8696//8131 
f 8574//8131 8695//8131 8481//8131 
f 8573//8131 8577//8131 8691//8131 
f 8568//8131 8691//8131 8681//8131 
f 8562//8131 8565//8131 8679//8131 
f 7765//8131 7768//8131 8671//8131 
f 7782//8131 8694//8131 8667//8131 
f 8548//8131 8530//8131 8649//8131 
f 8535//8131 8693//8131 8645//8131 
f 8496//8131 8678//8131 8683//8131 
f 8519//8131 8529//8131 8674//8131 
f 8515//8131 8517//8131 8673//8131 
f 8509//8131 8516//8131 8667//8131 
f 8498//8131 8512//8131 8697//8131 
f 8494//8131 8500//8131 8696//8131 
f 8467//8131 8659//8131 8283//8131 
f 8483//8131 8489//8131 8484//8131 
f 8469//8131 8485//8131 8695//8131 
f 8463//8131 8479//8131 8665//8131 
f 8452//8131 8420//8131 8417//8131 
f 8448//8131 8450//8131 8655//8131 
f 8433//8131 8446//8131 8666//8131 
f 8422//8131 8669//8131 8284//8131 
f 8416//8131 8387//8131 8688//8131 
f 8389//8131 8676//8131 8677//8131 
f 8369//8131 8351//8131 8693//8131 
f 8355//8131 8372//8131 8245//8131 
f 8350//8131 8343//8131 8653//8131 
f 8662//8131 8660//8131 8347//8131 
f 8344//8131 8347//8131 8660//8131 
f 8343//8131 8346//8131 8652//8131 
f 8341//8131 8320//8131 8675//8131 
f 8339//8131 8342//8131 8692//8131 
f 8338//8131 8340//8131 8687//8131 
f 8336//8131 8319//8131 8686//8131 
f 8335//8131 8686//8131 8682//8131 
f 8332//8131 8333//8131 8682//8131 
f 8330//8131 8681//8131 8691//8131 
f 8328//8131 8613//8131 8644//8131 
f 8325//8131 8640//8131 8324//8131 
f 8323//8131 8690//8131 8647//8131 
f 8321//8131 8641//8131 8670//8131 
f 8319//8131 8318//8131 8685//8131 
f 8318//8131 8317//8131 8684//8131 
f 8317//8131 8316//8131 8689//8131 
f 8316//8131 8315//8131 8688//8131 
f 8315//8131 8337//8131 8687//8131 
f 8314//8131 8311//8131 8682//8131 
f 8685//8131 8684//8131 8683//8131 
f 8684//8131 8689//8131 8677//8131 
f 8682//8131 8680//8131 8679//8131 
f 8680//8131 8683//8131 8678//8131 
f 8677//8131 8676//8131 8672//8131 
f 8676//8131 8692//8131 8675//8131 
f 8674//8131 8672//8131 8671//8131 
f 8672//8131 8675//8131 8670//8131 
f 8670//8131 8641//8131 8284//8131 
f 8668//8131 8697//8131 8663//8131 
f 8667//8131 8694//8131 8666//8131 
f 8665//8131 8663//8131 8662//8131 
f 8663//8131 8661//8131 8660//8131 
f 8661//8131 8666//8131 8656//8131 
f 8283//8131 8659//8131 8658//8131 
f 8659//8131 8664//8131 8657//8131 
f 8656//8131 8655//8131 8648//8131 
f 8655//8131 8449//8131 8282//8131 
f 8281//8131 8658//8131 8654//8131 
f 8653//8131 8652//8131 8651//8131 
f 8652//8131 8650//8131 8649//8131 
f 8650//8131 8648//8131 8647//8131 
f 8648//8131 8282//8131 8279//8131 
f 8646//8131 8651//8131 8645//8131 
f 8271//8131 8278//8131 8255//8131 
f 8643//8131 8642//8131 8246//8131 
f 8642//8131 8645//8131 8245//8131 
o mesh352
f 8636//8132 8634//8133 8153//8133 
f 8635//8134 8636//8132 8156//8135 
f 8632//8136 8635//8134 8157//8137 
f 8630//8138 8632//8136 8158//8139 
f 8631//8140 8630//8138 8151//8141 
f 8627//8142 8631//8140 8149//8143 
f 8625//8144 8627//8142 8148//8145 
f 8626//8146 8625//8144 8147//8147 
f 8628//8148 8626//8146 8150//8149 
f 8629//8150 8628//8148 8152//8151 
f 8637//8152 8629//8150 8155//8153 
f 8638//8154 8637//8152 8154//8155 
f 8639//8156 8638//8154 8160//8157 
f 8601//8158 8602//8159 8161//8159 
f 8159//8160 8161//8159 8602//8159 
f 8602//8159 8639//8156 8159//8160 
f 8600//8161 8601//8158 8186//8162 
f 8186//8162 8185//8161 8600//8161 
f 8161//8159 8186//8162 8601//8158 
f 8160//8157 8159//8160 8639//8156 
f 8154//8155 8160//8157 8638//8154 
f 8155//8153 8154//8155 8637//8152 
f 8152//8151 8155//8153 8629//8150 
f 8150//8149 8152//8151 8628//8148 
f 8147//8147 8150//8149 8626//8146 
f 8148//8145 8147//8147 8625//8144 
f 8149//8143 8148//8145 8627//8142 
f 8151//8141 8149//8143 8631//8140 
f 8158//8139 8151//8141 8630//8138 
f 8157//8137 8158//8139 8632//8136 
f 8156//8135 8157//8137 8635//8134 
f 8153//8133 8156//8135 8636//8132 
o mesh353
f 8163//8163 8162//8163 8633//8163 
f 8634//8163 8633//8163 8162//8163 
f 8162//8163 8153//8163 8634//8163 
f 8633//8163 8618//8163 8163//8163 
o mesh354
f 8605//8164 8604//8165 8181//8165 
f 8609//8166 8606//8167 8183//8167 
f 8182//8168 8183//8167 8606//8167 
f 8606//8167 8605//8164 8182//8168 
f 8610//8169 8609//8166 8180//8170 
f 8607//8171 8610//8169 8177//8172 
f 8608//8173 8607//8171 8176//8174 
f 8611//8175 8608//8173 8179//8176 
f 8616//8177 8617//8178 8172//8178 
f 8178//8179 8172//8178 8617//8178 
f 8617//8178 8611//8175 8178//8179 
f 8615//8180 8616//8177 8171//8181 
f 8623//8182 8612//8183 8175//8183 
f 8174//8184 8175//8183 8612//8183 
f 8612//8183 8615//8180 8174//8184 
f 8624//8185 8623//8182 8169//8186 
f 8621//8187 8624//8185 8165//8188 
f 8622//8189 8621//8187 8164//8190 
f 8620//8191 8622//8189 8167//8192 
f 8619//8193 8620//8191 8166//8194 
f 8618//8195 8619//8193 8168//8196 
f 8168//8196 8163//8195 8618//8195 
f 8166//8194 8168//8196 8619//8193 
f 8167//8192 8166//8194 8620//8191 
f 8164//8190 8167//8192 8622//8189 
f 8165//8188 8164//8190 8621//8187 
f 8169//8186 8165//8188 8624//8185 
f 8175//8183 8169//8186 8623//8182 
f 8171//8181 8174//8184 8615//8180 
f 8172//8178 8171//8181 8616//8177 
f 8179//8176 8178//8179 8611//8175 
f 8176//8174 8179//8176 8608//8173 
f 8177//8172 8176//8174 8607//8171 
f 8180//8170 8177//8172 8610//8169 
f 8183//8167 8180//8170 8609//8166 
f 8181//8165 8182//8168 8605//8164 
o mesh355
f 8599//8197 8589//8198 8110//8198 
f 8597//8199 8599//8197 8114//8200 
f 8598//8201 8597//8199 8119//8202 
f 8595//8203 8598//8201 8121//8204 
f 8596//8205 8595//8203 8120//8206 
f 8588//8207 8596//8205 8112//8208 
f 8586//8209 8588//8207 8111//8210 
f 8587//8211 8586//8209 8108//8212 
f 8594//8213 8587//8211 8109//8214 
f 8592//8215 8594//8213 8113//8216 
f 8593//8217 8592//8215 8122//8218 
f 8590//8219 8593//8217 8116//8220 
f 8591//8221 8590//8219 8115//8222 
f 8563//8223 8564//8224 8117//8224 
f 8118//8225 8117//8224 8564//8224 
f 8564//8224 8591//8221 8118//8225 
f 8562//8226 8563//8223 8146//8227 
f 8146//8227 8145//8226 8562//8226 
f 8117//8224 8146//8227 8563//8223 
f 8115//8222 8118//8225 8591//8221 
f 8116//8220 8115//8222 8590//8219 
f 8122//8218 8116//8220 8593//8217 
f 8113//8216 8122//8218 8592//8215 
f 8109//8214 8113//8216 8594//8213 
f 8108//8212 8109//8214 8587//8211 
f 8111//8210 8108//8212 8586//8209 
f 8112//8208 8111//8210 8588//8207 
f 8120//8206 8112//8208 8596//8205 
f 8121//8204 8120//8206 8595//8203 
f 8119//8202 8121//8204 8598//8201 
f 8114//8200 8119//8202 8597//8199 
f 8110//8198 8114//8200 8599//8197 
o mesh356
f 8124//8228 8123//8228 8585//8228 
f 8589//8228 8585//8228 8123//8228 
f 8123//8228 8110//8228 8589//8228 
f 8585//8228 8578//8228 8124//8228 
o mesh357
f 8567//8229 8566//8230 8141//8230 
f 8569//8231 8568//8232 8143//8232 
f 8142//8233 8143//8232 8568//8232 
f 8568//8232 8567//8229 8142//8233 
f 8572//8234 8569//8231 8137//8235 
f 8570//8236 8572//8234 8136//8237 
f 8571//8238 8570//8236 8138//8239 
f 8573//8240 8571//8238 8140//8241 
f 8576//8242 8577//8243 8133//8243 
f 8139//8244 8133//8243 8577//8243 
f 8577//8243 8573//8240 8139//8244 
f 8575//8245 8576//8242 8132//8246 
f 8584//8247 8574//8248 8134//8248 
f 8135//8249 8134//8248 8574//8248 
f 8574//8248 8575//8245 8135//8249 
f 8583//8250 8584//8247 8130//8251 
f 8582//8252 8583//8250 8128//8253 
f 8580//8254 8582//8252 8127//8255 
f 8581//8256 8580//8254 8129//8257 
f 8579//8258 8581//8256 8126//8259 
f 8578//8260 8579//8258 8125//8261 
f 8125//8261 8124//8260 8578//8260 
f 8126//8259 8125//8261 8579//8258 
f 8129//8257 8126//8259 8581//8256 
f 8127//8255 8129//8257 8580//8254 
f 8128//8253 8127//8255 8582//8252 
f 8130//8251 8128//8253 8583//8250 
f 8134//8248 8130//8251 8584//8247 
f 8132//8246 8135//8249 8575//8245 
f 8133//8243 8132//8246 8576//8242 
f 8140//8241 8139//8244 8573//8240 
f 8138//8239 8140//8241 8571//8238 
f 8136//8237 8138//8239 8570//8236 
f 8137//8235 8136//8237 8572//8234 
f 8143//8232 8137//8235 8569//8231 
f 8141//8230 8142//8233 8567//8229 
o mesh358
f 8491//8262 8490//8263 8001//8263 
f 8493//8264 8491//8262 8004//8265 
f 8492//8266 8493//8264 8005//8267 
f 8464//8268 8467//8269 8007//8269 
f 8006//8270 8007//8269 8467//8269 
f 8467//8269 8492//8266 8006//8270 
f 8465//8271 8464//8268 8038//8272 
f 8461//8273 8465//8271 8035//8274 
f 8459//8275 8461//8273 8034//8276 
f 8460//8277 8459//8275 8033//8278 
f 8458//8279 8460//8277 8029//8280 
f 8455//8281 8458//8279 8031//8282 
f 8456//8283 8455//8281 8030//8284 
f 8457//8285 8456//8283 8028//8286 
f 8466//8287 8457//8285 8027//8288 
f 8462//8289 8466//8287 8032//8290 
f 8490//8263 8488//8291 8002//8291 
f 8463//8292 8462//8289 8039//8293 
f 8039//8293 8036//8292 8463//8292 
f 8002//8291 8001//8263 8490//8263 
f 8032//8290 8039//8293 8462//8289 
f 8027//8288 8032//8290 8466//8287 
f 8028//8286 8027//8288 8457//8285 
f 8030//8284 8028//8286 8456//8283 
f 8031//8282 8030//8284 8455//8281 
f 8029//8280 8031//8282 8458//8279 
f 8033//8278 8029//8280 8460//8277 
f 8034//8276 8033//8278 8459//8275 
f 8035//8274 8034//8276 8461//8273 
f 8038//8272 8035//8274 8465//8271 
f 8007//8269 8038//8272 8464//8268 
f 8005//8267 8006//8270 8492//8266 
f 8004//8265 8005//8267 8493//8264 
f 8001//8263 8004//8265 8491//8262 
o mesh359
f 8488//8294 8489//8294 8012//8294 
f 8009//8294 8012//8294 8489//8294 
f 8489//8294 8483//8294 8009//8294 
f 8012//8294 8002//8294 8488//8294 
o mesh360
f 8478//8295 8480//8296 8025//8296 
f 8476//8297 8478//8295 8026//8298 
f 8477//8299 8476//8297 8020//8300 
f 8475//8301 8477//8299 8017//8302 
f 8474//8303 8475//8301 8016//8304 
f 8470//8305 8474//8303 8021//8306 
f 8471//8307 8470//8305 8018//8308 
f 8473//8309 8471//8307 8015//8310 
f 8472//8311 8473//8309 8023//8312 
f 8468//8313 8472//8311 8022//8314 
f 8469//8315 8468//8313 8024//8316 
f 8487//8317 8485//8318 8011//8318 
f 8019//8319 8011//8318 8485//8318 
f 8485//8318 8469//8315 8019//8319 
f 8486//8320 8487//8317 8010//8321 
f 8482//8322 8486//8320 8013//8323 
f 8483//8324 8482//8322 8014//8325 
f 8014//8325 8009//8324 8483//8324 
f 8013//8323 8014//8325 8482//8322 
f 8010//8321 8013//8323 8486//8320 
f 8011//8318 8010//8321 8487//8317 
f 8024//8316 8019//8319 8469//8315 
f 8022//8314 8024//8316 8468//8313 
f 8023//8312 8022//8314 8472//8311 
f 8015//8310 8023//8312 8473//8309 
f 8018//8308 8015//8310 8471//8307 
f 8021//8306 8018//8308 8470//8305 
f 8016//8304 8021//8306 8474//8303 
f 8017//8302 8016//8304 8475//8301 
f 8020//8300 8017//8302 8477//8299 
f 8026//8298 8020//8300 8476//8297 
f 8025//8296 8026//8298 8478//8295 
o mesh361
f 7968//8326 7970//8326 8420//8326 
f 8418//8326 8420//8326 7970//8326 
f 7970//8326 7997//8326 8418//8326 
f 8420//8326 8452//8326 7968//8326 
o mesh362
f 8445//8327 8447//8328 7981//8328 
f 8436//8329 8445//8327 7982//8330 
f 8437//8331 8436//8329 7980//8332 
f 8441//8333 8437//8331 7972//8334 
f 8439//8335 8441//8333 7971//8336 
f 8440//8337 8439//8335 7973//8338 
f 8438//8339 8440//8337 7975//8340 
f 8444//8341 8438//8339 7974//8342 
f 8442//8343 8444//8341 7976//8344 
f 8443//8345 8442//8343 7977//8346 
f 8448//8347 8443//8345 7979//8348 
f 8453//8349 8450//8350 7965//8350 
f 7978//8351 7965//8350 8450//8350 
f 8450//8350 8448//8347 7978//8351 
f 8454//8352 8453//8349 7964//8353 
f 8451//8354 8454//8352 7966//8355 
f 8452//8356 8451//8354 7969//8357 
f 7969//8357 7968//8356 8452//8356 
f 7966//8355 7969//8357 8451//8354 
f 7964//8353 7966//8355 8454//8352 
f 7965//8350 7964//8353 8453//8349 
f 7979//8348 7978//8351 8448//8347 
f 7977//8346 7979//8348 8443//8345 
f 7976//8344 7977//8346 8442//8343 
f 7974//8342 7976//8344 8444//8341 
f 7975//8340 7974//8342 8438//8339 
f 7973//8338 7975//8340 8440//8337 
f 7971//8336 7973//8338 8439//8335 
f 7972//8334 7971//8336 8441//8333 
f 7980//8332 7972//8334 8437//8331 
f 7982//8330 7980//8332 8436//8329 
f 7981//8328 7982//8330 8445//8327 
o mesh363
f 7995//8358 7994//8358 8446//8358 
f 8447//8358 8446//8358 7994//8358 
f 7994//8358 7981//8358 8447//8358 
f 8446//8358 8433//8358 7995//8358 
o mesh364
f 7894//8359 7892//8359 8343//8359 
f 8346//8359 8343//8359 7892//8359 
f 7892//8359 7891//8359 8346//8359 
f 8345//8359 8346//8359 7891//8359 
f 7891//8359 7897//8359 8345//8359 
f 8343//8359 8350//8359 7894//8359 
o mesh365
f 7894//8358 8350//8358 8349//8358 
f 8349//8358 7893//8358 7894//8358 
o mesh366
f 7896//8360 7895//8360 8347//8360 
f 8348//8360 8347//8360 7895//8360 
f 7895//8360 8187//8360 8348//8360 
f 8349//8360 8348//8360 8187//8360 
f 8187//8360 7893//8360 8349//8360 
f 8347//8360 8344//8360 7896//8360 
o mesh367
f 8321//8361 8320//8361 7870//8361 
f 7871//8361 7870//8361 8320//8361 
f 8320//8361 8341//8361 7871//8361 
f 7870//8361 7869//8361 8321//8361 
o mesh368
f 7873//8362 7872//8362 8342//8362 
f 8341//8362 8342//8362 7872//8362 
f 7872//8362 7871//8362 8341//8362 
f 8342//8362 8339//8362 7873//8362 
o mesh369
f 8339//8363 8340//8363 7874//8363 
f 7875//8363 7874//8363 8340//8363 
f 8340//8363 8338//8363 7875//8363 
f 7874//8363 7873//8363 8339//8363 
o mesh370
f 7876//8364 7797//8364 8319//8364 
f 8318//8364 8319//8364 7797//8364 
f 7797//8364 7796//8364 8318//8364 
f 8317//8364 8318//8364 7796//8364 
f 7796//8364 7795//8364 8317//8364 
f 8316//8364 8317//8364 7795//8364 
f 7795//8364 7794//8364 8316//8364 
f 8315//8364 8316//8364 7794//8364 
f 7794//8364 7793//8364 8315//8364 
f 8337//8364 8315//8364 7793//8364 
f 7793//8364 7792//8364 8337//8364 
f 8338//8364 8337//8364 7792//8364 
f 7792//8364 7875//8364 8338//8364 
f 8319//8364 8336//8364 7876//8364 
o mesh371
f 8336//8365 8335//8365 7877//8365 
f 7878//8365 7877//8365 8335//8365 
f 8335//8365 8334//8365 7878//8365 
f 7877//8365 7876//8365 8336//8365 
o mesh372
f 7879//8366 7880//8366 8333//8366 
f 8334//8366 8333//8366 7880//8366 
f 7880//8366 7878//8366 8334//8366 
f 8333//8366 8332//8366 7879//8366 
o mesh373
f 8332//8367 8330//8367 7881//8367 
f 7882//8367 7881//8367 8330//8367 
f 8330//8367 8329//8367 7882//8367 
f 7881//8367 7879//8367 8332//8367 
o mesh374
f 8173//8366 8170//8366 8280//8366 
f 8281//8366 8280//8366 8170//8366 
f 8170//8366 7834//8366 8281//8366 
f 8283//8366 8281//8366 7834//8366 
f 7834//8366 7832//8366 8283//8366 
f 8484//8366 8283//8366 7832//8366 
f 7832//8366 8003//8366 8484//8366 
f 8481//8366 8484//8366 8003//8366 
f 8003//8366 8008//8366 8481//8366 
f 8331//8366 8481//8366 8008//8366 
f 8008//8366 8131//8366 8331//8366 
f 8329//8366 8331//8366 8131//8366 
f 8131//8366 7882//8366 8329//8366 
f 8280//8366 8614//8366 8173//8366 
o mesh375
f 8614//8368 8613//8368 7885//8368 
f 7883//8368 7885//8368 8613//8368 
f 8613//8368 8328//8368 7883//8368 
f 7885//8368 8173//8368 8614//8368 
o mesh376
f 7883//8369 8328//8369 8327//8369 
f 8327//8369 7884//8369 7883//8369 
o mesh377
f 7884//8370 8327//8370 8326//8370 
f 8326//8370 8188//8370 7884//8370 
o mesh378
f 7916//8371 7904//8371 8372//8371 
f 8245//8371 8372//8371 7904//8371 
f 7904//8371 7835//8371 8245//8371 
f 8246//8371 8245//8371 7835//8371 
f 7835//8371 7836//8371 8246//8371 
f 8247//8371 8246//8371 7836//8371 
f 7836//8371 7840//8371 8247//8371 
f 8255//8371 8247//8371 7840//8371 
f 7840//8371 7845//8371 8255//8371 
f 8326//8371 8255//8371 7845//8371 
f 7845//8371 8188//8371 8326//8371 
f 8372//8371 8371//8371 7916//8371 
o mesh379
f 8371//8372 8324//8372 7886//8372 
f 7887//8372 7886//8372 8324//8372 
f 8324//8372 8640//8372 7887//8372 
f 7886//8372 7916//8372 8371//8372 
o mesh380
f 7887//8373 8640//8373 8325//8373 
f 8325//8373 7888//8373 7887//8373 
o mesh381
f 8325//8374 8323//8374 7889//8374 
f 7890//8374 7889//8374 8323//8374 
f 8323//8374 8322//8374 7890//8374 
f 7889//8374 7888//8374 8325//8374 
o mesh382
f 8145//8375 8144//8375 8565//8375 
f 8566//8375 8565//8375 8144//8375 
f 8144//8375 8141//8375 8566//8375 
f 8565//8375 8562//8375 8145//8375 
o mesh383
f 8036//8376 8037//8376 8479//8376 
f 8480//8376 8479//8376 8037//8376 
f 8037//8376 8025//8376 8480//8376 
f 8479//8376 8463//8376 8036//8376 
o mesh384
f 8419//8377 8418//8378 7997//8378 
f 8423//8379 8419//8377 7996//8380 
f 8421//8381 8423//8379 7998//8382 
f 8429//8383 8422//8384 8000//8384 
f 7999//8385 8000//8384 8422//8384 
f 8422//8384 8421//8381 7999//8385 
f 8432//8386 8429//8383 7986//8387 
f 8426//8388 8432//8386 7985//8389 
f 8424//8390 8426//8388 7990//8391 
f 8425//8392 8424//8390 7984//8393 
f 8427//8394 8425//8392 7983//8395 
f 8428//8396 8427//8394 7987//8397 
f 8434//8398 8428//8396 7989//8399 
f 8430//8400 8434//8398 7988//8401 
f 8431//8402 8430//8400 7993//8403 
f 8435//8404 8431//8402 7992//8405 
f 8433//8406 8435//8404 7991//8407 
f 7991//8407 7995//8406 8433//8406 
f 7992//8405 7991//8407 8435//8404 
f 7993//8403 7992//8405 8431//8402 
f 7988//8401 7993//8403 8430//8400 
f 7989//8399 7988//8401 8434//8398 
f 7987//8397 7989//8399 8428//8396 
f 7983//8395 7987//8397 8427//8394 
f 7984//8393 7983//8395 8425//8392 
f 7990//8391 7984//8393 8424//8390 
f 7985//8389 7990//8391 8426//8388 
f 7986//8387 7985//8389 8432//8386 
f 8000//8384 7986//8387 8429//8383 
f 7998//8382 7999//8385 8421//8381 
f 7996//8380 7998//8382 8423//8379 
f 7997//8378 7996//8380 8419//8377 
o mesh385
f 7896//8408 8344//8408 8345//8408 
f 8345//8408 7897//8408 7896//8408 
o mesh386
f 7869//8409 7829//8409 8641//8409 
f 8284//8409 8641//8409 7829//8409 
f 7829//8409 7828//8409 8284//8409 
f 8417//8409 8284//8409 7828//8409 
f 7828//8409 7967//8409 8417//8409 
f 8449//8409 8417//8409 7967//8409 
f 7967//8409 7831//8409 8449//8409 
f 8282//8409 8449//8409 7831//8409 
f 7831//8409 7830//8409 8282//8409 
f 8279//8409 8282//8409 7830//8409 
f 7830//8409 7833//8409 8279//8409 
f 8322//8409 8279//8409 7833//8409 
f 7833//8409 7890//8409 8322//8409 
f 8641//8409 8321//8409 7869//8409 
o mesh387
f 8185//8410 8184//8410 8603//8410 
f 8604//8410 8603//8410 8184//8410 
f 8184//8410 8181//8410 8604//8410 
f 8603//8410 8600//8410 8185//8410 
o mesh388
f 8552//8411 8550//8412 8094//8412 
f 8555//8413 8552//8411 8093//8414 
f 8556//8415 8555//8413 8101//8416 
f 8560//8417 8556//8415 8103//8418 
f 8553//8419 8560//8417 8102//8420 
f 8554//8421 8553//8419 8107//8422 
f 8549//8423 8554//8421 8104//8424 
f 8551//8425 8549//8423 8096//8426 
f 8546//8427 8551//8425 8095//8428 
f 8543//8429 8546//8427 8098//8430 
f 8544//8431 8543//8429 8091//8432 
f 8545//8433 8544//8431 8089//8434 
f 8541//8435 8545//8433 8088//8436 
f 8538//8437 8541//8435 8092//8438 
f 8085//8439 8540//8439 8539//8440 
f 8538//8437 8087//8441 8084//8440 
f 8084//8440 8539//8440 8538//8437 
f 8542//8442 8540//8439 8085//8439 
f 8547//8443 8542//8442 8086//8442 
f 8548//8444 8547//8443 8090//8443 
f 8533//8445 8530//8446 8077//8446 
f 8097//8447 8077//8446 8530//8446 
f 8530//8446 8548//8444 8097//8447 
f 8537//8448 8533//8445 8076//8449 
f 8536//8450 8537//8448 8078//8451 
f 8531//8452 8536//8450 8080//8453 
f 8532//8454 8531//8452 8081//8455 
f 8534//8456 8532//8454 8079//8457 
f 8561//8458 8535//8459 8082//8459 
f 8083//8460 8082//8459 8535//8459 
f 8535//8459 8534//8456 8083//8460 
f 8558//8461 8561//8458 8106//8462 
f 8559//8463 8558//8461 8105//8464 
f 8557//8465 8559//8463 8100//8466 
f 8550//8412 8557//8465 8099//8465 
f 8099//8465 8094//8412 8550//8412 
f 8100//8466 8099//8465 8557//8465 
f 8105//8464 8100//8466 8559//8463 
f 8106//8462 8105//8464 8558//8461 
f 8082//8459 8106//8462 8561//8458 
f 8079//8457 8083//8460 8534//8456 
f 8081//8455 8079//8457 8532//8454 
f 8080//8453 8081//8455 8531//8452 
f 8078//8451 8080//8453 8536//8450 
f 8076//8449 8078//8451 8537//8448 
f 8077//8446 8076//8449 8533//8445 
f 8090//8443 8097//8447 8548//8444 
f 8086//8442 8090//8443 8547//8443 
f 8085//8439 8086//8442 8542//8442 
f 8539//8440 8084//8440 8085//8439 
f 8092//8438 8087//8441 8538//8437 
f 8088//8436 8092//8438 8541//8435 
f 8089//8434 8088//8436 8545//8433 
f 8091//8432 8089//8434 8544//8431 
f 8098//8430 8091//8432 8543//8429 
f 8095//8428 8098//8430 8546//8427 
f 8096//8426 8095//8428 8551//8425 
f 8104//8424 8096//8426 8549//8423 
f 8107//8422 8104//8424 8554//8421 
f 8102//8420 8107//8422 8553//8419 
f 8103//8418 8102//8420 8560//8417 
f 8101//8416 8103//8418 8556//8415 
f 8093//8414 8101//8416 8555//8413 
f 8094//8412 8093//8414 8552//8411 
o mesh389
f 8507//8467 8501//8468 8051//8468 
f 8508//8469 8507//8467 8053//8470 
f 8510//8471 8508//8469 8055//8472 
f 8511//8473 8510//8471 8054//8474 
f 8509//8475 8511//8473 8057//8476 
f 8514//8477 8516//8478 8058//8478 
f 8056//8479 8058//8478 8516//8478 
f 8516//8478 8509//8475 8056//8479 
f 8513//8480 8514//8477 8046//8481 
f 8515//8482 8513//8480 8045//8483 
f 8518//8484 8517//8485 8041//8485 
f 8044//8486 8041//8485 8517//8485 
f 8517//8485 8515//8482 8044//8486 
f 8519//8487 8518//8484 8040//8488 
f 8527//8489 8529//8490 8043//8490 
f 8042//8491 8043//8490 8529//8490 
f 8529//8490 8519//8487 8042//8491 
f 8528//8492 8527//8489 8075//8493 
f 8526//8494 8528//8492 8074//8495 
f 8520//8496 8526//8494 8073//8497 
f 8067//8498 8524//8498 8521//8499 
f 8520//8496 8068//8500 8066//8499 
f 8066//8499 8521//8499 8520//8496 
f 8525//8501 8524//8498 8067//8498 
f 8523//8502 8525//8501 8069//8501 
f 8522//8503 8523//8502 8071//8502 
f 8495//8504 8496//8505 8070//8505 
f 8072//8506 8070//8505 8496//8505 
f 8496//8505 8522//8503 8072//8506 
f 8494//8507 8495//8504 8065//8508 
f 8499//8509 8500//8510 8063//8510 
f 8064//8511 8063//8510 8500//8510 
f 8500//8510 8494//8507 8064//8511 
f 8497//8512 8499//8509 8062//8513 
f 8498//8514 8497//8512 8059//8515 
f 8504//8516 8512//8517 8060//8517 
f 8061//8518 8060//8517 8512//8517 
f 8512//8517 8498//8514 8061//8518 
f 8506//8519 8504//8516 8048//8520 
f 8505//8521 8506//8519 8047//8522 
f 8502//8523 8505//8521 8049//8524 
f 8503//8525 8502//8523 8050//8526 
f 8501//8468 8503//8525 8052//8525 
f 8052//8525 8051//8468 8501//8468 
f 8050//8526 8052//8525 8503//8525 
f 8049//8524 8050//8526 8502//8523 
f 8047//8522 8049//8524 8505//8521 
f 8048//8520 8047//8522 8506//8519 
f 8060//8517 8048//8520 8504//8516 
f 8059//8515 8061//8518 8498//8514 
f 8062//8513 8059//8515 8497//8512 
f 8063//8510 8062//8513 8499//8509 
f 8065//8508 8064//8511 8494//8507 
f 8070//8505 8065//8508 8495//8504 
f 8071//8502 8072//8506 8522//8503 
f 8069//8501 8071//8502 8523//8502 
f 8067//8498 8069//8501 8525//8501 
f 8521//8499 8066//8499 8067//8498 
f 8073//8497 8068//8500 8520//8496 
f 8074//8495 8073//8497 8526//8494 
f 8075//8493 8074//8495 8528//8492 
f 8043//8490 8075//8493 8527//8489 
f 8040//8488 8042//8491 8519//8487 
f 8041//8485 8040//8488 8518//8484 
f 8045//8483 8044//8486 8515//8482 
f 8046//8481 8045//8483 8513//8480 
f 8058//8478 8046//8481 8514//8477 
f 8057//8476 8056//8479 8509//8475 
f 8054//8474 8057//8476 8511//8473 
f 8055//8472 8054//8474 8510//8471 
f 8053//8470 8055//8472 8508//8469 
f 8051//8468 8053//8470 8507//8467 
o mesh390
f 8407//8527 8401//8528 7946//8528 
f 8408//8529 8407//8527 7945//8530 
f 8409//8531 8408//8529 7957//8532 
f 8413//8533 8409//8531 7959//8534 
f 8405//8535 8413//8533 7958//8536 
f 8406//8537 8405//8535 7962//8538 
f 8404//8539 8406//8537 7951//8540 
f 8403//8541 8404//8539 7950//8542 
f 8399//8543 8403//8541 7952//8544 
f 8400//8545 8399//8543 7953//8546 
f 8402//8547 8400//8545 7948//8548 
f 8398//8549 8402//8547 7947//8550 
f 8396//8551 8398//8549 7954//8552 
f 8393//8553 8396//8551 7949//8554 
f 7942//8555 8395//8555 8394//8556 
f 8393//8553 7941//8557 7940//8556 
f 7940//8556 8394//8556 8393//8553 
f 8397//8558 8395//8555 7942//8555 
f 8415//8559 8397//8558 7943//8558 
f 8416//8560 8415//8559 7944//8559 
f 8391//8561 8387//8562 7934//8562 
f 7963//8563 7934//8562 8387//8562 
f 8387//8562 8416//8560 7963//8563 
f 8390//8564 8391//8561 7933//8565 
f 8385//8566 8390//8564 7936//8567 
f 8386//8568 8385//8566 7937//8569 
f 8392//8570 8386//8568 7932//8571 
f 8388//8572 8392//8570 7935//8573 
f 8411//8574 8389//8575 7938//8575 
f 7939//8576 7938//8575 8389//8575 
f 8389//8575 8388//8572 7939//8576 
f 8412//8577 8411//8574 7960//8578 
f 8414//8579 8412//8577 7956//8580 
f 8410//8581 8414//8579 7955//8582 
f 8401//8528 8410//8581 7961//8581 
f 7961//8581 7946//8528 8401//8528 
f 7955//8582 7961//8581 8410//8581 
f 7956//8580 7955//8582 8414//8579 
f 7960//8578 7956//8580 8412//8577 
f 7938//8575 7960//8578 8411//8574 
f 7935//8573 7939//8576 8388//8572 
f 7932//8571 7935//8573 8392//8570 
f 7937//8569 7932//8571 8386//8568 
f 7936//8567 7937//8569 8385//8566 
f 7933//8565 7936//8567 8390//8564 
f 7934//8562 7933//8565 8391//8561 
f 7944//8559 7963//8563 8416//8560 
f 7943//8558 7944//8559 8415//8559 
f 7942//8555 7943//8558 8397//8558 
f 8394//8556 7940//8556 7942//8555 
f 7949//8554 7941//8557 8393//8553 
f 7954//8552 7949//8554 8396//8551 
f 7947//8550 7954//8552 8398//8549 
f 7948//8548 7947//8550 8402//8547 
f 7953//8546 7948//8548 8400//8545 
f 7952//8544 7953//8546 8399//8543 
f 7950//8542 7952//8544 8403//8541 
f 7951//8540 7950//8542 8404//8539 
f 7962//8538 7951//8540 8406//8537 
f 7958//8536 7962//8538 8405//8535 
f 7959//8534 7958//8536 8413//8533 
f 7957//8532 7959//8534 8409//8531 
f 7945//8530 7957//8532 8408//8529 
f 7946//8528 7945//8530 8407//8527 
o mesh391
f 8313//8583 8311//8584 7805//8584 
f 8312//8585 8313//8583 7804//8586 
f 8309//8587 8312//8585 7818//8588 
f 8310//8589 8309//8587 7819//8590 
f 8303//8591 8310//8589 7807//8592 
f 8304//8593 8303//8591 7806//8594 
f 8301//8595 8304//8593 7820//8596 
f 8302//8597 8301//8595 7809//8598 
f 8300//8599 8302//8597 7808//8600 
f 8296//8601 8300//8599 7821//8602 
f 8297//8603 8296//8601 7822//8604 
f 8295//8605 8297//8603 7811//8606 
f 8288//8607 8295//8605 7810//8608 
f 8285//8609 8288//8607 7823//8610 
f 8287//8611 8286//8612 7798//8612 
f 7812//8613 7798//8612 8286//8612 
f 8286//8612 8285//8609 7812//8613 
f 8291//8614 8287//8611 7800//8615 
f 8289//8616 8291//8614 7799//8617 
f 8290//8618 8289//8616 7813//8619 
f 8294//8620 8290//8618 7802//8621 
f 8299//8622 8294//8620 7801//8623 
f 8292//8624 8299//8622 7814//8625 
f 8293//8626 8292//8624 7815//8627 
f 8298//8628 8293//8626 7803//8629 
f 8307//8630 8298//8628 7817//8631 
f 8308//8632 8307//8630 7816//8633 
f 8305//8634 8308//8632 7825//8635 
f 8306//8636 8305//8634 7824//8637 
f 8314//8638 8306//8636 7827//8639 
f 8311//8584 8314//8638 7826//8638 
f 7826//8638 7805//8584 8311//8584 
f 7827//8639 7826//8638 8314//8638 
f 7824//8637 7827//8639 8306//8636 
f 7825//8635 7824//8637 8305//8634 
f 7816//8633 7825//8635 8308//8632 
f 7817//8631 7816//8633 8307//8630 
f 7803//8629 7817//8631 8298//8628 
f 7815//8627 7803//8629 8293//8626 
f 7814//8625 7815//8627 8292//8624 
f 7801//8623 7814//8625 8299//8622 
f 7802//8621 7801//8623 8294//8620 
f 7813//8619 7802//8621 8290//8618 
f 7799//8617 7813//8619 8289//8616 
f 7800//8615 7799//8617 8291//8614 
f 7798//8612 7800//8615 8287//8611 
f 7823//8610 7812//8613 8285//8609 
f 7810//8608 7823//8610 8288//8607 
f 7811//8606 7810//8608 8295//8605 
f 7822//8604 7811//8606 8297//8603 
f 7821//8602 7822//8604 8296//8601 
f 7808//8600 7821//8602 8300//8599 
f 7809//8598 7808//8600 8302//8597 
f 7820//8596 7809//8598 8301//8595 
f 7806//8594 7820//8596 8304//8593 
f 7807//8592 7806//8594 8303//8591 
f 7819//8590 7807//8592 8310//8589 
f 7818//8588 7819//8590 8309//8587 
f 7804//8586 7818//8588 8312//8585 
f 7805//8584 7804//8586 8313//8583 
o mesh392
f 8276//8640 8278//8641 7842//8641 
f 8277//8642 8276//8640 7841//8643 
f 8274//8644 8277//8642 7860//8645 
f 8275//8646 8274//8644 7859//8647 
f 8265//8648 8275//8646 7868//8649 
f 8266//8650 8265//8648 7867//8651 
f 8264//8652 8266//8650 7850//8653 
f 8273//8654 8264//8652 7849//8655 
f 8262//8656 8273//8654 7851//8657 
f 8263//8658 8262//8656 7866//8659 
f 8261//8660 8263//8658 7862//8661 
f 8253//8662 8261//8660 7861//8663 
f 8251//8664 8253//8662 7863//8665 
f 8248//8666 8251//8664 7852//8667 
f 8250//8668 8249//8669 7837//8669 
f 7843//8670 7837//8669 8249//8669 
f 8249//8669 8248//8666 7843//8670 
f 8252//8671 8250//8668 7839//8672 
f 8254//8673 8252//8671 7838//8674 
f 8259//8675 8254//8673 7844//8676 
f 8260//8677 8259//8675 7853//8678 
f 8269//8679 8260//8677 7855//8680 
f 8258//8681 8269//8679 7854//8682 
f 8256//8683 8258//8681 7864//8684 
f 8257//8685 8256//8683 7846//8686 
f 8267//8687 8257//8685 7848//8688 
f 8268//8689 8267//8687 7847//8690 
f 8272//8691 8268//8689 7857//8692 
f 8270//8693 8272//8691 7856//8694 
f 8271//8695 8270//8693 7865//8696 
f 8278//8641 8271//8695 7858//8695 
f 7858//8695 7842//8641 8278//8641 
f 7865//8696 7858//8695 8271//8695 
f 7856//8694 7865//8696 8270//8693 
f 7857//8692 7856//8694 8272//8691 
f 7847//8690 7857//8692 8268//8689 
f 7848//8688 7847//8690 8267//8687 
f 7846//8686 7848//8688 8257//8685 
f 7864//8684 7846//8686 8256//8683 
f 7854//8682 7864//8684 8258//8681 
f 7855//8680 7854//8682 8269//8679 
f 7853//8678 7855//8680 8260//8677 
f 7844//8676 7853//8678 8259//8675 
f 7838//8674 7844//8676 8254//8673 
f 7839//8672 7838//8674 8252//8671 
f 7837//8669 7839//8672 8250//8668 
f 7852//8667 7843//8670 8248//8666 
f 7863//8665 7852//8667 8251//8664 
f 7861//8663 7863//8665 8253//8662 
f 7862//8661 7861//8663 8261//8660 
f 7866//8659 7862//8661 8263//8658 
f 7851//8657 7866//8659 8262//8656 
f 7849//8655 7851//8657 8273//8654 
f 7850//8653 7849//8655 8264//8652 
f 7867//8651 7850//8653 8266//8650 
f 7868//8649 7867//8651 8265//8648 
f 7859//8647 7868//8649 8275//8646 
f 7860//8645 7859//8647 8274//8644 
f 7841//8643 7860//8645 8277//8642 
f 7842//8641 7841//8643 8276//8640 
o mesh393
f 8377//8697 8373//8698 7918//8698 
f 8375//8699 8377//8697 7917//8700 
f 8376//8701 8375//8699 7922//8702 
f 8383//8703 8376//8701 7927//8704 
f 8378//8705 8383//8703 7926//8706 
f 8379//8707 8378//8705 7931//8708 
f 8370//8709 8379//8707 7928//8710 
f 8374//8711 8370//8709 7920//8712 
f 8367//8713 8374//8711 7919//8714 
f 8364//8715 8367//8713 7923//8716 
f 8365//8717 8364//8715 7914//8718 
f 8366//8719 8365//8717 7912//8720 
f 8362//8721 8366//8719 7911//8722 
f 8359//8723 8362//8721 7915//8724 
f 7908//8725 8361//8725 8360//8726 
f 8359//8723 7910//8727 7907//8726 
f 7907//8726 8360//8726 8359//8723 
f 8363//8728 8361//8725 7908//8725 
f 8368//8729 8363//8728 7909//8728 
f 8369//8730 8368//8729 7913//8729 
f 8353//8731 8351//8732 7899//8732 
f 7921//8733 7899//8732 8351//8732 
f 8351//8732 8369//8730 7921//8733 
f 8357//8734 8353//8731 7898//8735 
f 8352//8736 8357//8734 7900//8737 
f 8356//8738 8352//8736 7902//8739 
f 8358//8740 8356//8738 7901//8741 
f 8354//8742 8358//8740 7903//8743 
f 8384//8744 8355//8745 7905//8745 
f 7906//8746 7905//8745 8355//8745 
f 8355//8745 8354//8742 7906//8746 
f 8381//8747 8384//8744 7930//8748 
f 8382//8749 8381//8747 7929//8750 
f 8380//8751 8382//8749 7925//8752 
f 8373//8698 8380//8751 7924//8751 
f 7924//8751 7918//8698 8373//8698 
f 7925//8752 7924//8751 8380//8751 
f 7929//8750 7925//8752 8382//8749 
f 7930//8748 7929//8750 8381//8747 
f 7905//8745 7930//8748 8384//8744 
f 7903//8743 7906//8746 8354//8742 
f 7901//8741 7903//8743 8358//8740 
f 7902//8739 7901//8741 8356//8738 
f 7900//8737 7902//8739 8352//8736 
f 7898//8735 7900//8737 8357//8734 
f 7899//8732 7898//8735 8353//8731 
f 7913//8729 7921//8733 8369//8730 
f 7909//8728 7913//8729 8368//8729 
f 7908//8725 7909//8728 8363//8728 
f 8360//8726 7907//8726 7908//8725 
f 7915//8724 7910//8727 8359//8723 
f 7911//8722 7915//8724 8362//8721 
f 7912//8720 7911//8722 8366//8719 
f 7914//8718 7912//8720 8365//8717 
f 7923//8716 7914//8718 8364//8715 
f 7919//8714 7923//8716 8367//8713 
f 7920//8712 7919//8714 8374//8711 
f 7928//8710 7920//8712 8370//8709 
f 7931//8708 7928//8710 8379//8707 
f 7926//8706 7931//8708 8378//8705 
f 7927//8704 7926//8706 8383//8703 
f 7922//8702 7927//8704 8376//8701 
f 7917//8700 7922//8702 8375//8699 
f 7918//8698 7917//8700 8377//8697 
g bearing
v 0.0266739 -0.0163599 0.0596107 
v 0.0266155 -0.0163599 0.0590733 
v 0.0266155 -0.00615989 0.0590733 
v 0.0268465 -0.0163599 0.060123 
v 0.0266739 -0.00615989 0.0596107 
v 0.0271252 -0.0163599 0.0605862 
v 0.0268465 -0.00615989 0.060123 
v 0.027497 -0.0163599 0.0609787 
v 0.0271252 -0.00615989 0.0605862 
v 0.0279445 -0.0163599 0.0612821 
v 0.027497 -0.00615989 0.0609787 
v 0.0284467 -0.0163599 0.0614822 
v 0.0279445 -0.00615989 0.0612821 
v 0.0289801 -0.0163599 0.0615696 
v 0.0284467 -0.00615989 0.0614822 
v 0.0295199 -0.0163599 0.0615404 
v 0.0289801 -0.00615989 0.0615696 
v 0.0300408 -0.0163599 0.0613957 
v 0.0295199 -0.00615989 0.0615404 
v 0.0305184 -0.0163599 0.0611425 
v 0.0300408 -0.00615989 0.0613957 
v 0.0309305 -0.0163599 0.0607925 
v 0.0305184 -0.00615989 0.0611425 
v 0.0312576 -0.0163599 0.0603622 
v 0.0309305 -0.00615989 0.0607925 
v 0.0314846 -0.0163599 0.0598716 
v 0.0312576 -0.00615989 0.0603622 
v 0.0316008 -0.0163599 0.0593436 
v 0.0314846 -0.00615989 0.0598716 
v 0.0316008 -0.0163599 0.058803 
v 0.0316008 -0.00615989 0.0593436 
v 0.0314846 -0.0163599 0.058275 
v 0.0316008 -0.00615989 0.058803 
v 0.0312576 -0.0163599 0.0577844 
v 0.0314846 -0.00615989 0.058275 
v 0.0309305 -0.0163599 0.057354 
v 0.0312576 -0.00615989 0.0577844 
v 0.0305184 -0.0163599 0.0570041 
v 0.0309305 -0.00615989 0.057354 
v 0.0300408 -0.0163599 0.0567509 
v 0.0305184 -0.00615989 0.0570041 
v 0.0295199 -0.0163599 0.0566062 
v 0.0300408 -0.00615989 0.0567509 
v 0.0289801 -0.0163599 0.056577 
v 0.0295199 -0.00615989 0.0566062 
v 0.0284467 -0.0163599 0.0566644 
v 0.0289801 -0.00615989 0.056577 
v 0.0279445 -0.0163599 0.0568645 
v 0.0284467 -0.00615989 0.0566644 
v 0.027497 -0.0163599 0.0571679 
v 0.0279445 -0.00615989 0.0568645 
v 0.0271252 -0.0163599 0.0575604 
v 0.027497 -0.00615989 0.0571679 
v 0.0268465 -0.0163599 0.0580236 
v 0.0271252 -0.00615989 0.0575604 
v 0.0266739 -0.0163599 0.0585359 
v 0.0268465 -0.00615989 0.0580236 
v 0.0266739 -0.00615989 0.0585359 
v 0.0359398 -0.00615989 0.0526089 
v 0.0343906 -0.00615989 0.051293 
v 0.0371699 -0.00615989 0.0542271 
v 0.0286066 -0.00615989 0.0496871 
v 0.0266007 -0.00615989 0.0500159 
v 0.0325948 -0.00615989 0.0503409 
v 0.0306362 -0.00615989 0.0497971 
v 0.02303 -0.00615989 0.051909 
v 0.0216322 -0.00615989 0.0533847 
v 0.0199352 -0.00615989 0.0570526 
v 0.0197155 -0.00615989 0.0590733 
v 0.0247124 -0.00615989 0.0507683 
v 0.0199352 -0.00615989 0.061094 
v 0.0205843 -0.00615989 0.0551263 
v 0.0359398 -0.00615989 0.0655377 
v 0.0371699 -0.00615989 0.0639195 
v 0.0343906 -0.00615989 0.0668536 
v 0.0380234 -0.00615989 0.0560719 
v 0.0205843 -0.00615989 0.0630203 
v 0.0216322 -0.00615989 0.0647619 
v 0.02303 -0.00615989 0.0662376 
v 0.0247124 -0.00615989 0.0673783 
v 0.0266007 -0.00615989 0.0681307 
v 0.0286066 -0.00615989 0.0684595 
v 0.0380234 -0.00615989 0.0620747 
v 0.0384604 -0.00615989 0.0600896 
v 0.0384604 -0.00615989 0.058057 
v 0.0306362 -0.00615989 0.0683495 
v 0.0325948 -0.00615989 0.0678057 
v 0.0171155 -0.00875989 0.0590733 
v 0.017396 -0.00875989 0.0564937 
v 0.0182246 -0.00875989 0.0540346 
v 0.0195624 -0.00875989 0.0518112 
v 0.0213468 -0.00875989 0.0499274 
v 0.0234946 -0.00875989 0.0484712 
v 0.0259051 -0.00875989 0.0475107 
v 0.0284658 -0.00875989 0.0470909 
v 0.0310569 -0.00875989 0.0472314 
v 0.0335571 -0.00875989 0.0479256 
v 0.0358497 -0.00875989 0.049141 
v 0.0378274 -0.00875989 0.0508209 
v 0.0393978 -0.00875989 0.0528867 
v 0.0404873 -0.00875989 0.0552417 
v 0.0410451 -0.00875989 0.0577759 
v 0.0410451 -0.00875989 0.0603707 
v 0.0404873 -0.00875989 0.0629049 
v 0.0393978 -0.00875989 0.0652599 
v 0.0378274 -0.00875989 0.0673257 
v 0.0358497 -0.00875989 0.0690056 
v 0.0335571 -0.00875989 0.070221 
v 0.0310569 -0.00875989 0.0709152 
v 0.0284658 -0.00875989 0.0710557 
v 0.0259051 -0.00875989 0.0706359 
v 0.0234946 -0.00875989 0.0696754 
v 0.0213468 -0.00875989 0.0682192 
v 0.0195624 -0.00875989 0.0663354 
v 0.0182246 -0.00875989 0.064112 
v 0.017396 -0.00875989 0.0616529 
v 0.0174647 -0.0137599 0.0565088 
v 0.0171858 -0.0137599 0.0577759 
v 0.0182884 -0.0137599 0.0540642 
v 0.0177436 -0.0137599 0.0552417 
v 0.0196184 -0.0137599 0.0518538 
v 0.0188332 -0.0137599 0.0528867 
v 0.0213924 -0.0137599 0.049981 
v 0.0204035 -0.0137599 0.0508209 
v 0.0235275 -0.0137599 0.0485333 
v 0.0223812 -0.0137599 0.049141 
v 0.025924 -0.0137599 0.0475785 
v 0.0246738 -0.0137599 0.0479256 
v 0.0284696 -0.0137599 0.0471611 
v 0.0271741 -0.0137599 0.0472314 
v 0.0310455 -0.0137599 0.0473008 
v 0.0297651 -0.0137599 0.0470909 
v 0.0335311 -0.0137599 0.0479909 
v 0.0323258 -0.0137599 0.0475107 
v 0.0358102 -0.0137599 0.0491993 
v 0.0347364 -0.0137599 0.0484712 
v 0.0368841 -0.0137599 0.0499274 
v 0.0377764 -0.0137599 0.0508693 
v 0.0386686 -0.0137599 0.0518112 
v 0.0393375 -0.0137599 0.0529229 
v 0.0400064 -0.0137599 0.0540346 
v 0.0404207 -0.0137599 0.0552641 
v 0.0409752 -0.0137599 0.0577835 
v 0.0408349 -0.0137599 0.0564937 
v 0.0409752 -0.0137599 0.0603631 
v 0.0411155 -0.0137599 0.0590733 
v 0.0404207 -0.0137599 0.0628825 
v 0.0408349 -0.0137599 0.0616529 
v 0.0393375 -0.0137599 0.0652237 
v 0.0400064 -0.0137599 0.064112 
v 0.0377764 -0.0137599 0.0672773 
v 0.0386686 -0.0137599 0.0663354 
v 0.0358102 -0.0137599 0.0689473 
v 0.0368841 -0.0137599 0.0682192 
v 0.0335311 -0.0137599 0.0701557 
v 0.0347364 -0.0137599 0.0696754 
v 0.0310455 -0.0137599 0.0708458 
v 0.0323258 -0.0137599 0.0706359 
v 0.0284696 -0.0137599 0.0709855 
v 0.0297651 -0.0137599 0.0710557 
v 0.025924 -0.0137599 0.0705681 
v 0.0271741 -0.0137599 0.0709152 
v 0.0235275 -0.0137599 0.0696133 
v 0.0246738 -0.0137599 0.070221 
v 0.0213924 -0.0137599 0.0681656 
v 0.0223812 -0.0137599 0.0690056 
v 0.0196184 -0.0137599 0.0662928 
v 0.0204035 -0.0137599 0.0673257 
v 0.0182884 -0.0137599 0.0640824 
v 0.0188332 -0.0137599 0.0652599 
v 0.0174647 -0.0137599 0.0616378 
v 0.0177436 -0.0137599 0.0629049 
v 0.0171155 -0.0137599 0.0590733 
v 0.0171858 -0.0137599 0.0603707 
v 0.0382957 -0.0163599 0.0570526 
v 0.0385155 -0.0163599 0.0590733 
v 0.0376467 -0.0163599 0.0551263 
v 0.0365987 -0.0163599 0.0533847 
v 0.0352009 -0.0163599 0.051909 
v 0.0335185 -0.0163599 0.0507683 
v 0.0316302 -0.0163599 0.0500159 
v 0.0296244 -0.0163599 0.0496871 
v 0.0275947 -0.0163599 0.0497971 
v 0.0256362 -0.0163599 0.0503409 
v 0.0238403 -0.0163599 0.051293 
v 0.0222911 -0.0163599 0.0526089 
v 0.021061 -0.0163599 0.0542271 
v 0.0202075 -0.0163599 0.0560719 
v 0.0197706 -0.0163599 0.058057 
v 0.0197155 -0.0163599 0.0590733 
v 0.0197706 -0.0163599 0.0600896 
v 0.0202075 -0.0163599 0.0620747 
v 0.021061 -0.0163599 0.0639195 
v 0.0222911 -0.0163599 0.0655377 
v 0.0238403 -0.0163599 0.0668536 
v 0.0256362 -0.0163599 0.0678057 
v 0.0275947 -0.0163599 0.0683495 
v 0.0296244 -0.0163599 0.0684595 
v 0.0316302 -0.0163599 0.0681307 
v 0.0335185 -0.0163599 0.0673783 
v 0.0352009 -0.0163599 0.0662376 
v 0.0365987 -0.0163599 0.0647619 
v 0.0376467 -0.0163599 0.0630203 
v 0.0382957 -0.0163599 0.061094 
vn 0.988071 -0.0160725 -0.153159 
vn 0.998231 -0.0158689 0.0573005 
vn 0.933038 -0.0162961 -0.359409 
vn 0.988071 -0.0160725 -0.153159 
vn 0.833815 -0.0165305 -0.551796 
vn 0.933038 -0.0162961 -0.359409 
vn 0.693253 -0.016765 -0.720499 
vn 0.833815 -0.0165305 -0.551796 
vn 0.516604 -0.0169873 -0.856056 
vn 0.693253 -0.016765 -0.720499 
vn 0.311594 -0.0171844 -0.95006 
vn 0.516604 -0.0169873 -0.856056 
vn 0.0882602 -0.0173436 -0.995946 
vn 0.311594 -0.0171844 -0.95006 
vn -0.141536 -0.0174537 -0.989779 
vn 0.0882602 -0.0173436 -0.995946 
vn -0.364924 -0.0175065 -0.930873 
vn -0.141536 -0.0174537 -0.989779 
vn -0.569089 -0.0174981 -0.82209 
vn -0.364924 -0.0175065 -0.930873 
vn -0.742421 -0.017429 -0.669707 
vn -0.569089 -0.0174981 -0.82209 
vn -0.875538 -0.0173046 -0.482839 
vn -0.742421 -0.017429 -0.669707 
vn -0.961992 -0.0171339 -0.272539 
vn -0.875538 -0.0173046 -0.482839 
vn -0.998568 -0.0169286 -0.0507506 
vn -0.961992 -0.0171339 -0.272539 
vn -0.985184 -0.0167017 0.170685 
vn -0.998568 -0.0169286 -0.0507506 
vn -0.924498 -0.0164661 0.38083 
vn -0.985184 -0.0167017 0.170685 
vn -0.821352 -0.0162336 0.570191 
vn -0.924498 -0.0164661 0.38083 
vn -0.682174 -0.0160147 0.731014 
vn -0.821352 -0.0162336 0.570191 
vn -0.514441 -0.0158178 0.85738 
vn -0.682174 -0.0160147 0.731014 
vn -0.326221 -0.0156498 0.945164 
vn -0.514441 -0.0158178 0.85738 
vn -0.125821 -0.0155157 0.991932 
vn -0.326221 -0.0156498 0.945164 
vn 0.0784675 -0.0154192 0.996797 
vn -0.125821 -0.0155157 0.991932 
vn 0.278564 -0.0153628 0.960295 
vn 0.0784675 -0.0154192 0.996797 
vn 0.466739 -0.0153476 0.884262 
vn 0.278564 -0.0153628 0.960295 
vn 0.635739 -0.0153741 0.771751 
vn 0.466739 -0.0153476 0.884262 
vn 0.778893 -0.0154417 0.626966 
vn 0.635739 -0.0153741 0.771751 
vn 0.890246 -0.0155487 0.455214 
vn 0.778893 -0.0154417 0.626966 
vn 0.964705 -0.0156925 0.262864 
vn 0.890246 -0.0155487 0.455214 
vn 0.0295336 0.997766 0.0599216 
vn -0.699186 0.71234 0.06092 
vn -0.688387 0.718867 -0.096717 
vn -0.642564 0.72449 -0.249451 
vn -0.563267 0.728868 -0.389206 
vn -0.454084 0.731722 -0.508322 
vn -0.320518 0.732861 -0.600152 
vn -0.169663 0.732208 -0.65961 
vn -0.00968487 0.729808 -0.683584 
vn 0.1508 0.725821 -0.671151 
vn 0.303373 0.720506 -0.623567 
vn 0.44039 0.71419 -0.544049 
vn 0.555423 0.707237 -0.437403 
vn 0.64353 0.700021 -0.30958 
vn 0.70138 0.692893 -0.167225 
vn 0.727232 0.686175 -0.0172634 
vn 0.720835 0.680139 0.133444 
vn 0.68328 0.675012 0.278365 
vn 0.616824 0.670969 0.411496 
vn 0.524718 0.668141 0.527502 
vn 0.411052 0.666612 0.621824 
vn 0.280603 0.666427 0.690751 
vn 0.138702 0.667592 0.731494 
vn -0.00889216 0.670073 0.742242 
vn -0.156128 0.673795 0.722236 
vn -0.296805 0.678642 0.671827 
vn -0.424748 0.68445 0.592552 
vn -0.534008 0.691007 0.48718 
vn -0.619117 0.698053 0.359745 
vn -0.675376 0.705279 0.215521 
vn -0.98659 -0.0170347 -0.162328 
vn -0.998568 -0.0169286 -0.0507506 
vn -0.998013 -0.016817 0.0607239 
vn -0.924875 -0.0172243 -0.37988 
vn -0.961992 -0.0171339 -0.272539 
vn -0.814484 -0.0173732 -0.579926 
vn -0.875538 -0.0173046 -0.482839 
vn -0.660258 -0.0174709 -0.750836 
vn -0.742421 -0.017429 -0.669707 
vn -0.470176 -0.01751 -0.882399 
vn -0.569089 -0.0174981 -0.82209 
vn -0.254847 -0.0174876 -0.966823 
vn -0.364924 -0.0175065 -0.930873 
vn -0.0266225 -0.0174053 -0.999494 
vn -0.141536 -0.0174537 -0.989779 
vn 0.201511 -0.0172695 -0.979334 
vn 0.0882602 -0.0173436 -0.995946 
vn 0.417067 -0.0170898 -0.908715 
vn 0.311594 -0.0171844 -0.95006 
vn 0.609014 -0.0168785 -0.79298 
vn 0.516604 -0.0169873 -0.856056 
vn 0.768432 -0.0166485 -0.639715 
vn 0.693253 -0.016765 -0.720499 
vn 0.888826 -0.0164126 -0.457951 
vn 0.833815 -0.0165305 -0.551796 
vn 0.966168 -0.0161823 -0.257404 
vn 0.933038 -0.0162961 -0.359409 
vn 0.998726 -0.0159677 -0.0478701 
vn 0.988071 -0.0160725 -0.153159 
vn 0.98679 -0.0157769 0.161234 
vn 0.998231 -0.0158689 0.0573005 
vn 0.932367 -0.0156162 0.361175 
vn 0.964705 -0.0156925 0.262864 
vn 0.838886 -0.0154904 0.544087 
vn 0.890246 -0.0155487 0.455214 
vn 0.710937 -0.0154028 0.703087 
vn 0.778893 -0.0154417 0.626966 
vn 0.554068 -0.0153557 0.83233 
vn 0.635739 -0.0153741 0.771751 
vn 0.374607 -0.01535 0.927057 
vn 0.466739 -0.0153476 0.884262 
vn 0.179532 -0.0153859 0.983632 
vn 0.278564 -0.0153628 0.960295 
vn -0.023651 -0.0154626 0.999601 
vn 0.0784675 -0.0154192 0.996797 
vn -0.227022 -0.0155783 0.973765 
vn -0.125821 -0.0155157 0.991932 
vn -0.422375 -0.0157298 0.906285 
vn -0.326221 -0.0156498 0.945164 
vn -0.601382 -0.015913 0.798803 
vn -0.514441 -0.0158178 0.85738 
vn -0.755818 -0.0161219 0.654583 
vn -0.682174 -0.0160147 0.731014 
vn -0.877861 -0.0163487 0.478636 
vn -0.821352 -0.0162336 0.570191 
vn -0.960496 -0.0165842 0.277801 
vn -0.924498 -0.0164661 0.38083 
vn -0.998013 -0.016817 0.0607239 
vn -0.985184 -0.0167017 0.170685 
vn 0.702348 -0.706033 -0.0906943 
vn 0.711176 -0.702811 -0.0168822 
vn 0.712093 -0.699756 0.0571372 
vn 0.661016 -0.712842 -0.23434 
vn 0.685601 -0.709388 -0.163463 
vn 0.589111 -0.719889 -0.367026 
vn 0.628763 -0.716355 -0.302476 
vn 0.48916 -0.726845 -0.482098 
vn 0.542422 -0.723401 -0.427165 
vn 0.365255 -0.733354 -0.573395 
vn 0.429886 -0.730178 -0.531073 
vn 0.22299 -0.739055 -0.635667 
vn 0.296013 -0.736327 -0.608439 
vn 0.0692742 -0.743612 -0.665013 
vn 0.147089 -0.741496 -0.654636 
vn -0.0880251 -0.74674 -0.659265 
vn -0.00944403 -0.74537 -0.666584 
vn -0.240575 -0.748235 -0.618279 
vn -0.165417 -0.7477 -0.643103 
vn -0.380171 -0.747997 -0.544032 
vn -0.312483 -0.748334 -0.585107 
vn -0.499351 -0.746042 -0.440534 
vn -0.442734 -0.747228 -0.495617 
vn -0.591948 -0.7425 -0.313515 
vn -0.549295 -0.744457 -0.379551 
vn -0.653498 -0.737599 -0.169964 
vn -0.626809 -0.740202 -0.243335 
vn -0.681462 -0.731643 -0.0175748 
vn -0.67176 -0.734732 -0.0943809 
vn -0.675252 -0.724976 0.135808 
vn -0.682592 -0.728376 0.0594741 
vn -0.636098 -0.717961 0.282686 
vn -0.659652 -0.72149 0.210504 
vn -0.566793 -0.710947 0.416294 
vn -0.604987 -0.714433 0.351535 
vn -0.471382 -0.704256 0.530869 
vn -0.522058 -0.707542 0.476277 
vn -0.354846 -0.698169 0.621807 
vn -0.415416 -0.701121 0.579533 
vn -0.22279 -0.692921 0.68573 
vn -0.290391 -0.695427 0.657308 
vn -0.081183 -0.688697 0.72049 
vn -0.1528 -0.690671 0.706842 
vn 0.0638734 -0.685638 0.725135 
vn -0.00870466 -0.687015 0.726591 
vn 0.20633 -0.683839 0.699851 
vn 0.135798 -0.684577 0.71618 
vn 0.340353 -0.683356 0.645898 
vn 0.274748 -0.683432 0.676339 
vn 0.460461 -0.684201 0.565547 
vn 0.402471 -0.683613 0.608843 
vn 0.561665 -0.686351 0.462012 
vn 0.513716 -0.685116 0.516442 
vn 0.639593 -0.689739 0.339384 
vn 0.603783 -0.687896 0.402796 
vn 0.690634 -0.694258 0.202558 
vn 0.668666 -0.691866 0.272411 
vn 0.70519 -0.696896 0.130548 
vn 0.712093 -0.699756 0.0571372 
vn 0.0285869 -0.997907 0.0580008 
usemtl 0.400000_0.400000_0.400000_0.000000_0.000000
o mesh3
f 8698//8753 8699//8754 8700//8754 
f 8701//8755 8698//8753 8702//8756 
f 8703//8757 8701//8755 8704//8758 
f 8705//8759 8703//8757 8706//8760 
f 8707//8761 8705//8759 8708//8762 
f 8709//8763 8707//8761 8710//8764 
f 8711//8765 8709//8763 8712//8766 
f 8713//8767 8711//8765 8714//8768 
f 8715//8769 8713//8767 8716//8770 
f 8717//8771 8715//8769 8718//8772 
f 8719//8773 8717//8771 8720//8774 
f 8721//8775 8719//8773 8722//8776 
f 8723//8777 8721//8775 8724//8778 
f 8725//8779 8723//8777 8726//8780 
f 8727//8781 8725//8779 8728//8782 
f 8729//8783 8727//8781 8730//8784 
f 8731//8785 8729//8783 8732//8786 
f 8733//8787 8731//8785 8734//8788 
f 8735//8789 8733//8787 8736//8790 
f 8737//8791 8735//8789 8738//8792 
f 8739//8793 8737//8791 8740//8794 
f 8741//8795 8739//8793 8742//8796 
f 8743//8797 8741//8795 8744//8798 
f 8745//8799 8743//8797 8746//8800 
f 8747//8801 8745//8799 8748//8802 
f 8749//8803 8747//8801 8750//8804 
f 8751//8805 8749//8803 8752//8806 
f 8753//8807 8751//8805 8754//8808 
f 8699//8754 8753//8807 8755//8807 
f 8755//8807 8700//8754 8699//8754 
f 8754//8808 8755//8807 8753//8807 
f 8752//8806 8754//8808 8751//8805 
f 8750//8804 8752//8806 8749//8803 
f 8748//8802 8750//8804 8747//8801 
f 8746//8800 8748//8802 8745//8799 
f 8744//8798 8746//8800 8743//8797 
f 8742//8796 8744//8798 8741//8795 
f 8740//8794 8742//8796 8739//8793 
f 8738//8792 8740//8794 8737//8791 
f 8736//8790 8738//8792 8735//8789 
f 8734//8788 8736//8790 8733//8787 
f 8732//8786 8734//8788 8731//8785 
f 8730//8784 8732//8786 8729//8783 
f 8728//8782 8730//8784 8727//8781 
f 8726//8780 8728//8782 8725//8779 
f 8724//8778 8726//8780 8723//8777 
f 8722//8776 8724//8778 8721//8775 
f 8720//8774 8722//8776 8719//8773 
f 8718//8772 8720//8774 8717//8771 
f 8716//8770 8718//8772 8715//8769 
f 8714//8768 8716//8770 8713//8767 
f 8712//8766 8714//8768 8711//8765 
f 8710//8764 8712//8766 8709//8763 
f 8708//8762 8710//8764 8707//8761 
f 8706//8760 8708//8762 8705//8759 
f 8704//8758 8706//8760 8703//8757 
f 8702//8756 8704//8758 8701//8755 
f 8700//8754 8702//8756 8698//8753 
o mesh4
f 8756//8809 8736//8809 8734//8809 
f 8756//8809 8757//8809 8738//8809 
f 8758//8809 8734//8809 8732//8809 
f 8738//8809 8736//8809 8756//8809 
f 8759//8809 8744//8809 8742//8809 
f 8759//8809 8760//8809 8746//8809 
f 8734//8809 8758//8809 8756//8809 
f 8757//8809 8761//8809 8740//8809 
f 8762//8809 8742//8809 8740//8809 
f 8746//8809 8744//8809 8759//8809 
f 8763//8809 8750//8809 8748//8809 
f 8763//8809 8764//8809 8752//8809 
f 8765//8809 8755//8809 8754//8809 
f 8766//8809 8700//8809 8755//8809 
f 8740//8809 8738//8809 8757//8809 
f 8742//8809 8762//8809 8759//8809 
f 8767//8809 8748//8809 8746//8809 
f 8752//8809 8750//8809 8763//8809 
f 8755//8809 8765//8809 8766//8809 
f 8768//8809 8702//8809 8700//8809 
f 8740//8809 8761//8809 8762//8809 
f 8748//8809 8767//8809 8763//8809 
f 8769//8809 8754//8809 8752//8809 
f 8700//8809 8766//8809 8768//8809 
f 8770//8809 8722//8809 8720//8809 
f 8771//8809 8724//8809 8722//8809 
f 8746//8809 8760//8809 8767//8809 
f 8754//8809 8769//8809 8765//8809 
f 8772//8809 8720//8809 8718//8809 
f 8722//8809 8770//8809 8771//8809 
f 8773//8809 8732//8809 8730//8809 
f 8752//8809 8764//8809 8769//8809 
f 8774//8809 8704//8809 8702//8809 
f 8775//8809 8706//8809 8704//8809 
f 8776//8809 8708//8809 8706//8809 
f 8777//8809 8710//8809 8708//8809 
f 8778//8809 8712//8809 8710//8809 
f 8778//8809 8779//8809 8714//8809 
f 8720//8809 8772//8809 8770//8809 
f 8780//8809 8726//8809 8724//8809 
f 8781//8809 8728//8809 8726//8809 
f 8782//8809 8730//8809 8728//8809 
f 8732//8809 8773//8809 8758//8809 
f 8704//8809 8774//8809 8775//8809 
f 8708//8809 8776//8809 8777//8809 
f 8714//8809 8712//8809 8778//8809 
f 8783//8809 8716//8809 8714//8809 
f 8784//8809 8718//8809 8716//8809 
f 8724//8809 8771//8809 8780//8809 
f 8728//8809 8781//8809 8782//8809 
f 8702//8809 8768//8809 8774//8809 
f 8710//8809 8777//8809 8778//8809 
f 8716//8809 8783//8809 8784//8809 
f 8726//8809 8780//8809 8781//8809 
f 8706//8809 8775//8809 8776//8809 
f 8718//8809 8784//8809 8772//8809 
f 8714//8809 8779//8809 8783//8809 
f 8730//8809 8782//8809 8773//8809 
o mesh5
f 8785//8810 8766//8810 8765//8811 
f 8786//8811 8765//8811 8769//8812 
f 8787//8812 8769//8812 8764//8813 
f 8788//8813 8764//8813 8763//8814 
f 8789//8814 8763//8814 8767//8815 
f 8790//8815 8767//8815 8760//8816 
f 8791//8816 8760//8816 8759//8817 
f 8792//8817 8759//8817 8762//8818 
f 8793//8818 8762//8818 8761//8819 
f 8794//8819 8761//8819 8757//8820 
f 8795//8820 8757//8820 8756//8821 
f 8796//8821 8756//8821 8758//8822 
f 8797//8822 8758//8822 8773//8823 
f 8798//8823 8773//8823 8782//8824 
f 8799//8824 8782//8824 8781//8825 
f 8800//8825 8781//8825 8780//8826 
f 8801//8826 8780//8826 8771//8827 
f 8802//8827 8771//8827 8770//8828 
f 8803//8828 8770//8828 8772//8829 
f 8804//8829 8772//8829 8784//8830 
f 8805//8830 8784//8830 8783//8831 
f 8806//8831 8783//8831 8779//8832 
f 8807//8832 8779//8832 8778//8833 
f 8808//8833 8778//8833 8777//8834 
f 8809//8834 8777//8834 8776//8835 
f 8810//8835 8776//8835 8775//8836 
f 8811//8836 8775//8836 8774//8837 
f 8812//8837 8774//8837 8768//8838 
f 8813//8838 8768//8838 8766//8810 
f 8766//8810 8785//8810 8813//8838 
f 8768//8838 8813//8838 8812//8837 
f 8774//8837 8812//8837 8811//8836 
f 8775//8836 8811//8836 8810//8835 
f 8776//8835 8810//8835 8809//8834 
f 8777//8834 8809//8834 8808//8833 
f 8778//8833 8808//8833 8807//8832 
f 8779//8832 8807//8832 8806//8831 
f 8783//8831 8806//8831 8805//8830 
f 8784//8830 8805//8830 8804//8829 
f 8772//8829 8804//8829 8803//8828 
f 8770//8828 8803//8828 8802//8827 
f 8771//8827 8802//8827 8801//8826 
f 8780//8826 8801//8826 8800//8825 
f 8781//8825 8800//8825 8799//8824 
f 8782//8824 8799//8824 8798//8823 
f 8773//8823 8798//8823 8797//8822 
f 8758//8822 8797//8822 8796//8821 
f 8756//8821 8796//8821 8795//8820 
f 8757//8820 8795//8820 8794//8819 
f 8761//8819 8794//8819 8793//8818 
f 8762//8818 8793//8818 8792//8817 
f 8759//8817 8792//8817 8791//8816 
f 8760//8816 8791//8816 8790//8815 
f 8767//8815 8790//8815 8789//8814 
f 8763//8814 8789//8814 8788//8813 
f 8764//8813 8788//8813 8787//8812 
f 8769//8812 8787//8812 8786//8811 
f 8765//8811 8786//8811 8785//8810 
o mesh6
f 8786//8839 8814//8839 8815//8840 
f 8815//8840 8785//8841 8786//8839 
f 8787//8842 8816//8842 8817//8843 
f 8817//8843 8786//8839 8787//8842 
f 8788//8844 8818//8844 8819//8845 
f 8819//8845 8787//8842 8788//8844 
f 8789//8846 8820//8846 8821//8847 
f 8821//8847 8788//8844 8789//8846 
f 8790//8848 8822//8848 8823//8849 
f 8823//8849 8789//8846 8790//8848 
f 8791//8850 8824//8850 8825//8851 
f 8825//8851 8790//8848 8791//8850 
f 8792//8852 8826//8852 8827//8853 
f 8827//8853 8791//8850 8792//8852 
f 8793//8854 8828//8854 8829//8855 
f 8829//8855 8792//8852 8793//8854 
f 8794//8856 8830//8856 8831//8857 
f 8831//8857 8793//8854 8794//8856 
f 8795//8858 8832//8858 8833//8859 
f 8833//8859 8794//8856 8795//8858 
f 8795//8858 8796//8860 8834//8861 
f 8796//8860 8835//8860 8834//8861 
f 8796//8860 8797//8862 8836//8863 
f 8797//8862 8837//8862 8836//8863 
f 8797//8862 8798//8864 8838//8865 
f 8798//8864 8839//8864 8838//8865 
f 8799//8866 8840//8866 8841//8867 
f 8841//8867 8798//8864 8799//8866 
f 8800//8868 8842//8868 8843//8869 
f 8843//8869 8799//8866 8800//8868 
f 8801//8870 8844//8870 8845//8871 
f 8845//8871 8800//8868 8801//8870 
f 8802//8872 8846//8872 8847//8873 
f 8847//8873 8801//8870 8802//8872 
f 8803//8874 8848//8874 8849//8875 
f 8849//8875 8802//8872 8803//8874 
f 8804//8876 8850//8876 8851//8877 
f 8851//8877 8803//8874 8804//8876 
f 8805//8878 8852//8878 8853//8879 
f 8853//8879 8804//8876 8805//8878 
f 8806//8880 8854//8880 8855//8881 
f 8855//8881 8805//8878 8806//8880 
f 8807//8882 8856//8882 8857//8883 
f 8857//8883 8806//8880 8807//8882 
f 8808//8884 8858//8884 8859//8885 
f 8859//8885 8807//8882 8808//8884 
f 8809//8886 8860//8886 8861//8887 
f 8861//8887 8808//8884 8809//8886 
f 8810//8888 8862//8888 8863//8889 
f 8863//8889 8809//8886 8810//8888 
f 8811//8890 8864//8890 8865//8891 
f 8865//8891 8810//8888 8811//8890 
f 8812//8892 8866//8892 8867//8893 
f 8867//8893 8811//8890 8812//8892 
f 8813//8894 8868//8894 8869//8895 
f 8869//8895 8812//8892 8813//8894 
f 8785//8841 8870//8896 8871//8897 
f 8871//8897 8813//8894 8785//8841 
f 8871//8897 8868//8894 8813//8894 
f 8869//8895 8866//8892 8812//8892 
f 8867//8893 8864//8890 8811//8890 
f 8865//8891 8862//8888 8810//8888 
f 8863//8889 8860//8886 8809//8886 
f 8861//8887 8858//8884 8808//8884 
f 8859//8885 8856//8882 8807//8882 
f 8857//8883 8854//8880 8806//8880 
f 8855//8881 8852//8878 8805//8878 
f 8853//8879 8850//8876 8804//8876 
f 8851//8877 8848//8874 8803//8874 
f 8849//8875 8846//8872 8802//8872 
f 8847//8873 8844//8870 8801//8870 
f 8845//8871 8842//8868 8800//8868 
f 8843//8869 8840//8866 8799//8866 
f 8841//8867 8839//8864 8798//8864 
f 8838//8865 8837//8862 8797//8862 
f 8836//8863 8835//8860 8796//8860 
f 8834//8861 8832//8858 8795//8858 
f 8833//8859 8830//8856 8794//8856 
f 8831//8857 8828//8854 8793//8854 
f 8829//8855 8826//8852 8792//8852 
f 8827//8853 8824//8850 8791//8850 
f 8825//8851 8822//8848 8790//8848 
f 8823//8849 8820//8846 8789//8846 
f 8821//8847 8818//8844 8788//8844 
f 8819//8845 8816//8842 8787//8842 
f 8817//8843 8814//8839 8786//8839 
f 8815//8840 8870//8896 8785//8841 
o mesh7
f 8872//8898 8841//8898 8840//8899 
f 8840//8899 8873//8900 8872//8898 
f 8874//8901 8838//8901 8839//8902 
f 8839//8902 8872//8898 8874//8901 
f 8875//8903 8836//8903 8837//8904 
f 8837//8904 8874//8901 8875//8903 
f 8876//8905 8834//8905 8835//8906 
f 8835//8906 8875//8903 8876//8905 
f 8877//8907 8833//8907 8832//8908 
f 8832//8908 8876//8905 8877//8907 
f 8878//8909 8831//8909 8830//8910 
f 8830//8910 8877//8907 8878//8909 
f 8879//8911 8829//8911 8828//8912 
f 8828//8912 8878//8909 8879//8911 
f 8880//8913 8827//8913 8826//8914 
f 8826//8914 8879//8911 8880//8913 
f 8881//8915 8825//8915 8824//8916 
f 8824//8916 8880//8913 8881//8915 
f 8882//8917 8823//8917 8822//8918 
f 8822//8918 8881//8915 8882//8917 
f 8883//8919 8821//8919 8820//8920 
f 8820//8920 8882//8917 8883//8919 
f 8884//8921 8819//8921 8818//8922 
f 8818//8922 8883//8919 8884//8921 
f 8885//8923 8817//8923 8816//8924 
f 8816//8924 8884//8921 8885//8923 
f 8886//8925 8815//8925 8814//8926 
f 8814//8926 8885//8923 8886//8925 
f 8871//8927 8870//8928 8887//8928 
f 8815//8925 8886//8925 8887//8928 
f 8887//8928 8870//8928 8815//8925 
f 8888//8927 8889//8929 8868//8930 
f 8889//8929 8869//8929 8868//8930 
f 8889//8929 8890//8931 8866//8932 
f 8890//8931 8867//8931 8866//8932 
f 8890//8931 8891//8933 8864//8934 
f 8891//8933 8865//8933 8864//8934 
f 8892//8935 8863//8935 8862//8936 
f 8862//8936 8891//8933 8892//8935 
f 8893//8937 8861//8937 8860//8938 
f 8860//8938 8892//8935 8893//8937 
f 8894//8939 8859//8939 8858//8940 
f 8858//8940 8893//8937 8894//8939 
f 8895//8941 8857//8941 8856//8942 
f 8856//8942 8894//8939 8895//8941 
f 8896//8943 8855//8943 8854//8944 
f 8854//8944 8895//8941 8896//8943 
f 8897//8945 8853//8945 8852//8946 
f 8852//8946 8896//8943 8897//8945 
f 8898//8947 8851//8947 8850//8948 
f 8850//8948 8897//8945 8898//8947 
f 8898//8947 8899//8949 8848//8950 
f 8899//8949 8849//8949 8848//8950 
f 8900//8951 8847//8951 8846//8952 
f 8846//8952 8899//8949 8900//8951 
f 8901//8953 8845//8953 8844//8954 
f 8844//8954 8900//8951 8901//8953 
f 8901//8953 8873//8900 8842//8955 
f 8873//8900 8843//8956 8842//8955 
f 8842//8955 8845//8953 8901//8953 
f 8844//8954 8847//8951 8900//8951 
f 8846//8952 8849//8949 8899//8949 
f 8848//8950 8851//8947 8898//8947 
f 8850//8948 8853//8945 8897//8945 
f 8852//8946 8855//8943 8896//8943 
f 8854//8944 8857//8941 8895//8941 
f 8856//8942 8859//8939 8894//8939 
f 8858//8940 8861//8937 8893//8937 
f 8860//8938 8863//8935 8892//8935 
f 8862//8936 8865//8933 8891//8933 
f 8864//8934 8867//8931 8890//8931 
f 8866//8932 8869//8929 8889//8929 
f 8868//8930 8871//8927 8888//8927 
f 8887//8928 8888//8927 8871//8927 
f 8814//8926 8817//8923 8885//8923 
f 8816//8924 8819//8921 8884//8921 
f 8818//8922 8821//8919 8883//8919 
f 8820//8920 8823//8917 8882//8917 
f 8822//8918 8825//8915 8881//8915 
f 8824//8916 8827//8913 8880//8913 
f 8826//8914 8829//8911 8879//8911 
f 8828//8912 8831//8909 8878//8909 
f 8830//8910 8833//8907 8877//8907 
f 8832//8908 8834//8905 8876//8905 
f 8835//8906 8836//8903 8875//8903 
f 8837//8904 8838//8901 8874//8901 
f 8839//8902 8841//8898 8872//8898 
f 8840//8899 8843//8956 8873//8900 
o mesh8
f 8886//8957 8885//8957 8753//8957 
f 8699//8957 8887//8957 8886//8957 
f 8885//8957 8884//8957 8751//8957 
f 8883//8957 8882//8957 8747//8957 
f 8882//8957 8881//8957 8745//8957 
f 8751//8957 8753//8957 8885//8957 
f 8884//8957 8883//8957 8749//8957 
f 8745//8957 8747//8957 8882//8957 
f 8881//8957 8880//8957 8743//8957 
f 8880//8957 8879//8957 8741//8957 
f 8879//8957 8878//8957 8739//8957 
f 8876//8957 8875//8957 8733//8957 
f 8875//8957 8874//8957 8731//8957 
f 8899//8957 8898//8957 8719//8957 
f 8898//8957 8897//8957 8717//8957 
f 8749//8957 8751//8957 8884//8957 
f 8743//8957 8745//8957 8881//8957 
f 8739//8957 8741//8957 8879//8957 
f 8878//8957 8877//8957 8737//8957 
f 8877//8957 8876//8957 8735//8957 
f 8731//8957 8733//8957 8875//8957 
f 8872//8957 8873//8957 8727//8957 
f 8873//8957 8901//8957 8725//8957 
f 8717//8957 8719//8957 8898//8957 
f 8897//8957 8896//8957 8715//8957 
f 8747//8957 8749//8957 8883//8957 
f 8737//8957 8739//8957 8878//8957 
f 8733//8957 8735//8957 8876//8957 
f 8874//8957 8872//8957 8729//8957 
f 8725//8957 8727//8957 8873//8957 
f 8901//8957 8900//8957 8723//8957 
f 8900//8957 8899//8957 8721//8957 
f 8715//8957 8717//8957 8897//8957 
f 8894//8957 8893//8957 8709//8957 
f 8893//8957 8892//8957 8707//8957 
f 8892//8957 8891//8957 8705//8957 
f 8891//8957 8890//8957 8703//8957 
f 8741//8957 8743//8957 8880//8957 
f 8729//8957 8731//8957 8874//8957 
f 8723//8957 8725//8957 8901//8957 
f 8719//8957 8721//8957 8899//8957 
f 8707//8957 8709//8957 8893//8957 
f 8703//8957 8705//8957 8891//8957 
f 8890//8957 8889//8957 8701//8957 
f 8889//8957 8888//8957 8698//8957 
f 8735//8957 8737//8957 8877//8957 
f 8721//8957 8723//8957 8900//8957 
f 8896//8957 8895//8957 8713//8957 
f 8895//8957 8894//8957 8711//8957 
f 8705//8957 8707//8957 8892//8957 
f 8698//8957 8701//8957 8889//8957 
f 8727//8957 8729//8957 8872//8957 
f 8711//8957 8713//8957 8895//8957 
f 8701//8957 8703//8957 8890//8957 
f 8888//8957 8887//8957 8699//8957 
f 8713//8957 8715//8957 8896//8957 
f 8699//8957 8698//8957 8888//8957 
f 8709//8957 8711//8957 8894//8957 
f 8753//8957 8699//8957 8886//8957 
g 35cm_T2020
v 0.218349 -0.190844 -0.1151 
v -0.131651 -0.190844 -0.1151 
v -0.131651 -0.19438 -0.111565 
v 0.218349 -0.19438 -0.111565 
v -0.131651 -0.198344 -0.111565 
v 0.218349 -0.198344 -0.111565 
v -0.131651 -0.198344 -0.115529 
v 0.218349 -0.198344 -0.115529 
v -0.131651 -0.194809 -0.119065 
v 0.218349 -0.194809 -0.119065 
v -0.131651 -0.194809 -0.124065 
v 0.218349 -0.194809 -0.124065 
v -0.131651 -0.198344 -0.1276 
v 0.218349 -0.198344 -0.1276 
v -0.131651 -0.198344 -0.131565 
v 0.218349 -0.198344 -0.131565 
v -0.131651 -0.19438 -0.131565 
v 0.218349 -0.19438 -0.131565 
v -0.131651 -0.190844 -0.128029 
v 0.218349 -0.190844 -0.128029 
v -0.131651 -0.185844 -0.128029 
v 0.218349 -0.185844 -0.128029 
v -0.131651 -0.182309 -0.131565 
v 0.218349 -0.182309 -0.131565 
v -0.131651 -0.178344 -0.131565 
v 0.218349 -0.178344 -0.131565 
v -0.131651 -0.178344 -0.1276 
v 0.218349 -0.178344 -0.1276 
v -0.131651 -0.18188 -0.124065 
v 0.218349 -0.18188 -0.124065 
v -0.131651 -0.18188 -0.119065 
v 0.218349 -0.18188 -0.119065 
v -0.131651 -0.178344 -0.115529 
v 0.218349 -0.178344 -0.115529 
v -0.131651 -0.178344 -0.111565 
v 0.218349 -0.178344 -0.111565 
v 0.218349 -0.182309 -0.111565 
v 0.218349 -0.185844 -0.1151 
v -0.131651 -0.182309 -0.111565 
v -0.131651 -0.185844 -0.1151 
vn -0.171989 0.651583 0.738823 
vn -0.147407 -0.233279 0.961172 
vn -0.107583 -0.987443 -0.115685 
vn -0.104881 -0.729304 -0.676103 
vn -0.121441 -0.844453 0.521681 
vn -0.107583 -0.987443 -0.115685 
vn -0.112728 -0.178398 -0.97748 
vn -0.132559 0.502205 -0.854528 
vn -0.104881 -0.729304 -0.676103 
vn -0.112728 -0.178398 -0.97748 
vn -0.161551 0.971454 -0.173717 
vn -0.171989 0.651583 0.738823 
vn -0.132559 0.502205 -0.854528 
vn -0.161551 0.971454 -0.173717 
vn 0.960409 -0.230432 -0.156573 
vn -0.976112 -0.179709 -0.122107 
vn -0.147407 -0.233279 0.961172 
vn -0.121441 -0.844453 0.521681 
usemtl 0.301961_0.301961_0.301961_0.000000_0.000000
o mesh229
f 8902//8958 8903//8958 8904//8958 
f 8904//8958 8905//8958 8902//8958 
o mesh230
f 8905//8959 8904//8959 8906//8959 
f 8906//8959 8907//8959 8905//8959 
o mesh231
f 8907//8960 8906//8960 8908//8960 
f 8908//8960 8909//8960 8907//8960 
o mesh232
f 8909//8961 8908//8961 8910//8961 
f 8910//8961 8911//8961 8909//8961 
o mesh233
f 8911//8960 8910//8960 8912//8960 
f 8912//8960 8913//8960 8911//8960 
o mesh234
f 8913//8962 8912//8962 8914//8962 
f 8914//8962 8915//8962 8913//8962 
o mesh235
f 8915//8963 8914//8963 8916//8963 
f 8916//8963 8917//8963 8915//8963 
o mesh236
f 8917//8964 8916//8964 8918//8964 
f 8918//8964 8919//8964 8917//8964 
o mesh237
f 8919//8965 8918//8965 8920//8965 
f 8920//8965 8921//8965 8919//8965 
o mesh238
f 8921//8964 8920//8964 8922//8964 
f 8922//8964 8923//8964 8921//8964 
o mesh239
f 8923//8966 8922//8966 8924//8966 
f 8924//8966 8925//8966 8923//8966 
o mesh240
f 8925//8967 8924//8967 8926//8967 
f 8926//8967 8927//8967 8925//8967 
o mesh241
f 8927//8968 8926//8968 8928//8968 
f 8928//8968 8929//8968 8927//8968 
o mesh242
f 8929//8969 8928//8969 8930//8969 
f 8930//8969 8931//8969 8929//8969 
o mesh243
f 8931//8968 8930//8968 8932//8968 
f 8932//8968 8933//8968 8931//8968 
o mesh244
f 8933//8970 8932//8970 8934//8970 
f 8934//8970 8935//8970 8933//8970 
o mesh245
f 8935//8971 8934//8971 8936//8971 
f 8936//8971 8937//8971 8935//8971 
o mesh246
f 8938//8972 8933//8972 8935//8972 
f 8915//8972 8917//8972 8919//8972 
f 8913//8972 8921//8972 8931//8972 
f 8935//8972 8937//8972 8938//8972 
f 8921//8972 8913//8972 8915//8972 
f 8933//8972 8911//8972 8913//8972 
f 8925//8972 8927//8972 8929//8972 
f 8938//8972 8939//8972 8933//8972 
f 8931//8972 8933//8972 8913//8972 
f 8931//8972 8923//8972 8925//8972 
f 8905//8972 8907//8972 8909//8972 
f 8919//8972 8921//8972 8915//8972 
f 8931//8972 8921//8972 8923//8972 
f 8911//8972 8902//8972 8905//8972 
f 8929//8972 8931//8972 8925//8972 
f 8911//8972 8939//8972 8902//8972 
f 8909//8972 8911//8972 8905//8972 
f 8939//8972 8911//8972 8933//8972 
o mesh247
f 8912//8973 8932//8973 8930//8973 
f 8914//8973 8920//8973 8918//8973 
f 8940//8973 8936//8973 8934//8973 
f 8924//8973 8930//8973 8928//8973 
f 8930//8973 8920//8973 8912//8973 
f 8918//8973 8916//8973 8914//8973 
f 8932//8973 8941//8973 8940//8973 
f 8904//8973 8910//8973 8908//8973 
f 8928//8973 8926//8973 8924//8973 
f 8914//8973 8912//8973 8920//8973 
f 8932//8973 8910//8973 8941//8973 
f 8908//8973 8906//8973 8904//8973 
f 8924//8973 8922//8973 8930//8973 
f 8934//8973 8932//8973 8940//8973 
f 8904//8973 8903//8973 8910//8973 
f 8912//8973 8910//8973 8932//8973 
f 8922//8973 8920//8973 8930//8973 
f 8903//8973 8941//8973 8910//8973 
o mesh248
f 8937//8974 8936//8974 8940//8974 
f 8940//8974 8938//8974 8937//8974 
o mesh249
f 8938//8975 8940//8975 8941//8975 
f 8941//8975 8939//8975 8938//8975 
o mesh250
f 8939//8974 8941//8974 8903//8974 
f 8903//8974 8902//8974 8939//8974 
g 20cm_T2020
v -0.143849 0.0178046 0.0885184 
v -0.143849 0.0178046 -0.111482 
v -0.147385 0.0213401 -0.111482 
v -0.147385 0.0213401 0.0885184 
v -0.151349 0.0213401 -0.111482 
v -0.151349 0.0213401 0.0885184 
v -0.151349 0.0173756 -0.111482 
v -0.151349 0.0173756 0.0885184 
v -0.147813 0.0138401 -0.111482 
v -0.147813 0.0138401 0.0885184 
v -0.147813 0.00884011 -0.111482 
v -0.147813 0.00884011 0.0885184 
v -0.151349 0.00530457 -0.111482 
v -0.151349 0.00530457 0.0885184 
v -0.151349 0.00134011 -0.111482 
v -0.151349 0.00134011 0.0885184 
v -0.147385 0.00134011 -0.111482 
v -0.147385 0.00134011 0.0885184 
v -0.143849 0.00487564 -0.111482 
v -0.143849 0.00487564 0.0885184 
v -0.138849 0.00487564 -0.111482 
v -0.138849 0.00487564 0.0885184 
v -0.135313 0.00134011 -0.111482 
v -0.135313 0.00134011 0.0885184 
v -0.131349 0.00134011 -0.111482 
v -0.131349 0.00134011 0.0885184 
v -0.131349 0.00530457 -0.111482 
v -0.131349 0.00530457 0.0885184 
v -0.134885 0.00884011 -0.111482 
v -0.134885 0.00884011 0.0885184 
v -0.134885 0.0138401 -0.111482 
v -0.134885 0.0138401 0.0885184 
v -0.131349 0.0173756 -0.111482 
v -0.131349 0.0173756 0.0885184 
v -0.131349 0.0213401 -0.111482 
v -0.131349 0.0213401 0.0885184 
v -0.135313 0.0213401 0.0885184 
v -0.138849 0.0178046 0.0885184 
v -0.135313 0.0213401 -0.111482 
v -0.138849 0.0178046 -0.111482 
vn 0.590023 0.79834 -0.120524 
vn -0.153692 0.982396 -0.106191 
vn -0.995065 0.0268528 -0.0955195 
vn -0.7852 -0.610984 -0.100794 
vn -0.75821 0.644705 -0.0973296 
vn -0.995065 0.0268528 -0.0955195 
vn -0.163257 -0.980114 -0.1128 
vn 0.623188 -0.771642 -0.127298 
vn -0.7852 -0.610984 -0.100794 
vn -0.163257 -0.980114 -0.1128 
vn 0.990601 0.0370184 -0.13168 
vn 0.590023 0.79834 -0.120524 
vn 0.623188 -0.771642 -0.127298 
vn 0.990601 0.0370184 -0.13168 
vn -0.178564 0.0346839 0.983317 
vn -0.143604 0.0278934 -0.989242 
vn -0.153692 0.982396 -0.106191 
vn -0.75821 0.644705 -0.0973296 
o mesh394
f 8942//8976 8943//8976 8944//8976 
f 8944//8976 8945//8976 8942//8976 
o mesh395
f 8945//8977 8944//8977 8946//8977 
f 8946//8977 8947//8977 8945//8977 
o mesh396
f 8947//8978 8946//8978 8948//8978 
f 8948//8978 8949//8978 8947//8978 
o mesh397
f 8949//8979 8948//8979 8950//8979 
f 8950//8979 8951//8979 8949//8979 
o mesh398
f 8951//8978 8950//8978 8952//8978 
f 8952//8978 8953//8978 8951//8978 
o mesh399
f 8953//8980 8952//8980 8954//8980 
f 8954//8980 8955//8980 8953//8980 
o mesh400
f 8955//8981 8954//8981 8956//8981 
f 8956//8981 8957//8981 8955//8981 
o mesh401
f 8957//8982 8956//8982 8958//8982 
f 8958//8982 8959//8982 8957//8982 
o mesh402
f 8959//8983 8958//8983 8960//8983 
f 8960//8983 8961//8983 8959//8983 
o mesh403
f 8961//8982 8960//8982 8962//8982 
f 8962//8982 8963//8982 8961//8982 
o mesh404
f 8963//8984 8962//8984 8964//8984 
f 8964//8984 8965//8984 8963//8984 
o mesh405
f 8965//8985 8964//8985 8966//8985 
f 8966//8985 8967//8985 8965//8985 
o mesh406
f 8967//8986 8966//8986 8968//8986 
f 8968//8986 8969//8986 8967//8986 
o mesh407
f 8969//8987 8968//8987 8970//8987 
f 8970//8987 8971//8987 8969//8987 
o mesh408
f 8971//8986 8970//8986 8972//8986 
f 8972//8986 8973//8986 8971//8986 
o mesh409
f 8973//8988 8972//8988 8974//8988 
f 8974//8988 8975//8988 8973//8988 
o mesh410
f 8975//8989 8974//8989 8976//8989 
f 8976//8989 8977//8989 8975//8989 
o mesh411
f 8965//8990 8967//8990 8969//8990 
f 8945//8990 8947//8990 8949//8990 
f 8961//8990 8973//8990 8942//8990 
f 8978//8990 8973//8990 8975//8990 
f 8971//8990 8963//8990 8965//8990 
f 8951//8990 8942//8990 8945//8990 
f 8942//8990 8951//8990 8961//8990 
f 8975//8990 8977//8990 8978//8990 
f 8969//8990 8971//8990 8965//8990 
f 8961//8990 8963//8990 8973//8990 
f 8955//8990 8957//8990 8959//8990 
f 8978//8990 8979//8990 8973//8990 
f 8949//8990 8951//8990 8945//8990 
f 8961//8990 8953//8990 8955//8990 
f 8971//8990 8973//8990 8963//8990 
f 8961//8990 8951//8990 8953//8990 
f 8959//8990 8961//8990 8955//8990 
f 8979//8990 8942//8990 8973//8990 
o mesh412
f 8968//8991 8966//8991 8964//8991 
f 8948//8991 8946//8991 8944//8991 
f 8972//8991 8960//8991 8950//8991 
f 8954//8991 8960//8991 8958//8991 
f 8962//8991 8970//8991 8968//8991 
f 8943//8991 8950//8991 8948//8991 
f 8950//8991 8943//8991 8972//8991 
f 8958//8991 8956//8991 8954//8991 
f 8964//8991 8962//8991 8968//8991 
f 8972//8991 8970//8991 8960//8991 
f 8980//8991 8976//8991 8974//8991 
f 8954//8991 8952//8991 8960//8991 
f 8944//8991 8943//8991 8948//8991 
f 8972//8991 8981//8991 8980//8991 
f 8962//8991 8960//8991 8970//8991 
f 8972//8991 8943//8991 8981//8991 
f 8974//8991 8972//8991 8980//8991 
f 8952//8991 8950//8991 8960//8991 
o mesh413
f 8977//8992 8976//8992 8980//8992 
f 8980//8992 8978//8992 8977//8992 
o mesh414
f 8978//8993 8980//8993 8981//8993 
f 8981//8993 8979//8993 8978//8993 
o mesh415
f 8979//8992 8981//8992 8943//8992 
f 8943//8992 8942//8992 8979//8992 
g bearing
v -0.0637211 -0.00989681 -0.0966911 
v -0.0636627 -0.00935938 -0.0966911 
v -0.0636627 -0.00935938 -0.106891 
v -0.0638937 -0.0104091 -0.0966911 
v -0.0637211 -0.00989681 -0.106891 
v -0.0641724 -0.0108723 -0.0966911 
v -0.0638937 -0.0104091 -0.106891 
v -0.0645442 -0.0112648 -0.0966911 
v -0.0641724 -0.0108723 -0.106891 
v -0.0649916 -0.0115682 -0.0966911 
v -0.0645442 -0.0112648 -0.106891 
v -0.0654938 -0.0117683 -0.0966911 
v -0.0649916 -0.0115682 -0.106891 
v -0.0660273 -0.0118557 -0.0966911 
v -0.0654938 -0.0117683 -0.106891 
v -0.0665671 -0.0118264 -0.0966911 
v -0.0660273 -0.0118557 -0.106891 
v -0.067088 -0.0116818 -0.0966911 
v -0.0665671 -0.0118264 -0.106891 
v -0.0675656 -0.0114286 -0.0966911 
v -0.067088 -0.0116818 -0.106891 
v -0.0679776 -0.0110786 -0.0966911 
v -0.0675656 -0.0114286 -0.106891 
v -0.0683048 -0.0106483 -0.0966911 
v -0.0679776 -0.0110786 -0.106891 
v -0.0685318 -0.0101576 -0.0966911 
v -0.0683048 -0.0106483 -0.106891 
v -0.068648 -0.00962968 -0.0966911 
v -0.0685318 -0.0101576 -0.106891 
v -0.068648 -0.00908908 -0.0966911 
v -0.068648 -0.00962968 -0.106891 
v -0.0685318 -0.00856113 -0.0966911 
v -0.068648 -0.00908908 -0.106891 
v -0.0683048 -0.0080705 -0.0966911 
v -0.0685318 -0.00856113 -0.106891 
v -0.0679776 -0.00764013 -0.0966911 
v -0.0683048 -0.0080705 -0.106891 
v -0.0675656 -0.00729016 -0.0966911 
v -0.0679776 -0.00764013 -0.106891 
v -0.067088 -0.00703694 -0.0966911 
v -0.0675656 -0.00729016 -0.106891 
v -0.0665671 -0.00689231 -0.0966911 
v -0.067088 -0.00703694 -0.106891 
v -0.0660273 -0.00686305 -0.0966911 
v -0.0665671 -0.00689231 -0.106891 
v -0.0654938 -0.00695051 -0.0966911 
v -0.0660273 -0.00686305 -0.106891 
v -0.0649916 -0.0071506 -0.0966911 
v -0.0654938 -0.00695051 -0.106891 
v -0.0645442 -0.00745398 -0.0966911 
v -0.0649916 -0.0071506 -0.106891 
v -0.0641724 -0.00784645 -0.0966911 
v -0.0645442 -0.00745398 -0.106891 
v -0.0638937 -0.00830966 -0.0966911 
v -0.0641724 -0.00784645 -0.106891 
v -0.0637211 -0.00882196 -0.0966911 
v -0.0638937 -0.00830966 -0.106891 
v -0.0637211 -0.00882196 -0.106891 
v -0.072987 -0.00289501 -0.106891 
v -0.0714378 -0.0015791 -0.106891 
v -0.0742171 -0.00451317 -0.106891 
v -0.0656538 2.68329e-05 -0.106891 
v -0.0636479 -0.000302011 -0.106891 
v -0.069642 -0.000627 -0.106891 
v -0.0676834 -8.32119e-05 -0.106891 
v -0.0600772 -0.00219506 -0.106891 
v -0.0586794 -0.00367074 -0.106891 
v -0.0569824 -0.00733866 -0.106891 
v -0.0567627 -0.00935938 -0.106891 
v -0.0617596 -0.00105437 -0.106891 
v -0.0569824 -0.0113801 -0.106891 
v -0.0576315 -0.00541242 -0.106891 
v -0.072987 -0.0158238 -0.106891 
v -0.0742171 -0.0142056 -0.106891 
v -0.0714378 -0.0171397 -0.106891 
v -0.0750706 -0.00635795 -0.106891 
v -0.0576315 -0.0133063 -0.106891 
v -0.0586794 -0.015048 -0.106891 
v -0.0600772 -0.0165237 -0.106891 
v -0.0617596 -0.0176644 -0.106891 
v -0.0636479 -0.0184168 -0.106891 
v -0.0656538 -0.0187456 -0.106891 
v -0.0750706 -0.0123608 -0.106891 
v -0.0755076 -0.0103757 -0.106891 
v -0.0755076 -0.00834306 -0.106891 
v -0.0676834 -0.0186356 -0.106891 
v -0.069642 -0.0180918 -0.106891 
v -0.0541627 -0.00935938 -0.104291 
v -0.0544432 -0.00677974 -0.104291 
v -0.0552718 -0.00432071 -0.104291 
v -0.0566095 -0.00209729 -0.104291 
v -0.058394 -0.000213437 -0.104291 
v -0.0605418 0.00124276 -0.104291 
v -0.0629523 0.00220322 -0.104291 
v -0.065513 0.00262302 -0.104291 
v -0.068104 0.00248254 -0.104291 
v -0.0706043 0.00178834 -0.104291 
v -0.0728969 0.000572887 -0.104291 
v -0.0748746 -0.00110699 -0.104291 
v -0.0764449 -0.00317273 -0.104291 
v -0.0775345 -0.00552776 -0.104291 
v -0.0780923 -0.00806195 -0.104291 
v -0.0780923 -0.0106568 -0.104291 
v -0.0775345 -0.013191 -0.104291 
v -0.0764449 -0.015546 -0.104291 
v -0.0748746 -0.0176118 -0.104291 
v -0.0728969 -0.0192916 -0.104291 
v -0.0706043 -0.0205071 -0.104291 
v -0.068104 -0.0212013 -0.104291 
v -0.065513 -0.0213418 -0.104291 
v -0.0629523 -0.020922 -0.104291 
v -0.0605418 -0.0199615 -0.104291 
v -0.058394 -0.0185053 -0.104291 
v -0.0566095 -0.0166215 -0.104291 
v -0.0552718 -0.0143981 -0.104291 
v -0.0544432 -0.011939 -0.104291 
v -0.0545119 -0.00679486 -0.0992911 
v -0.054233 -0.00806195 -0.0992911 
v -0.0553356 -0.00435025 -0.0992911 
v -0.0547908 -0.00552776 -0.0992911 
v -0.0566655 -0.00213986 -0.0992911 
v -0.0558804 -0.00317273 -0.0992911 
v -0.0584396 -0.00026705 -0.0992911 
v -0.0574507 -0.00110699 -0.0992911 
v -0.0605747 0.00118061 -0.0992911 
v -0.0594284 0.000572887 -0.0992911 
v -0.0629711 0.00213544 -0.0992911 
v -0.061721 0.00178834 -0.0992911 
v -0.0655168 0.00255278 -0.0992911 
v -0.0642213 0.00248254 -0.0992911 
v -0.0680927 0.00241312 -0.0992911 
v -0.0668123 0.00262302 -0.0992911 
v -0.0705783 0.00172299 -0.0992911 
v -0.069373 0.00220322 -0.0992911 
v -0.0728574 0.000514663 -0.0992911 
v -0.0717836 0.00124276 -0.0992911 
v -0.0739313 -0.000213437 -0.0992911 
v -0.0748235 -0.00115536 -0.0992911 
v -0.0757158 -0.00209729 -0.0992911 
v -0.0763847 -0.003209 -0.0992911 
v -0.0770536 -0.00432071 -0.0992911 
v -0.0774678 -0.00555022 -0.0992911 
v -0.0780224 -0.00806956 -0.0992911 
v -0.0778821 -0.00677974 -0.0992911 
v -0.0780224 -0.0106492 -0.0992911 
v -0.0781627 -0.00935938 -0.0992911 
v -0.0774678 -0.0131685 -0.0992911 
v -0.0778821 -0.011939 -0.0992911 
v -0.0763847 -0.0155098 -0.0992911 
v -0.0770536 -0.0143981 -0.0992911 
v -0.0748235 -0.0175634 -0.0992911 
v -0.0757158 -0.0166215 -0.0992911 
v -0.0728574 -0.0192334 -0.0992911 
v -0.0739313 -0.0185053 -0.0992911 
v -0.0705783 -0.0204418 -0.0992911 
v -0.0717836 -0.0199615 -0.0992911 
v -0.0680927 -0.0211319 -0.0992911 
v -0.069373 -0.020922 -0.0992911 
v -0.0655168 -0.0212715 -0.0992911 
v -0.0668123 -0.0213418 -0.0992911 
v -0.0629711 -0.0208542 -0.0992911 
v -0.0642213 -0.0212013 -0.0992911 
v -0.0605747 -0.0198994 -0.0992911 
v -0.061721 -0.0205071 -0.0992911 
v -0.0584396 -0.0184517 -0.0992911 
v -0.0594284 -0.0192916 -0.0992911 
v -0.0566655 -0.0165789 -0.0992911 
v -0.0574507 -0.0176118 -0.0992911 
v -0.0553356 -0.0143685 -0.0992911 
v -0.0558804 -0.015546 -0.0992911 
v -0.0545119 -0.0119239 -0.0992911 
v -0.0547908 -0.013191 -0.0992911 
v -0.0541627 -0.00935938 -0.0992911 
v -0.054233 -0.0106568 -0.0992911 
v -0.0753429 -0.00733866 -0.0966911 
v -0.0755627 -0.00935938 -0.0966911 
v -0.0746939 -0.00541242 -0.0966911 
v -0.0736459 -0.00367074 -0.0966911 
v -0.0722481 -0.00219506 -0.0966911 
v -0.0705657 -0.00105437 -0.0966911 
v -0.0686774 -0.000302011 -0.0966911 
v -0.0666716 2.68329e-05 -0.0966911 
v -0.0646419 -8.32119e-05 -0.0966911 
v -0.0626834 -0.000627 -0.0966911 
v -0.0608875 -0.0015791 -0.0966911 
v -0.0593383 -0.00289501 -0.0966911 
v -0.0581082 -0.00451317 -0.0966911 
v -0.0572547 -0.00635795 -0.0966911 
v -0.0568178 -0.00834306 -0.0966911 
v -0.0567627 -0.00935938 -0.0966911 
v -0.0568178 -0.0103757 -0.0966911 
v -0.0572547 -0.0123608 -0.0966911 
v -0.0581082 -0.0142056 -0.0966911 
v -0.0593383 -0.0158238 -0.0966911 
v -0.0608875 -0.0171397 -0.0966911 
v -0.0626834 -0.0180918 -0.0966911 
v -0.0646419 -0.0186356 -0.0966911 
v -0.0666716 -0.0187456 -0.0966911 
v -0.0686774 -0.0184168 -0.0966911 
v -0.0705657 -0.0176644 -0.0966911 
v -0.0722481 -0.0165237 -0.0966911 
v -0.0736459 -0.015048 -0.0966911 
v -0.0746939 -0.0133063 -0.0966911 
v -0.0753429 -0.0113801 -0.0966911 
vn -0.977075 0.192655 -0.0905984 
vn -0.995875 -0.00874235 -0.0903167 
vn -0.917621 0.386871 -0.0911188 
vn -0.977075 0.192655 -0.0905984 
vn -0.819218 0.566076 -0.091865 
vn -0.917621 0.386871 -0.0911188 
vn -0.684962 0.722643 -0.0928173 
vn -0.819218 0.566076 -0.091865 
vn -0.519403 0.849349 -0.0939476 
vn -0.684962 0.722643 -0.0928173 
vn -0.328608 0.939654 -0.0952181 
vn -0.519403 0.849349 -0.0939476 
vn -0.120164 0.988045 -0.0965808 
vn -0.328608 0.939654 -0.0952181 
vn 0.0968904 0.990461 -0.0979765 
vn -0.120164 0.988045 -0.0965808 
vn 0.312292 0.944778 -0.0993366 
vn 0.0968904 0.990461 -0.0979765 
vn 0.514963 0.85129 -0.100586 
vn 0.312292 0.944778 -0.0993366 
vn 0.693649 0.713105 -0.101647 
vn 0.514963 0.85129 -0.100586 
vn 0.837768 0.53633 -0.102448 
vn 0.693649 0.713105 -0.101647 
vn 0.938373 0.329943 -0.102931 
vn 0.837768 0.53633 -0.102448 
vn 0.98909 0.105264 -0.103059 
vn 0.938373 0.329943 -0.102931 
vn 0.986823 -0.124928 -0.102823 
vn 0.98909 0.105264 -0.103059 
vn 0.932081 -0.347523 -0.10224 
vn 0.986823 -0.124928 -0.102823 
vn 0.828836 -0.550234 -0.101355 
vn 0.932081 -0.347523 -0.10224 
vn 0.683987 -0.722576 -0.100231 
vn 0.828836 -0.550234 -0.101355 
vn 0.50654 -0.856521 -0.0989405 
vn 0.683987 -0.722576 -0.100231 
vn 0.306714 -0.946788 -0.0975621 
vn 0.50654 -0.856521 -0.0989405 
vn 0.0951034 -0.990811 -0.0961694 
vn 0.306714 -0.946788 -0.0975621 
vn -0.117984 -0.988477 -0.0948285 
vn 0.0951034 -0.990811 -0.0961694 
vn -0.323006 -0.941757 -0.0935951 
vn -0.117984 -0.988477 -0.0948285 
vn -0.511479 -0.854301 -0.0925143 
vn -0.323006 -0.941757 -0.0935951 
vn -0.676131 -0.731063 -0.0916207 
vn -0.511479 -0.854301 -0.0925143 
vn -0.810968 -0.57798 -0.0909398 
vn -0.676131 -0.731063 -0.0916207 
vn -0.911282 -0.401716 -0.0904893 
vn -0.810968 -0.57798 -0.0909398 
vn -0.973642 -0.209456 -0.09028 
vn -0.911282 -0.401716 -0.0904893 
vn -0.0602177 -0.0085184 -0.998149 
vn 0.623426 -0.00910358 -0.781829 
vn 0.607535 0.138792 -0.782073 
vn 0.559042 0.27928 -0.780689 
vn 0.480673 0.405008 -0.777767 
vn 0.376844 0.509605 -0.773493 
vn 0.25329 0.588069 -0.768127 
vn 0.116609 0.637014 -0.761981 
vn -0.0262016 0.654752 -0.75539 
vn -0.168181 0.641233 -0.748689 
vn -0.30276 0.5979 -0.742194 
vn -0.424039 0.527464 -0.736188 
vn -0.52697 0.433672 -0.730912 
vn -0.607476 0.321062 -0.726562 
vn -0.662513 0.194745 -0.723292 
vn -0.690098 0.0601986 -0.721208 
vn -0.689304 -0.0769055 -0.720379 
vn -0.660258 -0.210868 -0.720829 
vn -0.604117 -0.336114 -0.722545 
vn -0.523048 -0.447339 -0.725472 
vn -0.420195 -0.539671 -0.729514 
vn -0.299635 -0.608834 -0.734534 
vn -0.166306 -0.651329 -0.740346 
vn -0.025901 -0.66463 -0.746724 
vn 0.115295 -0.647382 -0.753395 
vn 0.250627 -0.599588 -0.760053 
vn 0.373372 -0.522757 -0.766367 
vn 0.477108 -0.419983 -0.771999 
vn 0.556134 -0.295913 -0.776628 
vn 0.605906 -0.156584 -0.779974 
vn 0.970243 0.219113 -0.10304 
vn 0.98909 0.105264 -0.103059 
vn 0.994633 -0.0099687 -0.102986 
vn 0.893978 0.436176 -0.102732 
vn 0.938373 0.329943 -0.102931 
vn 0.770638 0.629043 -0.102084 
vn 0.837768 0.53633 -0.102448 
vn 0.607992 0.787474 -0.101144 
vn 0.693649 0.713105 -0.101647 
vn 0.415927 0.903885 -0.0999799 
vn 0.514963 0.85129 -0.100586 
vn 0.205478 0.973676 -0.0986656 
vn 0.312292 0.944778 -0.0993366 
vn -0.0120968 0.995184 -0.0972786 
vn 0.0968904 0.990461 -0.0979765 
vn -0.226059 0.969382 -0.0958914 
vn -0.120164 0.988045 -0.0965808 
vn -0.426721 0.899425 -0.0945681 
vn -0.328608 0.939654 -0.0952181 
vn -0.605752 0.790157 -0.0933623 
vn -0.519403 0.849349 -0.0939476 
vn -0.756322 0.647653 -0.092317 
vn -0.684962 0.722643 -0.0928173 
vn -0.873128 0.478833 -0.0914647 
vn -0.819218 0.566076 -0.091865 
vn -0.952355 0.291152 -0.0908294 
vn -0.917621 0.386871 -0.0911188 
vn -0.991611 0.0923617 -0.0904272 
vn -0.977075 0.192655 -0.0905984 
vn -0.98986 -0.109674 -0.0902675 
vn -0.995875 -0.00874235 -0.0903167 
vn -0.947372 -0.307121 -0.0903541 
vn -0.973642 -0.209456 -0.09028 
vn -0.865685 -0.492307 -0.090685 
vn -0.911282 -0.401716 -0.0904893 
vn -0.7476 -0.65785 -0.0912524 
vn -0.810968 -0.57798 -0.0909398 
vn -0.597187 -0.796804 -0.0920423 
vn -0.676131 -0.731063 -0.0916207 
vn -0.419795 -0.902838 -0.0930332 
vn -0.511479 -0.854301 -0.0925143 
vn -0.222061 -0.970472 -0.0941953 
vn -0.323006 -0.941757 -0.0935951 
vn -0.0118742 -0.99536 -0.0954888 
vn -0.117984 -0.988477 -0.0948285 
vn 0.201724 -0.974641 -0.0968632 
vn 0.0951034 -0.990811 -0.0961694 
vn 0.408762 -0.907336 -0.0982575 
vn 0.306714 -0.946788 -0.0975621 
vn 0.598718 -0.794743 -0.0996014 
vn 0.50654 -0.856521 -0.0989405 
vn 0.761088 -0.640766 -0.100818 
vn 0.683987 -0.722576 -0.100231 
vn 0.88615 -0.452071 -0.101832 
vn 0.828836 -0.550234 -0.101355 
vn 0.96584 -0.237975 -0.102573 
vn 0.932081 -0.347523 -0.10224 
vn 0.994633 -0.0099687 -0.102986 
vn 0.986823 -0.124928 -0.102823 
vn -0.770096 0.145166 0.621191 
vn -0.781467 0.068169 0.620211 
vn -0.784877 -0.00949988 0.619579 
vn -0.723858 0.294023 0.624163 
vn -0.750844 0.220709 0.622511 
vn -0.64763 0.430902 0.62841 
vn -0.689358 0.364338 0.626134 
vn -0.544009 0.549861 0.633804 
vn -0.599036 0.492979 0.630973 
vn -0.416747 0.645373 0.640169 
vn -0.483053 0.600871 0.636878 
vn -0.270752 0.71255 0.647275 
vn -0.34574 0.682777 0.643646 
vn -0.112046 0.747415 0.65484 
vn -0.192571 0.734227 0.65102 
vn 0.0523524 0.747205 0.662528 
vn -0.0300857 0.751811 0.658692 
vn 0.214641 0.710691 0.66996 
vn 0.13427 0.733495 0.666301 
vn 0.366581 0.638474 0.676734 
vn 0.292425 0.67893 0.673455 
vn 0.499965 0.533197 0.682448 
vn 0.436088 0.58972 0.679748 
vn 0.607212 0.399604 0.686739 
vn 0.557288 0.469563 0.684792 
vn 0.681992 0.244395 0.689317 
vn 0.64899 0.324215 0.688256 
vn 0.719824 0.0758397 0.690001 
vn 0.705721 0.161223 0.689902 
vn 0.718512 -0.0968221 0.688743 
vn 0.724102 -0.0105737 0.689612 
vn 0.678346 -0.264114 0.685632 
vn 0.70317 -0.18172 0.687408 
vn 0.602034 -0.417076 0.680883 
vn 0.644452 -0.342907 0.683444 
vn 0.494372 -0.547925 0.674814 
vn 0.551754 -0.485691 0.677991 
vn 0.361742 -0.650525 0.667802 
vn 0.430733 -0.603067 0.671401 
vn 0.211531 -0.72064 0.660252 
vn 0.288349 -0.689831 0.664069 
vn 0.0515649 -0.755978 0.652563 
vn 0.132275 -0.742725 0.656401 
vn -0.11038 -0.756082 0.645102 
vn -0.0296331 -0.760397 0.648783 
vn -0.266951 -0.722117 0.638188 
vn -0.189772 -0.743229 0.641558 
vn -0.411488 -0.656612 0.63209 
vn -0.341108 -0.693103 0.635023 
vn -0.538187 -0.563205 0.627021 
vn -0.477393 -0.613133 0.629416 
vn -0.642201 -0.446399 0.623142 
vn -0.593294 -0.507417 0.624925 
vn -0.719689 -0.311359 0.620567 
vn -0.684461 -0.380815 0.621686 
vn -0.767837 -0.163733 0.619369 
vn -0.747565 -0.238752 0.619793 
vn -0.780315 -0.0870596 0.619297 
vn -0.784877 -0.00949988 0.619579 
vn -0.0730452 -0.010333 0.997275 
usemtl 0.400000_0.400000_0.400000_0.000000_0.000000
o mesh3
f 8982//8994 8983//8995 8984//8995 
f 8985//8996 8982//8994 8986//8997 
f 8987//8998 8985//8996 8988//8999 
f 8989//9000 8987//8998 8990//9001 
f 8991//9002 8989//9000 8992//9003 
f 8993//9004 8991//9002 8994//9005 
f 8995//9006 8993//9004 8996//9007 
f 8997//9008 8995//9006 8998//9009 
f 8999//9010 8997//9008 9000//9011 
f 9001//9012 8999//9010 9002//9013 
f 9003//9014 9001//9012 9004//9015 
f 9005//9016 9003//9014 9006//9017 
f 9007//9018 9005//9016 9008//9019 
f 9009//9020 9007//9018 9010//9021 
f 9011//9022 9009//9020 9012//9023 
f 9013//9024 9011//9022 9014//9025 
f 9015//9026 9013//9024 9016//9027 
f 9017//9028 9015//9026 9018//9029 
f 9019//9030 9017//9028 9020//9031 
f 9021//9032 9019//9030 9022//9033 
f 9023//9034 9021//9032 9024//9035 
f 9025//9036 9023//9034 9026//9037 
f 9027//9038 9025//9036 9028//9039 
f 9029//9040 9027//9038 9030//9041 
f 9031//9042 9029//9040 9032//9043 
f 9033//9044 9031//9042 9034//9045 
f 9035//9046 9033//9044 9036//9047 
f 9037//9048 9035//9046 9038//9049 
f 8983//8995 9037//9048 9039//9048 
f 9039//9048 8984//8995 8983//8995 
f 9038//9049 9039//9048 9037//9048 
f 9036//9047 9038//9049 9035//9046 
f 9034//9045 9036//9047 9033//9044 
f 9032//9043 9034//9045 9031//9042 
f 9030//9041 9032//9043 9029//9040 
f 9028//9039 9030//9041 9027//9038 
f 9026//9037 9028//9039 9025//9036 
f 9024//9035 9026//9037 9023//9034 
f 9022//9033 9024//9035 9021//9032 
f 9020//9031 9022//9033 9019//9030 
f 9018//9029 9020//9031 9017//9028 
f 9016//9027 9018//9029 9015//9026 
f 9014//9025 9016//9027 9013//9024 
f 9012//9023 9014//9025 9011//9022 
f 9010//9021 9012//9023 9009//9020 
f 9008//9019 9010//9021 9007//9018 
f 9006//9017 9008//9019 9005//9016 
f 9004//9015 9006//9017 9003//9014 
f 9002//9013 9004//9015 9001//9012 
f 9000//9011 9002//9013 8999//9010 
f 8998//9009 9000//9011 8997//9008 
f 8996//9007 8998//9009 8995//9006 
f 8994//9005 8996//9007 8993//9004 
f 8992//9003 8994//9005 8991//9002 
f 8990//9001 8992//9003 8989//9000 
f 8988//8999 8990//9001 8987//8998 
f 8986//8997 8988//8999 8985//8996 
f 8984//8995 8986//8997 8982//8994 
o mesh4
f 9040//9050 9020//9050 9018//9050 
f 9040//9050 9041//9050 9022//9050 
f 9042//9050 9018//9050 9016//9050 
f 9022//9050 9020//9050 9040//9050 
f 9043//9050 9028//9050 9026//9050 
f 9043//9050 9044//9050 9030//9050 
f 9018//9050 9042//9050 9040//9050 
f 9041//9050 9045//9050 9024//9050 
f 9046//9050 9026//9050 9024//9050 
f 9030//9050 9028//9050 9043//9050 
f 9047//9050 9034//9050 9032//9050 
f 9047//9050 9048//9050 9036//9050 
f 9049//9050 9039//9050 9038//9050 
f 9050//9050 8984//9050 9039//9050 
f 9024//9050 9022//9050 9041//9050 
f 9026//9050 9046//9050 9043//9050 
f 9051//9050 9032//9050 9030//9050 
f 9036//9050 9034//9050 9047//9050 
f 9039//9050 9049//9050 9050//9050 
f 9052//9050 8986//9050 8984//9050 
f 9024//9050 9045//9050 9046//9050 
f 9032//9050 9051//9050 9047//9050 
f 9053//9050 9038//9050 9036//9050 
f 8984//9050 9050//9050 9052//9050 
f 9054//9050 9006//9050 9004//9050 
f 9055//9050 9008//9050 9006//9050 
f 9030//9050 9044//9050 9051//9050 
f 9038//9050 9053//9050 9049//9050 
f 9056//9050 9004//9050 9002//9050 
f 9006//9050 9054//9050 9055//9050 
f 9057//9050 9016//9050 9014//9050 
f 9036//9050 9048//9050 9053//9050 
f 9058//9050 8988//9050 8986//9050 
f 9059//9050 8990//9050 8988//9050 
f 9060//9050 8992//9050 8990//9050 
f 9061//9050 8994//9050 8992//9050 
f 9062//9050 8996//9050 8994//9050 
f 9062//9050 9063//9050 8998//9050 
f 9004//9050 9056//9050 9054//9050 
f 9064//9050 9010//9050 9008//9050 
f 9065//9050 9012//9050 9010//9050 
f 9066//9050 9014//9050 9012//9050 
f 9016//9050 9057//9050 9042//9050 
f 8988//9050 9058//9050 9059//9050 
f 8992//9050 9060//9050 9061//9050 
f 8998//9050 8996//9050 9062//9050 
f 9067//9050 9000//9050 8998//9050 
f 9068//9050 9002//9050 9000//9050 
f 9008//9050 9055//9050 9064//9050 
f 9012//9050 9065//9050 9066//9050 
f 8986//9050 9052//9050 9058//9050 
f 8994//9050 9061//9050 9062//9050 
f 9000//9050 9067//9050 9068//9050 
f 9010//9050 9064//9050 9065//9050 
f 8990//9050 9059//9050 9060//9050 
f 9002//9050 9068//9050 9056//9050 
f 8998//9050 9063//9050 9067//9050 
f 9014//9050 9066//9050 9057//9050 
o mesh5
f 9069//9051 9050//9051 9049//9052 
f 9070//9052 9049//9052 9053//9053 
f 9071//9053 9053//9053 9048//9054 
f 9072//9054 9048//9054 9047//9055 
f 9073//9055 9047//9055 9051//9056 
f 9074//9056 9051//9056 9044//9057 
f 9075//9057 9044//9057 9043//9058 
f 9076//9058 9043//9058 9046//9059 
f 9077//9059 9046//9059 9045//9060 
f 9078//9060 9045//9060 9041//9061 
f 9079//9061 9041//9061 9040//9062 
f 9080//9062 9040//9062 9042//9063 
f 9081//9063 9042//9063 9057//9064 
f 9082//9064 9057//9064 9066//9065 
f 9083//9065 9066//9065 9065//9066 
f 9084//9066 9065//9066 9064//9067 
f 9085//9067 9064//9067 9055//9068 
f 9086//9068 9055//9068 9054//9069 
f 9087//9069 9054//9069 9056//9070 
f 9088//9070 9056//9070 9068//9071 
f 9089//9071 9068//9071 9067//9072 
f 9090//9072 9067//9072 9063//9073 
f 9091//9073 9063//9073 9062//9074 
f 9092//9074 9062//9074 9061//9075 
f 9093//9075 9061//9075 9060//9076 
f 9094//9076 9060//9076 9059//9077 
f 9095//9077 9059//9077 9058//9078 
f 9096//9078 9058//9078 9052//9079 
f 9097//9079 9052//9079 9050//9051 
f 9050//9051 9069//9051 9097//9079 
f 9052//9079 9097//9079 9096//9078 
f 9058//9078 9096//9078 9095//9077 
f 9059//9077 9095//9077 9094//9076 
f 9060//9076 9094//9076 9093//9075 
f 9061//9075 9093//9075 9092//9074 
f 9062//9074 9092//9074 9091//9073 
f 9063//9073 9091//9073 9090//9072 
f 9067//9072 9090//9072 9089//9071 
f 9068//9071 9089//9071 9088//9070 
f 9056//9070 9088//9070 9087//9069 
f 9054//9069 9087//9069 9086//9068 
f 9055//9068 9086//9068 9085//9067 
f 9064//9067 9085//9067 9084//9066 
f 9065//9066 9084//9066 9083//9065 
f 9066//9065 9083//9065 9082//9064 
f 9057//9064 9082//9064 9081//9063 
f 9042//9063 9081//9063 9080//9062 
f 9040//9062 9080//9062 9079//9061 
f 9041//9061 9079//9061 9078//9060 
f 9045//9060 9078//9060 9077//9059 
f 9046//9059 9077//9059 9076//9058 
f 9043//9058 9076//9058 9075//9057 
f 9044//9057 9075//9057 9074//9056 
f 9051//9056 9074//9056 9073//9055 
f 9047//9055 9073//9055 9072//9054 
f 9048//9054 9072//9054 9071//9053 
f 9053//9053 9071//9053 9070//9052 
f 9049//9052 9070//9052 9069//9051 
o mesh6
f 9070//9080 9098//9080 9099//9081 
f 9099//9081 9069//9082 9070//9080 
f 9071//9083 9100//9083 9101//9084 
f 9101//9084 9070//9080 9071//9083 
f 9072//9085 9102//9085 9103//9086 
f 9103//9086 9071//9083 9072//9085 
f 9073//9087 9104//9087 9105//9088 
f 9105//9088 9072//9085 9073//9087 
f 9074//9089 9106//9089 9107//9090 
f 9107//9090 9073//9087 9074//9089 
f 9075//9091 9108//9091 9109//9092 
f 9109//9092 9074//9089 9075//9091 
f 9076//9093 9110//9093 9111//9094 
f 9111//9094 9075//9091 9076//9093 
f 9077//9095 9112//9095 9113//9096 
f 9113//9096 9076//9093 9077//9095 
f 9078//9097 9114//9097 9115//9098 
f 9115//9098 9077//9095 9078//9097 
f 9079//9099 9116//9099 9117//9100 
f 9117//9100 9078//9097 9079//9099 
f 9079//9099 9080//9101 9118//9102 
f 9080//9101 9119//9101 9118//9102 
f 9080//9101 9081//9103 9120//9104 
f 9081//9103 9121//9103 9120//9104 
f 9081//9103 9082//9105 9122//9106 
f 9082//9105 9123//9105 9122//9106 
f 9083//9107 9124//9107 9125//9108 
f 9125//9108 9082//9105 9083//9107 
f 9084//9109 9126//9109 9127//9110 
f 9127//9110 9083//9107 9084//9109 
f 9085//9111 9128//9111 9129//9112 
f 9129//9112 9084//9109 9085//9111 
f 9086//9113 9130//9113 9131//9114 
f 9131//9114 9085//9111 9086//9113 
f 9087//9115 9132//9115 9133//9116 
f 9133//9116 9086//9113 9087//9115 
f 9088//9117 9134//9117 9135//9118 
f 9135//9118 9087//9115 9088//9117 
f 9089//9119 9136//9119 9137//9120 
f 9137//9120 9088//9117 9089//9119 
f 9090//9121 9138//9121 9139//9122 
f 9139//9122 9089//9119 9090//9121 
f 9091//9123 9140//9123 9141//9124 
f 9141//9124 9090//9121 9091//9123 
f 9092//9125 9142//9125 9143//9126 
f 9143//9126 9091//9123 9092//9125 
f 9093//9127 9144//9127 9145//9128 
f 9145//9128 9092//9125 9093//9127 
f 9094//9129 9146//9129 9147//9130 
f 9147//9130 9093//9127 9094//9129 
f 9095//9131 9148//9131 9149//9132 
f 9149//9132 9094//9129 9095//9131 
f 9096//9133 9150//9133 9151//9134 
f 9151//9134 9095//9131 9096//9133 
f 9097//9135 9152//9135 9153//9136 
f 9153//9136 9096//9133 9097//9135 
f 9069//9082 9154//9137 9155//9138 
f 9155//9138 9097//9135 9069//9082 
f 9155//9138 9152//9135 9097//9135 
f 9153//9136 9150//9133 9096//9133 
f 9151//9134 9148//9131 9095//9131 
f 9149//9132 9146//9129 9094//9129 
f 9147//9130 9144//9127 9093//9127 
f 9145//9128 9142//9125 9092//9125 
f 9143//9126 9140//9123 9091//9123 
f 9141//9124 9138//9121 9090//9121 
f 9139//9122 9136//9119 9089//9119 
f 9137//9120 9134//9117 9088//9117 
f 9135//9118 9132//9115 9087//9115 
f 9133//9116 9130//9113 9086//9113 
f 9131//9114 9128//9111 9085//9111 
f 9129//9112 9126//9109 9084//9109 
f 9127//9110 9124//9107 9083//9107 
f 9125//9108 9123//9105 9082//9105 
f 9122//9106 9121//9103 9081//9103 
f 9120//9104 9119//9101 9080//9101 
f 9118//9102 9116//9099 9079//9099 
f 9117//9100 9114//9097 9078//9097 
f 9115//9098 9112//9095 9077//9095 
f 9113//9096 9110//9093 9076//9093 
f 9111//9094 9108//9091 9075//9091 
f 9109//9092 9106//9089 9074//9089 
f 9107//9090 9104//9087 9073//9087 
f 9105//9088 9102//9085 9072//9085 
f 9103//9086 9100//9083 9071//9083 
f 9101//9084 9098//9080 9070//9080 
f 9099//9081 9154//9137 9069//9082 
o mesh7
f 9156//9139 9125//9139 9124//9140 
f 9124//9140 9157//9141 9156//9139 
f 9158//9142 9122//9142 9123//9143 
f 9123//9143 9156//9139 9158//9142 
f 9159//9144 9120//9144 9121//9145 
f 9121//9145 9158//9142 9159//9144 
f 9160//9146 9118//9146 9119//9147 
f 9119//9147 9159//9144 9160//9146 
f 9161//9148 9117//9148 9116//9149 
f 9116//9149 9160//9146 9161//9148 
f 9162//9150 9115//9150 9114//9151 
f 9114//9151 9161//9148 9162//9150 
f 9163//9152 9113//9152 9112//9153 
f 9112//9153 9162//9150 9163//9152 
f 9164//9154 9111//9154 9110//9155 
f 9110//9155 9163//9152 9164//9154 
f 9165//9156 9109//9156 9108//9157 
f 9108//9157 9164//9154 9165//9156 
f 9166//9158 9107//9158 9106//9159 
f 9106//9159 9165//9156 9166//9158 
f 9167//9160 9105//9160 9104//9161 
f 9104//9161 9166//9158 9167//9160 
f 9168//9162 9103//9162 9102//9163 
f 9102//9163 9167//9160 9168//9162 
f 9169//9164 9101//9164 9100//9165 
f 9100//9165 9168//9162 9169//9164 
f 9170//9166 9099//9166 9098//9167 
f 9098//9167 9169//9164 9170//9166 
f 9155//9168 9154//9169 9171//9169 
f 9099//9166 9170//9166 9171//9169 
f 9171//9169 9154//9169 9099//9166 
f 9172//9168 9173//9170 9152//9171 
f 9173//9170 9153//9170 9152//9171 
f 9173//9170 9174//9172 9150//9173 
f 9174//9172 9151//9172 9150//9173 
f 9174//9172 9175//9174 9148//9175 
f 9175//9174 9149//9174 9148//9175 
f 9176//9176 9147//9176 9146//9177 
f 9146//9177 9175//9174 9176//9176 
f 9177//9178 9145//9178 9144//9179 
f 9144//9179 9176//9176 9177//9178 
f 9178//9180 9143//9180 9142//9181 
f 9142//9181 9177//9178 9178//9180 
f 9179//9182 9141//9182 9140//9183 
f 9140//9183 9178//9180 9179//9182 
f 9180//9184 9139//9184 9138//9185 
f 9138//9185 9179//9182 9180//9184 
f 9181//9186 9137//9186 9136//9187 
f 9136//9187 9180//9184 9181//9186 
f 9182//9188 9135//9188 9134//9189 
f 9134//9189 9181//9186 9182//9188 
f 9182//9188 9183//9190 9132//9191 
f 9183//9190 9133//9190 9132//9191 
f 9184//9192 9131//9192 9130//9193 
f 9130//9193 9183//9190 9184//9192 
f 9185//9194 9129//9194 9128//9195 
f 9128//9195 9184//9192 9185//9194 
f 9185//9194 9157//9141 9126//9196 
f 9157//9141 9127//9197 9126//9196 
f 9126//9196 9129//9194 9185//9194 
f 9128//9195 9131//9192 9184//9192 
f 9130//9193 9133//9190 9183//9190 
f 9132//9191 9135//9188 9182//9188 
f 9134//9189 9137//9186 9181//9186 
f 9136//9187 9139//9184 9180//9184 
f 9138//9185 9141//9182 9179//9182 
f 9140//9183 9143//9180 9178//9180 
f 9142//9181 9145//9178 9177//9178 
f 9144//9179 9147//9176 9176//9176 
f 9146//9177 9149//9174 9175//9174 
f 9148//9175 9151//9172 9174//9172 
f 9150//9173 9153//9170 9173//9170 
f 9152//9171 9155//9168 9172//9168 
f 9171//9169 9172//9168 9155//9168 
f 9098//9167 9101//9164 9169//9164 
f 9100//9165 9103//9162 9168//9162 
f 9102//9163 9105//9160 9167//9160 
f 9104//9161 9107//9158 9166//9158 
f 9106//9159 9109//9156 9165//9156 
f 9108//9157 9111//9154 9164//9154 
f 9110//9155 9113//9152 9163//9152 
f 9112//9153 9115//9150 9162//9150 
f 9114//9151 9117//9148 9161//9148 
f 9116//9149 9118//9146 9160//9146 
f 9119//9147 9120//9144 9159//9144 
f 9121//9145 9122//9142 9158//9142 
f 9123//9143 9125//9139 9156//9139 
f 9124//9140 9127//9197 9157//9141 
o mesh8
f 9170//9198 9169//9198 9037//9198 
f 8983//9198 9171//9198 9170//9198 
f 9169//9198 9168//9198 9035//9198 
f 9167//9198 9166//9198 9031//9198 
f 9166//9198 9165//9198 9029//9198 
f 9035//9198 9037//9198 9169//9198 
f 9168//9198 9167//9198 9033//9198 
f 9029//9198 9031//9198 9166//9198 
f 9165//9198 9164//9198 9027//9198 
f 9164//9198 9163//9198 9025//9198 
f 9163//9198 9162//9198 9023//9198 
f 9160//9198 9159//9198 9017//9198 
f 9159//9198 9158//9198 9015//9198 
f 9183//9198 9182//9198 9003//9198 
f 9182//9198 9181//9198 9001//9198 
f 9033//9198 9035//9198 9168//9198 
f 9027//9198 9029//9198 9165//9198 
f 9023//9198 9025//9198 9163//9198 
f 9162//9198 9161//9198 9021//9198 
f 9161//9198 9160//9198 9019//9198 
f 9015//9198 9017//9198 9159//9198 
f 9156//9198 9157//9198 9011//9198 
f 9157//9198 9185//9198 9009//9198 
f 9001//9198 9003//9198 9182//9198 
f 9181//9198 9180//9198 8999//9198 
f 9031//9198 9033//9198 9167//9198 
f 9021//9198 9023//9198 9162//9198 
f 9017//9198 9019//9198 9160//9198 
f 9158//9198 9156//9198 9013//9198 
f 9009//9198 9011//9198 9157//9198 
f 9185//9198 9184//9198 9007//9198 
f 9184//9198 9183//9198 9005//9198 
f 8999//9198 9001//9198 9181//9198 
f 9178//9198 9177//9198 8993//9198 
f 9177//9198 9176//9198 8991//9198 
f 9176//9198 9175//9198 8989//9198 
f 9175//9198 9174//9198 8987//9198 
f 9025//9198 9027//9198 9164//9198 
f 9013//9198 9015//9198 9158//9198 
f 9007//9198 9009//9198 9185//9198 
f 9003//9198 9005//9198 9183//9198 
f 8991//9198 8993//9198 9177//9198 
f 8987//9198 8989//9198 9175//9198 
f 9174//9198 9173//9198 8985//9198 
f 9173//9198 9172//9198 8982//9198 
f 9019//9198 9021//9198 9161//9198 
f 9005//9198 9007//9198 9184//9198 
f 9180//9198 9179//9198 8997//9198 
f 9179//9198 9178//9198 8995//9198 
f 8989//9198 8991//9198 9176//9198 
f 8982//9198 8985//9198 9173//9198 
f 9011//9198 9013//9198 9156//9198 
f 8995//9198 8997//9198 9179//9198 
f 8985//9198 8987//9198 9174//9198 
f 9172//9198 9171//9198 8983//9198 
f 8997//9198 8999//9198 9180//9198 
f 8983//9198 8982//9198 9172//9198 
f 8993//9198 8995//9198 9178//9198 
f 9037//9198 8983//9198 9170//9198 
g leadScrew
v -0.140074 0.0377995 -0.0536142 
v -0.140074 0.0367436 -0.0533818 
v -0.140074 0.0357623 -0.0529278 
v -0.140074 0.0349016 -0.0522735 
v -0.140074 0.0342017 -0.0514494 
v -0.140074 0.0336952 -0.0504942 
v -0.140074 0.033406 -0.0494524 
v -0.140074 0.0333474 -0.0483728 
v -0.140074 0.0335224 -0.0473059 
v -0.140074 0.0339225 -0.0463015 
v -0.140074 0.0345293 -0.0454066 
v -0.140074 0.0353142 -0.044663 
v -0.140074 0.0362407 -0.0441056 
v -0.140074 0.0372653 -0.0437604 
v -0.140074 0.0383401 -0.0436435 
v -0.140074 0.039415 -0.0437604 
v -0.140074 0.0404396 -0.0441056 
v -0.140074 0.041366 -0.044663 
v -0.140074 0.0421509 -0.0454066 
v -0.140074 0.0427577 -0.0463015 
v -0.140074 0.0431579 -0.0473059 
v -0.140074 0.0433328 -0.0483728 
v -0.140074 0.0432742 -0.0494524 
v -0.140074 0.042985 -0.0504942 
v -0.140074 0.0424786 -0.0514494 
v -0.140074 0.0417786 -0.0522735 
v -0.140074 0.0409179 -0.0529278 
v -0.140074 0.0399366 -0.0533818 
v -0.140074 0.0388807 -0.0536142 
v -0.140074 0.0383401 -0.0536435 
v -0.140074 0.0383401 -0.0486435 
v 0.159926 0.0383401 -0.0436435 
v 0.159926 0.0372653 -0.0437604 
v 0.159926 0.0362407 -0.0441056 
v 0.159926 0.0353142 -0.044663 
v 0.159926 0.0345293 -0.0454066 
v 0.159926 0.0339225 -0.0463015 
v 0.159926 0.0335224 -0.0473059 
v 0.159926 0.0333474 -0.0483728 
v 0.159926 0.033406 -0.0494524 
v 0.159926 0.0336952 -0.0504942 
v 0.159926 0.0342017 -0.0514494 
v 0.159926 0.0349016 -0.0522735 
v 0.159926 0.0357623 -0.0529278 
v 0.159926 0.0367436 -0.0533818 
v 0.159926 0.0388807 -0.0536142 
v 0.159926 0.0383401 -0.0536435 
v 0.159926 0.0377995 -0.0536142 
v 0.159926 0.0399366 -0.0533818 
v 0.159926 0.0409179 -0.0529278 
v 0.159926 0.0417786 -0.0522735 
v 0.159926 0.0424786 -0.0514494 
v 0.159926 0.042985 -0.0504942 
v 0.159926 0.0432742 -0.0494524 
v 0.159926 0.0433328 -0.0483728 
v 0.159926 0.0431579 -0.0473059 
v 0.159926 0.0427577 -0.0463015 
v 0.159926 0.0421509 -0.0454066 
v 0.159926 0.041366 -0.044663 
v 0.159926 0.0404396 -0.0441056 
v 0.159926 0.039415 -0.0437604 
v 0.159926 0.0383401 -0.0486435 
vn -0.995816 0.0708967 -0.0576616 
vn 0.16546 0.0618781 0.984273 
vn 0.167575 -0.162583 0.972361 
vn 0.169237 -0.381043 0.908936 
vn 0.17032 -0.580807 0.796024 
vn 0.170738 -0.749833 0.639218 
vn 0.170456 -0.877938 0.447403 
vn 0.169499 -0.957837 0.231987 
vn 0.167943 -0.98578 0.00577087 
vn 0.165906 -0.961677 -0.218293 
vn 0.16353 -0.888755 -0.428219 
vn 0.160967 -0.772878 -0.613799 
vn 0.158359 -0.621738 -0.767049 
vn 0.155834 -0.444083 -0.88233 
vn 0.153498 -0.249061 -0.956246 
vn 0.151434 -0.045745 -0.987408 
vn 0.149708 0.157198 -0.976154 
vn 0.150526 0.056293 -0.987002 
vn 0.151434 -0.045745 -0.987408 
vn 0.149708 0.157198 -0.976154 
vn 0.148366 0.351706 -0.924278 
vn 0.14744 0.53044 -0.834802 
vn 0.14695 0.686855 -0.711784 
vn 0.146906 0.81524 -0.56018 
vn 0.147308 0.910771 -0.38574 
vn 0.14815 0.969564 -0.19493 
vn 0.149412 0.988762 0.00513411 
vn 0.151066 0.966659 0.206758 
vn 0.153067 0.902861 0.401761 
vn 0.155356 0.79848 0.581631 
vn 0.157852 0.656356 0.737753 
vn 0.160453 0.481276 0.861759 
vn 0.163036 0.280121 0.946019 
vn 0.997799 0.051449 -0.0418444 
usemtl 0.231373_0.380392_0.705882_0.000000_0.000000
o mesh0
f 9216//9199 9186//9199 9187//9199 
f 9187//9199 9188//9199 9216//9199 
f 9188//9199 9189//9199 9216//9199 
f 9189//9199 9190//9199 9216//9199 
f 9190//9199 9191//9199 9216//9199 
f 9191//9199 9192//9199 9216//9199 
f 9192//9199 9193//9199 9216//9199 
f 9193//9199 9194//9199 9216//9199 
f 9194//9199 9195//9199 9216//9199 
f 9195//9199 9196//9199 9216//9199 
f 9196//9199 9197//9199 9216//9199 
f 9197//9199 9198//9199 9216//9199 
f 9198//9199 9199//9199 9216//9199 
f 9199//9199 9200//9199 9216//9199 
f 9200//9199 9201//9199 9216//9199 
f 9201//9199 9202//9199 9216//9199 
f 9202//9199 9203//9199 9216//9199 
f 9203//9199 9204//9199 9216//9199 
f 9204//9199 9205//9199 9216//9199 
f 9205//9199 9206//9199 9216//9199 
f 9206//9199 9207//9199 9216//9199 
f 9207//9199 9208//9199 9216//9199 
f 9208//9199 9209//9199 9216//9199 
f 9209//9199 9210//9199 9216//9199 
f 9210//9199 9211//9199 9216//9199 
f 9211//9199 9212//9199 9216//9199 
f 9212//9199 9213//9199 9216//9199 
f 9213//9199 9214//9199 9216//9199 
f 9214//9199 9215//9199 9216//9199 
f 9215//9199 9186//9199 9216//9199 
o mesh1
f 9217//9200 9200//9200 9199//9201 
f 9218//9201 9199//9201 9198//9202 
f 9219//9202 9198//9202 9197//9203 
f 9220//9203 9197//9203 9196//9204 
f 9221//9204 9196//9204 9195//9205 
f 9222//9205 9195//9205 9194//9206 
f 9223//9206 9194//9206 9193//9207 
f 9224//9207 9193//9207 9192//9208 
f 9225//9208 9192//9208 9191//9209 
f 9226//9209 9191//9209 9190//9210 
f 9227//9210 9190//9210 9189//9211 
f 9228//9211 9189//9211 9188//9212 
f 9229//9212 9188//9212 9187//9213 
f 9230//9213 9187//9213 9186//9214 
f 9231//9215 9232//9216 9215//9216 
f 9186//9214 9215//9216 9232//9216 
f 9232//9216 9233//9217 9186//9214 
f 9231//9215 9214//9218 9213//9219 
f 9234//9219 9213//9219 9212//9220 
f 9235//9220 9212//9220 9211//9221 
f 9236//9221 9211//9221 9210//9222 
f 9237//9222 9210//9222 9209//9223 
f 9238//9223 9209//9223 9208//9224 
f 9239//9224 9208//9224 9207//9225 
f 9240//9225 9207//9225 9206//9226 
f 9241//9226 9206//9226 9205//9227 
f 9242//9227 9205//9227 9204//9228 
f 9243//9228 9204//9228 9203//9229 
f 9244//9229 9203//9229 9202//9230 
f 9245//9230 9202//9230 9201//9231 
f 9246//9231 9201//9231 9200//9200 
f 9200//9200 9217//9200 9246//9231 
f 9201//9231 9246//9231 9245//9230 
f 9202//9230 9245//9230 9244//9229 
f 9203//9229 9244//9229 9243//9228 
f 9204//9228 9243//9228 9242//9227 
f 9205//9227 9242//9227 9241//9226 
f 9206//9226 9241//9226 9240//9225 
f 9207//9225 9240//9225 9239//9224 
f 9208//9224 9239//9224 9238//9223 
f 9209//9223 9238//9223 9237//9222 
f 9210//9222 9237//9222 9236//9221 
f 9211//9221 9236//9221 9235//9220 
f 9212//9220 9235//9220 9234//9219 
f 9213//9219 9234//9219 9231//9215 
f 9215//9216 9214//9218 9231//9215 
f 9186//9214 9233//9217 9230//9213 
f 9187//9213 9230//9213 9229//9212 
f 9188//9212 9229//9212 9228//9211 
f 9189//9211 9228//9211 9227//9210 
f 9190//9210 9227//9210 9226//9209 
f 9191//9209 9226//9209 9225//9208 
f 9192//9208 9225//9208 9224//9207 
f 9193//9207 9224//9207 9223//9206 
f 9194//9206 9223//9206 9222//9205 
f 9195//9205 9222//9205 9221//9204 
f 9196//9204 9221//9204 9220//9203 
f 9197//9203 9220//9203 9219//9202 
f 9198//9202 9219//9202 9218//9201 
f 9199//9201 9218//9201 9217//9200 
o mesh2
f 9247//9232 9231//9232 9234//9232 
f 9234//9232 9235//9232 9247//9232 
f 9235//9232 9236//9232 9247//9232 
f 9236//9232 9237//9232 9247//9232 
f 9237//9232 9238//9232 9247//9232 
f 9238//9232 9239//9232 9247//9232 
f 9239//9232 9240//9232 9247//9232 
f 9240//9232 9241//9232 9247//9232 
f 9241//9232 9242//9232 9247//9232 
f 9242//9232 9243//9232 9247//9232 
f 9243//9232 9244//9232 9247//9232 
f 9244//9232 9245//9232 9247//9232 
f 9245//9232 9246//9232 9247//9232 
f 9246//9232 9217//9232 9247//9232 
f 9217//9232 9218//9232 9247//9232 
f 9218//9232 9219//9232 9247//9232 
f 9219//9232 9220//9232 9247//9232 
f 9220//9232 9221//9232 9247//9232 
f 9221//9232 9222//9232 9247//9232 
f 9222//9232 9223//9232 9247//9232 
f 9223//9232 9224//9232 9247//9232 
f 9224//9232 9225//9232 9247//9232 
f 9225//9232 9226//9232 9247//9232 
f 9226//9232 9227//9232 9247//9232 
f 9227//9232 9228//9232 9247//9232 
f 9228//9232 9229//9232 9247//9232 
f 9229//9232 9230//9232 9247//9232 
f 9230//9232 9233//9232 9247//9232 
f 9233//9232 9232//9232 9247//9232 
f 9232//9232 9231//9232 9247//9232 
g 1mmSpacer
v 0.0284706 0.00584011 -0.0259968 
v 0.0291155 0.00584011 -0.0259267 
v 0.0291155 0.00484011 -0.0259267 
v 0.0278558 0.00584011 -0.026204 
v 0.0284706 0.00484011 -0.0259968 
v 0.0273 0.00584011 -0.0265384 
v 0.0278558 0.00484011 -0.026204 
v 0.026829 0.00584011 -0.0269845 
v 0.0273 0.00484011 -0.0265384 
v 0.0264649 0.00584011 -0.0275215 
v 0.026829 0.00484011 -0.0269845 
v 0.0262248 0.00584011 -0.0281241 
v 0.0264649 0.00484011 -0.0275215 
v 0.0261199 0.00584011 -0.0287643 
v 0.0262248 0.00484011 -0.0281241 
v 0.026155 0.00584011 -0.029412 
v 0.0261199 0.00484011 -0.0287643 
v 0.0263285 0.00584011 -0.0300371 
v 0.026155 0.00484011 -0.029412 
v 0.0266324 0.00584011 -0.0306103 
v 0.0263285 0.00484011 -0.0300371 
v 0.0270524 0.00584011 -0.0311047 
v 0.0266324 0.00484011 -0.0306103 
v 0.0275688 0.00584011 -0.0314973 
v 0.0270524 0.00484011 -0.0311047 
v 0.0281576 0.00584011 -0.0317697 
v 0.0275688 0.00484011 -0.0314973 
v 0.0287911 0.00584011 -0.0319091 
v 0.0281576 0.00484011 -0.0317697 
v 0.0294398 0.00584011 -0.0319091 
v 0.0291155 0.00584011 -0.0319267 
v 0.0291155 0.00484011 -0.0319267 
v 0.0287911 0.00484011 -0.0319091 
v 0.0300734 0.00584011 -0.0317697 
v 0.0294398 0.00484011 -0.0319091 
v 0.0306621 0.00584011 -0.0314973 
v 0.0300734 0.00484011 -0.0317697 
v 0.0311786 0.00584011 -0.0311047 
v 0.0306621 0.00484011 -0.0314973 
v 0.0315985 0.00584011 -0.0306103 
v 0.0311786 0.00484011 -0.0311047 
v 0.0319024 0.00584011 -0.0300371 
v 0.0315985 0.00484011 -0.0306103 
v 0.032076 0.00584011 -0.029412 
v 0.0319024 0.00484011 -0.0300371 
v 0.0321111 0.00584011 -0.0287643 
v 0.032076 0.00484011 -0.029412 
v 0.0320061 0.00584011 -0.0281241 
v 0.0321111 0.00484011 -0.0287643 
v 0.031766 0.00584011 -0.0275215 
v 0.0320061 0.00484011 -0.0281241 
v 0.031402 0.00584011 -0.0269845 
v 0.031766 0.00484011 -0.0275215 
v 0.030931 0.00584011 -0.0265384 
v 0.031402 0.00484011 -0.0269845 
v 0.0303751 0.00584011 -0.026204 
v 0.030931 0.00484011 -0.0265384 
v 0.0297604 0.00584011 -0.0259968 
v 0.0303751 0.00484011 -0.026204 
v 0.0297604 0.00484011 -0.0259968 
v 0.0321641 0.00484011 -0.0263372 
v 0.0315362 0.00484011 -0.0257423 
v 0.030795 0.00484011 -0.0252964 
v 0.0299754 0.00484011 -0.0250202 
v 0.0291155 0.00484011 -0.0249267 
v 0.029548 0.00484011 -0.0329033 
v 0.0303927 0.00484011 -0.0327173 
v 0.0326495 0.00484011 -0.0270531 
v 0.0260668 0.00484011 -0.0263372 
v 0.0255814 0.00484011 -0.0270531 
v 0.0270533 0.00484011 -0.0323541 
v 0.0278383 0.00484011 -0.0327173 
v 0.028683 0.00484011 -0.0329033 
v 0.0291155 0.00484011 -0.0329267 
v 0.0311777 0.00484011 -0.0323541 
v 0.0318663 0.00484011 -0.0318307 
v 0.0324262 0.00484011 -0.0311715 
v 0.0328314 0.00484011 -0.0304073 
v 0.0330628 0.00484011 -0.0295738 
v 0.0329697 0.00484011 -0.0278566 
v 0.0282556 0.00484011 -0.0250202 
v 0.0266948 0.00484011 -0.0257423 
v 0.0258047 0.00484011 -0.0311715 
v 0.0263647 0.00484011 -0.0318307 
v 0.0331096 0.00484011 -0.0287101 
v 0.0274359 0.00484011 -0.0252964 
v 0.0251213 0.00484011 -0.0287101 
v 0.0251682 0.00484011 -0.0295738 
v 0.0252613 0.00484011 -0.0278566 
v 0.0253996 0.00484011 -0.0304073 
v 0.0291155 0.00584011 -0.0249267 
v 0.0299754 0.00584011 -0.0250202 
v 0.030795 0.00584011 -0.0252964 
v 0.0315362 0.00584011 -0.0257423 
v 0.0321641 0.00584011 -0.0263372 
v 0.0326495 0.00584011 -0.0270531 
v 0.0329697 0.00584011 -0.0278566 
v 0.0331096 0.00584011 -0.0287101 
v 0.0330628 0.00584011 -0.0295738 
v 0.0328314 0.00584011 -0.0304073 
v 0.0324262 0.00584011 -0.0311715 
v 0.0318663 0.00584011 -0.0318307 
v 0.0311777 0.00584011 -0.0323541 
v 0.0303927 0.00584011 -0.0327173 
v 0.028683 0.00584011 -0.0329033 
v 0.0291155 0.00584011 -0.0329267 
v 0.029548 0.00584011 -0.0329033 
v 0.0278383 0.00584011 -0.0327173 
v 0.0270533 0.00584011 -0.0323541 
v 0.0263647 0.00584011 -0.0318307 
v 0.0258047 0.00584011 -0.0311715 
v 0.0253996 0.00584011 -0.0304073 
v 0.0251682 0.00584011 -0.0295738 
v 0.0251213 0.00584011 -0.0287101 
v 0.0252613 0.00584011 -0.0278566 
v 0.0255814 0.00584011 -0.0270531 
v 0.0260668 0.00584011 -0.0263372 
v 0.0266948 0.00584011 -0.0257423 
v 0.0274359 0.00584011 -0.0252964 
v 0.0282556 0.00584011 -0.0250202 
vn 0.262976 0.00560337 -0.964786 
vn 0.057358 0.00566649 -0.998338 
vn 0.455366 0.0055519 -0.890287 
vn 0.262976 0.00560337 -0.964786 
vn 0.627143 0.00551353 -0.778885 
vn 0.455366 0.0055519 -0.890287 
vn 0.771934 0.00548922 -0.635679 
vn 0.627143 0.00551353 -0.778885 
vn 0.884434 0.00547957 -0.466632 
vn 0.771934 0.00548922 -0.635679 
vn 0.960444 0.00548478 -0.278418 
vn 0.884434 0.00547957 -0.466632 
vn 0.996915 0.00550475 -0.0782957 
vn 0.960444 0.00548478 -0.278418 
vn 0.992014 0.005539 0.126005 
vn 0.996915 0.00550475 -0.0782957 
vn 0.945214 0.00558667 0.326404 
vn 0.992014 0.005539 0.126005 
vn 0.857403 0.00564648 0.514614 
vn 0.945214 0.00558667 0.326404 
vn 0.731023 0.00571661 0.682329 
vn 0.857403 0.00564648 0.514614 
vn 0.570197 0.00579466 0.821487 
vn 0.731023 0.00571661 0.682329 
vn 0.380845 0.00587757 0.92462 
vn 0.570197 0.00579466 0.821487 
vn 0.170716 0.00596167 0.985302 
vn 0.380845 0.00587757 0.92462 
vn -0.0507035 0.00604271 0.998695 
vn 0.0607628 0.00600285 0.998134 
vn 0.170716 0.00596167 0.985302 
vn -0.272481 0.00611609 0.962142 
vn -0.0507035 0.00604271 0.998695 
vn -0.482784 0.00617719 0.875718 
vn -0.272481 0.00611609 0.962142 
vn -0.669671 0.00622184 0.742632 
vn -0.482784 0.00617719 0.875718 
vn -0.822091 0.00624676 0.569323 
vn -0.669671 0.00622184 0.742632 
vn -0.930922 0.00625006 0.365163 
vn -0.822091 0.00624676 0.569323 
vn -0.989882 0.00623148 0.141759 
vn -0.930922 0.00625006 0.365163 
vn -0.996094 0.00619245 -0.0880771 
vn -0.989882 0.00623148 0.141759 
vn -0.950237 0.00613586 -0.311468 
vn -0.996094 0.00619245 -0.0880771 
vn -0.856239 0.00606568 -0.516545 
vn -0.950237 0.00613586 -0.311468 
vn -0.720663 0.00598644 -0.69326 
vn -0.856239 0.00606568 -0.516545 
vn -0.55192 0.0059028 -0.833876 
vn -0.720663 0.00598644 -0.69326 
vn -0.359477 0.00581911 -0.933136 
vn -0.55192 0.0059028 -0.833876 
vn -0.153164 0.00573926 -0.988184 
vn -0.359477 0.00581911 -0.933136 
vn 0.0593329 -0.997816 -0.0290331 
vn 0.0607628 0.00600285 0.998134 
vn 0.277823 0.00591973 0.960614 
vn 0.478645 0.00583572 0.877989 
vn 0.654589 0.00575482 0.755963 
vn 0.798818 0.0056804 0.601546 
vn 0.90632 0.00561516 0.422554 
vn 0.97383 0.00556123 0.227208 
vn 0.999701 0.00552013 0.0238308 
vn 0.983766 0.00549294 -0.179372 
vn 0.927219 0.00548032 -0.37448 
vn 0.832509 0.00548254 -0.553984 
vn 0.703269 0.00549957 -0.710903 
vn 0.544254 0.00553101 -0.838902 
vn 0.361309 0.00557608 -0.932429 
vn 0.161321 0.00563358 -0.986886 
vn -0.0478431 0.00570181 -0.998839 
vn 0.057358 0.00566649 -0.998338 
vn 0.161321 0.00563358 -0.986886 
vn -0.0478431 0.00570181 -0.998839 
vn -0.257441 0.00577849 -0.966277 
vn -0.458048 0.0058607 -0.888908 
vn -0.639862 0.00594489 -0.768467 
vn -0.793156 0.0060269 -0.608988 
vn -0.908898 0.00610219 -0.416974 
vn -0.979499 0.00616612 -0.201355 
vn -0.999621 0.00621437 0.0268279 
vn -0.9669 0.00624346 0.255081 
vn -0.882423 0.00625117 0.470415 
vn -0.750816 0.00623692 0.660482 
vn -0.579878 0.00620181 0.81468 
vn -0.379822 0.00614845 0.925039 
vn -0.162274 0.00608065 0.986727 
vn 0.0586468 0.997866 -0.0286974 
usemtl 0.647059_0.647059_0.647059_0.000000_0.000000
o mesh264
f 9248//9233 9249//9234 9250//9234 
f 9251//9235 9248//9233 9252//9236 
f 9253//9237 9251//9235 9254//9238 
f 9255//9239 9253//9237 9256//9240 
f 9257//9241 9255//9239 9258//9242 
f 9259//9243 9257//9241 9260//9244 
f 9261//9245 9259//9243 9262//9246 
f 9263//9247 9261//9245 9264//9248 
f 9265//9249 9263//9247 9266//9250 
f 9267//9251 9265//9249 9268//9252 
f 9269//9253 9267//9251 9270//9254 
f 9271//9255 9269//9253 9272//9256 
f 9273//9257 9271//9255 9274//9258 
f 9275//9259 9273//9257 9276//9260 
f 9277//9261 9278//9262 9279//9262 
f 9280//9263 9279//9262 9278//9262 
f 9278//9262 9275//9259 9280//9263 
f 9281//9264 9277//9261 9282//9265 
f 9283//9266 9281//9264 9284//9267 
f 9285//9268 9283//9266 9286//9269 
f 9287//9270 9285//9268 9288//9271 
f 9289//9272 9287//9270 9290//9273 
f 9291//9274 9289//9272 9292//9275 
f 9293//9276 9291//9274 9294//9277 
f 9295//9278 9293//9276 9296//9279 
f 9297//9280 9295//9278 9298//9281 
f 9299//9282 9297//9280 9300//9283 
f 9301//9284 9299//9282 9302//9285 
f 9303//9286 9301//9284 9304//9287 
f 9305//9288 9303//9286 9306//9289 
f 9249//9234 9305//9288 9307//9288 
f 9307//9288 9250//9234 9249//9234 
f 9306//9289 9307//9288 9305//9288 
f 9304//9287 9306//9289 9303//9286 
f 9302//9285 9304//9287 9301//9284 
f 9300//9283 9302//9285 9299//9282 
f 9298//9281 9300//9283 9297//9280 
f 9296//9279 9298//9281 9295//9278 
f 9294//9277 9296//9279 9293//9276 
f 9292//9275 9294//9277 9291//9274 
f 9290//9273 9292//9275 9289//9272 
f 9288//9271 9290//9273 9287//9270 
f 9286//9269 9288//9271 9285//9268 
f 9284//9267 9286//9269 9283//9266 
f 9282//9265 9284//9267 9281//9264 
f 9279//9262 9282//9265 9277//9261 
f 9276//9260 9280//9263 9275//9259 
f 9274//9258 9276//9260 9273//9257 
f 9272//9256 9274//9258 9271//9255 
f 9270//9254 9272//9256 9269//9253 
f 9268//9252 9270//9254 9267//9251 
f 9266//9250 9268//9252 9265//9249 
f 9264//9248 9266//9250 9263//9247 
f 9262//9246 9264//9248 9261//9245 
f 9260//9244 9262//9246 9259//9243 
f 9258//9242 9260//9244 9257//9241 
f 9256//9240 9258//9242 9255//9239 
f 9254//9238 9256//9240 9253//9237 
f 9252//9236 9254//9238 9251//9235 
f 9250//9234 9252//9236 9248//9233 
o mesh265
f 9308//9290 9309//9290 9304//9290 
f 9309//9290 9310//9290 9306//9290 
f 9310//9290 9311//9290 9307//9290 
f 9311//9290 9312//9290 9250//9290 
f 9313//9290 9282//9290 9279//9290 
f 9314//9290 9284//9290 9282//9290 
f 9315//9290 9300//9290 9298//9290 
f 9315//9290 9308//9290 9302//9290 
f 9306//9290 9304//9290 9309//9290 
f 9250//9290 9307//9290 9311//9290 
f 9316//9290 9258//9290 9256//9290 
f 9316//9290 9317//9290 9260//9290 
f 9318//9290 9274//9290 9272//9290 
f 9319//9290 9276//9290 9274//9290 
f 9319//9290 9320//9290 9280//9290 
f 9321//9290 9279//9290 9280//9290 
f 9282//9290 9313//9290 9314//9290 
f 9322//9290 9286//9290 9284//9290 
f 9322//9290 9323//9290 9288//9290 
f 9323//9290 9324//9290 9290//9290 
f 9325//9290 9292//9290 9290//9290 
f 9325//9290 9326//9290 9294//9290 
f 9327//9290 9298//9290 9296//9290 
f 9302//9290 9300//9290 9315//9290 
f 9307//9290 9306//9290 9310//9290 
f 9312//9290 9328//9290 9252//9290 
f 9329//9290 9256//9290 9254//9290 
f 9260//9290 9258//9290 9316//9290 
f 9330//9290 9270//9290 9268//9290 
f 9330//9290 9331//9290 9272//9290 
f 9274//9290 9318//9290 9319//9290 
f 9280//9290 9320//9290 9321//9290 
f 9284//9290 9314//9290 9322//9290 
f 9290//9290 9288//9290 9323//9290 
f 9294//9290 9292//9290 9325//9290 
f 9326//9290 9332//9290 9296//9290 
f 9298//9290 9327//9290 9315//9290 
f 9252//9290 9250//9290 9312//9290 
f 9333//9290 9254//9290 9252//9290 
f 9256//9290 9329//9290 9316//9290 
f 9334//9290 9264//9290 9262//9290 
f 9334//9290 9335//9290 9266//9290 
f 9272//9290 9270//9290 9330//9290 
f 9280//9290 9276//9290 9319//9290 
f 9288//9290 9286//9290 9322//9290 
f 9296//9290 9294//9290 9326//9290 
f 9304//9290 9302//9290 9308//9290 
f 9254//9290 9333//9290 9329//9290 
f 9336//9290 9262//9290 9260//9290 
f 9266//9290 9264//9290 9334//9290 
f 9337//9290 9268//9290 9266//9290 
f 9272//9290 9331//9290 9318//9290 
f 9290//9290 9324//9290 9325//9290 
f 9252//9290 9328//9290 9333//9290 
f 9262//9290 9336//9290 9334//9290 
f 9268//9290 9337//9290 9330//9290 
f 9296//9290 9332//9290 9327//9290 
f 9266//9290 9335//9290 9337//9290 
f 9260//9290 9317//9290 9336//9290 
f 9279//9290 9321//9290 9313//9290 
o mesh266
f 9338//9291 9312//9291 9311//9292 
f 9339//9292 9311//9292 9310//9293 
f 9340//9293 9310//9293 9309//9294 
f 9341//9294 9309//9294 9308//9295 
f 9342//9295 9308//9295 9315//9296 
f 9343//9296 9315//9296 9327//9297 
f 9344//9297 9327//9297 9332//9298 
f 9345//9298 9332//9298 9326//9299 
f 9346//9299 9326//9299 9325//9300 
f 9347//9300 9325//9300 9324//9301 
f 9348//9301 9324//9301 9323//9302 
f 9349//9302 9323//9302 9322//9303 
f 9350//9303 9322//9303 9314//9304 
f 9351//9304 9314//9304 9313//9305 
f 9352//9306 9353//9307 9321//9307 
f 9313//9305 9321//9307 9353//9307 
f 9353//9307 9354//9308 9313//9305 
f 9352//9306 9320//9309 9319//9310 
f 9355//9310 9319//9310 9318//9311 
f 9356//9311 9318//9311 9331//9312 
f 9357//9312 9331//9312 9330//9313 
f 9358//9313 9330//9313 9337//9314 
f 9359//9314 9337//9314 9335//9315 
f 9360//9315 9335//9315 9334//9316 
f 9361//9316 9334//9316 9336//9317 
f 9362//9317 9336//9317 9317//9318 
f 9363//9318 9317//9318 9316//9319 
f 9364//9319 9316//9319 9329//9320 
f 9365//9320 9329//9320 9333//9321 
f 9366//9321 9333//9321 9328//9322 
f 9367//9322 9328//9322 9312//9291 
f 9312//9291 9338//9291 9367//9322 
f 9328//9322 9367//9322 9366//9321 
f 9333//9321 9366//9321 9365//9320 
f 9329//9320 9365//9320 9364//9319 
f 9316//9319 9364//9319 9363//9318 
f 9317//9318 9363//9318 9362//9317 
f 9336//9317 9362//9317 9361//9316 
f 9334//9316 9361//9316 9360//9315 
f 9335//9315 9360//9315 9359//9314 
f 9337//9314 9359//9314 9358//9313 
f 9330//9313 9358//9313 9357//9312 
f 9331//9312 9357//9312 9356//9311 
f 9318//9311 9356//9311 9355//9310 
f 9319//9310 9355//9310 9352//9306 
f 9321//9307 9320//9309 9352//9306 
f 9313//9305 9354//9308 9351//9304 
f 9314//9304 9351//9304 9350//9303 
f 9322//9303 9350//9303 9349//9302 
f 9323//9302 9349//9302 9348//9301 
f 9324//9301 9348//9301 9347//9300 
f 9325//9300 9347//9300 9346//9299 
f 9326//9299 9346//9299 9345//9298 
f 9332//9298 9345//9298 9344//9297 
f 9327//9297 9344//9297 9343//9296 
f 9315//9296 9343//9296 9342//9295 
f 9308//9295 9342//9295 9341//9294 
f 9309//9294 9341//9294 9340//9293 
f 9310//9293 9340//9293 9339//9292 
f 9311//9292 9339//9292 9338//9291 
o mesh267
f 9354//9323 9353//9323 9278//9323 
f 9353//9323 9352//9323 9275//9323 
f 9351//9323 9354//9323 9277//9323 
f 9275//9323 9278//9323 9353//9323 
f 9339//9323 9305//9323 9249//9323 
f 9340//9323 9303//9323 9305//9323 
f 9278//9323 9277//9323 9354//9323 
f 9355//9323 9273//9323 9275//9323 
f 9305//9323 9339//9323 9340//9323 
f 9341//9323 9301//9323 9303//9323 
f 9343//9323 9297//9323 9299//9323 
f 9343//9323 9344//9323 9295//9323 
f 9350//9323 9351//9323 9281//9323 
f 9275//9323 9352//9323 9355//9323 
f 9355//9323 9356//9323 9271//9323 
f 9356//9323 9357//9323 9269//9323 
f 9303//9323 9340//9323 9341//9323 
f 9342//9323 9299//9323 9301//9323 
f 9295//9323 9297//9323 9343//9323 
f 9344//9323 9345//9323 9293//9323 
f 9347//9323 9289//9323 9291//9323 
f 9347//9323 9348//9323 9287//9323 
f 9349//9323 9285//9323 9287//9323 
f 9349//9323 9350//9323 9283//9323 
f 9277//9323 9281//9323 9351//9323 
f 9269//9323 9271//9323 9356//9323 
f 9301//9323 9341//9323 9342//9323 
f 9293//9323 9295//9323 9344//9323 
f 9346//9323 9291//9323 9293//9323 
f 9287//9323 9289//9323 9347//9323 
f 9283//9323 9285//9323 9349//9323 
f 9271//9323 9273//9323 9355//9323 
f 9358//9323 9267//9323 9269//9323 
f 9358//9323 9359//9323 9265//9323 
f 9299//9323 9342//9323 9343//9323 
f 9291//9323 9346//9323 9347//9323 
f 9281//9323 9283//9323 9350//9323 
f 9265//9323 9267//9323 9358//9323 
f 9364//9323 9255//9323 9257//9323 
f 9364//9323 9365//9323 9253//9323 
f 9293//9323 9345//9323 9346//9323 
f 9269//9323 9357//9323 9358//9323 
f 9361//9323 9261//9323 9263//9323 
f 9361//9323 9362//9323 9259//9323 
f 9253//9323 9255//9323 9364//9323 
f 9365//9323 9366//9323 9251//9323 
f 9287//9323 9348//9323 9349//9323 
f 9359//9323 9360//9323 9263//9323 
f 9259//9323 9261//9323 9361//9323 
f 9362//9323 9363//9323 9257//9323 
f 9251//9323 9253//9323 9365//9323 
f 9366//9323 9367//9323 9248//9323 
f 9263//9323 9265//9323 9359//9323 
f 9257//9323 9259//9323 9362//9323 
f 9248//9323 9251//9323 9366//9323 
f 9338//9323 9249//9323 9248//9323 
f 9263//9323 9360//9323 9361//9323 
f 9248//9323 9367//9323 9338//9323 
f 9257//9323 9363//9323 9364//9323 
f 9249//9323 9338//9323 9339//9323 
g bearing
v 0.031557 0.00584011 0.0585359 
v 0.0316155 0.00584011 0.0590733 
v 0.0316155 0.0160401 0.0590733 
v 0.0313844 0.00584011 0.0580236 
v 0.031557 0.0160401 0.0585359 
v 0.0311057 0.00584011 0.0575604 
v 0.0313844 0.0160401 0.0580236 
v 0.0307339 0.00584011 0.0571679 
v 0.0311057 0.0160401 0.0575604 
v 0.0302865 0.00584011 0.0568645 
v 0.0307339 0.0160401 0.0571679 
v 0.0297843 0.00584011 0.0566644 
v 0.0302865 0.0160401 0.0568645 
v 0.0292508 0.00584011 0.056577 
v 0.0297843 0.0160401 0.0566644 
v 0.028711 0.00584011 0.0566062 
v 0.0292508 0.0160401 0.056577 
v 0.0281901 0.00584011 0.0567509 
v 0.028711 0.0160401 0.0566062 
v 0.0277125 0.00584011 0.0570041 
v 0.0281901 0.0160401 0.0567509 
v 0.0273005 0.00584011 0.057354 
v 0.0277125 0.0160401 0.0570041 
v 0.0269733 0.00584011 0.0577844 
v 0.0273005 0.0160401 0.057354 
v 0.0267463 0.00584011 0.058275 
v 0.0269733 0.0160401 0.0577844 
v 0.0266301 0.00584011 0.058803 
v 0.0267463 0.0160401 0.058275 
v 0.0266301 0.00584011 0.0593436 
v 0.0266301 0.0160401 0.058803 
v 0.0267463 0.00584011 0.0598716 
v 0.0266301 0.0160401 0.0593436 
v 0.0269733 0.00584011 0.0603622 
v 0.0267463 0.0160401 0.0598716 
v 0.0273005 0.00584011 0.0607925 
v 0.0269733 0.0160401 0.0603622 
v 0.0277125 0.00584011 0.0611425 
v 0.0273005 0.0160401 0.0607925 
v 0.0281901 0.00584011 0.0613957 
v 0.0277125 0.0160401 0.0611425 
v 0.028711 0.00584011 0.0615404 
v 0.0281901 0.0160401 0.0613957 
v 0.0292508 0.00584011 0.0615696 
v 0.028711 0.0160401 0.0615404 
v 0.0297843 0.00584011 0.0614822 
v 0.0292508 0.0160401 0.0615696 
v 0.0302865 0.00584011 0.0612821 
v 0.0297843 0.0160401 0.0614822 
v 0.0307339 0.00584011 0.0609787 
v 0.0302865 0.0160401 0.0612821 
v 0.0311057 0.00584011 0.0605862 
v 0.0307339 0.0160401 0.0609787 
v 0.0313844 0.00584011 0.060123 
v 0.0311057 0.0160401 0.0605862 
v 0.031557 0.00584011 0.0596107 
v 0.0313844 0.0160401 0.060123 
v 0.031557 0.0160401 0.0596107 
v 0.0222911 0.0160401 0.0655377 
v 0.0238403 0.0160401 0.0668536 
v 0.021061 0.0160401 0.0639195 
v 0.0296244 0.0160401 0.0684595 
v 0.0316302 0.0160401 0.0681307 
v 0.0256362 0.0160401 0.0678057 
v 0.0275947 0.0160401 0.0683495 
v 0.0352009 0.0160401 0.0662376 
v 0.0365987 0.0160401 0.0647619 
v 0.0382957 0.0160401 0.061094 
v 0.0385155 0.0160401 0.0590733 
v 0.0335185 0.0160401 0.0673783 
v 0.0382957 0.0160401 0.0570526 
v 0.0376467 0.0160401 0.0630203 
v 0.0222911 0.0160401 0.0526089 
v 0.021061 0.0160401 0.0542271 
v 0.0238403 0.0160401 0.051293 
v 0.0202075 0.0160401 0.0620747 
v 0.0376467 0.0160401 0.0551263 
v 0.0365987 0.0160401 0.0533847 
v 0.0352009 0.0160401 0.051909 
v 0.0335185 0.0160401 0.0507683 
v 0.0316302 0.0160401 0.0500159 
v 0.0296244 0.0160401 0.0496871 
v 0.0202075 0.0160401 0.0560719 
v 0.0197706 0.0160401 0.058057 
v 0.0197706 0.0160401 0.0600896 
v 0.0275947 0.0160401 0.0497971 
v 0.0256362 0.0160401 0.0503409 
v 0.0411155 0.0134401 0.0590733 
v 0.0408349 0.0134401 0.0616529 
v 0.0400064 0.0134401 0.064112 
v 0.0386686 0.0134401 0.0663354 
v 0.0368841 0.0134401 0.0682192 
v 0.0347364 0.0134401 0.0696754 
v 0.0323258 0.0134401 0.0706359 
v 0.0297651 0.0134401 0.0710557 
v 0.0271741 0.0134401 0.0709152 
v 0.0246738 0.0134401 0.070221 
v 0.0223812 0.0134401 0.0690056 
v 0.0204035 0.0134401 0.0673257 
v 0.0188332 0.0134401 0.0652599 
v 0.0177436 0.0134401 0.0629049 
v 0.0171858 0.0134401 0.0603707 
v 0.0171858 0.0134401 0.0577759 
v 0.0177436 0.0134401 0.0552417 
v 0.0188332 0.0134401 0.0528867 
v 0.0204035 0.0134401 0.0508209 
v 0.0223812 0.0134401 0.049141 
v 0.0246738 0.0134401 0.0479256 
v 0.0271741 0.0134401 0.0472314 
v 0.0297651 0.0134401 0.0470909 
v 0.0323258 0.0134401 0.0475107 
v 0.0347364 0.0134401 0.0484712 
v 0.0368841 0.0134401 0.0499274 
v 0.0386686 0.0134401 0.0518112 
v 0.0400064 0.0134401 0.0540346 
v 0.0408349 0.0134401 0.0564937 
v 0.0407662 0.00844011 0.0616378 
v 0.0410451 0.00844011 0.0603707 
v 0.0399425 0.00844011 0.0640824 
v 0.0404873 0.00844011 0.0629049 
v 0.0386126 0.00844011 0.0662928 
v 0.0393978 0.00844011 0.0652599 
v 0.0368386 0.00844011 0.0681656 
v 0.0378274 0.00844011 0.0673257 
v 0.0347034 0.00844011 0.0696133 
v 0.0358497 0.00844011 0.0690056 
v 0.032307 0.00844011 0.0705681 
v 0.0335571 0.00844011 0.070221 
v 0.0297613 0.00844011 0.0709855 
v 0.0310569 0.00844011 0.0709152 
v 0.0271855 0.00844011 0.0708458 
v 0.0284658 0.00844011 0.0710557 
v 0.0246999 0.00844011 0.0701557 
v 0.0259051 0.00844011 0.0706359 
v 0.0224207 0.00844011 0.0689473 
v 0.0234946 0.00844011 0.0696754 
v 0.0213468 0.00844011 0.0682192 
v 0.0204546 0.00844011 0.0672773 
v 0.0195624 0.00844011 0.0663354 
v 0.0188935 0.00844011 0.0652237 
v 0.0182246 0.00844011 0.064112 
v 0.0178103 0.00844011 0.0628825 
v 0.0172558 0.00844011 0.0603631 
v 0.017396 0.00844011 0.0616529 
v 0.0172558 0.00844011 0.0577835 
v 0.0171155 0.00844011 0.0590733 
v 0.0178103 0.00844011 0.0552641 
v 0.017396 0.00844011 0.0564937 
v 0.0188935 0.00844011 0.0529229 
v 0.0182246 0.00844011 0.0540346 
v 0.0204546 0.00844011 0.0508693 
v 0.0195624 0.00844011 0.0518112 
v 0.0224207 0.00844011 0.0491993 
v 0.0213468 0.00844011 0.0499274 
v 0.0246999 0.00844011 0.0479909 
v 0.0234946 0.00844011 0.0484712 
v 0.0271855 0.00844011 0.0473008 
v 0.0259051 0.00844011 0.0475107 
v 0.0297613 0.00844011 0.0471611 
v 0.0284658 0.00844011 0.0470909 
v 0.032307 0.00844011 0.0475785 
v 0.0310569 0.00844011 0.0472314 
v 0.0347034 0.00844011 0.0485333 
v 0.0335571 0.00844011 0.0479256 
v 0.0368386 0.00844011 0.049981 
v 0.0358497 0.00844011 0.049141 
v 0.0386126 0.00844011 0.0518538 
v 0.0378274 0.00844011 0.0508209 
v 0.0399425 0.00844011 0.0540642 
v 0.0393978 0.00844011 0.0528867 
v 0.0407662 0.00844011 0.0565088 
v 0.0404873 0.00844011 0.0552417 
v 0.0411155 0.00844011 0.0590733 
v 0.0410451 0.00844011 0.0577759 
v 0.0199352 0.00584011 0.061094 
v 0.0197155 0.00584011 0.0590733 
v 0.0205843 0.00584011 0.0630203 
v 0.0216322 0.00584011 0.0647619 
v 0.02303 0.00584011 0.0662376 
v 0.0247124 0.00584011 0.0673783 
v 0.0266007 0.00584011 0.0681307 
v 0.0286066 0.00584011 0.0684595 
v 0.0306362 0.00584011 0.0683495 
v 0.0325948 0.00584011 0.0678057 
v 0.0343906 0.00584011 0.0668536 
v 0.0359398 0.00584011 0.0655377 
v 0.0371699 0.00584011 0.0639195 
v 0.0380234 0.00584011 0.0620747 
v 0.0384604 0.00584011 0.0600896 
v 0.0385155 0.00584011 0.0590733 
v 0.0384604 0.00584011 0.058057 
v 0.0380234 0.00584011 0.0560719 
v 0.0371699 0.00584011 0.0542271 
v 0.0359398 0.00584011 0.0526089 
v 0.0343906 0.00584011 0.051293 
v 0.0325948 0.00584011 0.0503409 
v 0.0306362 0.00584011 0.0497971 
v 0.0286066 0.00584011 0.0496871 
v 0.0266007 0.00584011 0.0500159 
v 0.0247124 0.00584011 0.0507683 
v 0.02303 0.00584011 0.051909 
v 0.0216322 0.00584011 0.0533847 
v 0.0205843 0.00584011 0.0551263 
v 0.0199352 0.00584011 0.0570526 
vn -0.960611 0.00592089 0.277834 
vn -0.998136 0.00600403 0.0607314 
vn -0.877964 0.00583681 0.478692 
vn -0.960611 0.00592089 0.277834 
vn -0.755904 0.00575579 0.654657 
vn -0.877964 0.00583681 0.478692 
vn -0.601449 0.00568121 0.798891 
vn -0.755904 0.00575579 0.654657 
vn -0.422421 0.0056158 0.906383 
vn -0.601449 0.00568121 0.798891 
vn -0.227046 0.00556167 0.973868 
vn -0.422421 0.0056158 0.906383 
vn -0.0236535 0.00552037 0.999705 
vn -0.227046 0.00556167 0.973868 
vn 0.179551 0.00549298 0.983733 
vn -0.0236535 0.00552037 0.999705 
vn 0.374646 0.00548015 0.927152 
vn 0.179551 0.00549298 0.983733 
vn 0.554125 0.00548219 0.832416 
vn 0.374646 0.00548015 0.927152 
vn 0.711011 0.00549903 0.70316 
vn 0.554125 0.00548219 0.832416 
vn 0.838973 0.0055303 0.544144 
vn 0.711011 0.00549903 0.70316 
vn 0.932467 0.00557522 0.361213 
vn 0.838973 0.0055303 0.544144 
vn 0.986897 0.00563261 0.161252 
vn 0.932467 0.00557522 0.361213 
vn 0.998837 0.00570075 -0.0478754 
vn 0.986897 0.00563261 0.161252 
vn 0.966279 0.00577739 -0.257434 
vn 0.998837 0.00570075 -0.0478754 
vn 0.888931 0.0058596 -0.458005 
vn 0.966279 0.00577739 -0.257434 
vn 0.768524 0.00594385 -0.639793 
vn 0.888931 0.0058596 -0.458005 
vn 0.60909 0.00602598 -0.793078 
vn 0.768524 0.00594385 -0.639793 
vn 0.41712 0.00610145 -0.908831 
vn 0.60909 0.00602598 -0.793078 
vn 0.201537 0.0061656 -0.979461 
vn 0.41712 0.00610145 -0.908831 
vn -0.026626 0.00621413 -0.999626 
vn 0.201537 0.0061656 -0.979461 
vn -0.254881 0.00624351 -0.966952 
vn -0.026626 0.00621413 -0.999626 
vn -0.470239 0.00625152 -0.882517 
vn -0.254881 0.00624351 -0.966952 
vn -0.660346 0.00623754 -0.750936 
vn -0.470239 0.00625152 -0.882517 
vn -0.814591 0.00620266 -0.580003 
vn -0.660346 0.00623754 -0.750936 
vn -0.924995 0.00614948 -0.379929 
vn -0.814591 0.00620266 -0.580003 
vn -0.986715 0.00608178 -0.162348 
vn -0.924995 0.00614948 -0.379929 
vn 0.0288846 0.997863 0.0586048 
vn 0.717181 0.694507 0.0575454 
vn 0.69549 0.688973 0.203983 
vn 0.644031 0.684426 0.341739 
vn 0.565524 0.681018 0.465186 
vn 0.463605 0.678855 0.569408 
vn 0.34267 0.678005 0.650297 
vn 0.207737 0.678492 0.704624 
vn 0.0643113 0.6803 0.730106 
vn -0.0817446 0.683378 0.725474 
vn -0.224351 0.687627 0.690533 
vn -0.35737 0.69291 0.626229 
vn -0.474794 0.699038 0.534711 
vn -0.570974 0.705777 0.419365 
vn -0.640885 0.712845 0.284813 
vn -0.680434 0.719917 0.13685 
vn -0.686789 0.726641 -0.0177122 
vn -0.658691 0.732651 -0.171314 
vn -0.596716 0.737597 -0.31604 
vn -0.503412 0.741173 -0.444117 
vn -0.383279 0.743146 -0.54848 
vn -0.242543 0.743387 -0.623337 
vn -0.0887423 0.741878 -0.664637 
vn 0.0698339 0.73872 -0.670385 
vn 0.224769 0.73412 -0.640739 
vn 0.368124 0.728367 -0.577899 
vn 0.492934 0.721802 -0.485817 
vn 0.593568 0.714789 -0.369802 
vn 0.665918 0.707686 -0.236078 
vn 0.707457 0.700828 -0.091354 
vn 0.964809 0.00560245 0.262892 
vn 0.986897 0.00563261 0.161252 
vn 0.998341 0.00566546 0.0573068 
vn 0.89034 0.00555112 0.455262 
vn 0.932467 0.00557522 0.361213 
vn 0.778974 0.0055129 0.627032 
vn 0.838973 0.0055303 0.544144 
vn 0.635804 0.00548877 0.771831 
vn 0.711011 0.00549903 0.70316 
vn 0.466787 0.00547931 0.884353 
vn 0.554125 0.00548219 0.832416 
vn 0.278592 0.00548472 0.960394 
vn 0.374646 0.00548015 0.927152 
vn 0.0784756 0.00550489 0.996901 
vn 0.179551 0.00549298 0.983733 
vn -0.125834 0.00553934 0.992036 
vn -0.0236535 0.00552037 0.999705 
vn -0.326256 0.00558722 0.945265 
vn -0.227046 0.00556167 0.973868 
vn -0.514498 0.00564721 0.857473 
vn -0.422421 0.0056158 0.906383 
vn -0.682251 0.00571751 0.731096 
vn -0.601449 0.00568121 0.798891 
vn -0.821446 0.00579569 0.570257 
vn -0.755904 0.00575579 0.654657 
vn -0.924608 0.0058787 0.380875 
vn -0.877964 0.00583681 0.478692 
vn -0.985304 0.00596285 0.170706 
vn -0.960611 0.00592089 0.277834 
vn -0.998693 0.00604387 -0.050757 
vn -0.998136 0.00600403 0.0607314 
vn -0.962115 0.00611718 -0.272574 
vn -0.986715 0.00608178 -0.162348 
vn -0.875652 0.00617814 -0.482902 
vn -0.924995 0.00614948 -0.379929 
vn -0.742519 0.00622258 -0.669796 
vn -0.814591 0.00620266 -0.580003 
vn -0.569165 0.00624725 -0.8222 
vn -0.660346 0.00623754 -0.750936 
vn -0.364973 0.00625026 -0.930997 
vn -0.470239 0.00625152 -0.882517 
vn -0.141555 0.00623138 -0.989911 
vn -0.254881 0.00624351 -0.966952 
vn 0.0882718 0.00619206 -0.996077 
vn -0.026626 0.00621413 -0.999626 
vn 0.311634 0.00613522 -0.950182 
vn 0.201537 0.0061656 -0.979461 
vn 0.516669 0.00606484 -0.856164 
vn 0.41712 0.00610145 -0.908831 
vn 0.693338 0.00598546 -0.720587 
vn 0.60909 0.00602598 -0.793078 
vn 0.833914 0.00590172 -0.551862 
vn 0.768524 0.00594385 -0.639793 
vn 0.933146 0.00581801 -0.35945 
vn 0.888931 0.0058596 -0.458005 
vn 0.988182 0.00573818 -0.153176 
vn 0.966279 0.00577739 -0.257434 
vn 0.998341 0.00566546 0.0573068 
vn 0.998837 0.00570075 -0.0478754 
vn -0.670279 -0.710616 0.213895 
vn -0.686238 -0.714163 0.138017 
vn -0.693804 -0.717622 0.0604511 
vn -0.614539 -0.703443 0.357085 
vn -0.646243 -0.707029 0.287194 
vn -0.530138 -0.696446 0.483649 
vn -0.575652 -0.699903 0.422801 
vn -0.421727 -0.689932 0.588337 
vn -0.478609 -0.693111 0.539008 
vn -0.294729 -0.684159 0.667129 
vn -0.360191 -0.686938 0.631172 
vn -0.155051 -0.67934 0.717256 
vn -0.226095 -0.681619 0.6959 
vn -0.00883152 -0.675638 0.73718 
vn -0.0823721 -0.677341 0.731043 
vn 0.137763 -0.673171 0.726542 
vn 0.0648004 -0.674245 0.73566 
vn 0.27871 -0.672012 0.686091 
vn 0.209309 -0.672425 0.709954 
vn 0.408277 -0.672196 0.617627 
vn 0.345259 -0.671935 0.655209 
vn 0.52116 -0.673717 0.523926 
vn 0.467116 -0.672791 0.573721 
vn 0.612606 -0.67653 0.408682 
vn 0.569834 -0.674966 0.468732 
vn 0.678552 -0.68055 0.276439 
vn 0.648989 -0.678397 0.34437 
vn 0.715772 -0.685648 0.132506 
vn 0.700917 -0.682974 0.205574 
vn 0.722034 -0.691646 -0.01714 
vn 0.722869 -0.688547 0.0580018 
vn 0.696269 -0.69832 -0.166006 
vn 0.713171 -0.694914 -0.0920919 
vn 0.638745 -0.705397 -0.307278 
vn 0.671404 -0.701827 -0.238023 
vn 0.551208 -0.71256 -0.434083 
vn 0.598558 -0.708989 -0.372911 
vn 0.436983 -0.719457 -0.53984 
vn 0.497161 -0.716065 -0.489982 
vn 0.300985 -0.72572 -0.618659 
vn 0.371339 -0.722691 -0.582946 
vn 0.149595 -0.730989 -0.66579 
vn 0.226764 -0.7285 -0.646425 
vn -0.00960667 -0.73494 -0.678064 
vn 0.0704614 -0.733147 -0.67641 
vn -0.168284 -0.737318 -0.654249 
vn -0.0895468 -0.736338 -0.670662 
vn -0.317909 -0.737965 -0.595266 
vn -0.244751 -0.737864 -0.62901 
vn -0.450398 -0.736836 -0.504196 
vn -0.386766 -0.737621 -0.553469 
vn -0.558731 -0.734009 -0.386071 
vn -0.507967 -0.735626 -0.448135 
vn -0.63745 -0.72967 -0.247466 
vn -0.602062 -0.732013 -0.318872 
vn -0.682992 -0.724095 -0.095959 
vn -0.664513 -0.727017 -0.172828 
vn -0.692758 -0.720948 -0.0178661 
vn -0.693804 -0.717622 0.0604511 
vn 0.0292225 -0.997813 0.0592904 
usemtl 0.400000_0.400000_0.400000_0.000000_0.000000
o mesh3
f 9368//9324 9369//9325 9370//9325 
f 9371//9326 9368//9324 9372//9327 
f 9373//9328 9371//9326 9374//9329 
f 9375//9330 9373//9328 9376//9331 
f 9377//9332 9375//9330 9378//9333 
f 9379//9334 9377//9332 9380//9335 
f 9381//9336 9379//9334 9382//9337 
f 9383//9338 9381//9336 9384//9339 
f 9385//9340 9383//9338 9386//9341 
f 9387//9342 9385//9340 9388//9343 
f 9389//9344 9387//9342 9390//9345 
f 9391//9346 9389//9344 9392//9347 
f 9393//9348 9391//9346 9394//9349 
f 9395//9350 9393//9348 9396//9351 
f 9397//9352 9395//9350 9398//9353 
f 9399//9354 9397//9352 9400//9355 
f 9401//9356 9399//9354 9402//9357 
f 9403//9358 9401//9356 9404//9359 
f 9405//9360 9403//9358 9406//9361 
f 9407//9362 9405//9360 9408//9363 
f 9409//9364 9407//9362 9410//9365 
f 9411//9366 9409//9364 9412//9367 
f 9413//9368 9411//9366 9414//9369 
f 9415//9370 9413//9368 9416//9371 
f 9417//9372 9415//9370 9418//9373 
f 9419//9374 9417//9372 9420//9375 
f 9421//9376 9419//9374 9422//9377 
f 9423//9378 9421//9376 9424//9379 
f 9369//9325 9423//9378 9425//9378 
f 9425//9378 9370//9325 9369//9325 
f 9424//9379 9425//9378 9423//9378 
f 9422//9377 9424//9379 9421//9376 
f 9420//9375 9422//9377 9419//9374 
f 9418//9373 9420//9375 9417//9372 
f 9416//9371 9418//9373 9415//9370 
f 9414//9369 9416//9371 9413//9368 
f 9412//9367 9414//9369 9411//9366 
f 9410//9365 9412//9367 9409//9364 
f 9408//9363 9410//9365 9407//9362 
f 9406//9361 9408//9363 9405//9360 
f 9404//9359 9406//9361 9403//9358 
f 9402//9357 9404//9359 9401//9356 
f 9400//9355 9402//9357 9399//9354 
f 9398//9353 9400//9355 9397//9352 
f 9396//9351 9398//9353 9395//9350 
f 9394//9349 9396//9351 9393//9348 
f 9392//9347 9394//9349 9391//9346 
f 9390//9345 9392//9347 9389//9344 
f 9388//9343 9390//9345 9387//9342 
f 9386//9341 9388//9343 9385//9340 
f 9384//9339 9386//9341 9383//9338 
f 9382//9337 9384//9339 9381//9336 
f 9380//9335 9382//9337 9379//9334 
f 9378//9333 9380//9335 9377//9332 
f 9376//9331 9378//9333 9375//9330 
f 9374//9329 9376//9331 9373//9328 
f 9372//9327 9374//9329 9371//9326 
f 9370//9325 9372//9327 9368//9324 
o mesh4
f 9426//9380 9406//9380 9404//9380 
f 9426//9380 9427//9380 9408//9380 
f 9428//9380 9404//9380 9402//9380 
f 9408//9380 9406//9380 9426//9380 
f 9429//9380 9414//9380 9412//9380 
f 9429//9380 9430//9380 9416//9380 
f 9404//9380 9428//9380 9426//9380 
f 9427//9380 9431//9380 9410//9380 
f 9432//9380 9412//9380 9410//9380 
f 9416//9380 9414//9380 9429//9380 
f 9433//9380 9420//9380 9418//9380 
f 9433//9380 9434//9380 9422//9380 
f 9435//9380 9425//9380 9424//9380 
f 9436//9380 9370//9380 9425//9380 
f 9410//9380 9408//9380 9427//9380 
f 9412//9380 9432//9380 9429//9380 
f 9437//9380 9418//9380 9416//9380 
f 9422//9380 9420//9380 9433//9380 
f 9425//9380 9435//9380 9436//9380 
f 9438//9380 9372//9380 9370//9380 
f 9410//9380 9431//9380 9432//9380 
f 9418//9380 9437//9380 9433//9380 
f 9439//9380 9424//9380 9422//9380 
f 9370//9380 9436//9380 9438//9380 
f 9440//9380 9392//9380 9390//9380 
f 9441//9380 9394//9380 9392//9380 
f 9416//9380 9430//9380 9437//9380 
f 9424//9380 9439//9380 9435//9380 
f 9442//9380 9390//9380 9388//9380 
f 9392//9380 9440//9380 9441//9380 
f 9443//9380 9402//9380 9400//9380 
f 9422//9380 9434//9380 9439//9380 
f 9444//9380 9374//9380 9372//9380 
f 9445//9380 9376//9380 9374//9380 
f 9446//9380 9378//9380 9376//9380 
f 9447//9380 9380//9380 9378//9380 
f 9448//9380 9382//9380 9380//9380 
f 9448//9380 9449//9380 9384//9380 
f 9390//9380 9442//9380 9440//9380 
f 9450//9380 9396//9380 9394//9380 
f 9451//9380 9398//9380 9396//9380 
f 9452//9380 9400//9380 9398//9380 
f 9402//9380 9443//9380 9428//9380 
f 9374//9380 9444//9380 9445//9380 
f 9378//9380 9446//9380 9447//9380 
f 9384//9380 9382//9380 9448//9380 
f 9453//9380 9386//9380 9384//9380 
f 9454//9380 9388//9380 9386//9380 
f 9394//9380 9441//9380 9450//9380 
f 9398//9380 9451//9380 9452//9380 
f 9372//9380 9438//9380 9444//9380 
f 9380//9380 9447//9380 9448//9380 
f 9386//9380 9453//9380 9454//9380 
f 9396//9380 9450//9380 9451//9380 
f 9376//9380 9445//9380 9446//9380 
f 9388//9380 9454//9380 9442//9380 
f 9384//9380 9449//9380 9453//9380 
f 9400//9380 9452//9380 9443//9380 
o mesh5
f 9455//9381 9436//9381 9435//9382 
f 9456//9382 9435//9382 9439//9383 
f 9457//9383 9439//9383 9434//9384 
f 9458//9384 9434//9384 9433//9385 
f 9459//9385 9433//9385 9437//9386 
f 9460//9386 9437//9386 9430//9387 
f 9461//9387 9430//9387 9429//9388 
f 9462//9388 9429//9388 9432//9389 
f 9463//9389 9432//9389 9431//9390 
f 9464//9390 9431//9390 9427//9391 
f 9465//9391 9427//9391 9426//9392 
f 9466//9392 9426//9392 9428//9393 
f 9467//9393 9428//9393 9443//9394 
f 9468//9394 9443//9394 9452//9395 
f 9469//9395 9452//9395 9451//9396 
f 9470//9396 9451//9396 9450//9397 
f 9471//9397 9450//9397 9441//9398 
f 9472//9398 9441//9398 9440//9399 
f 9473//9399 9440//9399 9442//9400 
f 9474//9400 9442//9400 9454//9401 
f 9475//9401 9454//9401 9453//9402 
f 9476//9402 9453//9402 9449//9403 
f 9477//9403 9449//9403 9448//9404 
f 9478//9404 9448//9404 9447//9405 
f 9479//9405 9447//9405 9446//9406 
f 9480//9406 9446//9406 9445//9407 
f 9481//9407 9445//9407 9444//9408 
f 9482//9408 9444//9408 9438//9409 
f 9483//9409 9438//9409 9436//9381 
f 9436//9381 9455//9381 9483//9409 
f 9438//9409 9483//9409 9482//9408 
f 9444//9408 9482//9408 9481//9407 
f 9445//9407 9481//9407 9480//9406 
f 9446//9406 9480//9406 9479//9405 
f 9447//9405 9479//9405 9478//9404 
f 9448//9404 9478//9404 9477//9403 
f 9449//9403 9477//9403 9476//9402 
f 9453//9402 9476//9402 9475//9401 
f 9454//9401 9475//9401 9474//9400 
f 9442//9400 9474//9400 9473//9399 
f 9440//9399 9473//9399 9472//9398 
f 9441//9398 9472//9398 9471//9397 
f 9450//9397 9471//9397 9470//9396 
f 9451//9396 9470//9396 9469//9395 
f 9452//9395 9469//9395 9468//9394 
f 9443//9394 9468//9394 9467//9393 
f 9428//9393 9467//9393 9466//9392 
f 9426//9392 9466//9392 9465//9391 
f 9427//9391 9465//9391 9464//9390 
f 9431//9390 9464//9390 9463//9389 
f 9432//9389 9463//9389 9462//9388 
f 9429//9388 9462//9388 9461//9387 
f 9430//9387 9461//9387 9460//9386 
f 9437//9386 9460//9386 9459//9385 
f 9433//9385 9459//9385 9458//9384 
f 9434//9384 9458//9384 9457//9383 
f 9439//9383 9457//9383 9456//9382 
f 9435//9382 9456//9382 9455//9381 
o mesh6
f 9456//9410 9484//9410 9485//9411 
f 9485//9411 9455//9412 9456//9410 
f 9457//9413 9486//9413 9487//9414 
f 9487//9414 9456//9410 9457//9413 
f 9458//9415 9488//9415 9489//9416 
f 9489//9416 9457//9413 9458//9415 
f 9459//9417 9490//9417 9491//9418 
f 9491//9418 9458//9415 9459//9417 
f 9460//9419 9492//9419 9493//9420 
f 9493//9420 9459//9417 9460//9419 
f 9461//9421 9494//9421 9495//9422 
f 9495//9422 9460//9419 9461//9421 
f 9462//9423 9496//9423 9497//9424 
f 9497//9424 9461//9421 9462//9423 
f 9463//9425 9498//9425 9499//9426 
f 9499//9426 9462//9423 9463//9425 
f 9464//9427 9500//9427 9501//9428 
f 9501//9428 9463//9425 9464//9427 
f 9465//9429 9502//9429 9503//9430 
f 9503//9430 9464//9427 9465//9429 
f 9465//9429 9466//9431 9504//9432 
f 9466//9431 9505//9431 9504//9432 
f 9466//9431 9467//9433 9506//9434 
f 9467//9433 9507//9433 9506//9434 
f 9467//9433 9468//9435 9508//9436 
f 9468//9435 9509//9435 9508//9436 
f 9469//9437 9510//9437 9511//9438 
f 9511//9438 9468//9435 9469//9437 
f 9470//9439 9512//9439 9513//9440 
f 9513//9440 9469//9437 9470//9439 
f 9471//9441 9514//9441 9515//9442 
f 9515//9442 9470//9439 9471//9441 
f 9472//9443 9516//9443 9517//9444 
f 9517//9444 9471//9441 9472//9443 
f 9473//9445 9518//9445 9519//9446 
f 9519//9446 9472//9443 9473//9445 
f 9474//9447 9520//9447 9521//9448 
f 9521//9448 9473//9445 9474//9447 
f 9475//9449 9522//9449 9523//9450 
f 9523//9450 9474//9447 9475//9449 
f 9476//9451 9524//9451 9525//9452 
f 9525//9452 9475//9449 9476//9451 
f 9477//9453 9526//9453 9527//9454 
f 9527//9454 9476//9451 9477//9453 
f 9478//9455 9528//9455 9529//9456 
f 9529//9456 9477//9453 9478//9455 
f 9479//9457 9530//9457 9531//9458 
f 9531//9458 9478//9455 9479//9457 
f 9480//9459 9532//9459 9533//9460 
f 9533//9460 9479//9457 9480//9459 
f 9481//9461 9534//9461 9535//9462 
f 9535//9462 9480//9459 9481//9461 
f 9482//9463 9536//9463 9537//9464 
f 9537//9464 9481//9461 9482//9463 
f 9483//9465 9538//9465 9539//9466 
f 9539//9466 9482//9463 9483//9465 
f 9455//9412 9540//9467 9541//9468 
f 9541//9468 9483//9465 9455//9412 
f 9541//9468 9538//9465 9483//9465 
f 9539//9466 9536//9463 9482//9463 
f 9537//9464 9534//9461 9481//9461 
f 9535//9462 9532//9459 9480//9459 
f 9533//9460 9530//9457 9479//9457 
f 9531//9458 9528//9455 9478//9455 
f 9529//9456 9526//9453 9477//9453 
f 9527//9454 9524//9451 9476//9451 
f 9525//9452 9522//9449 9475//9449 
f 9523//9450 9520//9447 9474//9447 
f 9521//9448 9518//9445 9473//9445 
f 9519//9446 9516//9443 9472//9443 
f 9517//9444 9514//9441 9471//9441 
f 9515//9442 9512//9439 9470//9439 
f 9513//9440 9510//9437 9469//9437 
f 9511//9438 9509//9435 9468//9435 
f 9508//9436 9507//9433 9467//9433 
f 9506//9434 9505//9431 9466//9431 
f 9504//9432 9502//9429 9465//9429 
f 9503//9430 9500//9427 9464//9427 
f 9501//9428 9498//9425 9463//9425 
f 9499//9426 9496//9423 9462//9423 
f 9497//9424 9494//9421 9461//9421 
f 9495//9422 9492//9419 9460//9419 
f 9493//9420 9490//9417 9459//9417 
f 9491//9418 9488//9415 9458//9415 
f 9489//9416 9486//9413 9457//9413 
f 9487//9414 9484//9410 9456//9410 
f 9485//9411 9540//9467 9455//9412 
o mesh7
f 9542//9469 9511//9469 9510//9470 
f 9510//9470 9543//9471 9542//9469 
f 9544//9472 9508//9472 9509//9473 
f 9509//9473 9542//9469 9544//9472 
f 9545//9474 9506//9474 9507//9475 
f 9507//9475 9544//9472 9545//9474 
f 9546//9476 9504//9476 9505//9477 
f 9505//9477 9545//9474 9546//9476 
f 9547//9478 9503//9478 9502//9479 
f 9502//9479 9546//9476 9547//9478 
f 9548//9480 9501//9480 9500//9481 
f 9500//9481 9547//9478 9548//9480 
f 9549//9482 9499//9482 9498//9483 
f 9498//9483 9548//9480 9549//9482 
f 9550//9484 9497//9484 9496//9485 
f 9496//9485 9549//9482 9550//9484 
f 9551//9486 9495//9486 9494//9487 
f 9494//9487 9550//9484 9551//9486 
f 9552//9488 9493//9488 9492//9489 
f 9492//9489 9551//9486 9552//9488 
f 9553//9490 9491//9490 9490//9491 
f 9490//9491 9552//9488 9553//9490 
f 9554//9492 9489//9492 9488//9493 
f 9488//9493 9553//9490 9554//9492 
f 9555//9494 9487//9494 9486//9495 
f 9486//9495 9554//9492 9555//9494 
f 9556//9496 9485//9496 9484//9497 
f 9484//9497 9555//9494 9556//9496 
f 9541//9498 9540//9499 9557//9499 
f 9485//9496 9556//9496 9557//9499 
f 9557//9499 9540//9499 9485//9496 
f 9558//9498 9559//9500 9538//9501 
f 9559//9500 9539//9500 9538//9501 
f 9559//9500 9560//9502 9536//9503 
f 9560//9502 9537//9502 9536//9503 
f 9560//9502 9561//9504 9534//9505 
f 9561//9504 9535//9504 9534//9505 
f 9562//9506 9533//9506 9532//9507 
f 9532//9507 9561//9504 9562//9506 
f 9563//9508 9531//9508 9530//9509 
f 9530//9509 9562//9506 9563//9508 
f 9564//9510 9529//9510 9528//9511 
f 9528//9511 9563//9508 9564//9510 
f 9565//9512 9527//9512 9526//9513 
f 9526//9513 9564//9510 9565//9512 
f 9566//9514 9525//9514 9524//9515 
f 9524//9515 9565//9512 9566//9514 
f 9567//9516 9523//9516 9522//9517 
f 9522//9517 9566//9514 9567//9516 
f 9568//9518 9521//9518 9520//9519 
f 9520//9519 9567//9516 9568//9518 
f 9568//9518 9569//9520 9518//9521 
f 9569//9520 9519//9520 9518//9521 
f 9570//9522 9517//9522 9516//9523 
f 9516//9523 9569//9520 9570//9522 
f 9571//9524 9515//9524 9514//9525 
f 9514//9525 9570//9522 9571//9524 
f 9571//9524 9543//9471 9512//9526 
f 9543//9471 9513//9527 9512//9526 
f 9512//9526 9515//9524 9571//9524 
f 9514//9525 9517//9522 9570//9522 
f 9516//9523 9519//9520 9569//9520 
f 9518//9521 9521//9518 9568//9518 
f 9520//9519 9523//9516 9567//9516 
f 9522//9517 9525//9514 9566//9514 
f 9524//9515 9527//9512 9565//9512 
f 9526//9513 9529//9510 9564//9510 
f 9528//9511 9531//9508 9563//9508 
f 9530//9509 9533//9506 9562//9506 
f 9532//9507 9535//9504 9561//9504 
f 9534//9505 9537//9502 9560//9502 
f 9536//9503 9539//9500 9559//9500 
f 9538//9501 9541//9498 9558//9498 
f 9557//9499 9558//9498 9541//9498 
f 9484//9497 9487//9494 9555//9494 
f 9486//9495 9489//9492 9554//9492 
f 9488//9493 9491//9490 9553//9490 
f 9490//9491 9493//9488 9552//9488 
f 9492//9489 9495//9486 9551//9486 
f 9494//9487 9497//9484 9550//9484 
f 9496//9485 9499//9482 9549//9482 
f 9498//9483 9501//9480 9548//9480 
f 9500//9481 9503//9478 9547//9478 
f 9502//9479 9504//9476 9546//9476 
f 9505//9477 9506//9474 9545//9474 
f 9507//9475 9508//9472 9544//9472 
f 9509//9473 9511//9469 9542//9469 
f 9510//9470 9513//9527 9543//9471 
o mesh8
f 9556//9528 9555//9528 9423//9528 
f 9369//9528 9557//9528 9556//9528 
f 9555//9528 9554//9528 9421//9528 
f 9553//9528 9552//9528 9417//9528 
f 9552//9528 9551//9528 9415//9528 
f 9421//9528 9423//9528 9555//9528 
f 9554//9528 9553//9528 9419//9528 
f 9415//9528 9417//9528 9552//9528 
f 9551//9528 9550//9528 9413//9528 
f 9550//9528 9549//9528 9411//9528 
f 9549//9528 9548//9528 9409//9528 
f 9546//9528 9545//9528 9403//9528 
f 9545//9528 9544//9528 9401//9528 
f 9569//9528 9568//9528 9389//9528 
f 9568//9528 9567//9528 9387//9528 
f 9419//9528 9421//9528 9554//9528 
f 9413//9528 9415//9528 9551//9528 
f 9409//9528 9411//9528 9549//9528 
f 9548//9528 9547//9528 9407//9528 
f 9547//9528 9546//9528 9405//9528 
f 9401//9528 9403//9528 9545//9528 
f 9542//9528 9543//9528 9397//9528 
f 9543//9528 9571//9528 9395//9528 
f 9387//9528 9389//9528 9568//9528 
f 9567//9528 9566//9528 9385//9528 
f 9417//9528 9419//9528 9553//9528 
f 9407//9528 9409//9528 9548//9528 
f 9403//9528 9405//9528 9546//9528 
f 9544//9528 9542//9528 9399//9528 
f 9395//9528 9397//9528 9543//9528 
f 9571//9528 9570//9528 9393//9528 
f 9570//9528 9569//9528 9391//9528 
f 9385//9528 9387//9528 9567//9528 
f 9564//9528 9563//9528 9379//9528 
f 9563//9528 9562//9528 9377//9528 
f 9562//9528 9561//9528 9375//9528 
f 9561//9528 9560//9528 9373//9528 
f 9411//9528 9413//9528 9550//9528 
f 9399//9528 9401//9528 9544//9528 
f 9393//9528 9395//9528 9571//9528 
f 9389//9528 9391//9528 9569//9528 
f 9377//9528 9379//9528 9563//9528 
f 9373//9528 9375//9528 9561//9528 
f 9560//9528 9559//9528 9371//9528 
f 9559//9528 9558//9528 9368//9528 
f 9405//9528 9407//9528 9547//9528 
f 9391//9528 9393//9528 9570//9528 
f 9566//9528 9565//9528 9383//9528 
f 9565//9528 9564//9528 9381//9528 
f 9375//9528 9377//9528 9562//9528 
f 9368//9528 9371//9528 9559//9528 
f 9397//9528 9399//9528 9542//9528 
f 9381//9528 9383//9528 9565//9528 
f 9371//9528 9373//9528 9560//9528 
f 9558//9528 9557//9528 9369//9528 
f 9383//9528 9385//9528 9566//9528 
f 9369//9528 9368//9528 9558//9528 
f 9379//9528 9381//9528 9564//9528 
f 9423//9528 9369//9528 9556//9528 
g 20cm_T2020
v 0.226151 0.0178046 0.0885184 
v 0.226151 0.0178046 -0.111482 
v 0.222615 0.0213401 -0.111482 
v 0.222615 0.0213401 0.0885184 
v 0.218651 0.0213401 -0.111482 
v 0.218651 0.0213401 0.0885184 
v 0.218651 0.0173756 -0.111482 
v 0.218651 0.0173756 0.0885184 
v 0.222187 0.0138401 -0.111482 
v 0.222187 0.0138401 0.0885184 
v 0.222187 0.00884011 -0.111482 
v 0.222187 0.00884011 0.0885184 
v 0.218651 0.00530457 -0.111482 
v 0.218651 0.00530457 0.0885184 
v 0.218651 0.00134011 -0.111482 
v 0.218651 0.00134011 0.0885184 
v 0.222615 0.00134011 -0.111482 
v 0.222615 0.00134011 0.0885184 
v 0.226151 0.00487564 -0.111482 
v 0.226151 0.00487564 0.0885184 
v 0.231151 0.00487564 -0.111482 
v 0.231151 0.00487564 0.0885184 
v 0.234687 0.00134011 -0.111482 
v 0.234687 0.00134011 0.0885184 
v 0.238651 0.00134011 -0.111482 
v 0.238651 0.00134011 0.0885184 
v 0.238651 0.00530457 -0.111482 
v 0.238651 0.00530457 0.0885184 
v 0.235115 0.00884011 -0.111482 
v 0.235115 0.00884011 0.0885184 
v 0.235115 0.0138401 -0.111482 
v 0.235115 0.0138401 0.0885184 
v 0.238651 0.0173756 -0.111482 
v 0.238651 0.0173756 0.0885184 
v 0.238651 0.0213401 -0.111482 
v 0.238651 0.0213401 0.0885184 
v 0.234687 0.0213401 0.0885184 
v 0.231151 0.0178046 0.0885184 
v 0.234687 0.0213401 -0.111482 
v 0.231151 0.0178046 -0.111482 
vn 0.774969 0.624918 -0.0943424 
vn 0.19719 0.974688 -0.105358 
vn -0.989462 0.039186 -0.139391 
vn -0.588439 -0.797759 -0.131607 
vn -0.555147 0.822433 -0.124161 
vn -0.989462 0.039186 -0.139391 
vn 0.209252 -0.971449 -0.111803 
vn 0.800804 -0.590939 -0.0974875 
vn -0.588439 -0.797759 -0.131607 
vn 0.209252 -0.971449 -0.111803 
vn 0.995441 0.0258116 -0.0918159 
vn 0.774969 0.624918 -0.0943424 
vn 0.800804 -0.590939 -0.0974875 
vn 0.995441 0.0258116 -0.0918159 
vn 0.228477 0.034318 0.972944 
vn 0.18443 0.027702 -0.982455 
vn 0.19719 0.974688 -0.105358 
vn -0.555147 0.822433 -0.124161 
usemtl 0.301961_0.301961_0.301961_0.000000_0.000000
o mesh394
f 9572//9529 9573//9529 9574//9529 
f 9574//9529 9575//9529 9572//9529 
o mesh395
f 9575//9530 9574//9530 9576//9530 
f 9576//9530 9577//9530 9575//9530 
o mesh396
f 9577//9531 9576//9531 9578//9531 
f 9578//9531 9579//9531 9577//9531 
o mesh397
f 9579//9532 9578//9532 9580//9532 
f 9580//9532 9581//9532 9579//9532 
o mesh398
f 9581//9531 9580//9531 9582//9531 
f 9582//9531 9583//9531 9581//9531 
o mesh399
f 9583//9533 9582//9533 9584//9533 
f 9584//9533 9585//9533 9583//9533 
o mesh400
f 9585//9534 9584//9534 9586//9534 
f 9586//9534 9587//9534 9585//9534 
o mesh401
f 9587//9535 9586//9535 9588//9535 
f 9588//9535 9589//9535 9587//9535 
o mesh402
f 9589//9536 9588//9536 9590//9536 
f 9590//9536 9591//9536 9589//9536 
o mesh403
f 9591//9535 9590//9535 9592//9535 
f 9592//9535 9593//9535 9591//9535 
o mesh404
f 9593//9537 9592//9537 9594//9537 
f 9594//9537 9595//9537 9593//9537 
o mesh405
f 9595//9538 9594//9538 9596//9538 
f 9596//9538 9597//9538 9595//9538 
o mesh406
f 9597//9539 9596//9539 9598//9539 
f 9598//9539 9599//9539 9597//9539 
o mesh407
f 9599//9540 9598//9540 9600//9540 
f 9600//9540 9601//9540 9599//9540 
o mesh408
f 9601//9539 9600//9539 9602//9539 
f 9602//9539 9603//9539 9601//9539 
o mesh409
f 9603//9541 9602//9541 9604//9541 
f 9604//9541 9605//9541 9603//9541 
o mesh410
f 9605//9542 9604//9542 9606//9542 
f 9606//9542 9607//9542 9605//9542 
o mesh411
f 9595//9543 9597//9543 9599//9543 
f 9575//9543 9577//9543 9579//9543 
f 9591//9543 9603//9543 9572//9543 
f 9608//9543 9603//9543 9605//9543 
f 9601//9543 9593//9543 9595//9543 
f 9581//9543 9572//9543 9575//9543 
f 9572//9543 9581//9543 9591//9543 
f 9605//9543 9607//9543 9608//9543 
f 9599//9543 9601//9543 9595//9543 
f 9591//9543 9593//9543 9603//9543 
f 9585//9543 9587//9543 9589//9543 
f 9608//9543 9609//9543 9603//9543 
f 9579//9543 9581//9543 9575//9543 
f 9591//9543 9583//9543 9585//9543 
f 9601//9543 9603//9543 9593//9543 
f 9591//9543 9581//9543 9583//9543 
f 9589//9543 9591//9543 9585//9543 
f 9609//9543 9572//9543 9603//9543 
o mesh412
f 9598//9544 9596//9544 9594//9544 
f 9578//9544 9576//9544 9574//9544 
f 9602//9544 9590//9544 9580//9544 
f 9584//9544 9590//9544 9588//9544 
f 9592//9544 9600//9544 9598//9544 
f 9573//9544 9580//9544 9578//9544 
f 9580//9544 9573//9544 9602//9544 
f 9588//9544 9586//9544 9584//9544 
f 9594//9544 9592//9544 9598//9544 
f 9602//9544 9600//9544 9590//9544 
f 9610//9544 9606//9544 9604//9544 
f 9584//9544 9582//9544 9590//9544 
f 9574//9544 9573//9544 9578//9544 
f 9602//9544 9611//9544 9610//9544 
f 9592//9544 9590//9544 9600//9544 
f 9602//9544 9573//9544 9611//9544 
f 9604//9544 9602//9544 9610//9544 
f 9582//9544 9580//9544 9590//9544 
o mesh413
f 9607//9545 9606//9545 9610//9545 
f 9610//9545 9608//9545 9607//9545 
o mesh414
f 9608//9546 9610//9546 9611//9546 
f 9611//9546 9609//9546 9608//9546 
o mesh415
f 9609//9545 9611//9545 9573//9545 
f 9573//9545 9572//9545 9609//9545 
g 6mmSpacer
v -0.0686042 -0.138822 -0.0906911 
v -0.0686627 -0.139359 -0.0906911 
v -0.0686627 -0.139359 -0.0966911 
v -0.0684316 -0.13831 -0.0906911 
v -0.0686042 -0.138822 -0.0966911 
v -0.0681529 -0.137846 -0.0906911 
v -0.0684316 -0.13831 -0.0966911 
v -0.0677811 -0.137454 -0.0906911 
v -0.0681529 -0.137846 -0.0966911 
v -0.0673337 -0.137151 -0.0906911 
v -0.0677811 -0.137454 -0.0966911 
v -0.0668315 -0.136951 -0.0906911 
v -0.0673337 -0.137151 -0.0966911 
v -0.066298 -0.136863 -0.0906911 
v -0.0668315 -0.136951 -0.0966911 
v -0.0657582 -0.136892 -0.0906911 
v -0.066298 -0.136863 -0.0966911 
v -0.0652373 -0.137037 -0.0906911 
v -0.0657582 -0.136892 -0.0966911 
v -0.0647597 -0.13729 -0.0906911 
v -0.0652373 -0.137037 -0.0966911 
v -0.0643477 -0.13764 -0.0906911 
v -0.0647597 -0.13729 -0.0966911 
v -0.0640205 -0.13807 -0.0906911 
v -0.0643477 -0.13764 -0.0966911 
v -0.0637935 -0.138561 -0.0906911 
v -0.0640205 -0.13807 -0.0966911 
v -0.0636773 -0.139089 -0.0906911 
v -0.0637935 -0.138561 -0.0966911 
v -0.0636773 -0.13963 -0.0966911 
v -0.0636773 -0.13963 -0.0906911 
v -0.0636627 -0.139359 -0.0906911 
v -0.0636773 -0.139089 -0.0966911 
v -0.0636627 -0.139359 -0.0966911 
v -0.0637935 -0.140158 -0.0906911 
v -0.0640205 -0.140648 -0.0906911 
v -0.0637935 -0.140158 -0.0966911 
v -0.0643477 -0.141079 -0.0906911 
v -0.0640205 -0.140648 -0.0966911 
v -0.0647597 -0.141429 -0.0906911 
v -0.0643477 -0.141079 -0.0966911 
v -0.0652373 -0.141682 -0.0906911 
v -0.0647597 -0.141429 -0.0966911 
v -0.0657582 -0.141826 -0.0906911 
v -0.0652373 -0.141682 -0.0966911 
v -0.066298 -0.141856 -0.0906911 
v -0.0657582 -0.141826 -0.0966911 
v -0.0668315 -0.141768 -0.0906911 
v -0.066298 -0.141856 -0.0966911 
v -0.0673337 -0.141568 -0.0906911 
v -0.0668315 -0.141768 -0.0966911 
v -0.0677811 -0.141265 -0.0906911 
v -0.0673337 -0.141568 -0.0966911 
v -0.0681529 -0.140872 -0.0906911 
v -0.0677811 -0.141265 -0.0966911 
v -0.0684316 -0.140409 -0.0906911 
v -0.0681529 -0.140872 -0.0966911 
v -0.0686042 -0.139897 -0.0906911 
v -0.0684316 -0.140409 -0.0966911 
v -0.0686042 -0.139897 -0.0966911 
v -0.0639179 -0.14267 -0.0966911 
v -0.0646821 -0.143075 -0.0966911 
v -0.0655155 -0.143307 -0.0966911 
v -0.0663792 -0.143354 -0.0966911 
v -0.0646821 -0.135643 -0.0966911 
v -0.0639179 -0.136049 -0.0966911 
v -0.0632587 -0.136609 -0.0966911 
v -0.0672328 -0.143214 -0.0966911 
v -0.0680363 -0.142893 -0.0966911 
v -0.0687522 -0.142408 -0.0966911 
v -0.069347 -0.136939 -0.0966911 
v -0.0687522 -0.136311 -0.0966911 
v -0.0680363 -0.135825 -0.0966911 
v -0.0672328 -0.135505 -0.0966911 
v -0.0663792 -0.135365 -0.0966911 
v -0.069793 -0.141039 -0.0966911 
v -0.0700691 -0.140219 -0.0966911 
v -0.0655155 -0.135412 -0.0966911 
v -0.0627352 -0.137297 -0.0966911 
v -0.062372 -0.138082 -0.0966911 
v -0.0621861 -0.138927 -0.0966911 
v -0.0621627 -0.139359 -0.0966911 
v -0.0621861 -0.139792 -0.0966911 
v -0.062372 -0.140637 -0.0966911 
v -0.0627352 -0.141422 -0.0966911 
v -0.0632587 -0.14211 -0.0966911 
v -0.069347 -0.14178 -0.0966911 
v -0.0701627 -0.139359 -0.0966911 
v -0.069793 -0.13768 -0.0966911 
v -0.0700691 -0.138499 -0.0966911 
v -0.0701627 -0.139359 -0.0906911 
v -0.0700691 -0.140219 -0.0906911 
v -0.069793 -0.141039 -0.0906911 
v -0.069347 -0.14178 -0.0906911 
v -0.0687522 -0.142408 -0.0906911 
v -0.0680363 -0.142893 -0.0906911 
v -0.0672328 -0.143214 -0.0906911 
v -0.0663792 -0.143354 -0.0906911 
v -0.0655155 -0.143307 -0.0906911 
v -0.0646821 -0.143075 -0.0906911 
v -0.0639179 -0.14267 -0.0906911 
v -0.0632587 -0.14211 -0.0906911 
v -0.0627352 -0.141422 -0.0906911 
v -0.062372 -0.140637 -0.0906911 
v -0.0621861 -0.138927 -0.0906911 
v -0.0621627 -0.139359 -0.0906911 
v -0.0621861 -0.139792 -0.0906911 
v -0.062372 -0.138082 -0.0906911 
v -0.0627352 -0.137297 -0.0906911 
v -0.0632587 -0.136609 -0.0906911 
v -0.0639179 -0.136049 -0.0906911 
v -0.0646821 -0.135643 -0.0906911 
v -0.0655155 -0.135412 -0.0906911 
v -0.0663792 -0.135365 -0.0906911 
v -0.0672328 -0.135505 -0.0906911 
v -0.0680363 -0.135825 -0.0906911 
v -0.0687522 -0.136311 -0.0906911 
v -0.069347 -0.136939 -0.0906911 
v -0.069793 -0.13768 -0.0906911 
v -0.0700691 -0.138499 -0.0906911 
vn 0.932829 -0.349068 -0.0893443 
vn 0.985633 -0.141566 -0.0921271 
vn 0.840208 -0.535271 -0.0868028 
vn 0.932829 -0.349068 -0.0893443 
vn 0.714678 -0.694321 -0.0845748 
vn 0.840208 -0.535271 -0.0868028 
vn 0.563262 -0.822129 -0.0827044 
vn 0.714678 -0.694321 -0.0845748 
vn 0.392849 -0.91601 -0.0812164 
vn 0.563262 -0.822129 -0.0827044 
vn 0.210089 -0.974394 -0.0801234 
vn 0.392849 -0.91601 -0.0812164 
vn 0.0213781 -0.996611 -0.0794308 
vn 0.210089 -0.974394 -0.0801234 
vn -0.167121 -0.982755 -0.0791407 
vn 0.0213781 -0.996611 -0.0794308 
vn -0.349438 -0.933601 -0.0792535 
vn -0.167121 -0.982755 -0.0791407 
vn -0.519752 -0.850585 -0.079769 
vn -0.349438 -0.933601 -0.0792535 
vn -0.672355 -0.735818 -0.0806862 
vn -0.519752 -0.850585 -0.079769 
vn -0.801637 -0.592161 -0.0820013 
vn -0.672355 -0.735818 -0.0806862 
vn -0.902099 -0.423332 -0.0837055 
vn -0.801637 -0.592161 -0.0820013 
vn -0.968426 -0.234078 -0.0857803 
vn -0.902099 -0.423332 -0.0837055 
vn -0.99564 -0.0303791 -0.0881908 
vn -0.987213 -0.133605 -0.0869465 
vn -0.968426 -0.234078 -0.0857803 
vn -0.979402 0.180314 -0.0908784 
vn -0.916503 0.388888 -0.0937512 
vn -0.805596 0.584525 -0.0966758 
vn -0.648145 0.754992 -0.0994742 
vn -0.449428 0.887482 -0.101931 
vn -0.219233 0.970133 -0.103818 
vn 0.0282413 0.994078 -0.104931 
vn 0.275679 0.955483 -0.105138 
vn 0.505054 0.856749 -0.104413 
vn 0.700433 0.706269 -0.102845 
vn 0.850193 0.516769 -0.100612 
vn 0.947965 0.302938 -0.0979353 
vn 0.992315 0.0792383 -0.0950418 
vn -0.0270284 -0.126695 -0.991573 
vn -0.987213 -0.133605 -0.0869465 
vn -0.939852 -0.330916 -0.0846983 
vn -0.855808 -0.510623 -0.0828057 
vn -0.740258 -0.66739 -0.0812944 
vn -0.59862 -0.79701 -0.0801775 
vn -0.436455 -0.89621 -0.079461 
vn -0.259419 -0.962516 -0.0791467 
vn -0.0732751 -0.994159 -0.0792354 
vn 0.116087 -0.990034 -0.0797269 
vn 0.302606 -0.9497 -0.0806201 
vn 0.480008 -0.873432 -0.0819116 
vn 0.641771 -0.762327 -0.083593 
vn 0.781117 -0.618483 -0.0856463 
vn 0.891071 -0.445244 -0.0880381 
vn 0.964623 -0.247534 -0.0907114 
vn 0.99509 -0.0322343 -0.0935764 
vn 0.985633 -0.141566 -0.0921271 
vn 0.964623 -0.247534 -0.0907114 
vn 0.976742 0.191473 -0.0965025 
vn 0.905772 0.411964 -0.0993142 
vn 0.781538 0.615496 -0.101798 
vn 0.607838 0.787257 -0.103725 
vn 0.3937 0.913235 -0.104889 
vn 0.153108 0.982599 -0.105152 
vn -0.0966224 0.989822 -0.104482 
vn -0.337472 0.935688 -0.10296 
vn -0.553443 0.82677 -0.10076 
vn -0.732459 0.673706 -0.0981035 
vn -0.867037 0.489062 -0.0952171 
vn -0.953923 0.285503 -0.092299 
vn -0.993187 0.074622 -0.0895048 
vn -0.0323012 -0.151411 0.987943 
usemtl 0.647059_0.647059_0.647059_0.000000_0.000000
o mesh268
f 9612//9547 9613//9548 9614//9548 
f 9615//9549 9612//9547 9616//9550 
f 9617//9551 9615//9549 9618//9552 
f 9619//9553 9617//9551 9620//9554 
f 9621//9555 9619//9553 9622//9556 
f 9623//9557 9621//9555 9624//9558 
f 9625//9559 9623//9557 9626//9560 
f 9627//9561 9625//9559 9628//9562 
f 9629//9563 9627//9561 9630//9564 
f 9631//9565 9629//9563 9632//9566 
f 9633//9567 9631//9565 9634//9568 
f 9635//9569 9633//9567 9636//9570 
f 9637//9571 9635//9569 9638//9572 
f 9639//9573 9637//9571 9640//9574 
f 9641//9575 9642//9575 9643//9576 
f 9639//9573 9644//9577 9645//9576 
f 9645//9576 9643//9576 9639//9573 
f 9646//9578 9642//9575 9641//9575 
f 9647//9579 9646//9578 9648//9578 
f 9649//9580 9647//9579 9650//9579 
f 9651//9581 9649//9580 9652//9580 
f 9653//9582 9651//9581 9654//9581 
f 9655//9583 9653//9582 9656//9582 
f 9657//9584 9655//9583 9658//9583 
f 9659//9585 9657//9584 9660//9584 
f 9661//9586 9659//9585 9662//9585 
f 9663//9587 9661//9586 9664//9586 
f 9665//9588 9663//9587 9666//9587 
f 9667//9589 9665//9588 9668//9588 
f 9669//9590 9667//9589 9670//9589 
f 9613//9548 9669//9590 9671//9590 
f 9671//9590 9614//9548 9613//9548 
f 9670//9589 9671//9590 9669//9590 
f 9668//9588 9670//9589 9667//9589 
f 9666//9587 9668//9588 9665//9588 
f 9664//9586 9666//9587 9663//9587 
f 9662//9585 9664//9586 9661//9586 
f 9660//9584 9662//9585 9659//9585 
f 9658//9583 9660//9584 9657//9584 
f 9656//9582 9658//9583 9655//9583 
f 9654//9581 9656//9582 9653//9582 
f 9652//9580 9654//9581 9651//9581 
f 9650//9579 9652//9580 9649//9580 
f 9648//9578 9650//9579 9647//9579 
f 9641//9575 9648//9578 9646//9578 
f 9643//9576 9645//9576 9641//9575 
f 9640//9574 9644//9577 9639//9573 
f 9638//9572 9640//9574 9637//9571 
f 9636//9570 9638//9572 9635//9569 
f 9634//9568 9636//9570 9633//9567 
f 9632//9566 9634//9568 9631//9565 
f 9630//9564 9632//9566 9629//9563 
f 9628//9562 9630//9564 9627//9561 
f 9626//9560 9628//9562 9625//9559 
f 9624//9558 9626//9560 9623//9557 
f 9622//9556 9624//9558 9621//9555 
f 9620//9554 9622//9556 9619//9553 
f 9618//9552 9620//9554 9617//9551 
f 9616//9550 9618//9552 9615//9549 
f 9614//9548 9616//9550 9612//9547 
o mesh269
f 9672//9591 9654//9591 9652//9591 
f 9672//9591 9673//9591 9656//9591 
f 9674//9591 9658//9591 9656//9591 
f 9674//9591 9675//9591 9660//9591 
f 9656//9591 9654//9591 9672//9591 
f 9660//9591 9658//9591 9674//9591 
f 9676//9591 9677//9591 9634//9591 
f 9677//9591 9678//9591 9636//9591 
f 9656//9591 9673//9591 9674//9591 
f 9679//9591 9662//9591 9660//9591 
f 9680//9591 9664//9591 9662//9591 
f 9681//9591 9666//9591 9664//9591 
f 9682//9591 9683//9591 9622//9591 
f 9683//9591 9684//9591 9624//9591 
f 9684//9591 9685//9591 9626//9591 
f 9685//9591 9686//9591 9628//9591 
f 9676//9591 9632//9591 9630//9591 
f 9636//9591 9634//9591 9677//9591 
f 9660//9591 9675//9591 9679//9591 
f 9664//9591 9680//9591 9681//9591 
f 9687//9591 9670//9591 9668//9591 
f 9687//9591 9688//9591 9671//9591 
f 9624//9591 9622//9591 9683//9591 
f 9628//9591 9626//9591 9685//9591 
f 9689//9591 9630//9591 9628//9591 
f 9634//9591 9632//9591 9676//9591 
f 9690//9591 9638//9591 9636//9591 
f 9690//9591 9691//9591 9640//9591 
f 9692//9591 9644//9591 9640//9591 
f 9692//9591 9693//9591 9645//9591 
f 9694//9591 9641//9591 9645//9591 
f 9694//9591 9695//9591 9648//9591 
f 9696//9591 9650//9591 9648//9591 
f 9696//9591 9697//9591 9652//9591 
f 9662//9591 9679//9591 9680//9591 
f 9698//9591 9668//9591 9666//9591 
f 9671//9591 9670//9591 9687//9591 
f 9688//9591 9699//9591 9614//9591 
f 9700//9591 9618//9591 9616//9591 
f 9700//9591 9682//9591 9620//9591 
f 9626//9591 9624//9591 9684//9591 
f 9630//9591 9689//9591 9676//9591 
f 9640//9591 9638//9591 9690//9591 
f 9645//9591 9644//9591 9692//9591 
f 9648//9591 9641//9591 9694//9591 
f 9652//9591 9650//9591 9696//9591 
f 9666//9591 9681//9591 9698//9591 
f 9614//9591 9671//9591 9688//9591 
f 9701//9591 9616//9591 9614//9591 
f 9620//9591 9618//9591 9700//9591 
f 9628//9591 9686//9591 9689//9591 
f 9640//9591 9691//9591 9692//9591 
f 9648//9591 9695//9591 9696//9591 
f 9668//9591 9698//9591 9687//9591 
f 9616//9591 9701//9591 9700//9591 
f 9636//9591 9678//9591 9690//9591 
f 9652//9591 9697//9591 9672//9591 
f 9622//9591 9620//9591 9682//9591 
f 9614//9591 9699//9591 9701//9591 
f 9645//9591 9693//9591 9694//9591 
o mesh270
f 9702//9592 9699//9592 9688//9593 
f 9703//9593 9688//9593 9687//9594 
f 9704//9594 9687//9594 9698//9595 
f 9705//9595 9698//9595 9681//9596 
f 9706//9596 9681//9596 9680//9597 
f 9707//9597 9680//9597 9679//9598 
f 9708//9598 9679//9598 9675//9599 
f 9709//9599 9675//9599 9674//9600 
f 9710//9600 9674//9600 9673//9601 
f 9711//9601 9673//9601 9672//9602 
f 9712//9602 9672//9602 9697//9603 
f 9713//9603 9697//9603 9696//9604 
f 9714//9604 9696//9604 9695//9605 
f 9715//9605 9695//9605 9694//9606 
f 9692//9607 9716//9607 9717//9608 
f 9718//9609 9694//9606 9693//9608 
f 9693//9608 9717//9608 9718//9609 
f 9716//9607 9692//9607 9691//9610 
f 9719//9610 9691//9610 9690//9611 
f 9720//9611 9690//9611 9678//9612 
f 9721//9612 9678//9612 9677//9613 
f 9722//9613 9677//9613 9676//9614 
f 9723//9614 9676//9614 9689//9615 
f 9724//9615 9689//9615 9686//9616 
f 9725//9616 9686//9616 9685//9617 
f 9726//9617 9685//9617 9684//9618 
f 9727//9618 9684//9618 9683//9619 
f 9728//9619 9683//9619 9682//9620 
f 9729//9620 9682//9620 9700//9621 
f 9730//9621 9700//9621 9701//9622 
f 9731//9622 9701//9622 9699//9592 
f 9699//9592 9702//9592 9731//9622 
f 9701//9622 9731//9622 9730//9621 
f 9700//9621 9730//9621 9729//9620 
f 9682//9620 9729//9620 9728//9619 
f 9683//9619 9728//9619 9727//9618 
f 9684//9618 9727//9618 9726//9617 
f 9685//9617 9726//9617 9725//9616 
f 9686//9616 9725//9616 9724//9615 
f 9689//9615 9724//9615 9723//9614 
f 9676//9614 9723//9614 9722//9613 
f 9677//9613 9722//9613 9721//9612 
f 9678//9612 9721//9612 9720//9611 
f 9690//9611 9720//9611 9719//9610 
f 9691//9610 9719//9610 9716//9607 
f 9717//9608 9693//9608 9692//9607 
f 9694//9606 9718//9609 9715//9605 
f 9695//9605 9715//9605 9714//9604 
f 9696//9604 9714//9604 9713//9603 
f 9697//9603 9713//9603 9712//9602 
f 9672//9602 9712//9602 9711//9601 
f 9673//9601 9711//9601 9710//9600 
f 9674//9600 9710//9600 9709//9599 
f 9675//9599 9709//9599 9708//9598 
f 9679//9598 9708//9598 9707//9597 
f 9680//9597 9707//9597 9706//9596 
f 9681//9596 9706//9596 9705//9595 
f 9698//9595 9705//9595 9704//9594 
f 9687//9594 9704//9594 9703//9593 
f 9688//9593 9703//9593 9702//9592 
o mesh271
f 9706//9623 9707//9623 9661//9623 
f 9707//9623 9708//9623 9659//9623 
f 9718//9623 9717//9623 9643//9623 
f 9716//9623 9639//9623 9643//9623 
f 9705//9623 9706//9623 9663//9623 
f 9659//9623 9661//9623 9707//9623 
f 9718//9623 9642//9623 9646//9623 
f 9643//9623 9717//9623 9716//9623 
f 9722//9623 9631//9623 9633//9623 
f 9723//9623 9629//9623 9631//9623 
f 9661//9623 9663//9623 9706//9623 
f 9708//9623 9709//9623 9657//9623 
f 9710//9623 9655//9623 9657//9623 
f 9710//9623 9711//9623 9653//9623 
f 9714//9623 9647//9623 9649//9623 
f 9714//9623 9715//9623 9646//9623 
f 9643//9623 9642//9623 9718//9623 
f 9716//9623 9719//9623 9637//9623 
f 9631//9623 9722//9623 9723//9623 
f 9723//9623 9724//9623 9627//9623 
f 9726//9623 9623//9623 9625//9623 
f 9727//9623 9621//9623 9623//9623 
f 9728//9623 9619//9623 9621//9623 
f 9729//9623 9617//9623 9619//9623 
f 9704//9623 9667//9623 9669//9623 
f 9704//9623 9705//9623 9665//9623 
f 9657//9623 9659//9623 9708//9623 
f 9653//9623 9655//9623 9710//9623 
f 9712//9623 9651//9623 9653//9623 
f 9712//9623 9713//9623 9649//9623 
f 9646//9623 9647//9623 9714//9623 
f 9637//9623 9639//9623 9716//9623 
f 9720//9623 9635//9623 9637//9623 
f 9720//9623 9721//9623 9633//9623 
f 9627//9623 9629//9623 9723//9623 
f 9724//9623 9725//9623 9625//9623 
f 9623//9623 9726//9623 9727//9623 
f 9619//9623 9728//9623 9729//9623 
f 9703//9623 9669//9623 9613//9623 
f 9665//9623 9667//9623 9704//9623 
f 9657//9623 9709//9623 9710//9623 
f 9649//9623 9651//9623 9712//9623 
f 9646//9623 9715//9623 9718//9623 
f 9633//9623 9635//9623 9720//9623 
f 9625//9623 9627//9623 9724//9623 
f 9621//9623 9727//9623 9728//9623 
f 9669//9623 9703//9623 9704//9623 
f 9653//9623 9711//9623 9712//9623 
f 9637//9623 9719//9623 9720//9623 
f 9625//9623 9725//9623 9726//9623 
f 9730//9623 9615//9623 9617//9623 
f 9730//9623 9731//9623 9612//9623 
f 9663//9623 9665//9623 9705//9623 
f 9633//9623 9721//9623 9722//9623 
f 9612//9623 9615//9623 9730//9623 
f 9731//9623 9702//9623 9613//9623 
f 9649//9623 9713//9623 9714//9623 
f 9613//9623 9612//9623 9731//9623 
f 9617//9623 9729//9623 9730//9623 
f 9613//9623 9702//9623 9703//9623 
g 6mmSpacer
v -0.0686042 -0.00882196 -0.0906911 
v -0.0686627 -0.00935938 -0.0906911 
v -0.0686627 -0.00935938 -0.0966911 
v -0.0684316 -0.00830966 -0.0906911 
v -0.0686042 -0.00882196 -0.0966911 
v -0.0681529 -0.00784645 -0.0906911 
v -0.0684316 -0.00830966 -0.0966911 
v -0.0677811 -0.00745398 -0.0906911 
v -0.0681529 -0.00784645 -0.0966911 
v -0.0673337 -0.0071506 -0.0906911 
v -0.0677811 -0.00745398 -0.0966911 
v -0.0668315 -0.00695051 -0.0906911 
v -0.0673337 -0.0071506 -0.0966911 
v -0.066298 -0.00686305 -0.0906911 
v -0.0668315 -0.00695051 -0.0966911 
v -0.0657582 -0.00689231 -0.0906911 
v -0.066298 -0.00686305 -0.0966911 
v -0.0652373 -0.00703694 -0.0906911 
v -0.0657582 -0.00689231 -0.0966911 
v -0.0647597 -0.00729016 -0.0906911 
v -0.0652373 -0.00703694 -0.0966911 
v -0.0643477 -0.00764013 -0.0906911 
v -0.0647597 -0.00729016 -0.0966911 
v -0.0640205 -0.0080705 -0.0906911 
v -0.0643477 -0.00764013 -0.0966911 
v -0.0637935 -0.00856113 -0.0906911 
v -0.0640205 -0.0080705 -0.0966911 
v -0.0636773 -0.00908908 -0.0906911 
v -0.0637935 -0.00856113 -0.0966911 
v -0.0636773 -0.00962968 -0.0966911 
v -0.0636773 -0.00962968 -0.0906911 
v -0.0636627 -0.00935938 -0.0906911 
v -0.0636773 -0.00908908 -0.0966911 
v -0.0636627 -0.00935938 -0.0966911 
v -0.0637935 -0.0101576 -0.0906911 
v -0.0640205 -0.0106483 -0.0906911 
v -0.0637935 -0.0101576 -0.0966911 
v -0.0643477 -0.0110786 -0.0906911 
v -0.0640205 -0.0106483 -0.0966911 
v -0.0647597 -0.0114286 -0.0906911 
v -0.0643477 -0.0110786 -0.0966911 
v -0.0652373 -0.0116818 -0.0906911 
v -0.0647597 -0.0114286 -0.0966911 
v -0.0657582 -0.0118264 -0.0906911 
v -0.0652373 -0.0116818 -0.0966911 
v -0.066298 -0.0118557 -0.0906911 
v -0.0657582 -0.0118264 -0.0966911 
v -0.0668315 -0.0117683 -0.0906911 
v -0.066298 -0.0118557 -0.0966911 
v -0.0673337 -0.0115682 -0.0906911 
v -0.0668315 -0.0117683 -0.0966911 
v -0.0677811 -0.0112648 -0.0906911 
v -0.0673337 -0.0115682 -0.0966911 
v -0.0681529 -0.0108723 -0.0906911 
v -0.0677811 -0.0112648 -0.0966911 
v -0.0684316 -0.0104091 -0.0906911 
v -0.0681529 -0.0108723 -0.0966911 
v -0.0686042 -0.00989681 -0.0906911 
v -0.0684316 -0.0104091 -0.0966911 
v -0.0686042 -0.00989681 -0.0966911 
v -0.0639179 -0.0126701 -0.0966911 
v -0.0646821 -0.0130753 -0.0966911 
v -0.0655155 -0.0133067 -0.0966911 
v -0.0663792 -0.0133535 -0.0966911 
v -0.0646821 -0.00564347 -0.0966911 
v -0.0639179 -0.00604863 -0.0966911 
v -0.0632587 -0.00660858 -0.0966911 
v -0.0672328 -0.0132136 -0.0966911 
v -0.0680363 -0.0128934 -0.0966911 
v -0.0687522 -0.012408 -0.0966911 
v -0.069347 -0.00693868 -0.0966911 
v -0.0687522 -0.00631073 -0.0966911 
v -0.0680363 -0.00582533 -0.0966911 
v -0.0672328 -0.00550518 -0.0966911 
v -0.0663792 -0.00536525 -0.0966911 
v -0.069793 -0.0110389 -0.0966911 
v -0.0700691 -0.0102193 -0.0966911 
v -0.0655155 -0.00541208 -0.0966911 
v -0.0627352 -0.00729717 -0.0966911 
v -0.062372 -0.00808218 -0.0966911 
v -0.0621861 -0.00892691 -0.0966911 
v -0.0621627 -0.00935938 -0.0966911 
v -0.0621861 -0.00979186 -0.0966911 
v -0.062372 -0.0106366 -0.0966911 
v -0.0627352 -0.0114216 -0.0966911 
v -0.0632587 -0.0121102 -0.0966911 
v -0.069347 -0.0117801 -0.0966911 
v -0.0701627 -0.00935938 -0.0966911 
v -0.069793 -0.00767982 -0.0966911 
v -0.0700691 -0.0084995 -0.0966911 
v -0.0701627 -0.00935938 -0.0906911 
v -0.0700691 -0.0102193 -0.0906911 
v -0.069793 -0.0110389 -0.0906911 
v -0.069347 -0.0117801 -0.0906911 
v -0.0687522 -0.012408 -0.0906911 
v -0.0680363 -0.0128934 -0.0906911 
v -0.0672328 -0.0132136 -0.0906911 
v -0.0663792 -0.0133535 -0.0906911 
v -0.0655155 -0.0133067 -0.0906911 
v -0.0646821 -0.0130753 -0.0906911 
v -0.0639179 -0.0126701 -0.0906911 
v -0.0632587 -0.0121102 -0.0906911 
v -0.0627352 -0.0114216 -0.0906911 
v -0.062372 -0.0106366 -0.0906911 
v -0.0621861 -0.00892691 -0.0906911 
v -0.0621627 -0.00935938 -0.0906911 
v -0.0621861 -0.00979186 -0.0906911 
v -0.062372 -0.00808218 -0.0906911 
v -0.0627352 -0.00729717 -0.0906911 
v -0.0632587 -0.00660858 -0.0906911 
v -0.0639179 -0.00604863 -0.0906911 
v -0.0646821 -0.00564347 -0.0906911 
v -0.0655155 -0.00541208 -0.0906911 
v -0.0663792 -0.00536525 -0.0906911 
v -0.0672328 -0.00550518 -0.0906911 
v -0.0680363 -0.00582533 -0.0906911 
v -0.0687522 -0.00631073 -0.0906911 
v -0.069347 -0.00693868 -0.0906911 
v -0.069793 -0.00767982 -0.0906911 
v -0.0700691 -0.0084995 -0.0906911 
vn 0.968866 -0.229536 -0.0927959 
vn 0.995614 -0.00960386 -0.0930601 
vn 0.894508 -0.437396 -0.0924126 
vn 0.968866 -0.229536 -0.0927959 
vn 0.776848 -0.622941 -0.0919319 
vn 0.894508 -0.437396 -0.0924126 
vn 0.622351 -0.777386 -0.0913805 
vn 0.776848 -0.622941 -0.0919319 
vn 0.439143 -0.893818 -0.0907873 
vn 0.622351 -0.777386 -0.0913805 
vn 0.236463 -0.967446 -0.0901819 
vn 0.439143 -0.893818 -0.0907873 
vn 0.0241131 -0.995687 -0.0895928 
vn 0.236463 -0.967446 -0.0901819 
vn -0.188038 -0.978117 -0.0890461 
vn 0.0241131 -0.995687 -0.0895928 
vn -0.390493 -0.916336 -0.0885648 
vn -0.188038 -0.978117 -0.0890461 
vn -0.574476 -0.813759 -0.0881678 
vn -0.390493 -0.916336 -0.0885648 
vn -0.732219 -0.675377 -0.0878702 
vn -0.574476 -0.813759 -0.0881678 
vn -0.857178 -0.507501 -0.0876828 
vn -0.732219 -0.675377 -0.0878702 
vn -0.944201 -0.317503 -0.0876122 
vn -0.857178 -0.507501 -0.0876828 
vn -0.989657 -0.113553 -0.0876608 
vn -0.944201 -0.317503 -0.0876122 
vn -0.991534 0.0956408 -0.087827 
vn -0.996103 -0.00905374 -0.0877295 
vn -0.989657 -0.113553 -0.0876608 
vn -0.949512 0.301104 -0.088105 
vn -0.865017 0.493879 -0.0884846 
vn -0.741231 0.66533 -0.0889517 
vn -0.583078 0.807473 -0.0894879 
vn -0.397134 0.91333 -0.0900711 
vn -0.191479 0.977299 -0.0906755 
vn 0.0245654 0.995523 -0.0912732 
vn 0.240796 0.966221 -0.0918346 
vn 0.446608 0.889953 -0.0923304 
vn 0.631566 0.769756 -0.0927335 
vn 0.786052 0.611122 -0.0930211 
vn 0.901899 0.421778 -0.0931761 
vn 0.972974 0.211275 -0.0931894 
vn -0.027247 -0.00857765 -0.999592 
vn -0.996103 -0.00905374 -0.0877295 
vn -0.97229 -0.216737 -0.0876216 
vn -0.905696 -0.414772 -0.0876326 
vn -0.799153 -0.594687 -0.0877622 
vn -0.657067 -0.748677 -0.0880058 
vn -0.485305 -0.869869 -0.0883547 
vn -0.291047 -0.952579 -0.088796 
vn -0.0825943 -0.992573 -0.0893126 
vn 0.130876 -0.987316 -0.0898836 
vn 0.339632 -0.936196 -0.0904843 
vn 0.533778 -0.840704 -0.0910872 
vn 0.703729 -0.704531 -0.0916633 
vn 0.840732 -0.533547 -0.0921828 
vn 0.937425 -0.335644 -0.0926179 
vn 0.988365 -0.120397 -0.092944 
vn 0.990473 0.101429 -0.0931422 
vn 0.995614 -0.00960386 -0.0930601 
vn 0.988365 -0.120397 -0.092944 
vn 0.943324 0.318519 -0.0932007 
vn 0.849242 0.519729 -0.0931159 
vn 0.71317 0.694809 -0.092893 
vn 0.542321 0.835059 -0.0925451 
vn 0.345668 0.933827 -0.0920924 
vn 0.133317 0.986835 -0.0915603 
vn -0.0841335 0.992293 -0.0909771 
vn -0.296214 0.950837 -0.0903723 
vn -0.493108 0.865324 -0.0897752 
vn -0.666077 0.740529 -0.0892125 
vn -0.807768 0.582788 -0.0887083 
vn -0.912416 0.399628 -0.0882829 
vn -0.975963 0.199402 -0.0879526 
vn -0.0326762 -0.0102868 0.999413 
o mesh268
f 9732//9624 9733//9625 9734//9625 
f 9735//9626 9732//9624 9736//9627 
f 9737//9628 9735//9626 9738//9629 
f 9739//9630 9737//9628 9740//9631 
f 9741//9632 9739//9630 9742//9633 
f 9743//9634 9741//9632 9744//9635 
f 9745//9636 9743//9634 9746//9637 
f 9747//9638 9745//9636 9748//9639 
f 9749//9640 9747//9638 9750//9641 
f 9751//9642 9749//9640 9752//9643 
f 9753//9644 9751//9642 9754//9645 
f 9755//9646 9753//9644 9756//9647 
f 9757//9648 9755//9646 9758//9649 
f 9759//9650 9757//9648 9760//9651 
f 9761//9652 9762//9652 9763//9653 
f 9759//9650 9764//9654 9765//9653 
f 9765//9653 9763//9653 9759//9650 
f 9766//9655 9762//9652 9761//9652 
f 9767//9656 9766//9655 9768//9655 
f 9769//9657 9767//9656 9770//9656 
f 9771//9658 9769//9657 9772//9657 
f 9773//9659 9771//9658 9774//9658 
f 9775//9660 9773//9659 9776//9659 
f 9777//9661 9775//9660 9778//9660 
f 9779//9662 9777//9661 9780//9661 
f 9781//9663 9779//9662 9782//9662 
f 9783//9664 9781//9663 9784//9663 
f 9785//9665 9783//9664 9786//9664 
f 9787//9666 9785//9665 9788//9665 
f 9789//9667 9787//9666 9790//9666 
f 9733//9625 9789//9667 9791//9667 
f 9791//9667 9734//9625 9733//9625 
f 9790//9666 9791//9667 9789//9667 
f 9788//9665 9790//9666 9787//9666 
f 9786//9664 9788//9665 9785//9665 
f 9784//9663 9786//9664 9783//9664 
f 9782//9662 9784//9663 9781//9663 
f 9780//9661 9782//9662 9779//9662 
f 9778//9660 9780//9661 9777//9661 
f 9776//9659 9778//9660 9775//9660 
f 9774//9658 9776//9659 9773//9659 
f 9772//9657 9774//9658 9771//9658 
f 9770//9656 9772//9657 9769//9657 
f 9768//9655 9770//9656 9767//9656 
f 9761//9652 9768//9655 9766//9655 
f 9763//9653 9765//9653 9761//9652 
f 9760//9651 9764//9654 9759//9650 
f 9758//9649 9760//9651 9757//9648 
f 9756//9647 9758//9649 9755//9646 
f 9754//9645 9756//9647 9753//9644 
f 9752//9643 9754//9645 9751//9642 
f 9750//9641 9752//9643 9749//9640 
f 9748//9639 9750//9641 9747//9638 
f 9746//9637 9748//9639 9745//9636 
f 9744//9635 9746//9637 9743//9634 
f 9742//9633 9744//9635 9741//9632 
f 9740//9631 9742//9633 9739//9630 
f 9738//9629 9740//9631 9737//9628 
f 9736//9627 9738//9629 9735//9626 
f 9734//9625 9736//9627 9732//9624 
o mesh269
f 9792//9668 9774//9668 9772//9668 
f 9792//9668 9793//9668 9776//9668 
f 9794//9668 9778//9668 9776//9668 
f 9794//9668 9795//9668 9780//9668 
f 9776//9668 9774//9668 9792//9668 
f 9780//9668 9778//9668 9794//9668 
f 9796//9668 9797//9668 9754//9668 
f 9797//9668 9798//9668 9756//9668 
f 9776//9668 9793//9668 9794//9668 
f 9799//9668 9782//9668 9780//9668 
f 9800//9668 9784//9668 9782//9668 
f 9801//9668 9786//9668 9784//9668 
f 9802//9668 9803//9668 9742//9668 
f 9803//9668 9804//9668 9744//9668 
f 9804//9668 9805//9668 9746//9668 
f 9805//9668 9806//9668 9748//9668 
f 9796//9668 9752//9668 9750//9668 
f 9756//9668 9754//9668 9797//9668 
f 9780//9668 9795//9668 9799//9668 
f 9784//9668 9800//9668 9801//9668 
f 9807//9668 9790//9668 9788//9668 
f 9807//9668 9808//9668 9791//9668 
f 9744//9668 9742//9668 9803//9668 
f 9748//9668 9746//9668 9805//9668 
f 9809//9668 9750//9668 9748//9668 
f 9754//9668 9752//9668 9796//9668 
f 9810//9668 9758//9668 9756//9668 
f 9810//9668 9811//9668 9760//9668 
f 9812//9668 9764//9668 9760//9668 
f 9812//9668 9813//9668 9765//9668 
f 9814//9668 9761//9668 9765//9668 
f 9814//9668 9815//9668 9768//9668 
f 9816//9668 9770//9668 9768//9668 
f 9816//9668 9817//9668 9772//9668 
f 9782//9668 9799//9668 9800//9668 
f 9818//9668 9788//9668 9786//9668 
f 9791//9668 9790//9668 9807//9668 
f 9808//9668 9819//9668 9734//9668 
f 9820//9668 9738//9668 9736//9668 
f 9820//9668 9802//9668 9740//9668 
f 9746//9668 9744//9668 9804//9668 
f 9750//9668 9809//9668 9796//9668 
f 9760//9668 9758//9668 9810//9668 
f 9765//9668 9764//9668 9812//9668 
f 9768//9668 9761//9668 9814//9668 
f 9772//9668 9770//9668 9816//9668 
f 9786//9668 9801//9668 9818//9668 
f 9734//9668 9791//9668 9808//9668 
f 9821//9668 9736//9668 9734//9668 
f 9740//9668 9738//9668 9820//9668 
f 9748//9668 9806//9668 9809//9668 
f 9760//9668 9811//9668 9812//9668 
f 9768//9668 9815//9668 9816//9668 
f 9788//9668 9818//9668 9807//9668 
f 9736//9668 9821//9668 9820//9668 
f 9756//9668 9798//9668 9810//9668 
f 9772//9668 9817//9668 9792//9668 
f 9742//9668 9740//9668 9802//9668 
f 9734//9668 9819//9668 9821//9668 
f 9765//9668 9813//9668 9814//9668 
o mesh270
f 9822//9669 9819//9669 9808//9670 
f 9823//9670 9808//9670 9807//9671 
f 9824//9671 9807//9671 9818//9672 
f 9825//9672 9818//9672 9801//9673 
f 9826//9673 9801//9673 9800//9674 
f 9827//9674 9800//9674 9799//9675 
f 9828//9675 9799//9675 9795//9676 
f 9829//9676 9795//9676 9794//9677 
f 9830//9677 9794//9677 9793//9678 
f 9831//9678 9793//9678 9792//9679 
f 9832//9679 9792//9679 9817//9680 
f 9833//9680 9817//9680 9816//9681 
f 9834//9681 9816//9681 9815//9682 
f 9835//9682 9815//9682 9814//9683 
f 9812//9684 9836//9684 9837//9685 
f 9838//9686 9814//9683 9813//9685 
f 9813//9685 9837//9685 9838//9686 
f 9836//9684 9812//9684 9811//9687 
f 9839//9687 9811//9687 9810//9688 
f 9840//9688 9810//9688 9798//9689 
f 9841//9689 9798//9689 9797//9690 
f 9842//9690 9797//9690 9796//9691 
f 9843//9691 9796//9691 9809//9692 
f 9844//9692 9809//9692 9806//9693 
f 9845//9693 9806//9693 9805//9694 
f 9846//9694 9805//9694 9804//9695 
f 9847//9695 9804//9695 9803//9696 
f 9848//9696 9803//9696 9802//9697 
f 9849//9697 9802//9697 9820//9698 
f 9850//9698 9820//9698 9821//9699 
f 9851//9699 9821//9699 9819//9669 
f 9819//9669 9822//9669 9851//9699 
f 9821//9699 9851//9699 9850//9698 
f 9820//9698 9850//9698 9849//9697 
f 9802//9697 9849//9697 9848//9696 
f 9803//9696 9848//9696 9847//9695 
f 9804//9695 9847//9695 9846//9694 
f 9805//9694 9846//9694 9845//9693 
f 9806//9693 9845//9693 9844//9692 
f 9809//9692 9844//9692 9843//9691 
f 9796//9691 9843//9691 9842//9690 
f 9797//9690 9842//9690 9841//9689 
f 9798//9689 9841//9689 9840//9688 
f 9810//9688 9840//9688 9839//9687 
f 9811//9687 9839//9687 9836//9684 
f 9837//9685 9813//9685 9812//9684 
f 9814//9683 9838//9686 9835//9682 
f 9815//9682 9835//9682 9834//9681 
f 9816//9681 9834//9681 9833//9680 
f 9817//9680 9833//9680 9832//9679 
f 9792//9679 9832//9679 9831//9678 
f 9793//9678 9831//9678 9830//9677 
f 9794//9677 9830//9677 9829//9676 
f 9795//9676 9829//9676 9828//9675 
f 9799//9675 9828//9675 9827//9674 
f 9800//9674 9827//9674 9826//9673 
f 9801//9673 9826//9673 9825//9672 
f 9818//9672 9825//9672 9824//9671 
f 9807//9671 9824//9671 9823//9670 
f 9808//9670 9823//9670 9822//9669 
o mesh271
f 9826//9700 9827//9700 9781//9700 
f 9827//9700 9828//9700 9779//9700 
f 9838//9700 9837//9700 9763//9700 
f 9836//9700 9759//9700 9763//9700 
f 9825//9700 9826//9700 9783//9700 
f 9779//9700 9781//9700 9827//9700 
f 9838//9700 9762//9700 9766//9700 
f 9763//9700 9837//9700 9836//9700 
f 9842//9700 9751//9700 9753//9700 
f 9843//9700 9749//9700 9751//9700 
f 9781//9700 9783//9700 9826//9700 
f 9828//9700 9829//9700 9777//9700 
f 9830//9700 9775//9700 9777//9700 
f 9830//9700 9831//9700 9773//9700 
f 9834//9700 9767//9700 9769//9700 
f 9834//9700 9835//9700 9766//9700 
f 9763//9700 9762//9700 9838//9700 
f 9836//9700 9839//9700 9757//9700 
f 9751//9700 9842//9700 9843//9700 
f 9843//9700 9844//9700 9747//9700 
f 9846//9700 9743//9700 9745//9700 
f 9847//9700 9741//9700 9743//9700 
f 9848//9700 9739//9700 9741//9700 
f 9849//9700 9737//9700 9739//9700 
f 9824//9700 9787//9700 9789//9700 
f 9824//9700 9825//9700 9785//9700 
f 9777//9700 9779//9700 9828//9700 
f 9773//9700 9775//9700 9830//9700 
f 9832//9700 9771//9700 9773//9700 
f 9832//9700 9833//9700 9769//9700 
f 9766//9700 9767//9700 9834//9700 
f 9757//9700 9759//9700 9836//9700 
f 9840//9700 9755//9700 9757//9700 
f 9840//9700 9841//9700 9753//9700 
f 9747//9700 9749//9700 9843//9700 
f 9844//9700 9845//9700 9745//9700 
f 9743//9700 9846//9700 9847//9700 
f 9739//9700 9848//9700 9849//9700 
f 9823//9700 9789//9700 9733//9700 
f 9785//9700 9787//9700 9824//9700 
f 9777//9700 9829//9700 9830//9700 
f 9769//9700 9771//9700 9832//9700 
f 9766//9700 9835//9700 9838//9700 
f 9753//9700 9755//9700 9840//9700 
f 9745//9700 9747//9700 9844//9700 
f 9741//9700 9847//9700 9848//9700 
f 9789//9700 9823//9700 9824//9700 
f 9773//9700 9831//9700 9832//9700 
f 9757//9700 9839//9700 9840//9700 
f 9745//9700 9845//9700 9846//9700 
f 9850//9700 9735//9700 9737//9700 
f 9850//9700 9851//9700 9732//9700 
f 9783//9700 9785//9700 9825//9700 
f 9753//9700 9841//9700 9842//9700 
f 9732//9700 9735//9700 9850//9700 
f 9851//9700 9822//9700 9733//9700 
f 9769//9700 9833//9700 9834//9700 
f 9733//9700 9732//9700 9851//9700 
f 9737//9700 9849//9700 9850//9700 
f 9733//9700 9822//9700 9823//9700 
g 35cm_T2020
v 0.218651 0.0138401 0.0720539 
v -0.131349 0.0138401 0.0720539 
v -0.131349 0.0173756 0.0685184 
v 0.218651 0.0173756 0.0685184 
v -0.131349 0.0213401 0.0685184 
v 0.218651 0.0213401 0.0685184 
v -0.131349 0.0213401 0.0724829 
v 0.218651 0.0213401 0.0724829 
v -0.131349 0.0178046 0.0760184 
v 0.218651 0.0178046 0.0760184 
v -0.131349 0.0178046 0.0810184 
v 0.218651 0.0178046 0.0810184 
v -0.131349 0.0213401 0.0845539 
v 0.218651 0.0213401 0.0845539 
v -0.131349 0.0213401 0.0885184 
v 0.218651 0.0213401 0.0885184 
v -0.131349 0.0173756 0.0885184 
v 0.218651 0.0173756 0.0885184 
v -0.131349 0.0138401 0.0849829 
v 0.218651 0.0138401 0.0849829 
v -0.131349 0.00884011 0.0849829 
v 0.218651 0.00884011 0.0849829 
v -0.131349 0.00530457 0.0885184 
v 0.218651 0.00530457 0.0885184 
v -0.131349 0.00134011 0.0885184 
v 0.218651 0.00134011 0.0885184 
v -0.131349 0.00134011 0.0845539 
v 0.218651 0.00134011 0.0845539 
v -0.131349 0.00487564 0.0810184 
v 0.218651 0.00487564 0.0810184 
v -0.131349 0.00487564 0.0760184 
v 0.218651 0.00487564 0.0760184 
v -0.131349 0.00134011 0.0724829 
v 0.218651 0.00134011 0.0724829 
v -0.131349 0.00134011 0.0685184 
v 0.218651 0.00134011 0.0685184 
v 0.218651 0.00530457 0.0685184 
v 0.218651 0.00884011 0.0720539 
v -0.131349 0.00530457 0.0685184 
v -0.131349 0.00884011 0.0720539 
vn -0.142949 -0.735445 -0.662334 
vn -0.144096 0.0343815 -0.988966 
vn -0.125774 0.987563 0.0943366 
vn -0.11933 0.670875 0.731906 
vn -0.135988 0.764528 -0.630083 
vn -0.125774 0.987563 0.0943366 
vn -0.118676 0.0283163 0.992529 
vn -0.12395 -0.637702 0.760245 
vn -0.11933 0.670875 0.731906 
vn -0.118676 0.0283163 0.992529 
vn -0.133692 -0.985937 0.100276 
vn -0.142949 -0.735445 -0.662334 
vn -0.12395 -0.637702 0.760245 
vn -0.133692 -0.985937 0.100276 
vn 0.992992 0.0358262 0.112621 
vn -0.995851 0.0275866 0.0867191 
vn -0.144096 0.0343815 -0.988966 
vn -0.135988 0.764528 -0.630083 
usemtl 0.301961_0.301961_0.301961_0.000000_0.000000
o mesh229
f 9852//9701 9853//9701 9854//9701 
f 9854//9701 9855//9701 9852//9701 
o mesh230
f 9855//9702 9854//9702 9856//9702 
f 9856//9702 9857//9702 9855//9702 
o mesh231
f 9857//9703 9856//9703 9858//9703 
f 9858//9703 9859//9703 9857//9703 
o mesh232
f 9859//9704 9858//9704 9860//9704 
f 9860//9704 9861//9704 9859//9704 
o mesh233
f 9861//9703 9860//9703 9862//9703 
f 9862//9703 9863//9703 9861//9703 
o mesh234
f 9863//9705 9862//9705 9864//9705 
f 9864//9705 9865//9705 9863//9705 
o mesh235
f 9865//9706 9864//9706 9866//9706 
f 9866//9706 9867//9706 9865//9706 
o mesh236
f 9867//9707 9866//9707 9868//9707 
f 9868//9707 9869//9707 9867//9707 
o mesh237
f 9869//9708 9868//9708 9870//9708 
f 9870//9708 9871//9708 9869//9708 
o mesh238
f 9871//9707 9870//9707 9872//9707 
f 9872//9707 9873//9707 9871//9707 
o mesh239
f 9873//9709 9872//9709 9874//9709 
f 9874//9709 9875//9709 9873//9709 
o mesh240
f 9875//9710 9874//9710 9876//9710 
f 9876//9710 9877//9710 9875//9710 
o mesh241
f 9877//9711 9876//9711 9878//9711 
f 9878//9711 9879//9711 9877//9711 
o mesh242
f 9879//9712 9878//9712 9880//9712 
f 9880//9712 9881//9712 9879//9712 
o mesh243
f 9881//9711 9880//9711 9882//9711 
f 9882//9711 9883//9711 9881//9711 
o mesh244
f 9883//9713 9882//9713 9884//9713 
f 9884//9713 9885//9713 9883//9713 
o mesh245
f 9885//9714 9884//9714 9886//9714 
f 9886//9714 9887//9714 9885//9714 
o mesh246
f 9888//9715 9883//9715 9885//9715 
f 9865//9715 9867//9715 9869//9715 
f 9863//9715 9871//9715 9881//9715 
f 9885//9715 9887//9715 9888//9715 
f 9871//9715 9863//9715 9865//9715 
f 9883//9715 9861//9715 9863//9715 
f 9875//9715 9877//9715 9879//9715 
f 9888//9715 9889//9715 9883//9715 
f 9881//9715 9883//9715 9863//9715 
f 9881//9715 9873//9715 9875//9715 
f 9855//9715 9857//9715 9859//9715 
f 9869//9715 9871//9715 9865//9715 
f 9881//9715 9871//9715 9873//9715 
f 9861//9715 9852//9715 9855//9715 
f 9879//9715 9881//9715 9875//9715 
f 9861//9715 9889//9715 9852//9715 
f 9859//9715 9861//9715 9855//9715 
f 9889//9715 9861//9715 9883//9715 
o mesh247
f 9862//9716 9882//9716 9880//9716 
f 9864//9716 9870//9716 9868//9716 
f 9890//9716 9886//9716 9884//9716 
f 9874//9716 9880//9716 9878//9716 
f 9880//9716 9870//9716 9862//9716 
f 9868//9716 9866//9716 9864//9716 
f 9882//9716 9891//9716 9890//9716 
f 9854//9716 9860//9716 9858//9716 
f 9878//9716 9876//9716 9874//9716 
f 9864//9716 9862//9716 9870//9716 
f 9882//9716 9860//9716 9891//9716 
f 9858//9716 9856//9716 9854//9716 
f 9874//9716 9872//9716 9880//9716 
f 9884//9716 9882//9716 9890//9716 
f 9854//9716 9853//9716 9860//9716 
f 9862//9716 9860//9716 9882//9716 
f 9872//9716 9870//9716 9880//9716 
f 9853//9716 9891//9716 9860//9716 
o mesh248
f 9887//9717 9886//9717 9890//9717 
f 9890//9717 9888//9717 9887//9717 
o mesh249
f 9888//9718 9890//9718 9891//9718 
f 9891//9718 9889//9718 9888//9718 
o mesh250
f 9889//9717 9891//9717 9853//9717 
f 9853//9717 9852//9717 9889//9717 
g nema17Bracket
v 0.0769064 0.0418663 0.0125733 
v 0.0768655 0.0414901 0.0125733 
v 0.0768655 0.0414901 0.0085733 
v 0.0770272 0.0422249 0.0125733 
v 0.0769064 0.0418663 0.0085733 
v 0.0772223 0.0425492 0.0125733 
v 0.0770272 0.0422249 0.0085733 
v 0.0774825 0.0428239 0.0125733 
v 0.0772223 0.0425492 0.0085733 
v 0.0777958 0.0430363 0.0125733 
v 0.0774825 0.0428239 0.0085733 
v 0.0781473 0.0431763 0.0125733 
v 0.0777958 0.0430363 0.0085733 
v 0.0785207 0.0432375 0.0125733 
v 0.0781473 0.0431763 0.0085733 
v 0.0788986 0.0432171 0.0125733 
v 0.0785207 0.0432375 0.0085733 
v 0.0792632 0.0431158 0.0125733 
v 0.0788986 0.0432171 0.0085733 
v 0.0795976 0.0429386 0.0125733 
v 0.0792632 0.0431158 0.0085733 
v 0.079886 0.0426936 0.0125733 
v 0.0795976 0.0429386 0.0085733 
v 0.080115 0.0423923 0.0125733 
v 0.079886 0.0426936 0.0085733 
v 0.0802739 0.0420489 0.0125733 
v 0.080115 0.0423923 0.0085733 
v 0.0803552 0.0416793 0.0125733 
v 0.0802739 0.0420489 0.0085733 
v 0.0803552 0.0413009 0.0085733 
v 0.0803552 0.0413009 0.0125733 
v 0.0803655 0.0414901 0.0125733 
v 0.0803552 0.0416793 0.0085733 
v 0.0802739 0.0409313 0.0125733 
v 0.080115 0.0405879 0.0125733 
v 0.0802739 0.0409313 0.0085733 
v 0.079886 0.0402866 0.0125733 
v 0.080115 0.0405879 0.0085733 
v 0.0795976 0.0400417 0.0125733 
v 0.079886 0.0402866 0.0085733 
v 0.0792632 0.0398644 0.0125733 
v 0.0795976 0.0400417 0.0085733 
v 0.0788986 0.0397632 0.0125733 
v 0.0792632 0.0398644 0.0085733 
v 0.0785207 0.0397427 0.0125733 
v 0.0788986 0.0397632 0.0085733 
v 0.0781473 0.0398039 0.0125733 
v 0.0785207 0.0397427 0.0085733 
v 0.0777958 0.039944 0.0125733 
v 0.0781473 0.0398039 0.0085733 
v 0.0774825 0.0401563 0.0125733 
v 0.0777958 0.039944 0.0085733 
v 0.0772223 0.0404311 0.0125733 
v 0.0774825 0.0401563 0.0085733 
v 0.0770272 0.0407553 0.0125733 
v 0.0772223 0.0404311 0.0085733 
v 0.0769064 0.0411139 0.0125733 
v 0.0770272 0.0407553 0.0085733 
v 0.0769064 0.0411139 0.0085733 
v 0.0494905 0.0471401 0.0125733 
v 0.0493552 0.0416793 0.0125733 
v 0.0493655 0.0414901 0.0125733 
v 0.0493552 0.0413009 0.0125733 
v 0.0492739 0.0420489 0.0125733 
v 0.0478986 0.0397632 0.0125733 
v 0.0475207 0.0397427 0.0125733 
v 0.0492739 0.0409313 0.0125733 
v 0.0410028 0.0396151 0.0125733 
v 0.0467958 0.039944 0.0125733 
v 0.0464825 0.0401563 0.0125733 
v 0.0471473 0.0398039 0.0125733 
v 0.0482632 0.0398644 0.0125733 
v 0.049115 0.0405879 0.0125733 
v 0.048886 0.0402866 0.0125733 
v 0.049115 0.0423923 0.0125733 
v 0.0430722 0.0471401 0.0125733 
v 0.0471473 0.0431763 0.0125733 
v 0.0485976 0.0400417 0.0125733 
v 0.0485976 0.0429386 0.0125733 
v 0.048886 0.0426936 0.0125733 
v 0.0478986 0.0432171 0.0125733 
v 0.0482632 0.0431158 0.0125733 
v 0.0467958 0.0430363 0.0125733 
v 0.0462223 0.0425492 0.0125733 
v 0.0464825 0.0428239 0.0125733 
v 0.0459064 0.0418663 0.0125733 
v 0.0462223 0.0404311 0.0125733 
v 0.0460272 0.0407553 0.0125733 
v 0.0475207 0.0432375 0.0125733 
v 0.0460272 0.0422249 0.0125733 
v 0.0459064 0.0411139 0.0125733 
v 0.0458655 0.0414901 0.0125733 
v 0.0493552 0.0106793 0.0125733 
v 0.0493655 0.0104901 0.0125733 
v 0.0492739 0.0110489 0.0125733 
v 0.0494905 0.00684011 0.0125733 
v 0.0493552 0.0103009 0.0125733 
v 0.0482632 0.0121158 0.0125733 
v 0.0485976 0.0119386 0.0125733 
v 0.0221155 0.00684011 0.0125733 
v 0.0464825 0.00915632 0.0125733 
v 0.0462223 0.00943105 0.0125733 
v 0.0478986 0.00876316 0.0125733 
v 0.0475207 0.00874267 0.0125733 
v 0.0492739 0.00993133 0.0125733 
v 0.049115 0.00958789 0.0125733 
v 0.048886 0.0116936 0.0125733 
v 0.0471473 0.0121763 0.0125733 
v 0.0475207 0.0122375 0.0125733 
v 0.0341897 0.0148401 0.0125733 
v 0.0462223 0.0115492 0.0125733 
v 0.0464825 0.0118239 0.0125733 
v 0.0460272 0.0097553 0.0125733 
v 0.0471473 0.00880389 0.0125733 
v 0.0482632 0.0088644 0.0125733 
v 0.048886 0.00928663 0.0125733 
v 0.0485976 0.00904165 0.0125733 
v 0.049115 0.0113923 0.0125733 
v 0.0467958 0.0120363 0.0125733 
v 0.0459064 0.0101139 0.0125733 
v 0.0467958 0.00894396 0.0125733 
v 0.0478986 0.0122171 0.0125733 
v 0.0459064 0.0108663 0.0125733 
v 0.0460272 0.0112249 0.0125733 
v 0.0458655 0.0104901 0.0125733 
v 0.0788986 0.0122171 0.0125733 
v 0.0852281 0.0396151 0.0125733 
v 0.0765363 0.0274497 0.0125733 
v 0.0920412 0.0148401 0.0125733 
v 0.0803552 0.0106793 0.0125733 
v 0.0803655 0.0104901 0.0125733 
v 0.0759088 0.0303007 0.0125733 
v 0.0802739 0.0110489 0.0125733 
v 0.0785207 0.0122375 0.0125733 
v 0.0706915 0.0371639 0.0125733 
v 0.0729164 0.035274 0.0125733 
v 0.0543758 0.0362793 0.0125733 
v 0.056792 0.0379175 0.0125733 
v 0.0768655 0.0104901 0.0125733 
v 0.0652995 0.0126679 0.0125733 
v 0.0706915 0.0148163 0.0125733 
v 0.0770272 0.0112249 0.0125733 
v 0.0772223 0.0115492 0.0125733 
v 0.0803552 0.0103009 0.0125733 
v 0.074683 0.0329501 0.0125733 
v 0.0681123 0.0385313 0.0125733 
v 0.0623846 0.0394703 0.0125733 
v 0.0523682 0.03416 0.0125733 
v 0.0496155 0.0259901 0.0125733 
v 0.0499311 0.0288922 0.0125733 
v 0.0499311 0.023088 0.0125733 
v 0.0523682 0.0178203 0.0125733 
v 0.0508632 0.0203216 0.0125733 
v 0.056792 0.0140627 0.0125733 
v 0.0543758 0.0157009 0.0125733 
v 0.0681123 0.0134489 0.0125733 
v 0.0769064 0.0108663 0.0125733 
v 0.0802739 0.00993133 0.0125733 
v 0.0795976 0.0119386 0.0125733 
v 0.079886 0.0116936 0.0125733 
v 0.0652995 0.0393123 0.0125733 
v 0.0595038 0.038998 0.0125733 
v 0.0508632 0.0316586 0.0125733 
v 0.0766155 0.0259901 0.0125733 
v 0.0595038 0.0129822 0.0125733 
v 0.0623846 0.0125099 0.0125733 
v 0.0759088 0.0216795 0.0125733 
v 0.074683 0.0190301 0.0125733 
v 0.080115 0.0113923 0.0125733 
v 0.0792632 0.0121158 0.0125733 
v 0.0777958 0.0120363 0.0125733 
v 0.0781473 0.0121763 0.0125733 
v 0.0774825 0.0118239 0.0125733 
v 0.0729164 0.0167062 0.0125733 
v 0.0765363 0.0245305 0.0125733 
v 0.080115 0.00958789 0.0125733 
v 0.0770272 0.0097553 0.0125733 
v 0.0769064 0.0101139 0.0125733 
v 0.0774825 0.00915632 0.0125733 
v 0.0772223 0.00943105 0.0125733 
v 0.104115 0.00684011 0.0125733 
v 0.0788986 0.00876316 0.0125733 
v 0.0785207 0.00874267 0.0125733 
v 0.104115 0.0148401 0.0125733 
v 0.079886 0.00928663 0.0125733 
v 0.0795976 0.00904165 0.0125733 
v 0.0781473 0.00880389 0.0125733 
v 0.0777958 0.00894396 0.0125733 
v 0.0792632 0.0088644 0.0125733 
v 0.0831587 0.0471401 0.0125733 
v 0.0221155 0.0148401 0.0125733 
v 0.0494905 0.0396151 0.0125733 
v 0.0458655 0.0414901 0.0085733 
v 0.0459064 0.0418663 0.0085733 
v 0.0460272 0.0422249 0.0085733 
v 0.0462223 0.0425492 0.0085733 
v 0.0464825 0.0428239 0.0085733 
v 0.0467958 0.0430363 0.0085733 
v 0.0471473 0.0431763 0.0085733 
v 0.0475207 0.0432375 0.0085733 
v 0.0478986 0.0432171 0.0085733 
v 0.0482632 0.0431158 0.0085733 
v 0.0485976 0.0429386 0.0085733 
v 0.048886 0.0426936 0.0085733 
v 0.049115 0.0423923 0.0085733 
v 0.0492739 0.0420489 0.0085733 
v 0.0493552 0.0413009 0.0085733 
v 0.0493552 0.0416793 0.0085733 
v 0.0492739 0.0409313 0.0085733 
v 0.049115 0.0405879 0.0085733 
v 0.048886 0.0402866 0.0085733 
v 0.0485976 0.0400417 0.0085733 
v 0.0482632 0.0398644 0.0085733 
v 0.0478986 0.0397632 0.0085733 
v 0.0475207 0.0397427 0.0085733 
v 0.0471473 0.0398039 0.0085733 
v 0.0467958 0.039944 0.0085733 
v 0.0464825 0.0401563 0.0085733 
v 0.0462223 0.0404311 0.0085733 
v 0.0460272 0.0407553 0.0085733 
v 0.0459064 0.0411139 0.0085733 
v 0.0458655 0.0104901 0.0085733 
v 0.0459064 0.0108663 0.0085733 
v 0.0460272 0.0112249 0.0085733 
v 0.0462223 0.0115492 0.0085733 
v 0.0464825 0.0118239 0.0085733 
v 0.0467958 0.0120363 0.0085733 
v 0.0471473 0.0121763 0.0085733 
v 0.0475207 0.0122375 0.0085733 
v 0.0478986 0.0122171 0.0085733 
v 0.0482632 0.0121158 0.0085733 
v 0.0485976 0.0119386 0.0085733 
v 0.048886 0.0116936 0.0085733 
v 0.049115 0.0113923 0.0085733 
v 0.0492739 0.0110489 0.0085733 
v 0.0493552 0.0106793 0.0085733 
v 0.0493552 0.0103009 0.0085733 
v 0.0492739 0.00993133 0.0085733 
v 0.049115 0.00958789 0.0085733 
v 0.048886 0.00928663 0.0085733 
v 0.0485976 0.00904165 0.0085733 
v 0.0482632 0.0088644 0.0085733 
v 0.0478986 0.00876316 0.0085733 
v 0.0475207 0.00874267 0.0085733 
v 0.0471473 0.00880389 0.0085733 
v 0.0467958 0.00894396 0.0085733 
v 0.0464825 0.00915632 0.0085733 
v 0.0462223 0.00943105 0.0085733 
v 0.0460272 0.0097553 0.0085733 
v 0.0459064 0.0101139 0.0085733 
v 0.0768655 0.0104901 0.0085733 
v 0.0769064 0.0108663 0.0085733 
v 0.0770272 0.0112249 0.0085733 
v 0.0772223 0.0115492 0.0085733 
v 0.0774825 0.0118239 0.0085733 
v 0.0777958 0.0120363 0.0085733 
v 0.0781473 0.0121763 0.0085733 
v 0.0785207 0.0122375 0.0085733 
v 0.0788986 0.0122171 0.0085733 
v 0.0792632 0.0121158 0.0085733 
v 0.0795976 0.0119386 0.0085733 
v 0.079886 0.0116936 0.0085733 
v 0.080115 0.0113923 0.0085733 
v 0.0802739 0.0110489 0.0085733 
v 0.0803552 0.0106793 0.0085733 
v 0.0803552 0.0103009 0.0085733 
v 0.0802739 0.00993133 0.0085733 
v 0.080115 0.00958789 0.0085733 
v 0.079886 0.00928663 0.0085733 
v 0.0795976 0.00904165 0.0085733 
v 0.0792632 0.0088644 0.0085733 
v 0.0788986 0.00876316 0.0085733 
v 0.0785207 0.00874267 0.0085733 
v 0.0781473 0.00880389 0.0085733 
v 0.0777958 0.00894396 0.0085733 
v 0.0774825 0.00915632 0.0085733 
v 0.0772223 0.00943105 0.0085733 
v 0.0770272 0.0097553 0.0085733 
v 0.0769064 0.0101139 0.0085733 
v 0.0518843 0.0235179 0.0105733 
v 0.0517499 0.024754 0.0105733 
v 0.0526784 0.0211614 0.0105733 
v 0.0522813 0.0223397 0.0105733 
v 0.0539604 0.0190306 0.0105733 
v 0.0533194 0.020096 0.0105733 
v 0.0556705 0.0172252 0.0105733 
v 0.0548155 0.0181279 0.0105733 
v 0.0577288 0.0158297 0.0105733 
v 0.0566997 0.0165275 0.0105733 
v 0.0600389 0.0149093 0.0105733 
v 0.0588838 0.0153695 0.0105733 
v 0.0624929 0.014507 0.0105733 
v 0.0612659 0.0147081 0.0105733 
v 0.064976 0.0146416 0.0105733 
v 0.0637344 0.0145743 0.0105733 
v 0.0673721 0.0153069 0.0105733 
v 0.066174 0.0149742 0.0105733 
v 0.0695691 0.0164717 0.0105733 
v 0.0684706 0.0158893 0.0105733 
v 0.0714644 0.0180816 0.0105733 
v 0.0705168 0.0172766 0.0105733 
v 0.0729693 0.0200612 0.0105733 
v 0.0722169 0.0190714 0.0105733 
v 0.0740135 0.0223181 0.0105733 
v 0.0734914 0.0211897 0.0105733 
v 0.0742808 0.0235324 0.0105733 
v 0.0745481 0.0247467 0.0105733 
v 0.0746155 0.0259901 0.0105733 
v 0.0745481 0.0272335 0.0105733 
v 0.0740135 0.0296621 0.0105733 
v 0.0742808 0.0284478 0.0105733 
v 0.0729693 0.031919 0.0105733 
v 0.0734914 0.0307905 0.0105733 
v 0.0714644 0.0338987 0.0105733 
v 0.0722169 0.0329088 0.0105733 
v 0.0695691 0.0355085 0.0105733 
v 0.0705168 0.0347036 0.0105733 
v 0.0673721 0.0366733 0.0105733 
v 0.0684706 0.0360909 0.0105733 
v 0.064976 0.0373386 0.0105733 
v 0.066174 0.037006 0.0105733 
v 0.0624929 0.0374732 0.0105733 
v 0.0637344 0.0374059 0.0105733 
v 0.0600389 0.0370709 0.0105733 
v 0.0612659 0.0372721 0.0105733 
v 0.0577288 0.0361505 0.0105733 
v 0.0588838 0.0366107 0.0105733 
v 0.0556705 0.034755 0.0105733 
v 0.0566997 0.0354527 0.0105733 
v 0.0539604 0.0329496 0.0105733 
v 0.0548155 0.0338523 0.0105733 
v 0.0526784 0.0308188 0.0105733 
v 0.0533194 0.0318842 0.0105733 
v 0.0518843 0.0284623 0.0105733 
v 0.0522813 0.0296405 0.0105733 
v 0.0516155 0.0259901 0.0105733 
v 0.0517499 0.0272262 0.0105733 
v 0.0766155 0.0259901 0.0085733 
v 0.0762999 0.023088 0.0085733 
v 0.0753677 0.0203216 0.0085733 
v 0.0738627 0.0178203 0.0085733 
v 0.0718552 0.0157009 0.0085733 
v 0.069439 0.0140627 0.0085733 
v 0.0667271 0.0129822 0.0085733 
v 0.0638463 0.0125099 0.0085733 
v 0.0609314 0.0126679 0.0085733 
v 0.0581186 0.0134489 0.0085733 
v 0.0555394 0.0148163 0.0085733 
v 0.0533145 0.0167062 0.0085733 
v 0.0515479 0.0190301 0.0085733 
v 0.0503222 0.0216795 0.0085733 
v 0.0496946 0.0245305 0.0085733 
v 0.0496155 0.0259901 0.0085733 
v 0.0496946 0.0274497 0.0085733 
v 0.0503222 0.0303007 0.0085733 
v 0.0515479 0.0329501 0.0085733 
v 0.0533145 0.035274 0.0085733 
v 0.0555394 0.0371639 0.0085733 
v 0.0581186 0.0385313 0.0085733 
v 0.0609314 0.0393123 0.0085733 
v 0.0638463 0.0394703 0.0085733 
v 0.0667271 0.038998 0.0085733 
v 0.069439 0.0379175 0.0085733 
v 0.0718552 0.0362793 0.0085733 
v 0.0738627 0.03416 0.0085733 
v 0.0753677 0.0316586 0.0085733 
v 0.0762999 0.0288922 0.0085733 
v 0.0941155 0.0148401 0.0105733 
v 0.0857992 0.0450813 0.0105733 
v 0.084742 0.0471401 0.0110467 
v 0.0941155 0.0148401 -0.004109 
v 0.0833989 0.0471401 0.0096071 
v 0.042832 0.0471401 0.0096071 
v 0.0414889 0.0471401 0.0110467 
v 0.0767405 0.0450108 0.0085733 
v 0.0839845 0.0450108 0.0085733 
v 0.0422464 0.0450108 0.0085733 
v 0.0404318 0.0450813 0.0105733 
v 0.0321155 0.0148401 0.0105733 
v 0.0321155 0.0148401 -0.004109 
v 0.0934498 0.0148401 -0.00482254 
v 0.0881155 0.0299891 0.00128015 
v 0.0865664 0.041464 0.0085733 
v 0.0925912 0.0137136 -0.00662171 
v 0.104115 0.0137136 -0.00662171 
v 0.104115 0.0148401 -0.00482254 
v 0.0981155 0.0148401 0.0113233 
v 0.0975243 0.0148401 0.011259 
v 0.100545 0.0148401 0.00986142 
v 0.100211 0.0148401 0.0103536 
v 0.100829 0.0148401 0.0081284 
v 0.100861 0.0148401 0.00872218 
v 0.10067 0.0148401 0.00755542 
v 0.0960195 0.0148401 0.0103536 
v 0.0956858 0.0148401 0.00986142 
v 0.0987066 0.0148401 0.011259 
v 0.0997797 0.0148401 0.0107626 
v 0.0992702 0.0148401 0.0110691 
v 0.100765 0.0148401 0.009309 
v 0.100007 0.0148401 0.00657681 
v 0.100392 0.0148401 0.00703003 
v 0.0989936 0.0148401 0.00596725 
v 0.0995332 0.0148401 0.00621694 
v 0.0981155 0.0148401 0.0058233 
v 0.0964512 0.0148401 0.0107626 
v 0.0969608 0.0148401 0.0110691 
v 0.0984128 0.0148401 0.00583942 
v 0.0962243 0.0148401 0.00657681 
v 0.0966977 0.0148401 0.00621694 
v 0.0954017 0.0148401 0.0081284 
v 0.0954657 0.0148401 0.009309 
v 0.0953695 0.0148401 0.00872218 
v 0.0972374 0.0148401 0.00596725 
v 0.0978181 0.0148401 0.00583942 
v 0.0958393 0.0148401 0.00703003 
v 0.0955608 0.0148401 0.00755542 
v 0.106115 0.0128401 0.0105733 
v 0.106115 0.0128401 -0.00482254 
v 0.106115 0.00684011 0.0105733 
v 0.100545 0.00484011 0.00986142 
v 0.100211 0.00484011 0.0103536 
v 0.100765 0.00484011 0.009309 
v 0.100861 0.00484011 0.00872218 
v 0.100829 0.00484011 0.0081284 
v 0.10067 0.00484011 0.00755542 
v 0.100392 0.00484011 0.00703003 
v 0.100007 0.00484011 0.00657681 
v 0.0995332 0.00484011 0.00621694 
v 0.0989936 0.00484011 0.00596725 
v 0.0984128 0.00484011 0.00583942 
v 0.0978181 0.00484011 0.00583942 
v 0.0972374 0.00484011 0.00596725 
v 0.0966977 0.00484011 0.00621694 
v 0.0962243 0.00484011 0.00657681 
v 0.0958393 0.00484011 0.00703003 
v 0.0955608 0.00484011 0.00755542 
v 0.0954017 0.00484011 0.0081284 
v 0.0953695 0.00484011 0.00872218 
v 0.0954657 0.00484011 0.009309 
v 0.0956858 0.00484011 0.00986142 
v 0.0960195 0.00484011 0.0103536 
v 0.100003 0.00484011 0.0105733 
v 0.0997797 0.00502936 0.0107626 
v 0.0995332 0.00519646 0.0109297 
v 0.0992702 0.00533594 0.0110691 
v 0.0989936 0.00544615 0.0111793 
v 0.0987066 0.00552581 0.011259 
v 0.0984128 0.00557399 0.0113072 
v 0.0981155 0.00559011 0.0113233 
v 0.0978181 0.00557399 0.0113072 
v 0.0975243 0.00552581 0.011259 
v 0.0972374 0.00544615 0.0111793 
v 0.0969608 0.00533594 0.0110691 
v 0.0966977 0.00519646 0.0109297 
v 0.0964512 0.00502936 0.0107626 
v 0.096228 0.00484011 0.0105733 
v 0.104115 0.00771361 -0.00953475 
v 0.0881155 0.00771361 -0.00953475 
v 0.106115 0.00684011 -0.00773559 
v 0.104115 0.00484011 0.0105733 
v 0.104115 0.00484011 -0.00773559 
v 0.0881155 0.00484011 -0.00773559 
v 0.0866787 0.00627686 -0.00863517 
v 0.0861155 0.00684011 -0.00773559 
v 0.0861155 0.0404315 0.0085733 
v 0.0861155 0.00684011 0.0085733 
v 0.0881155 0.00484011 0.0085733 
v 0.0861155 0.0396151 0.0085733 
v 0.0287066 0.00552581 0.011259 
v 0.0284128 0.00557399 0.0113072 
v 0.0221155 0.00484011 0.0105733 
v 0.026228 0.00484011 0.0105733 
v 0.0289936 0.00544615 0.0111793 
v 0.0292702 0.00533594 0.0110691 
v 0.0264512 0.00502936 0.0107626 
v 0.0295332 0.00519646 0.0109297 
v 0.0297797 0.00502936 0.0107626 
v 0.0266977 0.00519646 0.0109297 
v 0.0300029 0.00484011 0.0105733 
v 0.0269608 0.00533594 0.0110691 
v 0.0272374 0.00544615 0.0111793 
v 0.0281155 0.00559011 0.0113233 
v 0.0275243 0.00552581 0.011259 
v 0.0278181 0.00557399 0.0113072 
v 0.0305451 0.00484011 0.00986142 
v 0.0302114 0.00484011 0.0103536 
v 0.0302114 0.0148401 0.0103536 
v 0.0307652 0.00484011 0.009309 
v 0.0305451 0.0148401 0.00986142 
v 0.0308614 0.00484011 0.00872218 
v 0.0307652 0.0148401 0.009309 
v 0.0308292 0.00484011 0.0081284 
v 0.0308614 0.0148401 0.00872218 
v 0.0306702 0.00484011 0.00755542 
v 0.0308292 0.0148401 0.0081284 
v 0.0303916 0.00484011 0.00703003 
v 0.0306702 0.0148401 0.00755542 
v 0.0300066 0.00484011 0.00657681 
v 0.0303916 0.0148401 0.00703003 
v 0.0295332 0.00484011 0.00621694 
v 0.0300066 0.0148401 0.00657681 
v 0.0289936 0.00484011 0.00596725 
v 0.0295332 0.0148401 0.00621694 
v 0.0284128 0.00484011 0.00583942 
v 0.0289936 0.0148401 0.00596725 
v 0.0278181 0.00484011 0.00583942 
v 0.0281155 0.0148401 0.0058233 
v 0.0284128 0.0148401 0.00583942 
v 0.0272374 0.00484011 0.00596725 
v 0.0278181 0.0148401 0.00583942 
v 0.0266977 0.00484011 0.00621694 
v 0.0272374 0.0148401 0.00596725 
v 0.0262243 0.00484011 0.00657681 
v 0.0266977 0.0148401 0.00621694 
v 0.0258393 0.00484011 0.00703003 
v 0.0262243 0.0148401 0.00657681 
v 0.0255608 0.00484011 0.00755542 
v 0.0258393 0.0148401 0.00703003 
v 0.0254017 0.00484011 0.0081284 
v 0.0255608 0.0148401 0.00755542 
v 0.0253695 0.00484011 0.00872218 
v 0.0254017 0.0148401 0.0081284 
v 0.0254657 0.00484011 0.009309 
v 0.0253695 0.0148401 0.00872218 
v 0.0256858 0.00484011 0.00986142 
v 0.0254657 0.0148401 0.009309 
v 0.0260195 0.00484011 0.0103536 
v 0.0256858 0.0148401 0.00986142 
v 0.0297797 0.0148401 0.0107626 
v 0.0292702 0.0148401 0.0110691 
v 0.0287066 0.0148401 0.011259 
v 0.0275243 0.0148401 0.011259 
v 0.0281155 0.0148401 0.0113233 
v 0.0269608 0.0148401 0.0110691 
v 0.0264512 0.0148401 0.0107626 
v 0.0260195 0.0148401 0.0103536 
v 0.0201155 0.00684011 0.0105733 
v 0.0221155 0.00484011 -0.00773559 
v 0.0381155 0.00484011 -0.00773559 
v 0.0381155 0.00484011 0.0085733 
v 0.0767405 0.00484011 0.0085733 
v 0.0401155 0.0396151 0.0085733 
v 0.0401155 0.00684011 0.0085733 
v 0.0401155 0.0404315 0.0085733 
v 0.0396645 0.041464 0.0085733 
v 0.0767405 0.0396151 0.0085733 
v 0.0401155 0.00684011 -0.00773559 
v 0.0395522 0.00627686 -0.00863517 
v 0.0381155 0.0299891 0.00128015 
v 0.0381155 0.00771361 -0.00953475 
v 0.0336397 0.0137136 -0.00662171 
v 0.0327812 0.0148401 -0.00482254 
v 0.0221155 0.0148401 -0.00482254 
v 0.0221155 0.00771361 -0.00953475 
v 0.0221155 0.0137136 -0.00662171 
v 0.0201155 0.00684011 -0.00773559 
v 0.0201155 0.0128401 -0.00482254 
v 0.0201155 0.0128401 0.0105733 
vn 0.980151 -0.198088 0.00808198 
vn 0.999957 0.00455256 0.00806397 
vn 0.919444 -0.393137 0.00812068 
vn 0.980151 -0.198088 0.00808198 
vn 0.819703 -0.572731 0.0081791 
vn 0.919444 -0.393137 0.00812068 
vn 0.68418 -0.729266 0.00825569 
vn 0.819703 -0.572731 0.0081791 
vn 0.517568 -0.855601 0.00834819 
vn 0.68418 -0.729266 0.00825569 
vn 0.326027 -0.945323 0.00845358 
vn 0.517568 -0.855601 0.00834819 
vn 0.117181 -0.993074 0.00856795 
vn 0.326027 -0.945323 0.00845358 
vn -0.0999693 -0.994953 0.0086865 
vn 0.117181 -0.993074 0.00856795 
vn -0.31527 -0.948961 0.0088036 
vn -0.0999693 -0.994953 0.0086865 
vn -0.517806 -0.855452 0.00891299 
vn -0.31527 -0.948961 0.0088036 
vn -0.696504 -0.717497 0.00900817 
vn -0.517806 -0.855452 0.00891299 
vn -0.840926 -0.541074 0.00908294 
vn -0.696504 -0.717497 0.00900817 
vn -0.942189 -0.334957 0.00913208 
vn -0.840926 -0.541074 0.00908294 
vn -0.993862 -0.11025 0.00915195 
vn -0.942189 -0.334957 0.00913208 
vn -0.992679 0.12044 0.00914106 
vn -0.999945 0.00516589 0.00915035 
vn -0.993862 -0.11025 0.00915195 
vn -0.938902 0.344064 0.00910022 
vn -0.836255 0.548267 0.00903249 
vn -0.691441 0.722378 0.00894268 
vn -0.513379 0.858116 0.00883679 
vn -0.312322 0.949936 0.00872129 
vn -0.0990031 0.99505 0.00860255 
vn 0.116066 0.993205 0.00848641 
vn 0.32311 0.946324 0.00837795 
vn 0.513421 0.858097 0.00828131 
vn 0.679547 0.733586 0.00819978 
vn 0.815367 0.578888 0.00813584 
vn 0.916109 0.400847 0.00809122 
vn 0.978343 0.206832 0.00806707 
vn 0.0624561 0.00478954 0.998036 
vn 0.980151 -0.198088 0.00808198 
vn 0.999957 0.00455256 0.00806397 
vn 0.919444 -0.393137 0.00812068 
vn 0.980151 -0.198088 0.00808198 
vn 0.819703 -0.572731 0.0081791 
vn 0.919444 -0.393137 0.00812068 
vn 0.68418 -0.729266 0.00825569 
vn 0.819703 -0.572731 0.0081791 
vn 0.517568 -0.855601 0.00834819 
vn 0.68418 -0.729266 0.00825569 
vn 0.326027 -0.945323 0.00845358 
vn 0.517568 -0.855601 0.00834819 
vn 0.117181 -0.993074 0.00856795 
vn 0.326027 -0.945323 0.00845358 
vn -0.0999693 -0.994953 0.0086865 
vn 0.117181 -0.993074 0.00856795 
vn -0.31527 -0.948961 0.0088036 
vn -0.0999693 -0.994953 0.0086865 
vn -0.517806 -0.855452 0.00891299 
vn -0.31527 -0.948961 0.0088036 
vn -0.696504 -0.717497 0.00900817 
vn -0.517806 -0.855452 0.00891299 
vn -0.840926 -0.541074 0.00908294 
vn -0.696504 -0.717497 0.00900817 
vn -0.942189 -0.334957 0.00913208 
vn -0.840926 -0.541074 0.00908294 
vn -0.993862 -0.11025 0.00915195 
vn -0.942189 -0.334957 0.00913208 
vn -0.992679 0.12044 0.00914106 
vn -0.999945 0.00516589 0.00915035 
vn -0.993862 -0.11025 0.00915195 
vn -0.938902 0.344064 0.00910022 
vn -0.836255 0.548267 0.00903249 
vn -0.691441 0.722378 0.00894268 
vn -0.513379 0.858116 0.00883679 
vn -0.312322 0.949936 0.00872129 
vn -0.0990031 0.99505 0.00860255 
vn 0.116066 0.993205 0.00848641 
vn 0.32311 0.946324 0.00837795 
vn 0.513421 0.858097 0.00828131 
vn 0.679547 0.733586 0.00819978 
vn 0.815367 0.578888 0.00813584 
vn 0.916109 0.400847 0.00809122 
vn 0.978343 0.206832 0.00806707 
vn 0.980151 -0.198088 0.00808198 
vn 0.999957 0.00455256 0.00806397 
vn 0.919444 -0.393137 0.00812068 
vn 0.980151 -0.198088 0.00808198 
vn 0.819703 -0.572731 0.0081791 
vn 0.919444 -0.393137 0.00812068 
vn 0.68418 -0.729266 0.00825569 
vn 0.819703 -0.572731 0.0081791 
vn 0.517568 -0.855601 0.00834819 
vn 0.68418 -0.729266 0.00825569 
vn 0.326027 -0.945323 0.00845358 
vn 0.517568 -0.855601 0.00834819 
vn 0.117181 -0.993074 0.00856795 
vn 0.326027 -0.945323 0.00845358 
vn -0.0999693 -0.994953 0.0086865 
vn 0.117181 -0.993074 0.00856795 
vn -0.31527 -0.948961 0.0088036 
vn -0.0999693 -0.994953 0.0086865 
vn -0.517806 -0.855452 0.00891299 
vn -0.31527 -0.948961 0.0088036 
vn -0.696504 -0.717497 0.00900817 
vn -0.517806 -0.855452 0.00891299 
vn -0.840926 -0.541074 0.00908294 
vn -0.696504 -0.717497 0.00900817 
vn -0.942189 -0.334957 0.00913208 
vn -0.840926 -0.541074 0.00908294 
vn -0.993862 -0.11025 0.00915195 
vn -0.942189 -0.334957 0.00913208 
vn -0.992679 0.12044 0.00914106 
vn -0.999945 0.00516589 0.00915035 
vn -0.938902 0.344064 0.00910022 
vn -0.836255 0.548267 0.00903249 
vn -0.691441 0.722378 0.00894268 
vn -0.513379 0.858116 0.00883679 
vn -0.312322 0.949936 0.00872129 
vn -0.0990031 0.99505 0.00860255 
vn 0.116066 0.993205 0.00848641 
vn 0.32311 0.946324 0.00837795 
vn 0.513421 0.858097 0.00828131 
vn 0.679547 0.733586 0.00819978 
vn 0.815367 0.578888 0.00813584 
vn 0.916109 0.400847 0.00809122 
vn 0.978343 0.206832 0.00806707 
vn 0.980151 -0.198088 0.00808198 
vn 0.999957 0.00455256 0.00806397 
vn 0.919444 -0.393137 0.00812068 
vn 0.980151 -0.198088 0.00808198 
vn 0.819703 -0.572731 0.0081791 
vn 0.919444 -0.393137 0.00812068 
vn 0.68418 -0.729266 0.00825569 
vn 0.819703 -0.572731 0.0081791 
vn 0.517568 -0.855601 0.00834819 
vn 0.68418 -0.729266 0.00825569 
vn 0.326027 -0.945323 0.00845358 
vn 0.517568 -0.855601 0.00834819 
vn 0.117181 -0.993074 0.00856795 
vn 0.326027 -0.945323 0.00845358 
vn -0.0999693 -0.994953 0.0086865 
vn 0.117181 -0.993074 0.00856795 
vn -0.31527 -0.948961 0.0088036 
vn -0.0999693 -0.994953 0.0086865 
vn -0.517806 -0.855452 0.00891299 
vn -0.31527 -0.948961 0.0088036 
vn -0.696504 -0.717497 0.00900817 
vn -0.517806 -0.855452 0.00891299 
vn -0.840926 -0.541074 0.00908294 
vn -0.696504 -0.717497 0.00900817 
vn -0.942189 -0.334957 0.00913208 
vn -0.840926 -0.541074 0.00908294 
vn -0.993862 -0.11025 0.00915195 
vn -0.942189 -0.334957 0.00913208 
vn -0.992679 0.12044 0.00914106 
vn -0.999945 0.00516589 0.00915035 
vn -0.938902 0.344064 0.00910022 
vn -0.836255 0.548267 0.00903249 
vn -0.691441 0.722378 0.00894268 
vn -0.513379 0.858116 0.00883679 
vn -0.312322 0.949936 0.00872129 
vn -0.0990031 0.99505 0.00860255 
vn 0.116066 0.993205 0.00848641 
vn 0.32311 0.946324 0.00837795 
vn 0.513421 0.858097 0.00828131 
vn 0.679547 0.733586 0.00819978 
vn 0.815367 0.578888 0.00813584 
vn 0.916109 0.400847 0.00809122 
vn 0.978343 0.206832 0.00806707 
vn 0.717037 0.149219 0.680875 
vn 0.728547 0.0773093 0.680619 
vn 0.732561 0.00460344 0.680686 
vn 0.672039 0.287693 0.682347 
vn 0.698142 0.219591 0.681453 
vn 0.59925 0.414245 0.685056 
vn 0.638971 0.352809 0.683551 
vn 0.501408 0.523435 0.688917 
vn 0.553249 0.471332 0.686849 
vn 0.382276 0.610331 0.693802 
vn 0.444229 0.569954 0.691241 
vn 0.246597 0.670697 0.699539 
vn 0.316172 0.644063 0.696577 
vn 0.100013 0.701205 0.70591 
vn 0.174283 0.68985 0.702661 
vn -0.0510646 0.699658 0.712651 
vn 0.0246104 0.704525 0.709252 
vn -0.19966 0.665219 0.719458 
vn -0.126124 0.686543 0.716066 
vn -0.338514 0.598612 0.725997 
vn -0.27076 0.635826 0.722783 
vn -0.460459 0.502263 0.731922 
vn -0.402033 0.553935 0.729058 
vn -0.558863 0.380341 0.736894 
vn -0.512983 0.444172 0.734547 
vn -0.628122 0.238655 0.740612 
vn -0.597432 0.311548 0.738927 
vn -0.664129 0.0843769 0.742841 
vn -0.650469 0.162599 0.741924 
vn -0.668887 0.00502722 0.743347 
vn -0.664659 -0.0743887 0.743434 
vn -0.629597 -0.229174 0.742352 
vn -0.6515 -0.152805 0.743101 
vn -0.560965 -0.371767 0.739667 
vn -0.599271 -0.302481 0.741201 
vn -0.462743 -0.494805 0.735552 
vn -0.515237 -0.436144 0.737774 
vn -0.340505 -0.592255 0.730267 
vn -0.404227 -0.547043 0.733038 
vn -0.200956 -0.659741 0.724126 
vn -0.272446 -0.629947 0.727283 
vn -0.0514101 -0.694687 0.717473 
vn -0.126965 -0.681372 0.720842 
vn 0.100685 -0.696302 0.710651 
vn 0.0247773 -0.699644 0.714062 
vn 0.248165 -0.665442 0.703989 
vn 0.175429 -0.68482 0.707281 
vn 0.384467 -0.604392 0.697779 
vn 0.318094 -0.638499 0.700811 
vn 0.503849 -0.51662 0.692271 
vn 0.446595 -0.56359 0.694923 
vn 0.601537 -0.406525 0.687671 
vn 0.555663 -0.464059 0.689846 
vn 0.673801 -0.279194 0.684137 
vn 0.641038 -0.344674 0.685762 
vn 0.717994 -0.140197 0.681784 
vn 0.699529 -0.210792 0.682807 
vn 0.732561 0.00460344 0.680686 
vn 0.729035 -0.068149 0.681075 
vn -0.677812 0.00509429 -0.735218 
vn -0.659114 0.16476 -0.733773 
vn -0.672978 0.0855012 -0.734704 
vn -0.605307 0.315654 -0.73073 
vn -0.63644 0.241815 -0.732441 
vn -0.519664 0.449956 -0.726285 
vn -0.566188 0.385326 -0.728666 
vn -0.407189 0.561039 -0.720717 
vn -0.466411 0.508756 -0.723622 
vn -0.274172 0.643837 -0.714355 
vn -0.342819 0.606223 -0.717613 
vn -0.127683 0.695031 -0.707551 
vn -0.202152 0.673523 -0.710986 
vn 0.0249088 0.713067 -0.700653 
vn -0.0516898 0.708224 -0.704093 
vn 0.176357 0.698057 -0.693985 
vn 0.101214 0.709625 -0.697271 
vn 0.319867 0.65159 -0.687834 
vn 0.249504 0.678604 -0.690829 
vn 0.44934 0.576511 -0.682443 
vn 0.386707 0.617407 -0.68503 
vn 0.559532 0.476686 -0.678007 
vn 0.507137 0.529417 -0.680095 
vn 0.646158 0.356777 -0.674678 
vn 0.60602 0.418925 -0.676197 
vn 0.705945 0.222045 -0.67256 
vn 0.67957 0.290917 -0.673463 
vn 0.73667 0.0781713 -0.671719 
vn 0.725038 0.150884 -0.671978 
vn 0.74073 0.00465478 -0.671786 
vn 0.737175 -0.0689098 -0.672179 
vn 0.70738 -0.213157 -0.673927 
vn 0.726027 -0.141765 -0.672895 
vn 0.648296 -0.348576 -0.67691 
vn 0.681393 -0.282339 -0.675269 
vn 0.56203 -0.469376 -0.681034 
vn 0.608386 -0.411153 -0.678837 
vn 0.45179 -0.570146 -0.686163 
vn 0.509664 -0.522583 -0.683483 
vn 0.321858 -0.646054 -0.692114 
vn 0.388976 -0.611481 -0.689049 
vn 0.177544 -0.693076 -0.698659 
vn 0.251129 -0.673389 -0.695329 
vn 0.0250819 -0.708245 -0.705521 
vn 0.101911 -0.704779 -0.702069 
vn -0.128556 -0.68991 -0.712388 
vn -0.0520482 -0.70331 -0.708975 
vn -0.275922 -0.637986 -0.718917 
vn -0.203497 -0.668085 -0.715717 
vn -0.409469 -0.554137 -0.724753 
vn -0.344887 -0.599876 -0.721943 
vn -0.522006 -0.441874 -0.729559 
vn -0.468785 -0.501266 -0.727305 
vn -0.60722 -0.306493 -0.733039 
vn -0.568375 -0.376678 -0.731481 
vn -0.660187 -0.154843 -0.734968 
vn -0.637975 -0.232224 -0.734207 
vn -0.677812 0.00509429 -0.735218 
vn -0.67353 -0.0753814 -0.735306 
vn 0.708931 0.183044 0.681111 
vn 0.967124 0.254176 0.00807094 
vn 0.0626856 0.997997 0.00851491 
vn 0.0633413 0.443173 -0.894195 
vn -0.640868 0.199232 0.741346 
vn -0.957883 0.287014 0.00911365 
vn 0.681883 0.45683 -0.571263 
vn 0.0630152 0.851057 -0.521279 
vn 0.0626856 0.997997 0.00851491 
vn 0.734317 0.678758 0.00817363 
vn 0.732561 0.00460344 0.680686 
vn -0.872307 0.00514636 -0.488931 
vn -0.738185 0.0051111 -0.674579 
vn -0.961034 0.00516585 -0.276383 
vn -0.872307 0.00514636 -0.488931 
vn -0.998802 0.00516808 -0.0486532 
vn -0.961034 0.00516585 -0.276383 
vn -0.983403 0.00515288 0.181364 
vn -0.998802 0.00516808 -0.0486532 
vn -0.916185 0.00512141 0.400722 
vn -0.983403 0.00515288 0.181364 
vn -0.801833 0.00507598 0.597526 
vn -0.916185 0.00512141 0.400722 
vn -0.647761 0.00501971 0.761827 
vn -0.801833 0.00507598 0.597526 
vn -0.463292 0.00495622 0.886192 
vn -0.647761 0.00501971 0.761827 
vn -0.258784 0.00488919 0.965923 
vn -0.463292 0.00495622 0.886192 
vn -0.0448362 0.00482211 0.998983 
vn -0.258784 0.00488919 0.965923 
vn 0.168333 0.00475808 0.985719 
vn 0.0624561 0.00478954 0.998036 
vn -0.0448362 0.00482211 0.998983 
vn 0.371325 0.00469972 0.928491 
vn 0.168333 0.00475808 0.985719 
vn 0.555835 0.00464911 0.83128 
vn 0.371325 0.00469972 0.928491 
vn 0.71479 0.00460788 0.699324 
vn 0.555835 0.00464911 0.83128 
vn 0.842415 0.00457719 0.53881 
vn 0.71479 0.00460788 0.699324 
vn 0.934236 0.00455785 0.356626 
vn 0.842415 0.00457719 0.53881 
vn 0.987081 0.00455033 0.160156 
vn 0.934236 0.00455785 0.356626 
vn 0.99907 0.00455481 -0.0428797 
vn 0.987081 0.00455033 0.160156 
vn 0.969622 0.00457118 -0.244567 
vn 0.99907 0.00455481 -0.0428797 
vn 0.899482 0.00459905 -0.436934 
vn 0.969622 0.00457118 -0.244567 
vn 0.790767 0.00463771 -0.6121 
vn 0.899482 0.00459905 -0.436934 
vn -0.655138 0.00508789 -0.755492 
vn -0.566975 0.00506259 -0.823719 
vn -0.470599 0.00503438 -0.882333 
vn -0.368865 0.00500414 -0.92947 
vn -0.263184 0.00497232 -0.964733 
vn -0.15497 0.0049394 -0.987907 
vn -0.0456146 0.00490583 -0.998947 
vn 0.0635319 0.00487204 -0.997968 
vn 0.276095 0.00480546 -0.961118 
vn 0.171176 0.00483846 -0.985229 
vn 0.473279 0.00474265 -0.8809 
vn 0.276095 0.00480546 -0.961118 
vn 0.377148 0.00477342 -0.926141 
vn 0.647022 0.00468607 -0.762457 
vn 0.473279 0.00474265 -0.8809 
vn 0.563526 0.00471344 -0.826085 
vn 0.790767 0.00463771 -0.6121 
vn 0.647022 0.00468607 -0.762457 
vn 0.721758 0.00466118 -0.69213 
vn 0.681317 0.625371 -0.380418 
vn 0.0633413 0.443173 -0.894195 
vn 0.999957 0.00455256 0.00806397 
vn 0.615926 -0.550574 0.563474 
vn 0.739293 0.301076 -0.602328 
vn 0.738928 -0.673734 0.00822497 
vn 0.520083 -0.453635 -0.723692 
vn 0.0636133 -0.529989 -0.845615 
vn -0.676238 0.329378 -0.658949 
vn -0.675838 -0.736995 0.00899726 
vn -0.999945 0.00516589 0.00915035 
vn 0.0628222 -0.699003 0.712354 
vn -0.872307 0.00514636 -0.488931 
vn -0.738185 0.0051111 -0.674579 
vn -0.961034 0.00516585 -0.276383 
vn -0.872307 0.00514636 -0.488931 
vn -0.998802 0.00516808 -0.0486532 
vn -0.961034 0.00516585 -0.276383 
vn -0.983403 0.00515288 0.181364 
vn -0.998802 0.00516808 -0.0486532 
vn -0.916185 0.00512141 0.400722 
vn -0.983403 0.00515288 0.181364 
vn -0.801833 0.00507598 0.597526 
vn -0.916185 0.00512141 0.400722 
vn -0.647761 0.00501971 0.761827 
vn -0.801833 0.00507598 0.597526 
vn -0.463292 0.00495622 0.886192 
vn -0.647761 0.00501971 0.761827 
vn -0.258784 0.00488919 0.965923 
vn -0.463292 0.00495622 0.886192 
vn -0.0448362 0.00482211 0.998983 
vn -0.258784 0.00488919 0.965923 
vn 0.168333 0.00475808 0.985719 
vn 0.0624561 0.00478954 0.998036 
vn -0.0448362 0.00482211 0.998983 
vn 0.371325 0.00469972 0.928491 
vn 0.168333 0.00475808 0.985719 
vn 0.555835 0.00464911 0.83128 
vn 0.371325 0.00469972 0.928491 
vn 0.71479 0.00460788 0.699324 
vn 0.555835 0.00464911 0.83128 
vn 0.842415 0.00457719 0.53881 
vn 0.71479 0.00460788 0.699324 
vn 0.934236 0.00455785 0.356626 
vn 0.842415 0.00457719 0.53881 
vn 0.987081 0.00455033 0.160156 
vn 0.934236 0.00455785 0.356626 
vn 0.99907 0.00455481 -0.0428797 
vn 0.987081 0.00455033 0.160156 
vn 0.969622 0.00457118 -0.244567 
vn 0.99907 0.00455481 -0.0428797 
vn 0.899482 0.00459905 -0.436934 
vn 0.969622 0.00457118 -0.244567 
vn 0.790767 0.00463771 -0.6121 
vn 0.899482 0.00459905 -0.436934 
vn -0.655138 0.00508789 -0.755492 
vn -0.566975 0.00506259 -0.823719 
vn -0.470599 0.00503438 -0.882333 
vn -0.368865 0.00500414 -0.92947 
vn -0.263184 0.00497232 -0.964733 
vn -0.15497 0.0049394 -0.987907 
vn -0.0456146 0.00490583 -0.998947 
vn 0.0635319 0.00487204 -0.997968 
vn 0.276095 0.00480546 -0.961118 
vn 0.171176 0.00483846 -0.985229 
vn 0.473279 0.00474265 -0.8809 
vn 0.276095 0.00480546 -0.961118 
vn 0.377148 0.00477342 -0.926141 
vn 0.647022 0.00468607 -0.762457 
vn 0.473279 0.00474265 -0.8809 
vn 0.563526 0.00471344 -0.826085 
vn 0.790767 0.00463771 -0.6121 
vn 0.647022 0.00468607 -0.762457 
vn 0.721758 0.00466118 -0.69213 
vn -0.531663 -0.591914 0.605782 
vn 0.0632929 -0.997958 0.0085974 
vn 0.0635319 0.00487204 -0.997968 
vn 0.738928 -0.673734 0.00822497 
vn 0.999957 0.00455256 0.00806397 
vn 0.739293 0.301076 -0.602328 
vn -0.608171 0.495768 -0.619954 
vn 0.0626856 0.997997 0.00851491 
vn 0.0633413 0.443173 -0.894195 
vn 0.0636133 -0.529989 -0.845615 
vn -0.421197 -0.481706 -0.768474 
vn 0.0630152 0.851057 -0.521279 
vn -0.607708 0.678488 -0.412729 
vn -0.6708 0.741585 0.00893019 
vn -0.999945 0.00516589 0.00915035 
vn -0.668887 0.00502722 0.743347 
vn -0.676238 0.329378 -0.658949 
vn -0.675838 -0.736995 0.00899726 
usemtl 0.615686_0.811765_0.929412_0.000000_0.000000
o mesh416
f 9892//9719 9893//9720 9894//9720 
f 9895//9721 9892//9719 9896//9722 
f 9897//9723 9895//9721 9898//9724 
f 9899//9725 9897//9723 9900//9726 
f 9901//9727 9899//9725 9902//9728 
f 9903//9729 9901//9727 9904//9730 
f 9905//9731 9903//9729 9906//9732 
f 9907//9733 9905//9731 9908//9734 
f 9909//9735 9907//9733 9910//9736 
f 9911//9737 9909//9735 9912//9738 
f 9913//9739 9911//9737 9914//9740 
f 9915//9741 9913//9739 9916//9742 
f 9917//9743 9915//9741 9918//9744 
f 9919//9745 9917//9743 9920//9746 
f 9921//9747 9922//9747 9923//9748 
f 9923//9748 9924//9749 9921//9747 
f 9925//9750 9922//9747 9921//9747 
f 9926//9751 9925//9750 9927//9750 
f 9928//9752 9926//9751 9929//9751 
f 9930//9753 9928//9752 9931//9752 
f 9932//9754 9930//9753 9933//9753 
f 9934//9755 9932//9754 9935//9754 
f 9936//9756 9934//9755 9937//9755 
f 9938//9757 9936//9756 9939//9756 
f 9940//9758 9938//9757 9941//9757 
f 9942//9759 9940//9758 9943//9758 
f 9944//9760 9942//9759 9945//9759 
f 9946//9761 9944//9760 9947//9760 
f 9948//9762 9946//9761 9949//9761 
f 9893//9720 9948//9762 9950//9762 
f 9950//9762 9894//9720 9893//9720 
f 9949//9761 9950//9762 9948//9762 
f 9947//9760 9949//9761 9946//9761 
f 9945//9759 9947//9760 9944//9760 
f 9943//9758 9945//9759 9942//9759 
f 9941//9757 9943//9758 9940//9758 
f 9939//9756 9941//9757 9938//9757 
f 9937//9755 9939//9756 9936//9756 
f 9935//9754 9937//9755 9934//9755 
f 9933//9753 9935//9754 9932//9754 
f 9931//9752 9933//9753 9930//9753 
f 9929//9751 9931//9752 9928//9752 
f 9927//9750 9929//9751 9926//9751 
f 9921//9747 9927//9750 9925//9750 
f 9923//9748 9919//9745 9924//9749 
f 9920//9746 9924//9749 9919//9745 
f 9918//9744 9920//9746 9917//9743 
f 9916//9742 9918//9744 9915//9741 
f 9914//9740 9916//9742 9913//9739 
f 9912//9738 9914//9740 9911//9737 
f 9910//9736 9912//9738 9909//9735 
f 9908//9734 9910//9736 9907//9733 
f 9906//9732 9908//9734 9905//9731 
f 9904//9730 9906//9732 9903//9729 
f 9902//9728 9904//9730 9901//9727 
f 9900//9726 9902//9728 9899//9725 
f 9898//9724 9900//9726 9897//9723 
f 9896//9722 9898//9724 9895//9721 
f 9894//9720 9896//9722 9892//9719 
o mesh417
f 9951//9763 9952//9763 9953//9763 
f 9953//9763 10083//9763 9951//9763 
f 9953//9763 9954//9763 10083//9763 
f 9951//9763 9955//9763 9952//9763 
f 10083//9763 9956//9763 9957//9763 
f 9954//9763 9958//9763 10083//9763 
f 9959//9763 9960//9763 9961//9763 
f 9959//9763 9957//9763 9962//9763 
f 10083//9763 9963//9763 9956//9763 
f 10083//9763 9964//9763 9965//9763 
f 9951//9763 9966//9763 9955//9763 
f 9951//9763 9967//9763 9968//9763 
f 9962//9763 9960//9763 9959//9763 
f 10083//9763 9969//9763 9963//9763 
f 9958//9763 9964//9763 10083//9763 
f 9951//9763 9970//9763 9971//9763 
f 9951//9763 9972//9763 9973//9763 
f 9967//9763 9974//9763 9968//9763 
f 9967//9763 9975//9763 9976//9763 
f 9967//9763 9959//9763 9977//9763 
f 9959//9763 9978//9763 9979//9763 
f 9957//9763 9959//9763 10083//9763 
f 9971//9763 9966//9763 9951//9763 
f 9951//9763 9980//9763 9972//9763 
f 9976//9763 9974//9763 9967//9763 
f 9977//9763 9981//9763 9967//9763 
f 9979//9763 9982//9763 9959//9763 
f 9965//9763 9969//9763 10083//9763 
f 9968//9763 9980//9763 9951//9763 
f 9959//9763 9983//9763 9977//9763 
f 9961//9763 9978//9763 9959//9763 
f 9981//9763 9975//9763 9967//9763 
f 9973//9763 9970//9763 9951//9763 
f 10083//9763 9984//9763 9985//9763 
f 10083//9763 9986//9763 9984//9763 
f 9985//9763 9987//9763 10083//9763 
f 9985//9763 9988//9763 9987//9763 
f 10083//9763 9989//9763 9990//9763 
f 9991//9763 9992//9763 9993//9763 
f 9987//9763 9994//9763 9995//9763 
f 9987//9763 9996//9763 9997//9763 
f 9990//9763 9998//9763 10083//9763 
f 9959//9763 9999//9763 10000//9763 
f 10001//9763 10002//9763 10003//9763 
f 9993//9763 10004//9763 9991//9763 
f 9991//9763 9987//9763 10005//9763 
f 9987//9763 10006//9763 9994//9763 
f 9987//9763 10007//9763 10008//9763 
f 9988//9763 9996//9763 9987//9763 
f 9998//9763 10009//9763 10083//9763 
f 9959//9763 10010//9763 9999//9763 
f 10003//9763 9959//9763 10001//9763 
f 10004//9763 10011//9763 9991//9763 
f 10005//9763 10012//9763 9991//9763 
f 10008//9763 10006//9763 9987//9763 
f 10009//9763 9986//9763 10083//9763 
f 10083//9763 10000//9763 10013//9763 
f 10003//9763 10010//9763 9959//9763 
f 10001//9763 10014//9763 10015//9763 
f 10012//9763 9992//9763 9991//9763 
f 9997//9763 10007//9763 9987//9763 
f 10000//9763 10083//9763 9959//9763 
f 10001//9763 10016//9763 10014//9763 
f 9995//9763 10005//9763 9987//9763 
f 10015//9763 10002//9763 10001//9763 
f 9991//9763 10016//9763 10001//9763 
f 10013//9763 9989//9763 10083//9763 
f 10011//9763 10016//9763 9991//9763 
f 10017//9763 10018//9763 10019//9763 
f 10020//9763 10021//9763 10022//9763 
f 10018//9763 10023//9763 10019//9763 
f 10020//9763 10024//9763 10021//9763 
f 10019//9763 10025//9763 10017//9763 
f 10018//9763 10026//9763 10027//9763 
f 10083//9763 10028//9763 10029//9763 
f 9987//9763 10030//9763 10031//9763 
f 10032//9763 10033//9763 10034//9763 
f 10022//9763 10035//9763 10020//9763 
f 10018//9763 10036//9763 10023//9763 
f 10018//9763 10037//9763 10026//9763 
f 10018//9763 10083//9763 10038//9763 
f 10083//9763 10039//9763 10028//9763 
f 10083//9763 10040//9763 10041//9763 
f 9987//9763 10042//9763 10040//9763 
f 9987//9763 10043//9763 10044//9763 
f 9987//9763 10045//9763 10046//9763 
f 10030//9763 10047//9763 10031//9763 
f 10032//9763 10048//9763 10033//9763 
f 10035//9763 10049//9763 10020//9763 
f 10018//9763 10050//9763 10051//9763 
f 10027//9763 10036//9763 10018//9763 
f 10038//9763 10052//9763 10018//9763 
f 10029//9763 10053//9763 10083//9763 
f 10041//9763 10054//9763 10083//9763 
f 10025//9763 10019//9763 10055//9763 
f 10044//9763 10042//9763 9987//9763 
f 9987//9763 10056//9763 10045//9763 
f 10031//9763 10057//9763 9987//9763 
f 10032//9763 10030//9763 10048//9763 
f 10034//9763 10058//9763 10059//9763 
f 10020//9763 10060//9763 10024//9763 
f 10018//9763 10061//9763 10050//9763 
f 10052//9763 10037//9763 10018//9763 
f 10054//9763 10039//9763 10083//9763 
f 10055//9763 10062//9763 10063//9763 
f 10055//9763 10034//9763 10064//9763 
f 10046//9763 10043//9763 9987//9763 
f 10030//9763 10032//9763 10047//9763 
f 10059//9763 10065//9763 10034//9763 
f 10034//9763 10055//9763 10066//9763 
f 10049//9763 10067//9763 10020//9763 
f 10051//9763 10020//9763 10018//9763 
f 10053//9763 10038//9763 10083//9763 
f 10064//9763 10062//9763 10055//9763 
f 10057//9763 10056//9763 9987//9763 
f 10066//9763 10058//9763 10034//9763 
f 9987//9763 10068//9763 10069//9763 
f 9987//9763 10070//9763 10071//9763 
f 10072//9763 10073//9763 10074//9763 
f 10072//9763 10075//9763 10020//9763 
f 10020//9763 10076//9763 10077//9763 
f 10051//9763 10060//9763 10020//9763 
f 10055//9763 10063//9763 10025//9763 
f 10034//9763 10065//9763 10032//9763 
f 10071//9763 10068//9763 9987//9763 
f 9987//9763 10078//9763 10079//9763 
f 10074//9763 9987//9763 10072//9763 
f 10020//9763 10080//9763 10072//9763 
f 10067//9763 10076//9763 10020//9763 
f 10040//9763 10083//9763 9987//9763 
f 10079//9763 10070//9763 9987//9763 
f 10080//9763 10073//9763 10072//9763 
f 10017//9763 10061//9763 10018//9763 
f 10074//9763 10078//9763 9987//9763 
f 10069//9763 10030//9763 9987//9763 
f 10081//9763 9951//9763 9903//9763 
f 9951//9763 9901//9763 9903//9763 
f 9951//9763 10083//9763 9893//9763 
f 10083//9763 9938//9763 9940//9763 
f 10083//9763 10018//9763 9936//9763 
f 10018//9763 9919//9763 9923//9763 
f 9951//9763 9899//9763 9901//9763 
f 9893//9763 9892//9763 9951//9763 
f 9936//9763 9938//9763 10083//9763 
f 10018//9763 9930//9763 9932//9763 
f 9923//9763 9922//9763 10018//9763 
f 10018//9763 10081//9763 9917//9763 
f 10081//9763 9905//9763 9907//9763 
f 9951//9763 9897//9763 9899//9763 
f 9892//9763 9895//9763 9951//9763 
f 10083//9763 9944//9763 9946//9763 
f 9940//9763 9942//9763 10083//9763 
f 9932//9763 9934//9763 10018//9763 
f 9917//9763 9919//9763 10018//9763 
f 9907//9763 9909//9763 10081//9763 
f 9895//9763 9897//9763 9951//9763 
f 9946//9763 9948//9763 10083//9763 
f 9934//9763 9936//9763 10018//9763 
f 9942//9763 9944//9763 10083//9763 
f 9922//9763 9925//9763 10018//9763 
f 10081//9763 9911//9763 9913//9763 
f 9903//9763 9905//9763 10081//9763 
f 10018//9763 9926//9763 9928//9763 
f 10081//9763 9915//9763 9917//9763 
f 9909//9763 9911//9763 10081//9763 
f 9928//9763 9930//9763 10018//9763 
f 9913//9763 9915//9763 10081//9763 
f 9925//9763 9926//9763 10018//9763 
f 9948//9763 9893//9763 10083//9763 
f 10077//9763 10080//9763 10020//9763 
f 10001//9763 10082//9763 9991//9763 
f 9982//9763 9983//9763 9959//9763 
o mesh418
f 9977//9764 9983//9765 10084//9765 
f 9981//9766 9977//9764 10085//9767 
f 9975//9768 9981//9766 10086//9769 
f 9976//9770 9975//9768 10087//9771 
f 9974//9772 9976//9770 10088//9773 
f 9968//9774 9974//9772 10089//9775 
f 9980//9776 9968//9774 10090//9777 
f 9972//9778 9980//9776 10091//9779 
f 9973//9780 9972//9778 10092//9781 
f 9970//9782 9973//9780 10093//9783 
f 9971//9784 9970//9782 10094//9785 
f 9966//9786 9971//9784 10095//9787 
f 9955//9788 9966//9786 10096//9789 
f 9952//9790 9955//9788 10097//9791 
f 10098//9792 9954//9792 9953//9793 
f 9953//9793 10099//9794 10098//9792 
f 9958//9795 9954//9792 10098//9792 
f 9964//9796 9958//9795 10100//9795 
f 9965//9797 9964//9796 10101//9796 
f 9969//9798 9965//9797 10102//9797 
f 9963//9799 9969//9798 10103//9798 
f 9956//9800 9963//9799 10104//9799 
f 9957//9801 9956//9800 10105//9800 
f 9962//9802 9957//9801 10106//9801 
f 9960//9803 9962//9802 10107//9802 
f 9961//9804 9960//9803 10108//9803 
f 9978//9805 9961//9804 10109//9804 
f 9979//9806 9978//9805 10110//9805 
f 9982//9807 9979//9806 10111//9806 
f 9983//9765 9982//9807 10112//9807 
f 10112//9807 10084//9765 9983//9765 
f 10111//9806 10112//9807 9982//9807 
f 10110//9805 10111//9806 9979//9806 
f 10109//9804 10110//9805 9978//9805 
f 10108//9803 10109//9804 9961//9804 
f 10107//9802 10108//9803 9960//9803 
f 10106//9801 10107//9802 9962//9802 
f 10105//9800 10106//9801 9957//9801 
f 10104//9799 10105//9800 9956//9800 
f 10103//9798 10104//9799 9963//9799 
f 10102//9797 10103//9798 9969//9798 
f 10101//9796 10102//9797 9965//9797 
f 10100//9795 10101//9796 9964//9796 
f 10098//9792 10100//9795 9958//9795 
f 9953//9793 9952//9790 10099//9794 
f 10097//9791 10099//9794 9952//9790 
f 10096//9789 10097//9791 9955//9788 
f 10095//9787 10096//9789 9966//9786 
f 10094//9785 10095//9787 9971//9784 
f 10093//9783 10094//9785 9970//9782 
f 10092//9781 10093//9783 9973//9780 
f 10091//9779 10092//9781 9972//9778 
f 10090//9777 10091//9779 9980//9776 
f 10089//9775 10090//9777 9968//9774 
f 10088//9773 10089//9775 9974//9772 
f 10087//9771 10088//9773 9976//9770 
f 10086//9769 10087//9771 9975//9768 
f 10085//9767 10086//9769 9981//9766 
f 10084//9765 10085//9767 9977//9764 
o mesh419
f 10014//9808 10016//9809 10113//9809 
f 10015//9810 10014//9808 10114//9811 
f 10002//9812 10015//9810 10115//9813 
f 10003//9814 10002//9812 10116//9815 
f 10010//9816 10003//9814 10117//9817 
f 9999//9818 10010//9816 10118//9819 
f 10000//9820 9999//9818 10119//9821 
f 10013//9822 10000//9820 10120//9823 
f 9989//9824 10013//9822 10121//9825 
f 9990//9826 9989//9824 10122//9827 
f 9998//9828 9990//9826 10123//9829 
f 10009//9830 9998//9828 10124//9831 
f 9986//9832 10009//9830 10125//9833 
f 9984//9834 9986//9832 10126//9835 
f 10127//9834 10128//9836 9985//9837 
f 10128//9836 9988//9836 9985//9837 
f 9996//9838 9988//9836 10128//9836 
f 9997//9839 9996//9838 10129//9838 
f 10007//9840 9997//9839 10130//9839 
f 10008//9841 10007//9840 10131//9840 
f 10006//9842 10008//9841 10132//9841 
f 9994//9843 10006//9842 10133//9842 
f 9995//9844 9994//9843 10134//9843 
f 10005//9845 9995//9844 10135//9844 
f 10012//9846 10005//9845 10136//9845 
f 9992//9847 10012//9846 10137//9846 
f 9993//9848 9992//9847 10138//9847 
f 10004//9849 9993//9848 10139//9848 
f 10011//9850 10004//9849 10140//9849 
f 10016//9809 10011//9850 10141//9850 
f 10141//9850 10113//9809 10016//9809 
f 10140//9849 10141//9850 10011//9850 
f 10139//9848 10140//9849 10004//9849 
f 10138//9847 10139//9848 9993//9848 
f 10137//9846 10138//9847 9992//9847 
f 10136//9845 10137//9846 10012//9846 
f 10135//9844 10136//9845 10005//9845 
f 10134//9843 10135//9844 9995//9844 
f 10133//9842 10134//9843 9994//9843 
f 10132//9841 10133//9842 10006//9842 
f 10131//9840 10132//9841 10008//9841 
f 10130//9839 10131//9840 10007//9840 
f 10129//9838 10130//9839 9997//9839 
f 10128//9836 10129//9838 9996//9838 
f 9985//9837 9984//9834 10127//9834 
f 10126//9835 10127//9834 9984//9834 
f 10125//9833 10126//9835 9986//9832 
f 10124//9831 10125//9833 10009//9830 
f 10123//9829 10124//9831 9998//9828 
f 10122//9827 10123//9829 9990//9826 
f 10121//9825 10122//9827 9989//9824 
f 10120//9823 10121//9825 10013//9822 
f 10119//9821 10120//9823 10000//9820 
f 10118//9819 10119//9821 9999//9818 
f 10117//9817 10118//9819 10010//9816 
f 10116//9815 10117//9817 10003//9814 
f 10115//9813 10116//9815 10002//9812 
f 10114//9811 10115//9813 10015//9810 
f 10113//9809 10114//9811 10014//9808 
o mesh420
f 10048//9851 10030//9852 10142//9852 
f 10033//9853 10048//9851 10143//9854 
f 10034//9855 10033//9853 10144//9856 
f 10064//9857 10034//9855 10145//9858 
f 10062//9859 10064//9857 10146//9860 
f 10063//9861 10062//9859 10147//9862 
f 10025//9863 10063//9861 10148//9864 
f 10017//9865 10025//9863 10149//9866 
f 10061//9867 10017//9865 10150//9868 
f 10050//9869 10061//9867 10151//9870 
f 10051//9871 10050//9869 10152//9872 
f 10060//9873 10051//9871 10153//9874 
f 10024//9875 10060//9873 10154//9876 
f 10021//9877 10024//9875 10155//9878 
f 10156//9877 10157//9879 10022//9880 
f 10157//9879 10035//9879 10022//9880 
f 10049//9881 10035//9879 10157//9879 
f 10067//9882 10049//9881 10158//9881 
f 10076//9883 10067//9882 10159//9882 
f 10077//9884 10076//9883 10160//9883 
f 10080//9885 10077//9884 10161//9884 
f 10073//9886 10080//9885 10162//9885 
f 10074//9887 10073//9886 10163//9886 
f 10078//9888 10074//9887 10164//9887 
f 10079//9889 10078//9888 10165//9888 
f 10070//9890 10079//9889 10166//9889 
f 10071//9891 10070//9890 10167//9890 
f 10068//9892 10071//9891 10168//9891 
f 10069//9893 10068//9892 10169//9892 
f 10030//9852 10069//9893 10170//9893 
f 10170//9893 10142//9852 10030//9852 
f 10169//9892 10170//9893 10069//9893 
f 10168//9891 10169//9892 10068//9892 
f 10167//9890 10168//9891 10071//9891 
f 10166//9889 10167//9890 10070//9890 
f 10165//9888 10166//9889 10079//9889 
f 10164//9887 10165//9888 10078//9888 
f 10163//9886 10164//9887 10074//9887 
f 10162//9885 10163//9886 10073//9886 
f 10161//9884 10162//9885 10080//9885 
f 10160//9883 10161//9884 10077//9884 
f 10159//9882 10160//9883 10076//9883 
f 10158//9881 10159//9882 10067//9882 
f 10157//9879 10158//9881 10049//9881 
f 10022//9880 10021//9877 10156//9877 
f 10155//9878 10156//9877 10021//9877 
f 10154//9876 10155//9878 10024//9875 
f 10153//9874 10154//9876 10060//9873 
f 10152//9872 10153//9874 10051//9871 
f 10151//9870 10152//9872 10050//9869 
f 10150//9868 10151//9870 10061//9867 
f 10149//9866 10150//9868 10017//9865 
f 10148//9864 10149//9866 10025//9863 
f 10147//9862 10148//9864 10063//9861 
f 10146//9860 10147//9862 10062//9859 
f 10145//9858 10146//9860 10064//9857 
f 10144//9856 10145//9858 10034//9855 
f 10143//9854 10144//9856 10033//9853 
f 10142//9852 10143//9854 10048//9851 
o mesh421
f 10042//9894 10171//9894 10172//9895 
f 10172//9895 10040//9896 10042//9894 
f 10044//9897 10173//9897 10174//9898 
f 10174//9898 10042//9894 10044//9897 
f 10043//9899 10175//9899 10176//9900 
f 10176//9900 10044//9897 10043//9899 
f 10046//9901 10177//9901 10178//9902 
f 10178//9902 10043//9899 10046//9901 
f 10045//9903 10179//9903 10180//9904 
f 10180//9904 10046//9901 10045//9903 
f 10056//9905 10181//9905 10182//9906 
f 10182//9906 10045//9903 10056//9905 
f 10057//9907 10183//9907 10184//9908 
f 10184//9908 10056//9905 10057//9907 
f 10031//9909 10185//9909 10186//9910 
f 10186//9910 10057//9907 10031//9909 
f 10047//9911 10187//9911 10188//9912 
f 10188//9912 10031//9909 10047//9911 
f 10032//9913 10189//9913 10190//9914 
f 10190//9914 10047//9911 10032//9913 
f 10065//9915 10191//9915 10192//9916 
f 10192//9916 10032//9913 10065//9915 
f 10059//9917 10193//9917 10194//9918 
f 10194//9918 10065//9915 10059//9917 
f 10058//9919 10195//9919 10196//9920 
f 10196//9920 10059//9917 10058//9919 
f 10058//9919 10066//9921 10197//9922 
f 10066//9921 10198//9921 10197//9922 
f 10066//9921 10055//9923 10199//9923 
f 10019//9924 10200//9924 10199//9923 
f 10199//9923 10055//9923 10019//9924 
f 10023//9925 10201//9925 10202//9926 
f 10202//9926 10019//9924 10023//9925 
f 10036//9927 10203//9927 10204//9928 
f 10204//9928 10023//9925 10036//9927 
f 10027//9929 10205//9929 10206//9930 
f 10206//9930 10036//9927 10027//9929 
f 10026//9931 10207//9931 10208//9932 
f 10208//9932 10027//9929 10026//9931 
f 10037//9933 10209//9933 10210//9934 
f 10210//9934 10026//9931 10037//9933 
f 10052//9935 10211//9935 10212//9936 
f 10212//9936 10037//9933 10052//9935 
f 10038//9937 10213//9937 10214//9938 
f 10214//9938 10052//9935 10038//9937 
f 10053//9939 10215//9939 10216//9940 
f 10216//9940 10038//9937 10053//9939 
f 10029//9941 10217//9941 10218//9942 
f 10218//9942 10053//9939 10029//9941 
f 10028//9943 10219//9943 10220//9944 
f 10220//9944 10029//9941 10028//9943 
f 10039//9945 10221//9945 10222//9946 
f 10222//9946 10028//9943 10039//9945 
f 10054//9947 10223//9947 10224//9948 
f 10224//9948 10039//9945 10054//9947 
f 10041//9949 10225//9949 10226//9950 
f 10226//9950 10054//9947 10041//9949 
f 10040//9896 10227//9951 10228//9952 
f 10228//9952 10041//9949 10040//9896 
f 10228//9952 10225//9949 10041//9949 
f 10226//9950 10223//9947 10054//9947 
f 10224//9948 10221//9945 10039//9945 
f 10222//9946 10219//9943 10028//9943 
f 10220//9944 10217//9941 10029//9941 
f 10218//9942 10215//9939 10053//9939 
f 10216//9940 10213//9937 10038//9937 
f 10214//9938 10211//9935 10052//9935 
f 10212//9936 10209//9933 10037//9933 
f 10210//9934 10207//9931 10026//9931 
f 10208//9932 10205//9929 10027//9929 
f 10206//9930 10203//9927 10036//9927 
f 10204//9928 10201//9925 10023//9925 
f 10202//9926 10200//9924 10019//9924 
f 10199//9923 10198//9921 10066//9921 
f 10197//9922 10195//9919 10058//9919 
f 10196//9920 10193//9917 10059//9917 
f 10194//9918 10191//9915 10065//9915 
f 10192//9916 10189//9913 10032//9913 
f 10190//9914 10187//9911 10047//9911 
f 10188//9912 10185//9909 10031//9909 
f 10186//9910 10183//9907 10057//9907 
f 10184//9908 10181//9905 10056//9905 
f 10182//9906 10179//9903 10045//9903 
f 10180//9904 10177//9901 10046//9901 
f 10178//9902 10175//9899 10043//9899 
f 10176//9900 10173//9897 10044//9897 
f 10174//9898 10171//9894 10042//9894 
f 10172//9895 10227//9951 10040//9896 
o mesh422
f 10229//9953 10230//9954 10198//9955 
f 10230//9954 10197//9954 10198//9955 
f 10231//9956 10196//9956 10195//9957 
f 10195//9957 10230//9954 10231//9956 
f 10232//9958 10194//9958 10193//9959 
f 10193//9959 10231//9956 10232//9958 
f 10233//9960 10192//9960 10191//9961 
f 10191//9961 10232//9958 10233//9960 
f 10234//9962 10190//9962 10189//9963 
f 10189//9963 10233//9960 10234//9962 
f 10235//9964 10188//9964 10187//9965 
f 10187//9965 10234//9962 10235//9964 
f 10236//9966 10186//9966 10185//9967 
f 10185//9967 10235//9964 10236//9966 
f 10237//9968 10184//9968 10183//9969 
f 10183//9969 10236//9966 10237//9968 
f 10238//9970 10182//9970 10181//9971 
f 10181//9971 10237//9968 10238//9970 
f 10239//9972 10180//9972 10179//9973 
f 10179//9973 10238//9970 10239//9972 
f 10240//9974 10178//9974 10177//9975 
f 10177//9975 10239//9972 10240//9974 
f 10241//9976 10176//9976 10175//9977 
f 10175//9977 10240//9974 10241//9976 
f 10242//9978 10174//9978 10173//9979 
f 10173//9979 10241//9976 10242//9978 
f 10243//9980 10172//9980 10171//9981 
f 10171//9981 10242//9978 10243//9980 
f 10243//9980 10244//9982 10227//9982 
f 10245//9983 10228//9983 10227//9982 
f 10227//9982 10244//9982 10245//9983 
f 10246//9984 10226//9984 10225//9985 
f 10225//9985 10245//9983 10246//9984 
f 10247//9986 10224//9986 10223//9987 
f 10223//9987 10246//9984 10247//9986 
f 10248//9988 10222//9988 10221//9989 
f 10221//9989 10247//9986 10248//9988 
f 10249//9990 10220//9990 10219//9991 
f 10219//9991 10248//9988 10249//9990 
f 10250//9992 10218//9992 10217//9993 
f 10217//9993 10249//9990 10250//9992 
f 10251//9994 10216//9994 10215//9995 
f 10215//9995 10250//9992 10251//9994 
f 10252//9996 10214//9996 10213//9997 
f 10213//9997 10251//9994 10252//9996 
f 10253//9998 10212//9998 10211//9999 
f 10211//9999 10252//9996 10253//9998 
f 10254//10000 10210//10000 10209//10001 
f 10209//10001 10253//9998 10254//10000 
f 10255//10002 10208//10002 10207//10003 
f 10207//10003 10254//10000 10255//10002 
f 10256//10004 10206//10004 10205//10005 
f 10205//10005 10255//10002 10256//10004 
f 10257//10006 10204//10006 10203//10007 
f 10203//10007 10256//10004 10257//10006 
f 10258//10008 10202//10008 10201//10009 
f 10201//10009 10257//10006 10258//10008 
f 10229//9953 10199//10010 10200//10011 
f 10200//10011 10258//10008 10229//9953 
f 10200//10011 10202//10008 10258//10008 
f 10201//10009 10204//10006 10257//10006 
f 10203//10007 10206//10004 10256//10004 
f 10205//10005 10208//10002 10255//10002 
f 10207//10003 10210//10000 10254//10000 
f 10209//10001 10212//9998 10253//9998 
f 10211//9999 10214//9996 10252//9996 
f 10213//9997 10216//9994 10251//9994 
f 10215//9995 10218//9992 10250//9992 
f 10217//9993 10220//9990 10249//9990 
f 10219//9991 10222//9988 10248//9988 
f 10221//9989 10224//9986 10247//9986 
f 10223//9987 10226//9984 10246//9984 
f 10225//9985 10228//9983 10245//9983 
f 10227//9982 10172//9980 10243//9980 
f 10171//9981 10174//9978 10242//9978 
f 10173//9979 10176//9976 10241//9976 
f 10175//9977 10178//9974 10240//9974 
f 10177//9975 10180//9972 10239//9972 
f 10179//9973 10182//9970 10238//9970 
f 10181//9971 10184//9968 10237//9968 
f 10183//9969 10186//9966 10236//9966 
f 10185//9967 10188//9964 10235//9964 
f 10187//9965 10190//9962 10234//9962 
f 10189//9963 10192//9960 10233//9960 
f 10191//9961 10194//9958 10232//9958 
f 10193//9959 10196//9956 10231//9956 
f 10195//9957 10197//9954 10230//9954 
f 10198//9955 10199//10010 10229//9953 
o mesh423
f 10259//10012 10260//10012 10018//10012 
f 10081//10012 10018//10012 10260//10012 
f 10260//10012 10261//10012 10081//10012 
f 10018//10012 10020//10012 10259//10012 
o mesh424
f 10262//10013 10260//10013 10259//10013 
o mesh425
f 10263//10014 9951//10014 10081//10014 
f 10263//10014 10264//10014 9951//10014 
f 10264//10014 10265//10014 9967//10014 
f 9967//10014 9951//10014 10264//10014 
f 10081//10014 10261//10014 10263//10014 
o mesh426
f 10264//10015 10263//10015 10266//10015 
f 10263//10015 10267//10015 10266//10015 
f 10266//10015 10268//10015 10264//10015 
o mesh427
f 9967//10016 10265//10016 10269//10016 
f 10270//10016 10001//10016 9959//10016 
f 9959//10016 10269//10016 10270//10016 
f 10269//10016 9959//10016 9967//10016 
o mesh428
f 10271//10017 10270//10017 10269//10017 
o mesh429
f 10262//10018 10272//10018 10273//10018 
f 10267//10018 10263//10018 10261//10018 
f 10273//10018 10274//10018 10262//10018 
f 10261//10018 10260//10018 10267//10018 
f 10274//10018 10260//10018 10262//10018 
f 10272//10018 10275//10018 10273//10018 
f 10260//10018 10274//10018 10267//10018 
o mesh430
f 10276//10019 10275//10019 10272//10019 
f 10272//10019 10277//10019 10276//10019 
o mesh431
f 10020//10020 10075//10020 10278//10020 
f 10278//10020 10279//10020 10020//10020 
f 10075//10020 10280//10020 10281//10020 
f 10075//10020 10282//10020 10283//10020 
f 10277//10020 10284//10020 10282//10020 
f 10259//10020 10285//10020 10286//10020 
f 10075//10020 10287//10020 10278//10020 
f 10075//10020 10288//10020 10289//10020 
f 10075//10020 10290//10020 10280//10020 
f 10282//10020 10075//10020 10277//10020 
f 10277//10020 10291//10020 10292//10020 
f 10277//10020 10293//10020 10294//10020 
f 10277//10020 10262//10020 10295//10020 
f 10259//10020 10296//10020 10285//10020 
f 10259//10020 10279//10020 10297//10020 
f 10289//10020 10287//10020 10075//10020 
f 10283//10020 10290//10020 10075//10020 
f 10294//10020 10291//10020 10277//10020 
f 10295//10020 10298//10020 10277//10020 
f 10262//10020 10299//10020 10300//10020 
f 10262//10020 10259//10020 10301//10020 
f 10259//10020 10302//10020 10303//10020 
f 10297//10020 10296//10020 10259//10020 
f 10281//10020 10288//10020 10075//10020 
f 10298//10020 10293//10020 10277//10020 
f 10262//10020 10304//10020 10305//10020 
f 10262//10020 10306//10020 10299//10020 
f 10301//10020 10307//10020 10262//10020 
f 10286//10020 10302//10020 10259//10020 
f 10292//10020 10284//10020 10277//10020 
f 10300//10020 10304//10020 10262//10020 
f 10303//10020 10301//10020 10259//10020 
f 10277//10020 10272//10020 10262//10020 
f 10307//10020 10306//10020 10262//10020 
f 10305//10020 10295//10020 10262//10020 
f 10279//10020 10259//10020 10020//10020 
o mesh432
f 10277//10021 10075//10021 10308//10021 
f 10308//10021 10309//10021 10277//10021 
o mesh433
f 10072//10022 10310//10022 10308//10022 
f 10308//10022 10075//10022 10072//10022 
o mesh434
f 10311//10023 10312//10024 10281//10024 
f 10313//10025 10311//10023 10280//10026 
f 10314//10027 10313//10025 10290//10028 
f 10315//10029 10314//10027 10283//10030 
f 10316//10031 10315//10029 10282//10032 
f 10317//10033 10316//10031 10284//10034 
f 10318//10035 10317//10033 10292//10036 
f 10319//10037 10318//10035 10291//10038 
f 10320//10039 10319//10037 10294//10040 
f 10321//10041 10320//10039 10293//10042 
f 10322//10043 10321//10041 10295//10044 
f 10321//10041 10298//10045 10295//10044 
f 10323//10046 10322//10043 10305//10047 
f 10324//10048 10323//10046 10304//10049 
f 10325//10050 10324//10048 10300//10051 
f 10326//10052 10325//10050 10299//10053 
f 10327//10054 10326//10052 10306//10055 
f 10328//10056 10327//10054 10307//10057 
f 10329//10058 10328//10056 10301//10059 
f 10330//10060 10329//10058 10303//10061 
f 10331//10062 10330//10060 10302//10063 
f 10332//10064 10331//10062 10286//10065 
f 10281//10024 10333//10066 10334//10067 
f 10281//10024 10312//10024 10333//10066 
f 10288//10067 10335//10068 10336//10069 
f 10288//10067 10334//10067 10335//10068 
f 10289//10069 10337//10070 10338//10071 
f 10289//10069 10336//10069 10337//10070 
f 10287//10071 10339//10072 10340//10073 
f 10287//10071 10338//10071 10339//10072 
f 10279//10074 10278//10073 10340//10073 
f 10340//10073 10341//10075 10279//10074 
f 10297//10076 10279//10074 10342//10077 
f 10342//10077 10343//10078 10297//10076 
f 10296//10079 10297//10076 10344//10080 
f 10344//10080 10345//10081 10296//10079 
f 10285//10082 10296//10079 10346//10083 
f 10346//10083 10347//10084 10285//10082 
f 10347//10084 10332//10064 10285//10082 
f 10345//10081 10346//10083 10296//10079 
f 10343//10078 10344//10080 10297//10076 
f 10341//10075 10342//10077 10279//10074 
f 10340//10073 10278//10073 10287//10071 
f 10338//10071 10287//10071 10289//10069 
f 10336//10069 10289//10069 10288//10067 
f 10334//10067 10288//10067 10281//10024 
f 10286//10065 10285//10082 10332//10064 
f 10302//10063 10286//10065 10331//10062 
f 10303//10061 10302//10063 10330//10060 
f 10301//10059 10303//10061 10329//10058 
f 10307//10057 10301//10059 10328//10056 
f 10306//10055 10307//10057 10327//10054 
f 10299//10053 10306//10055 10326//10052 
f 10300//10051 10299//10053 10325//10050 
f 10304//10049 10300//10051 10324//10048 
f 10305//10047 10304//10049 10323//10046 
f 10295//10044 10305//10047 10322//10043 
f 10293//10042 10298//10045 10321//10041 
f 10294//10040 10293//10042 10320//10039 
f 10291//10038 10294//10040 10319//10037 
f 10292//10036 10291//10038 10318//10035 
f 10284//10034 10292//10036 10317//10033 
f 10282//10032 10284//10034 10316//10031 
f 10283//10030 10282//10032 10315//10029 
f 10290//10028 10283//10030 10314//10027 
f 10280//10026 10290//10028 10313//10025 
f 10281//10024 10280//10026 10311//10023 
o mesh435
f 10309//10085 10276//10085 10277//10085 
o mesh436
f 10348//10086 10349//10086 10275//10086 
f 10349//10086 10273//10086 10275//10086 
f 10275//10086 10276//10086 10348//10086 
o mesh437
f 10310//10087 10350//10087 10309//10087 
f 10309//10087 10308//10087 10310//10087 
o mesh438
f 10310//10088 10072//10088 10351//10088 
o mesh439
f 10309//10089 10350//10089 10348//10089 
f 10348//10089 10276//10089 10309//10089 
o mesh440
f 10351//10090 10352//10090 10350//10090 
f 10350//10090 10310//10090 10351//10090 
o mesh441
f 10348//10091 10350//10091 10352//10091 
o mesh442
f 10352//10092 10353//10092 10349//10092 
f 10349//10092 10348//10092 10352//10092 
f 10353//10092 10354//10092 10349//10092 
o mesh443
f 10349//10093 10354//10093 10355//10093 
f 10356//10093 10274//10093 10273//10093 
f 10273//10093 10355//10093 10356//10093 
f 10355//10093 10273//10093 10349//10093 
o mesh444
f 10357//10094 10355//10094 10353//10094 
f 10353//10094 10358//10094 10357//10094 
f 10355//10094 10354//10094 10353//10094 
o mesh445
f 10355//10095 10357//10095 10359//10095 
f 10359//10095 10356//10095 10355//10095 
o mesh446
f 10360//10096 10347//10096 9987//10096 
f 10347//10096 10346//10096 9987//10096 
f 9987//10096 10361//10096 10360//10096 
f 10346//10096 10345//10096 9987//10096 
f 9991//10096 10362//10096 10363//10096 
f 10072//10096 10334//10096 10333//10096 
f 10347//10096 10364//10096 10365//10096 
f 10345//10096 10344//10096 9987//10096 
f 10363//10096 10366//10096 9991//10096 
f 10072//10096 10335//10096 10334//10096 
f 10347//10096 10367//10096 10368//10096 
f 10347//10096 10360//10096 10364//10096 
f 10365//10096 10367//10096 10347//10096 
f 10344//10096 10343//10096 9987//10096 
f 10366//10096 10369//10096 9991//10096 
f 10072//10096 10336//10096 10335//10096 
f 10368//10096 10370//10096 10347//10096 
f 10343//10096 10342//10096 9987//10096 
f 10369//10096 10371//10096 9991//10096 
f 10072//10096 10337//10096 10336//10096 
f 10072//10096 9987//10096 10341//10096 
f 10342//10096 10341//10096 9987//10096 
f 10371//10096 10372//10096 9991//10096 
f 10072//10096 10338//10096 10337//10096 
f 9991//10096 10373//10096 10361//10096 
f 10372//10096 10374//10096 9991//10096 
f 10072//10096 10339//10096 10338//10096 
f 10361//10096 9987//10096 9991//10096 
f 10374//10096 10375//10096 9991//10096 
f 10072//10096 10340//10096 10339//10096 
f 10375//10096 10373//10096 9991//10096 
f 10341//10096 10340//10096 10072//10096 
f 10333//10096 10351//10096 10072//10096 
o mesh447
f 10376//10097 10377//10098 10378//10098 
f 10379//10099 10376//10097 10380//10100 
f 10381//10101 10379//10099 10382//10102 
f 10383//10103 10381//10101 10384//10104 
f 10385//10105 10383//10103 10386//10106 
f 10387//10107 10385//10105 10388//10108 
f 10389//10109 10387//10107 10390//10110 
f 10391//10111 10389//10109 10392//10112 
f 10393//10113 10391//10111 10394//10114 
f 10395//10115 10393//10113 10396//10116 
f 10397//10117 10395//10115 10398//10118 
f 10395//10115 10399//10119 10398//10118 
f 10400//10120 10397//10117 10401//10121 
f 10402//10122 10400//10120 10403//10123 
f 10404//10124 10402//10122 10405//10125 
f 10406//10126 10404//10124 10407//10127 
f 10408//10128 10406//10126 10409//10129 
f 10410//10130 10408//10128 10411//10131 
f 10412//10132 10410//10130 10413//10133 
f 10414//10134 10412//10132 10415//10135 
f 10416//10136 10414//10134 10417//10137 
f 10418//10138 10416//10136 10419//10139 
f 10378//10098 10370//10140 10368//10141 
f 10378//10098 10377//10098 10370//10140 
f 10420//10141 10367//10142 10365//10143 
f 10420//10141 10368//10141 10367//10142 
f 10421//10143 10364//10144 10360//10145 
f 10421//10143 10365//10143 10364//10144 
f 10422//10145 10361//10146 10373//10147 
f 10422//10145 10360//10145 10361//10146 
f 10423//10148 10424//10147 10373//10147 
f 10373//10147 10375//10149 10423//10148 
f 10425//10150 10423//10148 10374//10151 
f 10374//10151 10372//10152 10425//10150 
f 10426//10153 10425//10150 10371//10154 
f 10371//10154 10369//10155 10426//10153 
f 10427//10156 10426//10153 10366//10157 
f 10366//10157 10363//10158 10427//10156 
f 10363//10158 10418//10138 10427//10156 
f 10369//10155 10366//10157 10426//10153 
f 10372//10152 10371//10154 10425//10150 
f 10375//10149 10374//10151 10423//10148 
f 10373//10147 10424//10147 10422//10145 
f 10360//10145 10422//10145 10421//10143 
f 10365//10143 10421//10143 10420//10141 
f 10368//10141 10420//10141 10378//10098 
f 10419//10139 10427//10156 10418//10138 
f 10417//10137 10419//10139 10416//10136 
f 10415//10135 10417//10137 10414//10134 
f 10413//10133 10415//10135 10412//10132 
f 10411//10131 10413//10133 10410//10130 
f 10409//10129 10411//10131 10408//10128 
f 10407//10127 10409//10129 10406//10126 
f 10405//10125 10407//10127 10404//10124 
f 10403//10123 10405//10125 10402//10122 
f 10401//10121 10403//10123 10400//10120 
f 10398//10118 10401//10121 10397//10117 
f 10396//10116 10399//10119 10395//10115 
f 10394//10114 10396//10116 10393//10113 
f 10392//10112 10394//10114 10391//10111 
f 10390//10110 10392//10112 10389//10109 
f 10388//10108 10390//10110 10387//10107 
f 10386//10106 10388//10108 10385//10105 
f 10384//10104 10386//10106 10383//10103 
f 10382//10102 10384//10104 10381//10101 
f 10380//10100 10382//10102 10379//10099 
f 10378//10098 10380//10100 10376//10097 
o mesh448
f 9991//10159 10428//10159 10362//10159 
o mesh449
f 10352//10160 10321//10160 10322//10160 
f 10322//10160 10353//10160 10352//10160 
f 10429//10160 10430//10160 10395//10160 
f 10353//10160 10323//10160 10324//10160 
f 10352//10160 10320//10160 10321//10160 
f 10429//10160 10400//10160 10402//10160 
f 10395//10160 10397//10160 10429//10160 
f 10430//10160 10431//10160 10385//10160 
f 10322//10160 10323//10160 10353//10160 
f 10352//10160 10318//10160 10319//10160 
f 10402//10160 10404//10160 10429//10160 
f 10430//10160 10393//10160 10395//10160 
f 10430//10160 10389//10160 10391//10160 
f 10385//10160 10387//10160 10430//10160 
f 10319//10160 10320//10160 10352//10160 
f 10362//10160 10429//10160 10408//10160 
f 10397//10160 10400//10160 10429//10160 
f 10387//10160 10389//10160 10430//10160 
f 10353//10160 10326//10160 10327//10160 
f 10324//10160 10325//10160 10353//10160 
f 10352//10160 10316//10160 10317//10160 
f 10429//10160 10406//10160 10408//10160 
f 10391//10160 10393//10160 10430//10160 
f 10431//10160 10379//10160 10381//10160 
f 10358//10160 10331//10160 10332//10160 
f 10327//10160 10358//10160 10353//10160 
f 10317//10160 10318//10160 10352//10160 
f 10351//10160 10315//10160 10316//10160 
f 10351//10160 10313//10160 10314//10160 
f 10362//10160 10416//10160 10418//10160 
f 10404//10160 10406//10160 10429//10160 
f 10381//10160 10383//10160 10431//10160 
f 10431//10160 10370//10160 10377//10160 
f 10358//10160 10330//10160 10331//10160 
f 10358//10160 10328//10160 10329//10160 
f 10325//10160 10326//10160 10353//10160 
f 10314//10160 10315//10160 10351//10160 
f 10362//10160 10414//10160 10416//10160 
f 10362//10160 10410//10160 10412//10160 
f 10383//10160 10385//10160 10431//10160 
f 10377//10160 10376//10160 10431//10160 
f 10329//10160 10330//10160 10358//10160 
f 10316//10160 10352//10160 10351//10160 
f 10351//10160 10333//10160 10312//10160 
f 10370//10160 10431//10160 10432//10160 
f 10412//10160 10414//10160 10362//10160 
f 10376//10160 10379//10160 10431//10160 
f 10327//10160 10328//10160 10358//10160 
f 10312//10160 10311//10160 10351//10160 
f 10432//10160 10347//10160 10370//10160 
f 10408//10160 10410//10160 10362//10160 
f 10311//10160 10313//10160 10351//10160 
f 10418//10160 10363//10160 10362//10160 
f 10432//10160 10358//10160 10347//10160 
f 10332//10160 10347//10160 10358//10160 
o mesh450
f 10266//10161 9896//10161 9894//10161 
f 10437//10161 9945//10161 9943//10161 
f 10437//10161 9950//10161 9949//10161 
f 10266//10161 9898//10161 9896//10161 
f 10266//10161 9908//10161 9906//10161 
f 10359//10161 9937//10161 9935//10161 
f 10359//10161 10437//10161 9939//10161 
f 9943//10161 9941//10161 10437//10161 
f 10437//10161 9894//10161 9950//10161 
f 10266//10161 9900//10161 9898//10161 
f 9906//10161 9904//10161 10266//10161 
f 9939//10161 9937//10161 10359//10161 
f 10437//10161 9947//10161 9945//10161 
f 9894//10161 10437//10161 10266//10161 
f 9904//10161 9902//10161 10266//10161 
f 10267//10161 9912//10161 9910//10161 
f 9941//10161 9939//10161 10437//10161 
f 9902//10161 9900//10161 10266//10161 
f 9910//10161 10266//10161 10267//10161 
f 9949//10161 9947//10161 10437//10161 
f 10267//10161 9914//10161 9912//10161 
f 10359//10161 9933//10161 9931//10161 
f 9910//10161 9908//10161 10266//10161 
f 9927//10161 9921//10161 10356//10161 
f 9935//10161 9933//10161 10359//10161 
f 10267//10161 9918//10161 9916//10161 
f 10274//10161 9924//10161 9920//10161 
f 10359//10161 9929//10161 9927//10161 
f 9916//10161 9914//10161 10267//10161 
f 9920//10161 10267//10161 10274//10161 
f 9924//10161 10274//10161 10356//10161 
f 9931//10161 9929//10161 10359//10161 
f 10356//10161 9921//10161 9924//10161 
f 9920//10161 9918//10161 10267//10161 
f 10437//10161 10143//10161 10142//10161 
f 10437//10161 10145//10161 10144//10161 
f 10144//10161 10143//10161 10437//10161 
f 10142//10161 10432//10161 10437//10161 
f 10159//10161 10158//10161 10357//10161 
f 10358//10161 10162//10161 10161//10161 
f 10432//10161 10163//10161 10162//10161 
f 10432//10161 10169//10161 10168//10161 
f 10142//10161 10170//10161 10432//10161 
f 10437//10161 10147//10161 10146//10161 
f 10437//10161 10149//10161 10148//10161 
f 10437//10161 10359//10161 10150//10161 
f 10357//10161 10358//10161 10159//10161 
f 10162//10161 10358//10161 10432//10161 
f 10432//10161 10165//10161 10164//10161 
f 10432//10161 10167//10161 10166//10161 
f 10170//10161 10169//10161 10432//10161 
f 10148//10161 10147//10161 10437//10161 
f 10359//10161 10151//10161 10150//10161 
f 10358//10161 10160//10161 10159//10161 
f 10164//10161 10163//10161 10432//10161 
f 10168//10161 10167//10161 10432//10161 
f 10150//10161 10149//10161 10437//10161 
f 10359//10161 10153//10161 10152//10161 
f 10359//10161 10357//10161 10155//10161 
f 10357//10161 10157//10161 10156//10161 
f 10161//10161 10160//10161 10358//10161 
f 10146//10161 10145//10161 10437//10161 
f 10359//10161 10154//10161 10153//10161 
f 10156//10161 10155//10161 10357//10161 
f 10166//10161 10165//10161 10432//10161 
f 10155//10161 10154//10161 10359//10161 
f 10152//10161 10151//10161 10359//10161 
f 10119//10161 10433//10161 10245//10161 
f 10433//10161 10246//10161 10245//10161 
f 10240//10161 10124//10161 10123//10161 
f 10239//10161 10125//10161 10124//10161 
f 10432//10161 10126//10161 10237//10161 
f 10433//10161 10118//10161 10117//10161 
f 10245//10161 10120//10161 10119//10161 
f 10433//10161 10437//10161 10252//10161 
f 10437//10161 10256//10161 10255//10161 
f 10124//10161 10240//10161 10239//10161 
f 10432//10161 10230//10161 10229//10161 
f 10432//10161 10232//10161 10231//10161 
f 10432//10161 10235//10161 10234//10161 
f 10126//10161 10238//10161 10237//10161 
f 10139//10161 10431//10161 10434//10161 
f 10119//10161 10118//10161 10433//10161 
f 10433//10161 10249//10161 10248//10161 
f 10252//10161 10251//10161 10433//10161 
f 10437//10161 10254//10161 10253//10161 
f 10437//10161 10257//10161 10256//10161 
f 10437//10161 10229//10161 10258//10161 
f 10122//10161 10241//10161 10240//10161 
f 10122//10161 10245//10161 10244//10161 
f 10231//10161 10230//10161 10432//10161 
f 10234//10161 10233//10161 10432//10161 
f 10237//10161 10236//10161 10432//10161 
f 10126//10161 10125//10161 10239//10161 
f 10434//10161 10140//10161 10139//10161 
f 10433//10161 10247//10161 10246//10161 
f 10433//10161 10250//10161 10249//10161 
f 10253//10161 10252//10161 10437//10161 
f 10258//10161 10257//10161 10437//10161 
f 10122//10161 10242//10161 10241//10161 
f 10244//10161 10243//10161 10122//10161 
f 10233//10161 10232//10161 10432//10161 
f 10239//10161 10238//10161 10126//10161 
f 10432//10161 10133//10161 10132//10161 
f 10431//10161 10135//10161 10134//10161 
f 10431//10161 10138//10161 10137//10161 
f 10434//10161 10141//10161 10140//10161 
f 10434//10161 10114//10161 10113//10161 
f 10434//10161 10116//10161 10115//10161 
f 10248//10161 10247//10161 10433//10161 
f 10255//10161 10254//10161 10437//10161 
f 10243//10161 10242//10161 10122//10161 
f 10236//10161 10235//10161 10432//10161 
f 10432//10161 10131//10161 10130//10161 
f 10432//10161 10134//10161 10133//10161 
f 10431//10161 10136//10161 10135//10161 
f 10139//10161 10138//10161 10431//10161 
f 10115//10161 10114//10161 10434//10161 
f 10251//10161 10250//10161 10433//10161 
f 10245//10161 10122//10161 10121//10161 
f 10229//10161 10437//10161 10432//10161 
f 10432//10161 10128//10161 10127//10161 
f 10130//10161 10129//10161 10432//10161 
f 10134//10161 10432//10161 10431//10161 
f 10113//10161 10141//10161 10434//10161 
f 10121//10161 10120//10161 10245//10161 
f 10127//10161 10126//10161 10432//10161 
f 10132//10161 10131//10161 10432//10161 
f 10434//10161 10117//10161 10116//10161 
f 10123//10161 10122//10161 10240//10161 
f 10137//10161 10136//10161 10431//10161 
f 10129//10161 10128//10161 10432//10161 
f 10437//10161 10105//10161 10104//10161 
f 10437//10161 10433//10161 10106//10161 
f 10433//10161 10108//10161 10107//10161 
f 10433//10161 10110//10161 10109//10161 
f 10112//10161 10433//10161 10435//10161 
f 10437//10161 10101//10161 10100//10161 
f 10437//10161 10103//10161 10102//10161 
f 10106//10161 10105//10161 10437//10161 
f 10109//10161 10108//10161 10433//10161 
f 10433//10161 10112//10161 10111//10161 
f 10435//10161 10085//10161 10084//10161 
f 10090//10161 10435//10161 10436//10161 
f 10268//10161 10266//10161 10092//10161 
f 10266//10161 10094//10161 10093//10161 
f 10266//10161 10096//10161 10095//10161 
f 10266//10161 10099//10161 10097//10161 
f 10102//10161 10101//10161 10437//10161 
f 10107//10161 10106//10161 10433//10161 
f 10435//10161 10084//10161 10112//10161 
f 10435//10161 10087//10161 10086//10161 
f 10268//10161 10091//10161 10090//10161 
f 10093//10161 10092//10161 10266//10161 
f 10097//10161 10096//10161 10266//10161 
f 10437//10161 10098//10161 10099//10161 
f 10104//10161 10103//10161 10437//10161 
f 10086//10161 10085//10161 10435//10161 
f 10435//10161 10090//10161 10089//10161 
f 10092//10161 10091//10161 10268//10161 
f 10099//10161 10266//10161 10437//10161 
f 10111//10161 10110//10161 10433//10161 
f 10089//10161 10088//10161 10435//10161 
f 10088//10161 10087//10161 10435//10161 
f 10095//10161 10094//10161 10266//10161 
f 10100//10161 10098//10161 10437//10161 
f 10436//10161 10268//10161 10090//10161 
f 10117//10161 10434//10161 10433//10161 
f 10158//10161 10157//10161 10357//10161 
f 10356//10161 10359//10161 9927//10161 
o mesh451
f 10430//10162 10438//10162 10434//10162 
f 10430//10162 10439//10162 10438//10162 
f 10434//10162 10431//10162 10430//10162 
o mesh452
f 10438//10163 10435//10163 10433//10163 
f 10433//10163 10434//10163 10438//10163 
o mesh453
f 10435//10164 10438//10164 10440//10164 
f 10441//10164 10440//10164 10438//10164 
f 10438//10164 10439//10164 10441//10164 
f 10440//10164 10436//10164 10435//10164 
o mesh454
f 10271//10165 10436//10165 10440//10165 
f 10271//10165 10269//10165 10436//10165 
f 10268//10165 10269//10165 10265//10165 
f 10440//10165 10442//10165 10443//10165 
f 10268//10165 10436//10165 10269//10165 
f 10265//10165 10264//10165 10268//10165 
f 10440//10165 10443//10165 10271//10165 
o mesh455
f 10444//10166 10401//10166 10398//10166 
f 10444//10166 10403//10166 10401//10166 
f 10444//10166 10082//10166 10413//10166 
f 10082//10166 10427//10166 10419//10166 
f 10082//10166 10425//10166 10426//10166 
f 10001//10166 10422//10166 10424//10166 
f 10270//10166 10386//10166 10384//10166 
f 10271//10166 10388//10166 10386//10166 
f 10271//10166 10398//10166 10399//10166 
f 10444//10166 10405//10166 10403//10166 
f 10413//10166 10411//10166 10444//10166 
f 10082//10166 10417//10166 10415//10166 
f 10426//10166 10427//10166 10082//10166 
f 10082//10166 10424//10166 10423//10166 
f 10001//10166 10270//10166 10422//10166 
f 10270//10166 10378//10166 10420//10166 
f 10270//10166 10382//10166 10380//10166 
f 10386//10166 10270//10166 10271//10166 
f 10271//10166 10392//10166 10390//10166 
f 10399//10166 10396//10166 10271//10166 
f 10444//10166 10407//10166 10405//10166 
f 10411//10166 10409//10166 10444//10166 
f 10419//10166 10417//10166 10082//10166 
f 10424//10166 10082//10166 10001//10166 
f 10380//10166 10378//10166 10270//10166 
f 10390//10166 10388//10166 10271//10166 
f 10396//10166 10394//10166 10271//10166 
f 10409//10166 10407//10166 10444//10166 
f 10423//10166 10425//10166 10082//10166 
f 10420//10166 10421//10166 10270//10166 
f 10394//10166 10392//10166 10271//10166 
f 10415//10166 10413//10166 10082//10166 
f 10384//10166 10382//10166 10270//10166 
f 10398//10166 10271//10166 10444//10166 
f 10271//10166 10443//10166 10444//10166 
f 10421//10166 10422//10166 10270//10166 
o mesh456
f 10445//10167 10446//10167 10442//10167 
f 10442//10167 10441//10167 10445//10167 
f 10442//10167 10440//10167 10441//10167 
o mesh457
f 10429//10168 10445//10168 10441//10168 
f 10441//10168 10439//10168 10430//10168 
f 10441//10168 10430//10168 10429//10168 
o mesh458
f 10447//10169 10445//10169 10429//10169 
o mesh459
f 10446//10170 10444//10170 10443//10170 
f 10443//10170 10442//10170 10446//10170 
o mesh460
f 10444//10171 10446//10171 10448//10171 
o mesh461
f 10444//10172 10448//10172 10449//10172 
f 10449//10172 10082//10172 10444//10172 
o mesh462
f 10428//10173 10449//10173 10448//10173 
f 10448//10173 10447//10173 10428//10173 
o mesh463
f 9991//10174 10082//10174 10449//10174 
f 10449//10174 10428//10174 9991//10174 
o mesh464
f 10448//10175 10446//10175 10445//10175 
f 10445//10175 10447//10175 10448//10175 
o mesh465
f 10429//10176 10362//10176 10428//10176 
f 10428//10176 10447//10176 10429//10176 
g nema17
v -0.129074 0.0380698 -0.0461582 
v -0.129074 0.0375419 -0.0462744 
v -0.129074 0.0370512 -0.0465014 
v -0.129074 0.0366209 -0.0468285 
v -0.129074 0.0362709 -0.0472405 
v -0.129074 0.0360177 -0.0477182 
v -0.129074 0.035873 -0.0482391 
v -0.129074 0.0358438 -0.0487789 
v -0.129074 0.0359312 -0.0493123 
v -0.129074 0.0361313 -0.0498145 
v -0.129074 0.0364347 -0.050262 
v -0.129074 0.0368272 -0.0506337 
v -0.129074 0.0372904 -0.0509124 
v -0.129074 0.0378027 -0.0510851 
v -0.129074 0.0383401 -0.0511435 
v -0.129074 0.0388775 -0.0510851 
v -0.129074 0.0393898 -0.0509124 
v -0.129074 0.039853 -0.0506337 
v -0.129074 0.0402455 -0.050262 
v -0.129074 0.0405489 -0.0498145 
v -0.129074 0.040749 -0.0493123 
v -0.129074 0.0408364 -0.0487789 
v -0.129074 0.0408072 -0.0482391 
v -0.129074 0.0406625 -0.0477182 
v -0.129074 0.0404093 -0.0472405 
v -0.129074 0.0400594 -0.0468285 
v -0.129074 0.039629 -0.0465014 
v -0.129074 0.0391384 -0.0462744 
v -0.129074 0.0386104 -0.0461582 
v -0.129074 0.0383401 -0.0461435 
v -0.129074 0.0383401 -0.0486435 
v -0.151074 0.0383401 -0.0511435 
v -0.151074 0.0378027 -0.0510851 
v -0.151074 0.0372904 -0.0509124 
v -0.151074 0.0368272 -0.0506337 
v -0.151074 0.0364347 -0.050262 
v -0.151074 0.0361313 -0.0498145 
v -0.151074 0.0359312 -0.0493123 
v -0.151074 0.0358438 -0.0487789 
v -0.151074 0.035873 -0.0482391 
v -0.151074 0.0360177 -0.0477182 
v -0.151074 0.0362709 -0.0472405 
v -0.151074 0.0366209 -0.0468285 
v -0.151074 0.0370512 -0.0465014 
v -0.151074 0.0375419 -0.0462744 
v -0.151074 0.0386104 -0.0461582 
v -0.151074 0.0383401 -0.0461435 
v -0.151074 0.0380698 -0.0461582 
v -0.151074 0.0391384 -0.0462744 
v -0.151074 0.039629 -0.0465014 
v -0.151074 0.0400594 -0.0468285 
v -0.151074 0.0404093 -0.0472405 
v -0.151074 0.0406625 -0.0477182 
v -0.151074 0.0408072 -0.0482391 
v -0.151074 0.0408364 -0.0487789 
v -0.151074 0.040749 -0.0493123 
v -0.151074 0.0405489 -0.0498145 
v -0.151074 0.0402455 -0.050262 
v -0.151074 0.039853 -0.0506337 
v -0.151074 0.0393898 -0.0509124 
v -0.151074 0.0388775 -0.0510851 
v -0.151074 0.0383401 -0.0376435 
v -0.151074 0.0371508 -0.037708 
v -0.151074 0.0348278 -0.0382193 
v -0.151074 0.0337213 -0.0586268 
v -0.151074 0.0359754 -0.0593863 
v -0.151074 0.0383401 -0.0596435 
v -0.151074 0.0407048 -0.0593863 
v -0.151074 0.032669 -0.0392181 
v -0.151074 0.0307754 -0.0406576 
v -0.151074 0.0292355 -0.0424704 
v -0.151074 0.0277411 -0.0515863 
v -0.151074 0.0286215 -0.053796 
v -0.151074 0.0299563 -0.0557648 
v -0.151074 0.0316832 -0.0574005 
v -0.151074 0.0480587 -0.053796 
v -0.151074 0.0489392 -0.0515863 
v -0.151074 0.027485 -0.0468639 
v -0.151074 0.0273562 -0.049239 
v -0.151074 0.0429589 -0.0586268 
v -0.151074 0.044997 -0.0574005 
v -0.151074 0.0467239 -0.0557648 
v -0.151074 0.049324 -0.049239 
v -0.151074 0.0491952 -0.0468639 
v -0.151074 0.0485589 -0.044572 
v -0.151074 0.0281214 -0.044572 
v -0.151074 0.0474447 -0.0424704 
v -0.151074 0.0459048 -0.0406576 
v -0.151074 0.0440112 -0.0392181 
v -0.151074 0.0418524 -0.0382193 
v -0.151074 0.0395294 -0.037708 
v -0.153074 0.0383401 -0.0596435 
v -0.153074 0.0359754 -0.0593863 
v -0.153074 0.0337213 -0.0586268 
v -0.153074 0.0316832 -0.0574005 
v -0.153074 0.0299563 -0.0557648 
v -0.153074 0.0286215 -0.053796 
v -0.153074 0.0277411 -0.0515863 
v -0.153074 0.0273562 -0.049239 
v -0.153074 0.027485 -0.0468639 
v -0.153074 0.0281214 -0.044572 
v -0.153074 0.0292355 -0.0424704 
v -0.153074 0.0307754 -0.0406576 
v -0.153074 0.032669 -0.0392181 
v -0.153074 0.0348278 -0.0382193 
v -0.153074 0.0395294 -0.037708 
v -0.153074 0.0383401 -0.0376435 
v -0.153074 0.0371508 -0.037708 
v -0.153074 0.0418524 -0.0382193 
v -0.153074 0.0440112 -0.0392181 
v -0.153074 0.0459048 -0.0406576 
v -0.153074 0.0474447 -0.0424704 
v -0.153074 0.0485589 -0.044572 
v -0.153074 0.0491952 -0.0468639 
v -0.153074 0.049324 -0.049239 
v -0.153074 0.0489392 -0.0515863 
v -0.153074 0.0480587 -0.053796 
v -0.153074 0.0467239 -0.0557648 
v -0.153074 0.044997 -0.0574005 
v -0.153074 0.0429589 -0.0586268 
v -0.153074 0.0407048 -0.0593863 
v -0.153074 0.0228401 -0.0697935 
v -0.153074 0.0230563 -0.0661318 
v -0.153074 0.0226239 -0.0661318 
v -0.153074 0.0171901 -0.0608935 
v -0.153074 0.0210731 -0.0632067 
v -0.153074 0.0213158 -0.0628487 
v -0.153074 0.0222015 -0.0660388 
v -0.153074 0.021809 -0.0658572 
v -0.153074 0.0234787 -0.0660388 
v -0.153074 0.0505901 -0.0697935 
v -0.153074 0.0242155 -0.0655955 
v -0.153074 0.0238712 -0.0658572 
v -0.153074 0.0216298 -0.0625513 
v -0.153074 0.0171901 -0.0641435 
v -0.153074 0.0211847 -0.0652659 
v -0.153074 0.0209822 -0.0648838 
v -0.153074 0.0214647 -0.0655955 
v -0.153074 0.0220003 -0.0623284 
v -0.153074 0.0224102 -0.0621903 
v -0.153074 0.020913 -0.0636084 
v -0.153074 0.020843 -0.0640352 
v -0.153074 0.0248138 -0.0644671 
v -0.153074 0.0246981 -0.0648838 
v -0.153074 0.0208665 -0.0644671 
v -0.153074 0.0244955 -0.0652659 
v -0.153074 0.0228401 -0.0621435 
v -0.153074 0.0248372 -0.0640352 
v -0.153074 0.0240505 -0.0625513 
v -0.153074 0.0243644 -0.0628487 
v -0.153074 0.02327 -0.0621903 
v -0.153074 0.0247672 -0.0636084 
v -0.153074 0.0246071 -0.0632067 
v -0.153074 0.0236799 -0.0623284 
v -0.153074 0.0594901 -0.0640428 
v -0.153074 0.0594901 -0.0608935 
v -0.153074 0.0557672 -0.0636084 
v -0.153074 0.0558372 -0.0640352 
v -0.153074 0.0524647 -0.0655955 
v -0.153074 0.0521847 -0.0652659 
v -0.153074 0.0538401 -0.0697935 
v -0.153074 0.0536239 -0.0661318 
v -0.153074 0.0532015 -0.0660388 
v -0.153074 0.0554955 -0.0652659 
v -0.153074 0.0552155 -0.0655955 
v -0.153074 0.0558138 -0.0644671 
v -0.153074 0.051843 -0.0640352 
v -0.153074 0.051913 -0.0636084 
v -0.153074 0.0518665 -0.0644671 
v -0.153074 0.0519822 -0.0648838 
v -0.153074 0.0540563 -0.0661318 
v -0.153074 0.0556981 -0.0648838 
v -0.153074 0.0538401 -0.0621435 
v -0.153074 0.0523158 -0.0628487 
v -0.153074 0.0526298 -0.0625513 
v -0.153074 0.052809 -0.0658572 
v -0.153074 0.0544787 -0.0660388 
v -0.153074 0.0548712 -0.0658572 
v -0.153074 0.0556071 -0.0632067 
v -0.153074 0.05427 -0.0621903 
v -0.153074 0.0520731 -0.0632067 
v -0.153074 0.0550505 -0.0625513 
v -0.153074 0.0553644 -0.0628487 
v -0.153074 0.0546799 -0.0623284 
v -0.153074 0.0530003 -0.0623284 
v -0.153074 0.0534102 -0.0621903 
v -0.153074 0.0505901 -0.0274935 
v -0.153074 0.0523158 -0.0318487 
v -0.153074 0.0526298 -0.0315513 
v -0.153074 0.0520731 -0.0322067 
v -0.153074 0.051913 -0.0326084 
v -0.153074 0.051843 -0.0330352 
v -0.153074 0.0518665 -0.0334671 
v -0.153074 0.0538401 -0.0274935 
v -0.153074 0.0550505 -0.0315513 
v -0.153074 0.0553644 -0.0318487 
v -0.153074 0.0521847 -0.0342659 
v -0.153074 0.0519822 -0.0338838 
v -0.153074 0.052809 -0.0348572 
v -0.153074 0.0524647 -0.0345955 
v -0.153074 0.0540563 -0.0351318 
v -0.153074 0.0594901 -0.0331435 
v -0.153074 0.0556981 -0.0338838 
v -0.153074 0.0554955 -0.0342659 
v -0.153074 0.0532015 -0.0350388 
v -0.153074 0.0536239 -0.0351318 
v -0.153074 0.0558138 -0.0334671 
v -0.153074 0.0557672 -0.0326084 
v -0.153074 0.0558372 -0.0330352 
v -0.153074 0.0546799 -0.0313284 
v -0.153074 0.0530003 -0.0313284 
v -0.153074 0.0534102 -0.0311903 
v -0.153074 0.0544787 -0.0350388 
v -0.153074 0.0552155 -0.0345955 
v -0.153074 0.0556071 -0.0322067 
v -0.153074 0.0548712 -0.0348572 
v -0.153074 0.0538401 -0.0311435 
v -0.153074 0.05427 -0.0311903 
v -0.153074 0.0226239 -0.0351318 
v -0.153074 0.0230563 -0.0351318 
v -0.153074 0.0240505 -0.0315513 
v -0.153074 0.0238712 -0.0348572 
v -0.153074 0.0246071 -0.0322067 
v -0.153074 0.0247672 -0.0326084 
v -0.153074 0.0243644 -0.0318487 
v -0.153074 0.0171901 -0.0331435 
v -0.153074 0.0211847 -0.0342659 
v -0.153074 0.021809 -0.0348572 
v -0.153074 0.0214647 -0.0345955 
v -0.153074 0.0234787 -0.0350388 
v -0.153074 0.0244955 -0.0342659 
v -0.153074 0.0242155 -0.0345955 
v -0.153074 0.0248138 -0.0334671 
v -0.153074 0.0246981 -0.0338838 
v -0.153074 0.0227761 -0.0274935 
v -0.153074 0.0213158 -0.0318487 
v -0.153074 0.0209822 -0.0338838 
v -0.153074 0.0222015 -0.0350388 
v -0.153074 0.0248372 -0.0330352 
v -0.153074 0.0220003 -0.0313284 
v -0.153074 0.0224102 -0.0311903 
v -0.153074 0.0210731 -0.0322067 
v -0.153074 0.0208665 -0.0334671 
v -0.153074 0.020843 -0.0330352 
v -0.153074 0.0216298 -0.0315513 
v -0.153074 0.020913 -0.0326084 
v -0.153074 0.0236799 -0.0313284 
v -0.153074 0.0228401 -0.0311435 
v -0.153074 0.02327 -0.0311903 
v -0.153074 0.0505901 -0.0608935 
v -0.200074 0.0171901 -0.0331435 
v -0.200074 0.0171901 -0.0608935 
v -0.200074 0.0171901 -0.0641435 
v -0.200074 0.0228401 -0.0697935 
v -0.200074 0.0505901 -0.0697935 
v -0.200074 0.0538401 -0.0697935 
v -0.200074 0.0594901 -0.0640428 
v -0.200074 0.0594901 -0.0608935 
v -0.200074 0.0594901 -0.0331435 
v -0.200074 0.0538401 -0.0274935 
v -0.200074 0.0505901 -0.0274935 
v -0.200074 0.0227761 -0.0274935 
v -0.200074 0.0228401 -0.0621435 
v -0.200074 0.02327 -0.0621903 
v -0.200074 0.0236799 -0.0623284 
v -0.200074 0.0240505 -0.0625513 
v -0.200074 0.0243644 -0.0628487 
v -0.200074 0.0246071 -0.0632067 
v -0.200074 0.0247672 -0.0636084 
v -0.200074 0.0248372 -0.0640352 
v -0.200074 0.0248138 -0.0644671 
v -0.200074 0.0246981 -0.0648838 
v -0.200074 0.0244955 -0.0652659 
v -0.200074 0.0242155 -0.0655955 
v -0.200074 0.0238712 -0.0658572 
v -0.200074 0.0234787 -0.0660388 
v -0.200074 0.0230563 -0.0661318 
v -0.200074 0.0226239 -0.0661318 
v -0.200074 0.0222015 -0.0660388 
v -0.200074 0.021809 -0.0658572 
v -0.200074 0.0214647 -0.0655955 
v -0.200074 0.0211847 -0.0652659 
v -0.200074 0.0209822 -0.0648838 
v -0.200074 0.0208665 -0.0644671 
v -0.200074 0.020843 -0.0640352 
v -0.200074 0.020913 -0.0636084 
v -0.200074 0.0210731 -0.0632067 
v -0.200074 0.0213158 -0.0628487 
v -0.200074 0.0216298 -0.0625513 
v -0.200074 0.0220003 -0.0623284 
v -0.200074 0.0224102 -0.0621903 
v -0.200074 0.0538401 -0.0621435 
v -0.200074 0.05427 -0.0621903 
v -0.200074 0.0546799 -0.0623284 
v -0.200074 0.0550505 -0.0625513 
v -0.200074 0.0553644 -0.0628487 
v -0.200074 0.0556071 -0.0632067 
v -0.200074 0.0557672 -0.0636084 
v -0.200074 0.0558372 -0.0640352 
v -0.200074 0.0558138 -0.0644671 
v -0.200074 0.0556981 -0.0648838 
v -0.200074 0.0554955 -0.0652659 
v -0.200074 0.0552155 -0.0655955 
v -0.200074 0.0548712 -0.0658572 
v -0.200074 0.0544787 -0.0660388 
v -0.200074 0.0540563 -0.0661318 
v -0.200074 0.0536239 -0.0661318 
v -0.200074 0.0532015 -0.0660388 
v -0.200074 0.052809 -0.0658572 
v -0.200074 0.0524647 -0.0655955 
v -0.200074 0.0521847 -0.0652659 
v -0.200074 0.0519822 -0.0648838 
v -0.200074 0.0518665 -0.0644671 
v -0.200074 0.051843 -0.0640352 
v -0.200074 0.051913 -0.0636084 
v -0.200074 0.0520731 -0.0632067 
v -0.200074 0.0523158 -0.0628487 
v -0.200074 0.0526298 -0.0625513 
v -0.200074 0.0530003 -0.0623284 
v -0.200074 0.0534102 -0.0621903 
v -0.200074 0.0538401 -0.0311435 
v -0.200074 0.05427 -0.0311903 
v -0.200074 0.0546799 -0.0313284 
v -0.200074 0.0550505 -0.0315513 
v -0.200074 0.0553644 -0.0318487 
v -0.200074 0.0556071 -0.0322067 
v -0.200074 0.0557672 -0.0326084 
v -0.200074 0.0558372 -0.0330352 
v -0.200074 0.0558138 -0.0334671 
v -0.200074 0.0556981 -0.0338838 
v -0.200074 0.0554955 -0.0342659 
v -0.200074 0.0552155 -0.0345955 
v -0.200074 0.0548712 -0.0348572 
v -0.200074 0.0544787 -0.0350388 
v -0.200074 0.0540563 -0.0351318 
v -0.200074 0.0536239 -0.0351318 
v -0.200074 0.0532015 -0.0350388 
v -0.200074 0.052809 -0.0348572 
v -0.200074 0.0524647 -0.0345955 
v -0.200074 0.0521847 -0.0342659 
v -0.200074 0.0519822 -0.0338838 
v -0.200074 0.0518665 -0.0334671 
v -0.200074 0.051843 -0.0330352 
v -0.200074 0.051913 -0.0326084 
v -0.200074 0.0520731 -0.0322067 
v -0.200074 0.0523158 -0.0318487 
v -0.200074 0.0526298 -0.0315513 
v -0.200074 0.0530003 -0.0313284 
v -0.200074 0.0534102 -0.0311903 
v -0.200074 0.0228401 -0.0311435 
v -0.200074 0.02327 -0.0311903 
v -0.200074 0.0236799 -0.0313284 
v -0.200074 0.0240505 -0.0315513 
v -0.200074 0.0243644 -0.0318487 
v -0.200074 0.0246071 -0.0322067 
v -0.200074 0.0247672 -0.0326084 
v -0.200074 0.0248372 -0.0330352 
v -0.200074 0.0248138 -0.0334671 
v -0.200074 0.0246981 -0.0338838 
v -0.200074 0.0244955 -0.0342659 
v -0.200074 0.0242155 -0.0345955 
v -0.200074 0.0238712 -0.0348572 
v -0.200074 0.0234787 -0.0350388 
v -0.200074 0.0230563 -0.0351318 
v -0.200074 0.0226239 -0.0351318 
v -0.200074 0.0222015 -0.0350388 
v -0.200074 0.021809 -0.0348572 
v -0.200074 0.0214647 -0.0345955 
v -0.200074 0.0211847 -0.0342659 
v -0.200074 0.0209822 -0.0338838 
v -0.200074 0.0208665 -0.0334671 
v -0.200074 0.020843 -0.0330352 
v -0.200074 0.020913 -0.0326084 
v -0.200074 0.0210731 -0.0322067 
v -0.200074 0.0213158 -0.0318487 
v -0.200074 0.0216298 -0.0315513 
v -0.200074 0.0220003 -0.0313284 
v -0.200074 0.0224102 -0.0311903 
v -0.200074 0.049324 -0.048048 
v -0.200074 0.0489392 -0.0457007 
v -0.200074 0.0491952 -0.0504231 
v -0.200074 0.0337213 -0.0386602 
v -0.200074 0.0316832 -0.0398865 
v -0.200074 0.0286215 -0.043491 
v -0.200074 0.0281214 -0.052715 
v -0.200074 0.0407048 -0.0379007 
v -0.200074 0.0480587 -0.043491 
v -0.200074 0.0467239 -0.0415223 
v -0.200074 0.0485589 -0.052715 
v -0.200074 0.0459048 -0.0566295 
v -0.200074 0.0474447 -0.0548166 
v -0.200074 0.0418524 -0.0590677 
v -0.200074 0.0440112 -0.0580689 
v -0.200074 0.0299563 -0.0415223 
v -0.200074 0.0277411 -0.0457007 
v -0.200074 0.0307754 -0.0566295 
v -0.200074 0.032669 -0.0580689 
v -0.200074 0.0429589 -0.0386602 
v -0.200074 0.0371508 -0.059579 
v -0.200074 0.0359754 -0.0379007 
v -0.200074 0.0383401 -0.0376435 
v -0.200074 0.0273562 -0.048048 
v -0.200074 0.027485 -0.0504231 
v -0.200074 0.0348278 -0.0590677 
v -0.200074 0.0292355 -0.0548166 
v -0.200074 0.0395294 -0.059579 
v -0.200074 0.044997 -0.0398865 
v -0.200074 0.0505901 -0.0608935 
v -0.198074 0.0407048 -0.0379007 
v -0.198074 0.0383401 -0.0376435 
v -0.198074 0.0429589 -0.0386602 
v -0.198074 0.044997 -0.0398865 
v -0.198074 0.0467239 -0.0415223 
v -0.198074 0.0480587 -0.043491 
v -0.198074 0.0489392 -0.0457007 
v -0.198074 0.049324 -0.048048 
v -0.198074 0.0491952 -0.0504231 
v -0.198074 0.0485589 -0.052715 
v -0.198074 0.0474447 -0.0548166 
v -0.198074 0.0459048 -0.0566295 
v -0.198074 0.0440112 -0.0580689 
v -0.198074 0.0418524 -0.0590677 
v -0.198074 0.0395294 -0.059579 
v -0.198074 0.0371508 -0.059579 
v -0.198074 0.0348278 -0.0590677 
v -0.198074 0.032669 -0.0580689 
v -0.198074 0.0307754 -0.0566295 
v -0.198074 0.0292355 -0.0548166 
v -0.198074 0.0281214 -0.052715 
v -0.198074 0.027485 -0.0504231 
v -0.198074 0.0273562 -0.048048 
v -0.198074 0.0277411 -0.0457007 
v -0.198074 0.0286215 -0.043491 
v -0.198074 0.0299563 -0.0415223 
v -0.198074 0.0316832 -0.0398865 
v -0.198074 0.0337213 -0.0386602 
v -0.198074 0.0359754 -0.0379007 
v -0.198074 0.0372904 -0.0463746 
v -0.198074 0.0368272 -0.0466533 
v -0.198074 0.0378027 -0.046202 
v -0.198074 0.0383401 -0.0461435 
v -0.198074 0.0388775 -0.046202 
v -0.198074 0.0375419 -0.0510126 
v -0.198074 0.0380698 -0.0511289 
v -0.198074 0.0370512 -0.0507856 
v -0.198074 0.0366209 -0.0504585 
v -0.198074 0.0362709 -0.0500465 
v -0.198074 0.0359312 -0.0479747 
v -0.198074 0.0358438 -0.0485082 
v -0.198074 0.0361313 -0.0474725 
v -0.198074 0.0364347 -0.047025 
v -0.198074 0.0405489 -0.0474725 
v -0.198074 0.0402455 -0.047025 
v -0.198074 0.040749 -0.0479747 
v -0.198074 0.035873 -0.049048 
v -0.198074 0.0360177 -0.0495689 
v -0.198074 0.0393898 -0.0463746 
v -0.198074 0.039853 -0.0466533 
v -0.198074 0.0408364 -0.0485082 
v -0.198074 0.0408072 -0.049048 
v -0.198074 0.0406625 -0.0495689 
v -0.198074 0.0404093 -0.0500465 
v -0.198074 0.0400594 -0.0504585 
v -0.198074 0.039629 -0.0507856 
v -0.198074 0.0391384 -0.0510126 
v -0.198074 0.0386104 -0.0511289 
v -0.153074 0.0388775 -0.046202 
v -0.153074 0.0383401 -0.0461435 
v -0.153074 0.0393898 -0.0463746 
v -0.153074 0.039853 -0.0466533 
v -0.153074 0.0402455 -0.047025 
v -0.153074 0.0405489 -0.0474725 
v -0.153074 0.040749 -0.0479747 
v -0.153074 0.0408364 -0.0485082 
v -0.153074 0.0408072 -0.049048 
v -0.153074 0.0406625 -0.0495689 
v -0.153074 0.0404093 -0.0500465 
v -0.153074 0.0400594 -0.0504585 
v -0.153074 0.039629 -0.0507856 
v -0.153074 0.0391384 -0.0510126 
v -0.153074 0.0386104 -0.0511289 
v -0.153074 0.0380698 -0.0511289 
v -0.153074 0.0375419 -0.0510126 
v -0.153074 0.0370512 -0.0507856 
v -0.153074 0.0366209 -0.0504585 
v -0.153074 0.0362709 -0.0500465 
v -0.153074 0.0360177 -0.0495689 
v -0.153074 0.035873 -0.049048 
v -0.153074 0.0358438 -0.0485082 
v -0.153074 0.0359312 -0.0479747 
v -0.153074 0.0361313 -0.0474725 
v -0.153074 0.0364347 -0.047025 
v -0.153074 0.0368272 -0.0466533 
v -0.153074 0.0372904 -0.0463746 
v -0.153074 0.0378027 -0.046202 
v -0.153074 0.0383401 -0.0486435 
vn 0.994189 0.0698341 -0.0819291 
vn -0.14143 0.0549651 -0.988421 
vn -0.143204 -0.145456 -0.978946 
vn -0.145385 -0.342296 -0.928276 
vn -0.147915 -0.527296 -0.836708 
vn -0.150716 -0.691851 -0.706135 
vn -0.153681 -0.827294 -0.540339 
vn -0.156676 -0.925337 -0.345261 
vn -0.159539 -0.978705 -0.129167 
vn -0.16209 -0.981957 0.0974066 
vn -0.164146 -0.932378 0.322069 
vn -0.165543 -0.830775 0.531421 
vn -0.166161 -0.681919 0.712304 
vn -0.165944 -0.49441 0.853241 
vn -0.164913 -0.279906 0.945757 
vn -0.163158 -0.0518324 0.985238 
vn -0.160824 0.176096 0.971147 
vn -0.162053 0.0629797 0.98477 
vn -0.163158 -0.0518324 0.985238 
vn -0.160824 0.176096 0.971147 
vn -0.158089 0.391203 0.906624 
vn -0.155137 0.582795 0.797673 
vn -0.152139 0.742627 0.652195 
vn -0.149243 0.864981 0.479098 
vn -0.14657 0.946473 0.287585 
vn -0.144212 0.985745 0.0866632 
vn -0.142235 0.983111 -0.115158 
vn -0.140688 0.940261 -0.310027 
vn -0.1396 0.859999 -0.490829 
vn -0.138992 0.746066 -0.651204 
vn -0.138873 0.603003 -0.785558 
vn -0.139245 0.436072 -0.889074 
vn -0.140102 0.251203 -0.957741 
vn 0.994189 0.0698341 -0.0819291 
vn -0.14143 0.0549651 -0.988421 
vn -0.143204 -0.145456 -0.978946 
vn -0.145385 -0.342296 -0.928276 
vn -0.147915 -0.527296 -0.836708 
vn -0.150716 -0.691851 -0.706135 
vn -0.153681 -0.827294 -0.540339 
vn -0.156676 -0.925337 -0.345261 
vn -0.159539 -0.978705 -0.129167 
vn -0.16209 -0.981957 0.0974066 
vn -0.164146 -0.932378 0.322069 
vn -0.165543 -0.830775 0.531421 
vn -0.166161 -0.681919 0.712304 
vn -0.165944 -0.49441 0.853241 
vn -0.164913 -0.279906 0.945757 
vn -0.163158 -0.0518324 0.985238 
vn -0.160824 0.176096 0.971147 
vn -0.162053 0.0629797 0.98477 
vn -0.163158 -0.0518324 0.985238 
vn -0.158089 0.391203 0.906624 
vn -0.155137 0.582795 0.797673 
vn -0.152139 0.742627 0.652195 
vn -0.149243 0.864981 0.479098 
vn -0.14657 0.946473 0.287585 
vn -0.144212 0.985745 0.0866632 
vn -0.142235 0.983111 -0.115158 
vn -0.140688 0.940261 -0.310027 
vn -0.1396 0.859999 -0.490829 
vn -0.138992 0.746066 -0.651204 
vn -0.138873 0.603003 -0.785558 
vn -0.139245 0.436072 -0.889074 
vn -0.140102 0.251203 -0.957741 
vn 0.994189 0.0698341 -0.0819291 
vn -0.160213 -0.984376 -0.0730487 
vn -0.14964 -0.633091 -0.759475 
vn -0.14143 0.0549651 -0.988421 
vn -0.138897 0.701247 -0.699257 
vn -0.142691 0.987627 -0.0650595 
vn -0.151769 0.760062 0.63188 
vn -0.162053 0.0629797 0.98477 
vn -0.16612 -0.707173 0.687248 
vn -0.143204 -0.145456 -0.978946 
vn -0.14143 0.0549651 -0.988421 
vn -0.145385 -0.342296 -0.928276 
vn -0.143204 -0.145456 -0.978946 
vn -0.147915 -0.527296 -0.836708 
vn -0.145385 -0.342296 -0.928276 
vn -0.150716 -0.691851 -0.706135 
vn -0.147915 -0.527296 -0.836708 
vn -0.153681 -0.827294 -0.540339 
vn -0.150716 -0.691851 -0.706135 
vn -0.156676 -0.925337 -0.345261 
vn -0.153681 -0.827294 -0.540339 
vn -0.159539 -0.978705 -0.129167 
vn -0.156676 -0.925337 -0.345261 
vn -0.16209 -0.981957 0.0974066 
vn -0.159539 -0.978705 -0.129167 
vn -0.164146 -0.932378 0.322069 
vn -0.16209 -0.981957 0.0974066 
vn -0.165543 -0.830775 0.531421 
vn -0.164146 -0.932378 0.322069 
vn -0.166161 -0.681919 0.712304 
vn -0.165543 -0.830775 0.531421 
vn -0.165944 -0.49441 0.853241 
vn -0.166161 -0.681919 0.712304 
vn -0.164913 -0.279906 0.945757 
vn -0.165944 -0.49441 0.853241 
vn -0.163158 -0.0518324 0.985238 
vn -0.164913 -0.279906 0.945757 
vn -0.160824 0.176096 0.971147 
vn -0.163158 -0.0518324 0.985238 
vn -0.158089 0.391203 0.906624 
vn -0.160824 0.176096 0.971147 
vn -0.155137 0.582795 0.797673 
vn -0.158089 0.391203 0.906624 
vn -0.152139 0.742627 0.652195 
vn -0.155137 0.582795 0.797673 
vn -0.149243 0.864981 0.479098 
vn -0.152139 0.742627 0.652195 
vn -0.14657 0.946473 0.287585 
vn -0.149243 0.864981 0.479098 
vn -0.144212 0.985745 0.0866632 
vn -0.14657 0.946473 0.287585 
vn -0.142235 0.983111 -0.115158 
vn -0.144212 0.985745 0.0866632 
vn -0.140688 0.940261 -0.310027 
vn -0.142235 0.983111 -0.115158 
vn -0.1396 0.859999 -0.490829 
vn -0.140688 0.940261 -0.310027 
vn -0.138992 0.746066 -0.651204 
vn -0.1396 0.859999 -0.490829 
vn -0.138873 0.603003 -0.785558 
vn -0.138992 0.746066 -0.651204 
vn -0.139245 0.436072 -0.889074 
vn -0.138873 0.603003 -0.785558 
vn -0.140102 0.251203 -0.957741 
vn -0.139245 0.436072 -0.889074 
vn -0.143204 -0.145456 -0.978946 
vn -0.14143 0.0549651 -0.988421 
vn -0.145385 -0.342296 -0.928276 
vn -0.143204 -0.145456 -0.978946 
vn -0.147915 -0.527296 -0.836708 
vn -0.145385 -0.342296 -0.928276 
vn -0.150716 -0.691851 -0.706135 
vn -0.147915 -0.527296 -0.836708 
vn -0.153681 -0.827294 -0.540339 
vn -0.150716 -0.691851 -0.706135 
vn -0.156676 -0.925337 -0.345261 
vn -0.153681 -0.827294 -0.540339 
vn -0.159539 -0.978705 -0.129167 
vn -0.156676 -0.925337 -0.345261 
vn -0.16209 -0.981957 0.0974066 
vn -0.159539 -0.978705 -0.129167 
vn -0.164146 -0.932378 0.322069 
vn -0.16209 -0.981957 0.0974066 
vn -0.165543 -0.830775 0.531421 
vn -0.164146 -0.932378 0.322069 
vn -0.166161 -0.681919 0.712304 
vn -0.165543 -0.830775 0.531421 
vn -0.165944 -0.49441 0.853241 
vn -0.166161 -0.681919 0.712304 
vn -0.164913 -0.279906 0.945757 
vn -0.165944 -0.49441 0.853241 
vn -0.163158 -0.0518324 0.985238 
vn -0.164913 -0.279906 0.945757 
vn -0.160824 0.176096 0.971147 
vn -0.163158 -0.0518324 0.985238 
vn -0.158089 0.391203 0.906624 
vn -0.160824 0.176096 0.971147 
vn -0.155137 0.582795 0.797673 
vn -0.158089 0.391203 0.906624 
vn -0.152139 0.742627 0.652195 
vn -0.155137 0.582795 0.797673 
vn -0.149243 0.864981 0.479098 
vn -0.152139 0.742627 0.652195 
vn -0.14657 0.946473 0.287585 
vn -0.149243 0.864981 0.479098 
vn -0.144212 0.985745 0.0866632 
vn -0.14657 0.946473 0.287585 
vn -0.142235 0.983111 -0.115158 
vn -0.144212 0.985745 0.0866632 
vn -0.140688 0.940261 -0.310027 
vn -0.142235 0.983111 -0.115158 
vn -0.1396 0.859999 -0.490829 
vn -0.140688 0.940261 -0.310027 
vn -0.138992 0.746066 -0.651204 
vn -0.1396 0.859999 -0.490829 
vn -0.138873 0.603003 -0.785558 
vn -0.138992 0.746066 -0.651204 
vn -0.139245 0.436072 -0.889074 
vn -0.138873 0.603003 -0.785558 
vn -0.140102 0.251203 -0.957741 
vn -0.139245 0.436072 -0.889074 
vn -0.143204 -0.145456 -0.978946 
vn -0.14143 0.0549651 -0.988421 
vn -0.145385 -0.342296 -0.928276 
vn -0.143204 -0.145456 -0.978946 
vn -0.147915 -0.527296 -0.836708 
vn -0.145385 -0.342296 -0.928276 
vn -0.150716 -0.691851 -0.706135 
vn -0.147915 -0.527296 -0.836708 
vn -0.153681 -0.827294 -0.540339 
vn -0.150716 -0.691851 -0.706135 
vn -0.156676 -0.925337 -0.345261 
vn -0.153681 -0.827294 -0.540339 
vn -0.159539 -0.978705 -0.129167 
vn -0.156676 -0.925337 -0.345261 
vn -0.16209 -0.981957 0.0974066 
vn -0.159539 -0.978705 -0.129167 
vn -0.164146 -0.932378 0.322069 
vn -0.16209 -0.981957 0.0974066 
vn -0.165543 -0.830775 0.531421 
vn -0.164146 -0.932378 0.322069 
vn -0.166161 -0.681919 0.712304 
vn -0.165543 -0.830775 0.531421 
vn -0.165944 -0.49441 0.853241 
vn -0.166161 -0.681919 0.712304 
vn -0.164913 -0.279906 0.945757 
vn -0.165944 -0.49441 0.853241 
vn -0.163158 -0.0518324 0.985238 
vn -0.164913 -0.279906 0.945757 
vn -0.160824 0.176096 0.971147 
vn -0.163158 -0.0518324 0.985238 
vn -0.158089 0.391203 0.906624 
vn -0.160824 0.176096 0.971147 
vn -0.155137 0.582795 0.797673 
vn -0.158089 0.391203 0.906624 
vn -0.152139 0.742627 0.652195 
vn -0.155137 0.582795 0.797673 
vn -0.149243 0.864981 0.479098 
vn -0.152139 0.742627 0.652195 
vn -0.14657 0.946473 0.287585 
vn -0.149243 0.864981 0.479098 
vn -0.144212 0.985745 0.0866632 
vn -0.14657 0.946473 0.287585 
vn -0.142235 0.983111 -0.115158 
vn -0.144212 0.985745 0.0866632 
vn -0.140688 0.940261 -0.310027 
vn -0.142235 0.983111 -0.115158 
vn -0.1396 0.859999 -0.490829 
vn -0.140688 0.940261 -0.310027 
vn -0.138992 0.746066 -0.651204 
vn -0.1396 0.859999 -0.490829 
vn -0.138873 0.603003 -0.785558 
vn -0.138992 0.746066 -0.651204 
vn -0.139245 0.436072 -0.889074 
vn -0.138873 0.603003 -0.785558 
vn -0.140102 0.251203 -0.957741 
vn -0.139245 0.436072 -0.889074 
vn -0.143204 -0.145456 -0.978946 
vn -0.14143 0.0549651 -0.988421 
vn -0.145385 -0.342296 -0.928276 
vn -0.143204 -0.145456 -0.978946 
vn -0.147915 -0.527296 -0.836708 
vn -0.145385 -0.342296 -0.928276 
vn -0.150716 -0.691851 -0.706135 
vn -0.147915 -0.527296 -0.836708 
vn -0.153681 -0.827294 -0.540339 
vn -0.150716 -0.691851 -0.706135 
vn -0.156676 -0.925337 -0.345261 
vn -0.153681 -0.827294 -0.540339 
vn -0.159539 -0.978705 -0.129167 
vn -0.156676 -0.925337 -0.345261 
vn -0.16209 -0.981957 0.0974066 
vn -0.159539 -0.978705 -0.129167 
vn -0.164146 -0.932378 0.322069 
vn -0.16209 -0.981957 0.0974066 
vn -0.165543 -0.830775 0.531421 
vn -0.164146 -0.932378 0.322069 
vn -0.166161 -0.681919 0.712304 
vn -0.165543 -0.830775 0.531421 
vn -0.165944 -0.49441 0.853241 
vn -0.166161 -0.681919 0.712304 
vn -0.164913 -0.279906 0.945757 
vn -0.165944 -0.49441 0.853241 
vn -0.163158 -0.0518324 0.985238 
vn -0.164913 -0.279906 0.945757 
vn -0.160824 0.176096 0.971147 
vn -0.163158 -0.0518324 0.985238 
vn -0.158089 0.391203 0.906624 
vn -0.160824 0.176096 0.971147 
vn -0.155137 0.582795 0.797673 
vn -0.158089 0.391203 0.906624 
vn -0.152139 0.742627 0.652195 
vn -0.155137 0.582795 0.797673 
vn -0.149243 0.864981 0.479098 
vn -0.152139 0.742627 0.652195 
vn -0.14657 0.946473 0.287585 
vn -0.149243 0.864981 0.479098 
vn -0.144212 0.985745 0.0866632 
vn -0.14657 0.946473 0.287585 
vn -0.142235 0.983111 -0.115158 
vn -0.144212 0.985745 0.0866632 
vn -0.140688 0.940261 -0.310027 
vn -0.142235 0.983111 -0.115158 
vn -0.1396 0.859999 -0.490829 
vn -0.140688 0.940261 -0.310027 
vn -0.138992 0.746066 -0.651204 
vn -0.1396 0.859999 -0.490829 
vn -0.138873 0.603003 -0.785558 
vn -0.138992 0.746066 -0.651204 
vn -0.139245 0.436072 -0.889074 
vn -0.138873 0.603003 -0.785558 
vn -0.140102 0.251203 -0.957741 
vn -0.139245 0.436072 -0.889074 
vn -0.996852 0.0514302 -0.0603377 
vn -0.143204 -0.145456 -0.978946 
vn -0.14143 0.0549651 -0.988421 
vn -0.145385 -0.342296 -0.928276 
vn -0.143204 -0.145456 -0.978946 
vn -0.147915 -0.527296 -0.836708 
vn -0.145385 -0.342296 -0.928276 
vn -0.150716 -0.691851 -0.706135 
vn -0.147915 -0.527296 -0.836708 
vn -0.153681 -0.827294 -0.540339 
vn -0.150716 -0.691851 -0.706135 
vn -0.156676 -0.925337 -0.345261 
vn -0.153681 -0.827294 -0.540339 
vn -0.159539 -0.978705 -0.129167 
vn -0.156676 -0.925337 -0.345261 
vn -0.16209 -0.981957 0.0974066 
vn -0.159539 -0.978705 -0.129167 
vn -0.164146 -0.932378 0.322069 
vn -0.16209 -0.981957 0.0974066 
vn -0.165543 -0.830775 0.531421 
vn -0.164146 -0.932378 0.322069 
vn -0.166161 -0.681919 0.712304 
vn -0.165543 -0.830775 0.531421 
vn -0.165944 -0.49441 0.853241 
vn -0.166161 -0.681919 0.712304 
vn -0.164913 -0.279906 0.945757 
vn -0.165944 -0.49441 0.853241 
vn -0.163158 -0.0518324 0.985238 
vn -0.164913 -0.279906 0.945757 
vn -0.160824 0.176096 0.971147 
vn -0.163158 -0.0518324 0.985238 
vn -0.158089 0.391203 0.906624 
vn -0.160824 0.176096 0.971147 
vn -0.155137 0.582795 0.797673 
vn -0.158089 0.391203 0.906624 
vn -0.152139 0.742627 0.652195 
vn -0.155137 0.582795 0.797673 
vn -0.149243 0.864981 0.479098 
vn -0.152139 0.742627 0.652195 
vn -0.14657 0.946473 0.287585 
vn -0.149243 0.864981 0.479098 
vn -0.144212 0.985745 0.0866632 
vn -0.14657 0.946473 0.287585 
vn -0.142235 0.983111 -0.115158 
vn -0.144212 0.985745 0.0866632 
vn -0.140688 0.940261 -0.310027 
vn -0.142235 0.983111 -0.115158 
vn -0.1396 0.859999 -0.490829 
vn -0.140688 0.940261 -0.310027 
vn -0.138992 0.746066 -0.651204 
vn -0.1396 0.859999 -0.490829 
vn -0.138873 0.603003 -0.785558 
vn -0.138992 0.746066 -0.651204 
vn -0.139245 0.436072 -0.889074 
vn -0.138873 0.603003 -0.785558 
vn -0.140102 0.251203 -0.957741 
vn -0.139245 0.436072 -0.889074 
vn -0.996852 0.0514302 -0.0603377 
vn -0.143204 -0.145456 -0.978946 
vn -0.14143 0.0549651 -0.988421 
vn -0.145385 -0.342296 -0.928276 
vn -0.143204 -0.145456 -0.978946 
vn -0.147915 -0.527296 -0.836708 
vn -0.145385 -0.342296 -0.928276 
vn -0.150716 -0.691851 -0.706135 
vn -0.147915 -0.527296 -0.836708 
vn -0.153681 -0.827294 -0.540339 
vn -0.150716 -0.691851 -0.706135 
vn -0.156676 -0.925337 -0.345261 
vn -0.153681 -0.827294 -0.540339 
vn -0.159539 -0.978705 -0.129167 
vn -0.156676 -0.925337 -0.345261 
vn -0.16209 -0.981957 0.0974066 
vn -0.159539 -0.978705 -0.129167 
vn -0.164146 -0.932378 0.322069 
vn -0.16209 -0.981957 0.0974066 
vn -0.165543 -0.830775 0.531421 
vn -0.164146 -0.932378 0.322069 
vn -0.166161 -0.681919 0.712304 
vn -0.165543 -0.830775 0.531421 
vn -0.165944 -0.49441 0.853241 
vn -0.166161 -0.681919 0.712304 
vn -0.164913 -0.279906 0.945757 
vn -0.165944 -0.49441 0.853241 
vn -0.163158 -0.0518324 0.985238 
vn -0.164913 -0.279906 0.945757 
vn -0.160824 0.176096 0.971147 
vn -0.163158 -0.0518324 0.985238 
vn -0.158089 0.391203 0.906624 
vn -0.160824 0.176096 0.971147 
vn -0.155137 0.582795 0.797673 
vn -0.158089 0.391203 0.906624 
vn -0.152139 0.742627 0.652195 
vn -0.155137 0.582795 0.797673 
vn -0.149243 0.864981 0.479098 
vn -0.152139 0.742627 0.652195 
vn -0.14657 0.946473 0.287585 
vn -0.149243 0.864981 0.479098 
vn -0.144212 0.985745 0.0866632 
vn -0.14657 0.946473 0.287585 
vn -0.142235 0.983111 -0.115158 
vn -0.144212 0.985745 0.0866632 
vn -0.140688 0.940261 -0.310027 
vn -0.142235 0.983111 -0.115158 
vn -0.1396 0.859999 -0.490829 
vn -0.140688 0.940261 -0.310027 
vn -0.138992 0.746066 -0.651204 
vn -0.1396 0.859999 -0.490829 
vn -0.138873 0.603003 -0.785558 
vn -0.138992 0.746066 -0.651204 
vn -0.139245 0.436072 -0.889074 
vn -0.138873 0.603003 -0.785558 
vn -0.140102 0.251203 -0.957741 
vn -0.139245 0.436072 -0.889074 
vn -0.996852 0.0514302 -0.0603377 
usemtl 0.349020_0.376471_0.400000_0.000000_0.000000
o mesh207
f 10480//10177 10450//10177 10451//10177 
f 10451//10177 10452//10177 10480//10177 
f 10452//10177 10453//10177 10480//10177 
f 10453//10177 10454//10177 10480//10177 
f 10454//10177 10455//10177 10480//10177 
f 10455//10177 10456//10177 10480//10177 
f 10456//10177 10457//10177 10480//10177 
f 10457//10177 10458//10177 10480//10177 
f 10458//10177 10459//10177 10480//10177 
f 10459//10177 10460//10177 10480//10177 
f 10460//10177 10461//10177 10480//10177 
f 10461//10177 10462//10177 10480//10177 
f 10462//10177 10463//10177 10480//10177 
f 10463//10177 10464//10177 10480//10177 
f 10464//10177 10465//10177 10480//10177 
f 10465//10177 10466//10177 10480//10177 
f 10466//10177 10467//10177 10480//10177 
f 10467//10177 10468//10177 10480//10177 
f 10468//10177 10469//10177 10480//10177 
f 10469//10177 10470//10177 10480//10177 
f 10470//10177 10471//10177 10480//10177 
f 10471//10177 10472//10177 10480//10177 
f 10472//10177 10473//10177 10480//10177 
f 10473//10177 10474//10177 10480//10177 
f 10474//10177 10475//10177 10480//10177 
f 10475//10177 10476//10177 10480//10177 
f 10476//10177 10477//10177 10480//10177 
f 10477//10177 10478//10177 10480//10177 
f 10478//10177 10479//10177 10480//10177 
f 10479//10177 10450//10177 10480//10177 
o mesh208
f 10481//10178 10464//10178 10463//10179 
f 10482//10179 10463//10179 10462//10180 
f 10483//10180 10462//10180 10461//10181 
f 10484//10181 10461//10181 10460//10182 
f 10485//10182 10460//10182 10459//10183 
f 10486//10183 10459//10183 10458//10184 
f 10487//10184 10458//10184 10457//10185 
f 10488//10185 10457//10185 10456//10186 
f 10489//10186 10456//10186 10455//10187 
f 10490//10187 10455//10187 10454//10188 
f 10491//10188 10454//10188 10453//10189 
f 10492//10189 10453//10189 10452//10190 
f 10493//10190 10452//10190 10451//10191 
f 10494//10191 10451//10191 10450//10192 
f 10495//10193 10496//10194 10479//10194 
f 10450//10192 10479//10194 10496//10194 
f 10496//10194 10497//10195 10450//10192 
f 10495//10193 10478//10196 10477//10197 
f 10498//10197 10477//10197 10476//10198 
f 10499//10198 10476//10198 10475//10199 
f 10500//10199 10475//10199 10474//10200 
f 10501//10200 10474//10200 10473//10201 
f 10502//10201 10473//10201 10472//10202 
f 10503//10202 10472//10202 10471//10203 
f 10504//10203 10471//10203 10470//10204 
f 10505//10204 10470//10204 10469//10205 
f 10506//10205 10469//10205 10468//10206 
f 10507//10206 10468//10206 10467//10207 
f 10508//10207 10467//10207 10466//10208 
f 10509//10208 10466//10208 10465//10209 
f 10510//10209 10465//10209 10464//10178 
f 10464//10178 10481//10178 10510//10209 
f 10465//10209 10510//10209 10509//10208 
f 10466//10208 10509//10208 10508//10207 
f 10467//10207 10508//10207 10507//10206 
f 10468//10206 10507//10206 10506//10205 
f 10469//10205 10506//10205 10505//10204 
f 10470//10204 10505//10204 10504//10203 
f 10471//10203 10504//10203 10503//10202 
f 10472//10202 10503//10202 10502//10201 
f 10473//10201 10502//10201 10501//10200 
f 10474//10200 10501//10200 10500//10199 
f 10475//10199 10500//10199 10499//10198 
f 10476//10198 10499//10198 10498//10197 
f 10477//10197 10498//10197 10495//10193 
f 10479//10194 10478//10196 10495//10193 
f 10450//10192 10497//10195 10494//10191 
f 10451//10191 10494//10191 10493//10190 
f 10452//10190 10493//10190 10492//10189 
f 10453//10189 10492//10189 10491//10188 
f 10454//10188 10491//10188 10490//10187 
f 10455//10187 10490//10187 10489//10186 
f 10456//10186 10489//10186 10488//10185 
f 10457//10185 10488//10185 10487//10184 
f 10458//10184 10487//10184 10486//10183 
f 10459//10183 10486//10183 10485//10182 
f 10460//10182 10485//10182 10484//10181 
f 10461//10181 10484//10181 10483//10180 
f 10462//10180 10483//10180 10482//10179 
f 10463//10179 10482//10179 10481//10178 
o mesh209
f 10511//10210 10512//10210 10497//10210 
f 10513//10210 10494//10210 10497//10210 
f 10514//10210 10483//10210 10484//10210 
f 10515//10210 10482//10210 10483//10210 
f 10516//10210 10481//10210 10482//10210 
f 10516//10210 10517//10210 10510//10210 
f 10497//10210 10512//10210 10513//10210 
f 10518//10210 10493//10210 10494//10210 
f 10519//10210 10492//10210 10493//10210 
f 10519//10210 10520//10210 10491//10210 
f 10521//10210 10487//10210 10488//10210 
f 10521//10210 10522//10210 10486//10210 
f 10523//10210 10485//10210 10486//10210 
f 10523//10210 10524//10210 10484//10210 
f 10483//10210 10514//10210 10515//10210 
f 10510//10210 10481//10210 10516//10210 
f 10525//10210 10506//10210 10507//10210 
f 10526//10210 10505//10210 10506//10210 
f 10494//10210 10513//10210 10518//10210 
f 10491//10210 10492//10210 10519//10210 
f 10527//10210 10489//10210 10490//10210 
f 10527//10210 10528//10210 10488//10210 
f 10486//10210 10487//10210 10521//10210 
f 10484//10210 10485//10210 10523//10210 
f 10482//10210 10515//10210 10516//10210 
f 10517//10210 10529//10210 10509//10210 
f 10530//10210 10508//10210 10509//10210 
f 10530//10210 10531//10210 10507//10210 
f 10506//10210 10525//10210 10526//10210 
f 10532//10210 10504//10210 10505//10210 
f 10533//10210 10503//10210 10504//10210 
f 10533//10210 10534//10210 10502//10210 
f 10493//10210 10518//10210 10519//10210 
f 10520//10210 10535//10210 10490//10210 
f 10488//10210 10489//10210 10527//10210 
f 10486//10210 10522//10210 10523//10210 
f 10509//10210 10510//10210 10517//10210 
f 10507//10210 10508//10210 10530//10210 
f 10505//10210 10526//10210 10532//10210 
f 10502//10210 10503//10210 10533//10210 
f 10536//10210 10501//10210 10502//10210 
f 10536//10210 10537//10210 10500//10210 
f 10538//10210 10499//10210 10500//10210 
f 10538//10210 10539//10210 10498//10210 
f 10490//10210 10491//10210 10520//10210 
f 10488//10210 10528//10210 10521//10210 
f 10509//10210 10529//10210 10530//10210 
f 10504//10210 10532//10210 10533//10210 
f 10500//10210 10501//10210 10536//10210 
f 10498//10210 10499//10210 10538//10210 
f 10540//10210 10495//10210 10498//10210 
f 10540//10210 10511//10210 10496//10210 
f 10490//10210 10535//10210 10527//10210 
f 10507//10210 10531//10210 10525//10210 
f 10500//10210 10537//10210 10538//10210 
f 10496//10210 10495//10210 10540//10210 
f 10484//10210 10524//10210 10514//10210 
f 10498//10210 10539//10210 10540//10210 
f 10502//10210 10534//10210 10536//10210 
f 10497//10210 10496//10210 10511//10210 
o mesh210
f 10541//10211 10516//10211 10515//10212 
f 10542//10212 10515//10212 10514//10213 
f 10543//10213 10514//10213 10524//10214 
f 10544//10214 10524//10214 10523//10215 
f 10545//10215 10523//10215 10522//10216 
f 10546//10216 10522//10216 10521//10217 
f 10547//10217 10521//10217 10528//10218 
f 10548//10218 10528//10218 10527//10219 
f 10549//10219 10527//10219 10535//10220 
f 10550//10220 10535//10220 10520//10221 
f 10551//10221 10520//10221 10519//10222 
f 10552//10222 10519//10222 10518//10223 
f 10553//10223 10518//10223 10513//10224 
f 10554//10224 10513//10224 10512//10225 
f 10540//10226 10555//10226 10556//10227 
f 10557//10228 10512//10225 10511//10227 
f 10511//10227 10556//10227 10557//10228 
f 10555//10226 10540//10226 10539//10229 
f 10558//10229 10539//10229 10538//10230 
f 10559//10230 10538//10230 10537//10231 
f 10560//10231 10537//10231 10536//10232 
f 10561//10232 10536//10232 10534//10233 
f 10562//10233 10534//10233 10533//10234 
f 10563//10234 10533//10234 10532//10235 
f 10564//10235 10532//10235 10526//10236 
f 10565//10236 10526//10236 10525//10237 
f 10566//10237 10525//10237 10531//10238 
f 10567//10238 10531//10238 10530//10239 
f 10568//10239 10530//10239 10529//10240 
f 10569//10240 10529//10240 10517//10241 
f 10570//10241 10517//10241 10516//10211 
f 10516//10211 10541//10211 10570//10241 
f 10517//10241 10570//10241 10569//10240 
f 10529//10240 10569//10240 10568//10239 
f 10530//10239 10568//10239 10567//10238 
f 10531//10238 10567//10238 10566//10237 
f 10525//10237 10566//10237 10565//10236 
f 10526//10236 10565//10236 10564//10235 
f 10532//10235 10564//10235 10563//10234 
f 10533//10234 10563//10234 10562//10233 
f 10534//10233 10562//10233 10561//10232 
f 10536//10232 10561//10232 10560//10231 
f 10537//10231 10560//10231 10559//10230 
f 10538//10230 10559//10230 10558//10229 
f 10539//10229 10558//10229 10555//10226 
f 10556//10227 10511//10227 10540//10226 
f 10512//10225 10557//10228 10554//10224 
f 10513//10224 10554//10224 10553//10223 
f 10518//10223 10553//10223 10552//10222 
f 10519//10222 10552//10222 10551//10221 
f 10520//10221 10551//10221 10550//10220 
f 10535//10220 10550//10220 10549//10219 
f 10527//10219 10549//10219 10548//10218 
f 10528//10218 10548//10218 10547//10217 
f 10521//10217 10547//10217 10546//10216 
f 10522//10216 10546//10216 10545//10215 
f 10523//10215 10545//10215 10544//10214 
f 10524//10214 10544//10214 10543//10213 
f 10514//10213 10543//10213 10542//10212 
f 10515//10212 10542//10212 10541//10211 
o mesh211
f 10571//10242 10572//10242 10573//10242 
f 10574//10242 10575//10242 10576//10242 
f 10571//10242 10577//10242 10578//10242 
f 10571//10242 10579//10242 10572//10242 
f 10580//10242 10581//10242 10582//10242 
f 10576//10242 10583//10242 10574//10242 
f 10584//10242 10585//10242 10586//10242 
f 10584//10242 10571//10242 10587//10242 
f 10573//10242 10577//10242 10571//10242 
f 10582//10242 10571//10242 10580//10242 
f 10574//10242 10588//10242 10589//10242 
f 10574//10242 10590//10242 10575//10242 
f 10584//10242 10591//10242 10590//10242 
f 10587//10242 10585//10242 10584//10242 
f 10582//10242 10579//10242 10571//10242 
f 10580//10242 10592//10242 10593//10242 
f 10583//10242 10588//10242 10574//10242 
f 10584//10242 10594//10242 10591//10242 
f 10578//10242 10587//10242 10571//10242 
f 10593//10242 10595//10242 10580//10242 
f 10699//10242 10574//10242 10596//10242 
f 10590//10242 10574//10242 10584//10242 
f 10595//10242 10581//10242 10580//10242 
f 10580//10242 10699//10242 10597//10242 
f 10699//10242 10598//10242 10599//10242 
f 10596//10242 10600//10242 10699//10242 
f 10586//10242 10594//10242 10584//10242 
f 10699//10242 10601//10242 10597//10242 
f 10599//10242 10602//10242 10699//10242 
f 10600//10242 10603//10242 10699//10242 
f 10597//10242 10592//10242 10580//10242 
f 10603//10242 10598//10242 10699//10242 
f 10602//10242 10601//10242 10699//10242 
f 10604//10242 10605//10242 10606//10242 
f 10606//10242 10607//10242 10604//10242 
f 10580//10242 10608//10242 10609//10242 
f 10610//10242 10611//10242 10612//10242 
f 10604//10242 10613//10242 10614//10242 
f 10607//10242 10615//10242 10604//10242 
f 10699//10242 10616//10242 10617//10242 
f 10699//10242 10580//10242 10618//10242 
f 10609//10242 10619//10242 10580//10242 
f 10610//10242 10620//10242 10611//10242 
f 10614//10242 10610//10242 10604//10242 
f 10615//10242 10621//10242 10604//10242 
f 10605//10242 10699//10242 10622//10242 
f 10699//10242 10623//10242 10624//10242 
f 10618//10242 10616//10242 10699//10242 
f 10580//10242 10625//10242 10608//10242 
f 10610//10242 10626//10242 10620//10242 
f 10614//10242 10627//10242 10610//10242 
f 10605//10242 10628//10242 10606//10242 
f 10622//10242 10629//10242 10605//10242 
f 10699//10242 10630//10242 10623//10242 
f 10619//10242 10618//10242 10580//10242 
f 10612//10242 10580//10242 10610//10242 
f 10621//10242 10613//10242 10604//10242 
f 10605//10242 10631//10242 10632//10242 
f 10629//10242 10633//10242 10605//10242 
f 10699//10242 10634//10242 10635//10242 
f 10617//10242 10630//10242 10699//10242 
f 10627//10242 10626//10242 10610//10242 
f 10633//10242 10631//10242 10605//10242 
f 10624//10242 10634//10242 10699//10242 
f 10632//10242 10628//10242 10605//10242 
f 10612//10242 10625//10242 10580//10242 
f 10636//10242 10637//10242 10638//10242 
f 10636//10242 10639//10242 10637//10242 
f 10636//10242 10640//10242 10639//10242 
f 10636//10242 10641//10242 10640//10242 
f 10636//10242 10699//10242 10642//10242 
f 10643//10242 10644//10242 10645//10242 
f 10642//10242 10641//10242 10636//10242 
f 10699//10242 10646//10242 10647//10242 
f 10699//10242 10648//10242 10649//10242 
f 10699//10242 10605//10242 10650//10242 
f 10651//10242 10652//10242 10653//10242 
f 10645//10242 10651//10242 10643//10242 
f 10647//10242 10642//10242 10699//10242 
f 10699//10242 10654//10242 10648//10242 
f 10650//10242 10655//10242 10699//10242 
f 10651//10242 10656//10242 10652//10242 
f 10651//10242 10657//10242 10658//10242 
f 10643//10242 10659//10242 10644//10242 
f 10636//10242 10660//10242 10661//10242 
f 10649//10242 10646//10242 10699//10242 
f 10605//10242 10662//10242 10650//10242 
f 10605//10242 10653//10242 10663//10242 
f 10658//10242 10656//10242 10651//10242 
f 10645//10242 10664//10242 10651//10242 
f 10661//10242 10643//10242 10636//10242 
f 10655//10242 10654//10242 10699//10242 
f 10663//10242 10665//10242 10605//10242 
f 10664//10242 10657//10242 10651//10242 
f 10638//10242 10660//10242 10636//10242 
f 10653//10242 10605//10242 10651//10242 
f 10665//10242 10662//10242 10605//10242 
f 10643//10242 10666//10242 10667//10242 
f 10667//10242 10659//10242 10643//10242 
f 10574//10242 10544//10242 10545//10242 
f 10574//10242 10699//10242 10541//10242 
f 10699//10242 10566//10242 10567//10242 
f 10699//10242 10564//10242 10565//10242 
f 10668//10242 10574//10242 10547//10242 
f 10574//10242 10543//10242 10544//10242 
f 10541//10242 10542//10242 10574//10242 
f 10699//10242 10568//10242 10569//10242 
f 10565//10242 10566//10242 10699//10242 
f 10636//10242 10563//10242 10564//10242 
f 10574//10242 10546//10242 10547//10242 
f 10542//10242 10543//10242 10574//10242 
f 10569//10242 10570//10242 10699//10242 
f 10564//10242 10699//10242 10636//10242 
f 10547//10242 10669//10242 10668//10242 
f 10570//10242 10541//10242 10699//10242 
f 10636//10242 10562//10242 10563//10242 
f 10636//10242 10560//10242 10561//10242 
f 10636//10242 10556//10242 10555//10242 
f 10545//10242 10546//10242 10574//10242 
f 10561//10242 10562//10242 10636//10242 
f 10555//10242 10558//10242 10636//10242 
f 10636//10242 10670//10242 10557//10242 
f 10567//10242 10568//10242 10699//10242 
f 10558//10242 10559//10242 10636//10242 
f 10671//10242 10547//10242 10548//10242 
f 10670//10242 10554//10242 10557//10242 
f 10553//10242 10672//10242 10673//10242 
f 10553//10242 10670//10242 10674//10242 
f 10675//10242 10574//10242 10676//10242 
f 10574//10242 10677//10242 10678//10242 
f 10559//10242 10560//10242 10636//10242 
f 10547//10242 10671//10242 10679//10242 
f 10548//10242 10680//10242 10681//10242 
f 10548//10242 10682//10242 10683//10242 
f 10670//10242 10553//10242 10554//10242 
f 10674//10242 10672//10242 10553//10242 
f 10684//10242 10675//10242 10685//10242 
f 10676//10242 10686//10242 10675//10242 
f 10574//10242 10687//10242 10677//10242 
f 10679//10242 10669//10242 10547//10242 
f 10683//10242 10680//10242 10548//10242 
f 10549//10242 10673//10242 10688//10242 
f 10673//10242 10552//10242 10553//10242 
f 10673//10242 10550//10242 10551//10242 
f 10684//10242 10689//10242 10690//10242 
f 10675//10242 10691//10242 10685//10242 
f 10675//10242 10692//10242 10693//10242 
f 10678//10242 10676//10242 10574//10242 
f 10548//10242 10681//10242 10671//10242 
f 10688//10242 10548//10242 10549//10242 
f 10688//10242 10682//10242 10548//10242 
f 10551//10242 10552//10242 10673//10242 
f 10684//10242 10694//10242 10689//10242 
f 10675//10242 10695//10242 10691//10242 
f 10686//10242 10692//10242 10675//10242 
f 10673//10242 10549//10242 10550//10242 
f 10684//10242 10696//10242 10670//10242 
f 10685//10242 10694//10242 10684//10242 
f 10668//10242 10687//10242 10574//10242 
f 10670//10242 10636//10242 10684//10242 
f 10684//10242 10697//10242 10698//10242 
f 10693//10242 10695//10242 10675//10242 
f 10698//10242 10696//10242 10684//10242 
f 10557//10242 10556//10242 10636//10242 
f 10690//10242 10697//10242 10684//10242 
f 10661//10242 10666//10242 10643//10242 
f 10635//10242 10622//10242 10699//10242 
f 10589//10242 10596//10242 10574//10242 
o mesh212
f 10700//10243 10701//10243 10574//10243 
f 10584//10243 10574//10243 10701//10243 
f 10701//10243 10702//10243 10584//10243 
f 10574//10243 10675//10243 10700//10243 
o mesh213
f 10703//10244 10571//10244 10584//10244 
f 10584//10244 10702//10244 10703//10244 
o mesh214
f 10703//10245 10704//10245 10580//10245 
f 10610//10245 10580//10245 10704//10245 
f 10704//10245 10705//10245 10610//10245 
f 10580//10245 10571//10245 10703//10245 
o mesh215
f 10706//10246 10604//10246 10610//10246 
f 10610//10246 10705//10246 10706//10246 
o mesh216
f 10706//10247 10707//10247 10605//10247 
f 10651//10247 10605//10247 10707//10247 
f 10707//10247 10708//10247 10651//10247 
f 10605//10247 10604//10247 10706//10247 
o mesh217
f 10709//10248 10643//10248 10651//10248 
f 10651//10248 10708//10248 10709//10248 
o mesh218
f 10709//10249 10710//10249 10636//10249 
f 10684//10249 10636//10249 10710//10249 
f 10710//10249 10711//10249 10684//10249 
f 10636//10249 10643//10249 10709//10249 
o mesh219
f 10700//10250 10675//10250 10684//10250 
f 10684//10250 10711//10250 10700//10250 
o mesh220
f 10600//10251 10596//10252 10712//10252 
f 10603//10253 10600//10251 10713//10254 
f 10598//10255 10603//10253 10714//10256 
f 10599//10257 10598//10255 10715//10258 
f 10602//10259 10599//10257 10716//10260 
f 10601//10261 10602//10259 10717//10262 
f 10597//10263 10601//10261 10718//10264 
f 10592//10265 10597//10263 10719//10266 
f 10593//10267 10592//10265 10720//10268 
f 10595//10269 10593//10267 10721//10270 
f 10581//10271 10595//10269 10722//10272 
f 10582//10273 10581//10271 10723//10274 
f 10579//10275 10582//10273 10724//10276 
f 10572//10277 10579//10275 10725//10278 
f 10573//10279 10572//10277 10726//10280 
f 10577//10281 10573//10279 10727//10282 
f 10578//10283 10577//10281 10728//10284 
f 10587//10285 10578//10283 10729//10286 
f 10585//10287 10587//10285 10730//10288 
f 10586//10289 10585//10287 10731//10290 
f 10594//10291 10586//10289 10732//10292 
f 10591//10293 10594//10291 10733//10294 
f 10590//10295 10591//10293 10734//10296 
f 10575//10297 10590//10295 10735//10298 
f 10576//10299 10575//10297 10736//10300 
f 10583//10301 10576//10299 10737//10302 
f 10588//10303 10583//10301 10738//10304 
f 10589//10305 10588//10303 10739//10306 
f 10596//10252 10589//10305 10740//10305 
f 10740//10305 10712//10252 10596//10252 
f 10739//10306 10740//10305 10589//10305 
f 10738//10304 10739//10306 10588//10303 
f 10737//10302 10738//10304 10583//10301 
f 10736//10300 10737//10302 10576//10299 
f 10735//10298 10736//10300 10575//10297 
f 10734//10296 10735//10298 10590//10295 
f 10733//10294 10734//10296 10591//10293 
f 10732//10292 10733//10294 10594//10291 
f 10731//10290 10732//10292 10586//10289 
f 10730//10288 10731//10290 10585//10287 
f 10729//10286 10730//10288 10587//10285 
f 10728//10284 10729//10286 10578//10283 
f 10727//10282 10728//10284 10577//10281 
f 10726//10280 10727//10282 10573//10279 
f 10725//10278 10726//10280 10572//10277 
f 10724//10276 10725//10278 10579//10275 
f 10723//10274 10724//10276 10582//10273 
f 10722//10272 10723//10274 10581//10271 
f 10721//10270 10722//10272 10595//10269 
f 10720//10268 10721//10270 10593//10267 
f 10719//10266 10720//10268 10592//10265 
f 10718//10264 10719//10266 10597//10263 
f 10717//10262 10718//10264 10601//10261 
f 10716//10260 10717//10262 10602//10259 
f 10715//10258 10716//10260 10599//10257 
f 10714//10256 10715//10258 10598//10255 
f 10713//10254 10714//10256 10603//10253 
f 10712//10252 10713//10254 10600//10251 
o mesh221
f 10629//10307 10622//10308 10741//10308 
f 10633//10309 10629//10307 10742//10310 
f 10631//10311 10633//10309 10743//10312 
f 10632//10313 10631//10311 10744//10314 
f 10628//10315 10632//10313 10745//10316 
f 10606//10317 10628//10315 10746//10318 
f 10607//10319 10606//10317 10747//10320 
f 10615//10321 10607//10319 10748//10322 
f 10621//10323 10615//10321 10749//10324 
f 10613//10325 10621//10323 10750//10326 
f 10614//10327 10613//10325 10751//10328 
f 10627//10329 10614//10327 10752//10330 
f 10626//10331 10627//10329 10753//10332 
f 10620//10333 10626//10331 10754//10334 
f 10611//10335 10620//10333 10755//10336 
f 10612//10337 10611//10335 10756//10338 
f 10625//10339 10612//10337 10757//10340 
f 10608//10341 10625//10339 10758//10342 
f 10609//10343 10608//10341 10759//10344 
f 10619//10345 10609//10343 10760//10346 
f 10618//10347 10619//10345 10761//10348 
f 10616//10349 10618//10347 10762//10350 
f 10617//10351 10616//10349 10763//10352 
f 10630//10353 10617//10351 10764//10354 
f 10623//10355 10630//10353 10765//10356 
f 10624//10357 10623//10355 10766//10358 
f 10634//10359 10624//10357 10767//10360 
f 10635//10361 10634//10359 10768//10362 
f 10622//10308 10635//10361 10769//10361 
f 10769//10361 10741//10308 10622//10308 
f 10768//10362 10769//10361 10635//10361 
f 10767//10360 10768//10362 10634//10359 
f 10766//10358 10767//10360 10624//10357 
f 10765//10356 10766//10358 10623//10355 
f 10764//10354 10765//10356 10630//10353 
f 10763//10352 10764//10354 10617//10351 
f 10762//10350 10763//10352 10616//10349 
f 10761//10348 10762//10350 10618//10347 
f 10760//10346 10761//10348 10619//10345 
f 10759//10344 10760//10346 10609//10343 
f 10758//10342 10759//10344 10608//10341 
f 10757//10340 10758//10342 10625//10339 
f 10756//10338 10757//10340 10612//10337 
f 10755//10336 10756//10338 10611//10335 
f 10754//10334 10755//10336 10620//10333 
f 10753//10332 10754//10334 10626//10331 
f 10752//10330 10753//10332 10627//10329 
f 10751//10328 10752//10330 10614//10327 
f 10750//10326 10751//10328 10613//10325 
f 10749//10324 10750//10326 10621//10323 
f 10748//10322 10749//10324 10615//10321 
f 10747//10320 10748//10322 10607//10319 
f 10746//10318 10747//10320 10606//10317 
f 10745//10316 10746//10318 10628//10315 
f 10744//10314 10745//10316 10632//10313 
f 10743//10312 10744//10314 10631//10311 
f 10742//10310 10743//10312 10633//10309 
f 10741//10308 10742//10310 10629//10307 
o mesh222
f 10667//10363 10666//10364 10770//10364 
f 10659//10365 10667//10363 10771//10366 
f 10644//10367 10659//10365 10772//10368 
f 10645//10369 10644//10367 10773//10370 
f 10664//10371 10645//10369 10774//10372 
f 10657//10373 10664//10371 10775//10374 
f 10658//10375 10657//10373 10776//10376 
f 10656//10377 10658//10375 10777//10378 
f 10652//10379 10656//10377 10778//10380 
f 10653//10381 10652//10379 10779//10382 
f 10663//10383 10653//10381 10780//10384 
f 10665//10385 10663//10383 10781//10386 
f 10662//10387 10665//10385 10782//10388 
f 10650//10389 10662//10387 10783//10390 
f 10655//10391 10650//10389 10784//10392 
f 10654//10393 10655//10391 10785//10394 
f 10648//10395 10654//10393 10786//10396 
f 10649//10397 10648//10395 10787//10398 
f 10646//10399 10649//10397 10788//10400 
f 10647//10401 10646//10399 10789//10402 
f 10642//10403 10647//10401 10790//10404 
f 10641//10405 10642//10403 10791//10406 
f 10640//10407 10641//10405 10792//10408 
f 10639//10409 10640//10407 10793//10410 
f 10637//10411 10639//10409 10794//10412 
f 10638//10413 10637//10411 10795//10414 
f 10660//10415 10638//10413 10796//10416 
f 10661//10417 10660//10415 10797//10418 
f 10666//10364 10661//10417 10798//10417 
f 10798//10417 10770//10364 10666//10364 
f 10797//10418 10798//10417 10661//10417 
f 10796//10416 10797//10418 10660//10415 
f 10795//10414 10796//10416 10638//10413 
f 10794//10412 10795//10414 10637//10411 
f 10793//10410 10794//10412 10639//10409 
f 10792//10408 10793//10410 10640//10407 
f 10791//10406 10792//10408 10641//10405 
f 10790//10404 10791//10406 10642//10403 
f 10789//10402 10790//10404 10647//10401 
f 10788//10400 10789//10402 10646//10399 
f 10787//10398 10788//10400 10649//10397 
f 10786//10396 10787//10398 10648//10395 
f 10785//10394 10786//10396 10654//10393 
f 10784//10392 10785//10394 10655//10391 
f 10783//10390 10784//10392 10650//10389 
f 10782//10388 10783//10390 10662//10387 
f 10781//10386 10782//10388 10665//10385 
f 10780//10384 10781//10386 10663//10383 
f 10779//10382 10780//10384 10653//10381 
f 10778//10380 10779//10382 10652//10379 
f 10777//10378 10778//10380 10656//10377 
f 10776//10376 10777//10378 10658//10375 
f 10775//10374 10776//10376 10657//10373 
f 10774//10372 10775//10374 10664//10371 
f 10773//10370 10774//10372 10645//10369 
f 10772//10368 10773//10370 10644//10367 
f 10771//10366 10772//10368 10659//10365 
f 10770//10364 10771//10366 10667//10363 
o mesh223
f 10698//10419 10697//10420 10799//10420 
f 10696//10421 10698//10419 10800//10422 
f 10670//10423 10696//10421 10801//10424 
f 10674//10425 10670//10423 10802//10426 
f 10672//10427 10674//10425 10803//10428 
f 10673//10429 10672//10427 10804//10430 
f 10688//10431 10673//10429 10805//10432 
f 10682//10433 10688//10431 10806//10434 
f 10683//10435 10682//10433 10807//10436 
f 10680//10437 10683//10435 10808//10438 
f 10681//10439 10680//10437 10809//10440 
f 10671//10441 10681//10439 10810//10442 
f 10679//10443 10671//10441 10811//10444 
f 10669//10445 10679//10443 10812//10446 
f 10668//10447 10669//10445 10813//10448 
f 10687//10449 10668//10447 10814//10450 
f 10677//10451 10687//10449 10815//10452 
f 10678//10453 10677//10451 10816//10454 
f 10676//10455 10678//10453 10817//10456 
f 10686//10457 10676//10455 10818//10458 
f 10692//10459 10686//10457 10819//10460 
f 10693//10461 10692//10459 10820//10462 
f 10695//10463 10693//10461 10821//10464 
f 10691//10465 10695//10463 10822//10466 
f 10685//10467 10691//10465 10823//10468 
f 10694//10469 10685//10467 10824//10470 
f 10689//10471 10694//10469 10825//10472 
f 10690//10473 10689//10471 10826//10474 
f 10697//10420 10690//10473 10827//10473 
f 10827//10473 10799//10420 10697//10420 
f 10826//10474 10827//10473 10690//10473 
f 10825//10472 10826//10474 10689//10471 
f 10824//10470 10825//10472 10694//10469 
f 10823//10468 10824//10470 10685//10467 
f 10822//10466 10823//10468 10691//10465 
f 10821//10464 10822//10466 10695//10463 
f 10820//10462 10821//10464 10693//10461 
f 10819//10460 10820//10462 10692//10459 
f 10818//10458 10819//10460 10686//10457 
f 10817//10456 10818//10458 10676//10455 
f 10816//10454 10817//10456 10678//10453 
f 10815//10452 10816//10454 10677//10451 
f 10814//10450 10815//10452 10687//10449 
f 10813//10448 10814//10450 10668//10447 
f 10812//10446 10813//10448 10669//10445 
f 10811//10444 10812//10446 10679//10443 
f 10810//10442 10811//10444 10671//10441 
f 10809//10440 10810//10442 10681//10439 
f 10808//10438 10809//10440 10680//10437 
f 10807//10436 10808//10438 10683//10435 
f 10806//10434 10807//10436 10682//10433 
f 10805//10432 10806//10434 10688//10431 
f 10804//10430 10805//10432 10673//10429 
f 10803//10428 10804//10430 10672//10427 
f 10802//10426 10803//10428 10674//10425 
f 10801//10424 10802//10426 10670//10423 
f 10800//10422 10801//10424 10696//10421 
f 10799//10420 10800//10422 10698//10419 
o mesh224
f 10710//10475 10828//10475 10829//10475 
f 10857//10475 10830//10475 10828//10475 
f 10828//10475 10710//10475 10857//10475 
f 10808//10475 10831//10475 10832//10475 
f 10812//10475 10811//10475 10833//10475 
f 10814//10475 10813//10475 10834//10475 
f 10711//10475 10825//10475 10824//10475 
f 10806//10475 10710//10475 10835//10475 
f 10710//10475 10836//10475 10837//10475 
f 10857//10475 10838//10475 10830//10475 
f 10857//10475 10839//10475 10840//10475 
f 10857//10475 10841//10475 10842//10475 
f 10832//10475 10809//10475 10808//10475 
f 10832//10475 10843//10475 10810//10475 
f 10844//10475 10813//10475 10812//10475 
f 10701//10475 10845//10475 10846//10475 
f 10834//10475 10701//10475 10814//10475 
f 10824//10475 10700//10475 10711//10475 
f 10711//10475 10799//10475 10827//10475 
f 10710//10475 10847//10475 10835//10475 
f 10829//10475 10836//10475 10710//10475 
f 10842//10475 10839//10475 10857//10475 
f 10857//10475 10701//10475 10848//10475 
f 10807//10475 10849//10475 10831//10475 
f 10807//10475 10835//10475 10850//10475 
f 10843//10475 10811//10475 10810//10475 
f 10813//10475 10851//10475 10852//10475 
f 10833//10475 10844//10475 10812//10475 
f 10846//10475 10853//10475 10701//10475 
f 10834//10475 10854//10475 10701//10475 
f 10701//10475 10818//10475 10817//10475 
f 10700//10475 10819//10475 10818//10475 
f 10824//10475 10823//10475 10700//10475 
f 10827//10475 10826//10475 10711//10475 
f 10710//10475 10804//10475 10803//10475 
f 10835//10475 10807//10475 10806//10475 
f 10840//10475 10838//10475 10857//10475 
f 10848//10475 10855//10475 10857//10475 
f 10850//10475 10849//10475 10807//10475 
f 10810//10475 10809//10475 10832//10475 
f 10844//10475 10851//10475 10813//10475 
f 10854//10475 10845//10475 10701//10475 
f 10817//10475 10816//10475 10701//10475 
f 10700//10475 10820//10475 10819//10475 
f 10826//10475 10825//10475 10711//10475 
f 10711//10475 10801//10475 10800//10475 
f 10711//10475 10710//10475 10802//10475 
f 10710//10475 10805//10475 10804//10475 
f 10710//10475 10856//10475 10847//10475 
f 10855//10475 10841//10475 10857//10475 
f 10843//10475 10833//10475 10811//10475 
f 10853//10475 10848//10475 10701//10475 
f 10818//10475 10701//10475 10700//10475 
f 10700//10475 10822//10475 10821//10475 
f 10800//10475 10799//10475 10711//10475 
f 10803//10475 10802//10475 10710//10475 
f 10837//10475 10856//10475 10710//10475 
f 10852//10475 10834//10475 10813//10475 
f 10821//10475 10820//10475 10700//10475 
f 10802//10475 10801//10475 10711//10475 
f 10808//10475 10807//10475 10831//10475 
f 10816//10475 10815//10475 10701//10475 
f 10806//10475 10805//10475 10710//10475 
f 10823//10475 10822//10475 10700//10475 
f 10710//10475 10797//10475 10796//10475 
f 10709//10475 10708//10475 10774//10475 
f 10857//10475 10789//10475 10788//10475 
f 10710//10475 10794//10475 10793//10475 
f 10796//10475 10795//10475 10710//10475 
f 10708//10475 10775//10475 10774//10475 
f 10708//10475 10707//10475 10780//10475 
f 10788//10475 10787//10475 10857//10475 
f 10857//10475 10791//10475 10790//10475 
f 10710//10475 10792//10475 10791//10475 
f 10795//10475 10794//10475 10710//10475 
f 10774//10475 10773//10475 10709//10475 
f 10708//10475 10778//10475 10777//10475 
f 10780//10475 10779//10475 10708//10475 
f 10790//10475 10789//10475 10857//10475 
f 10793//10475 10792//10475 10710//10475 
f 10710//10475 10709//10475 10798//10475 
f 10708//10475 10776//10475 10775//10475 
f 10779//10475 10778//10475 10708//10475 
f 10707//10475 10782//10475 10781//10475 
f 10791//10475 10857//10475 10710//10475 
f 10709//10475 10770//10475 10798//10475 
f 10709//10475 10772//10475 10771//10475 
f 10777//10475 10776//10475 10708//10475 
f 10707//10475 10783//10475 10782//10475 
f 10857//10475 10785//10475 10784//10475 
f 10787//10475 10786//10475 10857//10475 
f 10771//10475 10770//10475 10709//10475 
f 10781//10475 10780//10475 10707//10475 
f 10784//10475 10707//10475 10857//10475 
f 10798//10475 10797//10475 10710//10475 
f 10784//10475 10783//10475 10707//10475 
f 10773//10475 10772//10475 10709//10475 
f 10704//10475 10761//10475 10760//10475 
f 10706//10475 10748//10475 10747//10475 
f 10704//10475 10762//10475 10761//10475 
f 10857//10475 10763//10475 10762//10475 
f 10857//10475 10765//10475 10764//10475 
f 10707//10475 10742//10475 10741//10475 
f 10706//10475 10749//10475 10748//10475 
f 10760//10475 10759//10475 10704//10475 
f 10764//10475 10763//10475 10857//10475 
f 10857//10475 10768//10475 10767//10475 
f 10857//10475 10741//10475 10769//10475 
f 10707//10475 10743//10475 10742//10475 
f 10706//10475 10750//10475 10749//10475 
f 10706//10475 10705//10475 10752//10475 
f 10762//10475 10704//10475 10857//10475 
f 10767//10475 10766//10475 10857//10475 
f 10741//10475 10857//10475 10707//10475 
f 10706//10475 10751//10475 10750//10475 
f 10705//10475 10753//10475 10752//10475 
f 10766//10475 10765//10475 10857//10475 
f 10707//10475 10744//10475 10743//10475 
f 10747//10475 10707//10475 10706//10475 
f 10705//10475 10754//10475 10753//10475 
f 10769//10475 10768//10475 10857//10475 
f 10707//10475 10746//10475 10745//10475 
f 10752//10475 10751//10475 10706//10475 
f 10705//10475 10756//10475 10755//10475 
f 10705//10475 10704//10475 10757//10475 
f 10745//10475 10744//10475 10707//10475 
f 10755//10475 10754//10475 10705//10475 
f 10704//10475 10758//10475 10757//10475 
f 10747//10475 10746//10475 10707//10475 
f 10759//10475 10758//10475 10704//10475 
f 10701//10475 10738//10475 10737//10475 
f 10857//10475 10713//10475 10712//10475 
f 10701//10475 10739//10475 10738//10475 
f 10857//10475 10714//10475 10713//10475 
f 10857//10475 10717//10475 10716//10475 
f 10737//10475 10736//10475 10701//10475 
f 10701//10475 10712//10475 10740//10475 
f 10857//10475 10715//10475 10714//10475 
f 10857//10475 10718//10475 10717//10475 
f 10704//10475 10703//10475 10724//10475 
f 10703//10475 10730//10475 10729//10475 
f 10702//10475 10731//10475 10730//10475 
f 10702//10475 10733//10475 10732//10475 
f 10702//10475 10701//10475 10735//10475 
f 10740//10475 10739//10475 10701//10475 
f 10716//10475 10715//10475 10857//10475 
f 10704//10475 10722//10475 10721//10475 
f 10703//10475 10725//10475 10724//10475 
f 10703//10475 10727//10475 10726//10475 
f 10729//10475 10728//10475 10703//10475 
f 10732//10475 10731//10475 10702//10475 
f 10735//10475 10734//10475 10702//10475 
f 10712//10475 10701//10475 10857//10475 
f 10704//10475 10720//10475 10719//10475 
f 10704//10475 10723//10475 10722//10475 
f 10726//10475 10725//10475 10703//10475 
f 10730//10475 10703//10475 10702//10475 
f 10736//10475 10735//10475 10701//10475 
f 10719//10475 10857//10475 10704//10475 
f 10724//10475 10723//10475 10704//10475 
f 10734//10475 10733//10475 10702//10475 
f 10721//10475 10720//10475 10704//10475 
f 10719//10475 10718//10475 10857//10475 
f 10728//10475 10727//10475 10703//10475 
f 10757//10475 10756//10475 10705//10475 
f 10786//10475 10785//10475 10857//10475 
f 10815//10475 10814//10475 10701//10475 
o mesh225
f 10858//10476 10859//10477 10850//10477 
f 10860//10478 10858//10476 10835//10479 
f 10861//10480 10860//10478 10847//10481 
f 10862//10482 10861//10480 10856//10483 
f 10863//10484 10862//10482 10837//10485 
f 10864//10486 10863//10484 10836//10487 
f 10865//10488 10864//10486 10829//10489 
f 10866//10490 10865//10488 10828//10491 
f 10867//10492 10866//10490 10830//10493 
f 10868//10494 10867//10492 10838//10495 
f 10869//10496 10868//10494 10840//10497 
f 10870//10498 10869//10496 10839//10499 
f 10871//10500 10870//10498 10842//10501 
f 10872//10502 10871//10500 10841//10503 
f 10873//10504 10872//10502 10855//10505 
f 10874//10506 10873//10504 10848//10507 
f 10875//10508 10874//10506 10853//10509 
f 10876//10510 10875//10508 10846//10511 
f 10877//10512 10876//10510 10845//10513 
f 10878//10514 10877//10512 10854//10515 
f 10879//10516 10878//10514 10834//10517 
f 10880//10518 10879//10516 10852//10519 
f 10881//10520 10880//10518 10851//10521 
f 10882//10522 10881//10520 10844//10523 
f 10883//10524 10882//10522 10833//10525 
f 10884//10526 10883//10524 10843//10527 
f 10885//10528 10884//10526 10832//10529 
f 10886//10530 10885//10528 10831//10531 
f 10859//10477 10886//10530 10849//10530 
f 10849//10530 10850//10477 10859//10477 
f 10831//10531 10849//10530 10886//10530 
f 10832//10529 10831//10531 10885//10528 
f 10843//10527 10832//10529 10884//10526 
f 10833//10525 10843//10527 10883//10524 
f 10844//10523 10833//10525 10882//10522 
f 10851//10521 10844//10523 10881//10520 
f 10852//10519 10851//10521 10880//10518 
f 10834//10517 10852//10519 10879//10516 
f 10854//10515 10834//10517 10878//10514 
f 10845//10513 10854//10515 10877//10512 
f 10846//10511 10845//10513 10876//10510 
f 10853//10509 10846//10511 10875//10508 
f 10848//10507 10853//10509 10874//10506 
f 10855//10505 10848//10507 10873//10504 
f 10841//10503 10855//10505 10872//10502 
f 10842//10501 10841//10503 10871//10500 
f 10839//10499 10842//10501 10870//10498 
f 10840//10497 10839//10499 10869//10496 
f 10838//10495 10840//10497 10868//10494 
f 10830//10493 10838//10495 10867//10492 
f 10828//10491 10830//10493 10866//10490 
f 10829//10489 10828//10491 10865//10488 
f 10836//10487 10829//10489 10864//10486 
f 10837//10485 10836//10487 10863//10484 
f 10856//10483 10837//10485 10862//10482 
f 10847//10481 10856//10483 10861//10480 
f 10835//10479 10847//10481 10860//10478 
f 10850//10477 10835//10479 10858//10476 
o mesh226
f 10885//10532 10887//10532 10888//10532 
f 10886//10532 10889//10532 10887//10532 
f 10859//10532 10890//10532 10889//10532 
f 10859//10532 10858//10532 10891//10532 
f 10874//10532 10892//10532 10893//10532 
f 10875//10532 10894//10532 10892//10532 
f 10876//10532 10895//10532 10894//10532 
f 10876//10532 10877//10532 10896//10532 
f 10881//10532 10897//10532 10898//10532 
f 10881//10532 10882//10532 10899//10532 
f 10883//10532 10900//10532 10899//10532 
f 10883//10532 10884//10532 10888//10532 
f 10887//10532 10885//10532 10886//10532 
f 10891//10532 10890//10532 10859//10532 
f 10863//10532 10901//10532 10902//10532 
f 10864//10532 10903//10532 10901//10532 
f 10892//10532 10874//10532 10875//10532 
f 10896//10532 10895//10532 10876//10532 
f 10879//10532 10904//10532 10905//10532 
f 10879//10532 10880//10532 10898//10532 
f 10899//10532 10897//10532 10881//10532 
f 10888//10532 10900//10532 10883//10532 
f 10889//10532 10886//10532 10859//10532 
f 10858//10532 10860//10532 10906//10532 
f 10861//10532 10907//10532 10906//10532 
f 10861//10532 10862//10532 10902//10532 
f 10901//10532 10863//10532 10864//10532 
f 10865//10532 10908//10532 10903//10532 
f 10866//10532 10909//10532 10908//10532 
f 10866//10532 10867//10532 10910//10532 
f 10894//10532 10875//10532 10876//10532 
f 10877//10532 10878//10532 10905//10532 
f 10898//10532 10904//10532 10879//10532 
f 10899//10532 10882//10532 10883//10532 
f 10906//10532 10891//10532 10858//10532 
f 10902//10532 10907//10532 10861//10532 
f 10903//10532 10864//10532 10865//10532 
f 10910//10532 10909//10532 10866//10532 
f 10868//10532 10911//10532 10910//10532 
f 10868//10532 10869//10532 10912//10532 
f 10870//10532 10913//10532 10912//10532 
f 10870//10532 10871//10532 10914//10532 
f 10905//10532 10896//10532 10877//10532 
f 10898//10532 10880//10532 10881//10532 
f 10906//10532 10860//10532 10861//10532 
f 10908//10532 10865//10532 10866//10532 
f 10912//10532 10911//10532 10868//10532 
f 10914//10532 10913//10532 10870//10532 
f 10872//10532 10915//10532 10914//10532 
f 10872//10532 10873//10532 10893//10532 
f 10905//10532 10878//10532 10879//10532 
f 10902//10532 10862//10532 10863//10532 
f 10912//10532 10869//10532 10870//10532 
f 10893//10532 10915//10532 10872//10532 
f 10888//10532 10884//10532 10885//10532 
f 10914//10532 10871//10532 10872//10532 
f 10910//10532 10867//10532 10868//10532 
f 10893//10532 10873//10532 10874//10532 
o mesh227
f 10916//10533 10917//10534 10890//10534 
f 10918//10535 10916//10533 10891//10536 
f 10919//10537 10918//10535 10906//10538 
f 10920//10539 10919//10537 10907//10540 
f 10921//10541 10920//10539 10902//10542 
f 10922//10543 10921//10541 10901//10544 
f 10923//10545 10922//10543 10903//10546 
f 10924//10547 10923//10545 10908//10548 
f 10925//10549 10924//10547 10909//10550 
f 10926//10551 10925//10549 10910//10552 
f 10927//10553 10926//10551 10911//10554 
f 10928//10555 10927//10553 10912//10556 
f 10929//10557 10928//10555 10913//10558 
f 10930//10559 10929//10557 10914//10560 
f 10931//10561 10930//10559 10915//10562 
f 10932//10563 10931//10561 10893//10564 
f 10933//10565 10932//10563 10892//10566 
f 10934//10567 10933//10565 10894//10568 
f 10935//10569 10934//10567 10895//10570 
f 10936//10571 10935//10569 10896//10572 
f 10937//10573 10936//10571 10905//10574 
f 10938//10575 10937//10573 10904//10576 
f 10939//10577 10938//10575 10898//10578 
f 10940//10579 10939//10577 10897//10580 
f 10941//10581 10940//10579 10899//10582 
f 10942//10583 10941//10581 10900//10584 
f 10943//10585 10942//10583 10888//10586 
f 10944//10587 10943//10585 10887//10588 
f 10917//10534 10944//10587 10889//10587 
f 10889//10587 10890//10534 10917//10534 
f 10887//10588 10889//10587 10944//10587 
f 10888//10586 10887//10588 10943//10585 
f 10900//10584 10888//10586 10942//10583 
f 10899//10582 10900//10584 10941//10581 
f 10897//10580 10899//10582 10940//10579 
f 10898//10578 10897//10580 10939//10577 
f 10904//10576 10898//10578 10938//10575 
f 10905//10574 10904//10576 10937//10573 
f 10896//10572 10905//10574 10936//10571 
f 10895//10570 10896//10572 10935//10569 
f 10894//10568 10895//10570 10934//10567 
f 10892//10566 10894//10568 10933//10565 
f 10893//10564 10892//10566 10932//10563 
f 10915//10562 10893//10564 10931//10561 
f 10914//10560 10915//10562 10930//10559 
f 10913//10558 10914//10560 10929//10557 
f 10912//10556 10913//10558 10928//10555 
f 10911//10554 10912//10556 10927//10553 
f 10910//10552 10911//10554 10926//10551 
f 10909//10550 10910//10552 10925//10549 
f 10908//10548 10909//10550 10924//10547 
f 10903//10546 10908//10548 10923//10545 
f 10901//10544 10903//10546 10922//10543 
f 10902//10542 10901//10544 10921//10541 
f 10907//10540 10902//10542 10920//10539 
f 10906//10538 10907//10540 10919//10537 
f 10891//10536 10906//10538 10918//10535 
f 10890//10534 10891//10536 10916//10533 
o mesh228
f 10945//10589 10916//10589 10918//10589 
f 10918//10589 10919//10589 10945//10589 
f 10919//10589 10920//10589 10945//10589 
f 10920//10589 10921//10589 10945//10589 
f 10921//10589 10922//10589 10945//10589 
f 10922//10589 10923//10589 10945//10589 
f 10923//10589 10924//10589 10945//10589 
f 10924//10589 10925//10589 10945//10589 
f 10925//10589 10926//10589 10945//10589 
f 10926//10589 10927//10589 10945//10589 
f 10927//10589 10928//10589 10945//10589 
f 10928//10589 10929//10589 10945//10589 
f 10929//10589 10930//10589 10945//10589 
f 10930//10589 10931//10589 10945//10589 
f 10931//10589 10932//10589 10945//10589 
f 10932//10589 10933//10589 10945//10589 
f 10933//10589 10934//10589 10945//10589 
f 10934//10589 10935//10589 10945//10589 
f 10935//10589 10936//10589 10945//10589 
f 10936//10589 10937//10589 10945//10589 
f 10937//10589 10938//10589 10945//10589 
f 10938//10589 10939//10589 10945//10589 
f 10939//10589 10940//10589 10945//10589 
f 10940//10589 10941//10589 10945//10589 
f 10941//10589 10942//10589 10945//10589 
f 10942//10589 10943//10589 10945//10589 
f 10943//10589 10944//10589 10945//10589 
f 10944//10589 10917//10589 10945//10589 
f 10917//10589 10916//10589 10945//10589 
g 1mmSpacer
v 0.0284706 0.00584011 0.0620032 
v 0.0291155 0.00584011 0.0620733 
v 0.0291155 0.00484011 0.0620733 
v 0.0278558 0.00584011 0.061796 
v 0.0284706 0.00484011 0.0620032 
v 0.0273 0.00584011 0.0614616 
v 0.0278558 0.00484011 0.061796 
v 0.026829 0.00584011 0.0610155 
v 0.0273 0.00484011 0.0614616 
v 0.0264649 0.00584011 0.0604785 
v 0.026829 0.00484011 0.0610155 
v 0.0262248 0.00584011 0.0598759 
v 0.0264649 0.00484011 0.0604785 
v 0.0261199 0.00584011 0.0592357 
v 0.0262248 0.00484011 0.0598759 
v 0.026155 0.00584011 0.058588 
v 0.0261199 0.00484011 0.0592357 
v 0.0263285 0.00584011 0.0579629 
v 0.026155 0.00484011 0.058588 
v 0.0266324 0.00584011 0.0573897 
v 0.0263285 0.00484011 0.0579629 
v 0.0270524 0.00584011 0.0568953 
v 0.0266324 0.00484011 0.0573897 
v 0.0275688 0.00584011 0.0565027 
v 0.0270524 0.00484011 0.0568953 
v 0.0281576 0.00584011 0.0562303 
v 0.0275688 0.00484011 0.0565027 
v 0.0287911 0.00584011 0.0560909 
v 0.0281576 0.00484011 0.0562303 
v 0.0294398 0.00584011 0.0560909 
v 0.0291155 0.00584011 0.0560733 
v 0.0291155 0.00484011 0.0560733 
v 0.0287911 0.00484011 0.0560909 
v 0.0300734 0.00584011 0.0562303 
v 0.0294398 0.00484011 0.0560909 
v 0.0306621 0.00584011 0.0565027 
v 0.0300734 0.00484011 0.0562303 
v 0.0311786 0.00584011 0.0568953 
v 0.0306621 0.00484011 0.0565027 
v 0.0315985 0.00584011 0.0573897 
v 0.0311786 0.00484011 0.0568953 
v 0.0319024 0.00584011 0.0579629 
v 0.0315985 0.00484011 0.0573897 
v 0.032076 0.00584011 0.058588 
v 0.0319024 0.00484011 0.0579629 
v 0.0321111 0.00584011 0.0592357 
v 0.032076 0.00484011 0.058588 
v 0.0320061 0.00584011 0.0598759 
v 0.0321111 0.00484011 0.0592357 
v 0.031766 0.00584011 0.0604785 
v 0.0320061 0.00484011 0.0598759 
v 0.031402 0.00584011 0.0610155 
v 0.031766 0.00484011 0.0604785 
v 0.030931 0.00584011 0.0614616 
v 0.031402 0.00484011 0.0610155 
v 0.0303751 0.00584011 0.061796 
v 0.030931 0.00484011 0.0614616 
v 0.0297604 0.00584011 0.0620032 
v 0.0303751 0.00484011 0.061796 
v 0.0297604 0.00484011 0.0620032 
v 0.0321641 0.00484011 0.0616628 
v 0.0315362 0.00484011 0.0622577 
v 0.030795 0.00484011 0.0627036 
v 0.0299754 0.00484011 0.0629798 
v 0.0291155 0.00484011 0.0630733 
v 0.029548 0.00484011 0.0550967 
v 0.0303927 0.00484011 0.0552827 
v 0.0326495 0.00484011 0.0609469 
v 0.0260668 0.00484011 0.0616628 
v 0.0255814 0.00484011 0.0609469 
v 0.0270533 0.00484011 0.0556459 
v 0.0278383 0.00484011 0.0552827 
v 0.028683 0.00484011 0.0550967 
v 0.0291155 0.00484011 0.0550733 
v 0.0311777 0.00484011 0.0556459 
v 0.0318663 0.00484011 0.0561693 
v 0.0324262 0.00484011 0.0568285 
v 0.0328314 0.00484011 0.0575927 
v 0.0330628 0.00484011 0.0584262 
v 0.0329697 0.00484011 0.0601434 
v 0.0282556 0.00484011 0.0629798 
v 0.0266948 0.00484011 0.0622577 
v 0.0258047 0.00484011 0.0568285 
v 0.0263647 0.00484011 0.0561693 
v 0.0331096 0.00484011 0.0592899 
v 0.0274359 0.00484011 0.0627036 
v 0.0251213 0.00484011 0.0592899 
v 0.0251682 0.00484011 0.0584262 
v 0.0252613 0.00484011 0.0601434 
v 0.0253996 0.00484011 0.0575927 
v 0.0291155 0.00584011 0.0630733 
v 0.0299754 0.00584011 0.0629798 
v 0.030795 0.00584011 0.0627036 
v 0.0315362 0.00584011 0.0622577 
v 0.0321641 0.00584011 0.0616628 
v 0.0326495 0.00584011 0.0609469 
v 0.0329697 0.00584011 0.0601434 
v 0.0331096 0.00584011 0.0592899 
v 0.0330628 0.00584011 0.0584262 
v 0.0328314 0.00584011 0.0575927 
v 0.0324262 0.00584011 0.0568285 
v 0.0318663 0.00584011 0.0561693 
v 0.0311777 0.00584011 0.0556459 
v 0.0303927 0.00584011 0.0552827 
v 0.028683 0.00584011 0.0550967 
v 0.0291155 0.00584011 0.0550733 
v 0.029548 0.00584011 0.0550967 
v 0.0278383 0.00584011 0.0552827 
v 0.0270533 0.00584011 0.0556459 
v 0.0263647 0.00584011 0.0561693 
v 0.0258047 0.00584011 0.0568285 
v 0.0253996 0.00584011 0.0575927 
v 0.0251682 0.00584011 0.0584262 
v 0.0251213 0.00584011 0.0592899 
v 0.0252613 0.00584011 0.0601434 
v 0.0255814 0.00584011 0.0609469 
v 0.0260668 0.00584011 0.0616628 
v 0.0266948 0.00584011 0.0622577 
v 0.0274359 0.00584011 0.0627036 
v 0.0282556 0.00584011 0.0629798 
vn 0.286214 0.00609852 -0.958146 
vn 0.062702 0.00619443 -0.998013 
vn 0.491594 0.0059936 -0.870804 
vn 0.286214 0.00609852 -0.958146 
vn 0.669494 0.00588586 -0.742794 
vn 0.491594 0.0059936 -0.870804 
vn 0.81293 0.00578075 -0.582333 
vn 0.669494 0.00588586 -0.742794 
vn 0.917234 0.00568278 -0.398308 
vn 0.81293 0.00578075 -0.582333 
vn 0.979836 0.00559552 -0.199725 
vn 0.917234 0.00568278 -0.398308 
vn 0.999974 0.00552164 0.00466531 
vn 0.979836 0.00559552 -0.199725 
vn 0.978411 0.00546304 0.206596 
vn 0.999974 0.00552164 0.00466531 
vn 0.91719 0.00542104 0.398413 
vn 0.978411 0.00546304 0.206596 
vn 0.819438 0.00539646 0.573142 
vn 0.91719 0.00542104 0.398413 
vn 0.689224 0.00538975 0.724528 
vn 0.819438 0.00539646 0.573142 
vn 0.531462 0.00540101 0.847065 
vn 0.689224 0.00538975 0.724528 
vn 0.351847 0.00543006 0.936042 
vn 0.531462 0.00540101 0.847065 
vn 0.156818 0.00547636 0.987612 
vn 0.351847 0.00543006 0.936042 
vn -0.0464768 0.00553897 0.998904 
vn 0.0557305 0.0055057 0.998431 
vn 0.156818 0.00547636 0.987612 
vn -0.250222 0.00561645 0.968172 
vn -0.0464768 0.00553897 0.998904 
vn -0.446012 0.00570671 0.895009 
vn -0.250222 0.00561645 0.968172 
vn -0.625005 0.00580686 0.780599 
vn -0.446012 0.00570671 0.895009 
vn -0.77818 0.0059131 0.628013 
vn -0.625005 0.00580686 0.780599 
vn -0.896757 0.00602068 0.442482 
vn -0.77818 0.0059131 0.628013 
vn -0.972795 0.00612392 0.231588 
vn -0.896757 0.00602068 0.442482 
vn -0.999967 0.00621652 0.00525243 
vn -0.972795 0.00612392 0.231588 
vn -0.974433 0.0062921 -0.224588 
vn -0.999967 0.00621652 0.00525243 
vn -0.89565 0.00634487 -0.444714 
vn -0.974433 0.0062921 -0.224588 
vn -0.766895 0.00637048 -0.641741 
vn -0.89565 0.00634487 -0.444714 
vn -0.595299 0.00636673 -0.803479 
vn -0.766895 0.00637048 -0.641741 
vn -0.39128 0.00633394 -0.92025 
vn -0.595299 0.00636673 -0.803479 
vn -0.167458 0.00627491 -0.985859 
vn -0.39128 0.00633394 -0.92025 
vn 0.0592538 -0.996485 0.0592115 
vn 0.0557305 0.0055057 0.998431 
vn 0.255829 0.0054511 0.966707 
vn 0.444001 0.00541334 0.89601 
vn 0.613448 0.00539314 0.789716 
vn 0.758101 0.00539086 0.652115 
vn 0.872647 0.00540654 0.488322 
vn 0.952586 0.00543991 0.304221 
vn 0.994305 0.00549033 0.106432 
vn 0.995198 0.00555677 -0.0977258 
vn 0.953834 0.00563763 -0.30028 
vn 0.87018 0.00573062 -0.492701 
vn 0.745864 0.00583267 -0.666073 
vn 0.584472 0.00593973 -0.811392 
vn 0.391809 0.00604679 -0.920027 
vn 0.176051 0.006148 -0.984362 
vn -0.0523337 0.00623699 -0.99861 
vn 0.062702 0.00619443 -0.998013 
vn 0.176051 0.006148 -0.984362 
vn -0.0523337 0.00623699 -0.99861 
vn -0.281006 0.00630744 -0.959685 
vn -0.49659 0.00635384 -0.867962 
vn -0.685867 0.00637232 -0.727699 
vn -0.83716 0.00636127 -0.546922 
vn -0.941586 0.00632165 -0.336714 
vn -0.993908 0.00625683 -0.110037 
vn -0.992798 0.00617195 0.119645 
vn -0.940536 0.00607322 0.339638 
vn -0.842318 0.00596706 0.538948 
vn -0.70538 0.00585949 0.708805 
vn -0.538172 0.00575576 0.842815 
vn -0.349656 0.00566014 0.936861 
vn -0.148806 0.00557597 0.988851 
vn 0.0585704 0.996566 0.0585286 
usemtl 0.647059_0.647059_0.647059_0.000000_0.000000
o mesh264
f 10946//10590 10947//10591 10948//10591 
f 10949//10592 10946//10590 10950//10593 
f 10951//10594 10949//10592 10952//10595 
f 10953//10596 10951//10594 10954//10597 
f 10955//10598 10953//10596 10956//10599 
f 10957//10600 10955//10598 10958//10601 
f 10959//10602 10957//10600 10960//10603 
f 10961//10604 10959//10602 10962//10605 
f 10963//10606 10961//10604 10964//10607 
f 10965//10608 10963//10606 10966//10609 
f 10967//10610 10965//10608 10968//10611 
f 10969//10612 10967//10610 10970//10613 
f 10971//10614 10969//10612 10972//10615 
f 10973//10616 10971//10614 10974//10617 
f 10975//10618 10976//10619 10977//10619 
f 10978//10620 10977//10619 10976//10619 
f 10976//10619 10973//10616 10978//10620 
f 10979//10621 10975//10618 10980//10622 
f 10981//10623 10979//10621 10982//10624 
f 10983//10625 10981//10623 10984//10626 
f 10985//10627 10983//10625 10986//10628 
f 10987//10629 10985//10627 10988//10630 
f 10989//10631 10987//10629 10990//10632 
f 10991//10633 10989//10631 10992//10634 
f 10993//10635 10991//10633 10994//10636 
f 10995//10637 10993//10635 10996//10638 
f 10997//10639 10995//10637 10998//10640 
f 10999//10641 10997//10639 11000//10642 
f 11001//10643 10999//10641 11002//10644 
f 11003//10645 11001//10643 11004//10646 
f 10947//10591 11003//10645 11005//10645 
f 11005//10645 10948//10591 10947//10591 
f 11004//10646 11005//10645 11003//10645 
f 11002//10644 11004//10646 11001//10643 
f 11000//10642 11002//10644 10999//10641 
f 10998//10640 11000//10642 10997//10639 
f 10996//10638 10998//10640 10995//10637 
f 10994//10636 10996//10638 10993//10635 
f 10992//10634 10994//10636 10991//10633 
f 10990//10632 10992//10634 10989//10631 
f 10988//10630 10990//10632 10987//10629 
f 10986//10628 10988//10630 10985//10627 
f 10984//10626 10986//10628 10983//10625 
f 10982//10624 10984//10626 10981//10623 
f 10980//10622 10982//10624 10979//10621 
f 10977//10619 10980//10622 10975//10618 
f 10974//10617 10978//10620 10973//10616 
f 10972//10615 10974//10617 10971//10614 
f 10970//10613 10972//10615 10969//10612 
f 10968//10611 10970//10613 10967//10610 
f 10966//10609 10968//10611 10965//10608 
f 10964//10607 10966//10609 10963//10606 
f 10962//10605 10964//10607 10961//10604 
f 10960//10603 10962//10605 10959//10602 
f 10958//10601 10960//10603 10957//10600 
f 10956//10599 10958//10601 10955//10598 
f 10954//10597 10956//10599 10953//10596 
f 10952//10595 10954//10597 10951//10594 
f 10950//10593 10952//10595 10949//10592 
f 10948//10591 10950//10593 10946//10590 
o mesh265
f 11006//10647 11007//10647 11002//10647 
f 11007//10647 11008//10647 11004//10647 
f 11008//10647 11009//10647 11005//10647 
f 11009//10647 11010//10647 10948//10647 
f 11011//10647 10980//10647 10977//10647 
f 11012//10647 10982//10647 10980//10647 
f 11013//10647 10998//10647 10996//10647 
f 11013//10647 11006//10647 11000//10647 
f 11004//10647 11002//10647 11007//10647 
f 10948//10647 11005//10647 11009//10647 
f 11014//10647 10956//10647 10954//10647 
f 11014//10647 11015//10647 10958//10647 
f 11016//10647 10972//10647 10970//10647 
f 11017//10647 10974//10647 10972//10647 
f 11017//10647 11018//10647 10978//10647 
f 11019//10647 10977//10647 10978//10647 
f 10980//10647 11011//10647 11012//10647 
f 11020//10647 10984//10647 10982//10647 
f 11020//10647 11021//10647 10986//10647 
f 11021//10647 11022//10647 10988//10647 
f 11023//10647 10990//10647 10988//10647 
f 11023//10647 11024//10647 10992//10647 
f 11025//10647 10996//10647 10994//10647 
f 11000//10647 10998//10647 11013//10647 
f 11005//10647 11004//10647 11008//10647 
f 11010//10647 11026//10647 10950//10647 
f 11027//10647 10954//10647 10952//10647 
f 10958//10647 10956//10647 11014//10647 
f 11028//10647 10968//10647 10966//10647 
f 11028//10647 11029//10647 10970//10647 
f 10972//10647 11016//10647 11017//10647 
f 10978//10647 11018//10647 11019//10647 
f 10982//10647 11012//10647 11020//10647 
f 10988//10647 10986//10647 11021//10647 
f 10992//10647 10990//10647 11023//10647 
f 11024//10647 11030//10647 10994//10647 
f 10996//10647 11025//10647 11013//10647 
f 10950//10647 10948//10647 11010//10647 
f 11031//10647 10952//10647 10950//10647 
f 10954//10647 11027//10647 11014//10647 
f 11032//10647 10962//10647 10960//10647 
f 11032//10647 11033//10647 10964//10647 
f 10970//10647 10968//10647 11028//10647 
f 10978//10647 10974//10647 11017//10647 
f 10986//10647 10984//10647 11020//10647 
f 10994//10647 10992//10647 11024//10647 
f 11002//10647 11000//10647 11006//10647 
f 10952//10647 11031//10647 11027//10647 
f 11034//10647 10960//10647 10958//10647 
f 10964//10647 10962//10647 11032//10647 
f 11035//10647 10966//10647 10964//10647 
f 10970//10647 11029//10647 11016//10647 
f 10988//10647 11022//10647 11023//10647 
f 10950//10647 11026//10647 11031//10647 
f 10960//10647 11034//10647 11032//10647 
f 10966//10647 11035//10647 11028//10647 
f 10994//10647 11030//10647 11025//10647 
f 10964//10647 11033//10647 11035//10647 
f 10958//10647 11015//10647 11034//10647 
f 10977//10647 11019//10647 11011//10647 
o mesh266
f 11036//10648 11010//10648 11009//10649 
f 11037//10649 11009//10649 11008//10650 
f 11038//10650 11008//10650 11007//10651 
f 11039//10651 11007//10651 11006//10652 
f 11040//10652 11006//10652 11013//10653 
f 11041//10653 11013//10653 11025//10654 
f 11042//10654 11025//10654 11030//10655 
f 11043//10655 11030//10655 11024//10656 
f 11044//10656 11024//10656 11023//10657 
f 11045//10657 11023//10657 11022//10658 
f 11046//10658 11022//10658 11021//10659 
f 11047//10659 11021//10659 11020//10660 
f 11048//10660 11020//10660 11012//10661 
f 11049//10661 11012//10661 11011//10662 
f 11050//10663 11051//10664 11019//10664 
f 11011//10662 11019//10664 11051//10664 
f 11051//10664 11052//10665 11011//10662 
f 11050//10663 11018//10666 11017//10667 
f 11053//10667 11017//10667 11016//10668 
f 11054//10668 11016//10668 11029//10669 
f 11055//10669 11029//10669 11028//10670 
f 11056//10670 11028//10670 11035//10671 
f 11057//10671 11035//10671 11033//10672 
f 11058//10672 11033//10672 11032//10673 
f 11059//10673 11032//10673 11034//10674 
f 11060//10674 11034//10674 11015//10675 
f 11061//10675 11015//10675 11014//10676 
f 11062//10676 11014//10676 11027//10677 
f 11063//10677 11027//10677 11031//10678 
f 11064//10678 11031//10678 11026//10679 
f 11065//10679 11026//10679 11010//10648 
f 11010//10648 11036//10648 11065//10679 
f 11026//10679 11065//10679 11064//10678 
f 11031//10678 11064//10678 11063//10677 
f 11027//10677 11063//10677 11062//10676 
f 11014//10676 11062//10676 11061//10675 
f 11015//10675 11061//10675 11060//10674 
f 11034//10674 11060//10674 11059//10673 
f 11032//10673 11059//10673 11058//10672 
f 11033//10672 11058//10672 11057//10671 
f 11035//10671 11057//10671 11056//10670 
f 11028//10670 11056//10670 11055//10669 
f 11029//10669 11055//10669 11054//10668 
f 11016//10668 11054//10668 11053//10667 
f 11017//10667 11053//10667 11050//10663 
f 11019//10664 11018//10666 11050//10663 
f 11011//10662 11052//10665 11049//10661 
f 11012//10661 11049//10661 11048//10660 
f 11020//10660 11048//10660 11047//10659 
f 11021//10659 11047//10659 11046//10658 
f 11022//10658 11046//10658 11045//10657 
f 11023//10657 11045//10657 11044//10656 
f 11024//10656 11044//10656 11043//10655 
f 11030//10655 11043//10655 11042//10654 
f 11025//10654 11042//10654 11041//10653 
f 11013//10653 11041//10653 11040//10652 
f 11006//10652 11040//10652 11039//10651 
f 11007//10651 11039//10651 11038//10650 
f 11008//10650 11038//10650 11037//10649 
f 11009//10649 11037//10649 11036//10648 
o mesh267
f 11052//10680 11051//10680 10976//10680 
f 11051//10680 11050//10680 10973//10680 
f 11049//10680 11052//10680 10975//10680 
f 10973//10680 10976//10680 11051//10680 
f 11037//10680 11003//10680 10947//10680 
f 11038//10680 11001//10680 11003//10680 
f 10976//10680 10975//10680 11052//10680 
f 11053//10680 10971//10680 10973//10680 
f 11003//10680 11037//10680 11038//10680 
f 11039//10680 10999//10680 11001//10680 
f 11041//10680 10995//10680 10997//10680 
f 11041//10680 11042//10680 10993//10680 
f 11048//10680 11049//10680 10979//10680 
f 10973//10680 11050//10680 11053//10680 
f 11053//10680 11054//10680 10969//10680 
f 11054//10680 11055//10680 10967//10680 
f 11001//10680 11038//10680 11039//10680 
f 11040//10680 10997//10680 10999//10680 
f 10993//10680 10995//10680 11041//10680 
f 11042//10680 11043//10680 10991//10680 
f 11045//10680 10987//10680 10989//10680 
f 11045//10680 11046//10680 10985//10680 
f 11047//10680 10983//10680 10985//10680 
f 11047//10680 11048//10680 10981//10680 
f 10975//10680 10979//10680 11049//10680 
f 10967//10680 10969//10680 11054//10680 
f 10999//10680 11039//10680 11040//10680 
f 10991//10680 10993//10680 11042//10680 
f 11044//10680 10989//10680 10991//10680 
f 10985//10680 10987//10680 11045//10680 
f 10981//10680 10983//10680 11047//10680 
f 10969//10680 10971//10680 11053//10680 
f 11056//10680 10965//10680 10967//10680 
f 11056//10680 11057//10680 10963//10680 
f 10997//10680 11040//10680 11041//10680 
f 10989//10680 11044//10680 11045//10680 
f 10979//10680 10981//10680 11048//10680 
f 10963//10680 10965//10680 11056//10680 
f 11062//10680 10953//10680 10955//10680 
f 11062//10680 11063//10680 10951//10680 
f 10991//10680 11043//10680 11044//10680 
f 10967//10680 11055//10680 11056//10680 
f 11059//10680 10959//10680 10961//10680 
f 11059//10680 11060//10680 10957//10680 
f 10951//10680 10953//10680 11062//10680 
f 11063//10680 11064//10680 10949//10680 
f 10985//10680 11046//10680 11047//10680 
f 11057//10680 11058//10680 10961//10680 
f 10957//10680 10959//10680 11059//10680 
f 11060//10680 11061//10680 10955//10680 
f 10949//10680 10951//10680 11063//10680 
f 11064//10680 11065//10680 10946//10680 
f 10961//10680 10963//10680 11057//10680 
f 10955//10680 10957//10680 11060//10680 
f 10946//10680 10949//10680 11064//10680 
f 11036//10680 10947//10680 10946//10680 
f 10961//10680 11058//10680 11059//10680 
f 10946//10680 11065//10680 11036//10680 
f 10955//10680 11061//10680 11062//10680 
f 10947//10680 11036//10680 11037//10680 
g 1mmSpacer
v 0.0964706 0.00584011 -0.0259968 
v 0.0971155 0.00584011 -0.0259267 
v 0.0971155 0.00484011 -0.0259267 
v 0.0958558 0.00584011 -0.026204 
v 0.0964706 0.00484011 -0.0259968 
v 0.0953 0.00584011 -0.0265384 
v 0.0958558 0.00484011 -0.026204 
v 0.094829 0.00584011 -0.0269845 
v 0.0953 0.00484011 -0.0265384 
v 0.0944649 0.00584011 -0.0275215 
v 0.094829 0.00484011 -0.0269845 
v 0.0942248 0.00584011 -0.0281241 
v 0.0944649 0.00484011 -0.0275215 
v 0.0941199 0.00584011 -0.0287643 
v 0.0942248 0.00484011 -0.0281241 
v 0.094155 0.00584011 -0.029412 
v 0.0941199 0.00484011 -0.0287643 
v 0.0943285 0.00584011 -0.0300371 
v 0.094155 0.00484011 -0.029412 
v 0.0946324 0.00584011 -0.0306103 
v 0.0943285 0.00484011 -0.0300371 
v 0.0950524 0.00584011 -0.0311047 
v 0.0946324 0.00484011 -0.0306103 
v 0.0955688 0.00584011 -0.0314973 
v 0.0950524 0.00484011 -0.0311047 
v 0.0961576 0.00584011 -0.0317697 
v 0.0955688 0.00484011 -0.0314973 
v 0.0967911 0.00584011 -0.0319091 
v 0.0961576 0.00484011 -0.0317697 
v 0.0974398 0.00584011 -0.0319091 
v 0.0971155 0.00584011 -0.0319267 
v 0.0971155 0.00484011 -0.0319267 
v 0.0967911 0.00484011 -0.0319091 
v 0.0980734 0.00584011 -0.0317697 
v 0.0974398 0.00484011 -0.0319091 
v 0.0986621 0.00584011 -0.0314973 
v 0.0980734 0.00484011 -0.0317697 
v 0.0991786 0.00584011 -0.0311047 
v 0.0986621 0.00484011 -0.0314973 
v 0.0995985 0.00584011 -0.0306103 
v 0.0991786 0.00484011 -0.0311047 
v 0.0999024 0.00584011 -0.0300371 
v 0.0995985 0.00484011 -0.0306103 
v 0.100076 0.00584011 -0.029412 
v 0.0999024 0.00484011 -0.0300371 
v 0.100111 0.00584011 -0.0287643 
v 0.100076 0.00484011 -0.029412 
v 0.100006 0.00584011 -0.0281241 
v 0.100111 0.00484011 -0.0287643 
v 0.099766 0.00584011 -0.0275215 
v 0.100006 0.00484011 -0.0281241 
v 0.099402 0.00584011 -0.0269845 
v 0.099766 0.00484011 -0.0275215 
v 0.098931 0.00584011 -0.0265384 
v 0.099402 0.00484011 -0.0269845 
v 0.0983751 0.00584011 -0.026204 
v 0.098931 0.00484011 -0.0265384 
v 0.0977604 0.00584011 -0.0259968 
v 0.0983751 0.00484011 -0.026204 
v 0.0977604 0.00484011 -0.0259968 
v 0.100164 0.00484011 -0.0263372 
v 0.0995362 0.00484011 -0.0257423 
v 0.098795 0.00484011 -0.0252964 
v 0.0979754 0.00484011 -0.0250202 
v 0.0971155 0.00484011 -0.0249267 
v 0.097548 0.00484011 -0.0329033 
v 0.0983927 0.00484011 -0.0327173 
v 0.10065 0.00484011 -0.0270531 
v 0.0940668 0.00484011 -0.0263372 
v 0.0935814 0.00484011 -0.0270531 
v 0.0950533 0.00484011 -0.0323541 
v 0.0958383 0.00484011 -0.0327173 
v 0.096683 0.00484011 -0.0329033 
v 0.0971155 0.00484011 -0.0329267 
v 0.0991777 0.00484011 -0.0323541 
v 0.0998663 0.00484011 -0.0318307 
v 0.100426 0.00484011 -0.0311715 
v 0.100831 0.00484011 -0.0304073 
v 0.101063 0.00484011 -0.0295738 
v 0.10097 0.00484011 -0.0278566 
v 0.0962556 0.00484011 -0.0250202 
v 0.0946948 0.00484011 -0.0257423 
v 0.0938047 0.00484011 -0.0311715 
v 0.0943647 0.00484011 -0.0318307 
v 0.10111 0.00484011 -0.0287101 
v 0.0954359 0.00484011 -0.0252964 
v 0.0931213 0.00484011 -0.0287101 
v 0.0931682 0.00484011 -0.0295738 
v 0.0932613 0.00484011 -0.0278566 
v 0.0933996 0.00484011 -0.0304073 
v 0.0971155 0.00584011 -0.0249267 
v 0.0979754 0.00584011 -0.0250202 
v 0.098795 0.00584011 -0.0252964 
v 0.0995362 0.00584011 -0.0257423 
v 0.100164 0.00584011 -0.0263372 
v 0.10065 0.00584011 -0.0270531 
v 0.10097 0.00584011 -0.0278566 
v 0.10111 0.00584011 -0.0287101 
v 0.101063 0.00584011 -0.0295738 
v 0.100831 0.00584011 -0.0304073 
v 0.100426 0.00584011 -0.0311715 
v 0.0998663 0.00584011 -0.0318307 
v 0.0991777 0.00584011 -0.0323541 
v 0.0983927 0.00584011 -0.0327173 
v 0.096683 0.00584011 -0.0329033 
v 0.0971155 0.00584011 -0.0329267 
v 0.097548 0.00584011 -0.0329033 
v 0.0958383 0.00584011 -0.0327173 
v 0.0950533 0.00584011 -0.0323541 
v 0.0943647 0.00584011 -0.0318307 
v 0.0938047 0.00584011 -0.0311715 
v 0.0933996 0.00584011 -0.0304073 
v 0.0931682 0.00584011 -0.0295738 
v 0.0931213 0.00584011 -0.0287101 
v 0.0932613 0.00584011 -0.0278566 
v 0.0935814 0.00584011 -0.0270531 
v 0.0940668 0.00584011 -0.0263372 
v 0.0946948 0.00584011 -0.0257423 
v 0.0954359 0.00584011 -0.0252964 
v 0.0962556 0.00584011 -0.0250202 
vn 0.322067 0.00549833 -0.946701 
vn 0.122608 0.00563301 -0.992439 
vn 0.504353 0.00538474 -0.863481 
vn 0.322067 0.00549833 -0.946701 
vn 0.663817 0.00529403 -0.747876 
vn 0.504353 0.00538474 -0.863481 
vn 0.795952 0.00522722 -0.605337 
vn 0.663817 0.00529403 -0.747876 
vn 0.897231 0.00518482 -0.441532 
vn 0.795952 0.00522722 -0.605337 
vn 0.964975 0.00516708 -0.262291 
vn 0.897231 0.00518482 -0.441532 
vn 0.997275 0.00517408 -0.0735924 
vn 0.964975 0.00516708 -0.262291 
vn 0.992949 0.00520577 0.118425 
vn 0.997275 0.00517408 -0.0735924 
vn 0.951554 0.00526202 0.307436 
vn 0.992949 0.00520577 0.118425 
vn 0.87344 0.00534244 0.486903 
vn 0.951554 0.00526202 0.307436 
vn 0.759864 0.00544625 0.650059 
vn 0.87344 0.00534244 0.486903 
vn 0.613172 0.00557206 0.78993 
vn 0.759864 0.00544625 0.650059 
vn 0.437038 0.00571741 0.899425 
vn 0.613172 0.00557206 0.78993 
vn 0.236778 0.00587844 0.971546 
vn 0.437038 0.00571741 0.899425 
vn 0.019677 0.00604932 0.999788 
vn 0.129792 0.00596309 0.991523 
vn 0.236778 0.00587844 0.971546 
vn -0.204751 0.00622194 0.978794 
vn 0.019677 0.00604932 0.999788 
vn -0.424735 0.00638583 0.905295 
vn -0.204751 0.00622194 0.978794 
vn -0.626676 0.00652865 0.779252 
vn -0.424735 0.00638583 0.905295 
vn -0.796241 0.00663761 0.604943 
vn -0.626676 0.00652865 0.779252 
vn -0.920136 0.00670153 0.39154 
vn -0.796241 0.00663761 0.604943 
vn -0.988247 0.00671326 0.152719 
vn -0.920136 0.00670153 0.39154 
vn -0.995465 0.00667145 -0.0948901 
vn -0.988247 0.00671326 0.152719 
vn -0.94253 0.00658088 -0.334058 
vn -0.995465 0.00667145 -0.0948901 
vn -0.835549 0.00645124 -0.549378 
vn -0.94253 0.00658088 -0.334058 
vn -0.684503 0.00629492 -0.728983 
vn -0.835549 0.00645124 -0.549378 
vn -0.501353 0.00612468 -0.865221 
vn -0.684503 0.00629492 -0.728983 
vn -0.298378 0.0059519 -0.954429 
vn -0.501353 0.00612468 -0.865221 
vn -0.0870373 0.00578575 -0.996188 
vn -0.298378 0.0059519 -0.954429 
vn 0.126777 -0.991512 -0.0288496 
vn 0.129792 0.00596309 0.991523 
vn 0.339519 0.00579628 0.940581 
vn 0.528495 0.00564249 0.848917 
vn 0.690463 0.00550653 0.723347 
vn 0.820966 0.00539149 0.570952 
vn 0.917031 0.00529924 0.39878 
vn 0.976883 0.00523085 0.21371 
vn 0.999736 0.00518684 0.022392 
vn 0.985646 0.00516749 -0.168744 
vn 0.935431 0.00517286 -0.353471 
vn 0.850634 0.00520295 -0.525732 
vn 0.733542 0.00525759 -0.679623 
vn 0.587244 0.00533644 -0.809392 
vn 0.415739 0.00543877 -0.909468 
vn 0.224081 0.00556319 -0.974555 
vn 0.0185647 0.00570737 -0.999811 
vn 0.122608 0.00563301 -0.992439 
vn 0.224081 0.00556319 -0.974555 
vn 0.0185647 0.00570737 -0.999811 
vn -0.193088 0.00586752 -0.981164 
vn -0.401599 0.00603798 -0.915796 
vn -0.596165 0.00621079 -0.802838 
vn -0.764811 0.0063756 -0.644223 
vn -0.89524 0.0065202 -0.445537 
vn -0.976247 0.00663175 -0.21656 
vn -0.999559 0.00669889 0.0289196 
vn -0.961617 0.00671415 0.274311 
vn -0.864629 0.00667576 0.502367 
vn -0.716385 0.00658813 0.697674 
vn -0.528858 0.00646068 0.848686 
vn -0.316115 0.00630572 0.9487 
vn -0.0923064 0.00613601 0.995712 
vn 0.125329 0.991705 -0.0285202 
o mesh264
f 11066//10681 11067//10682 11068//10682 
f 11069//10683 11066//10681 11070//10684 
f 11071//10685 11069//10683 11072//10686 
f 11073//10687 11071//10685 11074//10688 
f 11075//10689 11073//10687 11076//10690 
f 11077//10691 11075//10689 11078//10692 
f 11079//10693 11077//10691 11080//10694 
f 11081//10695 11079//10693 11082//10696 
f 11083//10697 11081//10695 11084//10698 
f 11085//10699 11083//10697 11086//10700 
f 11087//10701 11085//10699 11088//10702 
f 11089//10703 11087//10701 11090//10704 
f 11091//10705 11089//10703 11092//10706 
f 11093//10707 11091//10705 11094//10708 
f 11095//10709 11096//10710 11097//10710 
f 11098//10711 11097//10710 11096//10710 
f 11096//10710 11093//10707 11098//10711 
f 11099//10712 11095//10709 11100//10713 
f 11101//10714 11099//10712 11102//10715 
f 11103//10716 11101//10714 11104//10717 
f 11105//10718 11103//10716 11106//10719 
f 11107//10720 11105//10718 11108//10721 
f 11109//10722 11107//10720 11110//10723 
f 11111//10724 11109//10722 11112//10725 
f 11113//10726 11111//10724 11114//10727 
f 11115//10728 11113//10726 11116//10729 
f 11117//10730 11115//10728 11118//10731 
f 11119//10732 11117//10730 11120//10733 
f 11121//10734 11119//10732 11122//10735 
f 11123//10736 11121//10734 11124//10737 
f 11067//10682 11123//10736 11125//10736 
f 11125//10736 11068//10682 11067//10682 
f 11124//10737 11125//10736 11123//10736 
f 11122//10735 11124//10737 11121//10734 
f 11120//10733 11122//10735 11119//10732 
f 11118//10731 11120//10733 11117//10730 
f 11116//10729 11118//10731 11115//10728 
f 11114//10727 11116//10729 11113//10726 
f 11112//10725 11114//10727 11111//10724 
f 11110//10723 11112//10725 11109//10722 
f 11108//10721 11110//10723 11107//10720 
f 11106//10719 11108//10721 11105//10718 
f 11104//10717 11106//10719 11103//10716 
f 11102//10715 11104//10717 11101//10714 
f 11100//10713 11102//10715 11099//10712 
f 11097//10710 11100//10713 11095//10709 
f 11094//10708 11098//10711 11093//10707 
f 11092//10706 11094//10708 11091//10705 
f 11090//10704 11092//10706 11089//10703 
f 11088//10702 11090//10704 11087//10701 
f 11086//10700 11088//10702 11085//10699 
f 11084//10698 11086//10700 11083//10697 
f 11082//10696 11084//10698 11081//10695 
f 11080//10694 11082//10696 11079//10693 
f 11078//10692 11080//10694 11077//10691 
f 11076//10690 11078//10692 11075//10689 
f 11074//10688 11076//10690 11073//10687 
f 11072//10686 11074//10688 11071//10685 
f 11070//10684 11072//10686 11069//10683 
f 11068//10682 11070//10684 11066//10681 
o mesh265
f 11126//10738 11127//10738 11122//10738 
f 11127//10738 11128//10738 11124//10738 
f 11128//10738 11129//10738 11125//10738 
f 11129//10738 11130//10738 11068//10738 
f 11131//10738 11100//10738 11097//10738 
f 11132//10738 11102//10738 11100//10738 
f 11133//10738 11118//10738 11116//10738 
f 11133//10738 11126//10738 11120//10738 
f 11124//10738 11122//10738 11127//10738 
f 11068//10738 11125//10738 11129//10738 
f 11134//10738 11076//10738 11074//10738 
f 11134//10738 11135//10738 11078//10738 
f 11136//10738 11092//10738 11090//10738 
f 11137//10738 11094//10738 11092//10738 
f 11137//10738 11138//10738 11098//10738 
f 11139//10738 11097//10738 11098//10738 
f 11100//10738 11131//10738 11132//10738 
f 11140//10738 11104//10738 11102//10738 
f 11140//10738 11141//10738 11106//10738 
f 11141//10738 11142//10738 11108//10738 
f 11143//10738 11110//10738 11108//10738 
f 11143//10738 11144//10738 11112//10738 
f 11145//10738 11116//10738 11114//10738 
f 11120//10738 11118//10738 11133//10738 
f 11125//10738 11124//10738 11128//10738 
f 11130//10738 11146//10738 11070//10738 
f 11147//10738 11074//10738 11072//10738 
f 11078//10738 11076//10738 11134//10738 
f 11148//10738 11088//10738 11086//10738 
f 11148//10738 11149//10738 11090//10738 
f 11092//10738 11136//10738 11137//10738 
f 11098//10738 11138//10738 11139//10738 
f 11102//10738 11132//10738 11140//10738 
f 11108//10738 11106//10738 11141//10738 
f 11112//10738 11110//10738 11143//10738 
f 11144//10738 11150//10738 11114//10738 
f 11116//10738 11145//10738 11133//10738 
f 11070//10738 11068//10738 11130//10738 
f 11151//10738 11072//10738 11070//10738 
f 11074//10738 11147//10738 11134//10738 
f 11152//10738 11082//10738 11080//10738 
f 11152//10738 11153//10738 11084//10738 
f 11090//10738 11088//10738 11148//10738 
f 11098//10738 11094//10738 11137//10738 
f 11106//10738 11104//10738 11140//10738 
f 11114//10738 11112//10738 11144//10738 
f 11122//10738 11120//10738 11126//10738 
f 11072//10738 11151//10738 11147//10738 
f 11154//10738 11080//10738 11078//10738 
f 11084//10738 11082//10738 11152//10738 
f 11155//10738 11086//10738 11084//10738 
f 11090//10738 11149//10738 11136//10738 
f 11108//10738 11142//10738 11143//10738 
f 11070//10738 11146//10738 11151//10738 
f 11080//10738 11154//10738 11152//10738 
f 11086//10738 11155//10738 11148//10738 
f 11114//10738 11150//10738 11145//10738 
f 11084//10738 11153//10738 11155//10738 
f 11078//10738 11135//10738 11154//10738 
f 11097//10738 11139//10738 11131//10738 
o mesh266
f 11156//10739 11130//10739 11129//10740 
f 11157//10740 11129//10740 11128//10741 
f 11158//10741 11128//10741 11127//10742 
f 11159//10742 11127//10742 11126//10743 
f 11160//10743 11126//10743 11133//10744 
f 11161//10744 11133//10744 11145//10745 
f 11162//10745 11145//10745 11150//10746 
f 11163//10746 11150//10746 11144//10747 
f 11164//10747 11144//10747 11143//10748 
f 11165//10748 11143//10748 11142//10749 
f 11166//10749 11142//10749 11141//10750 
f 11167//10750 11141//10750 11140//10751 
f 11168//10751 11140//10751 11132//10752 
f 11169//10752 11132//10752 11131//10753 
f 11170//10754 11171//10755 11139//10755 
f 11131//10753 11139//10755 11171//10755 
f 11171//10755 11172//10756 11131//10753 
f 11170//10754 11138//10757 11137//10758 
f 11173//10758 11137//10758 11136//10759 
f 11174//10759 11136//10759 11149//10760 
f 11175//10760 11149//10760 11148//10761 
f 11176//10761 11148//10761 11155//10762 
f 11177//10762 11155//10762 11153//10763 
f 11178//10763 11153//10763 11152//10764 
f 11179//10764 11152//10764 11154//10765 
f 11180//10765 11154//10765 11135//10766 
f 11181//10766 11135//10766 11134//10767 
f 11182//10767 11134//10767 11147//10768 
f 11183//10768 11147//10768 11151//10769 
f 11184//10769 11151//10769 11146//10770 
f 11185//10770 11146//10770 11130//10739 
f 11130//10739 11156//10739 11185//10770 
f 11146//10770 11185//10770 11184//10769 
f 11151//10769 11184//10769 11183//10768 
f 11147//10768 11183//10768 11182//10767 
f 11134//10767 11182//10767 11181//10766 
f 11135//10766 11181//10766 11180//10765 
f 11154//10765 11180//10765 11179//10764 
f 11152//10764 11179//10764 11178//10763 
f 11153//10763 11178//10763 11177//10762 
f 11155//10762 11177//10762 11176//10761 
f 11148//10761 11176//10761 11175//10760 
f 11149//10760 11175//10760 11174//10759 
f 11136//10759 11174//10759 11173//10758 
f 11137//10758 11173//10758 11170//10754 
f 11139//10755 11138//10757 11170//10754 
f 11131//10753 11172//10756 11169//10752 
f 11132//10752 11169//10752 11168//10751 
f 11140//10751 11168//10751 11167//10750 
f 11141//10750 11167//10750 11166//10749 
f 11142//10749 11166//10749 11165//10748 
f 11143//10748 11165//10748 11164//10747 
f 11144//10747 11164//10747 11163//10746 
f 11150//10746 11163//10746 11162//10745 
f 11145//10745 11162//10745 11161//10744 
f 11133//10744 11161//10744 11160//10743 
f 11126//10743 11160//10743 11159//10742 
f 11127//10742 11159//10742 11158//10741 
f 11128//10741 11158//10741 11157//10740 
f 11129//10740 11157//10740 11156//10739 
o mesh267
f 11172//10771 11171//10771 11096//10771 
f 11171//10771 11170//10771 11093//10771 
f 11169//10771 11172//10771 11095//10771 
f 11093//10771 11096//10771 11171//10771 
f 11157//10771 11123//10771 11067//10771 
f 11158//10771 11121//10771 11123//10771 
f 11096//10771 11095//10771 11172//10771 
f 11173//10771 11091//10771 11093//10771 
f 11123//10771 11157//10771 11158//10771 
f 11159//10771 11119//10771 11121//10771 
f 11161//10771 11115//10771 11117//10771 
f 11161//10771 11162//10771 11113//10771 
f 11168//10771 11169//10771 11099//10771 
f 11093//10771 11170//10771 11173//10771 
f 11173//10771 11174//10771 11089//10771 
f 11174//10771 11175//10771 11087//10771 
f 11121//10771 11158//10771 11159//10771 
f 11160//10771 11117//10771 11119//10771 
f 11113//10771 11115//10771 11161//10771 
f 11162//10771 11163//10771 11111//10771 
f 11165//10771 11107//10771 11109//10771 
f 11165//10771 11166//10771 11105//10771 
f 11167//10771 11103//10771 11105//10771 
f 11167//10771 11168//10771 11101//10771 
f 11095//10771 11099//10771 11169//10771 
f 11087//10771 11089//10771 11174//10771 
f 11119//10771 11159//10771 11160//10771 
f 11111//10771 11113//10771 11162//10771 
f 11164//10771 11109//10771 11111//10771 
f 11105//10771 11107//10771 11165//10771 
f 11101//10771 11103//10771 11167//10771 
f 11089//10771 11091//10771 11173//10771 
f 11176//10771 11085//10771 11087//10771 
f 11176//10771 11177//10771 11083//10771 
f 11117//10771 11160//10771 11161//10771 
f 11109//10771 11164//10771 11165//10771 
f 11099//10771 11101//10771 11168//10771 
f 11083//10771 11085//10771 11176//10771 
f 11182//10771 11073//10771 11075//10771 
f 11182//10771 11183//10771 11071//10771 
f 11111//10771 11163//10771 11164//10771 
f 11087//10771 11175//10771 11176//10771 
f 11179//10771 11079//10771 11081//10771 
f 11179//10771 11180//10771 11077//10771 
f 11071//10771 11073//10771 11182//10771 
f 11183//10771 11184//10771 11069//10771 
f 11105//10771 11166//10771 11167//10771 
f 11177//10771 11178//10771 11081//10771 
f 11077//10771 11079//10771 11179//10771 
f 11180//10771 11181//10771 11075//10771 
f 11069//10771 11071//10771 11183//10771 
f 11184//10771 11185//10771 11066//10771 
f 11081//10771 11083//10771 11177//10771 
f 11075//10771 11077//10771 11180//10771 
f 11066//10771 11069//10771 11184//10771 
f 11156//10771 11067//10771 11066//10771 
f 11081//10771 11178//10771 11179//10771 
f 11066//10771 11185//10771 11156//10771 
f 11075//10771 11181//10771 11182//10771 
f 11067//10771 11156//10771 11157//10771 
g 6mmSpacer
v 0.161396 -0.00882196 -0.0906911 
v 0.161337 -0.00935938 -0.0906911 
v 0.161337 -0.00935938 -0.0966911 
v 0.161568 -0.00830966 -0.0906911 
v 0.161396 -0.00882196 -0.0966911 
v 0.161847 -0.00784645 -0.0906911 
v 0.161568 -0.00830966 -0.0966911 
v 0.162219 -0.00745398 -0.0906911 
v 0.161847 -0.00784645 -0.0966911 
v 0.162666 -0.0071506 -0.0906911 
v 0.162219 -0.00745398 -0.0966911 
v 0.163169 -0.00695051 -0.0906911 
v 0.162666 -0.0071506 -0.0966911 
v 0.163702 -0.00686305 -0.0906911 
v 0.163169 -0.00695051 -0.0966911 
v 0.164242 -0.00689231 -0.0906911 
v 0.163702 -0.00686305 -0.0966911 
v 0.164763 -0.00703694 -0.0906911 
v 0.164242 -0.00689231 -0.0966911 
v 0.16524 -0.00729016 -0.0906911 
v 0.164763 -0.00703694 -0.0966911 
v 0.165652 -0.00764013 -0.0906911 
v 0.16524 -0.00729016 -0.0966911 
v 0.165979 -0.0080705 -0.0906911 
v 0.165652 -0.00764013 -0.0966911 
v 0.166206 -0.00856113 -0.0906911 
v 0.165979 -0.0080705 -0.0966911 
v 0.166323 -0.00908908 -0.0906911 
v 0.166206 -0.00856113 -0.0966911 
v 0.166323 -0.00962968 -0.0966911 
v 0.166323 -0.00962968 -0.0906911 
v 0.166337 -0.00935938 -0.0906911 
v 0.166323 -0.00908908 -0.0966911 
v 0.166337 -0.00935938 -0.0966911 
v 0.166206 -0.0101576 -0.0906911 
v 0.165979 -0.0106483 -0.0906911 
v 0.166206 -0.0101576 -0.0966911 
v 0.165652 -0.0110786 -0.0906911 
v 0.165979 -0.0106483 -0.0966911 
v 0.16524 -0.0114286 -0.0906911 
v 0.165652 -0.0110786 -0.0966911 
v 0.164763 -0.0116818 -0.0906911 
v 0.16524 -0.0114286 -0.0966911 
v 0.164242 -0.0118264 -0.0906911 
v 0.164763 -0.0116818 -0.0966911 
v 0.163702 -0.0118557 -0.0906911 
v 0.164242 -0.0118264 -0.0966911 
v 0.163169 -0.0117683 -0.0906911 
v 0.163702 -0.0118557 -0.0966911 
v 0.162666 -0.0115682 -0.0906911 
v 0.163169 -0.0117683 -0.0966911 
v 0.162219 -0.0112648 -0.0906911 
v 0.162666 -0.0115682 -0.0966911 
v 0.161847 -0.0108723 -0.0906911 
v 0.162219 -0.0112648 -0.0966911 
v 0.161568 -0.0104091 -0.0906911 
v 0.161847 -0.0108723 -0.0966911 
v 0.161396 -0.00989681 -0.0906911 
v 0.161568 -0.0104091 -0.0966911 
v 0.161396 -0.00989681 -0.0966911 
v 0.166082 -0.0126701 -0.0966911 
v 0.165318 -0.0130753 -0.0966911 
v 0.164484 -0.0133067 -0.0966911 
v 0.163621 -0.0133535 -0.0966911 
v 0.165318 -0.00564347 -0.0966911 
v 0.166082 -0.00604863 -0.0966911 
v 0.166741 -0.00660858 -0.0966911 
v 0.162767 -0.0132136 -0.0966911 
v 0.161964 -0.0128934 -0.0966911 
v 0.161248 -0.012408 -0.0966911 
v 0.160653 -0.00693868 -0.0966911 
v 0.161248 -0.00631073 -0.0966911 
v 0.161964 -0.00582533 -0.0966911 
v 0.162767 -0.00550518 -0.0966911 
v 0.163621 -0.00536525 -0.0966911 
v 0.160207 -0.0110389 -0.0966911 
v 0.159931 -0.0102193 -0.0966911 
v 0.164484 -0.00541208 -0.0966911 
v 0.167265 -0.00729717 -0.0966911 
v 0.167628 -0.00808218 -0.0966911 
v 0.167814 -0.00892691 -0.0966911 
v 0.167837 -0.00935938 -0.0966911 
v 0.167814 -0.00979186 -0.0966911 
v 0.167628 -0.0106366 -0.0966911 
v 0.167265 -0.0114216 -0.0966911 
v 0.166741 -0.0121102 -0.0966911 
v 0.160653 -0.0117801 -0.0966911 
v 0.159837 -0.00935938 -0.0966911 
v 0.160207 -0.00767982 -0.0966911 
v 0.159931 -0.0084995 -0.0966911 
v 0.159837 -0.00935938 -0.0906911 
v 0.159931 -0.0102193 -0.0906911 
v 0.160207 -0.0110389 -0.0906911 
v 0.160653 -0.0117801 -0.0906911 
v 0.161248 -0.012408 -0.0906911 
v 0.161964 -0.0128934 -0.0906911 
v 0.162767 -0.0132136 -0.0906911 
v 0.163621 -0.0133535 -0.0906911 
v 0.164484 -0.0133067 -0.0906911 
v 0.165318 -0.0130753 -0.0906911 
v 0.166082 -0.0126701 -0.0906911 
v 0.166741 -0.0121102 -0.0906911 
v 0.167265 -0.0114216 -0.0906911 
v 0.167628 -0.0106366 -0.0906911 
v 0.167814 -0.00892691 -0.0906911 
v 0.167837 -0.00935938 -0.0906911 
v 0.167814 -0.00979186 -0.0906911 
v 0.167628 -0.00808218 -0.0906911 
v 0.167265 -0.00729717 -0.0906911 
v 0.166741 -0.00660858 -0.0906911 
v 0.166082 -0.00604863 -0.0906911 
v 0.165318 -0.00564347 -0.0906911 
v 0.164484 -0.00541208 -0.0906911 
v 0.163621 -0.00536525 -0.0906911 
v 0.162767 -0.00550518 -0.0906911 
v 0.161964 -0.00582533 -0.0906911 
v 0.161248 -0.00631073 -0.0906911 
v 0.160653 -0.00693868 -0.0906911 
v 0.160207 -0.00767982 -0.0906911 
v 0.159931 -0.0084995 -0.0906911 
vn 0.979512 -0.186707 -0.0754811 
vn 0.997127 -0.00777533 -0.0753419 
vn 0.929748 -0.360243 -0.0761117 
vn 0.979512 -0.186707 -0.0754811 
vn 0.848586 -0.523388 -0.0772402 
vn 0.929748 -0.360243 -0.0761117 
vn 0.737234 -0.671017 -0.078877 
vn 0.848586 -0.523388 -0.0772402 
vn 0.597469 -0.797787 -0.0810332 
vn 0.737234 -0.671017 -0.078877 
vn 0.431813 -0.89807 -0.0837148 
vn 0.597469 -0.797787 -0.0810332 
vn 0.243814 -0.96592 -0.0869143 
vn 0.431813 -0.89807 -0.0837148 
vn 0.0384476 -0.995145 -0.0905964 
vn 0.243814 -0.96592 -0.0869143 
vn -0.177336 -0.979586 -0.0946779 
vn 0.0384476 -0.995145 -0.0905964 
vn -0.393996 -0.913765 -0.099003 
vn -0.177336 -0.979586 -0.0946779 
vn -0.598924 -0.794113 -0.103318 
vn -0.393996 -0.913765 -0.099003 
vn -0.776569 -0.620834 -0.107264 
vn -0.598924 -0.794113 -0.103318 
vn -0.909804 -0.400085 -0.1104 
vn -0.776569 -0.620834 -0.107264 
vn -0.98297 -0.145462 -0.112294 
vn -0.909804 -0.400085 -0.1104 
vn -0.986035 0.122666 -0.112644 
vn -0.993564 -0.0116279 -0.112672 
vn -0.98297 -0.145462 -0.112294 
vn -0.917971 0.380685 -0.111391 
vn -0.78727 0.606944 -0.108742 
vn -0.609189 0.786032 -0.105089 
vn -0.401478 0.910296 -0.100883 
vn -0.180795 0.978773 -0.0965249 
vn 0.0391766 0.994959 -0.092314 
vn 0.24811 0.964686 -0.0884459 
vn 0.438607 0.894647 -0.0850318 
vn 0.605517 0.791583 -0.0821248 
vn 0.745321 0.661919 -0.0797423 
vn 0.855646 0.511668 -0.0778828 
vn 0.934939 0.346456 -0.0765365 
vn 0.982253 0.171607 -0.0756924 
vn 0.180592 -0.00843975 -0.983522 
vn -0.993564 -0.0116279 -0.112672 
vn -0.954704 -0.275866 -0.111526 
vn -0.849798 -0.515724 -0.108962 
vn -0.692218 -0.713956 -0.105364 
vn -0.498838 -0.860769 -0.101182 
vn -0.286269 -0.953245 -0.0968234 
vn -0.0686704 -0.993333 -0.0925949 
vn 0.142921 -0.985752 -0.0886988 
vn 0.340335 -0.936432 -0.0852512 
vn 0.517684 -0.851604 -0.0823083 
vn 0.670766 -0.737354 -0.0798896 
vn 0.796588 -0.59947 -0.0779943 
vn 0.893028 -0.443431 -0.0766131 
vn 0.958612 -0.274459 -0.0757347 
vn 0.992369 -0.0976064 -0.0753503 
vn 0.993758 0.0821689 -0.0754558 
vn 0.997127 -0.00777533 -0.0753419 
vn 0.992369 -0.0976064 -0.0753503 
vn 0.962632 0.259913 -0.0760523 
vn 0.899243 0.430593 -0.0771462 
vn 0.804282 0.589007 -0.0787477 
vn 0.678978 0.729691 -0.0808678 
vn 0.525262 0.846833 -0.0835132 
vn 0.34603 0.934211 -0.0866777 
vn 0.145547 0.985219 -0.0903285 
vn -0.0699992 0.993072 -0.0943866 
vn -0.291823 0.951366 -0.0987018 
vn -0.507939 0.855209 -0.103028 
vn -0.703051 0.703041 -0.107012 
vn -0.859607 0.498927 -0.110219 
vn -0.960567 0.2544 -0.112211 
vn 0.215078 -0.0100514 0.976545 
o mesh268
f 11186//10772 11187//10773 11188//10773 
f 11189//10774 11186//10772 11190//10775 
f 11191//10776 11189//10774 11192//10777 
f 11193//10778 11191//10776 11194//10779 
f 11195//10780 11193//10778 11196//10781 
f 11197//10782 11195//10780 11198//10783 
f 11199//10784 11197//10782 11200//10785 
f 11201//10786 11199//10784 11202//10787 
f 11203//10788 11201//10786 11204//10789 
f 11205//10790 11203//10788 11206//10791 
f 11207//10792 11205//10790 11208//10793 
f 11209//10794 11207//10792 11210//10795 
f 11211//10796 11209//10794 11212//10797 
f 11213//10798 11211//10796 11214//10799 
f 11215//10800 11216//10800 11217//10801 
f 11213//10798 11218//10802 11219//10801 
f 11219//10801 11217//10801 11213//10798 
f 11220//10803 11216//10800 11215//10800 
f 11221//10804 11220//10803 11222//10803 
f 11223//10805 11221//10804 11224//10804 
f 11225//10806 11223//10805 11226//10805 
f 11227//10807 11225//10806 11228//10806 
f 11229//10808 11227//10807 11230//10807 
f 11231//10809 11229//10808 11232//10808 
f 11233//10810 11231//10809 11234//10809 
f 11235//10811 11233//10810 11236//10810 
f 11237//10812 11235//10811 11238//10811 
f 11239//10813 11237//10812 11240//10812 
f 11241//10814 11239//10813 11242//10813 
f 11243//10815 11241//10814 11244//10814 
f 11187//10773 11243//10815 11245//10815 
f 11245//10815 11188//10773 11187//10773 
f 11244//10814 11245//10815 11243//10815 
f 11242//10813 11244//10814 11241//10814 
f 11240//10812 11242//10813 11239//10813 
f 11238//10811 11240//10812 11237//10812 
f 11236//10810 11238//10811 11235//10811 
f 11234//10809 11236//10810 11233//10810 
f 11232//10808 11234//10809 11231//10809 
f 11230//10807 11232//10808 11229//10808 
f 11228//10806 11230//10807 11227//10807 
f 11226//10805 11228//10806 11225//10806 
f 11224//10804 11226//10805 11223//10805 
f 11222//10803 11224//10804 11221//10804 
f 11215//10800 11222//10803 11220//10803 
f 11217//10801 11219//10801 11215//10800 
f 11214//10799 11218//10802 11213//10798 
f 11212//10797 11214//10799 11211//10796 
f 11210//10795 11212//10797 11209//10794 
f 11208//10793 11210//10795 11207//10792 
f 11206//10791 11208//10793 11205//10790 
f 11204//10789 11206//10791 11203//10788 
f 11202//10787 11204//10789 11201//10786 
f 11200//10785 11202//10787 11199//10784 
f 11198//10783 11200//10785 11197//10782 
f 11196//10781 11198//10783 11195//10780 
f 11194//10779 11196//10781 11193//10778 
f 11192//10777 11194//10779 11191//10776 
f 11190//10775 11192//10777 11189//10774 
f 11188//10773 11190//10775 11186//10772 
o mesh269
f 11246//10816 11228//10816 11226//10816 
f 11246//10816 11247//10816 11230//10816 
f 11248//10816 11232//10816 11230//10816 
f 11248//10816 11249//10816 11234//10816 
f 11230//10816 11228//10816 11246//10816 
f 11234//10816 11232//10816 11248//10816 
f 11250//10816 11251//10816 11208//10816 
f 11251//10816 11252//10816 11210//10816 
f 11230//10816 11247//10816 11248//10816 
f 11253//10816 11236//10816 11234//10816 
f 11254//10816 11238//10816 11236//10816 
f 11255//10816 11240//10816 11238//10816 
f 11256//10816 11257//10816 11196//10816 
f 11257//10816 11258//10816 11198//10816 
f 11258//10816 11259//10816 11200//10816 
f 11259//10816 11260//10816 11202//10816 
f 11250//10816 11206//10816 11204//10816 
f 11210//10816 11208//10816 11251//10816 
f 11234//10816 11249//10816 11253//10816 
f 11238//10816 11254//10816 11255//10816 
f 11261//10816 11244//10816 11242//10816 
f 11261//10816 11262//10816 11245//10816 
f 11198//10816 11196//10816 11257//10816 
f 11202//10816 11200//10816 11259//10816 
f 11263//10816 11204//10816 11202//10816 
f 11208//10816 11206//10816 11250//10816 
f 11264//10816 11212//10816 11210//10816 
f 11264//10816 11265//10816 11214//10816 
f 11266//10816 11218//10816 11214//10816 
f 11266//10816 11267//10816 11219//10816 
f 11268//10816 11215//10816 11219//10816 
f 11268//10816 11269//10816 11222//10816 
f 11270//10816 11224//10816 11222//10816 
f 11270//10816 11271//10816 11226//10816 
f 11236//10816 11253//10816 11254//10816 
f 11272//10816 11242//10816 11240//10816 
f 11245//10816 11244//10816 11261//10816 
f 11262//10816 11273//10816 11188//10816 
f 11274//10816 11192//10816 11190//10816 
f 11274//10816 11256//10816 11194//10816 
f 11200//10816 11198//10816 11258//10816 
f 11204//10816 11263//10816 11250//10816 
f 11214//10816 11212//10816 11264//10816 
f 11219//10816 11218//10816 11266//10816 
f 11222//10816 11215//10816 11268//10816 
f 11226//10816 11224//10816 11270//10816 
f 11240//10816 11255//10816 11272//10816 
f 11188//10816 11245//10816 11262//10816 
f 11275//10816 11190//10816 11188//10816 
f 11194//10816 11192//10816 11274//10816 
f 11202//10816 11260//10816 11263//10816 
f 11214//10816 11265//10816 11266//10816 
f 11222//10816 11269//10816 11270//10816 
f 11242//10816 11272//10816 11261//10816 
f 11190//10816 11275//10816 11274//10816 
f 11210//10816 11252//10816 11264//10816 
f 11226//10816 11271//10816 11246//10816 
f 11196//10816 11194//10816 11256//10816 
f 11188//10816 11273//10816 11275//10816 
f 11219//10816 11267//10816 11268//10816 
o mesh270
f 11276//10817 11273//10817 11262//10818 
f 11277//10818 11262//10818 11261//10819 
f 11278//10819 11261//10819 11272//10820 
f 11279//10820 11272//10820 11255//10821 
f 11280//10821 11255//10821 11254//10822 
f 11281//10822 11254//10822 11253//10823 
f 11282//10823 11253//10823 11249//10824 
f 11283//10824 11249//10824 11248//10825 
f 11284//10825 11248//10825 11247//10826 
f 11285//10826 11247//10826 11246//10827 
f 11286//10827 11246//10827 11271//10828 
f 11287//10828 11271//10828 11270//10829 
f 11288//10829 11270//10829 11269//10830 
f 11289//10830 11269//10830 11268//10831 
f 11266//10832 11290//10832 11291//10833 
f 11292//10834 11268//10831 11267//10833 
f 11267//10833 11291//10833 11292//10834 
f 11290//10832 11266//10832 11265//10835 
f 11293//10835 11265//10835 11264//10836 
f 11294//10836 11264//10836 11252//10837 
f 11295//10837 11252//10837 11251//10838 
f 11296//10838 11251//10838 11250//10839 
f 11297//10839 11250//10839 11263//10840 
f 11298//10840 11263//10840 11260//10841 
f 11299//10841 11260//10841 11259//10842 
f 11300//10842 11259//10842 11258//10843 
f 11301//10843 11258//10843 11257//10844 
f 11302//10844 11257//10844 11256//10845 
f 11303//10845 11256//10845 11274//10846 
f 11304//10846 11274//10846 11275//10847 
f 11305//10847 11275//10847 11273//10817 
f 11273//10817 11276//10817 11305//10847 
f 11275//10847 11305//10847 11304//10846 
f 11274//10846 11304//10846 11303//10845 
f 11256//10845 11303//10845 11302//10844 
f 11257//10844 11302//10844 11301//10843 
f 11258//10843 11301//10843 11300//10842 
f 11259//10842 11300//10842 11299//10841 
f 11260//10841 11299//10841 11298//10840 
f 11263//10840 11298//10840 11297//10839 
f 11250//10839 11297//10839 11296//10838 
f 11251//10838 11296//10838 11295//10837 
f 11252//10837 11295//10837 11294//10836 
f 11264//10836 11294//10836 11293//10835 
f 11265//10835 11293//10835 11290//10832 
f 11291//10833 11267//10833 11266//10832 
f 11268//10831 11292//10834 11289//10830 
f 11269//10830 11289//10830 11288//10829 
f 11270//10829 11288//10829 11287//10828 
f 11271//10828 11287//10828 11286//10827 
f 11246//10827 11286//10827 11285//10826 
f 11247//10826 11285//10826 11284//10825 
f 11248//10825 11284//10825 11283//10824 
f 11249//10824 11283//10824 11282//10823 
f 11253//10823 11282//10823 11281//10822 
f 11254//10822 11281//10822 11280//10821 
f 11255//10821 11280//10821 11279//10820 
f 11272//10820 11279//10820 11278//10819 
f 11261//10819 11278//10819 11277//10818 
f 11262//10818 11277//10818 11276//10817 
o mesh271
f 11280//10848 11281//10848 11235//10848 
f 11281//10848 11282//10848 11233//10848 
f 11292//10848 11291//10848 11217//10848 
f 11290//10848 11213//10848 11217//10848 
f 11279//10848 11280//10848 11237//10848 
f 11233//10848 11235//10848 11281//10848 
f 11292//10848 11216//10848 11220//10848 
f 11217//10848 11291//10848 11290//10848 
f 11296//10848 11205//10848 11207//10848 
f 11297//10848 11203//10848 11205//10848 
f 11235//10848 11237//10848 11280//10848 
f 11282//10848 11283//10848 11231//10848 
f 11284//10848 11229//10848 11231//10848 
f 11284//10848 11285//10848 11227//10848 
f 11288//10848 11221//10848 11223//10848 
f 11288//10848 11289//10848 11220//10848 
f 11217//10848 11216//10848 11292//10848 
f 11290//10848 11293//10848 11211//10848 
f 11205//10848 11296//10848 11297//10848 
f 11297//10848 11298//10848 11201//10848 
f 11300//10848 11197//10848 11199//10848 
f 11301//10848 11195//10848 11197//10848 
f 11302//10848 11193//10848 11195//10848 
f 11303//10848 11191//10848 11193//10848 
f 11278//10848 11241//10848 11243//10848 
f 11278//10848 11279//10848 11239//10848 
f 11231//10848 11233//10848 11282//10848 
f 11227//10848 11229//10848 11284//10848 
f 11286//10848 11225//10848 11227//10848 
f 11286//10848 11287//10848 11223//10848 
f 11220//10848 11221//10848 11288//10848 
f 11211//10848 11213//10848 11290//10848 
f 11294//10848 11209//10848 11211//10848 
f 11294//10848 11295//10848 11207//10848 
f 11201//10848 11203//10848 11297//10848 
f 11298//10848 11299//10848 11199//10848 
f 11197//10848 11300//10848 11301//10848 
f 11193//10848 11302//10848 11303//10848 
f 11277//10848 11243//10848 11187//10848 
f 11239//10848 11241//10848 11278//10848 
f 11231//10848 11283//10848 11284//10848 
f 11223//10848 11225//10848 11286//10848 
f 11220//10848 11289//10848 11292//10848 
f 11207//10848 11209//10848 11294//10848 
f 11199//10848 11201//10848 11298//10848 
f 11195//10848 11301//10848 11302//10848 
f 11243//10848 11277//10848 11278//10848 
f 11227//10848 11285//10848 11286//10848 
f 11211//10848 11293//10848 11294//10848 
f 11199//10848 11299//10848 11300//10848 
f 11304//10848 11189//10848 11191//10848 
f 11304//10848 11305//10848 11186//10848 
f 11237//10848 11239//10848 11279//10848 
f 11207//10848 11295//10848 11296//10848 
f 11186//10848 11189//10848 11304//10848 
f 11305//10848 11276//10848 11187//10848 
f 11223//10848 11287//10848 11288//10848 
f 11187//10848 11186//10848 11305//10848 
f 11191//10848 11303//10848 11304//10848 
f 11187//10848 11276//10848 11277//10848 
`;

export { cncRouterDataObj };